import "./html.00bc7041.js";
import "./html.53069f58.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire09c7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire09c7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hLNas", function(module, exports) {
module.exports = import.meta.resolve("kAQOV");

});

parcelRegister("jIc5b", function(module, exports) {

$parcel$export(module.exports, "default", () => $71759b68f808bc66$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $71759b68f808bc66$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M3 21l18 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M3 7v1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1h-18l2 -4h14l2 4",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M5 21l0 -10.15",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M19 21l0 -10.15",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M9 21v-4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v4",
            "key": "svg-4"
        }
    ]
];
const $71759b68f808bc66$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "building-store", "BuildingStore", $71759b68f808bc66$export$3efd853dbb351e94);

});

parcelRegister("35ntO", function(module, exports) {

$parcel$export(module.exports, "default", () => $1717d868af1ca240$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $1717d868af1ca240$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M9.615 20h-2.615a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M14 19l2 2l4 -4",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M9 8h4",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M9 12h2",
            "key": "svg-3"
        }
    ]
];
const $1717d868af1ca240$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "checklist", "Checklist", $1717d868af1ca240$export$3efd853dbb351e94);

});

parcelRegister("TC7kK", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcae7435022b5736$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $bcae7435022b5736$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0",
            "key": "svg-1"
        }
    ]
];
const $bcae7435022b5736$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "settings", "Settings", $bcae7435022b5736$export$3efd853dbb351e94);

});

parcelRegister("4d0Rl", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dd9ad21907f9c0e$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $1dd9ad21907f9c0e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M6 21v-2a4 4 0 0 1 4 -4h2.5",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M19 18v.01",
            "key": "svg-3"
        }
    ]
];
const $1dd9ad21907f9c0e$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "user-pin", "UserPin", $1dd9ad21907f9c0e$export$3efd853dbb351e94);

});

parcelRegister("eVReK", function(module, exports) {
module.exports = import("6Lx6Q").then(()=>parcelRequire('62g5g'));

});

parcelRegister("iEQtx", function(module, exports) {

$parcel$export(module.exports, "default", () => $73c5281b2a6c4f44$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $73c5281b2a6c4f44$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M10.425 1.414a3.33 3.33 0 0 1 3.026 -.097l.19 .097l6.775 3.995l.096 .063l.092 .077l.107 .075a3.224 3.224 0 0 1 1.266 2.188l.018 .202l.005 .204v7.284c0 1.106 -.57 2.129 -1.454 2.693l-.17 .1l-6.803 4.302c-.918 .504 -2.019 .535 -3.004 .068l-.196 -.1l-6.695 -4.237a3.225 3.225 0 0 1 -1.671 -2.619l-.007 -.207v-7.285c0 -1.106 .57 -2.128 1.476 -2.705l6.95 -4.098zm1.585 13.586l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm-.01 -8a1 1 0 0 0 -.993 .883l-.007 .117v4l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z",
            "key": "svg-0"
        }
    ]
];
const $73c5281b2a6c4f44$export$2e2bcd8739ae039 = (0, $eednQ.default)("filled", "alert-hexagon-filled", "AlertHexagonFilled", $73c5281b2a6c4f44$export$3efd853dbb351e94);

});

parcelRegister("6zxJ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cb535adfb9113eb$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $7cb535adfb9113eb$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M12 1.67c.955 0 1.845 .467 2.39 1.247l.105 .16l8.114 13.548a2.914 2.914 0 0 1 -2.307 4.363l-.195 .008h-16.225a2.914 2.914 0 0 1 -2.582 -4.2l.099 -.185l8.11 -13.538a2.914 2.914 0 0 1 2.491 -1.403zm.01 13.33l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm-.01 -7a1 1 0 0 0 -.993 .883l-.007 .117v4l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z",
            "key": "svg-0"
        }
    ]
];
const $7cb535adfb9113eb$export$2e2bcd8739ae039 = (0, $eednQ.default)("filled", "alert-triangle-filled", "AlertTriangleFilled", $7cb535adfb9113eb$export$3efd853dbb351e94);

});

parcelRegister("h8HR1", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b44f6fe60c75128$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $7b44f6fe60c75128$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M19 2h-14a3 3 0 0 0 -3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3 -3v-14a3 3 0 0 0 -3 -3zm-9.387 6.21l.094 .083l2.293 2.292l2.293 -2.292a1 1 0 0 1 1.497 1.32l-.083 .094l-2.292 2.293l2.292 2.293a1 1 0 0 1 -1.32 1.497l-.094 -.083l-2.293 -2.292l-2.293 2.292a1 1 0 0 1 -1.497 -1.32l.083 -.094l2.292 -2.293l-2.292 -2.293a1 1 0 0 1 1.32 -1.497z",
            "key": "svg-0"
        }
    ]
];
const $7b44f6fe60c75128$export$2e2bcd8739ae039 = (0, $eednQ.default)("filled", "square-x-filled", "SquareXFilled", $7b44f6fe60c75128$export$3efd853dbb351e94);

});

parcelRegister("5qfPT", function(module, exports) {

$parcel$export(module.exports, "EnviarRecibosIcon", () => $ad2a7f29e72acfd7$export$cd2ab6ea6d763536);
$parcel$export(module.exports, "EnviarRecibos", () => $ad2a7f29e72acfd7$export$dce9f7068c28f705);

var $49qEn = parcelRequire("49qEn");

var $2JAvD = parcelRequire("2JAvD");

var $k0CbA = parcelRequire("k0CbA");
const $ad2a7f29e72acfd7$export$a33c8da47dc03cd0 = "* Enviar recibos.";
const $ad2a7f29e72acfd7$export$cd2ab6ea6d763536 = (0, $2JAvD.default);

class $ad2a7f29e72acfd7$export$dce9f7068c28f705 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $k0CbA.EnviarRecibosDef)(), parentKeys);
        this.Form = (parcelRequire("bqaYX")).then((module)=>module.EnviarRecibosForm);
        this.Title = "Proceso de Env\xedo de Recibos de Sueldo";
        this.HelpText = $ad2a7f29e72acfd7$export$a33c8da47dc03cd0;
        this.Icon = $ad2a7f29e72acfd7$export$cd2ab6ea6d763536;
    }
}

});
parcelRegister("2JAvD", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d94dc5c36957eed$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $7d94dc5c36957eed$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M8 9l5 5v7h-5v-4m0 4h-5v-7l5 -5m1 1v-6a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v17h-8",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M13 7l0 .01",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M17 7l0 .01",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M17 11l0 .01",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M17 15l0 .01",
            "key": "svg-4"
        }
    ]
];
const $7d94dc5c36957eed$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "building-community", "BuildingCommunity", $7d94dc5c36957eed$export$3efd853dbb351e94);

});

parcelRegister("k0CbA", function(module, exports) {

$parcel$export(module.exports, "EnviarRecibosDef", () => $83dcdcebcdd91e79$export$143478fff993bb87);

var $49qEn = parcelRequire("49qEn");

var $dBQe4 = parcelRequire("dBQe4");

var $gMXxJ = parcelRequire("gMXxJ");

var $gNYFg = parcelRequire("gNYFg");
const $83dcdcebcdd91e79$var$columns = ()=>({
        c_proceso_id: new (0, $49qEn.EntityColumn)({
            name: 'c_proceso_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PKAutonum,
            prompt: 'Proceso ID'
        }),
        vc_nombre: new (0, $49qEn.EntityColumn)({
            name: 'vc_nombre',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Nombre'
        }),
        c_fileprocess_id: new (0, $49qEn.EntityColumn)({
            name: 'c_fileprocess_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Fileprocess Id'
        }),
        vc_filepath: new (0, $49qEn.EntityColumn)({
            name: 'vc_filepath',
            type: 'varchar',
            length: 2048,
            flags: (0, $49qEn.EntityColumnFlags).None,
            prompt: 'Filepath'
        }),
        c_enviar_recibo_status_id: new (0, $49qEn.EntityColumn)({
            name: 'c_enviar_recibo_status_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Enviar Recibo Status Id'
        }),
        bt_procesar: new (0, $49qEn.EntityColumn)({
            name: 'bt_procesar',
            type: 'bit',
            flags: (0, $49qEn.EntityColumnFlags).add | (0, $49qEn.EntityColumnFlags).edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Procesar'
        }),
        vc_errores: new (0, $49qEn.EntityColumn)({
            name: 'vc_errores',
            type: 'char',
            length: 0,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Errores'
        }),
        vc_password: new (0, $49qEn.EntityColumn)({
            name: 'vc_password',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Password'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $83dcdcebcdd91e79$var$views = ()=>({
        enre_brwStandard: {
            name: 'enre_brwStandard',
            keyMappings: {
                c_proceso_id: 0
            }
        }
    });
const $83dcdcebcdd91e79$var$clientActions = ()=>({
        ACTAgregar: (0, $dBQe4.ACTAgregar),
        ACTEditar: (0, $gMXxJ.ACTEditar),
        ACTProcesar: (0, $gNYFg.ACTProcesar)
    });
const $83dcdcebcdd91e79$var$procs = ()=>({
        enre_ComprobarPassword: {
            name: 'enre_ComprobarPassword'
        }
    });
class $83dcdcebcdd91e79$export$143478fff993bb87 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('EnviarRecibos'), this.columns = $83dcdcebcdd91e79$var$columns(), this.views = $83dcdcebcdd91e79$var$views(), this.clientActions = $83dcdcebcdd91e79$var$clientActions(), this.procs = $83dcdcebcdd91e79$var$procs();
    }
}

});
parcelRegister("dBQe4", function(module, exports) {

$parcel$export(module.exports, "ACTAgregar", () => $9f7b86bff1894ac6$export$de3375244f22cf2a);

var $ayMG0 = parcelRequire("ayMG0");

var $gU5rH = parcelRequire("gU5rH");
var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");

var $5qfPT = parcelRequire("5qfPT");
const $9f7b86bff1894ac6$export$de3375244f22cf2a = {
    name: 'ACTAgregar',
    label: 'Agregar',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Agregar"
    }),
    refreshOnClose: true,
    dontRequireSelection: true,
    views: [
        'enre_brwStandard'
    ],
    showActionInViewMode: true,
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const enviarRecibos = new (0, $5qfPT.EnviarRecibos)(entity.API.client);
        enviarRecibos.def.columns.vc_password.value = entity.def.columns.vc_password.value || '';
        const procParms = {
            vc_password: enviarRecibos.def.columns.vc_password.value
        };
        let errores = '';
        if (!procParms.vc_password) errores = "Los registros seleccionados son inv\xe1lidos.";
        if (errores) await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                            size: "1.5rem",
                            stroke: "1.5"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            fw: "700",
                            children: "ERROR"
                        })
                    ]
                })
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        size: "sm",
                        mb: "xs",
                        children: errores
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                        mt: "xs",
                        position: "right",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                            onClick: async ()=>await modal.close(),
                            children: "Cerrar"
                        })
                    })
                ]
            })
        });
        const abort_controller = new AbortController();
        const result = await enviarRecibos.API.executeProcess(enviarRecibos.def.procs.enre_ComprobarPassword, procParms, abort_controller.signal);
        if (result.Results[0].Status === 11) {
            errores = "Contrase\xf1a incorrecta.";
            await modal.open({
                modalProps: {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                                size: "1.5rem",
                                stroke: "1.5"
                            }),
                            " ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                                fw: "700",
                                children: "ERROR"
                            })
                        ]
                    })
                },
                focusOnClosed: element,
                content: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            size: "sm",
                            mb: "xs",
                            children: errores
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                            mt: "xs",
                            position: "right",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                                onClick: async ()=>await modal.close(),
                                children: "Cerrar"
                            })
                        })
                    ]
                })
            });
        } else await (0, $49qEn.openEntityForm)({
            modals: modal,
            formProps: {
                entity: entity,
                initialFormMode: 'add',
                getDataOnInit: true
            },
            modalFormSize: 'xl',
            handleModalSaved: async ()=>{
                await modal.close();
                if (onClose) await onClose();
            },
            handleModalCancel: async ()=>{
                await modal.close();
                if (onClose) await onClose();
            }
        });
        return false;
    }
};

});

parcelRegister("gMXxJ", function(module, exports) {

$parcel$export(module.exports, "ACTEditar", () => $1e91a3fb12e456f5$export$8d9b4348067e873);

var $ayMG0 = parcelRequire("ayMG0");

var $gU5rH = parcelRequire("gU5rH");
var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");

var $5qfPT = parcelRequire("5qfPT");
const $1e91a3fb12e456f5$export$8d9b4348067e873 = {
    name: 'ACTEditar',
    label: 'Editar',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Editar"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    minSelectedRecords: 1,
    maxSelectedRecords: 1,
    views: [
        'enre_brwStandard'
    ],
    showActionInViewMode: true,
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const enviarRecibos = new (0, $5qfPT.EnviarRecibos)(entity.API.client);
        enviarRecibos.def.columns.vc_password.value = entity.def.columns.vc_password.value || '';
        const procParms = {
            vc_password: enviarRecibos.def.columns.vc_password.value
        };
        let errores = '';
        if (!procParms.vc_password) errores = "Los registros seleccionados son inv\xe1lidos.";
        if (errores) await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                            size: "1.5rem",
                            stroke: "1.5"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            fw: "700",
                            children: "ERROR"
                        })
                    ]
                })
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        size: "sm",
                        mb: "xs",
                        children: errores
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                        mt: "xs",
                        position: "right",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                            onClick: async ()=>await modal.close(),
                            children: "Cerrar"
                        })
                    })
                ]
            })
        });
        const abort_controller = new AbortController();
        const result = await enviarRecibos.API.executeProcess(enviarRecibos.def.procs.enre_ComprobarPassword, procParms, abort_controller.signal);
        if (result.Results[0].Status === 11) {
            errores = "Contrase\xf1a incorrecta.";
            await modal.open({
                modalProps: {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                                size: "1.5rem",
                                stroke: "1.5"
                            }),
                            " ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                                fw: "700",
                                children: "ERROR"
                            })
                        ]
                    })
                },
                focusOnClosed: element,
                content: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            size: "sm",
                            mb: "xs",
                            children: errores
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                            mt: "xs",
                            position: "right",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                                onClick: async ()=>await modal.close(),
                                children: "Cerrar"
                            })
                        })
                    ]
                })
            });
        } else {
            enviarRecibos.def.columns.c_proceso_id.value = selectedKeys[0].c_proceso_id || '';
            await enviarRecibos.API.getData();
            enviarRecibos.def.columns.vc_password.value = entity.def.columns.vc_password.value;
            await (0, $49qEn.openEntityForm)({
                modals: modal,
                formProps: {
                    entity: enviarRecibos,
                    initialFormMode: 'edit',
                    getDataOnInit: false
                },
                modalFormSize: 'xl',
                handleModalSaved: async ()=>{
                    await modal.close();
                    if (onClose) await onClose();
                },
                handleModalCancel: async ()=>{
                    await modal.close();
                    if (onClose) await onClose();
                }
            });
        }
        return false;
    }
};

});

parcelRegister("gNYFg", function(module, exports) {

$parcel$export(module.exports, "ACTProcesar", () => $da656d5c7175e166$export$1043081507fb2bc6);

var $ayMG0 = parcelRequire("ayMG0");

var $gU5rH = parcelRequire("gU5rH");
var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");

var $5qfPT = parcelRequire("5qfPT");

var $4h3p0 = parcelRequire("4h3p0");
const $da656d5c7175e166$export$1043081507fb2bc6 = {
    name: 'ACTProcesar',
    label: 'Enviar Recibos',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Enviar Recibos"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    minSelectedRecords: 1,
    maxSelectedRecords: 1,
    views: [
        'enre_brwStandard'
    ],
    showActionInViewMode: true,
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const enviarRecibos = new (0, $5qfPT.EnviarRecibos)(entity.API.client);
        enviarRecibos.def.columns.vc_password.value = entity.def.columns.vc_password.value || '';
        const procParms = {
            vc_password: enviarRecibos.def.columns.vc_password.value
        };
        let errores = '';
        if (!procParms.vc_password) errores = "Los registros seleccionados son inv\xe1lidos.";
        if (errores) await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                            size: "1.5rem",
                            stroke: "1.5"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            fw: "700",
                            children: "ERROR"
                        })
                    ]
                })
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        size: "sm",
                        mb: "xs",
                        children: errores
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                        mt: "xs",
                        position: "right",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                            onClick: async ()=>await modal.close(),
                            children: "Cerrar"
                        })
                    })
                ]
            })
        });
        const abort_controller = new AbortController();
        const result = await enviarRecibos.API.executeProcess(enviarRecibos.def.procs.enre_ComprobarPassword, procParms, abort_controller.signal);
        if (result.Results[0].Status === 11) {
            errores = "Contrase\xf1a incorrecta.";
            await modal.open({
                modalProps: {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                                size: "1.5rem",
                                stroke: "1.5"
                            }),
                            " ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                                fw: "700",
                                children: "ERROR"
                            })
                        ]
                    })
                },
                focusOnClosed: element,
                content: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            size: "sm",
                            mb: "xs",
                            children: errores
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                            mt: "xs",
                            position: "right",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                                onClick: async ()=>await modal.close(),
                                children: "Cerrar"
                            })
                        })
                    ]
                })
            });
        } else {
            const enviarRecibosDetallesProcesar = new (0, $4h3p0.EnviarRecibosDetallesProcesar)(entity.API.client);
            enviarRecibosDetallesProcesar.def.columns.c_proceso_id.value = selectedKeys[0].c_proceso_id || '';
            enviarRecibosDetallesProcesar.def.columns.vc_password.value = entity.def.columns.vc_password.value || '';
            await (0, $49qEn.openEntityForm)({
                modals: modal,
                formProps: {
                    entity: enviarRecibosDetallesProcesar,
                    initialFormMode: 'add',
                    getDataOnInit: true
                },
                modalFormSize: 'md',
                handleModalSaved: async ()=>{
                    await modal.close();
                    if (onClose) await onClose();
                },
                handleModalCancel: async ()=>{
                    await modal.close();
                    if (onClose) await onClose();
                }
            });
        }
        return false;
    }
};

});
parcelRegister("4h3p0", function(module, exports) {

$parcel$export(module.exports, "EnviarRecibosDetallesProcesar", () => $9899cd677f49aa55$export$a4c448b590e405c3);

var $49qEn = parcelRequire("49qEn");

var $2JAvD = parcelRequire("2JAvD");

var $aJkAv = parcelRequire("aJkAv");
const $9899cd677f49aa55$export$382ffca19fceab8f = "* Enviar recibos.";
const $9899cd677f49aa55$export$bd6f7731dfa5dac2 = (0, $2JAvD.default);

class $9899cd677f49aa55$export$a4c448b590e405c3 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $aJkAv.EnviarRecibosDetallesProcesarDef)(), parentKeys);
        this.Form = (parcelRequire("69Dck")).then((module)=>module.EnviarRecibosDetallesProcesarForm);
        this.Title = "Proceso de Env\xedo de Recibos de Sueldo";
        this.HelpText = $9899cd677f49aa55$export$382ffca19fceab8f;
        this.Icon = $9899cd677f49aa55$export$bd6f7731dfa5dac2;
    }
}

});
parcelRegister("aJkAv", function(module, exports) {

$parcel$export(module.exports, "EnviarRecibosDetallesProcesarDef", () => $9747d1b869642357$export$c1ce6eabf2cb8356);

var $49qEn = parcelRequire("49qEn");
const $9747d1b869642357$var$columns = ()=>({
        c_proceso_id: new (0, $49qEn.EntityColumn)({
            name: 'c_proceso_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Proceso ID'
        }),
        vc_email: new (0, $49qEn.EntityColumn)({
            name: 'vc_email',
            type: 'char',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Email'
        }),
        bt_prueba: new (0, $49qEn.EntityColumn)({
            name: 'bt_prueba',
            type: 'bit',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Prueba'
        }),
        vc_password: new (0, $49qEn.EntityColumn)({
            name: 'vc_password',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Password'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $9747d1b869642357$var$views = ()=>({
        enrp_brwStandard: {
            name: 'enrp_brwStandard',
            keyMappings: {
                c_detalle_id: 0
            }
        }
    });
const $9747d1b869642357$var$lookups = ()=>({});
class $9747d1b869642357$export$c1ce6eabf2cb8356 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('EnviarRecibosDetallesProcesar'), this.columns = $9747d1b869642357$var$columns(), this.views = $9747d1b869642357$var$views(), this.lookups = $9747d1b869642357$var$lookups();
    }
}

});

parcelRegister("69Dck", function(module, exports) {
module.exports = import("hY69V").then(()=>parcelRequire('1vGXH'));

});




parcelRegister("bqaYX", function(module, exports) {
module.exports = import("6pwHQ").then(()=>parcelRequire('8q0sx'));

});


parcelRegister("j02RA", function(module, exports) {

$parcel$export(module.exports, "AppSupervisor", () => $77c12df39d62dc7d$export$86ac6195f2e3a403);

var $49qEn = parcelRequire("49qEn");

var $5Ue5f = parcelRequire("5Ue5f");

var $ckUJ5 = parcelRequire("ckUJ5");
const $77c12df39d62dc7d$export$89a61cf19d32f927 = (0, $5Ue5f.default);
const $77c12df39d62dc7d$export$6c49bc26998b375e = '* AppSupervisor.';

class $77c12df39d62dc7d$export$86ac6195f2e3a403 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $ckUJ5.AppSupervisorDef)(), parentKeys);
        this.Form = (parcelRequire("d2cgZ")).then((module)=>module.AppSupervisorForm);
        this.Title = "AppSupervisor";
        this.HelpText = $77c12df39d62dc7d$export$6c49bc26998b375e;
        this.Icon = $77c12df39d62dc7d$export$89a61cf19d32f927;
    }
}

});
parcelRegister("ckUJ5", function(module, exports) {

$parcel$export(module.exports, "AppSupervisorDef", () => $c6d14a69dd72a319$export$cab0d2a48278c8e6);

var $49qEn = parcelRequire("49qEn");

var $iwWhA = parcelRequire("iwWhA");

var $37S53 = parcelRequire("37S53");

var $2jdBt = parcelRequire("2jdBt");

var $lC6NH = parcelRequire("lC6NH");

var $fZbXf = parcelRequire("fZbXf");

var $2aZ1b = parcelRequire("2aZ1b");

var $50rai = parcelRequire("50rai");

var $ifvvj = parcelRequire("ifvvj");

var $gZeaI = parcelRequire("gZeaI");
const $c6d14a69dd72a319$var$columns = ()=>({
        c_personal_id: new (0, $49qEn.EntityColumn)({
            name: 'c_personal_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Personal Id'
        }),
        c_tienda_id: new (0, $49qEn.EntityColumn)({
            name: 'c_tienda_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Tienda Id'
        }),
        i_autorizaciones: new (0, $49qEn.EntityColumn)({
            name: 'i_autorizaciones',
            type: 'int',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Autorizaciones'
        }),
        i_autorizaciones_total: new (0, $49qEn.EntityColumn)({
            name: 'i_autorizaciones_total',
            type: 'int',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Total'
        }),
        i_personal_presentes: new (0, $49qEn.EntityColumn)({
            name: 'i_personal_presentes',
            type: 'int',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Presentes'
        }),
        i_personal_ausentes: new (0, $49qEn.EntityColumn)({
            name: 'i_personal_ausentes',
            type: 'int',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Ausentes'
        }),
        i_personal_sin_reportar: new (0, $49qEn.EntityColumn)({
            name: 'i_personal_sin_reportar',
            type: 'int',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Sin Reportar'
        }),
        i_personal_total: new (0, $49qEn.EntityColumn)({
            name: 'i_personal_total',
            type: 'int',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Total'
        }),
        i_visitas_finalizadas: new (0, $49qEn.EntityColumn)({
            name: 'i_visitas_finalizadas',
            type: 'int',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Finalizadas'
        }),
        i_visitas_en_proceso: new (0, $49qEn.EntityColumn)({
            name: 'i_visitas_en_proceso',
            type: 'int',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'En Proceso'
        }),
        i_visitas_sin_iniciar: new (0, $49qEn.EntityColumn)({
            name: 'i_visitas_sin_iniciar',
            type: 'int',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Sin Iniciar'
        }),
        i_visitas_total: new (0, $49qEn.EntityColumn)({
            name: 'i_visitas_total',
            type: 'int',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Total'
        }),
        i_total_personal_checkin: new (0, $49qEn.EntityColumn)({
            name: 'i_total_personal_checkin',
            type: 'int',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Personal Checkin'
        }),
        i_total_personal_sin_checkin: new (0, $49qEn.EntityColumn)({
            name: 'i_total_personal_sin_checkin',
            type: 'int',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Personal Sin Checkin'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $c6d14a69dd72a319$var$views = ()=>({
        apsp_brwStandard: {
            name: 'apsp_brwStandard',
            keyMappings: {}
        },
        apsp_brwPersonalLocalizacion: {
            name: 'apsp_brwPersonalLocalizacion',
            keyMappings: {
                c_personal_id: 0
            },
            FiltersEntity: (client, parentKeys)=>new (0, $iwWhA.AppSupervisorFilters)(client, parentKeys),
            mapMarkerRenderer: (0, $50rai.PersonalLocalizacionViewMarkerRenderer),
            mapInfoWindowRenderer: (0, $2aZ1b.PersonalLocalizacionViewInfoWindowRenderer)
        },
        apsp_brwPersonalLocalizacionPresentes: {
            name: 'apsp_brwPersonalLocalizacionPresentes',
            keyMappings: {
                c_personal_id: 0
            },
            FiltersEntity: (client, parentKeys)=>new (0, $37S53.AppSupervisorPersonalFilters)(client, parentKeys)
        },
        apsp_brwPersonalLocalizacionAusentes: {
            name: 'apsp_brwPersonalLocalizacionAusentes',
            keyMappings: {
                c_personal_id: 0
            },
            FiltersEntity: (client, parentKeys)=>new (0, $37S53.AppSupervisorPersonalFilters)(client, parentKeys)
        },
        apsp_brwPersonalLocalizacionSinReportar: {
            name: 'apsp_brwPersonalLocalizacionSinReportar',
            keyMappings: {
                c_personal_id: 0
            },
            FiltersEntity: (client, parentKeys)=>new (0, $37S53.AppSupervisorPersonalFilters)(client, parentKeys)
        },
        apsp_brwTiendas: {
            name: 'apsp_brwTiendas',
            keyMappings: {
                c_tienda_id: 0
            },
            FiltersEntity: (client, parentKeys)=>new (0, $iwWhA.AppSupervisorFilters)(client, parentKeys),
            mapMarkerRenderer: (0, $gZeaI.TiendasViewMarkerRenderer),
            mapInfoWindowRenderer: (0, $ifvvj.TiendasViewInfoWindowRenderer)
        },
        apsp_brwTiendasPersonal: {
            name: 'apsp_brwTiendasPersonal',
            keyMappings: {
                c_tienda_id: 0
            }
        }
    });
const $c6d14a69dd72a319$var$clientActions = ()=>({
        ACTVerReportesPersonal: (0, $lC6NH.ACTVerReportesPersonal),
        ACTVerReportesTienda: (0, $fZbXf.ACTVerReportesTienda),
        ACTVerPersonalTienda: (0, $2jdBt.ACTVerPersonalTienda)
    });
class $c6d14a69dd72a319$export$cab0d2a48278c8e6 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('AppSupervisor'), this.columns = $c6d14a69dd72a319$var$columns(), this.views = $c6d14a69dd72a319$var$views(), this.clientActions = $c6d14a69dd72a319$var$clientActions();
    }
}

});
parcelRegister("iwWhA", function(module, exports) {

$parcel$export(module.exports, "AppSupervisorFilters", () => $d840c007d070c5b9$export$83520496df757ef3);

var $49qEn = parcelRequire("49qEn");

var $5Ue5f = parcelRequire("5Ue5f");

var $6X2TE = parcelRequire("6X2TE");
const $d840c007d070c5b9$export$89a61cf19d32f927 = (0, $5Ue5f.default);
const $d840c007d070c5b9$export$6c49bc26998b375e = '* AppSupervisor.';

class $d840c007d070c5b9$export$83520496df757ef3 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $6X2TE.AppSupervisorFiltersDef)(), parentKeys);
        this.Form = (parcelRequire("jSEQJ")).then((module)=>module.AppSupervisorFiltersForm);
        this.Title = "AppSupervisor";
        this.HelpText = $d840c007d070c5b9$export$6c49bc26998b375e;
        this.Icon = $d840c007d070c5b9$export$89a61cf19d32f927;
    }
}

});
parcelRegister("6X2TE", function(module, exports) {

$parcel$export(module.exports, "AppSupervisorFiltersDef", () => $934b15490ca6d11f$export$828d32bf1b5f5e69);

var $49qEn = parcelRequire("49qEn");

var $9u8qf = parcelRequire("9u8qf");

var $7LP39 = parcelRequire("7LP39");

var $6awxZ = parcelRequire("6awxZ");
const $934b15490ca6d11f$var$columns = ()=>({
        vc_tiendas: new (0, $49qEn.EntityColumn)({
            name: 'vc_tiendas',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Tiendas',
            isArray: true
        }),
        vc_personal: new (0, $49qEn.EntityColumn)({
            name: 'vc_personal',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Personal',
            isArray: true
        }),
        vc_clientes: new (0, $49qEn.EntityColumn)({
            name: 'vc_clientes',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Clientes',
            isArray: true
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $934b15490ca6d11f$var$lookups = ()=>({
        'Tiendas': {
            name: 'Tiendas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 4
            },
            entityConstructor: (client, parentKeys)=>new (0, $6awxZ.Tiendas)(client, parentKeys)
        },
        'Personal': {
            name: 'Personal',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $7LP39.Personal)(client, parentKeys)
        },
        'Clientes': {
            name: 'Clientes',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 2
            },
            entityConstructor: (client, parentKeys)=>new (0, $9u8qf.Clientes)(client, parentKeys)
        }
    });
class $934b15490ca6d11f$export$828d32bf1b5f5e69 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('AppSupervisorFilters'), this.columns = $934b15490ca6d11f$var$columns(), this.views = {}, this.lookups = $934b15490ca6d11f$var$lookups();
    }
}

});
parcelRegister("9u8qf", function(module, exports) {

$parcel$export(module.exports, "ClientesHelpText", () => $ecb637daf1b6a5d2$export$67da146eb47799b8);
$parcel$export(module.exports, "ClientesIcon", () => $ecb637daf1b6a5d2$export$c67cdc88f1a47cb0);
$parcel$export(module.exports, "Clientes", () => $ecb637daf1b6a5d2$export$87c6078dc31a5958);

var $49qEn = parcelRequire("49qEn");

var $ktmlo = parcelRequire("ktmlo");

var $ap1wY = parcelRequire("ap1wY");
const $ecb637daf1b6a5d2$export$67da146eb47799b8 = "* Aqu\xed puede ver la lista de clientes.";
const $ecb637daf1b6a5d2$export$c67cdc88f1a47cb0 = (0, $ktmlo.default);

class $ecb637daf1b6a5d2$export$87c6078dc31a5958 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $ap1wY.ClientesDef)(), parentKeys);
        this.Form = (parcelRequire("3rbj2")).then((module)=>module.ClientesForm);
        this.Icon = $ecb637daf1b6a5d2$export$c67cdc88f1a47cb0;
        this.HelpText = $ecb637daf1b6a5d2$export$67da146eb47799b8;
    }
}

});
parcelRegister("ktmlo", function(module, exports) {

$parcel$export(module.exports, "default", () => $26396b66a2f4712a$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $26396b66a2f4712a$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M6 21v-2a4 4 0 0 1 4 -4h.5",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z",
            "key": "svg-2"
        }
    ]
];
const $26396b66a2f4712a$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "user-star", "UserStar", $26396b66a2f4712a$export$3efd853dbb351e94);

});

parcelRegister("ap1wY", function(module, exports) {

$parcel$export(module.exports, "ClientesDef", () => $196b8ca621695f22$export$b5565345736d8a07);

var $49qEn = parcelRequire("49qEn");

var $SKbb0 = parcelRequire("SKbb0");

var $6hvNA = parcelRequire("6hvNA");

var $5A5L0 = parcelRequire("5A5L0");

var $5kp3N = parcelRequire("5kp3N");

var $2LSnU = parcelRequire("2LSnU");

var $iHr81 = parcelRequire("iHr81");

var $bYVp3 = parcelRequire("bYVp3");

var $3IWeJ = parcelRequire("3IWeJ");

var $4Snq1 = parcelRequire("4Snq1");

var $iuVy4 = parcelRequire("iuVy4");
const $196b8ca621695f22$var$columns = ()=>({
        c_cliente_id: new (0, $49qEn.EntityColumn)({
            name: 'c_cliente_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PKAutonum,
            prompt: 'Cliente ID'
        }),
        c_clienteguid_id: new (0, $49qEn.EntityColumn)({
            name: 'c_clienteguid_id',
            type: 'char',
            length: 36,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Clienteguid Id'
        }),
        c_empresa_id: new (0, $49qEn.EntityColumn)({
            name: 'c_empresa_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Empresa'
        }),
        vc_nombre_cliente: new (0, $49qEn.EntityColumn)({
            name: 'vc_nombre_cliente',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Nombre'
        }),
        c_condicionfacturacion_id: new (0, $49qEn.EntityColumn)({
            name: 'c_condicionfacturacion_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Condici\xf3n de facturaci\xf3n"
        }),
        c_condicionpago_id: new (0, $49qEn.EntityColumn)({
            name: 'c_condicionpago_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Condici\xf3n de pago"
        }),
        vc_codigoexterno: new (0, $49qEn.EntityColumn)({
            name: 'vc_codigoexterno',
            type: 'varchar',
            length: 50,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "C\xf3digo externo"
        }),
        c_tipofactura_id: new (0, $49qEn.EntityColumn)({
            name: 'c_tipofactura_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Tipo de factura'
        }),
        c_tiposervicio_id: new (0, $49qEn.EntityColumn)({
            name: 'c_tiposervicio_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Tipo de servicio'
        }),
        c_activo_id: new (0, $49qEn.EntityColumn)({
            name: 'c_activo_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Estado'
        }),
        vc_url_dashboard: new (0, $49qEn.EntityColumn)({
            name: 'vc_url_dashboard',
            type: 'varchar',
            length: 2048,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'URL Dashboard'
        }),
        vc_workspace_id: new (0, $49qEn.EntityColumn)({
            name: 'vc_workspace_id',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Workspace Id'
        }),
        vc_report_id: new (0, $49qEn.EntityColumn)({
            name: 'vc_report_id',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Report Id'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $196b8ca621695f22$var$views = ()=>({
        clie_brwStandard: {
            name: 'clie_brwStandard',
            keyMappings: {
                c_cliente_id: 0
            }
        }
    });
const $196b8ca621695f22$var$lookups = ()=>({
        'CondicionesFacturacion': {
            name: 'CondicionesFacturacion',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $2LSnU.CondicionesFacturacion)(client, parentKeys)
        },
        'CondicionesPago': {
            name: 'CondicionesPago',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $iHr81.CondicionesPago)(client, parentKeys)
        },
        'Empresas': {
            name: 'Empresas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $bYVp3.Empresas)(client, parentKeys)
        },
        'GruposEmpresas': {
            name: 'GruposEmpresas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $3IWeJ.GruposEmpresas)(client, parentKeys)
        },
        'Cadenas': {
            name: 'Cadenas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $SKbb0.Cadenas)(client, parentKeys)
        },
        'TiposFactura': {
            name: 'TiposFactura',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $6hvNA.catTiposFactura)(client, parentKeys)
        },
        'TiposServicio': {
            name: 'TiposServicio',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $5A5L0.catTiposServicio)(client, parentKeys)
        },
        'Activo': {
            name: 'Activo',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $5kp3N.estActivo)(client, parentKeys)
        }
    });
const $196b8ca621695f22$var$clientActions = ()=>({
        ACTImportarDatos: (0, $4Snq1.ACTImportarDatos),
        ACTVerImportaciones: (0, $iuVy4.ACTVerImportaciones)
    });
class $196b8ca621695f22$export$b5565345736d8a07 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('Clientes'), this.columns = $196b8ca621695f22$var$columns(), this.views = $196b8ca621695f22$var$views(), this.lookups = $196b8ca621695f22$var$lookups(), this.clientActions = $196b8ca621695f22$var$clientActions();
    }
}

});
parcelRegister("SKbb0", function(module, exports) {

$parcel$export(module.exports, "CadenasHelpText", () => $0e472f2a0e799ffd$export$f7f55b34f43539e9);
$parcel$export(module.exports, "CadenasIcon", () => $0e472f2a0e799ffd$export$927e47f7c1137725);
$parcel$export(module.exports, "Cadenas", () => $0e472f2a0e799ffd$export$c60fa3b37a3de5b7);

var $49qEn = parcelRequire("49qEn");

var $l1OTv = parcelRequire("l1OTv");

var $agWEn = parcelRequire("agWEn");
const $0e472f2a0e799ffd$export$f7f55b34f43539e9 = "* Aqu\xed puede ver la lista de todas las cadenas de tiendas disponibles. Una cadena puede estar relacionada con un solo grupo de empresas.";
const $0e472f2a0e799ffd$export$927e47f7c1137725 = (0, $l1OTv.default);
class $0e472f2a0e799ffd$export$c60fa3b37a3de5b7 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $agWEn.CadenasDef)(), parentKeys);
        this.Form = "AutoForm";
        this.HelpText = $0e472f2a0e799ffd$export$f7f55b34f43539e9;
        this.Icon = $0e472f2a0e799ffd$export$927e47f7c1137725;
    }
}

});
parcelRegister("l1OTv", function(module, exports) {

$parcel$export(module.exports, "default", () => $395f0fb901c27815$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $395f0fb901c27815$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M6 9a6 6 0 1 0 12 0a6 6 0 0 0 -12 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M12 3c1.333 .333 2 2.333 2 6s-.667 5.667 -2 6",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M12 3c-1.333 .333 -2 2.333 -2 6s.667 5.667 2 6",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M6 9h12",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M3 20h7",
            "key": "svg-4"
        }
    ],
    [
        "path",
        {
            "d": "M14 20h7",
            "key": "svg-5"
        }
    ],
    [
        "path",
        {
            "d": "M10 20a2 2 0 1 0 4 0a2 2 0 0 0 -4 0",
            "key": "svg-6"
        }
    ],
    [
        "path",
        {
            "d": "M12 15v3",
            "key": "svg-7"
        }
    ]
];
const $395f0fb901c27815$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "network", "Network", $395f0fb901c27815$export$3efd853dbb351e94);

});

parcelRegister("agWEn", function(module, exports) {

$parcel$export(module.exports, "CadenasDef", () => $6aecee871328c6bb$export$867ecbdaf4fd64af);

var $49qEn = parcelRequire("49qEn");
const $6aecee871328c6bb$var$columns = ()=>({
        c_cadena_id: new (0, $49qEn.EntityColumn)({
            name: 'c_cadena_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'ID',
            description: "Ingrese el c\xf3digo de la cadena"
        }),
        vc_cadena_nombre: new (0, $49qEn.EntityColumn)({
            name: 'vc_cadena_nombre',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: "Descripci\xf3n",
            description: "Ingrese la descripci\xf3n para la cadena"
        }),
        vc_codigoexterno: new (0, $49qEn.EntityColumn)({
            name: 'vc_codigoexterno',
            type: 'varchar',
            length: 50,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "C\xf3digo externo"
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $6aecee871328c6bb$var$views = ()=>({
        cade_brwStandard: {
            name: 'cade_brwStandard',
            keyMappings: {
                c_cadena_id: 0
            }
        }
    });
class $6aecee871328c6bb$export$867ecbdaf4fd64af extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('Cadenas'), this.columns = $6aecee871328c6bb$var$columns(), this.views = $6aecee871328c6bb$var$views();
    }
}

});


parcelRegister("6hvNA", function(module, exports) {

$parcel$export(module.exports, "catTiposFactura", () => $cc2863614b90925d$export$2316dbf9bc7a2975);

var $49qEn = parcelRequire("49qEn");

var $76yg6 = parcelRequire("76yg6");
const $cc2863614b90925d$export$7b96fd72caacd173 = (0, $76yg6.default);
const $cc2863614b90925d$export$5f99462e22c5503d = "* Aqu\xed puede los tipos de factura.";
class $cc2863614b90925d$export$2316dbf9bc7a2975 extends (0, $49qEn.CategoriesValues) {
    constructor(client, parentKeys = {}){
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "TiposFactura";
        this.def.columns.c_category_id.defaultValue = "TiposFactura";
        this.Title = "Tipos de Factura";
        this.HelpText = $cc2863614b90925d$export$5f99462e22c5503d;
        this.Icon = $cc2863614b90925d$export$7b96fd72caacd173;
    }
}

});
parcelRegister("76yg6", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb7a5ba957d2845c$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $bb7a5ba957d2845c$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M14 3v4a1 1 0 0 0 1 1h4",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M9 7l1 0",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M9 13l6 0",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M13 17l2 0",
            "key": "svg-4"
        }
    ]
];
const $bb7a5ba957d2845c$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "file-invoice", "FileInvoice", $bb7a5ba957d2845c$export$3efd853dbb351e94);

});


parcelRegister("5A5L0", function(module, exports) {

$parcel$export(module.exports, "TiposServicioIcon", () => $5c5a76489c48d7dd$export$fd36f3a022bada65);
$parcel$export(module.exports, "TiposServicioHelpText", () => $5c5a76489c48d7dd$export$1530d416644e69d4);
$parcel$export(module.exports, "catTiposServicio", () => $5c5a76489c48d7dd$export$cb3b2ab1cb202b3f);

var $49qEn = parcelRequire("49qEn");

var $kOjPo = parcelRequire("kOjPo");
const $5c5a76489c48d7dd$export$fd36f3a022bada65 = (0, $kOjPo.default);
const $5c5a76489c48d7dd$export$1530d416644e69d4 = "* Aqu\xed puede los diferentes tipos de servicio.";
class $5c5a76489c48d7dd$export$cb3b2ab1cb202b3f extends (0, $49qEn.CategoriesValues) {
    constructor(client, parentKeys = {}){
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "TiposServicio";
        this.def.columns.c_category_id.defaultValue = "TiposServicio";
        this.Title = "Tipos de Servicio";
        this.HelpText = $5c5a76489c48d7dd$export$1530d416644e69d4;
        this.Icon = $5c5a76489c48d7dd$export$fd36f3a022bada65;
    }
}

});
parcelRegister("kOjPo", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbb38e263d26d834$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $dbb38e263d26d834$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M6 4v4",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M6 12v8",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M13.199 14.399a2 2 0 1 0 -1.199 3.601",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M12 4v10",
            "key": "svg-4"
        }
    ],
    [
        "path",
        {
            "d": "M12 18v2",
            "key": "svg-5"
        }
    ],
    [
        "path",
        {
            "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0",
            "key": "svg-6"
        }
    ],
    [
        "path",
        {
            "d": "M18 4v1",
            "key": "svg-7"
        }
    ],
    [
        "path",
        {
            "d": "M18 9v2.5",
            "key": "svg-8"
        }
    ],
    [
        "path",
        {
            "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0",
            "key": "svg-9"
        }
    ],
    [
        "path",
        {
            "d": "M19.001 15.5v1.5",
            "key": "svg-10"
        }
    ],
    [
        "path",
        {
            "d": "M19.001 21v1.5",
            "key": "svg-11"
        }
    ],
    [
        "path",
        {
            "d": "M22.032 17.25l-1.299 .75",
            "key": "svg-12"
        }
    ],
    [
        "path",
        {
            "d": "M17.27 20l-1.3 .75",
            "key": "svg-13"
        }
    ],
    [
        "path",
        {
            "d": "M15.97 17.25l1.3 .75",
            "key": "svg-14"
        }
    ],
    [
        "path",
        {
            "d": "M20.733 20l1.3 .75",
            "key": "svg-15"
        }
    ]
];
const $dbb38e263d26d834$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "adjustments-cog", "AdjustmentsCog", $dbb38e263d26d834$export$3efd853dbb351e94);

});


parcelRegister("5kp3N", function(module, exports) {

$parcel$export(module.exports, "estActivo", () => $b8ba1323feae4334$export$e35ddf104bfbd8a7);

var $49qEn = parcelRequire("49qEn");

var $iIAH4 = parcelRequire("iIAH4");
const $b8ba1323feae4334$export$e7c72414bc76914a = (0, $iIAH4.default);
const $b8ba1323feae4334$export$387601df39f4d99 = "* Valores para estado Activo";
class $b8ba1323feae4334$export$e35ddf104bfbd8a7 extends (0, $49qEn.StatusValues) {
    constructor(client, parentKeys = {}){
        super(client, parentKeys);
        this.def.columns.c_status_id.value = "Activo";
        this.def.columns.c_status_id.defaultValue = "Activo";
        this.Title = "Estado Activo";
        this.HelpText = $b8ba1323feae4334$export$387601df39f4d99;
        this.Icon = $b8ba1323feae4334$export$e7c72414bc76914a;
    }
}

});
parcelRegister("iIAH4", function(module, exports) {

$parcel$export(module.exports, "default", () => $a87180de27633773$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $a87180de27633773$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M6 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M18 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M6 12v-2a6 6 0 1 1 12 0v2",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M15 9l3 3l3 -3",
            "key": "svg-3"
        }
    ]
];
const $a87180de27633773$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "status-change", "StatusChange", $a87180de27633773$export$3efd853dbb351e94);

});


parcelRegister("2LSnU", function(module, exports) {

$parcel$export(module.exports, "CondicionesFacturacionIcon", () => $50aa4a3be4e7989c$export$3b9967b8690f6266);
$parcel$export(module.exports, "CondicionesFacturacion", () => $50aa4a3be4e7989c$export$e17dbcb1cd673af0);

var $49qEn = parcelRequire("49qEn");

var $bND1J = parcelRequire("bND1J");

var $joZIy = parcelRequire("joZIy");
const $50aa4a3be4e7989c$export$b07f9afe543984fc = "* Aqu\xed puede ver las condiciones de facturaci\xf3n.";
const $50aa4a3be4e7989c$export$3b9967b8690f6266 = (0, $bND1J.default);

class $50aa4a3be4e7989c$export$e17dbcb1cd673af0 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $joZIy.CondicionesFacturacionDef)(), parentKeys);
        this.Form = (parcelRequire("8zM2m")).then((module)=>module.CondicionesFacturacionForm);
        this.Icon = $50aa4a3be4e7989c$export$3b9967b8690f6266;
        this.HelpText = $50aa4a3be4e7989c$export$b07f9afe543984fc;
        this.Title = "Condiciones de Facturaci\xf3n";
    }
}

});
parcelRegister("bND1J", function(module, exports) {

$parcel$export(module.exports, "default", () => $5259df49fa7116c7$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $5259df49fa7116c7$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M14.8 9a2 2 0 0 0 -1.8 -1h-2a2 2 0 1 0 0 4h2a2 2 0 1 1 0 4h-2a2 2 0 0 1 -1.8 -1",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M12 7v10",
            "key": "svg-2"
        }
    ]
];
const $5259df49fa7116c7$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "coin", "Coin", $5259df49fa7116c7$export$3efd853dbb351e94);

});

parcelRegister("joZIy", function(module, exports) {

$parcel$export(module.exports, "CondicionesFacturacionDef", () => $a0a8959d04ea1f0c$export$54fc726aab99d042);

var $49qEn = parcelRequire("49qEn");
const $a0a8959d04ea1f0c$var$columns = ()=>({
        c_condicionfacturacion_id: new (0, $49qEn.EntityColumn)({
            name: 'c_condicionfacturacion_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: "Condici\xf3n de facturacion ID"
        }),
        vc_descripcion: new (0, $49qEn.EntityColumn)({
            name: 'vc_descripcion',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: "Descripci\xf3n"
        }),
        i_dias: new (0, $49qEn.EntityColumn)({
            name: 'i_dias',
            type: 'int',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: "D\xedas"
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $a0a8959d04ea1f0c$var$views = ()=>({
        cdfc_brwStandard: {
            name: 'cdfc_brwStandard',
            keyMappings: {
                c_condicionfacturacion_id: 0
            }
        }
    });
class $a0a8959d04ea1f0c$export$54fc726aab99d042 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('CondicionesFacturacion'), this.columns = $a0a8959d04ea1f0c$var$columns(), this.views = $a0a8959d04ea1f0c$var$views();
    }
}

});

parcelRegister("8zM2m", function(module, exports) {
module.exports = import("dVUx3").then(()=>parcelRequire('82cOK'));

});


parcelRegister("iHr81", function(module, exports) {

$parcel$export(module.exports, "CondicionesPago", () => $9ebe11dee5b1f068$export$eaf49018fb6cccab);

var $49qEn = parcelRequire("49qEn");

var $6sz6Z = parcelRequire("6sz6Z");

var $dl43Z = parcelRequire("dl43Z");
const $9ebe11dee5b1f068$export$50d5cdb9771d80c0 = "* Aqu\xed puede ver las condiciones de pago.";
const $9ebe11dee5b1f068$export$a26f02156e27e7cc = (0, $6sz6Z.default);

class $9ebe11dee5b1f068$export$eaf49018fb6cccab extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $dl43Z.CondicionesPagoDef)(), parentKeys);
        super.Form = (parcelRequire("oxDWK")).then((module)=>module.CondicionesPagoForm);
        this.Title = 'Condiciones de pago';
        this.Icon = $9ebe11dee5b1f068$export$a26f02156e27e7cc;
        this.HelpText = $9ebe11dee5b1f068$export$50d5cdb9771d80c0;
    }
}

});
parcelRegister("6sz6Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f9923b39407c282$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $3f9923b39407c282$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M7 15h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v3",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M7 9m0 1a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1z",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M12 14a2 2 0 1 0 4 0a2 2 0 0 0 -4 0",
            "key": "svg-2"
        }
    ]
];
const $3f9923b39407c282$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "cash", "Cash", $3f9923b39407c282$export$3efd853dbb351e94);

});

parcelRegister("dl43Z", function(module, exports) {

$parcel$export(module.exports, "CondicionesPagoDef", () => $e8c65e82f0b2a34c$export$30c18d9d6ca51d3a);

var $49qEn = parcelRequire("49qEn");
const $e8c65e82f0b2a34c$var$columns = ()=>({
        c_condicionpago_id: new (0, $49qEn.EntityColumn)({
            name: 'c_condicionpago_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: "Condici\xf3n de pago ID"
        }),
        vc_descripcion: new (0, $49qEn.EntityColumn)({
            name: 'vc_descripcion',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: "Descripci\xf3n"
        }),
        i_dias: new (0, $49qEn.EntityColumn)({
            name: 'i_dias',
            type: 'int',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Dias'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $e8c65e82f0b2a34c$var$views = ()=>({
        cdpg_brwStandard: {
            name: 'cdpg_brwStandard',
            keyMappings: {
                c_condicionpago_id: 0
            }
        }
    });
class $e8c65e82f0b2a34c$export$30c18d9d6ca51d3a extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('CondicionesPago'), this.columns = $e8c65e82f0b2a34c$var$columns(), this.views = $e8c65e82f0b2a34c$var$views();
    }
}

});

parcelRegister("oxDWK", function(module, exports) {
module.exports = import("2HDNH").then(()=>parcelRequire('3aQTF'));

});


parcelRegister("bYVp3", function(module, exports) {

$parcel$export(module.exports, "EmpresasHelpText", () => $3e13b0afa4522183$export$808b62ceb320f3a2);
$parcel$export(module.exports, "EmpresasIcon", () => $3e13b0afa4522183$export$d4ee309c28a64bb2);
$parcel$export(module.exports, "Empresas", () => $3e13b0afa4522183$export$264daae3a00c7119);

var $49qEn = parcelRequire("49qEn");

var $2JAvD = parcelRequire("2JAvD");

var $6tY8v = parcelRequire("6tY8v");
const $3e13b0afa4522183$export$808b62ceb320f3a2 = "* Aqu\xed tendra la lista de las empresas. Podra ver desde empresas disponibles para asociar a las tiendas, c\xf3mo tambien, empresas asignadas a numerosas tiendas y grupos.";
const $3e13b0afa4522183$export$d4ee309c28a64bb2 = (0, $2JAvD.default);

class $3e13b0afa4522183$export$264daae3a00c7119 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $6tY8v.EmpresasDef)(), parentKeys);
        this.Form = (parcelRequire("fakyl")).then((module)=>module.EmpresasForm);
        this.Title = "Empresas";
        this.HelpText = $3e13b0afa4522183$export$808b62ceb320f3a2;
        this.Icon = $3e13b0afa4522183$export$d4ee309c28a64bb2;
    }
}

});
parcelRegister("6tY8v", function(module, exports) {

$parcel$export(module.exports, "EmpresasDef", () => $7332962cc2b492e5$export$dffd206a87638370);

var $49qEn = parcelRequire("49qEn");

var $3IWeJ = parcelRequire("3IWeJ");
const $7332962cc2b492e5$var$columns = ()=>({
        c_empresa_id: new (0, $49qEn.EntityColumn)({
            name: 'c_empresa_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PKAutonum,
            prompt: 'Empresa ID'
        }),
        vc_nombreempresa: new (0, $49qEn.EntityColumn)({
            name: 'vc_nombreempresa',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Nombre'
        }),
        vc_razonsocial: new (0, $49qEn.EntityColumn)({
            name: 'vc_razonsocial',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: "Raz\xf3n social"
        }),
        c_grupoempresa_id: new (0, $49qEn.EntityColumn)({
            name: 'c_grupoempresa_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Grupo'
        }),
        c_cuit_id: new (0, $49qEn.EntityColumn)({
            name: 'c_cuit_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Cuit'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $7332962cc2b492e5$var$views = ()=>({
        empr_brwStandard: {
            name: 'empr_brwStandard',
            keyMappings: {
                c_empresa_id: 0,
                c_grupoempresa_id: -1
            }
        },
        empr_brwPorGrupo: {
            name: 'empr_brwPorGrupo',
            keyMappings: {
                c_empresa_id: 0,
                c_grupoempresa_id: -1
            }
        }
    });
const $7332962cc2b492e5$var$lookups = ()=>({
        'GruposEmpresas': {
            name: 'GruposEmpresas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $3IWeJ.GruposEmpresas)(client, parentKeys)
        }
    });
class $7332962cc2b492e5$export$dffd206a87638370 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('Empresas'), this.columns = $7332962cc2b492e5$var$columns(), this.views = $7332962cc2b492e5$var$views(), this.lookups = $7332962cc2b492e5$var$lookups();
    }
}

});
parcelRegister("3IWeJ", function(module, exports) {

$parcel$export(module.exports, "GruposEmpresasHelpText", () => $196316377b9c36cf$export$b34b7a23294242a9);
$parcel$export(module.exports, "GruposEmpresasIcon", () => $196316377b9c36cf$export$87b16043b61db566);
$parcel$export(module.exports, "GruposEmpresas", () => $196316377b9c36cf$export$b3d416d56e14ec5d);

var $49qEn = parcelRequire("49qEn");

var $7sO5w = parcelRequire("7sO5w");

var $jvVF9 = parcelRequire("jvVF9");
const $196316377b9c36cf$export$b34b7a23294242a9 = "* Aqu\xed podra ver todos los grupos de empresas.";
const $196316377b9c36cf$export$87b16043b61db566 = (0, $7sO5w.default);

class $196316377b9c36cf$export$b3d416d56e14ec5d extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $jvVF9.GruposEmpresasDef)(), parentKeys);
        this.Form = (parcelRequire("3zhg5")).then((module)=>module.GruposEmpresasForm);
        this.Title = "Grupos de Empresas";
        this.Icon = $196316377b9c36cf$export$87b16043b61db566;
        this.HelpText = $196316377b9c36cf$export$b34b7a23294242a9;
    }
}

});
parcelRegister("7sO5w", function(module, exports) {

$parcel$export(module.exports, "default", () => $264d2b7458b7f52b$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $264d2b7458b7f52b$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M3 21l18 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M5 21v-14l8 -4v18",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M19 21v-10l-6 -4",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M9 9l0 .01",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M9 12l0 .01",
            "key": "svg-4"
        }
    ],
    [
        "path",
        {
            "d": "M9 15l0 .01",
            "key": "svg-5"
        }
    ],
    [
        "path",
        {
            "d": "M9 18l0 .01",
            "key": "svg-6"
        }
    ]
];
const $264d2b7458b7f52b$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "building-skyscraper", "BuildingSkyscraper", $264d2b7458b7f52b$export$3efd853dbb351e94);

});

parcelRegister("jvVF9", function(module, exports) {

$parcel$export(module.exports, "GruposEmpresasDef", () => $3187e73ed831667d$export$220228cd50587bb3);

var $49qEn = parcelRequire("49qEn");

var $SKbb0 = parcelRequire("SKbb0");

var $6TYT5 = parcelRequire("6TYT5");
const $3187e73ed831667d$var$columns = ()=>({
        c_grupoempresa_id: new (0, $49qEn.EntityColumn)({
            name: 'c_grupoempresa_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PKAutonum,
            prompt: 'Grupo ID'
        }),
        vc_nombre: new (0, $49qEn.EntityColumn)({
            name: 'vc_nombre',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Nombre'
        }),
        vc_canales: new (0, $49qEn.EntityColumn)({
            name: 'vc_canales',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Canales',
            isArray: true
        }),
        vc_cadenas: new (0, $49qEn.EntityColumn)({
            name: 'vc_cadenas',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Cadenas',
            isArray: true
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $3187e73ed831667d$var$views = ()=>({
        grem_brwStandard: {
            name: 'grem_brwStandard',
            keyMappings: {
                c_grupoempresa_id: 0
            }
        }
    });
const $3187e73ed831667d$var$lookups = ()=>({
        'Canales': {
            name: 'Canales',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $6TYT5.catCanales)(client, parentKeys)
        },
        'Cadenas': {
            name: 'Cadenas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $SKbb0.Cadenas)(client, parentKeys)
        }
    });
class $3187e73ed831667d$export$220228cd50587bb3 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('GruposEmpresas'), this.columns = $3187e73ed831667d$var$columns(), this.views = $3187e73ed831667d$var$views(), this.lookups = $3187e73ed831667d$var$lookups();
    }
}

});
parcelRegister("6TYT5", function(module, exports) {

$parcel$export(module.exports, "CanalesIcon", () => $a48a1aee2a9fc287$export$9ef2eec132d794ca);
$parcel$export(module.exports, "CanalesHelpText", () => $a48a1aee2a9fc287$export$c133396137bab45e);
$parcel$export(module.exports, "catCanales", () => $a48a1aee2a9fc287$export$c2d1fb575b52422c);

var $49qEn = parcelRequire("49qEn");

var $l9ipQ = parcelRequire("l9ipQ");
const $a48a1aee2a9fc287$export$9ef2eec132d794ca = (0, $l9ipQ.default);
const $a48a1aee2a9fc287$export$c133396137bab45e = "* Los canales indican una agrupaci\xf3n transversal utilizada para las tiendas. Un canal puede estar relacionado a varias tiendas.";
class $a48a1aee2a9fc287$export$c2d1fb575b52422c extends (0, $49qEn.CategoriesValues) {
    constructor(client, parentKeys = {}){
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "Canales";
        this.def.columns.c_category_id.defaultValue = "Canales";
        this.Title = "Canales";
        this.HelpText = $a48a1aee2a9fc287$export$c133396137bab45e;
        this.Icon = $a48a1aee2a9fc287$export$9ef2eec132d794ca;
    }
}

});
parcelRegister("l9ipQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $63881bf632e4101a$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $63881bf632e4101a$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M4 4h6v6h-6z",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M14 4h6v6h-6z",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M4 14h6v6h-6z",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M17 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0",
            "key": "svg-3"
        }
    ]
];
const $63881bf632e4101a$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "category", "Category", $63881bf632e4101a$export$3efd853dbb351e94);

});



parcelRegister("3zhg5", function(module, exports) {
module.exports = import("ldp1A").then(()=>parcelRequire('3a1hM'));

});



parcelRegister("fakyl", function(module, exports) {
module.exports = import("jV2nd").then(()=>parcelRequire('cSG35'));

});


parcelRegister("4Snq1", function(module, exports) {

$parcel$export(module.exports, "ACTImportarDatos", () => $f03ba254f4c0bc28$export$db1355c52fd8a435);

var $ayMG0 = parcelRequire("ayMG0");

var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $283Rc = parcelRequire("283Rc");
const $f03ba254f4c0bc28$export$db1355c52fd8a435 = {
    name: 'ACTImportarDatos',
    label: 'Importar Datos',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Importar Datos"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    views: [
        'clie_brwStandard'
    ],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const clientesVmi = new (0, $283Rc.ClientesVmi)(entity.API.client);
        clientesVmi.def.columns.c_cliente_backoffice_id.value = selectedKeys[0].c_cliente_id || '';
        await (0, $49qEn.openEntityForm)({
            modals: modal,
            formProps: {
                entity: clientesVmi,
                initialFormMode: 'add',
                getDataOnInit: false
            },
            modalFormSize: 'xl',
            handleModalSaved: async ()=>{
                await modal.close();
                if (onClose) await onClose();
            },
            handleModalCancel: async ()=>{
                await modal.close();
                if (onClose) await onClose();
            }
        });
        return false;
    }
};

});

parcelRegister("iuVy4", function(module, exports) {

$parcel$export(module.exports, "ACTVerImportaciones", () => $1ec0d3fd2e06cbc2$export$669f660cc9308213);

var $ayMG0 = parcelRequire("ayMG0");

var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");

var $283Rc = parcelRequire("283Rc");
const $1ec0d3fd2e06cbc2$export$669f660cc9308213 = {
    name: 'ACTVerImportaciones',
    label: 'Ver Importaciones',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Ver Importaciones"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    views: [
        'clie_brwStandard'
    ],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const clientesVmi = new (0, $283Rc.ClientesVmi)(entity.API.client);
        clientesVmi.parentKeys = entity.parentKeys;
        clientesVmi.def.columns.c_cliente_backoffice_id.value = selectedKeys[0].c_cliente_id || '';
        await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                            size: "1.5rem",
                            stroke: "1.5"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            fw: "700",
                            children: "Importaciones"
                        })
                    ]
                }),
                size: "xl"
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: entity.API.client,
                entityConstructor: ()=>clientesVmi,
                formMode: "view",
                viewName: "cvmi_brwPorClienteBackoffice",
                refreshOnInit: true,
                enableAdd: false,
                enableDelete: false,
                enableEdit: false,
                enableView: true,
                selectionMode: "single"
            }, "importacion-datos")
        });
        return false;
    }
};

});


parcelRegister("3rbj2", function(module, exports) {
module.exports = Promise.all([
    import("iL7AZ"),
    import("1AiM9")
]).then(()=>parcelRequire('iYDWR'));

});


parcelRegister("7LP39", function(module, exports) {

$parcel$export(module.exports, "PersonalIcon", () => $187624778c5dc79b$export$df05e9dbe24e5903);
$parcel$export(module.exports, "PersonalHelpText", () => $187624778c5dc79b$export$ecfd87f9ae413ac);
$parcel$export(module.exports, "Personal", () => $187624778c5dc79b$export$3965927bf7a81700);

var $49qEn = parcelRequire("49qEn");

var $7fSvM = parcelRequire("7fSvM");

var $dOF90 = parcelRequire("dOF90");
const $187624778c5dc79b$export$df05e9dbe24e5903 = (0, $7fSvM.default);
const $187624778c5dc79b$export$ecfd87f9ae413ac = "* Aqu\xed puede ver la lista de todo el personal.";

class $187624778c5dc79b$export$3965927bf7a81700 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $dOF90.PersonalDef)(), parentKeys);
        this.Form = (parcelRequire("971Cw")).then((module)=>module.PersonalForm);
        this.Title = "Personal";
        this.Icon = $187624778c5dc79b$export$df05e9dbe24e5903;
        this.HelpText = $187624778c5dc79b$export$ecfd87f9ae413ac;
    }
}

});
parcelRegister("7fSvM", function(module, exports) {

$parcel$export(module.exports, "default", () => $46ef1534f8f42e73$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $46ef1534f8f42e73$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M6 21v-2a4 4 0 0 1 4 -4h4",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M15 19l2 2l4 -4",
            "key": "svg-2"
        }
    ]
];
const $46ef1534f8f42e73$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "user-check", "UserCheck", $46ef1534f8f42e73$export$3efd853dbb351e94);

});

parcelRegister("dOF90", function(module, exports) {

$parcel$export(module.exports, "PersonalDef", () => $3e87231be9b88067$export$31b27bd815ab5135);

var $49qEn = parcelRequire("49qEn");

var $aCFMu = parcelRequire("aCFMu");

var $bMvwR = parcelRequire("bMvwR");

var $316Pw = parcelRequire("316Pw");

var $841Z4 = parcelRequire("841Z4");

var $exmmN = parcelRequire("exmmN");

var $8PdZ4 = parcelRequire("8PdZ4");

var $9hCID = parcelRequire("9hCID");

var $gZrbO = parcelRequire("gZrbO");

var $a4nBq = parcelRequire("a4nBq");

var $9rTPL = parcelRequire("9rTPL");

var $jhL1X = parcelRequire("jhL1X");

var $dUhns = parcelRequire("dUhns");

var $8mlq5 = parcelRequire("8mlq5");

var $2qzcD = parcelRequire("2qzcD");

var $6KtvS = parcelRequire("6KtvS");

var $ctXMm = parcelRequire("ctXMm");

var $hsl31 = parcelRequire("hsl31");

var $7LP39 = parcelRequire("7LP39");

var $B2kod = parcelRequire("B2kod");

var $gZOwU = parcelRequire("gZOwU");

var $jNo5L = parcelRequire("jNo5L");
const $3e87231be9b88067$var$columns = ()=>({
        c_personal_id: new (0, $49qEn.EntityColumn)({
            name: 'c_personal_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PKAutonum,
            prompt: 'Personal Id'
        }),
        c_personalguid_id: new (0, $49qEn.EntityColumn)({
            name: 'c_personalguid_id',
            type: 'char',
            length: 36,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Personalguid Id'
        }),
        c_persona_id: new (0, $49qEn.EntityColumn)({
            name: 'c_persona_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Persona Id'
        }),
        c_puestotrabajo_id: new (0, $49qEn.EntityColumn)({
            name: 'c_puestotrabajo_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Puesto Trabajo'
        }),
        c_personallegajo_id: new (0, $49qEn.EntityColumn)({
            name: 'c_personallegajo_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Legajo RRHH'
        }),
        dt_fecha_alta: new (0, $49qEn.EntityColumn)({
            name: 'dt_fecha_alta',
            type: 'datetime',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Fecha Alta'
        }),
        vc_numerodni: new (0, $49qEn.EntityColumn)({
            name: 'vc_numerodni',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'DNI'
        }),
        vc_numerocuil: new (0, $49qEn.EntityColumn)({
            name: 'vc_numerocuil',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'CUIL'
        }),
        c_areapersonal_id: new (0, $49qEn.EntityColumn)({
            name: 'c_areapersonal_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Area'
        }),
        c_banco_id: new (0, $49qEn.EntityColumn)({
            name: 'c_banco_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Banco'
        }),
        vc_nombre: new (0, $49qEn.EntityColumn)({
            name: 'vc_nombre',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Nombre'
        }),
        vc_apellido: new (0, $49qEn.EntityColumn)({
            name: 'vc_apellido',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Apellido'
        }),
        dt_nacimiento: new (0, $49qEn.EntityColumn)({
            name: 'dt_nacimiento',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Nacimiento'
        }),
        c_fotofileprocess_id: new (0, $49qEn.EntityColumn)({
            name: 'c_fotofileprocess_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Fotofileprocess Id'
        }),
        c_genero_id: new (0, $49qEn.EntityColumn)({
            name: 'c_genero_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "G\xe9nero"
        }),
        c_dnifileprocess_id: new (0, $49qEn.EntityColumn)({
            name: 'c_dnifileprocess_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Dnifileprocess Id'
        }),
        c_cuilfileprocess_id: new (0, $49qEn.EntityColumn)({
            name: 'c_cuilfileprocess_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Cuilfileprocess Id'
        }),
        vc_fotoguid: new (0, $49qEn.EntityColumn)({
            name: 'vc_fotoguid',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Fotoguid'
        }),
        c_plantillahorario_id: new (0, $49qEn.EntityColumn)({
            name: 'c_plantillahorario_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Plantilla Horario'
        }),
        vc_telefono: new (0, $49qEn.EntityColumn)({
            name: 'vc_telefono',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Tel\xe9fono"
        }),
        vc_celular: new (0, $49qEn.EntityColumn)({
            name: 'vc_celular',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Celular'
        }),
        vc_celular_trabajo: new (0, $49qEn.EntityColumn)({
            name: 'vc_celular_trabajo',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Celular Trabajo'
        }),
        vc_telefono_alternativo: new (0, $49qEn.EntityColumn)({
            name: 'vc_telefono_alternativo',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Tel\xe9fono Alternativo"
        }),
        vc_email: new (0, $49qEn.EntityColumn)({
            name: 'vc_email',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Email'
        }),
        vc_email_alternativo: new (0, $49qEn.EntityColumn)({
            name: 'vc_email_alternativo',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Email Alternativo'
        }),
        c_superior_id: new (0, $49qEn.EntityColumn)({
            name: 'c_superior_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Superior'
        }),
        ...(0, $aCFMu.DomiciliosColumns)(false),
        dt_fecha_baja: new (0, $49qEn.EntityColumn)({
            name: 'dt_fecha_baja',
            type: 'datetime',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Fecha Baja'
        }),
        c_motivobaja_id: new (0, $49qEn.EntityColumn)({
            name: 'c_motivobaja_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Motivo'
        }),
        vc_observaciones_baja: new (0, $49qEn.EntityColumn)({
            name: 'vc_observaciones_baja',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Observaciones'
        }),
        ...(0, $49qEn.MicromUserStatusPanelColumns)(),
        ...(0, $49qEn.DefaultColumns)()
    });
const $3e87231be9b88067$var$views = ()=>({
        perl_brwStandard: {
            name: 'perl_brwStandard',
            keyMappings: {
                c_personal_id: 0
            }
        },
        perl_brwCard: {
            name: 'perl_brwCard',
            keyMappings: {
                c_personal_id: 0
            },
            FiltersEntity: (client, parentKeys)=>new (0, $gZOwU.PersonalFilters)(client, parentKeys)
        },
        perl_brwGetPorDNI: {
            name: 'perl_brwGetPorDNI',
            keyMappings: {
                c_personal_id: 0,
                c_persona_id: 1
            }
        },
        perl_brwAsignadoATiendas: {
            name: 'perl_brwAsignadoATiendas',
            keyMappings: {
                c_personal_id: 0
            }
        },
        perl_brwJefes: {
            name: 'perl_brwJefes',
            keyMappings: {
                c_personal_id: 0
            }
        },
        perl_brwEnRutas: {
            name: 'perl_brwEnRutas',
            keyMappings: {
                c_personal_id: 0
            }
        },
        perl_brwGestionPersonal: {
            name: 'perl_brwGestionPersonal',
            keyMappings: {
                c_personal_id: 0,
                vc_nombre: 1
            },
            FiltersEntity: (client, parentKeys)=>new (0, $jNo5L.PersonalGestionFilters)(client, parentKeys)
        },
        perl_brwGestionPersonalDetalles: {
            name: 'perl_brwGestionPersonalDetalles',
            keyMappings: {
                c_personal_id: 0
            },
            FiltersEntity: (client, parentKeys)=>new (0, $B2kod.PersonalAsignarFilters)(client, parentKeys),
            mapMarkerRenderer: (0, $hsl31.GestionPersonalDetallesViewMarkerRenderer),
            mapInfoWindowRenderer: (0, $ctXMm.GestionPersonalDetallesViewInfoWindowRenderer)
        },
        perl_brwGestionPersonalDetallesAgregar: {
            name: 'perl_brwGestionPersonalDetallesAgregar',
            keyMappings: {
                c_personal_id: 0
            },
            FiltersEntity: (client, parentKeys)=>new (0, $B2kod.PersonalAsignarFilters)(client, parentKeys)
        },
        perl_brwGestionPersonalDetallesReasignar: {
            name: 'perl_brwGestionPersonalDetallesReasignar',
            keyMappings: {
                c_personal_id: 0
            },
            FiltersEntity: (client, parentKeys)=>new (0, $B2kod.PersonalAsignarFilters)(client, parentKeys)
        }
    });
const $3e87231be9b88067$var$lookups = ()=>({
        'Personas': {
            name: 'Personas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $9hCID.Personas)(client, parentKeys)
        },
        'PuestosTrabajo': {
            name: 'PuestosTrabajo',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $a4nBq.PuestosTrabajo)(client, parentKeys)
        },
        'TiposDocumento': {
            name: 'TiposDocumento',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $8PdZ4.catTiposDocumento)(client, parentKeys)
        },
        'AreasPersonal': {
            name: 'AreasPersonal',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $316Pw.catAreasPersonal)(client, parentKeys)
        },
        'Genero': {
            name: 'Genero',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $841Z4.catGenero)(client, parentKeys)
        },
        'PlantillasHorarios': {
            name: 'PlantillasHorarios',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $gZrbO.PlantillasHorarios)(client, parentKeys)
        },
        'Superior': {
            name: 'Superior',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            bindingColumnKey: 'c_personal_id',
            entityConstructor: (client, parentKeys)=>new (0, $7LP39.Personal)(client, parentKeys)
        },
        'MotivosBaja': {
            name: 'MotivosBaja',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $exmmN.catMotivosBaja)(client, parentKeys)
        },
        'Bancos': {
            name: 'Bancos',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $bMvwR.Bancos)(client, parentKeys)
        },
        ...(0, $aCFMu.DomiciliosLookups)(),
        ...(0, $49qEn.MicromUsersStatusPanelLookups)()
    });
const $3e87231be9b88067$var$procs = ()=>({
        perl_AsignarSuperior: {
            name: 'perl_AsignarSuperior'
        },
        perl_ReemplazarPersonal: {
            name: 'perl_ReemplazarPersonal'
        }
    });
const $3e87231be9b88067$var$clientActions = ()=>({
        ACTAsignarSuperior: (0, $jhL1X.ACTAsignarSuperior),
        ACTReemplazarPersonal: (0, $6KtvS.ACTReemplazarPersonal),
        ACTGestionarPersonal: (0, $8mlq5.ACTGestionarPersonal),
        ACTAgregarPersonal: (0, $9rTPL.ACTAgregarPersonal),
        ACTEliminarPersonal: (0, $dUhns.ACTEliminarPersonal),
        ACTReasignarPersonal: (0, $2qzcD.ACTReasignarPersonal)
    });
class $3e87231be9b88067$export$31b27bd815ab5135 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('Personal'), this.columns = $3e87231be9b88067$var$columns(), this.views = $3e87231be9b88067$var$views(), this.lookups = $3e87231be9b88067$var$lookups(), this.procs = $3e87231be9b88067$var$procs(), this.clientActions = $3e87231be9b88067$var$clientActions();
    }
}

});
parcelRegister("aCFMu", function(module, exports) {

$parcel$export(module.exports, "DomiciliosColumnKeys", () => $6a51ec48f832d72f$export$c5617af2b2303e4f);
$parcel$export(module.exports, "DomiciliosColumns", () => $6a51ec48f832d72f$export$e711310c74ddd2b3);
$parcel$export(module.exports, "DomiciliosLookupsKeys", () => $6a51ec48f832d72f$export$5647c431943bebef);
$parcel$export(module.exports, "DomiciliosLookups", () => $6a51ec48f832d72f$export$9075e384b1598c6f);

var $49qEn = parcelRequire("49qEn");

var $aXfnS = parcelRequire("aXfnS");

var $kFypM = parcelRequire("kFypM");

var $aQujn = parcelRequire("aQujn");

var $j8GP5 = parcelRequire("j8GP5");

var $4Rlmx = parcelRequire("4Rlmx");
const $6a51ec48f832d72f$export$c5617af2b2303e4f = [
    'f_latitud',
    'f_longitud',
    'i_utc_offset_minutes',
    'c_pais_id',
    'c_provincia_id',
    'c_ciudad_id',
    'c_localidad_id',
    'vc_calle',
    'vc_altura',
    'vc_piso',
    'vc_departamento',
    'vc_codigopostal',
    'vc_domicilio_completo',
    'vc_tiposdomicilio'
];
const $6a51ec48f832d72f$export$e711310c74ddd2b3 = (required)=>({
        f_latitud: new (0, $49qEn.EntityColumn)({
            name: 'f_latitud',
            type: 'float',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Latitud',
            description: "Indica la latitud de la posici\xf3n GPS"
        }),
        f_longitud: new (0, $49qEn.EntityColumn)({
            name: 'f_longitud',
            type: 'float',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Longitud',
            description: "Indica la longitud de la posici\xf3n GPS"
        }),
        i_utc_offset_minutes: new (0, $49qEn.EntityColumn)({
            name: 'i_utc_offset_minutes',
            type: 'int',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Utc Offset Minutes',
            description: 'Indica la diferencia en minutos con respecto a la hora UTC'
        }),
        c_pais_id: new (0, $49qEn.EntityColumn)({
            name: 'c_pais_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Pa\xeds",
            description: "Indique el pa\xeds"
        }),
        c_provincia_id: new (0, $49qEn.EntityColumn)({
            name: 'c_provincia_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Provincia',
            description: 'Indique la provincia'
        }),
        c_ciudad_id: new (0, $49qEn.EntityColumn)({
            name: 'c_ciudad_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Ciudad',
            description: 'Indique la ciudad'
        }),
        c_localidad_id: new (0, $49qEn.EntityColumn)({
            name: 'c_localidad_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Localidad',
            description: 'Indique la localidad'
        }),
        vc_calle: new (0, $49qEn.EntityColumn)({
            name: 'vc_calle',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Calle',
            description: 'Indique la calle'
        }),
        vc_altura: new (0, $49qEn.EntityColumn)({
            name: 'vc_altura',
            type: 'varchar',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Numeraci\xf3n calle",
            description: "Indique la numeraci\xf3n de la calle"
        }),
        vc_piso: new (0, $49qEn.EntityColumn)({
            name: 'vc_piso',
            type: 'varchar',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Piso',
            description: 'Indique el piso'
        }),
        vc_departamento: new (0, $49qEn.EntityColumn)({
            name: 'vc_departamento',
            type: 'varchar',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Apartamento',
            description: 'Indique el apartamento'
        }),
        vc_codigopostal: new (0, $49qEn.EntityColumn)({
            name: 'vc_codigopostal',
            type: 'varchar',
            length: 50,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "C\xf3digo postal",
            description: "Indique el c\xf3digo postal"
        }),
        vc_domicilio_completo: new (0, $49qEn.EntityColumn)({
            name: 'vc_domicilio_completo',
            type: 'varchar',
            length: 2048,
            flags: required ? (0, $49qEn.CommonFlags).Edit : (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Domicilio',
            description: 'Ingrese el domiclio a buscar'
        }),
        vc_tiposdomicilio: new (0, $49qEn.EntityColumn)({
            name: 'vc_tiposdomicilio',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Tipo de Domicilio',
            isArray: true,
            description: 'Indique los tipos de domicilio'
        })
    });
const $6a51ec48f832d72f$export$5647c431943bebef = [
    'Paises',
    'Provincias',
    'Ciudades',
    'Localidades',
    'TiposDomicilio'
];
const $6a51ec48f832d72f$export$9075e384b1598c6f = ()=>({
        'Paises': {
            name: 'Paises',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $j8GP5.Paises)(client, parentKeys)
        },
        'Provincias': {
            name: 'Provincias',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $4Rlmx.Provincias)(client, parentKeys)
        },
        'Ciudades': {
            name: 'Ciudades',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $kFypM.Ciudades)(client, parentKeys)
        },
        'Localidades': {
            name: 'Localidades',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $aQujn.Localidades)(client, parentKeys)
        },
        'TiposDomicilio': {
            name: 'TiposDomicilio',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $aXfnS.catTiposDomicilio)(client, parentKeys)
        }
    });

});
parcelRegister("aXfnS", function(module, exports) {

$parcel$export(module.exports, "catTiposDomicilio", () => $63ab90450cf5fac3$export$c204ed03fd4e540a);

var $49qEn = parcelRequire("49qEn");
class $63ab90450cf5fac3$export$c204ed03fd4e540a extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $49qEn.CategoriesValuesDef)(), parentKeys);
        this.def.columns.c_category_id.value = "TiposDomicilio";
        this.def.columns.c_category_id.defaultValue = "TiposDomicilio";
        this.Title = "Tipos de domicilio";
    }
}

});

parcelRegister("kFypM", function(module, exports) {

$parcel$export(module.exports, "CiudadesIcon", () => $fdfc1c4ddb81ade5$export$2bdf2f2e82a20094);
$parcel$export(module.exports, "CiudadesHelpText", () => $fdfc1c4ddb81ade5$export$c72cda3fb3ccac65);
$parcel$export(module.exports, "Ciudades", () => $fdfc1c4ddb81ade5$export$11bf2ca199119815);

var $49qEn = parcelRequire("49qEn");

var $ey9pc = parcelRequire("ey9pc");

var $4YQwj = parcelRequire("4YQwj");
const $fdfc1c4ddb81ade5$export$2bdf2f2e82a20094 = (0, $ey9pc.default);
const $fdfc1c4ddb81ade5$export$c72cda3fb3ccac65 = "* Aqu\xed puede ver la lista de ciudades de la provincia seleccionada.";

class $fdfc1c4ddb81ade5$export$11bf2ca199119815 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $4YQwj.CiudadesDef)(), parentKeys);
        this.Form = (parcelRequire("7vtwt")).then((module)=>module.CiudadesForm);
        this.Title = "Ciudades";
        this.Icon = $fdfc1c4ddb81ade5$export$2bdf2f2e82a20094;
        this.HelpText = $fdfc1c4ddb81ade5$export$c72cda3fb3ccac65;
    }
}

});
parcelRegister("ey9pc", function(module, exports) {

$parcel$export(module.exports, "default", () => $c75813d87992b75c$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $c75813d87992b75c$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M3 21h18",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M19 21v-4",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M19 17a2 2 0 0 0 2 -2v-2a2 2 0 1 0 -4 0v2a2 2 0 0 0 2 2z",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M14 21v-14a3 3 0 0 0 -3 -3h-4a3 3 0 0 0 -3 3v14",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M9 17v4",
            "key": "svg-4"
        }
    ],
    [
        "path",
        {
            "d": "M8 13h2",
            "key": "svg-5"
        }
    ],
    [
        "path",
        {
            "d": "M8 9h2",
            "key": "svg-6"
        }
    ]
];
const $c75813d87992b75c$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "building-estate", "BuildingEstate", $c75813d87992b75c$export$3efd853dbb351e94);

});

parcelRegister("4YQwj", function(module, exports) {

$parcel$export(module.exports, "CiudadesDef", () => $d190be6f23a9f5bd$export$4cf6157401f2f510);

var $49qEn = parcelRequire("49qEn");

var $j8GP5 = parcelRequire("j8GP5");

var $4Rlmx = parcelRequire("4Rlmx");
const $d190be6f23a9f5bd$var$columns = ()=>({
        c_pais_id: new (0, $49qEn.EntityColumn)({
            name: 'c_pais_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: "Pa\xeds"
        }),
        c_provincia_id: new (0, $49qEn.EntityColumn)({
            name: 'c_provincia_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Provincia'
        }),
        c_ciudad_id: new (0, $49qEn.EntityColumn)({
            name: 'c_ciudad_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PKAutonum,
            prompt: 'Ciudad Id'
        }),
        vc_ciudad_nombre: new (0, $49qEn.EntityColumn)({
            name: 'vc_ciudad_nombre',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Nombre Ciudad'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $d190be6f23a9f5bd$var$views = ()=>({
        ciud_brwStandard: {
            name: 'ciud_brwStandard',
            keyMappings: {
                c_ciudad_id: 0
            }
        }
    });
const $d190be6f23a9f5bd$var$lookups = ()=>({
        'Paises': {
            name: 'Paises',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $j8GP5.Paises)(client, parentKeys)
        },
        'Provincias': {
            name: 'Provincias',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $4Rlmx.Provincias)(client, parentKeys)
        }
    });
class $d190be6f23a9f5bd$export$4cf6157401f2f510 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('Ciudades'), this.columns = $d190be6f23a9f5bd$var$columns(), this.views = $d190be6f23a9f5bd$var$views(), this.lookups = $d190be6f23a9f5bd$var$lookups();
    }
}

});
parcelRegister("j8GP5", function(module, exports) {

$parcel$export(module.exports, "PaisesIcon", () => $ea52e15da18d1fb0$export$e23a0474d0b76e95);
$parcel$export(module.exports, "PaisesHelpText", () => $ea52e15da18d1fb0$export$5ac7421d8cb9a4c1);
$parcel$export(module.exports, "Paises", () => $ea52e15da18d1fb0$export$7a7dbd340716d54f);

var $49qEn = parcelRequire("49qEn");

var $ivoLR = parcelRequire("ivoLR");

var $aR3Jb = parcelRequire("aR3Jb");
const $ea52e15da18d1fb0$export$e23a0474d0b76e95 = (0, $ivoLR.default);
const $ea52e15da18d1fb0$export$5ac7421d8cb9a4c1 = "* Aqu\xed podra ver la lista de paises";

class $ea52e15da18d1fb0$export$7a7dbd340716d54f extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $aR3Jb.PaisesDef)(), parentKeys);
        this.Form = (parcelRequire("75da4")).then((module)=>module.PaisesForm);
        this.Title = "Paises";
        this.Icon = $ea52e15da18d1fb0$export$e23a0474d0b76e95;
        this.HelpText = $ea52e15da18d1fb0$export$5ac7421d8cb9a4c1;
    }
}

});
parcelRegister("ivoLR", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1acab3a34685017$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $f1acab3a34685017$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M20.972 11.291a9 9 0 1 0 -8.322 9.686",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M3.6 9h16.8",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M3.6 15h8.9",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M11.5 3a17 17 0 0 0 0 18",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M12.5 3a16.986 16.986 0 0 1 2.578 9.018",
            "key": "svg-4"
        }
    ],
    [
        "path",
        {
            "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z",
            "key": "svg-5"
        }
    ],
    [
        "path",
        {
            "d": "M19 18v.01",
            "key": "svg-6"
        }
    ]
];
const $f1acab3a34685017$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "world-pin", "WorldPin", $f1acab3a34685017$export$3efd853dbb351e94);

});

parcelRegister("aR3Jb", function(module, exports) {

$parcel$export(module.exports, "PaisesDef", () => $ab1cdd86ab0fbf32$export$b1bbbbf0d94335cc);

var $49qEn = parcelRequire("49qEn");
const $ab1cdd86ab0fbf32$var$columns = ()=>({
        c_pais_id: new (0, $49qEn.EntityColumn)({
            name: 'c_pais_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: "Pa\xeds Id"
        }),
        vc_pais_nombre: new (0, $49qEn.EntityColumn)({
            name: 'vc_pais_nombre',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: "Nombre Pa\xeds"
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $ab1cdd86ab0fbf32$var$views = ()=>({
        pais_brwStandard: {
            name: 'pais_brwStandard',
            keyMappings: {
                c_pais_id: 0
            }
        }
    });
class $ab1cdd86ab0fbf32$export$b1bbbbf0d94335cc extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('Paises'), this.columns = $ab1cdd86ab0fbf32$var$columns(), this.views = $ab1cdd86ab0fbf32$var$views();
    }
}

});

parcelRegister("75da4", function(module, exports) {
module.exports = import("5jRcM").then(()=>parcelRequire('lo2KX'));

});


parcelRegister("4Rlmx", function(module, exports) {

$parcel$export(module.exports, "ProvinciasIcon", () => $ba6fcf6429126d37$export$c6bc3c4365ede9de);
$parcel$export(module.exports, "ProvinciasHelpText", () => $ba6fcf6429126d37$export$6595405cc3b693be);
$parcel$export(module.exports, "Provincias", () => $ba6fcf6429126d37$export$9f5d704ee23d558a);

var $49qEn = parcelRequire("49qEn");

var $2JAvD = parcelRequire("2JAvD");

var $iMxdG = parcelRequire("iMxdG");
const $ba6fcf6429126d37$export$c6bc3c4365ede9de = (0, $2JAvD.default);
const $ba6fcf6429126d37$export$6595405cc3b693be = "* Aqu\xed tendra la lista de las provincias del pais seleccionado.";

class $ba6fcf6429126d37$export$9f5d704ee23d558a extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $iMxdG.ProvinciasDef)(), parentKeys);
        this.Form = (parcelRequire("bs46v")).then((module)=>module.ProvinciasForm);
        this.Title = "Provincias";
        this.Icon = $ba6fcf6429126d37$export$c6bc3c4365ede9de;
        this.HelpText = $ba6fcf6429126d37$export$6595405cc3b693be;
    }
}

});
parcelRegister("iMxdG", function(module, exports) {

$parcel$export(module.exports, "ProvinciasDef", () => $87b2043e20a111e1$export$bc2e42cdd2b6029c);

var $49qEn = parcelRequire("49qEn");

var $j8GP5 = parcelRequire("j8GP5");
const $87b2043e20a111e1$var$columns = ()=>({
        c_pais_id: new (0, $49qEn.EntityColumn)({
            name: 'c_pais_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: "Pa\xeds"
        }),
        c_provincia_id: new (0, $49qEn.EntityColumn)({
            name: 'c_provincia_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PKAutonum,
            prompt: 'Provincia Id'
        }),
        vc_provincia_nombre: new (0, $49qEn.EntityColumn)({
            name: 'vc_provincia_nombre',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Nombre Provincia'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $87b2043e20a111e1$var$views = ()=>({
        prov_brwStandard: {
            name: 'prov_brwStandard',
            keyMappings: {
                c_provincia_id: 0
            }
        }
    });
const $87b2043e20a111e1$var$lookups = ()=>({
        'Paises': {
            name: 'Paises',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $j8GP5.Paises)(client, parentKeys)
        }
    });
class $87b2043e20a111e1$export$bc2e42cdd2b6029c extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('Provincias'), this.columns = $87b2043e20a111e1$var$columns(), this.views = $87b2043e20a111e1$var$views(), this.lookups = $87b2043e20a111e1$var$lookups();
    }
}

});

parcelRegister("bs46v", function(module, exports) {
module.exports = import("6Zyqh").then(()=>parcelRequire('hE6k4'));

});



parcelRegister("7vtwt", function(module, exports) {
module.exports = import("2ZM2n").then(()=>parcelRequire('fcI5Q'));

});


parcelRegister("aQujn", function(module, exports) {

$parcel$export(module.exports, "Localidades", () => $684121a0c83eb24a$export$fc1552fa7a297a46);

var $49qEn = parcelRequire("49qEn");

var $ey9pc = parcelRequire("ey9pc");

var $cNQXp = parcelRequire("cNQXp");
const $684121a0c83eb24a$export$6d0e28ebe77b20da = (0, $ey9pc.default);
const $684121a0c83eb24a$export$6cc07e8b398d8649 = "* Aqu\xed puede ver la lista de localidades de la ciudad seleccionada.";

class $684121a0c83eb24a$export$fc1552fa7a297a46 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $cNQXp.LocalidadesDef)(), parentKeys);
        super.Form = (parcelRequire("eHs27")).then((module)=>module.LocalidadesForm);
        this.Title = "Localidades";
        this.Icon = $684121a0c83eb24a$export$6d0e28ebe77b20da;
        this.HelpText = $684121a0c83eb24a$export$6cc07e8b398d8649;
    }
}

});
parcelRegister("cNQXp", function(module, exports) {

$parcel$export(module.exports, "LocalidadesDef", () => $ae834206485e4c51$export$6340f4e82519b987);

var $49qEn = parcelRequire("49qEn");

var $kFypM = parcelRequire("kFypM");

var $j8GP5 = parcelRequire("j8GP5");

var $4Rlmx = parcelRequire("4Rlmx");
const $ae834206485e4c51$var$columns = ()=>({
        c_pais_id: new (0, $49qEn.EntityColumn)({
            name: 'c_pais_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Pais Id'
        }),
        c_provincia_id: new (0, $49qEn.EntityColumn)({
            name: 'c_provincia_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Provincia Id'
        }),
        c_ciudad_id: new (0, $49qEn.EntityColumn)({
            name: 'c_ciudad_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Ciudad Id'
        }),
        c_localidad_id: new (0, $49qEn.EntityColumn)({
            name: 'c_localidad_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PKAutonum,
            prompt: 'Localidad Id'
        }),
        vc_localidad_nombre: new (0, $49qEn.EntityColumn)({
            name: 'vc_localidad_nombre',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Localidad Nombre'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $ae834206485e4c51$var$views = ()=>({
        locl_brwStandard: {
            name: 'locl_brwStandard',
            keyMappings: {
                c_localidad_id: 0
            }
        }
    });
const $ae834206485e4c51$var$lookups = ()=>({
        'Paises': {
            name: 'Paises',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $j8GP5.Paises)(client, parentKeys)
        },
        'Provincias': {
            name: 'Provincias',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $4Rlmx.Provincias)(client, parentKeys)
        },
        'Ciudades': {
            name: 'Ciudades',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $kFypM.Ciudades)(client, parentKeys)
        }
    });
class $ae834206485e4c51$export$6340f4e82519b987 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('Localidades'), this.columns = $ae834206485e4c51$var$columns(), this.views = $ae834206485e4c51$var$views(), this.lookups = $ae834206485e4c51$var$lookups();
    }
}

});

parcelRegister("eHs27", function(module, exports) {
module.exports = import("gm0Hl").then(()=>parcelRequire('1IwGh'));

});



parcelRegister("bMvwR", function(module, exports) {

$parcel$export(module.exports, "BancosIcon", () => $6c440fc5cd232543$export$431dc8b11ab414a);
$parcel$export(module.exports, "BancosHelpText", () => $6c440fc5cd232543$export$299fc39362ff0425);
$parcel$export(module.exports, "Bancos", () => $6c440fc5cd232543$export$cbb39673ffd19ebd);

var $49qEn = parcelRequire("49qEn");

var $hLuot = parcelRequire("hLuot");

var $h6wRd = parcelRequire("h6wRd");
const $6c440fc5cd232543$export$431dc8b11ab414a = (0, $hLuot.default);
const $6c440fc5cd232543$export$299fc39362ff0425 = "* Contiene los bancos con los que opera la instituci\xf3n";
class $6c440fc5cd232543$export$cbb39673ffd19ebd extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $h6wRd.BancosDef)(), parentKeys);
        super.Form = "AutoForm";
        this.Title = "Bancos";
        this.Icon = $6c440fc5cd232543$export$431dc8b11ab414a;
        this.HelpText = $6c440fc5cd232543$export$299fc39362ff0425;
    }
}

});
parcelRegister("hLuot", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba3c0ea914d8f412$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $ba3c0ea914d8f412$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M3 21l18 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M3 10l18 0",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M5 6l7 -3l7 3",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M4 10l0 11",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M20 10l0 11",
            "key": "svg-4"
        }
    ],
    [
        "path",
        {
            "d": "M8 14l0 3",
            "key": "svg-5"
        }
    ],
    [
        "path",
        {
            "d": "M12 14l0 3",
            "key": "svg-6"
        }
    ],
    [
        "path",
        {
            "d": "M16 14l0 3",
            "key": "svg-7"
        }
    ]
];
const $ba3c0ea914d8f412$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "building-bank", "BuildingBank", $ba3c0ea914d8f412$export$3efd853dbb351e94);

});

parcelRegister("h6wRd", function(module, exports) {

$parcel$export(module.exports, "BancosDef", () => $a8de709dd2b302e7$export$3bbb3d7eddf1fc32);

var $49qEn = parcelRequire("49qEn");
const $a8de709dd2b302e7$var$columns = ()=>({
        c_banco_id: new (0, $49qEn.EntityColumn)({
            name: 'c_banco_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Banco Id'
        }),
        vc_banco_nombre: new (0, $49qEn.EntityColumn)({
            name: 'vc_banco_nombre',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Banco Nombre'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $a8de709dd2b302e7$var$views = ()=>({
        banc_brwStandard: {
            name: 'banc_brwStandard',
            keyMappings: {
                c_banco_id: 0
            }
        }
    });
class $a8de709dd2b302e7$export$3bbb3d7eddf1fc32 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('Bancos'), this.columns = $a8de709dd2b302e7$var$columns(), this.views = $a8de709dd2b302e7$var$views();
    }
}

});


parcelRegister("316Pw", function(module, exports) {

$parcel$export(module.exports, "AreasPersonalHelpText", () => $8e8588c68f79bf49$export$39e0c82375a0700a);
$parcel$export(module.exports, "AreasPersonalIcon", () => $8e8588c68f79bf49$export$ac98e59e47610886);
$parcel$export(module.exports, "catAreasPersonal", () => $8e8588c68f79bf49$export$1c27caedb1db6d8c);

var $49qEn = parcelRequire("49qEn");

var $38Jku = parcelRequire("38Jku");
const $8e8588c68f79bf49$export$39e0c82375a0700a = "* Aqu\xed puede ver la lista de las areas del personal.";
const $8e8588c68f79bf49$export$ac98e59e47610886 = (0, $38Jku.default);
class $8e8588c68f79bf49$export$1c27caedb1db6d8c extends (0, $49qEn.CategoriesValues) {
    constructor(client, parentKeys = {}){
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "AreasPersonal";
        this.def.columns.c_category_id.defaultValue = "AreasPersonal";
        this.Title = "\xc1reas de Personal";
        this.HelpText = $8e8588c68f79bf49$export$39e0c82375a0700a;
        this.Icon = $8e8588c68f79bf49$export$ac98e59e47610886;
    }
}

});
parcelRegister("38Jku", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee212db77816dc56$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $ee212db77816dc56$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M12 12m-8 0a8 2 0 1 0 16 0a8 2 0 1 0 -16 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M4 12v7c0 .94 2.51 1.785 6 2v-3h4v3c3.435 -.225 6 -1.07 6 -2v-7",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M15 6h4v-3h-4v7",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M7 6h4v-3h-4v7",
            "key": "svg-3"
        }
    ]
];
const $ee212db77816dc56$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "building-stadium", "BuildingStadium", $ee212db77816dc56$export$3efd853dbb351e94);

});


parcelRegister("841Z4", function(module, exports) {

$parcel$export(module.exports, "GeneroIcon", () => $12fe540e22bec01e$export$428f61c3a08b2491);
$parcel$export(module.exports, "GeneroHelpText", () => $12fe540e22bec01e$export$41c5c8fecf67ff95);
$parcel$export(module.exports, "catGenero", () => $12fe540e22bec01e$export$e2ed3e34c8b0698);

var $49qEn = parcelRequire("49qEn");

var $awScz = parcelRequire("awScz");
const $12fe540e22bec01e$export$428f61c3a08b2491 = (0, $awScz.default);
const $12fe540e22bec01e$export$41c5c8fecf67ff95 = "* Aqu\xed puede ver la lista de los generos del personal.";
class $12fe540e22bec01e$export$e2ed3e34c8b0698 extends (0, $49qEn.CategoriesValues) {
    constructor(client, parentKeys = {}){
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "Genero";
        this.def.columns.c_category_id.defaultValue = "Genero";
        this.Title = "G\xe9nero";
        this.HelpText = $12fe540e22bec01e$export$41c5c8fecf67ff95;
        this.Icon = $12fe540e22bec01e$export$428f61c3a08b2491;
    }
}

});
parcelRegister("awScz", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4d30d811cd48520$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $d4d30d811cd48520$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M11 11m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M19 3l-5 5",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M15 3h4v4",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M11 16v6",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M8 19h6",
            "key": "svg-4"
        }
    ]
];
const $d4d30d811cd48520$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "gender-bigender", "GenderBigender", $d4d30d811cd48520$export$3efd853dbb351e94);

});


parcelRegister("exmmN", function(module, exports) {

$parcel$export(module.exports, "MotivosBajaIcon", () => $b44681825bdaa9a2$export$66002ba092287568);
$parcel$export(module.exports, "MotivosBajaHelpText", () => $b44681825bdaa9a2$export$c90b5949c1b3f6fa);
$parcel$export(module.exports, "catMotivosBaja", () => $b44681825bdaa9a2$export$e31b998c44b20cdb);

var $49qEn = parcelRequire("49qEn");

var $kIca3 = parcelRequire("kIca3");
const $b44681825bdaa9a2$export$66002ba092287568 = (0, $kIca3.default);
const $b44681825bdaa9a2$export$c90b5949c1b3f6fa = "* Aqu\xed puede ver los motivos de baja.";
class $b44681825bdaa9a2$export$e31b998c44b20cdb extends (0, $49qEn.CategoriesValues) {
    constructor(client, parentKeys = {}){
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "MotivosBaja";
        this.def.columns.c_category_id.defaultValue = "MotivosBaja";
        this.Title = "Motivos de Baja";
        this.Icon = $b44681825bdaa9a2$export$66002ba092287568;
        this.HelpText = $b44681825bdaa9a2$export$c90b5949c1b3f6fa;
    }
}

});
parcelRegister("kIca3", function(module, exports) {

$parcel$export(module.exports, "default", () => $041cffa62da914d2$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $041cffa62da914d2$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M9 5l-.117 .007a1 1 0 0 0 -.883 .993v4.999l-2.586 .001a2 2 0 0 0 -1.414 3.414l6.586 6.586a2 2 0 0 0 2.828 0l6.586 -6.586a2 2 0 0 0 .434 -2.18l-.068 -.145a2 2 0 0 0 -1.78 -1.089l-2.586 -.001v-4.999a1 1 0 0 0 -1 -1h-6z",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M15 2a1 1 0 0 1 .117 1.993l-.117 .007h-6a1 1 0 0 1 -.117 -1.993l.117 -.007h6z",
            "key": "svg-1"
        }
    ]
];
const $041cffa62da914d2$export$2e2bcd8739ae039 = (0, $eednQ.default)("filled", "arrow-big-down-line-filled", "ArrowBigDownLineFilled", $041cffa62da914d2$export$3efd853dbb351e94);

});


parcelRegister("8PdZ4", function(module, exports) {

$parcel$export(module.exports, "TiposDocumentoIcon", () => $ecd15a3d366ee659$export$960057e35faec22b);
$parcel$export(module.exports, "TiposDocumentoHelpText", () => $ecd15a3d366ee659$export$45ccdd845d24c2c5);
$parcel$export(module.exports, "catTiposDocumento", () => $ecd15a3d366ee659$export$ee199c296efc503f);

var $49qEn = parcelRequire("49qEn");

var $jkwVV = parcelRequire("jkwVV");
const $ecd15a3d366ee659$export$960057e35faec22b = (0, $jkwVV.default);
const $ecd15a3d366ee659$export$45ccdd845d24c2c5 = "* Aqu\xed puede ver los diferentes tipos de documento asignables por empleado.";
class $ecd15a3d366ee659$export$ee199c296efc503f extends (0, $49qEn.CategoriesValues) {
    constructor(client, parentKeys = {}){
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "TiposDocumento";
        this.def.columns.c_category_id.defaultValue = "TiposDocumento";
        this.Title = "Tipos de Documento";
        this.HelpText = $ecd15a3d366ee659$export$45ccdd845d24c2c5;
        this.Icon = $ecd15a3d366ee659$export$960057e35faec22b;
    }
}

});
parcelRegister("jkwVV", function(module, exports) {

$parcel$export(module.exports, "default", () => $e24a89081e182460$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $e24a89081e182460$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M9 12l.01 0",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M13 12l2 0",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M9 16l.01 0",
            "key": "svg-4"
        }
    ],
    [
        "path",
        {
            "d": "M13 16l2 0",
            "key": "svg-5"
        }
    ]
];
const $e24a89081e182460$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "clipboard-list", "ClipboardList", $e24a89081e182460$export$3efd853dbb351e94);

});


parcelRegister("9hCID", function(module, exports) {

$parcel$export(module.exports, "Personas", () => $394605a0c0727f7b$export$8715167b26e6e961);

var $49qEn = parcelRequire("49qEn");

var $j0QhJ = parcelRequire("j0QhJ");

var $i978t = parcelRequire("i978t");
const $394605a0c0727f7b$export$15f696a4769bb9ca = (0, $j0QhJ.default);
const $394605a0c0727f7b$export$905669098ef9e73b = "* Aqu\xed puede ver la lista de todos los Emails de Personas disponibles.";

class $394605a0c0727f7b$export$8715167b26e6e961 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $i978t.PersonasDef)(), parentKeys);
        this.Form = (parcelRequire("5fRGE")).then((module)=>module.PersonasForm);
        this.Title = "Personas";
        this.HelpText = $394605a0c0727f7b$export$905669098ef9e73b;
        this.Icon = $394605a0c0727f7b$export$15f696a4769bb9ca;
    }
}

});
parcelRegister("j0QhJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $48ea23a952bf7ec5$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $48ea23a952bf7ec5$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2",
            "key": "svg-1"
        }
    ]
];
const $48ea23a952bf7ec5$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "user", "User", $48ea23a952bf7ec5$export$3efd853dbb351e94);

});

parcelRegister("i978t", function(module, exports) {

$parcel$export(module.exports, "PersonasDef", () => $e0ca0da0aa18831b$export$3aa1912500134131);

var $49qEn = parcelRequire("49qEn");

var $841Z4 = parcelRequire("841Z4");

var $8PdZ4 = parcelRequire("8PdZ4");
const $e0ca0da0aa18831b$var$columns = ()=>({
        c_persona_id: new (0, $49qEn.EntityColumn)({
            name: 'c_persona_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PKAutonum,
            prompt: 'Persona Id'
        }),
        vc_nombre: new (0, $49qEn.EntityColumn)({
            name: 'vc_nombre',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Nombre'
        }),
        vc_apellido: new (0, $49qEn.EntityColumn)({
            name: 'vc_apellido',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Apellido'
        }),
        dt_nacimiento: new (0, $49qEn.EntityColumn)({
            name: 'dt_nacimiento',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Fecha de Nacimiento'
        }),
        c_fotofileprocess_id: new (0, $49qEn.EntityColumn)({
            name: 'c_fotofileprocess_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Fotofileprocess Id'
        }),
        c_tipodocumento_id: new (0, $49qEn.EntityColumn)({
            name: 'c_tipodocumento_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Tipo de Documento'
        }),
        vc_numerodocumento: new (0, $49qEn.EntityColumn)({
            name: 'vc_numerodocumento',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: "N\xfamero de Documento"
        }),
        c_genero_id: new (0, $49qEn.EntityColumn)({
            name: 'c_genero_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "G\xe9nero"
        }),
        c_documentofileprocess_id: new (0, $49qEn.EntityColumn)({
            name: 'c_documentofileprocess_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Documentofileprocess Id'
        }),
        vc_fotoguid: new (0, $49qEn.EntityColumn)({
            name: 'vc_fotoguid',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Fotoguid'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $e0ca0da0aa18831b$var$views = ()=>({
        pers_brwStandard: {
            name: 'pers_brwStandard',
            keyMappings: {
                c_persona_id: 0
            }
        },
        pers_brwCard: {
            name: 'pers_brwCard',
            keyMappings: {
                c_persona_id: 0
            }
        }
    });
const $e0ca0da0aa18831b$var$lookups = ()=>({
        'TiposDocumento': {
            name: 'TiposDocumento',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $8PdZ4.catTiposDocumento)(client, parentKeys)
        },
        'Genero': {
            name: 'Genero',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $841Z4.catGenero)(client, parentKeys)
        }
    });
class $e0ca0da0aa18831b$export$3aa1912500134131 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('Personas'), this.columns = $e0ca0da0aa18831b$var$columns(), this.views = $e0ca0da0aa18831b$var$views(), this.lookups = $e0ca0da0aa18831b$var$lookups();
    }
}

});

parcelRegister("5fRGE", function(module, exports) {
module.exports = import("gNAoD").then(()=>parcelRequire('iM4Hk'));

});


parcelRegister("gZrbO", function(module, exports) {

$parcel$export(module.exports, "PlantillasHorariosIcon", () => $c6d215576d2e7603$export$258255a47f9ec981);
$parcel$export(module.exports, "PlantillasHorariosHelpText", () => $c6d215576d2e7603$export$975041ef43f967f3);
$parcel$export(module.exports, "PlantillasHorarios", () => $c6d215576d2e7603$export$914eb08644ef2619);

var $49qEn = parcelRequire("49qEn");

var $8QOXi = parcelRequire("8QOXi");

var $cV78I = parcelRequire("cV78I");
const $c6d215576d2e7603$export$258255a47f9ec981 = (0, $8QOXi.default);
const $c6d215576d2e7603$export$975041ef43f967f3 = "* Aqu\xed tendra la lista de todas las zonas horarias disponibles.";

class $c6d215576d2e7603$export$914eb08644ef2619 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $cV78I.PlantillasHorariosDef)(), parentKeys);
        super.Form = (parcelRequire("dWUNR")).then((module)=>module.PlantillasHorariosForm);
        this.Title = "Plantillas de Horario";
        this.Icon = $c6d215576d2e7603$export$258255a47f9ec981;
        this.HelpText = $c6d215576d2e7603$export$975041ef43f967f3;
    }
}

});
parcelRegister("8QOXi", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1b72700ca5ed824$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $e1b72700ca5ed824$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M11.795 21h-6.795a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M18 14v4h4",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M18 18m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M15 3v4",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M7 3v4",
            "key": "svg-4"
        }
    ],
    [
        "path",
        {
            "d": "M3 11h16",
            "key": "svg-5"
        }
    ]
];
const $e1b72700ca5ed824$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "calendar-stats", "CalendarStats", $e1b72700ca5ed824$export$3efd853dbb351e94);

});

parcelRegister("cV78I", function(module, exports) {

$parcel$export(module.exports, "PlantillasHorariosDef", () => $0eaa47c22ebc2e73$export$607dadaffdb052f9);

var $49qEn = parcelRequire("49qEn");
const $0eaa47c22ebc2e73$var$columns = ()=>({
        c_plantillahorario_id: new (0, $49qEn.EntityColumn)({
            name: 'c_plantillahorario_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PKAutonum,
            prompt: 'Plantilla Horario Id'
        }),
        vc_nombre: new (0, $49qEn.EntityColumn)({
            name: 'vc_nombre',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Nombre'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $0eaa47c22ebc2e73$var$views = ()=>({
        plah_brwStandard: {
            name: 'plah_brwStandard',
            keyMappings: {
                c_plantillahorario_id: 0
            }
        }
    });
class $0eaa47c22ebc2e73$export$607dadaffdb052f9 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('PlantillasHorarios'), this.columns = $0eaa47c22ebc2e73$var$columns(), this.views = $0eaa47c22ebc2e73$var$views();
    }
}

});

parcelRegister("dWUNR", function(module, exports) {
module.exports = import("1hDda").then(()=>parcelRequire('esGSI'));

});


parcelRegister("a4nBq", function(module, exports) {

$parcel$export(module.exports, "PuestosTrabajoIcon", () => $733f4171b8e16677$export$98800fb37e5012fd);
$parcel$export(module.exports, "PuestosTrabajoHelpText", () => $733f4171b8e16677$export$af2b17d7463a5dc2);
$parcel$export(module.exports, "PuestosTrabajo", () => $733f4171b8e16677$export$c5601964e8e3421);

var $49qEn = parcelRequire("49qEn");

var $h3zca = parcelRequire("h3zca");

var $5zdlL = parcelRequire("5zdlL");
const $733f4171b8e16677$export$98800fb37e5012fd = (0, $h3zca.default);
const $733f4171b8e16677$export$af2b17d7463a5dc2 = "* Aqu\xed tendra todos los puestos de trabajo disponibles para asignar.";

class $733f4171b8e16677$export$c5601964e8e3421 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $5zdlL.PuestosTrabajoDef)(), parentKeys);
        super.Form = (parcelRequire("2FYEL")).then((module)=>module.PuestosTrabajoForm);
        this.Title = "Puestos de trabajo";
        this.Icon = $733f4171b8e16677$export$98800fb37e5012fd;
        this.HelpText = $733f4171b8e16677$export$af2b17d7463a5dc2;
    }
}

});
parcelRegister("h3zca", function(module, exports) {

$parcel$export(module.exports, "default", () => $9da444f495f9d484$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $9da444f495f9d484$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M7 12h3v4h-3z",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M10 6h-6a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h16a1 1 0 0 0 1 -1v-12a1 1 0 0 0 -1 -1h-6",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M10 3m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M14 16h2",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M14 12h4",
            "key": "svg-4"
        }
    ]
];
const $9da444f495f9d484$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "id-badge-2", "IdBadge2", $9da444f495f9d484$export$3efd853dbb351e94);

});

parcelRegister("5zdlL", function(module, exports) {

$parcel$export(module.exports, "PuestosTrabajoDef", () => $6c73f57bb8a29811$export$b5eabe4919af6a9);

var $49qEn = parcelRequire("49qEn");

var $fL73S = parcelRequire("fL73S");

var $b53M2 = parcelRequire("b53M2");

var $316Pw = parcelRequire("316Pw");
const $6c73f57bb8a29811$var$columns = ()=>({
        c_puestotrabajo_id: new (0, $49qEn.EntityColumn)({
            name: 'c_puestotrabajo_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PKAutonum,
            prompt: 'Puesto Id'
        }),
        vc_descripcion: new (0, $49qEn.EntityColumn)({
            name: 'vc_descripcion',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: "Descripci\xf3n"
        }),
        c_areapersonal_id: new (0, $49qEn.EntityColumn)({
            name: 'c_areapersonal_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: "\xc1rea personal"
        }),
        vc_requisitos: new (0, $49qEn.EntityColumn)({
            name: 'vc_requisitos',
            type: 'varchar',
            length: 0,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Requisitos de ingreso',
            isArray: true
        }),
        vc_ropa: new (0, $49qEn.EntityColumn)({
            name: 'vc_ropa',
            type: 'varchar',
            length: 0,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Ropa',
            isArray: true
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $6c73f57bb8a29811$var$views = ()=>({
        pues_brwStandard: {
            name: 'pues_brwStandard',
            keyMappings: {
                c_puestotrabajo_id: 0
            }
        }
    });
const $6c73f57bb8a29811$var$lookups = ()=>({
        'AreasPersonal': {
            name: 'AreasPersonal',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $316Pw.catAreasPersonal)(client, parentKeys)
        },
        'Requisitos': {
            name: 'Requisitos',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $fL73S.Requisitos)(client, parentKeys)
        },
        'Ropa': {
            name: 'Ropa',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $b53M2.Ropa)(client, parentKeys)
        }
    });
class $6c73f57bb8a29811$export$b5eabe4919af6a9 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('PuestosTrabajo'), this.columns = $6c73f57bb8a29811$var$columns(), this.views = $6c73f57bb8a29811$var$views(), this.lookups = $6c73f57bb8a29811$var$lookups();
    }
}

});
parcelRegister("fL73S", function(module, exports) {

$parcel$export(module.exports, "RequisitosIcon", () => $a3f8318ba43cb5b6$export$e8c917eafe850644);
$parcel$export(module.exports, "RequisitosHelpText", () => $a3f8318ba43cb5b6$export$5bee6f83f5c208eb);
$parcel$export(module.exports, "Requisitos", () => $a3f8318ba43cb5b6$export$ddc7a3c2ba70973c);

var $49qEn = parcelRequire("49qEn");

var $6HZkq = parcelRequire("6HZkq");

var $aH00O = parcelRequire("aH00O");
const $a3f8318ba43cb5b6$export$e8c917eafe850644 = (0, $6HZkq.default);
const $a3f8318ba43cb5b6$export$5bee6f83f5c208eb = "* Aqu\xed tendra la lista de todos los requisitos asignables.";

class $a3f8318ba43cb5b6$export$ddc7a3c2ba70973c extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $aH00O.RequisitosDef)(), parentKeys);
        super.Form = (parcelRequire("iMaQT")).then((module)=>module.RequisitosForm);
        this.Title = "Requisitos";
        this.Icon = $a3f8318ba43cb5b6$export$e8c917eafe850644;
        this.HelpText = $a3f8318ba43cb5b6$export$5bee6f83f5c208eb;
    }
}

});
parcelRegister("aH00O", function(module, exports) {

$parcel$export(module.exports, "RequisitosDef", () => $0a277d51a3c4a5fe$export$33cb13fad50d7640);

var $49qEn = parcelRequire("49qEn");

var $bcoNL = parcelRequire("bcoNL");
const $0a277d51a3c4a5fe$var$columns = ()=>({
        c_requisito_id: new (0, $49qEn.EntityColumn)({
            name: 'c_requisito_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PKAutonum,
            prompt: 'Requisito Id'
        }),
        vc_descripcion: new (0, $49qEn.EntityColumn)({
            name: 'vc_descripcion',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: "Descripci\xf3n"
        }),
        c_tiporequisito_id: new (0, $49qEn.EntityColumn)({
            name: 'c_tiporequisito_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Tipo de Requisito'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $0a277d51a3c4a5fe$var$views = ()=>({
        requ_brwStandard: {
            name: 'requ_brwStandard',
            keyMappings: {
                c_requisito_id: 0
            }
        }
    });
const $0a277d51a3c4a5fe$var$lookups = ()=>({
        'TiposRequisitos': {
            name: 'TiposRequisitos',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $bcoNL.catTiposRequisitos)(client, parentKeys)
        }
    });
class $0a277d51a3c4a5fe$export$33cb13fad50d7640 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('Requisitos'), this.columns = $0a277d51a3c4a5fe$var$columns(), this.views = $0a277d51a3c4a5fe$var$views(), this.lookups = $0a277d51a3c4a5fe$var$lookups();
    }
}

});
parcelRegister("bcoNL", function(module, exports) {

$parcel$export(module.exports, "catTiposRequisitos", () => $eb918ea58edcde28$export$b97b06494da88788);

var $49qEn = parcelRequire("49qEn");

var $6HZkq = parcelRequire("6HZkq");
const $eb918ea58edcde28$export$82fce83be4f76b36 = "* Aqu\xed puede ver la lista de los diversos tipos de requisitos.";
const $eb918ea58edcde28$export$4ea3a242c52ad307 = (0, $6HZkq.default);
class $eb918ea58edcde28$export$b97b06494da88788 extends (0, $49qEn.CategoriesValues) {
    constructor(client, parentKeys = {}){
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "TiposRequisitos";
        this.def.columns.c_category_id.defaultValue = "TiposRequisitos";
        this.Title = "Tipos de Requisitos";
        this.Icon = $eb918ea58edcde28$export$4ea3a242c52ad307;
        this.HelpText = $eb918ea58edcde28$export$82fce83be4f76b36;
    }
}

});


parcelRegister("iMaQT", function(module, exports) {
module.exports = import("gtP8I").then(()=>parcelRequire('aP6ko'));

});


parcelRegister("b53M2", function(module, exports) {

$parcel$export(module.exports, "RopaIcon", () => $133b817f80802613$export$5b75359aeefa5e52);
$parcel$export(module.exports, "Ropa", () => $133b817f80802613$export$5b19a9b261683b80);

var $49qEn = parcelRequire("49qEn");

var $6oCiX = parcelRequire("6oCiX");

var $hFjbr = parcelRequire("hFjbr");
const $133b817f80802613$export$5b75359aeefa5e52 = (0, $6oCiX.default);

class $133b817f80802613$export$5b19a9b261683b80 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $hFjbr.RopaDef)(), parentKeys);
        super.Form = (parcelRequire("7Lz8j")).then((module)=>module.RopaForm);
        this.Title = "Ropa";
        this.Icon = $133b817f80802613$export$5b75359aeefa5e52;
    }
}

});
parcelRegister("6oCiX", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ba827b7793edc5e$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $7ba827b7793edc5e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M15 4l6 2v5h-3v8a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1v-8h-3v-5l6 -2a3 3 0 0 0 6 0",
            "key": "svg-0"
        }
    ]
];
const $7ba827b7793edc5e$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "shirt", "Shirt", $7ba827b7793edc5e$export$3efd853dbb351e94);

});

parcelRegister("hFjbr", function(module, exports) {

$parcel$export(module.exports, "RopaDef", () => $24d16541d55e9326$export$4dab41dad12497ed);

var $49qEn = parcelRequire("49qEn");

var $841Z4 = parcelRequire("841Z4");

var $cDb8a = parcelRequire("cDb8a");
const $24d16541d55e9326$var$columns = ()=>({
        c_ropa_id: new (0, $49qEn.EntityColumn)({
            name: 'c_ropa_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PKAutonum,
            prompt: 'Ropa Id'
        }),
        vc_descripcion: new (0, $49qEn.EntityColumn)({
            name: 'vc_descripcion',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: "Descripci\xf3n"
        }),
        vc_generos: new (0, $49qEn.EntityColumn)({
            name: 'vc_generos',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Generos',
            isArray: true
        }),
        c_tipomedidaropa_id: new (0, $49qEn.EntityColumn)({
            name: 'c_tipomedidaropa_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Tipo de Talle'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $24d16541d55e9326$var$views = ()=>({
        ropa_brwStandard: {
            name: 'ropa_brwStandard',
            keyMappings: {
                c_ropa_id: 0
            }
        }
    });
const $24d16541d55e9326$var$lookups = ()=>({
        'Genero': {
            name: 'Genero',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $841Z4.catGenero)(client, parentKeys)
        },
        'TiposMedidasRopa': {
            name: 'TiposMedidasRopa',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $cDb8a.catTiposMedidasRopa)(client, parentKeys)
        }
    });
class $24d16541d55e9326$export$4dab41dad12497ed extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('Ropa'), this.columns = $24d16541d55e9326$var$columns(), this.views = $24d16541d55e9326$var$views(), this.lookups = $24d16541d55e9326$var$lookups();
    }
}

});
parcelRegister("cDb8a", function(module, exports) {

$parcel$export(module.exports, "catTiposMedidasRopa", () => $ab0e3d0bdb708b2c$export$8b0dc40c14719d51);

var $49qEn = parcelRequire("49qEn");

var $eksEu = parcelRequire("eksEu");
const $ab0e3d0bdb708b2c$export$258ca4a1cb66e58f = (0, $eksEu.default);
const $ab0e3d0bdb708b2c$export$55bae567065eca3a = "* Aqu\xed puede ver la lista de tipos de medidas.";
class $ab0e3d0bdb708b2c$export$8b0dc40c14719d51 extends (0, $49qEn.CategoriesValues) {
    constructor(client, parentKeys = {}){
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "TiposMedidasRopa";
        this.def.columns.c_category_id.defaultValue = "TiposMedidasRopa";
        this.Title = "Medidas Ropa";
        this.Icon = $ab0e3d0bdb708b2c$export$258ca4a1cb66e58f;
        this.HelpText = $ab0e3d0bdb708b2c$export$55bae567065eca3a;
    }
}

});
parcelRegister("eksEu", function(module, exports) {

$parcel$export(module.exports, "default", () => $513177676d509aea$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $513177676d509aea$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M19.875 12c.621 0 1.125 .512 1.125 1.143v5.714c0 .631 -.504 1.143 -1.125 1.143h-15.875a1 1 0 0 1 -1 -1v-5.857c0 -.631 .504 -1.143 1.125 -1.143h15.75z",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M9 12v2",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M6 12v3",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M12 12v3",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M18 12v3",
            "key": "svg-4"
        }
    ],
    [
        "path",
        {
            "d": "M15 12v2",
            "key": "svg-5"
        }
    ],
    [
        "path",
        {
            "d": "M3 3v4",
            "key": "svg-6"
        }
    ],
    [
        "path",
        {
            "d": "M3 5h18",
            "key": "svg-7"
        }
    ],
    [
        "path",
        {
            "d": "M21 3v4",
            "key": "svg-8"
        }
    ]
];
const $513177676d509aea$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "ruler-measure", "RulerMeasure", $513177676d509aea$export$3efd853dbb351e94);

});



parcelRegister("7Lz8j", function(module, exports) {
module.exports = import("1RQAF").then(()=>parcelRequire('5vg9G'));

});



parcelRegister("2FYEL", function(module, exports) {
module.exports = import("SHnIT").then(()=>parcelRequire('cwCy1'));

});


parcelRegister("9rTPL", function(module, exports) {

$parcel$export(module.exports, "ACTAgregarPersonal", () => $d0a317acbc312531$export$818224caab02f28e);

var $ayMG0 = parcelRequire("ayMG0");

var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $i7ldT = parcelRequire("i7ldT");
const $d0a317acbc312531$export$818224caab02f28e = {
    name: 'ACTAgregarPersonal',
    label: 'Agregar Personal',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Agregar Personal"
    }),
    refreshOnClose: true,
    dontRequireSelection: true,
    showActionInViewMode: true,
    views: [
        'perl_brwGestionPersonalDetalles'
    ],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const parent = entity;
        await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                    fw: "700",
                    children: "Agregar Personal"
                }),
                size: 'xl'
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.LookupFormAction), {
                lookupEntity: parent,
                viewName: parent.def.views.perl_brwGestionPersonalDetallesAgregar.name,
                title: "Agregar personal",
                confirmContent: "\xbfEst\xe1 seguro de que desea agregar el personal seleccionado?",
                onActionFinished: async ()=>{
                    if (onClose) await onClose();
                },
                modalFormSize: "xl",
                enableView: true,
                onOK: async (keys, abortSignal)=>{
                    if (keys && keys.length > 0) {
                        const personaljerarquia = new (0, $i7ldT.PersonalJerarquia)(parent.API.client, parent.parentKeys);
                        personaljerarquia.def.columns.c_superior_id.value = parent.parentKeys.c_superior_id;
                        await personaljerarquia.API.addData(abortSignal, keys, true);
                    }
                    return {
                        Results: [
                            {
                                Status: 0,
                                Message: 'OK'
                            }
                        ]
                    };
                }
            })
        });
        return false;
    }
};

});
parcelRegister("i7ldT", function(module, exports) {

$parcel$export(module.exports, "PersonalJerarquia", () => $3b4b2040334cd7d3$export$243a0883cdcabf1d);

var $49qEn = parcelRequire("49qEn");

var $kq3dp = parcelRequire("kq3dp");
class $3b4b2040334cd7d3$export$243a0883cdcabf1d extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $kq3dp.PersonalJerarquiaDef)(), parentKeys);
        this.Title = "Personal Jerarquia";
    }
}

});
parcelRegister("kq3dp", function(module, exports) {

$parcel$export(module.exports, "PersonalJerarquiaDef", () => $b6a11cbd8789b401$export$bca4cd9c5d505c0e);

var $49qEn = parcelRequire("49qEn");
const $b6a11cbd8789b401$var$columns = ()=>({
        c_personal_id: new (0, $49qEn.EntityColumn)({
            name: 'c_personal_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Personal Id'
        }),
        c_superior_id: new (0, $49qEn.EntityColumn)({
            name: 'c_superior_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Superior Id'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $b6a11cbd8789b401$var$views = ()=>({
        peje_brwStandard: {
            name: 'peje_brwStandard',
            keyMappings: {
                c_superior_id: 0
            }
        }
    });
const $b6a11cbd8789b401$var$procs = ()=>({
        peje_getJerarquiaPorPersonal: {
            name: 'peje_getJerarquiaPorPersonal'
        }
    });
class $b6a11cbd8789b401$export$bca4cd9c5d505c0e extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('PersonalJerarquia'), this.columns = $b6a11cbd8789b401$var$columns(), this.views = $b6a11cbd8789b401$var$views(), this.procs = $b6a11cbd8789b401$var$procs();
    }
}

});



parcelRegister("jhL1X", function(module, exports) {

$parcel$export(module.exports, "ACTAsignarSuperior", () => $0f7d8702570b4530$export$40f568d8eae92180);

var $ayMG0 = parcelRequire("ayMG0");

var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");
const $0f7d8702570b4530$export$40f568d8eae92180 = {
    name: 'ACTAsignarSuperior',
    label: 'Asignar Superior',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Asignar Superior"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    showActionInViewMode: true,
    views: [
        ''
    ],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const personal = entity;
        const procParms = {
            c_personal_id: selectedKeys?.[0]?.['c_personal_id'] ?? ''
        };
        let errores = '';
        if (!procParms.c_personal_id) errores = "Los registros seleccionados son inv\xe1lidos";
        await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                    fw: "700",
                    children: "Asignar superior"
                }),
                size: 'xl'
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.LookupFormAction), {
                lookupEntity: personal,
                viewName: personal.def.views.perl_brwGestionPersonal.name,
                title: "Asignar superior seleccionado",
                confirmContent: "\xbfEst\xe1 seguro de que desea asignar el superior al personal seleccionado?",
                onActionFinished: async ()=>{
                    if (onClose) await onClose();
                },
                onOK: async (keys, abortSignal)=>{
                    const abort_controller = new AbortController();
                    if (selectedKeys && selectedKeys.length > 0) {
                        entity.def.columns.c_superior_id.value = keys[0].c_personal_id;
                        const result = await entity.API.executeProcess(entity.def.procs.perl_AsignarSuperior, procParms, abort_controller.signal, selectedKeys);
                        if (!result.Failed) {
                            if (onClose) await onClose();
                            await modal.close();
                        }
                    }
                    return {
                        Results: [
                            {
                                Status: 0,
                                Message: 'OK'
                            }
                        ]
                    };
                }
            })
        });
        return false;
    }
};

});

parcelRegister("dUhns", function(module, exports) {

$parcel$export(module.exports, "ACTEliminarPersonal", () => $c58969d6ad27d613$export$3ea87a103f3c5368);

var $ayMG0 = parcelRequire("ayMG0");

var $9VIWE = parcelRequire("9VIWE");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $i7ldT = parcelRequire("i7ldT");
const $c58969d6ad27d613$export$3ea87a103f3c5368 = {
    name: 'ACTEliminarPersonal',
    label: 'Eliminar Personal',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Eliminar Personal"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    showActionInViewMode: true,
    views: [
        'perl_brwGestionPersonalDetalles'
    ],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        const abort_controller = new AbortController();
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const parent = entity;
        await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                    fw: "700",
                    children: `Quitar relaci\xf3n ${parent.Title}`
                })
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.ConfirmAndExecutePanel), {
                operation: "edit",
                loadingContent: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9VIWE.Stack), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.FakeProgressBar), {}),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            size: "sm",
                            mb: "xs",
                            children: `Eliminando relaciones`
                        })
                    ]
                }),
                content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                    size: "sm",
                    mb: "xs",
                    children: "Jerarqu\xeda de personal"
                }),
                okButtonText: "Aceptar",
                onCancel: async ()=>{
                    await abort_controller.abort();
                    await modal.close();
                    if (onClose) await onClose();
                },
                onOK: async ()=>{
                    const personaljerarquia = new (0, $i7ldT.PersonalJerarquia)(parent.API.client);
                    const result = await personaljerarquia.API.deleteData(selectedKeys, abort_controller.signal);
                    if (!result.Failed) {
                        if (onClose) await onClose();
                        await modal.close();
                    }
                }
            })
        });
        return false;
    }
};

});

parcelRegister("8mlq5", function(module, exports) {

$parcel$export(module.exports, "ACTGestionarPersonal", () => $85a2253beae86bba$export$ade261a80efdd847);

var $ayMG0 = parcelRequire("ayMG0");

var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");
var $4d0Rl = parcelRequire("4d0Rl");
const $85a2253beae86bba$export$ade261a80efdd847 = {
    name: 'ACTGestionarPersonal',
    label: 'Gestionar Personal',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Gestionar Personal"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    showActionInViewMode: true,
    views: [
        'perl_brwGestionPersonal'
    ],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const parent = entity;
        parent.def.columns.c_superior_id.value = selectedKeys[0].c_personal_id || '';
        parent.parentKeys = {
            ...parent.parentKeys,
            c_superior_id: selectedKeys[0].c_personal_id
        };
        const description = `Personal: ${selectedKeys[0].vc_nombre}`;
        await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                            size: "1.5rem",
                            stroke: "1.5"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            fw: "700",
                            children: description
                        })
                    ]
                }),
                size: "xl"
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.MultiDataMapForm), {
                autoFocus: true,
                formMode: "edit",
                title: "Gestionar Personal",
                dataMapView1: {
                    entity: parent,
                    viewName: parent.def.views.perl_brwGestionPersonalDetalles.name,
                    parentKeys: parent.parentKeys,
                    refreshOnInit: true,
                    latitudRecordIndex: 4,
                    longitudRecordIndex: 5,
                    tabLabel: "Personal",
                    tabIcon: (0, $4d0Rl.default),
                    enableView: true,
                    enableAdd: false,
                    enableEdit: false,
                    enableDelete: false,
                    showActions: true,
                    modalFormSize: "98%"
                },
                mapHeight: "50vh"
            }, `mapa-ubicacion-personal-${entity.def.name}`)
        });
        return false;
    }
};

});

parcelRegister("2qzcD", function(module, exports) {

$parcel$export(module.exports, "ACTReasignarPersonal", () => $336b7dca9da018ab$export$607214f6179fb8ad);

var $ayMG0 = parcelRequire("ayMG0");

var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");
const $336b7dca9da018ab$export$607214f6179fb8ad = {
    name: 'ACTReasignarPersonal',
    label: 'Reasignar Personal',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Reasignar Personal"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    showActionInViewMode: true,
    views: [
        'perl_brwGestionPersonalDetalles'
    ],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const personal = entity;
        const procParms = {
            c_personal_id: selectedKeys?.[0]?.['c_personal_id'] ?? ''
        };
        let errores = '';
        if (!procParms.c_personal_id) errores = "Los registros seleccionados son inv\xe1lidos";
        await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                    fw: "700",
                    children: "Reasignar personal"
                }),
                size: 'xl'
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.LookupFormAction), {
                lookupEntity: personal,
                viewName: personal.def.views.perl_brwGestionPersonal.name,
                title: "Reasignar personal seleccionado",
                confirmContent: "\xbfEst\xe1 seguro de que desea reasignar el personal seleccionado?",
                onActionFinished: async ()=>{
                    if (onClose) await onClose();
                },
                onOK: async (keys, abortSignal)=>{
                    const abort_controller = new AbortController();
                    if (selectedKeys && selectedKeys.length > 0) {
                        entity.def.columns.c_superior_id.value = keys[0].c_personal_id;
                        await entity.API.executeProcess(entity.def.procs.perl_AsignarSuperior, procParms, abort_controller.signal, selectedKeys);
                    }
                    return {
                        Results: [
                            {
                                Status: 0,
                                Message: 'OK'
                            }
                        ]
                    };
                }
            })
        });
        return false;
    }
};

});

parcelRegister("6KtvS", function(module, exports) {

$parcel$export(module.exports, "ACTReemplazarPersonal", () => $e5d4a5eb5aa6b40e$export$826009a629839d51);

var $ayMG0 = parcelRequire("ayMG0");

var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");
const $e5d4a5eb5aa6b40e$export$826009a629839d51 = {
    name: 'ACTReemplazarPersonal',
    label: 'Reemplazar Personal',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Reemplazar Personal"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    showActionInViewMode: true,
    minSelectedRecords: 1,
    maxSelectedRecords: 1,
    views: [
        ''
    ],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const personal = entity;
        const procParms = {
            c_personal_id: selectedKeys?.[0]?.['c_personal_id'] ?? ''
        };
        let errores = '';
        if (!procParms.c_personal_id) errores = "Los registros seleccionados son inv\xe1lidos";
        await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                    fw: "700",
                    children: "Reemplazar personal"
                }),
                size: 'xl'
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.LookupFormAction), {
                lookupEntity: personal,
                viewName: personal.def.views.perl_brwAsignarSuperior.name,
                title: "Reemplazar personal seleccionado",
                confirmContent: "\xbfEst\xe1 seguro de que desea asignar el superior al personal seleccionado?",
                onActionFinished: async ()=>{
                    if (onClose) await onClose();
                },
                onOK: async (keys, abortSignal)=>{
                    const abort_controller = new AbortController();
                    if (selectedKeys && selectedKeys.length === 1) {
                        entity.def.columns.c_superior_id.value = keys[0].c_personal_id;
                        const result = await entity.API.executeProcess(entity.def.procs.perl_ReemplazarPersonal, procParms, abort_controller.signal, selectedKeys);
                        if (!result.Failed) {
                            if (onClose) await onClose();
                            await modal.close();
                        }
                    }
                    return {
                        Results: [
                            {
                                Status: 0,
                                Message: 'OK'
                            }
                        ]
                    };
                }
            })
        });
        return false;
    }
};

});

parcelRegister("ctXMm", function(module, exports) {

$parcel$export(module.exports, "GestionPersonalDetallesViewInfoWindowRenderer", () => $4cae18c1e3670b07$export$3239d0b4cffb1c04);

var $ayMG0 = parcelRequire("ayMG0");

var $436KA = parcelRequire("436KA");
var $gU5rH = parcelRequire("gU5rH");
var $kPsAn = parcelRequire("kPsAn");
var $9mTYo = parcelRequire("9mTYo");
var $9VIWE = parcelRequire("9VIWE");
var $cjohz = parcelRequire("cjohz");
var $ew26C = parcelRequire("ew26C");
function $4cae18c1e3670b07$export$3239d0b4cffb1c04(record, position, groupManager, infoWindow, UIAPI, theme, entity) {
    const personal_id = record[0];
    const personal = record[1];
    const puesto = record[2];
    const vc_fotoguid = record[6];
    const fotoURL = entity.API.client.getDocumentURL(vc_fotoguid);
    const group = groupManager.getGroupByLocation(position);
    if (group) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kPsAn.Card), {
        withBorder: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9VIWE.Stack), {
            spacing: "xs",
            mb: "xs",
            children: [
                group.records.map(({ recordValue: rec }, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ew26C.Title), {
                                order: 5,
                                children: `${rec[1]}`
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                                size: "xs",
                                onClick: async ()=>{
                                    await UIAPI.handleViewClick({
                                        'c_personal_id': rec[0]
                                    });
                                },
                                children: "Ver"
                            })
                        ]
                    }, `grp_${rec[0]}`)),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                        size: "xs",
                        variant: "light",
                        onClick: ()=>{
                            infoWindow.close();
                        },
                        children: "Cerrar"
                    })
                })
            ]
        })
    });
    else return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kPsAn.Card), {
        withBorder: true,
        padding: "xs",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9VIWE.Stack), {
            spacing: "0.5rem",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    spacing: "xs",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $436KA.Avatar), {
                            size: "md",
                            src: fotoURL,
                            radius: "sm"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ew26C.Title), {
                            order: 4,
                            children: `${personal}`
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    spacing: "xs",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            weight: 500,
                            size: "sm",
                            children: "Puesto: "
                        }),
                        puesto
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    position: "right",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                            size: "xs",
                            onClick: async ()=>{
                                await UIAPI.handleViewClick({
                                    'c_personal_id': personal_id
                                });
                            },
                            children: "Ver"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                            size: "xs",
                            variant: "light",
                            onClick: ()=>{
                                infoWindow.close();
                            },
                            children: "Cerrar"
                        })
                    ]
                })
            ]
        })
    });
}

});

parcelRegister("hsl31", function(module, exports) {

$parcel$export(module.exports, "GestionPersonalDetallesViewMarkerRenderer", () => $350c0f3e62ad8782$export$51749d7f0677c03f);

var $49qEn = parcelRequire("49qEn");

var $d2PjO = parcelRequire("d2PjO");
function $350c0f3e62ad8782$export$51749d7f0677c03f(record, position, theme) {
    const personal = record[1];
    const puesto = record[2];
    const icon = (0, $d2PjO.moodSmileIcon);
    const label = undefined;
    const markerProps = {
        position: position,
        title: `${personal} - ${puesto}`,
        svgIcon: icon,
        assignColorByValue: undefined,
        fillColor: theme.colors.green[6],
        label: label,
        labelOrigin: label ? new google.maps.Point((0, $49qEn.MapMarkerGroupDefaultLabelOrigin).x, (0, $49qEn.MapMarkerGroupDefaultLabelOrigin).y) : undefined
    };
    return markerProps;
}

});
parcelRegister("d2PjO", function(module, exports) {

$parcel$export(module.exports, "moodSmileIcon", () => $df6550d73ee3bf49$export$3de11b867bb67e63);
$parcel$export(module.exports, "moodSadIcon", () => $df6550d73ee3bf49$export$5f8bfe3d51ad32a2);
$parcel$export(module.exports, "moodHappyIcon", () => $df6550d73ee3bf49$export$4d7efc430ec023c5);
$parcel$export(module.exports, "moodNeutralIcon", () => $df6550d73ee3bf49$export$f313d5becd027d83);
$parcel$export(module.exports, "mapPinSolidMarker", () => $df6550d73ee3bf49$export$50a502c1d7da5a52);
$parcel$export(module.exports, "solidCircleIcon", () => $df6550d73ee3bf49$export$d19f7f90e276ce1f);
$parcel$export(module.exports, "tiendaActualGroupIcon", () => $df6550d73ee3bf49$export$d5cd1ad66d4b55dd);
$parcel$export(module.exports, "tiendaGroupMarker", () => $df6550d73ee3bf49$export$dbe6a2e1a26a31df);

var $49qEn = parcelRequire("49qEn");
const $df6550d73ee3bf49$export$3de11b867bb67e63 = `<svg  xmlns="http://www.w3.org/2000/svg" style="${(0, $49qEn.MarkerSVGConverterStyleTAG)}${(0, $49qEn.MarkerSVGConverterSelectedStyleTAG)}" width="24"  height="24"  viewBox="0 0 24 24"  fill="${(0, $49qEn.MarkerSVGConverterFillColorTAG)}"  class="icon icon-tabler icons-tabler-filled icon-tabler-mood-smile"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-1.8 10.946a1 1 0 0 0 -1.414 .014a2.5 2.5 0 0 1 -3.572 0a1 1 0 0 0 -1.428 1.4a4.5 4.5 0 0 0 6.428 0a1 1 0 0 0 -.014 -1.414zm-6.19 -5.286l-.127 .007a1 1 0 0 0 .117 1.993l.127 -.007a1 1 0 0 0 -.117 -1.993zm6 0l-.127 .007a1 1 0 0 0 .117 1.993l.127 -.007a1 1 0 0 0 -.117 -1.993z" /></svg>`;
const $df6550d73ee3bf49$export$5f8bfe3d51ad32a2 = `<svg  xmlns="http://www.w3.org/2000/svg" style="${(0, $49qEn.MarkerSVGConverterStyleTAG)}${(0, $49qEn.MarkerSVGConverterSelectedStyleTAG)}" width="24"  height="24"  viewBox="0 0 24 24"  fill="${(0, $49qEn.MarkerSVGConverterFillColorTAG)}"  class="icon icon-tabler icons-tabler-filled icon-tabler-mood-sad"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-5 9.86a4.5 4.5 0 0 0 -3.214 1.35a1 1 0 1 0 1.428 1.4a2.5 2.5 0 0 1 3.572 0a1 1 0 0 0 1.428 -1.4a4.5 4.5 0 0 0 -3.214 -1.35zm-2.99 -4.2l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm6 0l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z" /></svg>`;
const $df6550d73ee3bf49$export$ff1c12f7f6bbdc63 = `<svg  xmlns="http://www.w3.org/2000/svg" style="${(0, $49qEn.MarkerSVGConverterStyleTAG)}${(0, $49qEn.MarkerSVGConverterSelectedStyleTAG)}"  width="24"  height="24"  viewBox="0 0 24 24"  fill="${(0, $49qEn.MarkerSVGConverterFillColorTAG)}"  class="icon icon-tabler icons-tabler-filled icon-tabler-mood-wrrr"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10a10 10 0 1 1 0 -20m3.707 12.293a1 1 0 0 0 -1.262 -.125l-.945 .63l-.945 -.63l-.116 -.066a1 1 0 0 0 -.994 .066l-.945 .63l-.945 -.63a1 1 0 0 0 -1.262 .125l-1 1a1 1 0 0 0 0 1.414l.094 .083a1 1 0 0 0 1.32 -.083l.42 -.42l.818 .545l.116 .066a1 1 0 0 0 .994 -.066l.945 -.63l.945 .63l.116 .066a1 1 0 0 0 .994 -.066l.817 -.545l.42 .42a1 1 0 0 0 1.415 -1.414zm-6.5 -6.5a1 1 0 0 0 -1.414 0l-.083 .094a1 1 0 0 0 .083 1.32l.792 .793l-.792 .793a1 1 0 0 0 1.414 1.414l1.5 -1.5a1 1 0 0 0 0 -1.414zm7 0a1 1 0 0 0 -1.414 0l-1.5 1.5a1 1 0 0 0 0 1.414l1.5 1.5a1 1 0 0 0 1.414 0l.083 -.094a1 1 0 0 0 -.083 -1.32l-.792 -.793l.792 -.793a1 1 0 0 0 0 -1.414" /></svg>`;
const $df6550d73ee3bf49$export$4d7efc430ec023c5 = `<svg  xmlns="http://www.w3.org/2000/svg" style="${(0, $49qEn.MarkerSVGConverterStyleTAG)}${(0, $49qEn.MarkerSVGConverterSelectedStyleTAG)}" width="24"  height="24"  viewBox="0 0 24 24"  fill="${(0, $49qEn.MarkerSVGConverterFillColorTAG)}"  class="icon icon-tabler icons-tabler-filled icon-tabler-mood-happy"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-2 9.66h-6a1 1 0 0 0 -1 1v.05a3.975 3.975 0 0 0 3.777 3.97l.227 .005a4.026 4.026 0 0 0 3.99 -3.79l.006 -.206a1 1 0 0 0 -1 -1.029zm-5.99 -5l-.127 .007a1 1 0 0 0 .117 1.993l.127 -.007a1 1 0 0 0 -.117 -1.993zm6 0l-.127 .007a1 1 0 0 0 .117 1.993l.127 -.007a1 1 0 0 0 -.117 -1.993z" /></svg>`;
const $df6550d73ee3bf49$export$d033386b142086aa = `<svg  xmlns="http://www.w3.org/2000/svg" style="${(0, $49qEn.MarkerSVGConverterStyleTAG)}${(0, $49qEn.MarkerSVGConverterSelectedStyleTAG)}" width="24"  height="24"  viewBox="0 0 24 24"  fill="${(0, $49qEn.MarkerSVGConverterFillColorTAG)}"  class="icon icon-tabler icons-tabler-filled icon-tabler-mood-confuzed"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-1.43 10.162a11 11 0 0 0 -6.6 1.65a1 1 0 0 0 1.06 1.696a9 9 0 0 1 5.4 -1.35a1 1 0 0 0 .14 -1.996zm-6.56 -4.502l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm6 0l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z" /></svg>`;
const $df6550d73ee3bf49$export$f313d5becd027d83 = `<svg  xmlns="http://www.w3.org/2000/svg" style="${(0, $49qEn.MarkerSVGConverterStyleTAG)}${(0, $49qEn.MarkerSVGConverterSelectedStyleTAG)}" width="24"  height="24"  viewBox="0 0 24 24"  fill="${(0, $49qEn.MarkerSVGConverterFillColorTAG)}"  class="icon icon-tabler icons-tabler-filled icon-tabler-mood-empty"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-2 10.66h-6l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h6l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm-5.99 -5l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm6 0l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z" /></svg>`;
const $df6550d73ee3bf49$export$9eeacff7781d768a = `<svg  xmlns="http://www.w3.org/2000/svg" style="${(0, $49qEn.MarkerSVGConverterStyleTAG)}${(0, $49qEn.MarkerSVGConverterSelectedStyleTAG)}" width="24"  height="24"  viewBox="0 0 24 24"  fill="${(0, $49qEn.MarkerSVGConverterFillColorTAG)}"  class="icon icon-tabler icons-tabler-filled icon-tabler-mood-crazy-happy"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m-1.8 10.946a1 1 0 0 0 -1.414 .014a2.5 2.5 0 0 1 -3.572 0a1 1 0 0 0 -1.428 1.4a4.5 4.5 0 0 0 6.428 0a1 1 0 0 0 -.014 -1.414m-7.493 -6.493a1 1 0 0 0 -1.414 1.414l.792 .793l-.792 .793a1 1 0 0 0 1.414 1.414l.793 -.792l.793 .792a1 1 0 1 0 1.414 -1.414l-.792 -.793l.792 -.793a1 1 0 1 0 -1.414 -1.414l-.793 .792zm7 0a1 1 0 0 0 -1.414 1.414l.792 .793l-.792 .793a1 1 0 0 0 1.414 1.414l.793 -.792l.793 .792a1 1 0 0 0 1.414 -1.414l-.792 -.793l.792 -.793a1 1 0 1 0 -1.414 -1.414l-.793 .792z" /></svg>`;
const $df6550d73ee3bf49$export$50a502c1d7da5a52 = `<svg  xmlns="http://www.w3.org/2000/svg" style="${(0, $49qEn.MarkerSVGConverterStyleTAG)}${(0, $49qEn.MarkerSVGConverterSelectedStyleTAG)}" width="24"  height="24"  viewBox="0 0 24 24"  fill="${(0, $49qEn.MarkerSVGConverterFillColorTAG)}"  class="icon icon-tabler icons-tabler-filled icon-tabler-map-pin"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M18.364 4.636a9 9 0 0 1 .203 12.519l-.203 .21l-4.243 4.242a3 3 0 0 1 -4.097 .135l-.144 -.135l-4.244 -4.243a9 9 0 0 1 12.728 -12.728z"/></svg>`;
const $df6550d73ee3bf49$export$d19f7f90e276ce1f = `<svg xmlns="http://www.w3.org/2000/svg" style="${(0, $49qEn.MarkerSVGConverterStyleTAG)}${(0, $49qEn.MarkerSVGConverterSelectedStyleTAG)}" width="24"  height="24"  viewBox="0 0 24 24"  fill="${(0, $49qEn.MarkerSVGConverterFillColorTAG)}"  class="icon icon-tabler icons-tabler-filled icon-tabler-circle"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M7 3.34a10 10 0 1 1 -4.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 4.995 -8.336z" /></svg>`;
const $df6550d73ee3bf49$export$d5cd1ad66d4b55dd = `<svg  xmlns="http://www.w3.org/2000/svg" style="${(0, $49qEn.MarkerSVGConverterStyleTAG)}${(0, $49qEn.MarkerSVGConverterSelectedStyleTAG)}"   width="24"  height="24"  viewBox="0 0 24 24"  fill="${(0, $49qEn.MarkerSVGConverterFillColorTAG)}"  class="icon icon-tabler icons-tabler-filled icon-tabler-circle"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M7 3.34a10 10 0 1 1 -4.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 4.995 -8.336z" /></svg>`;
const $df6550d73ee3bf49$export$dbe6a2e1a26a31df = `<svg  xmlns="http://www.w3.org/2000/svg" style="${(0, $49qEn.MarkerSVGConverterStyleTAG)}${(0, $49qEn.MarkerSVGConverterSelectedStyleTAG)}" width="24"  height="24"  viewBox="0 0 24 24"  fill="${(0, $49qEn.MarkerSVGConverterFillColorTAG)}"  class="icon icon-tabler icons-tabler-filled icon-tabler-map-pin"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M18.364 4.636a9 9 0 0 1 .203 12.519l-.203 .21l-4.243 4.242a3 3 0 0 1 -4.097 .135l-.144 -.135l-4.244 -4.243a9 9 0 0 1 12.728 -12.728z"/></svg>`;

});


parcelRegister("B2kod", function(module, exports) {

$parcel$export(module.exports, "PersonalAsignarFilters", () => $6e533f7b216c41e3$export$ef95cdffee6ce48d);

var $49qEn = parcelRequire("49qEn");

var $fzlgC = parcelRequire("fzlgC");

class $6e533f7b216c41e3$export$ef95cdffee6ce48d extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $fzlgC.PersonalAsignarFiltersDef)(), parentKeys);
        this.Form = (parcelRequire("4l0t7")).then((module)=>module.PersonalAsignarFiltersForm);
        this.Title = "Personal Filters";
    }
}

});
parcelRegister("fzlgC", function(module, exports) {

$parcel$export(module.exports, "PersonalAsignarFiltersDef", () => $cfbf1e35c3428531$export$5f922aebd0b13e0f);

var $49qEn = parcelRequire("49qEn");

var $hMWb0 = parcelRequire("hMWb0");

var $a4nBq = parcelRequire("a4nBq");

var $7LP39 = parcelRequire("7LP39");
const $cfbf1e35c3428531$var$columns = ()=>({
        vc_puestos: new (0, $49qEn.EntityColumn)({
            name: 'vc_puestos',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Puestos',
            isArray: true
        }),
        vc_licencias: new (0, $49qEn.EntityColumn)({
            name: 'vc_licencias',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Licencias',
            isArray: true
        }),
        vc_personal: new (0, $49qEn.EntityColumn)({
            name: 'vc_personal',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Personal',
            isArray: true
        }),
        vc_supervision: new (0, $49qEn.EntityColumn)({
            name: 'vc_supervision',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Supervisor',
            isArray: true
        }),
        b_activo: new (0, $49qEn.EntityColumn)({
            name: 'b_activo',
            type: 'bit',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Solo personal activo'
        }),
        b_baja: new (0, $49qEn.EntityColumn)({
            name: 'b_baja',
            type: 'bit',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Solo personal de baja'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $cfbf1e35c3428531$var$lookups = ()=>({
        'Puestos': {
            name: 'Puestos',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $a4nBq.PuestosTrabajo)(client, parentKeys)
        },
        'Licencias': {
            name: 'Licencias',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $hMWb0.catMotivosLicencia)(client, parentKeys)
        },
        'Personal': {
            name: 'Personal',
            view: 'perl_brwStandard',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $7LP39.Personal)(client, parentKeys)
        },
        'Supervision': {
            name: 'Supervision',
            view: 'perl_brwStandard',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $7LP39.Personal)(client, parentKeys)
        }
    });
class $cfbf1e35c3428531$export$5f922aebd0b13e0f extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('PersonalAsignarFilters'), this.columns = $cfbf1e35c3428531$var$columns(), this.views = {}, this.lookups = $cfbf1e35c3428531$var$lookups();
    }
}

});
parcelRegister("hMWb0", function(module, exports) {

$parcel$export(module.exports, "MotivosLicenciaIcon", () => $67e8a56b936d8064$export$306bd4d6012ee0c3);
$parcel$export(module.exports, "MotivosLicenciaHelpText", () => $67e8a56b936d8064$export$90d168f76a18f5d5);
$parcel$export(module.exports, "catMotivosLicencia", () => $67e8a56b936d8064$export$b3dd94400c60eabf);

var $49qEn = parcelRequire("49qEn");

var $3Wsto = parcelRequire("3Wsto");
const $67e8a56b936d8064$export$306bd4d6012ee0c3 = (0, $3Wsto.default);
const $67e8a56b936d8064$export$90d168f76a18f5d5 = "* Aqu\xed puede ver la lista de los motivos de licencia.";
class $67e8a56b936d8064$export$b3dd94400c60eabf extends (0, $49qEn.CategoriesValues) {
    constructor(client, parentKeys = {}){
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "MotivosLicencia";
        this.def.columns.c_category_id.defaultValue = "MotivosLicencia";
        this.Title = "Motivos de Licencia";
        this.Icon = $67e8a56b936d8064$export$306bd4d6012ee0c3;
        this.HelpText = $67e8a56b936d8064$export$90d168f76a18f5d5;
    }
}

});
parcelRegister("3Wsto", function(module, exports) {

$parcel$export(module.exports, "default", () => $adbfb4380cdd6b36$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $adbfb4380cdd6b36$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M15 21h-9a3 3 0 0 1 -3 -3v-1h10v2a2 2 0 0 0 4 0v-14a2 2 0 1 1 2 2h-2m2 -4h-11a3 3 0 0 0 -3 3v11",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M9 7l4 0",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M9 11l4 0",
            "key": "svg-2"
        }
    ]
];
const $adbfb4380cdd6b36$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "license", "License", $adbfb4380cdd6b36$export$3efd853dbb351e94);

});



parcelRegister("4l0t7", function(module, exports) {
module.exports = import("hJ5Jf").then(()=>parcelRequire('bCT8p'));

});


parcelRegister("gZOwU", function(module, exports) {

$parcel$export(module.exports, "PersonalFilters", () => $383e50d7f3338f3c$export$17aff4b859b743e1);

var $49qEn = parcelRequire("49qEn");

var $eKvk3 = parcelRequire("eKvk3");

class $383e50d7f3338f3c$export$17aff4b859b743e1 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $eKvk3.PersonalFiltersDef)(), parentKeys);
        this.Form = (parcelRequire("eSb09")).then((module)=>module.PersonalFiltersForm);
        this.Title = "Personal Filters";
    }
}

});
parcelRegister("eKvk3", function(module, exports) {

$parcel$export(module.exports, "PersonalFiltersDef", () => $f0564d3334e48297$export$37fe756ef2acea8);

var $49qEn = parcelRequire("49qEn");

var $hMWb0 = parcelRequire("hMWb0");

var $a4nBq = parcelRequire("a4nBq");

var $7LP39 = parcelRequire("7LP39");
const $f0564d3334e48297$var$columns = ()=>({
        vc_puestos: new (0, $49qEn.EntityColumn)({
            name: 'vc_puestos',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Puestos',
            isArray: true
        }),
        vc_licencias: new (0, $49qEn.EntityColumn)({
            name: 'vc_licencias',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Licencias',
            isArray: true
        }),
        vc_personal: new (0, $49qEn.EntityColumn)({
            name: 'vc_personal',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Personal',
            isArray: true
        }),
        vc_supervision: new (0, $49qEn.EntityColumn)({
            name: 'vc_supervision',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Supervisor',
            isArray: true
        }),
        b_activo: new (0, $49qEn.EntityColumn)({
            name: 'b_activo',
            type: 'bit',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Solo personal activo'
        }),
        b_baja: new (0, $49qEn.EntityColumn)({
            name: 'b_baja',
            type: 'bit',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Solo personal de baja'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $f0564d3334e48297$var$lookups = ()=>({
        'Puestos': {
            name: 'Puestos',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $a4nBq.PuestosTrabajo)(client, parentKeys)
        },
        'Licencias': {
            name: 'Licencias',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $hMWb0.catMotivosLicencia)(client, parentKeys)
        },
        'Personal': {
            name: 'Personal',
            view: 'perl_brwStandard',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $7LP39.Personal)(client, parentKeys)
        },
        'Supervision': {
            name: 'Supervision',
            view: 'perl_brwStandard',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $7LP39.Personal)(client, parentKeys)
        }
    });
class $f0564d3334e48297$export$37fe756ef2acea8 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('PersonalFilters'), this.columns = $f0564d3334e48297$var$columns(), this.views = {}, this.lookups = $f0564d3334e48297$var$lookups();
    }
}

});

parcelRegister("eSb09", function(module, exports) {
module.exports = import("jSZUo").then(()=>parcelRequire('5vbMV'));

});


parcelRegister("jNo5L", function(module, exports) {

$parcel$export(module.exports, "PersonalGestionFilters", () => $4af2d5f7ea5baf40$export$ee9a64e87c567768);

var $49qEn = parcelRequire("49qEn");

var $5om3i = parcelRequire("5om3i");

class $4af2d5f7ea5baf40$export$ee9a64e87c567768 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $5om3i.PersonalGestionFiltersDef)(), parentKeys);
        this.Form = (parcelRequire("iX1C1")).then((module)=>module.PersonalGestionFiltersForm);
        this.Title = "Personal Filters";
    }
}

});
parcelRegister("5om3i", function(module, exports) {

$parcel$export(module.exports, "PersonalGestionFiltersDef", () => $bb3fcae733c7a45d$export$38e340362b1e024f);

var $49qEn = parcelRequire("49qEn");

var $hMWb0 = parcelRequire("hMWb0");

var $a4nBq = parcelRequire("a4nBq");

var $7LP39 = parcelRequire("7LP39");
const $bb3fcae733c7a45d$var$columns = ()=>({
        vc_puestos: new (0, $49qEn.EntityColumn)({
            name: 'vc_puestos',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Puestos',
            isArray: true,
            defaultValue: [
                "0000000002",
                "0000000003"
            ]
        }),
        vc_licencias: new (0, $49qEn.EntityColumn)({
            name: 'vc_licencias',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Licencias',
            isArray: true
        }),
        vc_personal: new (0, $49qEn.EntityColumn)({
            name: 'vc_personal',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Personal',
            isArray: true
        }),
        vc_supervision: new (0, $49qEn.EntityColumn)({
            name: 'vc_supervision',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Supervisor',
            isArray: true
        }),
        b_activo: new (0, $49qEn.EntityColumn)({
            name: 'b_activo',
            type: 'bit',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Solo personal activo'
        }),
        b_baja: new (0, $49qEn.EntityColumn)({
            name: 'b_baja',
            type: 'bit',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Solo personal de baja'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $bb3fcae733c7a45d$var$lookups = ()=>({
        'Puestos': {
            name: 'Puestos',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $a4nBq.PuestosTrabajo)(client, parentKeys)
        },
        'Licencias': {
            name: 'Licencias',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $hMWb0.catMotivosLicencia)(client, parentKeys)
        },
        'Personal': {
            name: 'Personal',
            view: 'perl_brwStandard',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $7LP39.Personal)(client, parentKeys)
        },
        'Supervision': {
            name: 'Supervision',
            view: 'perl_brwStandard',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $7LP39.Personal)(client, parentKeys)
        }
    });
class $bb3fcae733c7a45d$export$38e340362b1e024f extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('PersonalGestionFilters'), this.columns = $bb3fcae733c7a45d$var$columns(), this.views = {}, this.lookups = $bb3fcae733c7a45d$var$lookups();
    }
}

});

parcelRegister("iX1C1", function(module, exports) {
module.exports = import("jtTpL").then(()=>parcelRequire('7vLVo'));

});



parcelRegister("971Cw", function(module, exports) {
module.exports = Promise.all([
    import("gbmT9"),
    import("j1ajl")
]).then(()=>parcelRequire('2FgBJ'));

});


parcelRegister("6awxZ", function(module, exports) {

$parcel$export(module.exports, "TiendasHelpText", () => $0c26469dc4508a2b$export$3ffb2745bdaad6e6);
$parcel$export(module.exports, "TiendasIcon", () => $0c26469dc4508a2b$export$79cbdcaeaffc33a8);
$parcel$export(module.exports, "Tiendas", () => $0c26469dc4508a2b$export$27a81cde3b5e5e23);

var $49qEn = parcelRequire("49qEn");

var $jIc5b = parcelRequire("jIc5b");

var $h7Ahw = parcelRequire("h7Ahw");
const $0c26469dc4508a2b$export$3ffb2745bdaad6e6 = "* Aqu\xed tiene toda la lista de las tiendas dadas de alta.";
const $0c26469dc4508a2b$export$79cbdcaeaffc33a8 = (0, $jIc5b.default);

class $0c26469dc4508a2b$export$27a81cde3b5e5e23 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $h7Ahw.TiendasDef)(), parentKeys);
        this.Form = (parcelRequire("8MlKq")).then((module)=>module.TiendasForm);
        this.Title = "Tiendas";
        //this.HelpText = "* Agregue aquí las Tiendas que pertenecen al Grupo. Al crear una tienda también podrá asignarle un Canal. Las Tiendas pueden pertenecer a una sola Empresa y a una sola Cadena.";
        this.HelpText = $0c26469dc4508a2b$export$3ffb2745bdaad6e6;
        this.Icon = $0c26469dc4508a2b$export$79cbdcaeaffc33a8;
    }
}

});
parcelRegister("h7Ahw", function(module, exports) {

$parcel$export(module.exports, "TiendasDef", () => $eddd66a670aad01c$export$f3f180de2884f40c);

var $49qEn = parcelRequire("49qEn");

var $6TYT5 = parcelRequire("6TYT5");

var $5kp3N = parcelRequire("5kp3N");

var $bYVp3 = parcelRequire("bYVp3");

var $3IWeJ = parcelRequire("3IWeJ");

var $6z1tR = parcelRequire("6z1tR");

var $iYjhm = parcelRequire("iYjhm");

var $gkMhi = parcelRequire("gkMhi");

var $7n4Yg = parcelRequire("7n4Yg");

var $6dHUT = parcelRequire("6dHUT");
const $eddd66a670aad01c$var$columns = ()=>({
        c_tienda_id: new (0, $49qEn.EntityColumn)({
            name: 'c_tienda_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PKAutonum,
            prompt: 'Tienda ID'
        }),
        c_empresa_id: new (0, $49qEn.EntityColumn)({
            name: 'c_empresa_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Empresa'
        }),
        c_grupoempresa_id: new (0, $49qEn.EntityColumn)({
            name: 'c_grupoempresa_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Grupo'
        }),
        vc_nombre: new (0, $49qEn.EntityColumn)({
            name: 'vc_nombre',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Nombre de la tienda'
        }),
        vc_codigoexterno: new (0, $49qEn.EntityColumn)({
            name: 'vc_codigoexterno',
            type: 'varchar',
            length: 50,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "C\xf3digo externo"
        }),
        c_cadena_id: new (0, $49qEn.EntityColumn)({
            name: 'c_cadena_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Cadena'
        }),
        vc_canales: new (0, $49qEn.EntityColumn)({
            name: 'vc_canales',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Canales',
            isArray: true
        }),
        c_activo_id: new (0, $49qEn.EntityColumn)({
            name: 'c_activo_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Estado'
        }),
        c_region_id: new (0, $49qEn.EntityColumn)({
            name: 'c_region_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Regi\xf3n"
        }),
        c_area_id: new (0, $49qEn.EntityColumn)({
            name: 'c_area_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Area'
        }),
        c_subarea_id: new (0, $49qEn.EntityColumn)({
            name: 'c_subarea_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Subarea'
        }),
        vc_domicilio_ruteo: new (0, $49qEn.EntityColumn)({
            name: 'vc_domicilio_ruteo',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Domicilio Ruteo'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $eddd66a670aad01c$var$views = ()=>({
        tien_brwStandard: {
            name: 'tien_brwStandard',
            keyMappings: {
                c_tienda_id: 0
            },
            FiltersEntity: (client, parentKeys)=>new (0, $6dHUT.TiendasFilters)(client, parentKeys)
        },
        tien_brwPorGrupo: {
            name: 'tien_brwPorGrupo',
            keyMappings: {
                c_tienda_id: 0,
                c_grupoempresa_id: -1
            }
        }
    });
const $eddd66a670aad01c$var$lookups = ()=>({
        'Empresas': {
            name: 'Empresas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 2
            },
            entityConstructor: (client, parentKeys)=>new (0, $bYVp3.Empresas)(client, parentKeys)
        },
        'Cadenas': {
            name: 'Cadenas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $6z1tR.GruposEmpresasCadenas)(client, parentKeys)
        },
        'Canales': {
            name: 'Canales',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $6TYT5.catCanales)(client, parentKeys)
        },
        'GruposEmpresas': {
            name: 'GruposEmpresas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $3IWeJ.GruposEmpresas)(client, parentKeys)
        },
        'Regiones': {
            name: 'Regiones',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $gkMhi.Regiones)(client, parentKeys)
        },
        'Areas': {
            name: 'Areas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $iYjhm.Areas)(client, parentKeys)
        },
        'SubAreas': {
            name: 'SubAreas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $7n4Yg.SubAreas)(client, parentKeys)
        },
        'Activo': {
            name: 'Activo',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $5kp3N.estActivo)(client, parentKeys)
        }
    });
class $eddd66a670aad01c$export$f3f180de2884f40c extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('Tiendas'), this.columns = $eddd66a670aad01c$var$columns(), this.views = $eddd66a670aad01c$var$views(), this.lookups = $eddd66a670aad01c$var$lookups();
    }
}

});
parcelRegister("6z1tR", function(module, exports) {

$parcel$export(module.exports, "GruposEmpresasCadenas", () => $fc3691c31e95024e$export$c18aeaa0980fab74);

var $49qEn = parcelRequire("49qEn");

var $38Jku = parcelRequire("38Jku");

var $cYA6a = parcelRequire("cYA6a");
class $fc3691c31e95024e$export$c18aeaa0980fab74 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $cYA6a.GruposEmpresasCadenasDef)(), parentKeys);
        //super.Form = import('./GruposEmpresasCat/GruposEmpresasCatForm').then((module) => module.GruposEmpresasCatForm);
        this.Title = "Cadenas de Tiendas";
        this.HelpText = '* Aqu\xed puede ver la lista de todas las cadenas de tiendas disponibles. La columna "RELACIONADA" indica si la cadena est\xe1 relacionada con este grupo de empresas. El bot\xf3n AGREGAR crear\xe1 una nueva Cadena y la relacionar\xe1 con este grupo. El bot\xf3n MODIFICAR permite cambiar el nombre de la cadena. Los botones RELACIONAR y QUITAR RELACI\xd3N permiten cambiar la relaci\xf3n de la cadena y grupo. Una cadena puede estar relacionada con un solo grupo de empresas.';
        this.Icon = (0, $38Jku.default);
    }
}

});
parcelRegister("cYA6a", function(module, exports) {

$parcel$export(module.exports, "GruposEmpresasCadenasDef", () => $129215f3a5a75b2c$export$ca9b6a38b47ad9e3);

var $49qEn = parcelRequire("49qEn");
const $129215f3a5a75b2c$var$columns = ()=>({
        c_grupoempresa_id: new (0, $49qEn.EntityColumn)({
            name: 'c_grupoempresa_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Grupo ID'
        }),
        c_cadena_id: new (0, $49qEn.EntityColumn)({
            name: 'c_cadena_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Cadena ID'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $129215f3a5a75b2c$var$views = ()=>({
        geca_brwStandard: {
            name: 'geca_brwStandard',
            keyMappings: {
                c_cadena_id: 0
            }
        },
        geca_brwPorGrupo: {
            name: 'geca_brwPorGrupo',
            keyMappings: {
                c_cadena_id: 0
            }
        }
    });
class $129215f3a5a75b2c$export$ca9b6a38b47ad9e3 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('GruposEmpresasCadenas'), this.columns = $129215f3a5a75b2c$var$columns(), this.views = $129215f3a5a75b2c$var$views();
    }
}

});


parcelRegister("iYjhm", function(module, exports) {

$parcel$export(module.exports, "Areas", () => $d6eb60f7670363a3$export$be037cb0eb4aad7a);

var $49qEn = parcelRequire("49qEn");

var $eae64 = parcelRequire("eae64");

var $2hZie = parcelRequire("2hZie");
const $d6eb60f7670363a3$export$33f713c7257ed726 = (0, $eae64.default);
const $d6eb60f7670363a3$export$f57d963dde26a9bc = "* \xc1reas de Ruteo.";

class $d6eb60f7670363a3$export$be037cb0eb4aad7a extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $2hZie.AreasDef)(), parentKeys);
        this.Form = (parcelRequire("icPJq")).then((module)=>module.AreasForm);
        this.Title = "Areas de Ruteo";
        this.HelpText = $d6eb60f7670363a3$export$f57d963dde26a9bc;
        this.Icon = $d6eb60f7670363a3$export$33f713c7257ed726;
    }
}

});
parcelRegister("2hZie", function(module, exports) {

$parcel$export(module.exports, "AreasDef", () => $15be647d9e2ff355$export$8058c5c83825087e);

var $49qEn = parcelRequire("49qEn");

var $gkMhi = parcelRequire("gkMhi");
const $15be647d9e2ff355$var$columns = ()=>({
        c_region_id: new (0, $49qEn.EntityColumn)({
            name: 'c_region_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Region Id'
        }),
        c_area_id: new (0, $49qEn.EntityColumn)({
            name: 'c_area_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PKAutonum,
            prompt: 'Area Id'
        }),
        vc_nombre_area: new (0, $49qEn.EntityColumn)({
            name: 'vc_nombre_area',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Nombre Area'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $15be647d9e2ff355$var$views = ()=>({
        area_brwStandard: {
            name: 'area_brwStandard',
            keyMappings: {
                c_area_id: 0
            }
        }
    });
const $15be647d9e2ff355$var$lookups = ()=>({
        'Regiones': {
            name: 'Regiones',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $gkMhi.Regiones)(client, parentKeys)
        }
    });
class $15be647d9e2ff355$export$8058c5c83825087e extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('Areas'), this.columns = $15be647d9e2ff355$var$columns(), this.views = $15be647d9e2ff355$var$views(), this.lookups = $15be647d9e2ff355$var$lookups();
    }
}

});
parcelRegister("gkMhi", function(module, exports) {

$parcel$export(module.exports, "RegionesIcon", () => $9d05a9ce8281b3f1$export$3c140d1a5c8936c6);
$parcel$export(module.exports, "RegionesHelpText", () => $9d05a9ce8281b3f1$export$b22f3e4cd4a129fc);
$parcel$export(module.exports, "Regiones", () => $9d05a9ce8281b3f1$export$6979a83bb95e7304);

var $49qEn = parcelRequire("49qEn");

var $ivoLR = parcelRequire("ivoLR");

var $lxBld = parcelRequire("lxBld");
const $9d05a9ce8281b3f1$export$3c140d1a5c8936c6 = (0, $ivoLR.default);
const $9d05a9ce8281b3f1$export$b22f3e4cd4a129fc = "* Aqu\xed puede ver la lista de todas las regiones disponibles.";

class $9d05a9ce8281b3f1$export$6979a83bb95e7304 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $lxBld.RegionesDef)(), parentKeys);
        this.Form = (parcelRequire("74y8G")).then((module)=>module.RegionesForm);
        this.Title = "Regiones";
        this.HelpText = $9d05a9ce8281b3f1$export$b22f3e4cd4a129fc;
        this.Icon = $9d05a9ce8281b3f1$export$3c140d1a5c8936c6;
    }
}

});
parcelRegister("lxBld", function(module, exports) {

$parcel$export(module.exports, "RegionesDef", () => $07f75d420d8d0bcb$export$62bf0c99bc3aa2b);

var $49qEn = parcelRequire("49qEn");

var $bcnVu = parcelRequire("bcnVu");
const $07f75d420d8d0bcb$var$columns = ()=>({
        c_region_id: new (0, $49qEn.EntityColumn)({
            name: 'c_region_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PKAutonum,
            prompt: 'Region Id',
            description: "Identificador \xfanico de la regi\xf3n. Este campo es autogenerado y no puede ser modificado manualmente."
        }),
        vc_nombre_region: new (0, $49qEn.EntityColumn)({
            name: 'vc_nombre_region',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: "Nombre Regi\xf3n",
            description: "Nombre descriptivo de la regi\xf3n."
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $07f75d420d8d0bcb$var$views = ()=>({
        regi_brwStandard: {
            name: 'regi_brwStandard',
            keyMappings: {
                c_region_id: 0
            }
        }
    });
const $07f75d420d8d0bcb$var$lookups = ()=>({});
const $07f75d420d8d0bcb$var$clientActions = ()=>({
        ACTGestionarTiendas: (0, $bcnVu.ACTGestionarTiendas)
    });
class $07f75d420d8d0bcb$export$62bf0c99bc3aa2b extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('Regiones'), this.columns = $07f75d420d8d0bcb$var$columns(), this.views = $07f75d420d8d0bcb$var$views(), this.lookups = $07f75d420d8d0bcb$var$lookups(), this.clientActions = $07f75d420d8d0bcb$var$clientActions();
    }
}

});
parcelRegister("bcnVu", function(module, exports) {

$parcel$export(module.exports, "ACTGestionarTiendas", () => $2b776f5ac3f681ab$export$a446eb376eb847fa);

var $ayMG0 = parcelRequire("ayMG0");

var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $6fChe = parcelRequire("6fChe");
const $2b776f5ac3f681ab$export$a446eb376eb847fa = {
    name: 'ACTGestionarTiendas',
    label: 'Gestionar Tiendas',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Gestionar Tiendas"
    }),
    refreshOnClose: true,
    minSelectedRecords: 1,
    maxSelectedRecords: 1,
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        // cast entity
        const parent = entity;
        const tiendas = new (0, $6fChe.RegionesTiendas)(entity.API.client);
        tiendas.parentKeys = {
            ...parent.parentKeys,
            vc_nombre_region: selectedKeys[0].vc_nombre_region
        };
        tiendas.def.columns.c_region_id.value = selectedKeys[0].c_region_id || '';
        if (modal) await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                    fw: "700",
                    children: "Gestionar Tiendas"
                }),
                size: 'xl'
            },
            focusOnClosed: element,
            onClosed: async ()=>{
                if (onClose) await onClose();
            },
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: entity.API.client,
                entityConstructor: ()=>tiendas,
                formMode: "edit",
                viewName: "regt_brwTiendasPorRegion",
                parentKeys: tiendas.parentKeys,
                refreshOnInit: true,
                enableAdd: false,
                enableDelete: false,
                enableEdit: false,
                enableView: false,
                showActions: true,
                title: `Gestionar ${selectedKeys[0].vc_nombre_region}`,
                selectionMode: "multi"
            }, "region-tiendas")
        });
        else console.log('modal context not found');
        return Promise.resolve(false);
    }
};

});
parcelRegister("6fChe", function(module, exports) {

$parcel$export(module.exports, "RegionesTiendas", () => $a7a09cfcb17e2811$export$25378bd690a26c4b);

var $49qEn = parcelRequire("49qEn");

var $ivoLR = parcelRequire("ivoLR");

var $d5Uw6 = parcelRequire("d5Uw6");
const $a7a09cfcb17e2811$export$149e426115fbedec = (0, $ivoLR.default);
const $a7a09cfcb17e2811$export$2d8a4f8f09129f8f = '* Regiones de Tiendas.';
class $a7a09cfcb17e2811$export$25378bd690a26c4b extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $d5Uw6.RegionesTiendasDef)(), parentKeys);
        this.Form = null;
        this.Title = "Regiones de Tiendas";
        this.HelpText = $a7a09cfcb17e2811$export$2d8a4f8f09129f8f;
        this.Icon = $a7a09cfcb17e2811$export$149e426115fbedec;
    }
}

});
parcelRegister("d5Uw6", function(module, exports) {

$parcel$export(module.exports, "RegionesTiendasDef", () => $61f6e507546b900f$export$4d82b3c95f9a76b3);

var $49qEn = parcelRequire("49qEn");

var $6awxZ = parcelRequire("6awxZ");

var $iYjhm = parcelRequire("iYjhm");

var $gkMhi = parcelRequire("gkMhi");

var $fEdFq = parcelRequire("fEdFq");

var $7n4Yg = parcelRequire("7n4Yg");

var $5oXCF = parcelRequire("5oXCF");
const $61f6e507546b900f$var$columns = ()=>({
        c_tienda_id: new (0, $49qEn.EntityColumn)({
            name: 'c_tienda_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Tienda Id'
        }),
        c_region_id: new (0, $49qEn.EntityColumn)({
            name: 'c_region_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: "Regi\xf3n Id"
        }),
        c_area_id: new (0, $49qEn.EntityColumn)({
            name: 'c_area_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Area Id'
        }),
        c_subarea_id: new (0, $49qEn.EntityColumn)({
            name: 'c_subarea_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Subarea Id'
        }),
        vc_domicilio_ruteo: new (0, $49qEn.EntityColumn)({
            name: 'vc_domicilio_ruteo',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Domicilio Ruteo'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $61f6e507546b900f$var$views = ()=>({
        regt_brwStandard: {
            name: 'regt_brwStandard',
            keyMappings: {
                c_tienda_id: 0
            }
        },
        regt_brwTiendasPorRegion: {
            name: 'regt_brwTiendasPorRegion',
            keyMappings: {
                c_tienda_id: 0
            },
            FiltersEntity: (client, parentKeys)=>new (0, $fEdFq.RegionesTiendasFilters)(client, parentKeys)
        }
    });
const $61f6e507546b900f$var$lookups = ()=>({
        'Regiones': {
            name: 'Regiones',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $gkMhi.Regiones)(client, parentKeys)
        },
        'Areas': {
            name: 'Areas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $iYjhm.Areas)(client, parentKeys)
        },
        'SubAreas': {
            name: 'SubAreas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $7n4Yg.SubAreas)(client, parentKeys)
        },
        'Tiendas': {
            name: 'Tiendas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $6awxZ.Tiendas)(client, parentKeys)
        }
    });
const $61f6e507546b900f$var$procs = ()=>({
        regt_AgregarTienda: {
            name: 'regt_AgregarTienda'
        },
        regt_EliminarTienda: {
            name: 'regt_EliminarTienda'
        }
    });
const $61f6e507546b900f$var$clientActions = ()=>({
        ACTEditarTienda: (0, $5oXCF.ACTEditarTienda)
    });
class $61f6e507546b900f$export$4d82b3c95f9a76b3 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('RegionesTiendas'), this.columns = $61f6e507546b900f$var$columns(), this.views = $61f6e507546b900f$var$views(), this.lookups = $61f6e507546b900f$var$lookups(), this.procs = $61f6e507546b900f$var$procs(), this.clientActions = $61f6e507546b900f$var$clientActions();
    }
}

});
parcelRegister("fEdFq", function(module, exports) {

$parcel$export(module.exports, "RegionesTiendasFilters", () => $4a0faa58fc692145$export$2343fa23672e750a);

var $49qEn = parcelRequire("49qEn");

var $ivoLR = parcelRequire("ivoLR");

var $6w5qB = parcelRequire("6w5qB");
const $4a0faa58fc692145$export$149e426115fbedec = (0, $ivoLR.default);
const $4a0faa58fc692145$export$2d8a4f8f09129f8f = '* Regiones Tiendas.';

class $4a0faa58fc692145$export$2343fa23672e750a extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $6w5qB.RegionesTiendasFiltersDef)(), parentKeys);
        this.Form = (parcelRequire("16R01")).then((module)=>module.RegionesTiendasFiltersForm);
        this.Title = "Regiones Tiendas";
        this.HelpText = $4a0faa58fc692145$export$2d8a4f8f09129f8f;
        this.Icon = $4a0faa58fc692145$export$149e426115fbedec;
    }
}

});
parcelRegister("6w5qB", function(module, exports) {

$parcel$export(module.exports, "RegionesTiendasFiltersDef", () => $3495f7c77f402c0e$export$28172e0dd34b8da1);

var $49qEn = parcelRequire("49qEn");

var $kFypM = parcelRequire("kFypM");

var $aQujn = parcelRequire("aQujn");

var $j8GP5 = parcelRequire("j8GP5");

var $4Rlmx = parcelRequire("4Rlmx");
const $3495f7c77f402c0e$var$columns = ()=>({
        c_pais_id: new (0, $49qEn.EntityColumn)({
            name: 'c_pais_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Pa\xeds"
        }),
        c_provincia_id: new (0, $49qEn.EntityColumn)({
            name: 'c_provincia_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Provincia'
        }),
        c_ciudad_id: new (0, $49qEn.EntityColumn)({
            name: 'c_ciudad_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Ciudad'
        }),
        c_localidad_id: new (0, $49qEn.EntityColumn)({
            name: 'c_localidad_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Localidad'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $3495f7c77f402c0e$var$lookups = ()=>({
        'Paises': {
            name: 'Paises',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $j8GP5.Paises)(client, parentKeys)
        },
        'Provincias': {
            name: 'Provincias',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $4Rlmx.Provincias)(client, parentKeys)
        },
        'Ciudades': {
            name: 'Ciudades',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $kFypM.Ciudades)(client, parentKeys)
        },
        'Localidades': {
            name: 'Localidades',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $aQujn.Localidades)(client, parentKeys)
        }
    });
class $3495f7c77f402c0e$export$28172e0dd34b8da1 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('RegionesTiendasFilters'), this.columns = $3495f7c77f402c0e$var$columns(), this.views = {}, this.lookups = $3495f7c77f402c0e$var$lookups();
    }
}

});

parcelRegister("16R01", function(module, exports) {
module.exports = import("lGlG3").then(()=>parcelRequire('e6QqM'));

});


parcelRegister("7n4Yg", function(module, exports) {

$parcel$export(module.exports, "SubAreas", () => $a6a76078f659199a$export$e73a84481ac3e99);

var $49qEn = parcelRequire("49qEn");

var $51dyQ = parcelRequire("51dyQ");

var $amSx7 = parcelRequire("amSx7");
const $a6a76078f659199a$export$7d75a6c358cbe1e = (0, $51dyQ.default);
const $a6a76078f659199a$export$de14b31e75724bbb = "* Sub \xe1reas para ruteo.";

class $a6a76078f659199a$export$e73a84481ac3e99 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $amSx7.SubAreasDef)(), parentKeys);
        this.Form = (parcelRequire("pyBv6")).then((module)=>module.SubAreasForm);
        this.Title = "Sub Areas";
        this.HelpText = $a6a76078f659199a$export$de14b31e75724bbb;
        this.Icon = $a6a76078f659199a$export$7d75a6c358cbe1e;
    }
}

});
parcelRegister("51dyQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e29cf2de95abb4d7$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $e29cf2de95abb4d7$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M10.828 9.828a4 4 0 1 0 -5.656 0l2.828 2.829l2.828 -2.829z",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M8 7l0 .01",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M18.828 17.828a4 4 0 1 0 -5.656 0l2.828 2.829l2.828 -2.829z",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M16 15l0 .01",
            "key": "svg-3"
        }
    ]
];
const $e29cf2de95abb4d7$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "map-pins", "MapPins", $e29cf2de95abb4d7$export$3efd853dbb351e94);

});

parcelRegister("amSx7", function(module, exports) {

$parcel$export(module.exports, "SubAreasDef", () => $7e85e452f276cf9c$export$81ddfe112ff053a0);

var $49qEn = parcelRequire("49qEn");

var $iYjhm = parcelRequire("iYjhm");

var $gkMhi = parcelRequire("gkMhi");
const $7e85e452f276cf9c$var$columns = ()=>({
        c_region_id: new (0, $49qEn.EntityColumn)({
            name: 'c_region_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Region Id'
        }),
        c_area_id: new (0, $49qEn.EntityColumn)({
            name: 'c_area_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Area Id'
        }),
        c_subarea_id: new (0, $49qEn.EntityColumn)({
            name: 'c_subarea_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PKAutonum,
            prompt: 'Subarea Id'
        }),
        vc_nombre_subarea: new (0, $49qEn.EntityColumn)({
            name: 'vc_nombre_subarea',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Nombre Subarea'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $7e85e452f276cf9c$var$views = ()=>({
        suba_brwStandard: {
            name: 'suba_brwStandard',
            keyMappings: {
                c_subarea_id: 0
            }
        }
    });
const $7e85e452f276cf9c$var$lookups = ()=>({
        'Areas': {
            name: 'Areas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $iYjhm.Areas)(client, parentKeys)
        },
        'Regiones': {
            name: 'Regiones',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $gkMhi.Regiones)(client, parentKeys)
        }
    });
class $7e85e452f276cf9c$export$81ddfe112ff053a0 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('SubAreas'), this.columns = $7e85e452f276cf9c$var$columns(), this.views = $7e85e452f276cf9c$var$views(), this.lookups = $7e85e452f276cf9c$var$lookups();
    }
}

});

parcelRegister("pyBv6", function(module, exports) {
module.exports = import("jFhDc").then(()=>parcelRequire('jLKVh'));

});


parcelRegister("5oXCF", function(module, exports) {

$parcel$export(module.exports, "ACTEditarTienda", () => $3ffd8e25e5ecc03b$export$3eca86a7cb7264d1);

var $ayMG0 = parcelRequire("ayMG0");

var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $6awxZ = parcelRequire("6awxZ");
const $3ffd8e25e5ecc03b$export$3eca86a7cb7264d1 = {
    name: 'ACTEditarTienda',
    label: 'Editar Tienda',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Editar Tienda"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    minSelectedRecords: 1,
    maxSelectedRecords: 1,
    views: [
        'regt_brwTiendasPorRegion'
    ],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const tiendas = new (0, $6awxZ.Tiendas)(entity.API.client);
        tiendas.def.columns.c_tienda_id.value = selectedKeys[0].c_tienda_id || '';
        await (0, $49qEn.openEntityForm)({
            modals: modal,
            formProps: {
                entity: tiendas,
                initialFormMode: 'edit',
                getDataOnInit: true
            },
            modalFormSize: 'xl',
            handleModalSaved: async ()=>{
                await modal.close();
                if (onClose) await onClose();
            },
            handleModalCancel: async ()=>{
                await modal.close();
                if (onClose) await onClose();
            }
        });
        return false;
    }
};

});





parcelRegister("74y8G", function(module, exports) {
module.exports = import("87s3Q").then(()=>parcelRequire('c8zUB'));

});



parcelRegister("icPJq", function(module, exports) {
module.exports = import("isWP6").then(()=>parcelRequire('cmUqB'));

});


parcelRegister("6dHUT", function(module, exports) {

$parcel$export(module.exports, "TiendasFilters", () => $93ad665d0c29b32a$export$349c4120c90ff467);

var $49qEn = parcelRequire("49qEn");

var $f4edX = parcelRequire("f4edX");

class $93ad665d0c29b32a$export$349c4120c90ff467 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $f4edX.TiendasFiltersDef)(), parentKeys);
        super.Form = (parcelRequire("9bZMR")).then((module)=>module.TiendasFiltersForm);
        this.Title = "Filtros";
    }
}

});
parcelRegister("f4edX", function(module, exports) {

$parcel$export(module.exports, "TiendasFiltersDef", () => $a0cee9522df1d2cb$export$26ddf99c946828a7);

var $49qEn = parcelRequire("49qEn");

var $SKbb0 = parcelRequire("SKbb0");

var $6TYT5 = parcelRequire("6TYT5");

var $5kp3N = parcelRequire("5kp3N");

var $kFypM = parcelRequire("kFypM");

var $aQujn = parcelRequire("aQujn");

var $j8GP5 = parcelRequire("j8GP5");

var $4Rlmx = parcelRequire("4Rlmx");
const $a0cee9522df1d2cb$var$columns = ()=>({
        c_pais_id: new (0, $49qEn.EntityColumn)({
            name: 'c_pais_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Pa\xeds"
        }),
        c_provincia_id: new (0, $49qEn.EntityColumn)({
            name: 'c_provincia_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Provincia'
        }),
        c_ciudad_id: new (0, $49qEn.EntityColumn)({
            name: 'c_ciudad_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Ciudad'
        }),
        c_localidad_id: new (0, $49qEn.EntityColumn)({
            name: 'c_localidad_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Localidad'
        }),
        vc_cadenas: new (0, $49qEn.EntityColumn)({
            name: 'vc_cadenas',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Cadenas',
            isArray: true
        }),
        vc_canales: new (0, $49qEn.EntityColumn)({
            name: 'vc_canales',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Canales',
            isArray: true
        }),
        c_activo_id: new (0, $49qEn.EntityColumn)({
            name: 'c_activo_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Estado'
        })
    });
const $a0cee9522df1d2cb$var$lookups = ()=>({
        'Activo': {
            name: 'Activo',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $5kp3N.estActivo)(client, parentKeys)
        },
        'Cadenas': {
            name: 'Cadenas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $SKbb0.Cadenas)(client, parentKeys)
        },
        'Canales': {
            name: 'Canales',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $6TYT5.catCanales)(client, parentKeys)
        },
        'Paises': {
            name: 'Paises',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $j8GP5.Paises)(client, parentKeys)
        },
        'Provincias': {
            name: 'Provincias',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $4Rlmx.Provincias)(client, parentKeys)
        },
        'Ciudades': {
            name: 'Ciudades',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $kFypM.Ciudades)(client, parentKeys)
        },
        'Localidades': {
            name: 'Localidades',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $aQujn.Localidades)(client, parentKeys)
        }
    });
class $a0cee9522df1d2cb$export$26ddf99c946828a7 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('TiendasFilters'), this.columns = $a0cee9522df1d2cb$var$columns(), this.views = {}, this.lookups = $a0cee9522df1d2cb$var$lookups();
    }
}

});

parcelRegister("9bZMR", function(module, exports) {
module.exports = import("fyzCP").then(()=>parcelRequire('98e7q'));

});



parcelRegister("8MlKq", function(module, exports) {
module.exports = import("1Jey3").then(()=>parcelRequire('2ywBd'));

});



parcelRegister("jSEQJ", function(module, exports) {
module.exports = import("5FW2X").then(()=>parcelRequire('lezDO'));

});


parcelRegister("37S53", function(module, exports) {

$parcel$export(module.exports, "AppSupervisorPersonalFilters", () => $4ba54d8ee5c32a6c$export$46a106dbd4497276);

var $49qEn = parcelRequire("49qEn");

var $5Ue5f = parcelRequire("5Ue5f");

var $dmBBe = parcelRequire("dmBBe");
const $4ba54d8ee5c32a6c$export$89a61cf19d32f927 = (0, $5Ue5f.default);
const $4ba54d8ee5c32a6c$export$6c49bc26998b375e = '* AppSupervisor.';

class $4ba54d8ee5c32a6c$export$46a106dbd4497276 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $dmBBe.AppSupervisorPersonalFiltersDef)(), parentKeys);
        this.Form = (parcelRequire("50dxp")).then((module)=>module.AppSupervisorPersonalFiltersForm);
        this.Title = "AppSupervisor";
        this.HelpText = $4ba54d8ee5c32a6c$export$6c49bc26998b375e;
        this.Icon = $4ba54d8ee5c32a6c$export$89a61cf19d32f927;
    }
}

});
parcelRegister("dmBBe", function(module, exports) {

$parcel$export(module.exports, "AppSupervisorPersonalFiltersDef", () => $c2f38561af340eca$export$ec1d44e244fa69a0);

var $49qEn = parcelRequire("49qEn");

var $kFypM = parcelRequire("kFypM");

var $aQujn = parcelRequire("aQujn");

var $j8GP5 = parcelRequire("j8GP5");

var $4Rlmx = parcelRequire("4Rlmx");

var $7LP39 = parcelRequire("7LP39");

var $a4nBq = parcelRequire("a4nBq");
const $c2f38561af340eca$var$columns = ()=>({
        c_pais_id: new (0, $49qEn.EntityColumn)({
            name: 'c_pais_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Pa\xeds"
        }),
        c_provincia_id: new (0, $49qEn.EntityColumn)({
            name: 'c_provincia_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Provincia'
        }),
        c_ciudad_id: new (0, $49qEn.EntityColumn)({
            name: 'c_ciudad_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Ciudad'
        }),
        c_localidad_id: new (0, $49qEn.EntityColumn)({
            name: 'c_localidad_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Localidad'
        }),
        vc_puestos: new (0, $49qEn.EntityColumn)({
            name: 'vc_puestos',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Puestos',
            isArray: true
        }),
        vc_personal: new (0, $49qEn.EntityColumn)({
            name: 'vc_personal',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Personal',
            isArray: true
        }),
        vc_supervision: new (0, $49qEn.EntityColumn)({
            name: 'vc_supervision',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Supervisi\xf3n",
            isArray: true
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $c2f38561af340eca$var$lookups = ()=>({
        'Paises': {
            name: 'Paises',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $j8GP5.Paises)(client, parentKeys)
        },
        'Provincias': {
            name: 'Provincias',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $4Rlmx.Provincias)(client, parentKeys)
        },
        'Ciudades': {
            name: 'Ciudades',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $kFypM.Ciudades)(client, parentKeys)
        },
        'Localidades': {
            name: 'Localidades',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $aQujn.Localidades)(client, parentKeys)
        },
        'Puestos': {
            name: 'Puestos',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $a4nBq.PuestosTrabajo)(client, parentKeys)
        },
        'Personal': {
            name: 'Personal',
            view: 'perl_brwStandard',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $7LP39.Personal)(client, parentKeys)
        },
        'Supervision': {
            name: 'Supervision',
            view: 'perl_brwStandard',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $7LP39.Personal)(client, parentKeys)
        }
    });
class $c2f38561af340eca$export$ec1d44e244fa69a0 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('AppSupervisorPersonalFilters'), this.columns = $c2f38561af340eca$var$columns(), this.views = {}, this.lookups = $c2f38561af340eca$var$lookups();
    }
}

});

parcelRegister("50dxp", function(module, exports) {
module.exports = import("fEaM8").then(()=>parcelRequire('fGvaf'));

});


parcelRegister("2jdBt", function(module, exports) {

$parcel$export(module.exports, "ACTVerPersonalTienda", () => $ac20990fdbae231b$export$51307592b3d78d06);

var $ayMG0 = parcelRequire("ayMG0");

var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");
const $ac20990fdbae231b$export$51307592b3d78d06 = {
    name: 'ACTVerPersonalTienda',
    label: 'Ver Personal',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Ver Personal"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    showActionInViewMode: true,
    views: [
        'apsp_brwTiendas'
    ],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const parent = entity;
        parent.def.columns.c_tienda_id.value = selectedKeys[0].c_tienda_id || '';
        await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                            size: "1.5rem",
                            stroke: "1.5"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            fw: "700",
                            children: "Personal"
                        })
                    ]
                }),
                size: "xl"
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: entity.API.client,
                entityConstructor: ()=>parent,
                formMode: "edit",
                viewName: "apsp_brwTiendasPersonal",
                refreshOnInit: true,
                enableAdd: false,
                enableDelete: false,
                enableEdit: false,
                enableView: false,
                title: "Ver Personal",
                selectionMode: "single"
            }, "personal-tienda")
        });
        return false;
    }
};

});

parcelRegister("lC6NH", function(module, exports) {

$parcel$export(module.exports, "ACTVerReportesPersonal", () => $a2dd9c16829228f1$export$389dafbb69870e8f);

var $ayMG0 = parcelRequire("ayMG0");

var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");

var $ieRws = parcelRequire("ieRws");

var $4ELnk = parcelRequire("4ELnk");
const $a2dd9c16829228f1$export$389dafbb69870e8f = {
    name: 'ACTVerReportesPersonal',
    label: 'Ver Reportes Personal',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Ver Reportes"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    showActionInViewMode: true,
    views: [
        ''
    ],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const parent = entity;
        const datos = new (0, $ieRws.DatosServiciosAutorizacion)(entity.API.client);
        datos.parentKeys = parent.parentKeys;
        datos.def.columns.c_personal_id.value = selectedKeys[0].c_personal_id || '';
        await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                            size: "1.5rem",
                            stroke: "1.5"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            fw: "700",
                            children: "Reportes"
                        })
                    ]
                }),
                size: "xl"
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataViewPage), {
                client: entity.API.client,
                entityConstructor: ()=>datos,
                viewName: "dasa_brwAutorizacionPorPersonal",
                refreshOnInit: true,
                enableAdd: false,
                enableDelete: false,
                enableEdit: false,
                enableView: true,
                selectionMode: "single",
                Card: (0, $4ELnk.DatosServiciosAutorizacionCard)
            }, "reportes-personal")
        });
        return false;
    }
};

});
parcelRegister("ieRws", function(module, exports) {

$parcel$export(module.exports, "DatosServiciosAutorizacion", () => $eb661c079b968641$export$ea77f67a5a3d0060);

var $49qEn = parcelRequire("49qEn");

var $35ntO = parcelRequire("35ntO");

var $4M4ef = parcelRequire("4M4ef");
const $eb661c079b968641$export$5f5157b8697a5985 = (0, $35ntO.default);
const $eb661c079b968641$export$1155456aa744427a = "* Datos Servicios Autorizaci\xf3n";

class $eb661c079b968641$export$ea77f67a5a3d0060 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $4M4ef.DatosServiciosAutorizacionDef)(), parentKeys);
        this.Form = (parcelRequire("e1Ond")).then((module)=>module.DatosServiciosAutorizacionForm);
        this.Title = "Autorizaci\xf3n de Reportes";
        this.HelpText = $eb661c079b968641$export$1155456aa744427a;
        this.Icon = $eb661c079b968641$export$5f5157b8697a5985;
    }
}

});
parcelRegister("4M4ef", function(module, exports) {

$parcel$export(module.exports, "DatosServiciosAutorizacionDef", () => $a5ba4e6c7f833da8$export$667547b64059f4b7);

var $49qEn = parcelRequire("49qEn");

var $9u8qf = parcelRequire("9u8qf");

var $7LP39 = parcelRequire("7LP39");

var $4usKR = parcelRequire("4usKR");

var $1OscC = parcelRequire("1OscC");

var $nttT0 = parcelRequire("nttT0");

var $6awxZ = parcelRequire("6awxZ");

var $5d2w1 = parcelRequire("5d2w1");

var $aBF3V = parcelRequire("aBF3V");

var $2rehK = parcelRequire("2rehK");

var $4vr9w = parcelRequire("4vr9w");

var $8zOb7 = parcelRequire("8zOb7");

var $juxlT = parcelRequire("juxlT");

var $6Ckc5 = parcelRequire("6Ckc5");

var $6r6d1 = parcelRequire("6r6d1");

var $bRKh1 = parcelRequire("bRKh1");
const $a5ba4e6c7f833da8$var$columns = ()=>({
        c_visita_id: new (0, $49qEn.EntityColumn)({
            name: 'c_visita_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PKAutonum | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Visita Id'
        }),
        c_datos_servicio_id: new (0, $49qEn.EntityColumn)({
            name: 'c_datos_servicio_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Datos Servicio Id'
        }),
        c_datos_servicio_registro_id: new (0, $49qEn.EntityColumn)({
            name: 'c_datos_servicio_registro_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Datos Servicio Registro Id'
        }),
        c_servicio_id: new (0, $49qEn.EntityColumn)({
            name: 'c_servicio_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Servicio Id'
        }),
        c_paso_id: new (0, $49qEn.EntityColumn)({
            name: 'c_paso_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Paso Id'
        }),
        c_tienda_id: new (0, $49qEn.EntityColumn)({
            name: 'c_tienda_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Tienda Id'
        }),
        c_producto_id: new (0, $49qEn.EntityColumn)({
            name: 'c_producto_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Producto Id'
        }),
        c_cliente_id: new (0, $49qEn.EntityColumn)({
            name: 'c_cliente_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Cliente Id'
        }),
        c_personal_id: new (0, $49qEn.EntityColumn)({
            name: 'c_personal_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Personal Id'
        }),
        c_relevamiento_status_id: new (0, $49qEn.EntityColumn)({
            name: 'c_relevamiento_status_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Relevamiento Status Id'
        }),
        c_autorizacion_directa_status_id: new (0, $49qEn.EntityColumn)({
            name: 'c_autorizacion_directa_status_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Autorizacion Directa Status Id'
        }),
        dt_fecha_hora_realizado: new (0, $49qEn.EntityColumn)({
            name: 'dt_fecha_hora_realizado',
            type: 'datetime',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Fecha Hora Realizado'
        }),
        vc_clientes: new (0, $49qEn.EntityColumn)({
            name: 'vc_clientes',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Clientes'
        }),
        vc_productos: new (0, $49qEn.EntityColumn)({
            name: 'vc_productos',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Productos'
        }),
        vc_servicios: new (0, $49qEn.EntityColumn)({
            name: 'vc_servicios',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Servicios'
        }),
        vc_imagenes: new (0, $49qEn.EntityColumn)({
            name: 'vc_imagenes',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Im\xe1genes"
        }),
        vc_imagenes_observaciones: new (0, $49qEn.EntityColumn)({
            name: 'vc_imagenes_observaciones',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Im\xe1genes Observaciones"
        }),
        c_persona_id: new (0, $49qEn.EntityColumn)({
            name: 'c_persona_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Persona Id'
        }),
        vc_numerodni: new (0, $49qEn.EntityColumn)({
            name: 'vc_numerodni',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'DNI'
        }),
        vc_nombre: new (0, $49qEn.EntityColumn)({
            name: 'vc_nombre',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Nombre'
        }),
        vc_apellido: new (0, $49qEn.EntityColumn)({
            name: 'vc_apellido',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Apellido'
        }),
        vc_puestotrabajo: new (0, $49qEn.EntityColumn)({
            name: 'vc_puestotrabajo',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Puesto'
        }),
        dt_nacimiento: new (0, $49qEn.EntityColumn)({
            name: 'dt_nacimiento',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Nacimiento'
        }),
        vc_genero: new (0, $49qEn.EntityColumn)({
            name: 'vc_genero',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "G\xe9nero"
        }),
        vc_fotoguid: new (0, $49qEn.EntityColumn)({
            name: 'vc_fotoguid',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Foto URL'
        }),
        vc_superior: new (0, $49qEn.EntityColumn)({
            name: 'vc_superior',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Superior'
        }),
        vc_telefono: new (0, $49qEn.EntityColumn)({
            name: 'vc_telefono',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Tel\xe9fono"
        }),
        vc_celular: new (0, $49qEn.EntityColumn)({
            name: 'vc_celular',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Celular'
        }),
        vc_celular_trabajo: new (0, $49qEn.EntityColumn)({
            name: 'vc_celular_trabajo',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Celular Trabajo'
        }),
        vc_telefono_alternativo: new (0, $49qEn.EntityColumn)({
            name: 'vc_telefono_alternativo',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Tel\xe9fono Alternativo"
        }),
        vc_email: new (0, $49qEn.EntityColumn)({
            name: 'vc_email',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Email'
        }),
        vc_email_alternativo: new (0, $49qEn.EntityColumn)({
            name: 'vc_email_alternativo',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Email Alternativo'
        }),
        f_latitud: new (0, $49qEn.EntityColumn)({
            name: 'f_latitud',
            type: 'float',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Latitud'
        }),
        f_longitud: new (0, $49qEn.EntityColumn)({
            name: 'f_longitud',
            type: 'float',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Longitud'
        }),
        vc_domicilio_completo: new (0, $49qEn.EntityColumn)({
            name: 'vc_domicilio_completo',
            type: 'varchar',
            length: 2048,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Domicilio Completo'
        }),
        n_total_horas_semanales: new (0, $49qEn.EntityColumn)({
            name: 'n_total_horas_semanales',
            type: 'decimal',
            scale: 2,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Total Horas Semanales'
        }),
        n_horas_semanales_disponibles: new (0, $49qEn.EntityColumn)({
            name: 'n_horas_semanales_disponibles',
            type: 'decimal',
            scale: 2,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Horas Semanales Disponibles'
        }),
        n_horas_semanales_compartidas: new (0, $49qEn.EntityColumn)({
            name: 'n_horas_semanales_compartidas',
            type: 'decimal',
            scale: 2,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Horas Semanales Compartidas'
        }),
        n_horas_semanales_exclusivas: new (0, $49qEn.EntityColumn)({
            name: 'n_horas_semanales_exclusivas',
            type: 'decimal',
            scale: 2,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Horas Semanales Exclusivas'
        }),
        dt_fecha_baja: new (0, $49qEn.EntityColumn)({
            name: 'dt_fecha_baja',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Fecha Baja'
        }),
        dt_fecha_alta: new (0, $49qEn.EntityColumn)({
            name: 'dt_fecha_alta',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Fecha Alta'
        }),
        dt_licencia_desde: new (0, $49qEn.EntityColumn)({
            name: 'dt_licencia_desde',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Licencia Desde'
        }),
        dt_licencia_hasta: new (0, $49qEn.EntityColumn)({
            name: 'dt_licencia_hasta',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Licencia Hasta'
        }),
        c_estado_licencia_id: new (0, $49qEn.EntityColumn)({
            name: 'c_estado_licencia_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Estado Licencia Id'
        }),
        vc_nombre_tienda: new (0, $49qEn.EntityColumn)({
            name: 'vc_nombre_tienda',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Nombre'
        }),
        bt_checkin: new (0, $49qEn.EntityColumn)({
            name: 'bt_checkin',
            type: 'bit',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Checkin'
        }),
        bt_checkout: new (0, $49qEn.EntityColumn)({
            name: 'bt_checkout',
            type: 'bit',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Checkout'
        }),
        d_fecha_visita: new (0, $49qEn.EntityColumn)({
            name: 'd_fecha_visita',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Fecha Visita'
        }),
        t_hora_desde: new (0, $49qEn.EntityColumn)({
            name: 't_hora_desde',
            type: 'time',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Hora Desde'
        }),
        t_hora_hasta: new (0, $49qEn.EntityColumn)({
            name: 't_hora_hasta',
            type: 'time',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Hora Hasta'
        }),
        vc_observaciones_visita: new (0, $49qEn.EntityColumn)({
            name: 'vc_observaciones_visita',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Observaciones Visita'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $a5ba4e6c7f833da8$var$views = ()=>({
        dasa_brwStandard: {
            name: 'dasa_brwStandard',
            keyMappings: {
                c_datos_servicio_id: 0
            }
        },
        dasa_brwAutorizacion: {
            name: 'dasa_brwAutorizacion',
            keyMappings: {
                c_datos_servicio_id: 1
            },
            FiltersEntity: (client, parentKeys)=>new (0, $5d2w1.DatosServiciosAutorizacionFilters)(client, parentKeys)
        },
        dasa_brwAutorizacionProductos: {
            name: 'dasa_brwAutorizacionProductos',
            keyMappings: {
                c_datos_servicio_id: 0
            }
        },
        dasa_brwAutorizacionPorPersonal: {
            name: 'dasa_brwAutorizacionPorPersonal',
            keyMappings: {
                c_datos_servicio_id: 0
            }
        },
        dasa_brwAutorizacionPorTienda: {
            name: 'dasa_brwAutorizacionPorTienda',
            keyMappings: {
                c_datos_servicio_id: 0
            }
        },
        dasa_brwAutorizacionCliente: {
            name: 'dasa_brwAutorizacionCliente',
            keyMappings: {
                c_visita_id: 0
            },
            FiltersEntity: (client, parentKeys)=>new (0, $5d2w1.DatosServiciosAutorizacionFilters)(client, parentKeys)
        },
        dasa_brwGestionReportes: {
            name: 'dasa_brwGestionReportes',
            keyMappings: {
                c_visita_id: 11
            },
            gridColumnsOverrides: (0, $bRKh1.GestionReportesViewColumnsOverrides),
            FiltersEntity: (client, parentKeys)=>new (0, $2rehK.DatosServiciosAutorizacionReportesFilters)(client, parentKeys)
        },
        dasa_brwGestionReportesVisitasIniciadas: {
            name: 'dasa_brwGestionReportesVisitasIniciadas',
            keyMappings: {
                c_visita_id: 12,
                c_personal_id: 13
            },
            gridColumnsOverrides: (0, $bRKh1.GestionReportesViewColumnsOverrides),
            FiltersEntity: (client, parentKeys)=>new (0, $2rehK.DatosServiciosAutorizacionReportesFilters)(client, parentKeys)
        },
        dasa_brwGestionReportesVisitasEnProceso: {
            name: 'dasa_brwGestionReportesVisitasEnProceso',
            keyMappings: {
                c_visita_id: 12,
                c_personal_id: 13
            },
            gridColumnsOverrides: (0, $bRKh1.GestionReportesViewColumnsOverrides),
            FiltersEntity: (client, parentKeys)=>new (0, $2rehK.DatosServiciosAutorizacionReportesFilters)(client, parentKeys)
        },
        dasa_brwGestionReportesVisitasFinalizadas: {
            name: 'dasa_brwGestionReportesVisitasFinalizadas',
            keyMappings: {
                c_visita_id: 12,
                c_personal_id: 13
            },
            gridColumnsOverrides: (0, $bRKh1.GestionReportesViewColumnsOverrides),
            FiltersEntity: (client, parentKeys)=>new (0, $2rehK.DatosServiciosAutorizacionReportesFilters)(client, parentKeys)
        },
        dasa_brwGestionReportesVisitasIniciadasAppSupervisor: {
            name: 'dasa_brwGestionReportesVisitasIniciadasAppSupervisor',
            keyMappings: {
                c_visita_id: 12,
                c_personal_id: 13
            },
            gridColumnsOverrides: (0, $bRKh1.GestionReportesViewColumnsOverrides),
            FiltersEntity: (client, parentKeys)=>new (0, $aBF3V.DatosServiciosAutorizacionReportesAppSupervisorFilters)(client, parentKeys)
        },
        dasa_brwGestionReportesVisitasEnProcesoAppSupervisor: {
            name: 'dasa_brwGestionReportesVisitasEnProcesoAppSupervisor',
            keyMappings: {
                c_visita_id: 12,
                c_personal_id: 13
            },
            gridColumnsOverrides: (0, $bRKh1.GestionReportesViewColumnsOverrides),
            FiltersEntity: (client, parentKeys)=>new (0, $aBF3V.DatosServiciosAutorizacionReportesAppSupervisorFilters)(client, parentKeys)
        },
        dasa_brwGestionReportesVisitasFinalizadasAppSupervisor: {
            name: 'dasa_brwGestionReportesVisitasFinalizadasAppSupervisor',
            keyMappings: {
                c_visita_id: 12,
                c_personal_id: 13
            },
            gridColumnsOverrides: (0, $bRKh1.GestionReportesViewColumnsOverrides),
            FiltersEntity: (client, parentKeys)=>new (0, $aBF3V.DatosServiciosAutorizacionReportesAppSupervisorFilters)(client, parentKeys)
        }
    });
const $a5ba4e6c7f833da8$var$lookups = ()=>({
        'ServiciosConfiguracion': {
            name: 'ServiciosConfiguracion',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $nttT0.ServiciosConfiguracion)(client, parentKeys)
        },
        'Productos': {
            name: 'Productos',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $4usKR.Productos)(client, parentKeys)
        },
        'Tiendas': {
            name: 'Tiendas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $6awxZ.Tiendas)(client, parentKeys)
        },
        'Clientes': {
            name: 'Clientes',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $9u8qf.Clientes)(client, parentKeys)
        },
        'Personal': {
            name: 'Personal',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $7LP39.Personal)(client, parentKeys)
        },
        'VisitasATiendas': {
            name: 'VisitasATiendas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $1OscC.VisitasATiendas)(client, parentKeys)
        }
    });
const $a5ba4e6c7f833da8$var$procs = ()=>({
        dasa_AutorizarReporte: {
            name: 'dasa_AutorizarReporte'
        }
    });
const $a5ba4e6c7f833da8$var$clientActions = ()=>({
        ACTAutorizarReporte: (0, $8zOb7.ACTAutorizarReporte),
        ACTAgregarReporte: (0, $4vr9w.ACTAgregarReporte),
        ACTCheckin: (0, $juxlT.ACTCheckin),
        ACTCheckout: (0, $6Ckc5.ACTCheckout),
        ACTVerUbicacion: (0, $6r6d1.ACTVerUbicacion)
    });
class $a5ba4e6c7f833da8$export$667547b64059f4b7 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('DatosServiciosAutorizacion'), this.columns = $a5ba4e6c7f833da8$var$columns(), this.views = $a5ba4e6c7f833da8$var$views(), this.lookups = $a5ba4e6c7f833da8$var$lookups(), this.procs = $a5ba4e6c7f833da8$var$procs(), this.clientActions = $a5ba4e6c7f833da8$var$clientActions();
    }
}

});
parcelRegister("4usKR", function(module, exports) {

$parcel$export(module.exports, "ProductosIcon", () => $35801b5c51f0565b$export$ade738819f2befdd);
$parcel$export(module.exports, "ProductosHelpText", () => $35801b5c51f0565b$export$b005be8ee5b699e6);
$parcel$export(module.exports, "Productos", () => $35801b5c51f0565b$export$2277ddc1f9d5a932);

var $49qEn = parcelRequire("49qEn");

var $jWD6w = parcelRequire("jWD6w");

var $6Cgy9 = parcelRequire("6Cgy9");
const $35801b5c51f0565b$export$ade738819f2befdd = (0, $jWD6w.default);
const $35801b5c51f0565b$export$b005be8ee5b699e6 = "* Ingrese aqu\xed los productos";

class $35801b5c51f0565b$export$2277ddc1f9d5a932 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $6Cgy9.ProductosDef)(), parentKeys);
        this.Form = (parcelRequire("hhDaM")).then((module)=>module.ProductosForm);
        this.Title = "Productos";
        this.HelpText = $35801b5c51f0565b$export$b005be8ee5b699e6;
        this.Icon = $35801b5c51f0565b$export$ade738819f2befdd;
    }
}

});
parcelRegister("jWD6w", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5d90e1eaea9575c$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $e5d90e1eaea9575c$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M7 16.5l-5 -3l5 -3l5 3v5.5l-5 3z",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M2 13.5v5.5l5 3",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M7 16.545l5 -3.03",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M17 16.5l-5 -3l5 -3l5 3v5.5l-5 3z",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M12 19l5 3",
            "key": "svg-4"
        }
    ],
    [
        "path",
        {
            "d": "M17 16.5l5 -3",
            "key": "svg-5"
        }
    ],
    [
        "path",
        {
            "d": "M12 13.5v-5.5l-5 -3l5 -3l5 3v5.5",
            "key": "svg-6"
        }
    ],
    [
        "path",
        {
            "d": "M7 5.03v5.455",
            "key": "svg-7"
        }
    ],
    [
        "path",
        {
            "d": "M12 8l5 -3",
            "key": "svg-8"
        }
    ]
];
const $e5d90e1eaea9575c$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "packages", "Packages", $e5d90e1eaea9575c$export$3efd853dbb351e94);

});

parcelRegister("6Cgy9", function(module, exports) {

$parcel$export(module.exports, "ProductosDef", () => $c3a96907b12755f8$export$20396f3cd98e2104);

var $49qEn = parcelRequire("49qEn");

var $kEjqx = parcelRequire("kEjqx");

var $45za5 = parcelRequire("45za5");

var $lMr9U = parcelRequire("lMr9U");
const $c3a96907b12755f8$var$columns = ()=>({
        c_producto_id: new (0, $49qEn.EntityColumn)({
            name: 'c_producto_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PKAutonum,
            prompt: 'Producto ID'
        }),
        c_fileprocess_id: new (0, $49qEn.EntityColumn)({
            name: 'c_fileprocess_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Fileprocess Id'
        }),
        vc_codigoproducto: new (0, $49qEn.EntityColumn)({
            name: 'vc_codigoproducto',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: "C\xf3digo interno"
        }),
        vc_codigobarras: new (0, $49qEn.EntityColumn)({
            name: 'vc_codigobarras',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: "C\xf3digo de barras"
        }),
        vc_nombre: new (0, $49qEn.EntityColumn)({
            name: 'vc_nombre',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Nombre'
        }),
        vc_nombrecorto: new (0, $49qEn.EntityColumn)({
            name: 'vc_nombrecorto',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Nombre corto'
        }),
        vc_GTIN8: new (0, $49qEn.EntityColumn)({
            name: 'vc_GTIN8',
            type: 'varchar',
            length: 8,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'GTIN8'
        }),
        vc_EAN13: new (0, $49qEn.EntityColumn)({
            name: 'vc_EAN13',
            type: 'varchar',
            length: 13,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'EAN13'
        }),
        vc_UPCA: new (0, $49qEn.EntityColumn)({
            name: 'vc_UPCA',
            type: 'varchar',
            length: 12,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'UPCA'
        }),
        vc_DUN14: new (0, $49qEn.EntityColumn)({
            name: 'vc_DUN14',
            type: 'varchar',
            length: 14,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'DUN14'
        }),
        vc_GS1128: new (0, $49qEn.EntityColumn)({
            name: 'vc_GS1128',
            type: 'varchar',
            length: 128,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'GS1-128'
        }),
        n_precio: new (0, $49qEn.EntityColumn)({
            name: 'n_precio',
            type: 'decimal',
            length: 14,
            scale: 2,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Precio'
        }),
        vc_peso: new (0, $49qEn.EntityColumn)({
            name: 'vc_peso',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Peso'
        }),
        vc_medida: new (0, $49qEn.EntityColumn)({
            name: 'vc_medida',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Medida'
        }),
        vc_unidadesxbulto: new (0, $49qEn.EntityColumn)({
            name: 'vc_unidadesxbulto',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Unidades'
        }),
        c_tipocodigobarra_id: new (0, $49qEn.EntityColumn)({
            name: 'c_tipocodigobarra_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Tipo'
        }),
        vc_gruposproducto: new (0, $49qEn.EntityColumn)({
            name: 'vc_gruposproducto',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Grupos',
            isArray: true
        }),
        vc_formatosproducto: new (0, $49qEn.EntityColumn)({
            name: 'vc_formatosproducto',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Formatos',
            isArray: true
        }),
        vc_fotoguid: new (0, $49qEn.EntityColumn)({
            name: 'vc_fotoguid',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Fotoguid'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $c3a96907b12755f8$var$views = ()=>({
        prdc_brwStandard: {
            name: 'prdc_brwStandard',
            keyMappings: {
                c_producto_id: 0
            }
        }
    });
const $c3a96907b12755f8$var$lookups = ()=>({
        'FileStoreProcess': {
            name: 'FileStoreProcess',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $49qEn.FileStoreProcess)(client, parentKeys)
        },
        'TiposCodigoBarra': {
            name: 'TiposCodigoBarra',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $lMr9U.catTiposCodigoBarra)(client, parentKeys)
        },
        'GruposProducto': {
            name: 'GruposProducto',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $45za5.catGruposProducto)(client, parentKeys)
        },
        'FormatosDeVenta': {
            name: 'FormatosDeVenta',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $kEjqx.catFormatosDeVenta)(client, parentKeys)
        }
    });
class $c3a96907b12755f8$export$20396f3cd98e2104 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('Productos'), this.columns = $c3a96907b12755f8$var$columns(), this.views = $c3a96907b12755f8$var$views(), this.lookups = $c3a96907b12755f8$var$lookups();
    }
}

});
parcelRegister("kEjqx", function(module, exports) {

$parcel$export(module.exports, "catFormatosDeVenta", () => $dbccc98270577871$export$5840db7042f370ae);

var $49qEn = parcelRequire("49qEn");

var $l9ipQ = parcelRequire("l9ipQ");
const $dbccc98270577871$export$628b56aa188fd17b = (0, $l9ipQ.default);
const $dbccc98270577871$export$bb666344b74462ed = "* Ingrese aqu\xed los formatos de venta para productos";
class $dbccc98270577871$export$5840db7042f370ae extends (0, $49qEn.CategoriesValues) {
    constructor(client, parentKeys = {}){
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "FormatosDeVenta";
        this.def.columns.c_category_id.defaultValue = "FormatosDeVenta";
        this.Title = "Formatos de Venta";
        this.HelpText = $dbccc98270577871$export$bb666344b74462ed;
        this.Icon = $dbccc98270577871$export$628b56aa188fd17b;
    }
}

});

parcelRegister("45za5", function(module, exports) {

$parcel$export(module.exports, "catGruposProducto", () => $893272d50e5d7c65$export$207821c91f6e005a);

var $49qEn = parcelRequire("49qEn");

var $l9ipQ = parcelRequire("l9ipQ");
const $893272d50e5d7c65$export$e1416a3a02bcbac5 = (0, $l9ipQ.default);
const $893272d50e5d7c65$export$67da91b2a5bf7a1a = "* Ingrese aqu\xed los grupos de producto";
class $893272d50e5d7c65$export$207821c91f6e005a extends (0, $49qEn.CategoriesValues) {
    constructor(client, parentKeys = {}){
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "GruposProducto";
        this.def.columns.c_category_id.defaultValue = "GruposProducto";
        this.Title = "Grupos de Producto";
        this.HelpText = $893272d50e5d7c65$export$67da91b2a5bf7a1a;
        this.Icon = $893272d50e5d7c65$export$e1416a3a02bcbac5;
    }
}

});

parcelRegister("lMr9U", function(module, exports) {

$parcel$export(module.exports, "catTiposCodigoBarra", () => $d0c418fa29f9e8b6$export$726cb5357a5c3274);

var $49qEn = parcelRequire("49qEn");

var $30j5V = parcelRequire("30j5V");
const $d0c418fa29f9e8b6$export$f4ad57efaedf00b4 = (0, $30j5V.default);
const $d0c418fa29f9e8b6$export$c2214c0bff24b7e9 = "* Tipos de c\xf3digos de barra";
class $d0c418fa29f9e8b6$export$726cb5357a5c3274 extends (0, $49qEn.CategoriesValues) {
    constructor(client, parentKeys = {}){
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "TiposCodigoBarra";
        this.def.columns.c_category_id.defaultValue = "TiposCodigoBarra";
        this.Title = "Tipos de C\xf3digos de barra";
        this.HelpText = $d0c418fa29f9e8b6$export$c2214c0bff24b7e9;
        this.Icon = $d0c418fa29f9e8b6$export$f4ad57efaedf00b4;
    }
}

});
parcelRegister("30j5V", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b539c3dd211070d$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $4b539c3dd211070d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M4 7v-1a2 2 0 0 1 2 -2h2",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M4 17v1a2 2 0 0 0 2 2h2",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M16 4h2a2 2 0 0 1 2 2v1",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M16 20h2a2 2 0 0 0 2 -2v-1",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M5 11h1v2h-1z",
            "key": "svg-4"
        }
    ],
    [
        "path",
        {
            "d": "M10 11l0 2",
            "key": "svg-5"
        }
    ],
    [
        "path",
        {
            "d": "M14 11h1v2h-1z",
            "key": "svg-6"
        }
    ],
    [
        "path",
        {
            "d": "M19 11l0 2",
            "key": "svg-7"
        }
    ]
];
const $4b539c3dd211070d$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "barcode", "Barcode", $4b539c3dd211070d$export$3efd853dbb351e94);

});



parcelRegister("hhDaM", function(module, exports) {
module.exports = Promise.all([
    import("fqG9h"),
    import("29zL2")
]).then(()=>parcelRequire('hJn0i'));

});


parcelRegister("1OscC", function(module, exports) {

$parcel$export(module.exports, "VisitasATiendas", () => $faa2faf703d3133f$export$203a6f1c0fe08aa1);

var $49qEn = parcelRequire("49qEn");

var $bdzm4 = parcelRequire("bdzm4");

var $ahfJk = parcelRequire("ahfJk");
const $faa2faf703d3133f$export$f7cf96f0a1e26d2e = (0, $bdzm4.default);
const $faa2faf703d3133f$export$1bfa4a2927fd7104 = '* Visitas a Tiendas';

class $faa2faf703d3133f$export$203a6f1c0fe08aa1 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $ahfJk.VisitasATiendasDef)(), parentKeys);
        this.Form = (parcelRequire("5VKBr")).then((module)=>module.VisitasATiendasForm);
        this.Title = "Visitas a Tiendas";
        this.HelpText = $faa2faf703d3133f$export$1bfa4a2927fd7104;
        this.Icon = $faa2faf703d3133f$export$f7cf96f0a1e26d2e;
    }
}

});
parcelRegister("bdzm4", function(module, exports) {

$parcel$export(module.exports, "default", () => $e22d066a1ffa37f6$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $e22d066a1ffa37f6$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M15 19h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4.5",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M19 22v.01",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M3 7l9 6l9 -6",
            "key": "svg-3"
        }
    ]
];
const $e22d066a1ffa37f6$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "mail-question", "MailQuestion", $e22d066a1ffa37f6$export$3efd853dbb351e94);

});

parcelRegister("ahfJk", function(module, exports) {

$parcel$export(module.exports, "VisitasATiendasDef", () => $75612cb5884a61f1$export$c862ac12bb560ae2);

var $49qEn = parcelRequire("49qEn");

var $6awxZ = parcelRequire("6awxZ");

var $eE7f5 = parcelRequire("eE7f5");

var $bs1nm = parcelRequire("bs1nm");

var $h84pQ = parcelRequire("h84pQ");

var $lO02G = parcelRequire("lO02G");

var $aHQIQ = parcelRequire("aHQIQ");
const $75612cb5884a61f1$var$columns = ()=>({
        c_ruta_id: new (0, $49qEn.EntityColumn)({
            name: 'c_ruta_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Ruta Id'
        }),
        c_personal_id: new (0, $49qEn.EntityColumn)({
            name: 'c_personal_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Personal Id'
        }),
        c_tienda_id: new (0, $49qEn.EntityColumn)({
            name: 'c_tienda_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Tienda Id'
        }),
        c_horario_id: new (0, $49qEn.EntityColumn)({
            name: 'c_horario_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Horario Id'
        }),
        c_visita_id: new (0, $49qEn.EntityColumn)({
            name: 'c_visita_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PKAutonum,
            prompt: 'Visita Id'
        }),
        d_fecha_visita: new (0, $49qEn.EntityColumn)({
            name: 'd_fecha_visita',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Fecha Visita'
        }),
        t_hora_desde: new (0, $49qEn.EntityColumn)({
            name: 't_hora_desde',
            type: 'time',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Hora Desde'
        }),
        t_hora_hasta: new (0, $49qEn.EntityColumn)({
            name: 't_hora_hasta',
            type: 'time',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Hora Hasta'
        }),
        vc_observaciones_visita: new (0, $49qEn.EntityColumn)({
            name: 'vc_observaciones_visita',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Observaciones Visita'
        }),
        c_visita_status_id: new (0, $49qEn.EntityColumn)({
            name: 'c_visita_status_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Visita Statud Id'
        }),
        vc_tienda: new (0, $49qEn.EntityColumn)({
            name: 'vc_tienda',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Tienda'
        }),
        vc_personal: new (0, $49qEn.EntityColumn)({
            name: 'vc_personal',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Personal'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $75612cb5884a61f1$var$views = ()=>({
        viti_brwStandard: {
            name: 'viti_brwStandard',
            keyMappings: {
                c_visita_id: 0
            }
        },
        viti_brwVisitasPorSemana: {
            name: 'viti_brwVisitasPorSemana',
            keyMappings: {
                c_visita_id: 0
            },
            FiltersEntity: (client, parentKeys)=>new (0, $eE7f5.VisitasATiendasFilters)(client, parentKeys),
            mapInfoWindowRenderer: (0, $aHQIQ.VisitasPorSemanaViewInfoWindowRenderer)
        },
        viti_brwVisitasPorSemanaPersonal: {
            name: 'viti_brwVisitasPorSemanaPersonal',
            keyMappings: {
                c_personal_id: 0
            },
            mapMarkerRenderer: (0, $lO02G.VisitasPorSemanaPersonalViewMarkerRenderer),
            mapInfoWindowRenderer: (0, $h84pQ.VisitasPorSemanaPersonalViewInfoWindowRenderer)
        }
    });
const $75612cb5884a61f1$var$lookups = ()=>({
        'Tiendas': {
            name: 'Tiendas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 4
            },
            entityConstructor: (client, parentKeys)=>new (0, $6awxZ.Tiendas)(client, parentKeys)
        }
    });
const $75612cb5884a61f1$var$procs = ()=>({
        viti_CancelarVisita: {
            name: 'viti_CancelarVisita'
        }
    });
const $75612cb5884a61f1$var$clientActions = ()=>({
        ACTCancelarVisita: (0, $bs1nm.ACTCancelarVisita)
    });
class $75612cb5884a61f1$export$c862ac12bb560ae2 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('VisitasATiendas'), this.columns = $75612cb5884a61f1$var$columns(), this.views = $75612cb5884a61f1$var$views(), this.lookups = $75612cb5884a61f1$var$lookups(), this.procs = $75612cb5884a61f1$var$procs(), this.clientActions = $75612cb5884a61f1$var$clientActions();
    }
}

});
parcelRegister("eE7f5", function(module, exports) {

$parcel$export(module.exports, "VisitasATiendasFilters", () => $acf8732b72545662$export$24a8206a039dfe92);

var $49qEn = parcelRequire("49qEn");

var $5TQmZ = parcelRequire("5TQmZ");

class $acf8732b72545662$export$24a8206a039dfe92 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $5TQmZ.VisitasATiendasFiltersDef)(), parentKeys);
        this.Form = (parcelRequire("2Y5Xo")).then((module)=>module.VisitasATiendasFiltersForm);
        this.Title = "Filtros de Visitas";
    }
}

});
parcelRegister("5TQmZ", function(module, exports) {

$parcel$export(module.exports, "VisitasATiendasFiltersDef", () => $1bcda3761150062b$export$63883396725e78c0);

var $49qEn = parcelRequire("49qEn");

var $SKbb0 = parcelRequire("SKbb0");

var $6TYT5 = parcelRequire("6TYT5");

var $9u8qf = parcelRequire("9u8qf");

var $kFypM = parcelRequire("kFypM");

var $aQujn = parcelRequire("aQujn");

var $j8GP5 = parcelRequire("j8GP5");

var $4Rlmx = parcelRequire("4Rlmx");

var $7LP39 = parcelRequire("7LP39");
const $1bcda3761150062b$var$currentDate = new Date();
const $1bcda3761150062b$var$dayOfWeek = $1bcda3761150062b$var$currentDate.getDay(); // Obtener el día de la semana (0 = Domingo, 1 = Lunes, etc.)
const $1bcda3761150062b$var$startOfWeek = new Date($1bcda3761150062b$var$currentDate); // Clonamos la fecha actual
const $1bcda3761150062b$var$endOfWeek = new Date($1bcda3761150062b$var$currentDate); // Clonamos la fecha actual
const $1bcda3761150062b$var$diffToMonday = ($1bcda3761150062b$var$dayOfWeek === 0 ? -6 : 1) - $1bcda3761150062b$var$dayOfWeek;
$1bcda3761150062b$var$startOfWeek.setDate($1bcda3761150062b$var$currentDate.getDate() + $1bcda3761150062b$var$diffToMonday);
$1bcda3761150062b$var$startOfWeek.setHours(0, 0, 0, 0);
$1bcda3761150062b$var$endOfWeek.setDate($1bcda3761150062b$var$startOfWeek.getDate() + 6);
$1bcda3761150062b$var$endOfWeek.setHours(0, 0, 0, 0);
const $1bcda3761150062b$var$columns = ()=>({
        c_pais_id: new (0, $49qEn.EntityColumn)({
            name: 'c_pais_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Pa\xeds"
        }),
        c_provincia_id: new (0, $49qEn.EntityColumn)({
            name: 'c_provincia_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Provincia'
        }),
        c_ciudad_id: new (0, $49qEn.EntityColumn)({
            name: 'c_ciudad_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Ciudad'
        }),
        c_localidad_id: new (0, $49qEn.EntityColumn)({
            name: 'c_localidad_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Localidad'
        }),
        vc_cadenas: new (0, $49qEn.EntityColumn)({
            name: 'vc_cadenas',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Cadenas',
            isArray: true
        }),
        vc_canales: new (0, $49qEn.EntityColumn)({
            name: 'vc_canales',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Canales',
            isArray: true
        }),
        vc_supervision: new (0, $49qEn.EntityColumn)({
            name: 'vc_supervision',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Supervisi\xf3n",
            isArray: true
        }),
        vc_visitas: new (0, $49qEn.EntityColumn)({
            name: 'vc_visitas',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Visitas',
            isArray: true
        }),
        vc_clientes: new (0, $49qEn.EntityColumn)({
            name: 'vc_clientes',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Clientes',
            isArray: true
        }),
        d_fecha_visita_desde: new (0, $49qEn.EntityColumn)({
            name: 'd_fecha_visita_desde',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Fecha Visita Desde',
            defaultValue: $1bcda3761150062b$var$startOfWeek
        }),
        d_fecha_visita_hasta: new (0, $49qEn.EntityColumn)({
            name: 'd_fecha_visita_hasta',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Fecha Visita Hasta',
            defaultValue: $1bcda3761150062b$var$endOfWeek
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $1bcda3761150062b$var$lookups = ()=>({
        'Cadenas': {
            name: 'Cadenas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $SKbb0.Cadenas)(client, parentKeys)
        },
        'Paises': {
            name: 'Paises',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $j8GP5.Paises)(client, parentKeys)
        },
        'Provincias': {
            name: 'Provincias',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $4Rlmx.Provincias)(client, parentKeys)
        },
        'Ciudades': {
            name: 'Ciudades',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $kFypM.Ciudades)(client, parentKeys)
        },
        'Localidades': {
            name: 'Localidades',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $aQujn.Localidades)(client, parentKeys)
        },
        'Supervision': {
            name: 'Supervision',
            view: 'perl_brwAsignadoATiendas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $7LP39.Personal)(client, parentKeys)
        },
        'Visitas': {
            name: 'Visitas',
            view: 'perl_brwEnRutas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $7LP39.Personal)(client, parentKeys)
        },
        'Canales': {
            name: 'Canales',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $6TYT5.catCanales)(client, parentKeys)
        },
        'Clientes': {
            name: 'Clientes',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 2
            },
            entityConstructor: (client, parentKeys)=>new (0, $9u8qf.Clientes)(client, parentKeys)
        }
    });
class $1bcda3761150062b$export$63883396725e78c0 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('VisitasATiendasFilters'), this.columns = $1bcda3761150062b$var$columns(), this.views = {}, this.lookups = $1bcda3761150062b$var$lookups();
    }
}

});

parcelRegister("2Y5Xo", function(module, exports) {
module.exports = import("8etC5").then(()=>parcelRequire('04gqz'));

});


parcelRegister("bs1nm", function(module, exports) {

$parcel$export(module.exports, "ACTCancelarVisita", () => $ecd70590c034a404$export$424913f6c4081bf3);

var $ayMG0 = parcelRequire("ayMG0");

var $gU5rH = parcelRequire("gU5rH");
var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");
const $ecd70590c034a404$export$424913f6c4081bf3 = {
    name: 'ACTCancelarVisita',
    label: 'Cancelar Visita',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Cancelar Visita"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    showActionInViewMode: true,
    views: [
        'viti_brwVisitasPorSemana'
    ],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const visita = entity;
        const procParms = {
            c_visita_id: selectedKeys?.[0]?.['c_visita_id'] ?? ''
        };
        let errores = '';
        if (!procParms.c_visita_id) errores = "Los registros seleccionados son inv\xe1lidos";
        if (errores) await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                            size: "1.5rem",
                            stroke: "1.5"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            fw: "700",
                            children: "ERROR"
                        })
                    ]
                })
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        size: "sm",
                        mb: "xs",
                        children: errores
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                        mt: "xs",
                        position: "right",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                            onClick: async ()=>await modal.close(),
                            children: "Cerrar"
                        })
                    })
                ]
            })
        });
        else {
            const abort_controller = new AbortController();
            await modal.open({
                modalProps: {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        fw: "700",
                        children: "Cancelar Visita"
                    })
                },
                focusOnClosed: element,
                content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.ConfirmAndExecutePanel), {
                    content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        size: "sm",
                        mb: "xs",
                        children: "Va a cancelar la visita. \xbfEst\xe1 seguro?"
                    }),
                    operation: "proc",
                    onCancel: async ()=>{
                        await abort_controller.abort();
                        await modal.close();
                    },
                    onOK: async ()=>{
                        //const visitas = Entity.clone(visita) as VisitasATiendas;
                        //visitas.def.columns.c_visita_id.value = visita.parentKeys[visita.def.columns.c_visita_id.name] as string;
                        const result = await visita.API.executeProcess(visita.def.procs.viti_CancelarVisita, procParms, abort_controller.signal, selectedKeys);
                        if (!result.Failed) {
                            if (onClose) await onClose();
                            await modal.close();
                        }
                        return result;
                    }
                })
            });
        }
        return false;
    }
};

});

parcelRegister("h84pQ", function(module, exports) {

$parcel$export(module.exports, "VisitasPorSemanaPersonalViewInfoWindowRenderer", () => $ed52005cbd8bc1d9$export$f99779225ce5aa09);

var $ayMG0 = parcelRequire("ayMG0");

var $436KA = parcelRequire("436KA");
var $gU5rH = parcelRequire("gU5rH");
var $kPsAn = parcelRequire("kPsAn");
var $9mTYo = parcelRequire("9mTYo");
var $9VIWE = parcelRequire("9VIWE");
var $cjohz = parcelRequire("cjohz");
var $ew26C = parcelRequire("ew26C");
function $ed52005cbd8bc1d9$export$f99779225ce5aa09(record, position, groupManager, infoWindow, UIAPI, theme, entity) {
    //const columnsRender = TodoElPersonalViewColumnsOverrides(theme);
    const personal_id = record[0];
    const apellido = record[1];
    const nombre = record[2];
    const puesto = record[3];
    const supervisor = record[6];
    const vc_fotoguid = record[23];
    const fotoURL = entity.API.client.getDocumentURL(vc_fotoguid);
    const group = groupManager.getGroupByLocation(position);
    if (group) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kPsAn.Card), {
        withBorder: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9VIWE.Stack), {
            spacing: "xs",
            mb: "xs",
            children: [
                group.records.map(({ recordValue: rec }, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ew26C.Title), {
                                order: 5,
                                children: `ID: ${rec[0]} ${rec[1]}, ${2}${rec[3] ? ' - ' : ''}${rec[3]}`
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                                size: "xs",
                                onClick: async ()=>{
                                    await UIAPI.handleEditClick({
                                        'c_personal_id': rec[0]
                                    });
                                },
                                children: "Editar"
                            })
                        ]
                    }, `grp_${rec[0]}`)),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                        size: "xs",
                        variant: "light",
                        onClick: ()=>{
                            infoWindow.close();
                        },
                        children: "Cerrar"
                    })
                })
            ]
        })
    });
    else {
        //const horario_asignado = columnsRender[4]!.render!(horario);
        //const horas_semanales_disponibles = columnsRender[5]!.render!(horas_disponibles);
        //const estado_baja = columnsRender[8]!.render!(baja);
        //const estado_licencia = columnsRender[9]!.render!(licencia);
        const client = entity.API.client;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kPsAn.Card), {
            withBorder: true,
            padding: "xs",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9VIWE.Stack), {
                spacing: "0.5rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        spacing: "xs",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $436KA.Avatar), {
                                size: "md",
                                src: fotoURL,
                                radius: "sm"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ew26C.Title), {
                                order: 4,
                                children: `${apellido}, ${nombre}`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        spacing: "xs",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                                weight: 500,
                                size: "sm",
                                children: "Puesto: "
                            }),
                            puesto
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        spacing: "xs",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                                weight: 500,
                                size: "sm",
                                children: "Supervisi\xf3n: "
                            }),
                            supervisor
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                        position: "right",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                            size: "xs",
                            variant: "light",
                            onClick: ()=>{
                                infoWindow.close();
                            },
                            children: "Cerrar"
                        })
                    })
                ]
            })
        });
    }
}

});

parcelRegister("lO02G", function(module, exports) {

$parcel$export(module.exports, "VisitasPorSemanaPersonalViewMarkerRenderer", () => $932fcd3fc0f6d39e$export$ef546d3395c7205f);

var $d2PjO = parcelRequire("d2PjO");
function $932fcd3fc0f6d39e$export$ef546d3395c7205f(record, position, theme) {
    const apellido = record[1];
    const nombre = record[2];
    const puesto = record[3];
    const color = theme.colors.green[6];
    const icon = (0, $d2PjO.moodSmileIcon);
    const markerProps = {
        position: position,
        title: `${apellido}, ${nombre}${puesto && puesto ? ' - ' : ''}${puesto}`,
        svgIcon: icon,
        assignColorByValue: undefined,
        fillColor: color
    };
    return markerProps;
}

});

parcelRegister("aHQIQ", function(module, exports) {

$parcel$export(module.exports, "VisitasPorSemanaViewInfoWindowRenderer", () => $87846936c6c4d024$export$86993f21fc1c8e68);

var $ayMG0 = parcelRequire("ayMG0");

var $gU5rH = parcelRequire("gU5rH");
var $kPsAn = parcelRequire("kPsAn");
var $fnRsm = parcelRequire("fnRsm");
var $9mTYo = parcelRequire("9mTYo");
var $hiGsa = parcelRequire("hiGsa");
var $9VIWE = parcelRequire("9VIWE");
var $ew26C = parcelRequire("ew26C");

var $49qEn = parcelRequire("49qEn");
function $87846936c6c4d024$export$86993f21fc1c8e68(record, position, groupManager, infoWindow, UIAPI, theme, entity) {
    const tienda = record[2];
    const lunes = record[5];
    const martes = record[6];
    const miercoles = record[7];
    const jueves = record[8];
    const viernes = record[9];
    const sabado = record[10];
    const domingo = record[11];
    const personal = record[12];
    const image_src = (0, $49qEn.getGoogleMapsStreetViewImage)(position, 350, 200, 150);
    const group = groupManager.getGroupByLocation(position);
    if (group) {
        let lastTitle = null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kPsAn.Card), {
            withBorder: true,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9VIWE.Stack), {
                spacing: "xs",
                mb: "xs",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hiGsa.Image), {
                        width: 350,
                        height: 120,
                        src: image_src,
                        mx: "auto"
                    }),
                    group.records.map(({ recordValue: rec }, index)=>{
                        const g_title = `${rec[2]}`;
                        const g_visita_id = rec[0];
                        const g_lunes = rec[5];
                        const g_martes = rec[6];
                        const g_miercoles = rec[7];
                        const g_jueves = rec[8];
                        const g_viernes = rec[9];
                        const g_sabado = rec[10];
                        const g_domingo = rec[11];
                        const g_personal = rec[12];
                        const showTitle = g_title !== lastTitle;
                        if (showTitle) lastTitle = g_title;
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9VIWE.Stack), {
                            children: [
                                showTitle && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ew26C.Title), {
                                    order: 5,
                                    children: g_title
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fnRsm.Divider), {}),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                                    spacing: "xs",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.CircleFilledIcon), {
                                            icon: index + 1,
                                            mr: "0",
                                            backColor: theme.colors.gray[6]
                                        }),
                                        g_lunes && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                "Lunes de ",
                                                g_lunes,
                                                " - ",
                                                g_personal
                                            ]
                                        }),
                                        g_martes && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                "Martes de ",
                                                g_martes,
                                                " - ",
                                                g_personal
                                            ]
                                        }),
                                        g_miercoles && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                "Mi\xe9rcoles de ",
                                                g_miercoles,
                                                " - ",
                                                g_personal
                                            ]
                                        }),
                                        g_jueves && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                "Jueves de ",
                                                g_jueves,
                                                " - ",
                                                g_personal
                                            ]
                                        }),
                                        g_viernes && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                "Viernes de ",
                                                g_viernes,
                                                " - ",
                                                g_personal
                                            ]
                                        }),
                                        g_sabado && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                "S\xe1bado de ",
                                                g_sabado,
                                                " - ",
                                                g_personal
                                            ]
                                        }),
                                        g_domingo && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                "Domingo de ",
                                                g_domingo,
                                                " - ",
                                                g_personal
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, `grp_${g_visita_id}`);
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fnRsm.Divider), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                            size: "xs",
                            variant: "light",
                            onClick: ()=>{
                                infoWindow.close();
                            },
                            children: "Cerrar"
                        })
                    })
                ]
            })
        });
    } else return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kPsAn.Card), {
        withBorder: true,
        padding: "xs",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9VIWE.Stack), {
            spacing: "0.5rem",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hiGsa.Image), {
                    width: 350,
                    height: 120,
                    src: image_src,
                    mx: "auto"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ew26C.Title), {
                    order: 4,
                    children: `${tienda}`
                }),
                lunes && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    spacing: "xs",
                    children: [
                        "Lunes de ",
                        lunes,
                        " - ",
                        personal
                    ]
                }),
                martes && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    spacing: "xs",
                    children: [
                        "Martes de ",
                        martes,
                        " - ",
                        personal
                    ]
                }),
                miercoles && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    spacing: "xs",
                    children: [
                        "Mi\xe9rcoles de ",
                        miercoles,
                        " - ",
                        personal
                    ]
                }),
                jueves && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    spacing: "xs",
                    children: [
                        "Jueves de ",
                        jueves,
                        " - ",
                        personal
                    ]
                }),
                viernes && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    spacing: "xs",
                    children: [
                        "Viernes de ",
                        viernes,
                        " - ",
                        personal
                    ]
                }),
                sabado && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    spacing: "xs",
                    children: [
                        "S\xe1bado de ",
                        sabado,
                        " - ",
                        personal
                    ]
                }),
                domingo && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    spacing: "xs",
                    children: [
                        "Domingo de ",
                        domingo,
                        " - ",
                        personal
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                    position: "right",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                        size: "xs",
                        variant: "light",
                        onClick: ()=>{
                            infoWindow.close();
                        },
                        children: "Cerrar"
                    })
                })
            ]
        })
    });
}

});


parcelRegister("5VKBr", function(module, exports) {
module.exports = import("6aAXf").then(()=>parcelRequire('9dZ4r'));

});


parcelRegister("nttT0", function(module, exports) {

$parcel$export(module.exports, "ServiciosConfiguracion", () => $4462a598ad92a9eb$export$9f68108162a486a9);

var $49qEn = parcelRequire("49qEn");

var $TC7kK = parcelRequire("TC7kK");

var $bif8L = parcelRequire("bif8L");
const $4462a598ad92a9eb$export$f88a4c650649eecf = "* Aqu\xed puede configurar los servicios.";
const $4462a598ad92a9eb$export$11db0dfc8a11c056 = (0, $TC7kK.default);

class $4462a598ad92a9eb$export$9f68108162a486a9 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $bif8L.ServiciosConfiguracionDef)(), parentKeys);
        super.Form = (parcelRequire("2OPzG")).then((module)=>module.ServiciosConfiguracionForm);
        this.Title = "Configuraci\xf3n de Servicios";
        this.Icon = $4462a598ad92a9eb$export$11db0dfc8a11c056;
        this.HelpText = $4462a598ad92a9eb$export$f88a4c650649eecf;
    }
}

});
parcelRegister("bif8L", function(module, exports) {

$parcel$export(module.exports, "ServiciosConfiguracionDef", () => $abf698617a9636cb$export$dfcade8e6e5c528a);

var $49qEn = parcelRequire("49qEn");

var $e4f1v = parcelRequire("e4f1v");

var $9v5jT = parcelRequire("9v5jT");
const $abf698617a9636cb$var$columns = ()=>({
        c_servicio_id: new (0, $49qEn.EntityColumn)({
            name: 'c_servicio_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Servicio ID'
        }),
        c_paso_id: new (0, $49qEn.EntityColumn)({
            name: 'c_paso_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PKAutonum,
            prompt: 'Paso ID'
        }),
        i_orden: new (0, $49qEn.EntityColumn)({
            name: 'i_orden',
            type: 'int',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Orden'
        }),
        bt_requerido: new (0, $49qEn.EntityColumn)({
            name: 'bt_requerido',
            type: 'bit',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Requerido'
        }),
        vc_descripcionpaso: new (0, $49qEn.EntityColumn)({
            name: 'vc_descripcionpaso',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: "Descripci\xf3n"
        }),
        vc_observacionespaso: new (0, $49qEn.EntityColumn)({
            name: 'vc_observacionespaso',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Observaciones'
        }),
        c_tiposdatosservicios_id: new (0, $49qEn.EntityColumn)({
            name: 'c_tiposdatosservicios_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Tipo de dato'
        }),
        c_listavalores_id: new (0, $49qEn.EntityColumn)({
            name: 'c_listavalores_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Lista de valores'
        }),
        bt_unsolovalor: new (0, $49qEn.EntityColumn)({
            name: 'bt_unsolovalor',
            type: 'bit',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Unico valor'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $abf698617a9636cb$var$views = ()=>({
        seco_brwStandard: {
            name: 'seco_brwStandard',
            keyMappings: {
                c_paso_id: 4
            }
        }
    });
const $abf698617a9636cb$var$lookups = ()=>({
        'TiposDatosServicios': {
            name: 'TiposDatosServicios',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $e4f1v.catTiposDatosServicios)(client, parentKeys)
        },
        'ListaValores': {
            name: 'ListaValores',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $9v5jT.ListasValores)(client, parentKeys)
        }
    });
const $abf698617a9636cb$var$procs = ()=>({
        seco_getOrdenSiguiente: {
            name: 'seco_getOrdenSiguiente'
        }
    });
class $abf698617a9636cb$export$dfcade8e6e5c528a extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('ServiciosConfiguracion'), this.columns = $abf698617a9636cb$var$columns(), this.views = $abf698617a9636cb$var$views(), this.lookups = $abf698617a9636cb$var$lookups(), this.procs = $abf698617a9636cb$var$procs();
    }
}

});
parcelRegister("e4f1v", function(module, exports) {

$parcel$export(module.exports, "TiposDatosServiciosIcon", () => $9bd3003d9ac8dc3e$export$7485747de7bed2);
$parcel$export(module.exports, "TiposDatosServiciosHelpText", () => $9bd3003d9ac8dc3e$export$b123fcb6ce9c7bca);
$parcel$export(module.exports, "catTiposDatosServicios", () => $9bd3003d9ac8dc3e$export$5c77f5e169badb5a);

var $49qEn = parcelRequire("49qEn");

var $4WImN = parcelRequire("4WImN");
const $9bd3003d9ac8dc3e$export$7485747de7bed2 = (0, $4WImN.default);
const $9bd3003d9ac8dc3e$export$b123fcb6ce9c7bca = "* Aqu\xed puede ver la lista de todos los tipos de datos del servicio.";
class $9bd3003d9ac8dc3e$export$5c77f5e169badb5a extends (0, $49qEn.CategoriesValues) {
    constructor(client, parentKeys = {}){
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "TiposDatosServicios";
        this.def.columns.c_category_id.defaultValue = "TiposDatosServicios";
        this.Title = "Tipos de Datos de Servicio";
        this.HelpText = $9bd3003d9ac8dc3e$export$b123fcb6ce9c7bca;
        this.Icon = $9bd3003d9ac8dc3e$export$7485747de7bed2;
    }
}

});
parcelRegister("4WImN", function(module, exports) {

$parcel$export(module.exports, "default", () => $04422a4dd3de0da0$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $04422a4dd3de0da0$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M3 4m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M12 20h-6a3 3 0 0 1 -3 -3v-2a3 3 0 0 1 3 -3h10.5",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M18 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M18 14.5v1.5",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M18 20v1.5",
            "key": "svg-4"
        }
    ],
    [
        "path",
        {
            "d": "M21.032 16.25l-1.299 .75",
            "key": "svg-5"
        }
    ],
    [
        "path",
        {
            "d": "M16.27 19l-1.3 .75",
            "key": "svg-6"
        }
    ],
    [
        "path",
        {
            "d": "M14.97 16.25l1.3 .75",
            "key": "svg-7"
        }
    ],
    [
        "path",
        {
            "d": "M19.733 19l1.3 .75",
            "key": "svg-8"
        }
    ],
    [
        "path",
        {
            "d": "M7 8v.01",
            "key": "svg-9"
        }
    ],
    [
        "path",
        {
            "d": "M7 16v.01",
            "key": "svg-10"
        }
    ]
];
const $04422a4dd3de0da0$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "server-cog", "ServerCog", $04422a4dd3de0da0$export$3efd853dbb351e94);

});


parcelRegister("9v5jT", function(module, exports) {

$parcel$export(module.exports, "ListasValoresIcon", () => $caff4daf4163f5b2$export$eaa09b5795ce7087);
$parcel$export(module.exports, "ListasValoresHelpText", () => $caff4daf4163f5b2$export$4457ac351145eeca);
$parcel$export(module.exports, "ListasValores", () => $caff4daf4163f5b2$export$fc59b5f28e6446e0);

var $49qEn = parcelRequire("49qEn");

var $4s4Yo = parcelRequire("4s4Yo");

var $7UDL3 = parcelRequire("7UDL3");
const $caff4daf4163f5b2$export$eaa09b5795ce7087 = (0, $4s4Yo.default);
const $caff4daf4163f5b2$export$4457ac351145eeca = "* Aqu\xed puede ver y dar de alta las listas de valores";

class $caff4daf4163f5b2$export$fc59b5f28e6446e0 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $7UDL3.ListasValoresDef)(), parentKeys);
        super.Form = (parcelRequire("kPmTg")).then((module)=>module.ListasValoresForm);
        this.Title = "Listas de Valores";
        this.HelpText = $caff4daf4163f5b2$export$4457ac351145eeca;
        this.Icon = $caff4daf4163f5b2$export$eaa09b5795ce7087;
    }
}

});
parcelRegister("4s4Yo", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fda5b0fa0f5799b$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $1fda5b0fa0f5799b$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M9 6l11 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M9 12l11 0",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M9 18l11 0",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M5 6l0 .01",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M5 12l0 .01",
            "key": "svg-4"
        }
    ],
    [
        "path",
        {
            "d": "M5 18l0 .01",
            "key": "svg-5"
        }
    ]
];
const $1fda5b0fa0f5799b$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "list", "List", $1fda5b0fa0f5799b$export$3efd853dbb351e94);

});

parcelRegister("7UDL3", function(module, exports) {

$parcel$export(module.exports, "ListasValoresDef", () => $bb1472d11a96f954$export$c3ee33ea45702c2e);

var $49qEn = parcelRequire("49qEn");

var $6Kvmk = parcelRequire("6Kvmk");
const $bb1472d11a96f954$var$columns = ()=>({
        c_listavalores_id: new (0, $49qEn.EntityColumn)({
            name: 'c_listavalores_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PKAutonum,
            prompt: 'Lista de valores ID'
        }),
        vc_nombrelista: new (0, $49qEn.EntityColumn)({
            name: 'vc_nombrelista',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Nombre'
        }),
        vc_items: new (0, $49qEn.EntityColumn)({
            name: 'vc_items',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Items de la lista de valores ',
            isArray: true
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $bb1472d11a96f954$var$views = ()=>({
        liva_brwStandard: {
            name: 'liva_brwStandard',
            keyMappings: {
                c_listavalores_id: 0
            }
        }
    });
const $bb1472d11a96f954$var$lookups = ()=>({
        'ListasValoresItems': {
            name: 'ListasValoresItems',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $6Kvmk.ListasValoresItems)(client, parentKeys)
        }
    });
class $bb1472d11a96f954$export$c3ee33ea45702c2e extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('ListasValores'), this.columns = $bb1472d11a96f954$var$columns(), this.views = $bb1472d11a96f954$var$views(), this.lookups = $bb1472d11a96f954$var$lookups();
    }
}

});
parcelRegister("6Kvmk", function(module, exports) {

$parcel$export(module.exports, "ListasValoresItems", () => $7d4236b992ecd8f3$export$899336cddb1e0bd8);

var $49qEn = parcelRequire("49qEn");

var $3Ej21 = parcelRequire("3Ej21");
class $7d4236b992ecd8f3$export$899336cddb1e0bd8 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $3Ej21.ListasValoresItemsDef)(), parentKeys);
        // super.Form = import('./ListasValoresItemsForm').then((module) => module.ListasValoresItemsForm);
        this.Title = "Listas Valores Items";
    }
}

});
parcelRegister("3Ej21", function(module, exports) {

$parcel$export(module.exports, "ListasValoresItemsDef", () => $1324a1a3cd1f5222$export$3d23dcd3ba3ffbc7);

var $49qEn = parcelRequire("49qEn");
const $1324a1a3cd1f5222$var$columns = ()=>({
        c_listavalores_id: new (0, $49qEn.EntityColumn)({
            name: 'c_listavalores_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Listavalores Id'
        }),
        c_listavaloritem_id: new (0, $49qEn.EntityColumn)({
            name: 'c_listavaloritem_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PKAutonum,
            prompt: 'Listavaloritem Id'
        }),
        vc_nombrelistaitem: new (0, $49qEn.EntityColumn)({
            name: 'vc_nombrelistaitem',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Nombrelistaitem'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $1324a1a3cd1f5222$var$views = ()=>({
        livi_brwStandard: {
            name: 'livi_brwStandard',
            keyMappings: {
                c_listavalores_id: 0
            }
        }
    });
class $1324a1a3cd1f5222$export$3d23dcd3ba3ffbc7 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('ListasValoresItems'), this.columns = $1324a1a3cd1f5222$var$columns(), this.views = $1324a1a3cd1f5222$var$views();
    }
}

});



parcelRegister("kPmTg", function(module, exports) {
module.exports = import("3gVKH").then(()=>parcelRequire('1VTBM'));

});



parcelRegister("2OPzG", function(module, exports) {
module.exports = import("jdgoK").then(()=>parcelRequire('lKmsh'));

});


parcelRegister("5d2w1", function(module, exports) {

$parcel$export(module.exports, "DatosServiciosAutorizacionFilters", () => $4f381f96df8204e3$export$deaa929b7a937955);

var $49qEn = parcelRequire("49qEn");

var $kk5cS = parcelRequire("kk5cS");

class $4f381f96df8204e3$export$deaa929b7a937955 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $kk5cS.DatosServiciosAutorizacionFiltersDef)(), parentKeys);
        this.Form = (parcelRequire("eL0Ia")).then((module)=>module.DatosServiciosFiltersForms);
        this.Title = "Filtros de Datos Servicios";
    }
}

});
parcelRegister("kk5cS", function(module, exports) {

$parcel$export(module.exports, "DatosServiciosAutorizacionFiltersDef", () => $ceef9c01427af380$export$91b46b1309f9d848);

var $49qEn = parcelRequire("49qEn");

var $9u8qf = parcelRequire("9u8qf");

var $7LP39 = parcelRequire("7LP39");

var $4usKR = parcelRequire("4usKR");

var $gKBQM = parcelRequire("gKBQM");

var $6awxZ = parcelRequire("6awxZ");
const $ceef9c01427af380$var$columns = ()=>({
        vc_servicios: new (0, $49qEn.EntityColumn)({
            name: 'vc_servicios',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Servicios',
            isArray: true
        }),
        vc_tiendas: new (0, $49qEn.EntityColumn)({
            name: 'vc_tiendas',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Tiendas',
            isArray: true
        }),
        vc_productos: new (0, $49qEn.EntityColumn)({
            name: 'vc_productos',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Productos',
            isArray: true
        }),
        vc_clientes: new (0, $49qEn.EntityColumn)({
            name: 'vc_clientes',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Clientes',
            isArray: true
        }),
        vc_personal: new (0, $49qEn.EntityColumn)({
            name: 'vc_personal',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Personal',
            isArray: true
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $ceef9c01427af380$var$lookups = ()=>({
        'Servicios': {
            name: 'Servicios',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 2
            },
            entityConstructor: (client, parentKeys)=>new (0, $gKBQM.Servicios)(client, parentKeys)
        },
        'Tiendas': {
            name: 'Tiendas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 4
            },
            entityConstructor: (client, parentKeys)=>new (0, $6awxZ.Tiendas)(client, parentKeys)
        },
        'Productos': {
            name: 'Productos',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 4
            },
            entityConstructor: (client, parentKeys)=>new (0, $4usKR.Productos)(client, parentKeys)
        },
        'Clientes': {
            name: 'Clientes',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 2
            },
            entityConstructor: (client, parentKeys)=>new (0, $9u8qf.Clientes)(client, parentKeys)
        },
        'Personal': {
            name: 'Personal',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $7LP39.Personal)(client, parentKeys)
        }
    });
class $ceef9c01427af380$export$91b46b1309f9d848 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('DatosServiciosAutorizacionFilters'), this.columns = $ceef9c01427af380$var$columns(), this.views = {}, this.lookups = $ceef9c01427af380$var$lookups();
    }
}

});
parcelRegister("gKBQM", function(module, exports) {

$parcel$export(module.exports, "ServiciosHelpText", () => $b2ba4506a1a5b07a$export$313b40b24077e963);
$parcel$export(module.exports, "ServiciosIcon", () => $b2ba4506a1a5b07a$export$f1b59850f0b6d075);
$parcel$export(module.exports, "Servicios", () => $b2ba4506a1a5b07a$export$7d04105c8eaf94aa);

var $49qEn = parcelRequire("49qEn");

var $7A7e8 = parcelRequire("7A7e8");

var $i6QZN = parcelRequire("i6QZN");
const $b2ba4506a1a5b07a$export$313b40b24077e963 = "* Aqu\xed tendra la lista de los Servicios disponibles.";
const $b2ba4506a1a5b07a$export$f1b59850f0b6d075 = (0, $7A7e8.default);

class $b2ba4506a1a5b07a$export$7d04105c8eaf94aa extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $i6QZN.ServiciosDef)(), parentKeys);
        super.Form = (parcelRequire("okOUQ")).then((module)=>module.ServiciosForm);
        this.Title = 'Servicios';
        this.Icon = $b2ba4506a1a5b07a$export$f1b59850f0b6d075;
        this.HelpText = $b2ba4506a1a5b07a$export$313b40b24077e963;
    }
}

});
parcelRegister("7A7e8", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca9871050e3cf45c$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $ca9871050e3cf45c$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M5 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M14 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M7 17l5 0",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M3 17v-6h13v6",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M5 11v-4h4",
            "key": "svg-4"
        }
    ],
    [
        "path",
        {
            "d": "M9 11v-6h4l3 6",
            "key": "svg-5"
        }
    ],
    [
        "path",
        {
            "d": "M22 15h-3v-10",
            "key": "svg-6"
        }
    ],
    [
        "path",
        {
            "d": "M16 13l3 0",
            "key": "svg-7"
        }
    ]
];
const $ca9871050e3cf45c$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "forklift", "Forklift", $ca9871050e3cf45c$export$3efd853dbb351e94);

});

parcelRegister("i6QZN", function(module, exports) {

$parcel$export(module.exports, "ServiciosDef", () => $68a5fcac866f66ce$export$7cd1ef21eb535414);

var $49qEn = parcelRequire("49qEn");

var $6LYxo = parcelRequire("6LYxo");
const $68a5fcac866f66ce$var$columns = ()=>({
        c_servicio_id: new (0, $49qEn.EntityColumn)({
            name: 'c_servicio_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PKAutonum,
            prompt: 'Servicio ID'
        }),
        c_codigoservicio_id: new (0, $49qEn.EntityColumn)({
            name: 'c_codigoservicio_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: "C\xf3digo de servicio"
        }),
        vc_nombreservicio: new (0, $49qEn.EntityColumn)({
            name: 'vc_nombreservicio',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Nombre'
        }),
        bt_multiples_registros: new (0, $49qEn.EntityColumn)({
            name: 'bt_multiples_registros',
            type: 'bit',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Permitir M\xfaltiples Registros"
        }),
        bt_encabezado: new (0, $49qEn.EntityColumn)({
            name: 'bt_encabezado',
            type: 'bit',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Encabezado'
        }),
        c_frecuenciaact_id: new (0, $49qEn.EntityColumn)({
            name: 'c_frecuenciaact_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Frecuencia Retenci\xf3n"
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $68a5fcac866f66ce$var$views = ()=>({
        serv_brwStandard: {
            name: 'serv_brwStandard',
            keyMappings: {
                c_servicio_id: 0
            }
        }
    });
const $68a5fcac866f66ce$var$lookups = ()=>({
        'FrecuenciaAct': {
            name: 'FrecuenciaAct',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $6LYxo.catFrecuenciaAct)(client, parentKeys)
        }
    });
class $68a5fcac866f66ce$export$7cd1ef21eb535414 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('Servicios'), this.columns = $68a5fcac866f66ce$var$columns(), this.views = $68a5fcac866f66ce$var$views(), this.lookups = $68a5fcac866f66ce$var$lookups();
    }
}

});
parcelRegister("6LYxo", function(module, exports) {

$parcel$export(module.exports, "catFrecuenciaAct", () => $eaca294a8dfed61c$export$14c0009d55be270d);

var $49qEn = parcelRequire("49qEn");

var $1E0l5 = parcelRequire("1E0l5");
const $eaca294a8dfed61c$export$423951f3bb3a8951 = (0, $1E0l5.default);
const $eaca294a8dfed61c$export$ce3d9f8d1b5a1054 = "* Aqu\xed se pueden ver las frecuencias de actualizaci\xf3n aplicables.";
class $eaca294a8dfed61c$export$14c0009d55be270d extends (0, $49qEn.CategoriesValues) {
    constructor(client, parentKeys = {}){
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "FrecuenciaAct";
        this.def.columns.c_category_id.defaultValue = "FrecuenciaAct";
        this.Title = "Frecuencias de actualizaci\xf3n";
        this.HelpText = $eaca294a8dfed61c$export$ce3d9f8d1b5a1054;
        this.Icon = $eaca294a8dfed61c$export$423951f3bb3a8951;
    }
}

});
parcelRegister("1E0l5", function(module, exports) {

$parcel$export(module.exports, "default", () => $54cf33ea67730e3e$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $54cf33ea67730e3e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M6.5 7h11",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M6 20v-2a6 6 0 1 1 12 0v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1z",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M6 4v2a6 6 0 1 0 12 0v-2a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1z",
            "key": "svg-2"
        }
    ]
];
const $54cf33ea67730e3e$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "hourglass-high", "HourglassHigh", $54cf33ea67730e3e$export$3efd853dbb351e94);

});



parcelRegister("okOUQ", function(module, exports) {
module.exports = import("bRhfF").then(()=>parcelRequire('7GXaa'));

});



parcelRegister("eL0Ia", function(module, exports) {
module.exports = import("7iEyY").then(()=>parcelRequire('7cUjQ'));

});


parcelRegister("aBF3V", function(module, exports) {

$parcel$export(module.exports, "DatosServiciosAutorizacionReportesAppSupervisorFilters", () => $176feea2bc8a6f76$export$aa22bd7c25a1c6c9);

var $49qEn = parcelRequire("49qEn");

var $dSGXz = parcelRequire("dSGXz");

class $176feea2bc8a6f76$export$aa22bd7c25a1c6c9 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $dSGXz.DatosServiciosAutorizacionReportesAppSupervisorFiltersDef)(), parentKeys);
        this.Form = (parcelRequire("l22fk")).then((module)=>module.DatosServiciosAutorizacionReportesAppSupervisorFiltersForms);
        this.Title = "Filtros de Datos Servicios";
    }
}

});
parcelRegister("dSGXz", function(module, exports) {

$parcel$export(module.exports, "DatosServiciosAutorizacionReportesAppSupervisorFiltersDef", () => $92d858cdfbbc7003$export$586669c526b85303);

var $49qEn = parcelRequire("49qEn");

var $9u8qf = parcelRequire("9u8qf");

var $7LP39 = parcelRequire("7LP39");

var $6awxZ = parcelRequire("6awxZ");
const $92d858cdfbbc7003$var$currentDate = new Date();
const $92d858cdfbbc7003$var$columns = ()=>({
        vc_clientes: new (0, $49qEn.EntityColumn)({
            name: 'vc_clientes',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Clientes',
            isArray: true
        }),
        vc_tiendas: new (0, $49qEn.EntityColumn)({
            name: 'vc_tiendas',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Tiendas',
            isArray: true
        }),
        vc_personal: new (0, $49qEn.EntityColumn)({
            name: 'vc_personal',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Personal',
            isArray: true
        }),
        d_fecha_visita_desde: new (0, $49qEn.EntityColumn)({
            name: 'd_fecha_visita_desde',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Fecha Visita Desde',
            defaultValue: $92d858cdfbbc7003$var$currentDate
        }),
        d_fecha_visita_hasta: new (0, $49qEn.EntityColumn)({
            name: 'd_fecha_visita_hasta',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Fecha Visita Hasta',
            defaultValue: $92d858cdfbbc7003$var$currentDate
        }),
        c_estado_visita_id: new (0, $49qEn.EntityColumn)({
            name: 'c_estado_visita_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Estado Visita'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $92d858cdfbbc7003$var$lookups = ()=>({
        'Clientes': {
            name: 'Clientes',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 2
            },
            entityConstructor: (client, parentKeys)=>new (0, $9u8qf.Clientes)(client, parentKeys)
        },
        'Tiendas': {
            name: 'Tiendas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 4
            },
            entityConstructor: (client, parentKeys)=>new (0, $6awxZ.Tiendas)(client, parentKeys)
        },
        'Personal': {
            name: 'Personal',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $7LP39.Personal)(client, parentKeys)
        }
    });
class $92d858cdfbbc7003$export$586669c526b85303 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('DatosServiciosAutorizacionReportesAppSupervisorFilters'), this.columns = $92d858cdfbbc7003$var$columns(), this.views = {}, this.lookups = $92d858cdfbbc7003$var$lookups();
    }
}

});

parcelRegister("l22fk", function(module, exports) {
module.exports = import("jupxl").then(()=>parcelRequire('eA7sA'));

});


parcelRegister("2rehK", function(module, exports) {

$parcel$export(module.exports, "DatosServiciosAutorizacionReportesFilters", () => $a7c34d6efbeff52c$export$ae75c26fd066445d);

var $49qEn = parcelRequire("49qEn");

var $esabW = parcelRequire("esabW");

class $a7c34d6efbeff52c$export$ae75c26fd066445d extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $esabW.DatosServiciosAutorizacionReportesFiltersDef)(), parentKeys);
        this.Form = (parcelRequire("7b669")).then((module)=>module.DatosServiciosAutorizacionReportesFiltersForms);
        this.Title = "Filtros de Datos Servicios";
    }
}

});
parcelRegister("esabW", function(module, exports) {

$parcel$export(module.exports, "DatosServiciosAutorizacionReportesFiltersDef", () => $e90d329829fdd68e$export$ee9c98ce1f27b302);

var $49qEn = parcelRequire("49qEn");

var $SKbb0 = parcelRequire("SKbb0");

var $9u8qf = parcelRequire("9u8qf");

var $7LP39 = parcelRequire("7LP39");

var $6awxZ = parcelRequire("6awxZ");
const $e90d329829fdd68e$var$currentDate = new Date();
const $e90d329829fdd68e$var$columns = ()=>({
        vc_clientes: new (0, $49qEn.EntityColumn)({
            name: 'vc_clientes',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Clientes',
            isArray: true
        }),
        vc_cadenas: new (0, $49qEn.EntityColumn)({
            name: 'vc_cadenas',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Cadenas',
            isArray: true
        }),
        vc_tiendas: new (0, $49qEn.EntityColumn)({
            name: 'vc_tiendas',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Tiendas',
            isArray: true
        }),
        vc_personal: new (0, $49qEn.EntityColumn)({
            name: 'vc_personal',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Personal',
            isArray: true
        }),
        d_fecha_visita_desde: new (0, $49qEn.EntityColumn)({
            name: 'd_fecha_visita_desde',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Fecha Visita Desde',
            defaultValue: $e90d329829fdd68e$var$currentDate
        }),
        d_fecha_visita_hasta: new (0, $49qEn.EntityColumn)({
            name: 'd_fecha_visita_hasta',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Fecha Visita Hasta',
            defaultValue: $e90d329829fdd68e$var$currentDate
        }),
        c_estado_visita_id: new (0, $49qEn.EntityColumn)({
            name: 'c_estado_visita_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Estado Visita'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $e90d329829fdd68e$var$lookups = ()=>({
        'Clientes': {
            name: 'Clientes',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 2
            },
            entityConstructor: (client, parentKeys)=>new (0, $9u8qf.Clientes)(client, parentKeys)
        },
        'Cadenas': {
            name: 'Cadenas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $SKbb0.Cadenas)(client, parentKeys)
        },
        'Tiendas': {
            name: 'Tiendas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 4
            },
            entityConstructor: (client, parentKeys)=>new (0, $6awxZ.Tiendas)(client, parentKeys)
        },
        'Personal': {
            name: 'Personal',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $7LP39.Personal)(client, parentKeys)
        }
    });
class $e90d329829fdd68e$export$ee9c98ce1f27b302 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('DatosServiciosAutorizacionReportesFilters'), this.columns = $e90d329829fdd68e$var$columns(), this.views = {}, this.lookups = $e90d329829fdd68e$var$lookups();
    }
}

});

parcelRegister("7b669", function(module, exports) {
module.exports = import("iPpSd").then(()=>parcelRequire('8hYvR'));

});


parcelRegister("4vr9w", function(module, exports) {

$parcel$export(module.exports, "ACTAgregarReporte", () => $da32406b4cf20727$export$9b0b3d9c7cedc8be);

var $ayMG0 = parcelRequire("ayMG0");

var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $33FZg = parcelRequire("33FZg");
const $da32406b4cf20727$export$9b0b3d9c7cedc8be = {
    name: 'ACTAgregarReporte',
    label: 'Editar Reporte',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Editar Reporte"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    minSelectedRecords: 1,
    maxSelectedRecords: 1,
    views: [
        'dasa_brwGestionReportes',
        'dasa_brwGestionReportesVisitasIniciadas',
        'dasa_brwGestionReportesVisitasEnProceso',
        'dasa_brwGestionReportesVisitasFinalizadas',
        'dasa_brwGestionReportesVisitasIniciadasAppSupervisor',
        'dasa_brwGestionReportesVisitasEnProcesoAppSupervisor',
        'dasa_brwGestionReportesVisitasFinalizadasAppSupervisor'
    ],
    showActionInViewMode: true,
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const datosServiciosGestion = new (0, $33FZg.DatosServiciosGestion)(entity.API.client);
        datosServiciosGestion.def.columns.c_visita_id.value = selectedKeys[0].c_visita_id || '';
        await (0, $49qEn.openEntityForm)({
            modals: modal,
            formProps: {
                entity: datosServiciosGestion,
                initialFormMode: 'view',
                getDataOnInit: true
            },
            modalFormSize: 'xl',
            handleModalSaved: async ()=>{
                await modal.close();
                if (onClose) await onClose();
            },
            handleModalCancel: async ()=>{
                await modal.close();
                if (onClose) await onClose();
            }
        });
        return false;
    }
};

});
parcelRegister("33FZg", function(module, exports) {

$parcel$export(module.exports, "DatosServiciosGestion", () => $62f7c8b5ba93d4cb$export$ada89539823b67fd);

var $49qEn = parcelRequire("49qEn");

var $35ntO = parcelRequire("35ntO");

var $SKsy4 = parcelRequire("SKsy4");
const $62f7c8b5ba93d4cb$export$5f5157b8697a5985 = (0, $35ntO.default);
const $62f7c8b5ba93d4cb$export$1155456aa744427a = "* Datos Servicios Gesti\xf3n";

class $62f7c8b5ba93d4cb$export$ada89539823b67fd extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $SKsy4.DatosServiciosGestionDef)(), parentKeys);
        this.Form = (parcelRequire("3JfYF")).then((module)=>module.DatosServiciosGestionForm);
        this.Title = "Gestionar Reporte";
        this.HelpText = $62f7c8b5ba93d4cb$export$1155456aa744427a;
        this.Icon = $62f7c8b5ba93d4cb$export$5f5157b8697a5985;
    }
}

});
parcelRegister("SKsy4", function(module, exports) {

$parcel$export(module.exports, "DatosServiciosGestionDef", () => $02bcc41e7acad1a2$export$2481eb6f0172591f);

var $49qEn = parcelRequire("49qEn");

var $9u8qf = parcelRequire("9u8qf");

var $7LP39 = parcelRequire("7LP39");

var $4usKR = parcelRequire("4usKR");

var $1OscC = parcelRequire("1OscC");

var $nttT0 = parcelRequire("nttT0");

var $6awxZ = parcelRequire("6awxZ");
const $02bcc41e7acad1a2$var$columns = ()=>({
        c_visita_id: new (0, $49qEn.EntityColumn)({
            name: 'c_visita_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PKAutonum | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Visita Id'
        }),
        c_datos_servicio_id: new (0, $49qEn.EntityColumn)({
            name: 'c_datos_servicio_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Datos Servicio Id'
        }),
        c_datos_servicio_registro_id: new (0, $49qEn.EntityColumn)({
            name: 'c_datos_servicio_registro_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Datos Servicio Registro Id'
        }),
        c_servicio_id: new (0, $49qEn.EntityColumn)({
            name: 'c_servicio_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Servicio Id'
        }),
        c_paso_id: new (0, $49qEn.EntityColumn)({
            name: 'c_paso_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Paso Id'
        }),
        c_tienda_id: new (0, $49qEn.EntityColumn)({
            name: 'c_tienda_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Tienda Id'
        }),
        c_producto_id: new (0, $49qEn.EntityColumn)({
            name: 'c_producto_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Producto Id'
        }),
        c_cliente_id: new (0, $49qEn.EntityColumn)({
            name: 'c_cliente_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Cliente Id'
        }),
        c_personal_id: new (0, $49qEn.EntityColumn)({
            name: 'c_personal_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Personal Id'
        }),
        c_relevamiento_status_id: new (0, $49qEn.EntityColumn)({
            name: 'c_relevamiento_status_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Relevamiento Status Id'
        }),
        c_autorizacion_directa_status_id: new (0, $49qEn.EntityColumn)({
            name: 'c_autorizacion_directa_status_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Autorizacion Directa Status Id'
        }),
        dt_fecha_hora_realizado: new (0, $49qEn.EntityColumn)({
            name: 'dt_fecha_hora_realizado',
            type: 'datetime',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Fecha Hora Realizado'
        }),
        vc_clientes: new (0, $49qEn.EntityColumn)({
            name: 'vc_clientes',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Clientes'
        }),
        vc_productos: new (0, $49qEn.EntityColumn)({
            name: 'vc_productos',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Productos'
        }),
        vc_servicios: new (0, $49qEn.EntityColumn)({
            name: 'vc_servicios',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Servicios'
        }),
        c_persona_id: new (0, $49qEn.EntityColumn)({
            name: 'c_persona_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Persona Id'
        }),
        vc_numerodni: new (0, $49qEn.EntityColumn)({
            name: 'vc_numerodni',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'DNI'
        }),
        vc_nombre: new (0, $49qEn.EntityColumn)({
            name: 'vc_nombre',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Nombre'
        }),
        vc_apellido: new (0, $49qEn.EntityColumn)({
            name: 'vc_apellido',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Apellido'
        }),
        vc_puestotrabajo: new (0, $49qEn.EntityColumn)({
            name: 'vc_puestotrabajo',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Puesto'
        }),
        dt_nacimiento: new (0, $49qEn.EntityColumn)({
            name: 'dt_nacimiento',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Nacimiento'
        }),
        vc_genero: new (0, $49qEn.EntityColumn)({
            name: 'vc_genero',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "G\xe9nero"
        }),
        vc_fotoguid: new (0, $49qEn.EntityColumn)({
            name: 'vc_fotoguid',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Foto URL'
        }),
        vc_superior: new (0, $49qEn.EntityColumn)({
            name: 'vc_superior',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Superior'
        }),
        vc_telefono: new (0, $49qEn.EntityColumn)({
            name: 'vc_telefono',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Tel\xe9fono"
        }),
        vc_celular: new (0, $49qEn.EntityColumn)({
            name: 'vc_celular',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Celular'
        }),
        vc_celular_trabajo: new (0, $49qEn.EntityColumn)({
            name: 'vc_celular_trabajo',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Celular Trabajo'
        }),
        vc_telefono_alternativo: new (0, $49qEn.EntityColumn)({
            name: 'vc_telefono_alternativo',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Tel\xe9fono Alternativo"
        }),
        vc_email: new (0, $49qEn.EntityColumn)({
            name: 'vc_email',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Email'
        }),
        vc_email_alternativo: new (0, $49qEn.EntityColumn)({
            name: 'vc_email_alternativo',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Email Alternativo'
        }),
        f_latitud: new (0, $49qEn.EntityColumn)({
            name: 'f_latitud',
            type: 'float',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Latitud'
        }),
        f_longitud: new (0, $49qEn.EntityColumn)({
            name: 'f_longitud',
            type: 'float',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Longitud'
        }),
        vc_domicilio_completo: new (0, $49qEn.EntityColumn)({
            name: 'vc_domicilio_completo',
            type: 'varchar',
            length: 2048,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Domicilio Completo'
        }),
        n_total_horas_semanales: new (0, $49qEn.EntityColumn)({
            name: 'n_total_horas_semanales',
            type: 'decimal',
            scale: 2,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Total Horas Semanales'
        }),
        n_horas_semanales_disponibles: new (0, $49qEn.EntityColumn)({
            name: 'n_horas_semanales_disponibles',
            type: 'decimal',
            scale: 2,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Horas Semanales Disponibles'
        }),
        n_horas_semanales_compartidas: new (0, $49qEn.EntityColumn)({
            name: 'n_horas_semanales_compartidas',
            type: 'decimal',
            scale: 2,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Horas Semanales Compartidas'
        }),
        n_horas_semanales_exclusivas: new (0, $49qEn.EntityColumn)({
            name: 'n_horas_semanales_exclusivas',
            type: 'decimal',
            scale: 2,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Horas Semanales Exclusivas'
        }),
        dt_fecha_baja: new (0, $49qEn.EntityColumn)({
            name: 'dt_fecha_baja',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Fecha Baja'
        }),
        dt_fecha_alta: new (0, $49qEn.EntityColumn)({
            name: 'dt_fecha_alta',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Fecha Alta'
        }),
        dt_licencia_desde: new (0, $49qEn.EntityColumn)({
            name: 'dt_licencia_desde',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Licencia Desde'
        }),
        dt_licencia_hasta: new (0, $49qEn.EntityColumn)({
            name: 'dt_licencia_hasta',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Licencia Hasta'
        }),
        c_estado_licencia_id: new (0, $49qEn.EntityColumn)({
            name: 'c_estado_licencia_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Estado Licencia Id'
        }),
        vc_nombre_tienda: new (0, $49qEn.EntityColumn)({
            name: 'vc_nombre_tienda',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Nombre'
        }),
        bt_checkin: new (0, $49qEn.EntityColumn)({
            name: 'bt_checkin',
            type: 'bit',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Checkin'
        }),
        bt_checkout: new (0, $49qEn.EntityColumn)({
            name: 'bt_checkout',
            type: 'bit',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Checkout'
        }),
        d_fecha_visita: new (0, $49qEn.EntityColumn)({
            name: 'd_fecha_visita',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Fecha Visita'
        }),
        t_hora_desde: new (0, $49qEn.EntityColumn)({
            name: 't_hora_desde',
            type: 'time',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Hora Desde'
        }),
        t_hora_hasta: new (0, $49qEn.EntityColumn)({
            name: 't_hora_hasta',
            type: 'time',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Hora Hasta'
        }),
        vc_observaciones_visita: new (0, $49qEn.EntityColumn)({
            name: 'vc_observaciones_visita',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Observaciones Visita'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $02bcc41e7acad1a2$var$views = ()=>({
        dasg_brwStandard: {
            name: 'dasg_brwStandard',
            keyMappings: {
                c_datos_servicio_id: 0
            }
        }
    });
const $02bcc41e7acad1a2$var$lookups = ()=>({
        'ServiciosConfiguracion': {
            name: 'ServiciosConfiguracion',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $nttT0.ServiciosConfiguracion)(client, parentKeys)
        },
        'Productos': {
            name: 'Productos',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $4usKR.Productos)(client, parentKeys)
        },
        'Tiendas': {
            name: 'Tiendas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $6awxZ.Tiendas)(client, parentKeys)
        },
        'Clientes': {
            name: 'Clientes',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $9u8qf.Clientes)(client, parentKeys)
        },
        'Personal': {
            name: 'Personal',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $7LP39.Personal)(client, parentKeys)
        },
        'VisitasATiendas': {
            name: 'VisitasATiendas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $1OscC.VisitasATiendas)(client, parentKeys)
        }
    });
const $02bcc41e7acad1a2$var$procs = ()=>({
        dasg_checkinPorVisita: {
            name: 'dasg_checkinPorVisita'
        },
        dasg_checkoutPorVisita: {
            name: 'dasg_checkoutPorVisita'
        }
    });
class $02bcc41e7acad1a2$export$2481eb6f0172591f extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('DatosServiciosGestion'), this.columns = $02bcc41e7acad1a2$var$columns(), this.views = $02bcc41e7acad1a2$var$views(), this.lookups = $02bcc41e7acad1a2$var$lookups(), this.procs = $02bcc41e7acad1a2$var$procs();
    }
}

});

parcelRegister("3JfYF", function(module, exports) {
module.exports = Promise.all([
    import("iU5Vi"),
    import("lI4GT")
]).then(()=>parcelRequire('Os257'));

});



parcelRegister("8zOb7", function(module, exports) {

$parcel$export(module.exports, "ACTAutorizarReporte", () => $ae7aabb70c5e5773$export$ab9881481affeb13);

var $ayMG0 = parcelRequire("ayMG0");

var $gU5rH = parcelRequire("gU5rH");
var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");
const $ae7aabb70c5e5773$export$ab9881481affeb13 = {
    name: 'ACTAutorizarReporte',
    label: 'Autorizar Reporte',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Autorizar Reporte"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    views: [],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const datosServicioAutorizacion = entity;
        const procParms = {
            c_datos_servicio_id: selectedKeys?.[0]?.['c_datos_servicio_id'] ?? ''
        };
        let errores = '';
        if (!procParms.c_datos_servicio_id) errores = "Los registros seleccionados son inv\xe1lidos";
        if (errores) await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                            size: "1.5rem",
                            stroke: "1.5"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            fw: "700",
                            children: "ERROR"
                        })
                    ]
                })
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        size: "sm",
                        mb: "xs",
                        children: errores
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                        mt: "xs",
                        position: "right",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                            onClick: async ()=>await modal.close(),
                            children: "Cerrar"
                        })
                    })
                ]
            })
        });
        else {
            const abort_controller = new AbortController();
            await modal.open({
                modalProps: {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        fw: "700",
                        children: "Autorizar Reporte"
                    })
                },
                focusOnClosed: element,
                content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.ConfirmAndExecutePanel), {
                    content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        size: "sm",
                        mb: "xs",
                        children: "Va a autorizar el reporte. \xbfEst\xe1 seguro?"
                    }),
                    operation: "proc",
                    onCancel: async ()=>{
                        await abort_controller.abort();
                        await modal.close();
                    },
                    onOK: async ()=>{
                        const result = await datosServicioAutorizacion.API.executeProcess(datosServicioAutorizacion.def.procs.dasa_AutorizarReporte, procParms, abort_controller.signal);
                        const success = result.Failed === false;
                        if (onClose) await onClose(success);
                        if (success) await modal.close();
                        return result;
                    }
                })
            });
        }
        return false;
    }
};

});

parcelRegister("juxlT", function(module, exports) {

$parcel$export(module.exports, "ACTCheckin", () => $22a23a1f19201c36$export$f8bd49d362fbffb7);

var $ayMG0 = parcelRequire("ayMG0");

var $gU5rH = parcelRequire("gU5rH");
var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");

var $33FZg = parcelRequire("33FZg");
const $22a23a1f19201c36$export$f8bd49d362fbffb7 = {
    name: 'ACTCheckin',
    label: 'Checkin',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Checkin"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    minSelectedRecords: 1,
    maxSelectedRecords: 1,
    views: [
        'dasa_brwGestionReportes',
        'dasa_brwGestionReportesVisitasIniciadas',
        'dasa_brwGestionReportesVisitasEnProceso',
        'dasa_brwGestionReportesVisitasFinalizadas',
        'dasa_brwGestionReportesVisitasIniciadasAppSupervisor',
        'dasa_brwGestionReportesVisitasEnProcesoAppSupervisor',
        'dasa_brwGestionReportesVisitasFinalizadasAppSupervisor'
    ],
    showActionInViewMode: true,
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const parent = entity;
        const datosServiciosGestion = new (0, $33FZg.DatosServiciosGestion)(entity.API.client);
        datosServiciosGestion.parentKeys = parent.parentKeys;
        const procParms = {
            c_visita_id: selectedKeys?.[0]?.['c_visita_id'] ?? ''
        };
        let errores = '';
        if (!procParms.c_visita_id) errores = "Los registros seleccionados son inv\xe1lidos";
        if (errores) await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                            size: "1.5rem",
                            stroke: "1.5"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            fw: "700",
                            children: "ERROR"
                        })
                    ]
                })
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        size: "sm",
                        mb: "xs",
                        children: errores
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                        mt: "xs",
                        position: "right",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                            onClick: async ()=>await modal.close(),
                            children: "Cerrar"
                        })
                    })
                ]
            })
        });
        else {
            const abort_controller = new AbortController();
            await modal.open({
                modalProps: {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        fw: "700",
                        children: "Checkin"
                    })
                },
                focusOnClosed: element,
                content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.ConfirmAndExecutePanel), {
                    content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        size: "sm",
                        mb: "xs",
                        children: "Va a realizar el checkin de la visita. \xbfEst\xe1 seguro?"
                    }),
                    operation: "proc",
                    onCancel: async ()=>{
                        await abort_controller.abort();
                        await modal.close();
                    },
                    onOK: async ()=>{
                        const result = await datosServiciosGestion.API.executeProcess(datosServiciosGestion.def.procs.dasg_checkinPorVisita, procParms, abort_controller.signal);
                        const success = result.Failed === false;
                        if (onClose) await onClose(success);
                        if (success) await modal.close();
                        return result;
                    }
                })
            });
        }
        return false;
    }
};

});

parcelRegister("6Ckc5", function(module, exports) {

$parcel$export(module.exports, "ACTCheckout", () => $5a728dde00aeff56$export$dc0c920d4519526c);

var $ayMG0 = parcelRequire("ayMG0");

var $gU5rH = parcelRequire("gU5rH");
var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");

var $33FZg = parcelRequire("33FZg");
const $5a728dde00aeff56$export$dc0c920d4519526c = {
    name: 'ACTCheckout',
    label: 'Checkout',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Checkout"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    minSelectedRecords: 1,
    maxSelectedRecords: 1,
    views: [
        'dasa_brwGestionReportes',
        'dasa_brwGestionReportesVisitasIniciadas',
        'dasa_brwGestionReportesVisitasEnProceso',
        'dasa_brwGestionReportesVisitasFinalizadas',
        'dasa_brwGestionReportesVisitasIniciadasAppSupervisor',
        'dasa_brwGestionReportesVisitasEnProcesoAppSupervisor',
        'dasa_brwGestionReportesVisitasFinalizadasAppSupervisor'
    ],
    showActionInViewMode: true,
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const parent = entity;
        const datosServiciosGestion = new (0, $33FZg.DatosServiciosGestion)(entity.API.client);
        datosServiciosGestion.parentKeys = parent.parentKeys;
        const procParms = {
            c_visita_id: selectedKeys?.[0]?.['c_visita_id'] ?? ''
        };
        let errores = '';
        if (!procParms.c_visita_id) errores = "Los registros seleccionados son inv\xe1lidos";
        if (errores) await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                            size: "1.5rem",
                            stroke: "1.5"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            fw: "700",
                            children: "ERROR"
                        })
                    ]
                })
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        size: "sm",
                        mb: "xs",
                        children: errores
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                        mt: "xs",
                        position: "right",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                            onClick: async ()=>await modal.close(),
                            children: "Cerrar"
                        })
                    })
                ]
            })
        });
        else {
            const abort_controller = new AbortController();
            await modal.open({
                modalProps: {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        fw: "700",
                        children: "Checkout"
                    })
                },
                focusOnClosed: element,
                content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.ConfirmAndExecutePanel), {
                    content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        size: "sm",
                        mb: "xs",
                        children: "Va a realizar el checkout de la visita. \xbfEst\xe1 seguro?"
                    }),
                    operation: "proc",
                    onCancel: async ()=>{
                        await abort_controller.abort();
                        await modal.close();
                    },
                    onOK: async ()=>{
                        const result = await datosServiciosGestion.API.executeProcess(datosServiciosGestion.def.procs.dasg_checkoutPorVisita, procParms, abort_controller.signal);
                        const success = result.Failed === false;
                        if (onClose) await onClose(success);
                        if (success) await modal.close();
                        return result;
                    }
                })
            });
        }
        return false;
    }
};

});

parcelRegister("6r6d1", function(module, exports) {

$parcel$export(module.exports, "ACTVerUbicacion", () => $9c4f249b9bcd175b$export$b17902a4f9232976);

var $ayMG0 = parcelRequire("ayMG0");

var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");
var $4d0Rl = parcelRequire("4d0Rl");

var $7UO1x = parcelRequire("7UO1x");

var $6awxZ = parcelRequire("6awxZ");
const $9c4f249b9bcd175b$export$b17902a4f9232976 = {
    name: 'ACTVerUbicacion',
    label: "Ver Ubicaci\xf3n",
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Ver Ubicaci\xf3n"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    minSelectedRecords: 1,
    maxSelectedRecords: 1,
    views: [
        'dasa_brwGestionReportesVisitasIniciadas',
        'dasa_brwGestionReportesVisitasEnProceso',
        'dasa_brwGestionReportesVisitasFinalizadas',
        'dasa_brwGestionReportesVisitasIniciadasAppSupervisor',
        'dasa_brwGestionReportesVisitasEnProcesoAppSupervisor',
        'dasa_brwGestionReportesVisitasFinalizadasAppSupervisor'
    ],
    showActionInViewMode: true,
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const parent = entity;
        const dashboard = new (0, $7UO1x.Dashboard)(entity.API.client);
        dashboard.parentKeys = parent.parentKeys;
        dashboard.def.columns.c_personal_id.value = selectedKeys[0].c_personal_id || '';
        const parms = {
            ...dashboard.parentKeys,
            ...dashboard.def.columns.c_personal_id
        };
        const results = await dashboard.API.executeProc(dashboard.def.procs.dash_getUbicacionPersonal, parms);
        const data = results[0];
        const [lat, lng] = data.records[0];
        await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                            size: "1.5rem",
                            stroke: "1.5"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            fw: "700",
                            children: "Personal"
                        })
                    ]
                }),
                size: "xl"
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.MultiDataMapForm), {
                autoFocus: true,
                formMode: "edit",
                title: "Ubicaci\xf3n en tiempo real",
                mapOptions: {
                    center: {
                        lat: lat,
                        lng: lng
                    },
                    zoom: 15,
                    gestureHandling: 'greedy'
                },
                dataMapView1: {
                    entity: dashboard,
                    viewName: dashboard.def.views.dash_brwUbicacionPersonal.name,
                    parentKeys: dashboard.parentKeys,
                    refreshOnInit: true,
                    latitudRecordIndex: 1,
                    longitudRecordIndex: 2,
                    tabLabel: "Personal",
                    tabIcon: (0, $4d0Rl.default),
                    enableView: false,
                    enableAdd: false,
                    enableEdit: false,
                    enableDelete: false,
                    showActions: true,
                    modalFormSize: "98%"
                },
                dataMapView2: {
                    entity: dashboard,
                    viewName: dashboard.def.views.dash_brwTiendasVisitasPersonal.name,
                    parentKeys: dashboard.parentKeys,
                    refreshOnInit: true,
                    latitudRecordIndex: 4,
                    longitudRecordIndex: 5,
                    tabLabel: "Tiendas",
                    tabIcon: (0, $6awxZ.TiendasIcon),
                    enableView: false,
                    enableAdd: false,
                    enableEdit: false,
                    enableDelete: false,
                    showActions: true,
                    modalFormSize: "98%"
                },
                //dataMapView3={{
                //    entity: dashboard,
                //    viewName: dashboard.def.views.dash_brwCheckinVisitasPersonal.name,
                //    parentKeys: dashboard.parentKeys,
                //    refreshOnInit: true,
                //    latitudRecordIndex: 6, longitudRecordIndex: 7,
                //    tabLabel: "Checkin",
                //    tabIcon: TiendasIcon,
                //    enableView: false,
                //    enableAdd: false,
                //    enableEdit: false,
                //    enableDelete: false,
                //    showActions: true,
                //    modalFormSize: "98%",
                //}}
                //dataMapView4={{
                //    entity: dashboard,
                //    viewName: dashboard.def.views.dash_brwCheckoutVisitasPersonal.name,
                //    parentKeys: dashboard.parentKeys,
                //    refreshOnInit: true,
                //    latitudRecordIndex: 6, longitudRecordIndex: 7,
                //    tabLabel: "Checkout",
                //    tabIcon: TiendasIcon,
                //    enableView: false,
                //    enableAdd: false,
                //    enableEdit: false,
                //    enableDelete: false,
                //    showActions: true,
                //    modalFormSize: "98%",
                //}}
                mapHeight: "50vh"
            }, `mapa-ubicacion-personal-${entity.def.name}`)
        });
        return false;
    }
};

});
parcelRegister("7UO1x", function(module, exports) {

$parcel$export(module.exports, "Dashboard", () => $3d76c100bd9e3d07$export$fe82a520fc33e5f4);

var $49qEn = parcelRequire("49qEn");

var $5Ue5f = parcelRequire("5Ue5f");

var $cnujZ = parcelRequire("cnujZ");
const $3d76c100bd9e3d07$export$8fd9d8340b1bb79a = (0, $5Ue5f.default);
const $3d76c100bd9e3d07$export$e5fd332841fb75a3 = '* Dashboard.';

class $3d76c100bd9e3d07$export$fe82a520fc33e5f4 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $cnujZ.DashboardDef)(), parentKeys);
        this.Form = (parcelRequire("bxOAu")).then((module)=>module.DashboardForm);
        this.Title = "Dashboard";
        this.HelpText = $3d76c100bd9e3d07$export$e5fd332841fb75a3;
        this.Icon = $3d76c100bd9e3d07$export$8fd9d8340b1bb79a;
    }
}

});
parcelRegister("cnujZ", function(module, exports) {

$parcel$export(module.exports, "DashboardDef", () => $c4360265f397cff0$export$91286ae36dfd389f);

var $49qEn = parcelRequire("49qEn");

var $hwEG9 = parcelRequire("hwEG9");

var $e2FFz = parcelRequire("e2FFz");

var $giw7R = parcelRequire("giw7R");

var $kvbrC = parcelRequire("kvbrC");

var $ouxpq = parcelRequire("ouxpq");

var $gAdar = parcelRequire("gAdar");

var $1Dhl4 = parcelRequire("1Dhl4");

var $afatt = parcelRequire("afatt");

var $H5yKj = parcelRequire("H5yKj");

var $4k2Xd = parcelRequire("4k2Xd");

var $gAMC4 = parcelRequire("gAMC4");

var $dfHNO = parcelRequire("dfHNO");

var $bsZPN = parcelRequire("bsZPN");

var $jJ4eF = parcelRequire("jJ4eF");

var $jOqEH = parcelRequire("jOqEH");

var $7Tiry = parcelRequire("7Tiry");

var $8fTSV = parcelRequire("8fTSV");

var $1ZUed = parcelRequire("1ZUed");

var $6MTtf = parcelRequire("6MTtf");

var $7hyB8 = parcelRequire("7hyB8");

var $dGKc3 = parcelRequire("dGKc3");

var $er95x = parcelRequire("er95x");

var $5v4bO = parcelRequire("5v4bO");

var $jHO5E = parcelRequire("jHO5E");

var $fCFaT = parcelRequire("fCFaT");

var $jI9GA = parcelRequire("jI9GA");

var $2xKFT = parcelRequire("2xKFT");

var $72uy6 = parcelRequire("72uy6");

var $fK3CP = parcelRequire("fK3CP");

var $2WxxY = parcelRequire("2WxxY");
const $c4360265f397cff0$var$columns = ()=>({
        c_personal_id: new (0, $49qEn.EntityColumn)({
            name: 'c_personal_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Personal Id'
        }),
        c_tienda_id: new (0, $49qEn.EntityColumn)({
            name: 'c_tienda_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Tienda Id'
        }),
        i_autorizaciones: new (0, $49qEn.EntityColumn)({
            name: 'i_autorizaciones',
            type: 'int',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Autorizaciones'
        }),
        i_autorizaciones_total: new (0, $49qEn.EntityColumn)({
            name: 'i_autorizaciones_total',
            type: 'int',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Total'
        }),
        i_personal_presentes: new (0, $49qEn.EntityColumn)({
            name: 'i_personal_presentes',
            type: 'int',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Presentes'
        }),
        i_personal_ausentes: new (0, $49qEn.EntityColumn)({
            name: 'i_personal_ausentes',
            type: 'int',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Ausentes'
        }),
        i_personal_sin_reportar: new (0, $49qEn.EntityColumn)({
            name: 'i_personal_sin_reportar',
            type: 'int',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Sin Reportar'
        }),
        i_personal_total: new (0, $49qEn.EntityColumn)({
            name: 'i_personal_total',
            type: 'int',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Total'
        }),
        i_visitas_finalizadas: new (0, $49qEn.EntityColumn)({
            name: 'i_visitas_finalizadas',
            type: 'int',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Finalizadas'
        }),
        i_visitas_en_proceso: new (0, $49qEn.EntityColumn)({
            name: 'i_visitas_en_proceso',
            type: 'int',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'En Proceso'
        }),
        i_visitas_sin_iniciar: new (0, $49qEn.EntityColumn)({
            name: 'i_visitas_sin_iniciar',
            type: 'int',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Sin Iniciar'
        }),
        i_visitas_total: new (0, $49qEn.EntityColumn)({
            name: 'i_visitas_total',
            type: 'int',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Total'
        }),
        i_total_personal_checkin: new (0, $49qEn.EntityColumn)({
            name: 'i_total_personal_checkin',
            type: 'int',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Personal Checkin'
        }),
        i_total_personal_sin_checkin: new (0, $49qEn.EntityColumn)({
            name: 'i_total_personal_sin_checkin',
            type: 'int',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Personal Sin Checkin'
        }),
        c_datos_geolocation_id: new (0, $49qEn.EntityColumn)({
            name: 'c_datos_geolocation_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: "Geolocalizaci\xf3n Id"
        }),
        c_personal_filtro_id: new (0, $49qEn.EntityColumn)({
            name: 'c_personal_filtro_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Personal Filtro Id'
        }),
        c_datos_checkin_id: new (0, $49qEn.EntityColumn)({
            name: 'c_datos_checkin_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Datos Chekin Id'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $c4360265f397cff0$var$views = ()=>({
        dash_brwStandard: {
            name: 'dash_brwStandard',
            keyMappings: {}
        },
        dash_brwPersonalLocalizacion: {
            name: 'dash_brwPersonalLocalizacion',
            keyMappings: {
                c_personal_id: 0
            },
            FiltersEntity: (client, parentKeys)=>new (0, $hwEG9.DashboardFilters)(client, parentKeys),
            mapMarkerRenderer: (0, $fCFaT.PersonalLocalizacionViewMarkerRenderer),
            mapInfoWindowRenderer: (0, $jHO5E.PersonalLocalizacionViewInfoWindowRenderer)
        },
        dash_brwPersonalLocalizacionPresentes: {
            name: 'dash_brwPersonalLocalizacionPresentes',
            keyMappings: {
                c_personal_id: 0
            },
            FiltersEntity: (client, parentKeys)=>new (0, $e2FFz.DashboardPersonalFilters)(client, parentKeys)
        },
        dash_brwPersonalLocalizacionAusentes: {
            name: 'dash_brwPersonalLocalizacionAusentes',
            keyMappings: {
                c_personal_id: 0
            },
            FiltersEntity: (client, parentKeys)=>new (0, $e2FFz.DashboardPersonalFilters)(client, parentKeys)
        },
        dash_brwPersonalLocalizacionSinReportar: {
            name: 'dash_brwPersonalLocalizacionSinReportar',
            keyMappings: {
                c_personal_id: 0
            },
            FiltersEntity: (client, parentKeys)=>new (0, $e2FFz.DashboardPersonalFilters)(client, parentKeys)
        },
        dash_brwTiendas: {
            name: 'dash_brwTiendas',
            keyMappings: {
                c_tienda_id: 0
            },
            FiltersEntity: (client, parentKeys)=>new (0, $hwEG9.DashboardFilters)(client, parentKeys),
            mapMarkerRenderer: (0, $2xKFT.TiendasViewMarkerRenderer),
            mapInfoWindowRenderer: (0, $jI9GA.TiendasViewInfoWindowRenderer)
        },
        dash_brwTiendasPersonal: {
            name: 'dash_brwTiendasPersonal',
            keyMappings: {
                c_tienda_id: 0
            }
        },
        dash_brwUbicacionPersonal: {
            name: 'dash_brwUbicacionPersonal',
            keyMappings: {
                c_personal_id: 0
            },
            mapMarkerRenderer: (0, $2WxxY.UbicacionPersonalViewMarkerRenderer)
        },
        dash_brwTiendasVisitasPersonal: {
            name: 'dash_brwTiendasVisitasPersonal',
            keyMappings: {
                c_tienda_id: 0
            },
            gridColumnsOverrides: (0, $72uy6.TiendasVisitasPersonalViewColumnsOverrides),
            mapMarkerRenderer: (0, $fK3CP.TiendasVisitasPersonalViewMarkerRenderer)
        },
        dash_brwCheckinVisitasPersonal: {
            name: 'dash_brwCheckinVisitasPersonal',
            keyMappings: {
                c_tienda_id: 0
            },
            mapMarkerRenderer: (0, $1ZUed.CheckinVisitasPersonalViewMarkerRenderer),
            mapInfoWindowRenderer: (0, $8fTSV.CheckinVisitasPersonalViewInfoWindowRenderer)
        },
        dash_brwCheckoutVisitasPersonal: {
            name: 'dash_brwCheckoutVisitasPersonal',
            keyMappings: {
                c_tienda_id: 0
            },
            mapMarkerRenderer: (0, $7hyB8.CheckoutVisitasPersonalViewMarkerRenderer),
            mapInfoWindowRenderer: (0, $6MTtf.CheckoutVisitasPersonalViewInfoWindowRenderer)
        },
        dash_brwPersonalSinCheckin: {
            name: 'dash_brwPersonalSinCheckin',
            keyMappings: {
                c_personal_id: 0
            },
            FiltersEntity: (client, parentKeys)=>new (0, $e2FFz.DashboardPersonalFilters)(client, parentKeys)
        },
        dash_brwPersonalSinCheckinSupervisor: {
            name: 'dash_brwPersonalSinCheckinSupervisor',
            keyMappings: {
                c_personal_id: 0
            },
            FiltersEntity: (client, parentKeys)=>new (0, $e2FFz.DashboardPersonalFilters)(client, parentKeys)
        },
        dash_brwPersonalHistorialUbicaciones: {
            name: 'dash_brwPersonalHistorialUbicaciones',
            keyMappings: {
                c_datos_geolocation_id: 3
            }
        },
        dash_brwPersonalHistorialVerUbicacion: {
            name: 'dash_brwPersonalHistorialVerUbicacion',
            keyMappings: {
                c_datos_geolocation_id: 3
            }
        },
        dash_brwPersonalDispositivos: {
            name: 'dash_brwPersonalDispositivos',
            keyMappings: {}
        },
        dash_brwPersonalLogins: {
            name: 'dash_brwPersonalLogins',
            keyMappings: {}
        },
        dash_brwPersonalVersionesApp: {
            name: 'dash_brwPersonalVersionesApp',
            keyMappings: {}
        },
        dash_brwPersonalHistorialCheckin: {
            name: 'dash_brwPersonalHistorialCheckin',
            keyMappings: {
                c_datos_checkin_id: 13
            },
            gridColumnsOverrides: (0, $5v4bO.PersonalHistorialCheckinViewColumnsOverrides)
        },
        dash_brwPersonalHistorialCheckinVerUbicacion: {
            name: 'dash_brwPersonalHistorialCheckinVerUbicacion',
            keyMappings: {
                c_datos_checkin_id: 10
            },
            mapMarkerRenderer: (0, $er95x.HistorialCheckinVerUbicacionViewMarkerRenderer)
        },
        dash_brwPersonalHistorialCheckinVerUbicacionTienda: {
            name: 'dash_brwPersonalHistorialCheckinVerUbicacionTienda',
            keyMappings: {
                c_datos_checkin_id: 13
            },
            mapMarkerRenderer: (0, $dGKc3.HistorialCheckinVerUbicacionTiendaViewMarkerRenderer)
        }
    });
const $c4360265f397cff0$var$procs = ()=>({
        dash_getUbicacionPersonal: {
            name: 'dash_getUbicacionPersonal'
        }
    });
const $c4360265f397cff0$var$clientActions = ()=>({
        ACTVerReportesPersonal: (0, $gAMC4.ACTVerReportesPersonal),
        ACTVerReportesTienda: (0, $dfHNO.ACTVerReportesTienda),
        ACTVerPersonalTienda: (0, $H5yKj.ACTVerPersonalTienda),
        ACTVerRutasEnTiendaDashboard: (0, $bsZPN.ACTVerRutasEnTiendaDashboard),
        ACTVerUbicacionDashboard: (0, $jJ4eF.ACTVerUbicacionDashboard),
        ACTVerHistorialUbicacion: (0, $gAdar.ACTVerHistorialUbicacion),
        ACTVerHistorialVerUbicacion: (0, $1Dhl4.ACTVerHistorialVerUbicacion),
        ACTVerDispositivos: (0, $giw7R.ACTVerDispositivos),
        ACTVerLogins: (0, $afatt.ACTVerLogins),
        ACTVerReportes: (0, $4k2Xd.ACTVerReportes),
        ACTVerVersionesApp: (0, $jOqEH.ACTVerVersionesApp),
        ACTVerHistorialCheckin: (0, $kvbrC.ACTVerHistorialCheckin),
        ACTVerHistorialCheckinVerUbicacion: (0, $ouxpq.ACTVerHistorialCheckinVerUbicacion),
        ACTVerVisitas: (0, $7Tiry.ACTVerVisitas)
    });
class $c4360265f397cff0$export$91286ae36dfd389f extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('Dashboard'), this.columns = $c4360265f397cff0$var$columns(), this.views = $c4360265f397cff0$var$views(), this.procs = $c4360265f397cff0$var$procs(), this.clientActions = $c4360265f397cff0$var$clientActions();
    }
}

});
parcelRegister("hwEG9", function(module, exports) {

$parcel$export(module.exports, "DashboardFilters", () => $c8635290617e4696$export$cf2332d8329013e5);

var $49qEn = parcelRequire("49qEn");

var $5Ue5f = parcelRequire("5Ue5f");

var $lf5rg = parcelRequire("lf5rg");
const $c8635290617e4696$export$8fd9d8340b1bb79a = (0, $5Ue5f.default);
const $c8635290617e4696$export$e5fd332841fb75a3 = '* Dashboard.';

class $c8635290617e4696$export$cf2332d8329013e5 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $lf5rg.DashboardFiltersDef)(), parentKeys);
        this.Form = (parcelRequire("d0siJ")).then((module)=>module.DashboardFiltersForm);
        this.Title = "Dashboard";
        this.HelpText = $c8635290617e4696$export$e5fd332841fb75a3;
        this.Icon = $c8635290617e4696$export$8fd9d8340b1bb79a;
    }
}

});
parcelRegister("lf5rg", function(module, exports) {

$parcel$export(module.exports, "DashboardFiltersDef", () => $94b714955052a0be$export$ab4900adeebac167);

var $49qEn = parcelRequire("49qEn");

var $9u8qf = parcelRequire("9u8qf");

var $7LP39 = parcelRequire("7LP39");

var $6awxZ = parcelRequire("6awxZ");
const $94b714955052a0be$var$columns = ()=>({
        vc_tiendas: new (0, $49qEn.EntityColumn)({
            name: 'vc_tiendas',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Tiendas',
            isArray: true
        }),
        vc_personal: new (0, $49qEn.EntityColumn)({
            name: 'vc_personal',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Personal',
            isArray: true
        }),
        vc_clientes: new (0, $49qEn.EntityColumn)({
            name: 'vc_clientes',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Clientes',
            isArray: true
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $94b714955052a0be$var$lookups = ()=>({
        'Tiendas': {
            name: 'Tiendas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 4
            },
            entityConstructor: (client, parentKeys)=>new (0, $6awxZ.Tiendas)(client, parentKeys)
        },
        'Personal': {
            name: 'Personal',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $7LP39.Personal)(client, parentKeys)
        },
        'Clientes': {
            name: 'Clientes',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 2
            },
            entityConstructor: (client, parentKeys)=>new (0, $9u8qf.Clientes)(client, parentKeys)
        }
    });
class $94b714955052a0be$export$ab4900adeebac167 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('DashboardFilters'), this.columns = $94b714955052a0be$var$columns(), this.views = {}, this.lookups = $94b714955052a0be$var$lookups();
    }
}

});

parcelRegister("d0siJ", function(module, exports) {
module.exports = import("X3c6W").then(()=>parcelRequire('2lxRs'));

});


parcelRegister("e2FFz", function(module, exports) {

$parcel$export(module.exports, "DashboardPersonalFilters", () => $109ca273b2d3f63b$export$210abaee6f384797);

var $49qEn = parcelRequire("49qEn");

var $5Ue5f = parcelRequire("5Ue5f");

var $j8HDq = parcelRequire("j8HDq");
const $109ca273b2d3f63b$export$8fd9d8340b1bb79a = (0, $5Ue5f.default);
const $109ca273b2d3f63b$export$e5fd332841fb75a3 = '* Dashboard.';

class $109ca273b2d3f63b$export$210abaee6f384797 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $j8HDq.DashboardPersonalFiltersDef)(), parentKeys);
        this.Form = (parcelRequire("5KQvI")).then((module)=>module.DashboardPersonalFiltersForm);
        this.Title = "Dashboard";
        this.HelpText = $109ca273b2d3f63b$export$e5fd332841fb75a3;
        this.Icon = $109ca273b2d3f63b$export$8fd9d8340b1bb79a;
    }
}

});
parcelRegister("j8HDq", function(module, exports) {

$parcel$export(module.exports, "DashboardPersonalFiltersDef", () => $939c9688bcb2d073$export$85e137beffd93ba0);

var $49qEn = parcelRequire("49qEn");

var $kFypM = parcelRequire("kFypM");

var $aQujn = parcelRequire("aQujn");

var $j8GP5 = parcelRequire("j8GP5");

var $4Rlmx = parcelRequire("4Rlmx");

var $7LP39 = parcelRequire("7LP39");

var $a4nBq = parcelRequire("a4nBq");
const $939c9688bcb2d073$var$columns = ()=>({
        c_pais_id: new (0, $49qEn.EntityColumn)({
            name: 'c_pais_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Pa\xeds"
        }),
        c_provincia_id: new (0, $49qEn.EntityColumn)({
            name: 'c_provincia_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Provincia'
        }),
        c_ciudad_id: new (0, $49qEn.EntityColumn)({
            name: 'c_ciudad_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Ciudad'
        }),
        c_localidad_id: new (0, $49qEn.EntityColumn)({
            name: 'c_localidad_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Localidad'
        }),
        vc_puestos: new (0, $49qEn.EntityColumn)({
            name: 'vc_puestos',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Puestos',
            isArray: true
        }),
        vc_personal: new (0, $49qEn.EntityColumn)({
            name: 'vc_personal',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Personal',
            isArray: true
        }),
        vc_supervision: new (0, $49qEn.EntityColumn)({
            name: 'vc_supervision',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Supervisi\xf3n",
            isArray: true
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $939c9688bcb2d073$var$lookups = ()=>({
        'Paises': {
            name: 'Paises',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $j8GP5.Paises)(client, parentKeys)
        },
        'Provincias': {
            name: 'Provincias',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $4Rlmx.Provincias)(client, parentKeys)
        },
        'Ciudades': {
            name: 'Ciudades',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $kFypM.Ciudades)(client, parentKeys)
        },
        'Localidades': {
            name: 'Localidades',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $aQujn.Localidades)(client, parentKeys)
        },
        'Puestos': {
            name: 'Puestos',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $a4nBq.PuestosTrabajo)(client, parentKeys)
        },
        'Personal': {
            name: 'Personal',
            view: 'perl_brwStandard',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $7LP39.Personal)(client, parentKeys)
        },
        'Supervision': {
            name: 'Supervision',
            view: 'perl_brwStandard',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $7LP39.Personal)(client, parentKeys)
        }
    });
class $939c9688bcb2d073$export$85e137beffd93ba0 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('DashboardPersonalFilters'), this.columns = $939c9688bcb2d073$var$columns(), this.views = {}, this.lookups = $939c9688bcb2d073$var$lookups();
    }
}

});

parcelRegister("5KQvI", function(module, exports) {
module.exports = import("2xSmK").then(()=>parcelRequire('ftmuO'));

});


parcelRegister("giw7R", function(module, exports) {

$parcel$export(module.exports, "ACTVerDispositivos", () => $0ab117de0e03984b$export$5789b420d22d55a2);

var $ayMG0 = parcelRequire("ayMG0");

var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");

var $7UO1x = parcelRequire("7UO1x");
const $0ab117de0e03984b$export$5789b420d22d55a2 = {
    name: 'ACTVerDispositivos',
    label: 'Ver Dispositivos',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Ver Dispositivos"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    minSelectedRecords: 1,
    maxSelectedRecords: 1,
    views: [
        'dash_brwPersonalLocalizacionPresentes',
        'dash_brwPersonalLocalizacionAusentes',
        'dash_brwPersonalLocalizacionSinReportar',
        'dash_brwPersonalSinCheckin',
        'dash_brwPersonalSinCheckinSupervisor',
        'dash_brwUbicacionPersonal'
    ],
    showActionInViewMode: true,
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const parent = entity;
        const dashboard = new (0, $7UO1x.Dashboard)(entity.API.client);
        dashboard.parentKeys = parent.parentKeys;
        dashboard.def.columns.c_personal_id.value = selectedKeys[0].c_personal_id || '';
        await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                            size: "1.5rem",
                            stroke: "1.5"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            fw: "700",
                            children: "Dispositivos"
                        })
                    ]
                }),
                size: "fullscreen"
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: entity.API.client,
                entityConstructor: ()=>dashboard,
                formMode: "view",
                viewName: "dash_brwPersonalDispositivos",
                refreshOnInit: true,
                title: "Dispositivos",
                enableAdd: false,
                enableDelete: false,
                enableEdit: false,
                enableView: false,
                showActions: true,
                selectionMode: "single"
            }, "personal-dispositivos")
        });
        return false;
    }
};

});

parcelRegister("kvbrC", function(module, exports) {

$parcel$export(module.exports, "ACTVerHistorialCheckin", () => $07c7d0cb4e29653b$export$cce48251dbcedded);

var $ayMG0 = parcelRequire("ayMG0");

var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");

var $7UO1x = parcelRequire("7UO1x");
const $07c7d0cb4e29653b$export$cce48251dbcedded = {
    name: 'ACTVerHistorialCheckin',
    label: 'Ver Historial Checkin',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Ver Historial Checkin"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    minSelectedRecords: 1,
    maxSelectedRecords: 1,
    views: [
        'dash_brwPersonalLocalizacionPresentes',
        'dash_brwPersonalLocalizacionAusentes',
        'dash_brwPersonalLocalizacionSinReportar',
        'dash_brwPersonalSinCheckin',
        'dash_brwPersonalSinCheckinSupervisor',
        'dash_brwUbicacionPersonal'
    ],
    showActionInViewMode: true,
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const parent = entity;
        const dashboard = new (0, $7UO1x.Dashboard)(entity.API.client);
        dashboard.parentKeys = parent.parentKeys;
        dashboard.def.columns.c_personal_id.value = selectedKeys[0].c_personal_id || '';
        await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                            size: "1.5rem",
                            stroke: "1.5"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            fw: "700",
                            children: "Historial de Checkin"
                        })
                    ]
                }),
                size: "fullscreen"
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: entity.API.client,
                entityConstructor: ()=>dashboard,
                formMode: "view",
                viewName: "dash_brwPersonalHistorialCheckin",
                refreshOnInit: true,
                title: "Historial de Checkin",
                enableAdd: false,
                enableDelete: false,
                enableEdit: false,
                enableView: false,
                showActions: true,
                selectionMode: "single"
            }, "historial-ubicaciones")
        });
        return false;
    }
};

});

parcelRegister("ouxpq", function(module, exports) {

$parcel$export(module.exports, "ACTVerHistorialCheckinVerUbicacion", () => $df796ac0f8928f0a$export$572417c605b36e15);

var $ayMG0 = parcelRequire("ayMG0");

var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");
var $jIc5b = parcelRequire("jIc5b");
var $4d0Rl = parcelRequire("4d0Rl");

var $7UO1x = parcelRequire("7UO1x");
const $df796ac0f8928f0a$export$572417c605b36e15 = {
    name: 'ACTVerHistorialCheckinVerUbicacion',
    label: "Ver Ubicaci\xf3n Checkin",
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Ver Ubicaci\xf3n Checkin"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    minSelectedRecords: 1,
    maxSelectedRecords: 1,
    views: [
        'dash_brwPersonalHistorialCheckin'
    ],
    showActionInViewMode: true,
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const parent = entity;
        const dashboard = new (0, $7UO1x.Dashboard)(entity.API.client);
        dashboard.parentKeys = parent.parentKeys;
        dashboard.def.columns.c_datos_checkin_id.value = selectedKeys[0].c_datos_checkin_id || '';
        await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                            size: "1.5rem",
                            stroke: "1.5"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            fw: "700",
                            children: "Historial de Chekin"
                        })
                    ]
                }),
                size: "fullscreen"
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.MultiDataMapForm), {
                autoFocus: true,
                formMode: "edit",
                title: "Historial de Checkin",
                dataMapView1: {
                    entity: dashboard,
                    viewName: dashboard.def.views.dash_brwPersonalHistorialCheckinVerUbicacion.name,
                    parentKeys: dashboard.parentKeys,
                    refreshOnInit: true,
                    latitudRecordIndex: 6,
                    longitudRecordIndex: 7,
                    tabLabel: "Ubicaci\xf3n Checkin",
                    tabIcon: (0, $4d0Rl.default),
                    enableView: false,
                    enableAdd: false,
                    enableEdit: false,
                    enableDelete: false,
                    showActions: true,
                    modalFormSize: "98%"
                },
                dataMapView2: {
                    entity: dashboard,
                    viewName: dashboard.def.views.dash_brwPersonalHistorialCheckinVerUbicacionTienda.name,
                    parentKeys: dashboard.parentKeys,
                    refreshOnInit: true,
                    latitudRecordIndex: 11,
                    longitudRecordIndex: 12,
                    tabLabel: "Ubicaci\xf3n Tienda",
                    tabIcon: (0, $jIc5b.default),
                    enableView: false,
                    enableAdd: false,
                    enableEdit: false,
                    enableDelete: false,
                    showActions: true,
                    modalFormSize: "98%"
                },
                mapHeight: "50vh"
            }, `mapa-ver-ubicacion-checkin${entity.def.name}`)
        });
        return false;
    }
};

});

parcelRegister("gAdar", function(module, exports) {

$parcel$export(module.exports, "ACTVerHistorialUbicacion", () => $2305c282e826ff0d$export$db5dd5cff98c8743);

var $ayMG0 = parcelRequire("ayMG0");

var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");

var $7UO1x = parcelRequire("7UO1x");
const $2305c282e826ff0d$export$db5dd5cff98c8743 = {
    name: 'ACTVerHistorialUbicacion',
    label: 'Ver Historial Ubicaciones',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Ver Historial Ubicaciones"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    minSelectedRecords: 1,
    maxSelectedRecords: 1,
    views: [
        'dash_brwPersonalLocalizacionPresentes',
        'dash_brwPersonalLocalizacionAusentes',
        'dash_brwPersonalLocalizacionSinReportar',
        'dash_brwPersonalSinCheckin',
        'dash_brwPersonalSinCheckinSupervisor',
        'dash_brwUbicacionPersonal'
    ],
    showActionInViewMode: true,
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const parent = entity;
        const dashboard = new (0, $7UO1x.Dashboard)(entity.API.client);
        dashboard.parentKeys = parent.parentKeys;
        dashboard.def.columns.c_personal_id.value = selectedKeys[0].c_personal_id || '';
        await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                            size: "1.5rem",
                            stroke: "1.5"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            fw: "700",
                            children: "Historial de Ubicaciones"
                        })
                    ]
                }),
                size: "fullscreen"
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: entity.API.client,
                entityConstructor: ()=>dashboard,
                formMode: "view",
                viewName: "dash_brwPersonalHistorialUbicaciones",
                refreshOnInit: true,
                title: "Historial de Ubicaciones",
                enableAdd: false,
                enableDelete: false,
                enableEdit: false,
                enableView: false,
                showActions: true,
                selectionMode: "single"
            }, "historial-ubicaciones")
        });
        return false;
    }
};

});

parcelRegister("1Dhl4", function(module, exports) {

$parcel$export(module.exports, "ACTVerHistorialVerUbicacion", () => $2df8bf89fd8f3d06$export$27f650e65eeac7c4);

var $ayMG0 = parcelRequire("ayMG0");

var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");
var $4d0Rl = parcelRequire("4d0Rl");

var $7UO1x = parcelRequire("7UO1x");
const $2df8bf89fd8f3d06$export$27f650e65eeac7c4 = {
    name: 'ACTVerHistorialVerUbicacion',
    label: "Ver Ubicaci\xf3n",
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Ver Ubicaci\xf3n"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    minSelectedRecords: 1,
    maxSelectedRecords: 1,
    views: [
        'dash_brwPersonalHistorialUbicaciones'
    ],
    showActionInViewMode: true,
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const parent = entity;
        const dashboard = new (0, $7UO1x.Dashboard)(entity.API.client);
        dashboard.parentKeys = parent.parentKeys;
        dashboard.def.columns.c_datos_geolocation_id.value = selectedKeys[0].c_datos_geolocation_id || '';
        await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                            size: "1.5rem",
                            stroke: "1.5"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            fw: "700",
                            children: "Historial de Ubicaciones"
                        })
                    ]
                }),
                size: "fullscreen"
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.MultiDataMapForm), {
                autoFocus: true,
                formMode: "edit",
                title: "Historial de Ubicaciones",
                dataMapView1: {
                    entity: dashboard,
                    viewName: dashboard.def.views.dash_brwPersonalHistorialVerUbicacion.name,
                    parentKeys: dashboard.parentKeys,
                    refreshOnInit: true,
                    latitudRecordIndex: 1,
                    longitudRecordIndex: 2,
                    tabLabel: "Historial de Ubicaciones",
                    tabIcon: (0, $4d0Rl.default),
                    enableView: false,
                    enableAdd: false,
                    enableEdit: false,
                    enableDelete: false,
                    showActions: true,
                    modalFormSize: "98%"
                },
                mapHeight: "50vh"
            }, `mapa-ver-ubicacion-personal-${entity.def.name}`)
        });
        return false;
    }
};

});

parcelRegister("afatt", function(module, exports) {

$parcel$export(module.exports, "ACTVerLogins", () => $b5b85288d89db468$export$9e54822e6cdcfb0a);

var $ayMG0 = parcelRequire("ayMG0");

var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");

var $7UO1x = parcelRequire("7UO1x");
const $b5b85288d89db468$export$9e54822e6cdcfb0a = {
    name: 'ACTVerLogins',
    label: "Ver Inicios de Sesi\xf3n",
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Ver Inicios de Sesi\xf3n"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    minSelectedRecords: 1,
    maxSelectedRecords: 1,
    views: [
        'dash_brwPersonalLocalizacionPresentes',
        'dash_brwPersonalLocalizacionAusentes',
        'dash_brwPersonalLocalizacionSinReportar',
        'dash_brwPersonalSinCheckin',
        'dash_brwPersonalSinCheckinSupervisor',
        'dash_brwUbicacionPersonal'
    ],
    showActionInViewMode: true,
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const parent = entity;
        const dashboard = new (0, $7UO1x.Dashboard)(entity.API.client);
        dashboard.parentKeys = parent.parentKeys;
        dashboard.def.columns.c_personal_id.value = selectedKeys[0].c_personal_id || '';
        await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                            size: "1.5rem",
                            stroke: "1.5"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            fw: "700",
                            children: "Inicios de Sesi\xf3n"
                        })
                    ]
                }),
                size: "fullscreen"
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: entity.API.client,
                entityConstructor: ()=>dashboard,
                formMode: "view",
                viewName: "dash_brwPersonalLogins",
                refreshOnInit: true,
                title: "Inicios de Sesi\xf3n",
                enableAdd: false,
                enableDelete: false,
                enableEdit: false,
                enableView: false,
                showActions: true,
                selectionMode: "single"
            }, "personal-logins")
        });
        return false;
    }
};

});

parcelRegister("H5yKj", function(module, exports) {

$parcel$export(module.exports, "ACTVerPersonalTienda", () => $5d6de9745e39a698$export$51307592b3d78d06);

var $ayMG0 = parcelRequire("ayMG0");

var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");
const $5d6de9745e39a698$export$51307592b3d78d06 = {
    name: 'ACTVerPersonalTienda',
    label: 'Ver Personal',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Ver Personal"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    showActionInViewMode: true,
    views: [
        'dash_brwTiendas'
    ],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const parent = entity;
        parent.def.columns.c_tienda_id.value = selectedKeys[0].c_tienda_id || '';
        await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                            size: "1.5rem",
                            stroke: "1.5"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            fw: "700",
                            children: "Personal"
                        })
                    ]
                }),
                size: "xl"
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: entity.API.client,
                entityConstructor: ()=>parent,
                formMode: "edit",
                viewName: "dash_brwTiendasPersonal",
                refreshOnInit: true,
                enableAdd: false,
                enableDelete: false,
                enableEdit: false,
                enableView: false,
                title: "Ver Personal",
                selectionMode: "single"
            }, "personal-tienda")
        });
        return false;
    }
};

});

parcelRegister("4k2Xd", function(module, exports) {

$parcel$export(module.exports, "ACTVerReportes", () => $187d9a02ac3ab6fd$export$1109e5b145072637);

var $ayMG0 = parcelRequire("ayMG0");

var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");

var $goQRU = parcelRequire("goQRU");
const $187d9a02ac3ab6fd$export$1109e5b145072637 = {
    name: 'ACTVerReportes',
    label: 'Ver Reportes',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Ver Reportes"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    minSelectedRecords: 1,
    maxSelectedRecords: 1,
    views: [
        'dash_brwPersonalLocalizacionPresentes',
        'dash_brwPersonalLocalizacionAusentes',
        'dash_brwPersonalLocalizacionSinReportar',
        'dash_brwPersonalSinCheckin',
        'dash_brwPersonalSinCheckinSupervisor',
        'dash_brwUbicacionPersonal'
    ],
    showActionInViewMode: true,
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const parent = entity;
        const reportes = new (0, $goQRU.DatosServiciosAutorizacionProductos)(entity.API.client);
        reportes.parentKeys = parent.parentKeys;
        reportes.def.columns.c_personal_id.value = selectedKeys[0].c_personal_id || '';
        await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                            size: "1.5rem",
                            stroke: "1.5"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            fw: "700",
                            children: "Reportes"
                        })
                    ]
                }),
                size: "fullscreen"
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: entity.API.client,
                entityConstructor: ()=>reportes,
                formMode: "view",
                viewName: "dasp_brwAutorizacionGeneralPorPersonal",
                refreshOnInit: true,
                title: "Reportes",
                enableAdd: false,
                enableDelete: false,
                enableEdit: false,
                enableView: false,
                showActions: true,
                selectionMode: "single"
            }, "personal-reportes")
        });
        return false;
    }
};

});
parcelRegister("goQRU", function(module, exports) {

$parcel$export(module.exports, "DatosServiciosAutorizacionProductos", () => $2ed51d8a05d94305$export$241a0fae2c625957);

var $49qEn = parcelRequire("49qEn");

var $35ntO = parcelRequire("35ntO");

var $9Aw8P = parcelRequire("9Aw8P");
const $2ed51d8a05d94305$export$5f5157b8697a5985 = (0, $35ntO.default);
const $2ed51d8a05d94305$export$1155456aa744427a = "* Datos Servicios Autorizaci\xf3n";

class $2ed51d8a05d94305$export$241a0fae2c625957 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $9Aw8P.DatosServiciosAutorizacionProductosDef)(), parentKeys);
        this.Form = (parcelRequire("gePgJ")).then((module)=>module.DatosServiciosAutorizacionProductosForm);
        this.Title = "Autorizaci\xf3n de Reportes";
        this.HelpText = $2ed51d8a05d94305$export$1155456aa744427a;
        this.Icon = $2ed51d8a05d94305$export$5f5157b8697a5985;
    }
}

});
parcelRegister("9Aw8P", function(module, exports) {

$parcel$export(module.exports, "DatosServiciosAutorizacionProductosDef", () => $6d410475e47e2399$export$6fa1f585f1e7285f);

var $49qEn = parcelRequire("49qEn");

var $kd5or = parcelRequire("kd5or");

var $9u8qf = parcelRequire("9u8qf");

var $7LP39 = parcelRequire("7LP39");

var $4usKR = parcelRequire("4usKR");

var $1OscC = parcelRequire("1OscC");

var $nttT0 = parcelRequire("nttT0");

var $6awxZ = parcelRequire("6awxZ");

var $hHIQ3 = parcelRequire("hHIQ3");

var $2rhA4 = parcelRequire("2rhA4");

var $lEZ9d = parcelRequire("lEZ9d");

var $hulZ3 = parcelRequire("hulZ3");

var $lHBTA = parcelRequire("lHBTA");

var $ctNgf = parcelRequire("ctNgf");

var $8qLfX = parcelRequire("8qLfX");

var $JZXJt = parcelRequire("JZXJt");

var $5e4FV = parcelRequire("5e4FV");
const $6d410475e47e2399$var$columns = ()=>({
        c_datos_servicio_id: new (0, $49qEn.EntityColumn)({
            name: 'c_datos_servicio_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PKAutonum,
            prompt: 'Datos Servicio Id'
        }),
        c_datos_servicio_registro_id: new (0, $49qEn.EntityColumn)({
            name: 'c_datos_servicio_registro_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Datos Servicio Registro Id'
        }),
        c_datos_servicio_set_id: new (0, $49qEn.EntityColumn)({
            name: 'c_datos_servicio_set_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Datos Servicio Set Id'
        }),
        c_visita_id: new (0, $49qEn.EntityColumn)({
            name: 'c_visita_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Visita Id'
        }),
        c_servicio_id: new (0, $49qEn.EntityColumn)({
            name: 'c_servicio_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Servicio Id'
        }),
        c_paso_id: new (0, $49qEn.EntityColumn)({
            name: 'c_paso_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Paso Id'
        }),
        c_tienda_id: new (0, $49qEn.EntityColumn)({
            name: 'c_tienda_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Tienda Id'
        }),
        c_producto_id: new (0, $49qEn.EntityColumn)({
            name: 'c_producto_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Producto Id'
        }),
        c_cliente_id: new (0, $49qEn.EntityColumn)({
            name: 'c_cliente_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Cliente Id'
        }),
        c_personal_id: new (0, $49qEn.EntityColumn)({
            name: 'c_personal_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Personal Id'
        }),
        c_relevamiento_status_id: new (0, $49qEn.EntityColumn)({
            name: 'c_relevamiento_status_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Relevamiento Status Id'
        }),
        c_autorizacion_directa_status_id: new (0, $49qEn.EntityColumn)({
            name: 'c_autorizacion_directa_status_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Autorizacion Directa Status Id'
        }),
        dt_fecha_hora_realizado: new (0, $49qEn.EntityColumn)({
            name: 'dt_fecha_hora_realizado',
            type: 'datetime',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Fecha Hora Realizado'
        }),
        bt_encabezado: new (0, $49qEn.EntityColumn)({
            name: 'bt_encabezado',
            type: 'bit',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Encabezado'
        }),
        vc_personal: new (0, $49qEn.EntityColumn)({
            name: 'vc_personal',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Personal'
        }),
        vc_tienda: new (0, $49qEn.EntityColumn)({
            name: 'vc_tienda',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Tienda'
        }),
        vc_paso: new (0, $49qEn.EntityColumn)({
            name: 'vc_paso',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Paso'
        }),
        vc_cliente: new (0, $49qEn.EntityColumn)({
            name: 'vc_cliente',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Cliente'
        }),
        c_tipo_contenido_id: new (0, $49qEn.EntityColumn)({
            name: 'c_tipo_contenido_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Tipo Contenido'
        }),
        vc_contenido: new (0, $49qEn.EntityColumn)({
            name: 'vc_contenido',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Contenido'
        }),
        vc_titulo_registro: new (0, $49qEn.EntityColumn)({
            name: 'vc_titulo_registro',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "T\xedtulo Registro"
        }),
        c_personal_filtro_id: new (0, $49qEn.EntityColumn)({
            name: 'c_personal_filtro_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Personal Filtro Id'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $6d410475e47e2399$var$views = ()=>({
        dasp_brwStandard: {
            name: 'dasp_brwStandard',
            keyMappings: {
                c_datos_servicio_id: 0
            }
        },
        dasp_brwAutorizacionProductos: {
            name: 'dasp_brwAutorizacionProductos',
            keyMappings: {
                c_datos_servicio_id: 0
            }
        },
        dasp_brwAutorizacionClienteProducto: {
            name: 'dasp_brwAutorizacionClienteProducto',
            keyMappings: {
                c_visita_id: 0,
                c_cliente_id: 1,
                c_producto_id: 2
            }
        },
        dasp_brwAutorizacionClienteProductoServicio: {
            name: 'dasp_brwAutorizacionClienteProductoServicio',
            keyMappings: {
                c_datos_servicio_id: 0
            }
        },
        dasp_brwAutorizacionVisitaProductos: {
            name: 'dasp_brwAutorizacionVisitaProductos',
            keyMappings: {
                c_datos_servicio_id: 0
            }
        },
        dasp_brwAutorizacionVisitaServicios: {
            name: 'dasp_brwAutorizacionVisitaServicios',
            keyMappings: {
                c_datos_servicio_id: 0
            }
        },
        dasp_brwAutorizacionGeneral: {
            name: 'dasp_brwAutorizacionGeneral',
            keyMappings: {
                c_cliente_id: 12,
                c_servicio_id: 13,
                c_producto_id: 14,
                c_visita_id: 15,
                c_paso_id: 16,
                c_datos_servicio_set_id: 17
            },
            gridColumnsOverrides: (0, $5e4FV.AutorizacionGeneralViewColumnsOverrides),
            FiltersEntity: (client, parentKeys)=>new (0, $2rhA4.DatosServiciosAutorizacionProductosFilters)(client, parentKeys)
        },
        dasp_brwAutorizacionGeneralAppSupervisor: {
            name: 'dasp_brwAutorizacionGeneralAppSupervisor',
            keyMappings: {
                c_cliente_id: 12,
                c_servicio_id: 13,
                c_producto_id: 14,
                c_visita_id: 15,
                c_paso_id: 16,
                c_datos_servicio_set_id: 17
            },
            gridColumnsOverrides: (0, $5e4FV.AutorizacionGeneralViewColumnsOverrides),
            FiltersEntity: (client, parentKeys)=>new (0, $hHIQ3.DatosServiciosAutorizacionProductosAppSupervisorFilters)(client, parentKeys)
        },
        dasp_brwAutorizacionGeneralPorPersonal: {
            name: 'dasp_brwAutorizacionGeneralPorPersonal',
            keyMappings: {
                c_cliente_id: 12,
                c_servicio_id: 13,
                c_producto_id: 14,
                c_visita_id: 15,
                c_paso_id: 16,
                c_datos_servicio_set_id: 17
            },
            gridColumnsOverrides: (0, $5e4FV.AutorizacionGeneralViewColumnsOverrides),
            FiltersEntity: (client, parentKeys)=>new (0, $2rhA4.DatosServiciosAutorizacionProductosFilters)(client, parentKeys)
        }
    });
const $6d410475e47e2399$var$lookups = ()=>({
        'ServiciosConfiguracion': {
            name: 'ServiciosConfiguracion',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $nttT0.ServiciosConfiguracion)(client, parentKeys)
        },
        'Productos': {
            name: 'Productos',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $4usKR.Productos)(client, parentKeys)
        },
        'Tiendas': {
            name: 'Tiendas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $6awxZ.Tiendas)(client, parentKeys)
        },
        'Clientes': {
            name: 'Clientes',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $9u8qf.Clientes)(client, parentKeys)
        },
        'Personal': {
            name: 'Personal',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $7LP39.Personal)(client, parentKeys)
        },
        'VisitasATiendas': {
            name: 'VisitasATiendas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $1OscC.VisitasATiendas)(client, parentKeys)
        },
        'AutorizacionDirecta': {
            name: 'AutorizacionDirecta',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $kd5or.estAutorizacionDirecta)(client, parentKeys)
        }
    });
const $6d410475e47e2399$var$procs = ()=>({
        dasp_AutorizarReporte: {
            name: 'dasp_AutorizarReporte'
        },
        dasp_AutorizarReporteCompleto: {
            name: 'dasp_AutorizarReporteCompleto'
        },
        dasp_RechazarReporte: {
            name: 'dasp_RechazarReporte'
        },
        dasp_RechazarReporteCompleto: {
            name: 'dasp_RechazarReporteCompleto'
        },
        dasp_ObtenerDetalles: {
            name: 'dasp_ObtenerDetalles'
        }
    });
const $6d410475e47e2399$var$clientActions = ()=>({
        ACTEditarReporte: (0, $lHBTA.ACTEditarReporte),
        ACTVerDetalles: (0, $JZXJt.ACTVerDetalles),
        ACTAutorizarReporte: (0, $lEZ9d.ACTAutorizarReporte),
        ACTAutorizarReporteCompleto: (0, $hulZ3.ACTAutorizarReporteCompleto),
        ACTRechazarReporte: (0, $ctNgf.ACTRechazarReporte),
        ACTRechazarReporteCompleto: (0, $8qLfX.ACTRechazarReporteCompleto)
    });
class $6d410475e47e2399$export$6fa1f585f1e7285f extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('DatosServiciosAutorizacionProductos'), this.columns = $6d410475e47e2399$var$columns(), this.views = $6d410475e47e2399$var$views(), this.lookups = $6d410475e47e2399$var$lookups(), this.procs = $6d410475e47e2399$var$procs(), this.clientActions = $6d410475e47e2399$var$clientActions();
    }
}

});
parcelRegister("kd5or", function(module, exports) {

$parcel$export(module.exports, "estAutorizacionDirecta", () => $2b21ab42c5ab8f45$export$65064168750b8dfc);

var $49qEn = parcelRequire("49qEn");

var $iIAH4 = parcelRequire("iIAH4");
const $2b21ab42c5ab8f45$export$a91bcd7a59bafbe9 = (0, $iIAH4.default);
const $2b21ab42c5ab8f45$export$fbf1ca2bd4dafa40 = "* Valores para estado Autorizacion Directa";
class $2b21ab42c5ab8f45$export$65064168750b8dfc extends (0, $49qEn.StatusValues) {
    constructor(client, parentKeys = {}){
        super(client, parentKeys);
        this.def.columns.c_status_id.value = "AutorizacionDirecta";
        this.def.columns.c_status_id.defaultValue = "AutorizacionDirecta";
        this.Title = "Estado Autorizacion Directa";
        this.HelpText = $2b21ab42c5ab8f45$export$fbf1ca2bd4dafa40;
        this.Icon = $2b21ab42c5ab8f45$export$a91bcd7a59bafbe9;
    }
}

});

parcelRegister("hHIQ3", function(module, exports) {

$parcel$export(module.exports, "DatosServiciosAutorizacionProductosAppSupervisorFilters", () => $dbd0fc77c7e22e9a$export$dfe773316ad9e116);

var $49qEn = parcelRequire("49qEn");

var $lynfu = parcelRequire("lynfu");

class $dbd0fc77c7e22e9a$export$dfe773316ad9e116 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $lynfu.DatosServiciosAutorizacionProductosAppSupervisorFiltersDef)(), parentKeys);
        this.Form = (parcelRequire("9Oqvc")).then((module)=>module.DatosServiciosAutorizacionProductosAppSupervisorFiltersForms);
        this.Title = "Filtros de Datos Servicios";
    }
}

});
parcelRegister("lynfu", function(module, exports) {

$parcel$export(module.exports, "DatosServiciosAutorizacionProductosAppSupervisorFiltersDef", () => $1133b9efa078deab$export$fb3a9362111ecd7d);

var $49qEn = parcelRequire("49qEn");

var $kd5or = parcelRequire("kd5or");

var $9u8qf = parcelRequire("9u8qf");

var $7LP39 = parcelRequire("7LP39");

var $4usKR = parcelRequire("4usKR");

var $gKBQM = parcelRequire("gKBQM");

var $6awxZ = parcelRequire("6awxZ");
const $1133b9efa078deab$var$currentDate = new Date();
const $1133b9efa078deab$var$columns = ()=>({
        vc_clientes: new (0, $49qEn.EntityColumn)({
            name: 'vc_clientes',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Clientes',
            isArray: true
        }),
        vc_productos: new (0, $49qEn.EntityColumn)({
            name: 'vc_productos',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Productos',
            isArray: true
        }),
        vc_personales: new (0, $49qEn.EntityColumn)({
            name: 'vc_personales',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Personal',
            isArray: true
        }),
        vc_tiendas: new (0, $49qEn.EntityColumn)({
            name: 'vc_tiendas',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Tiendas',
            isArray: true
        }),
        vc_servicios: new (0, $49qEn.EntityColumn)({
            name: 'vc_servicios',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Servicios',
            isArray: true
        }),
        d_fecha_visita_desde: new (0, $49qEn.EntityColumn)({
            name: 'd_fecha_visita_desde',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Fecha Visita Desde',
            defaultValue: $1133b9efa078deab$var$currentDate
        }),
        d_fecha_visita_hasta: new (0, $49qEn.EntityColumn)({
            name: 'd_fecha_visita_hasta',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Fecha Visita Hasta',
            defaultValue: $1133b9efa078deab$var$currentDate
        }),
        d_fecha_realizado_desde: new (0, $49qEn.EntityColumn)({
            name: 'd_fecha_realizado_desde',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Fecha Hora Realizado Desde',
            defaultValue: $1133b9efa078deab$var$currentDate
        }),
        d_fecha_realizado_hasta: new (0, $49qEn.EntityColumn)({
            name: 'd_fecha_realizado_hasta',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Fecha Hora Realizado Hasta',
            defaultValue: $1133b9efa078deab$var$currentDate
        }),
        c_autorizacion_directa_status_id: new (0, $49qEn.EntityColumn)({
            name: 'c_autorizacion_directa_status_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: "Autorizaci\xf3n",
            defaultValue: 'PENDIENTE'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $1133b9efa078deab$var$lookups = ()=>({
        'Clientes': {
            name: 'Clientes',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 2
            },
            entityConstructor: (client, parentKeys)=>new (0, $9u8qf.Clientes)(client, parentKeys)
        },
        'Productos': {
            name: 'Productos',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 4
            },
            entityConstructor: (client, parentKeys)=>new (0, $4usKR.Productos)(client, parentKeys)
        },
        'Personal': {
            name: 'Personal',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $7LP39.Personal)(client, parentKeys)
        },
        'Tiendas': {
            name: 'Tiendas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 4
            },
            entityConstructor: (client, parentKeys)=>new (0, $6awxZ.Tiendas)(client, parentKeys)
        },
        'Servicios': {
            name: 'Servicios',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 2
            },
            entityConstructor: (client, parentKeys)=>new (0, $gKBQM.Servicios)(client, parentKeys)
        },
        'AutorizacionDirecta': {
            name: 'AutorizacionDirecta',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $kd5or.estAutorizacionDirecta)(client, parentKeys)
        }
    });
class $1133b9efa078deab$export$fb3a9362111ecd7d extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('DatosServiciosAutorizacionProductosAppSupervisorFilters'), this.columns = $1133b9efa078deab$var$columns(), this.views = {}, this.lookups = $1133b9efa078deab$var$lookups();
    }
}

});

parcelRegister("9Oqvc", function(module, exports) {
module.exports = import("lv6YO").then(()=>parcelRequire('krAr6'));

});


parcelRegister("2rhA4", function(module, exports) {

$parcel$export(module.exports, "DatosServiciosAutorizacionProductosFilters", () => $71b0ceb95176f0cb$export$cb65f00129e4b73e);

var $49qEn = parcelRequire("49qEn");

var $kvkKA = parcelRequire("kvkKA");

class $71b0ceb95176f0cb$export$cb65f00129e4b73e extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $kvkKA.DatosServiciosAutorizacionProductosFiltersDef)(), parentKeys);
        this.Form = (parcelRequire("hNoQ7")).then((module)=>module.DatosServiciosAutorizacionProductosFiltersForms);
        this.Title = "Filtros de Datos Servicios";
    }
}

});
parcelRegister("kvkKA", function(module, exports) {

$parcel$export(module.exports, "DatosServiciosAutorizacionProductosFiltersDef", () => $e86458cc52c498d9$export$97e882090057c3ef);

var $49qEn = parcelRequire("49qEn");

var $kd5or = parcelRequire("kd5or");

var $9u8qf = parcelRequire("9u8qf");

var $7LP39 = parcelRequire("7LP39");

var $4usKR = parcelRequire("4usKR");

var $gKBQM = parcelRequire("gKBQM");

var $6awxZ = parcelRequire("6awxZ");
const $e86458cc52c498d9$var$currentDate = new Date();
const $e86458cc52c498d9$var$columns = ()=>({
        vc_clientes: new (0, $49qEn.EntityColumn)({
            name: 'vc_clientes',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Clientes',
            isArray: true
        }),
        vc_productos: new (0, $49qEn.EntityColumn)({
            name: 'vc_productos',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Productos',
            isArray: true
        }),
        vc_personales: new (0, $49qEn.EntityColumn)({
            name: 'vc_personales',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Personal',
            isArray: true
        }),
        vc_tiendas: new (0, $49qEn.EntityColumn)({
            name: 'vc_tiendas',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Tiendas',
            isArray: true
        }),
        vc_servicios: new (0, $49qEn.EntityColumn)({
            name: 'vc_servicios',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Servicios',
            isArray: true
        }),
        d_fecha_visita_desde: new (0, $49qEn.EntityColumn)({
            name: 'd_fecha_visita_desde',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Fecha Visita Desde',
            defaultValue: $e86458cc52c498d9$var$currentDate
        }),
        d_fecha_visita_hasta: new (0, $49qEn.EntityColumn)({
            name: 'd_fecha_visita_hasta',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Fecha Visita Hasta',
            defaultValue: $e86458cc52c498d9$var$currentDate
        }),
        d_fecha_realizado_desde: new (0, $49qEn.EntityColumn)({
            name: 'd_fecha_realizado_desde',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Fecha Hora Realizado Desde',
            defaultValue: $e86458cc52c498d9$var$currentDate
        }),
        d_fecha_realizado_hasta: new (0, $49qEn.EntityColumn)({
            name: 'd_fecha_realizado_hasta',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Fecha Hora Realizado Hasta',
            defaultValue: $e86458cc52c498d9$var$currentDate
        }),
        c_autorizacion_directa_status_id: new (0, $49qEn.EntityColumn)({
            name: 'c_autorizacion_directa_status_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: "Autorizaci\xf3n",
            defaultValue: 'PENDIENTE'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $e86458cc52c498d9$var$lookups = ()=>({
        'Clientes': {
            name: 'Clientes',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 2
            },
            entityConstructor: (client, parentKeys)=>new (0, $9u8qf.Clientes)(client, parentKeys)
        },
        'Productos': {
            name: 'Productos',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 4
            },
            entityConstructor: (client, parentKeys)=>new (0, $4usKR.Productos)(client, parentKeys)
        },
        'Personal': {
            name: 'Personal',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $7LP39.Personal)(client, parentKeys)
        },
        'Tiendas': {
            name: 'Tiendas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 4
            },
            entityConstructor: (client, parentKeys)=>new (0, $6awxZ.Tiendas)(client, parentKeys)
        },
        'Servicios': {
            name: 'Servicios',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 2
            },
            entityConstructor: (client, parentKeys)=>new (0, $gKBQM.Servicios)(client, parentKeys)
        },
        'AutorizacionDirecta': {
            name: 'AutorizacionDirecta',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $kd5or.estAutorizacionDirecta)(client, parentKeys)
        }
    });
class $e86458cc52c498d9$export$97e882090057c3ef extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('DatosServiciosAutorizacionProductosFilters'), this.columns = $e86458cc52c498d9$var$columns(), this.views = {}, this.lookups = $e86458cc52c498d9$var$lookups();
    }
}

});

parcelRegister("hNoQ7", function(module, exports) {
module.exports = import("iiYJ7").then(()=>parcelRequire('3laAI'));

});


parcelRegister("lEZ9d", function(module, exports) {

$parcel$export(module.exports, "ACTAutorizarReporte", () => $74e5e305cb5ff894$export$ab9881481affeb13);

var $ayMG0 = parcelRequire("ayMG0");

var $gU5rH = parcelRequire("gU5rH");
var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");
const $74e5e305cb5ff894$export$ab9881481affeb13 = {
    name: 'ACTAutorizarReporte',
    label: 'Autorizar Reporte',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Autorizar Reporte"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    showActionInViewMode: true,
    views: [
        'dasp_brwAutorizacionClienteProductoServicio',
        'dasp_brwAutorizacionVisitaProductos',
        'dasp_brwAutorizacionVisitaServicios'
    ],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const datosServicioAutorizacionProductos = entity;
        const procParms = {
            c_datos_servicio_id: selectedKeys?.[0]?.['c_datos_servicio_id'] ?? ''
        };
        let errores = '';
        if (!procParms.c_datos_servicio_id) errores = "Los registros seleccionados son inv\xe1lidos";
        if (errores) await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                            size: "1.5rem",
                            stroke: "1.5"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            fw: "700",
                            children: "ERROR"
                        })
                    ]
                })
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        size: "sm",
                        mb: "xs",
                        children: errores
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                        mt: "xs",
                        position: "right",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                            onClick: async ()=>await modal.close(),
                            children: "Cerrar"
                        })
                    })
                ]
            })
        });
        else {
            const abort_controller = new AbortController();
            await modal.open({
                modalProps: {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        fw: "700",
                        children: "Autorizar Reporte"
                    })
                },
                focusOnClosed: element,
                content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.ConfirmAndExecutePanel), {
                    content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        size: "sm",
                        mb: "xs",
                        children: "Va a autorizar el reporte. \xbfEst\xe1 seguro?"
                    }),
                    operation: "proc",
                    onCancel: async ()=>{
                        await abort_controller.abort();
                        await modal.close();
                    },
                    onOK: async ()=>{
                        const reportes = (0, $49qEn.Entity).clone(datosServicioAutorizacionProductos);
                        reportes.def.columns.c_datos_servicio_id.value = datosServicioAutorizacionProductos.parentKeys[reportes.def.columns.c_datos_servicio_id.name];
                        const result = await reportes.API.executeProcess(datosServicioAutorizacionProductos.def.procs.dasp_AutorizarReporte, procParms, abort_controller.signal, selectedKeys);
                        if (!result.Failed) {
                            if (onClose) await onClose();
                            await modal.close();
                        }
                        return result;
                    }
                })
            });
        }
        return false;
    }
};

});

parcelRegister("hulZ3", function(module, exports) {

$parcel$export(module.exports, "ACTAutorizarReporteCompleto", () => $7ad1a8db2f87cc73$export$bae6bb3945dd7269);

var $ayMG0 = parcelRequire("ayMG0");

var $gU5rH = parcelRequire("gU5rH");
var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");
const $7ad1a8db2f87cc73$export$bae6bb3945dd7269 = {
    name: 'ACTAutorizarReporteCompleto',
    label: 'Autorizar Reporte',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Autorizar Reporte"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    showActionInViewMode: true,
    views: [
        'dasp_brwAutorizacionGeneral',
        'dasp_brwAutorizacionGeneralAppSupervisor'
    ],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const datosServicioAutorizacionProductos = entity;
        const procParms = {
            c_cliente_id: selectedKeys?.[0]?.['c_cliente_id'] ?? '',
            c_servicio_id: selectedKeys?.[0]?.['c_servicio_id'] ?? '',
            c_producto_id: selectedKeys?.[0]?.['c_producto_id'] ?? '',
            c_visita_id: selectedKeys?.[0]?.['c_visita_id'] ?? '',
            c_datos_servicio_set_id: selectedKeys?.[0]?.['c_datos_servicio_set_id'] ?? ''
        };
        let errores = '';
        if (!procParms.c_cliente_id || !procParms.c_servicio_id || !procParms.c_visita_id) errores = "Los registros seleccionados son inv\xe1lidos";
        if (errores) await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                            size: "1.5rem",
                            stroke: "1.5"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            fw: "700",
                            children: "ERROR"
                        })
                    ]
                })
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        size: "sm",
                        mb: "xs",
                        children: errores
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                        mt: "xs",
                        position: "right",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                            onClick: async ()=>await modal.close(),
                            children: "Cerrar"
                        })
                    })
                ]
            })
        });
        else {
            const abort_controller = new AbortController();
            await modal.open({
                modalProps: {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        fw: "700",
                        children: "Autorizar Reporte"
                    })
                },
                focusOnClosed: element,
                content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.ConfirmAndExecutePanel), {
                    content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        size: "sm",
                        mb: "xs",
                        children: "Va a autorizar el reporte. \xbfEst\xe1 seguro?"
                    }),
                    operation: "proc",
                    onCancel: async ()=>{
                        await abort_controller.abort();
                        await modal.close();
                    },
                    onOK: async ()=>{
                        const reportes = (0, $49qEn.Entity).clone(datosServicioAutorizacionProductos);
                        reportes.def.columns.c_cliente_id.value = datosServicioAutorizacionProductos.parentKeys[reportes.def.columns.c_cliente_id.name];
                        reportes.def.columns.c_servicio_id.value = datosServicioAutorizacionProductos.parentKeys[reportes.def.columns.c_servicio_id.name];
                        reportes.def.columns.c_producto_id.value = datosServicioAutorizacionProductos.parentKeys[reportes.def.columns.c_producto_id.name];
                        reportes.def.columns.c_visita_id.value = datosServicioAutorizacionProductos.parentKeys[reportes.def.columns.c_visita_id.name];
                        const result = await reportes.API.executeProcess(datosServicioAutorizacionProductos.def.procs.dasp_AutorizarReporteCompleto, procParms, abort_controller.signal, selectedKeys);
                        if (!result.Failed) {
                            if (onClose) await onClose();
                            await modal.close();
                        }
                        return result;
                    }
                })
            });
        }
        return false;
    }
};

});

parcelRegister("lHBTA", function(module, exports) {

$parcel$export(module.exports, "ACTEditarReporte", () => $3d5d71ad9d27131e$export$64d3345c18b74ec3);

var $ayMG0 = parcelRequire("ayMG0");

var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $9CIrM = parcelRequire("9CIrM");
const $3d5d71ad9d27131e$export$64d3345c18b74ec3 = {
    name: 'ACTEditarReporte',
    label: 'Editar',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Editar"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    showActionInViewMode: true,
    views: [
        'dasp_brwAutorizacionGeneral',
        'dasp_brwAutorizacionGeneralAppSupervisor'
    ],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const datosServiciosGestionProductos = new (0, $9CIrM.DatosServiciosGestionServicios)(entity.API.client);
        datosServiciosGestionProductos.def.columns.c_visita_id.value = selectedKeys[0].c_visita_id || '';
        datosServiciosGestionProductos.def.columns.c_cliente_id.value = selectedKeys[0].c_cliente_id || '';
        datosServiciosGestionProductos.def.columns.c_producto_id.value = selectedKeys[0].c_producto_id || '';
        datosServiciosGestionProductos.def.columns.c_servicio_id.value = selectedKeys[0].c_servicio_id || '';
        datosServiciosGestionProductos.def.columns.c_paso_id.value = selectedKeys[0].c_paso_id || '';
        datosServiciosGestionProductos.def.columns.c_datos_servicio_id.value = selectedKeys[0].c_paso_id || '';
        datosServiciosGestionProductos.def.columns.c_datos_servicio_set_id.value = selectedKeys[0].c_datos_servicio_set_id || '';
        await (0, $49qEn.openEntityForm)({
            modals: modal,
            formProps: {
                entity: datosServiciosGestionProductos,
                initialFormMode: 'edit',
                getDataOnInit: true
            },
            modalFormSize: 'xl',
            handleModalSaved: async ()=>{
                await modal.close();
                if (onClose) await onClose();
            },
            handleModalCancel: async ()=>{
                await modal.close();
                if (onClose) await onClose();
            }
        });
        return false;
    }
};

});
parcelRegister("9CIrM", function(module, exports) {

$parcel$export(module.exports, "DatosServiciosGestionServicios", () => $0d25815611924847$export$bdc466db198e31b9);

var $49qEn = parcelRequire("49qEn");

var $35ntO = parcelRequire("35ntO");

var $4W5FT = parcelRequire("4W5FT");
const $0d25815611924847$export$5f5157b8697a5985 = (0, $35ntO.default);
const $0d25815611924847$export$1155456aa744427a = "* Datos Servicios Gesti\xf3n";

class $0d25815611924847$export$bdc466db198e31b9 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $4W5FT.DatosServiciosGestionServiciosDef)(), parentKeys);
        this.Form = (parcelRequire("5Hr7b")).then((module)=>module.DatosServiciosGestionServiciosForm);
        this.Title = "Gestionar Reporte";
        this.HelpText = $0d25815611924847$export$1155456aa744427a;
        this.Icon = $0d25815611924847$export$5f5157b8697a5985;
    }
}

});
parcelRegister("4W5FT", function(module, exports) {

$parcel$export(module.exports, "DatosServiciosGestionServiciosDef", () => $9e480f94cb222f52$export$fdb6c735f39f032d);

var $49qEn = parcelRequire("49qEn");

var $6Kvmk = parcelRequire("6Kvmk");

var $3DX4j = parcelRequire("3DX4j");
const $9e480f94cb222f52$var$columns = ()=>({
        c_visita_id: new (0, $49qEn.EntityColumn)({
            name: 'c_visita_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Visita Id'
        }),
        c_cliente_id: new (0, $49qEn.EntityColumn)({
            name: 'c_cliente_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Cliente Id'
        }),
        c_producto_id: new (0, $49qEn.EntityColumn)({
            name: 'c_producto_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Producto Id'
        }),
        c_servicio_id: new (0, $49qEn.EntityColumn)({
            name: 'c_servicio_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Servicio Id'
        }),
        c_paso_id: new (0, $49qEn.EntityColumn)({
            name: 'c_paso_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Paso Id'
        }),
        c_datos_servicio_id: new (0, $49qEn.EntityColumn)({
            name: 'c_datos_servicio_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Datos Servicio Id'
        }),
        c_datos_servicio_registro_id: new (0, $49qEn.EntityColumn)({
            name: 'c_datos_servicio_registro_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Datos Servicio Registro Id'
        }),
        c_datos_servicio_set_id: new (0, $49qEn.EntityColumn)({
            name: 'c_datos_servicio_set_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Datos Servicio Set Id'
        }),
        c_tienda_id: new (0, $49qEn.EntityColumn)({
            name: 'c_tienda_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Tienda Id'
        }),
        vc_producto: new (0, $49qEn.EntityColumn)({
            name: 'vc_producto',
            type: 'varchar',
            flags: (0, $49qEn.EntityColumnFlags).None,
            prompt: 'Producto'
        }),
        vc_servicio: new (0, $49qEn.EntityColumn)({
            name: 'vc_servicio',
            type: 'varchar',
            flags: (0, $49qEn.EntityColumnFlags).None,
            prompt: 'Servicio'
        }),
        bt_encabezado: new (0, $49qEn.EntityColumn)({
            name: 'bt_encabezado',
            type: 'bit',
            flags: (0, $49qEn.EntityColumnFlags).None,
            prompt: 'Encabezado'
        }),
        vc_paso: new (0, $49qEn.EntityColumn)({
            name: 'vc_paso',
            type: 'varchar',
            flags: (0, $49qEn.EntityColumnFlags).None,
            prompt: 'Paso'
        }),
        vc_paso_observaciones: new (0, $49qEn.EntityColumn)({
            name: 'vc_paso_observaciones',
            type: 'varchar',
            flags: (0, $49qEn.EntityColumnFlags).None,
            prompt: 'Paso Observaciones'
        }),
        c_listavalores_id: new (0, $49qEn.EntityColumn)({
            name: 'c_listavalores_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Lista Valores'
        }),
        bt_unsolovalor: new (0, $49qEn.EntityColumn)({
            name: 'bt_unsolovalor',
            type: 'bit',
            flags: (0, $49qEn.EntityColumnFlags).None,
            prompt: 'Un solo valor'
        }),
        c_tipoDatoServicios: new (0, $49qEn.EntityColumn)({
            name: 'c_tipoDatoServicios',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Tipo Dato Servicios'
        }),
        vc_valor_texto: new (0, $49qEn.EntityColumn)({
            name: 'vc_valor_texto',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Valor'
        }),
        n_valor_numerico: new (0, $49qEn.EntityColumn)({
            name: 'n_valor_numerico',
            type: 'decimal',
            length: 18,
            scale: 4,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Valor'
        }),
        vc_listavalores: new (0, $49qEn.EntityColumn)({
            name: 'vc_listavalores',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Valor',
            isArray: true
        }),
        vc_fileprocess: new (0, $49qEn.EntityColumn)({
            name: 'vc_fileprocess',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Fileprocess',
            isArray: true
        }),
        vc_tienda: new (0, $49qEn.EntityColumn)({
            name: 'vc_tienda',
            type: 'varchar',
            flags: (0, $49qEn.EntityColumnFlags).None,
            prompt: 'Tienda'
        }),
        dt_fecha_hora_realizado: new (0, $49qEn.EntityColumn)({
            name: 'dt_fecha_hora_realizado',
            type: 'datetime',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Fecha de inicio'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $9e480f94cb222f52$var$views = ()=>({
        dags_brwStandard: {
            name: 'dags_brwStandard',
            keyMappings: {
                c_datos_servicio_id: 0
            }
        },
        dags_brwServicios: {
            name: 'dags_brwServicios',
            keyMappings: {
                c_visita_id: 7,
                c_cliente_id: 8,
                c_producto_id: 9,
                c_servicio_id: 10,
                c_paso_id: 11,
                c_datos_servicio_set_id: 13
            },
            gridColumnsOverrides: (0, $3DX4j.DatosServiciosGestionViewColumnsOverrides)
        }
    });
const $9e480f94cb222f52$var$lookups = ()=>({
        'ListaValores': {
            name: 'ListaValores',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $6Kvmk.ListasValoresItems)(client, parentKeys)
        }
    });
const $9e480f94cb222f52$var$procs = ()=>({
        dags_GenerarDatosServiciosId: {
            name: 'dags_GenerarDatosServiciosId'
        }
    });
class $9e480f94cb222f52$export$fdb6c735f39f032d extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('DatosServiciosGestionServicios'), this.columns = $9e480f94cb222f52$var$columns(), this.views = $9e480f94cb222f52$var$views(), this.lookups = $9e480f94cb222f52$var$lookups(), this.procs = $9e480f94cb222f52$var$procs();
    }
}

});
parcelRegister("3DX4j", function(module, exports) {

$parcel$export(module.exports, "DatosServiciosGestionViewColumnsOverrides", () => $bdb19f0b5131a75b$export$4e1c367089154ed5);

var $ayMG0 = parcelRequire("ayMG0");

var $kPsAn = parcelRequire("kPsAn");
var $9mTYo = parcelRequire("9mTYo");
var $hiGsa = parcelRequire("hiGsa");
var $60Ffz = parcelRequire("60Ffz");

var $3OncY = parcelRequire("3OncY");
function $bdb19f0b5131a75b$export$4e1c367089154ed5(theme) {
    return {
        6: {
            render: (value)=>{
                const val = value;
                if (val.startsWith('*')) {
                    const result = val.replace('*', '').split('--');
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                        align: "flex-start",
                        spacing: "xs",
                        children: result.map((img, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $60Ffz.Tooltip), {
                                label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kPsAn.Card), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hiGsa.Image), {
                                        src: `${(0, $3OncY.API_URL)}/${(0, $3OncY.APP_ID)}/serve/${img.replace('*', '')}`,
                                        alt: `Imagen ${index + 1}`,
                                        maw: "600px",
                                        mt: "auto"
                                    }, index)
                                }),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hiGsa.Image), {
                                    src: `${(0, $3OncY.API_URL)}/${(0, $3OncY.APP_ID)}/serve/${img.replace('*', '')}`,
                                    alt: `Imagen ${index + 1}`,
                                    maw: "30px",
                                    mt: "auto"
                                }, index)
                            }))
                    });
                }
                return val.replace('--', ' ');
            }
        }
    };
}

});


parcelRegister("5Hr7b", function(module, exports) {
module.exports = import("jktSQ").then(()=>parcelRequire('lH32B'));

});



parcelRegister("ctNgf", function(module, exports) {

$parcel$export(module.exports, "ACTRechazarReporte", () => $0b9794ba07ea6515$export$1a7f0864bd478df6);

var $ayMG0 = parcelRequire("ayMG0");

var $gU5rH = parcelRequire("gU5rH");
var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");
const $0b9794ba07ea6515$export$1a7f0864bd478df6 = {
    name: 'ACTRechazarReporte',
    label: 'Rechazar Reporte',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Rechazar Reporte"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    showActionInViewMode: true,
    views: [
        'dasp_brwAutorizacionClienteProductoServicio',
        'dasp_brwAutorizacionVisitaProductos',
        'dasp_brwAutorizacionVisitaServicios'
    ],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const datosServicioAutorizacionProductos = entity;
        const procParms = {
            c_datos_servicio_id: selectedKeys?.[0]?.['c_datos_servicio_id'] ?? ''
        };
        let errores = '';
        if (!procParms.c_datos_servicio_id) errores = "Los registros seleccionados son inv\xe1lidos";
        if (errores) await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                            size: "1.5rem",
                            stroke: "1.5"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            fw: "700",
                            children: "ERROR"
                        })
                    ]
                })
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        size: "sm",
                        mb: "xs",
                        children: errores
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                        mt: "xs",
                        position: "right",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                            onClick: async ()=>await modal.close(),
                            children: "Cerrar"
                        })
                    })
                ]
            })
        });
        else {
            const abort_controller = new AbortController();
            await modal.open({
                modalProps: {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        fw: "700",
                        children: "Autorizar Reporte"
                    })
                },
                focusOnClosed: element,
                content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.ConfirmAndExecutePanel), {
                    content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        size: "sm",
                        mb: "xs",
                        children: "Va a autorizar el reporte. \xbfEst\xe1 seguro?"
                    }),
                    operation: "proc",
                    onCancel: async ()=>{
                        await abort_controller.abort();
                        await modal.close();
                    },
                    onOK: async ()=>{
                        const result = await datosServicioAutorizacionProductos.API.executeProcess(datosServicioAutorizacionProductos.def.procs.dasp_RechazarReporte, procParms, abort_controller.signal);
                        const success = result.Failed === false;
                        if (onClose) await onClose(success);
                        if (success) await modal.close();
                        return result;
                    }
                })
            });
        }
        return false;
    }
};

});

parcelRegister("8qLfX", function(module, exports) {

$parcel$export(module.exports, "ACTRechazarReporteCompleto", () => $385934a7abbe14cc$export$e19ba64ccdf3966c);

var $ayMG0 = parcelRequire("ayMG0");

var $gU5rH = parcelRequire("gU5rH");
var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");
const $385934a7abbe14cc$export$e19ba64ccdf3966c = {
    name: 'ACTRechazarReporteCompleto',
    label: 'Rechazar Reporte',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Rechazar Reporte"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    showActionInViewMode: true,
    views: [
        'dasp_brwAutorizacionGeneral',
        'dasp_brwAutorizacionGeneralAppSupervisor'
    ],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const datosServicioAutorizacionProductos = entity;
        const procParms = {
            c_cliente_id: selectedKeys?.[0]?.['c_cliente_id'] ?? '',
            c_servicio_id: selectedKeys?.[0]?.['c_servicio_id'] ?? '',
            c_producto_id: selectedKeys?.[0]?.['c_producto_id'] ?? '',
            c_visita_id: selectedKeys?.[0]?.['c_visita_id'] ?? '',
            c_datos_servicio_set_id: selectedKeys?.[0]?.['c_datos_servicio_set_id'] ?? ''
        };
        let errores = '';
        if (!procParms.c_cliente_id || !procParms.c_servicio_id || !procParms.c_visita_id) errores = "Los registros seleccionados son inv\xe1lidos";
        if (errores) await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                            size: "1.5rem",
                            stroke: "1.5"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            fw: "700",
                            children: "ERROR"
                        })
                    ]
                })
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        size: "sm",
                        mb: "xs",
                        children: errores
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                        mt: "xs",
                        position: "right",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                            onClick: async ()=>await modal.close(),
                            children: "Cerrar"
                        })
                    })
                ]
            })
        });
        else {
            const abort_controller = new AbortController();
            await modal.open({
                modalProps: {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        fw: "700",
                        children: "Rechazar Reporte"
                    })
                },
                focusOnClosed: element,
                content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.ConfirmAndExecutePanel), {
                    content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        size: "sm",
                        mb: "xs",
                        children: "Va a rechazar el reporte. \xbfEst\xe1 seguro?"
                    }),
                    operation: "proc",
                    onCancel: async ()=>{
                        await abort_controller.abort();
                        await modal.close();
                    },
                    onOK: async ()=>{
                        const reportes = (0, $49qEn.Entity).clone(datosServicioAutorizacionProductos);
                        reportes.def.columns.c_cliente_id.value = datosServicioAutorizacionProductos.parentKeys[reportes.def.columns.c_cliente_id.name];
                        reportes.def.columns.c_servicio_id.value = datosServicioAutorizacionProductos.parentKeys[reportes.def.columns.c_servicio_id.name];
                        reportes.def.columns.c_producto_id.value = datosServicioAutorizacionProductos.parentKeys[reportes.def.columns.c_producto_id.name];
                        reportes.def.columns.c_visita_id.value = datosServicioAutorizacionProductos.parentKeys[reportes.def.columns.c_visita_id.name];
                        const result = await reportes.API.executeProcess(datosServicioAutorizacionProductos.def.procs.dasp_RechazarReporteCompleto, procParms, abort_controller.signal, selectedKeys);
                        if (!result.Failed) {
                            if (onClose) await onClose();
                            await modal.close();
                        }
                        return result;
                    }
                })
            });
        }
        return false;
    }
};

});

parcelRegister("JZXJt", function(module, exports) {

$parcel$export(module.exports, "ACTVerDetalles", () => $57195313c79a0586$export$ad960858c08128b7);

var $ayMG0 = parcelRequire("ayMG0");

var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $9CIrM = parcelRequire("9CIrM");
const $57195313c79a0586$export$ad960858c08128b7 = {
    name: 'ACTVerDetalles',
    label: 'Ver',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Ver"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    showActionInViewMode: true,
    views: [
        'dasp_brwAutorizacionGeneral',
        'dasp_brwAutorizacionGeneralAppSupervisor',
        'dasp_brwAutorizacionGeneralPorPersonal'
    ],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const datosServiciosGestionProductos = new (0, $9CIrM.DatosServiciosGestionServicios)(entity.API.client);
        datosServiciosGestionProductos.def.columns.c_visita_id.value = selectedKeys[0].c_visita_id || '';
        datosServiciosGestionProductos.def.columns.c_cliente_id.value = selectedKeys[0].c_cliente_id || '';
        datosServiciosGestionProductos.def.columns.c_producto_id.value = selectedKeys[0].c_producto_id || '';
        datosServiciosGestionProductos.def.columns.c_servicio_id.value = selectedKeys[0].c_servicio_id || '';
        datosServiciosGestionProductos.def.columns.c_paso_id.value = selectedKeys[0].c_paso_id || '';
        datosServiciosGestionProductos.def.columns.c_datos_servicio_id.value = selectedKeys[0].c_paso_id || '';
        datosServiciosGestionProductos.def.columns.c_datos_servicio_set_id.value = selectedKeys[0].c_datos_servicio_set_id || '';
        await (0, $49qEn.openEntityForm)({
            modals: modal,
            formProps: {
                entity: datosServiciosGestionProductos,
                initialFormMode: 'view',
                getDataOnInit: true
            },
            modalFormSize: 'xl',
            handleModalSaved: async ()=>{
                await modal.close();
                if (onClose) await onClose();
            },
            handleModalCancel: async ()=>{
                await modal.close();
                if (onClose) await onClose();
            }
        });
        return false;
    }
};

});

parcelRegister("5e4FV", function(module, exports) {

$parcel$export(module.exports, "AutorizacionGeneralViewColumnsOverrides", () => $494f6cc2032d1430$export$de954f5265f371c0);

var $ayMG0 = parcelRequire("ayMG0");

var $kPsAn = parcelRequire("kPsAn");
var $9mTYo = parcelRequire("9mTYo");
var $hiGsa = parcelRequire("hiGsa");
var $60Ffz = parcelRequire("60Ffz");

var $3OncY = parcelRequire("3OncY");
function $494f6cc2032d1430$var$htmlUnescape(html) {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.documentElement.textContent;
}
function $494f6cc2032d1430$export$de954f5265f371c0(theme) {
    return {
        3: {
            render: (value)=>{
                const data = $494f6cc2032d1430$var$htmlUnescape(value);
                const rec = JSON.parse(data);
                if (rec.tipo === 'IMAGEN' || rec.tipo === 'IMAGEN_MULTIPLE') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                    align: "flex-start",
                    spacing: "xs",
                    children: rec.datos.map((img, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $60Ffz.Tooltip), {
                            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kPsAn.Card), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hiGsa.Image), {
                                    src: `${(0, $3OncY.API_URL)}/${(0, $3OncY.APP_ID)}/serve/${img}`,
                                    alt: `Imagen ${index + 1}`,
                                    maw: "600px",
                                    mt: "auto"
                                }, index)
                            }),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hiGsa.Image), {
                                src: `${(0, $3OncY.API_URL)}/${(0, $3OncY.APP_ID)}/serve/${img}`,
                                alt: `Imagen ${index + 1}`,
                                maw: "30px",
                                mt: "auto"
                            }, index)
                        }))
                });
                return rec.datos.length > 0 ? rec.datos[0] : '';
            }
        }
    };
}

});


parcelRegister("gePgJ", function(module, exports) {
module.exports = import("d0qUQ").then(()=>parcelRequire('1nMdL'));

});



parcelRegister("gAMC4", function(module, exports) {

$parcel$export(module.exports, "ACTVerReportesPersonal", () => $5bfe4425e6e16dad$export$389dafbb69870e8f);

var $ayMG0 = parcelRequire("ayMG0");

var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");

var $ieRws = parcelRequire("ieRws");

var $4ELnk = parcelRequire("4ELnk");
const $5bfe4425e6e16dad$export$389dafbb69870e8f = {
    name: 'ACTVerReportesPersonal',
    label: 'Ver Reportes Personal',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Ver Reportes"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    showActionInViewMode: true,
    views: [
        ''
    ],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const parent = entity;
        const datos = new (0, $ieRws.DatosServiciosAutorizacion)(entity.API.client);
        datos.parentKeys = parent.parentKeys;
        datos.def.columns.c_personal_id.value = selectedKeys[0].c_personal_id || '';
        await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                            size: "1.5rem",
                            stroke: "1.5"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            fw: "700",
                            children: "Reportes"
                        })
                    ]
                }),
                size: "xl"
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataViewPage), {
                client: entity.API.client,
                entityConstructor: ()=>datos,
                viewName: "dasa_brwAutorizacionPorPersonal",
                refreshOnInit: true,
                enableAdd: false,
                enableDelete: false,
                enableEdit: false,
                enableView: true,
                selectionMode: "single",
                Card: (0, $4ELnk.DatosServiciosAutorizacionCard)
            }, "reportes-personal")
        });
        return false;
    }
};

});
parcelRegister("4ELnk", function(module, exports) {

$parcel$export(module.exports, "DatosServiciosAutorizacionCard", () => $e61a31d7e5378c4d$export$31d29af9af3aadda);

var $ayMG0 = parcelRequire("ayMG0");

var $hiiR1 = parcelRequire("hiiR1");
var $9mTYo = parcelRequire("9mTYo");
var $9VIWE = parcelRequire("9VIWE");
var $cjohz = parcelRequire("cjohz");
var $64A2P = parcelRequire("64A2P");

var $fIMaa = parcelRequire("fIMaa");
var $jIc5b = parcelRequire("jIc5b");
var $35ntO = parcelRequire("35ntO");
var $4Rwq2 = parcelRequire("4Rwq2");
var $hkQ8M = parcelRequire("hkQ8M");
var $1YbUT = parcelRequire("1YbUT");
var $7fSvM = parcelRequire("7fSvM");
function $e61a31d7e5378c4d$export$31d29af9af3aadda(props) {
    const { entity: entity, record: record } = props;
    const data = record.data;
    const theme = (0, $64A2P.useMantineTheme)();
    const iconColor = theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[5];
    const warningColor = theme.colorScheme === "dark" ? theme.colors.orange[5] : theme.colors.orange[7];
    const okColor = theme.colorScheme === "dark" ? theme.colors.green[5] : theme.colors.green[7];
    const errorColor = theme.colorScheme === "dark" ? theme.colors.red[5] : theme.colors.red[7];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hiiR1.Box), {
        mih: "13rem",
        w: "20rem",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                fz: "lg",
                align: "center",
                fw: 500,
                mb: "xs",
                color: "dimmed",
                children: data.vc_titulo_registro
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                noWrap: true,
                align: "flex-start",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9VIWE.Stack), {
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                            noWrap: true,
                            spacing: 10,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jIc5b.default), {
                                    stroke: 1.5,
                                    size: "1.5rem",
                                    color: iconColor
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cjohz.Text), {
                                    fz: "xs",
                                    c: "dimmed",
                                    children: [
                                        "Tienda: ",
                                        data.vc_tienda
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                            noWrap: true,
                            spacing: 10,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7fSvM.default), {
                                    stroke: 1.5,
                                    size: "1.5rem",
                                    color: iconColor
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cjohz.Text), {
                                    fz: "xs",
                                    c: "dimmed",
                                    children: [
                                        "Clientes: ",
                                        data.vc_clientes
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                            noWrap: true,
                            spacing: 10,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1YbUT.default), {
                                    stroke: 1.5,
                                    size: "1.5rem",
                                    color: iconColor
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cjohz.Text), {
                                    fz: "xs",
                                    c: "dimmed",
                                    children: [
                                        "Fecha: ",
                                        data.d_fecha_visita.toString()
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                            noWrap: true,
                            spacing: 10,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $35ntO.default), {
                                    stroke: 1.5,
                                    size: "1.5rem",
                                    color: iconColor
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cjohz.Text), {
                                    fz: "xs",
                                    c: "dimmed",
                                    children: [
                                        "Autorizaciones: ",
                                        data.vc_total_autorizaciones
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                            noWrap: true,
                            spacing: 10,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hkQ8M.default), {
                                    stroke: 1.5,
                                    size: "1.5rem",
                                    color: warningColor
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cjohz.Text), {
                                    fz: "xs",
                                    c: "dimmed",
                                    children: [
                                        "Pendientes: ",
                                        data.vc_total_pendientes
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                            noWrap: true,
                            spacing: 10,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Rwq2.default), {
                                    stroke: 1.5,
                                    size: "1.5rem",
                                    color: okColor
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cjohz.Text), {
                                    fz: "xs",
                                    c: "dimmed",
                                    children: [
                                        "Autorizadas: ",
                                        data.vc_total_autorizadas
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                            noWrap: true,
                            spacing: 10,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                                    stroke: 1.5,
                                    size: "1.5rem",
                                    color: errorColor
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cjohz.Text), {
                                    fz: "xs",
                                    c: "dimmed",
                                    children: [
                                        "Rechazadas: ",
                                        data.vc_total_rechazadas
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}

});
parcelRegister("hkQ8M", function(module, exports) {

$parcel$export(module.exports, "default", () => $16b2456d4fe002a5$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $16b2456d4fe002a5$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M12 16v.01",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M12 13a2 2 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483",
            "key": "svg-2"
        }
    ]
];
const $16b2456d4fe002a5$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "help-circle", "HelpCircle", $16b2456d4fe002a5$export$3efd853dbb351e94);

});



parcelRegister("dfHNO", function(module, exports) {

$parcel$export(module.exports, "ACTVerReportesTienda", () => $34c373a1536ad0eb$export$2822001a4152c5fe);

var $ayMG0 = parcelRequire("ayMG0");

var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");

var $ieRws = parcelRequire("ieRws");

var $4ELnk = parcelRequire("4ELnk");
const $34c373a1536ad0eb$export$2822001a4152c5fe = {
    name: 'ACTVerReportesTienda',
    label: 'Ver Reportes Tienda',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Ver Reportes"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    showActionInViewMode: true,
    views: [
        ''
    ],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const parent = entity;
        const datos = new (0, $ieRws.DatosServiciosAutorizacion)(entity.API.client);
        datos.parentKeys = parent.parentKeys;
        datos.def.columns.c_tienda_id.value = selectedKeys[0].c_tienda_id || '';
        await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                            size: "1.5rem",
                            stroke: "1.5"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            fw: "700",
                            children: "Reportes"
                        })
                    ]
                }),
                size: "xl"
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataViewPage), {
                client: entity.API.client,
                entityConstructor: ()=>datos,
                viewName: "dasa_brwAutorizacionPorTienda",
                refreshOnInit: true,
                enableAdd: false,
                enableDelete: false,
                enableEdit: false,
                enableView: true,
                selectionMode: "single",
                Card: (0, $4ELnk.DatosServiciosAutorizacionCard)
            }, "reportes-tienda")
        });
        return false;
    }
};

});

parcelRegister("bsZPN", function(module, exports) {

$parcel$export(module.exports, "ACTVerRutasEnTiendaDashboard", () => $67d1ffdfae85ccf4$export$37ecb8be6cf5d22a);

var $ayMG0 = parcelRequire("ayMG0");

var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $bIKvx = parcelRequire("bIKvx");
const $67d1ffdfae85ccf4$export$37ecb8be6cf5d22a = {
    name: 'ACTVerRutasEnTiendaDashboard',
    label: 'Ver Rutas en Tienda',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Ver Rutas en Tienda"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    showActionInViewMode: true,
    views: [
        'dash_brwTiendasVisitasPersonal'
    ],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const tiendasConfig = new (0, $bIKvx.RutasTiendasConfiguracion)(entity.API.client);
        tiendasConfig.def.columns.c_tienda_id.value = selectedKeys?.[0].c_tienda_id;
        await (0, $49qEn.openEntityForm)({
            modals: modal,
            formProps: {
                entity: tiendasConfig,
                initialFormMode: 'view',
                getDataOnInit: true
            },
            modalFormSize: 'xl',
            handleModalSaved: async ()=>{
                await modal.close();
                if (onClose) await onClose(false);
            },
            handleModalCancel: async ()=>{
                await modal.close();
                if (onClose) await onClose(false);
            }
        });
        return false;
    }
};

});
parcelRegister("bIKvx", function(module, exports) {

$parcel$export(module.exports, "RutasTiendasConfiguracion", () => $03274504f683651c$export$2e9a62b38de92448);

var $49qEn = parcelRequire("49qEn");

var $hBHGA = parcelRequire("hBHGA");

var $4FWol = parcelRequire("4FWol");
const $03274504f683651c$export$2ea3351e3f9661a9 = (0, $hBHGA.default);
const $03274504f683651c$export$aef77bcd517620c1 = "* Configuraci\xf3n de rutas para tiendas.";

class $03274504f683651c$export$2e9a62b38de92448 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $4FWol.RutasTiendasConfiguracionDef)(), parentKeys);
        this.Form = (parcelRequire("dG5MW")).then((module)=>module.RutasTiendasConfiguracionForm);
        this.Title = "Configuraci\xf3n de Rutas";
        this.HelpText = $03274504f683651c$export$aef77bcd517620c1;
        this.Icon = $03274504f683651c$export$2ea3351e3f9661a9;
    }
}

});
parcelRegister("hBHGA", function(module, exports) {

$parcel$export(module.exports, "default", () => $516bf04d6cab2f51$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $516bf04d6cab2f51$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M7 10h3v-3l-3.5 -3.5a6 6 0 0 1 8 8l6 6a2 2 0 0 1 -3 3l-6 -6a6 6 0 0 1 -8 -8l3.5 3.5",
            "key": "svg-0"
        }
    ]
];
const $516bf04d6cab2f51$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "tool", "Tool", $516bf04d6cab2f51$export$3efd853dbb351e94);

});

parcelRegister("4FWol", function(module, exports) {

$parcel$export(module.exports, "RutasTiendasConfiguracionDef", () => $46670d909ce52d3e$export$298f835b1bc919a6);

var $49qEn = parcelRequire("49qEn");

var $SKbb0 = parcelRequire("SKbb0");

var $6TYT5 = parcelRequire("6TYT5");

var $7LP39 = parcelRequire("7LP39");

var $6awxZ = parcelRequire("6awxZ");

var $lV9FS = parcelRequire("lV9FS");

var $fciDj = parcelRequire("fciDj");

var $8nhIv = parcelRequire("8nhIv");

var $9RYNw = parcelRequire("9RYNw");
const $46670d909ce52d3e$var$columns = ()=>({
        c_tienda_id: new (0, $49qEn.EntityColumn)({
            name: 'c_tienda_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Tienda Id'
        }),
        c_cadena_id: new (0, $49qEn.EntityColumn)({
            name: 'c_cadena_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Cadena'
        }),
        vc_canales: new (0, $49qEn.EntityColumn)({
            name: 'vc_canales',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Canales',
            isArray: true
        }),
        vc_domicilio_completo: new (0, $49qEn.EntityColumn)({
            name: 'vc_domicilio_completo',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Domicilio Completo'
        }),
        i_cantidad_clientes: new (0, $49qEn.EntityColumn)({
            name: 'i_cantidad_clientes',
            type: 'int',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Cantidad Clientes'
        }),
        i_cantidad_productos: new (0, $49qEn.EntityColumn)({
            name: 'i_cantidad_productos',
            type: 'int',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Cantidad Productos'
        }),
        f_latitud: new (0, $49qEn.EntityColumn)({
            name: 'f_latitud',
            type: 'float',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Latitud'
        }),
        f_longitud: new (0, $49qEn.EntityColumn)({
            name: 'f_longitud',
            type: 'float',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Longitud'
        }),
        vc_cobertura_compartida: new (0, $49qEn.EntityColumn)({
            name: 'vc_cobertura_compartida',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Cobertura Compartida'
        }),
        vc_cobertura_exclusiva: new (0, $49qEn.EntityColumn)({
            name: 'vc_cobertura_exclusiva',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Cobertura Exclusiva'
        }),
        vc_personal: new (0, $49qEn.EntityColumn)({
            name: 'vc_personal',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Supervisi\xf3n",
            isArray: true
        }),
        n_horas_compartidas_configuradas: new (0, $49qEn.EntityColumn)({
            name: 'n_horas_compartidas_configuradas',
            type: 'decimal',
            scale: 2,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Horas Compartidas Configuradas'
        }),
        n_horas_exclusivas_configuradas: new (0, $49qEn.EntityColumn)({
            name: 'n_horas_exclusivas_configuradas',
            type: 'decimal',
            scale: 2,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Horas Exclusivas Configuradas'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $46670d909ce52d3e$var$views = ()=>({
        rtcf_brwStandard: {
            name: 'rtcf_brwStandard',
            keyMappings: {
                c_tienda_id: 0
            }
        },
        rtcf_brwCoberturaTiendas: {
            name: 'rtcf_brwCoberturaTiendas',
            keyMappings: {
                c_tienda_id: 0
            },
            FiltersEntity: (client, parentKeys)=>new (0, $lV9FS.RutasTiendasFilters)(client, parentKeys),
            gridColumnsOverrides: (0, $fciDj.CoberturaTiendasViewColumnsOverrides),
            mapMarkerRenderer: (0, $9RYNw.CoberturaTiendasViewMarkerRenderer),
            mapInfoWindowRenderer: (0, $8nhIv.CoberturaTiendasViewInfoWindowRenderer)
        }
    });
const $46670d909ce52d3e$var$lookups = ()=>({
        'Personal': {
            name: 'Personal',
            view: 'perl_brwJefes',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $7LP39.Personal)(client, parentKeys)
        },
        'Tiendas': {
            name: 'Tiendas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $6awxZ.Tiendas)(client, parentKeys)
        },
        'Canales': {
            name: 'Canales',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $6TYT5.catCanales)(client, parentKeys)
        },
        'Cadenas': {
            name: 'Cadenas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $SKbb0.Cadenas)(client, parentKeys)
        }
    });
class $46670d909ce52d3e$export$298f835b1bc919a6 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('RutasTiendasConfiguracion'), this.columns = $46670d909ce52d3e$var$columns(), this.views = $46670d909ce52d3e$var$views(), this.lookups = $46670d909ce52d3e$var$lookups();
    }
}

});
parcelRegister("lV9FS", function(module, exports) {

$parcel$export(module.exports, "RutasTiendasFilters", () => $74f614aecb0e99a2$export$af8947b244fb63b6);

var $49qEn = parcelRequire("49qEn");

var $49R6O = parcelRequire("49R6O");

class $74f614aecb0e99a2$export$af8947b244fb63b6 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $49R6O.RutasTiendasFiltersDef)(), parentKeys);
        this.Form = (parcelRequire("1fcQt")).then((module)=>module.RutasTiendasFiltersForm);
        this.Title = "Filtros de Ruteo";
    }
}

});
parcelRegister("49R6O", function(module, exports) {

$parcel$export(module.exports, "RutasTiendasFiltersDef", () => $d388a47f68e03f21$export$29dc384ef92520c7);

var $49qEn = parcelRequire("49qEn");

var $SKbb0 = parcelRequire("SKbb0");

var $6TYT5 = parcelRequire("6TYT5");

var $9u8qf = parcelRequire("9u8qf");

var $kFypM = parcelRequire("kFypM");

var $aQujn = parcelRequire("aQujn");

var $j8GP5 = parcelRequire("j8GP5");

var $4Rlmx = parcelRequire("4Rlmx");

var $7LP39 = parcelRequire("7LP39");
const $d388a47f68e03f21$var$columns = ()=>({
        c_pais_id: new (0, $49qEn.EntityColumn)({
            name: 'c_pais_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Pa\xeds"
        }),
        c_provincia_id: new (0, $49qEn.EntityColumn)({
            name: 'c_provincia_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Provincia'
        }),
        c_ciudad_id: new (0, $49qEn.EntityColumn)({
            name: 'c_ciudad_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Ciudad'
        }),
        c_localidad_id: new (0, $49qEn.EntityColumn)({
            name: 'c_localidad_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Localidad'
        }),
        vc_cadenas: new (0, $49qEn.EntityColumn)({
            name: 'vc_cadenas',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Cadenas',
            isArray: true
        }),
        vc_canales: new (0, $49qEn.EntityColumn)({
            name: 'vc_canales',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Canales',
            isArray: true
        }),
        vc_supervision: new (0, $49qEn.EntityColumn)({
            name: 'vc_supervision',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Supervisi\xf3n",
            isArray: true
        }),
        vc_visitas: new (0, $49qEn.EntityColumn)({
            name: 'vc_visitas',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Visitas',
            isArray: true
        }),
        vc_clientes: new (0, $49qEn.EntityColumn)({
            name: 'vc_clientes',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Clientes',
            isArray: true
        }),
        b_sinpersonal: new (0, $49qEn.EntityColumn)({
            name: 'b_sinpersonal',
            type: 'bit',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Solo sin personal asignado'
        }),
        b_sinrutascompartidas: new (0, $49qEn.EntityColumn)({
            name: 'b_sinrutascompartidas',
            type: 'bit',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Solo sin rutas compartidas'
        }),
        b_sinrutasexclusivas: new (0, $49qEn.EntityColumn)({
            name: 'b_sinrutasexclusivas',
            type: 'bit',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Solo sin rutas exclusivas'
        }),
        b_compartidassobreasginadas: new (0, $49qEn.EntityColumn)({
            name: 'b_compartidassobreasginadas',
            type: 'bit',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Solo rutas compartidas sobreasignadas'
        }),
        b_exclusivassobreasginadas: new (0, $49qEn.EntityColumn)({
            name: 'b_exclusivassobreasginadas',
            type: 'bit',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Solo rutas exclusivas sobreasignadas'
        }),
        b_compartidasnocubiertas: new (0, $49qEn.EntityColumn)({
            name: 'b_compartidasnocubiertas',
            type: 'bit',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Solo rutas compartidas no cubiertas'
        }),
        b_exclusivasnocubiertas: new (0, $49qEn.EntityColumn)({
            name: 'b_exclusivasnocubiertas',
            type: 'bit',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Solo rutas exclusivas no cubiertas'
        }),
        b_incluirbajas: new (0, $49qEn.EntityColumn)({
            name: 'b_incluirbajas',
            type: 'bit',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Incluir personal de baja'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $d388a47f68e03f21$var$lookups = ()=>({
        'Cadenas': {
            name: 'Cadenas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $SKbb0.Cadenas)(client, parentKeys)
        },
        'Paises': {
            name: 'Paises',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $j8GP5.Paises)(client, parentKeys)
        },
        'Provincias': {
            name: 'Provincias',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $4Rlmx.Provincias)(client, parentKeys)
        },
        'Ciudades': {
            name: 'Ciudades',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $kFypM.Ciudades)(client, parentKeys)
        },
        'Localidades': {
            name: 'Localidades',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $aQujn.Localidades)(client, parentKeys)
        },
        'Supervision': {
            name: 'Supervision',
            view: 'perl_brwAsignadoATiendas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $7LP39.Personal)(client, parentKeys)
        },
        'Visitas': {
            name: 'Visitas',
            view: 'perl_brwEnRutas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $7LP39.Personal)(client, parentKeys)
        },
        'Canales': {
            name: 'Canales',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $6TYT5.catCanales)(client, parentKeys)
        },
        'Clientes': {
            name: 'Clientes',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 2
            },
            entityConstructor: (client, parentKeys)=>new (0, $9u8qf.Clientes)(client, parentKeys)
        }
    });
class $d388a47f68e03f21$export$29dc384ef92520c7 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('RutasTiendasFilters'), this.columns = $d388a47f68e03f21$var$columns(), this.views = {}, this.lookups = $d388a47f68e03f21$var$lookups();
    }
}

});

parcelRegister("1fcQt", function(module, exports) {
module.exports = import("9LxJF").then(()=>parcelRequire('9Eupr'));

});


parcelRegister("fciDj", function(module, exports) {

$parcel$export(module.exports, "CoberturaTiendasViewColumnsOverrides", () => $bf2e48d38a40d0c6$export$ed3a28820d58de3c);

var $ayMG0 = parcelRequire("ayMG0");

var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $iEQtx = parcelRequire("iEQtx");
var $46Z0k = parcelRequire("46Z0k");
var $6zxJ3 = parcelRequire("6zxJ3");
var $3US3h = parcelRequire("3US3h");
function $bf2e48d38a40d0c6$export$ed3a28820d58de3c(theme) {
    return {
        // Personal asignado
        4: {
            render: (value)=>!value ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    style: {
                        gap: '.5rem'
                    },
                    noWrap: true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iEQtx.default), {
                            style: {
                                color: theme.colors.red[8],
                                minWidth: "1.3rem"
                            },
                            size: "1.3rem"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            truncate: true,
                            children: "Sin personal"
                        })
                    ]
                }) : value
        },
        // Cobertura compartida
        5: {
            render: (value)=>{
                const val = value;
                if (val === 'Sin rutas compartidas asignadas') return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    style: {
                        gap: '.5rem'
                    },
                    noWrap: true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iEQtx.default), {
                            style: {
                                color: theme.colors.red[8],
                                minWidth: "1.3rem"
                            },
                            size: "1.3rem"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            truncate: true,
                            children: "Sin rutas compartidas asignadas"
                        })
                    ]
                });
                if (val.endsWith('horas compartidas sobreasignadas')) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    style: {
                        gap: '.5rem'
                    },
                    noWrap: true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $46Z0k.default), {
                            style: {
                                color: theme.colors.orange[6],
                                minWidth: "1.3rem"
                            },
                            size: "1.3rem"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            truncate: true,
                            children: value
                        })
                    ]
                });
                if (val.endsWith('horas compartidas no cubiertas')) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    style: {
                        gap: '.5rem'
                    },
                    noWrap: true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6zxJ3.default), {
                            style: {
                                color: theme.colors.yellow[8],
                                minWidth: "1.3rem"
                            },
                            size: "1.3rem"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            children: value
                        })
                    ]
                });
                if (val === 'OK') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.CircleFilledIcon), {
                    mr: "xs",
                    width: "1.3rem",
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3US3h.default), {
                        size: "0.9rem"
                    })
                });
                return value;
            }
        },
        // Cobertura exclusiva
        6: {
            render: (value)=>{
                const val = value;
                if (val === 'Sin rutas exclusivas asignadas') return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    style: {
                        gap: '.5rem'
                    },
                    noWrap: true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iEQtx.default), {
                            style: {
                                color: theme.colors.red[8],
                                minWidth: "1.3rem"
                            },
                            size: "1.3rem"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            truncate: true,
                            children: "Sin rutas exclusivas asignadas"
                        })
                    ]
                });
                if (val.endsWith('horas exclusivas sobreasignadas')) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    style: {
                        gap: '.5rem'
                    },
                    noWrap: true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $46Z0k.default), {
                            style: {
                                color: theme.colors.pink[8],
                                minWidth: "1.3rem"
                            },
                            size: "1.3rem"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            truncate: true,
                            children: value
                        })
                    ]
                });
                if (val.endsWith('horas exclusivas no cubiertas')) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    style: {
                        gap: '.5rem'
                    },
                    noWrap: true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6zxJ3.default), {
                            style: {
                                color: theme.colors.grape[8],
                                minWidth: "1.3rem"
                            },
                            size: "1.3rem"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            truncate: true,
                            children: value
                        })
                    ]
                });
                if (val === 'OK') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.CircleFilledIcon), {
                    mr: "xs",
                    width: "1.3rem",
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3US3h.default), {
                        size: "0.9rem"
                    })
                });
                return value;
            }
        },
        // Cantidad de clientes
        12: {
            render: (value)=>!value || value === '0' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    style: {
                        gap: '.5rem'
                    },
                    noWrap: true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iEQtx.default), {
                            style: {
                                color: theme.colors.red[8],
                                minWidth: "1.3rem"
                            },
                            size: "1.3rem"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            truncate: true,
                            children: "Sin clientes"
                        })
                    ]
                }) : value
        },
        // Cantidad de productos
        13: {
            render: (value)=>!value || value === '0' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    style: {
                        gap: '.5rem'
                    },
                    noWrap: true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iEQtx.default), {
                            style: {
                                color: theme.colors.red[8],
                                minWidth: "1.3rem"
                            },
                            size: "1.3rem"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            truncate: true,
                            children: "Sin productos"
                        })
                    ]
                }) : value
        }
    };
}

});
parcelRegister("46Z0k", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0f20cf582082f7c$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $a0f20cf582082f7c$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M19 2a3 3 0 0 1 2.995 2.824l.005 .176v14a3 3 0 0 1 -2.824 2.995l-.176 .005h-14a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-14a3 3 0 0 1 2.824 -2.995l.176 -.005h14zm-6.99 13l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm-.01 -8a1 1 0 0 0 -.993 .883l-.007 .117v4l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z",
            "key": "svg-0"
        }
    ]
];
const $a0f20cf582082f7c$export$2e2bcd8739ae039 = (0, $eednQ.default)("filled", "alert-square-filled", "AlertSquareFilled", $a0f20cf582082f7c$export$3efd853dbb351e94);

});


parcelRegister("8nhIv", function(module, exports) {

$parcel$export(module.exports, "CoberturaTiendasViewInfoWindowRenderer", () => $be09c41c7d2ea250$export$cfe47ff7f998a2ff);

var $ayMG0 = parcelRequire("ayMG0");

var $gU5rH = parcelRequire("gU5rH");
var $kPsAn = parcelRequire("kPsAn");
var $9mTYo = parcelRequire("9mTYo");
var $hiGsa = parcelRequire("hiGsa");
var $9VIWE = parcelRequire("9VIWE");
var $cjohz = parcelRequire("cjohz");
var $ew26C = parcelRequire("ew26C");

var $49qEn = parcelRequire("49qEn");

var $fciDj = parcelRequire("fciDj");
function $be09c41c7d2ea250$export$cfe47ff7f998a2ff(record, position, groupManager, infoWindow, UIAPI, theme) {
    const columnsRender = (0, $fciDj.CoberturaTiendasViewColumnsOverrides)(theme);
    const group = groupManager.getGroupByLocation(position);
    if (group) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kPsAn.Card), {
        withBorder: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9VIWE.Stack), {
            spacing: "xs",
            mb: "xs",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hiGsa.Image), {
                    width: 350,
                    height: 120,
                    src: (0, $49qEn.getGoogleMapsStreetViewImage)(position, 350, 200, 150),
                    mx: "auto"
                }),
                group.records.map(({ recordValue: rec }, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ew26C.Title), {
                                order: 5,
                                children: `ID: ${rec[0]} ${rec[2]}${rec[2] && rec[1] ? ' - ' : ''}${rec[1]}`
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                                size: "xs",
                                onClick: async ()=>{
                                    await UIAPI.handleEditClick({
                                        'c_tienda_id': rec[0]
                                    });
                                },
                                children: "Editar"
                            })
                        ]
                    }, `grp_${rec[0]}`)),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                        size: "xs",
                        variant: "light",
                        onClick: ()=>{
                            infoWindow.close();
                        },
                        children: "Cerrar"
                    })
                })
            ]
        })
    });
    else {
        const cobertura_compartida = columnsRender[5].render(record[5]);
        const cobertura_exclusiva = columnsRender[6].render(record[6]);
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kPsAn.Card), {
            withBorder: true,
            padding: "xs",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9VIWE.Stack), {
                spacing: "0.1rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hiGsa.Image), {
                        width: 350,
                        height: 120,
                        src: (0, $49qEn.getGoogleMapsStreetViewImage)(position, 350, 200, 150),
                        mx: "auto"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ew26C.Title), {
                        mx: "auto",
                        mb: "xs",
                        order: 4,
                        children: `${record[2]}${record[2] && record[1] ? ' - ' : ''}${record[1]}`
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        spacing: "xs",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                                weight: 500,
                                size: "sm",
                                children: "Supervisi\xf3n: "
                            }),
                            columnsRender[4].render(record[4])
                        ]
                    }),
                    record[5] !== '' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        spacing: "0rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                                mr: "xs",
                                weight: 500,
                                size: "sm",
                                children: "Cobertura compartida: "
                            }),
                            cobertura_compartida,
                            record[5] === 'OK' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cjohz.Text), {
                                weight: 400,
                                size: "xs",
                                children: [
                                    "(",
                                    record[7],
                                    " horas)"
                                ]
                            }) : '',
                            record[5] !== 'OK' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cjohz.Text), {
                                ml: "xs",
                                weight: 400,
                                size: "xs",
                                children: [
                                    "(configuradas: ",
                                    record[7],
                                    " horas)"
                                ]
                            }) : ''
                        ]
                    }),
                    record[6] !== '' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        spacing: "0rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                                mr: "xs",
                                weight: 500,
                                size: "sm",
                                children: "Cobertura exclusiva: "
                            }),
                            cobertura_exclusiva,
                            record[6] === 'OK' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cjohz.Text), {
                                weight: 400,
                                size: "xs",
                                children: [
                                    "(",
                                    record[8],
                                    " horas)"
                                ]
                            }) : '',
                            record[6] !== 'OK' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cjohz.Text), {
                                ml: "xs",
                                weight: 400,
                                size: "xs",
                                children: [
                                    "(configuradas: ",
                                    record[8],
                                    " horas)"
                                ]
                            }) : ''
                        ]
                    }),
                    record[11] !== null && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        spacing: "0.5rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                                weight: 500,
                                size: "sm",
                                children: "Visitas: "
                            }),
                            record[11]
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        spacing: "0.5rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                                weight: 500,
                                size: "sm",
                                children: "Cantidad de clientes: "
                            }),
                            columnsRender[12].render(record[12])
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        spacing: "0.5rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                                weight: 500,
                                size: "sm",
                                children: "Cantidad de productos: "
                            }),
                            columnsRender[13].render(record[13])
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        position: "right",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                                size: "xs",
                                variant: "light",
                                onClick: ()=>{
                                    infoWindow.close();
                                },
                                children: "Cerrar"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                                size: "xs",
                                onClick: async ()=>{
                                    await UIAPI.handleEditClick({
                                        'c_tienda_id': record[0]
                                    });
                                },
                                children: "Editar"
                            })
                        ]
                    })
                ]
            })
        });
    }
}

});

parcelRegister("9RYNw", function(module, exports) {

$parcel$export(module.exports, "CoberturaTiendasViewMarkerRenderer", () => $dd7620ec68c14d40$export$e28960d55d70add4);
function $dd7620ec68c14d40$export$e28960d55d70add4(record, position, theme) {
    let fillColor;
    const cobertura_compartida = record[5];
    const cobertura_exclusiva = record[6];
    const canales = record[2];
    const cadena = record[1];
    if (cobertura_compartida === 'OK' && cobertura_exclusiva === 'OK' || cobertura_compartida === 'OK' && cobertura_exclusiva === '' || cobertura_compartida === '' && cobertura_exclusiva === 'OK') fillColor = theme.colors.green[6];
    else if (cobertura_compartida === 'OK' || cobertura_exclusiva === 'OK') fillColor = theme.colors.yellow[6];
    else if (cobertura_compartida !== 'Sin rutas compartidas asignadas' && cobertura_exclusiva !== 'Sin rutas exclusivas asignadas') fillColor = theme.colors.yellow[6];
    else fillColor = theme.colors.red[6];
    const markerProps = {
        position: position,
        title: `${canales}${canales && cadena ? ' - ' : ''}${cadena}`,
        fillColor: fillColor
    };
    return markerProps;
}

});


parcelRegister("dG5MW", function(module, exports) {
module.exports = Promise.all([
    import("l0wMD"),
    import("eQI13")
]).then(()=>parcelRequire('jxLRG'));

});



parcelRegister("jJ4eF", function(module, exports) {

$parcel$export(module.exports, "ACTVerUbicacionDashboard", () => $f8d051f04a01ccfb$export$761ea68f2482ce34);

var $ayMG0 = parcelRequire("ayMG0");

var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");
var $4d0Rl = parcelRequire("4d0Rl");

var $6awxZ = parcelRequire("6awxZ");

var $7UO1x = parcelRequire("7UO1x");
const $f8d051f04a01ccfb$export$761ea68f2482ce34 = {
    name: 'ACTVerUbicacionDashboard',
    label: "Ver Ubicaci\xf3n",
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Ver Ubicaci\xf3n"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    minSelectedRecords: 1,
    maxSelectedRecords: 1,
    views: [
        'dash_brwPersonalSinCheckin'
    ],
    showActionInViewMode: true,
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const parent = entity;
        const dashboard = new (0, $7UO1x.Dashboard)(entity.API.client);
        dashboard.parentKeys = parent.parentKeys;
        dashboard.def.columns.c_personal_id.value = selectedKeys[0].c_personal_id || '';
        await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                            size: "1.5rem",
                            stroke: "1.5"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            fw: "700",
                            children: "Personal"
                        })
                    ]
                }),
                size: "xl"
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.MultiDataMapForm), {
                autoFocus: true,
                formMode: "edit",
                title: "Ubicaci\xf3n en tiempo real",
                dataMapView1: {
                    entity: dashboard,
                    viewName: dashboard.def.views.dash_brwUbicacionPersonal.name,
                    parentKeys: dashboard.parentKeys,
                    refreshOnInit: true,
                    latitudRecordIndex: 1,
                    longitudRecordIndex: 2,
                    tabLabel: "Personal",
                    tabIcon: (0, $4d0Rl.default),
                    enableView: false,
                    enableAdd: false,
                    enableEdit: false,
                    enableDelete: false,
                    showActions: true,
                    modalFormSize: "98%"
                },
                dataMapView2: {
                    entity: dashboard,
                    viewName: dashboard.def.views.dash_brwTiendasVisitasPersonal.name,
                    parentKeys: dashboard.parentKeys,
                    refreshOnInit: true,
                    latitudRecordIndex: 4,
                    longitudRecordIndex: 5,
                    tabLabel: "Tiendas",
                    tabIcon: (0, $6awxZ.TiendasIcon),
                    enableView: false,
                    enableAdd: false,
                    enableEdit: false,
                    enableDelete: false,
                    showActions: true,
                    modalFormSize: "98%"
                },
                mapHeight: "50vh"
            }, `mapa-ubicacion-personal-${entity.def.name}`)
        });
        return false;
    }
};

});

parcelRegister("jOqEH", function(module, exports) {

$parcel$export(module.exports, "ACTVerVersionesApp", () => $73c2bf2a7eb96d25$export$b16694a322edcc09);

var $ayMG0 = parcelRequire("ayMG0");

var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");

var $7UO1x = parcelRequire("7UO1x");
const $73c2bf2a7eb96d25$export$b16694a322edcc09 = {
    name: 'ACTVerVersionesApp',
    label: 'Ver Versiones App',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Ver Versiones App"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    minSelectedRecords: 1,
    maxSelectedRecords: 1,
    views: [
        'dash_brwPersonalLocalizacionPresentes',
        'dash_brwPersonalLocalizacionAusentes',
        'dash_brwPersonalLocalizacionSinReportar',
        'dash_brwPersonalSinCheckin',
        'dash_brwPersonalSinCheckinSupervisor',
        'dash_brwUbicacionPersonal'
    ],
    showActionInViewMode: true,
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const parent = entity;
        const dashboard = new (0, $7UO1x.Dashboard)(entity.API.client);
        dashboard.parentKeys = parent.parentKeys;
        dashboard.def.columns.c_personal_id.value = selectedKeys[0].c_personal_id || '';
        await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                            size: "1.5rem",
                            stroke: "1.5"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            fw: "700",
                            children: "Versiones App"
                        })
                    ]
                }),
                size: "fullscreen"
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: entity.API.client,
                entityConstructor: ()=>dashboard,
                formMode: "view",
                viewName: "dash_brwPersonalVersionesApp",
                refreshOnInit: true,
                title: "Versiones App",
                enableAdd: false,
                enableDelete: false,
                enableEdit: false,
                enableView: false,
                showActions: true,
                selectionMode: "single"
            }, "personal-versiones-app")
        });
        return false;
    }
};

});

parcelRegister("7Tiry", function(module, exports) {

$parcel$export(module.exports, "ACTVerVisitas", () => $9d516fe214e6c47e$export$62f4c216aa8220af);

var $ayMG0 = parcelRequire("ayMG0");

var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");
var $4d0Rl = parcelRequire("4d0Rl");

var $6awxZ = parcelRequire("6awxZ");

var $7UO1x = parcelRequire("7UO1x");
const $9d516fe214e6c47e$export$62f4c216aa8220af = {
    name: 'ACTVerVisitas',
    label: 'Ver Visitas',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Ver Visitas"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    minSelectedRecords: 1,
    maxSelectedRecords: 1,
    views: [
        'dash_brwPersonalLocalizacion'
    ],
    showActionInViewMode: true,
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const parent = entity;
        const dashboard = new (0, $7UO1x.Dashboard)(entity.API.client);
        dashboard.parentKeys = parent.parentKeys;
        dashboard.def.columns.c_personal_id.value = selectedKeys[0].c_personal_id || '';
        const parms = {
            ...dashboard.parentKeys,
            ...dashboard.def.columns.c_personal_id
        };
        const results = await dashboard.API.executeProc(dashboard.def.procs.dash_getUbicacionPersonal, parms);
        const data = results[0];
        const [lat, lng] = data.records[0];
        await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                            size: "1.5rem",
                            stroke: "1.5"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            fw: "700",
                            children: "Personal"
                        })
                    ]
                }),
                size: "xl"
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.MultiDataMapForm), {
                autoFocus: true,
                formMode: "edit",
                title: "Ubicaci\xf3n en tiempo real",
                mapOptions: {
                    center: {
                        lat: lat,
                        lng: lng
                    },
                    zoom: 15,
                    gestureHandling: 'greedy'
                },
                dataMapView1: {
                    entity: dashboard,
                    viewName: dashboard.def.views.dash_brwUbicacionPersonal.name,
                    parentKeys: dashboard.parentKeys,
                    refreshOnInit: true,
                    latitudRecordIndex: 1,
                    longitudRecordIndex: 2,
                    tabLabel: "Personal",
                    tabIcon: (0, $4d0Rl.default),
                    enableView: false,
                    enableAdd: false,
                    enableEdit: false,
                    enableDelete: false,
                    showActions: true,
                    modalFormSize: "98%"
                },
                dataMapView2: {
                    entity: dashboard,
                    viewName: dashboard.def.views.dash_brwTiendasVisitasPersonal.name,
                    parentKeys: dashboard.parentKeys,
                    refreshOnInit: true,
                    latitudRecordIndex: 4,
                    longitudRecordIndex: 5,
                    tabLabel: "Tiendas",
                    tabIcon: (0, $6awxZ.TiendasIcon),
                    enableView: false,
                    enableAdd: false,
                    enableEdit: false,
                    enableDelete: false,
                    showActions: true,
                    modalFormSize: "98%"
                },
                dataMapView3: {
                    entity: dashboard,
                    viewName: dashboard.def.views.dash_brwCheckinVisitasPersonal.name,
                    parentKeys: dashboard.parentKeys,
                    refreshOnInit: true,
                    latitudRecordIndex: 6,
                    longitudRecordIndex: 7,
                    tabLabel: "Checkin",
                    tabIcon: (0, $6awxZ.TiendasIcon),
                    enableView: false,
                    enableAdd: false,
                    enableEdit: false,
                    enableDelete: false,
                    showActions: true,
                    modalFormSize: "98%"
                },
                dataMapView4: {
                    entity: dashboard,
                    viewName: dashboard.def.views.dash_brwCheckoutVisitasPersonal.name,
                    parentKeys: dashboard.parentKeys,
                    refreshOnInit: true,
                    latitudRecordIndex: 6,
                    longitudRecordIndex: 7,
                    tabLabel: "Checkout",
                    tabIcon: (0, $6awxZ.TiendasIcon),
                    enableView: false,
                    enableAdd: false,
                    enableEdit: false,
                    enableDelete: false,
                    showActions: true,
                    modalFormSize: "98%"
                },
                mapHeight: "50vh"
            }, `mapa-ubicacion-personal-${entity.def.name}`)
        });
        return false;
    }
};

});

parcelRegister("8fTSV", function(module, exports) {

$parcel$export(module.exports, "CheckinVisitasPersonalViewInfoWindowRenderer", () => $b4ffcc2c1cda5b7d$export$30dcc54ae9989c50);

var $ayMG0 = parcelRequire("ayMG0");

var $gU5rH = parcelRequire("gU5rH");
var $kPsAn = parcelRequire("kPsAn");
var $9mTYo = parcelRequire("9mTYo");
var $hiGsa = parcelRequire("hiGsa");
var $9VIWE = parcelRequire("9VIWE");
var $cjohz = parcelRequire("cjohz");
var $ew26C = parcelRequire("ew26C");

var $49qEn = parcelRequire("49qEn");
function $b4ffcc2c1cda5b7d$export$30dcc54ae9989c50(record, position, groupManager, infoWindow, UIAPI, theme, entity) {
    const dashboard = entity;
    const cadena = record[1];
    const tienda = record[2];
    const domicilio = record[3];
    const diferencia = record[8];
    const image_src = (0, $49qEn.getGoogleMapsStreetViewImage)(position, 350, 200, 150);
    const group = groupManager.getGroupByLocation(position);
    if (group) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kPsAn.Card), {
        withBorder: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9VIWE.Stack), {
            spacing: "xs",
            mb: "xs",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hiGsa.Image), {
                    width: 350,
                    height: 120,
                    src: image_src,
                    mx: "auto"
                }),
                group.records.map(({ recordValue: rec }, index)=>{
                    const g_tienda_id = rec[2];
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9VIWE.Stack), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ew26C.Title), {
                            order: 5,
                            children: [
                                index + 1,
                                ": ",
                                g_tienda_id
                            ]
                        })
                    }, `grp_${g_tienda_id}`);
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                    position: "right",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                        size: "xs",
                        variant: "light",
                        onClick: ()=>{
                            infoWindow.close();
                        },
                        children: "Cerrar"
                    })
                })
            ]
        })
    });
    else return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kPsAn.Card), {
        withBorder: true,
        padding: "xs",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9VIWE.Stack), {
            spacing: "0.5rem",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hiGsa.Image), {
                    width: 350,
                    height: 120,
                    src: image_src,
                    mx: "auto"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ew26C.Title), {
                    order: 4,
                    children: `${tienda}`
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                    spacing: "xs",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cjohz.Text), {
                        weight: 500,
                        size: "sm",
                        children: [
                            cadena,
                            " - ",
                            tienda,
                            " - ",
                            domicilio,
                            " - Distancia a tienda: ",
                            diferencia,
                            "m"
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                    position: "right",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                        size: "xs",
                        variant: "light",
                        onClick: ()=>{
                            infoWindow.close();
                        },
                        children: "Cerrar"
                    })
                })
            ]
        })
    });
}

});

parcelRegister("1ZUed", function(module, exports) {

$parcel$export(module.exports, "CheckinVisitasPersonalViewMarkerRenderer", () => $90d33df99eba7ec7$export$11dcae51b0b621d3);

var $d2PjO = parcelRequire("d2PjO");
function $90d33df99eba7ec7$export$11dcae51b0b621d3(record, position, theme) {
    const cadena = record[1];
    const tienda = record[2];
    const domicilio = record[3];
    const diferencia = record[8];
    const icon = (0, $d2PjO.solidCircleIcon);
    const markerProps = {
        position: position,
        title: `Checkin: ${cadena} - ${tienda} - ${domicilio} - Distancia a tienda: ${diferencia}m`,
        svgIcon: icon,
        assignColorByValue: undefined,
        fillColor: theme.colors.orange[6]
    };
    return markerProps;
}

});

parcelRegister("6MTtf", function(module, exports) {

$parcel$export(module.exports, "CheckoutVisitasPersonalViewInfoWindowRenderer", () => $59b1519ffeecdfbe$export$458942244d4c25b1);

var $ayMG0 = parcelRequire("ayMG0");

var $gU5rH = parcelRequire("gU5rH");
var $kPsAn = parcelRequire("kPsAn");
var $9mTYo = parcelRequire("9mTYo");
var $hiGsa = parcelRequire("hiGsa");
var $9VIWE = parcelRequire("9VIWE");
var $cjohz = parcelRequire("cjohz");
var $ew26C = parcelRequire("ew26C");

var $49qEn = parcelRequire("49qEn");
function $59b1519ffeecdfbe$export$458942244d4c25b1(record, position, groupManager, infoWindow, UIAPI, theme, entity) {
    const dashboard = entity;
    const cadena = record[1];
    const tienda = record[2];
    const domicilio = record[3];
    const diferencia = record[8];
    const image_src = (0, $49qEn.getGoogleMapsStreetViewImage)(position, 350, 200, 150);
    const group = groupManager.getGroupByLocation(position);
    if (group) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kPsAn.Card), {
        withBorder: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9VIWE.Stack), {
            spacing: "xs",
            mb: "xs",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hiGsa.Image), {
                    width: 350,
                    height: 120,
                    src: image_src,
                    mx: "auto"
                }),
                group.records.map(({ recordValue: rec }, index)=>{
                    const g_tienda_id = rec[2];
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9VIWE.Stack), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ew26C.Title), {
                            order: 5,
                            children: [
                                index + 1,
                                ": ",
                                g_tienda_id
                            ]
                        })
                    }, `grp_${g_tienda_id}`);
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                    position: "right",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                        size: "xs",
                        variant: "light",
                        onClick: ()=>{
                            infoWindow.close();
                        },
                        children: "Cerrar"
                    })
                })
            ]
        })
    });
    else return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kPsAn.Card), {
        withBorder: true,
        padding: "xs",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9VIWE.Stack), {
            spacing: "0.5rem",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hiGsa.Image), {
                    width: 350,
                    height: 120,
                    src: image_src,
                    mx: "auto"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ew26C.Title), {
                    order: 4,
                    children: `${tienda}`
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                    spacing: "xs",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cjohz.Text), {
                        weight: 500,
                        size: "sm",
                        children: [
                            cadena,
                            " - ",
                            tienda,
                            " - ",
                            domicilio,
                            " - Distancia a tienda: ",
                            diferencia,
                            "m"
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                    position: "right",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                        size: "xs",
                        variant: "light",
                        onClick: ()=>{
                            infoWindow.close();
                        },
                        children: "Cerrar"
                    })
                })
            ]
        })
    });
}

});

parcelRegister("7hyB8", function(module, exports) {

$parcel$export(module.exports, "CheckoutVisitasPersonalViewMarkerRenderer", () => $ab7d72bfde010cd1$export$2f717117c3748656);

var $d2PjO = parcelRequire("d2PjO");
function $ab7d72bfde010cd1$export$2f717117c3748656(record, position, theme) {
    const cadena = record[1];
    const tienda = record[2];
    const domicilio = record[3];
    const diferencia = record[8];
    const icon = (0, $d2PjO.solidCircleIcon);
    const markerProps = {
        position: position,
        title: `Checkout: ${cadena} - ${tienda} - ${domicilio} - Distancia a tienda: ${diferencia}m`,
        svgIcon: icon,
        assignColorByValue: undefined,
        fillColor: theme.colors.violet[6]
    };
    return markerProps;
}

});

parcelRegister("dGKc3", function(module, exports) {

$parcel$export(module.exports, "HistorialCheckinVerUbicacionTiendaViewMarkerRenderer", () => $65768f9ed7702571$export$8d7e557d4742c1cc);
function $65768f9ed7702571$export$8d7e557d4742c1cc(record, position, theme) {
    const tienda = record[3];
    const color = theme.colors.green[6];
    const markerProps = {
        position: position,
        title: `${tienda}`,
        assignColorByValue: undefined,
        fillColor: color
    };
    return markerProps;
}

});

parcelRegister("er95x", function(module, exports) {

$parcel$export(module.exports, "HistorialCheckinVerUbicacionViewMarkerRenderer", () => $e3eb0fafc5171f45$export$aecca93fe5feea66);

var $d2PjO = parcelRequire("d2PjO");
function $e3eb0fafc5171f45$export$aecca93fe5feea66(record, position, theme) {
    const personal = record[0];
    const color = theme.colors.green[6];
    const icon = (0, $d2PjO.moodSmileIcon);
    const markerProps = {
        position: position,
        title: `${personal}`,
        svgIcon: icon,
        assignColorByValue: undefined,
        fillColor: color
    };
    return markerProps;
}

});

parcelRegister("5v4bO", function(module, exports) {

$parcel$export(module.exports, "PersonalHistorialCheckinViewColumnsOverrides", () => $f189be0b27c32e1d$export$8c5ed021bed538c8);

var $ayMG0 = parcelRequire("ayMG0");

var $9mTYo = parcelRequire("9mTYo");

var $3an6L = parcelRequire("3an6L");
var $h8HR1 = parcelRequire("h8HR1");
function $f189be0b27c32e1d$export$8c5ed021bed538c8(theme) {
    return {
        5: {
            render: (value)=>{
                const val = value;
                if (val === '0') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                    style: {
                        gap: '.5rem'
                    },
                    noWrap: true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $h8HR1.default), {
                        style: {
                            color: theme.colors.red[8],
                            minWidth: "1.3rem"
                        },
                        size: "1.3rem"
                    })
                });
                else if (val === '1') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                    style: {
                        gap: '.5rem'
                    },
                    noWrap: true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3an6L.default), {
                        style: {
                            color: theme.colors.green[8],
                            minWidth: "1.3rem"
                        },
                        size: "1.3rem"
                    })
                });
                return value;
            }
        },
        6: {
            render: (value)=>{
                const val = value;
                if (val === '0') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                    style: {
                        gap: '.5rem'
                    },
                    noWrap: true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $h8HR1.default), {
                        style: {
                            color: theme.colors.red[8],
                            minWidth: "1.3rem"
                        },
                        size: "1.3rem"
                    })
                });
                else if (val === '1') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                    style: {
                        gap: '.5rem'
                    },
                    noWrap: true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3an6L.default), {
                        style: {
                            color: theme.colors.green[8],
                            minWidth: "1.3rem"
                        },
                        size: "1.3rem"
                    })
                });
                return value;
            }
        }
    };
}

});

parcelRegister("jHO5E", function(module, exports) {

$parcel$export(module.exports, "PersonalLocalizacionViewInfoWindowRenderer", () => $c5458014c0cfc0b6$export$81761ea35da934f7);

var $ayMG0 = parcelRequire("ayMG0");

var $436KA = parcelRequire("436KA");
var $gU5rH = parcelRequire("gU5rH");
var $kPsAn = parcelRequire("kPsAn");
var $9mTYo = parcelRequire("9mTYo");
var $9VIWE = parcelRequire("9VIWE");
var $cjohz = parcelRequire("cjohz");
var $ew26C = parcelRequire("ew26C");

var $fIMaa = parcelRequire("fIMaa");
var $4Rwq2 = parcelRequire("4Rwq2");
var $hkQ8M = parcelRequire("hkQ8M");
function $c5458014c0cfc0b6$export$81761ea35da934f7(record, position, groupManager, infoWindow, UIAPI, theme, entity) {
    const dashboard = entity;
    const personal_id = record[0];
    const apellido = record[3];
    const nombre = record[4];
    const fecha = record[5];
    const puesto = record[6];
    const vc_fotoguid = record[19];
    const visitas = record[21];
    const fotoURL = entity.API.client.getDocumentURL(vc_fotoguid);
    const group = groupManager.getGroupByLocation(position);
    const warningColor = theme.colorScheme === "dark" ? theme.colors.orange[5] : theme.colors.orange[7];
    const okColor = theme.colorScheme === "dark" ? theme.colors.green[5] : theme.colors.green[7];
    const errorColor = theme.colorScheme === "dark" ? theme.colors.red[5] : theme.colors.red[7];
    if (group) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kPsAn.Card), {
        withBorder: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9VIWE.Stack), {
            spacing: "xs",
            mb: "xs",
            children: [
                group.records.map(({ recordValue: rec }, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ew26C.Title), {
                            order: 5,
                            children: `${rec[3]}, ${rec[4]} - Fecha Localizaci\xf3n: ${rec[5]}`
                        })
                    }, `grp_${rec[0]}`)),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                    position: "right",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                        size: "xs",
                        variant: "light",
                        onClick: ()=>{
                            infoWindow.close();
                        },
                        children: "Cerrar"
                    })
                })
            ]
        })
    });
    else {
        const client = entity.API.client;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kPsAn.Card), {
            withBorder: true,
            padding: "xs",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9VIWE.Stack), {
                spacing: "0.5rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        spacing: "xs",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $436KA.Avatar), {
                                size: "md",
                                src: fotoURL,
                                radius: "sm"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ew26C.Title), {
                                order: 4,
                                children: `${apellido}, ${nombre}`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        spacing: "xs",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                                weight: 500,
                                size: "sm",
                                children: "Fecha Localizaci\xf3n: "
                            }),
                            fecha
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        spacing: "xs",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                                weight: 500,
                                size: "sm",
                                children: "Puesto: "
                            }),
                            puesto
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                        spacing: "xs",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cjohz.Text), {
                            weight: 500,
                            size: "sm",
                            children: [
                                "Visitas:",
                                visitas.split('--').map((line, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                                        children: line.includes('Sin iniciar') ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                line.split('Sin iniciar')[0],
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                                                    color: errorColor
                                                }),
                                                line.split('Sin iniciar')[1]
                                            ]
                                        }) : line.includes('En proceso') ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                line.split('En proceso')[0],
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hkQ8M.default), {
                                                    color: warningColor
                                                }),
                                                line.split('En proceso')[1]
                                            ]
                                        }) : line.includes('Finalizada') ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                line.split('Finalizada')[0],
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Rwq2.default), {
                                                    color: okColor
                                                }),
                                                line.split('Finalizada')[1]
                                            ]
                                        }) : line
                                    }, index))
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                        position: "right",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                            size: "xs",
                            variant: "light",
                            onClick: ()=>{
                                infoWindow.close();
                            },
                            children: "Cerrar"
                        })
                    })
                ]
            })
        });
    }
}

});

parcelRegister("fCFaT", function(module, exports) {

$parcel$export(module.exports, "PersonalLocalizacionViewMarkerRenderer", () => $9668f66c7c6d053f$export$a19ffe7796f8ddc4);

var $d2PjO = parcelRequire("d2PjO");
function $9668f66c7c6d053f$export$a19ffe7796f8ddc4(record, position, theme) {
    let fillColor;
    const apellido = record[3];
    const nombre = record[4];
    const fecha = record[5];
    const puesto = record[6];
    const distancia = record[20];
    const icon = (0, $d2PjO.moodSmileIcon);
    if (distancia <= 1) fillColor = theme.colors.green[6];
    else if (distancia <= 4) fillColor = theme.colors.yellow[6];
    else fillColor = theme.colors.red[6];
    const markerProps = {
        position: position,
        title: `${apellido}, ${nombre}${puesto && puesto ? ' - ' : ''}${puesto} - Fecha Localizaci\xf3n: ${fecha}`,
        svgIcon: icon,
        assignColorByValue: undefined,
        fillColor: fillColor
    };
    return markerProps;
}

});

parcelRegister("jI9GA", function(module, exports) {

$parcel$export(module.exports, "TiendasViewInfoWindowRenderer", () => $e7ce1afe05cb38d2$export$2b17f00bbcb8a397);

var $ayMG0 = parcelRequire("ayMG0");

var $gU5rH = parcelRequire("gU5rH");
var $kPsAn = parcelRequire("kPsAn");
var $9mTYo = parcelRequire("9mTYo");
var $hiGsa = parcelRequire("hiGsa");
var $9VIWE = parcelRequire("9VIWE");
var $cjohz = parcelRequire("cjohz");
var $ew26C = parcelRequire("ew26C");

var $49qEn = parcelRequire("49qEn");
function $e7ce1afe05cb38d2$export$2b17f00bbcb8a397(record, position, groupManager, infoWindow, UIAPI, theme, entity) {
    const dashboard = entity;
    const tienda_id = record[0];
    const nombre = record[2];
    const visitas = record[6];
    const image_src = (0, $49qEn.getGoogleMapsStreetViewImage)(position, 350, 200, 150);
    const group = groupManager.getGroupByLocation(position);
    if (group) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kPsAn.Card), {
        withBorder: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9VIWE.Stack), {
            spacing: "xs",
            mb: "xs",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hiGsa.Image), {
                    width: 350,
                    height: 120,
                    src: image_src,
                    mx: "auto"
                }),
                group.records.map(({ recordValue: rec }, index)=>{
                    const g_title = `${rec[2]}`;
                    const g_tienda_id = rec[0];
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9VIWE.Stack), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ew26C.Title), {
                            order: 5,
                            children: [
                                index + 1,
                                ": ",
                                g_title
                            ]
                        })
                    }, `grp_${g_tienda_id}`);
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                    position: "right",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                        size: "xs",
                        variant: "light",
                        onClick: ()=>{
                            infoWindow.close();
                        },
                        children: "Cerrar"
                    })
                })
            ]
        })
    });
    else return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kPsAn.Card), {
        withBorder: true,
        padding: "xs",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9VIWE.Stack), {
            spacing: "0.5rem",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hiGsa.Image), {
                    width: 350,
                    height: 120,
                    src: image_src,
                    mx: "auto"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ew26C.Title), {
                    order: 4,
                    children: `${nombre}`
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                    spacing: "xs",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cjohz.Text), {
                        weight: 500,
                        size: "sm",
                        children: [
                            "Visitas:",
                            visitas.split('--').map((line, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                                    children: line
                                }, index))
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    position: "right",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                            size: "xs",
                            variant: "light",
                            onClick: ()=>{
                                infoWindow.close();
                            },
                            children: "Cerrar"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                            size: "xs",
                            onClick: async ()=>{
                                await UIAPI.handleExecuteAction(dashboard.def.clientActions.ACTVerPersonalTienda, [
                                    {
                                        'c_tienda_id': tienda_id
                                    }
                                ]);
                            },
                            children: "Ver Personal"
                        })
                    ]
                })
            ]
        })
    });
}

});

parcelRegister("2xKFT", function(module, exports) {

$parcel$export(module.exports, "TiendasViewMarkerRenderer", () => $fea3a44fefd01e4a$export$3b923dde34741cc);
function $fea3a44fefd01e4a$export$3b923dde34741cc(record, position, theme) {
    const tienda = record[2];
    const markerProps = {
        position: position,
        title: `${tienda}`,
        assignColorByValue: undefined
    };
    return markerProps;
}

});

parcelRegister("72uy6", function(module, exports) {

$parcel$export(module.exports, "TiendasVisitasPersonalViewColumnsOverrides", () => $104776930a73f638$export$727d9885b334d52d);

var $ayMG0 = parcelRequire("ayMG0");

var $9mTYo = parcelRequire("9mTYo");

var $3an6L = parcelRequire("3an6L");
var $h8HR1 = parcelRequire("h8HR1");
function $104776930a73f638$export$727d9885b334d52d(theme) {
    return {
        7: {
            render: (value)=>{
                const val = value;
                if (val === '0') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                    style: {
                        gap: '.5rem'
                    },
                    noWrap: true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $h8HR1.default), {
                        style: {
                            color: theme.colors.red[8],
                            minWidth: "1.3rem"
                        },
                        size: "1.3rem"
                    })
                });
                else if (val === '1') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                    style: {
                        gap: '.5rem'
                    },
                    noWrap: true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3an6L.default), {
                        style: {
                            color: theme.colors.green[8],
                            minWidth: "1.3rem"
                        },
                        size: "1.3rem"
                    })
                });
                return value;
            }
        },
        9: {
            render: (value)=>{
                const val = value;
                if (val === '0') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                    style: {
                        gap: '.5rem'
                    },
                    noWrap: true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $h8HR1.default), {
                        style: {
                            color: theme.colors.red[8],
                            minWidth: "1.3rem"
                        },
                        size: "1.3rem"
                    })
                });
                else if (val === '1') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                    style: {
                        gap: '.5rem'
                    },
                    noWrap: true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3an6L.default), {
                        style: {
                            color: theme.colors.green[8],
                            minWidth: "1.3rem"
                        },
                        size: "1.3rem"
                    })
                });
                return value;
            }
        }
    };
}

});

parcelRegister("fK3CP", function(module, exports) {

$parcel$export(module.exports, "TiendasVisitasPersonalViewMarkerRenderer", () => $d16a2f09330e2f3a$export$2b7dbc2df6d2d89a);
function $d16a2f09330e2f3a$export$2b7dbc2df6d2d89a(record, position, theme) {
    const tienda = record[2];
    const visitas = record[6];
    const checkin = record[7];
    const checkout = record[9];
    let color = theme.colors.red[8];
    let descripcion = '';
    if (checkout) {
        color = theme.colors.green[6];
        descripcion = 'Visita Finalizada';
    } else if (checkin) {
        color = theme.colors.orange[6];
        descripcion = 'Visita Iniciada';
    } else descripcion = 'Sin Iniciar';
    const markerProps = {
        position: position,
        title: `${tienda} - ${visitas} - ${descripcion}`,
        assignColorByValue: undefined,
        fillColor: color
    };
    return markerProps;
}

});

parcelRegister("2WxxY", function(module, exports) {

$parcel$export(module.exports, "UbicacionPersonalViewMarkerRenderer", () => $e8f74f9a2bc4580a$export$d8b71cf4b5e00f35);

var $d2PjO = parcelRequire("d2PjO");
function $e8f74f9a2bc4580a$export$d8b71cf4b5e00f35(record, position, theme) {
    const apellido = record[3];
    const nombre = record[4];
    const fecha = record[5];
    const puesto = record[6];
    const icon = (0, $d2PjO.moodSmileIcon);
    const markerProps = {
        position: position,
        title: `${apellido}, ${nombre}${puesto && puesto ? ' - ' : ''}${puesto} - Fecha Localizaci\xf3n: ${fecha}`,
        svgIcon: icon,
        assignColorByValue: undefined,
        fillColor: theme.colors.green[6]
    };
    return markerProps;
}

});


parcelRegister("bxOAu", function(module, exports) {
module.exports = import("cQjnr").then(()=>parcelRequire('a1k52'));

});



parcelRegister("bRKh1", function(module, exports) {

$parcel$export(module.exports, "GestionReportesViewColumnsOverrides", () => $ec07baf8156952f1$export$ce989503b3fad929);

var $ayMG0 = parcelRequire("ayMG0");

var $9mTYo = parcelRequire("9mTYo");

var $3an6L = parcelRequire("3an6L");
var $h8HR1 = parcelRequire("h8HR1");
function $ec07baf8156952f1$export$ce989503b3fad929(theme) {
    return {
        8: {
            render: (value)=>{
                const val = value;
                if (val === '0') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                    style: {
                        gap: '.5rem'
                    },
                    noWrap: true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $h8HR1.default), {
                        style: {
                            color: theme.colors.red[8],
                            minWidth: "1.3rem"
                        },
                        size: "1.3rem"
                    })
                });
                else if (val === '1') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                    style: {
                        gap: '.5rem'
                    },
                    noWrap: true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3an6L.default), {
                        style: {
                            color: theme.colors.green[8],
                            minWidth: "1.3rem"
                        },
                        size: "1.3rem"
                    })
                });
                return value;
            }
        },
        10: {
            render: (value)=>{
                const val = value;
                if (val === '0') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                    style: {
                        gap: '.5rem'
                    },
                    noWrap: true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $h8HR1.default), {
                        style: {
                            color: theme.colors.red[8],
                            minWidth: "1.3rem"
                        },
                        size: "1.3rem"
                    })
                });
                else if (val === '1') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                    style: {
                        gap: '.5rem'
                    },
                    noWrap: true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3an6L.default), {
                        style: {
                            color: theme.colors.green[8],
                            minWidth: "1.3rem"
                        },
                        size: "1.3rem"
                    })
                });
                return value;
            }
        }
    };
}

});


parcelRegister("e1Ond", function(module, exports) {
module.exports = import("j4lN2").then(()=>parcelRequire('driJK'));

});



parcelRegister("fZbXf", function(module, exports) {

$parcel$export(module.exports, "ACTVerReportesTienda", () => $77df1cc8f250e9b9$export$2822001a4152c5fe);

var $ayMG0 = parcelRequire("ayMG0");

var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");

var $ieRws = parcelRequire("ieRws");

var $4ELnk = parcelRequire("4ELnk");
const $77df1cc8f250e9b9$export$2822001a4152c5fe = {
    name: 'ACTVerReportesTienda',
    label: 'Ver Reportes Tienda',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Ver Reportes"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    showActionInViewMode: true,
    views: [
        ''
    ],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const parent = entity;
        const datos = new (0, $ieRws.DatosServiciosAutorizacion)(entity.API.client);
        datos.parentKeys = parent.parentKeys;
        datos.def.columns.c_tienda_id.value = selectedKeys[0].c_tienda_id || '';
        await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                            size: "1.5rem",
                            stroke: "1.5"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            fw: "700",
                            children: "Reportes"
                        })
                    ]
                }),
                size: "xl"
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataViewPage), {
                client: entity.API.client,
                entityConstructor: ()=>datos,
                viewName: "dasa_brwAutorizacionPorTienda",
                refreshOnInit: true,
                enableAdd: false,
                enableDelete: false,
                enableEdit: false,
                enableView: true,
                selectionMode: "single",
                Card: (0, $4ELnk.DatosServiciosAutorizacionCard)
            }, "reportes-tienda")
        });
        return false;
    }
};

});

parcelRegister("2aZ1b", function(module, exports) {

$parcel$export(module.exports, "PersonalLocalizacionViewInfoWindowRenderer", () => $a7451f4bbb75f66c$export$81761ea35da934f7);

var $ayMG0 = parcelRequire("ayMG0");

var $436KA = parcelRequire("436KA");
var $gU5rH = parcelRequire("gU5rH");
var $kPsAn = parcelRequire("kPsAn");
var $9mTYo = parcelRequire("9mTYo");
var $9VIWE = parcelRequire("9VIWE");
var $cjohz = parcelRequire("cjohz");
var $ew26C = parcelRequire("ew26C");

var $fIMaa = parcelRequire("fIMaa");
var $4Rwq2 = parcelRequire("4Rwq2");
var $hkQ8M = parcelRequire("hkQ8M");
function $a7451f4bbb75f66c$export$81761ea35da934f7(record, position, groupManager, infoWindow, UIAPI, theme, entity) {
    const AppSupervisor = entity;
    const personal_id = record[0];
    const apellido = record[3];
    const nombre = record[4];
    const fecha = record[5];
    const puesto = record[6];
    const vc_fotoguid = record[19];
    const visitas = record[21];
    const fotoURL = entity.API.client.getDocumentURL(vc_fotoguid);
    const group = groupManager.getGroupByLocation(position);
    const warningColor = theme.colorScheme === "dark" ? theme.colors.orange[5] : theme.colors.orange[7];
    const okColor = theme.colorScheme === "dark" ? theme.colors.green[5] : theme.colors.green[7];
    const errorColor = theme.colorScheme === "dark" ? theme.colors.red[5] : theme.colors.red[7];
    if (group) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kPsAn.Card), {
        withBorder: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9VIWE.Stack), {
            spacing: "xs",
            mb: "xs",
            children: [
                group.records.map(({ recordValue: rec }, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ew26C.Title), {
                            order: 5,
                            children: `${rec[3]}, ${rec[4]} - Fecha Localizaci\xf3n: ${rec[5]}`
                        })
                    }, `grp_${rec[0]}`)),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                    position: "right",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                        size: "xs",
                        variant: "light",
                        onClick: ()=>{
                            infoWindow.close();
                        },
                        children: "Cerrar"
                    })
                })
            ]
        })
    });
    else {
        const client = entity.API.client;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kPsAn.Card), {
            withBorder: true,
            padding: "xs",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9VIWE.Stack), {
                spacing: "0.5rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        spacing: "xs",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $436KA.Avatar), {
                                size: "md",
                                src: fotoURL,
                                radius: "sm"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ew26C.Title), {
                                order: 4,
                                children: `${apellido}, ${nombre}`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        spacing: "xs",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                                weight: 500,
                                size: "sm",
                                children: "Fecha Localizaci\xf3n: "
                            }),
                            fecha
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        spacing: "xs",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                                weight: 500,
                                size: "sm",
                                children: "Puesto: "
                            }),
                            puesto
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                        spacing: "xs",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cjohz.Text), {
                            weight: 500,
                            size: "sm",
                            children: [
                                "Visitas:",
                                visitas.split('--').map((line, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                                        children: line.includes('Sin iniciar') ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                line.split('Sin iniciar')[0],
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                                                    color: errorColor
                                                }),
                                                line.split('Sin iniciar')[1]
                                            ]
                                        }) : line.includes('En proceso') ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                line.split('En proceso')[0],
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hkQ8M.default), {
                                                    color: warningColor
                                                }),
                                                line.split('En proceso')[1]
                                            ]
                                        }) : line.includes('Finalizada') ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                line.split('Finalizada')[0],
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Rwq2.default), {
                                                    color: okColor
                                                }),
                                                line.split('Finalizada')[1]
                                            ]
                                        }) : line
                                    }, index))
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                        position: "right",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                            size: "xs",
                            variant: "light",
                            onClick: ()=>{
                                infoWindow.close();
                            },
                            children: "Cerrar"
                        })
                    })
                ]
            })
        });
    }
}

});

parcelRegister("50rai", function(module, exports) {

$parcel$export(module.exports, "PersonalLocalizacionViewMarkerRenderer", () => $0802d228b81bf928$export$a19ffe7796f8ddc4);

var $d2PjO = parcelRequire("d2PjO");
function $0802d228b81bf928$export$a19ffe7796f8ddc4(record, position, theme) {
    let fillColor;
    const apellido = record[3];
    const nombre = record[4];
    const fecha = record[5];
    const puesto = record[6];
    const distancia = record[20];
    const icon = (0, $d2PjO.moodSmileIcon);
    if (distancia <= 1) fillColor = theme.colors.green[6];
    else if (distancia <= 4) fillColor = theme.colors.yellow[6];
    else fillColor = theme.colors.red[6];
    const markerProps = {
        position: position,
        title: `${apellido}, ${nombre}${puesto && puesto ? ' - ' : ''}${puesto} - Fecha Localizaci\xf3n: ${fecha}`,
        svgIcon: icon,
        assignColorByValue: undefined,
        fillColor: fillColor
    };
    return markerProps;
}

});

parcelRegister("ifvvj", function(module, exports) {

$parcel$export(module.exports, "TiendasViewInfoWindowRenderer", () => $5b72472aa55613c9$export$2b17f00bbcb8a397);

var $ayMG0 = parcelRequire("ayMG0");

var $gU5rH = parcelRequire("gU5rH");
var $kPsAn = parcelRequire("kPsAn");
var $9mTYo = parcelRequire("9mTYo");
var $hiGsa = parcelRequire("hiGsa");
var $9VIWE = parcelRequire("9VIWE");
var $cjohz = parcelRequire("cjohz");
var $ew26C = parcelRequire("ew26C");

var $49qEn = parcelRequire("49qEn");
function $5b72472aa55613c9$export$2b17f00bbcb8a397(record, position, groupManager, infoWindow, UIAPI, theme, entity) {
    const AppSupervisor = entity;
    const tienda_id = record[0];
    const nombre = record[2];
    const visitas = record[6];
    const image_src = (0, $49qEn.getGoogleMapsStreetViewImage)(position, 350, 200, 150);
    const group = groupManager.getGroupByLocation(position);
    if (group) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kPsAn.Card), {
        withBorder: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9VIWE.Stack), {
            spacing: "xs",
            mb: "xs",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hiGsa.Image), {
                    width: 350,
                    height: 120,
                    src: image_src,
                    mx: "auto"
                }),
                group.records.map(({ recordValue: rec }, index)=>{
                    const g_title = `${rec[2]}`;
                    const g_tienda_id = rec[0];
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9VIWE.Stack), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ew26C.Title), {
                            order: 5,
                            children: [
                                index + 1,
                                ": ",
                                g_title
                            ]
                        })
                    }, `grp_${g_tienda_id}`);
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                    position: "right",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                        size: "xs",
                        variant: "light",
                        onClick: ()=>{
                            infoWindow.close();
                        },
                        children: "Cerrar"
                    })
                })
            ]
        })
    });
    else return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kPsAn.Card), {
        withBorder: true,
        padding: "xs",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9VIWE.Stack), {
            spacing: "0.5rem",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hiGsa.Image), {
                    width: 350,
                    height: 120,
                    src: image_src,
                    mx: "auto"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ew26C.Title), {
                    order: 4,
                    children: `${nombre}`
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                    spacing: "xs",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cjohz.Text), {
                        weight: 500,
                        size: "sm",
                        children: [
                            "Visitas:",
                            visitas.split('--').map((line, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                                    children: line
                                }, index))
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    position: "right",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                            size: "xs",
                            variant: "light",
                            onClick: ()=>{
                                infoWindow.close();
                            },
                            children: "Cerrar"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                            size: "xs",
                            onClick: async ()=>{
                                await UIAPI.handleExecuteAction(AppSupervisor.def.clientActions.ACTVerPersonalTienda, [
                                    {
                                        'c_tienda_id': tienda_id
                                    }
                                ]);
                            },
                            children: "Ver Personal"
                        })
                    ]
                })
            ]
        })
    });
}

});

parcelRegister("gZeaI", function(module, exports) {

$parcel$export(module.exports, "TiendasViewMarkerRenderer", () => $c69ba4f4ac65b4db$export$3b923dde34741cc);
function $c69ba4f4ac65b4db$export$3b923dde34741cc(record, position, theme) {
    const tienda = record[2];
    const markerProps = {
        position: position,
        title: `${tienda}`,
        assignColorByValue: undefined
    };
    return markerProps;
}

});


parcelRegister("d2cgZ", function(module, exports) {
module.exports = import("3Pvrt").then(()=>parcelRequire('i7jXh'));

});


parcelRegister("k9JMU", function(module, exports) {

$parcel$export(module.exports, "FrecuenciaTiempoIcon", () => $92a5b8d3258df432$export$548df560f5359b5c);
$parcel$export(module.exports, "FrecuenciaTiempoHelpText", () => $92a5b8d3258df432$export$391e06dd9a681809);
$parcel$export(module.exports, "catFrecuenciaTiempo", () => $92a5b8d3258df432$export$ff893a114cf319c3);

var $49qEn = parcelRequire("49qEn");

var $1E0l5 = parcelRequire("1E0l5");
const $92a5b8d3258df432$export$548df560f5359b5c = (0, $1E0l5.default);
const $92a5b8d3258df432$export$391e06dd9a681809 = "* Aqu\xed se pueden ver las frecuencias de tiempo aplicables.";
class $92a5b8d3258df432$export$ff893a114cf319c3 extends (0, $49qEn.CategoriesValues) {
    constructor(client, parentKeys = {}){
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "FrecuenciaTiempo";
        this.def.columns.c_category_id.defaultValue = "FrecuenciaTiempo";
        this.Title = "Frecuencias de tiempo";
        this.HelpText = $92a5b8d3258df432$export$391e06dd9a681809;
        this.Icon = $92a5b8d3258df432$export$548df560f5359b5c;
    }
}

});

parcelRegister("5GxBW", function(module, exports) {

$parcel$export(module.exports, "TallesLetrasIcon", () => $27e1dcb08321712a$export$eb996a52aca190b2);
$parcel$export(module.exports, "TallesLetrasHelpText", () => $27e1dcb08321712a$export$f6fe9d74ea0875af);
$parcel$export(module.exports, "catTallesConLetras", () => $27e1dcb08321712a$export$d5f4957a07b89d18);

var $49qEn = parcelRequire("49qEn");

var $6oCiX = parcelRequire("6oCiX");
const $27e1dcb08321712a$export$eb996a52aca190b2 = (0, $6oCiX.default);
const $27e1dcb08321712a$export$f6fe9d74ea0875af = "* Aqu\xed puede ver la lista de talles de prendas para el torso.";
class $27e1dcb08321712a$export$d5f4957a07b89d18 extends (0, $49qEn.CategoriesValues) {
    constructor(client, parentKeys = {}){
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "TallesConLetras";
        this.def.columns.c_category_id.defaultValue = "TallesConLetras";
        this.Title = "Talles con Letras";
        this.Icon = $27e1dcb08321712a$export$eb996a52aca190b2;
        this.HelpText = $27e1dcb08321712a$export$f6fe9d74ea0875af;
    }
}

});

parcelRegister("iVMwo", function(module, exports) {

$parcel$export(module.exports, "TallesPantalonesIcon", () => $3146fffc14e9ec34$export$7ddb0e57da3735ed);
$parcel$export(module.exports, "TallesPantalonesHelpText", () => $3146fffc14e9ec34$export$586bcd94ceb68ee4);
$parcel$export(module.exports, "catTallesPantalones", () => $3146fffc14e9ec34$export$74e0584269a8ab4e);

var $49qEn = parcelRequire("49qEn");

var $5iYMI = parcelRequire("5iYMI");
const $3146fffc14e9ec34$export$7ddb0e57da3735ed = (0, $5iYMI.default);
const $3146fffc14e9ec34$export$586bcd94ceb68ee4 = "* Aqu\xed puede ver la lista de talles de pantalones.";
class $3146fffc14e9ec34$export$74e0584269a8ab4e extends (0, $49qEn.CategoriesValues) {
    constructor(client, parentKeys = {}){
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "TallesPantalones";
        this.def.columns.c_category_id.defaultValue = "TallesPantalones";
        this.Title = "Talles de Pantalones";
        this.Icon = $3146fffc14e9ec34$export$7ddb0e57da3735ed;
        this.HelpText = $3146fffc14e9ec34$export$586bcd94ceb68ee4;
    }
}

});
parcelRegister("5iYMI", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ac8c68bb064f575$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $3ac8c68bb064f575$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M17 3l4 4l-14 14l-4 -4z",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M16 7l-1.5 -1.5",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M13 10l-1.5 -1.5",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M10 13l-1.5 -1.5",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M7 16l-1.5 -1.5",
            "key": "svg-4"
        }
    ]
];
const $3ac8c68bb064f575$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "ruler-2", "Ruler2", $3ac8c68bb064f575$export$3efd853dbb351e94);

});


parcelRegister("l9enS", function(module, exports) {

$parcel$export(module.exports, "TallesZapatosIcon", () => $fc7043e4c20aaeba$export$c074b88ab82d6330);
$parcel$export(module.exports, "TallesZapatosHelpText", () => $fc7043e4c20aaeba$export$112f7e2dadcdd5cd);
$parcel$export(module.exports, "catTallesZapatos", () => $fc7043e4c20aaeba$export$e94297e1ca749e91);

var $49qEn = parcelRequire("49qEn");

var $7m5VP = parcelRequire("7m5VP");
const $fc7043e4c20aaeba$export$c074b88ab82d6330 = (0, $7m5VP.default);
const $fc7043e4c20aaeba$export$112f7e2dadcdd5cd = "* Aqu\xed puede ver la lista de talles de calzado.";
class $fc7043e4c20aaeba$export$e94297e1ca749e91 extends (0, $49qEn.CategoriesValues) {
    constructor(client, parentKeys = {}){
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "TallesZapatos";
        this.def.columns.c_category_id.defaultValue = "TallesZapatos";
        this.Title = "Talles de Zapatos";
        this.Icon = $fc7043e4c20aaeba$export$c074b88ab82d6330;
        this.HelpText = $fc7043e4c20aaeba$export$112f7e2dadcdd5cd;
    }
}

});
parcelRegister("7m5VP", function(module, exports) {

$parcel$export(module.exports, "default", () => $e70ab0bae2c286bf$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $e70ab0bae2c286bf$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M4 6h5.426a1 1 0 0 1 .863 .496l1.064 1.823a3 3 0 0 0 1.896 1.407l4.677 1.114a4 4 0 0 1 3.074 3.89v2.27a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1z",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M14 13l1 -2",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M8 18v-1a4 4 0 0 0 -4 -4h-1",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M10 12l1.5 -3",
            "key": "svg-3"
        }
    ]
];
const $e70ab0bae2c286bf$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "shoe", "Shoe", $e70ab0bae2c286bf$export$3efd853dbb351e94);

});


parcelRegister("3RgBj", function(module, exports) {

$parcel$export(module.exports, "TiposEmailIcon", () => $835c06f8e04df9d6$export$1aaca3037ce2d0c3);
$parcel$export(module.exports, "TiposEmailHelpText", () => $835c06f8e04df9d6$export$d03558fb79325791);
$parcel$export(module.exports, "catTiposEmail", () => $835c06f8e04df9d6$export$e04475cd48c3f1d9);

var $49qEn = parcelRequire("49qEn");

var $eMnMH = parcelRequire("eMnMH");
const $835c06f8e04df9d6$export$1aaca3037ce2d0c3 = (0, $eMnMH.default);
const $835c06f8e04df9d6$export$d03558fb79325791 = "* Aqu\xed puede ver los diferentes tipos de emails.";
class $835c06f8e04df9d6$export$e04475cd48c3f1d9 extends (0, $49qEn.CategoriesValues) {
    constructor(client, parentKeys = {}){
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "TiposEmail";
        this.def.columns.c_category_id.defaultValue = "TiposEmail";
        this.Title = "Tipos de Email";
        this.HelpText = $835c06f8e04df9d6$export$d03558fb79325791;
        this.Icon = $835c06f8e04df9d6$export$1aaca3037ce2d0c3;
    }
}

});
parcelRegister("eMnMH", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6a32a527b62892a$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $b6a32a527b62892a$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M22 7.535v9.465a3 3 0 0 1 -2.824 2.995l-.176 .005h-14a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-9.465l9.445 6.297l.116 .066a1 1 0 0 0 .878 0l.116 -.066l9.445 -6.297z",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M19 4c1.08 0 2.027 .57 2.555 1.427l-9.555 6.37l-9.555 -6.37a2.999 2.999 0 0 1 2.354 -1.42l.201 -.007h14z",
            "key": "svg-1"
        }
    ]
];
const $b6a32a527b62892a$export$2e2bcd8739ae039 = (0, $eednQ.default)("filled", "mail-filled", "MailFilled", $b6a32a527b62892a$export$3efd853dbb351e94);

});


parcelRegister("fRLGi", function(module, exports) {
module.exports = import("6bdVP").then(()=>parcelRequire('fInJ6'));

});

parcelRegister("cC5ZS", function(module, exports) {

$parcel$export(module.exports, "ClientesConfiguracionTiendasIcon", () => $4513607f1cb3dd17$export$e3259558e62bd5c3);
$parcel$export(module.exports, "ClientesConfiguracionTiendas", () => $4513607f1cb3dd17$export$debd713512be7e15);

var $49qEn = parcelRequire("49qEn");

var $TC7kK = parcelRequire("TC7kK");

var $c99PX = parcelRequire("c99PX");
const $4513607f1cb3dd17$export$d2afe65773b30c59 = "* Aqu\xed puede configurar los productos y servicios de cada tienda.";
const $4513607f1cb3dd17$export$e3259558e62bd5c3 = (0, $TC7kK.default);

class $4513607f1cb3dd17$export$debd713512be7e15 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $c99PX.ClientesConfiguracionTiendasDef)(), parentKeys);
        this.Form = (parcelRequire("jSisk")).then((module)=>module.ClientesConfiguracionTiendasForm);
        this.Title = "Configuraci\xf3n de Tiendas por Cliente";
        this.HelpText = $4513607f1cb3dd17$export$d2afe65773b30c59;
        this.Icon = $4513607f1cb3dd17$export$e3259558e62bd5c3;
    }
}

});
parcelRegister("c99PX", function(module, exports) {

$parcel$export(module.exports, "ClientesConfiguracionTiendasDef", () => $ad32d11b45d4aec1$export$c6b1d5e9a3b6020a);

var $49qEn = parcelRequire("49qEn");

var $SKbb0 = parcelRequire("SKbb0");

var $6TYT5 = parcelRequire("6TYT5");

var $k9JMU = parcelRequire("k9JMU");

var $6awxZ = parcelRequire("6awxZ");

var $9u8qf = parcelRequire("9u8qf");

var $axCTl = parcelRequire("axCTl");

var $7p7hH = parcelRequire("7p7hH");

var $dFiLq = parcelRequire("dFiLq");

var $6UH3r = parcelRequire("6UH3r");

var $hjvVr = parcelRequire("hjvVr");

var $i0O3P = parcelRequire("i0O3P");
const $ad32d11b45d4aec1$var$columns = ()=>({
        c_cliente_id: new (0, $49qEn.EntityColumn)({
            name: 'c_cliente_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Cliente ID'
        }),
        c_tienda_id: new (0, $49qEn.EntityColumn)({
            name: 'c_tienda_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Tienda'
        }),
        c_frecuenciatiempo_id: new (0, $49qEn.EntityColumn)({
            name: 'c_frecuenciatiempo_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Periodo'
        }),
        i_minutos_en_tienda: new (0, $49qEn.EntityColumn)({
            name: 'i_minutos_en_tienda',
            type: 'int',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Minutos en tienda'
        }),
        i_cantidad_frecuencia: new (0, $49qEn.EntityColumn)({
            name: 'i_cantidad_frecuencia',
            type: 'int',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Frecuencia'
        }),
        bt_ruta_compartida: new (0, $49qEn.EntityColumn)({
            name: 'bt_ruta_compartida',
            type: 'bit',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Ruta compartida'
        }),
        c_cadena_id: new (0, $49qEn.EntityColumn)({
            name: 'c_cadena_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Cadena'
        }),
        vc_canales: new (0, $49qEn.EntityColumn)({
            name: 'vc_canales',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Canales',
            isArray: true
        }),
        vc_domicilio_completo: new (0, $49qEn.EntityColumn)({
            name: 'vc_domicilio_completo',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Domicilio completo'
        }),
        f_latitud: new (0, $49qEn.EntityColumn)({
            name: 'f_latitud',
            type: 'float',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Latitud'
        }),
        f_longitud: new (0, $49qEn.EntityColumn)({
            name: 'f_longitud',
            type: 'float',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Longitud'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $ad32d11b45d4aec1$var$views = ()=>({
        clct_brwStandard: {
            name: 'clct_brwStandard',
            keyMappings: {
                c_tienda_id: 0
            },
            gridColumnsOverrides: (0, $hjvVr.ClientesConfiguracionTiendasRutaStatusOverrides)
        },
        clct_brwClientesPorTienda: {
            name: 'clct_brwClientesPorTienda',
            keyMappings: {
                c_cliente_id: 0
            },
            gridColumnsOverrides: (0, $i0O3P.ClientesPorTiendaColumnsOverrides)
        },
        clct_brwTodas: {
            name: 'clct_brwTodas',
            keyMappings: {
                c_cliente_id: 0,
                c_tienda_id: 2
            }
        }
    });
const $ad32d11b45d4aec1$var$lookups = ()=>({
        'Clientes': {
            name: 'Clientes',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $9u8qf.Clientes)(client, parentKeys)
        },
        'FrecuenciaTiempo': {
            name: 'FrecuenciaTiempo',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $k9JMU.catFrecuenciaTiempo)(client, parentKeys)
        },
        'Tiendas': {
            name: 'Tiendas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $6awxZ.Tiendas)(client, parentKeys)
        },
        'Cadenas': {
            name: 'Cadenas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $SKbb0.Cadenas)(client, parentKeys)
        },
        'Canales': {
            name: 'Canales',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $6TYT5.catCanales)(client, parentKeys)
        }
    });
const $ad32d11b45d4aec1$var$clientActions = ()=>({
        ACTAsignarProductos: (0, $axCTl.ACTAsignarProductos),
        ACTQuitarProductos: (0, $dFiLq.ACTQuitarProductos),
        ACTAsignarServicios: (0, $7p7hH.ACTAsignarServicios),
        ACTQuitarServicios: (0, $6UH3r.ACTQuitarServicios)
    });
class $ad32d11b45d4aec1$export$c6b1d5e9a3b6020a extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('ClientesConfiguracionTiendas'), this.columns = $ad32d11b45d4aec1$var$columns(), this.views = $ad32d11b45d4aec1$var$views(), this.lookups = $ad32d11b45d4aec1$var$lookups(), this.clientActions = $ad32d11b45d4aec1$var$clientActions();
    }
}

});
parcelRegister("axCTl", function(module, exports) {

$parcel$export(module.exports, "ACTAsignarProductos", () => $e7e53b77e8f0b5f5$export$67c862e9a6665e80);

var $ayMG0 = parcelRequire("ayMG0");

var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fbOz4 = parcelRequire("fbOz4");

var $393D4 = parcelRequire("393D4");
const $e7e53b77e8f0b5f5$export$67c862e9a6665e80 = {
    name: 'ACTAsignarProductos',
    label: 'Asignar productos',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Asignar productos"
    }),
    refreshOnClose: true,
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        // cast entity
        const parent = entity;
        const productos = new (0, $fbOz4.ClientesProductos)(entity.API.client);
        productos.parentKeys = parent.parentKeys;
        if (modal) await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                    fw: "700",
                    children: "Asignar productos"
                }),
                size: 'xl'
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.LookupFormAction), {
                lookupEntity: productos,
                viewName: productos.def.views.clpr_brwStandard.name,
                title: "Asignar productos seleccionados",
                confirmContent: "\xbfEst\xe1 seguro de que desea asignar los productos seleccionados a las tiendas seleccionadas?",
                onActionFinished: async ()=>{
                    if (onClose) await onClose();
                },
                onOK: async (keys, abortSignal)=>{
                    if (selectedKeys && selectedKeys.length > 0) {
                        const clientes_tiendas_productos = new (0, $393D4.ClientesTiendasProductos)(entity.API.client, entity.parentKeys);
                        clientes_tiendas_productos.def.columns.c_cliente_id.value = parent.parentKeys[clientes_tiendas_productos.def.columns.c_cliente_id.name];
                        for (const key of selectedKeys ?? []){
                            clientes_tiendas_productos.def.columns.c_tienda_id.value = key[clientes_tiendas_productos.def.columns.c_tienda_id.name];
                            await clientes_tiendas_productos.API.addData(abortSignal, keys, true);
                        }
                    }
                    return {
                        Results: [
                            {
                                Status: 0,
                                Message: 'OK'
                            }
                        ]
                    };
                }
            })
        });
        else {
            console.log('modal context not found');
            return Promise.resolve(false);
        }
        return false;
    }
};

});
parcelRegister("fbOz4", function(module, exports) {

$parcel$export(module.exports, "ClientesProductos", () => $5a5f5ade2118f144$export$a8a69c57712ae56f);

var $49qEn = parcelRequire("49qEn");

var $4usKR = parcelRequire("4usKR");

var $6sZV9 = parcelRequire("6sZV9");
const $5a5f5ade2118f144$export$4cf24fc4aee5dd82 = (0, $4usKR.ProductosIcon);
const $5a5f5ade2118f144$export$68b7fc23a5f1b16b = "* Aqu\xed estaran los Productos que seran asignados en los Servicios";

class $5a5f5ade2118f144$export$a8a69c57712ae56f extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $6sZV9.ClientesProductosDef)(), parentKeys);
        super.Form = (parcelRequire("hhDaM")).then((module)=>module.ProductosForm);
        this.Title = "Productos";
        this.HelpText = $5a5f5ade2118f144$export$68b7fc23a5f1b16b;
        this.Icon = $5a5f5ade2118f144$export$4cf24fc4aee5dd82;
    }
}

});
parcelRegister("6sZV9", function(module, exports) {

$parcel$export(module.exports, "ClientesProductosDef", () => $b5689aac67c13f6e$export$b5ef3e86342d70fa);

var $49qEn = parcelRequire("49qEn");

var $kEjqx = parcelRequire("kEjqx");

var $45za5 = parcelRequire("45za5");

var $lMr9U = parcelRequire("lMr9U");

var $5kp3N = parcelRequire("5kp3N");

var $4usKR = parcelRequire("4usKR");

var $9u8qf = parcelRequire("9u8qf");
const $b5689aac67c13f6e$var$columns = ()=>({
        c_cliente_id: new (0, $49qEn.EntityColumn)({
            name: 'c_cliente_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Cliente Id'
        }),
        c_producto_id: new (0, $49qEn.EntityColumn)({
            name: 'c_producto_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Producto Id'
        }),
        // Fake columns para poder crear un producto desde esta entidad
        c_fileprocess_id: new (0, $49qEn.EntityColumn)({
            name: 'c_fileprocess_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Fileprocess Id'
        }),
        vc_codigoproducto: new (0, $49qEn.EntityColumn)({
            name: 'vc_codigoproducto',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: "C\xf3digo interno"
        }),
        vc_codigobarras: new (0, $49qEn.EntityColumn)({
            name: 'vc_codigobarras',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: "C\xf3digo de barras"
        }),
        vc_nombre: new (0, $49qEn.EntityColumn)({
            name: 'vc_nombre',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Nombre'
        }),
        vc_nombrecorto: new (0, $49qEn.EntityColumn)({
            name: 'vc_nombrecorto',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Nombre corto'
        }),
        vc_GTIN8: new (0, $49qEn.EntityColumn)({
            name: 'vc_GTIN8',
            type: 'varchar',
            length: 8,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'GTIN8'
        }),
        vc_EAN13: new (0, $49qEn.EntityColumn)({
            name: 'vc_EAN13',
            type: 'varchar',
            length: 13,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'EAN13'
        }),
        vc_UPCA: new (0, $49qEn.EntityColumn)({
            name: 'vc_UPCA',
            type: 'varchar',
            length: 12,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'UPCA'
        }),
        vc_DUN14: new (0, $49qEn.EntityColumn)({
            name: 'vc_DUN14',
            type: 'varchar',
            length: 14,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'DUN14'
        }),
        vc_GS1128: new (0, $49qEn.EntityColumn)({
            name: 'vc_GS1128',
            type: 'varchar',
            length: 128,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'GS1128'
        }),
        n_precio: new (0, $49qEn.EntityColumn)({
            name: 'n_precio',
            type: 'decimal',
            length: 14,
            scale: 2,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Precio'
        }),
        vc_peso: new (0, $49qEn.EntityColumn)({
            name: 'vc_peso',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Peso'
        }),
        vc_medida: new (0, $49qEn.EntityColumn)({
            name: 'vc_medida',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Medida'
        }),
        vc_unidadesxbulto: new (0, $49qEn.EntityColumn)({
            name: 'vc_unidadesxbulto',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Unidades'
        }),
        c_tipocodigobarra_id: new (0, $49qEn.EntityColumn)({
            name: 'c_tipocodigobarra_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Tipo de codigobarra Id'
        }),
        vc_gruposproducto: new (0, $49qEn.EntityColumn)({
            name: 'vc_gruposproducto',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Grupo',
            isArray: true
        }),
        vc_formatosproducto: new (0, $49qEn.EntityColumn)({
            name: 'vc_formatosproducto',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Formato',
            isArray: true
        }),
        vc_fotoguid: new (0, $49qEn.EntityColumn)({
            name: 'vc_fotoguid',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Fotoguid'
        }),
        c_activo_id: new (0, $49qEn.EntityColumn)({
            name: 'c_activo_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Estado'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $b5689aac67c13f6e$var$views = ()=>({
        clpr_brwStandard: {
            name: 'clpr_brwStandard',
            keyMappings: {
                c_producto_id: 0
            }
        },
        clpr_brwNoEnCliente: {
            name: 'clpr_brwNoEnCliente',
            keyMappings: {
                c_producto_id: 0
            }
        }
    });
const $b5689aac67c13f6e$var$lookups = ()=>({
        'Clientes': {
            name: 'Clientes',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $9u8qf.Clientes)(client, parentKeys)
        },
        'Productos': {
            name: 'Productos',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $4usKR.Productos)(client, parentKeys)
        },
        'TiposCodigoBarra': {
            name: 'TiposCodigoBarra',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $lMr9U.catTiposCodigoBarra)(client, parentKeys)
        },
        'GruposProducto': {
            name: 'GruposProducto',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $45za5.catGruposProducto)(client, parentKeys)
        },
        'FormatosDeVenta': {
            name: 'FormatosDeVenta',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $kEjqx.catFormatosDeVenta)(client, parentKeys)
        },
        'Activo': {
            name: 'Activo',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $5kp3N.estActivo)(client, parentKeys)
        }
    });
class $b5689aac67c13f6e$export$b5ef3e86342d70fa extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('ClientesProductos'), this.columns = $b5689aac67c13f6e$var$columns(), this.views = $b5689aac67c13f6e$var$views(), this.lookups = $b5689aac67c13f6e$var$lookups();
    }
}

});


parcelRegister("393D4", function(module, exports) {

$parcel$export(module.exports, "ClientesTiendasProductos", () => $ec42e06a36f22bad$export$b20f1987f37395b7);

var $49qEn = parcelRequire("49qEn");

var $4usKR = parcelRequire("4usKR");

var $e31Nl = parcelRequire("e31Nl");

class $ec42e06a36f22bad$export$b20f1987f37395b7 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $e31Nl.ClientesTiendasProductosDef)(), parentKeys);
        this.Form = (parcelRequire("gSBMI")).then((module)=>module.ClientesTiendasProductosForm);
        this.Title = "Productos";
        this.Icon = (0, $4usKR.ProductosIcon);
        this.HelpText = "* Aqu\xed puede asignar los productos para la tienda.";
    }
}

});
parcelRegister("e31Nl", function(module, exports) {

$parcel$export(module.exports, "ClientesTiendasProductosDef", () => $2b0c9ad8da60c2d9$export$6f27b1e80f076bdf);

var $49qEn = parcelRequire("49qEn");

var $fbOz4 = parcelRequire("fbOz4");

var $3qtud = parcelRequire("3qtud");

var $2Nw3V = parcelRequire("2Nw3V");

var $393D4 = parcelRequire("393D4");

var $eSJT1 = parcelRequire("eSJT1");
const $2b0c9ad8da60c2d9$var$columns = ()=>({
        c_cliente_id: new (0, $49qEn.EntityColumn)({
            name: 'c_cliente_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Cliente ID'
        }),
        c_tienda_id: new (0, $49qEn.EntityColumn)({
            name: 'c_tienda_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Tienda ID'
        }),
        c_producto_id: new (0, $49qEn.EntityColumn)({
            name: 'c_producto_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Producto ID'
        }),
        n_ultimo_precio: new (0, $49qEn.EntityColumn)({
            name: 'n_ultimo_precio',
            type: 'decimal',
            length: 14,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Ultimo precio'
        }),
        i_ultima_cantidad: new (0, $49qEn.EntityColumn)({
            name: 'i_ultima_cantidad',
            type: 'int',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Ultima cantidad'
        }),
        c_servicio_id: new (0, $49qEn.EntityColumn)({
            name: 'c_servicio_id',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Servicios',
            isArray: true
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $2b0c9ad8da60c2d9$var$views = ()=>({
        ctip_brwStandard: {
            name: 'ctip_brwStandard',
            keyMappings: {
                c_producto_id: 0
            },
            gridColumnsOverrides: (0, $eSJT1.ClientesTiendasProductosOverrides)
        },
        ctip_brwNoEnTienda: {
            name: 'ctip_brwNoEnTienda',
            keyMappings: {
                c_producto_id: 0
            }
        },
        ctip_brwProductosPorTienda: {
            name: 'ctip_brwProductosPorTienda',
            keyMappings: {
                c_cliente_id: 0,
                c_producto_id: 2
            }
        }
    });
const $2b0c9ad8da60c2d9$var$lookups = ()=>({
        'Productos': {
            name: 'Productos',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $fbOz4.ClientesProductos)(client, parentKeys)
        },
        'ProductosNoEnTienda': {
            name: 'ProductosNoEnTienda',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            view: 'ctip_brwNoEnTienda',
            entityConstructor: (client, parentKeys)=>new (0, $393D4.ClientesTiendasProductos)(client, parentKeys)
        },
        'Servicios': {
            name: 'Servicios',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $3qtud.ClientesServicios)(client, parentKeys)
        }
    });
const $2b0c9ad8da60c2d9$var$clientActions = ()=>({
        ACTSeleccionarProductos: (0, $2Nw3V.ACTSeleccionarProductos)
    });
class $2b0c9ad8da60c2d9$export$6f27b1e80f076bdf extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('ClientesTiendasProductos'), this.columns = $2b0c9ad8da60c2d9$var$columns(), this.views = $2b0c9ad8da60c2d9$var$views(), this.lookups = $2b0c9ad8da60c2d9$var$lookups(), this.clientActions = $2b0c9ad8da60c2d9$var$clientActions();
    }
}

});
parcelRegister("3qtud", function(module, exports) {

$parcel$export(module.exports, "ClientesServicios", () => $931420a45caa6514$export$b55cf78f75fbaa6c);

var $49qEn = parcelRequire("49qEn");

var $gKBQM = parcelRequire("gKBQM");

var $1e0mh = parcelRequire("1e0mh");

class $931420a45caa6514$export$b55cf78f75fbaa6c extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $1e0mh.ClientesServiciosDef)(), parentKeys);
        super.Form = (parcelRequire("hP7N1")).then((module)=>module.ClientesServiciosForm);
        this.Icon = (0, $gKBQM.ServiciosIcon);
        this.HelpText = (0, $gKBQM.ServiciosHelpText);
        this.Title = "Servicio";
    }
}

});
parcelRegister("1e0mh", function(module, exports) {

$parcel$export(module.exports, "ClientesServiciosDef", () => $aaddc10b7869e6ac$export$df70878b059ff523);

var $49qEn = parcelRequire("49qEn");

var $3TX0s = parcelRequire("3TX0s");

var $99fvj = parcelRequire("99fvj");

var $5wo6I = parcelRequire("5wo6I");

var $6LYxo = parcelRequire("6LYxo");

var $k9JMU = parcelRequire("k9JMU");

var $gKBQM = parcelRequire("gKBQM");

var $iLSSH = parcelRequire("iLSSH");
const $aaddc10b7869e6ac$var$columns = ()=>({
        c_cliente_id: new (0, $49qEn.EntityColumn)({
            name: 'c_cliente_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Cliente ID'
        }),
        c_servicio_id: new (0, $49qEn.EntityColumn)({
            name: 'c_servicio_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Servicio'
        }),
        dt_fecha_inicio: new (0, $49qEn.EntityColumn)({
            name: 'dt_fecha_inicio',
            type: 'datetime',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Fecha de inicio'
        }),
        i_dias_envio_informacion: new (0, $49qEn.EntityColumn)({
            name: 'i_dias_envio_informacion',
            type: 'int',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "D\xedas antes de entrega informaci\xf3n"
        }),
        i_dias_finalizacion: new (0, $49qEn.EntityColumn)({
            name: 'i_dias_finalizacion',
            type: 'int',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "D\xedas antes de finalizaci\xf3n"
        }),
        vc_observaciones: new (0, $49qEn.EntityColumn)({
            name: 'vc_observaciones',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Observaciones'
        }),
        c_frecuenciatiempo_id: new (0, $49qEn.EntityColumn)({
            name: 'c_frecuenciatiempo_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Frecuencia de Datos'
        }),
        c_diassemana_id: new (0, $49qEn.EntityColumn)({
            name: 'c_diassemana_id',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "D\xeda"
        }),
        c_enviomensual_id: new (0, $49qEn.EntityColumn)({
            name: 'c_enviomensual_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Semana'
        }),
        c_envioquincenal_id: new (0, $49qEn.EntityColumn)({
            name: 'c_envioquincenal_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Semana'
        }),
        c_frecuenciaact_id: new (0, $49qEn.EntityColumn)({
            name: 'c_frecuenciaact_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Frecuencia de Retenci\xf3n"
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $aaddc10b7869e6ac$var$views = ()=>({
        clse_brwStandard: {
            name: 'clse_brwStandard',
            keyMappings: {
                c_servicio_id: 0
            }
        }
    });
const $aaddc10b7869e6ac$var$lookups = ()=>({
        'Servicios': {
            name: 'Servicios',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $gKBQM.Servicios)(client, parentKeys)
        },
        'FrecuenciaTiempo': {
            name: 'FrecuenciaTiempo',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $k9JMU.catFrecuenciaTiempo)(client, parentKeys)
        },
        'DiasSemana': {
            name: 'DiasSemana',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $3TX0s.catDiasSemana)(client, parentKeys)
        },
        'EnvioMensual': {
            name: 'EnvioMensual',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $99fvj.catEnvioMensual)(client, parentKeys)
        },
        'EnvioQuincenal': {
            name: 'EnvioQuincenal',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $5wo6I.catEnvioQuincenal)(client, parentKeys)
        },
        'FrecuenciaActualizacion': {
            name: 'FrecuenciaActualizacion',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $6LYxo.catFrecuenciaAct)(client, parentKeys)
        }
    });
const $aaddc10b7869e6ac$var$clientActions = ()=>({
        ACTSeleccionarServicios: (0, $iLSSH.ACTSeleccionarServicios)
    });
class $aaddc10b7869e6ac$export$df70878b059ff523 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('ClientesServicios'), this.columns = $aaddc10b7869e6ac$var$columns(), this.views = $aaddc10b7869e6ac$var$views(), this.lookups = $aaddc10b7869e6ac$var$lookups(), this.clientActions = $aaddc10b7869e6ac$var$clientActions();
    }
}

});
parcelRegister("3TX0s", function(module, exports) {

$parcel$export(module.exports, "DiasSemanaIcon", () => $0e1c8caef69c0225$export$b4206c24af2eb64f);
$parcel$export(module.exports, "DiasSemanaHelpText", () => $0e1c8caef69c0225$export$82e26ecc903a0a82);
$parcel$export(module.exports, "catDiasSemana", () => $0e1c8caef69c0225$export$d0303ba423f137d1);

var $49qEn = parcelRequire("49qEn");

var $gsgdS = parcelRequire("gsgdS");
const $0e1c8caef69c0225$export$b4206c24af2eb64f = (0, $gsgdS.default);
const $0e1c8caef69c0225$export$82e26ecc903a0a82 = "* Aqu\xed puede ver los dias de la semana.";
class $0e1c8caef69c0225$export$d0303ba423f137d1 extends (0, $49qEn.CategoriesValues) {
    constructor(client, parentKeys = {}){
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "DiasSemana";
        this.def.columns.c_category_id.defaultValue = "DiasSemana";
        this.Title = "Dias de la Semana";
        this.HelpText = $0e1c8caef69c0225$export$82e26ecc903a0a82;
        this.Icon = $0e1c8caef69c0225$export$b4206c24af2eb64f;
    }
}

});

parcelRegister("99fvj", function(module, exports) {

$parcel$export(module.exports, "EnvioMensualIcon", () => $7d08d242d56573cd$export$ca09e90fdb064b1d);
$parcel$export(module.exports, "EnvioMensualHelpText", () => $7d08d242d56573cd$export$c19adc5c402ff0d2);
$parcel$export(module.exports, "catEnvioMensual", () => $7d08d242d56573cd$export$e7a57d1289702f52);

var $49qEn = parcelRequire("49qEn");

var $gPbJn = parcelRequire("gPbJn");
const $7d08d242d56573cd$export$ca09e90fdb064b1d = (0, $gPbJn.default);
const $7d08d242d56573cd$export$c19adc5c402ff0d2 = "* Aqu\xed puede ver la lista de envios mensuales.";
class $7d08d242d56573cd$export$e7a57d1289702f52 extends (0, $49qEn.CategoriesValues) {
    constructor(client, parentKeys = {}){
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "EnvioMensual";
        this.def.columns.c_category_id.defaultValue = "EnvioMensual";
        this.Title = "Envios Mensuales";
        this.HelpText = $7d08d242d56573cd$export$c19adc5c402ff0d2;
        this.Icon = $7d08d242d56573cd$export$ca09e90fdb064b1d;
    }
}

});
parcelRegister("gPbJn", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d285ee5593f8b03$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $5d285ee5593f8b03$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M16 12.5l-5 -3l5 -3l5 3v5.5l-5 3z",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M11 9.5v5.5l5 3",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M16 12.545l5 -3.03",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M7 9h-5",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M7 12h-3",
            "key": "svg-4"
        }
    ],
    [
        "path",
        {
            "d": "M7 15h-1",
            "key": "svg-5"
        }
    ]
];
const $5d285ee5593f8b03$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "cube-send", "CubeSend", $5d285ee5593f8b03$export$3efd853dbb351e94);

});


parcelRegister("5wo6I", function(module, exports) {

$parcel$export(module.exports, "EnvioQuincenalIcon", () => $af1f3306ed675700$export$da1919849d84c3b8);
$parcel$export(module.exports, "EnvioQuincenalHelpText", () => $af1f3306ed675700$export$62fb3f58a36b1a8c);
$parcel$export(module.exports, "catEnvioQuincenal", () => $af1f3306ed675700$export$5bf70cff69053e8b);

var $49qEn = parcelRequire("49qEn");

var $gPbJn = parcelRequire("gPbJn");
const $af1f3306ed675700$export$da1919849d84c3b8 = (0, $gPbJn.default);
const $af1f3306ed675700$export$62fb3f58a36b1a8c = "* Aqu\xed puede ver la lista de env\xedos por quincena.";
class $af1f3306ed675700$export$5bf70cff69053e8b extends (0, $49qEn.CategoriesValues) {
    constructor(client, parentKeys = {}){
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "EnvioQuincenal";
        this.def.columns.c_category_id.defaultValue = "EnvioQuincenal";
        this.Title = "Env\xedos Quincenales";
        this.Icon = $af1f3306ed675700$export$da1919849d84c3b8;
        this.HelpText = $af1f3306ed675700$export$62fb3f58a36b1a8c;
    }
}

});

parcelRegister("iLSSH", function(module, exports) {

$parcel$export(module.exports, "ACTSeleccionarServicios", () => $cccf44fe9fbfdccd$export$6bea8b62ba9b9e6e);

var $ayMG0 = parcelRequire("ayMG0");

var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $gKBQM = parcelRequire("gKBQM");
const $cccf44fe9fbfdccd$export$6bea8b62ba9b9e6e = {
    name: 'ACTSeleccionarServicios',
    label: "Selecci\xf3n m\xfaltiple",
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Seleccionar servicios"
    }),
    refreshOnClose: true,
    dontRequireSelection: true,
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        // cast entity
        const parent = entity;
        const servicios = new (0, $gKBQM.Servicios)(entity.API.client);
        servicios.parentKeys = parent.parentKeys;
        if (modal) await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                    fw: "700",
                    children: "Seleccionar servicios"
                })
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.LookupFormAction), {
                lookupEntity: servicios,
                viewName: servicios.def.views.serv_brwStandard.name,
                title: "Agregar servicios seleccionados",
                onActionFinished: async ()=>{
                    if (onClose) await onClose();
                },
                onOK: async (keys, abortSignal)=>{
                    const clientes_servicios = (0, $49qEn.Entity).clone(parent);
                    clientes_servicios.def.columns.c_cliente_id.value = parent.parentKeys[clientes_servicios.def.columns.c_cliente_id.name];
                    const result = await clientes_servicios.API.addData(abortSignal, keys, true);
                    return result;
                }
            })
        });
        else console.log('modal context not found');
        return Promise.resolve(false);
    }
};

});


parcelRegister("hP7N1", function(module, exports) {
module.exports = import("gxzG3").then(()=>parcelRequire('chCIN'));

});


parcelRegister("2Nw3V", function(module, exports) {

$parcel$export(module.exports, "ACTSeleccionarProductos", () => $f20e14fabc81573e$export$601dd4f485cba9d3);

var $ayMG0 = parcelRequire("ayMG0");

var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fbOz4 = parcelRequire("fbOz4");
const $f20e14fabc81573e$export$601dd4f485cba9d3 = {
    name: 'ACTSeleccionarProductos',
    label: 'Seleccionar productos',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Seleccionar productos"
    }),
    refreshOnClose: true,
    dontRequireSelection: true,
    views: [
        'ctip_brwStandard'
    ],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        // cast entity
        const parent = entity;
        const productos = new (0, $fbOz4.ClientesProductos)(entity.API.client);
        productos.parentKeys = parent.parentKeys;
        if (modal) await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                    fw: "700",
                    children: "Seleccionar productos"
                }),
                size: 'xl'
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.LookupFormAction), {
                lookupEntity: productos,
                viewName: productos.def.views.clpr_brwStandard.name,
                title: "Agregar productos seleccionados",
                onActionFinished: async ()=>{
                    if (onClose) await onClose();
                },
                onOK: async (keys, abortSignal)=>{
                    const clientes_tiendas_productos = (0, $49qEn.Entity).clone(parent);
                    clientes_tiendas_productos.def.columns.c_cliente_id.value = parent.parentKeys[clientes_tiendas_productos.def.columns.c_cliente_id.name];
                    clientes_tiendas_productos.def.columns.c_tienda_id.value = parent.parentKeys[clientes_tiendas_productos.def.columns.c_tienda_id.name];
                    const result = await clientes_tiendas_productos.API.addData(abortSignal, keys, true);
                    return result;
                }
            })
        });
        else console.log('modal context not found');
        return Promise.resolve(false);
    }
};

});

parcelRegister("eSJT1", function(module, exports) {

$parcel$export(module.exports, "ClientesTiendasProductosOverrides", () => $9452770f864a98ce$export$ca73c2d1cee2476f);

var $ayMG0 = parcelRequire("ayMG0");

var $9mTYo = parcelRequire("9mTYo");

var $iEQtx = parcelRequire("iEQtx");
function $9452770f864a98ce$export$ca73c2d1cee2476f(theme) {
    //Overrides para alertas
    return {
        4: {
            render: (value)=>!value ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iEQtx.default), {
                            style: {
                                color: theme.colors.red[8]
                            },
                            size: "1.3rem"
                        }),
                        "Sin servicios"
                    ]
                }) : value
        }
    };
}

});


parcelRegister("gSBMI", function(module, exports) {
module.exports = import("kps5h").then(()=>parcelRequire('1a9Xb'));

});



parcelRegister("7p7hH", function(module, exports) {

$parcel$export(module.exports, "ACTAsignarServicios", () => $9f2cddee2cb185a7$export$762458dc20665af7);

var $ayMG0 = parcelRequire("ayMG0");

var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $3qtud = parcelRequire("3qtud");

var $gbYxj = parcelRequire("gbYxj");
const $9f2cddee2cb185a7$export$762458dc20665af7 = {
    name: 'ACTAsignarServicios',
    label: 'Asignar servicios',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Asignar servicios"
    }),
    refreshOnClose: true,
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        // cast entity
        const parent = entity;
        const servicios = new (0, $3qtud.ClientesServicios)(entity.API.client);
        servicios.parentKeys = parent.parentKeys;
        if (modal) await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                    fw: "700",
                    children: "Asignar servicios"
                }),
                size: 'md'
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.LookupFormAction), {
                lookupEntity: servicios,
                viewName: servicios.def.views.clse_brwStandard.name,
                title: "Asignar servicios seleccionados",
                confirmContent: "\xbfEst\xe1 seguro de que desea asignar los servicios seleccionados a las tiendas seleccionadas?",
                onActionFinished: async ()=>{
                    if (onClose) await onClose();
                },
                onOK: async (keys, abortSignal)=>{
                    if (selectedKeys && selectedKeys.length > 0) {
                        const clientes_tiendas_servicios = new (0, $gbYxj.ClientesTiendasServicios)(entity.API.client, entity.parentKeys);
                        clientes_tiendas_servicios.def.columns.c_cliente_id.value = parent.parentKeys[clientes_tiendas_servicios.def.columns.c_cliente_id.name];
                        for (const key of selectedKeys ?? []){
                            clientes_tiendas_servicios.def.columns.c_tienda_id.value = key[clientes_tiendas_servicios.def.columns.c_tienda_id.name];
                            await clientes_tiendas_servicios.API.addData(abortSignal, keys, true);
                        }
                    }
                    return {
                        Results: [
                            {
                                Status: 0,
                                Message: 'OK'
                            }
                        ]
                    };
                }
            })
        });
        else console.log('modal context not found');
        return Promise.resolve(false);
    }
};

});
parcelRegister("gbYxj", function(module, exports) {

$parcel$export(module.exports, "ClientesTiendasServicios", () => $44d0f98d9bd0587e$export$1e8cbf43843ebe1d);

var $49qEn = parcelRequire("49qEn");

var $gKBQM = parcelRequire("gKBQM");

var $dJeki = parcelRequire("dJeki");

class $44d0f98d9bd0587e$export$1e8cbf43843ebe1d extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $dJeki.ClientesTiendasServiciosDef)(), parentKeys);
        super.Form = (parcelRequire("em7qk")).then((module)=>module.ClientesTiendasServiciosForm);
        this.Title = "Servicios";
        this.Icon = (0, $gKBQM.ServiciosIcon);
        this.HelpText = (0, $gKBQM.ServiciosHelpText);
    }
}

});
parcelRegister("dJeki", function(module, exports) {

$parcel$export(module.exports, "ClientesTiendasServiciosDef", () => $79d4d49c4ae54a51$export$90b662a967a30d6);

var $49qEn = parcelRequire("49qEn");

var $3qtud = parcelRequire("3qtud");

var $abwhM = parcelRequire("abwhM");

var $gbYxj = parcelRequire("gbYxj");

var $ifmmR = parcelRequire("ifmmR");
const $79d4d49c4ae54a51$var$columns = ()=>({
        c_cliente_id: new (0, $49qEn.EntityColumn)({
            name: 'c_cliente_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Cliente ID'
        }),
        c_tienda_id: new (0, $49qEn.EntityColumn)({
            name: 'c_tienda_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Tienda ID'
        }),
        c_servicio_id: new (0, $49qEn.EntityColumn)({
            name: 'c_servicio_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Servicio'
        }),
        dt_fecha_inicio: new (0, $49qEn.EntityColumn)({
            name: 'dt_fecha_inicio',
            type: 'datetime',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Fecha de Inicio'
        }),
        i_dias_envio_informacion: new (0, $49qEn.EntityColumn)({
            name: 'i_dias_envio_informacion',
            type: 'int',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Dias de Env\xedo de Informaci\xf3n"
        }),
        i_dias_finalizacion: new (0, $49qEn.EntityColumn)({
            name: 'i_dias_finalizacion',
            type: 'int',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Dias de finalizaci\xf3n"
        }),
        vc_observaciones: new (0, $49qEn.EntityColumn)({
            name: 'vc_observaciones',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Observaci\xf3nes"
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $79d4d49c4ae54a51$var$views = ()=>({
        clts_brwStandard: {
            name: 'clts_brwStandard',
            keyMappings: {
                c_servicio_id: 0
            },
            gridColumnsOverrides: (0, $ifmmR.ClientesTiendasServiciosOverrides)
        },
        clts_brwNoEnTienda: {
            name: 'clts_brwNoEnTienda',
            keyMappings: {
                c_servicio_id: 0
            }
        }
    });
const $79d4d49c4ae54a51$var$lookups = ()=>({
        'Servicios': {
            name: 'Servicios',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $3qtud.ClientesServicios)(client, parentKeys)
        },
        'ServiciosNoEnTienda': {
            name: 'ServiciosNoEnTienda',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            view: 'clts_brwNoEnTienda',
            entityConstructor: (client, parentKeys)=>new (0, $gbYxj.ClientesTiendasServicios)(client, parentKeys)
        }
    });
const $79d4d49c4ae54a51$var$clientActions = ()=>({
        ACTSeleccionarServicios: (0, $abwhM.ACTSeleccionarServicios)
    });
class $79d4d49c4ae54a51$export$90b662a967a30d6 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('ClientesTiendasServicios'), this.columns = $79d4d49c4ae54a51$var$columns(), this.views = $79d4d49c4ae54a51$var$views(), this.lookups = $79d4d49c4ae54a51$var$lookups(), this.clientActions = $79d4d49c4ae54a51$var$clientActions();
    }
}

});
parcelRegister("abwhM", function(module, exports) {

$parcel$export(module.exports, "ACTSeleccionarServicios", () => $09fdd6fba1a2a08c$export$6bea8b62ba9b9e6e);

var $ayMG0 = parcelRequire("ayMG0");

var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $3qtud = parcelRequire("3qtud");
const $09fdd6fba1a2a08c$export$6bea8b62ba9b9e6e = {
    name: 'ACTSeleccionarServicios',
    label: 'Seleccionar servicios',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Seleccionar servicios"
    }),
    refreshOnClose: true,
    dontRequireSelection: true,
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        // cast entity
        const parent = entity;
        const servicios = new (0, $3qtud.ClientesServicios)(entity.API.client);
        servicios.parentKeys = parent.parentKeys;
        if (modal) await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                    fw: "700",
                    children: "Seleccionar servicios"
                }),
                size: 'xl'
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.LookupFormAction), {
                lookupEntity: servicios,
                viewName: servicios.def.views.clse_brwStandard.name,
                title: "Agregar servicios seleccionados",
                onActionFinished: async ()=>{
                    if (onClose) await onClose();
                },
                onOK: async (keys, abortSignal)=>{
                    const clientes_tiendas_servicios = (0, $49qEn.Entity).clone(parent);
                    clientes_tiendas_servicios.def.columns.c_cliente_id.value = parent.parentKeys[clientes_tiendas_servicios.def.columns.c_cliente_id.name];
                    clientes_tiendas_servicios.def.columns.c_tienda_id.value = parent.parentKeys[clientes_tiendas_servicios.def.columns.c_tienda_id.name];
                    const result = await clientes_tiendas_servicios.API.addData(abortSignal, keys, true);
                    return result;
                }
            })
        });
        else console.log('modal context not found');
        return Promise.resolve(false);
    }
};

});

parcelRegister("ifmmR", function(module, exports) {

$parcel$export(module.exports, "ClientesTiendasServiciosOverrides", () => $8d6f758591444a0f$export$4fe9df2269ab012c);

var $ayMG0 = parcelRequire("ayMG0");

var $9mTYo = parcelRequire("9mTYo");

var $6zxJ3 = parcelRequire("6zxJ3");
function $8d6f758591444a0f$export$4fe9df2269ab012c(theme) {
    return {
        2: {
            render: (value)=>!value || value === '0' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6zxJ3.default), {
                            style: {
                                color: theme.colors.yellow[8]
                            },
                            size: "1.3rem"
                        }),
                        "Sin productos"
                    ]
                }) : value
        }
    };
}

});


parcelRegister("em7qk", function(module, exports) {
module.exports = Promise.all([
    import("iL7AZ"),
    import("hdCcc")
]).then(()=>parcelRequire('gFUD1'));

});



parcelRegister("dFiLq", function(module, exports) {

$parcel$export(module.exports, "ACTQuitarProductos", () => $f6758e224121aa7d$export$d7aca8c27450ede2);

var $ayMG0 = parcelRequire("ayMG0");

var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fbOz4 = parcelRequire("fbOz4");

var $393D4 = parcelRequire("393D4");
const $f6758e224121aa7d$export$d7aca8c27450ede2 = {
    name: 'ACTQuitarProductos',
    label: 'Quitar productos',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Quitar productos"
    }),
    refreshOnClose: true,
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        // cast entity
        const parent = entity;
        const productos = new (0, $fbOz4.ClientesProductos)(entity.API.client);
        productos.parentKeys = parent.parentKeys;
        if (modal) await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                    fw: "700",
                    children: "Quitar productos"
                }),
                size: 'xl'
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.LookupFormAction), {
                lookupEntity: productos,
                viewName: productos.def.views.clpr_brwStandard.name,
                title: "Quitar productos seleccionados",
                confirmContent: "\xbfEst\xe1 seguro de que desea Quitar los productos seleccionados a las tiendas seleccionadas?",
                onActionFinished: async ()=>{
                    if (onClose) await onClose();
                },
                onOK: async (keys, abortSignal)=>{
                    if (selectedKeys && selectedKeys.length > 0) {
                        const clientes_tiendas_productos = new (0, $393D4.ClientesTiendasProductos)(entity.API.client, entity.parentKeys);
                        const parentKeys = {};
                        parentKeys[clientes_tiendas_productos.def.columns.c_cliente_id.name] = parent.parentKeys[clientes_tiendas_productos.def.columns.c_cliente_id.name];
                        for (const key of selectedKeys){
                            parentKeys[clientes_tiendas_productos.def.columns.c_tienda_id.name] = key[clientes_tiendas_productos.def.columns.c_tienda_id.name];
                            await clientes_tiendas_productos.API.deleteData(keys, abortSignal, parentKeys);
                        }
                    }
                    return {
                        Results: [
                            {
                                Status: 0,
                                Message: 'OK'
                            }
                        ]
                    };
                }
            })
        });
        else console.log('modal context not found');
        return Promise.resolve(false);
    }
};

});

parcelRegister("6UH3r", function(module, exports) {

$parcel$export(module.exports, "ACTQuitarServicios", () => $20801324c34576e4$export$636a5e982b2339b2);

var $ayMG0 = parcelRequire("ayMG0");

var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $3qtud = parcelRequire("3qtud");

var $gbYxj = parcelRequire("gbYxj");
const $20801324c34576e4$export$636a5e982b2339b2 = {
    name: 'ACTQuitarServicios',
    label: 'Quitar servicios',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Quitar servicios"
    }),
    refreshOnClose: true,
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        // cast entity
        const parent = entity;
        const servicios = new (0, $3qtud.ClientesServicios)(entity.API.client);
        servicios.parentKeys = parent.parentKeys;
        if (modal) await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                    fw: "700",
                    children: "Quitar servicios"
                }),
                size: 'md'
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.LookupFormAction), {
                lookupEntity: servicios,
                viewName: servicios.def.views.clse_brwStandard.name,
                title: "Quitar servicios seleccionados",
                confirmContent: "\xbfEst\xe1 seguro de que desea Quitar los servicios seleccionados a las tiendas seleccionadas?",
                onActionFinished: async ()=>{
                    if (onClose) await onClose();
                },
                onOK: async (keys, abortSignal)=>{
                    if (selectedKeys && selectedKeys.length > 0) {
                        const clientes_tiendas_servicios = new (0, $gbYxj.ClientesTiendasServicios)(entity.API.client, entity.parentKeys);
                        const parentKeys = {};
                        parentKeys[clientes_tiendas_servicios.def.columns.c_cliente_id.name] = parent.parentKeys[clientes_tiendas_servicios.def.columns.c_cliente_id.name];
                        for (const key of selectedKeys){
                            parentKeys[clientes_tiendas_servicios.def.columns.c_tienda_id.name] = key[clientes_tiendas_servicios.def.columns.c_tienda_id.name];
                            await clientes_tiendas_servicios.API.deleteData(keys, abortSignal, parentKeys);
                        }
                    }
                    return {
                        Results: [
                            {
                                Status: 0,
                                Message: 'OK'
                            }
                        ]
                    };
                }
            })
        });
        else console.log('modal context not found');
        return Promise.resolve(false);
    }
};

});

parcelRegister("hjvVr", function(module, exports) {

$parcel$export(module.exports, "ClientesConfiguracionTiendasRutaStatusOverrides", () => $458f7590a73f9a13$export$83c97f9ca9a9fe76);

var $ayMG0 = parcelRequire("ayMG0");

var $9mTYo = parcelRequire("9mTYo");

var $49qEn = parcelRequire("49qEn");

var $iEQtx = parcelRequire("iEQtx");
var $6zxJ3 = parcelRequire("6zxJ3");
var $j0J5n = parcelRequire("j0J5n");
var $j0QhJ = parcelRequire("j0QhJ");
var $ce5R4 = parcelRequire("ce5R4");
function $458f7590a73f9a13$export$83c97f9ca9a9fe76(theme) {
    //Overrides para alertas
    return {
        4: {
            render: (value)=>!value ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    sx: {
                        gap: '.5rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j0J5n.default), {
                            style: {
                                color: theme.colors.red[8]
                            },
                            size: "1.3rem"
                        }),
                        "Sin ubicaci\xf3n"
                    ]
                }) : value
        },
        8: {
            render: (value)=>value === "true" ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    sx: {
                        gap: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.CircleFilledIcon), {
                            backColor: theme.colors.teal[8],
                            width: "1.3rem",
                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ce5R4.default), {
                                size: "0.9rem"
                            })
                        }),
                        "Compartida"
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    sx: {
                        gap: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.CircleFilledIcon), {
                            backColor: theme.colors.grape[8],
                            width: "1.3rem",
                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j0QhJ.default), {
                                size: "0.9rem"
                            })
                        }),
                        "Exclusiva"
                    ]
                })
        },
        9: {
            render: (value)=>!value || value === '0' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    sx: {
                        gap: '.5rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6zxJ3.default), {
                            style: {
                                color: theme.colors.yellow[8]
                            },
                            size: "1.3rem"
                        }),
                        "Sin productos"
                    ]
                }) : value
        },
        10: {
            render: (value)=>!value ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    sx: {
                        gap: '.5rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iEQtx.default), {
                            style: {
                                color: theme.colors.red[8]
                            },
                            size: "1.3rem"
                        }),
                        "Sin servicios"
                    ]
                }) : value
        }
    };
}

});
parcelRegister("j0J5n", function(module, exports) {

$parcel$export(module.exports, "default", () => $03ede6fdbb3d4218$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $03ede6fdbb3d4218$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M18.364 4.636a9 9 0 0 1 .203 12.519l-.203 .21l-4.243 4.242a3 3 0 0 1 -4.097 .135l-.144 -.135l-4.244 -4.243a9 9 0 0 1 12.728 -12.728zm-6.364 3.364a3 3 0 1 0 0 6a3 3 0 0 0 0 -6z",
            "key": "svg-0"
        }
    ]
];
const $03ede6fdbb3d4218$export$2e2bcd8739ae039 = (0, $eednQ.default)("filled", "map-pin-filled", "MapPinFilled", $03ede6fdbb3d4218$export$3efd853dbb351e94);

});

parcelRegister("ce5R4", function(module, exports) {

$parcel$export(module.exports, "default", () => $3179916719a6f561$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $3179916719a6f561$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M5 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M3 21v-2a4 4 0 0 1 4 -4h4c.96 0 1.84 .338 2.53 .901",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M16 3.13a4 4 0 0 1 0 7.75",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M16 19h6",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M19 16v6",
            "key": "svg-4"
        }
    ]
];
const $3179916719a6f561$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "users-plus", "UsersPlus", $3179916719a6f561$export$3efd853dbb351e94);

});


parcelRegister("i0O3P", function(module, exports) {

$parcel$export(module.exports, "ClientesPorTiendaColumnsOverrides", () => $2feac71c96c10042$export$7c1d7e37f9c0f610);

var $ayMG0 = parcelRequire("ayMG0");

var $9mTYo = parcelRequire("9mTYo");

var $49qEn = parcelRequire("49qEn");

var $iEQtx = parcelRequire("iEQtx");
var $6zxJ3 = parcelRequire("6zxJ3");
var $j0QhJ = parcelRequire("j0QhJ");
var $ce5R4 = parcelRequire("ce5R4");
function $2feac71c96c10042$export$7c1d7e37f9c0f610(theme) {
    return {
        // Ruta compartida
        5: {
            render: (value)=>value === "true" ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    sx: {
                        gap: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.CircleFilledIcon), {
                            backColor: theme.colors.teal[8],
                            width: "1.3rem",
                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ce5R4.default), {
                                size: "0.9rem"
                            })
                        }),
                        "Compartida"
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    sx: {
                        gap: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.CircleFilledIcon), {
                            backColor: theme.colors.grape[8],
                            width: "1.3rem",
                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j0QhJ.default), {
                                size: "0.9rem"
                            })
                        }),
                        "Exclusiva"
                    ]
                })
        },
        // Productos
        6: {
            render: (value)=>!value || value === '0' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    sx: {
                        gap: '.5rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6zxJ3.default), {
                            style: {
                                color: theme.colors.yellow[8]
                            },
                            size: "1.3rem"
                        }),
                        "Sin productos"
                    ]
                }) : value
        },
        // Servicios
        7: {
            render: (value)=>!value ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    sx: {
                        gap: '.5rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iEQtx.default), {
                            style: {
                                color: theme.colors.red[8]
                            },
                            size: "1.3rem"
                        }),
                        "Sin servicios"
                    ]
                }) : value
        }
    };
}

});


parcelRegister("jSisk", function(module, exports) {
module.exports = Promise.all([
    import("iL7AZ"),
    import("gfhHV")
]).then(()=>parcelRequire('gifsz'));

});


parcelRegister("9ln4I", function(module, exports) {
module.exports = import("3kqgZ").then(()=>parcelRequire('6xuYs'));

});

parcelRegister("giXL1", function(module, exports) {

$parcel$export(module.exports, "DispositivosIcon", () => $3969d9bff92ac52e$export$3f575affda7d8f9c);
$parcel$export(module.exports, "DispositivosHelpText", () => $3969d9bff92ac52e$export$796280d577af4c56);
$parcel$export(module.exports, "Dispositivos", () => $3969d9bff92ac52e$export$df221368140ebad);

var $49qEn = parcelRequire("49qEn");

var $6ayRl = parcelRequire("6ayRl");

var $7FjC3 = parcelRequire("7FjC3");
const $3969d9bff92ac52e$export$3f575affda7d8f9c = (0, $6ayRl.default);
const $3969d9bff92ac52e$export$796280d577af4c56 = "* Contiene los dispositivos con los que opera la instituci\xf3n";

class $3969d9bff92ac52e$export$df221368140ebad extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $7FjC3.DispositivosDef)(), parentKeys);
        this.Form = (parcelRequire("7yqXv")).then((module)=>module.DispositivosForm);
        this.Title = 'Dispositivos';
        this.Icon = $3969d9bff92ac52e$export$3f575affda7d8f9c;
        this.HelpText = $3969d9bff92ac52e$export$796280d577af4c56;
    }
}

});
parcelRegister("6ayRl", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e3056d2d72af643$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $7e3056d2d72af643$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M6 5a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-14z",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M11 4h2",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M12 17v.01",
            "key": "svg-2"
        }
    ]
];
const $7e3056d2d72af643$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "device-mobile", "DeviceMobile", $7e3056d2d72af643$export$3efd853dbb351e94);

});

parcelRegister("7FjC3", function(module, exports) {

$parcel$export(module.exports, "DispositivosDef", () => $9f87c9b10b93f0a2$export$bbae03dafe18e0dd);

var $49qEn = parcelRequire("49qEn");

var $aUp8k = parcelRequire("aUp8k");
const $9f87c9b10b93f0a2$var$columns = ()=>({
        c_dispositivo_id: new (0, $49qEn.EntityColumn)({
            name: 'c_dispositivo_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PKAutonum,
            prompt: 'Dispositivo Id',
            description: "Id entificador \xfanico del dispositivo, generado autom\xe1ticamente por el sistema"
        }),
        vc_descripcion: new (0, $49qEn.EntityColumn)({
            name: 'vc_descripcion',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: "Descripci\xf3n",
            description: "Descripci\xf3n del dispositivo"
        }),
        vc_marca: new (0, $49qEn.EntityColumn)({
            name: 'vc_marca',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Marca',
            description: 'Marca del dispositivo'
        }),
        vc_modelo: new (0, $49qEn.EntityColumn)({
            name: 'vc_modelo',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Modelo',
            description: 'Modelo del dispositivo'
        }),
        vc_numeroserie: new (0, $49qEn.EntityColumn)({
            name: 'vc_numeroserie',
            type: 'varchar',
            length: 50,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Numero de serie',
            description: "N\xfamero de serie del dispositivo"
        }),
        vc_numerolinea: new (0, $49qEn.EntityColumn)({
            name: 'vc_numerolinea',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Numero de linea',
            description: "N\xfamero de l\xednea telef\xf3nica del dispositivo"
        }),
        b_asegurado: new (0, $49qEn.EntityColumn)({
            name: 'b_asegurado',
            type: 'bit',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Asegurado',
            description: "Indica si el dispositivo est\xe1 asegurado"
        }),
        vc_asignado_a: new (0, $49qEn.EntityColumn)({
            name: 'vc_asignado_a',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Personal Asignado',
            description: "Persona a la que est\xe1 asignado el dispositivo"
        }),
        vc_especificaciones: new (0, $49qEn.EntityColumn)({
            name: 'vc_especificaciones',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Especificaciones',
            description: "Especificaciones t\xe9cnicas del dispositivo"
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $9f87c9b10b93f0a2$var$views = ()=>({
        disp_brwStandard: {
            name: 'disp_brwStandard',
            keyMappings: {
                c_dispositivo_id: 0
            },
            gridColumnsOverrides: (0, $aUp8k.DispositivosOverrides)
        }
    });
class $9f87c9b10b93f0a2$export$bbae03dafe18e0dd extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('Dispositivos'), this.columns = $9f87c9b10b93f0a2$var$columns(), this.views = $9f87c9b10b93f0a2$var$views();
    }
}

});
parcelRegister("aUp8k", function(module, exports) {

$parcel$export(module.exports, "DispositivosOverrides", () => $64cf4bff4a2522eb$export$bf763b65ec12b77b);

var $ayMG0 = parcelRequire("ayMG0");

var $49qEn = parcelRequire("49qEn");

var $3US3h = parcelRequire("3US3h");
function $64cf4bff4a2522eb$export$bf763b65ec12b77b(theme) {
    const booleanRender = (value)=>value === 'true' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.CircleFilledIcon), {
            width: "1.3rem",
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3US3h.default), {
                size: "0.9rem"
            })
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {});
    return {
        //Asegurado
        6: {
            render: booleanRender
        }
    };
}

});


parcelRegister("7yqXv", function(module, exports) {
module.exports = import("6r2WN").then(()=>parcelRequire('2L79Z'));

});


parcelRegister("ivsSe", function(module, exports) {
module.exports = import("9MuzX").then(()=>parcelRequire('9iZxj'));

});

parcelRegister("4TDO3", function(module, exports) {
module.exports = import("hqIGe").then(()=>parcelRequire('7wiTX'));

});

parcelRegister("j8fD9", function(module, exports) {
module.exports = import("7eVCx").then(()=>parcelRequire('jBTrF'));

});

parcelRegister("iayaH", function(module, exports) {

$parcel$export(module.exports, "default", () => $32e9feea7782929e$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $32e9feea7782929e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M3 20h18v-8a3 3 0 0 0 -3 -3h-12a3 3 0 0 0 -3 3v8z",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M3 14.803c.312 .135 .654 .204 1 .197a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1c.35 .007 .692 -.062 1 -.197",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M12 4l1.465 1.638a2 2 0 1 1 -3.015 .099l1.55 -1.737z",
            "key": "svg-2"
        }
    ]
];
const $32e9feea7782929e$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "cake", "Cake", $32e9feea7782929e$export$3efd853dbb351e94);

});

parcelRegister("k0vmM", function(module, exports) {

$parcel$export(module.exports, "default", () => $be84f0e94c14cdf3$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $be84f0e94c14cdf3$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M12 10a5 5 0 1 1 0 10a5 5 0 0 1 0 -10z",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M12 10v-7",
            "key": "svg-1"
        }
    ]
];
const $be84f0e94c14cdf3$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "gender-neutrois", "GenderNeutrois", $be84f0e94c14cdf3$export$3efd853dbb351e94);

});

parcelRegister("hbKWn", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9758ab4ccffba6f$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $d9758ab4ccffba6f$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M15 7a2 2 0 0 1 2 2",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M15 3a6 6 0 0 1 6 6",
            "key": "svg-2"
        }
    ]
];
const $d9758ab4ccffba6f$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "phone-call", "PhoneCall", $d9758ab4ccffba6f$export$3efd853dbb351e94);

});

parcelRegister("2cMSZ", function(module, exports) {

$parcel$export(module.exports, "PersonalLicenciasIcon", () => $8166c2a1f6c4de59$export$5289ba409bf5602c);
$parcel$export(module.exports, "PersonalLicenciasText", () => $8166c2a1f6c4de59$export$ceb670a33381cd32);
$parcel$export(module.exports, "PersonalLicencias", () => $8166c2a1f6c4de59$export$4bba59531ffc0e3d);

var $49qEn = parcelRequire("49qEn");

var $dQo80 = parcelRequire("dQo80");

var $j5DtL = parcelRequire("j5DtL");
const $8166c2a1f6c4de59$export$5289ba409bf5602c = (0, $dQo80.default);
const $8166c2a1f6c4de59$export$ceb670a33381cd32 = "* Aqu\xed puede ver el historial de vacaciones, maternidad y otro tipo de licencias para esta persona";

class $8166c2a1f6c4de59$export$4bba59531ffc0e3d extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $j5DtL.PersonalLicenciasDef)(), parentKeys);
        super.Form = (parcelRequire("kKPpP")).then((module)=>module.PersonalLicenciasForm);
        this.Title = "Licencias";
        this.Icon = $8166c2a1f6c4de59$export$5289ba409bf5602c;
        this.HelpText = $8166c2a1f6c4de59$export$ceb670a33381cd32;
    }
}

});
parcelRegister("dQo80", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc45d5526d90bcfa$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $dc45d5526d90bcfa$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M11.795 21h-6.795a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M18 18m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M15 3v4",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M7 3v4",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M3 11h16",
            "key": "svg-4"
        }
    ],
    [
        "path",
        {
            "d": "M18 16.496v1.504l1 1",
            "key": "svg-5"
        }
    ]
];
const $dc45d5526d90bcfa$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "calendar-time", "CalendarTime", $dc45d5526d90bcfa$export$3efd853dbb351e94);

});

parcelRegister("j5DtL", function(module, exports) {

$parcel$export(module.exports, "PersonalLicenciasDef", () => $a925ef41551e91b3$export$52f62af2bc4f4815);

var $49qEn = parcelRequire("49qEn");

var $hMWb0 = parcelRequire("hMWb0");

var $7LP39 = parcelRequire("7LP39");

var $a9mhP = parcelRequire("a9mhP");
const $a925ef41551e91b3$var$columns = ()=>({
        c_personallicencia_id: new (0, $49qEn.EntityColumn)({
            name: 'c_personallicencia_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PKAutonum,
            prompt: 'Licencia Id'
        }),
        c_personal_id: new (0, $49qEn.EntityColumn)({
            name: 'c_personal_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Personal Id'
        }),
        c_fileprocess_id: new (0, $49qEn.EntityColumn)({
            name: 'c_fileprocess_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Fileprocess Id'
        }),
        c_motivoliciencia_id: new (0, $49qEn.EntityColumn)({
            name: 'c_motivoliciencia_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Motivo'
        }),
        dt_fecha_desde: new (0, $49qEn.EntityColumn)({
            name: 'dt_fecha_desde',
            type: 'datetime',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Fecha Desde'
        }),
        dt_fecha_hasta: new (0, $49qEn.EntityColumn)({
            name: 'dt_fecha_hasta',
            type: 'datetime',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Fecha Hasta'
        }),
        vc_observaciones: new (0, $49qEn.EntityColumn)({
            name: 'vc_observaciones',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Observaciones'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $a925ef41551e91b3$var$views = ()=>({
        plli_brwStandard: {
            name: 'plli_brwStandard',
            keyMappings: {
                c_personallicencia_id: 0
            }
        },
        plli_brwHistorial: {
            name: 'plli_brwHistorial',
            keyMappings: {
                c_personallicencia_id: 0,
                c_personal_id: 6
            },
            FiltersEntity: (client, parentKeys)=>new (0, $a9mhP.PersonalLicenciasFilters)(client, parentKeys)
        }
    });
const $a925ef41551e91b3$var$lookups = ()=>({
        'Personal': {
            name: 'Personal',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $7LP39.Personal)(client, parentKeys)
        },
        'MotivosLicencia': {
            name: 'MotivosLicencia',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $hMWb0.catMotivosLicencia)(client, parentKeys)
        }
    });
class $a925ef41551e91b3$export$52f62af2bc4f4815 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('PersonalLicencias'), this.columns = $a925ef41551e91b3$var$columns(), this.views = $a925ef41551e91b3$var$views(), this.lookups = $a925ef41551e91b3$var$lookups();
    }
}

});
parcelRegister("a9mhP", function(module, exports) {

$parcel$export(module.exports, "PersonalLicenciasFilters", () => $7dd5f76cc8fbbb34$export$e5bdd670ea9227f4);

var $49qEn = parcelRequire("49qEn");

var $kZp0F = parcelRequire("kZp0F");

class $7dd5f76cc8fbbb34$export$e5bdd670ea9227f4 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $kZp0F.PersonalLicenciasFiltersDef)(), parentKeys);
        this.Form = (parcelRequire("5jJJq")).then((module)=>module.PersonalLicenciasFiltersForm);
        this.Title = "Personal Licencias Filters";
    }
}

});
parcelRegister("kZp0F", function(module, exports) {

$parcel$export(module.exports, "PersonalLicenciasFiltersDef", () => $17fae343fba414f0$export$6fb0820526f5fe9c);

var $49qEn = parcelRequire("49qEn");
const $17fae343fba414f0$var$columns = ()=>({
        dt_fecha_desde: new (0, $49qEn.EntityColumn)({
            name: 'dt_fecha_desde',
            type: 'datetime',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Fecha Desde'
        }),
        dt_fecha_hasta: new (0, $49qEn.EntityColumn)({
            name: 'dt_fecha_hasta',
            type: 'datetime',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Fecha Hasta'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
class $17fae343fba414f0$export$6fb0820526f5fe9c extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('PersonalLicenciasFilters'), this.columns = $17fae343fba414f0$var$columns();
    }
}

});

parcelRegister("5jJJq", function(module, exports) {
module.exports = import("7nCFf").then(()=>parcelRequire('eU4pf'));

});



parcelRegister("kKPpP", function(module, exports) {
module.exports = import("9zGgh").then(()=>parcelRequire('kimUo'));

});


parcelRegister("loUYT", function(module, exports) {
module.exports = import("bt6c2").then(()=>parcelRequire('iqhvp'));

});

parcelRegister("fHG9v", function(module, exports) {

$parcel$export(module.exports, "PersonalTiendasIcon", () => $61993647cd1170f3$export$1911b24e48d2b21a);
$parcel$export(module.exports, "PersonalTiendasHelpText", () => $61993647cd1170f3$export$10b591275c2758df);
$parcel$export(module.exports, "PersonalTiendas", () => $61993647cd1170f3$export$787a0990435702d6);

var $49qEn = parcelRequire("49qEn");

var $ce5R4 = parcelRequire("ce5R4");

var $hkAoi = parcelRequire("hkAoi");
const $61993647cd1170f3$export$1911b24e48d2b21a = (0, $ce5R4.default);
const $61993647cd1170f3$export$10b591275c2758df = "* Aqu\xed puede asignar el personal a cualquiera de las tiendas dadas de alta";

class $61993647cd1170f3$export$787a0990435702d6 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $hkAoi.PersonalTiendasDef)(), parentKeys);
        this.Form = (parcelRequire("6QddX")).then((module)=>module.PersonalTiendasForm);
        this.Title = "Tiendas: Asignaci\xf3n de personal";
        this.HelpText = $61993647cd1170f3$export$10b591275c2758df;
        this.Icon = $61993647cd1170f3$export$1911b24e48d2b21a;
    }
}

});
parcelRegister("hkAoi", function(module, exports) {

$parcel$export(module.exports, "PersonalTiendasDef", () => $fc8a9c89df537532$export$587665c455e98ca3);

var $49qEn = parcelRequire("49qEn");

var $SKbb0 = parcelRequire("SKbb0");

var $6TYT5 = parcelRequire("6TYT5");

var $6awxZ = parcelRequire("6awxZ");

var $7LP39 = parcelRequire("7LP39");

var $jNo5L = parcelRequire("jNo5L");

var $a4ZMZ = parcelRequire("a4ZMZ");

var $hMkiM = parcelRequire("hMkiM");

var $94Ivy = parcelRequire("94Ivy");

var $9OYBQ = parcelRequire("9OYBQ");

var $5sum9 = parcelRequire("5sum9");

var $egSs2 = parcelRequire("egSs2");

var $79ZNw = parcelRequire("79ZNw");

var $3JwyS = parcelRequire("3JwyS");

var $4gxU1 = parcelRequire("4gxU1");

var $3IKIk = parcelRequire("3IKIk");

var $bAcmJ = parcelRequire("bAcmJ");

var $yrOHM = parcelRequire("yrOHM");

var $dWhai = parcelRequire("dWhai");

var $gQ8XH = parcelRequire("gQ8XH");
const $fc8a9c89df537532$var$columns = ()=>({
        c_personal_id: new (0, $49qEn.EntityColumn)({
            name: 'c_personal_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Personal Id'
        }),
        c_tienda_id: new (0, $49qEn.EntityColumn)({
            name: 'c_tienda_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Tienda Id'
        }),
        c_cadena_id: new (0, $49qEn.EntityColumn)({
            name: 'c_cadena_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Cadena Id'
        }),
        vc_canales: new (0, $49qEn.EntityColumn)({
            name: 'vc_canales',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Canales',
            isArray: true
        }),
        vc_domicilio_completo: new (0, $49qEn.EntityColumn)({
            name: 'vc_domicilio_completo',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Domicilio Completo'
        }),
        f_latitud: new (0, $49qEn.EntityColumn)({
            name: 'f_latitud',
            type: 'float',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Latitud'
        }),
        f_longitud: new (0, $49qEn.EntityColumn)({
            name: 'f_longitud',
            type: 'float',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Longitud'
        }),
        vc_personales: new (0, $49qEn.EntityColumn)({
            name: 'vc_personales',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Supervisi\xf3n",
            isArray: true
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $fc8a9c89df537532$var$views = ()=>({
        plti_brwStandard: {
            name: 'plti_brwStandard',
            keyMappings: {
                c_tienda_id: 0
            },
            FiltersEntity: (client, parentKeys)=>new (0, $a4ZMZ.PersonalTiendasFilters)(client, parentKeys),
            gridColumnsOverrides: (0, $yrOHM.StandardViewColumnsOverrides),
            mapMarkerRenderer: (0, $gQ8XH.StandardViewMarkerRenderer),
            mapInfoWindowRenderer: (0, $dWhai.StandardViewInfoWindowRenderer)
        },
        plti_brwPorPersonal: {
            name: 'plti_brwPorPersonal',
            keyMappings: {
                c_tienda_id: 0
            },
            FiltersEntity: (client, parentKeys)=>new (0, $hMkiM.PersonalTiendasFiltersPorPersonal)(client, parentKeys),
            gridColumnsOverrides: (0, $yrOHM.StandardViewColumnsOverrides),
            mapMarkerRenderer: (0, $gQ8XH.StandardViewMarkerRenderer),
            mapInfoWindowRenderer: (0, $dWhai.StandardViewInfoWindowRenderer)
        },
        plti_brwGestionTiendas: {
            name: 'plti_brwGestionTiendas',
            keyMappings: {
                c_personal_id: 0
            },
            FiltersEntity: (client, parentKeys)=>new (0, $jNo5L.PersonalGestionFilters)(client, parentKeys)
        },
        plti_brwGestionTiendasPersonal: {
            name: 'plti_brwGestionTiendasPersonal',
            keyMappings: {
                c_personal_id: 0,
                c_tienda_id: 1
            },
            FiltersEntity: (client, parentKeys)=>new (0, $94Ivy.PersonalTiendasGestionFilters)(client, parentKeys),
            mapMarkerRenderer: (0, $bAcmJ.GestionTiendasPersonalViewMarkerRenderer),
            mapInfoWindowRenderer: (0, $3IKIk.GestionTiendasPersonalViewInfoWindowRenderer)
        },
        plti_brwGestionTiendasPersonalAgregar: {
            name: 'plti_brwGestionTiendasPersonalAgregar',
            keyMappings: {
                c_tienda_id: 0
            },
            FiltersEntity: (client, parentKeys)=>new (0, $94Ivy.PersonalTiendasGestionFilters)(client, parentKeys),
            mapMarkerRenderer: (0, $bAcmJ.GestionTiendasPersonalViewMarkerRenderer)
        }
    });
const $fc8a9c89df537532$var$lookups = ()=>({
        'Personal': {
            name: 'Personal',
            view: 'perl_brwJefes',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $7LP39.Personal)(client, parentKeys)
        },
        'Tiendas': {
            name: 'Tiendas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $6awxZ.Tiendas)(client, parentKeys)
        },
        'Cadenas': {
            name: 'Cadenas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $SKbb0.Cadenas)(client, parentKeys)
        },
        'Canales': {
            name: 'Canales',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $6TYT5.catCanales)(client, parentKeys)
        }
    });
const $fc8a9c89df537532$var$clientActions = ()=>({
        ACTSeleccionarTiendas: (0, $5sum9.ACTAsignarPersonal),
        ACTVerTienda: (0, $4gxU1.ACTVerTienda),
        ACTGestionarTiendas: (0, $79ZNw.ACTGestionarTiendas),
        ACTAgregarTienda: (0, $9OYBQ.ACTAgregarTienda),
        ACTEliminarTienda: (0, $egSs2.ACTEliminarTienda),
        ACTReasignarTienda: (0, $3JwyS.ACTReasignarTienda)
    });
class $fc8a9c89df537532$export$587665c455e98ca3 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('PersonalTiendas'), this.columns = $fc8a9c89df537532$var$columns(), this.views = $fc8a9c89df537532$var$views(), this.lookups = $fc8a9c89df537532$var$lookups(), this.clientActions = $fc8a9c89df537532$var$clientActions();
    }
}

});
parcelRegister("a4ZMZ", function(module, exports) {

$parcel$export(module.exports, "PersonalTiendasFilters", () => $20130f5b170afc74$export$b856405e01fbfaf2);

var $49qEn = parcelRequire("49qEn");

var $bJX2O = parcelRequire("bJX2O");

class $20130f5b170afc74$export$b856405e01fbfaf2 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $bJX2O.PersonalTiendasFiltersDef)(), parentKeys);
        this.Form = (parcelRequire("eENHH")).then((module)=>module.PersonalTiendasFiltersForm);
        this.Title = "Personal Tiendas Filters";
    }
}

});
parcelRegister("bJX2O", function(module, exports) {

$parcel$export(module.exports, "PersonalTiendasFiltersDef", () => $f899d82119975b00$export$72eb4ebfb18b12c7);

var $49qEn = parcelRequire("49qEn");

var $SKbb0 = parcelRequire("SKbb0");

var $6TYT5 = parcelRequire("6TYT5");

var $5kp3N = parcelRequire("5kp3N");

var $kFypM = parcelRequire("kFypM");

var $aQujn = parcelRequire("aQujn");

var $j8GP5 = parcelRequire("j8GP5");

var $4Rlmx = parcelRequire("4Rlmx");

var $7LP39 = parcelRequire("7LP39");
const $f899d82119975b00$var$columns = ()=>({
        c_pais_id: new (0, $49qEn.EntityColumn)({
            name: 'c_pais_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Pa\xeds"
        }),
        c_provincia_id: new (0, $49qEn.EntityColumn)({
            name: 'c_provincia_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Provincia'
        }),
        c_ciudad_id: new (0, $49qEn.EntityColumn)({
            name: 'c_ciudad_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Ciudad'
        }),
        c_localidad_id: new (0, $49qEn.EntityColumn)({
            name: 'c_localidad_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Localidad'
        }),
        vc_cadenas: new (0, $49qEn.EntityColumn)({
            name: 'vc_cadenas',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Cadenas',
            isArray: true
        }),
        vc_canales: new (0, $49qEn.EntityColumn)({
            name: 'vc_canales',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Canales',
            isArray: true
        }),
        c_activo_id: new (0, $49qEn.EntityColumn)({
            name: 'c_activo_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Estado de la tienda'
        }),
        vc_personales: new (0, $49qEn.EntityColumn)({
            name: 'vc_personales',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Personal asignado',
            isArray: true
        }),
        b_sinpersonal: new (0, $49qEn.EntityColumn)({
            name: 'b_sinpersonal',
            type: 'bit',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Solo sin personal asignado'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $f899d82119975b00$var$lookups = ()=>({
        'Activo': {
            name: 'Activo',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $5kp3N.estActivo)(client, parentKeys)
        },
        'Cadenas': {
            name: 'Cadenas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $SKbb0.Cadenas)(client, parentKeys)
        },
        'Paises': {
            name: 'Paises',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $j8GP5.Paises)(client, parentKeys)
        },
        'Provincias': {
            name: 'Provincias',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $4Rlmx.Provincias)(client, parentKeys)
        },
        'Ciudades': {
            name: 'Ciudades',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $kFypM.Ciudades)(client, parentKeys)
        },
        'Localidades': {
            name: 'Localidades',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $aQujn.Localidades)(client, parentKeys)
        },
        'Personal': {
            name: 'Personal',
            view: 'perl_brwAsignadoATiendas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $7LP39.Personal)(client, parentKeys)
        },
        'Canales': {
            name: 'Canales',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $6TYT5.catCanales)(client, parentKeys)
        }
    });
class $f899d82119975b00$export$72eb4ebfb18b12c7 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('PersonalTiendasFilters'), this.columns = $f899d82119975b00$var$columns(), this.views = {}, this.lookups = $f899d82119975b00$var$lookups();
    }
}

});

parcelRegister("eENHH", function(module, exports) {
module.exports = import("4m5RK").then(()=>parcelRequire('jRHH4'));

});


parcelRegister("hMkiM", function(module, exports) {

$parcel$export(module.exports, "PersonalTiendasFiltersPorPersonal", () => $8922844a8d1b39e2$export$4a725930143ed35);

var $49qEn = parcelRequire("49qEn");

var $e5AlD = parcelRequire("e5AlD");

class $8922844a8d1b39e2$export$4a725930143ed35 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $e5AlD.PersonalTiendasFiltersPorPersonalDef)(), parentKeys);
        this.Form = (parcelRequire("qFXU4")).then((module)=>module.PersonalTiendasFiltersPorPersonalForm);
        this.Title = "Personal Tiendas Filters por Personal";
    }
}

});
parcelRegister("e5AlD", function(module, exports) {

$parcel$export(module.exports, "PersonalTiendasFiltersPorPersonalDef", () => $2b0defdb0b566420$export$1872b677f1e27c57);

var $49qEn = parcelRequire("49qEn");

var $SKbb0 = parcelRequire("SKbb0");

var $6TYT5 = parcelRequire("6TYT5");

var $5kp3N = parcelRequire("5kp3N");

var $kFypM = parcelRequire("kFypM");

var $aQujn = parcelRequire("aQujn");

var $j8GP5 = parcelRequire("j8GP5");

var $4Rlmx = parcelRequire("4Rlmx");
const $2b0defdb0b566420$var$columns = ()=>({
        c_pais_id: new (0, $49qEn.EntityColumn)({
            name: 'c_pais_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Pa\xeds"
        }),
        c_provincia_id: new (0, $49qEn.EntityColumn)({
            name: 'c_provincia_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Provincia'
        }),
        c_ciudad_id: new (0, $49qEn.EntityColumn)({
            name: 'c_ciudad_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Ciudad'
        }),
        c_localidad_id: new (0, $49qEn.EntityColumn)({
            name: 'c_localidad_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Localidad'
        }),
        vc_cadenas: new (0, $49qEn.EntityColumn)({
            name: 'vc_cadenas',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Cadenas',
            isArray: true
        }),
        vc_canales: new (0, $49qEn.EntityColumn)({
            name: 'vc_canales',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Canales',
            isArray: true
        }),
        c_activo_id: new (0, $49qEn.EntityColumn)({
            name: 'c_activo_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Estado'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $2b0defdb0b566420$var$lookups = ()=>({
        'Activo': {
            name: 'Activo',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $5kp3N.estActivo)(client, parentKeys)
        },
        'Cadenas': {
            name: 'Cadenas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $SKbb0.Cadenas)(client, parentKeys)
        },
        'Paises': {
            name: 'Paises',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $j8GP5.Paises)(client, parentKeys)
        },
        'Provincias': {
            name: 'Provincias',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $4Rlmx.Provincias)(client, parentKeys)
        },
        'Ciudades': {
            name: 'Ciudades',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $kFypM.Ciudades)(client, parentKeys)
        },
        'Localidades': {
            name: 'Localidades',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $aQujn.Localidades)(client, parentKeys)
        },
        'Canales': {
            name: 'Canales',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $6TYT5.catCanales)(client, parentKeys)
        }
    });
class $2b0defdb0b566420$export$1872b677f1e27c57 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('PersonalTiendasFiltersPorPersonal'), this.columns = $2b0defdb0b566420$var$columns(), this.views = {}, this.lookups = $2b0defdb0b566420$var$lookups();
    }
}

});

parcelRegister("qFXU4", function(module, exports) {
module.exports = import("6yq3P").then(()=>parcelRequire('jsttD'));

});


parcelRegister("94Ivy", function(module, exports) {

$parcel$export(module.exports, "PersonalTiendasGestionFilters", () => $5059ff848551cc0a$export$edcc7b486d09e383);

var $49qEn = parcelRequire("49qEn");

var $d1p54 = parcelRequire("d1p54");

class $5059ff848551cc0a$export$edcc7b486d09e383 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $d1p54.PersonalTiendasGestionFiltersDef)(), parentKeys);
        this.Form = (parcelRequire("1vEiV")).then((module)=>module.PersonalTiendasGestionFiltersForm);
        this.Title = "Personal Tiendas Filters";
    }
}

});
parcelRegister("d1p54", function(module, exports) {

$parcel$export(module.exports, "PersonalTiendasGestionFiltersDef", () => $f5c85c9f4c87301d$export$6d52f917a0c3a0ca);

var $49qEn = parcelRequire("49qEn");

var $SKbb0 = parcelRequire("SKbb0");

var $6TYT5 = parcelRequire("6TYT5");

var $5kp3N = parcelRequire("5kp3N");

var $kFypM = parcelRequire("kFypM");

var $aQujn = parcelRequire("aQujn");

var $j8GP5 = parcelRequire("j8GP5");

var $4Rlmx = parcelRequire("4Rlmx");

var $7LP39 = parcelRequire("7LP39");
const $f5c85c9f4c87301d$var$columns = ()=>({
        c_pais_id: new (0, $49qEn.EntityColumn)({
            name: 'c_pais_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Pa\xeds"
        }),
        c_provincia_id: new (0, $49qEn.EntityColumn)({
            name: 'c_provincia_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Provincia'
        }),
        c_ciudad_id: new (0, $49qEn.EntityColumn)({
            name: 'c_ciudad_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Ciudad'
        }),
        c_localidad_id: new (0, $49qEn.EntityColumn)({
            name: 'c_localidad_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Localidad'
        }),
        vc_cadenas: new (0, $49qEn.EntityColumn)({
            name: 'vc_cadenas',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Cadenas',
            isArray: true
        }),
        vc_canales: new (0, $49qEn.EntityColumn)({
            name: 'vc_canales',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Canales',
            isArray: true
        }),
        c_activo_id: new (0, $49qEn.EntityColumn)({
            name: 'c_activo_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Estado de la tienda'
        }),
        vc_personales: new (0, $49qEn.EntityColumn)({
            name: 'vc_personales',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Personal asignado',
            isArray: true
        }),
        b_sinpersonal: new (0, $49qEn.EntityColumn)({
            name: 'b_sinpersonal',
            type: 'bit',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Solo sin personal asignado'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $f5c85c9f4c87301d$var$lookups = ()=>({
        'Activo': {
            name: 'Activo',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $5kp3N.estActivo)(client, parentKeys)
        },
        'Cadenas': {
            name: 'Cadenas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $SKbb0.Cadenas)(client, parentKeys)
        },
        'Paises': {
            name: 'Paises',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $j8GP5.Paises)(client, parentKeys)
        },
        'Provincias': {
            name: 'Provincias',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $4Rlmx.Provincias)(client, parentKeys)
        },
        'Ciudades': {
            name: 'Ciudades',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $kFypM.Ciudades)(client, parentKeys)
        },
        'Localidades': {
            name: 'Localidades',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $aQujn.Localidades)(client, parentKeys)
        },
        'Personal': {
            name: 'Personal',
            view: 'perl_brwAsignadoATiendas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $7LP39.Personal)(client, parentKeys)
        },
        'Canales': {
            name: 'Canales',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $6TYT5.catCanales)(client, parentKeys)
        }
    });
class $f5c85c9f4c87301d$export$6d52f917a0c3a0ca extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('PersonalTiendasGestionFilters'), this.columns = $f5c85c9f4c87301d$var$columns(), this.views = {}, this.lookups = $f5c85c9f4c87301d$var$lookups();
    }
}

});

parcelRegister("1vEiV", function(module, exports) {
module.exports = import("cxY4b").then(()=>parcelRequire('9iJkE'));

});


parcelRegister("9OYBQ", function(module, exports) {

$parcel$export(module.exports, "ACTAgregarTienda", () => $23a87c5ac5d46553$export$e511c16d8f9a21bd);

var $ayMG0 = parcelRequire("ayMG0");

var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");
const $23a87c5ac5d46553$export$e511c16d8f9a21bd = {
    name: 'ACTAgregarTienda',
    label: 'Agregar Tienda',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Agregar Tienda"
    }),
    refreshOnClose: true,
    dontRequireSelection: true,
    showActionInViewMode: true,
    views: [
        'plti_brwGestionTiendasPersonal'
    ],
    onClick: async ({ entity: entity, modal: modal, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const parent = entity;
        await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                    fw: "700",
                    children: "Agregar Tienda"
                }),
                size: 'xl'
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.LookupFormAction), {
                lookupEntity: entity,
                viewName: entity.def.views.plti_brwGestionTiendasPersonalAgregar.name,
                title: "Agregar tienda",
                confirmContent: "\xbfEst\xe1 seguro de que desea agregar las tiendas seleccionadas?",
                onActionFinished: async ()=>{
                    if (onClose) await onClose();
                },
                showActions: true,
                onOK: async (keys, abortSignal)=>{
                    if (keys && keys.length > 0) await parent.API.addData(abortSignal, keys, true);
                    return {
                        Results: [
                            {
                                Status: 0,
                                Message: 'OK'
                            }
                        ]
                    };
                }
            })
        });
        return false;
    }
};

});

parcelRegister("5sum9", function(module, exports) {

$parcel$export(module.exports, "ACTAsignarPersonal", () => $6dfa01c2a34b037f$export$52dd4ac6e15e125f);

var $ayMG0 = parcelRequire("ayMG0");

var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $7LP39 = parcelRequire("7LP39");
const $6dfa01c2a34b037f$export$52dd4ac6e15e125f = {
    name: 'ACTSeleccionarTiendas',
    label: 'Asignar Personal',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Asignar personal a tiendas seleccionadas"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    views: [],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        // cast entity
        const parent = entity;
        const personal = new (0, $7LP39.Personal)(entity.API.client);
        if (modal) await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                    fw: "700",
                    children: "Asignar personal a tiendas seleccionadas"
                }),
                size: 'xl'
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.LookupFormAction), {
                lookupEntity: personal,
                viewName: personal.def.views.perl_brwJefes.name,
                title: "Asignar personal a tiendas seleccionadas",
                onActionFinished: onClose,
                onOK: async (keys, abortSignal)=>{
                    const personal_tiendas = (0, $49qEn.Entity).clone(parent);
                    const result = {
                        Failed: false,
                        AutonumReturned: false,
                        Results: []
                    };
                    for (const key of selectedKeys ?? []){
                        personal_tiendas.def.columns.c_tienda_id.value = key[personal_tiendas.def.columns.c_tienda_id.name];
                        const ret = await personal_tiendas.API.addData(abortSignal, keys, true);
                        if (ret.Failed) {
                            result.Failed = true;
                            result.Results.push(...ret.Results);
                        }
                    }
                    return result;
                }
            })
        });
        else {
            console.log('modal context not found');
            return Promise.resolve();
        }
    }
};

});

parcelRegister("egSs2", function(module, exports) {

$parcel$export(module.exports, "ACTEliminarTienda", () => $6d3485b1470d303b$export$1c1af068eeb6f547);

var $ayMG0 = parcelRequire("ayMG0");

var $9VIWE = parcelRequire("9VIWE");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");
const $6d3485b1470d303b$export$1c1af068eeb6f547 = {
    name: 'ACTEliminarTienda',
    label: 'Eliminar Tienda',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Eliminar Tienda"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    showActionInViewMode: true,
    views: [
        'plti_brwGestionTiendasPersonal'
    ],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        const abort_controller = new AbortController();
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const parent = entity;
        await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                    fw: "700",
                    children: `Eliminar Tienda`
                })
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.ConfirmAndExecutePanel), {
                operation: "edit",
                loadingContent: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9VIWE.Stack), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.FakeProgressBar), {}),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            size: "sm",
                            mb: "xs",
                            children: `Eliminando tiendas`
                        })
                    ]
                }),
                content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                    size: "sm",
                    mb: "xs",
                    children: "\xbfDesea eliminar las tiendas del personal?"
                }),
                okButtonText: "Aceptar",
                onCancel: async ()=>{
                    await abort_controller.abort();
                    await modal.close();
                    if (onClose) await onClose();
                },
                onOK: async ()=>{
                    const result = await parent.API.deleteData(selectedKeys, abort_controller.signal);
                    if (!result.Failed) {
                        if (onClose) await onClose();
                        await modal.close();
                    }
                }
            })
        });
        return false;
    }
};

});

parcelRegister("79ZNw", function(module, exports) {

$parcel$export(module.exports, "ACTGestionarTiendas", () => $368102147d3cd417$export$a446eb376eb847fa);

var $ayMG0 = parcelRequire("ayMG0");

var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");
var $4d0Rl = parcelRequire("4d0Rl");

var $7LP39 = parcelRequire("7LP39");
const $368102147d3cd417$export$a446eb376eb847fa = {
    name: 'ACTGestionarTiendas',
    label: 'Gestionar Tiendas',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Gestionar Tiendas"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    showActionInViewMode: true,
    views: [
        'plti_brwGestionTiendas'
    ],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const parent = entity;
        parent.def.columns.c_personal_id.value = selectedKeys[0].c_personal_id || '';
        parent.parentKeys = {
            ...parent.parentKeys,
            c_personal_id: selectedKeys[0].c_personal_id
        };
        const personal = new (0, $7LP39.Personal)(entity.API.client);
        personal.def.columns.c_personal_id.value = parent.def.columns.c_personal_id.value;
        await personal.API.getData();
        const description = `Personal: ${personal.def.columns.vc_apellido.value + ', ' + personal.def.columns.vc_nombre.value}`;
        await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                            size: "1.5rem",
                            stroke: "1.5"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            fw: "700",
                            children: description
                        })
                    ]
                }),
                size: "xl"
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.MultiDataMapForm), {
                autoFocus: true,
                formMode: "edit",
                title: "Gestionar Tiendas",
                dataMapView1: {
                    entity: parent,
                    viewName: parent.def.views.plti_brwGestionTiendasPersonal.name,
                    parentKeys: parent.parentKeys,
                    refreshOnInit: true,
                    latitudRecordIndex: 9,
                    longitudRecordIndex: 10,
                    tabLabel: "Tiendas",
                    tabIcon: (0, $4d0Rl.default),
                    enableView: false,
                    enableAdd: false,
                    enableEdit: false,
                    enableDelete: false,
                    showActions: true,
                    modalFormSize: "98%"
                },
                mapHeight: "50vh"
            }, `mapa-ubicacion-tiendas-${entity.def.name}`)
        });
        return false;
    }
};

});

parcelRegister("3JwyS", function(module, exports) {

$parcel$export(module.exports, "ACTReasignarTienda", () => $4903a943f8a716e0$export$cb184ad67d3ea1cf);

var $ayMG0 = parcelRequire("ayMG0");

var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $7LP39 = parcelRequire("7LP39");

var $fHG9v = parcelRequire("fHG9v");
const $4903a943f8a716e0$export$cb184ad67d3ea1cf = {
    name: 'ACTReasignarTienda',
    label: 'Reasignar Tienda',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Reasignar Tienda"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    showActionInViewMode: true,
    views: [
        'plti_brwGestionTiendasPersonal'
    ],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const personaltiendas = entity;
        const personal = new (0, $7LP39.Personal)(entity.API.client);
        await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                    fw: "700",
                    children: "Reasignar tienda"
                }),
                size: 'xl'
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.LookupFormAction), {
                lookupEntity: personal,
                viewName: personal.def.views.perl_brwGestionPersonal.name,
                title: "Reasignar tienda a personal seleccionado",
                confirmContent: "\xbfEst\xe1 seguro de que desea reasignar las tiendas seleccionadas?",
                onActionFinished: async ()=>{
                    if (onClose) await onClose();
                },
                onOK: async (keys, abortSignal)=>{
                    const abort_controller = new AbortController();
                    if (selectedKeys && selectedKeys.length > 0) {
                        await personaltiendas.API.deleteData(selectedKeys, abort_controller.signal);
                        for (const key of selectedKeys ?? []){
                            const personaltiendasagregar = new (0, $fHG9v.PersonalTiendas)(entity.API.client);
                            personaltiendasagregar.def.columns.c_personal_id.value = keys[0].c_personal_id;
                            personaltiendasagregar.def.columns.c_tienda_id.value = key.c_tienda_id;
                            await personaltiendasagregar.API.addData(abortSignal);
                        }
                    }
                    return {
                        Results: [
                            {
                                Status: 0,
                                Message: 'OK'
                            }
                        ]
                    };
                }
            })
        });
        return false;
    }
};

});

parcelRegister("4gxU1", function(module, exports) {

$parcel$export(module.exports, "ACTVerTienda", () => $0818e77121e29926$export$41a14c2a4c84e929);

var $ayMG0 = parcelRequire("ayMG0");

var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $6awxZ = parcelRequire("6awxZ");
const $0818e77121e29926$export$41a14c2a4c84e929 = {
    name: 'ACTVerTienda',
    label: 'Ver Tienda',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Ver Tienda"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    showActionInViewMode: true,
    minSelectedRecords: 1,
    maxSelectedRecords: 1,
    views: [
        'plti_brwGestionTiendasPersonal',
        'plti_brwGestionTiendasPersonalAgregar'
    ],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const tiendas = new (0, $6awxZ.Tiendas)(entity.API.client);
        tiendas.def.columns.c_tienda_id.value = selectedKeys?.[0].c_tienda_id;
        await (0, $49qEn.openEntityForm)({
            modals: modal,
            formProps: {
                entity: tiendas,
                initialFormMode: 'view',
                getDataOnInit: true
            },
            modalFormSize: 'xl',
            handleModalSaved: async ()=>{
                await modal.close();
                if (onClose) await onClose(false);
            },
            handleModalCancel: async ()=>{
                await modal.close();
                if (onClose) await onClose(false);
            }
        });
        return false;
    }
};

});

parcelRegister("3IKIk", function(module, exports) {

$parcel$export(module.exports, "GestionTiendasPersonalViewInfoWindowRenderer", () => $45e35013a3223b38$export$4f587379a580fc1a);

var $ayMG0 = parcelRequire("ayMG0");

var $gU5rH = parcelRequire("gU5rH");
var $kPsAn = parcelRequire("kPsAn");
var $9mTYo = parcelRequire("9mTYo");
var $hiGsa = parcelRequire("hiGsa");
var $9VIWE = parcelRequire("9VIWE");
var $cjohz = parcelRequire("cjohz");
var $ew26C = parcelRequire("ew26C");

var $49qEn = parcelRequire("49qEn");
function $45e35013a3223b38$export$4f587379a580fc1a(record, position, groupManager, infoWindow, UIAPI, theme, entity) {
    const tienda_id = record[1];
    const cadena = record[3];
    const canales = record[4];
    const tienda = record[5];
    const PersonalTiendas = entity;
    const group = groupManager.getGroupByLocation(position);
    if (group) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kPsAn.Card), {
        withBorder: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9VIWE.Stack), {
            spacing: "xs",
            mb: "xs",
            children: [
                group.records.map(({ recordValue: rec }, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ew26C.Title), {
                                order: 5,
                                children: `${rec[4]} - ${rec[5]}`
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                                size: "xs",
                                onClick: async ()=>{
                                    await UIAPI.handleExecuteAction(PersonalTiendas.def.clientActions.ACTVerTienda, [
                                        {
                                            'c_tienda_id': rec[1]
                                        }
                                    ]);
                                },
                                children: "Ver"
                            })
                        ]
                    }, `grp_${rec[1]}`)),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                        size: "xs",
                        variant: "light",
                        onClick: ()=>{
                            infoWindow.close();
                        },
                        children: "Cerrar"
                    })
                })
            ]
        })
    });
    else return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kPsAn.Card), {
        withBorder: true,
        padding: "xs",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9VIWE.Stack), {
            spacing: "0.5rem",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hiGsa.Image), {
                    width: 350,
                    height: 120,
                    src: (0, $49qEn.getGoogleMapsStreetViewImage)(position, 350, 200, 150),
                    mx: "auto"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ew26C.Title), {
                    order: 4,
                    children: `${tienda}`
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    spacing: "xs",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            weight: 500,
                            size: "sm",
                            children: "Cadena: "
                        }),
                        cadena
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    spacing: "xs",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            weight: 500,
                            size: "sm",
                            children: "Canales: "
                        }),
                        canales
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    position: "right",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                            size: "xs",
                            onClick: async ()=>{
                                await UIAPI.handleExecuteAction(PersonalTiendas.def.clientActions.ACTVerTienda, [
                                    {
                                        'c_tienda_id': tienda_id
                                    }
                                ]);
                            },
                            children: "Ver"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                            size: "xs",
                            variant: "light",
                            onClick: ()=>{
                                infoWindow.close();
                            },
                            children: "Cerrar"
                        })
                    ]
                })
            ]
        })
    });
}

});

parcelRegister("bAcmJ", function(module, exports) {

$parcel$export(module.exports, "GestionTiendasPersonalViewMarkerRenderer", () => $607eb6b7fd016c07$export$e244e4b2ef77222f);
function $607eb6b7fd016c07$export$e244e4b2ef77222f(record, position, theme) {
    const canales = record[3];
    const cadena = record[4];
    const tienda = record[5];
    const markerProps = {
        position: position,
        title: `${canales}${canales && cadena ? ' - ' : ''}${cadena} - ${tienda}`,
        assignColorByValue: undefined,
        fillColor: theme.colors.gray[8]
    };
    return markerProps;
}

});

parcelRegister("yrOHM", function(module, exports) {

$parcel$export(module.exports, "StandardViewColumnsOverrides", () => $e907fec2534dc555$export$b00a966d072dc3a4);

var $ayMG0 = parcelRequire("ayMG0");

var $9mTYo = parcelRequire("9mTYo");

var $49qEn = parcelRequire("49qEn");

var $iEQtx = parcelRequire("iEQtx");
var $3US3h = parcelRequire("3US3h");
var $h8HR1 = parcelRequire("h8HR1");
function $e907fec2534dc555$export$b00a966d072dc3a4(theme) {
    return {
        // Personal asignado
        5: {
            render: (value)=>!value ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    style: {
                        gap: '.5rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iEQtx.default), {
                            style: {
                                color: theme.colors.red[8]
                            },
                            size: "1.3rem"
                        }),
                        "Sin personal"
                    ]
                }) : value
        },
        // Cantidad de clientes
        6: {
            render: (value)=>!value || value === '0' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    style: {
                        gap: '.5rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iEQtx.default), {
                            style: {
                                color: theme.colors.red[8]
                            },
                            size: "1.3rem"
                        }),
                        "Sin clientes"
                    ]
                }) : value
        },
        // Cantidad de productos
        7: {
            render: (value)=>!value || value === '0' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    style: {
                        gap: '.5rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iEQtx.default), {
                            style: {
                                color: theme.colors.red[8]
                            },
                            size: "1.3rem"
                        }),
                        "Sin productos"
                    ]
                }) : value
        },
        // Tienda activa
        8: {
            render: (value)=>value === 'ACTIVO' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    style: {
                        gap: '0rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.CircleFilledIcon), {
                            mr: "xs",
                            width: "1.3rem",
                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3US3h.default), {
                                size: "0.9rem"
                            })
                        }),
                        "Activa"
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    style: {
                        gap: '.5rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $h8HR1.default), {
                            style: {
                                color: theme.colors.red[8]
                            },
                            size: "1.3rem"
                        }),
                        "Baja"
                    ]
                })
        }
    };
}

});

parcelRegister("dWhai", function(module, exports) {

$parcel$export(module.exports, "StandardViewInfoWindowRenderer", () => $4c0566121c12d47f$export$491840c25ac8f8db);

var $ayMG0 = parcelRequire("ayMG0");

var $gU5rH = parcelRequire("gU5rH");
var $kPsAn = parcelRequire("kPsAn");
var $9mTYo = parcelRequire("9mTYo");
var $hiGsa = parcelRequire("hiGsa");
var $9VIWE = parcelRequire("9VIWE");
var $cjohz = parcelRequire("cjohz");
var $ew26C = parcelRequire("ew26C");

var $49qEn = parcelRequire("49qEn");

var $yrOHM = parcelRequire("yrOHM");
function $4c0566121c12d47f$export$491840c25ac8f8db(record, position, groupManager, infoWindow, UIAPI, theme) {
    const columnsRender = (0, $yrOHM.StandardViewColumnsOverrides)(theme);
    const group = groupManager.getGroupByLocation(position);
    if (group) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kPsAn.Card), {
        withBorder: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9VIWE.Stack), {
            spacing: "xs",
            mb: "xs",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hiGsa.Image), {
                    width: 350,
                    height: 120,
                    src: (0, $49qEn.getGoogleMapsStreetViewImage)(position, 350, 200, 150),
                    mx: "auto"
                }),
                group.records.map(({ recordValue: rec }, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ew26C.Title), {
                                order: 5,
                                children: `ID: ${rec[0]} ${rec[2]}${rec[2] && rec[1] ? ' - ' : ''}${rec[1]}`
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                                size: "xs",
                                onClick: async ()=>{
                                    await UIAPI.handleEditClick({
                                        'c_tienda_id': rec[0]
                                    });
                                },
                                children: "Editar"
                            })
                        ]
                    }, `grp_${rec[0]}`)),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                        size: "xs",
                        variant: "light",
                        onClick: ()=>{
                            infoWindow.close();
                        },
                        children: "Cerrar"
                    })
                })
            ]
        })
    });
    else return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kPsAn.Card), {
        withBorder: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9VIWE.Stack), {
            spacing: "xs",
            mb: "xs",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hiGsa.Image), {
                    width: 350,
                    height: 120,
                    src: (0, $49qEn.getGoogleMapsStreetViewImage)(position, 350, 200, 150),
                    mx: "auto"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ew26C.Title), {
                    order: 4,
                    children: `${record[2]}${record[2] && record[1] ? ' - ' : ''}${record[1]}`
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    spacing: "0.5rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            weight: 500,
                            size: "sm",
                            children: "Personal: "
                        }),
                        columnsRender[5].render(record[5])
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    spacing: "0.5rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            weight: 500,
                            size: "sm",
                            children: "Cantidad de Clientes: "
                        }),
                        columnsRender[6].render(record[6])
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    spacing: "0.5rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            weight: 500,
                            size: "sm",
                            children: "Cantidad de Productos: "
                        }),
                        columnsRender[7].render(record[7])
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    spacing: "0.5rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            weight: 500,
                            size: "sm",
                            children: "Estado: "
                        }),
                        columnsRender[8].render(record[8])
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    position: "right",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                            size: "xs",
                            variant: "light",
                            onClick: ()=>{
                                infoWindow.close();
                            },
                            children: "Cerrar"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                            size: "xs",
                            onClick: async ()=>{
                                await UIAPI.handleEditClick({
                                    'c_tienda_id': record[0]
                                });
                            },
                            children: "Editar"
                        })
                    ]
                })
            ]
        })
    });
}

});

parcelRegister("gQ8XH", function(module, exports) {

$parcel$export(module.exports, "StandardViewMarkerRenderer", () => $869485cc68da35d6$export$6cfbff7a43f3bede);
function $869485cc68da35d6$export$6cfbff7a43f3bede(record, position, theme) {
    const personal = record[5];
    const canales = record[2];
    const cadena = record[1];
    const markerProps = {
        position: position,
        title: `${canales}${canales && cadena ? ' - ' : ''}${cadena} - ${personal ?? 'Sin personal asignado'}`,
        assignColorByValue: `${personal}` ?? 'default'
    };
    return markerProps;
}

});


parcelRegister("6QddX", function(module, exports) {
module.exports = import("8HF9D").then(()=>parcelRequire('8XUCr'));

});


parcelRegister("aPuNp", function(module, exports) {

$parcel$export(module.exports, "default", () => $c70898c6f767d85f$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $c70898c6f767d85f$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M12 18.5l-3 -1.5l-6 3v-13l6 -3l6 3l6 -3v7.5",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M9 4v13",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M15 7v5.5",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M19 18v.01",
            "key": "svg-4"
        }
    ]
];
const $c70898c6f767d85f$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "map-2", "Map2", $c70898c6f767d85f$export$3efd853dbb351e94);

});

parcelRegister("1GHab", function(module, exports) {

$parcel$export(module.exports, "ReportesIcon", () => $a42737426d3fe863$export$7d4a8b000441ac8f);
$parcel$export(module.exports, "Reportes", () => $a42737426d3fe863$export$987222a8a10f14e8);

var $49qEn = parcelRequire("49qEn");

var $5Ue5f = parcelRequire("5Ue5f");

var $c4qgm = parcelRequire("c4qgm");
const $a42737426d3fe863$export$7d4a8b000441ac8f = (0, $5Ue5f.default);
const $a42737426d3fe863$export$25f512c9e80a172f = '* Reportes.';

class $a42737426d3fe863$export$987222a8a10f14e8 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $c4qgm.ReportesDef)(), parentKeys);
        this.Form = (parcelRequire("fE7ax")).then((module)=>module.ReportesForm);
        this.Title = "Exportaci\xf3n de Datos";
        this.HelpText = $a42737426d3fe863$export$25f512c9e80a172f;
        this.Icon = $a42737426d3fe863$export$7d4a8b000441ac8f;
    }
}

});
parcelRegister("c4qgm", function(module, exports) {

$parcel$export(module.exports, "ReportesDef", () => $71168b02d3b334ed$export$3c559da9e25edb38);

var $49qEn = parcelRequire("49qEn");

var $SKbb0 = parcelRequire("SKbb0");

var $kd5or = parcelRequire("kd5or");

var $9u8qf = parcelRequire("9u8qf");

var $gKBQM = parcelRequire("gKBQM");

var $6awxZ = parcelRequire("6awxZ");

var $1CpMv = parcelRequire("1CpMv");

var $7gAwr = parcelRequire("7gAwr");

var $kSjlk = parcelRequire("kSjlk");

var $ly0BV = parcelRequire("ly0BV");

var $iaVJq = parcelRequire("iaVJq");

var $047iA = parcelRequire("047iA");

var $1noBe = parcelRequire("1noBe");
const $71168b02d3b334ed$var$currentDate = new Date();
const $71168b02d3b334ed$var$columns = ()=>({
        c_cliente_id: new (0, $49qEn.EntityColumn)({
            name: 'c_cliente_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Cliente'
        }),
        dt_fecha_desde: new (0, $49qEn.EntityColumn)({
            name: 'dt_fecha_desde',
            type: 'datetime',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Fecha Visita Desde',
            defaultValue: $71168b02d3b334ed$var$currentDate
        }),
        dt_fecha_hasta: new (0, $49qEn.EntityColumn)({
            name: 'dt_fecha_hasta',
            type: 'datetime',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Fecha Visita Hasta',
            defaultValue: $71168b02d3b334ed$var$currentDate
        }),
        c_cadena_id: new (0, $49qEn.EntityColumn)({
            name: 'c_cadena_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Cadena'
        }),
        c_tienda_id: new (0, $49qEn.EntityColumn)({
            name: 'c_tienda_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Tienda'
        }),
        c_servicio_id: new (0, $49qEn.EntityColumn)({
            name: 'c_servicio_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Servicio'
        }),
        c_autorizacion_directa_status_id: new (0, $49qEn.EntityColumn)({
            name: 'c_autorizacion_directa_status_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Estado'
        }),
        dt_fecha_realizado_desde: new (0, $49qEn.EntityColumn)({
            name: 'dt_fecha_realizado_desde',
            type: 'datetime',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Fecha Hora Realizado Desde'
        }),
        dt_fecha_realizado_hasta: new (0, $49qEn.EntityColumn)({
            name: 'dt_fecha_realizado_hasta',
            type: 'datetime',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Fecha Hora Realizado Hasta'
        }),
        vc_servicios: new (0, $49qEn.EntityColumn)({
            name: 'vc_servicios',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Servicio',
            isArray: true
        }),
        vc_status: new (0, $49qEn.EntityColumn)({
            name: 'vc_status',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Estado',
            isArray: true
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $71168b02d3b334ed$var$views = ()=>({
        repo_brwBaseClientes: {
            name: 'repo_brwBaseClientes',
            keyMappings: {
                c_cliente_id: 0
            },
            gridColumnsOverrides: (0, $047iA.BaseClientesViewColumnsOverrides)
        },
        repo_brwBaseRuteos: {
            name: 'repo_brwBaseRuteos',
            keyMappings: {
                c_cliente_id: 0
            }
        },
        repo_brwBaseReportes: {
            name: 'repo_brwBaseReportes',
            keyMappings: {
                c_cliente_id: 0
            },
            gridColumnsOverrides: ()=>(0, $1noBe.BaseReportesViewColumnsOverrides)(17)
        },
        repo_brwBaseReportesDetallada: {
            name: 'repo_brwBaseReportesDetallada',
            keyMappings: {
                c_cliente_id: 0
            },
            gridColumnsOverrides: ()=>(0, $1noBe.BaseReportesViewColumnsOverrides)(17)
        },
        repo_brwBaseQuiebresrepo_brwBaseQuiebres: {
            name: 'repo_brwBaseQuiebres',
            keyMappings: {
                c_cliente_id: 0
            },
            gridColumnsOverrides: (0, $047iA.BaseClientesViewColumnsOverrides)
        },
        repo_brwBasePreciosrepo_brwBasePrecios: {
            name: 'repo_brwBasePrecios',
            keyMappings: {
                c_cliente_id: 0
            }
        },
        repo_brwBaseNovedades: {
            name: 'repo_brwBaseNovedades',
            keyMappings: {
                c_cliente_id: 0
            }
        },
        repo_brwBaseReportesFotos: {
            name: 'repo_brwBaseReportesFotos',
            keyMappings: {
                c_cliente_id: 0
            },
            gridColumnsOverrides: ()=>(0, $1noBe.BaseReportesViewColumnsOverrides)(8)
        }
    });
const $71168b02d3b334ed$var$lookups = ()=>({
        'Clientes': {
            name: 'Clientes',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 2
            },
            entityConstructor: (client, parentKeys)=>new (0, $9u8qf.Clientes)(client, parentKeys)
        },
        'AutorizacionDirecta': {
            name: 'AutorizacionDirecta',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $kd5or.estAutorizacionDirecta)(client, parentKeys)
        },
        'Cadenas': {
            name: 'Cadenas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $SKbb0.Cadenas)(client, parentKeys)
        },
        'Tiendas': {
            name: 'Tiendas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 4
            },
            entityConstructor: (client, parentKeys)=>new (0, $6awxZ.Tiendas)(client, parentKeys)
        },
        'Servicios': {
            name: 'Servicios',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $gKBQM.Servicios)(client, parentKeys)
        }
    });
const $71168b02d3b334ed$var$procs = ()=>({
        repo_qryReportes: {
            name: 'repo_qryReportes'
        },
        repo_qryReportesDetallada: {
            name: 'repo_qryReportesDetallada'
        },
        repo_qryReportesPorServicio: {
            name: 'repo_qryReportesPorServicio'
        },
        repo_qryReportesFotos: {
            name: 'repo_qryReportesFotos'
        }
    });
const $71168b02d3b334ed$var$clientActions = ()=>({
        ACTExportarExcel: (0, $7gAwr.ACTExportarExcel),
        ACTExportarExcelPorServicios: (0, $ly0BV.ACTExportarExcelPorServicios),
        ACTExportarPdf: (0, $iaVJq.ACTExportarPdf),
        ACTDescargarFotos: (0, $1CpMv.ACTDescargarFotos),
        ACTExportarExcelConsolidado: (0, $kSjlk.ACTExportarExcelConsolidado)
    });
class $71168b02d3b334ed$export$3c559da9e25edb38 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('Reportes'), this.columns = $71168b02d3b334ed$var$columns(), this.views = $71168b02d3b334ed$var$views(), this.lookups = $71168b02d3b334ed$var$lookups(), this.procs = $71168b02d3b334ed$var$procs(), this.clientActions = $71168b02d3b334ed$var$clientActions();
    }
}

});
parcelRegister("1CpMv", function(module, exports) {

$parcel$export(module.exports, "ACTDescargarFotos", () => $cc877aa86fe4496f$export$4af42e4ad258caf9);

var $ayMG0 = parcelRequire("ayMG0");

var $9VIWE = parcelRequire("9VIWE");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $crxWL = parcelRequire("crxWL");

var $lUp03 = parcelRequire("lUp03");

var $acw62 = parcelRequire("acw62");

var $3OncY = parcelRequire("3OncY");
function $cc877aa86fe4496f$var$sanitizeSegment(s) {
    return (s || "").trim().replace(/[\\/:*?"<>|]+/g, "_").replace(/\s+/g, " ").substring(0, 100);
}
function $cc877aa86fe4496f$var$onlyDateYYYYMMDD(value) {
    const tryDate = new Date(value);
    if (!isNaN(tryDate.getTime())) {
        const y = tryDate.getFullYear();
        const m = String(tryDate.getMonth() + 1).padStart(2, "0");
        const d = String(tryDate.getDate()).padStart(2, "0");
        return `${y}-${m}-${d}`;
    }
    const cut = value.split(/[ T]/)[0]?.replace(/[/\\.]/g, "-");
    if (/^\d{4}-\d{2}-\d{2}$/.test(cut)) return cut;
    return "0000-00-00";
}
async function $cc877aa86fe4496f$var$fetchWithTimeout(url, ms = 20000) {
    const ctrl = new AbortController();
    const t = setTimeout(()=>ctrl.abort(), ms);
    try {
        return await fetch(url, {
            signal: ctrl.signal,
            credentials: "omit",
            cache: "no-store"
        });
    } finally{
        clearTimeout(t);
    }
}
function $cc877aa86fe4496f$var$avoidCollision(pathMap, basePath) {
    if (!pathMap.has(basePath)) {
        pathMap.add(basePath);
        return basePath;
    }
    const dot = basePath.lastIndexOf(".");
    const name = dot > 0 ? basePath.slice(0, dot) : basePath;
    const ext = dot > 0 ? basePath.slice(dot) : "";
    let i = 1;
    let candidate = `${name}(${i})${ext}`;
    while(pathMap.has(candidate)){
        i++;
        candidate = `${name}(${i})${ext}`;
    }
    pathMap.add(candidate);
    return candidate;
}
async function $cc877aa86fe4496f$var$buildZip(dr) {
    const headers = dr?.Header ?? [];
    const rows = dr?.records ?? [];
    const idxImagen = headers.indexOf("ValorImagen");
    const idxCliente = headers.indexOf("Cliente");
    const idxCadena = headers.indexOf("Cadena");
    const idxTienda = headers.indexOf("Tienda");
    const idxRealizado = headers.indexOf("FechaRealizado");
    if (rows.length === 0 || idxImagen < 0) return new Blob([], {
        type: "application/zip"
    });
    const zip = new (0, (/*@__PURE__*/$parcel$interopDefault($lUp03)))();
    const CONCURRENCIA = 5; // habría que probar con mas datos
    let cursor = 0;
    const pathSet = new Set();
    async function worker() {
        while(cursor < rows.length){
            const i = cursor++;
            const row = rows[i];
            const imagenUrl = String(row[idxImagen] ?? "").trim();
            if (!imagenUrl) continue;
            try {
                const url_img = `${(0, $3OncY.API_URL)}/${(0, $3OncY.APP_ID)}/serve/${imagenUrl}`;
                const res = await $cc877aa86fe4496f$var$fetchWithTimeout(url_img, 20000);
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                const blob = await res.blob();
                const valorImagen = String(row[idxImagen] ?? "").trim();
                const fileName = $cc877aa86fe4496f$var$sanitizeSegment(valorImagen);
                const cliente = $cc877aa86fe4496f$var$sanitizeSegment(idxCliente >= 0 ? String(row[idxCliente] ?? "") : "");
                const cadena = $cc877aa86fe4496f$var$sanitizeSegment(idxCadena >= 0 ? String(row[idxCadena] ?? "") : "");
                const tienda = $cc877aa86fe4496f$var$sanitizeSegment(idxTienda >= 0 ? String(row[idxTienda] ?? "") : "");
                const realizado = $cc877aa86fe4496f$var$onlyDateYYYYMMDD(idxRealizado >= 0 ? String(row[idxRealizado] ?? "") : "");
                const carpetaCliente = cliente || "Cliente";
                const carpetaFecha = realizado || "Fecha";
                const carpetaCadena = cadena || "Cadena";
                const carpetaTienda = tienda || "Tienda";
                const basePath = `${carpetaCliente}/${carpetaFecha}/${carpetaCadena}/${carpetaTienda}/${fileName}`;
                const finalPath = $cc877aa86fe4496f$var$avoidCollision(pathSet, basePath);
                zip.file(finalPath, blob, {
                    binary: true
                });
            } catch (err) {
                console.warn("No se pudo descargar:", imagenUrl, err);
            }
        }
    }
    await Promise.all(Array.from({
        length: Math.min(CONCURRENCIA, rows.length)
    }, worker));
    return zip.generateAsync({
        type: "blob",
        compression: "DEFLATE",
        compressionOptions: {
            level: 6
        }
    });
}
const $cc877aa86fe4496f$export$a1528ccc57760479 = ({ reportes: reportes, onClose: onClose })=>{
    const getReportes = (0, $49qEn.useExecuteProc)(reportes, reportes.def.procs.repo_qryReportesFotos);
    const [datos0, setDatos0] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        (async ()=>{
            await getReportes.execute({
                c_cliente_id: reportes.def.columns.c_cliente_id.value,
                dt_fecha_desde: reportes.parentKeys.dt_fecha_desde,
                dt_fecha_hasta: reportes.parentKeys.dt_fecha_hasta,
                c_autorizacion_directa_status_id: reportes.parentKeys.c_autorizacion_directa_status_id,
                dt_fecha_realizado_desde: reportes.parentKeys.dt_fecha_realizado_desde,
                dt_fecha_realizado_hasta: reportes.parentKeys.dt_fecha_realizado_hasta
            });
        })();
    }, [
        reportes.def.columns.c_cliente_id.value,
        reportes.parentKeys.dt_fecha_desde,
        reportes.parentKeys.dt_fecha_hasta,
        reportes.parentKeys.c_autorizacion_directa_status_id,
        reportes.parentKeys.dt_fecha_realizado_desde,
        reportes.parentKeys.dt_fecha_realizado_hasta
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!getReportes.status.loading && getReportes.status.data) setDatos0(getReportes.status.data[0]);
    }, [
        getReportes.status
    ]);
    (0, $acw62.useEffect)(()=>{
        (async ()=>{
            if (!datos0) return;
            try {
                const zipBlob = await $cc877aa86fe4496f$var$buildZip(datos0);
                (0, (/*@__PURE__*/$parcel$interopDefault($crxWL)))(zipBlob, "fotos.zip");
            } finally{
                onClose();
            }
        })();
    }, [
        datos0
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9VIWE.Stack), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                children: "Generando ZIP de im\xe1genes\u2026"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.FakeProgressBar), {})
        ]
    });
};
const $cc877aa86fe4496f$export$4af42e4ad258caf9 = {
    name: "ACTDescargarFotos",
    label: "Descargar Fotos",
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Descargar Fotos"
    }),
    refreshOnClose: true,
    dontRequireSelection: true,
    showActionInViewMode: true,
    views: [
        "repo_brwBaseReportesDetallada"
    ],
    onClick: async ({ entity: entity, modal: modal, element: element })=>{
        const reportes = entity;
        if (!modal) {
            console.warn("modal context not found");
            return false;
        }
        await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                    fw: "700",
                    children: "Exportar Fotos"
                })
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)($cc877aa86fe4496f$export$a1528ccc57760479, {
                reportes: reportes,
                onClose: ()=>modal.close()
            })
        });
        return false;
    }
};

});
parcelRegister("crxWL", function(module, exports) {
(function(a, b) {
    if ("function" == typeof define && define.amd) define([], b);
    else b();
})(module.exports, function() {
    "use strict";
    function b(a, b) {
        return "undefined" == typeof b ? b = {
            autoBom: !1
        } : "object" != typeof b && (console.warn("Deprecated: Expected third argument to be a object"), b = {
            autoBom: !b
        }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type) ? new Blob([
            "\uFEFF",
            a
        ], {
            type: a.type
        }) : a;
    }
    function c(a, b, c) {
        var d = new XMLHttpRequest;
        d.open("GET", a), d.responseType = "blob", d.onload = function() {
            g(d.response, b, c);
        }, d.onerror = function() {
            console.error("could not download file");
        }, d.send();
    }
    function d(a) {
        var b = new XMLHttpRequest;
        b.open("HEAD", a, !1);
        try {
            b.send();
        } catch (a) {}
        return 200 <= b.status && 299 >= b.status;
    }
    function e(a) {
        try {
            a.dispatchEvent(new MouseEvent("click"));
        } catch (c) {
            var b = document.createEvent("MouseEvents");
            b.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), a.dispatchEvent(b);
        }
    }
    var f = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof $parcel$global && $parcel$global.global === $parcel$global ? $parcel$global : void 0, a = f.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), g = f.saveAs || ("object" != typeof window || window !== f ? function() {} : "download" in HTMLAnchorElement.prototype && !a ? function(b, g, h) {
        var i = f.URL || f.webkitURL, j = document.createElement("a");
        g = g || b.name || "download", j.download = g, j.rel = "noopener", "string" == typeof b ? (j.href = b, j.origin === location.origin ? e(j) : d(j.href) ? c(b, g, h) : e(j, j.target = "_blank")) : (j.href = i.createObjectURL(b), setTimeout(function() {
            i.revokeObjectURL(j.href);
        }, 4E4), setTimeout(function() {
            e(j);
        }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(f, g, h) {
        if (g = g || f.name || "download", "string" != typeof f) navigator.msSaveOrOpenBlob(b(f, h), g);
        else if (d(f)) c(f, g, h);
        else {
            var i = document.createElement("a");
            i.href = f, i.target = "_blank", setTimeout(function() {
                e(i);
            });
        }
    } : function(b, d, e, g) {
        if (g = g || open("", "_blank"), g && (g.document.title = g.document.body.innerText = "downloading..."), "string" == typeof b) return c(b, d, e);
        var h = "application/octet-stream" === b.type, i = /constructor/i.test(f.HTMLElement) || f.safari, j = /CriOS\/[\d]+/.test(navigator.userAgent);
        if ((j || h && i || a) && "undefined" != typeof FileReader) {
            var k = new FileReader;
            k.onloadend = function() {
                var a = k.result;
                a = j ? a : a.replace(/^data:[^;]*;/, "data:attachment/file;"), g ? g.location.href = a : location = a, g = null;
            }, k.readAsDataURL(b);
        } else {
            var l = f.URL || f.webkitURL, m = l.createObjectURL(b);
            g ? g.location = m : location.href = m, g = null, setTimeout(function() {
                l.revokeObjectURL(m);
            }, 4E4);
        }
    });
    f.saveAs = g.saveAs = g, module.exports = g;
});

});

parcelRegister("lUp03", function(module, exports) {
/*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/ 
var $6ZWSX = parcelRequire("6ZWSX");
var $ff323866fb43afa6$require$Buffer = $6ZWSX.Buffer;

var $hPtJY = parcelRequire("hPtJY");
!function(e) {
    module.exports = e();
}(function() {
    return (function s(a, o, h) {
        function u(r, e) {
            if (!o[r]) {
                if (!a[r]) {
                    var t = undefined;
                    if (!e && t) return t(r, !0);
                    if (l) return l(r, !0);
                    var n = new Error("Cannot find module '" + r + "'");
                    throw n.code = "MODULE_NOT_FOUND", n;
                }
                var i = o[r] = {
                    exports: {}
                };
                a[r][0].call(i.exports, function(e) {
                    var t = a[r][1][e];
                    return u(t || e);
                }, i, i.exports, s, a, o, h);
            }
            return o[r].exports;
        }
        for(var l = undefined, e = 0; e < h.length; e++)u(h[e]);
        return u;
    })({
        1: [
            function(e, t, r) {
                "use strict";
                var d = e("./utils"), c = e("./support"), p = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                r.encode = function(e) {
                    for(var t, r, n, i, s, a, o, h = [], u = 0, l = e.length, f = l, c = "string" !== d.getTypeOf(e); u < e.length;)f = l - u, n = c ? (t = e[u++], r = u < l ? e[u++] : 0, u < l ? e[u++] : 0) : (t = e.charCodeAt(u++), r = u < l ? e.charCodeAt(u++) : 0, u < l ? e.charCodeAt(u++) : 0), i = t >> 2, s = (3 & t) << 4 | r >> 4, a = 1 < f ? (15 & r) << 2 | n >> 6 : 64, o = 2 < f ? 63 & n : 64, h.push(p.charAt(i) + p.charAt(s) + p.charAt(a) + p.charAt(o));
                    return h.join("");
                }, r.decode = function(e) {
                    var t, r, n, i, s, a, o = 0, h = 0, u = "data:";
                    if (e.substr(0, u.length) === u) throw new Error("Invalid base64 input, it looks like a data url.");
                    var l, f = 3 * (e = e.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
                    if (e.charAt(e.length - 1) === p.charAt(64) && f--, e.charAt(e.length - 2) === p.charAt(64) && f--, f % 1 != 0) throw new Error("Invalid base64 input, bad content length.");
                    for(l = c.uint8array ? new Uint8Array(0 | f) : new Array(0 | f); o < e.length;)t = p.indexOf(e.charAt(o++)) << 2 | (i = p.indexOf(e.charAt(o++))) >> 4, r = (15 & i) << 4 | (s = p.indexOf(e.charAt(o++))) >> 2, n = (3 & s) << 6 | (a = p.indexOf(e.charAt(o++))), l[h++] = t, 64 !== s && (l[h++] = r), 64 !== a && (l[h++] = n);
                    return l;
                };
            },
            {
                "./support": 30,
                "./utils": 32
            }
        ],
        2: [
            function(e, t, r) {
                "use strict";
                var n = e("./external"), i = e("./stream/DataWorker"), s = e("./stream/Crc32Probe"), a = e("./stream/DataLengthProbe");
                function o(e, t, r, n, i) {
                    this.compressedSize = e, this.uncompressedSize = t, this.crc32 = r, this.compression = n, this.compressedContent = i;
                }
                o.prototype = {
                    getContentWorker: function() {
                        var e = new i(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new a("data_length")), t = this;
                        return e.on("end", function() {
                            if (this.streamInfo.data_length !== t.uncompressedSize) throw new Error("Bug : uncompressed data size mismatch");
                        }), e;
                    },
                    getCompressedWorker: function() {
                        return new i(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
                    }
                }, o.createWorkerFrom = function(e, t, r) {
                    return e.pipe(new s).pipe(new a("uncompressedSize")).pipe(t.compressWorker(r)).pipe(new a("compressedSize")).withStreamInfo("compression", t);
                }, t.exports = o;
            },
            {
                "./external": 6,
                "./stream/Crc32Probe": 25,
                "./stream/DataLengthProbe": 26,
                "./stream/DataWorker": 27
            }
        ],
        3: [
            function(e, t, r) {
                "use strict";
                var n = e("./stream/GenericWorker");
                r.STORE = {
                    magic: "\0\0",
                    compressWorker: function() {
                        return new n("STORE compression");
                    },
                    uncompressWorker: function() {
                        return new n("STORE decompression");
                    }
                }, r.DEFLATE = e("./flate");
            },
            {
                "./flate": 7,
                "./stream/GenericWorker": 28
            }
        ],
        4: [
            function(e, t, r) {
                "use strict";
                var n = e("./utils");
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t) {
                    return void 0 !== e && e.length ? "string" !== n.getTypeOf(e) ? function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t.charCodeAt(a))];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : 0;
                };
            },
            {
                "./utils": 32
            }
        ],
        5: [
            function(e, t, r) {
                "use strict";
                r.base64 = !1, r.binary = !1, r.dir = !1, r.createFolders = !0, r.date = null, r.compression = null, r.compressionOptions = null, r.comment = null, r.unixPermissions = null, r.dosPermissions = null;
            },
            {}
        ],
        6: [
            function(e, t, r) {
                "use strict";
                var n = null;
                n = "undefined" != typeof Promise ? Promise : e("lie"), t.exports = {
                    Promise: n
                };
            },
            {
                lie: 37
            }
        ],
        7: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Uint32Array, i = e("pako"), s = e("./utils"), a = e("./stream/GenericWorker"), o = n ? "uint8array" : "array";
                function h(e, t) {
                    a.call(this, "FlateWorker/" + e), this._pako = null, this._pakoAction = e, this._pakoOptions = t, this.meta = {};
                }
                r.magic = "\b\0", s.inherits(h, a), h.prototype.processChunk = function(e) {
                    this.meta = e.meta, null === this._pako && this._createPako(), this._pako.push(s.transformTo(o, e.data), !1);
                }, h.prototype.flush = function() {
                    a.prototype.flush.call(this), null === this._pako && this._createPako(), this._pako.push([], !0);
                }, h.prototype.cleanUp = function() {
                    a.prototype.cleanUp.call(this), this._pako = null;
                }, h.prototype._createPako = function() {
                    this._pako = new i[this._pakoAction]({
                        raw: !0,
                        level: this._pakoOptions.level || -1
                    });
                    var t = this;
                    this._pako.onData = function(e) {
                        t.push({
                            data: e,
                            meta: t.meta
                        });
                    };
                }, r.compressWorker = function(e) {
                    return new h("Deflate", e);
                }, r.uncompressWorker = function() {
                    return new h("Inflate", {});
                };
            },
            {
                "./stream/GenericWorker": 28,
                "./utils": 32,
                pako: 38
            }
        ],
        8: [
            function(e, t, r) {
                "use strict";
                function A(e, t) {
                    var r, n = "";
                    for(r = 0; r < t; r++)n += String.fromCharCode(255 & e), e >>>= 8;
                    return n;
                }
                function n(e, t, r, n, i, s) {
                    var a, o, h = e.file, u = e.compression, l = s !== O.utf8encode, f = I.transformTo("string", s(h.name)), c = I.transformTo("string", O.utf8encode(h.name)), d = h.comment, p = I.transformTo("string", s(d)), m = I.transformTo("string", O.utf8encode(d)), _ = c.length !== h.name.length, g = m.length !== d.length, b = "", v = "", y = "", w = h.dir, k = h.date, x = {
                        crc32: 0,
                        compressedSize: 0,
                        uncompressedSize: 0
                    };
                    t && !r || (x.crc32 = e.crc32, x.compressedSize = e.compressedSize, x.uncompressedSize = e.uncompressedSize);
                    var S = 0;
                    t && (S |= 8), l || !_ && !g || (S |= 2048);
                    var z = 0, C = 0;
                    w && (z |= 16), "UNIX" === i ? (C = 798, z |= function(e, t) {
                        var r = e;
                        return e || (r = t ? 16893 : 33204), (65535 & r) << 16;
                    }(h.unixPermissions, w)) : (C = 20, z |= function(e) {
                        return 63 & (e || 0);
                    }(h.dosPermissions)), a = k.getUTCHours(), a <<= 6, a |= k.getUTCMinutes(), a <<= 5, a |= k.getUTCSeconds() / 2, o = k.getUTCFullYear() - 1980, o <<= 4, o |= k.getUTCMonth() + 1, o <<= 5, o |= k.getUTCDate(), _ && (v = A(1, 1) + A(B(f), 4) + c, b += "up" + A(v.length, 2) + v), g && (y = A(1, 1) + A(B(p), 4) + m, b += "uc" + A(y.length, 2) + y);
                    var E = "";
                    return E += "\n\0", E += A(S, 2), E += u.magic, E += A(a, 2), E += A(o, 2), E += A(x.crc32, 4), E += A(x.compressedSize, 4), E += A(x.uncompressedSize, 4), E += A(f.length, 2), E += A(b.length, 2), {
                        fileRecord: R.LOCAL_FILE_HEADER + E + f + b,
                        dirRecord: R.CENTRAL_FILE_HEADER + A(C, 2) + E + A(p.length, 2) + "\0\0\0\0" + A(z, 4) + A(n, 4) + f + b + p
                    };
                }
                var I = e("../utils"), i = e("../stream/GenericWorker"), O = e("../utf8"), B = e("../crc32"), R = e("../signature");
                function s(e, t, r, n) {
                    i.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = t, this.zipPlatform = r, this.encodeFileName = n, this.streamFiles = e, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
                }
                I.inherits(s, i), s.prototype.push = function(e) {
                    var t = e.meta.percent || 0, r = this.entriesCount, n = this._sources.length;
                    this.accumulate ? this.contentBuffer.push(e) : (this.bytesWritten += e.data.length, i.prototype.push.call(this, {
                        data: e.data,
                        meta: {
                            currentFile: this.currentFile,
                            percent: r ? (t + 100 * (r - n - 1)) / r : 100
                        }
                    }));
                }, s.prototype.openedSource = function(e) {
                    this.currentSourceOffset = this.bytesWritten, this.currentFile = e.file.name;
                    var t = this.streamFiles && !e.file.dir;
                    if (t) {
                        var r = n(e, t, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                        this.push({
                            data: r.fileRecord,
                            meta: {
                                percent: 0
                            }
                        });
                    } else this.accumulate = !0;
                }, s.prototype.closedSource = function(e) {
                    this.accumulate = !1;
                    var t = this.streamFiles && !e.file.dir, r = n(e, t, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                    if (this.dirRecords.push(r.dirRecord), t) this.push({
                        data: function(e) {
                            return R.DATA_DESCRIPTOR + A(e.crc32, 4) + A(e.compressedSize, 4) + A(e.uncompressedSize, 4);
                        }(e),
                        meta: {
                            percent: 100
                        }
                    });
                    else for(this.push({
                        data: r.fileRecord,
                        meta: {
                            percent: 0
                        }
                    }); this.contentBuffer.length;)this.push(this.contentBuffer.shift());
                    this.currentFile = null;
                }, s.prototype.flush = function() {
                    for(var e = this.bytesWritten, t = 0; t < this.dirRecords.length; t++)this.push({
                        data: this.dirRecords[t],
                        meta: {
                            percent: 100
                        }
                    });
                    var r = this.bytesWritten - e, n = function(e, t, r, n, i) {
                        var s = I.transformTo("string", i(n));
                        return R.CENTRAL_DIRECTORY_END + "\0\0\0\0" + A(e, 2) + A(e, 2) + A(t, 4) + A(r, 4) + A(s.length, 2) + s;
                    }(this.dirRecords.length, r, e, this.zipComment, this.encodeFileName);
                    this.push({
                        data: n,
                        meta: {
                            percent: 100
                        }
                    });
                }, s.prototype.prepareNextSource = function() {
                    this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
                }, s.prototype.registerPrevious = function(e) {
                    this._sources.push(e);
                    var t = this;
                    return e.on("data", function(e) {
                        t.processChunk(e);
                    }), e.on("end", function() {
                        t.closedSource(t.previous.streamInfo), t._sources.length ? t.prepareNextSource() : t.end();
                    }), e.on("error", function(e) {
                        t.error(e);
                    }), this;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
                }, s.prototype.error = function(e) {
                    var t = this._sources;
                    if (!i.prototype.error.call(this, e)) return !1;
                    for(var r = 0; r < t.length; r++)try {
                        t[r].error(e);
                    } catch (e) {}
                    return !0;
                }, s.prototype.lock = function() {
                    i.prototype.lock.call(this);
                    for(var e = this._sources, t = 0; t < e.length; t++)e[t].lock();
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../signature": 23,
                "../stream/GenericWorker": 28,
                "../utf8": 31,
                "../utils": 32
            }
        ],
        9: [
            function(e, t, r) {
                "use strict";
                var u = e("../compressions"), n = e("./ZipFileWorker");
                r.generateWorker = function(e, a, t) {
                    var o = new n(a.streamFiles, t, a.platform, a.encodeFileName), h = 0;
                    try {
                        e.forEach(function(e, t) {
                            h++;
                            var r = function(e, t) {
                                var r = e || t, n = u[r];
                                if (!n) throw new Error(r + " is not a valid compression method !");
                                return n;
                            }(t.options.compression, a.compression), n = t.options.compressionOptions || a.compressionOptions || {}, i = t.dir, s = t.date;
                            t._compressWorker(r, n).withStreamInfo("file", {
                                name: e,
                                dir: i,
                                date: s,
                                comment: t.comment || "",
                                unixPermissions: t.unixPermissions,
                                dosPermissions: t.dosPermissions
                            }).pipe(o);
                        }), o.entriesCount = h;
                    } catch (e) {
                        o.error(e);
                    }
                    return o;
                };
            },
            {
                "../compressions": 3,
                "./ZipFileWorker": 8
            }
        ],
        10: [
            function(e, t, r) {
                "use strict";
                function n() {
                    if (!(this instanceof n)) return new n;
                    if (arguments.length) throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
                    this.files = Object.create(null), this.comment = null, this.root = "", this.clone = function() {
                        var e = new n;
                        for(var t in this)"function" != typeof this[t] && (e[t] = this[t]);
                        return e;
                    };
                }
                (n.prototype = e("./object")).loadAsync = e("./load"), n.support = e("./support"), n.defaults = e("./defaults"), n.version = "3.10.1", n.loadAsync = function(e, t) {
                    return (new n).loadAsync(e, t);
                }, n.external = e("./external"), t.exports = n;
            },
            {
                "./defaults": 5,
                "./external": 6,
                "./load": 11,
                "./object": 15,
                "./support": 30
            }
        ],
        11: [
            function(e, t, r) {
                "use strict";
                var u = e("./utils"), i = e("./external"), n = e("./utf8"), s = e("./zipEntries"), a = e("./stream/Crc32Probe"), l = e("./nodejsUtils");
                function f(n) {
                    return new i.Promise(function(e, t) {
                        var r = n.decompressed.getContentWorker().pipe(new a);
                        r.on("error", function(e) {
                            t(e);
                        }).on("end", function() {
                            r.streamInfo.crc32 !== n.decompressed.crc32 ? t(new Error("Corrupted zip : CRC32 mismatch")) : e();
                        }).resume();
                    });
                }
                t.exports = function(e, o) {
                    var h = this;
                    return o = u.extend(o || {}, {
                        base64: !1,
                        checkCRC32: !1,
                        optimizedBinaryString: !1,
                        createFolders: !1,
                        decodeFileName: n.utf8decode
                    }), l.isNode && l.isStream(e) ? i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : u.prepareContent("the loaded zip file", e, !0, o.optimizedBinaryString, o.base64).then(function(e) {
                        var t = new s(o);
                        return t.load(e), t;
                    }).then(function(e) {
                        var t = [
                            i.Promise.resolve(e)
                        ], r = e.files;
                        if (o.checkCRC32) for(var n = 0; n < r.length; n++)t.push(f(r[n]));
                        return i.Promise.all(t);
                    }).then(function(e) {
                        for(var t = e.shift(), r = t.files, n = 0; n < r.length; n++){
                            var i = r[n], s = i.fileNameStr, a = u.resolve(i.fileNameStr);
                            h.file(a, i.decompressed, {
                                binary: !0,
                                optimizedBinaryString: !0,
                                date: i.date,
                                dir: i.dir,
                                comment: i.fileCommentStr.length ? i.fileCommentStr : null,
                                unixPermissions: i.unixPermissions,
                                dosPermissions: i.dosPermissions,
                                createFolders: o.createFolders
                            }), i.dir || (h.file(a).unsafeOriginalName = s);
                        }
                        return t.zipComment.length && (h.comment = t.zipComment), h;
                    });
                };
            },
            {
                "./external": 6,
                "./nodejsUtils": 14,
                "./stream/Crc32Probe": 25,
                "./utf8": 31,
                "./utils": 32,
                "./zipEntries": 33
            }
        ],
        12: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../stream/GenericWorker");
                function s(e, t) {
                    i.call(this, "Nodejs stream input adapter for " + e), this._upstreamEnded = !1, this._bindStream(t);
                }
                n.inherits(s, i), s.prototype._bindStream = function(e) {
                    var t = this;
                    (this._stream = e).pause(), e.on("data", function(e) {
                        t.push({
                            data: e,
                            meta: {
                                percent: 0
                            }
                        });
                    }).on("error", function(e) {
                        t.isPaused ? this.generatedError = e : t.error(e);
                    }).on("end", function() {
                        t.isPaused ? t._upstreamEnded = !0 : t.end();
                    });
                }, s.prototype.pause = function() {
                    return !!i.prototype.pause.call(this) && (this._stream.pause(), !0);
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
                }, t.exports = s;
            },
            {
                "../stream/GenericWorker": 28,
                "../utils": 32
            }
        ],
        13: [
            function(e, t, r) {
                "use strict";
                var i = e("readable-stream").Readable;
                function n(e, t, r) {
                    i.call(this, t), this._helper = e;
                    var n = this;
                    e.on("data", function(e, t) {
                        n.push(e) || n._helper.pause(), r && r(t);
                    }).on("error", function(e) {
                        n.emit("error", e);
                    }).on("end", function() {
                        n.push(null);
                    });
                }
                e("../utils").inherits(n, i), n.prototype._read = function() {
                    this._helper.resume();
                }, t.exports = n;
            },
            {
                "../utils": 32,
                "readable-stream": 16
            }
        ],
        14: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    isNode: "undefined" != typeof $ff323866fb43afa6$require$Buffer,
                    newBufferFrom: function(e, t) {
                        if ($ff323866fb43afa6$require$Buffer.from && $ff323866fb43afa6$require$Buffer.from !== Uint8Array.from) return $ff323866fb43afa6$require$Buffer.from(e, t);
                        if ("number" == typeof e) throw new Error('The "data" argument must not be a number');
                        return new $ff323866fb43afa6$require$Buffer(e, t);
                    },
                    allocBuffer: function(e) {
                        if ($ff323866fb43afa6$require$Buffer.alloc) return $ff323866fb43afa6$require$Buffer.alloc(e);
                        var t = new $ff323866fb43afa6$require$Buffer(e);
                        return t.fill(0), t;
                    },
                    isBuffer: function(e) {
                        return $ff323866fb43afa6$require$Buffer.isBuffer(e);
                    },
                    isStream: function(e) {
                        return e && "function" == typeof e.on && "function" == typeof e.pause && "function" == typeof e.resume;
                    }
                };
            },
            {}
        ],
        15: [
            function(e, t, r) {
                "use strict";
                function s(e, t, r) {
                    var n, i = u.getTypeOf(t), s = u.extend(r || {}, f);
                    s.date = s.date || new Date, null !== s.compression && (s.compression = s.compression.toUpperCase()), "string" == typeof s.unixPermissions && (s.unixPermissions = parseInt(s.unixPermissions, 8)), s.unixPermissions && 16384 & s.unixPermissions && (s.dir = !0), s.dosPermissions && 16 & s.dosPermissions && (s.dir = !0), s.dir && (e = g(e)), s.createFolders && (n = _(e)) && b.call(this, n, !0);
                    var a = "string" === i && !1 === s.binary && !1 === s.base64;
                    r && void 0 !== r.binary || (s.binary = !a), (t instanceof c && 0 === t.uncompressedSize || s.dir || !t || 0 === t.length) && (s.base64 = !1, s.binary = !0, t = "", s.compression = "STORE", i = "string");
                    var o = null;
                    o = t instanceof c || t instanceof l ? t : p.isNode && p.isStream(t) ? new m(e, t) : u.prepareContent(e, t, s.binary, s.optimizedBinaryString, s.base64);
                    var h = new d(e, o, s);
                    this.files[e] = h;
                }
                var i = e("./utf8"), u = e("./utils"), l = e("./stream/GenericWorker"), a = e("./stream/StreamHelper"), f = e("./defaults"), c = e("./compressedObject"), d = e("./zipObject"), o = e("./generate"), p = e("./nodejsUtils"), m = e("./nodejs/NodejsStreamInputAdapter"), _ = function(e) {
                    "/" === e.slice(-1) && (e = e.substring(0, e.length - 1));
                    var t = e.lastIndexOf("/");
                    return 0 < t ? e.substring(0, t) : "";
                }, g = function(e) {
                    return "/" !== e.slice(-1) && (e += "/"), e;
                }, b = function(e, t) {
                    return t = void 0 !== t ? t : f.createFolders, e = g(e), this.files[e] || s.call(this, e, null, {
                        dir: !0,
                        createFolders: t
                    }), this.files[e];
                };
                function h(e) {
                    return "[object RegExp]" === Object.prototype.toString.call(e);
                }
                var n = {
                    load: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    forEach: function(e) {
                        var t, r, n;
                        for(t in this.files)n = this.files[t], (r = t.slice(this.root.length, t.length)) && t.slice(0, this.root.length) === this.root && e(r, n);
                    },
                    filter: function(r) {
                        var n = [];
                        return this.forEach(function(e, t) {
                            r(e, t) && n.push(t);
                        }), n;
                    },
                    file: function(e, t, r) {
                        if (1 !== arguments.length) return e = this.root + e, s.call(this, e, t, r), this;
                        if (h(e)) {
                            var n = e;
                            return this.filter(function(e, t) {
                                return !t.dir && n.test(e);
                            });
                        }
                        var i = this.files[this.root + e];
                        return i && !i.dir ? i : null;
                    },
                    folder: function(r) {
                        if (!r) return this;
                        if (h(r)) return this.filter(function(e, t) {
                            return t.dir && r.test(e);
                        });
                        var e = this.root + r, t = b.call(this, e), n = this.clone();
                        return n.root = t.name, n;
                    },
                    remove: function(r) {
                        r = this.root + r;
                        var e = this.files[r];
                        if (e || ("/" !== r.slice(-1) && (r += "/"), e = this.files[r]), e && !e.dir) delete this.files[r];
                        else for(var t = this.filter(function(e, t) {
                            return t.name.slice(0, r.length) === r;
                        }), n = 0; n < t.length; n++)delete this.files[t[n].name];
                        return this;
                    },
                    generate: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    generateInternalStream: function(e) {
                        var t, r = {};
                        try {
                            if ((r = u.extend(e || {}, {
                                streamFiles: !1,
                                compression: "STORE",
                                compressionOptions: null,
                                type: "",
                                platform: "DOS",
                                comment: null,
                                mimeType: "application/zip",
                                encodeFileName: i.utf8encode
                            })).type = r.type.toLowerCase(), r.compression = r.compression.toUpperCase(), "binarystring" === r.type && (r.type = "string"), !r.type) throw new Error("No output type specified.");
                            u.checkSupport(r.type), "darwin" !== r.platform && "freebsd" !== r.platform && "linux" !== r.platform && "sunos" !== r.platform || (r.platform = "UNIX"), "win32" === r.platform && (r.platform = "DOS");
                            var n = r.comment || this.comment || "";
                            t = o.generateWorker(this, r, n);
                        } catch (e) {
                            (t = new l("error")).error(e);
                        }
                        return new a(t, r.type || "string", r.mimeType);
                    },
                    generateAsync: function(e, t) {
                        return this.generateInternalStream(e).accumulate(t);
                    },
                    generateNodeStream: function(e, t) {
                        return (e = e || {}).type || (e.type = "nodebuffer"), this.generateInternalStream(e).toNodejsStream(t);
                    }
                };
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./defaults": 5,
                "./generate": 9,
                "./nodejs/NodejsStreamInputAdapter": 12,
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31,
                "./utils": 32,
                "./zipObject": 35
            }
        ],
        16: [
            function(e, t, r) {
                "use strict";
                t.exports = e("stream");
            },
            {
                stream: void 0
            }
        ],
        17: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                    for(var t = 0; t < this.data.length; t++)e[t] = 255 & e[t];
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data[this.zero + e];
                }, i.prototype.lastIndexOfSignature = function(e) {
                    for(var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.length - 4; 0 <= s; --s)if (this.data[s] === t && this.data[s + 1] === r && this.data[s + 2] === n && this.data[s + 3] === i) return s - this.zero;
                    return -1;
                }, i.prototype.readAndCheckSignature = function(e) {
                    var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.readData(4);
                    return t === s[0] && r === s[1] && n === s[2] && i === s[3];
                }, i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return [];
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        18: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils");
                function i(e) {
                    this.data = e, this.length = e.length, this.index = 0, this.zero = 0;
                }
                i.prototype = {
                    checkOffset: function(e) {
                        this.checkIndex(this.index + e);
                    },
                    checkIndex: function(e) {
                        if (this.length < this.zero + e || e < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + e + "). Corrupted zip ?");
                    },
                    setIndex: function(e) {
                        this.checkIndex(e), this.index = e;
                    },
                    skip: function(e) {
                        this.setIndex(this.index + e);
                    },
                    byteAt: function() {},
                    readInt: function(e) {
                        var t, r = 0;
                        for(this.checkOffset(e), t = this.index + e - 1; t >= this.index; t--)r = (r << 8) + this.byteAt(t);
                        return this.index += e, r;
                    },
                    readString: function(e) {
                        return n.transformTo("string", this.readData(e));
                    },
                    readData: function() {},
                    lastIndexOfSignature: function() {},
                    readAndCheckSignature: function() {},
                    readDate: function() {
                        var e = this.readInt(4);
                        return new Date(Date.UTC(1980 + (e >> 25 & 127), (e >> 21 & 15) - 1, e >> 16 & 31, e >> 11 & 31, e >> 5 & 63, (31 & e) << 1));
                    }
                }, t.exports = i;
            },
            {
                "../utils": 32
            }
        ],
        19: [
            function(e, t, r) {
                "use strict";
                var n = e("./Uint8ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./Uint8ArrayReader": 21
            }
        ],
        20: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data.charCodeAt(this.zero + e);
                }, i.prototype.lastIndexOfSignature = function(e) {
                    return this.data.lastIndexOf(e) - this.zero;
                }, i.prototype.readAndCheckSignature = function(e) {
                    return e === this.readData(4);
                }, i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        21: [
            function(e, t, r) {
                "use strict";
                var n = e("./ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return new Uint8Array(0);
                    var t = this.data.subarray(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./ArrayReader": 17
            }
        ],
        22: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../support"), s = e("./ArrayReader"), a = e("./StringReader"), o = e("./NodeBufferReader"), h = e("./Uint8ArrayReader");
                t.exports = function(e) {
                    var t = n.getTypeOf(e);
                    return n.checkSupport(t), "string" !== t || i.uint8array ? "nodebuffer" === t ? new o(e) : i.uint8array ? new h(n.transformTo("uint8array", e)) : new s(n.transformTo("array", e)) : new a(e);
                };
            },
            {
                "../support": 30,
                "../utils": 32,
                "./ArrayReader": 17,
                "./NodeBufferReader": 19,
                "./StringReader": 20,
                "./Uint8ArrayReader": 21
            }
        ],
        23: [
            function(e, t, r) {
                "use strict";
                r.LOCAL_FILE_HEADER = "PK", r.CENTRAL_FILE_HEADER = "PK", r.CENTRAL_DIRECTORY_END = "PK", r.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK", r.ZIP64_CENTRAL_DIRECTORY_END = "PK", r.DATA_DESCRIPTOR = "PK\b";
            },
            {}
        ],
        24: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../utils");
                function s(e) {
                    n.call(this, "ConvertWorker to " + e), this.destType = e;
                }
                i.inherits(s, n), s.prototype.processChunk = function(e) {
                    this.push({
                        data: i.transformTo(this.destType, e.data),
                        meta: e.meta
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        25: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../crc32");
                function s() {
                    n.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
                }
                e("../utils").inherits(s, n), s.prototype.processChunk = function(e) {
                    this.streamInfo.crc32 = i(e.data, this.streamInfo.crc32 || 0), this.push(e);
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        26: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataLengthProbe for " + e), this.propName = e, this.withStreamInfo(e, 0);
                }
                n.inherits(s, i), s.prototype.processChunk = function(e) {
                    if (e) {
                        var t = this.streamInfo[this.propName] || 0;
                        this.streamInfo[this.propName] = t + e.data.length;
                    }
                    i.prototype.processChunk.call(this, e);
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        27: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataWorker");
                    var t = this;
                    this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, e.then(function(e) {
                        t.dataIsReady = !0, t.data = e, t.max = e && e.length || 0, t.type = n.getTypeOf(e), t.isPaused || t._tickAndRepeat();
                    }, function(e) {
                        t.error(e);
                    });
                }
                n.inherits(s, i), s.prototype.cleanUp = function() {
                    i.prototype.cleanUp.call(this), this.data = null;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, n.delay(this._tickAndRepeat, [], this)), !0);
                }, s.prototype._tickAndRepeat = function() {
                    this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (n.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
                }, s.prototype._tick = function() {
                    if (this.isPaused || this.isFinished) return !1;
                    var e = null, t = Math.min(this.max, this.index + 16384);
                    if (this.index >= this.max) return this.end();
                    switch(this.type){
                        case "string":
                            e = this.data.substring(this.index, t);
                            break;
                        case "uint8array":
                            e = this.data.subarray(this.index, t);
                            break;
                        case "array":
                        case "nodebuffer":
                            e = this.data.slice(this.index, t);
                    }
                    return this.index = t, this.push({
                        data: e,
                        meta: {
                            percent: this.max ? this.index / this.max * 100 : 0
                        }
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        28: [
            function(e, t, r) {
                "use strict";
                function n(e) {
                    this.name = e || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = {
                        data: [],
                        end: [],
                        error: []
                    }, this.previous = null;
                }
                n.prototype = {
                    push: function(e) {
                        this.emit("data", e);
                    },
                    end: function() {
                        if (this.isFinished) return !1;
                        this.flush();
                        try {
                            this.emit("end"), this.cleanUp(), this.isFinished = !0;
                        } catch (e) {
                            this.emit("error", e);
                        }
                        return !0;
                    },
                    error: function(e) {
                        return !this.isFinished && (this.isPaused ? this.generatedError = e : (this.isFinished = !0, this.emit("error", e), this.previous && this.previous.error(e), this.cleanUp()), !0);
                    },
                    on: function(e, t) {
                        return this._listeners[e].push(t), this;
                    },
                    cleanUp: function() {
                        this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
                    },
                    emit: function(e, t) {
                        if (this._listeners[e]) for(var r = 0; r < this._listeners[e].length; r++)this._listeners[e][r].call(this, t);
                    },
                    pipe: function(e) {
                        return e.registerPrevious(this);
                    },
                    registerPrevious: function(e) {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.streamInfo = e.streamInfo, this.mergeStreamInfo(), this.previous = e;
                        var t = this;
                        return e.on("data", function(e) {
                            t.processChunk(e);
                        }), e.on("end", function() {
                            t.end();
                        }), e.on("error", function(e) {
                            t.error(e);
                        }), this;
                    },
                    pause: function() {
                        return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
                    },
                    resume: function() {
                        if (!this.isPaused || this.isFinished) return !1;
                        var e = this.isPaused = !1;
                        return this.generatedError && (this.error(this.generatedError), e = !0), this.previous && this.previous.resume(), !e;
                    },
                    flush: function() {},
                    processChunk: function(e) {
                        this.push(e);
                    },
                    withStreamInfo: function(e, t) {
                        return this.extraStreamInfo[e] = t, this.mergeStreamInfo(), this;
                    },
                    mergeStreamInfo: function() {
                        for(var e in this.extraStreamInfo)Object.prototype.hasOwnProperty.call(this.extraStreamInfo, e) && (this.streamInfo[e] = this.extraStreamInfo[e]);
                    },
                    lock: function() {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.isLocked = !0, this.previous && this.previous.lock();
                    },
                    toString: function() {
                        var e = "Worker " + this.name;
                        return this.previous ? this.previous + " -> " + e : e;
                    }
                }, t.exports = n;
            },
            {}
        ],
        29: [
            function(e, t, r) {
                "use strict";
                var h = e("../utils"), i = e("./ConvertWorker"), s = e("./GenericWorker"), u = e("../base64"), n = e("../support"), a = e("../external"), o = null;
                if (n.nodestream) try {
                    o = e("../nodejs/NodejsStreamOutputAdapter");
                } catch (e) {}
                function l(e, o) {
                    return new a.Promise(function(t, r) {
                        var n = [], i = e._internalType, s = e._outputType, a = e._mimeType;
                        e.on("data", function(e, t) {
                            n.push(e), o && o(t);
                        }).on("error", function(e) {
                            n = [], r(e);
                        }).on("end", function() {
                            try {
                                var e = function(e, t, r) {
                                    switch(e){
                                        case "blob":
                                            return h.newBlob(h.transformTo("arraybuffer", t), r);
                                        case "base64":
                                            return u.encode(t);
                                        default:
                                            return h.transformTo(e, t);
                                    }
                                }(s, function(e, t) {
                                    var r, n = 0, i = null, s = 0;
                                    for(r = 0; r < t.length; r++)s += t[r].length;
                                    switch(e){
                                        case "string":
                                            return t.join("");
                                        case "array":
                                            return Array.prototype.concat.apply([], t);
                                        case "uint8array":
                                            for(i = new Uint8Array(s), r = 0; r < t.length; r++)i.set(t[r], n), n += t[r].length;
                                            return i;
                                        case "nodebuffer":
                                            return $ff323866fb43afa6$require$Buffer.concat(t);
                                        default:
                                            throw new Error("concat : unsupported type '" + e + "'");
                                    }
                                }(i, n), a);
                                t(e);
                            } catch (e) {
                                r(e);
                            }
                            n = [];
                        }).resume();
                    });
                }
                function f(e, t, r) {
                    var n = t;
                    switch(t){
                        case "blob":
                        case "arraybuffer":
                            n = "uint8array";
                            break;
                        case "base64":
                            n = "string";
                    }
                    try {
                        this._internalType = n, this._outputType = t, this._mimeType = r, h.checkSupport(n), this._worker = e.pipe(new i(n)), e.lock();
                    } catch (e) {
                        this._worker = new s("error"), this._worker.error(e);
                    }
                }
                f.prototype = {
                    accumulate: function(e) {
                        return l(this, e);
                    },
                    on: function(e, t) {
                        var r = this;
                        return "data" === e ? this._worker.on(e, function(e) {
                            t.call(r, e.data, e.meta);
                        }) : this._worker.on(e, function() {
                            h.delay(t, arguments, r);
                        }), this;
                    },
                    resume: function() {
                        return h.delay(this._worker.resume, [], this._worker), this;
                    },
                    pause: function() {
                        return this._worker.pause(), this;
                    },
                    toNodejsStream: function(e) {
                        if (h.checkSupport("nodestream"), "nodebuffer" !== this._outputType) throw new Error(this._outputType + " is not supported by this method");
                        return new o(this, {
                            objectMode: "nodebuffer" !== this._outputType
                        }, e);
                    }
                }, t.exports = f;
            },
            {
                "../base64": 1,
                "../external": 6,
                "../nodejs/NodejsStreamOutputAdapter": 13,
                "../support": 30,
                "../utils": 32,
                "./ConvertWorker": 24,
                "./GenericWorker": 28
            }
        ],
        30: [
            function(e, t, r) {
                "use strict";
                if (r.base64 = !0, r.array = !0, r.string = !0, r.arraybuffer = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, r.nodebuffer = "undefined" != typeof $ff323866fb43afa6$require$Buffer, r.uint8array = "undefined" != typeof Uint8Array, "undefined" == typeof ArrayBuffer) r.blob = !1;
                else {
                    var n = new ArrayBuffer(0);
                    try {
                        r.blob = 0 === new Blob([
                            n
                        ], {
                            type: "application/zip"
                        }).size;
                    } catch (e) {
                        try {
                            var i = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            i.append(n), r.blob = 0 === i.getBlob("application/zip").size;
                        } catch (e) {
                            r.blob = !1;
                        }
                    }
                }
                try {
                    r.nodestream = !!e("readable-stream").Readable;
                } catch (e) {
                    r.nodestream = !1;
                }
            },
            {
                "readable-stream": 16
            }
        ],
        31: [
            function(e, t, s) {
                "use strict";
                for(var o = e("./utils"), h = e("./support"), r = e("./nodejsUtils"), n = e("./stream/GenericWorker"), u = new Array(256), i = 0; i < 256; i++)u[i] = 252 <= i ? 6 : 248 <= i ? 5 : 240 <= i ? 4 : 224 <= i ? 3 : 192 <= i ? 2 : 1;
                u[254] = u[254] = 1;
                function a() {
                    n.call(this, "utf-8 decode"), this.leftOver = null;
                }
                function l() {
                    n.call(this, "utf-8 encode");
                }
                s.utf8encode = function(e) {
                    return h.nodebuffer ? r.newBufferFrom(e, "utf-8") : function(e) {
                        var t, r, n, i, s, a = e.length, o = 0;
                        for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                        for(t = h.uint8array ? new Uint8Array(o) : new Array(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                        return t;
                    }(e);
                }, s.utf8decode = function(e) {
                    return h.nodebuffer ? o.transformTo("nodebuffer", e).toString("utf-8") : function(e) {
                        var t, r, n, i, s = e.length, a = new Array(2 * s);
                        for(t = r = 0; t < s;)if ((n = e[t++]) < 128) a[r++] = n;
                        else if (4 < (i = u[n])) a[r++] = 65533, t += i - 1;
                        else {
                            for(n &= 2 === i ? 31 : 3 === i ? 15 : 7; 1 < i && t < s;)n = n << 6 | 63 & e[t++], i--;
                            1 < i ? a[r++] = 65533 : n < 65536 ? a[r++] = n : (n -= 65536, a[r++] = 55296 | n >> 10 & 1023, a[r++] = 56320 | 1023 & n);
                        }
                        return a.length !== r && (a.subarray ? a = a.subarray(0, r) : a.length = r), o.applyFromCharCode(a);
                    }(e = o.transformTo(h.uint8array ? "uint8array" : "array", e));
                }, o.inherits(a, n), a.prototype.processChunk = function(e) {
                    var t = o.transformTo(h.uint8array ? "uint8array" : "array", e.data);
                    if (this.leftOver && this.leftOver.length) {
                        if (h.uint8array) {
                            var r = t;
                            (t = new Uint8Array(r.length + this.leftOver.length)).set(this.leftOver, 0), t.set(r, this.leftOver.length);
                        } else t = this.leftOver.concat(t);
                        this.leftOver = null;
                    }
                    var n = function(e, t) {
                        var r;
                        for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                        return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                    }(t), i = t;
                    n !== t.length && (h.uint8array ? (i = t.subarray(0, n), this.leftOver = t.subarray(n, t.length)) : (i = t.slice(0, n), this.leftOver = t.slice(n, t.length))), this.push({
                        data: s.utf8decode(i),
                        meta: e.meta
                    });
                }, a.prototype.flush = function() {
                    this.leftOver && this.leftOver.length && (this.push({
                        data: s.utf8decode(this.leftOver),
                        meta: {}
                    }), this.leftOver = null);
                }, s.Utf8DecodeWorker = a, o.inherits(l, n), l.prototype.processChunk = function(e) {
                    this.push({
                        data: s.utf8encode(e.data),
                        meta: e.meta
                    });
                }, s.Utf8EncodeWorker = l;
            },
            {
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./support": 30,
                "./utils": 32
            }
        ],
        32: [
            function(e, t, a) {
                "use strict";
                var o = e("./support"), h = e("./base64"), r = e("./nodejsUtils"), u = e("./external");
                function n(e) {
                    return e;
                }
                function l(e, t) {
                    for(var r = 0; r < e.length; ++r)t[r] = 255 & e.charCodeAt(r);
                    return t;
                }
                e("setimmediate"), a.newBlob = function(t, r) {
                    a.checkSupport("blob");
                    try {
                        return new Blob([
                            t
                        ], {
                            type: r
                        });
                    } catch (e) {
                        try {
                            var n = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            return n.append(t), n.getBlob(r);
                        } catch (e) {
                            throw new Error("Bug : can't construct the Blob.");
                        }
                    }
                };
                var i = {
                    stringifyByChunk: function(e, t, r) {
                        var n = [], i = 0, s = e.length;
                        if (s <= r) return String.fromCharCode.apply(null, e);
                        for(; i < s;)"array" === t || "nodebuffer" === t ? n.push(String.fromCharCode.apply(null, e.slice(i, Math.min(i + r, s)))) : n.push(String.fromCharCode.apply(null, e.subarray(i, Math.min(i + r, s)))), i += r;
                        return n.join("");
                    },
                    stringifyByChar: function(e) {
                        for(var t = "", r = 0; r < e.length; r++)t += String.fromCharCode(e[r]);
                        return t;
                    },
                    applyCanBeUsed: {
                        uint8array: function() {
                            try {
                                return o.uint8array && 1 === String.fromCharCode.apply(null, new Uint8Array(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }(),
                        nodebuffer: function() {
                            try {
                                return o.nodebuffer && 1 === String.fromCharCode.apply(null, r.allocBuffer(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }()
                    }
                };
                function s(e) {
                    var t = 65536, r = a.getTypeOf(e), n = !0;
                    if ("uint8array" === r ? n = i.applyCanBeUsed.uint8array : "nodebuffer" === r && (n = i.applyCanBeUsed.nodebuffer), n) for(; 1 < t;)try {
                        return i.stringifyByChunk(e, r, t);
                    } catch (e) {
                        t = Math.floor(t / 2);
                    }
                    return i.stringifyByChar(e);
                }
                function f(e, t) {
                    for(var r = 0; r < e.length; r++)t[r] = e[r];
                    return t;
                }
                a.applyFromCharCode = s;
                var c = {};
                c.string = {
                    string: n,
                    array: function(e) {
                        return l(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.string.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return l(e, new Uint8Array(e.length));
                    },
                    nodebuffer: function(e) {
                        return l(e, r.allocBuffer(e.length));
                    }
                }, c.array = {
                    string: s,
                    array: n,
                    arraybuffer: function(e) {
                        return new Uint8Array(e).buffer;
                    },
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.arraybuffer = {
                    string: function(e) {
                        return s(new Uint8Array(e));
                    },
                    array: function(e) {
                        return f(new Uint8Array(e), new Array(e.byteLength));
                    },
                    arraybuffer: n,
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(new Uint8Array(e));
                    }
                }, c.uint8array = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return e.buffer;
                    },
                    uint8array: n,
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.nodebuffer = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.nodebuffer.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return f(e, new Uint8Array(e.length));
                    },
                    nodebuffer: n
                }, a.transformTo = function(e, t) {
                    if (t = t || "", !e) return t;
                    a.checkSupport(e);
                    var r = a.getTypeOf(t);
                    return c[r][e](t);
                }, a.resolve = function(e) {
                    for(var t = e.split("/"), r = [], n = 0; n < t.length; n++){
                        var i = t[n];
                        "." === i || "" === i && 0 !== n && n !== t.length - 1 || (".." === i ? r.pop() : r.push(i));
                    }
                    return r.join("/");
                }, a.getTypeOf = function(e) {
                    return "string" == typeof e ? "string" : "[object Array]" === Object.prototype.toString.call(e) ? "array" : o.nodebuffer && r.isBuffer(e) ? "nodebuffer" : o.uint8array && e instanceof Uint8Array ? "uint8array" : o.arraybuffer && e instanceof ArrayBuffer ? "arraybuffer" : void 0;
                }, a.checkSupport = function(e) {
                    if (!o[e.toLowerCase()]) throw new Error(e + " is not supported by this platform");
                }, a.MAX_VALUE_16BITS = 65535, a.MAX_VALUE_32BITS = -1, a.pretty = function(e) {
                    var t, r, n = "";
                    for(r = 0; r < (e || "").length; r++)n += "\\x" + ((t = e.charCodeAt(r)) < 16 ? "0" : "") + t.toString(16).toUpperCase();
                    return n;
                }, a.delay = function(e, t, r) {
                    setImmediate(function() {
                        e.apply(r || null, t || []);
                    });
                }, a.inherits = function(e, t) {
                    function r() {}
                    r.prototype = t.prototype, e.prototype = new r;
                }, a.extend = function() {
                    var e, t, r = {};
                    for(e = 0; e < arguments.length; e++)for(t in arguments[e])Object.prototype.hasOwnProperty.call(arguments[e], t) && void 0 === r[t] && (r[t] = arguments[e][t]);
                    return r;
                }, a.prepareContent = function(r, e, n, i, s) {
                    return u.Promise.resolve(e).then(function(n) {
                        return o.blob && (n instanceof Blob || -1 !== [
                            "[object File]",
                            "[object Blob]"
                        ].indexOf(Object.prototype.toString.call(n))) && "undefined" != typeof FileReader ? new u.Promise(function(t, r) {
                            var e = new FileReader;
                            e.onload = function(e) {
                                t(e.target.result);
                            }, e.onerror = function(e) {
                                r(e.target.error);
                            }, e.readAsArrayBuffer(n);
                        }) : n;
                    }).then(function(e) {
                        var t = a.getTypeOf(e);
                        return t ? ("arraybuffer" === t ? e = a.transformTo("uint8array", e) : "string" === t && (s ? e = h.decode(e) : n && !0 !== i && (e = function(e) {
                            return l(e, o.uint8array ? new Uint8Array(e.length) : new Array(e.length));
                        }(e))), e) : u.Promise.reject(new Error("Can't read the data of '" + r + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
                    });
                };
            },
            {
                "./base64": 1,
                "./external": 6,
                "./nodejsUtils": 14,
                "./support": 30,
                setimmediate: 54
            }
        ],
        33: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), i = e("./utils"), s = e("./signature"), a = e("./zipEntry"), o = e("./support");
                function h(e) {
                    this.files = [], this.loadOptions = e;
                }
                h.prototype = {
                    checkSignature: function(e) {
                        if (!this.reader.readAndCheckSignature(e)) {
                            this.reader.index -= 4;
                            var t = this.reader.readString(4);
                            throw new Error("Corrupted zip or bug: unexpected signature (" + i.pretty(t) + ", expected " + i.pretty(e) + ")");
                        }
                    },
                    isSignature: function(e, t) {
                        var r = this.reader.index;
                        this.reader.setIndex(e);
                        var n = this.reader.readString(4) === t;
                        return this.reader.setIndex(r), n;
                    },
                    readBlockEndOfCentral: function() {
                        this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
                        var e = this.reader.readData(this.zipCommentLength), t = o.uint8array ? "uint8array" : "array", r = i.transformTo(t, e);
                        this.zipComment = this.loadOptions.decodeFileName(r);
                    },
                    readBlockZip64EndOfCentral: function() {
                        this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
                        for(var e, t, r, n = this.zip64EndOfCentralSize - 44; 0 < n;)e = this.reader.readInt(2), t = this.reader.readInt(4), r = this.reader.readData(t), this.zip64ExtensibleData[e] = {
                            id: e,
                            length: t,
                            value: r
                        };
                    },
                    readBlockZip64EndOfCentralLocator: function() {
                        if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount) throw new Error("Multi-volumes zip are not supported");
                    },
                    readLocalFiles: function() {
                        var e, t;
                        for(e = 0; e < this.files.length; e++)t = this.files[e], this.reader.setIndex(t.localHeaderOffset), this.checkSignature(s.LOCAL_FILE_HEADER), t.readLocalPart(this.reader), t.handleUTF8(), t.processAttributes();
                    },
                    readCentralDir: function() {
                        var e;
                        for(this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER);)(e = new a({
                            zip64: this.zip64
                        }, this.loadOptions)).readCentralPart(this.reader), this.files.push(e);
                        if (this.centralDirRecords !== this.files.length && 0 !== this.centralDirRecords && 0 === this.files.length) throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
                    },
                    readEndOfCentral: function() {
                        var e = this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);
                        if (e < 0) throw !this.isSignature(0, s.LOCAL_FILE_HEADER) ? new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html") : new Error("Corrupted zip: can't find end of central directory");
                        this.reader.setIndex(e);
                        var t = e;
                        if (this.checkSignature(s.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === i.MAX_VALUE_16BITS || this.diskWithCentralDirStart === i.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === i.MAX_VALUE_16BITS || this.centralDirRecords === i.MAX_VALUE_16BITS || this.centralDirSize === i.MAX_VALUE_32BITS || this.centralDirOffset === i.MAX_VALUE_32BITS) {
                            if (this.zip64 = !0, (e = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
                            if (this.reader.setIndex(e), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, s.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0)) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
                            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
                        }
                        var r = this.centralDirOffset + this.centralDirSize;
                        this.zip64 && (r += 20, r += 12 + this.zip64EndOfCentralSize);
                        var n = t - r;
                        if (0 < n) this.isSignature(t, s.CENTRAL_FILE_HEADER) || (this.reader.zero = n);
                        else if (n < 0) throw new Error("Corrupted zip: missing " + Math.abs(n) + " bytes.");
                    },
                    prepareReader: function(e) {
                        this.reader = n(e);
                    },
                    load: function(e) {
                        this.prepareReader(e), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
                    }
                }, t.exports = h;
            },
            {
                "./reader/readerFor": 22,
                "./signature": 23,
                "./support": 30,
                "./utils": 32,
                "./zipEntry": 34
            }
        ],
        34: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), s = e("./utils"), i = e("./compressedObject"), a = e("./crc32"), o = e("./utf8"), h = e("./compressions"), u = e("./support");
                function l(e, t) {
                    this.options = e, this.loadOptions = t;
                }
                l.prototype = {
                    isEncrypted: function() {
                        return 1 == (1 & this.bitFlag);
                    },
                    useUTF8: function() {
                        return 2048 == (2048 & this.bitFlag);
                    },
                    readLocalPart: function(e) {
                        var t, r;
                        if (e.skip(22), this.fileNameLength = e.readInt(2), r = e.readInt(2), this.fileName = e.readData(this.fileNameLength), e.skip(r), -1 === this.compressedSize || -1 === this.uncompressedSize) throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
                        if (null === (t = function(e) {
                            for(var t in h)if (Object.prototype.hasOwnProperty.call(h, t) && h[t].magic === e) return h[t];
                            return null;
                        }(this.compressionMethod))) throw new Error("Corrupted zip : compression " + s.pretty(this.compressionMethod) + " unknown (inner file : " + s.transformTo("string", this.fileName) + ")");
                        this.decompressed = new i(this.compressedSize, this.uncompressedSize, this.crc32, t, e.readData(this.compressedSize));
                    },
                    readCentralPart: function(e) {
                        this.versionMadeBy = e.readInt(2), e.skip(2), this.bitFlag = e.readInt(2), this.compressionMethod = e.readString(2), this.date = e.readDate(), this.crc32 = e.readInt(4), this.compressedSize = e.readInt(4), this.uncompressedSize = e.readInt(4);
                        var t = e.readInt(2);
                        if (this.extraFieldsLength = e.readInt(2), this.fileCommentLength = e.readInt(2), this.diskNumberStart = e.readInt(2), this.internalFileAttributes = e.readInt(2), this.externalFileAttributes = e.readInt(4), this.localHeaderOffset = e.readInt(4), this.isEncrypted()) throw new Error("Encrypted zip are not supported");
                        e.skip(t), this.readExtraFields(e), this.parseZIP64ExtraField(e), this.fileComment = e.readData(this.fileCommentLength);
                    },
                    processAttributes: function() {
                        this.unixPermissions = null, this.dosPermissions = null;
                        var e = this.versionMadeBy >> 8;
                        this.dir = !!(16 & this.externalFileAttributes), 0 == e && (this.dosPermissions = 63 & this.externalFileAttributes), 3 == e && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || "/" !== this.fileNameStr.slice(-1) || (this.dir = !0);
                    },
                    parseZIP64ExtraField: function() {
                        if (this.extraFields[1]) {
                            var e = n(this.extraFields[1].value);
                            this.uncompressedSize === s.MAX_VALUE_32BITS && (this.uncompressedSize = e.readInt(8)), this.compressedSize === s.MAX_VALUE_32BITS && (this.compressedSize = e.readInt(8)), this.localHeaderOffset === s.MAX_VALUE_32BITS && (this.localHeaderOffset = e.readInt(8)), this.diskNumberStart === s.MAX_VALUE_32BITS && (this.diskNumberStart = e.readInt(4));
                        }
                    },
                    readExtraFields: function(e) {
                        var t, r, n, i = e.index + this.extraFieldsLength;
                        for(this.extraFields || (this.extraFields = {}); e.index + 4 < i;)t = e.readInt(2), r = e.readInt(2), n = e.readData(r), this.extraFields[t] = {
                            id: t,
                            length: r,
                            value: n
                        };
                        e.setIndex(i);
                    },
                    handleUTF8: function() {
                        var e = u.uint8array ? "uint8array" : "array";
                        if (this.useUTF8()) this.fileNameStr = o.utf8decode(this.fileName), this.fileCommentStr = o.utf8decode(this.fileComment);
                        else {
                            var t = this.findExtraFieldUnicodePath();
                            if (null !== t) this.fileNameStr = t;
                            else {
                                var r = s.transformTo(e, this.fileName);
                                this.fileNameStr = this.loadOptions.decodeFileName(r);
                            }
                            var n = this.findExtraFieldUnicodeComment();
                            if (null !== n) this.fileCommentStr = n;
                            else {
                                var i = s.transformTo(e, this.fileComment);
                                this.fileCommentStr = this.loadOptions.decodeFileName(i);
                            }
                        }
                    },
                    findExtraFieldUnicodePath: function() {
                        var e = this.extraFields[28789];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileName) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    },
                    findExtraFieldUnicodeComment: function() {
                        var e = this.extraFields[25461];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileComment) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    }
                }, t.exports = l;
            },
            {
                "./compressedObject": 2,
                "./compressions": 3,
                "./crc32": 4,
                "./reader/readerFor": 22,
                "./support": 30,
                "./utf8": 31,
                "./utils": 32
            }
        ],
        35: [
            function(e, t, r) {
                "use strict";
                function n(e, t, r) {
                    this.name = e, this.dir = r.dir, this.date = r.date, this.comment = r.comment, this.unixPermissions = r.unixPermissions, this.dosPermissions = r.dosPermissions, this._data = t, this._dataBinary = r.binary, this.options = {
                        compression: r.compression,
                        compressionOptions: r.compressionOptions
                    };
                }
                var s = e("./stream/StreamHelper"), i = e("./stream/DataWorker"), a = e("./utf8"), o = e("./compressedObject"), h = e("./stream/GenericWorker");
                n.prototype = {
                    internalStream: function(e) {
                        var t = null, r = "string";
                        try {
                            if (!e) throw new Error("No output type specified.");
                            var n = "string" === (r = e.toLowerCase()) || "text" === r;
                            "binarystring" !== r && "text" !== r || (r = "string"), t = this._decompressWorker();
                            var i = !this._dataBinary;
                            i && !n && (t = t.pipe(new a.Utf8EncodeWorker)), !i && n && (t = t.pipe(new a.Utf8DecodeWorker));
                        } catch (e) {
                            (t = new h("error")).error(e);
                        }
                        return new s(t, r, "");
                    },
                    async: function(e, t) {
                        return this.internalStream(e).accumulate(t);
                    },
                    nodeStream: function(e, t) {
                        return this.internalStream(e || "nodebuffer").toNodejsStream(t);
                    },
                    _compressWorker: function(e, t) {
                        if (this._data instanceof o && this._data.compression.magic === e.magic) return this._data.getCompressedWorker();
                        var r = this._decompressWorker();
                        return this._dataBinary || (r = r.pipe(new a.Utf8EncodeWorker)), o.createWorkerFrom(r, e, t);
                    },
                    _decompressWorker: function() {
                        return this._data instanceof o ? this._data.getContentWorker() : this._data instanceof h ? this._data : new i(this._data);
                    }
                };
                for(var u = [
                    "asText",
                    "asBinary",
                    "asNodeBuffer",
                    "asUint8Array",
                    "asArrayBuffer"
                ], l = function() {
                    throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                }, f = 0; f < u.length; f++)n.prototype[u[f]] = l;
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./stream/DataWorker": 27,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31
            }
        ],
        36: [
            function(e, l, t) {
                (function(t) {
                    "use strict";
                    var r, n, e = t.MutationObserver || t.WebKitMutationObserver;
                    if (e) {
                        var i = 0, s = new e(u), a = t.document.createTextNode("");
                        s.observe(a, {
                            characterData: !0
                        }), r = function() {
                            a.data = i = ++i % 2;
                        };
                    } else if (t.setImmediate || void 0 === t.MessageChannel) r = "document" in t && "onreadystatechange" in t.document.createElement("script") ? function() {
                        var e = t.document.createElement("script");
                        e.onreadystatechange = function() {
                            u(), e.onreadystatechange = null, e.parentNode.removeChild(e), e = null;
                        }, t.document.documentElement.appendChild(e);
                    } : function() {
                        setTimeout(u, 0);
                    };
                    else {
                        var o = new t.MessageChannel;
                        o.port1.onmessage = u, r = function() {
                            o.port2.postMessage(0);
                        };
                    }
                    var h = [];
                    function u() {
                        var e, t;
                        n = !0;
                        for(var r = h.length; r;){
                            for(t = h, h = [], e = -1; ++e < r;)t[e]();
                            r = h.length;
                        }
                        n = !1;
                    }
                    l.exports = function(e) {
                        1 !== h.push(e) || n || r();
                    };
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        37: [
            function(e, t, r) {
                "use strict";
                var i = e("immediate");
                function u() {}
                var l = {}, s = [
                    "REJECTED"
                ], a = [
                    "FULFILLED"
                ], n = [
                    "PENDING"
                ];
                function o(e) {
                    if ("function" != typeof e) throw new TypeError("resolver must be a function");
                    this.state = n, this.queue = [], this.outcome = void 0, e !== u && d(this, e);
                }
                function h(e, t, r) {
                    this.promise = e, "function" == typeof t && (this.onFulfilled = t, this.callFulfilled = this.otherCallFulfilled), "function" == typeof r && (this.onRejected = r, this.callRejected = this.otherCallRejected);
                }
                function f(t, r, n) {
                    i(function() {
                        var e;
                        try {
                            e = r(n);
                        } catch (e) {
                            return l.reject(t, e);
                        }
                        e === t ? l.reject(t, new TypeError("Cannot resolve promise with itself")) : l.resolve(t, e);
                    });
                }
                function c(e) {
                    var t = e && e.then;
                    if (e && ("object" == typeof e || "function" == typeof e) && "function" == typeof t) return function() {
                        t.apply(e, arguments);
                    };
                }
                function d(t, e) {
                    var r = !1;
                    function n(e) {
                        r || (r = !0, l.reject(t, e));
                    }
                    function i(e) {
                        r || (r = !0, l.resolve(t, e));
                    }
                    var s = p(function() {
                        e(i, n);
                    });
                    "error" === s.status && n(s.value);
                }
                function p(e, t) {
                    var r = {};
                    try {
                        r.value = e(t), r.status = "success";
                    } catch (e) {
                        r.status = "error", r.value = e;
                    }
                    return r;
                }
                (t.exports = o).prototype.finally = function(t) {
                    if ("function" != typeof t) return this;
                    var r = this.constructor;
                    return this.then(function(e) {
                        return r.resolve(t()).then(function() {
                            return e;
                        });
                    }, function(e) {
                        return r.resolve(t()).then(function() {
                            throw e;
                        });
                    });
                }, o.prototype.catch = function(e) {
                    return this.then(null, e);
                }, o.prototype.then = function(e, t) {
                    if ("function" != typeof e && this.state === a || "function" != typeof t && this.state === s) return this;
                    var r = new this.constructor(u);
                    this.state !== n ? f(r, this.state === a ? e : t, this.outcome) : this.queue.push(new h(r, e, t));
                    return r;
                }, h.prototype.callFulfilled = function(e) {
                    l.resolve(this.promise, e);
                }, h.prototype.otherCallFulfilled = function(e) {
                    f(this.promise, this.onFulfilled, e);
                }, h.prototype.callRejected = function(e) {
                    l.reject(this.promise, e);
                }, h.prototype.otherCallRejected = function(e) {
                    f(this.promise, this.onRejected, e);
                }, l.resolve = function(e, t) {
                    var r = p(c, t);
                    if ("error" === r.status) return l.reject(e, r.value);
                    var n = r.value;
                    if (n) d(e, n);
                    else {
                        e.state = a, e.outcome = t;
                        for(var i = -1, s = e.queue.length; ++i < s;)e.queue[i].callFulfilled(t);
                    }
                    return e;
                }, l.reject = function(e, t) {
                    e.state = s, e.outcome = t;
                    for(var r = -1, n = e.queue.length; ++r < n;)e.queue[r].callRejected(t);
                    return e;
                }, o.resolve = function(e) {
                    if (e instanceof this) return e;
                    return l.resolve(new this(u), e);
                }, o.reject = function(e) {
                    var t = new this(u);
                    return l.reject(t, e);
                }, o.all = function(e) {
                    var r = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var n = e.length, i = !1;
                    if (!n) return this.resolve([]);
                    var s = new Array(n), a = 0, t = -1, o = new this(u);
                    for(; ++t < n;)h(e[t], t);
                    return o;
                    function h(e, t) {
                        r.resolve(e).then(function(e) {
                            s[t] = e, ++a !== n || i || (i = !0, l.resolve(o, s));
                        }, function(e) {
                            i || (i = !0, l.reject(o, e));
                        });
                    }
                }, o.race = function(e) {
                    var t = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var r = e.length, n = !1;
                    if (!r) return this.resolve([]);
                    var i = -1, s = new this(u);
                    for(; ++i < r;)a = e[i], t.resolve(a).then(function(e) {
                        n || (n = !0, l.resolve(s, e));
                    }, function(e) {
                        n || (n = !0, l.reject(s, e));
                    });
                    var a;
                    return s;
                };
            },
            {
                immediate: 36
            }
        ],
        38: [
            function(e, t, r) {
                "use strict";
                var n = {};
                (0, e("./lib/utils/common").assign)(n, e("./lib/deflate"), e("./lib/inflate"), e("./lib/zlib/constants")), t.exports = n;
            },
            {
                "./lib/deflate": 39,
                "./lib/inflate": 40,
                "./lib/utils/common": 41,
                "./lib/zlib/constants": 44
            }
        ],
        39: [
            function(e, t, r) {
                "use strict";
                var a = e("./zlib/deflate"), o = e("./utils/common"), h = e("./utils/strings"), i = e("./zlib/messages"), s = e("./zlib/zstream"), u = Object.prototype.toString, l = 0, f = -1, c = 0, d = 8;
                function p(e) {
                    if (!(this instanceof p)) return new p(e);
                    this.options = o.assign({
                        level: f,
                        method: d,
                        chunkSize: 16384,
                        windowBits: 15,
                        memLevel: 8,
                        strategy: c,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 < t.windowBits ? t.windowBits = -t.windowBits : t.gzip && 0 < t.windowBits && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new s, this.strm.avail_out = 0;
                    var r = a.deflateInit2(this.strm, t.level, t.method, t.windowBits, t.memLevel, t.strategy);
                    if (r !== l) throw new Error(i[r]);
                    if (t.header && a.deflateSetHeader(this.strm, t.header), t.dictionary) {
                        var n;
                        if (n = "string" == typeof t.dictionary ? h.string2buf(t.dictionary) : "[object ArrayBuffer]" === u.call(t.dictionary) ? new Uint8Array(t.dictionary) : t.dictionary, (r = a.deflateSetDictionary(this.strm, n)) !== l) throw new Error(i[r]);
                        this._dict_set = !0;
                    }
                }
                function n(e, t) {
                    var r = new p(t);
                    if (r.push(e, !0), r.err) throw r.msg || i[r.err];
                    return r.result;
                }
                p.prototype.push = function(e, t) {
                    var r, n, i = this.strm, s = this.options.chunkSize;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? 4 : 0, "string" == typeof e ? i.input = h.string2buf(e) : "[object ArrayBuffer]" === u.call(e) ? i.input = new Uint8Array(e) : i.input = e, i.next_in = 0, i.avail_in = i.input.length;
                    do {
                        if (0 === i.avail_out && (i.output = new o.Buf8(s), i.next_out = 0, i.avail_out = s), 1 !== (r = a.deflate(i, n)) && r !== l) return this.onEnd(r), this.ended = !0, false;
                        0 !== i.avail_out && (0 !== i.avail_in || 4 !== n && 2 !== n) || ("string" === this.options.to ? this.onData(h.buf2binstring(o.shrinkBuf(i.output, i.next_out))) : this.onData(o.shrinkBuf(i.output, i.next_out)));
                    }while ((0 < i.avail_in || 0 === i.avail_out) && 1 !== r);
                    return 4 === n ? (r = a.deflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === l) : 2 !== n || (this.onEnd(l), i.avail_out = 0, true);
                }, p.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, p.prototype.onEnd = function(e) {
                    e === l && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = o.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Deflate = p, r.deflate = n, r.deflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, n(e, t);
                }, r.gzip = function(e, t) {
                    return (t = t || {}).gzip = !0, n(e, t);
                };
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/deflate": 46,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        40: [
            function(e, t, r) {
                "use strict";
                var c = e("./zlib/inflate"), d = e("./utils/common"), p = e("./utils/strings"), m = e("./zlib/constants"), n = e("./zlib/messages"), i = e("./zlib/zstream"), s = e("./zlib/gzheader"), _ = Object.prototype.toString;
                function a(e) {
                    if (!(this instanceof a)) return new a(e);
                    this.options = d.assign({
                        chunkSize: 16384,
                        windowBits: 0,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 <= t.windowBits && t.windowBits < 16 && (t.windowBits = -t.windowBits, 0 === t.windowBits && (t.windowBits = -15)), !(0 <= t.windowBits && t.windowBits < 16) || e && e.windowBits || (t.windowBits += 32), 15 < t.windowBits && t.windowBits < 48 && 0 == (15 & t.windowBits) && (t.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new i, this.strm.avail_out = 0;
                    var r = c.inflateInit2(this.strm, t.windowBits);
                    if (r !== m.Z_OK) throw new Error(n[r]);
                    this.header = new s, c.inflateGetHeader(this.strm, this.header);
                }
                function o(e, t) {
                    var r = new a(t);
                    if (r.push(e, !0), r.err) throw r.msg || n[r.err];
                    return r.result;
                }
                a.prototype.push = function(e, t) {
                    var r, n, i, s, a, o, h = this.strm, u = this.options.chunkSize, l = this.options.dictionary, f = !1;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? m.Z_FINISH : m.Z_NO_FLUSH, "string" == typeof e ? h.input = p.binstring2buf(e) : "[object ArrayBuffer]" === _.call(e) ? h.input = new Uint8Array(e) : h.input = e, h.next_in = 0, h.avail_in = h.input.length;
                    do {
                        if (0 === h.avail_out && (h.output = new d.Buf8(u), h.next_out = 0, h.avail_out = u), (r = c.inflate(h, m.Z_NO_FLUSH)) === m.Z_NEED_DICT && l && (o = "string" == typeof l ? p.string2buf(l) : "[object ArrayBuffer]" === _.call(l) ? new Uint8Array(l) : l, r = c.inflateSetDictionary(this.strm, o)), r === m.Z_BUF_ERROR && !0 === f && (r = m.Z_OK, f = !1), r !== m.Z_STREAM_END && r !== m.Z_OK) return this.onEnd(r), this.ended = !0, false;
                        h.next_out && (0 !== h.avail_out && r !== m.Z_STREAM_END && (0 !== h.avail_in || n !== m.Z_FINISH && n !== m.Z_SYNC_FLUSH) || ("string" === this.options.to ? (i = p.utf8border(h.output, h.next_out), s = h.next_out - i, a = p.buf2string(h.output, i), h.next_out = s, h.avail_out = u - s, s && d.arraySet(h.output, h.output, i, s, 0), this.onData(a)) : this.onData(d.shrinkBuf(h.output, h.next_out)))), 0 === h.avail_in && 0 === h.avail_out && (f = !0);
                    }while ((0 < h.avail_in || 0 === h.avail_out) && r !== m.Z_STREAM_END);
                    return r === m.Z_STREAM_END && (n = m.Z_FINISH), n === m.Z_FINISH ? (r = c.inflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === m.Z_OK) : n !== m.Z_SYNC_FLUSH || (this.onEnd(m.Z_OK), h.avail_out = 0, true);
                }, a.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, a.prototype.onEnd = function(e) {
                    e === m.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = d.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Inflate = a, r.inflate = o, r.inflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, o(e, t);
                }, r.ungzip = o;
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/constants": 44,
                "./zlib/gzheader": 47,
                "./zlib/inflate": 49,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        41: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
                r.assign = function(e) {
                    for(var t = Array.prototype.slice.call(arguments, 1); t.length;){
                        var r = t.shift();
                        if (r) {
                            if ("object" != typeof r) throw new TypeError(r + "must be non-object");
                            for(var n in r)r.hasOwnProperty(n) && (e[n] = r[n]);
                        }
                    }
                    return e;
                }, r.shrinkBuf = function(e, t) {
                    return e.length === t ? e : e.subarray ? e.subarray(0, t) : (e.length = t, e);
                };
                var i = {
                    arraySet: function(e, t, r, n, i) {
                        if (t.subarray && e.subarray) e.set(t.subarray(r, r + n), i);
                        else for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        var t, r, n, i, s, a;
                        for(t = n = 0, r = e.length; t < r; t++)n += e[t].length;
                        for(a = new Uint8Array(n), t = i = 0, r = e.length; t < r; t++)s = e[t], a.set(s, i), i += s.length;
                        return a;
                    }
                }, s = {
                    arraySet: function(e, t, r, n, i) {
                        for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        return [].concat.apply([], e);
                    }
                };
                r.setTyped = function(e) {
                    e ? (r.Buf8 = Uint8Array, r.Buf16 = Uint16Array, r.Buf32 = Int32Array, r.assign(r, i)) : (r.Buf8 = Array, r.Buf16 = Array, r.Buf32 = Array, r.assign(r, s));
                }, r.setTyped(n);
            },
            {}
        ],
        42: [
            function(e, t, r) {
                "use strict";
                var h = e("./common"), i = !0, s = !0;
                try {
                    String.fromCharCode.apply(null, [
                        0
                    ]);
                } catch (e) {
                    i = !1;
                }
                try {
                    String.fromCharCode.apply(null, new Uint8Array(1));
                } catch (e) {
                    s = !1;
                }
                for(var u = new h.Buf8(256), n = 0; n < 256; n++)u[n] = 252 <= n ? 6 : 248 <= n ? 5 : 240 <= n ? 4 : 224 <= n ? 3 : 192 <= n ? 2 : 1;
                function l(e, t) {
                    if (t < 65537 && (e.subarray && s || !e.subarray && i)) return String.fromCharCode.apply(null, h.shrinkBuf(e, t));
                    for(var r = "", n = 0; n < t; n++)r += String.fromCharCode(e[n]);
                    return r;
                }
                u[254] = u[254] = 1, r.string2buf = function(e) {
                    var t, r, n, i, s, a = e.length, o = 0;
                    for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                    for(t = new h.Buf8(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                    return t;
                }, r.buf2binstring = function(e) {
                    return l(e, e.length);
                }, r.binstring2buf = function(e) {
                    for(var t = new h.Buf8(e.length), r = 0, n = t.length; r < n; r++)t[r] = e.charCodeAt(r);
                    return t;
                }, r.buf2string = function(e, t) {
                    var r, n, i, s, a = t || e.length, o = new Array(2 * a);
                    for(r = n = 0; r < a;)if ((i = e[r++]) < 128) o[n++] = i;
                    else if (4 < (s = u[i])) o[n++] = 65533, r += s - 1;
                    else {
                        for(i &= 2 === s ? 31 : 3 === s ? 15 : 7; 1 < s && r < a;)i = i << 6 | 63 & e[r++], s--;
                        1 < s ? o[n++] = 65533 : i < 65536 ? o[n++] = i : (i -= 65536, o[n++] = 55296 | i >> 10 & 1023, o[n++] = 56320 | 1023 & i);
                    }
                    return l(o, n);
                }, r.utf8border = function(e, t) {
                    var r;
                    for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                    return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                };
            },
            {
                "./common": 41
            }
        ],
        43: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t, r, n) {
                    for(var i = 65535 & e | 0, s = e >>> 16 & 65535 | 0, a = 0; 0 !== r;){
                        for(r -= a = 2e3 < r ? 2e3 : r; s = s + (i = i + t[n++] | 0) | 0, --a;);
                        i %= 65521, s %= 65521;
                    }
                    return i | s << 16 | 0;
                };
            },
            {}
        ],
        44: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    Z_NO_FLUSH: 0,
                    Z_PARTIAL_FLUSH: 1,
                    Z_SYNC_FLUSH: 2,
                    Z_FULL_FLUSH: 3,
                    Z_FINISH: 4,
                    Z_BLOCK: 5,
                    Z_TREES: 6,
                    Z_OK: 0,
                    Z_STREAM_END: 1,
                    Z_NEED_DICT: 2,
                    Z_ERRNO: -1,
                    Z_STREAM_ERROR: -2,
                    Z_DATA_ERROR: -3,
                    Z_BUF_ERROR: -5,
                    Z_NO_COMPRESSION: 0,
                    Z_BEST_SPEED: 1,
                    Z_BEST_COMPRESSION: 9,
                    Z_DEFAULT_COMPRESSION: -1,
                    Z_FILTERED: 1,
                    Z_HUFFMAN_ONLY: 2,
                    Z_RLE: 3,
                    Z_FIXED: 4,
                    Z_DEFAULT_STRATEGY: 0,
                    Z_BINARY: 0,
                    Z_TEXT: 1,
                    Z_UNKNOWN: 2,
                    Z_DEFLATED: 8
                };
            },
            {}
        ],
        45: [
            function(e, t, r) {
                "use strict";
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t, r, n) {
                    var i = o, s = n + r;
                    e ^= -1;
                    for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                    return -1 ^ e;
                };
            },
            {}
        ],
        46: [
            function(e, t, r) {
                "use strict";
                var h, c = e("../utils/common"), u = e("./trees"), d = e("./adler32"), p = e("./crc32"), n = e("./messages"), l = 0, f = 4, m = 0, _ = -2, g = -1, b = 4, i = 2, v = 8, y = 9, s = 286, a = 30, o = 19, w = 2 * s + 1, k = 15, x = 3, S = 258, z = S + x + 1, C = 42, E = 113, A = 1, I = 2, O = 3, B = 4;
                function R(e, t) {
                    return e.msg = n[t], t;
                }
                function T(e) {
                    return (e << 1) - (4 < e ? 9 : 0);
                }
                function D(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                function F(e) {
                    var t = e.state, r = t.pending;
                    r > e.avail_out && (r = e.avail_out), 0 !== r && (c.arraySet(e.output, t.pending_buf, t.pending_out, r, e.next_out), e.next_out += r, t.pending_out += r, e.total_out += r, e.avail_out -= r, t.pending -= r, 0 === t.pending && (t.pending_out = 0));
                }
                function N(e, t) {
                    u._tr_flush_block(e, 0 <= e.block_start ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, F(e.strm);
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = t;
                }
                function P(e, t) {
                    e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = 255 & t;
                }
                function L(e, t) {
                    var r, n, i = e.max_chain_length, s = e.strstart, a = e.prev_length, o = e.nice_match, h = e.strstart > e.w_size - z ? e.strstart - (e.w_size - z) : 0, u = e.window, l = e.w_mask, f = e.prev, c = e.strstart + S, d = u[s + a - 1], p = u[s + a];
                    e.prev_length >= e.good_match && (i >>= 2), o > e.lookahead && (o = e.lookahead);
                    do if (u[(r = t) + a] === p && u[r + a - 1] === d && u[r] === u[s] && u[++r] === u[s + 1]) {
                        s += 2, r++;
                        do ;
                        while (u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && s < c);
                        if (n = S - (c - s), s = c - S, a < n) {
                            if (e.match_start = t, o <= (a = n)) break;
                            d = u[s + a - 1], p = u[s + a];
                        }
                    }
                    while ((t = f[t & l]) > h && 0 != --i);
                    return a <= e.lookahead ? a : e.lookahead;
                }
                function j(e) {
                    var t, r, n, i, s, a, o, h, u, l, f = e.w_size;
                    do {
                        if (i = e.window_size - e.lookahead - e.strstart, e.strstart >= f + (f - z)) {
                            for(c.arraySet(e.window, e.window, f, f, 0), e.match_start -= f, e.strstart -= f, e.block_start -= f, t = r = e.hash_size; n = e.head[--t], e.head[t] = f <= n ? n - f : 0, --r;);
                            for(t = r = f; n = e.prev[--t], e.prev[t] = f <= n ? n - f : 0, --r;);
                            i += f;
                        }
                        if (0 === e.strm.avail_in) break;
                        if (a = e.strm, o = e.window, h = e.strstart + e.lookahead, u = i, l = void 0, l = a.avail_in, u < l && (l = u), r = 0 === l ? 0 : (a.avail_in -= l, c.arraySet(o, a.input, a.next_in, l, h), 1 === a.state.wrap ? a.adler = d(a.adler, o, l, h) : 2 === a.state.wrap && (a.adler = p(a.adler, o, l, h)), a.next_in += l, a.total_in += l, l), e.lookahead += r, e.lookahead + e.insert >= x) for(s = e.strstart - e.insert, e.ins_h = e.window[s], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + 1]) & e.hash_mask; e.insert && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + x - 1]) & e.hash_mask, e.prev[s & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = s, s++, e.insert--, !(e.lookahead + e.insert < x)););
                    }while (e.lookahead < z && 0 !== e.strm.avail_in);
                }
                function Z(e, t) {
                    for(var r, n;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 !== r && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r)), e.match_length >= x) {
                            if (n = u._tr_tally(e, e.strstart - e.match_start, e.match_length - x), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= x) {
                                for(e.match_length--; e.strstart++, e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart, 0 != --e.match_length;);
                                e.strstart++;
                            } else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 1]) & e.hash_mask;
                        } else n = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
                        if (n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                    }
                    return e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function W(e, t) {
                    for(var r, n, i;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = x - 1, 0 !== r && e.prev_length < e.max_lazy_match && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r), e.match_length <= 5 && (1 === e.strategy || e.match_length === x && 4096 < e.strstart - e.match_start) && (e.match_length = x - 1)), e.prev_length >= x && e.match_length <= e.prev_length) {
                            for(i = e.strstart + e.lookahead - x, n = u._tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - x), e.lookahead -= e.prev_length - 1, e.prev_length -= 2; ++e.strstart <= i && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 != --e.prev_length;);
                            if (e.match_available = 0, e.match_length = x - 1, e.strstart++, n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        } else if (e.match_available) {
                            if ((n = u._tr_tally(e, 0, e.window[e.strstart - 1])) && N(e, !1), e.strstart++, e.lookahead--, 0 === e.strm.avail_out) return A;
                        } else e.match_available = 1, e.strstart++, e.lookahead--;
                    }
                    return e.match_available && (n = u._tr_tally(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function M(e, t, r, n, i) {
                    this.good_length = e, this.max_lazy = t, this.nice_length = r, this.max_chain = n, this.func = i;
                }
                function H() {
                    this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = v, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new c.Buf16(2 * w), this.dyn_dtree = new c.Buf16(2 * (2 * a + 1)), this.bl_tree = new c.Buf16(2 * (2 * o + 1)), D(this.dyn_ltree), D(this.dyn_dtree), D(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new c.Buf16(k + 1), this.heap = new c.Buf16(2 * s + 1), D(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new c.Buf16(2 * s + 1), D(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
                }
                function G(e) {
                    var t;
                    return e && e.state ? (e.total_in = e.total_out = 0, e.data_type = i, (t = e.state).pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = t.wrap ? C : E, e.adler = 2 === t.wrap ? 0 : 1, t.last_flush = l, u._tr_init(t), m) : R(e, _);
                }
                function K(e) {
                    var t = G(e);
                    return t === m && function(e) {
                        e.window_size = 2 * e.w_size, D(e.head), e.max_lazy_match = h[e.level].max_lazy, e.good_match = h[e.level].good_length, e.nice_match = h[e.level].nice_length, e.max_chain_length = h[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = x - 1, e.match_available = 0, e.ins_h = 0;
                    }(e.state), t;
                }
                function Y(e, t, r, n, i, s) {
                    if (!e) return _;
                    var a = 1;
                    if (t === g && (t = 6), n < 0 ? (a = 0, n = -n) : 15 < n && (a = 2, n -= 16), i < 1 || y < i || r !== v || n < 8 || 15 < n || t < 0 || 9 < t || s < 0 || b < s) return R(e, _);
                    8 === n && (n = 9);
                    var o = new H;
                    return (e.state = o).strm = e, o.wrap = a, o.gzhead = null, o.w_bits = n, o.w_size = 1 << o.w_bits, o.w_mask = o.w_size - 1, o.hash_bits = i + 7, o.hash_size = 1 << o.hash_bits, o.hash_mask = o.hash_size - 1, o.hash_shift = ~~((o.hash_bits + x - 1) / x), o.window = new c.Buf8(2 * o.w_size), o.head = new c.Buf16(o.hash_size), o.prev = new c.Buf16(o.w_size), o.lit_bufsize = 1 << i + 6, o.pending_buf_size = 4 * o.lit_bufsize, o.pending_buf = new c.Buf8(o.pending_buf_size), o.d_buf = 1 * o.lit_bufsize, o.l_buf = 3 * o.lit_bufsize, o.level = t, o.strategy = s, o.method = r, K(e);
                }
                h = [
                    new M(0, 0, 0, 0, function(e, t) {
                        var r = 65535;
                        for(r > e.pending_buf_size - 5 && (r = e.pending_buf_size - 5);;){
                            if (e.lookahead <= 1) {
                                if (j(e), 0 === e.lookahead && t === l) return A;
                                if (0 === e.lookahead) break;
                            }
                            e.strstart += e.lookahead, e.lookahead = 0;
                            var n = e.block_start + r;
                            if ((0 === e.strstart || e.strstart >= n) && (e.lookahead = e.strstart - n, e.strstart = n, N(e, !1), 0 === e.strm.avail_out)) return A;
                            if (e.strstart - e.block_start >= e.w_size - z && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        }
                        return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : (e.strstart > e.block_start && (N(e, !1), e.strm.avail_out), A);
                    }),
                    new M(4, 4, 8, 4, Z),
                    new M(4, 5, 16, 8, Z),
                    new M(4, 6, 32, 32, Z),
                    new M(4, 4, 16, 16, W),
                    new M(8, 16, 32, 32, W),
                    new M(8, 16, 128, 128, W),
                    new M(8, 32, 128, 256, W),
                    new M(32, 128, 258, 1024, W),
                    new M(32, 258, 258, 4096, W)
                ], r.deflateInit = function(e, t) {
                    return Y(e, t, v, 15, 8, 0);
                }, r.deflateInit2 = Y, r.deflateReset = K, r.deflateResetKeep = G, r.deflateSetHeader = function(e, t) {
                    return e && e.state ? 2 !== e.state.wrap ? _ : (e.state.gzhead = t, m) : _;
                }, r.deflate = function(e, t) {
                    var r, n, i, s;
                    if (!e || !e.state || 5 < t || t < 0) return e ? R(e, _) : _;
                    if (n = e.state, !e.output || !e.input && 0 !== e.avail_in || 666 === n.status && t !== f) return R(e, 0 === e.avail_out ? -5 : _);
                    if (n.strm = e, r = n.last_flush, n.last_flush = t, n.status === C) {
                        if (2 === n.wrap) e.adler = 0, U(n, 31), U(n, 139), U(n, 8), n.gzhead ? (U(n, (n.gzhead.text ? 1 : 0) + (n.gzhead.hcrc ? 2 : 0) + (n.gzhead.extra ? 4 : 0) + (n.gzhead.name ? 8 : 0) + (n.gzhead.comment ? 16 : 0)), U(n, 255 & n.gzhead.time), U(n, n.gzhead.time >> 8 & 255), U(n, n.gzhead.time >> 16 & 255), U(n, n.gzhead.time >> 24 & 255), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 255 & n.gzhead.os), n.gzhead.extra && n.gzhead.extra.length && (U(n, 255 & n.gzhead.extra.length), U(n, n.gzhead.extra.length >> 8 & 255)), n.gzhead.hcrc && (e.adler = p(e.adler, n.pending_buf, n.pending, 0)), n.gzindex = 0, n.status = 69) : (U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 3), n.status = E);
                        else {
                            var a = v + (n.w_bits - 8 << 4) << 8;
                            a |= (2 <= n.strategy || n.level < 2 ? 0 : n.level < 6 ? 1 : 6 === n.level ? 2 : 3) << 6, 0 !== n.strstart && (a |= 32), a += 31 - a % 31, n.status = E, P(n, a), 0 !== n.strstart && (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), e.adler = 1;
                        }
                    }
                    if (69 === n.status) {
                        if (n.gzhead.extra) {
                            for(i = n.pending; n.gzindex < (65535 & n.gzhead.extra.length) && (n.pending !== n.pending_buf_size || (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending !== n.pending_buf_size));)U(n, 255 & n.gzhead.extra[n.gzindex]), n.gzindex++;
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), n.gzindex === n.gzhead.extra.length && (n.gzindex = 0, n.status = 73);
                        } else n.status = 73;
                    }
                    if (73 === n.status) {
                        if (n.gzhead.name) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.name.length ? 255 & n.gzhead.name.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.gzindex = 0, n.status = 91);
                        } else n.status = 91;
                    }
                    if (91 === n.status) {
                        if (n.gzhead.comment) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.comment.length ? 255 & n.gzhead.comment.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.status = 103);
                        } else n.status = 103;
                    }
                    if (103 === n.status && (n.gzhead.hcrc ? (n.pending + 2 > n.pending_buf_size && F(e), n.pending + 2 <= n.pending_buf_size && (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), e.adler = 0, n.status = E)) : n.status = E), 0 !== n.pending) {
                        if (F(e), 0 === e.avail_out) return n.last_flush = -1, m;
                    } else if (0 === e.avail_in && T(t) <= T(r) && t !== f) return R(e, -5);
                    if (666 === n.status && 0 !== e.avail_in) return R(e, -5);
                    if (0 !== e.avail_in || 0 !== n.lookahead || t !== l && 666 !== n.status) {
                        var o = 2 === n.strategy ? function(e, t) {
                            for(var r;;){
                                if (0 === e.lookahead && (j(e), 0 === e.lookahead)) {
                                    if (t === l) return A;
                                    break;
                                }
                                if (e.match_length = 0, r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : 3 === n.strategy ? function(e, t) {
                            for(var r, n, i, s, a = e.window;;){
                                if (e.lookahead <= S) {
                                    if (j(e), e.lookahead <= S && t === l) return A;
                                    if (0 === e.lookahead) break;
                                }
                                if (e.match_length = 0, e.lookahead >= x && 0 < e.strstart && (n = a[i = e.strstart - 1]) === a[++i] && n === a[++i] && n === a[++i]) {
                                    s = e.strstart + S;
                                    do ;
                                    while (n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && i < s);
                                    e.match_length = S - (s - i), e.match_length > e.lookahead && (e.match_length = e.lookahead);
                                }
                                if (e.match_length >= x ? (r = u._tr_tally(e, 1, e.match_length - x), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : h[n.level].func(n, t);
                        if (o !== O && o !== B || (n.status = 666), o === A || o === O) return 0 === e.avail_out && (n.last_flush = -1), m;
                        if (o === I && (1 === t ? u._tr_align(n) : 5 !== t && (u._tr_stored_block(n, 0, 0, !1), 3 === t && (D(n.head), 0 === n.lookahead && (n.strstart = 0, n.block_start = 0, n.insert = 0))), F(e), 0 === e.avail_out)) return n.last_flush = -1, m;
                    }
                    return t !== f ? m : n.wrap <= 0 ? 1 : (2 === n.wrap ? (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), U(n, e.adler >> 16 & 255), U(n, e.adler >> 24 & 255), U(n, 255 & e.total_in), U(n, e.total_in >> 8 & 255), U(n, e.total_in >> 16 & 255), U(n, e.total_in >> 24 & 255)) : (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), F(e), 0 < n.wrap && (n.wrap = -n.wrap), 0 !== n.pending ? m : 1);
                }, r.deflateEnd = function(e) {
                    var t;
                    return e && e.state ? (t = e.state.status) !== C && 69 !== t && 73 !== t && 91 !== t && 103 !== t && t !== E && 666 !== t ? R(e, _) : (e.state = null, t === E ? R(e, -3) : m) : _;
                }, r.deflateSetDictionary = function(e, t) {
                    var r, n, i, s, a, o, h, u, l = t.length;
                    if (!e || !e.state) return _;
                    if (2 === (s = (r = e.state).wrap) || 1 === s && r.status !== C || r.lookahead) return _;
                    for(1 === s && (e.adler = d(e.adler, t, l, 0)), r.wrap = 0, l >= r.w_size && (0 === s && (D(r.head), r.strstart = 0, r.block_start = 0, r.insert = 0), u = new c.Buf8(r.w_size), c.arraySet(u, t, l - r.w_size, r.w_size, 0), t = u, l = r.w_size), a = e.avail_in, o = e.next_in, h = e.input, e.avail_in = l, e.next_in = 0, e.input = t, j(r); r.lookahead >= x;){
                        for(n = r.strstart, i = r.lookahead - (x - 1); r.ins_h = (r.ins_h << r.hash_shift ^ r.window[n + x - 1]) & r.hash_mask, r.prev[n & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = n, n++, --i;);
                        r.strstart = n, r.lookahead = x - 1, j(r);
                    }
                    return r.strstart += r.lookahead, r.block_start = r.strstart, r.insert = r.lookahead, r.lookahead = 0, r.match_length = r.prev_length = x - 1, r.match_available = 0, e.next_in = o, e.input = h, e.avail_in = a, r.wrap = s, m;
                }, r.deflateInfo = "pako deflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./messages": 51,
                "./trees": 52
            }
        ],
        47: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
                };
            },
            {}
        ],
        48: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C;
                    r = e.state, n = e.next_in, z = e.input, i = n + (e.avail_in - 5), s = e.next_out, C = e.output, a = s - (t - e.avail_out), o = s + (e.avail_out - 257), h = r.dmax, u = r.wsize, l = r.whave, f = r.wnext, c = r.window, d = r.hold, p = r.bits, m = r.lencode, _ = r.distcode, g = (1 << r.lenbits) - 1, b = (1 << r.distbits) - 1;
                    e: do {
                        p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = m[d & g];
                        t: for(;;){
                            if (d >>>= y = v >>> 24, p -= y, 0 === (y = v >>> 16 & 255)) C[s++] = 65535 & v;
                            else {
                                if (!(16 & y)) {
                                    if (0 == (64 & y)) {
                                        v = m[(65535 & v) + (d & (1 << y) - 1)];
                                        continue t;
                                    }
                                    if (32 & y) {
                                        r.mode = 12;
                                        break e;
                                    }
                                    e.msg = "invalid literal/length code", r.mode = 30;
                                    break e;
                                }
                                w = 65535 & v, (y &= 15) && (p < y && (d += z[n++] << p, p += 8), w += d & (1 << y) - 1, d >>>= y, p -= y), p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = _[d & b];
                                r: for(;;){
                                    if (d >>>= y = v >>> 24, p -= y, !(16 & (y = v >>> 16 & 255))) {
                                        if (0 == (64 & y)) {
                                            v = _[(65535 & v) + (d & (1 << y) - 1)];
                                            continue r;
                                        }
                                        e.msg = "invalid distance code", r.mode = 30;
                                        break e;
                                    }
                                    if (k = 65535 & v, p < (y &= 15) && (d += z[n++] << p, (p += 8) < y && (d += z[n++] << p, p += 8)), h < (k += d & (1 << y) - 1)) {
                                        e.msg = "invalid distance too far back", r.mode = 30;
                                        break e;
                                    }
                                    if (d >>>= y, p -= y, (y = s - a) < k) {
                                        if (l < (y = k - y) && r.sane) {
                                            e.msg = "invalid distance too far back", r.mode = 30;
                                            break e;
                                        }
                                        if (S = c, (x = 0) === f) {
                                            if (x += u - y, y < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                x = s - k, S = C;
                                            }
                                        } else if (f < y) {
                                            if (x += u + f - y, (y -= f) < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                if (x = 0, f < w) {
                                                    for(w -= y = f; C[s++] = c[x++], --y;);
                                                    x = s - k, S = C;
                                                }
                                            }
                                        } else if (x += f - y, y < w) {
                                            for(w -= y; C[s++] = c[x++], --y;);
                                            x = s - k, S = C;
                                        }
                                        for(; 2 < w;)C[s++] = S[x++], C[s++] = S[x++], C[s++] = S[x++], w -= 3;
                                        w && (C[s++] = S[x++], 1 < w && (C[s++] = S[x++]));
                                    } else {
                                        for(x = s - k; C[s++] = C[x++], C[s++] = C[x++], C[s++] = C[x++], 2 < (w -= 3););
                                        w && (C[s++] = C[x++], 1 < w && (C[s++] = C[x++]));
                                    }
                                    break;
                                }
                            }
                            break;
                        }
                    }while (n < i && s < o);
                    n -= w = p >> 3, d &= (1 << (p -= w << 3)) - 1, e.next_in = n, e.next_out = s, e.avail_in = n < i ? i - n + 5 : 5 - (n - i), e.avail_out = s < o ? o - s + 257 : 257 - (s - o), r.hold = d, r.bits = p;
                };
            },
            {}
        ],
        49: [
            function(e, t, r) {
                "use strict";
                var I = e("../utils/common"), O = e("./adler32"), B = e("./crc32"), R = e("./inffast"), T = e("./inftrees"), D = 1, F = 2, N = 0, U = -2, P = 1, n = 852, i = 592;
                function L(e) {
                    return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
                }
                function s() {
                    this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new I.Buf16(320), this.work = new I.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
                }
                function a(e) {
                    var t;
                    return e && e.state ? (t = e.state, e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = 1 & t.wrap), t.mode = P, t.last = 0, t.havedict = 0, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new I.Buf32(n), t.distcode = t.distdyn = new I.Buf32(i), t.sane = 1, t.back = -1, N) : U;
                }
                function o(e) {
                    var t;
                    return e && e.state ? ((t = e.state).wsize = 0, t.whave = 0, t.wnext = 0, a(e)) : U;
                }
                function h(e, t) {
                    var r, n;
                    return e && e.state ? (n = e.state, t < 0 ? (r = 0, t = -t) : (r = 1 + (t >> 4), t < 48 && (t &= 15)), t && (t < 8 || 15 < t) ? U : (null !== n.window && n.wbits !== t && (n.window = null), n.wrap = r, n.wbits = t, o(e))) : U;
                }
                function u(e, t) {
                    var r, n;
                    return e ? (n = new s, (e.state = n).window = null, (r = h(e, t)) !== N && (e.state = null), r) : U;
                }
                var l, f, c = !0;
                function j(e) {
                    if (c) {
                        var t;
                        for(l = new I.Buf32(512), f = new I.Buf32(32), t = 0; t < 144;)e.lens[t++] = 8;
                        for(; t < 256;)e.lens[t++] = 9;
                        for(; t < 280;)e.lens[t++] = 7;
                        for(; t < 288;)e.lens[t++] = 8;
                        for(T(D, e.lens, 0, 288, l, 0, e.work, {
                            bits: 9
                        }), t = 0; t < 32;)e.lens[t++] = 5;
                        T(F, e.lens, 0, 32, f, 0, e.work, {
                            bits: 5
                        }), c = !1;
                    }
                    e.lencode = l, e.lenbits = 9, e.distcode = f, e.distbits = 5;
                }
                function Z(e, t, r, n) {
                    var i, s = e.state;
                    return null === s.window && (s.wsize = 1 << s.wbits, s.wnext = 0, s.whave = 0, s.window = new I.Buf8(s.wsize)), n >= s.wsize ? (I.arraySet(s.window, t, r - s.wsize, s.wsize, 0), s.wnext = 0, s.whave = s.wsize) : (n < (i = s.wsize - s.wnext) && (i = n), I.arraySet(s.window, t, r - n, i, s.wnext), (n -= i) ? (I.arraySet(s.window, t, r - n, n, 0), s.wnext = n, s.whave = s.wsize) : (s.wnext += i, s.wnext === s.wsize && (s.wnext = 0), s.whave < s.wsize && (s.whave += i))), 0;
                }
                r.inflateReset = o, r.inflateReset2 = h, r.inflateResetKeep = a, r.inflateInit = function(e) {
                    return u(e, 15);
                }, r.inflateInit2 = u, r.inflate = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C = 0, E = new I.Buf8(4), A = [
                        16,
                        17,
                        18,
                        0,
                        8,
                        7,
                        9,
                        6,
                        10,
                        5,
                        11,
                        4,
                        12,
                        3,
                        13,
                        2,
                        14,
                        1,
                        15
                    ];
                    if (!e || !e.state || !e.output || !e.input && 0 !== e.avail_in) return U;
                    12 === (r = e.state).mode && (r.mode = 13), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, f = o, c = h, x = N;
                    e: for(;;)switch(r.mode){
                        case P:
                            if (0 === r.wrap) {
                                r.mode = 13;
                                break;
                            }
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (2 & r.wrap && 35615 === u) {
                                E[r.check = 0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0), l = u = 0, r.mode = 2;
                                break;
                            }
                            if (r.flags = 0, r.head && (r.head.done = !1), !(1 & r.wrap) || (((255 & u) << 8) + (u >> 8)) % 31) {
                                e.msg = "incorrect header check", r.mode = 30;
                                break;
                            }
                            if (8 != (15 & u)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (l -= 4, k = 8 + (15 & (u >>>= 4)), 0 === r.wbits) r.wbits = k;
                            else if (k > r.wbits) {
                                e.msg = "invalid window size", r.mode = 30;
                                break;
                            }
                            r.dmax = 1 << k, e.adler = r.check = 1, r.mode = 512 & u ? 10 : 12, l = u = 0;
                            break;
                        case 2:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.flags = u, 8 != (255 & r.flags)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (57344 & r.flags) {
                                e.msg = "unknown header flags set", r.mode = 30;
                                break;
                            }
                            r.head && (r.head.text = u >> 8 & 1), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 3;
                        case 3:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.time = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, E[2] = u >>> 16 & 255, E[3] = u >>> 24 & 255, r.check = B(r.check, E, 4, 0)), l = u = 0, r.mode = 4;
                        case 4:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.xflags = 255 & u, r.head.os = u >> 8), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 5;
                        case 5:
                            if (1024 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length = u, r.head && (r.head.extra_len = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0;
                            } else r.head && (r.head.extra = null);
                            r.mode = 6;
                        case 6:
                            if (1024 & r.flags && (o < (d = r.length) && (d = o), d && (r.head && (k = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Array(r.head.extra_len)), I.arraySet(r.head.extra, n, s, d, k)), 512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, r.length -= d), r.length)) break e;
                            r.length = 0, r.mode = 7;
                        case 7:
                            if (2048 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.name += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.name = null);
                            r.length = 0, r.mode = 8;
                        case 8:
                            if (4096 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.comment += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.comment = null);
                            r.mode = 9;
                        case 9:
                            if (512 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (65535 & r.check)) {
                                    e.msg = "header crc mismatch", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), e.adler = r.check = 0, r.mode = 12;
                            break;
                        case 10:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            e.adler = r.check = L(u), l = u = 0, r.mode = 11;
                        case 11:
                            if (0 === r.havedict) return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, 2;
                            e.adler = r.check = 1, r.mode = 12;
                        case 12:
                            if (5 === t || 6 === t) break e;
                        case 13:
                            if (r.last) {
                                u >>>= 7 & l, l -= 7 & l, r.mode = 27;
                                break;
                            }
                            for(; l < 3;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            switch(r.last = 1 & u, l -= 1, 3 & (u >>>= 1)){
                                case 0:
                                    r.mode = 14;
                                    break;
                                case 1:
                                    if (j(r), r.mode = 20, 6 !== t) break;
                                    u >>>= 2, l -= 2;
                                    break e;
                                case 2:
                                    r.mode = 17;
                                    break;
                                case 3:
                                    e.msg = "invalid block type", r.mode = 30;
                            }
                            u >>>= 2, l -= 2;
                            break;
                        case 14:
                            for(u >>>= 7 & l, l -= 7 & l; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if ((65535 & u) != (u >>> 16 ^ 65535)) {
                                e.msg = "invalid stored block lengths", r.mode = 30;
                                break;
                            }
                            if (r.length = 65535 & u, l = u = 0, r.mode = 15, 6 === t) break e;
                        case 15:
                            r.mode = 16;
                        case 16:
                            if (d = r.length) {
                                if (o < d && (d = o), h < d && (d = h), 0 === d) break e;
                                I.arraySet(i, n, s, d, a), o -= d, s += d, h -= d, a += d, r.length -= d;
                                break;
                            }
                            r.mode = 12;
                            break;
                        case 17:
                            for(; l < 14;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.nlen = 257 + (31 & u), u >>>= 5, l -= 5, r.ndist = 1 + (31 & u), u >>>= 5, l -= 5, r.ncode = 4 + (15 & u), u >>>= 4, l -= 4, 286 < r.nlen || 30 < r.ndist) {
                                e.msg = "too many length or distance symbols", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 18;
                        case 18:
                            for(; r.have < r.ncode;){
                                for(; l < 3;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.lens[A[r.have++]] = 7 & u, u >>>= 3, l -= 3;
                            }
                            for(; r.have < 19;)r.lens[A[r.have++]] = 0;
                            if (r.lencode = r.lendyn, r.lenbits = 7, S = {
                                bits: r.lenbits
                            }, x = T(0, r.lens, 0, 19, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid code lengths set", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 19;
                        case 19:
                            for(; r.have < r.nlen + r.ndist;){
                                for(; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (b < 16) u >>>= _, l -= _, r.lens[r.have++] = b;
                                else {
                                    if (16 === b) {
                                        for(z = _ + 2; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        if (u >>>= _, l -= _, 0 === r.have) {
                                            e.msg = "invalid bit length repeat", r.mode = 30;
                                            break;
                                        }
                                        k = r.lens[r.have - 1], d = 3 + (3 & u), u >>>= 2, l -= 2;
                                    } else if (17 === b) {
                                        for(z = _ + 3; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 3 + (7 & (u >>>= _)), u >>>= 3, l -= 3;
                                    } else {
                                        for(z = _ + 7; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 11 + (127 & (u >>>= _)), u >>>= 7, l -= 7;
                                    }
                                    if (r.have + d > r.nlen + r.ndist) {
                                        e.msg = "invalid bit length repeat", r.mode = 30;
                                        break;
                                    }
                                    for(; d--;)r.lens[r.have++] = k;
                                }
                            }
                            if (30 === r.mode) break;
                            if (0 === r.lens[256]) {
                                e.msg = "invalid code -- missing end-of-block", r.mode = 30;
                                break;
                            }
                            if (r.lenbits = 9, S = {
                                bits: r.lenbits
                            }, x = T(D, r.lens, 0, r.nlen, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid literal/lengths set", r.mode = 30;
                                break;
                            }
                            if (r.distbits = 6, r.distcode = r.distdyn, S = {
                                bits: r.distbits
                            }, x = T(F, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, S), r.distbits = S.bits, x) {
                                e.msg = "invalid distances set", r.mode = 30;
                                break;
                            }
                            if (r.mode = 20, 6 === t) break e;
                        case 20:
                            r.mode = 21;
                        case 21:
                            if (6 <= o && 258 <= h) {
                                e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, R(e, c), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, 12 === r.mode && (r.back = -1);
                                break;
                            }
                            for(r.back = 0; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (g && 0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.lencode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, r.length = b, 0 === g) {
                                r.mode = 26;
                                break;
                            }
                            if (32 & g) {
                                r.back = -1, r.mode = 12;
                                break;
                            }
                            if (64 & g) {
                                e.msg = "invalid literal/length code", r.mode = 30;
                                break;
                            }
                            r.extra = 15 & g, r.mode = 22;
                        case 22:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            r.was = r.length, r.mode = 23;
                        case 23:
                            for(; g = (C = r.distcode[u & (1 << r.distbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.distcode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, 64 & g) {
                                e.msg = "invalid distance code", r.mode = 30;
                                break;
                            }
                            r.offset = b, r.extra = 15 & g, r.mode = 24;
                        case 24:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.offset += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            if (r.offset > r.dmax) {
                                e.msg = "invalid distance too far back", r.mode = 30;
                                break;
                            }
                            r.mode = 25;
                        case 25:
                            if (0 === h) break e;
                            if (d = c - h, r.offset > d) {
                                if ((d = r.offset - d) > r.whave && r.sane) {
                                    e.msg = "invalid distance too far back", r.mode = 30;
                                    break;
                                }
                                p = d > r.wnext ? (d -= r.wnext, r.wsize - d) : r.wnext - d, d > r.length && (d = r.length), m = r.window;
                            } else m = i, p = a - r.offset, d = r.length;
                            for(h < d && (d = h), h -= d, r.length -= d; i[a++] = m[p++], --d;);
                            0 === r.length && (r.mode = 21);
                            break;
                        case 26:
                            if (0 === h) break e;
                            i[a++] = r.length, h--, r.mode = 21;
                            break;
                        case 27:
                            if (r.wrap) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u |= n[s++] << l, l += 8;
                                }
                                if (c -= h, e.total_out += c, r.total += c, c && (e.adler = r.check = r.flags ? B(r.check, i, c, a - c) : O(r.check, i, c, a - c)), c = h, (r.flags ? u : L(u)) !== r.check) {
                                    e.msg = "incorrect data check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 28;
                        case 28:
                            if (r.wrap && r.flags) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (4294967295 & r.total)) {
                                    e.msg = "incorrect length check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 29;
                        case 29:
                            x = 1;
                            break e;
                        case 30:
                            x = -3;
                            break e;
                        case 31:
                            return -4;
                        case 32:
                        default:
                            return U;
                    }
                    return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, (r.wsize || c !== e.avail_out && r.mode < 30 && (r.mode < 27 || 4 !== t)) && Z(e, e.output, e.next_out, c - e.avail_out) ? (r.mode = 31, -4) : (f -= e.avail_in, c -= e.avail_out, e.total_in += f, e.total_out += c, r.total += c, r.wrap && c && (e.adler = r.check = r.flags ? B(r.check, i, c, e.next_out - c) : O(r.check, i, c, e.next_out - c)), e.data_type = r.bits + (r.last ? 64 : 0) + (12 === r.mode ? 128 : 0) + (20 === r.mode || 15 === r.mode ? 256 : 0), (0 == f && 0 === c || 4 === t) && x === N && (x = -5), x);
                }, r.inflateEnd = function(e) {
                    if (!e || !e.state) return U;
                    var t = e.state;
                    return t.window && (t.window = null), e.state = null, N;
                }, r.inflateGetHeader = function(e, t) {
                    var r;
                    return e && e.state ? 0 == (2 & (r = e.state).wrap) ? U : ((r.head = t).done = !1, N) : U;
                }, r.inflateSetDictionary = function(e, t) {
                    var r, n = t.length;
                    return e && e.state ? 0 !== (r = e.state).wrap && 11 !== r.mode ? U : 11 === r.mode && O(1, t, n, 0) !== r.check ? -3 : Z(e, t, n, n) ? (r.mode = 31, -4) : (r.havedict = 1, N) : U;
                }, r.inflateInfo = "pako inflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./inffast": 48,
                "./inftrees": 50
            }
        ],
        50: [
            function(e, t, r) {
                "use strict";
                var D = e("../utils/common"), F = [
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    13,
                    15,
                    17,
                    19,
                    23,
                    27,
                    31,
                    35,
                    43,
                    51,
                    59,
                    67,
                    83,
                    99,
                    115,
                    131,
                    163,
                    195,
                    227,
                    258,
                    0,
                    0
                ], N = [
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    17,
                    17,
                    18,
                    18,
                    18,
                    18,
                    19,
                    19,
                    19,
                    19,
                    20,
                    20,
                    20,
                    20,
                    21,
                    21,
                    21,
                    21,
                    16,
                    72,
                    78
                ], U = [
                    1,
                    2,
                    3,
                    4,
                    5,
                    7,
                    9,
                    13,
                    17,
                    25,
                    33,
                    49,
                    65,
                    97,
                    129,
                    193,
                    257,
                    385,
                    513,
                    769,
                    1025,
                    1537,
                    2049,
                    3073,
                    4097,
                    6145,
                    8193,
                    12289,
                    16385,
                    24577,
                    0,
                    0
                ], P = [
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    18,
                    18,
                    19,
                    19,
                    20,
                    20,
                    21,
                    21,
                    22,
                    22,
                    23,
                    23,
                    24,
                    24,
                    25,
                    25,
                    26,
                    26,
                    27,
                    27,
                    28,
                    28,
                    29,
                    29,
                    64,
                    64
                ];
                t.exports = function(e, t, r, n, i, s, a, o) {
                    var h, u, l, f, c, d, p, m, _, g = o.bits, b = 0, v = 0, y = 0, w = 0, k = 0, x = 0, S = 0, z = 0, C = 0, E = 0, A = null, I = 0, O = new D.Buf16(16), B = new D.Buf16(16), R = null, T = 0;
                    for(b = 0; b <= 15; b++)O[b] = 0;
                    for(v = 0; v < n; v++)O[t[r + v]]++;
                    for(k = g, w = 15; 1 <= w && 0 === O[w]; w--);
                    if (w < k && (k = w), 0 === w) return i[s++] = 20971520, i[s++] = 20971520, o.bits = 1, 0;
                    for(y = 1; y < w && 0 === O[y]; y++);
                    for(k < y && (k = y), b = z = 1; b <= 15; b++)if (z <<= 1, (z -= O[b]) < 0) return -1;
                    if (0 < z && (0 === e || 1 !== w)) return -1;
                    for(B[1] = 0, b = 1; b < 15; b++)B[b + 1] = B[b] + O[b];
                    for(v = 0; v < n; v++)0 !== t[r + v] && (a[B[t[r + v]]++] = v);
                    if (d = 0 === e ? (A = R = a, 19) : 1 === e ? (A = F, I -= 257, R = N, T -= 257, 256) : (A = U, R = P, -1), b = y, c = s, S = v = E = 0, l = -1, f = (C = 1 << (x = k)) - 1, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                    for(;;){
                        for(p = b - S, _ = a[v] < d ? (m = 0, a[v]) : a[v] > d ? (m = R[T + a[v]], A[I + a[v]]) : (m = 96, 0), h = 1 << b - S, y = u = 1 << x; i[c + (E >> S) + (u -= h)] = p << 24 | m << 16 | _ | 0, 0 !== u;);
                        for(h = 1 << b - 1; E & h;)h >>= 1;
                        if (0 !== h ? (E &= h - 1, E += h) : E = 0, v++, 0 == --O[b]) {
                            if (b === w) break;
                            b = t[r + a[v]];
                        }
                        if (k < b && (E & f) !== l) {
                            for(0 === S && (S = k), c += y, z = 1 << (x = b - S); x + S < w && !((z -= O[x + S]) <= 0);)x++, z <<= 1;
                            if (C += 1 << x, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                            i[l = E & f] = k << 24 | x << 16 | c - s | 0;
                        }
                    }
                    return 0 !== E && (i[c + E] = b - S << 24 | 4194304), o.bits = k, 0;
                };
            },
            {
                "../utils/common": 41
            }
        ],
        51: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    2: "need dictionary",
                    1: "stream end",
                    0: "",
                    "-1": "file error",
                    "-2": "stream error",
                    "-3": "data error",
                    "-4": "insufficient memory",
                    "-5": "buffer error",
                    "-6": "incompatible version"
                };
            },
            {}
        ],
        52: [
            function(e, t, r) {
                "use strict";
                var i = e("../utils/common"), o = 0, h = 1;
                function n(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                var s = 0, a = 29, u = 256, l = u + 1 + a, f = 30, c = 19, _ = 2 * l + 1, g = 15, d = 16, p = 7, m = 256, b = 16, v = 17, y = 18, w = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    3,
                    3,
                    3,
                    3,
                    4,
                    4,
                    4,
                    4,
                    5,
                    5,
                    5,
                    5,
                    0
                ], k = [
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    4,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    8,
                    8,
                    9,
                    9,
                    10,
                    10,
                    11,
                    11,
                    12,
                    12,
                    13,
                    13
                ], x = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    3,
                    7
                ], S = [
                    16,
                    17,
                    18,
                    0,
                    8,
                    7,
                    9,
                    6,
                    10,
                    5,
                    11,
                    4,
                    12,
                    3,
                    13,
                    2,
                    14,
                    1,
                    15
                ], z = new Array(2 * (l + 2));
                n(z);
                var C = new Array(2 * f);
                n(C);
                var E = new Array(512);
                n(E);
                var A = new Array(256);
                n(A);
                var I = new Array(a);
                n(I);
                var O, B, R, T = new Array(f);
                function D(e, t, r, n, i) {
                    this.static_tree = e, this.extra_bits = t, this.extra_base = r, this.elems = n, this.max_length = i, this.has_stree = e && e.length;
                }
                function F(e, t) {
                    this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
                }
                function N(e) {
                    return e < 256 ? E[e] : E[256 + (e >>> 7)];
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = 255 & t, e.pending_buf[e.pending++] = t >>> 8 & 255;
                }
                function P(e, t, r) {
                    e.bi_valid > d - r ? (e.bi_buf |= t << e.bi_valid & 65535, U(e, e.bi_buf), e.bi_buf = t >> d - e.bi_valid, e.bi_valid += r - d) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += r);
                }
                function L(e, t, r) {
                    P(e, r[2 * t], r[2 * t + 1]);
                }
                function j(e, t) {
                    for(var r = 0; r |= 1 & e, e >>>= 1, r <<= 1, 0 < --t;);
                    return r >>> 1;
                }
                function Z(e, t, r) {
                    var n, i, s = new Array(g + 1), a = 0;
                    for(n = 1; n <= g; n++)s[n] = a = a + r[n - 1] << 1;
                    for(i = 0; i <= t; i++){
                        var o = e[2 * i + 1];
                        0 !== o && (e[2 * i] = j(s[o]++, o));
                    }
                }
                function W(e) {
                    var t;
                    for(t = 0; t < l; t++)e.dyn_ltree[2 * t] = 0;
                    for(t = 0; t < f; t++)e.dyn_dtree[2 * t] = 0;
                    for(t = 0; t < c; t++)e.bl_tree[2 * t] = 0;
                    e.dyn_ltree[2 * m] = 1, e.opt_len = e.static_len = 0, e.last_lit = e.matches = 0;
                }
                function M(e) {
                    8 < e.bi_valid ? U(e, e.bi_buf) : 0 < e.bi_valid && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
                }
                function H(e, t, r, n) {
                    var i = 2 * t, s = 2 * r;
                    return e[i] < e[s] || e[i] === e[s] && n[t] <= n[r];
                }
                function G(e, t, r) {
                    for(var n = e.heap[r], i = r << 1; i <= e.heap_len && (i < e.heap_len && H(t, e.heap[i + 1], e.heap[i], e.depth) && i++, !H(t, n, e.heap[i], e.depth));)e.heap[r] = e.heap[i], r = i, i <<= 1;
                    e.heap[r] = n;
                }
                function K(e, t, r) {
                    var n, i, s, a, o = 0;
                    if (0 !== e.last_lit) for(; n = e.pending_buf[e.d_buf + 2 * o] << 8 | e.pending_buf[e.d_buf + 2 * o + 1], i = e.pending_buf[e.l_buf + o], o++, 0 === n ? L(e, i, t) : (L(e, (s = A[i]) + u + 1, t), 0 !== (a = w[s]) && P(e, i -= I[s], a), L(e, s = N(--n), r), 0 !== (a = k[s]) && P(e, n -= T[s], a)), o < e.last_lit;);
                    L(e, m, t);
                }
                function Y(e, t) {
                    var r, n, i, s = t.dyn_tree, a = t.stat_desc.static_tree, o = t.stat_desc.has_stree, h = t.stat_desc.elems, u = -1;
                    for(e.heap_len = 0, e.heap_max = _, r = 0; r < h; r++)0 !== s[2 * r] ? (e.heap[++e.heap_len] = u = r, e.depth[r] = 0) : s[2 * r + 1] = 0;
                    for(; e.heap_len < 2;)s[2 * (i = e.heap[++e.heap_len] = u < 2 ? ++u : 0)] = 1, e.depth[i] = 0, e.opt_len--, o && (e.static_len -= a[2 * i + 1]);
                    for(t.max_code = u, r = e.heap_len >> 1; 1 <= r; r--)G(e, s, r);
                    for(i = h; r = e.heap[1], e.heap[1] = e.heap[e.heap_len--], G(e, s, 1), n = e.heap[1], e.heap[--e.heap_max] = r, e.heap[--e.heap_max] = n, s[2 * i] = s[2 * r] + s[2 * n], e.depth[i] = (e.depth[r] >= e.depth[n] ? e.depth[r] : e.depth[n]) + 1, s[2 * r + 1] = s[2 * n + 1] = i, e.heap[1] = i++, G(e, s, 1), 2 <= e.heap_len;);
                    e.heap[--e.heap_max] = e.heap[1], function(e, t) {
                        var r, n, i, s, a, o, h = t.dyn_tree, u = t.max_code, l = t.stat_desc.static_tree, f = t.stat_desc.has_stree, c = t.stat_desc.extra_bits, d = t.stat_desc.extra_base, p = t.stat_desc.max_length, m = 0;
                        for(s = 0; s <= g; s++)e.bl_count[s] = 0;
                        for(h[2 * e.heap[e.heap_max] + 1] = 0, r = e.heap_max + 1; r < _; r++)p < (s = h[2 * h[2 * (n = e.heap[r]) + 1] + 1] + 1) && (s = p, m++), h[2 * n + 1] = s, u < n || (e.bl_count[s]++, a = 0, d <= n && (a = c[n - d]), o = h[2 * n], e.opt_len += o * (s + a), f && (e.static_len += o * (l[2 * n + 1] + a)));
                        if (0 !== m) {
                            do {
                                for(s = p - 1; 0 === e.bl_count[s];)s--;
                                e.bl_count[s]--, e.bl_count[s + 1] += 2, e.bl_count[p]--, m -= 2;
                            }while (0 < m);
                            for(s = p; 0 !== s; s--)for(n = e.bl_count[s]; 0 !== n;)u < (i = e.heap[--r]) || (h[2 * i + 1] !== s && (e.opt_len += (s - h[2 * i + 1]) * h[2 * i], h[2 * i + 1] = s), n--);
                        }
                    }(e, t), Z(s, u, e.bl_count);
                }
                function X(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), t[2 * (r + 1) + 1] = 65535, n = 0; n <= r; n++)i = a, a = t[2 * (n + 1) + 1], ++o < h && i === a || (o < u ? e.bl_tree[2 * i] += o : 0 !== i ? (i !== s && e.bl_tree[2 * i]++, e.bl_tree[2 * b]++) : o <= 10 ? e.bl_tree[2 * v]++ : e.bl_tree[2 * y]++, s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4));
                }
                function V(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), n = 0; n <= r; n++)if (i = a, a = t[2 * (n + 1) + 1], !(++o < h && i === a)) {
                        if (o < u) for(; L(e, i, e.bl_tree), 0 != --o;);
                        else 0 !== i ? (i !== s && (L(e, i, e.bl_tree), o--), L(e, b, e.bl_tree), P(e, o - 3, 2)) : o <= 10 ? (L(e, v, e.bl_tree), P(e, o - 3, 3)) : (L(e, y, e.bl_tree), P(e, o - 11, 7));
                        s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4);
                    }
                }
                n(T);
                var q = !1;
                function J(e, t, r, n) {
                    P(e, (s << 1) + (n ? 1 : 0), 3), function(e, t, r, n) {
                        M(e), n && (U(e, r), U(e, ~r)), i.arraySet(e.pending_buf, e.window, t, r, e.pending), e.pending += r;
                    }(e, t, r, !0);
                }
                r._tr_init = function(e) {
                    q || (function() {
                        var e, t, r, n, i, s = new Array(g + 1);
                        for(n = r = 0; n < a - 1; n++)for(I[n] = r, e = 0; e < 1 << w[n]; e++)A[r++] = n;
                        for(A[r - 1] = n, n = i = 0; n < 16; n++)for(T[n] = i, e = 0; e < 1 << k[n]; e++)E[i++] = n;
                        for(i >>= 7; n < f; n++)for(T[n] = i << 7, e = 0; e < 1 << k[n] - 7; e++)E[256 + i++] = n;
                        for(t = 0; t <= g; t++)s[t] = 0;
                        for(e = 0; e <= 143;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(; e <= 255;)z[2 * e + 1] = 9, e++, s[9]++;
                        for(; e <= 279;)z[2 * e + 1] = 7, e++, s[7]++;
                        for(; e <= 287;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(Z(z, l + 1, s), e = 0; e < f; e++)C[2 * e + 1] = 5, C[2 * e] = j(e, 5);
                        O = new D(z, w, u + 1, l, g), B = new D(C, k, 0, f, g), R = new D(new Array(0), x, 0, c, p);
                    }(), q = !0), e.l_desc = new F(e.dyn_ltree, O), e.d_desc = new F(e.dyn_dtree, B), e.bl_desc = new F(e.bl_tree, R), e.bi_buf = 0, e.bi_valid = 0, W(e);
                }, r._tr_stored_block = J, r._tr_flush_block = function(e, t, r, n) {
                    var i, s, a = 0;
                    0 < e.level ? (2 === e.strm.data_type && (e.strm.data_type = function(e) {
                        var t, r = 4093624447;
                        for(t = 0; t <= 31; t++, r >>>= 1)if (1 & r && 0 !== e.dyn_ltree[2 * t]) return o;
                        if (0 !== e.dyn_ltree[18] || 0 !== e.dyn_ltree[20] || 0 !== e.dyn_ltree[26]) return h;
                        for(t = 32; t < u; t++)if (0 !== e.dyn_ltree[2 * t]) return h;
                        return o;
                    }(e)), Y(e, e.l_desc), Y(e, e.d_desc), a = function(e) {
                        var t;
                        for(X(e, e.dyn_ltree, e.l_desc.max_code), X(e, e.dyn_dtree, e.d_desc.max_code), Y(e, e.bl_desc), t = c - 1; 3 <= t && 0 === e.bl_tree[2 * S[t] + 1]; t--);
                        return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
                    }(e), i = e.opt_len + 3 + 7 >>> 3, (s = e.static_len + 3 + 7 >>> 3) <= i && (i = s)) : i = s = r + 5, r + 4 <= i && -1 !== t ? J(e, t, r, n) : 4 === e.strategy || s === i ? (P(e, 2 + (n ? 1 : 0), 3), K(e, z, C)) : (P(e, 4 + (n ? 1 : 0), 3), function(e, t, r, n) {
                        var i;
                        for(P(e, t - 257, 5), P(e, r - 1, 5), P(e, n - 4, 4), i = 0; i < n; i++)P(e, e.bl_tree[2 * S[i] + 1], 3);
                        V(e, e.dyn_ltree, t - 1), V(e, e.dyn_dtree, r - 1);
                    }(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, a + 1), K(e, e.dyn_ltree, e.dyn_dtree)), W(e), n && M(e);
                }, r._tr_tally = function(e, t, r) {
                    return e.pending_buf[e.d_buf + 2 * e.last_lit] = t >>> 8 & 255, e.pending_buf[e.d_buf + 2 * e.last_lit + 1] = 255 & t, e.pending_buf[e.l_buf + e.last_lit] = 255 & r, e.last_lit++, 0 === t ? e.dyn_ltree[2 * r]++ : (e.matches++, t--, e.dyn_ltree[2 * (A[r] + u + 1)]++, e.dyn_dtree[2 * N(t)]++), e.last_lit === e.lit_bufsize - 1;
                }, r._tr_align = function(e) {
                    P(e, 2, 3), L(e, m, z), function(e) {
                        16 === e.bi_valid ? (U(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : 8 <= e.bi_valid && (e.pending_buf[e.pending++] = 255 & e.bi_buf, e.bi_buf >>= 8, e.bi_valid -= 8);
                    }(e);
                };
            },
            {
                "../utils/common": 41
            }
        ],
        53: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
                };
            },
            {}
        ],
        54: [
            function(e, t, r) {
                (function(e) {
                    !function(r, n) {
                        "use strict";
                        if (!r.setImmediate) {
                            var i, s, t, a, o = 1, h = {}, u = !1, l = r.document, e = Object.getPrototypeOf && Object.getPrototypeOf(r);
                            e = e && e.setTimeout ? e : r, i = "[object process]" === ({}).toString.call(r.process) ? function(e) {
                                $hPtJY.nextTick(function() {
                                    c(e);
                                });
                            } : function() {
                                if (r.postMessage && !r.importScripts) {
                                    var e = !0, t = r.onmessage;
                                    return r.onmessage = function() {
                                        e = !1;
                                    }, r.postMessage("", "*"), r.onmessage = t, e;
                                }
                            }() ? (a = "setImmediate$" + Math.random() + "$", r.addEventListener ? r.addEventListener("message", d, !1) : r.attachEvent("onmessage", d), function(e) {
                                r.postMessage(a + e, "*");
                            }) : r.MessageChannel ? ((t = new MessageChannel).port1.onmessage = function(e) {
                                c(e.data);
                            }, function(e) {
                                t.port2.postMessage(e);
                            }) : l && "onreadystatechange" in l.createElement("script") ? (s = l.documentElement, function(e) {
                                var t = l.createElement("script");
                                t.onreadystatechange = function() {
                                    c(e), t.onreadystatechange = null, s.removeChild(t), t = null;
                                }, s.appendChild(t);
                            }) : function(e) {
                                setTimeout(c, 0, e);
                            }, e.setImmediate = function(e) {
                                "function" != typeof e && (e = new Function("" + e));
                                for(var t = new Array(arguments.length - 1), r = 0; r < t.length; r++)t[r] = arguments[r + 1];
                                var n = {
                                    callback: e,
                                    args: t
                                };
                                return h[o] = n, i(o), o++;
                            }, e.clearImmediate = f;
                        }
                        function f(e) {
                            delete h[e];
                        }
                        function c(e) {
                            if (u) setTimeout(c, 0, e);
                            else {
                                var t = h[e];
                                if (t) {
                                    u = !0;
                                    try {
                                        !function(e) {
                                            var t = e.callback, r = e.args;
                                            switch(r.length){
                                                case 0:
                                                    t();
                                                    break;
                                                case 1:
                                                    t(r[0]);
                                                    break;
                                                case 2:
                                                    t(r[0], r[1]);
                                                    break;
                                                case 3:
                                                    t(r[0], r[1], r[2]);
                                                    break;
                                                default:
                                                    t.apply(n, r);
                                            }
                                        }(t);
                                    } finally{
                                        f(e), u = !1;
                                    }
                                }
                            }
                        }
                        function d(e) {
                            e.source === r && "string" == typeof e.data && 0 === e.data.indexOf(a) && c(+e.data.slice(a.length));
                        }
                    }("undefined" == typeof self ? void 0 === e ? this : e : self);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ]
    }, {}, [
        10
    ])(10);
});

});
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
var $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
var $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        var len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        var buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $51861dfc7ca9d588$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});



parcelRegister("7gAwr", function(module, exports) {

$parcel$export(module.exports, "ACTExportarExcel", () => $67231a6c899afdb8$export$6a098118b7287a21);

var $ayMG0 = parcelRequire("ayMG0");

var $9VIWE = parcelRequire("9VIWE");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $acw62 = parcelRequire("acw62");
const $67231a6c899afdb8$export$6d76997fc2058bf9 = ({ reportes: reportes, onClose: onClose })=>{
    const getReportes = (0, $49qEn.useExecuteProc)(reportes, reportes.def.procs.repo_qryReportes);
    const [datos0, setDatos0] = (0, $acw62.useState)();
    const { exportToExcel: exportToExcel } = (0, $49qEn.useExportToExcel)({
        data: [
            datos0
        ],
        dataResultNames: [
            'Base Reportes'
        ]
    });
    (0, $acw62.useEffect)(()=>{
        async function fetchData() {
            await getReportes.execute({
                c_cliente_id: reportes.def.columns.c_cliente_id.value,
                dt_fecha_desde: reportes.parentKeys.dt_fecha_desde,
                dt_fecha_hasta: reportes.parentKeys.dt_fecha_hasta,
                c_autorizacion_directa_status_id: reportes.parentKeys.c_autorizacion_directa_status_id,
                dt_fecha_realizado_desde: reportes.parentKeys.dt_fecha_realizado_desde,
                dt_fecha_realizado_hasta: reportes.parentKeys.dt_fecha_realizado_hasta
            });
        }
        fetchData();
    }, [
        reportes.def.columns.c_cliente_id.value,
        reportes.parentKeys.dt_fecha_desde,
        reportes.parentKeys.dt_fecha_hasta,
        reportes.parentKeys.c_autorizacion_directa_status_id,
        reportes.parentKeys.dt_fecha_realizado_desde,
        reportes.parentKeys.dt_fecha_realizado_hasta
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!getReportes.status.loading && getReportes.status.data) setDatos0(getReportes.status.data[0]);
    }, [
        getReportes.status
    ]);
    (0, $acw62.useEffect)(()=>{
        if (datos0) {
            exportToExcel();
            onClose();
        }
    }, [
        datos0
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9VIWE.Stack), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                children: "Generando archivo..."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.FakeProgressBar), {})
        ]
    });
};
const $67231a6c899afdb8$export$6a098118b7287a21 = {
    name: 'ACTExportarExcel',
    label: 'Exportar Excel',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Exportar Excel"
    }),
    refreshOnClose: true,
    dontRequireSelection: true,
    showActionInViewMode: true,
    views: [
        'repo_brwBaseReportesDetallada'
    ],
    onClick: async ({ entity: entity, modal: modal, element: element, onClose: onClose })=>{
        const reportes = entity;
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                    fw: "700",
                    children: "Exportar Excel"
                })
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)($67231a6c899afdb8$export$6d76997fc2058bf9, {
                reportes: reportes,
                onClose: ()=>modal.close()
            })
        });
        return false;
    }
};

});

parcelRegister("kSjlk", function(module, exports) {

$parcel$export(module.exports, "ACTExportarExcelConsolidado", () => $1e31dbb914e4aa45$export$be50a717308e6a07);

var $ayMG0 = parcelRequire("ayMG0");

var $gU5rH = parcelRequire("gU5rH");
var $9mTYo = parcelRequire("9mTYo");
var $9VIWE = parcelRequire("9VIWE");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $dRw7S = parcelRequire("dRw7S");

var $acw62 = parcelRequire("acw62");
const $1e31dbb914e4aa45$export$49954ba03a221611 = ({ reportes: reportes, onClose: onClose })=>{
    const proc = (0, $49qEn.useExecuteExportProc)(reportes, reportes.def.procs.repo_qryReportesDetallada);
    (0, $acw62.useEffect)(()=>{
        async function fetchData() {
            await proc.execute({
                c_cliente_id: reportes.def.columns.c_cliente_id.value,
                dt_fecha_desde: reportes.parentKeys.dt_fecha_desde,
                dt_fecha_hasta: reportes.parentKeys.dt_fecha_hasta,
                c_autorizacion_directa_status_id: reportes.parentKeys.c_autorizacion_directa_status_id,
                dt_fecha_realizado_desde: reportes.parentKeys.dt_fecha_realizado_desde,
                dt_fecha_realizado_hasta: reportes.parentKeys.dt_fecha_realizado_hasta
            });
        }
        fetchData();
    }, [
        reportes.def.columns.c_cliente_id.value,
        reportes.parentKeys.dt_fecha_desde,
        reportes.parentKeys.dt_fecha_hasta,
        reportes.parentKeys.c_autorizacion_directa_status_id,
        reportes.parentKeys.dt_fecha_realizado_desde,
        reportes.parentKeys.dt_fecha_realizado_hasta
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!proc.status.loading && proc.status.data) {
            reportes.API.downloadBlobFile(proc.status.data, `Reporte_Consolidado_${new Date().toISOString()}.xlsx`);
            onClose();
        }
    }, [
        proc.status
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9VIWE.Stack), {
        children: [
            proc.status.error && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $49qEn.AlertError), {
                mb: "xs",
                children: [
                    proc.status.error.status,
                    " ",
                    proc.status.error.message,
                    " ",
                    proc.status.error.statusMessage,
                    " ",
                    proc.status.error.status === 400 && proc.status.error.errorBody
                ]
            }),
            proc.status.loading && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        children: "Generando archivo..."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.FakeProgressBar), {})
                ]
            }),
            !proc.status.loading && proc.status.data && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                children: "Archivo exportado con \xe9xito..."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                mt: "xs",
                position: "right",
                children: [
                    proc.status.loading && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                        variant: "light",
                        leftIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dRw7S.default), {
                            size: "1.5rem"
                        }),
                        onClick: async ()=>{
                            await Promise.resolve(proc.abort());
                            onClose();
                        },
                        children: "Cancelar"
                    }),
                    !proc.status.loading && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                        variant: "light",
                        leftIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dRw7S.default), {
                            size: "1.5rem"
                        }),
                        onClick: async ()=>{
                            onClose();
                        },
                        children: "Cerrar"
                    })
                ]
            })
        ]
    });
};
const $1e31dbb914e4aa45$export$be50a717308e6a07 = {
    name: 'ACTExportarExcelConsolidado',
    label: 'Exportar Excel Consolidado',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Exportar Excel"
    }),
    refreshOnClose: true,
    dontRequireSelection: true,
    showActionInViewMode: true,
    views: [
        'repo_brwBaseReportesDetallada'
    ],
    onClick: async ({ entity: entity, modal: modal, element: element, onClose: onClose })=>{
        const reportes = entity;
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                    fw: "700",
                    children: "Exportar Excel"
                })
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)($1e31dbb914e4aa45$export$49954ba03a221611, {
                reportes: reportes,
                onClose: ()=>modal.close()
            })
        });
        return false;
    }
};

});

parcelRegister("ly0BV", function(module, exports) {

$parcel$export(module.exports, "ACTExportarExcelPorServicios", () => $8c12a2639efe8d2f$export$efa55bdbc1deca01);

var $ayMG0 = parcelRequire("ayMG0");

var $9VIWE = parcelRequire("9VIWE");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $acw62 = parcelRequire("acw62");
const $8c12a2639efe8d2f$export$1ca04ccf3c6b5219 = ({ reportes: reportes, onClose: onClose })=>{
    const getReportes = (0, $49qEn.useExecuteProc)(reportes, reportes.def.procs.repo_qryReportesPorServicio);
    const [datos0, setDatos0] = (0, $acw62.useState)();
    const [datos1, setDatos1] = (0, $acw62.useState)();
    const [datos2, setDatos2] = (0, $acw62.useState)();
    const { exportToExcel: exportToExcel } = (0, $49qEn.useExportToExcel)({
        data: [
            datos0,
            datos1,
            datos2
        ],
        dataResultNames: [
            'Hoja1',
            'Precios',
            'Novedades'
        ]
    });
    (0, $acw62.useEffect)(()=>{
        async function fetchData() {
            await getReportes.execute({
                c_cliente_id: reportes.def.columns.c_cliente_id.value,
                dt_fecha_desde: reportes.def.columns.dt_fecha_desde.value,
                dt_fecha_hasta: reportes.def.columns.dt_fecha_hasta.value,
                c_autorizacion_directa_status_id: reportes.def.columns.c_autorizacion_directa_status_id.value
            });
        }
        fetchData();
    }, [
        reportes.def.columns.c_cliente_id.value,
        reportes.def.columns.dt_fecha_desde.value,
        reportes.def.columns.dt_fecha_hasta.value,
        reportes.def.columns.c_autorizacion_directa_status_id.value
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!getReportes.status.loading && getReportes.status.data) {
            setDatos0(getReportes.status.data[0]);
            setDatos1(getReportes.status.data[1]);
            setDatos2(getReportes.status.data[2]);
        }
    }, [
        getReportes.status
    ]);
    (0, $acw62.useEffect)(()=>{
        if (datos0 && datos1 && datos2) {
            exportToExcel();
            onClose();
        }
    }, [
        datos0,
        datos1,
        datos2
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9VIWE.Stack), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                children: "Generando archivo..."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.FakeProgressBar), {})
        ]
    });
};
const $8c12a2639efe8d2f$export$efa55bdbc1deca01 = {
    name: 'ACTExportarExcelPorServicios',
    label: 'Exportar Excel por Servicios',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Exportar Excel"
    }),
    refreshOnClose: true,
    dontRequireSelection: true,
    showActionInViewMode: true,
    views: [],
    onClick: async ({ entity: entity, modal: modal, element: element, onClose: onClose })=>{
        const reportes = entity;
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                    fw: "700",
                    children: "Exportar Excel por Servicios"
                })
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)($8c12a2639efe8d2f$export$1ca04ccf3c6b5219, {
                reportes: reportes,
                onClose: ()=>modal.close()
            })
        });
        return false;
    }
};

});

parcelRegister("iaVJq", function(module, exports) {

$parcel$export(module.exports, "ACTExportarPdf", () => $631983b74b869f71$export$235d573ac42cb1a2);

var $ayMG0 = parcelRequire("ayMG0");

var $9VIWE = parcelRequire("9VIWE");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");
parcelRequire("01v82");
var $cGbw3 = parcelRequire("cGbw3");
var $gidDr = parcelRequire("gidDr");
var $i4gUC = parcelRequire("i4gUC");

var $acw62 = parcelRequire("acw62");

var $3OncY = parcelRequire("3OncY");

var $cWkOq = parcelRequire("cWkOq");
async function $631983b74b869f71$var$embedImageFromUrl(pdf, url) {
    try {
        const res = await fetch(url, {
            mode: 'cors',
            cache: 'no-store'
        });
        if (!res.ok) return undefined;
        const ct = (res.headers.get('content-type') || '').toLowerCase();
        const bytes = await res.arrayBuffer();
        if (ct.includes('png')) return await pdf.embedPng(bytes);
        if (ct.includes('jpeg') || ct.includes('jpg')) return await pdf.embedJpg(bytes);
        return undefined;
    } catch  {
        return undefined;
    }
}
async function $631983b74b869f71$var$buildPdf(dr) {
    const A4 = {
        w: 595,
        h: 842
    }, margin = 36, renglon = 24, headerH = 64;
    const pdf = await (0, $cGbw3.default).create();
    const font = await pdf.embedFont((0, $i4gUC.StandardFonts).Helvetica);
    const fontBold = await pdf.embedFont((0, $i4gUC.StandardFonts).HelveticaBold); // para “MTS”
    const headers = dr?.Header ?? [];
    const rows = dr?.records ?? [];
    const idxImagen = headers.includes('ValorImagen') ? headers.indexOf('ValorImagen') : 0;
    const idxCliente = headers.includes('Cliente') ? headers.indexOf('Cliente') : 0;
    const idxCadena = headers.includes('Cadena') ? headers.indexOf('Cadena') : 0;
    const idxTienda = headers.includes('Tienda') ? headers.indexOf('Tienda') : 0;
    const idxRealizado = headers.includes('FechaRealizado') ? headers.indexOf('FechaRealizado') : 0;
    const idxDomicilio = headers.includes('Domicilio') ? headers.indexOf('Domicilio') : 0;
    if (!rows.length) {
        const page = pdf.addPage([
            A4.w,
            A4.h
        ]);
        const titleY = A4.h - headerH - margin - 24;
        page.drawText('Sin datos', {
            x: margin,
            y: titleY,
            size: 18,
            font: font
        });
        return pdf.save();
    }
    const logoBytes = await fetch((0, (/*@__PURE__*/$parcel$interopDefault($cWkOq)))).then((r)=>r.arrayBuffer());
    const logoImg = await pdf.embedPng(logoBytes);
    const logoH = 40;
    const logoScale = logoH / logoImg.height;
    const logoW = logoImg.width * logoScale;
    for(let i = 0; i < rows.length; i++){
        const row = rows[i];
        const imagen = String(row[idxImagen] ?? '');
        const cliente = String(row[idxCliente] ?? '');
        const cadena = String(row[idxCadena] ?? '');
        const tienda = String(row[idxTienda] ?? '');
        const realizado = String(row[idxRealizado] ?? '');
        const domicilio = String(row[idxDomicilio] ?? '');
        const page = pdf.addPage([
            A4.w,
            A4.h
        ]);
        page.drawRectangle({
            x: 0,
            y: A4.h - headerH,
            width: A4.w,
            height: headerH,
            color: (0, $gidDr.rgb)(1, 0.6, 0)
        });
        const logoY = A4.h - headerH + (headerH - logoH) / 2;
        page.drawImage(logoImg, {
            x: margin,
            y: logoY,
            width: logoW,
            height: logoH
        });
        const titleY = A4.h - headerH - margin - 24;
        page.drawText(`Cliente: ${cliente}`, {
            x: margin,
            y: titleY,
            size: 12,
            font: font
        });
        page.drawText(`Tienda: ${cadena} - ${tienda}`, {
            x: margin,
            y: titleY - renglon,
            size: 12,
            font: font
        });
        page.drawText(`Domicilio: ${domicilio}`, {
            x: margin,
            y: titleY - renglon * 2,
            size: 12,
            font: font
        });
        page.drawText(`Fecha: ${realizado}`, {
            x: margin,
            y: titleY - renglon * 3,
            size: 12,
            font: font
        });
        const url_img = imagen ? `${0, $3OncY.API_URL}/${0, $3OncY.APP_ID}/serve/${imagen}` : '';
        let photoImg;
        if (imagen) photoImg = await $631983b74b869f71$var$embedImageFromUrl(pdf, url_img);
        const gap = 20;
        const imgTop = titleY - gap - renglon * 3;
        if (photoImg) {
            const maxW = A4.w - margin * 2, maxH = 420;
            const scale = Math.min(maxW / photoImg.width, maxH / photoImg.height);
            const imgW = photoImg.width * scale, imgH = photoImg.height * scale;
            page.drawImage(photoImg, {
                x: margin,
                y: imgTop - imgH,
                width: imgW,
                height: imgH
            });
        } else page.drawText('Imagen no disponible', {
            x: margin,
            y: imgTop - 14,
            size: 12,
            font: font,
            color: (0, $gidDr.rgb)(0.5, 0.5, 0.5)
        });
        const pn = `P\xe1gina ${i + 1} de ${rows.length}`;
        page.drawText(pn, {
            x: A4.w - margin - 100,
            y: 16,
            size: 10,
            font: font
        });
    }
    return pdf.save();
}
const $631983b74b869f71$export$942efa8648791354 = ({ reportes: reportes, onClose: onClose })=>{
    const getReportes = (0, $49qEn.useExecuteProc)(reportes, reportes.def.procs.repo_qryReportesFotos);
    const [datos0, setDatos0] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        (async ()=>{
            await getReportes.execute({
                c_cliente_id: reportes.def.columns.c_cliente_id.value,
                dt_fecha_desde: reportes.parentKeys.dt_fecha_desde,
                dt_fecha_hasta: reportes.parentKeys.dt_fecha_hasta,
                c_autorizacion_directa_status_id: reportes.parentKeys.c_autorizacion_directa_status_id,
                dt_fecha_realizado_desde: reportes.parentKeys.dt_fecha_realizado_desde,
                dt_fecha_realizado_hasta: reportes.parentKeys.dt_fecha_realizado_hasta
            });
        })();
    }, [
        reportes.def.columns.c_cliente_id.value,
        reportes.parentKeys.dt_fecha_desde,
        reportes.parentKeys.dt_fecha_hasta,
        reportes.parentKeys.c_autorizacion_directa_status_id,
        reportes.parentKeys.dt_fecha_realizado_desde,
        reportes.parentKeys.dt_fecha_realizado_hasta
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!getReportes.status.loading && getReportes.status.data) setDatos0(getReportes.status.data[0]);
    }, [
        getReportes.status
    ]);
    (0, $acw62.useEffect)(()=>{
        (async ()=>{
            if (!datos0) return;
            try {
                const bytes = await $631983b74b869f71$var$buildPdf(datos0);
                const url = URL.createObjectURL(new Blob([
                    bytes
                ], {
                    type: "application/pdf"
                }));
                window.open(url, "_blank");
            } finally{
                onClose();
            }
        })();
    }, [
        datos0
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9VIWE.Stack), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                children: "Generando PDF\u2026"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.FakeProgressBar), {})
        ]
    });
};
const $631983b74b869f71$export$235d573ac42cb1a2 = {
    name: "ACTExportarPdf",
    label: "Exportar Fotos",
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Exportar Fotos"
    }),
    refreshOnClose: true,
    dontRequireSelection: true,
    showActionInViewMode: true,
    views: [
        "repo_brwBaseReportesDetallada"
    ],
    onClick: async ({ entity: entity, modal: modal, element: element })=>{
        const reportes = entity;
        if (!modal) {
            console.warn("modal context not found");
            return false;
        }
        await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                    fw: "700",
                    children: "Exportar Fotos"
                })
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)($631983b74b869f71$export$942efa8648791354, {
                reportes: reportes,
                onClose: ()=>modal.close()
            })
        });
        return false;
    }
};

});
parcelRegister("01v82", function(module, exports) {
$parcel$export(module.exports, "PDFDocument", () => (parcelRequire("cGbw3")).default);
$parcel$export(module.exports, "rgb", () => (parcelRequire("gidDr")).rgb);
$parcel$export(module.exports, "StandardFonts", () => (parcelRequire("i4gUC")).StandardFonts);
parcelRequire("43ivt");
parcelRequire("iT7lj");

var $4J7XC = parcelRequire("4J7XC");
parcelRequire("fvYKZ");
$parcel$exportWildcard(module.exports, $4J7XC);

});
parcelRegister("43ivt", function(module, exports) {
$parcel$export(module.exports, "rgb", () => (parcelRequire("gidDr")).rgb);
$parcel$export(module.exports, "StandardFonts", () => (parcelRequire("i4gUC")).StandardFonts);

$parcel$export(module.exports, "PDFDocument", () => (parcelRequire("cGbw3")).default);
parcelRequire("1tnyK");
parcelRequire("5yZPW");
parcelRequire("gidDr");
parcelRequire("aYJvX");
parcelRequire("6vWdG");
parcelRequire("dW4Sr");
parcelRequire("7mLHs");
parcelRequire("hPFvC");
parcelRequire("55HYh");
parcelRequire("gjdfV");
parcelRequire("j1dka");
parcelRequire("dJaLP");
parcelRequire("i4gUC");

var $cGbw3 = parcelRequire("cGbw3");

var $lzaL9 = parcelRequire("lzaL9");

var $7F2yc = parcelRequire("7F2yc");

var $eq4Zh = parcelRequire("eq4Zh");

var $kUs6q = parcelRequire("kUs6q");

var $ceWew = parcelRequire("ceWew");

});
parcelRegister("1tnyK", function(module, exports) {
parcelRequire("ikSoM");

var $fphXB = parcelRequire("fphXB");

var $67hmm = parcelRequire("67hmm");

var $c2qg8 = parcelRequire("c2qg8");

var $dgAbg = parcelRequire("dgAbg");

var $2sybW = parcelRequire("2sybW");

var $5Apvp = parcelRequire("5Apvp");

var $1DKij = parcelRequire("1DKij");

var $hzhWN = parcelRequire("hzhWN");

var $lqhKQ = parcelRequire("lqhKQ");

});
parcelRegister("ikSoM", function(module, exports) {

$parcel$export(module.exports, "normalizeAppearance", () => $d5944ab433082972$export$8a3aea031520d39b);
$parcel$export(module.exports, "defaultCheckBoxAppearanceProvider", () => $d5944ab433082972$export$e11eab3ac6c06eb0);
$parcel$export(module.exports, "defaultRadioGroupAppearanceProvider", () => $d5944ab433082972$export$6440094330a99ef8);
$parcel$export(module.exports, "defaultButtonAppearanceProvider", () => $d5944ab433082972$export$68f9b19f48ffeeec);
$parcel$export(module.exports, "defaultTextFieldAppearanceProvider", () => $d5944ab433082972$export$42ba95e6b8df3d7);
$parcel$export(module.exports, "defaultDropdownAppearanceProvider", () => $d5944ab433082972$export$90f1ca03d512ec5);
$parcel$export(module.exports, "defaultOptionListAppearanceProvider", () => $d5944ab433082972$export$f9fab495286778d2);

var $cOQTW = parcelRequire("cOQTW");

var $7mLHs = parcelRequire("7mLHs");

var $gidDr = parcelRequire("gidDr");

var $55HYh = parcelRequire("55HYh");

var $d1UXb = parcelRequire("d1UXb");

var $5rdXu = parcelRequire("5rdXu");

var $hPFvC = parcelRequire("hPFvC");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $d5944ab433082972$export$8a3aea031520d39b = function(appearance) {
    if ('normal' in appearance) return appearance;
    return {
        normal: appearance
    };
};
// Examples:
//   `/Helv 12 Tf` -> ['/Helv 12 Tf', 'Helv', '12']
//   `/HeBo 8.00 Tf` -> ['/HeBo 8 Tf', 'HeBo', '8.00']
var $d5944ab433082972$var$tfRegex = /\/([^\0\t\n\f\r\ ]+)[\0\t\n\f\r\ ]+(\d*\.\d+|\d+)[\0\t\n\f\r\ ]+Tf/;
var $d5944ab433082972$var$getDefaultFontSize = function(field) {
    var _a, _b;
    var da = (_a = field.getDefaultAppearance()) !== null && _a !== void 0 ? _a : '';
    var daMatch = (_b = (0, $7Kmy8.findLastMatch)(da, $d5944ab433082972$var$tfRegex).match) !== null && _b !== void 0 ? _b : [];
    var defaultFontSize = Number(daMatch[2]);
    return isFinite(defaultFontSize) ? defaultFontSize : undefined;
};
// Examples:
//   `0.3 g` -> ['0.3', 'g']
//   `0.3 1 .3 rg` -> ['0.3', '1', '.3', 'rg']
//   `0.3 1 .3 0 k` -> ['0.3', '1', '.3', '0', 'k']
var $d5944ab433082972$var$colorRegex = /(\d*\.\d+|\d+)[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]+(g|rg|k)/;
var $d5944ab433082972$var$getDefaultColor = function(field) {
    var _a;
    var da = (_a = field.getDefaultAppearance()) !== null && _a !== void 0 ? _a : '';
    var daMatch = (0, $7Kmy8.findLastMatch)(da, $d5944ab433082972$var$colorRegex).match;
    var _b = daMatch !== null && daMatch !== void 0 ? daMatch : [], c1 = _b[1], c2 = _b[2], c3 = _b[3], c4 = _b[4], colorSpace = _b[5];
    if (colorSpace === 'g' && c1) return (0, $gidDr.grayscale)(Number(c1));
    if (colorSpace === 'rg' && c1 && c2 && c3) return (0, $gidDr.rgb)(Number(c1), Number(c2), Number(c3));
    if (colorSpace === 'k' && c1 && c2 && c3 && c4) return (0, $gidDr.cmyk)(Number(c1), Number(c2), Number(c3), Number(c4));
    return undefined;
};
var $d5944ab433082972$var$updateDefaultAppearance = function(field, color, font, fontSize) {
    var _a;
    if (fontSize === void 0) fontSize = 0;
    var da = [
        (0, $gidDr.setFillingColor)(color).toString(),
        (0, $hPFvC.setFontAndSize)((_a = font === null || font === void 0 ? void 0 : font.name) !== null && _a !== void 0 ? _a : 'dummy__noop', fontSize).toString()
    ].join('\n');
    field.setDefaultAppearance(da);
};
var $d5944ab433082972$export$e11eab3ac6c06eb0 = function(checkBox, widget) {
    var _a, _b, _c;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $d5944ab433082972$var$getDefaultColor(widget);
    var fieldColor = $d5944ab433082972$var$getDefaultColor(checkBox.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var borderWidth = (_a = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _a !== void 0 ? _a : 0;
    var rotation = (0, $55HYh.reduceRotation)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _d = (0, $55HYh.adjustDimsForRotation)(rectangle, rotation), width = _d.width, height = _d.height;
    var rotate = (0, $7mLHs.rotateInPlace)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $gidDr.rgb)(0, 0, 0);
    var borderColor = (_b = (0, $gidDr.componentsToColor)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor())) !== null && _b !== void 0 ? _b : black;
    var normalBackgroundColor = (0, $gidDr.componentsToColor)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var downBackgroundColor = (0, $gidDr.componentsToColor)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor(), 0.8);
    // Update color
    var textColor = (_c = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _c !== void 0 ? _c : black;
    if (widgetColor) $d5944ab433082972$var$updateDefaultAppearance(widget, textColor);
    else $d5944ab433082972$var$updateDefaultAppearance(checkBox.acroField, textColor);
    var options = {
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        thickness: 1.5,
        borderWidth: borderWidth,
        borderColor: borderColor,
        markColor: textColor
    };
    return {
        normal: {
            on: (0, $cOQTW.__spreadArrays)(rotate, (0, $7mLHs.drawCheckBox)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
                color: normalBackgroundColor,
                filled: true
            }))),
            off: (0, $cOQTW.__spreadArrays)(rotate, (0, $7mLHs.drawCheckBox)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
                color: normalBackgroundColor,
                filled: false
            })))
        },
        down: {
            on: (0, $cOQTW.__spreadArrays)(rotate, (0, $7mLHs.drawCheckBox)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
                color: downBackgroundColor,
                filled: true
            }))),
            off: (0, $cOQTW.__spreadArrays)(rotate, (0, $7mLHs.drawCheckBox)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
                color: downBackgroundColor,
                filled: false
            })))
        }
    };
};
var $d5944ab433082972$export$6440094330a99ef8 = function(radioGroup, widget) {
    var _a, _b, _c;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $d5944ab433082972$var$getDefaultColor(widget);
    var fieldColor = $d5944ab433082972$var$getDefaultColor(radioGroup.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var borderWidth = (_a = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _a !== void 0 ? _a : 0;
    var rotation = (0, $55HYh.reduceRotation)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _d = (0, $55HYh.adjustDimsForRotation)(rectangle, rotation), width = _d.width, height = _d.height;
    var rotate = (0, $7mLHs.rotateInPlace)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $gidDr.rgb)(0, 0, 0);
    var borderColor = (_b = (0, $gidDr.componentsToColor)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor())) !== null && _b !== void 0 ? _b : black;
    var normalBackgroundColor = (0, $gidDr.componentsToColor)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var downBackgroundColor = (0, $gidDr.componentsToColor)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor(), 0.8);
    // Update color
    var textColor = (_c = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _c !== void 0 ? _c : black;
    if (widgetColor) $d5944ab433082972$var$updateDefaultAppearance(widget, textColor);
    else $d5944ab433082972$var$updateDefaultAppearance(radioGroup.acroField, textColor);
    var options = {
        x: width / 2,
        y: height / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth,
        borderColor: borderColor,
        dotColor: textColor
    };
    return {
        normal: {
            on: (0, $cOQTW.__spreadArrays)(rotate, (0, $7mLHs.drawRadioButton)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
                color: normalBackgroundColor,
                filled: true
            }))),
            off: (0, $cOQTW.__spreadArrays)(rotate, (0, $7mLHs.drawRadioButton)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
                color: normalBackgroundColor,
                filled: false
            })))
        },
        down: {
            on: (0, $cOQTW.__spreadArrays)(rotate, (0, $7mLHs.drawRadioButton)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
                color: downBackgroundColor,
                filled: true
            }))),
            off: (0, $cOQTW.__spreadArrays)(rotate, (0, $7mLHs.drawRadioButton)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
                color: downBackgroundColor,
                filled: false
            })))
        }
    };
};
var $d5944ab433082972$export$68f9b19f48ffeeec = function(button, widget, font) {
    var _a, _b, _c, _d, _e;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $d5944ab433082972$var$getDefaultColor(widget);
    var fieldColor = $d5944ab433082972$var$getDefaultColor(button.acroField);
    var widgetFontSize = $d5944ab433082972$var$getDefaultFontSize(widget);
    var fieldFontSize = $d5944ab433082972$var$getDefaultFontSize(button.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var captions = ap === null || ap === void 0 ? void 0 : ap.getCaptions();
    var normalText = (_a = captions === null || captions === void 0 ? void 0 : captions.normal) !== null && _a !== void 0 ? _a : '';
    var downText = (_c = (_b = captions === null || captions === void 0 ? void 0 : captions.down) !== null && _b !== void 0 ? _b : normalText) !== null && _c !== void 0 ? _c : '';
    var borderWidth = (_d = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _d !== void 0 ? _d : 0;
    var rotation = (0, $55HYh.reduceRotation)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _f = (0, $55HYh.adjustDimsForRotation)(rectangle, rotation), width = _f.width, height = _f.height;
    var rotate = (0, $7mLHs.rotateInPlace)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $gidDr.rgb)(0, 0, 0);
    var borderColor = (0, $gidDr.componentsToColor)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor());
    var normalBackgroundColor = (0, $gidDr.componentsToColor)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var downBackgroundColor = (0, $gidDr.componentsToColor)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor(), 0.8);
    var bounds = {
        x: borderWidth,
        y: borderWidth,
        width: width - borderWidth * 2,
        height: height - borderWidth * 2
    };
    var normalLayout = (0, $d1UXb.layoutSinglelineText)(normalText, {
        alignment: (0, $5rdXu.TextAlignment).Center,
        fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
        font: font,
        bounds: bounds
    });
    var downLayout = (0, $d1UXb.layoutSinglelineText)(downText, {
        alignment: (0, $5rdXu.TextAlignment).Center,
        fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
        font: font,
        bounds: bounds
    });
    // Update font size and color
    var fontSize = Math.min(normalLayout.fontSize, downLayout.fontSize);
    var textColor = (_e = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _e !== void 0 ? _e : black;
    if (widgetColor || widgetFontSize !== undefined) $d5944ab433082972$var$updateDefaultAppearance(widget, textColor, font, fontSize);
    else $d5944ab433082972$var$updateDefaultAppearance(button.acroField, textColor, font, fontSize);
    var options = {
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth,
        borderColor: borderColor,
        textColor: textColor,
        font: font.name,
        fontSize: fontSize
    };
    return {
        normal: (0, $cOQTW.__spreadArrays)(rotate, (0, $7mLHs.drawButton)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
            color: normalBackgroundColor,
            textLines: [
                normalLayout.line
            ]
        }))),
        down: (0, $cOQTW.__spreadArrays)(rotate, (0, $7mLHs.drawButton)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
            color: downBackgroundColor,
            textLines: [
                downLayout.line
            ]
        })))
    };
};
var $d5944ab433082972$export$42ba95e6b8df3d7 = function(textField, widget, font) {
    var _a, _b, _c, _d;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $d5944ab433082972$var$getDefaultColor(widget);
    var fieldColor = $d5944ab433082972$var$getDefaultColor(textField.acroField);
    var widgetFontSize = $d5944ab433082972$var$getDefaultFontSize(widget);
    var fieldFontSize = $d5944ab433082972$var$getDefaultFontSize(textField.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var text = (_a = textField.getText()) !== null && _a !== void 0 ? _a : '';
    var borderWidth = (_b = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _b !== void 0 ? _b : 0;
    var rotation = (0, $55HYh.reduceRotation)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _e = (0, $55HYh.adjustDimsForRotation)(rectangle, rotation), width = _e.width, height = _e.height;
    var rotate = (0, $7mLHs.rotateInPlace)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $gidDr.rgb)(0, 0, 0);
    var borderColor = (0, $gidDr.componentsToColor)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor());
    var normalBackgroundColor = (0, $gidDr.componentsToColor)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var textLines;
    var fontSize;
    var padding = textField.isCombed() ? 0 : 1;
    var bounds = {
        x: borderWidth + padding,
        y: borderWidth + padding,
        width: width - (borderWidth + padding) * 2,
        height: height - (borderWidth + padding) * 2
    };
    if (textField.isMultiline()) {
        var layout = (0, $d1UXb.layoutMultilineText)(text, {
            alignment: textField.getAlignment(),
            fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
            font: font,
            bounds: bounds
        });
        textLines = layout.lines;
        fontSize = layout.fontSize;
    } else if (textField.isCombed()) {
        var layout = (0, $d1UXb.layoutCombedText)(text, {
            fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
            font: font,
            bounds: bounds,
            cellCount: (_c = textField.getMaxLength()) !== null && _c !== void 0 ? _c : 0
        });
        textLines = layout.cells;
        fontSize = layout.fontSize;
    } else {
        var layout = (0, $d1UXb.layoutSinglelineText)(text, {
            alignment: textField.getAlignment(),
            fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
            font: font,
            bounds: bounds
        });
        textLines = [
            layout.line
        ];
        fontSize = layout.fontSize;
    }
    // Update font size and color
    var textColor = (_d = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _d !== void 0 ? _d : black;
    if (widgetColor || widgetFontSize !== undefined) $d5944ab433082972$var$updateDefaultAppearance(widget, textColor, font, fontSize);
    else $d5944ab433082972$var$updateDefaultAppearance(textField.acroField, textColor, font, fontSize);
    var options = {
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth !== null && borderWidth !== void 0 ? borderWidth : 0,
        borderColor: borderColor,
        textColor: textColor,
        font: font.name,
        fontSize: fontSize,
        color: normalBackgroundColor,
        textLines: textLines,
        padding: padding
    };
    return (0, $cOQTW.__spreadArrays)(rotate, (0, $7mLHs.drawTextField)(options));
};
var $d5944ab433082972$export$90f1ca03d512ec5 = function(dropdown, widget, font) {
    var _a, _b, _c;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $d5944ab433082972$var$getDefaultColor(widget);
    var fieldColor = $d5944ab433082972$var$getDefaultColor(dropdown.acroField);
    var widgetFontSize = $d5944ab433082972$var$getDefaultFontSize(widget);
    var fieldFontSize = $d5944ab433082972$var$getDefaultFontSize(dropdown.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var text = (_a = dropdown.getSelected()[0]) !== null && _a !== void 0 ? _a : '';
    var borderWidth = (_b = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _b !== void 0 ? _b : 0;
    var rotation = (0, $55HYh.reduceRotation)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _d = (0, $55HYh.adjustDimsForRotation)(rectangle, rotation), width = _d.width, height = _d.height;
    var rotate = (0, $7mLHs.rotateInPlace)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $gidDr.rgb)(0, 0, 0);
    var borderColor = (0, $gidDr.componentsToColor)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor());
    var normalBackgroundColor = (0, $gidDr.componentsToColor)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var padding = 1;
    var bounds = {
        x: borderWidth + padding,
        y: borderWidth + padding,
        width: width - (borderWidth + padding) * 2,
        height: height - (borderWidth + padding) * 2
    };
    var _e = (0, $d1UXb.layoutSinglelineText)(text, {
        alignment: (0, $5rdXu.TextAlignment).Left,
        fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
        font: font,
        bounds: bounds
    }), line = _e.line, fontSize = _e.fontSize;
    // Update font size and color
    var textColor = (_c = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _c !== void 0 ? _c : black;
    if (widgetColor || widgetFontSize !== undefined) $d5944ab433082972$var$updateDefaultAppearance(widget, textColor, font, fontSize);
    else $d5944ab433082972$var$updateDefaultAppearance(dropdown.acroField, textColor, font, fontSize);
    var options = {
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth !== null && borderWidth !== void 0 ? borderWidth : 0,
        borderColor: borderColor,
        textColor: textColor,
        font: font.name,
        fontSize: fontSize,
        color: normalBackgroundColor,
        textLines: [
            line
        ],
        padding: padding
    };
    return (0, $cOQTW.__spreadArrays)(rotate, (0, $7mLHs.drawTextField)(options));
};
var $d5944ab433082972$export$f9fab495286778d2 = function(optionList, widget, font) {
    var _a, _b;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $d5944ab433082972$var$getDefaultColor(widget);
    var fieldColor = $d5944ab433082972$var$getDefaultColor(optionList.acroField);
    var widgetFontSize = $d5944ab433082972$var$getDefaultFontSize(widget);
    var fieldFontSize = $d5944ab433082972$var$getDefaultFontSize(optionList.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var borderWidth = (_a = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _a !== void 0 ? _a : 0;
    var rotation = (0, $55HYh.reduceRotation)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _c = (0, $55HYh.adjustDimsForRotation)(rectangle, rotation), width = _c.width, height = _c.height;
    var rotate = (0, $7mLHs.rotateInPlace)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $gidDr.rgb)(0, 0, 0);
    var borderColor = (0, $gidDr.componentsToColor)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor());
    var normalBackgroundColor = (0, $gidDr.componentsToColor)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var options = optionList.getOptions();
    var selected = optionList.getSelected();
    if (optionList.isSorted()) options.sort();
    var text = '';
    for(var idx = 0, len = options.length; idx < len; idx++){
        text += options[idx];
        if (idx < len - 1) text += '\n';
    }
    var padding = 1;
    var bounds = {
        x: borderWidth + padding,
        y: borderWidth + padding,
        width: width - (borderWidth + padding) * 2,
        height: height - (borderWidth + padding) * 2
    };
    var _d = (0, $d1UXb.layoutMultilineText)(text, {
        alignment: (0, $5rdXu.TextAlignment).Left,
        fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
        font: font,
        bounds: bounds
    }), lines = _d.lines, fontSize = _d.fontSize, lineHeight = _d.lineHeight;
    var selectedLines = [];
    for(var idx = 0, len = lines.length; idx < len; idx++){
        var line = lines[idx];
        if (selected.includes(line.text)) selectedLines.push(idx);
    }
    var blue = (0, $gidDr.rgb)(0.6, 193 / 255, 218 / 255);
    // Update font size and color
    var textColor = (_b = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _b !== void 0 ? _b : black;
    if (widgetColor || widgetFontSize !== undefined) $d5944ab433082972$var$updateDefaultAppearance(widget, textColor, font, fontSize);
    else $d5944ab433082972$var$updateDefaultAppearance(optionList.acroField, textColor, font, fontSize);
    return (0, $cOQTW.__spreadArrays)(rotate, (0, $7mLHs.drawOptionList)({
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth !== null && borderWidth !== void 0 ? borderWidth : 0,
        borderColor: borderColor,
        textColor: textColor,
        font: font.name,
        fontSize: fontSize,
        color: normalBackgroundColor,
        textLines: lines,
        lineHeight: lineHeight,
        selectedColor: blue,
        selectedLines: selectedLines,
        padding: padding
    }));
};

});
parcelRegister("cOQTW", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $955330a26152f448$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $955330a26152f448$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $955330a26152f448$export$3c9a16f847548506);
$parcel$export(module.exports, "__awaiter", () => $955330a26152f448$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $955330a26152f448$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__spreadArrays", () => $955330a26152f448$export$6388937ca91ccae8);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $955330a26152f448$var$extendStatics = function(d, b) {
    $955330a26152f448$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $955330a26152f448$var$extendStatics(d, b);
};
function $955330a26152f448$export$a8ba968b8961cb8a(d, b) {
    $955330a26152f448$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $955330a26152f448$export$18ce0697a983be9b = function() {
    $955330a26152f448$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $955330a26152f448$export$18ce0697a983be9b.apply(this, arguments);
};
function $955330a26152f448$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $955330a26152f448$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $955330a26152f448$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $955330a26152f448$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $955330a26152f448$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $955330a26152f448$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $955330a26152f448$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $955330a26152f448$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $955330a26152f448$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $955330a26152f448$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $955330a26152f448$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($955330a26152f448$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $955330a26152f448$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $955330a26152f448$export$10c90e4f7922046c(v) {
    return this instanceof $955330a26152f448$export$10c90e4f7922046c ? (this.v = v, this) : new $955330a26152f448$export$10c90e4f7922046c(v);
}
function $955330a26152f448$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $955330a26152f448$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $955330a26152f448$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $955330a26152f448$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $955330a26152f448$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $955330a26152f448$export$19a8beecd37a4c45 === "function" ? $955330a26152f448$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $955330a26152f448$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $955330a26152f448$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $955330a26152f448$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $955330a26152f448$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $955330a26152f448$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("7mLHs", function(module, exports) {

$parcel$export(module.exports, "drawLinesOfText", () => $55cf96b3448598de$export$f7b8b44d3d84bc26);
$parcel$export(module.exports, "drawImage", () => $55cf96b3448598de$export$21a059be5bfd5fb);
$parcel$export(module.exports, "drawPage", () => $55cf96b3448598de$export$f8ea28c31069cbc9);
$parcel$export(module.exports, "drawLine", () => $55cf96b3448598de$export$819db45aec5fcbe5);
$parcel$export(module.exports, "drawRectangle", () => $55cf96b3448598de$export$cac848e0621718d8);
$parcel$export(module.exports, "drawEllipse", () => $55cf96b3448598de$export$43c9e2bb0dc74582);
$parcel$export(module.exports, "drawSvgPath", () => $55cf96b3448598de$export$47c8a640c39d0756);
$parcel$export(module.exports, "rotateInPlace", () => $55cf96b3448598de$export$5dd9a0a87f38a2a6);
$parcel$export(module.exports, "drawCheckBox", () => $55cf96b3448598de$export$1c2f7a8d0ec539ab);
$parcel$export(module.exports, "drawRadioButton", () => $55cf96b3448598de$export$d01bb537f184a293);
$parcel$export(module.exports, "drawButton", () => $55cf96b3448598de$export$31046eb8c5070d92);
$parcel$export(module.exports, "drawTextField", () => $55cf96b3448598de$export$7d8517ad99905084);
$parcel$export(module.exports, "drawOptionList", () => $55cf96b3448598de$export$5a3093287b85b7c0);

var $cOQTW = parcelRequire("cOQTW");

var $gidDr = parcelRequire("gidDr");

var $hPFvC = parcelRequire("hPFvC");

var $55HYh = parcelRequire("55HYh");

var $ibsNb = parcelRequire("ibsNb");

var $dW4Sr = parcelRequire("dW4Sr");
var $55cf96b3448598de$export$b11bd9a0808bdc9 = function(line, options) {
    return [
        (0, $hPFvC.pushGraphicsState)(),
        options.graphicsState && (0, $hPFvC.setGraphicsState)(options.graphicsState),
        (0, $hPFvC.beginText)(),
        (0, $gidDr.setFillingColor)(options.color),
        (0, $hPFvC.setFontAndSize)(options.font, options.size),
        (0, $hPFvC.rotateAndSkewTextRadiansAndTranslate)((0, $55HYh.toRadians)(options.rotate), (0, $55HYh.toRadians)(options.xSkew), (0, $55HYh.toRadians)(options.ySkew), options.x, options.y),
        (0, $hPFvC.showText)(line),
        (0, $hPFvC.endText)(),
        (0, $hPFvC.popGraphicsState)()
    ].filter(Boolean);
};
var $55cf96b3448598de$export$f7b8b44d3d84bc26 = function(lines, options) {
    var operators = [
        (0, $hPFvC.pushGraphicsState)(),
        options.graphicsState && (0, $hPFvC.setGraphicsState)(options.graphicsState),
        (0, $hPFvC.beginText)(),
        (0, $gidDr.setFillingColor)(options.color),
        (0, $hPFvC.setFontAndSize)(options.font, options.size),
        (0, $hPFvC.setLineHeight)(options.lineHeight),
        (0, $hPFvC.rotateAndSkewTextRadiansAndTranslate)((0, $55HYh.toRadians)(options.rotate), (0, $55HYh.toRadians)(options.xSkew), (0, $55HYh.toRadians)(options.ySkew), options.x, options.y)
    ].filter(Boolean);
    for(var idx = 0, len = lines.length; idx < len; idx++)operators.push((0, $hPFvC.showText)(lines[idx]), (0, $hPFvC.nextLine)());
    operators.push((0, $hPFvC.endText)(), (0, $hPFvC.popGraphicsState)());
    return operators;
};
var $55cf96b3448598de$export$21a059be5bfd5fb = function(name, options) {
    return [
        (0, $hPFvC.pushGraphicsState)(),
        options.graphicsState && (0, $hPFvC.setGraphicsState)(options.graphicsState),
        (0, $hPFvC.translate)(options.x, options.y),
        (0, $hPFvC.rotateRadians)((0, $55HYh.toRadians)(options.rotate)),
        (0, $hPFvC.scale)(options.width, options.height),
        (0, $hPFvC.skewRadians)((0, $55HYh.toRadians)(options.xSkew), (0, $55HYh.toRadians)(options.ySkew)),
        (0, $hPFvC.drawObject)(name),
        (0, $hPFvC.popGraphicsState)()
    ].filter(Boolean);
};
var $55cf96b3448598de$export$f8ea28c31069cbc9 = function(name, options) {
    return [
        (0, $hPFvC.pushGraphicsState)(),
        options.graphicsState && (0, $hPFvC.setGraphicsState)(options.graphicsState),
        (0, $hPFvC.translate)(options.x, options.y),
        (0, $hPFvC.rotateRadians)((0, $55HYh.toRadians)(options.rotate)),
        (0, $hPFvC.scale)(options.xScale, options.yScale),
        (0, $hPFvC.skewRadians)((0, $55HYh.toRadians)(options.xSkew), (0, $55HYh.toRadians)(options.ySkew)),
        (0, $hPFvC.drawObject)(name),
        (0, $hPFvC.popGraphicsState)()
    ].filter(Boolean);
};
var $55cf96b3448598de$export$819db45aec5fcbe5 = function(options) {
    var _a, _b;
    return [
        (0, $hPFvC.pushGraphicsState)(),
        options.graphicsState && (0, $hPFvC.setGraphicsState)(options.graphicsState),
        options.color && (0, $gidDr.setStrokingColor)(options.color),
        (0, $hPFvC.setLineWidth)(options.thickness),
        (0, $hPFvC.setDashPattern)((_a = options.dashArray) !== null && _a !== void 0 ? _a : [], (_b = options.dashPhase) !== null && _b !== void 0 ? _b : 0),
        (0, $hPFvC.moveTo)(options.start.x, options.start.y),
        options.lineCap && (0, $hPFvC.setLineCap)(options.lineCap),
        (0, $hPFvC.moveTo)(options.start.x, options.start.y),
        (0, $hPFvC.lineTo)(options.end.x, options.end.y),
        (0, $hPFvC.stroke)(),
        (0, $hPFvC.popGraphicsState)()
    ].filter(Boolean);
};
var $55cf96b3448598de$export$cac848e0621718d8 = function(options) {
    var _a, _b;
    return [
        (0, $hPFvC.pushGraphicsState)(),
        options.graphicsState && (0, $hPFvC.setGraphicsState)(options.graphicsState),
        options.color && (0, $gidDr.setFillingColor)(options.color),
        options.borderColor && (0, $gidDr.setStrokingColor)(options.borderColor),
        (0, $hPFvC.setLineWidth)(options.borderWidth),
        options.borderLineCap && (0, $hPFvC.setLineCap)(options.borderLineCap),
        (0, $hPFvC.setDashPattern)((_a = options.borderDashArray) !== null && _a !== void 0 ? _a : [], (_b = options.borderDashPhase) !== null && _b !== void 0 ? _b : 0),
        (0, $hPFvC.translate)(options.x, options.y),
        (0, $hPFvC.rotateRadians)((0, $55HYh.toRadians)(options.rotate)),
        (0, $hPFvC.skewRadians)((0, $55HYh.toRadians)(options.xSkew), (0, $55HYh.toRadians)(options.ySkew)),
        (0, $hPFvC.moveTo)(0, 0),
        (0, $hPFvC.lineTo)(0, options.height),
        (0, $hPFvC.lineTo)(options.width, options.height),
        (0, $hPFvC.lineTo)(options.width, 0),
        (0, $hPFvC.closePath)(),
        // prettier-ignore
        options.color && options.borderWidth ? (0, $hPFvC.fillAndStroke)() : options.color ? (0, $hPFvC.fill)() : options.borderColor ? (0, $hPFvC.stroke)() : (0, $hPFvC.closePath)(),
        (0, $hPFvC.popGraphicsState)()
    ].filter(Boolean);
};
var $55cf96b3448598de$var$KAPPA = 4.0 * ((Math.sqrt(2) - 1.0) / 3.0);
var $55cf96b3448598de$export$f219d5f4b18063ad = function(config) {
    var x = (0, $dW4Sr.asNumber)(config.x);
    var y = (0, $dW4Sr.asNumber)(config.y);
    var xScale = (0, $dW4Sr.asNumber)(config.xScale);
    var yScale = (0, $dW4Sr.asNumber)(config.yScale);
    x -= xScale;
    y -= yScale;
    var ox = xScale * $55cf96b3448598de$var$KAPPA;
    var oy = yScale * $55cf96b3448598de$var$KAPPA;
    var xe = x + xScale * 2;
    var ye = y + yScale * 2;
    var xm = x + xScale;
    var ym = y + yScale;
    return [
        (0, $hPFvC.pushGraphicsState)(),
        (0, $hPFvC.moveTo)(x, ym),
        (0, $hPFvC.appendBezierCurve)(x, ym - oy, xm - ox, y, xm, y),
        (0, $hPFvC.appendBezierCurve)(xm + ox, y, xe, ym - oy, xe, ym),
        (0, $hPFvC.appendBezierCurve)(xe, ym + oy, xm + ox, ye, xm, ye),
        (0, $hPFvC.appendBezierCurve)(xm - ox, ye, x, ym + oy, x, ym),
        (0, $hPFvC.popGraphicsState)()
    ];
};
var $55cf96b3448598de$var$drawEllipseCurves = function(config) {
    var centerX = (0, $dW4Sr.asNumber)(config.x);
    var centerY = (0, $dW4Sr.asNumber)(config.y);
    var xScale = (0, $dW4Sr.asNumber)(config.xScale);
    var yScale = (0, $dW4Sr.asNumber)(config.yScale);
    var x = -xScale;
    var y = -yScale;
    var ox = xScale * $55cf96b3448598de$var$KAPPA;
    var oy = yScale * $55cf96b3448598de$var$KAPPA;
    var xe = x + xScale * 2;
    var ye = y + yScale * 2;
    var xm = x + xScale;
    var ym = y + yScale;
    return [
        (0, $hPFvC.translate)(centerX, centerY),
        (0, $hPFvC.rotateRadians)((0, $55HYh.toRadians)(config.rotate)),
        (0, $hPFvC.moveTo)(x, ym),
        (0, $hPFvC.appendBezierCurve)(x, ym - oy, xm - ox, y, xm, y),
        (0, $hPFvC.appendBezierCurve)(xm + ox, y, xe, ym - oy, xe, ym),
        (0, $hPFvC.appendBezierCurve)(xe, ym + oy, xm + ox, ye, xm, ye),
        (0, $hPFvC.appendBezierCurve)(xm - ox, ye, x, ym + oy, x, ym)
    ];
};
var $55cf96b3448598de$export$43c9e2bb0dc74582 = function(options) {
    var _a, _b, _c;
    return (0, $cOQTW.__spreadArrays)([
        (0, $hPFvC.pushGraphicsState)(),
        options.graphicsState && (0, $hPFvC.setGraphicsState)(options.graphicsState),
        options.color && (0, $gidDr.setFillingColor)(options.color),
        options.borderColor && (0, $gidDr.setStrokingColor)(options.borderColor),
        (0, $hPFvC.setLineWidth)(options.borderWidth),
        options.borderLineCap && (0, $hPFvC.setLineCap)(options.borderLineCap),
        (0, $hPFvC.setDashPattern)((_a = options.borderDashArray) !== null && _a !== void 0 ? _a : [], (_b = options.borderDashPhase) !== null && _b !== void 0 ? _b : 0)
    ], options.rotate === undefined ? $55cf96b3448598de$export$f219d5f4b18063ad({
        x: options.x,
        y: options.y,
        xScale: options.xScale,
        yScale: options.yScale
    }) : $55cf96b3448598de$var$drawEllipseCurves({
        x: options.x,
        y: options.y,
        xScale: options.xScale,
        yScale: options.yScale,
        rotate: (_c = options.rotate) !== null && _c !== void 0 ? _c : (0, $55HYh.degrees)(0)
    }), [
        // prettier-ignore
        options.color && options.borderWidth ? (0, $hPFvC.fillAndStroke)() : options.color ? (0, $hPFvC.fill)() : options.borderColor ? (0, $hPFvC.stroke)() : (0, $hPFvC.closePath)(),
        (0, $hPFvC.popGraphicsState)()
    ]).filter(Boolean);
};
var $55cf96b3448598de$export$47c8a640c39d0756 = function(path, options) {
    var _a, _b, _c;
    return (0, $cOQTW.__spreadArrays)([
        (0, $hPFvC.pushGraphicsState)(),
        options.graphicsState && (0, $hPFvC.setGraphicsState)(options.graphicsState),
        (0, $hPFvC.translate)(options.x, options.y),
        (0, $hPFvC.rotateRadians)((0, $55HYh.toRadians)((_a = options.rotate) !== null && _a !== void 0 ? _a : (0, $55HYh.degrees)(0))),
        // SVG path Y axis is opposite pdf-lib's
        options.scale ? (0, $hPFvC.scale)(options.scale, -options.scale) : (0, $hPFvC.scale)(1, -1),
        options.color && (0, $gidDr.setFillingColor)(options.color),
        options.borderColor && (0, $gidDr.setStrokingColor)(options.borderColor),
        options.borderWidth && (0, $hPFvC.setLineWidth)(options.borderWidth),
        options.borderLineCap && (0, $hPFvC.setLineCap)(options.borderLineCap),
        (0, $hPFvC.setDashPattern)((_b = options.borderDashArray) !== null && _b !== void 0 ? _b : [], (_c = options.borderDashPhase) !== null && _c !== void 0 ? _c : 0)
    ], (0, $ibsNb.svgPathToOperators)(path), [
        // prettier-ignore
        options.color && options.borderWidth ? (0, $hPFvC.fillAndStroke)() : options.color ? (0, $hPFvC.fill)() : options.borderColor ? (0, $hPFvC.stroke)() : (0, $hPFvC.closePath)(),
        (0, $hPFvC.popGraphicsState)()
    ]).filter(Boolean);
};
var $55cf96b3448598de$export$695703ffa02b3ffb = function(options) {
    var size = (0, $dW4Sr.asNumber)(options.size);
    /*********************** Define Check Mark Points ***************************/ // A check mark is defined by three points in some coordinate space. Here, we
    // define these points in a unit coordinate system, where the range of the x
    // and y axis are both [-1, 1].
    //
    // Note that we do not hard code `p1y` in case we wish to change the
    // size/shape of the check mark in the future. We want the check mark to
    // always form a right angle. This means that the dot product between (p1-p2)
    // and (p3-p2) should be zero:
    //
    //   (p1x-p2x) * (p3x-p2x) + (p1y-p2y) * (p3y-p2y) = 0
    //
    // We can now rejigger this equation to solve for `p1y`:
    //
    //   (p1y-p2y) * (p3y-p2y) = -((p1x-p2x) * (p3x-p2x))
    //   (p1y-p2y) = -((p1x-p2x) * (p3x-p2x)) / (p3y-p2y)
    //   p1y = -((p1x-p2x) * (p3x-p2x)) / (p3y-p2y) + p2y
    //
    // Thanks to my friend Joel Walker (https://github.com/JWalker1995) for
    // devising the above equation and unit coordinate system approach!
    // (x, y) coords of the check mark's bottommost point
    var p2x = -0.25;
    var p2y = -0.49;
    // (x, y) coords of the check mark's topmost point
    var p3y = 0.475;
    var p3x = 0.69;
    // (x, y) coords of the check mark's center (vertically) point
    var p1x = -0.675;
    var p1y = -((p1x - p2x) * (p3x - p2x)) / (p3y - p2y) + p2y;
    /****************************************************************************/ return [
        (0, $hPFvC.pushGraphicsState)(),
        options.color && (0, $gidDr.setStrokingColor)(options.color),
        (0, $hPFvC.setLineWidth)(options.thickness),
        (0, $hPFvC.translate)(options.x, options.y),
        (0, $hPFvC.moveTo)(p1x * size, p1y * size),
        (0, $hPFvC.lineTo)(p2x * size, p2y * size),
        (0, $hPFvC.lineTo)(p3x * size, p3y * size),
        (0, $hPFvC.stroke)(),
        (0, $hPFvC.popGraphicsState)()
    ].filter(Boolean);
};
var $55cf96b3448598de$export$5dd9a0a87f38a2a6 = function(options) {
    return options.rotation === 0 ? [
        (0, $hPFvC.translate)(0, 0),
        (0, $hPFvC.rotateDegrees)(0)
    ] : options.rotation === 90 ? [
        (0, $hPFvC.translate)(options.width, 0),
        (0, $hPFvC.rotateDegrees)(90)
    ] : options.rotation === 180 ? [
        (0, $hPFvC.translate)(options.width, options.height),
        (0, $hPFvC.rotateDegrees)(180)
    ] : options.rotation === 270 ? [
        (0, $hPFvC.translate)(0, options.height),
        (0, $hPFvC.rotateDegrees)(270)
    ] : [];
}; // Invalid rotation - noop
var $55cf96b3448598de$export$1c2f7a8d0ec539ab = function(options) {
    var outline = $55cf96b3448598de$export$cac848e0621718d8({
        x: options.x,
        y: options.y,
        width: options.width,
        height: options.height,
        borderWidth: options.borderWidth,
        color: options.color,
        borderColor: options.borderColor,
        rotate: (0, $55HYh.degrees)(0),
        xSkew: (0, $55HYh.degrees)(0),
        ySkew: (0, $55HYh.degrees)(0)
    });
    if (!options.filled) return outline;
    var width = (0, $dW4Sr.asNumber)(options.width);
    var height = (0, $dW4Sr.asNumber)(options.height);
    var checkMarkSize = Math.min(width, height) / 2;
    var checkMark = $55cf96b3448598de$export$695703ffa02b3ffb({
        x: width / 2,
        y: height / 2,
        size: checkMarkSize,
        thickness: options.thickness,
        color: options.markColor
    });
    return (0, $cOQTW.__spreadArrays)([
        (0, $hPFvC.pushGraphicsState)()
    ], outline, checkMark, [
        (0, $hPFvC.popGraphicsState)()
    ]);
};
var $55cf96b3448598de$export$d01bb537f184a293 = function(options) {
    var width = (0, $dW4Sr.asNumber)(options.width);
    var height = (0, $dW4Sr.asNumber)(options.height);
    var outlineScale = Math.min(width, height) / 2;
    var outline = $55cf96b3448598de$export$43c9e2bb0dc74582({
        x: options.x,
        y: options.y,
        xScale: outlineScale,
        yScale: outlineScale,
        color: options.color,
        borderColor: options.borderColor,
        borderWidth: options.borderWidth
    });
    if (!options.filled) return outline;
    var dot = $55cf96b3448598de$export$43c9e2bb0dc74582({
        x: options.x,
        y: options.y,
        xScale: outlineScale * 0.45,
        yScale: outlineScale * 0.45,
        color: options.dotColor,
        borderColor: undefined,
        borderWidth: 0
    });
    return (0, $cOQTW.__spreadArrays)([
        (0, $hPFvC.pushGraphicsState)()
    ], outline, dot, [
        (0, $hPFvC.popGraphicsState)()
    ]);
};
var $55cf96b3448598de$export$31046eb8c5070d92 = function(options) {
    var x = (0, $dW4Sr.asNumber)(options.x);
    var y = (0, $dW4Sr.asNumber)(options.y);
    var width = (0, $dW4Sr.asNumber)(options.width);
    var height = (0, $dW4Sr.asNumber)(options.height);
    var background = $55cf96b3448598de$export$cac848e0621718d8({
        x: x,
        y: y,
        width: width,
        height: height,
        borderWidth: options.borderWidth,
        color: options.color,
        borderColor: options.borderColor,
        rotate: (0, $55HYh.degrees)(0),
        xSkew: (0, $55HYh.degrees)(0),
        ySkew: (0, $55HYh.degrees)(0)
    });
    var lines = $55cf96b3448598de$export$8a28629e0fa0aec4(options.textLines, {
        color: options.textColor,
        font: options.font,
        size: options.fontSize,
        rotate: (0, $55HYh.degrees)(0),
        xSkew: (0, $55HYh.degrees)(0),
        ySkew: (0, $55HYh.degrees)(0)
    });
    return (0, $cOQTW.__spreadArrays)([
        (0, $hPFvC.pushGraphicsState)()
    ], background, lines, [
        (0, $hPFvC.popGraphicsState)()
    ]);
};
var $55cf96b3448598de$export$8a28629e0fa0aec4 = function(lines, options) {
    var operators = [
        (0, $hPFvC.beginText)(),
        (0, $gidDr.setFillingColor)(options.color),
        (0, $hPFvC.setFontAndSize)(options.font, options.size)
    ];
    for(var idx = 0, len = lines.length; idx < len; idx++){
        var _a = lines[idx], encoded = _a.encoded, x = _a.x, y = _a.y;
        operators.push((0, $hPFvC.rotateAndSkewTextRadiansAndTranslate)((0, $55HYh.toRadians)(options.rotate), (0, $55HYh.toRadians)(options.xSkew), (0, $55HYh.toRadians)(options.ySkew), x, y), (0, $hPFvC.showText)(encoded));
    }
    operators.push((0, $hPFvC.endText)());
    return operators;
};
var $55cf96b3448598de$export$7d8517ad99905084 = function(options) {
    var x = (0, $dW4Sr.asNumber)(options.x);
    var y = (0, $dW4Sr.asNumber)(options.y);
    var width = (0, $dW4Sr.asNumber)(options.width);
    var height = (0, $dW4Sr.asNumber)(options.height);
    var borderWidth = (0, $dW4Sr.asNumber)(options.borderWidth);
    var padding = (0, $dW4Sr.asNumber)(options.padding);
    var clipX = x + borderWidth / 2 + padding;
    var clipY = y + borderWidth / 2 + padding;
    var clipWidth = width - (borderWidth / 2 + padding) * 2;
    var clipHeight = height - (borderWidth / 2 + padding) * 2;
    var clippingArea = [
        (0, $hPFvC.moveTo)(clipX, clipY),
        (0, $hPFvC.lineTo)(clipX, clipY + clipHeight),
        (0, $hPFvC.lineTo)(clipX + clipWidth, clipY + clipHeight),
        (0, $hPFvC.lineTo)(clipX + clipWidth, clipY),
        (0, $hPFvC.closePath)(),
        (0, $hPFvC.clip)(),
        (0, $hPFvC.endPath)()
    ];
    var background = $55cf96b3448598de$export$cac848e0621718d8({
        x: x,
        y: y,
        width: width,
        height: height,
        borderWidth: options.borderWidth,
        color: options.color,
        borderColor: options.borderColor,
        rotate: (0, $55HYh.degrees)(0),
        xSkew: (0, $55HYh.degrees)(0),
        ySkew: (0, $55HYh.degrees)(0)
    });
    var lines = $55cf96b3448598de$export$8a28629e0fa0aec4(options.textLines, {
        color: options.textColor,
        font: options.font,
        size: options.fontSize,
        rotate: (0, $55HYh.degrees)(0),
        xSkew: (0, $55HYh.degrees)(0),
        ySkew: (0, $55HYh.degrees)(0)
    });
    var markedContent = (0, $cOQTW.__spreadArrays)([
        (0, $hPFvC.beginMarkedContent)('Tx'),
        (0, $hPFvC.pushGraphicsState)()
    ], lines, [
        (0, $hPFvC.popGraphicsState)(),
        (0, $hPFvC.endMarkedContent)()
    ]);
    return (0, $cOQTW.__spreadArrays)([
        (0, $hPFvC.pushGraphicsState)()
    ], background, clippingArea, markedContent, [
        (0, $hPFvC.popGraphicsState)()
    ]);
};
var $55cf96b3448598de$export$5a3093287b85b7c0 = function(options) {
    var x = (0, $dW4Sr.asNumber)(options.x);
    var y = (0, $dW4Sr.asNumber)(options.y);
    var width = (0, $dW4Sr.asNumber)(options.width);
    var height = (0, $dW4Sr.asNumber)(options.height);
    var lineHeight = (0, $dW4Sr.asNumber)(options.lineHeight);
    var borderWidth = (0, $dW4Sr.asNumber)(options.borderWidth);
    var padding = (0, $dW4Sr.asNumber)(options.padding);
    var clipX = x + borderWidth / 2 + padding;
    var clipY = y + borderWidth / 2 + padding;
    var clipWidth = width - (borderWidth / 2 + padding) * 2;
    var clipHeight = height - (borderWidth / 2 + padding) * 2;
    var clippingArea = [
        (0, $hPFvC.moveTo)(clipX, clipY),
        (0, $hPFvC.lineTo)(clipX, clipY + clipHeight),
        (0, $hPFvC.lineTo)(clipX + clipWidth, clipY + clipHeight),
        (0, $hPFvC.lineTo)(clipX + clipWidth, clipY),
        (0, $hPFvC.closePath)(),
        (0, $hPFvC.clip)(),
        (0, $hPFvC.endPath)()
    ];
    var background = $55cf96b3448598de$export$cac848e0621718d8({
        x: x,
        y: y,
        width: width,
        height: height,
        borderWidth: options.borderWidth,
        color: options.color,
        borderColor: options.borderColor,
        rotate: (0, $55HYh.degrees)(0),
        xSkew: (0, $55HYh.degrees)(0),
        ySkew: (0, $55HYh.degrees)(0)
    });
    var highlights = [];
    for(var idx = 0, len = options.selectedLines.length; idx < len; idx++){
        var line = options.textLines[options.selectedLines[idx]];
        highlights.push.apply(highlights, $55cf96b3448598de$export$cac848e0621718d8({
            x: line.x - padding,
            y: line.y - (lineHeight - line.height) / 2,
            width: width - borderWidth,
            height: line.height + (lineHeight - line.height) / 2,
            borderWidth: 0,
            color: options.selectedColor,
            borderColor: undefined,
            rotate: (0, $55HYh.degrees)(0),
            xSkew: (0, $55HYh.degrees)(0),
            ySkew: (0, $55HYh.degrees)(0)
        }));
    }
    var lines = $55cf96b3448598de$export$8a28629e0fa0aec4(options.textLines, {
        color: options.textColor,
        font: options.font,
        size: options.fontSize,
        rotate: (0, $55HYh.degrees)(0),
        xSkew: (0, $55HYh.degrees)(0),
        ySkew: (0, $55HYh.degrees)(0)
    });
    var markedContent = (0, $cOQTW.__spreadArrays)([
        (0, $hPFvC.beginMarkedContent)('Tx'),
        (0, $hPFvC.pushGraphicsState)()
    ], lines, [
        (0, $hPFvC.popGraphicsState)(),
        (0, $hPFvC.endMarkedContent)()
    ]);
    return (0, $cOQTW.__spreadArrays)([
        (0, $hPFvC.pushGraphicsState)()
    ], background, highlights, clippingArea, markedContent, [
        (0, $hPFvC.popGraphicsState)()
    ]);
};

});
parcelRegister("gidDr", function(module, exports) {

$parcel$export(module.exports, "grayscale", () => $030fa0a2c4d1456e$export$6f416a6db2dfcd5c);
$parcel$export(module.exports, "rgb", () => $030fa0a2c4d1456e$export$8972dc0e6ad9238f);
$parcel$export(module.exports, "cmyk", () => $030fa0a2c4d1456e$export$358b1a66a3c77756);
$parcel$export(module.exports, "setFillingColor", () => $030fa0a2c4d1456e$export$6126e5d7ba707741);
$parcel$export(module.exports, "setStrokingColor", () => $030fa0a2c4d1456e$export$ae31e5cacc8bb23d);
$parcel$export(module.exports, "componentsToColor", () => $030fa0a2c4d1456e$export$8750a268217b0987);
$parcel$export(module.exports, "colorToComponents", () => $030fa0a2c4d1456e$export$ffee2793812e3e56);

var $hPFvC = parcelRequire("hPFvC");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
var $hP0hy = parcelRequire("hP0hy");
var $030fa0a2c4d1456e$export$4eb09b1c0a6dec24;
(function(ColorTypes) {
    ColorTypes["Grayscale"] = "Grayscale";
    ColorTypes["RGB"] = "RGB";
    ColorTypes["CMYK"] = "CMYK";
})($030fa0a2c4d1456e$export$4eb09b1c0a6dec24 || ($030fa0a2c4d1456e$export$4eb09b1c0a6dec24 = {}));
var $030fa0a2c4d1456e$export$6f416a6db2dfcd5c = function(gray) {
    (0, $j0tvB.assertRange)(gray, 'gray', 0.0, 1.0);
    return {
        type: $030fa0a2c4d1456e$export$4eb09b1c0a6dec24.Grayscale,
        gray: gray
    };
};
var $030fa0a2c4d1456e$export$8972dc0e6ad9238f = function(red, green, blue) {
    (0, $j0tvB.assertRange)(red, 'red', 0, 1);
    (0, $j0tvB.assertRange)(green, 'green', 0, 1);
    (0, $j0tvB.assertRange)(blue, 'blue', 0, 1);
    return {
        type: $030fa0a2c4d1456e$export$4eb09b1c0a6dec24.RGB,
        red: red,
        green: green,
        blue: blue
    };
};
var $030fa0a2c4d1456e$export$358b1a66a3c77756 = function(cyan, magenta, yellow, key) {
    (0, $j0tvB.assertRange)(cyan, 'cyan', 0, 1);
    (0, $j0tvB.assertRange)(magenta, 'magenta', 0, 1);
    (0, $j0tvB.assertRange)(yellow, 'yellow', 0, 1);
    (0, $j0tvB.assertRange)(key, 'key', 0, 1);
    return {
        type: $030fa0a2c4d1456e$export$4eb09b1c0a6dec24.CMYK,
        cyan: cyan,
        magenta: magenta,
        yellow: yellow,
        key: key
    };
};
var $030fa0a2c4d1456e$var$Grayscale = $030fa0a2c4d1456e$export$4eb09b1c0a6dec24.Grayscale, $030fa0a2c4d1456e$var$RGB = $030fa0a2c4d1456e$export$4eb09b1c0a6dec24.RGB, $030fa0a2c4d1456e$var$CMYK = $030fa0a2c4d1456e$export$4eb09b1c0a6dec24.CMYK;
var $030fa0a2c4d1456e$export$6126e5d7ba707741 = function(color) {
    return color.type === $030fa0a2c4d1456e$var$Grayscale ? (0, $hPFvC.setFillingGrayscaleColor)(color.gray) : color.type === $030fa0a2c4d1456e$var$RGB ? (0, $hPFvC.setFillingRgbColor)(color.red, color.green, color.blue) : color.type === $030fa0a2c4d1456e$var$CMYK ? (0, $hPFvC.setFillingCmykColor)(color.cyan, color.magenta, color.yellow, color.key) : (0, $hP0hy.error)("Invalid color: " + JSON.stringify(color));
};
var $030fa0a2c4d1456e$export$ae31e5cacc8bb23d = function(color) {
    return color.type === $030fa0a2c4d1456e$var$Grayscale ? (0, $hPFvC.setStrokingGrayscaleColor)(color.gray) : color.type === $030fa0a2c4d1456e$var$RGB ? (0, $hPFvC.setStrokingRgbColor)(color.red, color.green, color.blue) : color.type === $030fa0a2c4d1456e$var$CMYK ? (0, $hPFvC.setStrokingCmykColor)(color.cyan, color.magenta, color.yellow, color.key) : (0, $hP0hy.error)("Invalid color: " + JSON.stringify(color));
};
var $030fa0a2c4d1456e$export$8750a268217b0987 = function(comps, scale) {
    if (scale === void 0) scale = 1;
    return (comps === null || comps === void 0 ? void 0 : comps.length) === 1 ? $030fa0a2c4d1456e$export$6f416a6db2dfcd5c(comps[0] * scale) : (comps === null || comps === void 0 ? void 0 : comps.length) === 3 ? $030fa0a2c4d1456e$export$8972dc0e6ad9238f(comps[0] * scale, comps[1] * scale, comps[2] * scale) : (comps === null || comps === void 0 ? void 0 : comps.length) === 4 ? $030fa0a2c4d1456e$export$358b1a66a3c77756(comps[0] * scale, comps[1] * scale, comps[2] * scale, comps[3] * scale) : undefined;
};
var $030fa0a2c4d1456e$export$ffee2793812e3e56 = function(color) {
    return color.type === $030fa0a2c4d1456e$var$Grayscale ? [
        color.gray
    ] : color.type === $030fa0a2c4d1456e$var$RGB ? [
        color.red,
        color.green,
        color.blue
    ] : color.type === $030fa0a2c4d1456e$var$CMYK ? [
        color.cyan,
        color.magenta,
        color.yellow,
        color.key
    ] : (0, $hP0hy.error)("Invalid color: " + JSON.stringify(color));
};

});
parcelRegister("hPFvC", function(module, exports) {

$parcel$export(module.exports, "clip", () => $cfb765e9daff3c3a$export$e0b576e7a74416cd);
$parcel$export(module.exports, "translate", () => $cfb765e9daff3c3a$export$d73ee8ef04f5226a);
$parcel$export(module.exports, "scale", () => $cfb765e9daff3c3a$export$dcdf75081b88279d);
$parcel$export(module.exports, "rotateRadians", () => $cfb765e9daff3c3a$export$a2ba89726971a90f);
$parcel$export(module.exports, "rotateDegrees", () => $cfb765e9daff3c3a$export$91df22fbff99d059);
$parcel$export(module.exports, "skewRadians", () => $cfb765e9daff3c3a$export$985cb1d69d6a3add);
$parcel$export(module.exports, "setDashPattern", () => $cfb765e9daff3c3a$export$e0e900d241274e06);
$parcel$export(module.exports, "LineCapStyle", () => $cfb765e9daff3c3a$export$7a77bc708e50709e);
$parcel$export(module.exports, "setLineCap", () => $cfb765e9daff3c3a$export$6c65ed24e870eec);
$parcel$export(module.exports, "setGraphicsState", () => $cfb765e9daff3c3a$export$568567f665d3f3bb);
$parcel$export(module.exports, "pushGraphicsState", () => $cfb765e9daff3c3a$export$cb182c48e35739ac);
$parcel$export(module.exports, "popGraphicsState", () => $cfb765e9daff3c3a$export$10581a6f45bf75eb);
$parcel$export(module.exports, "setLineWidth", () => $cfb765e9daff3c3a$export$558e0f90d8262345);
$parcel$export(module.exports, "appendBezierCurve", () => $cfb765e9daff3c3a$export$45bd49bb15a3c5cb);
$parcel$export(module.exports, "appendQuadraticCurve", () => $cfb765e9daff3c3a$export$6f4913b22432f892);
$parcel$export(module.exports, "closePath", () => $cfb765e9daff3c3a$export$21f87e210c424cd0);
$parcel$export(module.exports, "moveTo", () => $cfb765e9daff3c3a$export$75f1ccd6dc32e80a);
$parcel$export(module.exports, "lineTo", () => $cfb765e9daff3c3a$export$73abee0cf983cb99);
$parcel$export(module.exports, "stroke", () => $cfb765e9daff3c3a$export$d9b706f8d0a70aef);
$parcel$export(module.exports, "fill", () => $cfb765e9daff3c3a$export$9563e054e6f787fb);
$parcel$export(module.exports, "fillAndStroke", () => $cfb765e9daff3c3a$export$76d37801baac10fb);
$parcel$export(module.exports, "endPath", () => $cfb765e9daff3c3a$export$d366e9c0a9bd860f);
$parcel$export(module.exports, "nextLine", () => $cfb765e9daff3c3a$export$829ffc2dbe358942);
$parcel$export(module.exports, "showText", () => $cfb765e9daff3c3a$export$778bfc3c1a2b7ba4);
$parcel$export(module.exports, "beginText", () => $cfb765e9daff3c3a$export$337b8dbf65fbb95e);
$parcel$export(module.exports, "endText", () => $cfb765e9daff3c3a$export$e3caa83a99d72806);
$parcel$export(module.exports, "setFontAndSize", () => $cfb765e9daff3c3a$export$df01d619ff6ce7f7);
$parcel$export(module.exports, "setLineHeight", () => $cfb765e9daff3c3a$export$79399e66b6bb212c);
$parcel$export(module.exports, "rotateAndSkewTextRadiansAndTranslate", () => $cfb765e9daff3c3a$export$f567083ac6aa5aa3);
$parcel$export(module.exports, "drawObject", () => $cfb765e9daff3c3a$export$382c18f8bccd9e2b);
$parcel$export(module.exports, "setFillingGrayscaleColor", () => $cfb765e9daff3c3a$export$f30201749d00f572);
$parcel$export(module.exports, "setStrokingGrayscaleColor", () => $cfb765e9daff3c3a$export$6502921112196b8f);
$parcel$export(module.exports, "setFillingRgbColor", () => $cfb765e9daff3c3a$export$f59cae633978eea7);
$parcel$export(module.exports, "setStrokingRgbColor", () => $cfb765e9daff3c3a$export$e743468c48a4fd5a);
$parcel$export(module.exports, "setFillingCmykColor", () => $cfb765e9daff3c3a$export$e836aceb3db98cc0);
$parcel$export(module.exports, "setStrokingCmykColor", () => $cfb765e9daff3c3a$export$4004b818fda831c1);
$parcel$export(module.exports, "beginMarkedContent", () => $cfb765e9daff3c3a$export$a028b403e40f1ab2);
$parcel$export(module.exports, "endMarkedContent", () => $cfb765e9daff3c3a$export$935e2334f5a50589);

var $dW4Sr = parcelRequire("dW4Sr");

var $55HYh = parcelRequire("55HYh");
parcelRequire("iT7lj");
var $5uV6d = parcelRequire("5uV6d");
var $3oHKx = parcelRequire("3oHKx");
var $cfb765e9daff3c3a$export$e0b576e7a74416cd = function() {
    return (0, $5uV6d.default).of((0, $3oHKx.default).ClipNonZero);
};
var $cfb765e9daff3c3a$export$dd6fb25f201b5a7a = function() {
    return (0, $5uV6d.default).of((0, $3oHKx.default).ClipEvenOdd);
};
/* ==================== Graphics State Operators ==================== */ var $cfb765e9daff3c3a$var$cos = Math.cos, $cfb765e9daff3c3a$var$sin = Math.sin, $cfb765e9daff3c3a$var$tan = Math.tan;
var $cfb765e9daff3c3a$export$ed5b99ee38154497 = function(a, b, c, d, e, f) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).ConcatTransformationMatrix, [
        (0, $dW4Sr.asPDFNumber)(a),
        (0, $dW4Sr.asPDFNumber)(b),
        (0, $dW4Sr.asPDFNumber)(c),
        (0, $dW4Sr.asPDFNumber)(d),
        (0, $dW4Sr.asPDFNumber)(e),
        (0, $dW4Sr.asPDFNumber)(f)
    ]);
};
var $cfb765e9daff3c3a$export$d73ee8ef04f5226a = function(xPos, yPos) {
    return $cfb765e9daff3c3a$export$ed5b99ee38154497(1, 0, 0, 1, xPos, yPos);
};
var $cfb765e9daff3c3a$export$dcdf75081b88279d = function(xPos, yPos) {
    return $cfb765e9daff3c3a$export$ed5b99ee38154497(xPos, 0, 0, yPos, 0, 0);
};
var $cfb765e9daff3c3a$export$a2ba89726971a90f = function(angle) {
    return $cfb765e9daff3c3a$export$ed5b99ee38154497($cfb765e9daff3c3a$var$cos((0, $dW4Sr.asNumber)(angle)), $cfb765e9daff3c3a$var$sin((0, $dW4Sr.asNumber)(angle)), -$cfb765e9daff3c3a$var$sin((0, $dW4Sr.asNumber)(angle)), $cfb765e9daff3c3a$var$cos((0, $dW4Sr.asNumber)(angle)), 0, 0);
};
var $cfb765e9daff3c3a$export$91df22fbff99d059 = function(angle) {
    return $cfb765e9daff3c3a$export$a2ba89726971a90f((0, $55HYh.degreesToRadians)((0, $dW4Sr.asNumber)(angle)));
};
var $cfb765e9daff3c3a$export$985cb1d69d6a3add = function(xSkewAngle, ySkewAngle) {
    return $cfb765e9daff3c3a$export$ed5b99ee38154497(1, $cfb765e9daff3c3a$var$tan((0, $dW4Sr.asNumber)(xSkewAngle)), $cfb765e9daff3c3a$var$tan((0, $dW4Sr.asNumber)(ySkewAngle)), 1, 0, 0);
};
var $cfb765e9daff3c3a$export$8ecb831b3efbb169 = function(xSkewAngle, ySkewAngle) {
    return $cfb765e9daff3c3a$export$985cb1d69d6a3add((0, $55HYh.degreesToRadians)((0, $dW4Sr.asNumber)(xSkewAngle)), (0, $55HYh.degreesToRadians)((0, $dW4Sr.asNumber)(ySkewAngle)));
};
var $cfb765e9daff3c3a$export$e0e900d241274e06 = function(dashArray, dashPhase) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).SetLineDashPattern, [
        "[" + dashArray.map((0, $dW4Sr.asPDFNumber)).join(' ') + "]",
        (0, $dW4Sr.asPDFNumber)(dashPhase)
    ]);
};
var $cfb765e9daff3c3a$export$d10d019aadfd45c7 = function() {
    return $cfb765e9daff3c3a$export$e0e900d241274e06([], 0);
};
var $cfb765e9daff3c3a$export$7a77bc708e50709e;
(function(LineCapStyle) {
    LineCapStyle[LineCapStyle["Butt"] = 0] = "Butt";
    LineCapStyle[LineCapStyle["Round"] = 1] = "Round";
    LineCapStyle[LineCapStyle["Projecting"] = 2] = "Projecting";
})($cfb765e9daff3c3a$export$7a77bc708e50709e || ($cfb765e9daff3c3a$export$7a77bc708e50709e = {}));
var $cfb765e9daff3c3a$export$6c65ed24e870eec = function(style) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).SetLineCapStyle, [
        (0, $dW4Sr.asPDFNumber)(style)
    ]);
};
var $cfb765e9daff3c3a$export$cba5d0f1cde60b86;
(function(LineJoinStyle) {
    LineJoinStyle[LineJoinStyle["Miter"] = 0] = "Miter";
    LineJoinStyle[LineJoinStyle["Round"] = 1] = "Round";
    LineJoinStyle[LineJoinStyle["Bevel"] = 2] = "Bevel";
})($cfb765e9daff3c3a$export$cba5d0f1cde60b86 || ($cfb765e9daff3c3a$export$cba5d0f1cde60b86 = {}));
var $cfb765e9daff3c3a$export$97dfb3b4509cd5bc = function(style) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).SetLineJoinStyle, [
        (0, $dW4Sr.asPDFNumber)(style)
    ]);
};
var $cfb765e9daff3c3a$export$568567f665d3f3bb = function(state) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).SetGraphicsStateParams, [
        (0, $dW4Sr.asPDFName)(state)
    ]);
};
var $cfb765e9daff3c3a$export$cb182c48e35739ac = function() {
    return (0, $5uV6d.default).of((0, $3oHKx.default).PushGraphicsState);
};
var $cfb765e9daff3c3a$export$10581a6f45bf75eb = function() {
    return (0, $5uV6d.default).of((0, $3oHKx.default).PopGraphicsState);
};
var $cfb765e9daff3c3a$export$558e0f90d8262345 = function(width) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).SetLineWidth, [
        (0, $dW4Sr.asPDFNumber)(width)
    ]);
};
var $cfb765e9daff3c3a$export$45bd49bb15a3c5cb = function(x1, y1, x2, y2, x3, y3) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).AppendBezierCurve, [
        (0, $dW4Sr.asPDFNumber)(x1),
        (0, $dW4Sr.asPDFNumber)(y1),
        (0, $dW4Sr.asPDFNumber)(x2),
        (0, $dW4Sr.asPDFNumber)(y2),
        (0, $dW4Sr.asPDFNumber)(x3),
        (0, $dW4Sr.asPDFNumber)(y3)
    ]);
};
var $cfb765e9daff3c3a$export$6f4913b22432f892 = function(x1, y1, x2, y2) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).CurveToReplicateInitialPoint, [
        (0, $dW4Sr.asPDFNumber)(x1),
        (0, $dW4Sr.asPDFNumber)(y1),
        (0, $dW4Sr.asPDFNumber)(x2),
        (0, $dW4Sr.asPDFNumber)(y2)
    ]);
};
var $cfb765e9daff3c3a$export$21f87e210c424cd0 = function() {
    return (0, $5uV6d.default).of((0, $3oHKx.default).ClosePath);
};
var $cfb765e9daff3c3a$export$75f1ccd6dc32e80a = function(xPos, yPos) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).MoveTo, [
        (0, $dW4Sr.asPDFNumber)(xPos),
        (0, $dW4Sr.asPDFNumber)(yPos)
    ]);
};
var $cfb765e9daff3c3a$export$73abee0cf983cb99 = function(xPos, yPos) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).LineTo, [
        (0, $dW4Sr.asPDFNumber)(xPos),
        (0, $dW4Sr.asPDFNumber)(yPos)
    ]);
};
var $cfb765e9daff3c3a$export$405b065079b7caf2 = function(xPos, yPos, width, height) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).AppendRectangle, [
        (0, $dW4Sr.asPDFNumber)(xPos),
        (0, $dW4Sr.asPDFNumber)(yPos),
        (0, $dW4Sr.asPDFNumber)(width),
        (0, $dW4Sr.asPDFNumber)(height)
    ]);
};
var $cfb765e9daff3c3a$export$dd4f28cef696bc7d = function(xPos, yPos, size) {
    return $cfb765e9daff3c3a$export$405b065079b7caf2(xPos, yPos, size, size);
};
var $cfb765e9daff3c3a$export$d9b706f8d0a70aef = function() {
    return (0, $5uV6d.default).of((0, $3oHKx.default).StrokePath);
};
var $cfb765e9daff3c3a$export$9563e054e6f787fb = function() {
    return (0, $5uV6d.default).of((0, $3oHKx.default).FillNonZero);
};
var $cfb765e9daff3c3a$export$76d37801baac10fb = function() {
    return (0, $5uV6d.default).of((0, $3oHKx.default).FillNonZeroAndStroke);
};
var $cfb765e9daff3c3a$export$d366e9c0a9bd860f = function() {
    return (0, $5uV6d.default).of((0, $3oHKx.default).EndPath);
};
var $cfb765e9daff3c3a$export$829ffc2dbe358942 = function() {
    return (0, $5uV6d.default).of((0, $3oHKx.default).NextLine);
};
var $cfb765e9daff3c3a$export$b84c1833e225e397 = function(x, y) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).MoveText, [
        (0, $dW4Sr.asPDFNumber)(x),
        (0, $dW4Sr.asPDFNumber)(y)
    ]);
};
var $cfb765e9daff3c3a$export$778bfc3c1a2b7ba4 = function(text) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).ShowText, [
        text
    ]);
};
var $cfb765e9daff3c3a$export$337b8dbf65fbb95e = function() {
    return (0, $5uV6d.default).of((0, $3oHKx.default).BeginText);
};
var $cfb765e9daff3c3a$export$e3caa83a99d72806 = function() {
    return (0, $5uV6d.default).of((0, $3oHKx.default).EndText);
};
var $cfb765e9daff3c3a$export$df01d619ff6ce7f7 = function(name, size) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).SetFontAndSize, [
        (0, $dW4Sr.asPDFName)(name),
        (0, $dW4Sr.asPDFNumber)(size)
    ]);
};
var $cfb765e9daff3c3a$export$710392ce2617f080 = function(spacing) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).SetCharacterSpacing, [
        (0, $dW4Sr.asPDFNumber)(spacing)
    ]);
};
var $cfb765e9daff3c3a$export$a2801242b2f8967d = function(spacing) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).SetWordSpacing, [
        (0, $dW4Sr.asPDFNumber)(spacing)
    ]);
};
var $cfb765e9daff3c3a$export$20dbb065c447b4da = function(squeeze) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).SetTextHorizontalScaling, [
        (0, $dW4Sr.asPDFNumber)(squeeze)
    ]);
};
var $cfb765e9daff3c3a$export$79399e66b6bb212c = function(lineHeight) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).SetTextLineHeight, [
        (0, $dW4Sr.asPDFNumber)(lineHeight)
    ]);
};
var $cfb765e9daff3c3a$export$ad1653459b07f70c = function(rise) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).SetTextRise, [
        (0, $dW4Sr.asPDFNumber)(rise)
    ]);
};
var $cfb765e9daff3c3a$export$ca45e4ab114d4814;
(function(TextRenderingMode) {
    TextRenderingMode[TextRenderingMode["Fill"] = 0] = "Fill";
    TextRenderingMode[TextRenderingMode["Outline"] = 1] = "Outline";
    TextRenderingMode[TextRenderingMode["FillAndOutline"] = 2] = "FillAndOutline";
    TextRenderingMode[TextRenderingMode["Invisible"] = 3] = "Invisible";
    TextRenderingMode[TextRenderingMode["FillAndClip"] = 4] = "FillAndClip";
    TextRenderingMode[TextRenderingMode["OutlineAndClip"] = 5] = "OutlineAndClip";
    TextRenderingMode[TextRenderingMode["FillAndOutlineAndClip"] = 6] = "FillAndOutlineAndClip";
    TextRenderingMode[TextRenderingMode["Clip"] = 7] = "Clip";
})($cfb765e9daff3c3a$export$ca45e4ab114d4814 || ($cfb765e9daff3c3a$export$ca45e4ab114d4814 = {}));
var $cfb765e9daff3c3a$export$99f0dc2c4cb099ab = function(mode) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).SetTextRenderingMode, [
        (0, $dW4Sr.asPDFNumber)(mode)
    ]);
};
var $cfb765e9daff3c3a$export$d3656d656af31043 = function(a, b, c, d, e, f) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).SetTextMatrix, [
        (0, $dW4Sr.asPDFNumber)(a),
        (0, $dW4Sr.asPDFNumber)(b),
        (0, $dW4Sr.asPDFNumber)(c),
        (0, $dW4Sr.asPDFNumber)(d),
        (0, $dW4Sr.asPDFNumber)(e),
        (0, $dW4Sr.asPDFNumber)(f)
    ]);
};
var $cfb765e9daff3c3a$export$f567083ac6aa5aa3 = function(rotationAngle, xSkewAngle, ySkewAngle, x, y) {
    return $cfb765e9daff3c3a$export$d3656d656af31043($cfb765e9daff3c3a$var$cos((0, $dW4Sr.asNumber)(rotationAngle)), $cfb765e9daff3c3a$var$sin((0, $dW4Sr.asNumber)(rotationAngle)) + $cfb765e9daff3c3a$var$tan((0, $dW4Sr.asNumber)(xSkewAngle)), -$cfb765e9daff3c3a$var$sin((0, $dW4Sr.asNumber)(rotationAngle)) + $cfb765e9daff3c3a$var$tan((0, $dW4Sr.asNumber)(ySkewAngle)), $cfb765e9daff3c3a$var$cos((0, $dW4Sr.asNumber)(rotationAngle)), x, y);
};
var $cfb765e9daff3c3a$export$909384d9b9d39aff = function(rotationAngle, xSkewAngle, ySkewAngle, x, y) {
    return $cfb765e9daff3c3a$export$f567083ac6aa5aa3((0, $55HYh.degreesToRadians)((0, $dW4Sr.asNumber)(rotationAngle)), (0, $55HYh.degreesToRadians)((0, $dW4Sr.asNumber)(xSkewAngle)), (0, $55HYh.degreesToRadians)((0, $dW4Sr.asNumber)(ySkewAngle)), x, y);
};
var $cfb765e9daff3c3a$export$382c18f8bccd9e2b = function(name) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).DrawObject, [
        (0, $dW4Sr.asPDFName)(name)
    ]);
};
var $cfb765e9daff3c3a$export$f30201749d00f572 = function(gray) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).NonStrokingColorGray, [
        (0, $dW4Sr.asPDFNumber)(gray)
    ]);
};
var $cfb765e9daff3c3a$export$6502921112196b8f = function(gray) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).StrokingColorGray, [
        (0, $dW4Sr.asPDFNumber)(gray)
    ]);
};
var $cfb765e9daff3c3a$export$f59cae633978eea7 = function(red, green, blue) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).NonStrokingColorRgb, [
        (0, $dW4Sr.asPDFNumber)(red),
        (0, $dW4Sr.asPDFNumber)(green),
        (0, $dW4Sr.asPDFNumber)(blue)
    ]);
};
var $cfb765e9daff3c3a$export$e743468c48a4fd5a = function(red, green, blue) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).StrokingColorRgb, [
        (0, $dW4Sr.asPDFNumber)(red),
        (0, $dW4Sr.asPDFNumber)(green),
        (0, $dW4Sr.asPDFNumber)(blue)
    ]);
};
var $cfb765e9daff3c3a$export$e836aceb3db98cc0 = function(cyan, magenta, yellow, key) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).NonStrokingColorCmyk, [
        (0, $dW4Sr.asPDFNumber)(cyan),
        (0, $dW4Sr.asPDFNumber)(magenta),
        (0, $dW4Sr.asPDFNumber)(yellow),
        (0, $dW4Sr.asPDFNumber)(key)
    ]);
};
var $cfb765e9daff3c3a$export$4004b818fda831c1 = function(cyan, magenta, yellow, key) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).StrokingColorCmyk, [
        (0, $dW4Sr.asPDFNumber)(cyan),
        (0, $dW4Sr.asPDFNumber)(magenta),
        (0, $dW4Sr.asPDFNumber)(yellow),
        (0, $dW4Sr.asPDFNumber)(key)
    ]);
};
var $cfb765e9daff3c3a$export$a028b403e40f1ab2 = function(tag) {
    return (0, $5uV6d.default).of((0, $3oHKx.default).BeginMarkedContent, [
        (0, $dW4Sr.asPDFName)(tag)
    ]);
};
var $cfb765e9daff3c3a$export$935e2334f5a50589 = function() {
    return (0, $5uV6d.default).of((0, $3oHKx.default).EndMarkedContent);
};

});
parcelRegister("dW4Sr", function(module, exports) {

$parcel$export(module.exports, "asPDFName", () => $a25479a44f824b27$export$69d5e1b305482e08);
$parcel$export(module.exports, "asPDFNumber", () => $a25479a44f824b27$export$fb5b5e76a3a5c568);
$parcel$export(module.exports, "asNumber", () => $a25479a44f824b27$export$37576b9ba69b50db);
parcelRequire("iT7lj");
var $dPHSK = parcelRequire("dPHSK");
var $j04jt = parcelRequire("j04jt");
var $a25479a44f824b27$export$69d5e1b305482e08 = function(name) {
    return name instanceof (0, $dPHSK.default) ? name : (0, $dPHSK.default).of(name);
};
var $a25479a44f824b27$export$fb5b5e76a3a5c568 = function(num) {
    return num instanceof (0, $j04jt.default) ? num : (0, $j04jt.default).of(num);
};
var $a25479a44f824b27$export$37576b9ba69b50db = function(num) {
    return num instanceof (0, $j04jt.default) ? num.asNumber() : num;
};

});
parcelRegister("iT7lj", function(module, exports) {
$parcel$export(module.exports, "MethodNotImplementedError", () => (parcelRequire("nAWRe")).MethodNotImplementedError);
$parcel$export(module.exports, "PageEmbeddingMismatchedContextError", () => (parcelRequire("nAWRe")).PageEmbeddingMismatchedContextError);
$parcel$export(module.exports, "UnexpectedObjectTypeError", () => (parcelRequire("nAWRe")).UnexpectedObjectTypeError);
$parcel$export(module.exports, "AnnotationFlags", () => (parcelRequire("ckfWn")).AnnotationFlags);
$parcel$export(module.exports, "PDFWidgetAnnotation", () => (parcelRequire("7ds0z")).default);
$parcel$export(module.exports, "AcroButtonFlags", () => (parcelRequire("d5IrD")).AcroButtonFlags);
$parcel$export(module.exports, "AcroChoiceFlags", () => (parcelRequire("d5IrD")).AcroChoiceFlags);
$parcel$export(module.exports, "AcroFieldFlags", () => (parcelRequire("d5IrD")).AcroFieldFlags);
$parcel$export(module.exports, "AcroTextFlags", () => (parcelRequire("d5IrD")).AcroTextFlags);
$parcel$export(module.exports, "createPDFAcroFields", () => (parcelRequire("gkGMc")).createPDFAcroFields);
$parcel$export(module.exports, "PDFAcroCheckBox", () => (parcelRequire("lmORt")).default);
$parcel$export(module.exports, "PDFAcroComboBox", () => (parcelRequire("4vDg3")).default);
$parcel$export(module.exports, "PDFAcroForm", () => (parcelRequire("flrAV")).default);
$parcel$export(module.exports, "PDFAcroListBox", () => (parcelRequire("gEqSi")).default);
$parcel$export(module.exports, "PDFAcroNonTerminal", () => (parcelRequire("dP7Ar")).default);
$parcel$export(module.exports, "PDFAcroPushButton", () => (parcelRequire("1757u")).default);
$parcel$export(module.exports, "PDFAcroRadioButton", () => (parcelRequire("hpItd")).default);
$parcel$export(module.exports, "PDFAcroSignature", () => (parcelRequire("7hDvO")).default);
$parcel$export(module.exports, "PDFAcroTerminal", () => (parcelRequire("64Z70")).default);
$parcel$export(module.exports, "PDFAcroText", () => (parcelRequire("clInn")).default);

$parcel$export(module.exports, "PDFContext", () => (parcelRequire("kl4jO")).default);
$parcel$export(module.exports, "PDFObjectCopier", () => (parcelRequire("k5Uzj")).default);
$parcel$export(module.exports, "PDFWriter", () => (parcelRequire("5HlMk")).default);
$parcel$export(module.exports, "PDFStreamWriter", () => (parcelRequire("7YdvF")).default);
$parcel$export(module.exports, "StandardFontEmbedder", () => (parcelRequire("jwvE5")).default);
$parcel$export(module.exports, "CustomFontEmbedder", () => (parcelRequire("gCJZ9")).default);
$parcel$export(module.exports, "CustomFontSubsetEmbedder", () => (parcelRequire("6uXKX")).default);
$parcel$export(module.exports, "JpegEmbedder", () => (parcelRequire("fmxHr")).default);
$parcel$export(module.exports, "PngEmbedder", () => (parcelRequire("atfwl")).default);
$parcel$export(module.exports, "PDFPageEmbedder", () => (parcelRequire("h9IbG")).default);
$parcel$export(module.exports, "PDFNumber", () => (parcelRequire("j04jt")).default);
$parcel$export(module.exports, "PDFString", () => (parcelRequire("8dCYu")).default);
$parcel$export(module.exports, "PDFHexString", () => (parcelRequire("jWFiV")).default);
$parcel$export(module.exports, "PDFName", () => (parcelRequire("dPHSK")).default);
$parcel$export(module.exports, "PDFArray", () => (parcelRequire("8auL6")).default);
$parcel$export(module.exports, "PDFDict", () => (parcelRequire("brir8")).default);
$parcel$export(module.exports, "PDFRef", () => (parcelRequire("kHzkO")).default);
$parcel$export(module.exports, "PDFStream", () => (parcelRequire("4CgUJ")).default);
$parcel$export(module.exports, "PDFCatalog", () => (parcelRequire("b3l66")).default);
$parcel$export(module.exports, "PDFContentStream", () => (parcelRequire("9EODP")).default);
$parcel$export(module.exports, "PDFPageTree", () => (parcelRequire("4oH3u")).default);
$parcel$export(module.exports, "PDFPageLeaf", () => (parcelRequire("eAof5")).default);
$parcel$export(module.exports, "PDFOperator", () => (parcelRequire("5uV6d")).default);
$parcel$export(module.exports, "PDFOperatorNames", () => (parcelRequire("3oHKx")).default);
$parcel$export(module.exports, "PDFParser", () => (parcelRequire("14nUL")).default);
parcelRequire("nAWRe");

var $8zvel = parcelRequire("8zvel");

var $kl4jO = parcelRequire("kl4jO");

var $k5Uzj = parcelRequire("k5Uzj");

var $5HlMk = parcelRequire("5HlMk");

var $7YdvF = parcelRequire("7YdvF");

var $eHlB9 = parcelRequire("eHlB9");

var $4S3gv = parcelRequire("4S3gv");

var $fXb4L = parcelRequire("fXb4L");

var $Vy0LI = parcelRequire("Vy0LI");

var $jwvE5 = parcelRequire("jwvE5");

var $gCJZ9 = parcelRequire("gCJZ9");

var $6uXKX = parcelRequire("6uXKX");

var $k8kub = parcelRequire("k8kub");

var $fmxHr = parcelRequire("fmxHr");

var $atfwl = parcelRequire("atfwl");

var $h9IbG = parcelRequire("h9IbG");

var $cpTWE = parcelRequire("cpTWE");

var $11c5J = parcelRequire("11c5J");

var $8gQNC = parcelRequire("8gQNC");

var $j04jt = parcelRequire("j04jt");

var $8dCYu = parcelRequire("8dCYu");

var $jWFiV = parcelRequire("jWFiV");

var $dPHSK = parcelRequire("dPHSK");

var $eTKUN = parcelRequire("eTKUN");

var $8auL6 = parcelRequire("8auL6");

var $brir8 = parcelRequire("brir8");

var $kHzkO = parcelRequire("kHzkO");

var $eTWtL = parcelRequire("eTWtL");

var $4CgUJ = parcelRequire("4CgUJ");

var $kx2r4 = parcelRequire("kx2r4");

var $b3l66 = parcelRequire("b3l66");

var $9EODP = parcelRequire("9EODP");

var $eMjAF = parcelRequire("eMjAF");

var $8nK9n = parcelRequire("8nK9n");

var $4oH3u = parcelRequire("4oH3u");

var $eAof5 = parcelRequire("eAof5");

var $3T8kK = parcelRequire("3T8kK");

var $5uV6d = parcelRequire("5uV6d");

var $3oHKx = parcelRequire("3oHKx");

var $3QRZR = parcelRequire("3QRZR");

var $7yUXZ = parcelRequire("7yUXZ");

var $14nUL = parcelRequire("14nUL");

var $b1gaC = parcelRequire("b1gaC");

var $dLMRX = parcelRequire("dLMRX");
parcelRequire("6anj6");
parcelRequire("hO9YF");

});
parcelRegister("nAWRe", function(module, exports) {

$parcel$export(module.exports, "MethodNotImplementedError", () => $046ecf435f71da9c$export$b549a6777be1bc17);
$parcel$export(module.exports, "PrivateConstructorError", () => $046ecf435f71da9c$export$20e18464cd4b43a);
$parcel$export(module.exports, "UnexpectedObjectTypeError", () => $046ecf435f71da9c$export$ab03f98a62c22159);
$parcel$export(module.exports, "UnsupportedEncodingError", () => $046ecf435f71da9c$export$5de8fe8a6031fb92);
$parcel$export(module.exports, "ReparseError", () => $046ecf435f71da9c$export$df523155c7c35e23);
$parcel$export(module.exports, "MissingPageContentsEmbeddingError", () => $046ecf435f71da9c$export$48e9be38307e3c37);
$parcel$export(module.exports, "UnrecognizedStreamTypeError", () => $046ecf435f71da9c$export$f8343077e7fd3a86);
$parcel$export(module.exports, "PageEmbeddingMismatchedContextError", () => $046ecf435f71da9c$export$22c55e00f6509a2c);
$parcel$export(module.exports, "PDFArrayIsNotRectangleError", () => $046ecf435f71da9c$export$a76bae7761f3d760);
$parcel$export(module.exports, "InvalidPDFDateStringError", () => $046ecf435f71da9c$export$8638e3ad1edceac8);
$parcel$export(module.exports, "InvalidTargetIndexError", () => $046ecf435f71da9c$export$845c01ec1ddb8877);
$parcel$export(module.exports, "CorruptPageTreeError", () => $046ecf435f71da9c$export$1012d63cae1523f8);
$parcel$export(module.exports, "IndexOutOfBoundsError", () => $046ecf435f71da9c$export$19a77d83c7473130);
$parcel$export(module.exports, "InvalidAcroFieldValueError", () => $046ecf435f71da9c$export$d39c49ea9be644ec);
$parcel$export(module.exports, "MultiSelectValueError", () => $046ecf435f71da9c$export$6606fe23b6c4542c);
$parcel$export(module.exports, "MissingDAEntryError", () => $046ecf435f71da9c$export$dfa101de065b3cc2);
$parcel$export(module.exports, "MissingTfOperatorError", () => $046ecf435f71da9c$export$b5ee390f1267b133);
$parcel$export(module.exports, "NumberParsingError", () => $046ecf435f71da9c$export$81adf4c464255546);
$parcel$export(module.exports, "NextByteAssertionError", () => $046ecf435f71da9c$export$fda6cb3cf0fe0c76);
$parcel$export(module.exports, "PDFObjectParsingError", () => $046ecf435f71da9c$export$b8907968b8d7f502);
$parcel$export(module.exports, "PDFInvalidObjectParsingError", () => $046ecf435f71da9c$export$72474f06fb3a1c6b);
$parcel$export(module.exports, "PDFStreamParsingError", () => $046ecf435f71da9c$export$b1a91b84397f50d6);
$parcel$export(module.exports, "UnbalancedParenthesisError", () => $046ecf435f71da9c$export$92803ff0e03167f9);
$parcel$export(module.exports, "StalledParserError", () => $046ecf435f71da9c$export$b934c61834236c8);
$parcel$export(module.exports, "MissingPDFHeaderError", () => $046ecf435f71da9c$export$cf6bd1b11dd05d74);
$parcel$export(module.exports, "MissingKeywordError", () => $046ecf435f71da9c$export$bc024c15c94be864);

var $cOQTW = parcelRequire("cOQTW");
parcelRequire("fvYKZ");
var $4ISq8 = parcelRequire("4ISq8");
var $046ecf435f71da9c$export$b549a6777be1bc17 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(MethodNotImplementedError, _super);
    function MethodNotImplementedError(className, methodName) {
        var _this = this;
        var msg = "Method " + className + "." + methodName + "() not implemented";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MethodNotImplementedError;
}(Error);
var $046ecf435f71da9c$export$20e18464cd4b43a = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PrivateConstructorError, _super);
    function PrivateConstructorError(className) {
        var _this = this;
        var msg = "Cannot construct " + className + " - it has a private constructor";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return PrivateConstructorError;
}(Error);
var $046ecf435f71da9c$export$ab03f98a62c22159 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(UnexpectedObjectTypeError, _super);
    function UnexpectedObjectTypeError(expected, actual) {
        var _this = this;
        var name = function(t) {
            var _a, _b;
            return (_a = t === null || t === void 0 ? void 0 : t.name) !== null && _a !== void 0 ? _a : (_b = t === null || t === void 0 ? void 0 : t.constructor) === null || _b === void 0 ? void 0 : _b.name;
        };
        var expectedTypes = Array.isArray(expected) ? expected.map(name) : [
            name(expected)
        ];
        var msg = "Expected instance of " + expectedTypes.join(' or ') + ", " + ("but got instance of " + (actual ? name(actual) : actual));
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return UnexpectedObjectTypeError;
}(Error);
var $046ecf435f71da9c$export$5de8fe8a6031fb92 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(UnsupportedEncodingError, _super);
    function UnsupportedEncodingError(encoding) {
        var _this = this;
        var msg = encoding + " stream encoding not supported";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return UnsupportedEncodingError;
}(Error);
var $046ecf435f71da9c$export$df523155c7c35e23 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(ReparseError, _super);
    function ReparseError(className, methodName) {
        var _this = this;
        var msg = "Cannot call " + className + "." + methodName + "() more than once";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return ReparseError;
}(Error);
var $046ecf435f71da9c$export$3afc9350d4666214 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(MissingCatalogError, _super);
    function MissingCatalogError(ref) {
        var _this = this;
        var msg = "Missing catalog (ref=" + ref + ")";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingCatalogError;
}(Error);
var $046ecf435f71da9c$export$48e9be38307e3c37 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(MissingPageContentsEmbeddingError, _super);
    function MissingPageContentsEmbeddingError() {
        var _this = this;
        var msg = "Can't embed page with missing Contents";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingPageContentsEmbeddingError;
}(Error);
var $046ecf435f71da9c$export$f8343077e7fd3a86 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(UnrecognizedStreamTypeError, _super);
    function UnrecognizedStreamTypeError(stream) {
        var _a, _b, _c;
        var _this = this;
        var streamType = (_c = (_b = (_a = stream === null || stream === void 0 ? void 0 : stream.contructor) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : stream === null || stream === void 0 ? void 0 : stream.name) !== null && _c !== void 0 ? _c : stream;
        var msg = "Unrecognized stream type: " + streamType;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return UnrecognizedStreamTypeError;
}(Error);
var $046ecf435f71da9c$export$22c55e00f6509a2c = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PageEmbeddingMismatchedContextError, _super);
    function PageEmbeddingMismatchedContextError() {
        var _this = this;
        var msg = "Found mismatched contexts while embedding pages. All pages in the array passed to `PDFDocument.embedPages()` must be from the same document.";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return PageEmbeddingMismatchedContextError;
}(Error);
var $046ecf435f71da9c$export$a76bae7761f3d760 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFArrayIsNotRectangleError, _super);
    function PDFArrayIsNotRectangleError(size) {
        var _this = this;
        var msg = "Attempted to convert PDFArray with " + size + " elements to rectangle, but must have exactly 4 elements.";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return PDFArrayIsNotRectangleError;
}(Error);
var $046ecf435f71da9c$export$8638e3ad1edceac8 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(InvalidPDFDateStringError, _super);
    function InvalidPDFDateStringError(value) {
        var _this = this;
        var msg = "Attempted to convert \"" + value + "\" to a date, but it does not match the PDF date string format.";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidPDFDateStringError;
}(Error);
var $046ecf435f71da9c$export$845c01ec1ddb8877 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(InvalidTargetIndexError, _super);
    function InvalidTargetIndexError(targetIndex, Count) {
        var _this = this;
        var msg = "Invalid targetIndex specified: targetIndex=" + targetIndex + " must be less than Count=" + Count;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidTargetIndexError;
}(Error);
var $046ecf435f71da9c$export$1012d63cae1523f8 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(CorruptPageTreeError, _super);
    function CorruptPageTreeError(targetIndex, operation) {
        var _this = this;
        var msg = "Failed to " + operation + " at targetIndex=" + targetIndex + " due to corrupt page tree: It is likely that one or more 'Count' entries are invalid";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return CorruptPageTreeError;
}(Error);
var $046ecf435f71da9c$export$19a77d83c7473130 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(IndexOutOfBoundsError, _super);
    function IndexOutOfBoundsError(index, min, max) {
        var _this = this;
        var msg = "index should be at least " + min + " and at most " + max + ", but was actually " + index;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return IndexOutOfBoundsError;
}(Error);
var $046ecf435f71da9c$export$d39c49ea9be644ec = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(InvalidAcroFieldValueError, _super);
    function InvalidAcroFieldValueError() {
        var _this = this;
        var msg = "Attempted to set invalid field value";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidAcroFieldValueError;
}(Error);
var $046ecf435f71da9c$export$6606fe23b6c4542c = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(MultiSelectValueError, _super);
    function MultiSelectValueError() {
        var _this = this;
        var msg = "Attempted to select multiple values for single-select field";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MultiSelectValueError;
}(Error);
var $046ecf435f71da9c$export$dfa101de065b3cc2 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(MissingDAEntryError, _super);
    function MissingDAEntryError(fieldName) {
        var _this = this;
        var msg = "No /DA (default appearance) entry found for field: " + fieldName;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingDAEntryError;
}(Error);
var $046ecf435f71da9c$export$b5ee390f1267b133 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(MissingTfOperatorError, _super);
    function MissingTfOperatorError(fieldName) {
        var _this = this;
        var msg = "No Tf operator found for DA of field: " + fieldName;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingTfOperatorError;
}(Error);
var $046ecf435f71da9c$export$81adf4c464255546 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(NumberParsingError, _super);
    function NumberParsingError(pos, value) {
        var _this = this;
        var msg = "Failed to parse number " + ("(line:" + pos.line + " col:" + pos.column + " offset=" + pos.offset + "): \"" + value + "\"");
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return NumberParsingError;
}(Error);
var $046ecf435f71da9c$export$fd202455a19cb700 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFParsingError, _super);
    function PDFParsingError(pos, details) {
        var _this = this;
        var msg = "Failed to parse PDF document " + ("(line:" + pos.line + " col:" + pos.column + " offset=" + pos.offset + "): " + details);
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return PDFParsingError;
}(Error);
var $046ecf435f71da9c$export$fda6cb3cf0fe0c76 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(NextByteAssertionError, _super);
    function NextByteAssertionError(pos, expectedByte, actualByte) {
        var _this = this;
        var msg = "Expected next byte to be " + expectedByte + " but it was actually " + actualByte;
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return NextByteAssertionError;
}($046ecf435f71da9c$export$fd202455a19cb700);
var $046ecf435f71da9c$export$b8907968b8d7f502 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFObjectParsingError, _super);
    function PDFObjectParsingError(pos, byte) {
        var _this = this;
        var msg = "Failed to parse PDF object starting with the following byte: " + byte;
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return PDFObjectParsingError;
}($046ecf435f71da9c$export$fd202455a19cb700);
var $046ecf435f71da9c$export$72474f06fb3a1c6b = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFInvalidObjectParsingError, _super);
    function PDFInvalidObjectParsingError(pos) {
        var _this = this;
        var msg = "Failed to parse invalid PDF object";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return PDFInvalidObjectParsingError;
}($046ecf435f71da9c$export$fd202455a19cb700);
var $046ecf435f71da9c$export$b1a91b84397f50d6 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFStreamParsingError, _super);
    function PDFStreamParsingError(pos) {
        var _this = this;
        var msg = "Failed to parse PDF stream";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return PDFStreamParsingError;
}($046ecf435f71da9c$export$fd202455a19cb700);
var $046ecf435f71da9c$export$92803ff0e03167f9 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(UnbalancedParenthesisError, _super);
    function UnbalancedParenthesisError(pos) {
        var _this = this;
        var msg = "Failed to parse PDF literal string due to unbalanced parenthesis";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return UnbalancedParenthesisError;
}($046ecf435f71da9c$export$fd202455a19cb700);
var $046ecf435f71da9c$export$b934c61834236c8 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(StalledParserError, _super);
    function StalledParserError(pos) {
        var _this = this;
        var msg = "Parser stalled";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return StalledParserError;
}($046ecf435f71da9c$export$fd202455a19cb700);
var $046ecf435f71da9c$export$cf6bd1b11dd05d74 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(MissingPDFHeaderError, _super);
    function MissingPDFHeaderError(pos) {
        var _this = this;
        var msg = "No PDF header found";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return MissingPDFHeaderError;
}($046ecf435f71da9c$export$fd202455a19cb700);
var $046ecf435f71da9c$export$bc024c15c94be864 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(MissingKeywordError, _super);
    function MissingKeywordError(pos, keyword) {
        var _this = this;
        var msg = "Did not find expected keyword '" + (0, $4ISq8.arrayAsString)(keyword) + "'";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return MissingKeywordError;
}($046ecf435f71da9c$export$fd202455a19cb700);

});
parcelRegister("fvYKZ", function(module, exports) {
$parcel$export(module.exports, "arrayAsString", () => (parcelRequire("4ISq8")).arrayAsString);
$parcel$export(module.exports, "byAscendingId", () => (parcelRequire("4ISq8")).byAscendingId);
$parcel$export(module.exports, "canBeConvertedToUint8Array", () => (parcelRequire("4ISq8")).canBeConvertedToUint8Array);
$parcel$export(module.exports, "last", () => (parcelRequire("4ISq8")).last);
$parcel$export(module.exports, "mergeIntoTypedArray", () => (parcelRequire("4ISq8")).mergeIntoTypedArray);
$parcel$export(module.exports, "mergeUint8Arrays", () => (parcelRequire("4ISq8")).mergeUint8Arrays);
$parcel$export(module.exports, "pluckIndices", () => (parcelRequire("4ISq8")).pluckIndices);
$parcel$export(module.exports, "range", () => (parcelRequire("4ISq8")).range);
$parcel$export(module.exports, "reverseArray", () => (parcelRequire("4ISq8")).reverseArray);
$parcel$export(module.exports, "sortedUniq", () => (parcelRequire("4ISq8")).sortedUniq);
$parcel$export(module.exports, "sum", () => (parcelRequire("4ISq8")).sum);
$parcel$export(module.exports, "toUint8Array", () => (parcelRequire("4ISq8")).toUint8Array);
$parcel$export(module.exports, "typedArrayFor", () => (parcelRequire("4ISq8")).typedArrayFor);
$parcel$export(module.exports, "waitForTick", () => (parcelRequire("ggjMi")).waitForTick);
$parcel$export(module.exports, "breakTextIntoLines", () => (parcelRequire("7Kmy8")).breakTextIntoLines);
$parcel$export(module.exports, "charAtIndex", () => (parcelRequire("7Kmy8")).charAtIndex);
$parcel$export(module.exports, "charFromCode", () => (parcelRequire("7Kmy8")).charFromCode);
$parcel$export(module.exports, "charFromHexCode", () => (parcelRequire("7Kmy8")).charFromHexCode);
$parcel$export(module.exports, "charSplit", () => (parcelRequire("7Kmy8")).charSplit);
$parcel$export(module.exports, "cleanText", () => (parcelRequire("7Kmy8")).cleanText);
$parcel$export(module.exports, "copyStringIntoBuffer", () => (parcelRequire("7Kmy8")).copyStringIntoBuffer);
$parcel$export(module.exports, "findLastMatch", () => (parcelRequire("7Kmy8")).findLastMatch);
$parcel$export(module.exports, "lineSplit", () => (parcelRequire("7Kmy8")).lineSplit);
$parcel$export(module.exports, "mergeLines", () => (parcelRequire("7Kmy8")).mergeLines);
$parcel$export(module.exports, "padStart", () => (parcelRequire("7Kmy8")).padStart);
$parcel$export(module.exports, "parseDate", () => (parcelRequire("7Kmy8")).parseDate);
$parcel$export(module.exports, "toCharCode", () => (parcelRequire("7Kmy8")).toCharCode);
$parcel$export(module.exports, "toCodePoint", () => (parcelRequire("7Kmy8")).toCodePoint);
$parcel$export(module.exports, "toHexString", () => (parcelRequire("7Kmy8")).toHexString);
$parcel$export(module.exports, "toHexStringOfMinLength", () => (parcelRequire("7Kmy8")).toHexStringOfMinLength);
$parcel$export(module.exports, "hasUtf16BOM", () => (parcelRequire("ejAvl")).hasUtf16BOM);
$parcel$export(module.exports, "utf16Decode", () => (parcelRequire("ejAvl")).utf16Decode);
$parcel$export(module.exports, "utf16Encode", () => (parcelRequire("ejAvl")).utf16Encode);
$parcel$export(module.exports, "bytesFor", () => (parcelRequire("hiEdU")).bytesFor);
$parcel$export(module.exports, "numberToString", () => (parcelRequire("hiEdU")).numberToString);
$parcel$export(module.exports, "sizeInBytes", () => (parcelRequire("hiEdU")).sizeInBytes);
$parcel$export(module.exports, "error", () => (parcelRequire("hP0hy")).error);
$parcel$export(module.exports, "encodeToBase64", () => (parcelRequire("fZ8o5")).encodeToBase64);
$parcel$export(module.exports, "isStandardFont", () => (parcelRequire("cbIAG")).isStandardFont);
$parcel$export(module.exports, "rectanglesAreEqual", () => (parcelRequire("cbIAG")).rectanglesAreEqual);
$parcel$export(module.exports, "assertEachIs", () => (parcelRequire("j0tvB")).assertEachIs);
$parcel$export(module.exports, "assertInteger", () => (parcelRequire("j0tvB")).assertInteger);
$parcel$export(module.exports, "assertIs", () => (parcelRequire("j0tvB")).assertIs);
$parcel$export(module.exports, "assertIsOneOf", () => (parcelRequire("j0tvB")).assertIsOneOf);
$parcel$export(module.exports, "assertIsOneOfOrUndefined", () => (parcelRequire("j0tvB")).assertIsOneOfOrUndefined);
$parcel$export(module.exports, "assertIsSubset", () => (parcelRequire("j0tvB")).assertIsSubset);
$parcel$export(module.exports, "assertMultiple", () => (parcelRequire("j0tvB")).assertMultiple);
$parcel$export(module.exports, "assertOrUndefined", () => (parcelRequire("j0tvB")).assertOrUndefined);
$parcel$export(module.exports, "assertPositive", () => (parcelRequire("j0tvB")).assertPositive);
$parcel$export(module.exports, "assertRange", () => (parcelRequire("j0tvB")).assertRange);
$parcel$export(module.exports, "assertRangeOrUndefined", () => (parcelRequire("j0tvB")).assertRangeOrUndefined);
$parcel$export(module.exports, "pdfDocEncodingDecode", () => (parcelRequire("iSBb0")).pdfDocEncodingDecode);

$parcel$export(module.exports, "Cache", () => (parcelRequire("clYSv")).default);
parcelRequire("4ISq8");
parcelRequire("ggjMi");
parcelRequire("7Kmy8");
parcelRequire("ejAvl");
parcelRequire("hiEdU");
parcelRequire("hP0hy");
parcelRequire("fZ8o5");
parcelRequire("cbIAG");
parcelRequire("j0tvB");
parcelRequire("iSBb0");

var $clYSv = parcelRequire("clYSv");

});
parcelRegister("4ISq8", function(module, exports) {

$parcel$export(module.exports, "last", () => $37057c446bb711eb$export$4c7897fafd92b108);
$parcel$export(module.exports, "typedArrayFor", () => $37057c446bb711eb$export$98b44e66722b6f4d);
$parcel$export(module.exports, "mergeIntoTypedArray", () => $37057c446bb711eb$export$8907b5381cbcd9a7);
$parcel$export(module.exports, "mergeUint8Arrays", () => $37057c446bb711eb$export$99cee7ee2de7e6e4);
$parcel$export(module.exports, "arrayAsString", () => $37057c446bb711eb$export$5f8f9664fe5c5f14);
$parcel$export(module.exports, "byAscendingId", () => $37057c446bb711eb$export$55b6b1f56c6e1ba5);
$parcel$export(module.exports, "sortedUniq", () => $37057c446bb711eb$export$720e3b5aefb27114);
$parcel$export(module.exports, "reverseArray", () => $37057c446bb711eb$export$c9b97e771c4a8302);
$parcel$export(module.exports, "sum", () => $37057c446bb711eb$export$8a63f25cc62965f1);
$parcel$export(module.exports, "range", () => $37057c446bb711eb$export$d02631cccf789723);
$parcel$export(module.exports, "pluckIndices", () => $37057c446bb711eb$export$279d041ff3481d88);
$parcel$export(module.exports, "canBeConvertedToUint8Array", () => $37057c446bb711eb$export$20e9c5ed92218c4b);
$parcel$export(module.exports, "toUint8Array", () => $37057c446bb711eb$export$73470fd2221e6aef);

var $fZ8o5 = parcelRequire("fZ8o5");

var $7Kmy8 = parcelRequire("7Kmy8");
var $37057c446bb711eb$export$4c7897fafd92b108 = function(array) {
    return array[array.length - 1];
};
var $37057c446bb711eb$export$98b44e66722b6f4d = function(value) {
    if (value instanceof Uint8Array) return value;
    var length = value.length;
    var typedArray = new Uint8Array(length);
    for(var idx = 0; idx < length; idx++)typedArray[idx] = value.charCodeAt(idx);
    return typedArray;
};
var $37057c446bb711eb$export$8907b5381cbcd9a7 = function() {
    var arrays = [];
    for(var _i = 0; _i < arguments.length; _i++)arrays[_i] = arguments[_i];
    var arrayCount = arrays.length;
    var typedArrays = [];
    for(var idx = 0; idx < arrayCount; idx++){
        var element = arrays[idx];
        typedArrays[idx] = element instanceof Uint8Array ? element : $37057c446bb711eb$export$98b44e66722b6f4d(element);
    }
    var totalSize = 0;
    for(var idx = 0; idx < arrayCount; idx++)totalSize += arrays[idx].length;
    var merged = new Uint8Array(totalSize);
    var offset = 0;
    for(var arrIdx = 0; arrIdx < arrayCount; arrIdx++){
        var arr = typedArrays[arrIdx];
        for(var byteIdx = 0, arrLen = arr.length; byteIdx < arrLen; byteIdx++)merged[offset++] = arr[byteIdx];
    }
    return merged;
};
var $37057c446bb711eb$export$99cee7ee2de7e6e4 = function(arrays) {
    var totalSize = 0;
    for(var idx = 0, len = arrays.length; idx < len; idx++)totalSize += arrays[idx].length;
    var mergedBuffer = new Uint8Array(totalSize);
    var offset = 0;
    for(var idx = 0, len = arrays.length; idx < len; idx++){
        var array = arrays[idx];
        mergedBuffer.set(array, offset);
        offset += array.length;
    }
    return mergedBuffer;
};
var $37057c446bb711eb$export$5f8f9664fe5c5f14 = function(array) {
    var str = '';
    for(var idx = 0, len = array.length; idx < len; idx++)str += (0, $7Kmy8.charFromCode)(array[idx]);
    return str;
};
var $37057c446bb711eb$export$55b6b1f56c6e1ba5 = function(a, b) {
    return a.id - b.id;
};
var $37057c446bb711eb$export$720e3b5aefb27114 = function(array, indexer) {
    var uniq = [];
    for(var idx = 0, len = array.length; idx < len; idx++){
        var curr = array[idx];
        var prev = array[idx - 1];
        if (idx === 0 || indexer(curr) !== indexer(prev)) uniq.push(curr);
    }
    return uniq;
};
var $37057c446bb711eb$export$c9b97e771c4a8302 = function(array) {
    var arrayLen = array.length;
    for(var idx = 0, len = Math.floor(arrayLen / 2); idx < len; idx++){
        var leftIdx = idx;
        var rightIdx = arrayLen - idx - 1;
        var temp = array[idx];
        array[leftIdx] = array[rightIdx];
        array[rightIdx] = temp;
    }
    return array;
};
var $37057c446bb711eb$export$8a63f25cc62965f1 = function(array) {
    var total = 0;
    for(var idx = 0, len = array.length; idx < len; idx++)total += array[idx];
    return total;
};
var $37057c446bb711eb$export$d02631cccf789723 = function(start, end) {
    var arr = new Array(end - start);
    for(var idx = 0, len = arr.length; idx < len; idx++)arr[idx] = start + idx;
    return arr;
};
var $37057c446bb711eb$export$279d041ff3481d88 = function(arr, indices) {
    var plucked = new Array(indices.length);
    for(var idx = 0, len = indices.length; idx < len; idx++)plucked[idx] = arr[indices[idx]];
    return plucked;
};
var $37057c446bb711eb$export$20e9c5ed92218c4b = function(input) {
    return input instanceof Uint8Array || input instanceof ArrayBuffer || typeof input === 'string';
};
var $37057c446bb711eb$export$73470fd2221e6aef = function(input) {
    if (typeof input === 'string') return (0, $fZ8o5.decodeFromBase64DataUri)(input);
    else if (input instanceof ArrayBuffer) return new Uint8Array(input);
    else if (input instanceof Uint8Array) return input;
    else throw new TypeError('`input` must be one of `string | ArrayBuffer | Uint8Array`');
};

});
parcelRegister("fZ8o5", function(module, exports) {

$parcel$export(module.exports, "encodeToBase64", () => $ba330f1ee33d4a3b$export$373f4c3083978ffd);
$parcel$export(module.exports, "decodeFromBase64DataUri", () => $ba330f1ee33d4a3b$export$f6810f5086699d73);
/*
 * The `chars`, `lookup`, `encode`, and `decode` members of this file are
 * licensed under the following:
 *
 *     base64-arraybuffer
 *     https://github.com/niklasvh/base64-arraybuffer
 *
 *     Copyright (c) 2012 Niklas von Hertzen
 *     Licensed under the MIT license.
 *
 */ var $ba330f1ee33d4a3b$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
var $ba330f1ee33d4a3b$var$lookup = new Uint8Array(256);
for(var $ba330f1ee33d4a3b$var$i = 0; $ba330f1ee33d4a3b$var$i < $ba330f1ee33d4a3b$var$chars.length; $ba330f1ee33d4a3b$var$i++)$ba330f1ee33d4a3b$var$lookup[$ba330f1ee33d4a3b$var$chars.charCodeAt($ba330f1ee33d4a3b$var$i)] = $ba330f1ee33d4a3b$var$i;
var $ba330f1ee33d4a3b$export$373f4c3083978ffd = function(bytes) {
    var base64 = '';
    var len = bytes.length;
    for(var i = 0; i < len; i += 3){
        base64 += $ba330f1ee33d4a3b$var$chars[bytes[i] >> 2];
        base64 += $ba330f1ee33d4a3b$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $ba330f1ee33d4a3b$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $ba330f1ee33d4a3b$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + '=';
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + '==';
    return base64;
};
var $ba330f1ee33d4a3b$export$83edfd8fcc66ec17 = function(base64) {
    var bufferLength = base64.length * 0.75;
    var len = base64.length;
    var i;
    var p = 0;
    var encoded1;
    var encoded2;
    var encoded3;
    var encoded4;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') bufferLength--;
    }
    var bytes = new Uint8Array(bufferLength);
    for(i = 0; i < len; i += 4){
        encoded1 = $ba330f1ee33d4a3b$var$lookup[base64.charCodeAt(i)];
        encoded2 = $ba330f1ee33d4a3b$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $ba330f1ee33d4a3b$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $ba330f1ee33d4a3b$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return bytes;
};
// This regex is designed to be as flexible as possible. It will parse certain
// invalid data URIs.
var $ba330f1ee33d4a3b$var$DATA_URI_PREFIX_REGEX = /^(data)?:?([\w\/\+]+)?;?(charset=[\w-]+|base64)?.*,/i;
var $ba330f1ee33d4a3b$export$f6810f5086699d73 = function(dataUri) {
    var trimmedUri = dataUri.trim();
    var prefix = trimmedUri.substring(0, 100);
    var res = prefix.match($ba330f1ee33d4a3b$var$DATA_URI_PREFIX_REGEX);
    // Assume it's not a data URI - just a plain base64 string
    if (!res) return $ba330f1ee33d4a3b$export$83edfd8fcc66ec17(trimmedUri);
    // Remove the data URI prefix and parse the remainder as a base64 string
    var fullMatch = res[0];
    var data = trimmedUri.substring(fullMatch.length);
    return $ba330f1ee33d4a3b$export$83edfd8fcc66ec17(data);
};

});

parcelRegister("7Kmy8", function(module, exports) {

$parcel$export(module.exports, "toCharCode", () => $5a3e522cca792aad$export$d90166409dd04e85);
$parcel$export(module.exports, "toCodePoint", () => $5a3e522cca792aad$export$93bf578f015d73f0);
$parcel$export(module.exports, "toHexStringOfMinLength", () => $5a3e522cca792aad$export$6ac97d2d1bf41f39);
$parcel$export(module.exports, "padStart", () => $5a3e522cca792aad$export$36cf564d487b5178);
$parcel$export(module.exports, "toHexString", () => $5a3e522cca792aad$export$f4915efbb94d4d01);
$parcel$export(module.exports, "charFromCode", () => $5a3e522cca792aad$export$207031940e6950ad);
$parcel$export(module.exports, "charFromHexCode", () => $5a3e522cca792aad$export$ceedd1b69dcde7a5);
$parcel$export(module.exports, "copyStringIntoBuffer", () => $5a3e522cca792aad$export$c41a03555c37a984);
$parcel$export(module.exports, "cleanText", () => $5a3e522cca792aad$export$6b5e57d20078142b);
$parcel$export(module.exports, "lineSplit", () => $5a3e522cca792aad$export$4f60280859794d8c);
$parcel$export(module.exports, "mergeLines", () => $5a3e522cca792aad$export$b5bf5e120f07cbe);
$parcel$export(module.exports, "charAtIndex", () => $5a3e522cca792aad$export$1a93fc5af577aa5c);
$parcel$export(module.exports, "charSplit", () => $5a3e522cca792aad$export$78f5a8ab9b5e7f1e);
$parcel$export(module.exports, "breakTextIntoLines", () => $5a3e522cca792aad$export$38936f7739928807);
$parcel$export(module.exports, "parseDate", () => $5a3e522cca792aad$export$6b862160d295c8e);
$parcel$export(module.exports, "findLastMatch", () => $5a3e522cca792aad$export$dc1d7d42f51764e3);
var $5a3e522cca792aad$export$d90166409dd04e85 = function(character) {
    return character.charCodeAt(0);
};
var $5a3e522cca792aad$export$93bf578f015d73f0 = function(character) {
    return character.codePointAt(0);
};
var $5a3e522cca792aad$export$6ac97d2d1bf41f39 = function(num, minLength) {
    return $5a3e522cca792aad$export$36cf564d487b5178(num.toString(16), minLength, '0').toUpperCase();
};
var $5a3e522cca792aad$export$f4915efbb94d4d01 = function(num) {
    return $5a3e522cca792aad$export$6ac97d2d1bf41f39(num, 2);
};
var $5a3e522cca792aad$export$207031940e6950ad = function(code) {
    return String.fromCharCode(code);
};
var $5a3e522cca792aad$export$ceedd1b69dcde7a5 = function(hex) {
    return $5a3e522cca792aad$export$207031940e6950ad(parseInt(hex, 16));
};
var $5a3e522cca792aad$export$36cf564d487b5178 = function(value, length, padChar) {
    var padding = '';
    for(var idx = 0, len = length - value.length; idx < len; idx++)padding += padChar;
    return padding + value;
};
var $5a3e522cca792aad$export$c41a03555c37a984 = function(str, buffer, offset) {
    var length = str.length;
    for(var idx = 0; idx < length; idx++)buffer[offset++] = str.charCodeAt(idx);
    return length;
};
var $5a3e522cca792aad$export$505d8f7c00d806ca = function(prefix, suffixLength) {
    if (suffixLength === void 0) suffixLength = 4;
    return prefix + "-" + Math.floor(Math.random() * Math.pow(10, suffixLength));
};
var $5a3e522cca792aad$export$7c57da42ce8e346f = function(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};
var $5a3e522cca792aad$export$6b5e57d20078142b = function(text) {
    return text.replace(/\t|\u0085|\u2028|\u2029/g, '    ').replace(/[\b\v]/g, '');
};
var $5a3e522cca792aad$export$60bd2eb6e5a75df0 = [
    '\\n',
    '\\f',
    '\\r',
    '\\u000B'
];
var $5a3e522cca792aad$export$634cc0013ed0f624 = [
    '\n',
    '\f',
    '\r',
    '\u000B'
];
var $5a3e522cca792aad$export$3fc8feceeed3beb0 = function(text) {
    return /^[\n\f\r\u000B]$/.test(text);
};
var $5a3e522cca792aad$export$4f60280859794d8c = function(text) {
    return text.split(/[\n\f\r\u000B]/);
};
var $5a3e522cca792aad$export$b5bf5e120f07cbe = function(text) {
    return text.replace(/[\n\f\r\u000B]/g, ' ');
};
var $5a3e522cca792aad$export$1a93fc5af577aa5c = function(text, index) {
    // Get the first code unit and code unit value
    var cuFirst = text.charCodeAt(index);
    var cuSecond;
    var nextIndex = index + 1;
    var length = 1;
    if (// Check if it's the start of a surrogate pair.
    cuFirst >= 0xd800 && cuFirst <= 0xdbff && // high surrogate
    text.length > nextIndex // there is a next code unit
    ) {
        cuSecond = text.charCodeAt(nextIndex);
        if (cuSecond >= 0xdc00 && cuSecond <= 0xdfff) length = 2; // low surrogate
    }
    return [
        text.slice(index, index + length),
        length
    ];
};
var $5a3e522cca792aad$export$78f5a8ab9b5e7f1e = function(text) {
    var chars = [];
    for(var idx = 0, len = text.length; idx < len;){
        var _a = $5a3e522cca792aad$export$1a93fc5af577aa5c(text, idx), c = _a[0], cLen = _a[1];
        chars.push(c);
        idx += cLen;
    }
    return chars;
};
var $5a3e522cca792aad$var$buildWordBreakRegex = function(wordBreaks) {
    var newlineCharUnion = $5a3e522cca792aad$export$60bd2eb6e5a75df0.join('|');
    var escapedRules = [
        '$'
    ];
    for(var idx = 0, len = wordBreaks.length; idx < len; idx++){
        var wordBreak = wordBreaks[idx];
        if ($5a3e522cca792aad$export$3fc8feceeed3beb0(wordBreak)) throw new TypeError("`wordBreak` must not include " + newlineCharUnion);
        escapedRules.push(wordBreak === '' ? '.' : $5a3e522cca792aad$export$7c57da42ce8e346f(wordBreak));
    }
    var breakRules = escapedRules.join('|');
    return new RegExp("(" + newlineCharUnion + ")|((.*?)(" + breakRules + "))", 'gm');
};
var $5a3e522cca792aad$export$38936f7739928807 = function(text, wordBreaks, maxWidth, computeWidthOfText) {
    var regex = $5a3e522cca792aad$var$buildWordBreakRegex(wordBreaks);
    var words = $5a3e522cca792aad$export$6b5e57d20078142b(text).match(regex);
    var currLine = '';
    var currWidth = 0;
    var lines = [];
    var pushCurrLine = function() {
        if (currLine !== '') lines.push(currLine);
        currLine = '';
        currWidth = 0;
    };
    for(var idx = 0, len = words.length; idx < len; idx++){
        var word = words[idx];
        if ($5a3e522cca792aad$export$3fc8feceeed3beb0(word)) pushCurrLine();
        else {
            var width = computeWidthOfText(word);
            if (currWidth + width > maxWidth) pushCurrLine();
            currLine += word;
            currWidth += width;
        }
    }
    pushCurrLine();
    return lines;
};
// See section "7.9.4 Dates" of the PDF specification
var $5a3e522cca792aad$var$dateRegex = /^D:(\d\d\d\d)(\d\d)?(\d\d)?(\d\d)?(\d\d)?(\d\d)?([+\-Z])?(\d\d)?'?(\d\d)?'?$/;
var $5a3e522cca792aad$export$6b862160d295c8e = function(dateStr) {
    var match = dateStr.match($5a3e522cca792aad$var$dateRegex);
    if (!match) return undefined;
    var year = match[1], _a = match[2], month = _a === void 0 ? '01' : _a, _b = match[3], day = _b === void 0 ? '01' : _b, _c = match[4], hours = _c === void 0 ? '00' : _c, _d = match[5], mins = _d === void 0 ? '00' : _d, _e = match[6], secs = _e === void 0 ? '00' : _e, _f = match[7], offsetSign = _f === void 0 ? 'Z' : _f, _g = match[8], offsetHours = _g === void 0 ? '00' : _g, _h = match[9], offsetMins = _h === void 0 ? '00' : _h;
    // http://www.ecma-international.org/ecma-262/5.1/#sec-15.9.1.15
    var tzOffset = offsetSign === 'Z' ? 'Z' : "" + offsetSign + offsetHours + ":" + offsetMins;
    var date = new Date(year + "-" + month + "-" + day + "T" + hours + ":" + mins + ":" + secs + tzOffset);
    return date;
};
var $5a3e522cca792aad$export$dc1d7d42f51764e3 = function(value, regex) {
    var _a;
    var position = 0;
    var lastMatch;
    while(position < value.length){
        var match = value.substring(position).match(regex);
        if (!match) return {
            match: lastMatch,
            pos: position
        };
        lastMatch = match;
        position += ((_a = match.index) !== null && _a !== void 0 ? _a : 0) + match[0].length;
    }
    return {
        match: lastMatch,
        pos: position
    };
};

});


parcelRegister("ggjMi", function(module, exports) {

$parcel$export(module.exports, "waitForTick", () => $bd6d7b74aa8160e5$export$3b7198a3beef1a5f);
/**
 * Returns a Promise that resolves after at least one tick of the
 * Macro Task Queue occurs.
 */ var $bd6d7b74aa8160e5$export$3b7198a3beef1a5f = function() {
    return new Promise(function(resolve) {
        setTimeout(function() {
            return resolve();
        }, 0);
    });
};

});

parcelRegister("ejAvl", function(module, exports) {

$parcel$export(module.exports, "utf16Encode", () => $a6bf2813aae3d0a0$export$73704d2337848c8e);
$parcel$export(module.exports, "highSurrogate", () => $a6bf2813aae3d0a0$export$8d3bd4086f36eaeb);
$parcel$export(module.exports, "lowSurrogate", () => $a6bf2813aae3d0a0$export$382051c72943492d);
$parcel$export(module.exports, "isWithinBMP", () => $a6bf2813aae3d0a0$export$919ae47c3852aa15);
$parcel$export(module.exports, "hasSurrogates", () => $a6bf2813aae3d0a0$export$d5ab89e7561b44ab);
$parcel$export(module.exports, "utf16Decode", () => $a6bf2813aae3d0a0$export$b89f54f9db637f79);
$parcel$export(module.exports, "hasUtf16BOM", () => $a6bf2813aae3d0a0$export$41e7c15c75b1b24d);

var $7Kmy8 = parcelRequire("7Kmy8");
var $a6bf2813aae3d0a0$export$e1b32e613f230dc6 = function(input, byteOrderMark) {
    if (byteOrderMark === void 0) byteOrderMark = true;
    var encoded = [];
    if (byteOrderMark) encoded.push(0xef, 0xbb, 0xbf);
    for(var idx = 0, len = input.length; idx < len;){
        var codePoint = input.codePointAt(idx);
        // One byte encoding
        if (codePoint < 0x80) {
            var byte1 = codePoint & 0x7f;
            encoded.push(byte1);
            idx += 1;
        } else if (codePoint < 0x0800) {
            var byte1 = codePoint >> 6 & 0x1f | 0xc0;
            var byte2 = codePoint & 0x3f | 0x80;
            encoded.push(byte1, byte2);
            idx += 1;
        } else if (codePoint < 0x010000) {
            var byte1 = codePoint >> 12 & 0x0f | 0xe0;
            var byte2 = codePoint >> 6 & 0x3f | 0x80;
            var byte3 = codePoint & 0x3f | 0x80;
            encoded.push(byte1, byte2, byte3);
            idx += 1;
        } else if (codePoint < 0x110000) {
            var byte1 = codePoint >> 18 & 0x07 | 0xf0;
            var byte2 = codePoint >> 12 & 0x3f | 0x80;
            var byte3 = codePoint >> 6 & 0x3f | 0x80;
            var byte4 = codePoint >> 0 & 0x3f | 0x80;
            encoded.push(byte1, byte2, byte3, byte4);
            idx += 2;
        } else throw new Error("Invalid code point: 0x" + (0, $7Kmy8.toHexString)(codePoint));
    }
    return new Uint8Array(encoded);
};
var $a6bf2813aae3d0a0$export$73704d2337848c8e = function(input, byteOrderMark) {
    if (byteOrderMark === void 0) byteOrderMark = true;
    var encoded = [];
    if (byteOrderMark) encoded.push(0xfeff);
    for(var idx = 0, len = input.length; idx < len;){
        var codePoint = input.codePointAt(idx);
        // Two byte encoding
        if (codePoint < 0x010000) {
            encoded.push(codePoint);
            idx += 1;
        } else if (codePoint < 0x110000) {
            encoded.push($a6bf2813aae3d0a0$export$8d3bd4086f36eaeb(codePoint), $a6bf2813aae3d0a0$export$382051c72943492d(codePoint));
            idx += 2;
        } else throw new Error("Invalid code point: 0x" + (0, $7Kmy8.toHexString)(codePoint));
    }
    return new Uint16Array(encoded);
};
var $a6bf2813aae3d0a0$export$919ae47c3852aa15 = function(codePoint) {
    return codePoint >= 0 && codePoint <= 0xffff;
};
var $a6bf2813aae3d0a0$export$d5ab89e7561b44ab = function(codePoint) {
    return codePoint >= 0x010000 && codePoint <= 0x10ffff;
};
var $a6bf2813aae3d0a0$export$8d3bd4086f36eaeb = function(codePoint) {
    return Math.floor((codePoint - 0x10000) / 0x400) + 0xd800;
};
var $a6bf2813aae3d0a0$export$382051c72943492d = function(codePoint) {
    return (codePoint - 0x10000) % 0x400 + 0xdc00;
};
var $a6bf2813aae3d0a0$var$ByteOrder;
(function(ByteOrder) {
    ByteOrder["BigEndian"] = "BigEndian";
    ByteOrder["LittleEndian"] = "LittleEndian";
})($a6bf2813aae3d0a0$var$ByteOrder || ($a6bf2813aae3d0a0$var$ByteOrder = {}));
var $a6bf2813aae3d0a0$var$REPLACEMENT = "\uFFFD".codePointAt(0);
var $a6bf2813aae3d0a0$export$b89f54f9db637f79 = function(input, byteOrderMark) {
    if (byteOrderMark === void 0) byteOrderMark = true;
    // Need at least 2 bytes of data in UTF-16 encodings
    if (input.length <= 1) return String.fromCodePoint($a6bf2813aae3d0a0$var$REPLACEMENT);
    var byteOrder = byteOrderMark ? $a6bf2813aae3d0a0$var$readBOM(input) : $a6bf2813aae3d0a0$var$ByteOrder.BigEndian;
    // Skip byte order mark if needed
    var idx = byteOrderMark ? 2 : 0;
    var codePoints = [];
    while(input.length - idx >= 2){
        var first = $a6bf2813aae3d0a0$var$decodeValues(input[idx++], input[idx++], byteOrder);
        if ($a6bf2813aae3d0a0$var$isHighSurrogate(first)) {
            if (input.length - idx < 2) // Need at least 2 bytes left for the low surrogate that is required
            codePoints.push($a6bf2813aae3d0a0$var$REPLACEMENT);
            else {
                var second = $a6bf2813aae3d0a0$var$decodeValues(input[idx++], input[idx++], byteOrder);
                if ($a6bf2813aae3d0a0$var$isLowSurrogate(second)) codePoints.push(first, second);
                else // Low surrogates should always follow high surrogates
                codePoints.push($a6bf2813aae3d0a0$var$REPLACEMENT);
            }
        } else if ($a6bf2813aae3d0a0$var$isLowSurrogate(first)) {
            // High surrogates should always come first since `decodeValues()`
            // accounts for the byte ordering
            idx += 2;
            codePoints.push($a6bf2813aae3d0a0$var$REPLACEMENT);
        } else codePoints.push(first);
    }
    // There shouldn't be extra byte(s) left over
    if (idx < input.length) codePoints.push($a6bf2813aae3d0a0$var$REPLACEMENT);
    return String.fromCodePoint.apply(String, codePoints);
};
/**
 * Returns `true` if the given `codePoint` is a high surrogate.
 * @param codePoint The code point to be evaluated.
 *
 * Reference: https://en.wikipedia.org/wiki/UTF-16#Description
 */ var $a6bf2813aae3d0a0$var$isHighSurrogate = function(codePoint) {
    return codePoint >= 0xd800 && codePoint <= 0xdbff;
};
/**
 * Returns `true` if the given `codePoint` is a low surrogate.
 * @param codePoint The code point to be evaluated.
 *
 * Reference: https://en.wikipedia.org/wiki/UTF-16#Description
 */ var $a6bf2813aae3d0a0$var$isLowSurrogate = function(codePoint) {
    return codePoint >= 0xdc00 && codePoint <= 0xdfff;
};
/**
 * Decodes the given utf-16 values first and second using the specified
 * byte order.
 * @param first The first byte of the encoding.
 * @param second The second byte of the encoding.
 * @param byteOrder The byte order of the encoding.
 * Reference: https://en.wikipedia.org/wiki/UTF-16#Examples
 */ var $a6bf2813aae3d0a0$var$decodeValues = function(first, second, byteOrder) {
    // Append the binary representation of the preceding byte by shifting the
    // first one 8 to the left and than applying a bitwise or-operator to append
    // the second one.
    if (byteOrder === $a6bf2813aae3d0a0$var$ByteOrder.LittleEndian) return second << 8 | first;
    if (byteOrder === $a6bf2813aae3d0a0$var$ByteOrder.BigEndian) return first << 8 | second;
    throw new Error("Invalid byteOrder: " + byteOrder);
};
/**
 * Returns whether the given array contains a byte order mark for the
 * UTF-16BE or UTF-16LE encoding. If it has neither, BigEndian is assumed.
 *
 * Reference: https://en.wikipedia.org/wiki/Byte_order_mark#UTF-16
 *
 * @param bytes The byte array to be evaluated.
 */ // prettier-ignore
var $a6bf2813aae3d0a0$var$readBOM = function(bytes) {
    return $a6bf2813aae3d0a0$var$hasUtf16BigEndianBOM(bytes) ? $a6bf2813aae3d0a0$var$ByteOrder.BigEndian : $a6bf2813aae3d0a0$var$hasUtf16LittleEndianBOM(bytes) ? $a6bf2813aae3d0a0$var$ByteOrder.LittleEndian : $a6bf2813aae3d0a0$var$ByteOrder.BigEndian;
};
var $a6bf2813aae3d0a0$var$hasUtf16BigEndianBOM = function(bytes) {
    return bytes[0] === 0xfe && bytes[1] === 0xff;
};
var $a6bf2813aae3d0a0$var$hasUtf16LittleEndianBOM = function(bytes) {
    return bytes[0] === 0xff && bytes[1] === 0xfe;
};
var $a6bf2813aae3d0a0$export$41e7c15c75b1b24d = function(bytes) {
    return $a6bf2813aae3d0a0$var$hasUtf16BigEndianBOM(bytes) || $a6bf2813aae3d0a0$var$hasUtf16LittleEndianBOM(bytes);
};

});

parcelRegister("hiEdU", function(module, exports) {

$parcel$export(module.exports, "numberToString", () => $c983519a4c18aa89$export$f67be9d9b0e25d7b);
$parcel$export(module.exports, "sizeInBytes", () => $c983519a4c18aa89$export$cc6acfd7a782614d);
$parcel$export(module.exports, "bytesFor", () => $c983519a4c18aa89$export$3c7962b7d5fa4e42);
// tslint:disable radix
/**
 * Converts a number to its string representation in decimal. This function
 * differs from simply converting a number to a string with `.toString()`
 * because this function's output string will **not** contain exponential
 * notation.
 *
 * Credit: https://stackoverflow.com/a/46545519
 */ var $c983519a4c18aa89$export$f67be9d9b0e25d7b = function(num) {
    var numStr = String(num);
    if (Math.abs(num) < 1.0) {
        var e = parseInt(num.toString().split('e-')[1]);
        if (e) {
            var negative = num < 0;
            if (negative) num *= -1;
            num *= Math.pow(10, e - 1);
            numStr = '0.' + new Array(e).join('0') + num.toString().substring(2);
            if (negative) numStr = '-' + numStr;
        }
    } else {
        var e = parseInt(num.toString().split('+')[1]);
        if (e > 20) {
            e -= 20;
            num /= Math.pow(10, e);
            numStr = num.toString() + new Array(e + 1).join('0');
        }
    }
    return numStr;
};
var $c983519a4c18aa89$export$cc6acfd7a782614d = function(n) {
    return Math.ceil(n.toString(2).length / 8);
};
var $c983519a4c18aa89$export$3c7962b7d5fa4e42 = function(n) {
    var bytes = new Uint8Array($c983519a4c18aa89$export$cc6acfd7a782614d(n));
    for(var i = 1; i <= bytes.length; i++)bytes[i - 1] = n >> (bytes.length - i) * 8;
    return bytes;
};

});

parcelRegister("hP0hy", function(module, exports) {

$parcel$export(module.exports, "error", () => $cf976b189519155d$export$a3bc9b8ed74fc);
var $cf976b189519155d$export$a3bc9b8ed74fc = function(msg) {
    throw new Error(msg);
};

});

parcelRegister("cbIAG", function(module, exports) {

$parcel$export(module.exports, "values", () => $8df919e62912d805$export$68c286be0e7e55b7);
$parcel$export(module.exports, "isStandardFont", () => $8df919e62912d805$export$f2950432a4491977);
$parcel$export(module.exports, "rectanglesAreEqual", () => $8df919e62912d805$export$93263d7e9f52c023);
parcelRequire("eNCdi");
var $kkdJe = parcelRequire("kkdJe");
var $8df919e62912d805$export$68c286be0e7e55b7 = function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $8df919e62912d805$export$59252e21bbb61725 = $8df919e62912d805$export$68c286be0e7e55b7((0, $kkdJe.FontNames));
var $8df919e62912d805$export$f2950432a4491977 = function(input) {
    return $8df919e62912d805$export$59252e21bbb61725.includes(input);
};
var $8df919e62912d805$export$93263d7e9f52c023 = function(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
};

});
parcelRegister("eNCdi", function(module, exports) {
$parcel$export(module.exports, "Font", () => (parcelRequire("kkdJe")).Font);
$parcel$export(module.exports, "FontNames", () => (parcelRequire("kkdJe")).FontNames);
$parcel$export(module.exports, "Encodings", () => (parcelRequire("90iSP")).Encodings);
parcelRequire("kkdJe");
parcelRequire("90iSP");

});
parcelRegister("kkdJe", function(module, exports) {

$parcel$export(module.exports, "FontNames", () => $ecc0531572753d26$export$a1e7b970f5a14844);
$parcel$export(module.exports, "Font", () => $ecc0531572753d26$export$89abf52a030e56ee);

var $5JpfH = parcelRequire("5JpfH");

var $3uXKw = parcelRequire("3uXKw");

var $7ybLn = parcelRequire("7ybLn");

var $fCZVO = parcelRequire("fCZVO");

var $cOHfc = parcelRequire("cOHfc");

var $eVbDh = parcelRequire("eVbDh");

var $g9ZKL = parcelRequire("g9ZKL");

var $hgkij = parcelRequire("hgkij");

var $4W9K8 = parcelRequire("4W9K8");

var $gbK7N = parcelRequire("gbK7N");

var $lan6Z = parcelRequire("lan6Z");

var $1zetG = parcelRequire("1zetG");

var $53nEH = parcelRequire("53nEH");

var $fhfja = parcelRequire("fhfja");

var $enbPQ = parcelRequire("enbPQ");
// prettier-ignore
var $ecc0531572753d26$var$compressedJsonForFontName = {
    'Courier': (0, (/*@__PURE__*/$parcel$interopDefault($cOHfc))),
    'Courier-Bold': (0, (/*@__PURE__*/$parcel$interopDefault($3uXKw))),
    'Courier-Oblique': (0, (/*@__PURE__*/$parcel$interopDefault($fCZVO))),
    'Courier-BoldOblique': (0, (/*@__PURE__*/$parcel$interopDefault($7ybLn))),
    'Helvetica': (0, (/*@__PURE__*/$parcel$interopDefault($4W9K8))),
    'Helvetica-Bold': (0, (/*@__PURE__*/$parcel$interopDefault($eVbDh))),
    'Helvetica-Oblique': (0, (/*@__PURE__*/$parcel$interopDefault($hgkij))),
    'Helvetica-BoldOblique': (0, (/*@__PURE__*/$parcel$interopDefault($g9ZKL))),
    'Times-Roman': (0, (/*@__PURE__*/$parcel$interopDefault($53nEH))),
    'Times-Bold': (0, (/*@__PURE__*/$parcel$interopDefault($gbK7N))),
    'Times-Italic': (0, (/*@__PURE__*/$parcel$interopDefault($1zetG))),
    'Times-BoldItalic': (0, (/*@__PURE__*/$parcel$interopDefault($lan6Z))),
    'Symbol': (0, (/*@__PURE__*/$parcel$interopDefault($fhfja))),
    'ZapfDingbats': (0, (/*@__PURE__*/$parcel$interopDefault($enbPQ)))
};
var $ecc0531572753d26$export$a1e7b970f5a14844;
(function(FontNames) {
    FontNames["Courier"] = "Courier";
    FontNames["CourierBold"] = "Courier-Bold";
    FontNames["CourierOblique"] = "Courier-Oblique";
    FontNames["CourierBoldOblique"] = "Courier-BoldOblique";
    FontNames["Helvetica"] = "Helvetica";
    FontNames["HelveticaBold"] = "Helvetica-Bold";
    FontNames["HelveticaOblique"] = "Helvetica-Oblique";
    FontNames["HelveticaBoldOblique"] = "Helvetica-BoldOblique";
    FontNames["TimesRoman"] = "Times-Roman";
    FontNames["TimesRomanBold"] = "Times-Bold";
    FontNames["TimesRomanItalic"] = "Times-Italic";
    FontNames["TimesRomanBoldItalic"] = "Times-BoldItalic";
    FontNames["Symbol"] = "Symbol";
    FontNames["ZapfDingbats"] = "ZapfDingbats";
})($ecc0531572753d26$export$a1e7b970f5a14844 || ($ecc0531572753d26$export$a1e7b970f5a14844 = {}));
var $ecc0531572753d26$var$fontCache = {};
var $ecc0531572753d26$export$89abf52a030e56ee = /** @class */ function() {
    function Font() {
        var _this = this;
        this.getWidthOfGlyph = function(glyphName) {
            return _this.CharWidths[glyphName];
        };
        this.getXAxisKerningForPair = function(leftGlyphName, rightGlyphName) {
            return (_this.KernPairXAmounts[leftGlyphName] || {})[rightGlyphName];
        };
    }
    Font.load = function(fontName) {
        var cachedFont = $ecc0531572753d26$var$fontCache[fontName];
        if (cachedFont) return cachedFont;
        var json = (0, $5JpfH.decompressJson)($ecc0531572753d26$var$compressedJsonForFontName[fontName]);
        var font = Object.assign(new Font(), JSON.parse(json));
        font.CharWidths = font.CharMetrics.reduce(function(acc, metric) {
            acc[metric.N] = metric.WX;
            return acc;
        }, {});
        font.KernPairXAmounts = font.KernPairs.reduce(function(acc, _a) {
            var name1 = _a[0], name2 = _a[1], width = _a[2];
            if (!acc[name1]) acc[name1] = {};
            acc[name1][name2] = width;
            return acc;
        }, {});
        $ecc0531572753d26$var$fontCache[fontName] = font;
        return font;
    };
    return Font;
}();

});
parcelRegister("5JpfH", function(module, exports) {

$parcel$export(module.exports, "decompressJson", () => $42c4be4670940c1e$export$134b8d792d6efd14);
$parcel$export(module.exports, "padStart", () => $42c4be4670940c1e$export$36cf564d487b5178);
/*
 * The `chars`, `lookup`, and `decodeFromBase64` members of this file are
 * licensed under the following:
 *
 *     base64-arraybuffer
 *     https://github.com/niklasvh/base64-arraybuffer
 *
 *     Copyright (c) 2012 Niklas von Hertzen
 *     Licensed under the MIT license.
 *
 */ 
var $ckCqy = parcelRequire("ckCqy");
var $42c4be4670940c1e$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
var $42c4be4670940c1e$var$lookup = new Uint8Array(256);
for(var $42c4be4670940c1e$var$i = 0; $42c4be4670940c1e$var$i < $42c4be4670940c1e$var$chars.length; $42c4be4670940c1e$var$i++)$42c4be4670940c1e$var$lookup[$42c4be4670940c1e$var$chars.charCodeAt($42c4be4670940c1e$var$i)] = $42c4be4670940c1e$var$i;
var $42c4be4670940c1e$export$83edfd8fcc66ec17 = function(base64) {
    var bufferLength = base64.length * 0.75;
    var len = base64.length;
    var i;
    var p = 0;
    var encoded1;
    var encoded2;
    var encoded3;
    var encoded4;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') bufferLength--;
    }
    var bytes = new Uint8Array(bufferLength);
    for(i = 0; i < len; i += 4){
        encoded1 = $42c4be4670940c1e$var$lookup[base64.charCodeAt(i)];
        encoded2 = $42c4be4670940c1e$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $42c4be4670940c1e$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $42c4be4670940c1e$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return bytes;
};
var $42c4be4670940c1e$var$arrayToString = function(array) {
    var str = '';
    for(var i = 0; i < array.length; i++)str += String.fromCharCode(array[i]);
    return str;
};
var $42c4be4670940c1e$export$134b8d792d6efd14 = function(compressedJson) {
    return $42c4be4670940c1e$var$arrayToString((0, (/*@__PURE__*/$parcel$interopDefault($ckCqy))).inflate($42c4be4670940c1e$export$83edfd8fcc66ec17(compressedJson)));
};
var $42c4be4670940c1e$export$36cf564d487b5178 = function(value, length, padChar) {
    var padding = '';
    for(var idx = 0, len = length - value.length; idx < len; idx++)padding += padChar;
    return padding + value;
};

});
parcelRegister("ckCqy", function(module, exports) {
// Top level file is just a mixin of submodules & constants
'use strict';

var $9CLQF = parcelRequire("9CLQF");
var $8fa5292818130bae$require$assign = $9CLQF.assign;

var $2wbN5 = parcelRequire("2wbN5");

var $3OYOJ = parcelRequire("3OYOJ");

var $hf4Xu = parcelRequire("hf4Xu");
var $8fa5292818130bae$var$pako = {};
$8fa5292818130bae$require$assign($8fa5292818130bae$var$pako, $2wbN5, $3OYOJ, $hf4Xu);
module.exports = $8fa5292818130bae$var$pako;

});
parcelRegister("9CLQF", function(module, exports) {
'use strict';
var $701cc75d47025217$var$TYPED_OK = typeof Uint8Array !== 'undefined' && typeof Uint16Array !== 'undefined' && typeof Int32Array !== 'undefined';
function $701cc75d47025217$var$_has(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
module.exports.assign = function(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    while(sources.length){
        var source = sources.shift();
        if (!source) continue;
        if (typeof source !== 'object') throw new TypeError(source + 'must be non-object');
        for(var p in source)if ($701cc75d47025217$var$_has(source, p)) obj[p] = source[p];
    }
    return obj;
};
// reduce buffer size, avoiding mem copy
module.exports.shrinkBuf = function(buf, size) {
    if (buf.length === size) return buf;
    if (buf.subarray) return buf.subarray(0, size);
    buf.length = size;
    return buf;
};
var $701cc75d47025217$var$fnTyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        if (src.subarray && dest.subarray) {
            dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
            return;
        }
        // Fallback to ordinary array
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        var i, l, len, pos, chunk, result;
        // calculate data length
        len = 0;
        for(i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
        // join chunks
        result = new Uint8Array(len);
        pos = 0;
        for(i = 0, l = chunks.length; i < l; i++){
            chunk = chunks[i];
            result.set(chunk, pos);
            pos += chunk.length;
        }
        return result;
    }
};
var $701cc75d47025217$var$fnUntyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        return [].concat.apply([], chunks);
    }
};
// Enable/Disable typed arrays use, for testing
//
module.exports.setTyped = function(on) {
    if (on) {
        module.exports.Buf8 = Uint8Array;
        module.exports.Buf16 = Uint16Array;
        module.exports.Buf32 = Int32Array;
        module.exports.assign(module.exports, $701cc75d47025217$var$fnTyped);
    } else {
        module.exports.Buf8 = Array;
        module.exports.Buf16 = Array;
        module.exports.Buf32 = Array;
        module.exports.assign(module.exports, $701cc75d47025217$var$fnUntyped);
    }
};
module.exports.setTyped($701cc75d47025217$var$TYPED_OK);

});

parcelRegister("2wbN5", function(module, exports) {

$parcel$export(module.exports, "Deflate", () => $1d57b756249bc6d3$export$ae157b6234afe138, (v) => $1d57b756249bc6d3$export$ae157b6234afe138 = v);
$parcel$export(module.exports, "deflate", () => $1d57b756249bc6d3$export$2316623ecd1285ab, (v) => $1d57b756249bc6d3$export$2316623ecd1285ab = v);
$parcel$export(module.exports, "deflateRaw", () => $1d57b756249bc6d3$export$e95d6a8f69fb340a, (v) => $1d57b756249bc6d3$export$e95d6a8f69fb340a = v);
$parcel$export(module.exports, "gzip", () => $1d57b756249bc6d3$export$69f0ea7cf3a331a8, (v) => $1d57b756249bc6d3$export$69f0ea7cf3a331a8 = v);
var $1d57b756249bc6d3$export$ae157b6234afe138;
var $1d57b756249bc6d3$export$2316623ecd1285ab;
var $1d57b756249bc6d3$export$e95d6a8f69fb340a;
var $1d57b756249bc6d3$export$69f0ea7cf3a331a8;
'use strict';

var $lGf86 = parcelRequire("lGf86");

var $9CLQF = parcelRequire("9CLQF");

var $iC2HB = parcelRequire("iC2HB");

var $7gAmB = parcelRequire("7gAmB");

var $9WDto = parcelRequire("9WDto");
var $1d57b756249bc6d3$var$toString = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ var $1d57b756249bc6d3$var$Z_NO_FLUSH = 0;
var $1d57b756249bc6d3$var$Z_FINISH = 4;
var $1d57b756249bc6d3$var$Z_OK = 0;
var $1d57b756249bc6d3$var$Z_STREAM_END = 1;
var $1d57b756249bc6d3$var$Z_SYNC_FLUSH = 2;
var $1d57b756249bc6d3$var$Z_DEFAULT_COMPRESSION = -1;
var $1d57b756249bc6d3$var$Z_DEFAULT_STRATEGY = 0;
var $1d57b756249bc6d3$var$Z_DEFLATED = 8;
/* ===========================================================================*/ /**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/ /* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/ /**
 * Deflate.result -> Uint8Array|Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param)  or if you
 * push a chunk with explicit flush (call [[Deflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/ /**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/ /**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/ /**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/ function $1d57b756249bc6d3$var$Deflate(options) {
    if (!(this instanceof $1d57b756249bc6d3$var$Deflate)) return new $1d57b756249bc6d3$var$Deflate(options);
    this.options = $9CLQF.assign({
        level: $1d57b756249bc6d3$var$Z_DEFAULT_COMPRESSION,
        method: $1d57b756249bc6d3$var$Z_DEFLATED,
        chunkSize: 16384,
        windowBits: 15,
        memLevel: 8,
        strategy: $1d57b756249bc6d3$var$Z_DEFAULT_STRATEGY,
        to: ''
    }, options || {});
    var opt = this.options;
    if (opt.raw && opt.windowBits > 0) opt.windowBits = -opt.windowBits;
    else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) opt.windowBits += 16;
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ''; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $9WDto();
    this.strm.avail_out = 0;
    var status = $lGf86.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
    if (status !== $1d57b756249bc6d3$var$Z_OK) throw new Error($7gAmB[status]);
    if (opt.header) $lGf86.deflateSetHeader(this.strm, opt.header);
    if (opt.dictionary) {
        var dict;
        // Convert data if needed
        if (typeof opt.dictionary === 'string') // If we need to compress text, change encoding to utf8.
        dict = $iC2HB.string2buf(opt.dictionary);
        else if ($1d57b756249bc6d3$var$toString.call(opt.dictionary) === '[object ArrayBuffer]') dict = new Uint8Array(opt.dictionary);
        else dict = opt.dictionary;
        status = $lGf86.deflateSetDictionary(this.strm, dict);
        if (status !== $1d57b756249bc6d3$var$Z_OK) throw new Error($7gAmB[status]);
        this._dict_set = true;
    }
}
/**
 * Deflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Deflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the compression context.
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * array format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $1d57b756249bc6d3$var$Deflate.prototype.push = function(data, mode) {
    var strm = this.strm;
    var chunkSize = this.options.chunkSize;
    var status, _mode;
    if (this.ended) return false;
    _mode = mode === ~~mode ? mode : mode === true ? $1d57b756249bc6d3$var$Z_FINISH : $1d57b756249bc6d3$var$Z_NO_FLUSH;
    // Convert data if needed
    if (typeof data === 'string') // If we need to compress text, change encoding to utf8.
    strm.input = $iC2HB.string2buf(data);
    else if ($1d57b756249bc6d3$var$toString.call(data) === '[object ArrayBuffer]') strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    do {
        if (strm.avail_out === 0) {
            strm.output = new $9CLQF.Buf8(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $lGf86.deflate(strm, _mode); /* no bad return value */ 
        if (status !== $1d57b756249bc6d3$var$Z_STREAM_END && status !== $1d57b756249bc6d3$var$Z_OK) {
            this.onEnd(status);
            this.ended = true;
            return false;
        }
        if (strm.avail_out === 0 || strm.avail_in === 0 && (_mode === $1d57b756249bc6d3$var$Z_FINISH || _mode === $1d57b756249bc6d3$var$Z_SYNC_FLUSH)) {
            if (this.options.to === 'string') this.onData($iC2HB.buf2binstring($9CLQF.shrinkBuf(strm.output, strm.next_out)));
            else this.onData($9CLQF.shrinkBuf(strm.output, strm.next_out));
        }
    }while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== $1d57b756249bc6d3$var$Z_STREAM_END);
    // Finalize on the last chunk.
    if (_mode === $1d57b756249bc6d3$var$Z_FINISH) {
        status = $lGf86.deflateEnd(this.strm);
        this.onEnd(status);
        this.ended = true;
        return status === $1d57b756249bc6d3$var$Z_OK;
    }
    // callback interim results if Z_SYNC_FLUSH.
    if (_mode === $1d57b756249bc6d3$var$Z_SYNC_FLUSH) {
        this.onEnd($1d57b756249bc6d3$var$Z_OK);
        strm.avail_out = 0;
        return true;
    }
    return true;
};
/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $1d57b756249bc6d3$var$Deflate.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $1d57b756249bc6d3$var$Deflate.prototype.onEnd = function(status) {
    // On success - join
    if (status === $1d57b756249bc6d3$var$Z_OK) {
        if (this.options.to === 'string') this.result = this.chunks.join('');
        else this.result = $9CLQF.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * deflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/ function $1d57b756249bc6d3$var$deflate(input, options) {
    var deflator = new $1d57b756249bc6d3$var$Deflate(options);
    deflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (deflator.err) throw deflator.msg || $7gAmB[deflator.err];
    return deflator.result;
}
/**
 * deflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $1d57b756249bc6d3$var$deflateRaw(input, options) {
    options = options || {};
    options.raw = true;
    return $1d57b756249bc6d3$var$deflate(input, options);
}
/**
 * gzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/ function $1d57b756249bc6d3$var$gzip(input, options) {
    options = options || {};
    options.gzip = true;
    return $1d57b756249bc6d3$var$deflate(input, options);
}
$1d57b756249bc6d3$export$ae157b6234afe138 = $1d57b756249bc6d3$var$Deflate;
$1d57b756249bc6d3$export$2316623ecd1285ab = $1d57b756249bc6d3$var$deflate;
$1d57b756249bc6d3$export$e95d6a8f69fb340a = $1d57b756249bc6d3$var$deflateRaw;
$1d57b756249bc6d3$export$69f0ea7cf3a331a8 = $1d57b756249bc6d3$var$gzip;

});
parcelRegister("lGf86", function(module, exports) {

$parcel$export(module.exports, "deflateInit2", () => $fc8941aa2060205a$export$a65c7b2bde87cb70, (v) => $fc8941aa2060205a$export$a65c7b2bde87cb70 = v);
$parcel$export(module.exports, "deflateSetHeader", () => $fc8941aa2060205a$export$1cd50f7b2515ba19, (v) => $fc8941aa2060205a$export$1cd50f7b2515ba19 = v);
$parcel$export(module.exports, "deflate", () => $fc8941aa2060205a$export$2316623ecd1285ab, (v) => $fc8941aa2060205a$export$2316623ecd1285ab = v);
$parcel$export(module.exports, "deflateEnd", () => $fc8941aa2060205a$export$599854fa319a815f, (v) => $fc8941aa2060205a$export$599854fa319a815f = v);
$parcel$export(module.exports, "deflateSetDictionary", () => $fc8941aa2060205a$export$f55e0b3ab66b5d46, (v) => $fc8941aa2060205a$export$f55e0b3ab66b5d46 = v);
var $fc8941aa2060205a$export$72b35d618fb8ad9b;
var $fc8941aa2060205a$export$a65c7b2bde87cb70;
var $fc8941aa2060205a$export$8f99f0e30bc7dd53;
var $fc8941aa2060205a$export$e78fab288549509;
var $fc8941aa2060205a$export$1cd50f7b2515ba19;
var $fc8941aa2060205a$export$2316623ecd1285ab;
var $fc8941aa2060205a$export$599854fa319a815f;
var $fc8941aa2060205a$export$f55e0b3ab66b5d46;
var $fc8941aa2060205a$export$12b6e1fcadea22f9;
'use strict';

var $9CLQF = parcelRequire("9CLQF");

var $hx6dX = parcelRequire("hx6dX");

var $gJUj4 = parcelRequire("gJUj4");

var $5UMyJ = parcelRequire("5UMyJ");

var $7gAmB = parcelRequire("7gAmB");
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ var $fc8941aa2060205a$var$Z_NO_FLUSH = 0;
var $fc8941aa2060205a$var$Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var $fc8941aa2060205a$var$Z_FULL_FLUSH = 3;
var $fc8941aa2060205a$var$Z_FINISH = 4;
var $fc8941aa2060205a$var$Z_BLOCK = 5;
//var Z_TREES         = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var $fc8941aa2060205a$var$Z_OK = 0;
var $fc8941aa2060205a$var$Z_STREAM_END = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var $fc8941aa2060205a$var$Z_STREAM_ERROR = -2;
var $fc8941aa2060205a$var$Z_DATA_ERROR = -3;
//var Z_MEM_ERROR     = -4;
var $fc8941aa2060205a$var$Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* compression levels */ //var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var $fc8941aa2060205a$var$Z_DEFAULT_COMPRESSION = -1;
var $fc8941aa2060205a$var$Z_FILTERED = 1;
var $fc8941aa2060205a$var$Z_HUFFMAN_ONLY = 2;
var $fc8941aa2060205a$var$Z_RLE = 3;
var $fc8941aa2060205a$var$Z_FIXED = 4;
var $fc8941aa2060205a$var$Z_DEFAULT_STRATEGY = 0;
/* Possible values of the data_type field (though see inflate()) */ //var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var $fc8941aa2060205a$var$Z_UNKNOWN = 2;
/* The deflate compression method */ var $fc8941aa2060205a$var$Z_DEFLATED = 8;
/*============================================================================*/ var $fc8941aa2060205a$var$MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ var $fc8941aa2060205a$var$MAX_WBITS = 15;
/* 32K LZ77 window */ var $fc8941aa2060205a$var$DEF_MEM_LEVEL = 8;
var $fc8941aa2060205a$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $fc8941aa2060205a$var$LITERALS = 256;
/* number of literal bytes 0..255 */ var $fc8941aa2060205a$var$L_CODES = $fc8941aa2060205a$var$LITERALS + 1 + $fc8941aa2060205a$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var $fc8941aa2060205a$var$D_CODES = 30;
/* number of distance codes */ var $fc8941aa2060205a$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var $fc8941aa2060205a$var$HEAP_SIZE = 2 * $fc8941aa2060205a$var$L_CODES + 1;
/* maximum heap size */ var $fc8941aa2060205a$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var $fc8941aa2060205a$var$MIN_MATCH = 3;
var $fc8941aa2060205a$var$MAX_MATCH = 258;
var $fc8941aa2060205a$var$MIN_LOOKAHEAD = $fc8941aa2060205a$var$MAX_MATCH + $fc8941aa2060205a$var$MIN_MATCH + 1;
var $fc8941aa2060205a$var$PRESET_DICT = 0x20;
var $fc8941aa2060205a$var$INIT_STATE = 42;
var $fc8941aa2060205a$var$EXTRA_STATE = 69;
var $fc8941aa2060205a$var$NAME_STATE = 73;
var $fc8941aa2060205a$var$COMMENT_STATE = 91;
var $fc8941aa2060205a$var$HCRC_STATE = 103;
var $fc8941aa2060205a$var$BUSY_STATE = 113;
var $fc8941aa2060205a$var$FINISH_STATE = 666;
var $fc8941aa2060205a$var$BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
var $fc8941aa2060205a$var$BS_BLOCK_DONE = 2; /* block flush performed */ 
var $fc8941aa2060205a$var$BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
var $fc8941aa2060205a$var$BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
var $fc8941aa2060205a$var$OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
function $fc8941aa2060205a$var$err(strm, errorCode) {
    strm.msg = $7gAmB[errorCode];
    return errorCode;
}
function $fc8941aa2060205a$var$rank(f) {
    return (f << 1) - (f > 4 ? 9 : 0);
}
function $fc8941aa2060205a$var$zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */ function $fc8941aa2060205a$var$flush_pending(strm) {
    var s = strm.state;
    //_tr_flush_bits(s);
    var len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    $9CLQF.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
}
function $fc8941aa2060205a$var$flush_block_only(s, last) {
    $hx6dX._tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    $fc8941aa2060205a$var$flush_pending(s.strm);
}
function $fc8941aa2060205a$var$put_byte(s, b) {
    s.pending_buf[s.pending++] = b;
}
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ function $fc8941aa2060205a$var$putShortMSB(s, b) {
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
}
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ function $fc8941aa2060205a$var$read_buf(strm, buf, start, size) {
    var len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    $9CLQF.arraySet(buf, strm.input, strm.next_in, len, start);
    if (strm.state.wrap === 1) strm.adler = $gJUj4(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = $5UMyJ(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
}
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ function $fc8941aa2060205a$var$longest_match(s, cur_match) {
    var chain_length = s.max_chain_length; /* max hash chain length */ 
    var scan = s.strstart; /* current string */ 
    var match; /* matched string */ 
    var len; /* length of current match */ 
    var best_len = s.prev_length; /* best match length so far */ 
    var nice_match = s.nice_match; /* stop if match long enough */ 
    var limit = s.strstart > s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD ? s.strstart - (s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    var _win = s.window; // shortcut
    var wmask = s.w_mask;
    var prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ var strend = s.strstart + $fc8941aa2060205a$var$MAX_MATCH;
    var scan_end1 = _win[scan + best_len - 1];
    var scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = $fc8941aa2060205a$var$MAX_MATCH - (strend - scan);
        scan = strend - $fc8941aa2060205a$var$MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
}
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ function $fc8941aa2060205a$var$fill_window(s) {
    var _w_size = s.w_size;
    var p, n, m, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD)) {
            $9CLQF.arraySet(s.window, s.window, _w_size, _w_size, 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */ n = s.hash_size;
            p = n;
            do {
                m = s.head[--p];
                s.head[p] = m >= _w_size ? m - _w_size : 0;
            }while (--n);
            n = _w_size;
            p = n;
            do {
                m = s.prev[--p];
                s.prev[p] = m >= _w_size ? m - _w_size : 0;
            /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */ }while (--n);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = $fc8941aa2060205a$var$read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= $fc8941aa2060205a$var$MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < $fc8941aa2060205a$var$MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */ function $fc8941aa2060205a$var$deflate_stored(s, flush) {
    /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */ var max_block_size = 0xffff;
    if (max_block_size > s.pending_buf_size - 5) max_block_size = s.pending_buf_size - 5;
    /* Copy as much as possible from input to output: */ for(;;){
        /* Fill the window as much as possible: */ if (s.lookahead <= 1) {
            //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
            //  s->block_start >= (long)s->w_size, "slide too late");
            //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
            //        s.block_start >= s.w_size)) {
            //        throw  new Error("slide too late");
            //      }
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead === 0 && flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
        /* flush the current block */ }
        //Assert(s->block_start >= 0L, "block gone");
        //    if (s.block_start < 0) throw new Error("block gone");
        s.strstart += s.lookahead;
        s.lookahead = 0;
        /* Emit a stored block if pending_buf will be full: */ var max_start = s.block_start + max_block_size;
        if (s.strstart === 0 || s.strstart >= max_start) {
            /* strstart == 0 is possible when wraparound on 16-bit machine */ s.lookahead = s.strstart - max_start;
            s.strstart = max_start;
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
        /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */ if (s.strstart - s.block_start >= s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD) {
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.strstart > s.block_start) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_NEED_MORE;
}
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ function $fc8941aa2060205a$var$deflate_fast(s, flush) {
    var hash_head; /* head of the hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD) {
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD && flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $fc8941aa2060205a$var$longest_match(s, hash_head);
        if (s.match_length >= $fc8941aa2060205a$var$MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = $hx6dX._tr_tally(s, s.strstart - s.match_start, s.match_length - $fc8941aa2060205a$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $hx6dX._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < $fc8941aa2060205a$var$MIN_MATCH - 1 ? s.strstart : $fc8941aa2060205a$var$MIN_MATCH - 1;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ function $fc8941aa2060205a$var$deflate_slow(s, flush) {
    var hash_head; /* head of hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    var max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD) {
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD && flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $fc8941aa2060205a$var$longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === $fc8941aa2060205a$var$Z_FILTERED || s.match_length === $fc8941aa2060205a$var$MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= $fc8941aa2060205a$var$MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - $fc8941aa2060205a$var$MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = $hx6dX._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - $fc8941aa2060205a$var$MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
                if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $hx6dX._tr_tally(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $hx6dX._tr_tally(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < $fc8941aa2060205a$var$MIN_MATCH - 1 ? s.strstart : $fc8941aa2060205a$var$MIN_MATCH - 1;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ function $fc8941aa2060205a$var$deflate_rle(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    var prev; /* byte at distance one to match */ 
    var scan, strend; /* scan goes up to strend for length of run */ 
    var _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= $fc8941aa2060205a$var$MAX_MATCH) {
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead <= $fc8941aa2060205a$var$MAX_MATCH && flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + $fc8941aa2060205a$var$MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = $fc8941aa2060205a$var$MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= $fc8941aa2060205a$var$MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = $hx6dX._tr_tally(s, 1, s.match_length - $fc8941aa2060205a$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $hx6dX._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ function $fc8941aa2060205a$var$deflate_huff(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead === 0) {
                if (flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $hx6dX._tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_BLOCK_DONE;
}
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function $fc8941aa2060205a$var$Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
var $fc8941aa2060205a$var$configuration_table;
$fc8941aa2060205a$var$configuration_table = [
    /*      good lazy nice chain */ new $fc8941aa2060205a$var$Config(0, 0, 0, 0, $fc8941aa2060205a$var$deflate_stored),
    /* 0 store only */ new $fc8941aa2060205a$var$Config(4, 4, 8, 4, $fc8941aa2060205a$var$deflate_fast),
    /* 1 max speed, no lazy matches */ new $fc8941aa2060205a$var$Config(4, 5, 16, 8, $fc8941aa2060205a$var$deflate_fast),
    /* 2 */ new $fc8941aa2060205a$var$Config(4, 6, 32, 32, $fc8941aa2060205a$var$deflate_fast),
    /* 3 */ new $fc8941aa2060205a$var$Config(4, 4, 16, 16, $fc8941aa2060205a$var$deflate_slow),
    /* 4 lazy matches */ new $fc8941aa2060205a$var$Config(8, 16, 32, 32, $fc8941aa2060205a$var$deflate_slow),
    /* 5 */ new $fc8941aa2060205a$var$Config(8, 16, 128, 128, $fc8941aa2060205a$var$deflate_slow),
    /* 6 */ new $fc8941aa2060205a$var$Config(8, 32, 128, 256, $fc8941aa2060205a$var$deflate_slow),
    /* 7 */ new $fc8941aa2060205a$var$Config(32, 128, 258, 1024, $fc8941aa2060205a$var$deflate_slow),
    /* 8 */ new $fc8941aa2060205a$var$Config(32, 258, 258, 4096, $fc8941aa2060205a$var$deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ function $fc8941aa2060205a$var$lm_init(s) {
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ $fc8941aa2060205a$var$zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = $fc8941aa2060205a$var$configuration_table[s.level].max_lazy;
    s.good_match = $fc8941aa2060205a$var$configuration_table[s.level].good_length;
    s.nice_match = $fc8941aa2060205a$var$configuration_table[s.level].nice_length;
    s.max_chain_length = $fc8941aa2060205a$var$configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
}
function $fc8941aa2060205a$var$DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = $fc8941aa2060205a$var$Z_DEFLATED; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new $9CLQF.Buf16($fc8941aa2060205a$var$HEAP_SIZE * 2);
    this.dyn_dtree = new $9CLQF.Buf16((2 * $fc8941aa2060205a$var$D_CODES + 1) * 2);
    this.bl_tree = new $9CLQF.Buf16((2 * $fc8941aa2060205a$var$BL_CODES + 1) * 2);
    $fc8941aa2060205a$var$zero(this.dyn_ltree);
    $fc8941aa2060205a$var$zero(this.dyn_dtree);
    $fc8941aa2060205a$var$zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new $9CLQF.Buf16($fc8941aa2060205a$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new $9CLQF.Buf16(2 * $fc8941aa2060205a$var$L_CODES + 1); /* heap used to build the Huffman trees */ 
    $fc8941aa2060205a$var$zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new $9CLQF.Buf16(2 * $fc8941aa2060205a$var$L_CODES + 1); //uch depth[2*L_CODES+1];
    $fc8941aa2060205a$var$zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.l_buf = 0; /* buffer index for literals or lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.last_lit = 0; /* running index in l_buf */ 
    this.d_buf = 0;
    /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */ this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
function $fc8941aa2060205a$var$deflateResetKeep(strm) {
    var s;
    if (!strm || !strm.state) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_STREAM_ERROR);
    strm.total_in = strm.total_out = 0;
    strm.data_type = $fc8941aa2060205a$var$Z_UNKNOWN;
    s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = s.wrap ? $fc8941aa2060205a$var$INIT_STATE : $fc8941aa2060205a$var$BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = $fc8941aa2060205a$var$Z_NO_FLUSH;
    $hx6dX._tr_init(s);
    return $fc8941aa2060205a$var$Z_OK;
}
function $fc8941aa2060205a$var$deflateReset(strm) {
    var ret = $fc8941aa2060205a$var$deflateResetKeep(strm);
    if (ret === $fc8941aa2060205a$var$Z_OK) $fc8941aa2060205a$var$lm_init(strm.state);
    return ret;
}
function $fc8941aa2060205a$var$deflateSetHeader(strm, head) {
    if (!strm || !strm.state) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    if (strm.state.wrap !== 2) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    strm.state.gzhead = head;
    return $fc8941aa2060205a$var$Z_OK;
}
function $fc8941aa2060205a$var$deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
    if (!strm) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    var wrap = 1;
    if (level === $fc8941aa2060205a$var$Z_DEFAULT_COMPRESSION) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > $fc8941aa2060205a$var$MAX_MEM_LEVEL || method !== $fc8941aa2060205a$var$Z_DEFLATED || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > $fc8941aa2060205a$var$Z_FIXED) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_STREAM_ERROR);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ var s = new $fc8941aa2060205a$var$DeflateState();
    strm.state = s;
    s.strm = strm;
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + $fc8941aa2060205a$var$MIN_MATCH - 1) / $fc8941aa2060205a$var$MIN_MATCH);
    s.window = new $9CLQF.Buf8(s.w_size * 2);
    s.head = new $9CLQF.Buf16(s.hash_size);
    s.prev = new $9CLQF.Buf16(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    s.pending_buf_size = s.lit_bufsize * 4;
    //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
    //s->pending_buf = (uchf *) overlay;
    s.pending_buf = new $9CLQF.Buf8(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
    s.d_buf = 1 * s.lit_bufsize;
    //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
    s.l_buf = 3 * s.lit_bufsize;
    s.level = level;
    s.strategy = strategy;
    s.method = method;
    return $fc8941aa2060205a$var$deflateReset(strm);
}
function $fc8941aa2060205a$var$deflateInit(strm, level) {
    return $fc8941aa2060205a$var$deflateInit2(strm, level, $fc8941aa2060205a$var$Z_DEFLATED, $fc8941aa2060205a$var$MAX_WBITS, $fc8941aa2060205a$var$DEF_MEM_LEVEL, $fc8941aa2060205a$var$Z_DEFAULT_STRATEGY);
}
function $fc8941aa2060205a$var$deflate(strm, flush) {
    var old_flush, s;
    var beg, val; // for gzip header write only
    if (!strm || !strm.state || flush > $fc8941aa2060205a$var$Z_BLOCK || flush < 0) return strm ? $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_STREAM_ERROR) : $fc8941aa2060205a$var$Z_STREAM_ERROR;
    s = strm.state;
    if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === $fc8941aa2060205a$var$FINISH_STATE && flush !== $fc8941aa2060205a$var$Z_FINISH) return $fc8941aa2060205a$var$err(strm, strm.avail_out === 0 ? $fc8941aa2060205a$var$Z_BUF_ERROR : $fc8941aa2060205a$var$Z_STREAM_ERROR);
    s.strm = strm; /* just in case */ 
    old_flush = s.last_flush;
    s.last_flush = flush;
    /* Write the header */ if (s.status === $fc8941aa2060205a$var$INIT_STATE) {
        if (s.wrap === 2) {
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
            $fc8941aa2060205a$var$put_byte(s, 31);
            $fc8941aa2060205a$var$put_byte(s, 139);
            $fc8941aa2060205a$var$put_byte(s, 8);
            if (!s.gzhead) {
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $fc8941aa2060205a$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                $fc8941aa2060205a$var$put_byte(s, $fc8941aa2060205a$var$OS_CODE);
                s.status = $fc8941aa2060205a$var$BUSY_STATE;
            } else {
                $fc8941aa2060205a$var$put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.time & 0xff);
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.time >> 8 & 0xff);
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.time >> 16 & 0xff);
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.time >> 24 & 0xff);
                $fc8941aa2060205a$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $fc8941aa2060205a$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.os & 0xff);
                if (s.gzhead.extra && s.gzhead.extra.length) {
                    $fc8941aa2060205a$var$put_byte(s, s.gzhead.extra.length & 0xff);
                    $fc8941aa2060205a$var$put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
                }
                if (s.gzhead.hcrc) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending, 0);
                s.gzindex = 0;
                s.status = $fc8941aa2060205a$var$EXTRA_STATE;
            }
        } else {
            var header = $fc8941aa2060205a$var$Z_DEFLATED + (s.w_bits - 8 << 4) << 8;
            var level_flags = -1;
            if (s.strategy >= $fc8941aa2060205a$var$Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
            else if (s.level < 6) level_flags = 1;
            else if (s.level === 6) level_flags = 2;
            else level_flags = 3;
            header |= level_flags << 6;
            if (s.strstart !== 0) header |= $fc8941aa2060205a$var$PRESET_DICT;
            header += 31 - header % 31;
            s.status = $fc8941aa2060205a$var$BUSY_STATE;
            $fc8941aa2060205a$var$putShortMSB(s, header);
            /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
                $fc8941aa2060205a$var$putShortMSB(s, strm.adler >>> 16);
                $fc8941aa2060205a$var$putShortMSB(s, strm.adler & 0xffff);
            }
            strm.adler = 1; // adler32(0L, Z_NULL, 0);
        }
    }
    //#ifdef GZIP
    if (s.status === $fc8941aa2060205a$var$EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            while(s.gzindex < (s.gzhead.extra.length & 0xffff)){
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $fc8941aa2060205a$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) break;
                }
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
                s.gzindex++;
            }
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (s.gzindex === s.gzhead.extra.length) {
                s.gzindex = 0;
                s.status = $fc8941aa2060205a$var$NAME_STATE;
            }
        } else s.status = $fc8941aa2060205a$var$NAME_STATE;
    }
    if (s.status === $fc8941aa2060205a$var$NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $fc8941aa2060205a$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $fc8941aa2060205a$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) {
                s.gzindex = 0;
                s.status = $fc8941aa2060205a$var$COMMENT_STATE;
            }
        } else s.status = $fc8941aa2060205a$var$COMMENT_STATE;
    }
    if (s.status === $fc8941aa2060205a$var$COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $fc8941aa2060205a$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $fc8941aa2060205a$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $5UMyJ(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) s.status = $fc8941aa2060205a$var$HCRC_STATE;
        } else s.status = $fc8941aa2060205a$var$HCRC_STATE;
    }
    if (s.status === $fc8941aa2060205a$var$HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) $fc8941aa2060205a$var$flush_pending(strm);
            if (s.pending + 2 <= s.pending_buf_size) {
                $fc8941aa2060205a$var$put_byte(s, strm.adler & 0xff);
                $fc8941aa2060205a$var$put_byte(s, strm.adler >> 8 & 0xff);
                strm.adler = 0; //crc32(0L, Z_NULL, 0);
                s.status = $fc8941aa2060205a$var$BUSY_STATE;
            }
        } else s.status = $fc8941aa2060205a$var$BUSY_STATE;
    }
    //#endif
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        $fc8941aa2060205a$var$flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return $fc8941aa2060205a$var$Z_OK;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && $fc8941aa2060205a$var$rank(flush) <= $fc8941aa2060205a$var$rank(old_flush) && flush !== $fc8941aa2060205a$var$Z_FINISH) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_BUF_ERROR);
    /* User must not provide more input after the first FINISH: */ if (s.status === $fc8941aa2060205a$var$FINISH_STATE && strm.avail_in !== 0) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_BUF_ERROR);
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== $fc8941aa2060205a$var$Z_NO_FLUSH && s.status !== $fc8941aa2060205a$var$FINISH_STATE) {
        var bstate = s.strategy === $fc8941aa2060205a$var$Z_HUFFMAN_ONLY ? $fc8941aa2060205a$var$deflate_huff(s, flush) : s.strategy === $fc8941aa2060205a$var$Z_RLE ? $fc8941aa2060205a$var$deflate_rle(s, flush) : $fc8941aa2060205a$var$configuration_table[s.level].func(s, flush);
        if (bstate === $fc8941aa2060205a$var$BS_FINISH_STARTED || bstate === $fc8941aa2060205a$var$BS_FINISH_DONE) s.status = $fc8941aa2060205a$var$FINISH_STATE;
        if (bstate === $fc8941aa2060205a$var$BS_NEED_MORE || bstate === $fc8941aa2060205a$var$BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return $fc8941aa2060205a$var$Z_OK;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === $fc8941aa2060205a$var$BS_BLOCK_DONE) {
            if (flush === $fc8941aa2060205a$var$Z_PARTIAL_FLUSH) $hx6dX._tr_align(s);
            else if (flush !== $fc8941aa2060205a$var$Z_BLOCK) {
                $hx6dX._tr_stored_block(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === $fc8941aa2060205a$var$Z_FULL_FLUSH) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ $fc8941aa2060205a$var$zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            $fc8941aa2060205a$var$flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return $fc8941aa2060205a$var$Z_OK;
            }
        }
    }
    //Assert(strm->avail_out > 0, "bug2");
    //if (strm.avail_out <= 0) { throw new Error("bug2");}
    if (flush !== $fc8941aa2060205a$var$Z_FINISH) return $fc8941aa2060205a$var$Z_OK;
    if (s.wrap <= 0) return $fc8941aa2060205a$var$Z_STREAM_END;
    /* Write the trailer */ if (s.wrap === 2) {
        $fc8941aa2060205a$var$put_byte(s, strm.adler & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.adler >> 8 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.adler >> 16 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.adler >> 24 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.total_in & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.total_in >> 8 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.total_in >> 16 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        $fc8941aa2060205a$var$putShortMSB(s, strm.adler >>> 16);
        $fc8941aa2060205a$var$putShortMSB(s, strm.adler & 0xffff);
    }
    $fc8941aa2060205a$var$flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? $fc8941aa2060205a$var$Z_OK : $fc8941aa2060205a$var$Z_STREAM_END;
}
function $fc8941aa2060205a$var$deflateEnd(strm) {
    var status;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    status = strm.state.status;
    if (status !== $fc8941aa2060205a$var$INIT_STATE && status !== $fc8941aa2060205a$var$EXTRA_STATE && status !== $fc8941aa2060205a$var$NAME_STATE && status !== $fc8941aa2060205a$var$COMMENT_STATE && status !== $fc8941aa2060205a$var$HCRC_STATE && status !== $fc8941aa2060205a$var$BUSY_STATE && status !== $fc8941aa2060205a$var$FINISH_STATE) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_STREAM_ERROR);
    strm.state = null;
    return status === $fc8941aa2060205a$var$BUSY_STATE ? $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_DATA_ERROR) : $fc8941aa2060205a$var$Z_OK;
}
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ function $fc8941aa2060205a$var$deflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var s;
    var str, n;
    var wrap;
    var avail;
    var next;
    var input;
    var tmpDict;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    s = strm.state;
    wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== $fc8941aa2060205a$var$INIT_STATE || s.lookahead) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = $gJUj4(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /*** CLEAR_HASH(s); ***/ $fc8941aa2060205a$var$zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        tmpDict = new $9CLQF.Buf8(s.w_size);
        $9CLQF.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ avail = strm.avail_in;
    next = strm.next_in;
    input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    $fc8941aa2060205a$var$fill_window(s);
    while(s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH){
        str = s.strstart;
        n = s.lookahead - ($fc8941aa2060205a$var$MIN_MATCH - 1);
        do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = $fc8941aa2060205a$var$MIN_MATCH - 1;
        $fc8941aa2060205a$var$fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return $fc8941aa2060205a$var$Z_OK;
}
$fc8941aa2060205a$export$72b35d618fb8ad9b = $fc8941aa2060205a$var$deflateInit;
$fc8941aa2060205a$export$a65c7b2bde87cb70 = $fc8941aa2060205a$var$deflateInit2;
$fc8941aa2060205a$export$8f99f0e30bc7dd53 = $fc8941aa2060205a$var$deflateReset;
$fc8941aa2060205a$export$e78fab288549509 = $fc8941aa2060205a$var$deflateResetKeep;
$fc8941aa2060205a$export$1cd50f7b2515ba19 = $fc8941aa2060205a$var$deflateSetHeader;
$fc8941aa2060205a$export$2316623ecd1285ab = $fc8941aa2060205a$var$deflate;
$fc8941aa2060205a$export$599854fa319a815f = $fc8941aa2060205a$var$deflateEnd;
$fc8941aa2060205a$export$f55e0b3ab66b5d46 = $fc8941aa2060205a$var$deflateSetDictionary;
$fc8941aa2060205a$export$12b6e1fcadea22f9 = 'pako deflate (from Nodeca project)'; /* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/ 

});
parcelRegister("hx6dX", function(module, exports) {

$parcel$export(module.exports, "_tr_init", () => $cc3a58b664fcb155$export$4e4fc0157c3cd14d, (v) => $cc3a58b664fcb155$export$4e4fc0157c3cd14d = v);
$parcel$export(module.exports, "_tr_stored_block", () => $cc3a58b664fcb155$export$8959e34c5e020172, (v) => $cc3a58b664fcb155$export$8959e34c5e020172 = v);
$parcel$export(module.exports, "_tr_flush_block", () => $cc3a58b664fcb155$export$44f15b52eef0cf41, (v) => $cc3a58b664fcb155$export$44f15b52eef0cf41 = v);
$parcel$export(module.exports, "_tr_tally", () => $cc3a58b664fcb155$export$b3cbce147289408f, (v) => $cc3a58b664fcb155$export$b3cbce147289408f = v);
$parcel$export(module.exports, "_tr_align", () => $cc3a58b664fcb155$export$bfb360e02ee9b403, (v) => $cc3a58b664fcb155$export$bfb360e02ee9b403 = v);
var $cc3a58b664fcb155$export$4e4fc0157c3cd14d;
var $cc3a58b664fcb155$export$8959e34c5e020172;
var $cc3a58b664fcb155$export$44f15b52eef0cf41;
var $cc3a58b664fcb155$export$b3cbce147289408f;
var $cc3a58b664fcb155$export$bfb360e02ee9b403;
'use strict';

var $9CLQF = parcelRequire("9CLQF");
/* Public constants ==========================================================*/ /* ===========================================================================*/ //var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var $cc3a58b664fcb155$var$Z_FIXED = 4;
//var Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ var $cc3a58b664fcb155$var$Z_BINARY = 0;
var $cc3a58b664fcb155$var$Z_TEXT = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var $cc3a58b664fcb155$var$Z_UNKNOWN = 2;
/*============================================================================*/ function $cc3a58b664fcb155$var$zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
var $cc3a58b664fcb155$var$STORED_BLOCK = 0;
var $cc3a58b664fcb155$var$STATIC_TREES = 1;
var $cc3a58b664fcb155$var$DYN_TREES = 2;
/* The three kinds of block type */ var $cc3a58b664fcb155$var$MIN_MATCH = 3;
var $cc3a58b664fcb155$var$MAX_MATCH = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ var $cc3a58b664fcb155$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $cc3a58b664fcb155$var$LITERALS = 256;
/* number of literal bytes 0..255 */ var $cc3a58b664fcb155$var$L_CODES = $cc3a58b664fcb155$var$LITERALS + 1 + $cc3a58b664fcb155$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var $cc3a58b664fcb155$var$D_CODES = 30;
/* number of distance codes */ var $cc3a58b664fcb155$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var $cc3a58b664fcb155$var$HEAP_SIZE = 2 * $cc3a58b664fcb155$var$L_CODES + 1;
/* maximum heap size */ var $cc3a58b664fcb155$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var $cc3a58b664fcb155$var$Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ var $cc3a58b664fcb155$var$MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ var $cc3a58b664fcb155$var$END_BLOCK = 256;
/* end of block literal code */ var $cc3a58b664fcb155$var$REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ var $cc3a58b664fcb155$var$REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ var $cc3a58b664fcb155$var$REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ var $cc3a58b664fcb155$var$extra_lbits = /* extra bits for each length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
];
var $cc3a58b664fcb155$var$extra_dbits = /* extra bits for each distance code */ [
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
];
var $cc3a58b664fcb155$var$extra_blbits = /* extra bits for each bit length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
];
var $cc3a58b664fcb155$var$bl_order = [
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
];
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
var $cc3a58b664fcb155$var$DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
var $cc3a58b664fcb155$var$static_ltree = new Array(($cc3a58b664fcb155$var$L_CODES + 2) * 2);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ var $cc3a58b664fcb155$var$static_dtree = new Array($cc3a58b664fcb155$var$D_CODES * 2);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ var $cc3a58b664fcb155$var$_dist_code = new Array($cc3a58b664fcb155$var$DIST_CODE_LEN);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ var $cc3a58b664fcb155$var$_length_code = new Array($cc3a58b664fcb155$var$MAX_MATCH - $cc3a58b664fcb155$var$MIN_MATCH + 1);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ var $cc3a58b664fcb155$var$base_length = new Array($cc3a58b664fcb155$var$LENGTH_CODES);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ var $cc3a58b664fcb155$var$base_dist = new Array($cc3a58b664fcb155$var$D_CODES);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function $cc3a58b664fcb155$var$StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
var $cc3a58b664fcb155$var$static_l_desc;
var $cc3a58b664fcb155$var$static_d_desc;
var $cc3a58b664fcb155$var$static_bl_desc;
function $cc3a58b664fcb155$var$TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
function $cc3a58b664fcb155$var$d_code(dist) {
    return dist < 256 ? $cc3a58b664fcb155$var$_dist_code[dist] : $cc3a58b664fcb155$var$_dist_code[256 + (dist >>> 7)];
}
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ function $cc3a58b664fcb155$var$put_short(s, w) {
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
}
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ function $cc3a58b664fcb155$var$send_bits(s, value, length) {
    if (s.bi_valid > $cc3a58b664fcb155$var$Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        $cc3a58b664fcb155$var$put_short(s, s.bi_buf);
        s.bi_buf = value >> $cc3a58b664fcb155$var$Buf_size - s.bi_valid;
        s.bi_valid += length - $cc3a58b664fcb155$var$Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
}
function $cc3a58b664fcb155$var$send_code(s, c, tree) {
    $cc3a58b664fcb155$var$send_bits(s, tree[c * 2], tree[c * 2 + 1]);
}
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ function $cc3a58b664fcb155$var$bi_reverse(code, len) {
    var res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
}
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ function $cc3a58b664fcb155$var$bi_flush(s) {
    if (s.bi_valid === 16) {
        $cc3a58b664fcb155$var$put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
}
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ function $cc3a58b664fcb155$var$gen_bitlen(s, desc) //    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var max_code = desc.max_code;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var extra = desc.stat_desc.extra_bits;
    var base = desc.stat_desc.extra_base;
    var max_length = desc.stat_desc.max_length;
    var h; /* heap index */ 
    var n, m; /* iterate over the tree elements */ 
    var bits; /* bit length */ 
    var xbits; /* extra bits */ 
    var f; /* frequency */ 
    var overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= $cc3a58b664fcb155$var$MAX_BITS; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < $cc3a58b664fcb155$var$HEAP_SIZE; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Trace((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
}
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ function $cc3a58b664fcb155$var$gen_codes(tree, max_code, bl_count) //    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
    var next_code = new Array($cc3a58b664fcb155$var$MAX_BITS + 1); /* next code value for each bit length */ 
    var code = 0; /* running code value */ 
    var bits; /* bit index */ 
    var n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= $cc3a58b664fcb155$var$MAX_BITS; bits++)next_code[bits] = code = code + bl_count[bits - 1] << 1;
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        var len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = $cc3a58b664fcb155$var$bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
}
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ function $cc3a58b664fcb155$var$tr_static_init() {
    var n; /* iterates over tree elements */ 
    var bits; /* bit counter */ 
    var length; /* length value */ 
    var code; /* code value */ 
    var dist; /* distance index */ 
    var bl_count = new Array($cc3a58b664fcb155$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < $cc3a58b664fcb155$var$LENGTH_CODES - 1; code++){
        $cc3a58b664fcb155$var$base_length[code] = length;
        for(n = 0; n < 1 << $cc3a58b664fcb155$var$extra_lbits[code]; n++)$cc3a58b664fcb155$var$_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ $cc3a58b664fcb155$var$_length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        $cc3a58b664fcb155$var$base_dist[code] = dist;
        for(n = 0; n < 1 << $cc3a58b664fcb155$var$extra_dbits[code]; n++)$cc3a58b664fcb155$var$_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < $cc3a58b664fcb155$var$D_CODES; code++){
        $cc3a58b664fcb155$var$base_dist[code] = dist << 7;
        for(n = 0; n < 1 << $cc3a58b664fcb155$var$extra_dbits[code] - 7; n++)$cc3a58b664fcb155$var$_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= $cc3a58b664fcb155$var$MAX_BITS; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        $cc3a58b664fcb155$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        $cc3a58b664fcb155$var$static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        $cc3a58b664fcb155$var$static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        $cc3a58b664fcb155$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ $cc3a58b664fcb155$var$gen_codes($cc3a58b664fcb155$var$static_ltree, $cc3a58b664fcb155$var$L_CODES + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < $cc3a58b664fcb155$var$D_CODES; n++){
        $cc3a58b664fcb155$var$static_dtree[n * 2 + 1] = 5;
        $cc3a58b664fcb155$var$static_dtree[n * 2] = $cc3a58b664fcb155$var$bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    $cc3a58b664fcb155$var$static_l_desc = new $cc3a58b664fcb155$var$StaticTreeDesc($cc3a58b664fcb155$var$static_ltree, $cc3a58b664fcb155$var$extra_lbits, $cc3a58b664fcb155$var$LITERALS + 1, $cc3a58b664fcb155$var$L_CODES, $cc3a58b664fcb155$var$MAX_BITS);
    $cc3a58b664fcb155$var$static_d_desc = new $cc3a58b664fcb155$var$StaticTreeDesc($cc3a58b664fcb155$var$static_dtree, $cc3a58b664fcb155$var$extra_dbits, 0, $cc3a58b664fcb155$var$D_CODES, $cc3a58b664fcb155$var$MAX_BITS);
    $cc3a58b664fcb155$var$static_bl_desc = new $cc3a58b664fcb155$var$StaticTreeDesc(new Array(0), $cc3a58b664fcb155$var$extra_blbits, 0, $cc3a58b664fcb155$var$BL_CODES, $cc3a58b664fcb155$var$MAX_BL_BITS);
//static_init_done = true;
}
/* ===========================================================================
 * Initialize a new block.
 */ function $cc3a58b664fcb155$var$init_block(s) {
    var n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < $cc3a58b664fcb155$var$L_CODES; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < $cc3a58b664fcb155$var$D_CODES; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < $cc3a58b664fcb155$var$BL_CODES; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[$cc3a58b664fcb155$var$END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.last_lit = s.matches = 0;
}
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ function $cc3a58b664fcb155$var$bi_windup(s) {
    if (s.bi_valid > 8) $cc3a58b664fcb155$var$put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
}
/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */ function $cc3a58b664fcb155$var$copy_block(s, buf, len, header) //DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
    $cc3a58b664fcb155$var$bi_windup(s); /* align on byte boundary */ 
    if (header) {
        $cc3a58b664fcb155$var$put_short(s, len);
        $cc3a58b664fcb155$var$put_short(s, ~len);
    }
    //  while (len--) {
    //    put_byte(s, *buf++);
    //  }
    $9CLQF.arraySet(s.pending_buf, s.window, buf, len, s.pending);
    s.pending += len;
}
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ function $cc3a58b664fcb155$var$smaller(tree, n, m, depth) {
    var _n2 = n * 2;
    var _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
}
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ function $cc3a58b664fcb155$var$pqdownheap(s, tree, k) //    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
    var v = s.heap[k];
    var j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && $cc3a58b664fcb155$var$smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if ($cc3a58b664fcb155$var$smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
}
// inlined manually
// var SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ function $cc3a58b664fcb155$var$compress_block(s, ltree, dtree) //    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
    var dist; /* distance of matched string */ 
    var lc; /* match length or unmatched char (if dist == 0) */ 
    var lx = 0; /* running index in l_buf */ 
    var code; /* the code to send */ 
    var extra; /* number of extra bits to send */ 
    if (s.last_lit !== 0) do {
        dist = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1];
        lc = s.pending_buf[s.l_buf + lx];
        lx++;
        if (dist === 0) $cc3a58b664fcb155$var$send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = $cc3a58b664fcb155$var$_length_code[lc];
            $cc3a58b664fcb155$var$send_code(s, code + $cc3a58b664fcb155$var$LITERALS + 1, ltree); /* send the length code */ 
            extra = $cc3a58b664fcb155$var$extra_lbits[code];
            if (extra !== 0) {
                lc -= $cc3a58b664fcb155$var$base_length[code];
                $cc3a58b664fcb155$var$send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = $cc3a58b664fcb155$var$d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            $cc3a58b664fcb155$var$send_code(s, code, dtree); /* send the distance code */ 
            extra = $cc3a58b664fcb155$var$extra_dbits[code];
            if (extra !== 0) {
                dist -= $cc3a58b664fcb155$var$base_dist[code];
                $cc3a58b664fcb155$var$send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */ //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
    //       "pendingBuf overflow");
    }while (lx < s.last_lit);
    $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$END_BLOCK, ltree);
}
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ function $cc3a58b664fcb155$var$build_tree(s, desc) //    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var elems = desc.stat_desc.elems;
    var n, m; /* iterate over heap elements */ 
    var max_code = -1; /* largest code with non zero frequency */ 
    var node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = $cc3a58b664fcb155$var$HEAP_SIZE;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)$cc3a58b664fcb155$var$pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        $cc3a58b664fcb155$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        $cc3a58b664fcb155$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ $cc3a58b664fcb155$var$gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ $cc3a58b664fcb155$var$gen_codes(tree, max_code, s.bl_count);
}
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ function $cc3a58b664fcb155$var$scan_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[$cc3a58b664fcb155$var$REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[$cc3a58b664fcb155$var$REPZ_3_10 * 2]++;
        else s.bl_tree[$cc3a58b664fcb155$var$REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ function $cc3a58b664fcb155$var$send_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do $cc3a58b664fcb155$var$send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                $cc3a58b664fcb155$var$send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$REP_3_6, s.bl_tree);
            $cc3a58b664fcb155$var$send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$REPZ_3_10, s.bl_tree);
            $cc3a58b664fcb155$var$send_bits(s, count - 3, 3);
        } else {
            $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$REPZ_11_138, s.bl_tree);
            $cc3a58b664fcb155$var$send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ function $cc3a58b664fcb155$var$build_bl_tree(s) {
    var max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ $cc3a58b664fcb155$var$scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    $cc3a58b664fcb155$var$scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ $cc3a58b664fcb155$var$build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = $cc3a58b664fcb155$var$BL_CODES - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[$cc3a58b664fcb155$var$bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
}
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ function $cc3a58b664fcb155$var$send_all_trees(s, lcodes, dcodes, blcodes) //    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
    var rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    $cc3a58b664fcb155$var$send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    $cc3a58b664fcb155$var$send_bits(s, dcodes - 1, 5);
    $cc3a58b664fcb155$var$send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    $cc3a58b664fcb155$var$send_bits(s, s.bl_tree[$cc3a58b664fcb155$var$bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    $cc3a58b664fcb155$var$send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    $cc3a58b664fcb155$var$send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ function $cc3a58b664fcb155$var$detect_data_type(s) {
    /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ var black_mask = 0xf3ffc07f;
    var n;
    /* Check for non-textual ("black-listed") bytes. */ for(n = 0; n <= 31; n++, black_mask >>>= 1){
        if (black_mask & 1 && s.dyn_ltree[n * 2] !== 0) return $cc3a58b664fcb155$var$Z_BINARY;
    }
    /* Check for textual ("white-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return $cc3a58b664fcb155$var$Z_TEXT;
    for(n = 32; n < $cc3a58b664fcb155$var$LITERALS; n++){
        if (s.dyn_ltree[n * 2] !== 0) return $cc3a58b664fcb155$var$Z_TEXT;
    }
    /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return $cc3a58b664fcb155$var$Z_BINARY;
}
var $cc3a58b664fcb155$var$static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ function $cc3a58b664fcb155$var$_tr_init(s) {
    if (!$cc3a58b664fcb155$var$static_init_done) {
        $cc3a58b664fcb155$var$tr_static_init();
        $cc3a58b664fcb155$var$static_init_done = true;
    }
    s.l_desc = new $cc3a58b664fcb155$var$TreeDesc(s.dyn_ltree, $cc3a58b664fcb155$var$static_l_desc);
    s.d_desc = new $cc3a58b664fcb155$var$TreeDesc(s.dyn_dtree, $cc3a58b664fcb155$var$static_d_desc);
    s.bl_desc = new $cc3a58b664fcb155$var$TreeDesc(s.bl_tree, $cc3a58b664fcb155$var$static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ $cc3a58b664fcb155$var$init_block(s);
}
/* ===========================================================================
 * Send a stored block
 */ function $cc3a58b664fcb155$var$_tr_stored_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    $cc3a58b664fcb155$var$send_bits(s, ($cc3a58b664fcb155$var$STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    $cc3a58b664fcb155$var$copy_block(s, buf, stored_len, true); /* with header */ 
}
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ function $cc3a58b664fcb155$var$_tr_align(s) {
    $cc3a58b664fcb155$var$send_bits(s, $cc3a58b664fcb155$var$STATIC_TREES << 1, 3);
    $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$END_BLOCK, $cc3a58b664fcb155$var$static_ltree);
    $cc3a58b664fcb155$var$bi_flush(s);
}
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */ function $cc3a58b664fcb155$var$_tr_flush_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    var opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    var max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === $cc3a58b664fcb155$var$Z_UNKNOWN) s.strm.data_type = $cc3a58b664fcb155$var$detect_data_type(s);
        /* Construct the literal and distance trees */ $cc3a58b664fcb155$var$build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        $cc3a58b664fcb155$var$build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = $cc3a58b664fcb155$var$build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->last_lit));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ $cc3a58b664fcb155$var$_tr_stored_block(s, buf, stored_len, last);
    else if (s.strategy === $cc3a58b664fcb155$var$Z_FIXED || static_lenb === opt_lenb) {
        $cc3a58b664fcb155$var$send_bits(s, ($cc3a58b664fcb155$var$STATIC_TREES << 1) + (last ? 1 : 0), 3);
        $cc3a58b664fcb155$var$compress_block(s, $cc3a58b664fcb155$var$static_ltree, $cc3a58b664fcb155$var$static_dtree);
    } else {
        $cc3a58b664fcb155$var$send_bits(s, ($cc3a58b664fcb155$var$DYN_TREES << 1) + (last ? 1 : 0), 3);
        $cc3a58b664fcb155$var$send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        $cc3a58b664fcb155$var$compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ $cc3a58b664fcb155$var$init_block(s);
    if (last) $cc3a58b664fcb155$var$bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
}
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ function $cc3a58b664fcb155$var$_tr_tally(s, dist, lc) //    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
    //var out_length, in_length, dcode;
    s.pending_buf[s.d_buf + s.last_lit * 2] = dist >>> 8 & 0xff;
    s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
    s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
    s.last_lit++;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[($cc3a58b664fcb155$var$_length_code[lc] + $cc3a58b664fcb155$var$LITERALS + 1) * 2]++;
        s.dyn_dtree[$cc3a58b664fcb155$var$d_code(dist) * 2]++;
    }
    // (!) This block is disabled in zlib defaults,
    // don't enable it for binary compatibility
    //#ifdef TRUNCATE_BLOCK
    //  /* Try to guess if it is profitable to stop the current block here */
    //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
    //    /* Compute an upper bound for the compressed length */
    //    out_length = s.last_lit*8;
    //    in_length = s.strstart - s.block_start;
    //
    //    for (dcode = 0; dcode < D_CODES; dcode++) {
    //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
    //    }
    //    out_length >>>= 3;
    //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
    //    //       s->last_lit, in_length, out_length,
    //    //       100L - out_length*100L/in_length));
    //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
    //      return true;
    //    }
    //  }
    //#endif
    return s.last_lit === s.lit_bufsize - 1;
/* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ }
$cc3a58b664fcb155$export$4e4fc0157c3cd14d = $cc3a58b664fcb155$var$_tr_init;
$cc3a58b664fcb155$export$8959e34c5e020172 = $cc3a58b664fcb155$var$_tr_stored_block;
$cc3a58b664fcb155$export$44f15b52eef0cf41 = $cc3a58b664fcb155$var$_tr_flush_block;
$cc3a58b664fcb155$export$b3cbce147289408f = $cc3a58b664fcb155$var$_tr_tally;
$cc3a58b664fcb155$export$bfb360e02ee9b403 = $cc3a58b664fcb155$var$_tr_align;

});

parcelRegister("gJUj4", function(module, exports) {
'use strict';
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $c2fc869ba2d0859c$var$adler32(adler, buf, len, pos) {
    var s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
}
module.exports = $c2fc869ba2d0859c$var$adler32;

});

parcelRegister("5UMyJ", function(module, exports) {
'use strict';
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
function $44e7d98dd6723a9a$var$makeTable() {
    var c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
}
// Create table on load. Just 255 signed longs. Not a problem.
var $44e7d98dd6723a9a$var$crcTable = $44e7d98dd6723a9a$var$makeTable();
function $44e7d98dd6723a9a$var$crc32(crc, buf, len, pos) {
    var t = $44e7d98dd6723a9a$var$crcTable, end = pos + len;
    crc ^= -1;
    for(var i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
}
module.exports = $44e7d98dd6723a9a$var$crc32;

});

parcelRegister("7gAmB", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
module.exports = {
    2: 'need dictionary',
    /* Z_NEED_DICT       2  */ 1: 'stream end',
    /* Z_STREAM_END      1  */ 0: '',
    /* Z_OK              0  */ '-1': 'file error',
    /* Z_ERRNO         (-1) */ '-2': 'stream error',
    /* Z_STREAM_ERROR  (-2) */ '-3': 'data error',
    /* Z_DATA_ERROR    (-3) */ '-4': 'insufficient memory',
    /* Z_MEM_ERROR     (-4) */ '-5': 'buffer error',
    /* Z_BUF_ERROR     (-5) */ '-6': 'incompatible version' /* Z_VERSION_ERROR (-6) */ 
};

});


parcelRegister("iC2HB", function(module, exports) {

$parcel$export(module.exports, "string2buf", () => $d8cddf31faab2448$export$7a4c1b2f775b5a9f, (v) => $d8cddf31faab2448$export$7a4c1b2f775b5a9f = v);
$parcel$export(module.exports, "buf2binstring", () => $d8cddf31faab2448$export$a751fe64af8a9a51, (v) => $d8cddf31faab2448$export$a751fe64af8a9a51 = v);
$parcel$export(module.exports, "binstring2buf", () => $d8cddf31faab2448$export$1d1a7119601ff18c, (v) => $d8cddf31faab2448$export$1d1a7119601ff18c = v);
$parcel$export(module.exports, "buf2string", () => $d8cddf31faab2448$export$49a50563f377746, (v) => $d8cddf31faab2448$export$49a50563f377746 = v);
$parcel$export(module.exports, "utf8border", () => $d8cddf31faab2448$export$53dee3f58a714214, (v) => $d8cddf31faab2448$export$53dee3f58a714214 = v);
// String encode/decode helpers
// convert string to array (typed, when possible)
var $d8cddf31faab2448$export$7a4c1b2f775b5a9f;
// Convert byte array to binary string
var $d8cddf31faab2448$export$a751fe64af8a9a51;
// Convert binary string (typed, when possible)
var $d8cddf31faab2448$export$1d1a7119601ff18c;
// convert array to string
var $d8cddf31faab2448$export$49a50563f377746;
// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var $d8cddf31faab2448$export$53dee3f58a714214;
'use strict';

var $9CLQF = parcelRequire("9CLQF");
// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
var $d8cddf31faab2448$var$STR_APPLY_OK = true;
var $d8cddf31faab2448$var$STR_APPLY_UIA_OK = true;
try {
    String.fromCharCode.apply(null, [
        0
    ]);
} catch (__) {
    $d8cddf31faab2448$var$STR_APPLY_OK = false;
}
try {
    String.fromCharCode.apply(null, new Uint8Array(1));
} catch (__) {
    $d8cddf31faab2448$var$STR_APPLY_UIA_OK = false;
}
// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var $d8cddf31faab2448$var$_utf8len = new $9CLQF.Buf8(256);
for(var $d8cddf31faab2448$var$q = 0; $d8cddf31faab2448$var$q < 256; $d8cddf31faab2448$var$q++)$d8cddf31faab2448$var$_utf8len[$d8cddf31faab2448$var$q] = $d8cddf31faab2448$var$q >= 252 ? 6 : $d8cddf31faab2448$var$q >= 248 ? 5 : $d8cddf31faab2448$var$q >= 240 ? 4 : $d8cddf31faab2448$var$q >= 224 ? 3 : $d8cddf31faab2448$var$q >= 192 ? 2 : 1;
$d8cddf31faab2448$var$_utf8len[254] = $d8cddf31faab2448$var$_utf8len[254] = 1; // Invalid sequence start
$d8cddf31faab2448$export$7a4c1b2f775b5a9f = function(str) {
    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
    // count binary size
    for(m_pos = 0; m_pos < str_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }
    // allocate buffer
    buf = new $9CLQF.Buf8(buf_len);
    // convert
    for(i = 0, m_pos = 0; i < buf_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) /* one byte */ buf[i++] = c;
        else if (c < 0x800) {
            /* two bytes */ buf[i++] = 0xC0 | c >>> 6;
            buf[i++] = 0x80 | c & 0x3f;
        } else if (c < 0x10000) {
            /* three bytes */ buf[i++] = 0xE0 | c >>> 12;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        } else {
            /* four bytes */ buf[i++] = 0xf0 | c >>> 18;
            buf[i++] = 0x80 | c >>> 12 & 0x3f;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        }
    }
    return buf;
};
// Helper (used in 2 places)
function $d8cddf31faab2448$var$buf2binstring(buf, len) {
    // On Chrome, the arguments in a function call that are allowed is `65534`.
    // If the length of the buffer is smaller than that, we can use this optimization,
    // otherwise we will take a slower path.
    if (len < 65534) {
        if (buf.subarray && $d8cddf31faab2448$var$STR_APPLY_UIA_OK || !buf.subarray && $d8cddf31faab2448$var$STR_APPLY_OK) return String.fromCharCode.apply(null, $9CLQF.shrinkBuf(buf, len));
    }
    var result = '';
    for(var i = 0; i < len; i++)result += String.fromCharCode(buf[i]);
    return result;
}
$d8cddf31faab2448$export$a751fe64af8a9a51 = function(buf) {
    return $d8cddf31faab2448$var$buf2binstring(buf, buf.length);
};
$d8cddf31faab2448$export$1d1a7119601ff18c = function(str) {
    var buf = new $9CLQF.Buf8(str.length);
    for(var i = 0, len = buf.length; i < len; i++)buf[i] = str.charCodeAt(i);
    return buf;
};
$d8cddf31faab2448$export$49a50563f377746 = function(buf, max) {
    var i, out, c, c_len;
    var len = max || buf.length;
    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    var utf16buf = new Array(len * 2);
    for(out = 0, i = 0; i < len;){
        c = buf[i++];
        // quick process ascii
        if (c < 0x80) {
            utf16buf[out++] = c;
            continue;
        }
        c_len = $d8cddf31faab2448$var$_utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) {
            utf16buf[out++] = 0xfffd;
            i += c_len - 1;
            continue;
        }
        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while(c_len > 1 && i < len){
            c = c << 6 | buf[i++] & 0x3f;
            c_len--;
        }
        // terminated by end of string?
        if (c_len > 1) {
            utf16buf[out++] = 0xfffd;
            continue;
        }
        if (c < 0x10000) utf16buf[out++] = c;
        else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
            utf16buf[out++] = 0xdc00 | c & 0x3ff;
        }
    }
    return $d8cddf31faab2448$var$buf2binstring(utf16buf, out);
};
$d8cddf31faab2448$export$53dee3f58a714214 = function(buf, max) {
    var pos;
    max = max || buf.length;
    if (max > buf.length) max = buf.length;
    // go back from last position, until start of sequence found
    pos = max - 1;
    while(pos >= 0 && (buf[pos] & 0xC0) === 0x80)pos--;
    // Very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) return max;
    // If we came to start of buffer - that means buffer is too small,
    // return max too.
    if (pos === 0) return max;
    return pos + $d8cddf31faab2448$var$_utf8len[buf[pos]] > max ? pos : max;
};

});

parcelRegister("9WDto", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $73d8265e2c50d00b$var$ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = '' /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
module.exports = $73d8265e2c50d00b$var$ZStream;

});


parcelRegister("3OYOJ", function(module, exports) {

$parcel$export(module.exports, "Inflate", () => $2c8537a6b47169be$export$d1de70a877d6e43c, (v) => $2c8537a6b47169be$export$d1de70a877d6e43c = v);
$parcel$export(module.exports, "inflate", () => $2c8537a6b47169be$export$cae1ce83fe4a1782, (v) => $2c8537a6b47169be$export$cae1ce83fe4a1782 = v);
$parcel$export(module.exports, "inflateRaw", () => $2c8537a6b47169be$export$d0f0aa2d05c905c5, (v) => $2c8537a6b47169be$export$d0f0aa2d05c905c5 = v);
$parcel$export(module.exports, "ungzip", () => $2c8537a6b47169be$export$95adf9d270383091, (v) => $2c8537a6b47169be$export$95adf9d270383091 = v);
/**
 * ungzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/ var $2c8537a6b47169be$export$d1de70a877d6e43c;
var $2c8537a6b47169be$export$cae1ce83fe4a1782;
var $2c8537a6b47169be$export$d0f0aa2d05c905c5;
var $2c8537a6b47169be$export$95adf9d270383091;
'use strict';

var $fzvBq = parcelRequire("fzvBq");

var $9CLQF = parcelRequire("9CLQF");

var $iC2HB = parcelRequire("iC2HB");

var $hf4Xu = parcelRequire("hf4Xu");

var $7gAmB = parcelRequire("7gAmB");

var $9WDto = parcelRequire("9WDto");

var $9t6AE = parcelRequire("9t6AE");
var $2c8537a6b47169be$var$toString = Object.prototype.toString;
/**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/ /* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/ /**
 * Inflate.result -> Uint8Array|Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param) or if you
 * push a chunk with explicit flush (call [[Inflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/ /**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/ /**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/ /**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/ function $2c8537a6b47169be$var$Inflate(options) {
    if (!(this instanceof $2c8537a6b47169be$var$Inflate)) return new $2c8537a6b47169be$var$Inflate(options);
    this.options = $9CLQF.assign({
        chunkSize: 16384,
        windowBits: 0,
        to: ''
    }, options || {});
    var opt = this.options;
    // Force window size for `raw` data, if not set directly,
    // because we have no header for autodetect.
    if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
        opt.windowBits = -opt.windowBits;
        if (opt.windowBits === 0) opt.windowBits = -15;
    }
    // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
    if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) opt.windowBits += 32;
    // Gzip header has no info about windows size, we can do autodetect only
    // for deflate. So, if window size not set, force it to max when gzip possible
    if (opt.windowBits > 15 && opt.windowBits < 48) // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    {
        if ((opt.windowBits & 15) === 0) opt.windowBits |= 15;
    }
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ''; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $9WDto();
    this.strm.avail_out = 0;
    var status = $fzvBq.inflateInit2(this.strm, opt.windowBits);
    if (status !== $hf4Xu.Z_OK) throw new Error($7gAmB[status]);
    this.header = new $9t6AE();
    $fzvBq.inflateGetHeader(this.strm, this.header);
    // Setup dictionary
    if (opt.dictionary) {
        // Convert data if needed
        if (typeof opt.dictionary === 'string') opt.dictionary = $iC2HB.string2buf(opt.dictionary);
        else if ($2c8537a6b47169be$var$toString.call(opt.dictionary) === '[object ArrayBuffer]') opt.dictionary = new Uint8Array(opt.dictionary);
        if (opt.raw) {
            status = $fzvBq.inflateSetDictionary(this.strm, opt.dictionary);
            if (status !== $hf4Xu.Z_OK) throw new Error($7gAmB[status]);
        }
    }
}
/**
 * Inflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Inflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the decompression context.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $2c8537a6b47169be$var$Inflate.prototype.push = function(data, mode) {
    var strm = this.strm;
    var chunkSize = this.options.chunkSize;
    var dictionary = this.options.dictionary;
    var status, _mode;
    var next_out_utf8, tail, utf8str;
    // Flag to properly process Z_BUF_ERROR on testing inflate call
    // when we check that all output data was flushed.
    var allowBufError = false;
    if (this.ended) return false;
    _mode = mode === ~~mode ? mode : mode === true ? $hf4Xu.Z_FINISH : $hf4Xu.Z_NO_FLUSH;
    // Convert data if needed
    if (typeof data === 'string') // Only binary strings can be decompressed on practice
    strm.input = $iC2HB.binstring2buf(data);
    else if ($2c8537a6b47169be$var$toString.call(data) === '[object ArrayBuffer]') strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    do {
        if (strm.avail_out === 0) {
            strm.output = new $9CLQF.Buf8(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $fzvBq.inflate(strm, $hf4Xu.Z_NO_FLUSH); /* no bad return value */ 
        if (status === $hf4Xu.Z_NEED_DICT && dictionary) status = $fzvBq.inflateSetDictionary(this.strm, dictionary);
        if (status === $hf4Xu.Z_BUF_ERROR && allowBufError === true) {
            status = $hf4Xu.Z_OK;
            allowBufError = false;
        }
        if (status !== $hf4Xu.Z_STREAM_END && status !== $hf4Xu.Z_OK) {
            this.onEnd(status);
            this.ended = true;
            return false;
        }
        if (strm.next_out) {
            if (strm.avail_out === 0 || status === $hf4Xu.Z_STREAM_END || strm.avail_in === 0 && (_mode === $hf4Xu.Z_FINISH || _mode === $hf4Xu.Z_SYNC_FLUSH)) {
                if (this.options.to === 'string') {
                    next_out_utf8 = $iC2HB.utf8border(strm.output, strm.next_out);
                    tail = strm.next_out - next_out_utf8;
                    utf8str = $iC2HB.buf2string(strm.output, next_out_utf8);
                    // move tail
                    strm.next_out = tail;
                    strm.avail_out = chunkSize - tail;
                    if (tail) $9CLQF.arraySet(strm.output, strm.output, next_out_utf8, tail, 0);
                    this.onData(utf8str);
                } else this.onData($9CLQF.shrinkBuf(strm.output, strm.next_out));
            }
        }
        // When no more input data, we should check that internal inflate buffers
        // are flushed. The only way to do it when avail_out = 0 - run one more
        // inflate pass. But if output data not exists, inflate return Z_BUF_ERROR.
        // Here we set flag to process this error properly.
        //
        // NOTE. Deflate does not return error in this case and does not needs such
        // logic.
        if (strm.avail_in === 0 && strm.avail_out === 0) allowBufError = true;
    }while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== $hf4Xu.Z_STREAM_END);
    if (status === $hf4Xu.Z_STREAM_END) _mode = $hf4Xu.Z_FINISH;
    // Finalize on the last chunk.
    if (_mode === $hf4Xu.Z_FINISH) {
        status = $fzvBq.inflateEnd(this.strm);
        this.onEnd(status);
        this.ended = true;
        return status === $hf4Xu.Z_OK;
    }
    // callback interim results if Z_SYNC_FLUSH.
    if (_mode === $hf4Xu.Z_SYNC_FLUSH) {
        this.onEnd($hf4Xu.Z_OK);
        strm.avail_out = 0;
        return true;
    }
    return true;
};
/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $2c8537a6b47169be$var$Inflate.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $2c8537a6b47169be$var$Inflate.prototype.onEnd = function(status) {
    // On success - join
    if (status === $hf4Xu.Z_OK) {
        if (this.options.to === 'string') // Glue & convert here, until we teach pako to send
        // utf8 aligned strings to onData
        this.result = this.chunks.join('');
        else this.result = $9CLQF.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * inflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
 *   , output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err)
 *   console.log(err);
 * }
 * ```
 **/ function $2c8537a6b47169be$var$inflate(input, options) {
    var inflator = new $2c8537a6b47169be$var$Inflate(options);
    inflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (inflator.err) throw inflator.msg || $7gAmB[inflator.err];
    return inflator.result;
}
/**
 * inflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $2c8537a6b47169be$var$inflateRaw(input, options) {
    options = options || {};
    options.raw = true;
    return $2c8537a6b47169be$var$inflate(input, options);
}
$2c8537a6b47169be$export$d1de70a877d6e43c = $2c8537a6b47169be$var$Inflate;
$2c8537a6b47169be$export$cae1ce83fe4a1782 = $2c8537a6b47169be$var$inflate;
$2c8537a6b47169be$export$d0f0aa2d05c905c5 = $2c8537a6b47169be$var$inflateRaw;
$2c8537a6b47169be$export$95adf9d270383091 = $2c8537a6b47169be$var$inflate;

});
parcelRegister("fzvBq", function(module, exports) {

$parcel$export(module.exports, "inflateInit2", () => $b562a383a327bea1$export$6792d92addc5c8a0, (v) => $b562a383a327bea1$export$6792d92addc5c8a0 = v);
$parcel$export(module.exports, "inflate", () => $b562a383a327bea1$export$cae1ce83fe4a1782, (v) => $b562a383a327bea1$export$cae1ce83fe4a1782 = v);
$parcel$export(module.exports, "inflateEnd", () => $b562a383a327bea1$export$224e1a443c3fba76, (v) => $b562a383a327bea1$export$224e1a443c3fba76 = v);
$parcel$export(module.exports, "inflateGetHeader", () => $b562a383a327bea1$export$6d4647cb9e1c75fc, (v) => $b562a383a327bea1$export$6d4647cb9e1c75fc = v);
$parcel$export(module.exports, "inflateSetDictionary", () => $b562a383a327bea1$export$60da749bed98ccf8, (v) => $b562a383a327bea1$export$60da749bed98ccf8 = v);
var $b562a383a327bea1$export$42de45683a92ba94;
var $b562a383a327bea1$export$7633ac2cd30f9650;
var $b562a383a327bea1$export$6710ea52c4ec9d6a;
var $b562a383a327bea1$export$9c140b25e26874f9;
var $b562a383a327bea1$export$6792d92addc5c8a0;
var $b562a383a327bea1$export$cae1ce83fe4a1782;
var $b562a383a327bea1$export$224e1a443c3fba76;
var $b562a383a327bea1$export$6d4647cb9e1c75fc;
var $b562a383a327bea1$export$60da749bed98ccf8;
var $b562a383a327bea1$export$220f6291ca35fd71;
'use strict';

var $9CLQF = parcelRequire("9CLQF");

var $gJUj4 = parcelRequire("gJUj4");

var $5UMyJ = parcelRequire("5UMyJ");

var $6OFFF = parcelRequire("6OFFF");

var $bxjQM = parcelRequire("bxjQM");
var $b562a383a327bea1$var$CODES = 0;
var $b562a383a327bea1$var$LENS = 1;
var $b562a383a327bea1$var$DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ //var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var $b562a383a327bea1$var$Z_FINISH = 4;
var $b562a383a327bea1$var$Z_BLOCK = 5;
var $b562a383a327bea1$var$Z_TREES = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var $b562a383a327bea1$var$Z_OK = 0;
var $b562a383a327bea1$var$Z_STREAM_END = 1;
var $b562a383a327bea1$var$Z_NEED_DICT = 2;
//var Z_ERRNO         = -1;
var $b562a383a327bea1$var$Z_STREAM_ERROR = -2;
var $b562a383a327bea1$var$Z_DATA_ERROR = -3;
var $b562a383a327bea1$var$Z_MEM_ERROR = -4;
var $b562a383a327bea1$var$Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* The deflate compression method */ var $b562a383a327bea1$var$Z_DEFLATED = 8;
/* STATES ====================================================================*/ /* ===========================================================================*/ var $b562a383a327bea1$var$HEAD = 1; /* i: waiting for magic header */ 
var $b562a383a327bea1$var$FLAGS = 2; /* i: waiting for method and flags (gzip) */ 
var $b562a383a327bea1$var$TIME = 3; /* i: waiting for modification time (gzip) */ 
var $b562a383a327bea1$var$OS = 4; /* i: waiting for extra flags and operating system (gzip) */ 
var $b562a383a327bea1$var$EXLEN = 5; /* i: waiting for extra length (gzip) */ 
var $b562a383a327bea1$var$EXTRA = 6; /* i: waiting for extra bytes (gzip) */ 
var $b562a383a327bea1$var$NAME = 7; /* i: waiting for end of file name (gzip) */ 
var $b562a383a327bea1$var$COMMENT = 8; /* i: waiting for end of comment (gzip) */ 
var $b562a383a327bea1$var$HCRC = 9; /* i: waiting for header crc (gzip) */ 
var $b562a383a327bea1$var$DICTID = 10; /* i: waiting for dictionary check value */ 
var $b562a383a327bea1$var$DICT = 11; /* waiting for inflateSetDictionary() call */ 
var $b562a383a327bea1$var$TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
var $b562a383a327bea1$var$TYPEDO = 13; /* i: same, but skip check to exit inflate on new block */ 
var $b562a383a327bea1$var$STORED = 14; /* i: waiting for stored size (length and complement) */ 
var $b562a383a327bea1$var$COPY_ = 15; /* i/o: same as COPY below, but only first time in */ 
var $b562a383a327bea1$var$COPY = 16; /* i/o: waiting for input or output to copy stored block */ 
var $b562a383a327bea1$var$TABLE = 17; /* i: waiting for dynamic block table lengths */ 
var $b562a383a327bea1$var$LENLENS = 18; /* i: waiting for code length code lengths */ 
var $b562a383a327bea1$var$CODELENS = 19; /* i: waiting for length/lit and distance code lengths */ 
var $b562a383a327bea1$var$LEN_ = 20; /* i: same as LEN below, but only first time in */ 
var $b562a383a327bea1$var$LEN = 21; /* i: waiting for length/lit/eob code */ 
var $b562a383a327bea1$var$LENEXT = 22; /* i: waiting for length extra bits */ 
var $b562a383a327bea1$var$DIST = 23; /* i: waiting for distance code */ 
var $b562a383a327bea1$var$DISTEXT = 24; /* i: waiting for distance extra bits */ 
var $b562a383a327bea1$var$MATCH = 25; /* o: waiting for output space to copy string */ 
var $b562a383a327bea1$var$LIT = 26; /* o: waiting for output space to write literal */ 
var $b562a383a327bea1$var$CHECK = 27; /* i: waiting for 32-bit check value */ 
var $b562a383a327bea1$var$LENGTH = 28; /* i: waiting for 32-bit length (gzip) */ 
var $b562a383a327bea1$var$DONE = 29; /* finished check, done -- remain here until reset */ 
var $b562a383a327bea1$var$BAD = 30; /* got a data error -- remain here until reset */ 
var $b562a383a327bea1$var$MEM = 31; /* got an inflate() memory error -- remain here until reset */ 
var $b562a383a327bea1$var$SYNC = 32; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ var $b562a383a327bea1$var$ENOUGH_LENS = 852;
var $b562a383a327bea1$var$ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
var $b562a383a327bea1$var$MAX_WBITS = 15;
/* 32K LZ77 window */ var $b562a383a327bea1$var$DEF_WBITS = $b562a383a327bea1$var$MAX_WBITS;
function $b562a383a327bea1$var$zswap32(q) {
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
}
function $b562a383a327bea1$var$InflateState() {
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib) */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new $9CLQF.Buf16(320); /* temporary storage for code lengths */ 
    this.work = new $9CLQF.Buf16(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
function $b562a383a327bea1$var$inflateResetKeep(strm) {
    var state;
    if (!strm || !strm.state) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ''; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = $b562a383a327bea1$var$HEAD;
    state.last = 0;
    state.havedict = 0;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new $9CLQF.Buf32($b562a383a327bea1$var$ENOUGH_LENS);
    state.distcode = state.distdyn = new $9CLQF.Buf32($b562a383a327bea1$var$ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return $b562a383a327bea1$var$Z_OK;
}
function $b562a383a327bea1$var$inflateReset(strm) {
    var state;
    if (!strm || !strm.state) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return $b562a383a327bea1$var$inflateResetKeep(strm);
}
function $b562a383a327bea1$var$inflateReset2(strm, windowBits) {
    var wrap;
    var state;
    /* get the state */ if (!strm || !strm.state) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 1;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return $b562a383a327bea1$var$inflateReset(strm);
}
function $b562a383a327bea1$var$inflateInit2(strm, windowBits) {
    var ret;
    var state;
    if (!strm) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    state = new $b562a383a327bea1$var$InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.window = null /*Z_NULL*/ ;
    ret = $b562a383a327bea1$var$inflateReset2(strm, windowBits);
    if (ret !== $b562a383a327bea1$var$Z_OK) strm.state = null /*Z_NULL*/ ;
    return ret;
}
function $b562a383a327bea1$var$inflateInit(strm) {
    return $b562a383a327bea1$var$inflateInit2(strm, $b562a383a327bea1$var$DEF_WBITS);
}
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ var $b562a383a327bea1$var$virgin = true;
var $b562a383a327bea1$var$lenfix, $b562a383a327bea1$var$distfix; // We have no pointers in JS, so keep tables separate
function $b562a383a327bea1$var$fixedtables(state) {
    /* build fixed huffman tables if first call (may not be thread safe) */ if ($b562a383a327bea1$var$virgin) {
        var sym;
        $b562a383a327bea1$var$lenfix = new $9CLQF.Buf32(512);
        $b562a383a327bea1$var$distfix = new $9CLQF.Buf32(32);
        /* literal/length table */ sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        $bxjQM($b562a383a327bea1$var$LENS, state.lens, 0, 288, $b562a383a327bea1$var$lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        $bxjQM($b562a383a327bea1$var$DISTS, state.lens, 0, 32, $b562a383a327bea1$var$distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ $b562a383a327bea1$var$virgin = false;
    }
    state.lencode = $b562a383a327bea1$var$lenfix;
    state.lenbits = 9;
    state.distcode = $b562a383a327bea1$var$distfix;
    state.distbits = 5;
}
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ function $b562a383a327bea1$var$updatewindow(strm, src, end, copy) {
    var dist;
    var state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new $9CLQF.Buf8(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        $9CLQF.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        $9CLQF.arraySet(state.window, src, end - copy, dist, state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            $9CLQF.arraySet(state.window, src, end - copy, copy, 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
}
function $b562a383a327bea1$var$inflate(strm, flush) {
    var state;
    var input, output; // input/output buffers
    var next; /* next input INDEX */ 
    var put; /* next output INDEX */ 
    var have, left; /* available input and output */ 
    var hold; /* bit buffer */ 
    var bits; /* bits in bit buffer */ 
    var _in, _out; /* save starting available input and output */ 
    var copy; /* number of stored or match bytes to copy */ 
    var from; /* where to copy match bytes from */ 
    var from_source;
    var here = 0; /* current decoding table entry */ 
    var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //var last;                   /* parent table entry */
    var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    var len; /* length to copy for repeats, bits to drop */ 
    var ret; /* return code */ 
    var hbuf = new $9CLQF.Buf8(4); /* buffer for gzip header crc calculation */ 
    var opts;
    var n; // temporary var for NEED_BITS
    var order = /* permutation of code lengths */ [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    if (state.mode === $b562a383a327bea1$var$TYPE) state.mode = $b562a383a327bea1$var$TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = $b562a383a327bea1$var$Z_OK;
    inf_leave: for(;;)switch(state.mode){
        case $b562a383a327bea1$var$HEAD:
            if (state.wrap === 0) {
                state.mode = $b562a383a327bea1$var$TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $5UMyJ(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = $b562a383a327bea1$var$FLAGS;
                break;
            }
            state.flags = 0; /* expect zlib header */ 
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = 'incorrect header check';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            if ((hold & 0x0f) !== $b562a383a327bea1$var$Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            else if (len > state.wbits) {
                strm.msg = 'invalid window size';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.dmax = 1 << len;
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? $b562a383a327bea1$var$DICTID : $b562a383a327bea1$var$TYPE;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case $b562a383a327bea1$var$FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== $b562a383a327bea1$var$Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = 'unknown header flags set';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $5UMyJ(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$TIME;
        /* falls through */ case $b562a383a327bea1$var$TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = $5UMyJ(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$OS;
        /* falls through */ case $b562a383a327bea1$var$OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $5UMyJ(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$EXLEN;
        /* falls through */ case $b562a383a327bea1$var$EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = $5UMyJ(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = $b562a383a327bea1$var$EXTRA;
        /* falls through */ case $b562a383a327bea1$var$EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Array(state.head.extra_len);
                        $9CLQF.arraySet(state.head.extra, input, next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        copy, /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200) state.check = $5UMyJ(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = $b562a383a327bea1$var$NAME;
        /* falls through */ case $b562a383a327bea1$var$NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $5UMyJ(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = $b562a383a327bea1$var$COMMENT;
        /* falls through */ case $b562a383a327bea1$var$COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $5UMyJ(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = $b562a383a327bea1$var$HCRC;
        /* falls through */ case $b562a383a327bea1$var$HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.check & 0xffff)) {
                    strm.msg = 'header crc mismatch';
                    state.mode = $b562a383a327bea1$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = $b562a383a327bea1$var$TYPE;
            break;
        case $b562a383a327bea1$var$DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = $b562a383a327bea1$var$zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$DICT;
        /* falls through */ case $b562a383a327bea1$var$DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return $b562a383a327bea1$var$Z_NEED_DICT;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = $b562a383a327bea1$var$TYPE;
        /* falls through */ case $b562a383a327bea1$var$TYPE:
            if (flush === $b562a383a327bea1$var$Z_BLOCK || flush === $b562a383a327bea1$var$Z_TREES) break inf_leave;
        /* falls through */ case $b562a383a327bea1$var$TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = $b562a383a327bea1$var$CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $b562a383a327bea1$var$STORED;
                    break;
                case 1:
                    /* fixed block */ $b562a383a327bea1$var$fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $b562a383a327bea1$var$LEN_; /* decode codes */ 
                    if (flush === $b562a383a327bea1$var$Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $b562a383a327bea1$var$TABLE;
                    break;
                case 3:
                    strm.msg = 'invalid block type';
                    state.mode = $b562a383a327bea1$var$BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case $b562a383a327bea1$var$STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = 'invalid stored block lengths';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$COPY_;
            if (flush === $b562a383a327bea1$var$Z_TREES) break inf_leave;
        /* falls through */ case $b562a383a327bea1$var$COPY_:
            state.mode = $b562a383a327bea1$var$COPY;
        /* falls through */ case $b562a383a327bea1$var$COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                $9CLQF.arraySet(output, input, next, copy, put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = $b562a383a327bea1$var$TYPE;
            break;
        case $b562a383a327bea1$var$TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = 'too many length or distance symbols';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = $b562a383a327bea1$var$LENLENS;
        /* falls through */ case $b562a383a327bea1$var$LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = $bxjQM($b562a383a327bea1$var$CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = 'invalid code lengths set';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = $b562a383a327bea1$var$CODELENS;
        /* falls through */ case $b562a383a327bea1$var$CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = 'invalid bit length repeat';
                            state.mode = $b562a383a327bea1$var$BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = 'invalid bit length repeat';
                        state.mode = $b562a383a327bea1$var$BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === $b562a383a327bea1$var$BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = 'invalid code -- missing end-of-block';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = $bxjQM($b562a383a327bea1$var$LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = 'invalid literal/lengths set';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = $bxjQM($b562a383a327bea1$var$DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = 'invalid distances set';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = $b562a383a327bea1$var$LEN_;
            if (flush === $b562a383a327bea1$var$Z_TREES) break inf_leave;
        /* falls through */ case $b562a383a327bea1$var$LEN_:
            state.mode = $b562a383a327bea1$var$LEN;
        /* falls through */ case $b562a383a327bea1$var$LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                $6OFFF(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === $b562a383a327bea1$var$TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = $b562a383a327bea1$var$LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = $b562a383a327bea1$var$TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = 'invalid literal/length code';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = $b562a383a327bea1$var$LENEXT;
        /* falls through */ case $b562a383a327bea1$var$LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = $b562a383a327bea1$var$DIST;
        /* falls through */ case $b562a383a327bea1$var$DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = 'invalid distance code';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = $b562a383a327bea1$var$DISTEXT;
        /* falls through */ case $b562a383a327bea1$var$DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = 'invalid distance too far back';
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = $b562a383a327bea1$var$MATCH;
        /* falls through */ case $b562a383a327bea1$var$MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = 'invalid distance too far back';
                        state.mode = $b562a383a327bea1$var$BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = $b562a383a327bea1$var$LEN;
            break;
        case $b562a383a327bea1$var$LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = $b562a383a327bea1$var$LEN;
            break;
        case $b562a383a327bea1$var$CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (_out) strm.adler = state.check = /*UPDATE(state.check, put - _out, _out);*/ state.flags ? $5UMyJ(state.check, output, _out, put - _out) : $gJUj4(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if ((state.flags ? hold : $b562a383a327bea1$var$zswap32(hold)) !== state.check) {
                    strm.msg = 'incorrect data check';
                    state.mode = $b562a383a327bea1$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = $b562a383a327bea1$var$LENGTH;
        /* falls through */ case $b562a383a327bea1$var$LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.total & 0xffffffff)) {
                    strm.msg = 'incorrect length check';
                    state.mode = $b562a383a327bea1$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = $b562a383a327bea1$var$DONE;
        /* falls through */ case $b562a383a327bea1$var$DONE:
            ret = $b562a383a327bea1$var$Z_STREAM_END;
            break inf_leave;
        case $b562a383a327bea1$var$BAD:
            ret = $b562a383a327bea1$var$Z_DATA_ERROR;
            break inf_leave;
        case $b562a383a327bea1$var$MEM:
            return $b562a383a327bea1$var$Z_MEM_ERROR;
        case $b562a383a327bea1$var$SYNC:
        /* falls through */ default:
            return $b562a383a327bea1$var$Z_STREAM_ERROR;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < $b562a383a327bea1$var$BAD && (state.mode < $b562a383a327bea1$var$CHECK || flush !== $b562a383a327bea1$var$Z_FINISH)) {
        if ($b562a383a327bea1$var$updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
            state.mode = $b562a383a327bea1$var$MEM;
            return $b562a383a327bea1$var$Z_MEM_ERROR;
        }
    }
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap && _out) strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/ state.flags ? $5UMyJ(state.check, output, _out, strm.next_out - _out) : $gJUj4(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === $b562a383a327bea1$var$TYPE ? 128 : 0) + (state.mode === $b562a383a327bea1$var$LEN_ || state.mode === $b562a383a327bea1$var$COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === $b562a383a327bea1$var$Z_FINISH) && ret === $b562a383a327bea1$var$Z_OK) ret = $b562a383a327bea1$var$Z_BUF_ERROR;
    return ret;
}
function $b562a383a327bea1$var$inflateEnd(strm) {
    if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/ ) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    var state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return $b562a383a327bea1$var$Z_OK;
}
function $b562a383a327bea1$var$inflateGetHeader(strm, head) {
    var state;
    /* check state */ if (!strm || !strm.state) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    if ((state.wrap & 2) === 0) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    /* save header structure */ state.head = head;
    head.done = false;
    return $b562a383a327bea1$var$Z_OK;
}
function $b562a383a327bea1$var$inflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var state;
    var dictid;
    var ret;
    /* check state */ if (!strm /* == Z_NULL */  || !strm.state /* == Z_NULL */ ) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== $b562a383a327bea1$var$DICT) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    /* check for correct dictionary identifier */ if (state.mode === $b562a383a327bea1$var$DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = $gJUj4(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return $b562a383a327bea1$var$Z_DATA_ERROR;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = $b562a383a327bea1$var$updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = $b562a383a327bea1$var$MEM;
        return $b562a383a327bea1$var$Z_MEM_ERROR;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return $b562a383a327bea1$var$Z_OK;
}
$b562a383a327bea1$export$42de45683a92ba94 = $b562a383a327bea1$var$inflateReset;
$b562a383a327bea1$export$7633ac2cd30f9650 = $b562a383a327bea1$var$inflateReset2;
$b562a383a327bea1$export$6710ea52c4ec9d6a = $b562a383a327bea1$var$inflateResetKeep;
$b562a383a327bea1$export$9c140b25e26874f9 = $b562a383a327bea1$var$inflateInit;
$b562a383a327bea1$export$6792d92addc5c8a0 = $b562a383a327bea1$var$inflateInit2;
$b562a383a327bea1$export$cae1ce83fe4a1782 = $b562a383a327bea1$var$inflate;
$b562a383a327bea1$export$224e1a443c3fba76 = $b562a383a327bea1$var$inflateEnd;
$b562a383a327bea1$export$6d4647cb9e1c75fc = $b562a383a327bea1$var$inflateGetHeader;
$b562a383a327bea1$export$60da749bed98ccf8 = $b562a383a327bea1$var$inflateSetDictionary;
$b562a383a327bea1$export$220f6291ca35fd71 = 'pako inflate (from Nodeca project)'; /* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/ 

});
parcelRegister("6OFFF", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
var $4f67bc996330e695$var$BAD = 30; /* got a data error -- remain here until reset */ 
var $4f67bc996330e695$var$TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ module.exports = function inflate_fast(strm, start) {
    var state;
    var _in; /* local strm.input */ 
    var last; /* have enough input while in < last */ 
    var _out; /* local strm.output */ 
    var beg; /* inflate()'s initial strm.output */ 
    var end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    var dmax; /* maximum distance from zlib header */ 
    //#endif
    var wsize; /* window size or zero if not using window */ 
    var whave; /* valid bytes in the window */ 
    var wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    var s_window; /* allocated sliding window, if wsize != 0 */ 
    var hold; /* local strm.hold */ 
    var bits; /* local strm.bits */ 
    var lcode; /* local strm.lencode */ 
    var dcode; /* local strm.distcode */ 
    var lmask; /* mask for first level of length codes */ 
    var dmask; /* mask for first level of distance codes */ 
    var here; /* retrieved table entry */ 
    var op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ var len; /* match length, unused bytes */ 
    var dist; /* match distance */ 
    var from; /* where to copy match from */ 
    var from_source;
    var input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = 'invalid distance too far back';
                            state.mode = $4f67bc996330e695$var$BAD;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = 'invalid distance too far back';
                                    state.mode = $4f67bc996330e695$var$BAD;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = 'invalid distance code';
                        state.mode = $4f67bc996330e695$var$BAD;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = $4f67bc996330e695$var$TYPE;
                break top;
            } else {
                strm.msg = 'invalid literal/length code';
                state.mode = $4f67bc996330e695$var$BAD;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};

});

parcelRegister("bxjQM", function(module, exports) {
'use strict';

var $9CLQF = parcelRequire("9CLQF");
var $86622ca50c32b2ec$var$MAXBITS = 15;
var $86622ca50c32b2ec$var$ENOUGH_LENS = 852;
var $86622ca50c32b2ec$var$ENOUGH_DISTS = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
var $86622ca50c32b2ec$var$CODES = 0;
var $86622ca50c32b2ec$var$LENS = 1;
var $86622ca50c32b2ec$var$DISTS = 2;
var $86622ca50c32b2ec$var$lbase = [
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
];
var $86622ca50c32b2ec$var$lext = [
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
];
var $86622ca50c32b2ec$var$dbase = [
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
];
var $86622ca50c32b2ec$var$dext = [
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
];
module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts) {
    var bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    var len = 0; /* a code's length in bits */ 
    var sym = 0; /* index of code symbols */ 
    var min = 0, max = 0; /* minimum and maximum code lengths */ 
    var root = 0; /* number of index bits for root table */ 
    var curr = 0; /* number of index bits for current table */ 
    var drop = 0; /* code bits to drop for sub-table */ 
    var left = 0; /* number of prefix codes available */ 
    var used = 0; /* code entries in table used */ 
    var huff = 0; /* Huffman code */ 
    var incr; /* for incrementing code, index */ 
    var fill; /* index for replicating entries */ 
    var low; /* low bits for current root entry */ 
    var mask; /* mask for low root bits */ 
    var next; /* next available space in table */ 
    var base = null; /* base value table to use */ 
    var base_index = 0;
    //  var shoextra;    /* extra bits table to use */
    var end; /* use base and extra for symbol > end */ 
    var count = new $9CLQF.Buf16($86622ca50c32b2ec$var$MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    var offs = new $9CLQF.Buf16($86622ca50c32b2ec$var$MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    var extra = null;
    var extra_index = 0;
    var here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= $86622ca50c32b2ec$var$MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = $86622ca50c32b2ec$var$MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= $86622ca50c32b2ec$var$MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === $86622ca50c32b2ec$var$CODES || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < $86622ca50c32b2ec$var$MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === $86622ca50c32b2ec$var$CODES) {
        base = extra = work; /* dummy value--not used */ 
        end = 19;
    } else if (type === $86622ca50c32b2ec$var$LENS) {
        base = $86622ca50c32b2ec$var$lbase;
        base_index -= 257;
        extra = $86622ca50c32b2ec$var$lext;
        extra_index -= 257;
        end = 256;
    } else {
        base = $86622ca50c32b2ec$var$dbase;
        extra = $86622ca50c32b2ec$var$dext;
        end = -1;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === $86622ca50c32b2ec$var$LENS && used > $86622ca50c32b2ec$var$ENOUGH_LENS || type === $86622ca50c32b2ec$var$DISTS && used > $86622ca50c32b2ec$var$ENOUGH_DISTS) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] < end) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] > end) {
            here_op = extra[extra_index + work[sym]];
            here_val = base[base_index + work[sym]];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === $86622ca50c32b2ec$var$LENS && used > $86622ca50c32b2ec$var$ENOUGH_LENS || type === $86622ca50c32b2ec$var$DISTS && used > $86622ca50c32b2ec$var$ENOUGH_DISTS) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};

});


parcelRegister("hf4Xu", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
module.exports = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    //Z_MEM_ERROR:     -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};

});

parcelRegister("9t6AE", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $6e4bef2851e6b301$var$GZheader() {
    /* true if compressed data believed to be text */ this.text = 0;
    /* modification time */ this.time = 0;
    /* extra flags (not used when writing a gzip file) */ this.xflags = 0;
    /* operating system */ this.os = 0;
    /* pointer to extra field or Z_NULL if none */ this.extra = null;
    /* extra field length (valid if extra != Z_NULL) */ this.extra_len = 0; // Actually, we don't need it in JS,
    // but leave for few code modifications
    //
    // Setup limits is not necessary because in js we should not preallocate memory
    // for inflate use constant limit in 65536 bytes
    //
    /* space at extra (only when reading header) */ // this.extra_max  = 0;
    /* pointer to zero-terminated file name or Z_NULL */ this.name = '';
    /* space at name (only when reading header) */ // this.name_max   = 0;
    /* pointer to zero-terminated comment or Z_NULL */ this.comment = '';
    /* space at comment (only when reading header) */ // this.comm_max   = 0;
    /* true if there was or will be a header crc */ this.hcrc = 0;
    /* true when done reading gzip header (not used when writing a gzip file) */ this.done = false;
}
module.exports = $6e4bef2851e6b301$var$GZheader;

});




parcelRegister("3uXKw", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("7ybLn", function(module, exports) {
module.exports = JSON.parse("\"eJyFWdtyGjkQ/RVqnnarcAo7vuE3jEnCxgEvGDtxKg9iRgxaa0ZEF9s4lX/fnrGdTVZ9lBcKTmvU96PW8C0bmqqStc9OsqsPwYlSdnaPDvb6naP+3v5+1s3emNpPRCVpwdAEq6TdOTW6mC61+hpksyBo/euCTrOg89MKUSm9/XUNwddSletGcbOcfo+90Cof1KWmdTu7e4S4N+pBFhfK5+vsxNsgu9lwLazIvbRz2Tw7evCyLmQxM5Won809PTUP2cnnnYOj7s7eQa97fNjvHvd2v3SzBS21WtXywjjllakbRb3eT4LLtcpva+lcdkJPZlfSunZZ1uu9ftXr9UjFxHiVP7my2drGh84f+Z+d3f5xv0uf/V77udt+vm4/jzqDwixlZ751XlauM65zYzfGCi+LV53OQOvOrNnHdWbSSXtHKOkZ0apC1eU8X8s2dO0mcy/qQtjiRUoLh2Lz7jmWB4cUto8vv/Zf97vZwOVNhGx2crhHP8/kj987uxShbO6Ld9fZyfF++/WKvu72Dp/i/EF6q3IKxedv2fVH2qAJ1YQscRtBEfje/R8sH3Itqhj/Ggx5utSxpA7VsglxWceywmgtbIxvpM2bio0EoiKRo/AAC9pcMfsJK2stV0gEHhOu2dHdMk/p4GI0p0YTMbzebtaS8Z5cUYbxxGnh1jH8KK2JUVMzWfL3zEq/tpJZu6JuZVB1x6x16oEB5R3nneRjWivO4Nxow+zhZKWASDcNHCv9GgRTg6WV1IiMm8ReriWJOPeM7YMYOo2hYQydxdAoht7E0NsYehdD4xj6K4bex9B5DH2IoUkMTWPoIob+jqFZDM1j6DKGFjF0FUPXMfQxhj7F0E0MLekQupWep40lyUCfPj8HOSVXKlc2DwyLhoa1HZ0cTIu0/MYbw3DOkukxhn+ZDmK4gGkohuViSMXQPzHE0CvTwky0mK5laG/DhDKGGG5g6IWJfYihuxi6jyGGSbcM6fP1BQphyR2m7fpUNXqlC3jUF+aeiTN/OjfHpW4GlriEmoGO5dktd3astLGKPQ/ALnmwdIznTADbtnGqHTnh1MJHswyKJJUBFNCI241/IwahXzHdsWIKnyY5lmYKUZbckfaEs6PY08DR5E5ayfQ+zUKitGLDkRpdASTjxX/hXQqXiHBaCkL0IwFALrVWG6eYRiVP/doENCk+Hfp8aVMAuNFH5MFzg0vL5CstmXYGfVWJ3HI1vLSSU1wYL3K+3wq6ZUnWf8t2YS4LCig3oYa6FDZUWgRGjSlpyGRYOhesH7LiC3bAjDzGFiua8fih8BwcsFOE8woqIrmgWQ2Cj3czWzLdqYFeg3Bmd2pNusVSyTNJG+N8SlB+AhRNSGdUgtR9whYU6k5x1fwJWDZIdYYADy1SD23BQ669dqEekaktF3yfLHAYBGqGBbAuoAdGWMkZEQR3/0g6mr+8qmBUIcrJQR0IPi6TpAEa1Shg1MvkbkO0G2DVUYInHXDTQUJUQLs2j7IuGcEMqHibdDIkmyQlHKCUWmBIDn29SUTucm0ss9kUaZ+BuM0BXgBrF0hB4CuzfbfhQjvgMDPRFJTgAOGAVqugvdpoZswMwMFL4CCNWl4JXagVc7vaYmqYAD0qVSyjZJklTh0syoEdNaJBlNAJCNAYbNS8eaOBgXv9trTmVtbsHcjKUjkw9b4FyR6nGCVQV/NXkRGoKQscMigyN+CBGxCx55dc4BXYyDMTyhCSgk7ylkejHzwdkWCAxodEVYIAP6LWQLqnKCPo6EGZckgzdmKaHEuAh2dSeyZXnidpf28SjIhNq5hXGgpYZNJz5giFvgATTsvjVMCWCpkxbZ6oV74i3yfr+BwkzltRyEpYxnKZYIUxiNIYFc45sJqCthaaORmamwlocJOqqBpMTYvf5A/ERyKHSsCl5NBzVrmk8kGYJ1M3TVteEEtw/3YYkKIhMCJANi9UzqXhDGxkk95MQH4MwGfpsk5KB2DPAeRofuaagn0eEx0yQqc90n2bdAUMAuNkKwATfPpyY8om37Xh3o9gLg1YRFuhf6vSF1ruIH8ETtXJrSjk+IRQqMdHofkf8ks3ey9tfSGUbf49/vL9XxrnGMA=\"");

});

parcelRegister("fCZVO", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("cOHfc", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("eVbDh", function(module, exports) {
module.exports = JSON.parse("\"eJyNnVtzG0eyrf8KA0/7RMhzJJK6+U2+zMX2mJYsEuJMzANEtihsgYQMEITaO/Z/P41CV+bKlaug86JQf6uArsrKXNVX8H8m3y9vb7u7+8m3k4t/btazm+7o5PmTZy+PTl88eXk6eTT56/Lu/tfZbTc0+Hu3eOju51ezb75bLq532maxYO2oarPb+aJndRCm3fzm425/Y8N/3M8W86tXdzeLoeXjYXv91/mX7vq3+f3Vx8m396tN92jy/cfZanZ1361+73af/PHLfXd33V2/Wd7O7sY+fvfd8svk239/8+T540ffHB+/ePTk8eOTRy+fHf/n0eR8aLxazO+635br+f18eTf59ptBBuHtx/nVp7tuvZ58+3TgF91qXZpNHj8+/svjx4+Hnfy6HAawG8z3y8/9ajeGo/+6+j9HT16+ePpo9+/z8u/L3b8vH5d/nx+9ul6+745+79f33e366B93V8vV5+Vqdt9d/+Xo6NVicfRm9z3rozfduls9DNTDOF8fzY7uV7Pr7na2+nS0/HD0y/xued9/7r4ZGi2OXv3taHZ3/X+Xq6P58AXrzfv1/Ho+W8279V+Gzv447Op6fnfz+9XHrsxA6cnv98NHZqvrqg4Nv599/vs4Ic+fvHg0eVe3np4cP5q8Wl/tAr0axR862/7m+PHzR5Pf76//Pp18+2QnDv+/2P3/9PF+vv7Z3a/mV0NA//0/k+m7ybfHz4dGvw5dWX+eDXH830d7fHJyssfdl6vF7Nb46fPTPf9jsxzi9X5hytOnz/bK3eb2/W6ibu6ydr1cLGYr4y+GiSn8c7e62qV7FZ4fH++F2e0grYf4mGQdLj0oM557/Xm26u4W3YeWRB+r3Zitd9+4/uQdfzEO9/Nis85duBqqdJZ38bH//LG7y82HocyXYiTrxWz9MQfrz261zHR512V4vxUt7z+uOtH2w3KzEnT+INqu518E7B46MbddiKmnw/xOpNXVcrG8y3jd3c6jZDOw2NlAot0fm9ki45tVN5SzD/PZkyc1abp1sZqqvHz+dJx7kX2vMvouo+8z+sH3/Oz5Hv2YO/NX/2BNhb/l7/p7Tph/5DD/lD/4c97jL156NeT/zB/8NffrLA/ot9zqdf6uN/mDv+d+vc0fPM8fvPBZOx0neppbvcvoMu/xXzn53g+L2afuPtiGhfz9oMU65c9FT7FUnK2v5vOr+epqc5tnbbOz7fWw/nR5j8XfQmfsY7M8nve51VVudZ1bieL8kD94k9HH3OV5Rv+d9/gpt/IStiXhNu/xLqNlRp9F1WerFxa4zpG4z9+1yR98yJWwza2Ek/aOdsc9xfRzV3f5FRPh+MXjmpWrRvtD2Xg/X1w3l/rr5VaYe1idPWL35TjNk+NJrbgPuwND9Fkfs1o7PiyWq7ng667xLVeb1bCMX3kAj0+wbNbzcuCaoluPWnRZ3Wzmg3K7vNdHDju5fPFX5Bh6S5wPc8HE8dNwKCcPB65nNzedSNs9x0MxOuDYzV236kTtD8dCs5vV7DOY2tOaWcNJRCd80MP7frY+EOHD6kofK9gERH04KRg/Pxxizz+v52shDWO9/7jchGPFtOyH5PaZW80eRD3Mrjb36tClePmHRfcla43Kup1drdThzvtVp3Z8vbyfXYWKc2k+zCQGwJQV1qF3trseQqqOUTd3N7PV5nYx24jdLG+Gw8xP4utmOA6Yl9uQsy688sOek+cjW66uPwzHeeHA0I9Q4iLrByCR+x7OYA/Pntoebgen2yxwF7ayzMRie70r+vVaLGCLuGNfeSK3I5KlGNRQn8Mp8ZD34hziH2lK3QliBvryH/PGlyY5qf51cfb86Cj3oC4X1/OHOSS0fyT2zA+YRXF4txsfOj/0ob4Rg3U596IygaHmr/T9hVJx3J6IGdWDfyb2zmeCPuBnAWknfs4weASchBxXJ1YDfX7yvIrjVQ+xK3IdXztjHvgodVx+VR3w8mjlaDRVP9KXw7FTqda3RWOFcCarhAzRw1yzJ/rha9z76ct66rn8s7u7EZn7Ju7Cz+LUID05DhbJocx9xQuJHc02xnrFY/Xznxw5i+rbj8uVGNUZ7d3DQFVgJ3pU8Kd1EaOwWTXRDjxienErFzjWm3KUsxL9jSnoUWzxaKtmgrebxf3886IX/WqU/9s4QEuk4Xjrfj5bXM8/fMhz1bet4de4H09YkSxeGwfT7MCq05auGuO9a9lgK2N+jQHyxZDqHy+/DUcMeA3OToFWy0/dHZ4ImTmuupv5Oh76eonGyYblONdFPdRYb4aqDucjHmw6hrTCbERm2Ur1fzU+8C+q8NOX9di1XOmK18Eszj/ef8zw+6YBLpRv2VjuGybTNVfHlvCqdfhwICtjgP18uVUavG9zhdaMtJae1jK6bu0517Ht++BhCa+Y9bigW9wLA78PJu2euF0ecMTUNfu6240YSWMNX8rjTK8FPvixq0/xCOfFySn4+JDAqyGR1/n7fud8Pa2Tv2gsJD8fXH9/iRPnpxJ2X0eZYrIFt4wYJuetGv8ldtviMETt42wBS0Mt8t2pSaxwnwu1BJgvx8MmT7WvTGCjFLrWgG6imeKAxmlVs6rPRn6XB4iWwbLnlhDXg010KmMbS/731AlbuMhtTs3Or+dXymh/iF8EB2aHDnd/pcNa625j3t4czuuD+3rV+M5XTZOOpwM2A/F73IgPHFD+2Fruad9+iVie3dkBWTwSsG87WAo0QeaXB/e0WN7s5vtuKcK9bJvpJq9jNYOGr2pU8s3Bye1gJfeYN9L3Tq7jdnHnLh80u+e3lrsfN7u7kf95NPm5W939NpuvdveQ/z15tbtbPXn0zenj/zwat/buEdC+nxGNpo7wb8PWU9/au0pAODAUzsL3nOUu4NIbuE1VoPv6Dyg4T1DGkAW2vzoU0L5wEL0OW2+HrZe+VWOGKIzehfMQi/M6ekBh9MBh9EDr6AHR6EGx0QMb6zqwYidILoatF7Y1Hbae2dblsPXkiW/WISGDvgPeDJsnvlU/CCjEAjh8H9AaC0AUC1AsFsAsFsDGWDh5CJmwDVoft/KI+tzzsRGWpiEqDuNUpM65UqsC5WqIata4LNyqnuXv5hI2rurYxFzMJlFFG9dlbTLXtglU4Mapyit/nRHUuyEqeueq8qt6niPKHmBcGYGJ2Q1MIkswrn3BZDYHE9ghTIg2UTF4RUVgGBWhaxhj6zBB+EfVwEQMUd0ZV3ZiYrsy2ViMa3cxmS3GBPYZE6LZVPyQE3KbW/UCNQIhXGg0A3QhQ1TfxsmFnLMLVQVcyBC5kHHpQlU9y9/NLmRcuZCJ2YVMIhcyrl3IZHYhE8iFjJMLVf46I3AhQ+RCzpULVfU8R5RdyLhyIROzC5lELmRcu5DJ7EImsAuZEF2oYnChisCFKkIXMsYuZIJwoaqBCxmi4jOuXMjEdmWyCxnXLmQyu5AJ7EImRBeq+CEn5Da36gVqBEK4EIYGrShyqvQokimRyM4UZLCnyMmjoiiNKjQ5a+yPLSuKyrdii2xeUScHi6K2sdiGvSyqZGhRJFcL4usGB3+LnEyOROV0ocl5Y17Y86KojC+2yO4XdbLAKGofjG3YDKPKjhjVaItBA28MHAwycHTJKLBVRlX4ZWgAphk5GUYUlX3GFl/xFTbSKGo3jW3YUqPKvhrVaK5Be2jUxbbRvm/xQ/ETrusEPRcpGRVK5LdBYrcFEbwWKTktStJnocGZ3A97LErKYVHP/ooquStK2luxBTsrauSrKJGrgvRaUnBUpOSnQVJuCg3OZezZSVFSPop6dlFUyUNR0g6KLdg/UWP3RC16JyjgnEDBN4GiayJmz0RNOCbI4JdIqdpRUl6J+kEvYJ9ESbsktmCPRI0dErXoj6A8yAzfyra9pu1ICVccR4+WaIhMxTiZoXN2wqqADRoiDzQuDbCqZ/m72fqMK98zMZueSeR4xrXdmcxeZwIZnXFyucpfZwT+ZojMzblytqqe54iypxlXhmZidjOTyMqMax8zmU3MBHYwE6J9VQzeVREYV0XoWsbYskwQflU1MCtDVH/GlU2Z2K5MNijj2p1MZmsygX3JhGhKFT/khNzmVr1AjUAIF6p9RRtyRhXuAhkRCOxEJoEVOSMvckGakcln4vvZjlxQfuRqNiTXyJFc0JbkOnuSK2RKLpArmfBaMPAlZ2RMIChnMvlcxJe9yQVlTq5md3KN7MkF7U+us0G5wg7lSrQo4+BRxsCkjKFLOWSbckX4lIlgVM6oQF1QVuXqgfpls3JBu5XrbFeusF+5Eg3L+IPI1a1o1yvWiolwrdoxdC1nZAQukGuBwK5lEriWM3ItF6RrmXwmvp9dywXlWq5m13KNXMsF7Vqus2u5Qq7lArmWCa8FA9dyRq4FgnItk89FfNm1XFCu5Wp2LdfItVzQruU6u5Yr7FquRNcyDq5lDFzLGLqWQ3YtV4RrmQiu5Ywq1AXlWq4eqF92LRe0a7nOruUKu5Yr0bWMP4hc3Yp2vWKtmAjXWo2/6OG7q4RMoGLyK8PsVqMAXlUJOVXF0qdG8Sx9L3tUxcqhqpb9qSrkThVrb6oqO1Pl5EsVkyuN+HUi4EiVkB8ZVm40iucphuxEFSsfqlp2oaqQB1WsHaiq7D+Vs/tUHr1npOA8IwHfGQm6TkXsOZULxxkl8JtKqLIqVl5TtWbNsc9UrF2mquwxlbPDVB79ZaQPKeu2qU2fiR69cJUx19FWDFHhGidjcc7OUhWwFkPkLcaluVT1LH8324tx5S8mZoMxiRzGuLYYk9ljTCCTMU4uU/nrjMBnDJHROFdOU9XzHFH2GuPKbEzMbmMS2Y1x7Tcms+GYwI5jQrScisFzKgLTqQhdxxjbjgnCd6oGxmOIas+4sh4T25XJ5mNcu4/JbD8msP+YEA2o4oeckNvcqheoEYjsQt8N9FXcip8tqDoGIBHSwvUeYiALoiAVRvEpLISmkFq+jnbV9cS3LJ0che4CxwRzWrsLiKYcFBsIMBsIsHEge/LDGPdT34pu+gPGHZDw1h8o7kCjo/4Q4g7Mugts7C6QaJs/jCXvW9OwtSv0575VRwcIuux0/3tsdXJ3ZPzJNUOj/2L4DFEMjVMgjatomphDahLF1TgH1wSOsAkxzIYp1pVfZDTNCEJviOJvPE9ClWgmKk7TUV4IjNNREU9H5TwdlcvpqKKYjirxdFSepqMKaTqqQNNRMU/HyC8ymmaE01ERT0flYjpGiadjxDQdfx1n4oVv1V0BqvEHFEIPHDoEtAYckMUamIUZ2BhhIDW4jnbjPPatOgJAdQSAwgiAwwiA1hEAshEAsxEAG0cApI7AUZ2tJ48N2UyN7Kdxqo59Kw70J5wqQGKgP9FUAY0D/SlMFTAa6E8wVUDiQH+CgTqxcTraxK08zE1jTBs5pk0eEx+SgSJGuxGj3YTR/jzZn/Kc+FY8LipIHAQVng6CCo0HQQXJA8mi0OFRYfV8BlA8Ftqhctzy1LbsWMhRPYFBFA6PnOPhEVB7TTRgO2py5MdGzvzYyNhyNwLfskg7ipF2jpF2apF2xJF2xSPtzCLtyCJtaBPivsn5oc47fp6oU46fJ+ls42eR1aCI/ODTi58nfGaxI70tUGUrLtEFpYU2vIsf6oIECgGpKhrUJAeGGlCMSNXhokYcOZKpyEileosqJD8JVIWkUkGyKmqTmuQy5Qa5YqkFFS+pXMckc0lHGaqbBCp0UlXNU5Nc/tSAnIBUbQrUiP2BZLIKUsk1orppJRJ7CalfLyThMNTgYCE1fIcaHS6k5EYkR2OKIngUCWRXpCbn+mWC1/DKVrx8t0fiyt1O2B3ej5eddptTO0bdbZULWce+aSUODOvScfwFzUE6jZLgfo3nl0m6vPPLRF3Z+SW/o+qIgnDwHVVTMRz4BueLiDAw+Q1OFkSIqtaKU9BbYp8DwWFrv/X4S8wriCAJFEdWVTRjG4xpVCCyUcD4ksJRJlnEOrZoRVy0Otykb4WS56BdwGOD0V5xDgxR9J2ruFcVI14ZxLoijLIxjq8JIrJVa8U06C2xz4HgCBpPsRuO08oJ5lPfirccCop3gwoSNyAKT/ceCo23HQqiWwqF0d2EwsKNhELqeunorZn5Gc45ojDdLlyE75mGrXdhy6/QnE3SxZmzibous6P13Nd3aee+I6oWA9NgiObCOE2IcTUrJuapMYnmxzhPkgk8UybE6TJMc4brDoWBZ6+x7pB6kb97mtG7jGBa00LEPE9wlWiWK+apDi9TwXxHTpMeRZr5KKrpjy1yDkSdEiGKnA1R5ZSIasyLqFFypPc6VfQ4TQ6916maXDT2N23wdw0O+aNfb5RizqSgUzoFjXMKXkSBjEJK+YQSZRNKKpdQz5mEKuURSpxFqHEOoRYzCBXKH3qHLceJc6f9DltucCH3M5X0naSQMerVLiHlbAGVcgUUzpT6pgCkiSHKEeOUIMZVdpiYU8MkygvjnBQmcEaYENPBMOUCvuxDYeAsaLzsQ+pF/u5pRu8ygmlP78YwzxNeJZrtinmq47k5zjgrNPEs0/yzrNKA2+Rs4BaUFCxzbrDOKcJ6zBRWKWFIftuMKadPklUWUaOL5n6nTeVdU4EMY4USjeWcb9SC0o5Uzj57uh/yzhllnAuUay6oLHM155drlFkucE65wtnkSswj55RB4UUejghnTetFHpYvxPdPBXsnGORFft8lCTkXTKMsMM7zX083YfoN0ewbp8k3rubexDz1JtHMG+eJN4Hn3YQ47YZp1vEaBIWB57xxDYLUi/zd04zeZQTTnS5KMM+TXSWa64p5qutTYzDVhmiqjdNUG1dTbWKeapNoqo3zVJvAU21CnGrDNNX44CeFgae68eAnqRf5u6cZvcsIpjo9J8k8T3WVaKorpqn+bZzl8cmE33CGkdXZRUZP1rkQHq1z7M/WOYNH6BzCM3QO7SE6R3UGgflzMmUrXjErKD7RWJC4q1J4uq5WaLx/UhDdDymMboIUFu58FBLvKv4G8zZeTdyh2KDLg7L7iIj0oDo5qHCbEHAeayfG2omxLkOK2f0+QOKRr8LTrZxC44NeBcmHw4tCT38VFh8JLyg+2/UbVscY/dcTfMS0bMVHTAsSj5gWnh4xLTQ+YlqQfMS0KPSIaWH0iGlh4RHT155GPow6tD15M9nfzYet+GxOQeLZnMLTszmFxmdzCpLP5hSFns0prE4RoPjY0ZvRn2GrZj6i4MounMetPN7zxnjP5XjP83h5IkER4z2nZ5HewEQ68WXkzQQfMnwzrhSuXcal+Q2tDyOtVzFh9g1RSIyruJiYg2MSRci4DpPJHCsTKEGMU5bgdWhGlC+N69CkngvUiJXMIRPbseJsMn44VimvTODkMiFmWL7UbghyDa+rUyvOOnVdfZTqg8SQeoYonMZVOE3M4TSJwmlch9NkDqcJlHrGKfUqfysQpZ5zlXpVPReoESuZeia2Y8WpZ/xwrFLqmcCpZ0JMPXy0nTIEUg8fbadWnHrq0fYqpefYjqXAoT3wHJtuIsKsn2PTaiPkjefYtMypqp9jk+rbpsDJe+h5B9nmvCkcjLlO6tjkazFPCR7V/5+Y52SPckr5KFPipwdBZJZiEaTnQOQnUkE0nwLZNximu5z9vfSt+g2A6hkToDApwGEPQGv4AVk4gVkMgY2BA1Lz15G/oPoWSxiQONV4S8UKNJ5qvBVlCQqdarzFAgQUTzV2aHeO98K34rsaBcV3NQoS72oUnt7VKDS+q1EQvatRGL2rUVh4V6OQ+K7GDl0tFzTyeu7qbXafeOZbdZSAqrEgwlECh1EihVNXwHXwgGzwwGzwzj72nz925Zzr2NgyjGqZZ2vZmJqlnJplnho+nQVFTJqdzgLKM2Sns45WcSsPZBW93IV1dzvPU74JpbjJ9rFpeMVGesUmewU/kgqKcJGNcJFNcpFtmPA+buUk7XPm4buILwlRENK7iMxVhNS7iCxRrPK7iCxwbPhdRMbktXj8fkqIXFcfv7OY/TcdvzPXTpyP31kgT07H78TBxQxRrRgnnzauHMHEbAsmkTcYZxswgQ3chOjihsko/LXPhQodmXrFXa4Ftnfj5PHOhdGb2K45Zfmmke8bZ/M3gVeAKqRloArLHAxeEIwfygGxNJjUyIHGImFyK0V4uTDeSAVeOCpfCdQYul5HqioWkyrBimKo4ahybTGx7Zy8yhjXS43JLWNNi44J2li3Odt6gRrlpFajcKCPa1IUOI5R5fUpqjLWsYmIeGzAcY9qCm+UU5CjTKGOIq9k6XLAqRR4VTtwOUA3ESucvhyg1cZq17gcoGVe+fTlAKmi7UeBiz6qvCJGVXpibCKcMTZgf4xqssEop/UyyrRqRpENM6jsaCTGdTS+SNeq5bSmRpVXVlLV+hqbfM1L5FobW/CKG9W07kY5rb5BzmtwfMmuFc60Hkf16xmo1ubY4GAGttbp2OhwmqY1O6oHEzGt30FdNYWDYWus6KGNWtdDA1zdo3BwbdIrfWzytdUnrfpRbaz9sdHhJSofB0T50BK1bdVA3xQOWkM+Sjif4BM953g8ACg+x3OeVn7g6XriOa7xgOiZnfOwmgMLT+qc47rtqNroiRH6IZR6PRnH2nj1xjmN+tCrNy7m8TdevXHOkWi9euNCjEnj1RvjFJ30ysrIG6+sEKdgHXplhUQVtq+8skI6BfDgKyukcigPvLJCGgVVvr2hIsjhlW9vBEqhbb+9ESQV1oNvbwSVQnrg7Y2gcTibb28EhUIpXm3IseIw5lcbHFEAG682OFeha7/a4BIFrfVqgwscLv1qg2MKFL8SQKHgEDVfCUgKBezwKwFJVuH76isBqQUF8yuvBCSdQ3vwlYCkUqAbz8LruHLYxbPwwCjUrWfhQVDhPfAsPGgU0uaz8KBwGBvPwgOn0KVHxzkqHC77iW0IlzMKlwsULhdUuFzN4XKNwuUCh8sVDpcrMVzOKVwmULiMc7jGXw6GYFVCoaqYAlWxClPVcpCqQiGqmANUOYen8hicSik0I6bAjJTCcjGG5IVvxdOVCwwFIHG2d0EhABrP6y7C0IHRNYQLGDKQeJK2Q/6zzGUrzlxB8SzLhbO4FVOhIDHfhae5LjTOc0Hy94KLQrNfWD0/BRSnd4d20/rMt+IpS0E1BIDEdYvC0ylNofH6Q0F00aEwutJQ2DhjQOoIHMXT2YtJekR7h+Kguzw5dqUGkZ6vTs5XuBADOE9jJyarozLdMbu44tm5u6Dy0rfiKXlB4jy88HTyXWg84y5InmYXhc6tC6s5Biheyr2Y5Ke2dyxfiNjRTZjZTc7GTSP1NjL1Njn1+DICKCIpNyIpNyEpp6PrwVbs9RRdD5AYyJRcD2gcyDS4HjDq7hRcD0isoekEH7iboncBEo95Tcm7gMYHuqbCu0ChR7em6F2A4oNx09G7Tn0r3gyYoncBEjcFpuRdQOPl/2nwLmD0q7VT8C4g8Vr+FLzrCRC8Cj0drWv/I2VTtC5A9nYJoPwLbVOyLqT4donj+BNt02BdwPztEmNmXT7UZUi4ZS6SZaMilrIilrki2LpAEbVi1gUoFwZdqJ2Sc/m87Zzr1MZvzgUoJp5zTDynlniO+GaTK56SzjwlndWUNNKHeupz3fepvi9Hwxt/qekSHQ+ZvZEGLL6IAwK+iQPYXsUB5m/cAPRXbgDWd24A2RtpznbW99y34ot8l8n6gKd3+y7R+gDRxIFigwFW8xJQ7bajmS2wl2h9gOLN4stkfcDTscElWh8gOgK4DNYHLFxHv0Trc1RL6CmQW/xl5svR+174VjyfuETvQ5TPJy7J+5CC9wGOpxmXwfuA0WnG5Wh0MARzOmTq1cxL8jrE9GrmpXA7lPitzUv0O2T0hublJP8Y9iVZns/XJjbaiIFuWgPd6IFuxEDZ91BSA3XnQxhfT7206/RgBukmRBLY0/RtiKQKd0s3IpKQfC7fikgKOV66GcECeF96x4y5ckH1jhlL5Ietd8xYZmdM75gxJ4+sHIzSELmlcbJM48o3TczmaRI5qHG2URPYS02IhmqYXNVvMoVS5XtPXANgc4bIaY2T3ToXnmtiNl6XsvuaRhZsnH3YBDbjKizFoJMtmyAty1ThW6axeZnQcDDTk42ZwqZtAjt3upPIgvDwKm1E8+TmJhyMj/J101rxaTm86c34ZK83hQyfbvlVJ1T3/JTGzt+866caCP9X9/2UllYBeedPibQWqHt/QoMVASktCiipdQH1vDSgSqsDSnqBwBa8RqBGywRKtFKABIsFUlovUKIlAyW1aqCeFw5Uae1AiZcP1HgFQS0uIqjQOhJuBgfHELeJRYGBaSOlNQUlWlaCJFYW1PPiEtS8vqBMSwxKvMqgxgsNaEsdkrTcoCYdFRsIU0WZfRW1hrVik+SuKPIChBqvQepRAaGJlQjUjf5QWo9Q+1oA1aqE8oEAttYmbHIogHmFQjEuUkM5TfxXQsqW/66PoXj/yYXd3yTc/5WH3dY2bPl1nrIVr/MUlK7zVNfDHhmibhmXfasqdLCibUZ97gH313ju9Ngx7LQh6rRx2emqQqcr2mbU5x5wp43nTodnlaDnkVP3oyjHEJrAQALfNnjf6B+PK4p5cJDuMDSkNDCU5LCgAQwK6FbSXvaJh4NSHkx9zAdGYoiGYVyOoaowgIq2GfW5B9xv47nT9tgH9NoZddsF2W+ToePGtoL1oh/cdxdy5+0hDOi8M+q8C7Lz4c/Tjx0Nf56eWS/6wZ2Xf55+1MYHJaDrlVDHK5bdhr96PXYQ/up1JH3aN3dX/NXrUam/QAe9NUTdNS77i38kd+we/pFcQn3uAfdZ/ZHcvfR+oAvbc9ny4wRDqpdF8IObijbhq+nv4b1PxxrAZd/o7+G9FwcUoNCN0Pfh8AFY+LWK92OkfauPW3kMOY5XA/VA7LY+Be2T+gGRqzH4sBX3dZWDD0K8xXs1dtx70MeZvKKOj7QeC3zMCIZgSPamqguBaETGD38RjQ2PbaiTPEp1bDNK9uJrRjBUQ7KHVV0IREM1fviLaKj4viR1koeq3pes0nBat1jMaLAGcbgOdT9NX0jIg3bla1/HAzelV11Og3clD39/cjRZf55d7T5yOtJywp3/bM1xlhta/MLh9GxybTstW1f7v10LyE38Ovj3dR2ob9kIHeHQ9nTcA+7YEO298of86W1GvUDUI+OpW7uKG4O03zleSj028hA+sA1bX8JWH7diR1J97yldpx87whd2jyN+yJ/fZvQlo14g6qb0or1EPz4w9pVfTz+O+CF/fpvRl4x6gaiv0kxGSbwmUjus3hI5FtpD4+u2Df6lwfsW5+G0zqpGPV+IG0ckrsEcJ+VBftFW0i+S9prSKBonU1X1a3M8CFB4FCA96O/aavxF476BeSio5bHQayHjOPitkOOIH/Lntxl9yagXiPqrzgdHiV8PGDub3g44Jv4gvmIr2BfBesWoy/I0cNT4Gf2xz+kR/WPiD+IrtoJ9EaxXjPosz/722ocJXiSvpItb8aigoHotHFH+AePC05HDnuKflHUcf9e4IPr14sLo14t3bGlHOWUrHjIVJE6KCk8nGoXGk6KC5ElRUeikqLB46FVQfDr0wyRcgq6IDp1OohDozX6unvjGOGwg40whgTgA9jAg9GkCOsYGSA0AoDpHjvykXVxeaF5aqO1gpEbicA3HMTvOAzctjd6VFAKTYhwMUzCMU0TyZeCbxmXgm4OXgSOEMOkfgdBiDNmBn4DQLVL42j8AoRvEUDZ+/kGrFNao3rTCxCEmVQW6/knNY9+KNsN/SHNPP43utHfcT+hOgKJ9Ok+W/QndCRDfA3LFHdSZXVVyZHfK9ij/SoYWaCyHfiVDN8kjbPxKhlb1uFu/kqFlikbjVzL26iKszouwBi/y6ruQ6+4inwct8knPonHSs2if9MQrAvj1+QchtEC7av8gxNig/v2XbUa9QPT16u/P7qXbCV7pLFux2goSi3rhqQoLjYt6QXJRLwot6oXRlc7CwpXO2wn+2d1bHDEg6N2e3k3qTWXbikddd2mwwNMh1t0k3DA2JP9GxN0k3h42RkdZdxO8GVzJ7uD11LbcHsU9FH335C4+4RURBaH1fFcUczjE012R68CoZ7uiwCHKT3YFDMHKt5LvUrUzz7HD37t7Qohip3/vjsUcu/R7d8x17PLv3bHAsePfuyMMscNLLhQIjp265FKl9JtCT6TAcTzwm0K6iYip/k0hrTbi2/hNIS2nWMvfFJIixj0tITKUaQ6aS8jYoN47gzkwRNE3ruJuYo64SRRr4zrKJnN8TeDImhBjivcbTyPqcyA4gu2bi8sJ3llbhnV4t+V/uGkZdrXMe1nqHaB3EYJd4UXck9iqzx/kPbcdbpmucCoOHUlXOE9E+77xPdyvrzw3Aoeu2DV5uRIpdEs++xEodengsx9LvGpHCLqCV+1OYqs+f5B70H6Kg47FsRekQGdIgT6R0je/jXvIcu5ouF7IDDoXrheeULtefJa7cuCxkXrWgX3IB9OGoAd4fE0f5P2r4+tRQksiBLuvCHafjWvZMK5l27g+T/D84DN+FlA6K6gXzFp3GKPeEuM9RvoqU1+4uug+3Ncv3f//m9NnptYPXscPGa73DIXmN3wjjnGMmrrpG1vEa49BC3ERY1jFsBiuHVJavRostdBZ0WI3t88ErjtUWvzFUtLqTWuthu6oFnnyq+SFMgRp96wHbsUJK6j2EpF1DuB4/f2ZkeugW/o4urF6KFt2KcsRXb8ywV569y9bxq08EHXlvPBU1IXGk+yC5El2Uegku7CYvQXFK+c7ZFfOPWx/hAbrMO51NJcVZhEimx+EjVje11s5ZSO0cv5QL0yu9oYHG+GC7Cra3QjtdrsPzRBNlHFKO+ece3Qvv0ay4uvcklPRnqn2uBiipDQuo2lPSFF6Vr4UqDF+ma0m5pQ1ifLWuE5ekzmDTaA0Nk65zM9O8DT8kZuuc+A4v41TkjvnTHfl0AR5bhtRiQ8nDZTJfSaxDsS5wKjY8xweEUOUDMapGJxzMfBfqngW8XVuycVQORSDISoG4zLW6Y9H0A6WAjXGL4tB/e0IlqgYWn87gmUuhvS3I5hTMaS/HUHT8Eduus6B42IwTsXgnIvBlUMT5PluRBUDXMGiTO4zicUgLl9VJVxUwZKIAidGVLk8SE1FEnUqlSBetz6Vyibfr3uqBC6hg/frVJtUTukGlxYORlAXWPMGl27AxXbwBpdulApP3+DSKhdhUFMpBvWP1sfWrWlIxRlVLlFSU6GS/vU0gLqMXJYuXwqV1de3OBVz6zroXo/Xi2qYEOUHEj0gATbuAcJLjXQKPG6Vv905vuhnyJ/1IU63yIN6YadQlUwT2f0JyvHM3JAlB3G8EBClevY+npa/yOKo7PN3mMOJO1rZigVeUDUbQKLQC0/VXWgs6YKoRAuj+4mFhfuJhcT6fADrfWFk518nvhVvOj4kpwKebkY+oCcBIiMCxX9xzVm1HEB1HI7op8u2MLRTI27N2+zH24YJb6XzbrPdbpseuxXGus1uus0WusWh7Qeyu4Ls9x3KVry1UVB8rm6P8o2OwtM9jj1Nz9UVHO96FER3NAqjmxn9WCsnvhXzqsdaASRSradaARpTrQ+1Asx/ws/ZWCtAYo71qVb6MA99noc+z0PfmIdezkOv56HP89CLeegb81CK4KltWRE4ikXgHIvAqRWBIy4CV7wInFkROLIiMET1XRdEzCpDlFrGKb+MqyQzMWeaSZRuxjnnTODEMyFmn2FKQb7MQqGAdDBEGWmc0tK5yE0Tc4K6lLPUNEpV45yvJnDShms3TyOi9G1cuyExJ3K+dkNcp7S4dkMCJXe+dhM5pzncpINMR0rJjhLlO0oq5VHPWY8qJT5KnPuocfqjFisAFSqC/C6IiBWkG1KqBpSoIIIkagL1XBZBzZWBMhUHSlwfqHGJgAZVgpQKBSVVK6jnckGVKgYlXTTYgusGNSodlKh6xGtAY1L8OYHnmP+EHAASnlj+k2ccMJ9n/UnzCzQ8hfwnziag+Lzxn+DjTGKn2cUTzt0XHp6UNBB2cMY0pOTfI68nm10mcVyG47gc53GZlsblShqXSXFchmlcxmlc+JJUp2kcX5DiGKOUxxn0NNaopvEGOY45SDTuoMHY//O//w/7Vd1G\"");

});

parcelRegister("g9ZKL", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("hgkij", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("4W9K8", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("gbK7N", function(module, exports) {
module.exports = JSON.parse("\"eJyFnVtzG0eShf8KA0+7EfKseJXkN9nj0Vj0yNaNEHZiHkCySWEJsmmAIA1PzH/fRqMr8+TJU9CLQv2dYqMrK/NU9Q349+jH9va2uXsYfT86+8dqOb1u9o72Tw5P9o4PTk72R89Gf2vvHt5Nb5uuwafZbbP87od2frnhq/kc+V7h09vZfI1KB8fN7Prr5jOGRj8/TOezi9d31/Ou1fNue/m32R/N5W+zh4uvo+8fFqvm2ejHr9PF9OKhWXxsNn/50x8Pzd1lc/mhvZ3eDcf1ww/tH6Pv//nd/snLZ98d7L98tv/8+fNnrw6P//Vs9LlrvJjP7prf2uXsYdbejb7/rpNB+PR1dnFz1yyXo++PO37WLJZ9s9Hz5wd/6XbUfci79mF2senIj+39erHpw95/Xfz33v6rl8fPNv++6P99tfn31fP+38P+3xd7ry/b82bv43r50Nwu936+u2gX9+1i+tBc/mVv7/V8vvdhs7fl3odm2SweO7oN4my5N917WEwvm9vp4mavvdr7ZXbXPqzvm+/+3nR/9frN3vTu8n/axd6s++Pl6nw5u5xNF7Nm+ZfucH/qPuZydnf98eJr08e/P4qPD92fTBeXRe0a/ji9//swJCcvTp6NvpSto5P9Z6PXy4tNqBed+PLw2eivjW13QX7xbPTx4fLv467tUf/fs+6/+4evtgP2j+ZhMbvoIvrPf4/GX0bfH2wi+647kuX9tAvkf55t8eHh4RY3f1zMp7fGj4+Pt/z3VduF6nzuyvNhR3er2/PNSF3fZe2ync+nC+N9NvTCfbO42CR5UV6Wz5/edtKyi08+tP4Q+jHP2v100dzNm6uaFP/Mjm+63OxxeePKi3KA89XSqAXtoqvNaf6Ir+v7r81dbt51ZdZ6Tw5evBxiP58uv+aj+bNZtJm2d02GD0+i5cPXRSPaXrWrhaCzR9F2OftDwOaxEYPb6Jjeze5EXl208/Yu42VzO4uSjcB8YwSJNr+vpvOMrxdNV8qim7+vmmVvNkV5dVjG3o/9xcHBlr02dHLyYot+yK1+zOiv+Q9/crS/v0V/8z8sqfAmo797mDon69HPuWNv8x+e5oP4xfu9cYcN+kc++nd5X7/mo/8tt3qf9/UBvONkiz7m4/qU//BzRmfCOca52ZeMJvkj/zdn33k3n900D8E3rEjPOy0WKv8dmcrL/WIqF7PZxWxxsbrNw7ba+Paym3xEjfQGFw7GjSpH9dzQURnai9zqMrcSn3yVP/E67+trDtIs7+v/8h/e5D/0Gjbrv81/KFynza3uM/o9d9vNwcpqmY/+Ie9rlQ/iMWfcU24lrHSdj+tPP4hXR55fMREODp6XrFxU2lM2HjyHbHyYzS+rk/1l+yTiHKZnnwoe+qWaJ8d+Ka+rzdoQjdb7rCaPq3m7mAm+bCp7uVgtunn8Yp1TqS+b5axfuwr/365bdFldr2adcts+6KXDRu53/A2ZQl8S52ommFhBdWs5uR64nF5fqzlty3ExRiuOzdg1i8Zr//io6N0S/noxvQdTK3963p0/NKKXHt7z6XJHhHerlQWYDUDU3e67NfbsfjlbCqnr68PXdhUWi2neD8ntI7eYPop6mF6sHtTapffyq3nzR9YqlXU7vVio9c75olEffNk+TC9Cxbk060YSA2DKAuvQD7a57EKqFqmru+vpYnU7n67Ex7TX3TrzRuxuiv2AcbkNOevCa1/3HJpnLy6vuoVeWBn6EiVOsr4Cidw/4Vf4hEP/hNvO6VZz/Ajz5qkzc43LTdEvl7OszCvL85YOtOy9hbQvZd7VZ3dW3OU9jJst5tKQ+tQcM9Cn/5g3PjXJQfXdxdHz1VE6AltIX84eZ5cihJN4ZL5iFsXhh135o8+7/mhNVWiTdX/yRWUCXc279M8LpeI4h8GOnOrB/4ZGyEaC/sBPA9KH+ElD5xFwFhLPMqmjL45eFHG48CE+ilzH14UxD7yXOi7v1AF4edRyNJqqL/Vld+xcqra3aKwQzmyVniGhm8DJE335Gj/9qCyo5u2fzd21yNwPVFF2Gqc66cmxs0h2Ze7r2pAu4oHAUFNf/fwnR85O7T59bReiV7/Sp3sYKlXwMfKTF0P7y4oRfaYP8IjFyS1c4Viu+lXOQhxvTEGPYo2TrRYTvF3NH2b387U4LuqgJ3kcjpJI3XrrYTadX86uxCnWum4N7+LneMKKZPHa2JlmO2adunRRGei7mg3WMuZdpTZ/ph3h9bduxYAX4ewUaNHeNHd4ImTmuGiuZ8u49PUSpbWXT8e5LuxsZNVVdTgf8WDHnPLCrBhaS5Hxuqyk1P+SaR+9KmvX/lJXvBBmcf7pQaxQfqwa4FxOqvvDaD5UTKapzo414XVt+bAjKysB/rNWGvzZ5gq1EalNPbx4t3mk9sm5ju2zdy5LaMbcL+uCZv4gLvg8BJN2T3xqdzhiXuKU3d2uRE/iEXmo5DrTa4FC71ef4grnxTH6eJfAiy6RxaF9TCcxNjFX5t9Tlcd+ihEHzk8l7MaOMsX6QuNnOn80XqvxX+iwSxy6qH2dzmFqKEW+OTWhS902FsrlzZfjsslT7RsDSOsgCwLPz3beHs0UOzQMqxrVqZzrP8oFomWwPsWxayGdTaibHm1lyv+xchAryvwyEF2CzC6U0f614o2Lncvdd3F8/HAr4/Zhd17v/KzXlX2+rpp0PB2wEYj7cSMWE6cvRSrTfc0pbuQC2hZkYSXge9tZCnQIdsVm5yfN2+vNeN+14mJVWzfTVZZKBnW7qlTytTwSu8ICM7nHvJK+d2pXfv3lLi+a3fNrNf7TanM78l/PRqfN4u636WyxuYv8z9Hrze3q0bPvjo//9WzY2rpHQNvjjGgwdYRv4tbWVQLCjqHwa7d15FvlEABBcgRuQxXotv4DCs4TlCFkgW2vDgW0LRxE78PWp27rlW+VmCEKvXfh8yYWz23LBsBR6D1w6D3Q0ntA1HtQrPfAhroOrLcTJGfd1r53f7zZPDR1stl87pulU8jg6AHfd5sHtlt4TuDZdy+OCl6FQ1nlkK0qIVvJkK1yyFbVkK1EyFYiZKsUssfY06dNFtjWOnRwXboECA59oEMjLGFDVMfGqZidc0UX5Y1AVNvGZYEXFarcEJW6cVXvJuaiN4kq37guf5PZA0wgIzBOblD4+4zAFwyROThXDlFUsAlDlPjGVfabmEvAJKoD47oYTOaKMIHLwoRYGwWjpxSGxlIYuosxthgThM8UDcymIOU4RVvlQ2bvMb5rCIQLmVQZgoofmVwbguRMJugheBRRAqMqaJ2Dw5ZlPPvWYB/oW4bIt4yTbzln3yrKG4HIt4xL3yoq+JYh8i3jyrdMzL5lEvmWce1bJrNvmUC+ZZx8q/D3GYFvGSLfcq58q6jgW4aoaIyrojExF41JVDTGddGYzEVjAheNCbFoCkbfKgx9qzD0LWPsWyYI3yoa+FZByreKtsqHzL5lfNcQCN8yqTIEFd8yuTYEybdM0EPwKKIEvlXQOgeHfct49i2MDZpX5ORgUSQbI5G9LMhvapxcLYrS2kIT8LfIyeSiqJwutsh2F3XyvChq44tt2P2iShYYRfLBIL6vcHDEyMkWSVTeGJqAQUZOJRpFVaexRS7WqFPFRlGXbWzDtRtVLuCoxioOGrppENBSg4C+GgU216gKhw0NwGYDV14bGqwqXWPXjeI3h1T4b9R3DWnFiWObnUOaPDmqO4b0sRZhsOjA15XAsllHMTu2E/RrpOTWKJFXB4mdGsQ3mpJLoyQ9GhqAQyMlf0ZJuTPq2ZtRJWdGSfsytmBXRo08GSVyZJDeSwpujJS8OEjKiaEB+DBSKlmUVMGinssVVSpWlHSpYgsuVNS4TFGLRQoKui5g9FzA6LiI2W9RE24LMngtUOW0IK9kV9hlUfrGkAmHRbU+ZBV3xRY7hiw5K2rVIXvUkQRPBbqWAWQ/RSm76dB9tFJD5KPGyUSds4MW5Y1A5J3GpXEWFVzTEFmmceWXJmazNImc0ri2SZPZI00ggzRO7lj4+4zAFw2RKTpXjlhUsENDVFjGVVWZmEvKJKon47qYTOZKMoHLyIRYQwWj5xWGhlcYup0xtjoThM8VDUyuIOVwRVvlQ2ZvM75rCISrmVQZgoqfmVwbguRkJugheBRRAgMraJ2Dw9ZlPPtWOVg0LmfkXC6QdYHA3mXSG8XIvVyQ9mUy+JczMjAXlIO5mi3MNfIwF7SJuc4u5grZmAvkYya8FwyczBlZGQjKy0wGM3NGpeSCqiVXczG5RtXkgi4n17meXOGCciVWlHF0NYNoawbR1xyysbkinM1EsDZjyttMXIlDZ3dzYeeQCH9zrTYkFYdzvTokyeNcqQzJo4oY2JyxtQgUG50L2enKkaHTOSOnc4GcDgR2OpPeKEZO54J0OpPB6ZyR07mgnM7V7HSukdO5oJ3OdXY6V8jpXCCnM+G9YOB0zsjpQFBOZzI4nTMqKxdUWbmay8o1KisXdFm5zmXlCpeVK7GsjKPTGUSnM4hO55CdzhXhdCaC0xlTTmfiShw6O50LO4dEOJ1rtSGpOJ3r1SFJTudKZUgeVcTA6YxtnO6QAmVOlwTo9qAthi9bcTsphFyuYPI4w+xwg/AmE3K3gqW3DSI4WyHkawUrVyta9rSikKMVrP2sqOxmhZOXFUxONuD3iYCLFUIeZlg52CCCfxVCpVKwKpSi5TIpChVJwbpEisoFUjiXR+GxOAaKbjUg9KoBoVMVxD5VuHCpQQKPGohyqEFapUNldyp4R8iFMxVFh7ziSkWthDw5UuEy5I85MuBFA1mngPCKq+C83hpqA23IEPmQcTIi5+xERXkjEHmRcWlGRQU3MkR2ZFz5kYnZkEwiRzKuLclk9iQTyJSMkysV/j4j8CVDZEzOlTMVFazJEBWKcVUpJuZSMYlqxbguFpO5WkzgcjEh1kvB6FGFoUkVhi5ljG3KBOFTRQOjKkg5VdFW+ZDZq4zvGgLhViZVhqDiVybXhiA5lgl6CB5FlMC0Clrn4LBtGU++9UNHX2/WUs9ty5ZejorHAAoxBY7rM6clkoAsSsAsQMCG2AApBe/ocx8p2/L0MxQOF3hISKPlcAHRmINiHQFmHQE2dGRL/lrifmxbFndHFndHMe7OMe5OLe6OPO7OPO7OStydWNwNbUziyPozDluTuGWziyOcO4wO367XecEWDf6MwTJEETNOYTOuYmdiDqBJFEXjHEoTOJ4mxKAapsgWDuEtaJzRRCCKtvEc8iKluPfveMa4F8RxL5zjXriMexFF3IvEcS88xb0IKe5FoLgXzHEfOMZ9QOOMJgJx3AsXcR8kivvfhpC/8q2yT0Al0IBCjIHDJwMtkQVkQQVm8QQ2hBJIiaKjqc3l/VbpAaDSA0ChB8ChB0BLDwBZD4BZD4ANPQBSeuBo+52gXZ8OCol6k/vUlKUkIt2nRvYJXk4OOHe1EV1tRFfbuJWPua0cYCsPsM1H0tK8CIo4xras4QHl2FtJ7G/nyrdhjfI2r1He5jXK28oa5a1co7zNa5S3Yo3yVqxR3qY1ytu8Rnk71MT+sW3ZGsVR6QGguGxxjssWp7ZsceSLE2e+OHFWFidOSg8c0VbugVUAIt2DRvYgVADg3LFGdKwRHWvjVj7mtnKArTzANh8JVwAo4hitAgDlSNOksEGr0GCVO7KqdGQlO7LKHeHTGlBER1Yi2KuQRaej7XWGbQn0W7FseyRqtOepRnsaa7RHdNSgUPX2rIQfUCzV02D1p9nqT7PVn1as/lRa/am2+tNs9afC6k+F1Z8Gqz/NVn9asfpTafWn2epPq1Z/Kqz+NFv9abb605DVpzmrTytZfSqz+jRn9Wk1q09FVp+KrD6VWb054z7yrXjhrEfpslj4KpNQFyRQiZCqqoWa5MKhBlRDpOpyokZcWSRTkZFK9RZVSA8SKKNJpYJkVaQ+NclVwA1yxVILKhlSuUZI5pKOclsVdoZF1jw1+VbH2QlI1aZAjXb3na2CVHKNqIKBkEBeQqqyFWqSHYYakNmQqn2HGrEFkcxuRHI0piiCR5FAdkVqcq5fRsOF8wPbsmvmgOLlchPOwtY4bE3ilp3nOsKTV6Pxy4fLGsmUgoeTh1+GWBxbZywAgPAi8JaGt/YPIqL+197aj+pZRuOMJgJRYNTr7CRVQiTfbC9xwhe6KQYcMfVC9yDFbILgkUAhZFUFMrY5qwnjmjCpChRgUnOYY4NKsEUjDnmuWBlFDn+9YocGg59i+A1R4J2rkBf1LKNxRhOBKLTGc1CLVAlnkDmQRVznGHDwjKewvRttLzNsP7DfssnVkV24chQnWec4szq16dSRT4/OfD3grFy4cmJz4xaVwnwtEPXFOHXIuOqViblrJlH/jHMnTeCemhC7a5j6jDcIGFGf0w0C5qrP6gYBS9TnfIOABe4z3yBgzH0ODvC6KnD/o8pRiKqMRWwiIhIbcFyimqIT5RSjKFOkokjxKvc/XwtEMTJO0TGu4mJijohJFAvjHAUTuP8mxJ4bjn3+dejukW/FmxO/YicBxcc9nKdbGL9irwD5AxzOrC/Ahm4AsSc5DH2KW2XyQhTmLRc2U9axbY3D1pfQchI0m7EApUcEfkWjPSJEYU5Gy1wFXBktSxT6bLQs8CCw0TKm4cAVMSMamMqKmNSzHM9xRl/yH05yKx42tUgepPCmOAxg5DSKUaShjKIaz9giD2rUaWSjyMMbVR7jqMaBjhqNdvrCC8lp3Hd94YVqclYZlXGFf6nsZ1Jpz1lR/dKHQYeXXiExkFJaoERJgZJKCdRzQqBK6YASJwNqnAqoxURAhdKA3rMXlFKg/p59bnAmIz+W9Ivcw0S25WGvvHs+qOV1QRhxQzTcxmmsjauBNjGPskk0xMZ5fE3gwTUhjqxhGlZ8R5gRDWjlHWFSz3I8xxl9yX84ya14+NT7tIMUL7LhELJCI8kyDSjLaly5TR5ebkGjzDIPNus85qzHoWeVMoDkT3WF8iHJKi2o0Vl1xMZV5Ut1b5Pq33DmsJwTyF6hg9RxRknjAqWLCypRXM0p4holhwucFq5wQrgSU8E5JUF4wzYxGvjaG7Ysn4nojgX7Iv52ItrxoMq3UAetXN2B0TREg2mcxtK4GkoT80iaRANpnMfRBB5GE+IoGqZBxKt9jGgIK1f7SD3L8Rxn9CX/4SS34sFTFwAHCU/SjwjR2KWTdOZq7NRJOks0dvkknQUeOz5JZ0xjh28mMKKxq7yZQOpZjuc4oy/5Dye5FY+deop/K/02DNv2mfLfcMQAlcECFMYJeHpO/TccHUA2MMBsTIANwwGkjISj/gkt648/oeXIntByJB4s73l6sLyn8cHyHtHj4z2jx8d7Fh4f74k9N2QoPrW4IX5BqN+KF7t6ZHfOAeVLXD1PV7e2FG+MO47Xu3pEl7p6Rle5NqyNW/mY28oBtvIA23wk6a61K+IY/f60o3ixbYP4qcX3I3wvod+KGdUjkT49T+nT05g+PZLvJfQKJVbPKLF6FhLr/Sg9ffZhhM+r9FvxIZUeiSdTep4eR+lpfAalR/LBk16hp016Fh8x6VF8ruRDcNUP2VA/1Lz0wzBwvp/Pub+fK/39LPv7OfeXBw4U0d/P9NTpBxg4J735H5etje8f2tYkbsVH+D+Qqw+0XESD0TdEITGu4mJiDo5JFCHjOkwmc6xMoAQxTlmSL2o6onzZeVHT1M9535w+xnfFSiSSSZVYVVLK5FqsUnKZEDMsXLeNGTLOSTMRiLJOXaQdpHLnC1LPEIXTuAqniTmcJlE4jetwmszhNIFSzzilXuGQeoYo9Zyr1Cvq57xvTj3ju2IlUs+kSqwqqWdyLVYp9UyIqYdvRB3HDBnnpJkIRKmn3ogqUuVJTRY4tN98UpObiDDvelKT1UrIdz6pyTKn6q4nNUnFtNXP9lRUmcKhzefaZ6Z0juq3Y65SOzbYGfNamsdGu2OeUz7KlPjpoadjlaXjWvpOqgIXRPWhp22DbrjhxbR+y57tcRRfTOuReDGt5+nFtJ7GF9N6RC+m9YxeTOtZeDGtJ/HFtE9DNe+/tC1bkDuKC3LnuCB3agtyR7wgd8UX5M7sdRBHdlpnyE/p+q34TFWP7EsgHMWX3p3jybtTe9Xdkb/G7szj7qzE3Unpgf/hRTuHs/Qt2Z6qOoldanIv7VQVUcgu57KX4VQVGufON6Lzjej81/X91yYe0iwM3Syn2MxPwoy1YRdt7ntb6Sie8gK1MnJEeQmKF5izkpeArJoM2YmiF9giDOkiXgXqURlERGFKcGHZ3M5y5qzCMaxyrFaVWK1krFY5VvzsNigiViuRF6tUFE+hD/6dV/2WebGj9D1XZVpFF04PujEnP9YPurGYnTk96MacPTo/6MZCdOv0oBtx8O10GsBcObg6DWCJvLx2GsAyu3o6DWBO/l44mLwhym3jZPfGleebmC3RJDJA4+yCJnDKmxDz3jDNCIVTcTsOc0PBIhI8SxinqcK5sAYT6xFSM4dpleilOcSEWvR4Nil8lrOF5xXjPLkUoc275WnG+K4giQnHJHJS49pOTWZPNYEmIeM0ExXO01Hhi5xKPDEZp9nJuZqiiirmqSKt8mHyjGV8V9jF3GVSJeyVWczkWtjTfGaCLu6n3GuY3gzRHGdcTHTp6eYyoPrpZq3y1Lfj6WbdREyD+ulmraYpsfJ0s5ZpetRPN0sVp0p9wUKrctqsXrDQDXgK3XnBQjdK06m+YKFVnlqDihNsFLggo8qTbVTllBubiGklNuAJJKppGolyqtYoU81GkafloLKjkRin6Pgya+0D03QdVZ60SVX2GJt8K9JyGo8tdo5FntKjvHss0vQe1Fktb9NUH9U04Qe5rX1cmvyj+u1gq4VAbMDzUlQrs1NslOaoKPMCIaq8TAhqWiwEdVFL7bRwiCovH0iVi4jQRi0lQoNVrUNpWRHVbw+oWmLEBjsHtLbciI12D2heekR5l5k91SKGi5Eo8JIkqmlh8nlYjZw8t62yB0BlugAUYg8cPgFoiTIgixowCxWwIT5ASg04Ks59bMRKYUD4cssJIepwermFueq6ermFJQpCfrmFBQ4Hv9zCmAJTOEWnYA5ReofkRHEKln6HRIoqbNV3SKROAay8QyJVDqV8h0RqFNQgUmSDxuGl9zBOMqXQqvcwhKTCWnkPQ6gUUvkehtA4nOI9DKFQKEGiQILCYcQ3G04IUQDTmw3MVejUmw0sUdDymw0scLj4zQbGFKjCKUoFc4jECwQnWqGA1V4gqMgqfDteIKi0oGBWXyCo6BzaygsEFZUCTTLFm1QOe3js/oQZhTo/dp8EFV752H3SKKTisfukcBjTY/eJU+hMoKAZ53DZz19AuJxRuFygcLmgwuVqDpdrFC4XOFyucLhcieFyTuEygcLlv8NC4Rq+pR+CVQiFqmAKVMEqTEXLQSoKhahgDlDhHJ7CY3AKpdAMmAJTfvohhuVsCMn+9ob+GcYDmT3kDCxeHAIBLwkBtgtBwPzKDkA/ewVYnkgFZFd2nG1+DOHQema/gwAonm+54L9+0G/ZywWOxG8e9Dx9O1JP4y8d9Ej+yEGv0O8b9Cz+tEGP4q8abJBfv+q34ulej+ySpyNx2tfzdK7X03iC1yM6YesZnaX1LJya9SSefp+N/IoSkm3i7h+8Kqgf5ec2Vv41o8DKaXZg8UlqF8Kj1IDxq0aB+zPWzuBRaofwLLVBu8SzPRPdoM11ncMXtmXnnI7iY0vO8QTUqT2g5MgfOHLmTxkZa+OxtiKybS2KrY5iK6KVvhAVJBVI/0pUYP5ugzF/wN5rAi+XeFat4lauFHU1pOeyLFa5LPTFjl4RBcOXNXoWCmZcvHn7yP04eDMw82ZgcchAwCEDbEMGzMcFoCc4wOLNgGysnPU3IXwrvvgwTg4LPL34MEaHBSRffBgHhwXmOWYovj4zHhz25Ni2bLHgyBYKjuIiwTkuEJza4sCRLwyc+aLAWVkQOLHFgKFSC8dA8JWg8WCw/hdN7qXZKyLdy0b2Mngr4Nz5RnS+EZ03X9262XiE18vHo3SRfDzKV8bHgwW+sL2aAwKKb6Q5xzfSnNobaY4oL0Hxd9WclbwEZC+mGfJr1TaIaHw+2P6jOGM0PkDip3DGZHxA4w/gjIXxgUI/ezMOxgcs/NjNhmwu0J74Vlyj9ygttifFL/d90zIAmPklsOg8IKD1ADbvAeYWA9DzDWDxS0BmPM76p8yPbSs+mztJfgk8Pag7Qb8ExI8uu0I/pzFBvwQUfyxjMvjlS98qRw2oxB9Q6Ahw6AjQ0hFAdrjALPTAhsgDKT1wFNcOk+SXk8Ev9/f3bdPzzJktSJHFPHMBrQQorkehtVmMIzcSZ5B8BumG42SEq9HJKK1GJ6O8cJwMrgm7bUUE2lpvw8IRsFeVM57SQYKCc2iTOjAvLmNkn5ORWjdORrhunIzSunGS7BN4WjdORmndOBH2CQqtGyejvG6cjHjdOLH7GeAn6WZNEtgW9e2apAqDTDdskpCsMt+ySQqZZrppwwLYZ35BkbgyUvmCIklkqdUXFElmc80vKBInmy0cvNYQGa5xcl3jynpNzP5rEpmwcXZiE9iOTYiebJiM2W/GhQrle3SEseqNsVWZwI7tgjIyU7N3uyQM3ERyceNs5SYkPy8Km3rh4OyGyN6Ns8cXoRWfl9zehJ2RUr5vGpu/CZUZwPQ0DZjCc4EJPCGkW7oURzE1FGklEE0SxtVMYWKeLkyiOcO4njhM5tnDBJ5CTIjzCN1xLQarbrkqjSeU6k1X1UBMK+q2q9LS5CJvvCqRphh161VoMNEgpbkGJTXdoJ5nHFRp0kFJzzvYgqce1Gj2QYkmIJBgDkJK0xBKNBOhpCYj1PN8hCpNSSjxrIQaT0yoxbkJFZqewr34YBTiLn1W0IwQs8+ixrNV0JQNY4M8ZwVVTFuo08yFEk9eqKX5C0SewkCCWQwpTWQo8VwGWqs/Ps1oqH0rmmpeQ5mnNtQqsxs2SRMcijzHocbTnHosJIdbTHagrjSlKQ8lNeuhnic+VGnuQ0lPf9iCZ0DUeBJELcyDXcX2P7u8/a2Z4myIBkdDFB5lAg6fArQ8iQLI7vsDs5vbwOC37AeCPxW9Refd1vmoXNU+x+E/MrQZ2APfKgMKSHzD0jkNIND4DUvnYsBAoW9YOg8DBCx8zfn50Mntb90M5pp+K+Ioq0XaXiTtwtA/KLrdzeXF8COsjprwOQ0mwIDKiyuIOAEGTglQqBsuYsyLAYW8GFjIiy27gunGSfcx82a5nNlMfjXY64FttXHL0sCR+P2oKzJBoPGXoq6E5YFCvwl1hQYHKP760xXms/eV8mB7afmKUmCbAdd5D9elpplXnhjfquX3RmDL5hVHOFv0dFaGrj/GWUiwLcrZtOWcTVsa0maLYtpsWUybnt2UtYhvxft0N2HlASjfuruhdQbScJ/dcLyjdxOWE8DoC8tuyqx+bFsx6Dd5DneeBuMmzNiO5G933cT52Vn8Sc+bMBsbWsetfNQ5VW7yWzVDFCpv1WiVRnDXWzW6SR7XHW/V6BY02rW3arTMOZDfcJHx4szY9YaLbvKtEeHU2f2Gi27ECVV5w0WrlGb5vQct7AxMzsNiJdv1wx1a1oBwTiwo7BQEXLJsURtsqS3z8XYrG6QhaFXxzMihvfRSpNA2O6whaEUPvD5WFfgbYdTOoF350tzHjKAVBpaQtyqTWFo6bWfHKEet/MW8uSqPSm/3yUK0I1bjd6iyKuyImyQ74gbRbFgls2GZzIbl8GWZLMYnSnpVB2tHpHaE6Vsx2h2gHdHZFZpdcakH5dsRgf9/d3Jo6pByI//60YiHFbvSQsqKXS70ny3i2U/UytwptfB0qWjhD+5FHC9mRK18oNS6mXg+n9bU+LCraHE/vegv5Bwl6dE60AVpdLEZsJe2FZ+s6ZEtKQDZwQEM18AWZQ1jepN33eRd0xLFOeY5UFyMOI6vpi/issMZPTO0YZ7a/VYszB7F0LtATy1tkM/0/VaciXtkAQAU9+9CnP8XZTVkh97mALeVaLYymm0OW1rWuCIC2sYX9hdh1WLoPoTNT7SeG/s9tPcprlQvJq0h6r1xyjHnnMP6jqNhsW9O6Xy/kbkYDnW3MUk5zdPNRuY8PuJmYxSuc5w5/43LIkg3LYdKKBwS3RDVhHEqDOeqOkylEgl3OmNnuVgq9zlJrA8R1071JifJtVHiUsp3OCO/z8OQKqsIv+c/hxqz72XyVoYoaMYp351zjfGXPg01hl/6RC25xtKXPiUuBlB96VOSco2lL31izqOXv/SJhOscZ64x47LG0rdHDTVWONSMIaox41RjzlWNmUo1hl85RZ3lGtNfOcVifYi4xmpfOcVybZS4xtJXThG/z8OQaqwIv+c/xxqLX68CbaPAAYwqVwCpqfbkd7qUCsxXn9RfpWqsXH3Sqhr2+tUn3UBUaeXqk1RTLtSuPin5ujaCqYajqitZf11MqeegYpVGgWs7qlzhpMo6j2242vPVOBWoVPm7rsbJJt9KhOQFu6/GyUa7cyG5Q+VqnFLva8Oc/SLIv9d26N4xnNj1Fxm2l2qMlKATtq+0iji+HBA1fEEgKvaSQMT+OkDk/kpA5OW1gEjtG6oC/jQqr3MasRNnwuIV0CJuvk37KOx3nNpM0mdPdEwnKUDdAMFPCvVb8XpPj6JN9Ehc3+l5uq7T03g9p0d0HadndP2mZ+G6TU/i9ZpHmBS8T1Fvcp/ojsNjNnrnsk/ihsJj8HFHoqt8v+Cx2JJv5WPmFx+NywNs85Hktx5NEcfYxvfRHoN9GDJreNGjpzQcT6FrT7lrT5WuPcmuPeWuPVW79iS69pS79pS79pS7tk5dW4dMW+dMW+dMW1cybS0zba0zbZ0zbS0ybS0ybT3Ce+prHA5A4p76moYDaLynvhbDAQrdU1/jcACK99TXYjj4wscwJuHCR2zJo5MvfDAX4yQvfLCURyxf+CDOYycufEQBRjFdHmCuxlNdHmCJRrZ2eYBlHuN0eYA5jXa6FjAMuXh2cRh1fnYxteexl08uCklkQOW5RaXmPFCPLQqJs0E/tpg0yAn1MKGQVGZUHiUUKuXHjgcJRQvOEvUYoZAoV9RDhF26/Os//w8s8zdF\"");

});

parcelRegister("lan6Z", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("1zetG", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("53nEH", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("fhfja", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("enbPQ", function(module, exports) {
module.exports = JSON.parse("\"eJxtmNtu20YQhl+F4FULyMGeD7pz3AY1ChtG7NpFA18w1NomIlECSRcxgrx7SVk7+wOdG8H5OJydf2Z2d5gf9cV+t0v9VK/r+6vXsXlOlbHe28paq229qj/t++m62aXZ4J/m8PRb1z9/baZxefK63Z6eXN5dVMvTCh83u277xr/6kLrnl2XNq7TpXnczuZyabdee98/b2VzM/x4/dd/T5qab2pd6PQ2vaVVfvDRD005puE3Lu7eH1HbN9hTjx4/77/X6y5lcnUmjVzHIVVDicVX/1W/SsO36dLMfu6nb9/X6TAoBD+5euvZbn8axXtuZ36dhPJrVQqgPQoh5hev91LWLkIv94W1Ygq9+aX+tZAx2tfz64284/sblN/rqfLP/mqrbt3FKu7G67Nv9cNgPzZQ2H6rz7bb6vLgZq89pTMO/M/xfEqturJpqSM/d7GJIm2oamk3aNcO3av80O5xh3yyKmm1193ZIT02bqovTKjP+MAf++7zsZvZ3276kYyWWXB0z99S18/PbafPHQ71W4fjn/fxnFO+ZvkrT0LVzTr78qB/+nk38bHM9exgP8zr1z9U7jt6840YW5uSJKcZOCaBBnKgm5mU8MVNYyMwWFvO7Ukagkmgg6sDWQ5yFFqjzUrLEaQ3BEmiwNsMSaZS0vgWfOkPHWQowNeTUc0kumnxZvsgPxlGai6VTGUqAVCTQ6QkWnc77DKEiLktSUBJKqHIQZ86d8gCpHYoiEzMsb1ubYy8vW50DChB5ZhGqrijD0EqUIeiaEHIfCg5Kpuu0ApiToaGPSY0uaQsyr65L2oKi1yFt1PLaQ3lzfXTgXodGoJYzglndSLDMPg1sTPJpQJHJigw0QrGERqD9YhyTOgONQDUyuF1zaxuokc/BW2ztXCMrGZ9WMW1oQZHIXWNBkSCfRZEL5BMUiZw6CzVSFCfUSGZFNjIldoKDkonTKQiJIGzWmFd3BizJJ9SINoLDriOfUCOZS+zg+KGD1qGiLNMLxtJD1/ns00ON6EzyUCM6vbxhoBKaqbG3DFQCNiL1iHccBPV0DHhQH/JW8EW90dkyFKGywCJU0WkVSvSGeiSUODWFFD0HYdPQVoiRgfPMA+/nnRgiAyNYSjpWNQcNSMrtFCUH4ZIRpSCWocFCSuhCEY6hoUClc0WC52BJlCYYLQdhN+hygRRRlo5BKRRLS6oihSqh+ZzzRGG1Mo4Iz1LoP0qsxDGFzk0JE42ji0jCPejomJKCuwil4m5CiRMEUMVSzVLDUstSx1Juc0oVWMpqY295qVltmtWmWW2a1aZZbZrVplltmtWmWW2G1WZYbYbVZlhthtVmWG2G1WZYbYbVZlhtltVmWW2W1WZZbZbVZlltltVmWW2W1QYjQCh7E2aAQHeGhCFgPoNoy8KNb2wxBhmGKBxoUZXlLGsLI6AsftEDHV0wIURVbANLcTKlGGBIKPOAxCmhePCKUwFzAmpDFRQvjA9R06Hq8TONvshgKDCuRAZTXigUxjxNFfKRo3CLhnIJBMFRvMZpqpNBMlQJzGT5WFQMVQI/AikPMIhEU1aDjqJvQwmjSHB05cC9jbYwc5UtAHNLhDw41ha+lEqF4JaH3gmB61SYcqInxTDmQK8v08vjqv4zDf1N0w3Lf4A8/vwPpfK11w==\"");

});


parcelRegister("90iSP", function(module, exports) {

$parcel$export(module.exports, "Encodings", () => $68e2c2ff57f5b549$export$c85030bb86979d84);
/* tslint:disable max-classes-per-file */ 
var $5JpfH = parcelRequire("5JpfH");

var $9zuq9 = parcelRequire("9zuq9");
var $68e2c2ff57f5b549$var$decompressedEncodings = (0, $5JpfH.decompressJson)((0, (/*@__PURE__*/$parcel$interopDefault($9zuq9))));
var $68e2c2ff57f5b549$var$allUnicodeMappings = JSON.parse($68e2c2ff57f5b549$var$decompressedEncodings);
var $68e2c2ff57f5b549$var$Encoding = /** @class */ function() {
    function Encoding(name, unicodeMappings) {
        var _this = this;
        this.canEncodeUnicodeCodePoint = function(codePoint) {
            return codePoint in _this.unicodeMappings;
        };
        this.encodeUnicodeCodePoint = function(codePoint) {
            var mapped = _this.unicodeMappings[codePoint];
            if (!mapped) {
                var str = String.fromCharCode(codePoint);
                var hexCode = "0x" + (0, $5JpfH.padStart)(codePoint.toString(16), 4, '0');
                var msg = _this.name + " cannot encode \"" + str + "\" (" + hexCode + ")";
                throw new Error(msg);
            }
            return {
                code: mapped[0],
                name: mapped[1]
            };
        };
        this.name = name;
        this.supportedCodePoints = Object.keys(unicodeMappings).map(Number).sort(function(a, b) {
            return a - b;
        });
        this.unicodeMappings = unicodeMappings;
    }
    return Encoding;
}();
var $68e2c2ff57f5b549$export$c85030bb86979d84 = {
    Symbol: new $68e2c2ff57f5b549$var$Encoding('Symbol', $68e2c2ff57f5b549$var$allUnicodeMappings.symbol),
    ZapfDingbats: new $68e2c2ff57f5b549$var$Encoding('ZapfDingbats', $68e2c2ff57f5b549$var$allUnicodeMappings.zapfdingbats),
    WinAnsi: new $68e2c2ff57f5b549$var$Encoding('WinAnsi', $68e2c2ff57f5b549$var$allUnicodeMappings.win1252)
};

});
parcelRegister("9zuq9", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});




parcelRegister("j0tvB", function(module, exports) {

$parcel$export(module.exports, "assertIsOneOf", () => $dd64e83d12710def$export$8883a3014ee46cd1);
$parcel$export(module.exports, "assertIsOneOfOrUndefined", () => $dd64e83d12710def$export$846079600c50354e);
$parcel$export(module.exports, "assertIsSubset", () => $dd64e83d12710def$export$dce66947695c582f);
$parcel$export(module.exports, "assertIs", () => $dd64e83d12710def$export$6fee1f82edcf4a03);
$parcel$export(module.exports, "assertOrUndefined", () => $dd64e83d12710def$export$92143017cb173fb0);
$parcel$export(module.exports, "assertEachIs", () => $dd64e83d12710def$export$47fbce961905bcd0);
$parcel$export(module.exports, "assertRange", () => $dd64e83d12710def$export$6698b6d148bc9b0c);
$parcel$export(module.exports, "assertRangeOrUndefined", () => $dd64e83d12710def$export$bce4080186be486);
$parcel$export(module.exports, "assertMultiple", () => $dd64e83d12710def$export$c9f5acf8e31d1a2e);
$parcel$export(module.exports, "assertInteger", () => $dd64e83d12710def$export$a59e49f1e2708383);
$parcel$export(module.exports, "assertPositive", () => $dd64e83d12710def$export$2cad8b74f3cf13dd);
/* tslint:disable:ban-types */ 
var $cbIAG = parcelRequire("cbIAG");
var $dd64e83d12710def$export$c7ce26e85cccb3a8 = function(val) {
    return "`" + val + "`";
};
var $dd64e83d12710def$export$1909b7b8a28995a9 = function(val) {
    return "'" + val + "'";
};
// prettier-ignore
var $dd64e83d12710def$var$formatValue = function(value) {
    var type = typeof value;
    if (type === 'string') return $dd64e83d12710def$export$1909b7b8a28995a9(value);
    else if (type === 'undefined') return $dd64e83d12710def$export$c7ce26e85cccb3a8(value);
    else return value;
};
var $dd64e83d12710def$export$2ac73c5d250d45a9 = function(value, valueName, values) {
    var allowedValues = new Array(values.length);
    for(var idx = 0, len = values.length; idx < len; idx++){
        var v = values[idx];
        allowedValues[idx] = $dd64e83d12710def$var$formatValue(v);
    }
    var joinedValues = allowedValues.join(' or ');
    // prettier-ignore
    return $dd64e83d12710def$export$c7ce26e85cccb3a8(valueName) + " must be one of " + joinedValues + ", but was actually " + $dd64e83d12710def$var$formatValue(value);
};
var $dd64e83d12710def$export$8883a3014ee46cd1 = function(value, valueName, allowedValues) {
    if (!Array.isArray(allowedValues)) allowedValues = (0, $cbIAG.values)(allowedValues);
    for(var idx = 0, len = allowedValues.length; idx < len; idx++){
        if (value === allowedValues[idx]) return;
    }
    throw new TypeError($dd64e83d12710def$export$2ac73c5d250d45a9(value, valueName, allowedValues));
};
var $dd64e83d12710def$export$846079600c50354e = function(value, valueName, allowedValues) {
    if (!Array.isArray(allowedValues)) allowedValues = (0, $cbIAG.values)(allowedValues);
    $dd64e83d12710def$export$8883a3014ee46cd1(value, valueName, allowedValues.concat(undefined));
};
var $dd64e83d12710def$export$dce66947695c582f = function(values, valueName, allowedValues) {
    if (!Array.isArray(allowedValues)) allowedValues = (0, $cbIAG.values)(allowedValues);
    for(var idx = 0, len = values.length; idx < len; idx++)$dd64e83d12710def$export$8883a3014ee46cd1(values[idx], valueName, allowedValues);
};
var $dd64e83d12710def$export$e2b5c5db9e2009fd = function(val) {
    if (val === null) return 'null';
    if (val === undefined) return 'undefined';
    if (typeof val === 'string') return 'string';
    if (isNaN(val)) return 'NaN';
    if (typeof val === 'number') return 'number';
    if (typeof val === 'boolean') return 'boolean';
    if (typeof val === 'symbol') return 'symbol';
    if (typeof val === 'bigint') return 'bigint';
    if (val.constructor && val.constructor.name) return val.constructor.name;
    if (val.name) return val.name;
    if (val.constructor) return String(val.constructor);
    return String(val);
};
var $dd64e83d12710def$export$26b9f946b448f23e = function(value, type) {
    if (type === 'null') return value === null;
    if (type === 'undefined') return value === undefined;
    if (type === 'string') return typeof value === 'string';
    if (type === 'number') return typeof value === 'number' && !isNaN(value);
    if (type === 'boolean') return typeof value === 'boolean';
    if (type === 'symbol') return typeof value === 'symbol';
    if (type === 'bigint') return typeof value === 'bigint';
    if (type === Date) return value instanceof Date;
    if (type === Array) return value instanceof Array;
    if (type === Uint8Array) return value instanceof Uint8Array;
    if (type === ArrayBuffer) return value instanceof ArrayBuffer;
    if (type === Function) return value instanceof Function;
    return value instanceof type[0];
};
var $dd64e83d12710def$export$6e3e1e6304e79984 = function(value, valueName, types) {
    var allowedTypes = new Array(types.length);
    for(var idx = 0, len = types.length; idx < len; idx++){
        var type = types[idx];
        if (type === 'null') allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8('null');
        if (type === 'undefined') allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8('undefined');
        if (type === 'string') allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8('string');
        else if (type === 'number') allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8('number');
        else if (type === 'boolean') allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8('boolean');
        else if (type === 'symbol') allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8('symbol');
        else if (type === 'bigint') allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8('bigint');
        else if (type === Array) allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8('Array');
        else if (type === Uint8Array) allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8('Uint8Array');
        else if (type === ArrayBuffer) allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8('ArrayBuffer');
        else allowedTypes[idx] = $dd64e83d12710def$export$c7ce26e85cccb3a8(type[1]);
    }
    var joinedTypes = allowedTypes.join(' or ');
    // prettier-ignore
    return $dd64e83d12710def$export$c7ce26e85cccb3a8(valueName) + " must be of type " + joinedTypes + ", but was actually of type " + $dd64e83d12710def$export$c7ce26e85cccb3a8($dd64e83d12710def$export$e2b5c5db9e2009fd(value));
};
var $dd64e83d12710def$export$6fee1f82edcf4a03 = function(value, valueName, types) {
    for(var idx = 0, len = types.length; idx < len; idx++){
        if ($dd64e83d12710def$export$26b9f946b448f23e(value, types[idx])) return;
    }
    throw new TypeError($dd64e83d12710def$export$6e3e1e6304e79984(value, valueName, types));
};
var $dd64e83d12710def$export$92143017cb173fb0 = function(value, valueName, types) {
    $dd64e83d12710def$export$6fee1f82edcf4a03(value, valueName, types.concat('undefined'));
};
var $dd64e83d12710def$export$47fbce961905bcd0 = function(values, valueName, types) {
    for(var idx = 0, len = values.length; idx < len; idx++)$dd64e83d12710def$export$6fee1f82edcf4a03(values[idx], valueName, types);
};
var $dd64e83d12710def$export$6698b6d148bc9b0c = function(value, valueName, min, max) {
    $dd64e83d12710def$export$6fee1f82edcf4a03(value, valueName, [
        'number'
    ]);
    $dd64e83d12710def$export$6fee1f82edcf4a03(min, 'min', [
        'number'
    ]);
    $dd64e83d12710def$export$6fee1f82edcf4a03(max, 'max', [
        'number'
    ]);
    max = Math.max(min, max);
    if (value < min || value > max) // prettier-ignore
    throw new Error($dd64e83d12710def$export$c7ce26e85cccb3a8(valueName) + " must be at least " + min + " and at most " + max + ", but was actually " + value);
};
var $dd64e83d12710def$export$bce4080186be486 = function(value, valueName, min, max) {
    $dd64e83d12710def$export$6fee1f82edcf4a03(value, valueName, [
        'number',
        'undefined'
    ]);
    if (typeof value === 'number') $dd64e83d12710def$export$6698b6d148bc9b0c(value, valueName, min, max);
};
var $dd64e83d12710def$export$c9f5acf8e31d1a2e = function(value, valueName, multiplier) {
    $dd64e83d12710def$export$6fee1f82edcf4a03(value, valueName, [
        'number'
    ]);
    if (value % multiplier !== 0) // prettier-ignore
    throw new Error($dd64e83d12710def$export$c7ce26e85cccb3a8(valueName) + " must be a multiple of " + multiplier + ", but was actually " + value);
};
var $dd64e83d12710def$export$a59e49f1e2708383 = function(value, valueName) {
    if (!Number.isInteger(value)) throw new Error($dd64e83d12710def$export$c7ce26e85cccb3a8(valueName) + " must be an integer, but was actually " + value);
};
var $dd64e83d12710def$export$2cad8b74f3cf13dd = function(value, valueName) {
    if (![
        1,
        0
    ].includes(Math.sign(value))) // prettier-ignore
    throw new Error($dd64e83d12710def$export$c7ce26e85cccb3a8(valueName) + " must be a positive number or 0, but was actually " + value);
};

});

parcelRegister("iSBb0", function(module, exports) {

$parcel$export(module.exports, "pdfDocEncodingDecode", () => $dbea1b9ee80fa12b$export$ea426b9c784ba215);

var $7Kmy8 = parcelRequire("7Kmy8");
// Mapping from PDFDocEncoding to Unicode code point
var $dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode = new Uint16Array(256);
// Initialize the code points which are the same
for(var $dbea1b9ee80fa12b$var$idx = 0; $dbea1b9ee80fa12b$var$idx < 256; $dbea1b9ee80fa12b$var$idx++)$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[$dbea1b9ee80fa12b$var$idx] = $dbea1b9ee80fa12b$var$idx;
// Set differences (see "Table D.2 – PDFDocEncoding Character Set" of the PDF spec)
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x16] = (0, $7Kmy8.toCharCode)('\u0017'); // SYNCRONOUS IDLE
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x18] = (0, $7Kmy8.toCharCode)('\u02D8'); // BREVE
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x19] = (0, $7Kmy8.toCharCode)('\u02C7'); // CARON
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x1a] = (0, $7Kmy8.toCharCode)('\u02C6'); // MODIFIER LETTER CIRCUMFLEX ACCENT
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x1b] = (0, $7Kmy8.toCharCode)('\u02D9'); // DOT ABOVE
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x1c] = (0, $7Kmy8.toCharCode)('\u02DD'); // DOUBLE ACUTE ACCENT
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x1d] = (0, $7Kmy8.toCharCode)('\u02DB'); // OGONEK
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x1e] = (0, $7Kmy8.toCharCode)('\u02DA'); // RING ABOVE
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x1f] = (0, $7Kmy8.toCharCode)('\u02DC'); // SMALL TILDE
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x7f] = (0, $7Kmy8.toCharCode)('\uFFFD'); // REPLACEMENT CHARACTER (box with questionmark)
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x80] = (0, $7Kmy8.toCharCode)('\u2022'); // BULLET
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x81] = (0, $7Kmy8.toCharCode)('\u2020'); // DAGGER
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x82] = (0, $7Kmy8.toCharCode)('\u2021'); // DOUBLE DAGGER
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x83] = (0, $7Kmy8.toCharCode)('\u2026'); // HORIZONTAL ELLIPSIS
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x84] = (0, $7Kmy8.toCharCode)('\u2014'); // EM DASH
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x85] = (0, $7Kmy8.toCharCode)('\u2013'); // EN DASH
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x86] = (0, $7Kmy8.toCharCode)('\u0192'); // LATIN SMALL LETTER SCRIPT F
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x87] = (0, $7Kmy8.toCharCode)('\u2044'); // FRACTION SLASH (solidus)
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x88] = (0, $7Kmy8.toCharCode)('\u2039'); // SINGLE LEFT-POINTING ANGLE QUOTATION MARK
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x89] = (0, $7Kmy8.toCharCode)('\u203A'); // SINGLE RIGHT-POINTING ANGLE QUOTATION MARK
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x8a] = (0, $7Kmy8.toCharCode)('\u2212'); // MINUS SIGN
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x8b] = (0, $7Kmy8.toCharCode)('\u2030'); // PER MILLE SIGN
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x8c] = (0, $7Kmy8.toCharCode)('\u201E'); // DOUBLE LOW-9 QUOTATION MARK (quotedblbase)
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x8d] = (0, $7Kmy8.toCharCode)('\u201C'); // LEFT DOUBLE QUOTATION MARK (quotedblleft)
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x8e] = (0, $7Kmy8.toCharCode)('\u201D'); // RIGHT DOUBLE QUOTATION MARK (quotedblright)
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x8f] = (0, $7Kmy8.toCharCode)('\u2018'); // LEFT SINGLE QUOTATION MARK (quoteleft)
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x90] = (0, $7Kmy8.toCharCode)('\u2019'); // RIGHT SINGLE QUOTATION MARK (quoteright)
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x91] = (0, $7Kmy8.toCharCode)('\u201A'); // SINGLE LOW-9 QUOTATION MARK (quotesinglbase)
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x92] = (0, $7Kmy8.toCharCode)('\u2122'); // TRADE MARK SIGN
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x93] = (0, $7Kmy8.toCharCode)('\uFB01'); // LATIN SMALL LIGATURE FI
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x94] = (0, $7Kmy8.toCharCode)('\uFB02'); // LATIN SMALL LIGATURE FL
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x95] = (0, $7Kmy8.toCharCode)('\u0141'); // LATIN CAPITAL LETTER L WITH STROKE
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x96] = (0, $7Kmy8.toCharCode)('\u0152'); // LATIN CAPITAL LIGATURE OE
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x97] = (0, $7Kmy8.toCharCode)('\u0160'); // LATIN CAPITAL LETTER S WITH CARON
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x98] = (0, $7Kmy8.toCharCode)('\u0178'); // LATIN CAPITAL LETTER Y WITH DIAERESIS
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x99] = (0, $7Kmy8.toCharCode)('\u017D'); // LATIN CAPITAL LETTER Z WITH CARON
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x9a] = (0, $7Kmy8.toCharCode)('\u0131'); // LATIN SMALL LETTER DOTLESS I
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x9b] = (0, $7Kmy8.toCharCode)('\u0142'); // LATIN SMALL LETTER L WITH STROKE
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x9c] = (0, $7Kmy8.toCharCode)('\u0153'); // LATIN SMALL LIGATURE OE
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x9d] = (0, $7Kmy8.toCharCode)('\u0161'); // LATIN SMALL LETTER S WITH CARON
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x9e] = (0, $7Kmy8.toCharCode)('\u017E'); // LATIN SMALL LETTER Z WITH CARON
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0x9f] = (0, $7Kmy8.toCharCode)('\uFFFD'); // REPLACEMENT CHARACTER (box with questionmark)
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0xa0] = (0, $7Kmy8.toCharCode)('\u20AC'); // EURO SIGN
$dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[0xad] = (0, $7Kmy8.toCharCode)('\uFFFD'); // REPLACEMENT CHARACTER (box with questionmark)
var $dbea1b9ee80fa12b$export$ea426b9c784ba215 = function(bytes) {
    var codePoints = new Array(bytes.length);
    for(var idx = 0, len = bytes.length; idx < len; idx++)codePoints[idx] = $dbea1b9ee80fa12b$var$pdfDocEncodingToUnicode[bytes[idx]];
    return String.fromCodePoint.apply(String, codePoints);
};

});

parcelRegister("clYSv", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fe6ab59ebda0f6a$export$2e2bcd8739ae039);
var $8fe6ab59ebda0f6a$var$Cache = /** @class */ function() {
    function Cache(populate) {
        this.populate = populate;
        this.value = undefined;
    }
    Cache.prototype.getValue = function() {
        return this.value;
    };
    Cache.prototype.access = function() {
        if (!this.value) this.value = this.populate();
        return this.value;
    };
    Cache.prototype.invalidate = function() {
        this.value = undefined;
    };
    Cache.populatedBy = function(populate) {
        return new Cache(populate);
    };
    return Cache;
}();
var $8fe6ab59ebda0f6a$export$2e2bcd8739ae039 = $8fe6ab59ebda0f6a$var$Cache;

});



parcelRegister("8zvel", function(module, exports) {

$parcel$export(module.exports, "default", () => $63d9d14d65819945$export$2e2bcd8739ae039);
var $63d9d14d65819945$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["Null"] = 0] = "Null";
    CharCodes[CharCodes["Backspace"] = 8] = "Backspace";
    CharCodes[CharCodes["Tab"] = 9] = "Tab";
    CharCodes[CharCodes["Newline"] = 10] = "Newline";
    CharCodes[CharCodes["FormFeed"] = 12] = "FormFeed";
    CharCodes[CharCodes["CarriageReturn"] = 13] = "CarriageReturn";
    CharCodes[CharCodes["Space"] = 32] = "Space";
    CharCodes[CharCodes["ExclamationPoint"] = 33] = "ExclamationPoint";
    CharCodes[CharCodes["Hash"] = 35] = "Hash";
    CharCodes[CharCodes["Percent"] = 37] = "Percent";
    CharCodes[CharCodes["LeftParen"] = 40] = "LeftParen";
    CharCodes[CharCodes["RightParen"] = 41] = "RightParen";
    CharCodes[CharCodes["Plus"] = 43] = "Plus";
    CharCodes[CharCodes["Minus"] = 45] = "Minus";
    CharCodes[CharCodes["Dash"] = 45] = "Dash";
    CharCodes[CharCodes["Period"] = 46] = "Period";
    CharCodes[CharCodes["ForwardSlash"] = 47] = "ForwardSlash";
    CharCodes[CharCodes["Zero"] = 48] = "Zero";
    CharCodes[CharCodes["One"] = 49] = "One";
    CharCodes[CharCodes["Two"] = 50] = "Two";
    CharCodes[CharCodes["Three"] = 51] = "Three";
    CharCodes[CharCodes["Four"] = 52] = "Four";
    CharCodes[CharCodes["Five"] = 53] = "Five";
    CharCodes[CharCodes["Six"] = 54] = "Six";
    CharCodes[CharCodes["Seven"] = 55] = "Seven";
    CharCodes[CharCodes["Eight"] = 56] = "Eight";
    CharCodes[CharCodes["Nine"] = 57] = "Nine";
    CharCodes[CharCodes["LessThan"] = 60] = "LessThan";
    CharCodes[CharCodes["GreaterThan"] = 62] = "GreaterThan";
    CharCodes[CharCodes["A"] = 65] = "A";
    CharCodes[CharCodes["D"] = 68] = "D";
    CharCodes[CharCodes["E"] = 69] = "E";
    CharCodes[CharCodes["F"] = 70] = "F";
    CharCodes[CharCodes["O"] = 79] = "O";
    CharCodes[CharCodes["P"] = 80] = "P";
    CharCodes[CharCodes["R"] = 82] = "R";
    CharCodes[CharCodes["LeftSquareBracket"] = 91] = "LeftSquareBracket";
    CharCodes[CharCodes["BackSlash"] = 92] = "BackSlash";
    CharCodes[CharCodes["RightSquareBracket"] = 93] = "RightSquareBracket";
    CharCodes[CharCodes["a"] = 97] = "a";
    CharCodes[CharCodes["b"] = 98] = "b";
    CharCodes[CharCodes["d"] = 100] = "d";
    CharCodes[CharCodes["e"] = 101] = "e";
    CharCodes[CharCodes["f"] = 102] = "f";
    CharCodes[CharCodes["i"] = 105] = "i";
    CharCodes[CharCodes["j"] = 106] = "j";
    CharCodes[CharCodes["l"] = 108] = "l";
    CharCodes[CharCodes["m"] = 109] = "m";
    CharCodes[CharCodes["n"] = 110] = "n";
    CharCodes[CharCodes["o"] = 111] = "o";
    CharCodes[CharCodes["r"] = 114] = "r";
    CharCodes[CharCodes["s"] = 115] = "s";
    CharCodes[CharCodes["t"] = 116] = "t";
    CharCodes[CharCodes["u"] = 117] = "u";
    CharCodes[CharCodes["x"] = 120] = "x";
    CharCodes[CharCodes["LeftCurly"] = 123] = "LeftCurly";
    CharCodes[CharCodes["RightCurly"] = 125] = "RightCurly";
    CharCodes[CharCodes["Tilde"] = 126] = "Tilde";
})($63d9d14d65819945$var$CharCodes || ($63d9d14d65819945$var$CharCodes = {}));
var $63d9d14d65819945$export$2e2bcd8739ae039 = $63d9d14d65819945$var$CharCodes;

});

parcelRegister("kl4jO", function(module, exports) {

$parcel$export(module.exports, "default", () => $ece91e5f61c516eb$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $ckCqy = parcelRequire("ckCqy");

var $eHlB9 = parcelRequire("eHlB9");

var $nAWRe = parcelRequire("nAWRe");

var $8auL6 = parcelRequire("8auL6");

var $8gQNC = parcelRequire("8gQNC");

var $brir8 = parcelRequire("brir8");

var $dPHSK = parcelRequire("dPHSK");

var $eTKUN = parcelRequire("eTKUN");

var $j04jt = parcelRequire("j04jt");

var $11c5J = parcelRequire("11c5J");

var $kx2r4 = parcelRequire("kx2r4");

var $kHzkO = parcelRequire("kHzkO");

var $5uV6d = parcelRequire("5uV6d");

var $3oHKx = parcelRequire("3oHKx");

var $9EODP = parcelRequire("9EODP");
parcelRequire("fvYKZ");
var $4ISq8 = parcelRequire("4ISq8");

var $5QhVg = parcelRequire("5QhVg");
var $ece91e5f61c516eb$var$byAscendingObjectNumber = function(_a, _b) {
    var a = _a[0];
    var b = _b[0];
    return a.objectNumber - b.objectNumber;
};
var $ece91e5f61c516eb$var$PDFContext = /** @class */ function() {
    function PDFContext() {
        this.largestObjectNumber = 0;
        this.header = (0, $eHlB9.default).forVersion(1, 7);
        this.trailerInfo = {};
        this.indirectObjects = new Map();
        this.rng = (0, $5QhVg.SimpleRNG).withSeed(1);
    }
    PDFContext.prototype.assign = function(ref, object) {
        this.indirectObjects.set(ref, object);
        if (ref.objectNumber > this.largestObjectNumber) this.largestObjectNumber = ref.objectNumber;
    };
    PDFContext.prototype.nextRef = function() {
        this.largestObjectNumber += 1;
        return (0, $kHzkO.default).of(this.largestObjectNumber);
    };
    PDFContext.prototype.register = function(object) {
        var ref = this.nextRef();
        this.assign(ref, object);
        return ref;
    };
    PDFContext.prototype.delete = function(ref) {
        return this.indirectObjects.delete(ref);
    };
    PDFContext.prototype.lookupMaybe = function(ref) {
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        // TODO: `preservePDFNull` is for backwards compatibility. Should be
        // removed in next breaking API change.
        var preservePDFNull = types.includes((0, $eTKUN.default));
        var result = ref instanceof (0, $kHzkO.default) ? this.indirectObjects.get(ref) : ref;
        if (!result || result === (0, $eTKUN.default) && !preservePDFNull) return undefined;
        for(var idx = 0, len = types.length; idx < len; idx++){
            var type = types[idx];
            if (type === (0, $eTKUN.default)) {
                if (result === (0, $eTKUN.default)) return result;
            } else {
                if (result instanceof type) return result;
            }
        }
        throw new (0, $nAWRe.UnexpectedObjectTypeError)(types, result);
    };
    PDFContext.prototype.lookup = function(ref) {
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        var result = ref instanceof (0, $kHzkO.default) ? this.indirectObjects.get(ref) : ref;
        if (types.length === 0) return result;
        for(var idx = 0, len = types.length; idx < len; idx++){
            var type = types[idx];
            if (type === (0, $eTKUN.default)) {
                if (result === (0, $eTKUN.default)) return result;
            } else {
                if (result instanceof type) return result;
            }
        }
        throw new (0, $nAWRe.UnexpectedObjectTypeError)(types, result);
    };
    PDFContext.prototype.getObjectRef = function(pdfObject) {
        var entries = Array.from(this.indirectObjects.entries());
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], ref = _a[0], object = _a[1];
            if (object === pdfObject) return ref;
        }
        return undefined;
    };
    PDFContext.prototype.enumerateIndirectObjects = function() {
        return Array.from(this.indirectObjects.entries()).sort($ece91e5f61c516eb$var$byAscendingObjectNumber);
    };
    PDFContext.prototype.obj = function(literal) {
        if (literal instanceof (0, $11c5J.default)) return literal;
        else if (literal === null || literal === undefined) return 0, $eTKUN.default;
        else if (typeof literal === 'string') return (0, $dPHSK.default).of(literal);
        else if (typeof literal === 'number') return (0, $j04jt.default).of(literal);
        else if (typeof literal === 'boolean') return literal ? (0, $8gQNC.default).True : (0, $8gQNC.default).False;
        else if (Array.isArray(literal)) {
            var array = (0, $8auL6.default).withContext(this);
            for(var idx = 0, len = literal.length; idx < len; idx++)array.push(this.obj(literal[idx]));
            return array;
        } else {
            var dict = (0, $brir8.default).withContext(this);
            var keys = Object.keys(literal);
            for(var idx = 0, len = keys.length; idx < len; idx++){
                var key = keys[idx];
                var value = literal[key];
                if (value !== undefined) dict.set((0, $dPHSK.default).of(key), this.obj(value));
            }
            return dict;
        }
    };
    PDFContext.prototype.stream = function(contents, dict) {
        if (dict === void 0) dict = {};
        return (0, $kx2r4.default).of(this.obj(dict), (0, $4ISq8.typedArrayFor)(contents));
    };
    PDFContext.prototype.flateStream = function(contents, dict) {
        if (dict === void 0) dict = {};
        return this.stream((0, (/*@__PURE__*/$parcel$interopDefault($ckCqy))).deflate((0, $4ISq8.typedArrayFor)(contents)), (0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, dict), {
            Filter: 'FlateDecode'
        }));
    };
    PDFContext.prototype.contentStream = function(operators, dict) {
        if (dict === void 0) dict = {};
        return (0, $9EODP.default).of(this.obj(dict), operators);
    };
    PDFContext.prototype.formXObject = function(operators, dict) {
        if (dict === void 0) dict = {};
        return this.contentStream(operators, (0, $cOQTW.__assign)((0, $cOQTW.__assign)({
            BBox: this.obj([
                0,
                0,
                0,
                0
            ]),
            Matrix: this.obj([
                1,
                0,
                0,
                1,
                0,
                0
            ])
        }, dict), {
            Type: 'XObject',
            Subtype: 'Form'
        }));
    };
    /*
     * Reference to PDFContentStream that contains a single PDFOperator: `q`.
     * Used by [[PDFPageLeaf]] instances to ensure that when content streams are
     * added to a modified PDF, they start in the default, unchanged graphics
     * state.
     */ PDFContext.prototype.getPushGraphicsStateContentStream = function() {
        if (this.pushGraphicsStateContentStreamRef) return this.pushGraphicsStateContentStreamRef;
        var dict = this.obj({});
        var op = (0, $5uV6d.default).of((0, $3oHKx.default).PushGraphicsState);
        var stream = (0, $9EODP.default).of(dict, [
            op
        ]);
        this.pushGraphicsStateContentStreamRef = this.register(stream);
        return this.pushGraphicsStateContentStreamRef;
    };
    /*
     * Reference to PDFContentStream that contains a single PDFOperator: `Q`.
     * Used by [[PDFPageLeaf]] instances to ensure that when content streams are
     * added to a modified PDF, they start in the default, unchanged graphics
     * state.
     */ PDFContext.prototype.getPopGraphicsStateContentStream = function() {
        if (this.popGraphicsStateContentStreamRef) return this.popGraphicsStateContentStreamRef;
        var dict = this.obj({});
        var op = (0, $5uV6d.default).of((0, $3oHKx.default).PopGraphicsState);
        var stream = (0, $9EODP.default).of(dict, [
            op
        ]);
        this.popGraphicsStateContentStreamRef = this.register(stream);
        return this.popGraphicsStateContentStreamRef;
    };
    PDFContext.prototype.addRandomSuffix = function(prefix, suffixLength) {
        if (suffixLength === void 0) suffixLength = 4;
        return prefix + "-" + Math.floor(this.rng.nextInt() * Math.pow(10, suffixLength));
    };
    PDFContext.create = function() {
        return new PDFContext();
    };
    return PDFContext;
}();
var $ece91e5f61c516eb$export$2e2bcd8739ae039 = $ece91e5f61c516eb$var$PDFContext;

});
parcelRegister("eHlB9", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab35d5c6c69177c9$export$2e2bcd8739ae039);

var $8zvel = parcelRequire("8zvel");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $ab35d5c6c69177c9$var$PDFHeader = /** @class */ function() {
    function PDFHeader(major, minor) {
        this.major = String(major);
        this.minor = String(minor);
    }
    PDFHeader.prototype.toString = function() {
        var bc = (0, $7Kmy8.charFromCode)(129);
        return "%PDF-" + this.major + "." + this.minor + "\n%" + bc + bc + bc + bc;
    };
    PDFHeader.prototype.sizeInBytes = function() {
        return 12 + this.major.length + this.minor.length;
    };
    PDFHeader.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $8zvel.default).Percent;
        buffer[offset++] = (0, $8zvel.default).P;
        buffer[offset++] = (0, $8zvel.default).D;
        buffer[offset++] = (0, $8zvel.default).F;
        buffer[offset++] = (0, $8zvel.default).Dash;
        offset += (0, $7Kmy8.copyStringIntoBuffer)(this.major, buffer, offset);
        buffer[offset++] = (0, $8zvel.default).Period;
        offset += (0, $7Kmy8.copyStringIntoBuffer)(this.minor, buffer, offset);
        buffer[offset++] = (0, $8zvel.default).Newline;
        buffer[offset++] = (0, $8zvel.default).Percent;
        buffer[offset++] = 129;
        buffer[offset++] = 129;
        buffer[offset++] = 129;
        buffer[offset++] = 129;
        return offset - initialOffset;
    };
    PDFHeader.forVersion = function(major, minor) {
        return new PDFHeader(major, minor);
    };
    return PDFHeader;
}();
var $ab35d5c6c69177c9$export$2e2bcd8739ae039 = $ab35d5c6c69177c9$var$PDFHeader;

});

parcelRegister("8auL6", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f271df805933107$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $j04jt = parcelRequire("j04jt");

var $11c5J = parcelRequire("11c5J");

var $8zvel = parcelRequire("8zvel");

var $nAWRe = parcelRequire("nAWRe");
var $5f271df805933107$var$PDFArray = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFArray, _super);
    function PDFArray(context) {
        var _this = _super.call(this) || this;
        _this.array = [];
        _this.context = context;
        return _this;
    }
    PDFArray.prototype.size = function() {
        return this.array.length;
    };
    PDFArray.prototype.push = function(object) {
        this.array.push(object);
    };
    PDFArray.prototype.insert = function(index, object) {
        this.array.splice(index, 0, object);
    };
    PDFArray.prototype.indexOf = function(object) {
        var index = this.array.indexOf(object);
        return index === -1 ? undefined : index;
    };
    PDFArray.prototype.remove = function(index) {
        this.array.splice(index, 1);
    };
    PDFArray.prototype.set = function(idx, object) {
        this.array[idx] = object;
    };
    PDFArray.prototype.get = function(index) {
        return this.array[index];
    };
    PDFArray.prototype.lookupMaybe = function(index) {
        var _a;
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        return (_a = this.context).lookupMaybe.apply(_a, (0, $cOQTW.__spreadArrays)([
            this.get(index)
        ], types));
    };
    PDFArray.prototype.lookup = function(index) {
        var _a;
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        return (_a = this.context).lookup.apply(_a, (0, $cOQTW.__spreadArrays)([
            this.get(index)
        ], types));
    };
    PDFArray.prototype.asRectangle = function() {
        if (this.size() !== 4) throw new (0, $nAWRe.PDFArrayIsNotRectangleError)(this.size());
        var lowerLeftX = this.lookup(0, (0, $j04jt.default)).asNumber();
        var lowerLeftY = this.lookup(1, (0, $j04jt.default)).asNumber();
        var upperRightX = this.lookup(2, (0, $j04jt.default)).asNumber();
        var upperRightY = this.lookup(3, (0, $j04jt.default)).asNumber();
        var x = lowerLeftX;
        var y = lowerLeftY;
        var width = upperRightX - lowerLeftX;
        var height = upperRightY - lowerLeftY;
        return {
            x: x,
            y: y,
            width: width,
            height: height
        };
    };
    PDFArray.prototype.asArray = function() {
        return this.array.slice();
    };
    PDFArray.prototype.clone = function(context) {
        var clone = PDFArray.withContext(context || this.context);
        for(var idx = 0, len = this.size(); idx < len; idx++)clone.push(this.array[idx]);
        return clone;
    };
    PDFArray.prototype.toString = function() {
        var arrayString = '[ ';
        for(var idx = 0, len = this.size(); idx < len; idx++){
            arrayString += this.get(idx).toString();
            arrayString += ' ';
        }
        arrayString += ']';
        return arrayString;
    };
    PDFArray.prototype.sizeInBytes = function() {
        var size = 3;
        for(var idx = 0, len = this.size(); idx < len; idx++)size += this.get(idx).sizeInBytes() + 1;
        return size;
    };
    PDFArray.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $8zvel.default).LeftSquareBracket;
        buffer[offset++] = (0, $8zvel.default).Space;
        for(var idx = 0, len = this.size(); idx < len; idx++){
            offset += this.get(idx).copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $8zvel.default).Space;
        }
        buffer[offset++] = (0, $8zvel.default).RightSquareBracket;
        return offset - initialOffset;
    };
    PDFArray.prototype.scalePDFNumbers = function(x, y) {
        for(var idx = 0, len = this.size(); idx < len; idx++){
            var el = this.lookup(idx);
            if (el instanceof (0, $j04jt.default)) {
                var factor = idx % 2 === 0 ? x : y;
                this.set(idx, (0, $j04jt.default).of(el.asNumber() * factor));
            }
        }
    };
    PDFArray.withContext = function(context) {
        return new PDFArray(context);
    };
    return PDFArray;
}((0, $11c5J.default));
var $5f271df805933107$export$2e2bcd8739ae039 = $5f271df805933107$var$PDFArray;

});
parcelRegister("j04jt", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd515ce6ac431bbb$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $hiEdU = parcelRequire("hiEdU");

var $11c5J = parcelRequire("11c5J");
var $dd515ce6ac431bbb$var$PDFNumber = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFNumber, _super);
    function PDFNumber(value) {
        var _this = _super.call(this) || this;
        _this.numberValue = value;
        _this.stringValue = (0, $hiEdU.numberToString)(value);
        return _this;
    }
    PDFNumber.prototype.asNumber = function() {
        return this.numberValue;
    };
    /** @deprecated in favor of [[PDFNumber.asNumber]] */ PDFNumber.prototype.value = function() {
        return this.numberValue;
    };
    PDFNumber.prototype.clone = function() {
        return PDFNumber.of(this.numberValue);
    };
    PDFNumber.prototype.toString = function() {
        return this.stringValue;
    };
    PDFNumber.prototype.sizeInBytes = function() {
        return this.stringValue.length;
    };
    PDFNumber.prototype.copyBytesInto = function(buffer, offset) {
        offset += (0, $7Kmy8.copyStringIntoBuffer)(this.stringValue, buffer, offset);
        return this.stringValue.length;
    };
    PDFNumber.of = function(value) {
        return new PDFNumber(value);
    };
    return PDFNumber;
}((0, $11c5J.default));
var $dd515ce6ac431bbb$export$2e2bcd8739ae039 = $dd515ce6ac431bbb$var$PDFNumber;

});
parcelRegister("11c5J", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bdf4392b99cfcf1$export$2e2bcd8739ae039);

var $nAWRe = parcelRequire("nAWRe");
var $0bdf4392b99cfcf1$var$PDFObject = /** @class */ function() {
    function PDFObject() {}
    PDFObject.prototype.clone = function(_context) {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'clone');
    };
    PDFObject.prototype.toString = function() {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'toString');
    };
    PDFObject.prototype.sizeInBytes = function() {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'sizeInBytes');
    };
    PDFObject.prototype.copyBytesInto = function(_buffer, _offset) {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'copyBytesInto');
    };
    return PDFObject;
}();
var $0bdf4392b99cfcf1$export$2e2bcd8739ae039 = $0bdf4392b99cfcf1$var$PDFObject;

});



parcelRegister("8gQNC", function(module, exports) {

$parcel$export(module.exports, "default", () => $6058c6342b5f9099$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $nAWRe = parcelRequire("nAWRe");

var $11c5J = parcelRequire("11c5J");

var $8zvel = parcelRequire("8zvel");
var $6058c6342b5f9099$var$ENFORCER = {};
var $6058c6342b5f9099$var$PDFBool = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFBool, _super);
    function PDFBool(enforcer, value) {
        var _this = this;
        if (enforcer !== $6058c6342b5f9099$var$ENFORCER) throw new (0, $nAWRe.PrivateConstructorError)('PDFBool');
        _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    PDFBool.prototype.asBoolean = function() {
        return this.value;
    };
    PDFBool.prototype.clone = function() {
        return this;
    };
    PDFBool.prototype.toString = function() {
        return String(this.value);
    };
    PDFBool.prototype.sizeInBytes = function() {
        return this.value ? 4 : 5;
    };
    PDFBool.prototype.copyBytesInto = function(buffer, offset) {
        if (this.value) {
            buffer[offset++] = (0, $8zvel.default).t;
            buffer[offset++] = (0, $8zvel.default).r;
            buffer[offset++] = (0, $8zvel.default).u;
            buffer[offset++] = (0, $8zvel.default).e;
            return 4;
        } else {
            buffer[offset++] = (0, $8zvel.default).f;
            buffer[offset++] = (0, $8zvel.default).a;
            buffer[offset++] = (0, $8zvel.default).l;
            buffer[offset++] = (0, $8zvel.default).s;
            buffer[offset++] = (0, $8zvel.default).e;
            return 5;
        }
    };
    PDFBool.True = new PDFBool($6058c6342b5f9099$var$ENFORCER, true);
    PDFBool.False = new PDFBool($6058c6342b5f9099$var$ENFORCER, false);
    return PDFBool;
}((0, $11c5J.default));
var $6058c6342b5f9099$export$2e2bcd8739ae039 = $6058c6342b5f9099$var$PDFBool;

});

parcelRegister("brir8", function(module, exports) {

$parcel$export(module.exports, "default", () => $85408478fbb7cbde$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $dPHSK = parcelRequire("dPHSK");

var $eTKUN = parcelRequire("eTKUN");

var $11c5J = parcelRequire("11c5J");

var $8zvel = parcelRequire("8zvel");
var $85408478fbb7cbde$var$PDFDict = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFDict, _super);
    function PDFDict(map, context) {
        var _this = _super.call(this) || this;
        _this.dict = map;
        _this.context = context;
        return _this;
    }
    PDFDict.prototype.keys = function() {
        return Array.from(this.dict.keys());
    };
    PDFDict.prototype.values = function() {
        return Array.from(this.dict.values());
    };
    PDFDict.prototype.entries = function() {
        return Array.from(this.dict.entries());
    };
    PDFDict.prototype.set = function(key, value) {
        this.dict.set(key, value);
    };
    PDFDict.prototype.get = function(key, // TODO: `preservePDFNull` is for backwards compatibility. Should be
    // removed in next breaking API change.
    preservePDFNull) {
        if (preservePDFNull === void 0) preservePDFNull = false;
        var value = this.dict.get(key);
        if (value === (0, $eTKUN.default) && !preservePDFNull) return undefined;
        return value;
    };
    PDFDict.prototype.has = function(key) {
        var value = this.dict.get(key);
        return value !== undefined && value !== (0, $eTKUN.default);
    };
    PDFDict.prototype.lookupMaybe = function(key) {
        var _a;
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        // TODO: `preservePDFNull` is for backwards compatibility. Should be
        // removed in next breaking API change.
        var preservePDFNull = types.includes((0, $eTKUN.default));
        var value = (_a = this.context).lookupMaybe.apply(_a, (0, $cOQTW.__spreadArrays)([
            this.get(key, preservePDFNull)
        ], types));
        if (value === (0, $eTKUN.default) && !preservePDFNull) return undefined;
        return value;
    };
    PDFDict.prototype.lookup = function(key) {
        var _a;
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        // TODO: `preservePDFNull` is for backwards compatibility. Should be
        // removed in next breaking API change.
        var preservePDFNull = types.includes((0, $eTKUN.default));
        var value = (_a = this.context).lookup.apply(_a, (0, $cOQTW.__spreadArrays)([
            this.get(key, preservePDFNull)
        ], types));
        if (value === (0, $eTKUN.default) && !preservePDFNull) return undefined;
        return value;
    };
    PDFDict.prototype.delete = function(key) {
        return this.dict.delete(key);
    };
    PDFDict.prototype.asMap = function() {
        return new Map(this.dict);
    };
    /** Generate a random key that doesn't exist in current key set */ PDFDict.prototype.uniqueKey = function(tag) {
        if (tag === void 0) tag = '';
        var existingKeys = this.keys();
        var key = (0, $dPHSK.default).of(this.context.addRandomSuffix(tag, 10));
        while(existingKeys.includes(key))key = (0, $dPHSK.default).of(this.context.addRandomSuffix(tag, 10));
        return key;
    };
    PDFDict.prototype.clone = function(context) {
        var clone = PDFDict.withContext(context || this.context);
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            clone.set(key, value);
        }
        return clone;
    };
    PDFDict.prototype.toString = function() {
        var dictString = '<<\n';
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            dictString += key.toString() + ' ' + value.toString() + '\n';
        }
        dictString += '>>';
        return dictString;
    };
    PDFDict.prototype.sizeInBytes = function() {
        var size = 5;
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            size += key.sizeInBytes() + value.sizeInBytes() + 2;
        }
        return size;
    };
    PDFDict.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $8zvel.default).LessThan;
        buffer[offset++] = (0, $8zvel.default).LessThan;
        buffer[offset++] = (0, $8zvel.default).Newline;
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            offset += key.copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $8zvel.default).Space;
            offset += value.copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $8zvel.default).Newline;
        }
        buffer[offset++] = (0, $8zvel.default).GreaterThan;
        buffer[offset++] = (0, $8zvel.default).GreaterThan;
        return offset - initialOffset;
    };
    PDFDict.withContext = function(context) {
        return new PDFDict(new Map(), context);
    };
    PDFDict.fromMapWithContext = function(map, context) {
        return new PDFDict(map, context);
    };
    return PDFDict;
}((0, $11c5J.default));
var $85408478fbb7cbde$export$2e2bcd8739ae039 = $85408478fbb7cbde$var$PDFDict;

});
parcelRegister("dPHSK", function(module, exports) {

$parcel$export(module.exports, "default", () => $a12213d87b46303c$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $nAWRe = parcelRequire("nAWRe");

var $11c5J = parcelRequire("11c5J");

var $8zvel = parcelRequire("8zvel");

var $6InlX = parcelRequire("6InlX");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $a12213d87b46303c$var$decodeName = function(name) {
    return name.replace(/#([\dABCDEF]{2})/g, function(_, hex) {
        return (0, $7Kmy8.charFromHexCode)(hex);
    });
};
var $a12213d87b46303c$var$isRegularChar = function(charCode) {
    return charCode >= (0, $8zvel.default).ExclamationPoint && charCode <= (0, $8zvel.default).Tilde && !(0, $6InlX.IsIrregular)[charCode];
};
var $a12213d87b46303c$var$ENFORCER = {};
var $a12213d87b46303c$var$pool = new Map();
var $a12213d87b46303c$var$PDFName = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFName, _super);
    function PDFName(enforcer, name) {
        var _this = this;
        if (enforcer !== $a12213d87b46303c$var$ENFORCER) throw new (0, $nAWRe.PrivateConstructorError)('PDFName');
        _this = _super.call(this) || this;
        var encodedName = '/';
        for(var idx = 0, len = name.length; idx < len; idx++){
            var character = name[idx];
            var code = (0, $7Kmy8.toCharCode)(character);
            encodedName += $a12213d87b46303c$var$isRegularChar(code) ? character : "#" + (0, $7Kmy8.toHexString)(code);
        }
        _this.encodedName = encodedName;
        return _this;
    }
    PDFName.prototype.asBytes = function() {
        var bytes = [];
        var hex = '';
        var escaped = false;
        var pushByte = function(byte) {
            if (byte !== undefined) bytes.push(byte);
            escaped = false;
        };
        for(var idx = 1, len = this.encodedName.length; idx < len; idx++){
            var char = this.encodedName[idx];
            var byte = (0, $7Kmy8.toCharCode)(char);
            var nextChar = this.encodedName[idx + 1];
            if (!escaped) {
                if (byte === (0, $8zvel.default).Hash) escaped = true;
                else pushByte(byte);
            } else if (byte >= (0, $8zvel.default).Zero && byte <= (0, $8zvel.default).Nine || byte >= (0, $8zvel.default).a && byte <= (0, $8zvel.default).f || byte >= (0, $8zvel.default).A && byte <= (0, $8zvel.default).F) {
                hex += char;
                if (hex.length === 2 || !(nextChar >= '0' && nextChar <= '9' || nextChar >= 'a' && nextChar <= 'f' || nextChar >= 'A' && nextChar <= 'F')) {
                    pushByte(parseInt(hex, 16));
                    hex = '';
                }
            } else pushByte(byte);
        }
        return new Uint8Array(bytes);
    };
    // TODO: This should probably use `utf8Decode()`
    // TODO: Polyfill Array.from?
    PDFName.prototype.decodeText = function() {
        var bytes = this.asBytes();
        return String.fromCharCode.apply(String, Array.from(bytes));
    };
    PDFName.prototype.asString = function() {
        return this.encodedName;
    };
    /** @deprecated in favor of [[PDFName.asString]] */ PDFName.prototype.value = function() {
        return this.encodedName;
    };
    PDFName.prototype.clone = function() {
        return this;
    };
    PDFName.prototype.toString = function() {
        return this.encodedName;
    };
    PDFName.prototype.sizeInBytes = function() {
        return this.encodedName.length;
    };
    PDFName.prototype.copyBytesInto = function(buffer, offset) {
        offset += (0, $7Kmy8.copyStringIntoBuffer)(this.encodedName, buffer, offset);
        return this.encodedName.length;
    };
    PDFName.of = function(name) {
        var decodedValue = $a12213d87b46303c$var$decodeName(name);
        var instance = $a12213d87b46303c$var$pool.get(decodedValue);
        if (!instance) {
            instance = new PDFName($a12213d87b46303c$var$ENFORCER, decodedValue);
            $a12213d87b46303c$var$pool.set(decodedValue, instance);
        }
        return instance;
    };
    /* tslint:disable member-ordering */ PDFName.Length = PDFName.of('Length');
    PDFName.FlateDecode = PDFName.of('FlateDecode');
    PDFName.Resources = PDFName.of('Resources');
    PDFName.Font = PDFName.of('Font');
    PDFName.XObject = PDFName.of('XObject');
    PDFName.ExtGState = PDFName.of('ExtGState');
    PDFName.Contents = PDFName.of('Contents');
    PDFName.Type = PDFName.of('Type');
    PDFName.Parent = PDFName.of('Parent');
    PDFName.MediaBox = PDFName.of('MediaBox');
    PDFName.Page = PDFName.of('Page');
    PDFName.Annots = PDFName.of('Annots');
    PDFName.TrimBox = PDFName.of('TrimBox');
    PDFName.ArtBox = PDFName.of('ArtBox');
    PDFName.BleedBox = PDFName.of('BleedBox');
    PDFName.CropBox = PDFName.of('CropBox');
    PDFName.Rotate = PDFName.of('Rotate');
    PDFName.Title = PDFName.of('Title');
    PDFName.Author = PDFName.of('Author');
    PDFName.Subject = PDFName.of('Subject');
    PDFName.Creator = PDFName.of('Creator');
    PDFName.Keywords = PDFName.of('Keywords');
    PDFName.Producer = PDFName.of('Producer');
    PDFName.CreationDate = PDFName.of('CreationDate');
    PDFName.ModDate = PDFName.of('ModDate');
    return PDFName;
}((0, $11c5J.default));
var $a12213d87b46303c$export$2e2bcd8739ae039 = $a12213d87b46303c$var$PDFName;

});
parcelRegister("6InlX", function(module, exports) {

$parcel$export(module.exports, "IsIrregular", () => $4e38f796f0a0073a$export$5a447e10c710a69b);

var $8zvel = parcelRequire("8zvel");

var $eOx0D = parcelRequire("eOx0D");

var $14u6w = parcelRequire("14u6w");
var $4e38f796f0a0073a$export$5a447e10c710a69b = new Uint8Array(256);
for(var $4e38f796f0a0073a$var$idx = 0, $4e38f796f0a0073a$var$len = 256; $4e38f796f0a0073a$var$idx < $4e38f796f0a0073a$var$len; $4e38f796f0a0073a$var$idx++)$4e38f796f0a0073a$export$5a447e10c710a69b[$4e38f796f0a0073a$var$idx] = (0, $14u6w.IsWhitespace)[$4e38f796f0a0073a$var$idx] || (0, $eOx0D.IsDelimiter)[$4e38f796f0a0073a$var$idx] ? 1 : 0;
$4e38f796f0a0073a$export$5a447e10c710a69b[(0, $8zvel.default).Hash] = 1;

});
parcelRegister("eOx0D", function(module, exports) {

$parcel$export(module.exports, "IsDelimiter", () => $ac8f572666c7d7dc$export$30620680eaa3becd);

var $8zvel = parcelRequire("8zvel");
var $ac8f572666c7d7dc$export$30620680eaa3becd = new Uint8Array(256);
$ac8f572666c7d7dc$export$30620680eaa3becd[(0, $8zvel.default).LeftParen] = 1;
$ac8f572666c7d7dc$export$30620680eaa3becd[(0, $8zvel.default).RightParen] = 1;
$ac8f572666c7d7dc$export$30620680eaa3becd[(0, $8zvel.default).LessThan] = 1;
$ac8f572666c7d7dc$export$30620680eaa3becd[(0, $8zvel.default).GreaterThan] = 1;
$ac8f572666c7d7dc$export$30620680eaa3becd[(0, $8zvel.default).LeftSquareBracket] = 1;
$ac8f572666c7d7dc$export$30620680eaa3becd[(0, $8zvel.default).RightSquareBracket] = 1;
$ac8f572666c7d7dc$export$30620680eaa3becd[(0, $8zvel.default).LeftCurly] = 1;
$ac8f572666c7d7dc$export$30620680eaa3becd[(0, $8zvel.default).RightCurly] = 1;
$ac8f572666c7d7dc$export$30620680eaa3becd[(0, $8zvel.default).ForwardSlash] = 1;
$ac8f572666c7d7dc$export$30620680eaa3becd[(0, $8zvel.default).Percent] = 1;

});

parcelRegister("14u6w", function(module, exports) {

$parcel$export(module.exports, "IsWhitespace", () => $0c7d843fbd7cd19d$export$38c4de915d0e2c37);

var $8zvel = parcelRequire("8zvel");
var $0c7d843fbd7cd19d$export$38c4de915d0e2c37 = new Uint8Array(256);
$0c7d843fbd7cd19d$export$38c4de915d0e2c37[(0, $8zvel.default).Null] = 1;
$0c7d843fbd7cd19d$export$38c4de915d0e2c37[(0, $8zvel.default).Tab] = 1;
$0c7d843fbd7cd19d$export$38c4de915d0e2c37[(0, $8zvel.default).Newline] = 1;
$0c7d843fbd7cd19d$export$38c4de915d0e2c37[(0, $8zvel.default).FormFeed] = 1;
$0c7d843fbd7cd19d$export$38c4de915d0e2c37[(0, $8zvel.default).CarriageReturn] = 1;
$0c7d843fbd7cd19d$export$38c4de915d0e2c37[(0, $8zvel.default).Space] = 1;

});



parcelRegister("eTKUN", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad8a981877dc5d20$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $11c5J = parcelRequire("11c5J");

var $8zvel = parcelRequire("8zvel");
var $ad8a981877dc5d20$var$PDFNull = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFNull, _super);
    function PDFNull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFNull.prototype.asNull = function() {
        return null;
    };
    PDFNull.prototype.clone = function() {
        return this;
    };
    PDFNull.prototype.toString = function() {
        return 'null';
    };
    PDFNull.prototype.sizeInBytes = function() {
        return 4;
    };
    PDFNull.prototype.copyBytesInto = function(buffer, offset) {
        buffer[offset++] = (0, $8zvel.default).n;
        buffer[offset++] = (0, $8zvel.default).u;
        buffer[offset++] = (0, $8zvel.default).l;
        buffer[offset++] = (0, $8zvel.default).l;
        return 4;
    };
    return PDFNull;
}((0, $11c5J.default));
var $ad8a981877dc5d20$export$2e2bcd8739ae039 = new $ad8a981877dc5d20$var$PDFNull();

});


parcelRegister("kx2r4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef28c75b0f11042e$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $4CgUJ = parcelRequire("4CgUJ");
parcelRequire("fvYKZ");
var $4ISq8 = parcelRequire("4ISq8");
var $ef28c75b0f11042e$var$PDFRawStream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFRawStream, _super);
    function PDFRawStream(dict, contents) {
        var _this = _super.call(this, dict) || this;
        _this.contents = contents;
        return _this;
    }
    PDFRawStream.prototype.asUint8Array = function() {
        return this.contents.slice();
    };
    PDFRawStream.prototype.clone = function(context) {
        return PDFRawStream.of(this.dict.clone(context), this.contents.slice());
    };
    PDFRawStream.prototype.getContentsString = function() {
        return (0, $4ISq8.arrayAsString)(this.contents);
    };
    PDFRawStream.prototype.getContents = function() {
        return this.contents;
    };
    PDFRawStream.prototype.getContentsSize = function() {
        return this.contents.length;
    };
    PDFRawStream.of = function(dict, contents) {
        return new PDFRawStream(dict, contents);
    };
    return PDFRawStream;
}((0, $4CgUJ.default));
var $ef28c75b0f11042e$export$2e2bcd8739ae039 = $ef28c75b0f11042e$var$PDFRawStream;

});
parcelRegister("4CgUJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $35c7d4c8e4f2bcc7$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $nAWRe = parcelRequire("nAWRe");

var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");

var $11c5J = parcelRequire("11c5J");

var $8zvel = parcelRequire("8zvel");
var $35c7d4c8e4f2bcc7$var$PDFStream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFStream, _super);
    function PDFStream(dict) {
        var _this = _super.call(this) || this;
        _this.dict = dict;
        return _this;
    }
    PDFStream.prototype.clone = function(_context) {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'clone');
    };
    PDFStream.prototype.getContentsString = function() {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'getContentsString');
    };
    PDFStream.prototype.getContents = function() {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'getContents');
    };
    PDFStream.prototype.getContentsSize = function() {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'getContentsSize');
    };
    PDFStream.prototype.updateDict = function() {
        var contentsSize = this.getContentsSize();
        this.dict.set((0, $dPHSK.default).Length, (0, $j04jt.default).of(contentsSize));
    };
    PDFStream.prototype.sizeInBytes = function() {
        this.updateDict();
        return this.dict.sizeInBytes() + this.getContentsSize() + 18;
    };
    PDFStream.prototype.toString = function() {
        this.updateDict();
        var streamString = this.dict.toString();
        streamString += '\nstream\n';
        streamString += this.getContentsString();
        streamString += '\nendstream';
        return streamString;
    };
    PDFStream.prototype.copyBytesInto = function(buffer, offset) {
        this.updateDict();
        var initialOffset = offset;
        offset += this.dict.copyBytesInto(buffer, offset);
        buffer[offset++] = (0, $8zvel.default).Newline;
        buffer[offset++] = (0, $8zvel.default).s;
        buffer[offset++] = (0, $8zvel.default).t;
        buffer[offset++] = (0, $8zvel.default).r;
        buffer[offset++] = (0, $8zvel.default).e;
        buffer[offset++] = (0, $8zvel.default).a;
        buffer[offset++] = (0, $8zvel.default).m;
        buffer[offset++] = (0, $8zvel.default).Newline;
        var contents = this.getContents();
        for(var idx = 0, len = contents.length; idx < len; idx++)buffer[offset++] = contents[idx];
        buffer[offset++] = (0, $8zvel.default).Newline;
        buffer[offset++] = (0, $8zvel.default).e;
        buffer[offset++] = (0, $8zvel.default).n;
        buffer[offset++] = (0, $8zvel.default).d;
        buffer[offset++] = (0, $8zvel.default).s;
        buffer[offset++] = (0, $8zvel.default).t;
        buffer[offset++] = (0, $8zvel.default).r;
        buffer[offset++] = (0, $8zvel.default).e;
        buffer[offset++] = (0, $8zvel.default).a;
        buffer[offset++] = (0, $8zvel.default).m;
        return offset - initialOffset;
    };
    return PDFStream;
}((0, $11c5J.default));
var $35c7d4c8e4f2bcc7$export$2e2bcd8739ae039 = $35c7d4c8e4f2bcc7$var$PDFStream;

});


parcelRegister("kHzkO", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1233b848bc26abe$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $nAWRe = parcelRequire("nAWRe");

var $11c5J = parcelRequire("11c5J");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $f1233b848bc26abe$var$ENFORCER = {};
var $f1233b848bc26abe$var$pool = new Map();
var $f1233b848bc26abe$var$PDFRef = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFRef, _super);
    function PDFRef(enforcer, objectNumber, generationNumber) {
        var _this = this;
        if (enforcer !== $f1233b848bc26abe$var$ENFORCER) throw new (0, $nAWRe.PrivateConstructorError)('PDFRef');
        _this = _super.call(this) || this;
        _this.objectNumber = objectNumber;
        _this.generationNumber = generationNumber;
        _this.tag = objectNumber + " " + generationNumber + " R";
        return _this;
    }
    PDFRef.prototype.clone = function() {
        return this;
    };
    PDFRef.prototype.toString = function() {
        return this.tag;
    };
    PDFRef.prototype.sizeInBytes = function() {
        return this.tag.length;
    };
    PDFRef.prototype.copyBytesInto = function(buffer, offset) {
        offset += (0, $7Kmy8.copyStringIntoBuffer)(this.tag, buffer, offset);
        return this.tag.length;
    };
    PDFRef.of = function(objectNumber, generationNumber) {
        if (generationNumber === void 0) generationNumber = 0;
        var tag = objectNumber + " " + generationNumber + " R";
        var instance = $f1233b848bc26abe$var$pool.get(tag);
        if (!instance) {
            instance = new PDFRef($f1233b848bc26abe$var$ENFORCER, objectNumber, generationNumber);
            $f1233b848bc26abe$var$pool.set(tag, instance);
        }
        return instance;
    };
    return PDFRef;
}((0, $11c5J.default));
var $f1233b848bc26abe$export$2e2bcd8739ae039 = $f1233b848bc26abe$var$PDFRef;

});

parcelRegister("5uV6d", function(module, exports) {

$parcel$export(module.exports, "default", () => $400c0bd11400a1c4$export$2e2bcd8739ae039);

var $11c5J = parcelRequire("11c5J");

var $8zvel = parcelRequire("8zvel");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $400c0bd11400a1c4$var$PDFOperator = /** @class */ function() {
    function PDFOperator(name, args) {
        this.name = name;
        this.args = args || [];
    }
    PDFOperator.prototype.clone = function(context) {
        var args = new Array(this.args.length);
        for(var idx = 0, len = args.length; idx < len; idx++){
            var arg = this.args[idx];
            args[idx] = arg instanceof (0, $11c5J.default) ? arg.clone(context) : arg;
        }
        return PDFOperator.of(this.name, args);
    };
    PDFOperator.prototype.toString = function() {
        var value = '';
        for(var idx = 0, len = this.args.length; idx < len; idx++)value += String(this.args[idx]) + ' ';
        value += this.name;
        return value;
    };
    PDFOperator.prototype.sizeInBytes = function() {
        var size = 0;
        for(var idx = 0, len = this.args.length; idx < len; idx++){
            var arg = this.args[idx];
            size += (arg instanceof (0, $11c5J.default) ? arg.sizeInBytes() : arg.length) + 1;
        }
        size += this.name.length;
        return size;
    };
    PDFOperator.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        for(var idx = 0, len = this.args.length; idx < len; idx++){
            var arg = this.args[idx];
            if (arg instanceof (0, $11c5J.default)) offset += arg.copyBytesInto(buffer, offset);
            else offset += (0, $7Kmy8.copyStringIntoBuffer)(arg, buffer, offset);
            buffer[offset++] = (0, $8zvel.default).Space;
        }
        offset += (0, $7Kmy8.copyStringIntoBuffer)(this.name, buffer, offset);
        return offset - initialOffset;
    };
    PDFOperator.of = function(name, args) {
        return new PDFOperator(name, args);
    };
    return PDFOperator;
}();
var $400c0bd11400a1c4$export$2e2bcd8739ae039 = $400c0bd11400a1c4$var$PDFOperator;

});

parcelRegister("3oHKx", function(module, exports) {

$parcel$export(module.exports, "default", () => $27958cc2c5d88a31$export$2e2bcd8739ae039);
var $27958cc2c5d88a31$var$PDFOperatorNames;
(function(PDFOperatorNames) {
    // Non Stroking Color Operators
    PDFOperatorNames["NonStrokingColor"] = "sc";
    PDFOperatorNames["NonStrokingColorN"] = "scn";
    PDFOperatorNames["NonStrokingColorRgb"] = "rg";
    PDFOperatorNames["NonStrokingColorGray"] = "g";
    PDFOperatorNames["NonStrokingColorCmyk"] = "k";
    PDFOperatorNames["NonStrokingColorspace"] = "cs";
    // Stroking Color Operators
    PDFOperatorNames["StrokingColor"] = "SC";
    PDFOperatorNames["StrokingColorN"] = "SCN";
    PDFOperatorNames["StrokingColorRgb"] = "RG";
    PDFOperatorNames["StrokingColorGray"] = "G";
    PDFOperatorNames["StrokingColorCmyk"] = "K";
    PDFOperatorNames["StrokingColorspace"] = "CS";
    // Marked Content Operators
    PDFOperatorNames["BeginMarkedContentSequence"] = "BDC";
    PDFOperatorNames["BeginMarkedContent"] = "BMC";
    PDFOperatorNames["EndMarkedContent"] = "EMC";
    PDFOperatorNames["MarkedContentPointWithProps"] = "DP";
    PDFOperatorNames["MarkedContentPoint"] = "MP";
    PDFOperatorNames["DrawObject"] = "Do";
    // Graphics State Operators
    PDFOperatorNames["ConcatTransformationMatrix"] = "cm";
    PDFOperatorNames["PopGraphicsState"] = "Q";
    PDFOperatorNames["PushGraphicsState"] = "q";
    PDFOperatorNames["SetFlatness"] = "i";
    PDFOperatorNames["SetGraphicsStateParams"] = "gs";
    PDFOperatorNames["SetLineCapStyle"] = "J";
    PDFOperatorNames["SetLineDashPattern"] = "d";
    PDFOperatorNames["SetLineJoinStyle"] = "j";
    PDFOperatorNames["SetLineMiterLimit"] = "M";
    PDFOperatorNames["SetLineWidth"] = "w";
    PDFOperatorNames["SetTextMatrix"] = "Tm";
    PDFOperatorNames["SetRenderingIntent"] = "ri";
    // Graphics Operators
    PDFOperatorNames["AppendRectangle"] = "re";
    PDFOperatorNames["BeginInlineImage"] = "BI";
    PDFOperatorNames["BeginInlineImageData"] = "ID";
    PDFOperatorNames["EndInlineImage"] = "EI";
    PDFOperatorNames["ClipEvenOdd"] = "W*";
    PDFOperatorNames["ClipNonZero"] = "W";
    PDFOperatorNames["CloseAndStroke"] = "s";
    PDFOperatorNames["CloseFillEvenOddAndStroke"] = "b*";
    PDFOperatorNames["CloseFillNonZeroAndStroke"] = "b";
    PDFOperatorNames["ClosePath"] = "h";
    PDFOperatorNames["AppendBezierCurve"] = "c";
    PDFOperatorNames["CurveToReplicateFinalPoint"] = "y";
    PDFOperatorNames["CurveToReplicateInitialPoint"] = "v";
    PDFOperatorNames["EndPath"] = "n";
    PDFOperatorNames["FillEvenOddAndStroke"] = "B*";
    PDFOperatorNames["FillEvenOdd"] = "f*";
    PDFOperatorNames["FillNonZeroAndStroke"] = "B";
    PDFOperatorNames["FillNonZero"] = "f";
    PDFOperatorNames["LegacyFillNonZero"] = "F";
    PDFOperatorNames["LineTo"] = "l";
    PDFOperatorNames["MoveTo"] = "m";
    PDFOperatorNames["ShadingFill"] = "sh";
    PDFOperatorNames["StrokePath"] = "S";
    // Text Operators
    PDFOperatorNames["BeginText"] = "BT";
    PDFOperatorNames["EndText"] = "ET";
    PDFOperatorNames["MoveText"] = "Td";
    PDFOperatorNames["MoveTextSetLeading"] = "TD";
    PDFOperatorNames["NextLine"] = "T*";
    PDFOperatorNames["SetCharacterSpacing"] = "Tc";
    PDFOperatorNames["SetFontAndSize"] = "Tf";
    PDFOperatorNames["SetTextHorizontalScaling"] = "Tz";
    PDFOperatorNames["SetTextLineHeight"] = "TL";
    PDFOperatorNames["SetTextRenderingMode"] = "Tr";
    PDFOperatorNames["SetTextRise"] = "Ts";
    PDFOperatorNames["SetWordSpacing"] = "Tw";
    PDFOperatorNames["ShowText"] = "Tj";
    PDFOperatorNames["ShowTextAdjusted"] = "TJ";
    PDFOperatorNames["ShowTextLine"] = "'";
    PDFOperatorNames["ShowTextLineAndSpace"] = "\"";
    // Type3 Font Operators
    PDFOperatorNames["Type3D0"] = "d0";
    PDFOperatorNames["Type3D1"] = "d1";
    // Compatibility Section Operators
    PDFOperatorNames["BeginCompatibilitySection"] = "BX";
    PDFOperatorNames["EndCompatibilitySection"] = "EX";
})($27958cc2c5d88a31$var$PDFOperatorNames || ($27958cc2c5d88a31$var$PDFOperatorNames = {}));
var $27958cc2c5d88a31$export$2e2bcd8739ae039 = $27958cc2c5d88a31$var$PDFOperatorNames;

});

parcelRegister("9EODP", function(module, exports) {

$parcel$export(module.exports, "default", () => $707f21d02e4e1bf4$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $3T8kK = parcelRequire("3T8kK");

var $8zvel = parcelRequire("8zvel");
var $707f21d02e4e1bf4$var$PDFContentStream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFContentStream, _super);
    function PDFContentStream(dict, operators, encode) {
        if (encode === void 0) encode = true;
        var _this = _super.call(this, dict, encode) || this;
        _this.operators = operators;
        return _this;
    }
    PDFContentStream.prototype.push = function() {
        var _a;
        var operators = [];
        for(var _i = 0; _i < arguments.length; _i++)operators[_i] = arguments[_i];
        (_a = this.operators).push.apply(_a, operators);
    };
    PDFContentStream.prototype.clone = function(context) {
        var operators = new Array(this.operators.length);
        for(var idx = 0, len = this.operators.length; idx < len; idx++)operators[idx] = this.operators[idx].clone(context);
        var _a = this, dict = _a.dict, encode = _a.encode;
        return PDFContentStream.of(dict.clone(context), operators, encode);
    };
    PDFContentStream.prototype.getContentsString = function() {
        var value = '';
        for(var idx = 0, len = this.operators.length; idx < len; idx++)value += this.operators[idx] + "\n";
        return value;
    };
    PDFContentStream.prototype.getUnencodedContents = function() {
        var buffer = new Uint8Array(this.getUnencodedContentsSize());
        var offset = 0;
        for(var idx = 0, len = this.operators.length; idx < len; idx++){
            offset += this.operators[idx].copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $8zvel.default).Newline;
        }
        return buffer;
    };
    PDFContentStream.prototype.getUnencodedContentsSize = function() {
        var size = 0;
        for(var idx = 0, len = this.operators.length; idx < len; idx++)size += this.operators[idx].sizeInBytes() + 1;
        return size;
    };
    PDFContentStream.of = function(dict, operators, encode) {
        if (encode === void 0) encode = true;
        return new PDFContentStream(dict, operators, encode);
    };
    return PDFContentStream;
}((0, $3T8kK.default));
var $707f21d02e4e1bf4$export$2e2bcd8739ae039 = $707f21d02e4e1bf4$var$PDFContentStream;

});
parcelRegister("3T8kK", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d4cf9103ab67d11$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $ckCqy = parcelRequire("ckCqy");

var $nAWRe = parcelRequire("nAWRe");

var $dPHSK = parcelRequire("dPHSK");

var $4CgUJ = parcelRequire("4CgUJ");
parcelRequire("fvYKZ");
var $clYSv = parcelRequire("clYSv");
var $2d4cf9103ab67d11$var$PDFFlateStream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFFlateStream, _super);
    function PDFFlateStream(dict, encode) {
        var _this = _super.call(this, dict) || this;
        _this.computeContents = function() {
            var unencodedContents = _this.getUnencodedContents();
            return _this.encode ? (0, (/*@__PURE__*/$parcel$interopDefault($ckCqy))).deflate(unencodedContents) : unencodedContents;
        };
        _this.encode = encode;
        if (encode) dict.set((0, $dPHSK.default).of('Filter'), (0, $dPHSK.default).of('FlateDecode'));
        _this.contentsCache = (0, $clYSv.default).populatedBy(_this.computeContents);
        return _this;
    }
    PDFFlateStream.prototype.getContents = function() {
        return this.contentsCache.access();
    };
    PDFFlateStream.prototype.getContentsSize = function() {
        return this.contentsCache.access().length;
    };
    PDFFlateStream.prototype.getUnencodedContents = function() {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'getUnencodedContents');
    };
    return PDFFlateStream;
}((0, $4CgUJ.default));
var $2d4cf9103ab67d11$export$2e2bcd8739ae039 = $2d4cf9103ab67d11$var$PDFFlateStream;

});


parcelRegister("5QhVg", function(module, exports) {

$parcel$export(module.exports, "SimpleRNG", () => $440fb620dea1b860$export$205b650d120b95b5);
/**
 * Generates a pseudo random number. Although it is not cryptographically secure
 * and uniformly distributed, it is not a concern for the intended use-case,
 * which is to generate distinct numbers.
 *
 * Credit: https://stackoverflow.com/a/19303725/10254049
 */ var $440fb620dea1b860$export$205b650d120b95b5 = /** @class */ function() {
    function SimpleRNG(seed) {
        this.seed = seed;
    }
    SimpleRNG.prototype.nextInt = function() {
        var x = Math.sin(this.seed++) * 10000;
        return x - Math.floor(x);
    };
    SimpleRNG.withSeed = function(seed) {
        return new SimpleRNG(seed);
    };
    return SimpleRNG;
}();

});


parcelRegister("k5Uzj", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea102798c96bfd06$export$2e2bcd8739ae039);

var $8auL6 = parcelRequire("8auL6");

var $brir8 = parcelRequire("brir8");

var $dPHSK = parcelRequire("dPHSK");

var $kHzkO = parcelRequire("kHzkO");

var $4CgUJ = parcelRequire("4CgUJ");

var $eAof5 = parcelRequire("eAof5");
/**
 * PDFObjectCopier copies PDFObjects from a src context to a dest context.
 * The primary use case for this is to copy pages between PDFs.
 *
 * _Copying_ an object with a PDFObjectCopier is different from _cloning_ an
 * object with its [[PDFObject.clone]] method:
 *
 * ```
 *   const src: PDFContext = ...
 *   const dest: PDFContext = ...
 *   const originalObject: PDFObject = ...
 *   const copiedObject = PDFObjectCopier.for(src, dest).copy(originalObject);
 *   const clonedObject = originalObject.clone();
 * ```
 *
 * Copying an object is equivalent to cloning it and then copying over any other
 * objects that it references. Note that only dictionaries, arrays, and streams
 * (or structures build from them) can contain indirect references to other
 * objects. Copying a PDFObject that is not a dictionary, array, or stream is
 * supported, but is equivalent to cloning it.
 */ var $ea102798c96bfd06$var$PDFObjectCopier = /** @class */ function() {
    function PDFObjectCopier(src, dest) {
        var _this = this;
        this.traversedObjects = new Map();
        // prettier-ignore
        this.copy = function(object) {
            return object instanceof (0, $eAof5.default) ? _this.copyPDFPage(object) : object instanceof (0, $brir8.default) ? _this.copyPDFDict(object) : object instanceof (0, $8auL6.default) ? _this.copyPDFArray(object) : object instanceof (0, $4CgUJ.default) ? _this.copyPDFStream(object) : object instanceof (0, $kHzkO.default) ? _this.copyPDFIndirectObject(object) : object.clone();
        };
        this.copyPDFPage = function(originalPage) {
            var clonedPage = originalPage.clone();
            // Move any entries that the originalPage is inheriting from its parent
            // tree nodes directly into originalPage so they are preserved during
            // the copy.
            var InheritableEntries = (0, $eAof5.default).InheritableEntries;
            for(var idx = 0, len = InheritableEntries.length; idx < len; idx++){
                var key = (0, $dPHSK.default).of(InheritableEntries[idx]);
                var value = clonedPage.getInheritableAttribute(key);
                if (!clonedPage.get(key) && value) clonedPage.set(key, value);
            }
            // Remove the parent reference to prevent the whole donor document's page
            // tree from being copied when we only need a single page.
            clonedPage.delete((0, $dPHSK.default).of('Parent'));
            return _this.copyPDFDict(clonedPage);
        };
        this.copyPDFDict = function(originalDict) {
            if (_this.traversedObjects.has(originalDict)) return _this.traversedObjects.get(originalDict);
            var clonedDict = originalDict.clone(_this.dest);
            _this.traversedObjects.set(originalDict, clonedDict);
            var entries = originalDict.entries();
            for(var idx = 0, len = entries.length; idx < len; idx++){
                var _a = entries[idx], key = _a[0], value = _a[1];
                clonedDict.set(key, _this.copy(value));
            }
            return clonedDict;
        };
        this.copyPDFArray = function(originalArray) {
            if (_this.traversedObjects.has(originalArray)) return _this.traversedObjects.get(originalArray);
            var clonedArray = originalArray.clone(_this.dest);
            _this.traversedObjects.set(originalArray, clonedArray);
            for(var idx = 0, len = originalArray.size(); idx < len; idx++){
                var value = originalArray.get(idx);
                clonedArray.set(idx, _this.copy(value));
            }
            return clonedArray;
        };
        this.copyPDFStream = function(originalStream) {
            if (_this.traversedObjects.has(originalStream)) return _this.traversedObjects.get(originalStream);
            var clonedStream = originalStream.clone(_this.dest);
            _this.traversedObjects.set(originalStream, clonedStream);
            var entries = originalStream.dict.entries();
            for(var idx = 0, len = entries.length; idx < len; idx++){
                var _a = entries[idx], key = _a[0], value = _a[1];
                clonedStream.dict.set(key, _this.copy(value));
            }
            return clonedStream;
        };
        this.copyPDFIndirectObject = function(ref) {
            var alreadyMapped = _this.traversedObjects.has(ref);
            if (!alreadyMapped) {
                var newRef = _this.dest.nextRef();
                _this.traversedObjects.set(ref, newRef);
                var dereferencedValue = _this.src.lookup(ref);
                if (dereferencedValue) {
                    var cloned = _this.copy(dereferencedValue);
                    _this.dest.assign(newRef, cloned);
                }
            }
            return _this.traversedObjects.get(ref);
        };
        this.src = src;
        this.dest = dest;
    }
    PDFObjectCopier.for = function(src, dest) {
        return new PDFObjectCopier(src, dest);
    };
    return PDFObjectCopier;
}();
var $ea102798c96bfd06$export$2e2bcd8739ae039 = $ea102798c96bfd06$var$PDFObjectCopier;

});
parcelRegister("eAof5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9e73b7ced5abfa4$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $8auL6 = parcelRequire("8auL6");

var $brir8 = parcelRequire("brir8");

var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");

var $4CgUJ = parcelRequire("4CgUJ");
var $a9e73b7ced5abfa4$var$PDFPageLeaf = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFPageLeaf, _super);
    function PDFPageLeaf(map, context, autoNormalizeCTM) {
        if (autoNormalizeCTM === void 0) autoNormalizeCTM = true;
        var _this = _super.call(this, map, context) || this;
        _this.normalized = false;
        _this.autoNormalizeCTM = autoNormalizeCTM;
        return _this;
    }
    PDFPageLeaf.prototype.clone = function(context) {
        var clone = PDFPageLeaf.fromMapWithContext(new Map(), context || this.context, this.autoNormalizeCTM);
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            clone.set(key, value);
        }
        return clone;
    };
    PDFPageLeaf.prototype.Parent = function() {
        return this.lookupMaybe((0, $dPHSK.default).Parent, (0, $brir8.default));
    };
    PDFPageLeaf.prototype.Contents = function() {
        return this.lookup((0, $dPHSK.default).of('Contents'));
    };
    PDFPageLeaf.prototype.Annots = function() {
        return this.lookupMaybe((0, $dPHSK.default).Annots, (0, $8auL6.default));
    };
    PDFPageLeaf.prototype.BleedBox = function() {
        return this.lookupMaybe((0, $dPHSK.default).BleedBox, (0, $8auL6.default));
    };
    PDFPageLeaf.prototype.TrimBox = function() {
        return this.lookupMaybe((0, $dPHSK.default).TrimBox, (0, $8auL6.default));
    };
    PDFPageLeaf.prototype.ArtBox = function() {
        return this.lookupMaybe((0, $dPHSK.default).ArtBox, (0, $8auL6.default));
    };
    PDFPageLeaf.prototype.Resources = function() {
        var dictOrRef = this.getInheritableAttribute((0, $dPHSK.default).Resources);
        return this.context.lookupMaybe(dictOrRef, (0, $brir8.default));
    };
    PDFPageLeaf.prototype.MediaBox = function() {
        var arrayOrRef = this.getInheritableAttribute((0, $dPHSK.default).MediaBox);
        return this.context.lookup(arrayOrRef, (0, $8auL6.default));
    };
    PDFPageLeaf.prototype.CropBox = function() {
        var arrayOrRef = this.getInheritableAttribute((0, $dPHSK.default).CropBox);
        return this.context.lookupMaybe(arrayOrRef, (0, $8auL6.default));
    };
    PDFPageLeaf.prototype.Rotate = function() {
        var numberOrRef = this.getInheritableAttribute((0, $dPHSK.default).Rotate);
        return this.context.lookupMaybe(numberOrRef, (0, $j04jt.default));
    };
    PDFPageLeaf.prototype.getInheritableAttribute = function(name) {
        var attribute;
        this.ascend(function(node) {
            if (!attribute) attribute = node.get(name);
        });
        return attribute;
    };
    PDFPageLeaf.prototype.setParent = function(parentRef) {
        this.set((0, $dPHSK.default).Parent, parentRef);
    };
    PDFPageLeaf.prototype.addContentStream = function(contentStreamRef) {
        var Contents = this.normalizedEntries().Contents || this.context.obj([]);
        this.set((0, $dPHSK.default).Contents, Contents);
        Contents.push(contentStreamRef);
    };
    PDFPageLeaf.prototype.wrapContentStreams = function(startStream, endStream) {
        var Contents = this.Contents();
        if (Contents instanceof (0, $8auL6.default)) {
            Contents.insert(0, startStream);
            Contents.push(endStream);
            return true;
        }
        return false;
    };
    PDFPageLeaf.prototype.addAnnot = function(annotRef) {
        var Annots = this.normalizedEntries().Annots;
        Annots.push(annotRef);
    };
    PDFPageLeaf.prototype.removeAnnot = function(annotRef) {
        var Annots = this.normalizedEntries().Annots;
        var index = Annots.indexOf(annotRef);
        if (index !== undefined) Annots.remove(index);
    };
    PDFPageLeaf.prototype.setFontDictionary = function(name, fontDictRef) {
        var Font = this.normalizedEntries().Font;
        Font.set(name, fontDictRef);
    };
    PDFPageLeaf.prototype.newFontDictionaryKey = function(tag) {
        var Font = this.normalizedEntries().Font;
        return Font.uniqueKey(tag);
    };
    PDFPageLeaf.prototype.newFontDictionary = function(tag, fontDictRef) {
        var key = this.newFontDictionaryKey(tag);
        this.setFontDictionary(key, fontDictRef);
        return key;
    };
    PDFPageLeaf.prototype.setXObject = function(name, xObjectRef) {
        var XObject = this.normalizedEntries().XObject;
        XObject.set(name, xObjectRef);
    };
    PDFPageLeaf.prototype.newXObjectKey = function(tag) {
        var XObject = this.normalizedEntries().XObject;
        return XObject.uniqueKey(tag);
    };
    PDFPageLeaf.prototype.newXObject = function(tag, xObjectRef) {
        var key = this.newXObjectKey(tag);
        this.setXObject(key, xObjectRef);
        return key;
    };
    PDFPageLeaf.prototype.setExtGState = function(name, extGStateRef) {
        var ExtGState = this.normalizedEntries().ExtGState;
        ExtGState.set(name, extGStateRef);
    };
    PDFPageLeaf.prototype.newExtGStateKey = function(tag) {
        var ExtGState = this.normalizedEntries().ExtGState;
        return ExtGState.uniqueKey(tag);
    };
    PDFPageLeaf.prototype.newExtGState = function(tag, extGStateRef) {
        var key = this.newExtGStateKey(tag);
        this.setExtGState(key, extGStateRef);
        return key;
    };
    PDFPageLeaf.prototype.ascend = function(visitor) {
        visitor(this);
        var Parent = this.Parent();
        if (Parent) Parent.ascend(visitor);
    };
    PDFPageLeaf.prototype.normalize = function() {
        if (this.normalized) return;
        var context = this.context;
        var contentsRef = this.get((0, $dPHSK.default).Contents);
        var contents = this.context.lookup(contentsRef);
        if (contents instanceof (0, $4CgUJ.default)) this.set((0, $dPHSK.default).Contents, context.obj([
            contentsRef
        ]));
        if (this.autoNormalizeCTM) this.wrapContentStreams(this.context.getPushGraphicsStateContentStream(), this.context.getPopGraphicsStateContentStream());
        // TODO: Clone `Resources` if it is inherited
        var dictOrRef = this.getInheritableAttribute((0, $dPHSK.default).Resources);
        var Resources = context.lookupMaybe(dictOrRef, (0, $brir8.default)) || context.obj({});
        this.set((0, $dPHSK.default).Resources, Resources);
        // TODO: Clone `Font` if it is inherited
        var Font = Resources.lookupMaybe((0, $dPHSK.default).Font, (0, $brir8.default)) || context.obj({});
        Resources.set((0, $dPHSK.default).Font, Font);
        // TODO: Clone `XObject` if it is inherited
        var XObject = Resources.lookupMaybe((0, $dPHSK.default).XObject, (0, $brir8.default)) || context.obj({});
        Resources.set((0, $dPHSK.default).XObject, XObject);
        // TODO: Clone `ExtGState` if it is inherited
        var ExtGState = Resources.lookupMaybe((0, $dPHSK.default).ExtGState, (0, $brir8.default)) || context.obj({});
        Resources.set((0, $dPHSK.default).ExtGState, ExtGState);
        var Annots = this.Annots() || context.obj([]);
        this.set((0, $dPHSK.default).Annots, Annots);
        this.normalized = true;
    };
    PDFPageLeaf.prototype.normalizedEntries = function() {
        this.normalize();
        var Annots = this.Annots();
        var Resources = this.Resources();
        var Contents = this.Contents();
        return {
            Annots: Annots,
            Resources: Resources,
            Contents: Contents,
            Font: Resources.lookup((0, $dPHSK.default).Font, (0, $brir8.default)),
            XObject: Resources.lookup((0, $dPHSK.default).XObject, (0, $brir8.default)),
            ExtGState: Resources.lookup((0, $dPHSK.default).ExtGState, (0, $brir8.default))
        };
    };
    PDFPageLeaf.InheritableEntries = [
        'Resources',
        'MediaBox',
        'CropBox',
        'Rotate'
    ];
    PDFPageLeaf.withContextAndParent = function(context, parent) {
        var dict = new Map();
        dict.set((0, $dPHSK.default).Type, (0, $dPHSK.default).Page);
        dict.set((0, $dPHSK.default).Parent, parent);
        dict.set((0, $dPHSK.default).Resources, context.obj({}));
        dict.set((0, $dPHSK.default).MediaBox, context.obj([
            0,
            0,
            612,
            792
        ]));
        return new PDFPageLeaf(dict, context, false);
    };
    PDFPageLeaf.fromMapWithContext = function(map, context, autoNormalizeCTM) {
        if (autoNormalizeCTM === void 0) autoNormalizeCTM = true;
        return new PDFPageLeaf(map, context, autoNormalizeCTM);
    };
    return PDFPageLeaf;
}((0, $brir8.default));
var $a9e73b7ced5abfa4$export$2e2bcd8739ae039 = $a9e73b7ced5abfa4$var$PDFPageLeaf;

});


parcelRegister("5HlMk", function(module, exports) {

$parcel$export(module.exports, "default", () => $4261dca68d44d2dc$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $Vy0LI = parcelRequire("Vy0LI");

var $eHlB9 = parcelRequire("eHlB9");

var $4S3gv = parcelRequire("4S3gv");

var $fXb4L = parcelRequire("fXb4L");

var $8nK9n = parcelRequire("8nK9n");

var $8zvel = parcelRequire("8zvel");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $ggjMi = parcelRequire("ggjMi");
var $4261dca68d44d2dc$var$PDFWriter = /** @class */ function() {
    function PDFWriter(context, objectsPerTick) {
        var _this = this;
        this.parsedObjects = 0;
        this.shouldWaitForTick = function(n) {
            _this.parsedObjects += n;
            return _this.parsedObjects % _this.objectsPerTick === 0;
        };
        this.context = context;
        this.objectsPerTick = objectsPerTick;
    }
    PDFWriter.prototype.serializeToBuffer = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var _a, size, header, indirectObjects, xref, trailerDict, trailer, offset, buffer, idx, len, _b, ref, object, objectNumber, generationNumber, n;
            return (0, $cOQTW.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.computeBufferSize()
                        ];
                    case 1:
                        _a = _c.sent(), size = _a.size, header = _a.header, indirectObjects = _a.indirectObjects, xref = _a.xref, trailerDict = _a.trailerDict, trailer = _a.trailer;
                        offset = 0;
                        buffer = new Uint8Array(size);
                        offset += header.copyBytesInto(buffer, offset);
                        buffer[offset++] = (0, $8zvel.default).Newline;
                        buffer[offset++] = (0, $8zvel.default).Newline;
                        idx = 0, len = indirectObjects.length;
                        _c.label = 2;
                    case 2:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            5
                        ];
                        _b = indirectObjects[idx], ref = _b[0], object = _b[1];
                        objectNumber = String(ref.objectNumber);
                        offset += (0, $7Kmy8.copyStringIntoBuffer)(objectNumber, buffer, offset);
                        buffer[offset++] = (0, $8zvel.default).Space;
                        generationNumber = String(ref.generationNumber);
                        offset += (0, $7Kmy8.copyStringIntoBuffer)(generationNumber, buffer, offset);
                        buffer[offset++] = (0, $8zvel.default).Space;
                        buffer[offset++] = (0, $8zvel.default).o;
                        buffer[offset++] = (0, $8zvel.default).b;
                        buffer[offset++] = (0, $8zvel.default).j;
                        buffer[offset++] = (0, $8zvel.default).Newline;
                        offset += object.copyBytesInto(buffer, offset);
                        buffer[offset++] = (0, $8zvel.default).Newline;
                        buffer[offset++] = (0, $8zvel.default).e;
                        buffer[offset++] = (0, $8zvel.default).n;
                        buffer[offset++] = (0, $8zvel.default).d;
                        buffer[offset++] = (0, $8zvel.default).o;
                        buffer[offset++] = (0, $8zvel.default).b;
                        buffer[offset++] = (0, $8zvel.default).j;
                        buffer[offset++] = (0, $8zvel.default).Newline;
                        buffer[offset++] = (0, $8zvel.default).Newline;
                        n = object instanceof (0, $8nK9n.default) ? object.getObjectsCount() : 1;
                        if (!this.shouldWaitForTick(n)) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $ggjMi.waitForTick)()
                        ];
                    case 3:
                        _c.sent();
                        _c.label = 4;
                    case 4:
                        idx++;
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 5:
                        if (xref) {
                            offset += xref.copyBytesInto(buffer, offset);
                            buffer[offset++] = (0, $8zvel.default).Newline;
                        }
                        if (trailerDict) {
                            offset += trailerDict.copyBytesInto(buffer, offset);
                            buffer[offset++] = (0, $8zvel.default).Newline;
                            buffer[offset++] = (0, $8zvel.default).Newline;
                        }
                        offset += trailer.copyBytesInto(buffer, offset);
                        return [
                            2 /*return*/ ,
                            buffer
                        ];
                }
            });
        });
    };
    PDFWriter.prototype.computeIndirectObjectSize = function(_a) {
        var ref = _a[0], object = _a[1];
        var refSize = ref.sizeInBytes() + 3; // 'R' -> 'obj\n'
        var objectSize = object.sizeInBytes() + 9; // '\nendobj\n\n'
        return refSize + objectSize;
    };
    PDFWriter.prototype.createTrailerDict = function() {
        return this.context.obj({
            Size: this.context.largestObjectNumber + 1,
            Root: this.context.trailerInfo.Root,
            Encrypt: this.context.trailerInfo.Encrypt,
            Info: this.context.trailerInfo.Info,
            ID: this.context.trailerInfo.ID
        });
    };
    PDFWriter.prototype.computeBufferSize = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var header, size, xref, indirectObjects, idx, len, indirectObject, ref, xrefOffset, trailerDict, trailer;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        header = (0, $eHlB9.default).forVersion(1, 7);
                        size = header.sizeInBytes() + 2;
                        xref = (0, $Vy0LI.default).create();
                        indirectObjects = this.context.enumerateIndirectObjects();
                        idx = 0, len = indirectObjects.length;
                        _a.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            4
                        ];
                        indirectObject = indirectObjects[idx];
                        ref = indirectObject[0];
                        xref.addEntry(ref, size);
                        size += this.computeIndirectObjectSize(indirectObject);
                        if (!this.shouldWaitForTick(1)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $ggjMi.waitForTick)()
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        xrefOffset = size;
                        size += xref.sizeInBytes() + 1; // '\n'
                        trailerDict = (0, $fXb4L.default).of(this.createTrailerDict());
                        size += trailerDict.sizeInBytes() + 2; // '\n\n'
                        trailer = (0, $4S3gv.default).forLastCrossRefSectionOffset(xrefOffset);
                        size += trailer.sizeInBytes();
                        return [
                            2 /*return*/ ,
                            {
                                size: size,
                                header: header,
                                indirectObjects: indirectObjects,
                                xref: xref,
                                trailerDict: trailerDict,
                                trailer: trailer
                            }
                        ];
                }
            });
        });
    };
    PDFWriter.forContext = function(context, objectsPerTick) {
        return new PDFWriter(context, objectsPerTick);
    };
    return PDFWriter;
}();
var $4261dca68d44d2dc$export$2e2bcd8739ae039 = $4261dca68d44d2dc$var$PDFWriter;

});
parcelRegister("Vy0LI", function(module, exports) {

$parcel$export(module.exports, "default", () => $0acfb4f0f4898246$export$2e2bcd8739ae039);

var $kHzkO = parcelRequire("kHzkO");

var $8zvel = parcelRequire("8zvel");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
/**
 * Entries should be added using the [[addEntry]] and [[addDeletedEntry]]
 * methods **in order of ascending object number**.
 */ var $0acfb4f0f4898246$var$PDFCrossRefSection = /** @class */ function() {
    function PDFCrossRefSection(firstEntry) {
        this.subsections = firstEntry ? [
            [
                firstEntry
            ]
        ] : [];
        this.chunkIdx = 0;
        this.chunkLength = firstEntry ? 1 : 0;
    }
    PDFCrossRefSection.prototype.addEntry = function(ref, offset) {
        this.append({
            ref: ref,
            offset: offset,
            deleted: false
        });
    };
    PDFCrossRefSection.prototype.addDeletedEntry = function(ref, nextFreeObjectNumber) {
        this.append({
            ref: ref,
            offset: nextFreeObjectNumber,
            deleted: true
        });
    };
    PDFCrossRefSection.prototype.toString = function() {
        var section = "xref\n";
        for(var rangeIdx = 0, rangeLen = this.subsections.length; rangeIdx < rangeLen; rangeIdx++){
            var range = this.subsections[rangeIdx];
            section += range[0].ref.objectNumber + " " + range.length + "\n";
            for(var entryIdx = 0, entryLen = range.length; entryIdx < entryLen; entryIdx++){
                var entry = range[entryIdx];
                section += (0, $7Kmy8.padStart)(String(entry.offset), 10, '0');
                section += ' ';
                section += (0, $7Kmy8.padStart)(String(entry.ref.generationNumber), 5, '0');
                section += ' ';
                section += entry.deleted ? 'f' : 'n';
                section += ' \n';
            }
        }
        return section;
    };
    PDFCrossRefSection.prototype.sizeInBytes = function() {
        var size = 5;
        for(var idx = 0, len = this.subsections.length; idx < len; idx++){
            var subsection = this.subsections[idx];
            var subsectionLength = subsection.length;
            var firstEntry = subsection[0];
            size += 2;
            size += String(firstEntry.ref.objectNumber).length;
            size += String(subsectionLength).length;
            size += 20 * subsectionLength;
        }
        return size;
    };
    PDFCrossRefSection.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $8zvel.default).x;
        buffer[offset++] = (0, $8zvel.default).r;
        buffer[offset++] = (0, $8zvel.default).e;
        buffer[offset++] = (0, $8zvel.default).f;
        buffer[offset++] = (0, $8zvel.default).Newline;
        offset += this.copySubsectionsIntoBuffer(this.subsections, buffer, offset);
        return offset - initialOffset;
    };
    PDFCrossRefSection.prototype.copySubsectionsIntoBuffer = function(subsections, buffer, offset) {
        var initialOffset = offset;
        var length = subsections.length;
        for(var idx = 0; idx < length; idx++){
            var subsection = this.subsections[idx];
            var firstObjectNumber = String(subsection[0].ref.objectNumber);
            offset += (0, $7Kmy8.copyStringIntoBuffer)(firstObjectNumber, buffer, offset);
            buffer[offset++] = (0, $8zvel.default).Space;
            var rangeLength = String(subsection.length);
            offset += (0, $7Kmy8.copyStringIntoBuffer)(rangeLength, buffer, offset);
            buffer[offset++] = (0, $8zvel.default).Newline;
            offset += this.copyEntriesIntoBuffer(subsection, buffer, offset);
        }
        return offset - initialOffset;
    };
    PDFCrossRefSection.prototype.copyEntriesIntoBuffer = function(entries, buffer, offset) {
        var length = entries.length;
        for(var idx = 0; idx < length; idx++){
            var entry = entries[idx];
            var entryOffset = (0, $7Kmy8.padStart)(String(entry.offset), 10, '0');
            offset += (0, $7Kmy8.copyStringIntoBuffer)(entryOffset, buffer, offset);
            buffer[offset++] = (0, $8zvel.default).Space;
            var entryGen = (0, $7Kmy8.padStart)(String(entry.ref.generationNumber), 5, '0');
            offset += (0, $7Kmy8.copyStringIntoBuffer)(entryGen, buffer, offset);
            buffer[offset++] = (0, $8zvel.default).Space;
            buffer[offset++] = entry.deleted ? (0, $8zvel.default).f : (0, $8zvel.default).n;
            buffer[offset++] = (0, $8zvel.default).Space;
            buffer[offset++] = (0, $8zvel.default).Newline;
        }
        return 20 * length;
    };
    PDFCrossRefSection.prototype.append = function(currEntry) {
        if (this.chunkLength === 0) {
            this.subsections.push([
                currEntry
            ]);
            this.chunkIdx = 0;
            this.chunkLength = 1;
            return;
        }
        var chunk = this.subsections[this.chunkIdx];
        var prevEntry = chunk[this.chunkLength - 1];
        if (currEntry.ref.objectNumber - prevEntry.ref.objectNumber > 1) {
            this.subsections.push([
                currEntry
            ]);
            this.chunkIdx += 1;
            this.chunkLength = 1;
        } else {
            chunk.push(currEntry);
            this.chunkLength += 1;
        }
    };
    PDFCrossRefSection.create = function() {
        return new PDFCrossRefSection({
            ref: (0, $kHzkO.default).of(0, 65535),
            offset: 0,
            deleted: true
        });
    };
    PDFCrossRefSection.createEmpty = function() {
        return new PDFCrossRefSection();
    };
    return PDFCrossRefSection;
}();
var $0acfb4f0f4898246$export$2e2bcd8739ae039 = $0acfb4f0f4898246$var$PDFCrossRefSection;

});

parcelRegister("4S3gv", function(module, exports) {

$parcel$export(module.exports, "default", () => $38bebcf76e0d2d54$export$2e2bcd8739ae039);

var $8zvel = parcelRequire("8zvel");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $38bebcf76e0d2d54$var$PDFTrailer = /** @class */ function() {
    function PDFTrailer(lastXRefOffset) {
        this.lastXRefOffset = String(lastXRefOffset);
    }
    PDFTrailer.prototype.toString = function() {
        return "startxref\n" + this.lastXRefOffset + "\n%%EOF";
    };
    PDFTrailer.prototype.sizeInBytes = function() {
        return 16 + this.lastXRefOffset.length;
    };
    PDFTrailer.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $8zvel.default).s;
        buffer[offset++] = (0, $8zvel.default).t;
        buffer[offset++] = (0, $8zvel.default).a;
        buffer[offset++] = (0, $8zvel.default).r;
        buffer[offset++] = (0, $8zvel.default).t;
        buffer[offset++] = (0, $8zvel.default).x;
        buffer[offset++] = (0, $8zvel.default).r;
        buffer[offset++] = (0, $8zvel.default).e;
        buffer[offset++] = (0, $8zvel.default).f;
        buffer[offset++] = (0, $8zvel.default).Newline;
        offset += (0, $7Kmy8.copyStringIntoBuffer)(this.lastXRefOffset, buffer, offset);
        buffer[offset++] = (0, $8zvel.default).Newline;
        buffer[offset++] = (0, $8zvel.default).Percent;
        buffer[offset++] = (0, $8zvel.default).Percent;
        buffer[offset++] = (0, $8zvel.default).E;
        buffer[offset++] = (0, $8zvel.default).O;
        buffer[offset++] = (0, $8zvel.default).F;
        return offset - initialOffset;
    };
    PDFTrailer.forLastCrossRefSectionOffset = function(offset) {
        return new PDFTrailer(offset);
    };
    return PDFTrailer;
}();
var $38bebcf76e0d2d54$export$2e2bcd8739ae039 = $38bebcf76e0d2d54$var$PDFTrailer;

});

parcelRegister("fXb4L", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9d4f51bf55d54ab$export$2e2bcd8739ae039);

var $8zvel = parcelRequire("8zvel");
var $b9d4f51bf55d54ab$var$PDFTrailerDict = /** @class */ function() {
    function PDFTrailerDict(dict) {
        this.dict = dict;
    }
    PDFTrailerDict.prototype.toString = function() {
        return "trailer\n" + this.dict.toString();
    };
    PDFTrailerDict.prototype.sizeInBytes = function() {
        return 8 + this.dict.sizeInBytes();
    };
    PDFTrailerDict.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $8zvel.default).t;
        buffer[offset++] = (0, $8zvel.default).r;
        buffer[offset++] = (0, $8zvel.default).a;
        buffer[offset++] = (0, $8zvel.default).i;
        buffer[offset++] = (0, $8zvel.default).l;
        buffer[offset++] = (0, $8zvel.default).e;
        buffer[offset++] = (0, $8zvel.default).r;
        buffer[offset++] = (0, $8zvel.default).Newline;
        offset += this.dict.copyBytesInto(buffer, offset);
        return offset - initialOffset;
    };
    PDFTrailerDict.of = function(dict) {
        return new PDFTrailerDict(dict);
    };
    return PDFTrailerDict;
}();
var $b9d4f51bf55d54ab$export$2e2bcd8739ae039 = $b9d4f51bf55d54ab$var$PDFTrailerDict;

});

parcelRegister("8nK9n", function(module, exports) {

$parcel$export(module.exports, "default", () => $61a4452f4878bba9$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");

var $3T8kK = parcelRequire("3T8kK");

var $8zvel = parcelRequire("8zvel");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $4ISq8 = parcelRequire("4ISq8");
var $61a4452f4878bba9$var$PDFObjectStream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFObjectStream, _super);
    function PDFObjectStream(context, objects, encode) {
        if (encode === void 0) encode = true;
        var _this = _super.call(this, context.obj({}), encode) || this;
        _this.objects = objects;
        _this.offsets = _this.computeObjectOffsets();
        _this.offsetsString = _this.computeOffsetsString();
        _this.dict.set((0, $dPHSK.default).of('Type'), (0, $dPHSK.default).of('ObjStm'));
        _this.dict.set((0, $dPHSK.default).of('N'), (0, $j04jt.default).of(_this.objects.length));
        _this.dict.set((0, $dPHSK.default).of('First'), (0, $j04jt.default).of(_this.offsetsString.length));
        return _this;
    }
    PDFObjectStream.prototype.getObjectsCount = function() {
        return this.objects.length;
    };
    PDFObjectStream.prototype.clone = function(context) {
        return PDFObjectStream.withContextAndObjects(context || this.dict.context, this.objects.slice(), this.encode);
    };
    PDFObjectStream.prototype.getContentsString = function() {
        var value = this.offsetsString;
        for(var idx = 0, len = this.objects.length; idx < len; idx++){
            var _a = this.objects[idx], object = _a[1];
            value += object + "\n";
        }
        return value;
    };
    PDFObjectStream.prototype.getUnencodedContents = function() {
        var buffer = new Uint8Array(this.getUnencodedContentsSize());
        var offset = (0, $7Kmy8.copyStringIntoBuffer)(this.offsetsString, buffer, 0);
        for(var idx = 0, len = this.objects.length; idx < len; idx++){
            var _a = this.objects[idx], object = _a[1];
            offset += object.copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $8zvel.default).Newline;
        }
        return buffer;
    };
    PDFObjectStream.prototype.getUnencodedContentsSize = function() {
        return this.offsetsString.length + (0, $4ISq8.last)(this.offsets)[1] + (0, $4ISq8.last)(this.objects)[1].sizeInBytes() + 1;
    };
    PDFObjectStream.prototype.computeOffsetsString = function() {
        var offsetsString = '';
        for(var idx = 0, len = this.offsets.length; idx < len; idx++){
            var _a = this.offsets[idx], objectNumber = _a[0], offset = _a[1];
            offsetsString += objectNumber + " " + offset + " ";
        }
        return offsetsString;
    };
    PDFObjectStream.prototype.computeObjectOffsets = function() {
        var offset = 0;
        var offsets = new Array(this.objects.length);
        for(var idx = 0, len = this.objects.length; idx < len; idx++){
            var _a = this.objects[idx], ref = _a[0], object = _a[1];
            offsets[idx] = [
                ref.objectNumber,
                offset
            ];
            offset += object.sizeInBytes() + 1; // '\n'
        }
        return offsets;
    };
    PDFObjectStream.withContextAndObjects = function(context, objects, encode) {
        if (encode === void 0) encode = true;
        return new PDFObjectStream(context, objects, encode);
    };
    return PDFObjectStream;
}((0, $3T8kK.default));
var $61a4452f4878bba9$export$2e2bcd8739ae039 = $61a4452f4878bba9$var$PDFObjectStream;

});


parcelRegister("7YdvF", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cd89dbe12e59987$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $eHlB9 = parcelRequire("eHlB9");

var $4S3gv = parcelRequire("4S3gv");

var $eTWtL = parcelRequire("eTWtL");

var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");

var $kHzkO = parcelRequire("kHzkO");

var $4CgUJ = parcelRequire("4CgUJ");

var $eMjAF = parcelRequire("eMjAF");

var $8nK9n = parcelRequire("8nK9n");

var $5HlMk = parcelRequire("5HlMk");
parcelRequire("fvYKZ");
var $4ISq8 = parcelRequire("4ISq8");
var $ggjMi = parcelRequire("ggjMi");
var $5cd89dbe12e59987$var$PDFStreamWriter = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFStreamWriter, _super);
    function PDFStreamWriter(context, objectsPerTick, encodeStreams, objectsPerStream) {
        var _this = _super.call(this, context, objectsPerTick) || this;
        _this.encodeStreams = encodeStreams;
        _this.objectsPerStream = objectsPerStream;
        return _this;
    }
    PDFStreamWriter.prototype.computeBufferSize = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var objectNumber, header, size, xrefStream, uncompressedObjects, compressedObjects, objectStreamRefs, indirectObjects, idx, len, indirectObject, ref, object, shouldNotCompress, chunk, objectStreamRef, idx, len, chunk, ref, objectStream, xrefStreamRef, xrefOffset, trailer;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        objectNumber = this.context.largestObjectNumber + 1;
                        header = (0, $eHlB9.default).forVersion(1, 7);
                        size = header.sizeInBytes() + 2;
                        xrefStream = (0, $eMjAF.default).create(this.createTrailerDict(), this.encodeStreams);
                        uncompressedObjects = [];
                        compressedObjects = [];
                        objectStreamRefs = [];
                        indirectObjects = this.context.enumerateIndirectObjects();
                        idx = 0, len = indirectObjects.length;
                        _a.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            6
                        ];
                        indirectObject = indirectObjects[idx];
                        ref = indirectObject[0], object = indirectObject[1];
                        shouldNotCompress = ref === this.context.trailerInfo.Encrypt || object instanceof (0, $4CgUJ.default) || object instanceof (0, $eTWtL.default) || ref.generationNumber !== 0;
                        if (!shouldNotCompress) return [
                            3 /*break*/ ,
                            4
                        ];
                        uncompressedObjects.push(indirectObject);
                        xrefStream.addUncompressedEntry(ref, size);
                        size += this.computeIndirectObjectSize(indirectObject);
                        if (!this.shouldWaitForTick(1)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $ggjMi.waitForTick)()
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        chunk = (0, $4ISq8.last)(compressedObjects);
                        objectStreamRef = (0, $4ISq8.last)(objectStreamRefs);
                        if (!chunk || chunk.length % this.objectsPerStream === 0) {
                            chunk = [];
                            compressedObjects.push(chunk);
                            objectStreamRef = (0, $kHzkO.default).of(objectNumber++);
                            objectStreamRefs.push(objectStreamRef);
                        }
                        xrefStream.addCompressedEntry(ref, objectStreamRef, chunk.length);
                        chunk.push(indirectObject);
                        _a.label = 5;
                    case 5:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 6:
                        idx = 0, len = compressedObjects.length;
                        _a.label = 7;
                    case 7:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            10
                        ];
                        chunk = compressedObjects[idx];
                        ref = objectStreamRefs[idx];
                        objectStream = (0, $8nK9n.default).withContextAndObjects(this.context, chunk, this.encodeStreams);
                        xrefStream.addUncompressedEntry(ref, size);
                        size += this.computeIndirectObjectSize([
                            ref,
                            objectStream
                        ]);
                        uncompressedObjects.push([
                            ref,
                            objectStream
                        ]);
                        if (!this.shouldWaitForTick(chunk.length)) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $ggjMi.waitForTick)()
                        ];
                    case 8:
                        _a.sent();
                        _a.label = 9;
                    case 9:
                        idx++;
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 10:
                        xrefStreamRef = (0, $kHzkO.default).of(objectNumber++);
                        xrefStream.dict.set((0, $dPHSK.default).of('Size'), (0, $j04jt.default).of(objectNumber));
                        xrefStream.addUncompressedEntry(xrefStreamRef, size);
                        xrefOffset = size;
                        size += this.computeIndirectObjectSize([
                            xrefStreamRef,
                            xrefStream
                        ]);
                        uncompressedObjects.push([
                            xrefStreamRef,
                            xrefStream
                        ]);
                        trailer = (0, $4S3gv.default).forLastCrossRefSectionOffset(xrefOffset);
                        size += trailer.sizeInBytes();
                        return [
                            2 /*return*/ ,
                            {
                                size: size,
                                header: header,
                                indirectObjects: uncompressedObjects,
                                trailer: trailer
                            }
                        ];
                }
            });
        });
    };
    PDFStreamWriter.forContext = function(context, objectsPerTick, encodeStreams, objectsPerStream) {
        if (encodeStreams === void 0) encodeStreams = true;
        if (objectsPerStream === void 0) objectsPerStream = 50;
        return new PDFStreamWriter(context, objectsPerTick, encodeStreams, objectsPerStream);
    };
    return PDFStreamWriter;
}((0, $5HlMk.default));
var $5cd89dbe12e59987$export$2e2bcd8739ae039 = $5cd89dbe12e59987$var$PDFStreamWriter;

});
parcelRegister("eTWtL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad9390730b9495a5$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $11c5J = parcelRequire("11c5J");
var $ad9390730b9495a5$var$PDFInvalidObject = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFInvalidObject, _super);
    function PDFInvalidObject(data) {
        var _this = _super.call(this) || this;
        _this.data = data;
        return _this;
    }
    PDFInvalidObject.prototype.clone = function() {
        return PDFInvalidObject.of(this.data.slice());
    };
    PDFInvalidObject.prototype.toString = function() {
        return "PDFInvalidObject(" + this.data.length + " bytes)";
    };
    PDFInvalidObject.prototype.sizeInBytes = function() {
        return this.data.length;
    };
    PDFInvalidObject.prototype.copyBytesInto = function(buffer, offset) {
        var length = this.data.length;
        for(var idx = 0; idx < length; idx++)buffer[offset++] = this.data[idx];
        return length;
    };
    PDFInvalidObject.of = function(data) {
        return new PDFInvalidObject(data);
    };
    return PDFInvalidObject;
}((0, $11c5J.default));
var $ad9390730b9495a5$export$2e2bcd8739ae039 = $ad9390730b9495a5$var$PDFInvalidObject;

});

parcelRegister("eMjAF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac24be9f2612b58f$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $dPHSK = parcelRequire("dPHSK");

var $kHzkO = parcelRequire("kHzkO");

var $3T8kK = parcelRequire("3T8kK");
parcelRequire("fvYKZ");
var $hiEdU = parcelRequire("hiEdU");
var $clYSv = parcelRequire("clYSv");
var $4ISq8 = parcelRequire("4ISq8");
var $ac24be9f2612b58f$export$e41c32906b33062a;
(function(EntryType) {
    EntryType[EntryType["Deleted"] = 0] = "Deleted";
    EntryType[EntryType["Uncompressed"] = 1] = "Uncompressed";
    EntryType[EntryType["Compressed"] = 2] = "Compressed";
})($ac24be9f2612b58f$export$e41c32906b33062a || ($ac24be9f2612b58f$export$e41c32906b33062a = {}));
/**
 * Entries should be added using the [[addDeletedEntry]],
 * [[addUncompressedEntry]], and [[addCompressedEntry]] methods
 * **in order of ascending object number**.
 */ var $ac24be9f2612b58f$var$PDFCrossRefStream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFCrossRefStream, _super);
    function PDFCrossRefStream(dict, entries, encode) {
        if (encode === void 0) encode = true;
        var _this = _super.call(this, dict, encode) || this;
        // Returns an array of integer pairs for each subsection of the cross ref
        // section, where each integer pair represents:
        //   firstObjectNumber(OfSection), length(OfSection)
        _this.computeIndex = function() {
            var subsections = [];
            var subsectionLength = 0;
            for(var idx = 0, len = _this.entries.length; idx < len; idx++){
                var currEntry = _this.entries[idx];
                var prevEntry = _this.entries[idx - 1];
                if (idx === 0) subsections.push(currEntry.ref.objectNumber);
                else if (currEntry.ref.objectNumber - prevEntry.ref.objectNumber > 1) {
                    subsections.push(subsectionLength);
                    subsections.push(currEntry.ref.objectNumber);
                    subsectionLength = 0;
                }
                subsectionLength += 1;
            }
            subsections.push(subsectionLength);
            return subsections;
        };
        _this.computeEntryTuples = function() {
            var entryTuples = new Array(_this.entries.length);
            for(var idx = 0, len = _this.entries.length; idx < len; idx++){
                var entry = _this.entries[idx];
                if (entry.type === $ac24be9f2612b58f$export$e41c32906b33062a.Deleted) {
                    var type = entry.type, nextFreeObjectNumber = entry.nextFreeObjectNumber, ref = entry.ref;
                    entryTuples[idx] = [
                        type,
                        nextFreeObjectNumber,
                        ref.generationNumber
                    ];
                }
                if (entry.type === $ac24be9f2612b58f$export$e41c32906b33062a.Uncompressed) {
                    var type = entry.type, offset = entry.offset, ref = entry.ref;
                    entryTuples[idx] = [
                        type,
                        offset,
                        ref.generationNumber
                    ];
                }
                if (entry.type === $ac24be9f2612b58f$export$e41c32906b33062a.Compressed) {
                    var type = entry.type, objectStreamRef = entry.objectStreamRef, index = entry.index;
                    entryTuples[idx] = [
                        type,
                        objectStreamRef.objectNumber,
                        index
                    ];
                }
            }
            return entryTuples;
        };
        _this.computeMaxEntryByteWidths = function() {
            var entryTuples = _this.entryTuplesCache.access();
            var widths = [
                0,
                0,
                0
            ];
            for(var idx = 0, len = entryTuples.length; idx < len; idx++){
                var _a = entryTuples[idx], first = _a[0], second = _a[1], third = _a[2];
                var firstSize = (0, $hiEdU.sizeInBytes)(first);
                var secondSize = (0, $hiEdU.sizeInBytes)(second);
                var thirdSize = (0, $hiEdU.sizeInBytes)(third);
                if (firstSize > widths[0]) widths[0] = firstSize;
                if (secondSize > widths[1]) widths[1] = secondSize;
                if (thirdSize > widths[2]) widths[2] = thirdSize;
            }
            return widths;
        };
        _this.entries = entries || [];
        _this.entryTuplesCache = (0, $clYSv.default).populatedBy(_this.computeEntryTuples);
        _this.maxByteWidthsCache = (0, $clYSv.default).populatedBy(_this.computeMaxEntryByteWidths);
        _this.indexCache = (0, $clYSv.default).populatedBy(_this.computeIndex);
        dict.set((0, $dPHSK.default).of('Type'), (0, $dPHSK.default).of('XRef'));
        return _this;
    }
    PDFCrossRefStream.prototype.addDeletedEntry = function(ref, nextFreeObjectNumber) {
        var type = $ac24be9f2612b58f$export$e41c32906b33062a.Deleted;
        this.entries.push({
            type: type,
            ref: ref,
            nextFreeObjectNumber: nextFreeObjectNumber
        });
        this.entryTuplesCache.invalidate();
        this.maxByteWidthsCache.invalidate();
        this.indexCache.invalidate();
        this.contentsCache.invalidate();
    };
    PDFCrossRefStream.prototype.addUncompressedEntry = function(ref, offset) {
        var type = $ac24be9f2612b58f$export$e41c32906b33062a.Uncompressed;
        this.entries.push({
            type: type,
            ref: ref,
            offset: offset
        });
        this.entryTuplesCache.invalidate();
        this.maxByteWidthsCache.invalidate();
        this.indexCache.invalidate();
        this.contentsCache.invalidate();
    };
    PDFCrossRefStream.prototype.addCompressedEntry = function(ref, objectStreamRef, index) {
        var type = $ac24be9f2612b58f$export$e41c32906b33062a.Compressed;
        this.entries.push({
            type: type,
            ref: ref,
            objectStreamRef: objectStreamRef,
            index: index
        });
        this.entryTuplesCache.invalidate();
        this.maxByteWidthsCache.invalidate();
        this.indexCache.invalidate();
        this.contentsCache.invalidate();
    };
    PDFCrossRefStream.prototype.clone = function(context) {
        var _a = this, dict = _a.dict, entries = _a.entries, encode = _a.encode;
        return PDFCrossRefStream.of(dict.clone(context), entries.slice(), encode);
    };
    PDFCrossRefStream.prototype.getContentsString = function() {
        var entryTuples = this.entryTuplesCache.access();
        var byteWidths = this.maxByteWidthsCache.access();
        var value = '';
        for(var entryIdx = 0, entriesLen = entryTuples.length; entryIdx < entriesLen; entryIdx++){
            var _a = entryTuples[entryIdx], first = _a[0], second = _a[1], third = _a[2];
            var firstBytes = (0, $4ISq8.reverseArray)((0, $hiEdU.bytesFor)(first));
            var secondBytes = (0, $4ISq8.reverseArray)((0, $hiEdU.bytesFor)(second));
            var thirdBytes = (0, $4ISq8.reverseArray)((0, $hiEdU.bytesFor)(third));
            for(var idx = byteWidths[0] - 1; idx >= 0; idx--)value += (firstBytes[idx] || 0).toString(2);
            for(var idx = byteWidths[1] - 1; idx >= 0; idx--)value += (secondBytes[idx] || 0).toString(2);
            for(var idx = byteWidths[2] - 1; idx >= 0; idx--)value += (thirdBytes[idx] || 0).toString(2);
        }
        return value;
    };
    PDFCrossRefStream.prototype.getUnencodedContents = function() {
        var entryTuples = this.entryTuplesCache.access();
        var byteWidths = this.maxByteWidthsCache.access();
        var buffer = new Uint8Array(this.getUnencodedContentsSize());
        var offset = 0;
        for(var entryIdx = 0, entriesLen = entryTuples.length; entryIdx < entriesLen; entryIdx++){
            var _a = entryTuples[entryIdx], first = _a[0], second = _a[1], third = _a[2];
            var firstBytes = (0, $4ISq8.reverseArray)((0, $hiEdU.bytesFor)(first));
            var secondBytes = (0, $4ISq8.reverseArray)((0, $hiEdU.bytesFor)(second));
            var thirdBytes = (0, $4ISq8.reverseArray)((0, $hiEdU.bytesFor)(third));
            for(var idx = byteWidths[0] - 1; idx >= 0; idx--)buffer[offset++] = firstBytes[idx] || 0;
            for(var idx = byteWidths[1] - 1; idx >= 0; idx--)buffer[offset++] = secondBytes[idx] || 0;
            for(var idx = byteWidths[2] - 1; idx >= 0; idx--)buffer[offset++] = thirdBytes[idx] || 0;
        }
        return buffer;
    };
    PDFCrossRefStream.prototype.getUnencodedContentsSize = function() {
        var byteWidths = this.maxByteWidthsCache.access();
        var entryWidth = (0, $4ISq8.sum)(byteWidths);
        return entryWidth * this.entries.length;
    };
    PDFCrossRefStream.prototype.updateDict = function() {
        _super.prototype.updateDict.call(this);
        var byteWidths = this.maxByteWidthsCache.access();
        var index = this.indexCache.access();
        var context = this.dict.context;
        this.dict.set((0, $dPHSK.default).of('W'), context.obj(byteWidths));
        this.dict.set((0, $dPHSK.default).of('Index'), context.obj(index));
    };
    PDFCrossRefStream.create = function(dict, encode) {
        if (encode === void 0) encode = true;
        var stream = new PDFCrossRefStream(dict, [], encode);
        stream.addDeletedEntry((0, $kHzkO.default).of(0, 65535), 0);
        return stream;
    };
    PDFCrossRefStream.of = function(dict, entries, encode) {
        if (encode === void 0) encode = true;
        return new PDFCrossRefStream(dict, entries, encode);
    };
    return PDFCrossRefStream;
}((0, $3T8kK.default));
var $ac24be9f2612b58f$export$2e2bcd8739ae039 = $ac24be9f2612b58f$var$PDFCrossRefStream;

});


parcelRegister("jwvE5", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3698d9fec5e57b0$export$2e2bcd8739ae039);
parcelRequire("eNCdi");
var $90iSP = parcelRequire("90iSP");
var $kkdJe = parcelRequire("kkdJe");

var $jWFiV = parcelRequire("jWFiV");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/foliojs/pdfkit/blob/f91bdd61c164a72ea06be1a43dc0a412afc3925f/lib/font/afm.coffee
 */ var $e3698d9fec5e57b0$var$StandardFontEmbedder = /** @class */ function() {
    function StandardFontEmbedder(fontName, customName) {
        // prettier-ignore
        this.encoding = fontName === (0, $kkdJe.FontNames).ZapfDingbats ? (0, $90iSP.Encodings).ZapfDingbats : fontName === (0, $kkdJe.FontNames).Symbol ? (0, $90iSP.Encodings).Symbol : (0, $90iSP.Encodings).WinAnsi;
        this.font = (0, $kkdJe.Font).load(fontName);
        this.fontName = this.font.FontName;
        this.customName = customName;
    }
    /**
     * Encode the JavaScript string into this font. (JavaScript encodes strings in
     * Unicode, but standard fonts use either WinAnsi, ZapfDingbats, or Symbol
     * encodings)
     */ StandardFontEmbedder.prototype.encodeText = function(text) {
        var glyphs = this.encodeTextAsGlyphs(text);
        var hexCodes = new Array(glyphs.length);
        for(var idx = 0, len = glyphs.length; idx < len; idx++)hexCodes[idx] = (0, $7Kmy8.toHexString)(glyphs[idx].code);
        return (0, $jWFiV.default).of(hexCodes.join(''));
    };
    StandardFontEmbedder.prototype.widthOfTextAtSize = function(text, size) {
        var glyphs = this.encodeTextAsGlyphs(text);
        var totalWidth = 0;
        for(var idx = 0, len = glyphs.length; idx < len; idx++){
            var left = glyphs[idx].name;
            var right = (glyphs[idx + 1] || {}).name;
            var kernAmount = this.font.getXAxisKerningForPair(left, right) || 0;
            totalWidth += this.widthOfGlyph(left) + kernAmount;
        }
        var scale = size / 1000;
        return totalWidth * scale;
    };
    StandardFontEmbedder.prototype.heightOfFontAtSize = function(size, options) {
        if (options === void 0) options = {};
        var _a = options.descender, descender = _a === void 0 ? true : _a;
        var _b = this.font, Ascender = _b.Ascender, Descender = _b.Descender, FontBBox = _b.FontBBox;
        var yTop = Ascender || FontBBox[3];
        var yBottom = Descender || FontBBox[1];
        var height = yTop - yBottom;
        if (!descender) height += Descender || 0;
        return height / 1000 * size;
    };
    StandardFontEmbedder.prototype.sizeOfFontAtHeight = function(height) {
        var _a = this.font, Ascender = _a.Ascender, Descender = _a.Descender, FontBBox = _a.FontBBox;
        var yTop = Ascender || FontBBox[3];
        var yBottom = Descender || FontBBox[1];
        return 1000 * height / (yTop - yBottom);
    };
    StandardFontEmbedder.prototype.embedIntoContext = function(context, ref) {
        var fontDict = context.obj({
            Type: 'Font',
            Subtype: 'Type1',
            BaseFont: this.customName || this.fontName,
            Encoding: this.encoding === (0, $90iSP.Encodings).WinAnsi ? 'WinAnsiEncoding' : undefined
        });
        if (ref) {
            context.assign(ref, fontDict);
            return ref;
        } else return context.register(fontDict);
    };
    StandardFontEmbedder.prototype.widthOfGlyph = function(glyphName) {
        // Default to 250 if font doesn't specify a width
        return this.font.getWidthOfGlyph(glyphName) || 250;
    };
    StandardFontEmbedder.prototype.encodeTextAsGlyphs = function(text) {
        var codePoints = Array.from(text);
        var glyphs = new Array(codePoints.length);
        for(var idx = 0, len = codePoints.length; idx < len; idx++){
            var codePoint = (0, $7Kmy8.toCodePoint)(codePoints[idx]);
            glyphs[idx] = this.encoding.encodeUnicodeCodePoint(codePoint);
        }
        return glyphs;
    };
    StandardFontEmbedder.for = function(fontName, customName) {
        return new StandardFontEmbedder(fontName, customName);
    };
    return StandardFontEmbedder;
}();
var $e3698d9fec5e57b0$export$2e2bcd8739ae039 = $e3698d9fec5e57b0$var$StandardFontEmbedder;

});
parcelRegister("jWFiV", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8537943f4279a06$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $11c5J = parcelRequire("11c5J");

var $8zvel = parcelRequire("8zvel");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $ejAvl = parcelRequire("ejAvl");
var $iSBb0 = parcelRequire("iSBb0");

var $nAWRe = parcelRequire("nAWRe");
var $e8537943f4279a06$var$PDFHexString = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFHexString, _super);
    function PDFHexString(value) {
        var _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    PDFHexString.prototype.asBytes = function() {
        // Append a zero if the number of digits is odd. See PDF spec 7.3.4.3
        var hex = this.value + (this.value.length % 2 === 1 ? '0' : '');
        var hexLength = hex.length;
        var bytes = new Uint8Array(hex.length / 2);
        var hexOffset = 0;
        var bytesOffset = 0;
        // Interpret each pair of hex digits as a single byte
        while(hexOffset < hexLength){
            var byte = parseInt(hex.substring(hexOffset, hexOffset + 2), 16);
            bytes[bytesOffset] = byte;
            hexOffset += 2;
            bytesOffset += 1;
        }
        return bytes;
    };
    PDFHexString.prototype.decodeText = function() {
        var bytes = this.asBytes();
        if ((0, $ejAvl.hasUtf16BOM)(bytes)) return (0, $ejAvl.utf16Decode)(bytes);
        return (0, $iSBb0.pdfDocEncodingDecode)(bytes);
    };
    PDFHexString.prototype.decodeDate = function() {
        var text = this.decodeText();
        var date = (0, $7Kmy8.parseDate)(text);
        if (!date) throw new (0, $nAWRe.InvalidPDFDateStringError)(text);
        return date;
    };
    PDFHexString.prototype.asString = function() {
        return this.value;
    };
    PDFHexString.prototype.clone = function() {
        return PDFHexString.of(this.value);
    };
    PDFHexString.prototype.toString = function() {
        return "<" + this.value + ">";
    };
    PDFHexString.prototype.sizeInBytes = function() {
        return this.value.length + 2;
    };
    PDFHexString.prototype.copyBytesInto = function(buffer, offset) {
        buffer[offset++] = (0, $8zvel.default).LessThan;
        offset += (0, $7Kmy8.copyStringIntoBuffer)(this.value, buffer, offset);
        buffer[offset++] = (0, $8zvel.default).GreaterThan;
        return this.value.length + 2;
    };
    PDFHexString.of = function(value) {
        return new PDFHexString(value);
    };
    PDFHexString.fromText = function(value) {
        var encoded = (0, $ejAvl.utf16Encode)(value);
        var hex = '';
        for(var idx = 0, len = encoded.length; idx < len; idx++)hex += (0, $7Kmy8.toHexStringOfMinLength)(encoded[idx], 4);
        return new PDFHexString(hex);
    };
    return PDFHexString;
}((0, $11c5J.default));
var $e8537943f4279a06$export$2e2bcd8739ae039 = $e8537943f4279a06$var$PDFHexString;

});


parcelRegister("gCJZ9", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1a3ddaa0f08fc18$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $ckCcM = parcelRequire("ckCcM");

var $9XzjW = parcelRequire("9XzjW");

var $jWFiV = parcelRequire("jWFiV");

var $8dCYu = parcelRequire("8dCYu");
parcelRequire("fvYKZ");
var $4ISq8 = parcelRequire("4ISq8");
var $clYSv = parcelRequire("clYSv");
var $7Kmy8 = parcelRequire("7Kmy8");
/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/devongovett/pdfkit/blob/e71edab0dd4657b5a767804ba86c94c58d01fbca/lib/image/jpeg.coffee
 */ var $c1a3ddaa0f08fc18$var$CustomFontEmbedder = /** @class */ function() {
    function CustomFontEmbedder(font, fontData, customName, fontFeatures) {
        var _this = this;
        this.allGlyphsInFontSortedById = function() {
            var glyphs = new Array(_this.font.characterSet.length);
            for(var idx = 0, len = glyphs.length; idx < len; idx++){
                var codePoint = _this.font.characterSet[idx];
                glyphs[idx] = _this.font.glyphForCodePoint(codePoint);
            }
            return (0, $4ISq8.sortedUniq)(glyphs.sort((0, $4ISq8.byAscendingId)), function(g) {
                return g.id;
            });
        };
        this.font = font;
        this.scale = 1000 / this.font.unitsPerEm;
        this.fontData = fontData;
        this.fontName = this.font.postscriptName || 'Font';
        this.customName = customName;
        this.fontFeatures = fontFeatures;
        this.baseFontName = '';
        this.glyphCache = (0, $clYSv.default).populatedBy(this.allGlyphsInFontSortedById);
    }
    CustomFontEmbedder.for = function(fontkit, fontData, customName, fontFeatures) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var font;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            fontkit.create(fontData)
                        ];
                    case 1:
                        font = _a.sent();
                        return [
                            2 /*return*/ ,
                            new CustomFontEmbedder(font, fontData, customName, fontFeatures)
                        ];
                }
            });
        });
    };
    /**
     * Encode the JavaScript string into this font. (JavaScript encodes strings in
     * Unicode, but embedded fonts use their own custom encodings)
     */ CustomFontEmbedder.prototype.encodeText = function(text) {
        var glyphs = this.font.layout(text, this.fontFeatures).glyphs;
        var hexCodes = new Array(glyphs.length);
        for(var idx = 0, len = glyphs.length; idx < len; idx++)hexCodes[idx] = (0, $7Kmy8.toHexStringOfMinLength)(glyphs[idx].id, 4);
        return (0, $jWFiV.default).of(hexCodes.join(''));
    };
    // The advanceWidth takes into account kerning automatically, so we don't
    // have to do that manually like we do for the standard fonts.
    CustomFontEmbedder.prototype.widthOfTextAtSize = function(text, size) {
        var glyphs = this.font.layout(text, this.fontFeatures).glyphs;
        var totalWidth = 0;
        for(var idx = 0, len = glyphs.length; idx < len; idx++)totalWidth += glyphs[idx].advanceWidth * this.scale;
        var scale = size / 1000;
        return totalWidth * scale;
    };
    CustomFontEmbedder.prototype.heightOfFontAtSize = function(size, options) {
        if (options === void 0) options = {};
        var _a = options.descender, descender = _a === void 0 ? true : _a;
        var _b = this.font, ascent = _b.ascent, descent = _b.descent, bbox = _b.bbox;
        var yTop = (ascent || bbox.maxY) * this.scale;
        var yBottom = (descent || bbox.minY) * this.scale;
        var height = yTop - yBottom;
        if (!descender) height -= Math.abs(descent) || 0;
        return height / 1000 * size;
    };
    CustomFontEmbedder.prototype.sizeOfFontAtHeight = function(height) {
        var _a = this.font, ascent = _a.ascent, descent = _a.descent, bbox = _a.bbox;
        var yTop = (ascent || bbox.maxY) * this.scale;
        var yBottom = (descent || bbox.minY) * this.scale;
        return 1000 * height / (yTop - yBottom);
    };
    CustomFontEmbedder.prototype.embedIntoContext = function(context, ref) {
        this.baseFontName = this.customName || context.addRandomSuffix(this.fontName);
        return this.embedFontDict(context, ref);
    };
    CustomFontEmbedder.prototype.embedFontDict = function(context, ref) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var cidFontDictRef, unicodeCMapRef, fontDict;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.embedCIDFontDict(context)
                        ];
                    case 1:
                        cidFontDictRef = _a.sent();
                        unicodeCMapRef = this.embedUnicodeCmap(context);
                        fontDict = context.obj({
                            Type: 'Font',
                            Subtype: 'Type0',
                            BaseFont: this.baseFontName,
                            Encoding: 'Identity-H',
                            DescendantFonts: [
                                cidFontDictRef
                            ],
                            ToUnicode: unicodeCMapRef
                        });
                        if (ref) {
                            context.assign(ref, fontDict);
                            return [
                                2 /*return*/ ,
                                ref
                            ];
                        } else return [
                            2 /*return*/ ,
                            context.register(fontDict)
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CustomFontEmbedder.prototype.isCFF = function() {
        return this.font.cff;
    };
    CustomFontEmbedder.prototype.embedCIDFontDict = function(context) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var fontDescriptorRef, cidFontDict;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.embedFontDescriptor(context)
                        ];
                    case 1:
                        fontDescriptorRef = _a.sent();
                        cidFontDict = context.obj({
                            Type: 'Font',
                            Subtype: this.isCFF() ? 'CIDFontType0' : 'CIDFontType2',
                            CIDToGIDMap: 'Identity',
                            BaseFont: this.baseFontName,
                            CIDSystemInfo: {
                                Registry: (0, $8dCYu.default).of('Adobe'),
                                Ordering: (0, $8dCYu.default).of('Identity'),
                                Supplement: 0
                            },
                            FontDescriptor: fontDescriptorRef,
                            W: this.computeWidths()
                        });
                        return [
                            2 /*return*/ ,
                            context.register(cidFontDict)
                        ];
                }
            });
        });
    };
    CustomFontEmbedder.prototype.embedFontDescriptor = function(context) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var fontStreamRef, scale, _a, italicAngle, ascent, descent, capHeight, xHeight, _b, minX, minY, maxX, maxY, fontDescriptor;
            var _c;
            return (0, $cOQTW.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.embedFontStream(context)
                        ];
                    case 1:
                        fontStreamRef = _d.sent();
                        scale = this.scale;
                        _a = this.font, italicAngle = _a.italicAngle, ascent = _a.ascent, descent = _a.descent, capHeight = _a.capHeight, xHeight = _a.xHeight;
                        _b = this.font.bbox, minX = _b.minX, minY = _b.minY, maxX = _b.maxX, maxY = _b.maxY;
                        fontDescriptor = context.obj((_c = {
                            Type: 'FontDescriptor',
                            FontName: this.baseFontName,
                            Flags: (0, $9XzjW.deriveFontFlags)(this.font),
                            FontBBox: [
                                minX * scale,
                                minY * scale,
                                maxX * scale,
                                maxY * scale
                            ],
                            ItalicAngle: italicAngle,
                            Ascent: ascent * scale,
                            Descent: descent * scale,
                            CapHeight: (capHeight || ascent) * scale,
                            XHeight: (xHeight || 0) * scale,
                            // Not sure how to compute/find this, nor is anybody else really:
                            // https://stackoverflow.com/questions/35485179/stemv-value-of-the-truetype-font
                            StemV: 0
                        }, _c[this.isCFF() ? 'FontFile3' : 'FontFile2'] = fontStreamRef, _c));
                        return [
                            2 /*return*/ ,
                            context.register(fontDescriptor)
                        ];
                }
            });
        });
    };
    CustomFontEmbedder.prototype.serializeFont = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            return (0, $cOQTW.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.fontData
                ];
            });
        });
    };
    CustomFontEmbedder.prototype.embedFontStream = function(context) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var fontStream, _a, _b;
            return (0, $cOQTW.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _b = (_a = context).flateStream;
                        return [
                            4 /*yield*/ ,
                            this.serializeFont()
                        ];
                    case 1:
                        fontStream = _b.apply(_a, [
                            _c.sent(),
                            {
                                Subtype: this.isCFF() ? 'CIDFontType0C' : undefined
                            }
                        ]);
                        return [
                            2 /*return*/ ,
                            context.register(fontStream)
                        ];
                }
            });
        });
    };
    CustomFontEmbedder.prototype.embedUnicodeCmap = function(context) {
        var cmap = (0, $ckCcM.createCmap)(this.glyphCache.access(), this.glyphId.bind(this));
        var cmapStream = context.flateStream(cmap);
        return context.register(cmapStream);
    };
    CustomFontEmbedder.prototype.glyphId = function(glyph) {
        return glyph ? glyph.id : -1;
    };
    CustomFontEmbedder.prototype.computeWidths = function() {
        var glyphs = this.glyphCache.access();
        var widths = [];
        var currSection = [];
        for(var idx = 0, len = glyphs.length; idx < len; idx++){
            var currGlyph = glyphs[idx];
            var prevGlyph = glyphs[idx - 1];
            var currGlyphId = this.glyphId(currGlyph);
            var prevGlyphId = this.glyphId(prevGlyph);
            if (idx === 0) widths.push(currGlyphId);
            else if (currGlyphId - prevGlyphId !== 1) {
                widths.push(currSection);
                widths.push(currGlyphId);
                currSection = [];
            }
            currSection.push(currGlyph.advanceWidth * this.scale);
        }
        widths.push(currSection);
        return widths;
    };
    return CustomFontEmbedder;
}();
var $c1a3ddaa0f08fc18$export$2e2bcd8739ae039 = $c1a3ddaa0f08fc18$var$CustomFontEmbedder;

});
parcelRegister("ckCcM", function(module, exports) {

$parcel$export(module.exports, "createCmap", () => $8fa4fd029ce650b8$export$ecb273704ecc155f);
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");

var $ejAvl = parcelRequire("ejAvl");
var $8fa4fd029ce650b8$export$ecb273704ecc155f = function(glyphs, glyphId) {
    var bfChars = new Array(glyphs.length);
    for(var idx = 0, len = glyphs.length; idx < len; idx++){
        var glyph = glyphs[idx];
        var id = $8fa4fd029ce650b8$var$cmapHexFormat($8fa4fd029ce650b8$var$cmapHexString(glyphId(glyph)));
        var unicode = $8fa4fd029ce650b8$var$cmapHexFormat.apply(void 0, glyph.codePoints.map($8fa4fd029ce650b8$var$cmapCodePointFormat));
        bfChars[idx] = [
            id,
            unicode
        ];
    }
    return $8fa4fd029ce650b8$var$fillCmapTemplate(bfChars);
};
/* =============================== Templates ================================ */ var $8fa4fd029ce650b8$var$fillCmapTemplate = function(bfChars) {
    return "/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange\n" + bfChars.length + " beginbfchar\n" + bfChars.map(function(_a) {
        var glyphId = _a[0], codePoint = _a[1];
        return glyphId + " " + codePoint;
    }).join('\n') + "\nendbfchar\nendcmap\nCMapName currentdict /CMap defineresource pop\nend\nend";
};
/* =============================== Utilities ================================ */ var $8fa4fd029ce650b8$var$cmapHexFormat = function() {
    var values = [];
    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
    return "<" + values.join('') + ">";
};
var $8fa4fd029ce650b8$var$cmapHexString = function(value) {
    return (0, $7Kmy8.toHexStringOfMinLength)(value, 4);
};
var $8fa4fd029ce650b8$var$cmapCodePointFormat = function(codePoint) {
    if ((0, $ejAvl.isWithinBMP)(codePoint)) return $8fa4fd029ce650b8$var$cmapHexString(codePoint);
    if ((0, $ejAvl.hasSurrogates)(codePoint)) {
        var hs = (0, $ejAvl.highSurrogate)(codePoint);
        var ls = (0, $ejAvl.lowSurrogate)(codePoint);
        return "" + $8fa4fd029ce650b8$var$cmapHexString(hs) + $8fa4fd029ce650b8$var$cmapHexString(ls);
    }
    var hex = (0, $7Kmy8.toHexString)(codePoint);
    var msg = "0x" + hex + " is not a valid UTF-8 or UTF-16 codepoint.";
    throw new Error(msg);
};

});

parcelRegister("9XzjW", function(module, exports) {

$parcel$export(module.exports, "deriveFontFlags", () => $740505aae0fb9700$export$aa92af1a056b24e8);
// prettier-ignore
var $740505aae0fb9700$var$makeFontFlags = function(options) {
    var flags = 0;
    var flipBit = function(bit) {
        flags |= 1 << bit - 1;
    };
    if (options.fixedPitch) flipBit(1);
    if (options.serif) flipBit(2);
    if (options.symbolic) flipBit(3);
    if (options.script) flipBit(4);
    if (options.nonsymbolic) flipBit(6);
    if (options.italic) flipBit(7);
    if (options.allCap) flipBit(17);
    if (options.smallCap) flipBit(18);
    if (options.forceBold) flipBit(19);
    return flags;
};
var $740505aae0fb9700$export$aa92af1a056b24e8 = function(font) {
    var familyClass = font['OS/2'] ? font['OS/2'].sFamilyClass : 0;
    var flags = $740505aae0fb9700$var$makeFontFlags({
        fixedPitch: font.post.isFixedPitch,
        serif: 1 <= familyClass && familyClass <= 7,
        symbolic: true,
        script: familyClass === 10,
        italic: font.head.macStyle.italic
    });
    return flags;
};

});

parcelRegister("8dCYu", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fbdc5307b6362f1$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $11c5J = parcelRequire("11c5J");

var $8zvel = parcelRequire("8zvel");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $ejAvl = parcelRequire("ejAvl");
var $iSBb0 = parcelRequire("iSBb0");

var $nAWRe = parcelRequire("nAWRe");
var $5fbdc5307b6362f1$var$PDFString = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFString, _super);
    function PDFString(value) {
        var _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    PDFString.prototype.asBytes = function() {
        var bytes = [];
        var octal = '';
        var escaped = false;
        var pushByte = function(byte) {
            if (byte !== undefined) bytes.push(byte);
            escaped = false;
        };
        for(var idx = 0, len = this.value.length; idx < len; idx++){
            var char = this.value[idx];
            var byte = (0, $7Kmy8.toCharCode)(char);
            var nextChar = this.value[idx + 1];
            if (!escaped) {
                if (byte === (0, $8zvel.default).BackSlash) escaped = true;
                else pushByte(byte);
            } else {
                if (byte === (0, $8zvel.default).Newline) pushByte();
                else if (byte === (0, $8zvel.default).CarriageReturn) pushByte();
                else if (byte === (0, $8zvel.default).n) pushByte((0, $8zvel.default).Newline);
                else if (byte === (0, $8zvel.default).r) pushByte((0, $8zvel.default).CarriageReturn);
                else if (byte === (0, $8zvel.default).t) pushByte((0, $8zvel.default).Tab);
                else if (byte === (0, $8zvel.default).b) pushByte((0, $8zvel.default).Backspace);
                else if (byte === (0, $8zvel.default).f) pushByte((0, $8zvel.default).FormFeed);
                else if (byte === (0, $8zvel.default).LeftParen) pushByte((0, $8zvel.default).LeftParen);
                else if (byte === (0, $8zvel.default).RightParen) pushByte((0, $8zvel.default).RightParen);
                else if (byte === (0, $8zvel.default).Backspace) pushByte((0, $8zvel.default).BackSlash);
                else if (byte >= (0, $8zvel.default).Zero && byte <= (0, $8zvel.default).Seven) {
                    octal += char;
                    if (octal.length === 3 || !(nextChar >= '0' && nextChar <= '7')) {
                        pushByte(parseInt(octal, 8));
                        octal = '';
                    }
                } else pushByte(byte);
            }
        }
        return new Uint8Array(bytes);
    };
    PDFString.prototype.decodeText = function() {
        var bytes = this.asBytes();
        if ((0, $ejAvl.hasUtf16BOM)(bytes)) return (0, $ejAvl.utf16Decode)(bytes);
        return (0, $iSBb0.pdfDocEncodingDecode)(bytes);
    };
    PDFString.prototype.decodeDate = function() {
        var text = this.decodeText();
        var date = (0, $7Kmy8.parseDate)(text);
        if (!date) throw new (0, $nAWRe.InvalidPDFDateStringError)(text);
        return date;
    };
    PDFString.prototype.asString = function() {
        return this.value;
    };
    PDFString.prototype.clone = function() {
        return PDFString.of(this.value);
    };
    PDFString.prototype.toString = function() {
        return "(" + this.value + ")";
    };
    PDFString.prototype.sizeInBytes = function() {
        return this.value.length + 2;
    };
    PDFString.prototype.copyBytesInto = function(buffer, offset) {
        buffer[offset++] = (0, $8zvel.default).LeftParen;
        offset += (0, $7Kmy8.copyStringIntoBuffer)(this.value, buffer, offset);
        buffer[offset++] = (0, $8zvel.default).RightParen;
        return this.value.length + 2;
    };
    // The PDF spec allows newlines and parens to appear directly within a literal
    // string. These character _may_ be escaped. But they do not _have_ to be. So
    // for simplicity, we will not bother escaping them.
    PDFString.of = function(value) {
        return new PDFString(value);
    };
    PDFString.fromDate = function(date) {
        var year = (0, $7Kmy8.padStart)(String(date.getUTCFullYear()), 4, '0');
        var month = (0, $7Kmy8.padStart)(String(date.getUTCMonth() + 1), 2, '0');
        var day = (0, $7Kmy8.padStart)(String(date.getUTCDate()), 2, '0');
        var hours = (0, $7Kmy8.padStart)(String(date.getUTCHours()), 2, '0');
        var mins = (0, $7Kmy8.padStart)(String(date.getUTCMinutes()), 2, '0');
        var secs = (0, $7Kmy8.padStart)(String(date.getUTCSeconds()), 2, '0');
        return new PDFString("D:" + year + month + day + hours + mins + secs + "Z");
    };
    return PDFString;
}((0, $11c5J.default));
var $5fbdc5307b6362f1$export$2e2bcd8739ae039 = $5fbdc5307b6362f1$var$PDFString;

});


parcelRegister("6uXKX", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bb3e5ce3694dd68$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $gCJZ9 = parcelRequire("gCJZ9");

var $jWFiV = parcelRequire("jWFiV");
parcelRequire("fvYKZ");
var $clYSv = parcelRequire("clYSv");
var $4ISq8 = parcelRequire("4ISq8");
var $7Kmy8 = parcelRequire("7Kmy8");
/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/devongovett/pdfkit/blob/e71edab0dd4657b5a767804ba86c94c58d01fbca/lib/image/jpeg.coffee
 */ var $4bb3e5ce3694dd68$var$CustomFontSubsetEmbedder = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(CustomFontSubsetEmbedder, _super);
    function CustomFontSubsetEmbedder(font, fontData, customFontName, fontFeatures) {
        var _this = _super.call(this, font, fontData, customFontName, fontFeatures) || this;
        _this.subset = _this.font.createSubset();
        _this.glyphs = [];
        _this.glyphCache = (0, $clYSv.default).populatedBy(function() {
            return _this.glyphs;
        });
        _this.glyphIdMap = new Map();
        return _this;
    }
    CustomFontSubsetEmbedder.for = function(fontkit, fontData, customFontName, fontFeatures) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var font;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            fontkit.create(fontData)
                        ];
                    case 1:
                        font = _a.sent();
                        return [
                            2 /*return*/ ,
                            new CustomFontSubsetEmbedder(font, fontData, customFontName, fontFeatures)
                        ];
                }
            });
        });
    };
    CustomFontSubsetEmbedder.prototype.encodeText = function(text) {
        var glyphs = this.font.layout(text, this.fontFeatures).glyphs;
        var hexCodes = new Array(glyphs.length);
        for(var idx = 0, len = glyphs.length; idx < len; idx++){
            var glyph = glyphs[idx];
            var subsetGlyphId = this.subset.includeGlyph(glyph);
            this.glyphs[subsetGlyphId - 1] = glyph;
            this.glyphIdMap.set(glyph.id, subsetGlyphId);
            hexCodes[idx] = (0, $7Kmy8.toHexStringOfMinLength)(subsetGlyphId, 4);
        }
        this.glyphCache.invalidate();
        return (0, $jWFiV.default).of(hexCodes.join(''));
    };
    CustomFontSubsetEmbedder.prototype.isCFF = function() {
        return this.subset.cff;
    };
    CustomFontSubsetEmbedder.prototype.glyphId = function(glyph) {
        return glyph ? this.glyphIdMap.get(glyph.id) : -1;
    };
    CustomFontSubsetEmbedder.prototype.serializeFont = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var parts = [];
            _this.subset.encodeStream().on('data', function(bytes) {
                return parts.push(bytes);
            }).on('end', function() {
                return resolve((0, $4ISq8.mergeUint8Arrays)(parts));
            }).on('error', function(err) {
                return reject(err);
            });
        });
    };
    return CustomFontSubsetEmbedder;
}((0, $gCJZ9.default));
var $4bb3e5ce3694dd68$export$2e2bcd8739ae039 = $4bb3e5ce3694dd68$var$CustomFontSubsetEmbedder;

});

parcelRegister("k8kub", function(module, exports) {

$parcel$export(module.exports, "AFRelationship", () => $03c8546b8537a071$export$c12eac46fbec1b74);
$parcel$export(module.exports, "default", () => $03c8546b8537a071$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $8dCYu = parcelRequire("8dCYu");

var $jWFiV = parcelRequire("jWFiV");
var $03c8546b8537a071$export$c12eac46fbec1b74;
(function(AFRelationship) {
    AFRelationship["Source"] = "Source";
    AFRelationship["Data"] = "Data";
    AFRelationship["Alternative"] = "Alternative";
    AFRelationship["Supplement"] = "Supplement";
    AFRelationship["EncryptedPayload"] = "EncryptedPayload";
    AFRelationship["FormData"] = "EncryptedPayload";
    AFRelationship["Schema"] = "Schema";
    AFRelationship["Unspecified"] = "Unspecified";
})($03c8546b8537a071$export$c12eac46fbec1b74 || ($03c8546b8537a071$export$c12eac46fbec1b74 = {}));
var $03c8546b8537a071$var$FileEmbedder = /** @class */ function() {
    function FileEmbedder(fileData, fileName, options) {
        if (options === void 0) options = {};
        this.fileData = fileData;
        this.fileName = fileName;
        this.options = options;
    }
    FileEmbedder.for = function(bytes, fileName, options) {
        if (options === void 0) options = {};
        return new FileEmbedder(bytes, fileName, options);
    };
    FileEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var _a, mimeType, description, creationDate, modificationDate, afRelationship, embeddedFileStream, embeddedFileStreamRef, fileSpecDict;
            return (0, $cOQTW.__generator)(this, function(_b) {
                _a = this.options, mimeType = _a.mimeType, description = _a.description, creationDate = _a.creationDate, modificationDate = _a.modificationDate, afRelationship = _a.afRelationship;
                embeddedFileStream = context.flateStream(this.fileData, {
                    Type: 'EmbeddedFile',
                    Subtype: mimeType !== null && mimeType !== void 0 ? mimeType : undefined,
                    Params: {
                        Size: this.fileData.length,
                        CreationDate: creationDate ? (0, $8dCYu.default).fromDate(creationDate) : undefined,
                        ModDate: modificationDate ? (0, $8dCYu.default).fromDate(modificationDate) : undefined
                    }
                });
                embeddedFileStreamRef = context.register(embeddedFileStream);
                fileSpecDict = context.obj({
                    Type: 'Filespec',
                    F: (0, $8dCYu.default).of(this.fileName),
                    UF: (0, $jWFiV.default).fromText(this.fileName),
                    EF: {
                        F: embeddedFileStreamRef
                    },
                    Desc: description ? (0, $jWFiV.default).fromText(description) : undefined,
                    AFRelationship: afRelationship !== null && afRelationship !== void 0 ? afRelationship : undefined
                });
                if (ref) {
                    context.assign(ref, fileSpecDict);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(fileSpecDict)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return FileEmbedder;
}();
var $03c8546b8537a071$export$2e2bcd8739ae039 = $03c8546b8537a071$var$FileEmbedder;

});

parcelRegister("fmxHr", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2f30d23c2f107ea$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");
// prettier-ignore
var $b2f30d23c2f107ea$var$MARKERS = [
    0xffc0,
    0xffc1,
    0xffc2,
    0xffc3,
    0xffc5,
    0xffc6,
    0xffc7,
    0xffc8,
    0xffc9,
    0xffca,
    0xffcb,
    0xffcc,
    0xffcd,
    0xffce,
    0xffcf
];
var $b2f30d23c2f107ea$var$ColorSpace;
(function(ColorSpace) {
    ColorSpace["DeviceGray"] = "DeviceGray";
    ColorSpace["DeviceRGB"] = "DeviceRGB";
    ColorSpace["DeviceCMYK"] = "DeviceCMYK";
})($b2f30d23c2f107ea$var$ColorSpace || ($b2f30d23c2f107ea$var$ColorSpace = {}));
var $b2f30d23c2f107ea$var$ChannelToColorSpace = {
    1: $b2f30d23c2f107ea$var$ColorSpace.DeviceGray,
    3: $b2f30d23c2f107ea$var$ColorSpace.DeviceRGB,
    4: $b2f30d23c2f107ea$var$ColorSpace.DeviceCMYK
};
/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/foliojs/pdfkit/blob/a6af76467ce06bd6a2af4aa7271ccac9ff152a7d/lib/image/jpeg.js
 */ var $b2f30d23c2f107ea$var$JpegEmbedder = /** @class */ function() {
    function JpegEmbedder(imageData, bitsPerComponent, width, height, colorSpace) {
        this.imageData = imageData;
        this.bitsPerComponent = bitsPerComponent;
        this.width = width;
        this.height = height;
        this.colorSpace = colorSpace;
    }
    JpegEmbedder.for = function(imageData) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var dataView, soi, pos, marker, bitsPerComponent, height, width, channelByte, channelName, colorSpace;
            return (0, $cOQTW.__generator)(this, function(_a) {
                dataView = new DataView(imageData.buffer);
                soi = dataView.getUint16(0);
                if (soi !== 0xffd8) throw new Error('SOI not found in JPEG');
                pos = 2;
                while(pos < dataView.byteLength){
                    marker = dataView.getUint16(pos);
                    pos += 2;
                    if ($b2f30d23c2f107ea$var$MARKERS.includes(marker)) break;
                    pos += dataView.getUint16(pos);
                }
                if (!$b2f30d23c2f107ea$var$MARKERS.includes(marker)) throw new Error('Invalid JPEG');
                pos += 2;
                bitsPerComponent = dataView.getUint8(pos++);
                height = dataView.getUint16(pos);
                pos += 2;
                width = dataView.getUint16(pos);
                pos += 2;
                channelByte = dataView.getUint8(pos++);
                channelName = $b2f30d23c2f107ea$var$ChannelToColorSpace[channelByte];
                if (!channelName) throw new Error('Unknown JPEG channel.');
                colorSpace = channelName;
                return [
                    2 /*return*/ ,
                    new JpegEmbedder(imageData, bitsPerComponent, width, height, colorSpace)
                ];
            });
        });
    };
    JpegEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var xObject;
            return (0, $cOQTW.__generator)(this, function(_a) {
                xObject = context.stream(this.imageData, {
                    Type: 'XObject',
                    Subtype: 'Image',
                    BitsPerComponent: this.bitsPerComponent,
                    Width: this.width,
                    Height: this.height,
                    ColorSpace: this.colorSpace,
                    Filter: 'DCTDecode',
                    // CMYK JPEG streams in PDF are typically stored complemented,
                    // with 1 as 'off' and 0 as 'on' (PDF 32000-1:2008, 8.6.4.4).
                    //
                    // Standalone CMYK JPEG (usually exported by Photoshop) are
                    // stored inverse, with 0 as 'off' and 1 as 'on', like RGB.
                    //
                    // Applying a swap here as a hedge that most bytes passing
                    // through this method will benefit from it.
                    Decode: this.colorSpace === $b2f30d23c2f107ea$var$ColorSpace.DeviceCMYK ? [
                        1,
                        0,
                        1,
                        0,
                        1,
                        0,
                        1,
                        0
                    ] : undefined
                });
                if (ref) {
                    context.assign(ref, xObject);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(xObject)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return JpegEmbedder;
}();
var $b2f30d23c2f107ea$export$2e2bcd8739ae039 = $b2f30d23c2f107ea$var$JpegEmbedder;

});

parcelRegister("atfwl", function(module, exports) {

$parcel$export(module.exports, "default", () => $79f8a6e417146498$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $kdfvO = parcelRequire("kdfvO");
/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/devongovett/pdfkit/blob/e71edab0dd4657b5a767804ba86c94c58d01fbca/lib/image/png.coffee
 */ var $79f8a6e417146498$var$PngEmbedder = /** @class */ function() {
    function PngEmbedder(png) {
        this.image = png;
        this.bitsPerComponent = png.bitsPerComponent;
        this.width = png.width;
        this.height = png.height;
        this.colorSpace = 'DeviceRGB';
    }
    PngEmbedder.for = function(imageData) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var png;
            return (0, $cOQTW.__generator)(this, function(_a) {
                png = (0, $kdfvO.PNG).load(imageData);
                return [
                    2 /*return*/ ,
                    new PngEmbedder(png)
                ];
            });
        });
    };
    PngEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var SMask, xObject;
            return (0, $cOQTW.__generator)(this, function(_a) {
                SMask = this.embedAlphaChannel(context);
                xObject = context.flateStream(this.image.rgbChannel, {
                    Type: 'XObject',
                    Subtype: 'Image',
                    BitsPerComponent: this.image.bitsPerComponent,
                    Width: this.image.width,
                    Height: this.image.height,
                    ColorSpace: this.colorSpace,
                    SMask: SMask
                });
                if (ref) {
                    context.assign(ref, xObject);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(xObject)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    PngEmbedder.prototype.embedAlphaChannel = function(context) {
        if (!this.image.alphaChannel) return undefined;
        var xObject = context.flateStream(this.image.alphaChannel, {
            Type: 'XObject',
            Subtype: 'Image',
            Height: this.image.height,
            Width: this.image.width,
            BitsPerComponent: this.image.bitsPerComponent,
            ColorSpace: 'DeviceGray',
            Decode: [
                0,
                1
            ]
        });
        return context.register(xObject);
    };
    return PngEmbedder;
}();
var $79f8a6e417146498$export$2e2bcd8739ae039 = $79f8a6e417146498$var$PngEmbedder;

});
parcelRegister("kdfvO", function(module, exports) {

$parcel$export(module.exports, "PNG", () => $eb710dec6a4e1482$export$1f536085c24cc947);

var $9wmwO = parcelRequire("9wmwO");
var $eb710dec6a4e1482$var$getImageType = function(ctype) {
    if (ctype === 0) return $eb710dec6a4e1482$export$3ff975e8f63e458c.Greyscale;
    if (ctype === 2) return $eb710dec6a4e1482$export$3ff975e8f63e458c.Truecolour;
    if (ctype === 3) return $eb710dec6a4e1482$export$3ff975e8f63e458c.IndexedColour;
    if (ctype === 4) return $eb710dec6a4e1482$export$3ff975e8f63e458c.GreyscaleWithAlpha;
    if (ctype === 6) return $eb710dec6a4e1482$export$3ff975e8f63e458c.TruecolourWithAlpha;
    throw new Error("Unknown color type: " + ctype);
};
var $eb710dec6a4e1482$var$splitAlphaChannel = function(rgbaChannel) {
    var pixelCount = Math.floor(rgbaChannel.length / 4);
    var rgbChannel = new Uint8Array(pixelCount * 3);
    var alphaChannel = new Uint8Array(pixelCount * 1);
    var rgbaOffset = 0;
    var rgbOffset = 0;
    var alphaOffset = 0;
    while(rgbaOffset < rgbaChannel.length){
        rgbChannel[rgbOffset++] = rgbaChannel[rgbaOffset++];
        rgbChannel[rgbOffset++] = rgbaChannel[rgbaOffset++];
        rgbChannel[rgbOffset++] = rgbaChannel[rgbaOffset++];
        alphaChannel[alphaOffset++] = rgbaChannel[rgbaOffset++];
    }
    return {
        rgbChannel: rgbChannel,
        alphaChannel: alphaChannel
    };
};
var $eb710dec6a4e1482$export$3ff975e8f63e458c;
(function(PngType) {
    PngType["Greyscale"] = "Greyscale";
    PngType["Truecolour"] = "Truecolour";
    PngType["IndexedColour"] = "IndexedColour";
    PngType["GreyscaleWithAlpha"] = "GreyscaleWithAlpha";
    PngType["TruecolourWithAlpha"] = "TruecolourWithAlpha";
})($eb710dec6a4e1482$export$3ff975e8f63e458c || ($eb710dec6a4e1482$export$3ff975e8f63e458c = {}));
var $eb710dec6a4e1482$export$1f536085c24cc947 = /** @class */ function() {
    function PNG(pngData) {
        var upng = (0, $9wmwO.default).decode(pngData);
        var frames = (0, $9wmwO.default).toRGBA8(upng);
        if (frames.length > 1) throw new Error("Animated PNGs are not supported");
        var frame = new Uint8Array(frames[0]);
        var _a = $eb710dec6a4e1482$var$splitAlphaChannel(frame), rgbChannel = _a.rgbChannel, alphaChannel = _a.alphaChannel;
        this.rgbChannel = rgbChannel;
        var hasAlphaValues = alphaChannel.some(function(a) {
            return a < 255;
        });
        if (hasAlphaValues) this.alphaChannel = alphaChannel;
        this.type = $eb710dec6a4e1482$var$getImageType(upng.ctype);
        this.width = upng.width;
        this.height = upng.height;
        this.bitsPerComponent = 8;
    }
    PNG.load = function(pngData) {
        return new PNG(pngData);
    };
    return PNG;
}();

});
parcelRegister("9wmwO", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ee893d66c44e557$export$2e2bcd8739ae039);

var $ckCqy = parcelRequire("ckCqy");
var $6ee893d66c44e557$var$UPNG = {};
$6ee893d66c44e557$var$UPNG.toRGBA8 = function(out) {
    var w = out.width, h = out.height;
    if (out.tabs.acTL == null) return [
        $6ee893d66c44e557$var$UPNG.toRGBA8.decodeImage(out.data, w, h, out).buffer
    ];
    var frms = [];
    if (out.frames[0].data == null) out.frames[0].data = out.data;
    var len = w * h * 4, img = new Uint8Array(len), empty = new Uint8Array(len), prev = new Uint8Array(len);
    for(var i = 0; i < out.frames.length; i++){
        var frm = out.frames[i];
        var fx = frm.rect.x, fy = frm.rect.y, fw = frm.rect.width, fh = frm.rect.height;
        var fdata = $6ee893d66c44e557$var$UPNG.toRGBA8.decodeImage(frm.data, fw, fh, out);
        if (i != 0) for(var j = 0; j < len; j++)prev[j] = img[j];
        if (frm.blend == 0) $6ee893d66c44e557$var$UPNG._copyTile(fdata, fw, fh, img, w, h, fx, fy, 0);
        else if (frm.blend == 1) $6ee893d66c44e557$var$UPNG._copyTile(fdata, fw, fh, img, w, h, fx, fy, 1);
        frms.push(img.buffer.slice(0));
        if (frm.dispose == 0) ;
        else if (frm.dispose == 1) $6ee893d66c44e557$var$UPNG._copyTile(empty, fw, fh, img, w, h, fx, fy, 0);
        else if (frm.dispose == 2) for(var j = 0; j < len; j++)img[j] = prev[j];
    }
    return frms;
};
$6ee893d66c44e557$var$UPNG.toRGBA8.decodeImage = function(data, w, h, out) {
    var area = w * h, bpp = $6ee893d66c44e557$var$UPNG.decode._getBPP(out);
    var bpl = Math.ceil(w * bpp / 8); // bytes per line
    var bf = new Uint8Array(area * 4), bf32 = new Uint32Array(bf.buffer);
    var ctype = out.ctype, depth = out.depth;
    var rs = $6ee893d66c44e557$var$UPNG._bin.readUshort;
    //console.log(ctype, depth);
    var time = Date.now();
    if (ctype == 6) {
        var qarea = area << 2;
        if (depth == 8) for(var i = 0; i < qarea; i += 4){
            bf[i] = data[i];
            bf[i + 1] = data[i + 1];
            bf[i + 2] = data[i + 2];
            bf[i + 3] = data[i + 3];
        }
        if (depth == 16) for(var i = 0; i < qarea; i++)bf[i] = data[i << 1];
    } else if (ctype == 2) {
        var ts = out.tabs["tRNS"];
        if (ts == null) {
            if (depth == 8) for(var i = 0; i < area; i++){
                var ti = i * 3;
                bf32[i] = -16777216 | data[ti + 2] << 16 | data[ti + 1] << 8 | data[ti];
            }
            if (depth == 16) for(var i = 0; i < area; i++){
                var ti = i * 6;
                bf32[i] = -16777216 | data[ti + 4] << 16 | data[ti + 2] << 8 | data[ti];
            }
        } else {
            var tr = ts[0], tg = ts[1], tb = ts[2];
            if (depth == 8) for(var i = 0; i < area; i++){
                var qi = i << 2, ti = i * 3;
                bf32[i] = -16777216 | data[ti + 2] << 16 | data[ti + 1] << 8 | data[ti];
                if (data[ti] == tr && data[ti + 1] == tg && data[ti + 2] == tb) bf[qi + 3] = 0;
            }
            if (depth == 16) for(var i = 0; i < area; i++){
                var qi = i << 2, ti = i * 6;
                bf32[i] = -16777216 | data[ti + 4] << 16 | data[ti + 2] << 8 | data[ti];
                if (rs(data, ti) == tr && rs(data, ti + 2) == tg && rs(data, ti + 4) == tb) bf[qi + 3] = 0;
            }
        }
    } else if (ctype == 3) {
        var p = out.tabs["PLTE"], ap = out.tabs["tRNS"], tl = ap ? ap.length : 0;
        //console.log(p, ap);
        if (depth == 1) for(var y = 0; y < h; y++){
            var s0 = y * bpl, t0 = y * w;
            for(var i = 0; i < w; i++){
                var qi = t0 + i << 2, j = data[s0 + (i >> 3)] >> 7 - ((i & 7) << 0) & 1, cj = 3 * j;
                bf[qi] = p[cj];
                bf[qi + 1] = p[cj + 1];
                bf[qi + 2] = p[cj + 2];
                bf[qi + 3] = j < tl ? ap[j] : 255;
            }
        }
        if (depth == 2) for(var y = 0; y < h; y++){
            var s0 = y * bpl, t0 = y * w;
            for(var i = 0; i < w; i++){
                var qi = t0 + i << 2, j = data[s0 + (i >> 2)] >> 6 - ((i & 3) << 1) & 3, cj = 3 * j;
                bf[qi] = p[cj];
                bf[qi + 1] = p[cj + 1];
                bf[qi + 2] = p[cj + 2];
                bf[qi + 3] = j < tl ? ap[j] : 255;
            }
        }
        if (depth == 4) for(var y = 0; y < h; y++){
            var s0 = y * bpl, t0 = y * w;
            for(var i = 0; i < w; i++){
                var qi = t0 + i << 2, j = data[s0 + (i >> 1)] >> 4 - ((i & 1) << 2) & 15, cj = 3 * j;
                bf[qi] = p[cj];
                bf[qi + 1] = p[cj + 1];
                bf[qi + 2] = p[cj + 2];
                bf[qi + 3] = j < tl ? ap[j] : 255;
            }
        }
        if (depth == 8) for(var i = 0; i < area; i++){
            var qi = i << 2, j = data[i], cj = 3 * j;
            bf[qi] = p[cj];
            bf[qi + 1] = p[cj + 1];
            bf[qi + 2] = p[cj + 2];
            bf[qi + 3] = j < tl ? ap[j] : 255;
        }
    } else if (ctype == 4) {
        if (depth == 8) for(var i = 0; i < area; i++){
            var qi = i << 2, di = i << 1, gr = data[di];
            bf[qi] = gr;
            bf[qi + 1] = gr;
            bf[qi + 2] = gr;
            bf[qi + 3] = data[di + 1];
        }
        if (depth == 16) for(var i = 0; i < area; i++){
            var qi = i << 2, di = i << 2, gr = data[di];
            bf[qi] = gr;
            bf[qi + 1] = gr;
            bf[qi + 2] = gr;
            bf[qi + 3] = data[di + 2];
        }
    } else if (ctype == 0) {
        var tr = out.tabs["tRNS"] ? out.tabs["tRNS"] : -1;
        for(var y = 0; y < h; y++){
            var off = y * bpl, to = y * w;
            if (depth == 1) for(var x = 0; x < w; x++){
                var gr = 255 * (data[off + (x >>> 3)] >>> 7 - (x & 7) & 1), al = gr == tr * 255 ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
            else if (depth == 2) for(var x = 0; x < w; x++){
                var gr = 85 * (data[off + (x >>> 2)] >>> 6 - ((x & 3) << 1) & 3), al = gr == tr * 85 ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
            else if (depth == 4) for(var x = 0; x < w; x++){
                var gr = 17 * (data[off + (x >>> 1)] >>> 4 - ((x & 1) << 2) & 15), al = gr == tr * 17 ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
            else if (depth == 8) for(var x = 0; x < w; x++){
                var gr = data[off + x], al = gr == tr ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
            else if (depth == 16) for(var x = 0; x < w; x++){
                var gr = data[off + (x << 1)], al = rs(data, off + (x << i)) == tr ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
        }
    }
    //console.log(Date.now()-time);
    return bf;
};
$6ee893d66c44e557$var$UPNG.decode = function(buff) {
    var data = new Uint8Array(buff), offset = 8, bin = $6ee893d66c44e557$var$UPNG._bin, rUs = bin.readUshort, rUi = bin.readUint;
    var out = {
        tabs: {},
        frames: []
    };
    var dd = new Uint8Array(data.length), doff = 0; // put all IDAT data into it
    var fd, foff = 0; // frames
    var mgck = [
        0x89,
        0x50,
        0x4e,
        0x47,
        0x0d,
        0x0a,
        0x1a,
        0x0a
    ];
    for(var i = 0; i < 8; i++)if (data[i] != mgck[i]) throw "The input is not a PNG file!";
    while(offset < data.length){
        var len = bin.readUint(data, offset);
        offset += 4;
        var type = bin.readASCII(data, offset, 4);
        offset += 4;
        //console.log(type,len);
        if (type == "IHDR") $6ee893d66c44e557$var$UPNG.decode._IHDR(data, offset, out);
        else if (type == "IDAT") {
            for(var i = 0; i < len; i++)dd[doff + i] = data[offset + i];
            doff += len;
        } else if (type == "acTL") {
            out.tabs[type] = {
                num_frames: rUi(data, offset),
                num_plays: rUi(data, offset + 4)
            };
            fd = new Uint8Array(data.length);
        } else if (type == "fcTL") {
            if (foff != 0) {
                var fr = out.frames[out.frames.length - 1];
                fr.data = $6ee893d66c44e557$var$UPNG.decode._decompress(out, fd.slice(0, foff), fr.rect.width, fr.rect.height);
                foff = 0;
            }
            var rct = {
                x: rUi(data, offset + 12),
                y: rUi(data, offset + 16),
                width: rUi(data, offset + 4),
                height: rUi(data, offset + 8)
            };
            var del = rUs(data, offset + 22);
            del = rUs(data, offset + 20) / (del == 0 ? 100 : del);
            var frm = {
                rect: rct,
                delay: Math.round(del * 1000),
                dispose: data[offset + 24],
                blend: data[offset + 25]
            };
            //console.log(frm);
            out.frames.push(frm);
        } else if (type == "fdAT") {
            for(var i = 0; i < len - 4; i++)fd[foff + i] = data[offset + i + 4];
            foff += len - 4;
        } else if (type == "pHYs") out.tabs[type] = [
            bin.readUint(data, offset),
            bin.readUint(data, offset + 4),
            data[offset + 8]
        ];
        else if (type == "cHRM") {
            out.tabs[type] = [];
            for(var i = 0; i < 8; i++)out.tabs[type].push(bin.readUint(data, offset + i * 4));
        } else if (type == "tEXt") {
            if (out.tabs[type] == null) out.tabs[type] = {};
            var nz = bin.nextZero(data, offset);
            var keyw = bin.readASCII(data, offset, nz - offset);
            var text = bin.readASCII(data, nz + 1, offset + len - nz - 1);
            out.tabs[type][keyw] = text;
        } else if (type == "iTXt") {
            if (out.tabs[type] == null) out.tabs[type] = {};
            var nz = 0, off = offset;
            nz = bin.nextZero(data, off);
            var keyw = bin.readASCII(data, off, nz - off);
            off = nz + 1;
            var cflag = data[off], cmeth = data[off + 1];
            off += 2;
            nz = bin.nextZero(data, off);
            var ltag = bin.readASCII(data, off, nz - off);
            off = nz + 1;
            nz = bin.nextZero(data, off);
            var tkeyw = bin.readUTF8(data, off, nz - off);
            off = nz + 1;
            var text = bin.readUTF8(data, off, len - (off - offset));
            out.tabs[type][keyw] = text;
        } else if (type == "PLTE") out.tabs[type] = bin.readBytes(data, offset, len);
        else if (type == "hIST") {
            var pl = out.tabs["PLTE"].length / 3;
            out.tabs[type] = [];
            for(var i = 0; i < pl; i++)out.tabs[type].push(rUs(data, offset + i * 2));
        } else if (type == "tRNS") {
            if (out.ctype == 3) out.tabs[type] = bin.readBytes(data, offset, len);
            else if (out.ctype == 0) out.tabs[type] = rUs(data, offset);
            else if (out.ctype == 2) out.tabs[type] = [
                rUs(data, offset),
                rUs(data, offset + 2),
                rUs(data, offset + 4)
            ];
        //else console.log("tRNS for unsupported color type",out.ctype, len);
        } else if (type == "gAMA") out.tabs[type] = bin.readUint(data, offset) / 100000;
        else if (type == "sRGB") out.tabs[type] = data[offset];
        else if (type == "bKGD") {
            if (out.ctype == 0 || out.ctype == 4) out.tabs[type] = [
                rUs(data, offset)
            ];
            else if (out.ctype == 2 || out.ctype == 6) out.tabs[type] = [
                rUs(data, offset),
                rUs(data, offset + 2),
                rUs(data, offset + 4)
            ];
            else if (out.ctype == 3) out.tabs[type] = data[offset];
        } else if (type == "IEND") break;
        //else {  log("unknown chunk type", type, len);  }
        offset += len;
        var crc = bin.readUint(data, offset);
        offset += 4;
    }
    if (foff != 0) {
        var fr = out.frames[out.frames.length - 1];
        fr.data = $6ee893d66c44e557$var$UPNG.decode._decompress(out, fd.slice(0, foff), fr.rect.width, fr.rect.height);
        foff = 0;
    }
    out.data = $6ee893d66c44e557$var$UPNG.decode._decompress(out, dd, out.width, out.height);
    delete out.compress;
    delete out.interlace;
    delete out.filter;
    return out;
};
$6ee893d66c44e557$var$UPNG.decode._decompress = function(out, dd, w, h) {
    var time = Date.now();
    var bpp = $6ee893d66c44e557$var$UPNG.decode._getBPP(out), bpl = Math.ceil(w * bpp / 8), buff = new Uint8Array((bpl + 1 + out.interlace) * h);
    dd = $6ee893d66c44e557$var$UPNG.decode._inflate(dd, buff);
    //console.log(dd.length, buff.length);
    //console.log(Date.now()-time);
    var time = Date.now();
    if (out.interlace == 0) dd = $6ee893d66c44e557$var$UPNG.decode._filterZero(dd, out, 0, w, h);
    else if (out.interlace == 1) dd = $6ee893d66c44e557$var$UPNG.decode._readInterlace(dd, out);
    //console.log(Date.now()-time);
    return dd;
};
$6ee893d66c44e557$var$UPNG.decode._inflate = function(data, buff) {
    var out = $6ee893d66c44e557$var$UPNG["inflateRaw"](new Uint8Array(data.buffer, 2, data.length - 6), buff);
    return out;
};
$6ee893d66c44e557$var$UPNG.inflateRaw = function() {
    var H = {};
    H.H = {};
    H.H.N = function(N, W) {
        var R = Uint8Array, i = 0, m = 0, J = 0, h = 0, Q = 0, X = 0, u = 0, w = 0, d = 0, v, C;
        if (N[0] == 3 && N[1] == 0) return W ? W : new R(0);
        var V = H.H, n = V.b, A = V.e, l = V.R, M = V.n, I = V.A, e = V.Z, b = V.m, Z = W == null;
        if (Z) W = new R(N.length >>> 2 << 3);
        while(i == 0){
            i = n(N, d, 1);
            m = n(N, d + 1, 2);
            d += 3;
            if (m == 0) {
                if ((d & 7) != 0) d += 8 - (d & 7);
                var D = (d >>> 3) + 4, q = N[D - 4] | N[D - 3] << 8;
                if (Z) W = H.H.W(W, w + q);
                W.set(new R(N.buffer, N.byteOffset + D, q), w);
                d = D + q << 3;
                w += q;
                continue;
            }
            if (Z) W = H.H.W(W, w + 131072);
            if (m == 1) {
                v = b.J;
                C = b.h;
                X = 511;
                u = 31;
            }
            if (m == 2) {
                J = A(N, d, 5) + 257;
                h = A(N, d + 5, 5) + 1;
                Q = A(N, d + 10, 4) + 4;
                d += 14;
                var E = d, j = 1;
                for(var c = 0; c < 38; c += 2){
                    b.Q[c] = 0;
                    b.Q[c + 1] = 0;
                }
                for(var c = 0; c < Q; c++){
                    var K = A(N, d + c * 3, 3);
                    b.Q[(b.X[c] << 1) + 1] = K;
                    if (K > j) j = K;
                }
                d += 3 * Q;
                M(b.Q, j);
                I(b.Q, j, b.u);
                v = b.w;
                C = b.d;
                d = l(b.u, (1 << j) - 1, J + h, N, d, b.v);
                var r = V.V(b.v, 0, J, b.C);
                X = (1 << r) - 1;
                var S = V.V(b.v, J, h, b.D);
                u = (1 << S) - 1;
                M(b.C, r);
                I(b.C, r, v);
                M(b.D, S);
                I(b.D, S, C);
            }
            while(true){
                var T = v[e(N, d) & X];
                d += T & 15;
                var p = T >>> 4;
                if (p >>> 8 == 0) W[w++] = p;
                else if (p == 256) break;
                else {
                    var z = w + p - 254;
                    if (p > 264) {
                        var _ = b.q[p - 257];
                        z = w + (_ >>> 3) + A(N, d, _ & 7);
                        d += _ & 7;
                    }
                    var $ = C[e(N, d) & u];
                    d += $ & 15;
                    var s = $ >>> 4, Y = b.c[s], a = (Y >>> 4) + n(N, d, Y & 15);
                    d += Y & 15;
                    while(w < z){
                        W[w] = W[w++ - a];
                        W[w] = W[w++ - a];
                        W[w] = W[w++ - a];
                        W[w] = W[w++ - a];
                    }
                    w = z;
                }
            }
        }
        return W.length == w ? W : W.slice(0, w);
    };
    H.H.W = function(N, W) {
        var R = N.length;
        if (W <= R) return N;
        var V = new Uint8Array(R << 1);
        V.set(N, 0);
        return V;
    };
    H.H.R = function(N, W, R, V, n, A) {
        var l = H.H.e, M = H.H.Z, I = 0;
        while(I < R){
            var e = N[M(V, n) & W];
            n += e & 15;
            var b = e >>> 4;
            if (b <= 15) {
                A[I] = b;
                I++;
            } else {
                var Z = 0, m = 0;
                if (b == 16) {
                    m = 3 + l(V, n, 2);
                    n += 2;
                    Z = A[I - 1];
                } else if (b == 17) {
                    m = 3 + l(V, n, 3);
                    n += 3;
                } else if (b == 18) {
                    m = 11 + l(V, n, 7);
                    n += 7;
                }
                var J = I + m;
                while(I < J){
                    A[I] = Z;
                    I++;
                }
            }
        }
        return n;
    };
    H.H.V = function(N, W, R, V) {
        var n = 0, A = 0, l = V.length >>> 1;
        while(A < R){
            var M = N[A + W];
            V[A << 1] = 0;
            V[(A << 1) + 1] = M;
            if (M > n) n = M;
            A++;
        }
        while(A < l){
            V[A << 1] = 0;
            V[(A << 1) + 1] = 0;
            A++;
        }
        return n;
    };
    H.H.n = function(N, W) {
        var R = H.H.m, V = N.length, n, A, l, M, I, e = R.j;
        for(var M = 0; M <= W; M++)e[M] = 0;
        for(M = 1; M < V; M += 2)e[N[M]]++;
        var b = R.K;
        n = 0;
        e[0] = 0;
        for(A = 1; A <= W; A++){
            n = n + e[A - 1] << 1;
            b[A] = n;
        }
        for(l = 0; l < V; l += 2){
            I = N[l + 1];
            if (I != 0) {
                N[l] = b[I];
                b[I]++;
            }
        }
    };
    H.H.A = function(N, W, R) {
        var V = N.length, n = H.H.m, A = n.r;
        for(var l = 0; l < V; l += 2)if (N[l + 1] != 0) {
            var M = l >> 1, I = N[l + 1], e = M << 4 | I, b = W - I, Z = N[l] << b, m = Z + (1 << b);
            while(Z != m){
                var J = A[Z] >>> 15 - W;
                R[J] = e;
                Z++;
            }
        }
    };
    H.H.l = function(N, W) {
        var R = H.H.m.r, V = 15 - W;
        for(var n = 0; n < N.length; n += 2){
            var A = N[n] << W - N[n + 1];
            N[n] = R[A] >>> V;
        }
    };
    H.H.M = function(N, W, R) {
        R = R << (W & 7);
        var V = W >>> 3;
        N[V] |= R;
        N[V + 1] |= R >>> 8;
    };
    H.H.I = function(N, W, R) {
        R = R << (W & 7);
        var V = W >>> 3;
        N[V] |= R;
        N[V + 1] |= R >>> 8;
        N[V + 2] |= R >>> 16;
    };
    H.H.e = function(N, W, R) {
        return (N[W >>> 3] | N[(W >>> 3) + 1] << 8) >>> (W & 7) & (1 << R) - 1;
    };
    H.H.b = function(N, W, R) {
        return (N[W >>> 3] | N[(W >>> 3) + 1] << 8 | N[(W >>> 3) + 2] << 16) >>> (W & 7) & (1 << R) - 1;
    };
    H.H.Z = function(N, W) {
        return (N[W >>> 3] | N[(W >>> 3) + 1] << 8 | N[(W >>> 3) + 2] << 16) >>> (W & 7);
    };
    H.H.i = function(N, W) {
        return (N[W >>> 3] | N[(W >>> 3) + 1] << 8 | N[(W >>> 3) + 2] << 16 | N[(W >>> 3) + 3] << 24) >>> (W & 7);
    };
    H.H.m = function() {
        var N = Uint16Array, W = Uint32Array;
        return {
            K: new N(16),
            j: new N(16),
            X: [
                16,
                17,
                18,
                0,
                8,
                7,
                9,
                6,
                10,
                5,
                11,
                4,
                12,
                3,
                13,
                2,
                14,
                1,
                15
            ],
            S: [
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                13,
                15,
                17,
                19,
                23,
                27,
                31,
                35,
                43,
                51,
                59,
                67,
                83,
                99,
                115,
                131,
                163,
                195,
                227,
                258,
                999,
                999,
                999
            ],
            T: [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                1,
                1,
                1,
                2,
                2,
                2,
                2,
                3,
                3,
                3,
                3,
                4,
                4,
                4,
                4,
                5,
                5,
                5,
                5,
                0,
                0,
                0,
                0
            ],
            q: new N(32),
            p: [
                1,
                2,
                3,
                4,
                5,
                7,
                9,
                13,
                17,
                25,
                33,
                49,
                65,
                97,
                129,
                193,
                257,
                385,
                513,
                769,
                1025,
                1537,
                2049,
                3073,
                4097,
                6145,
                8193,
                12289,
                16385,
                24577,
                65535,
                65535
            ],
            z: [
                0,
                0,
                0,
                0,
                1,
                1,
                2,
                2,
                3,
                3,
                4,
                4,
                5,
                5,
                6,
                6,
                7,
                7,
                8,
                8,
                9,
                9,
                10,
                10,
                11,
                11,
                12,
                12,
                13,
                13,
                0,
                0
            ],
            c: new W(32),
            J: new N(512),
            _: [],
            h: new N(32),
            $: [],
            w: new N(32768),
            C: [],
            v: [],
            d: new N(32768),
            D: [],
            u: new N(512),
            Q: [],
            r: new N(32768),
            s: new W(286),
            Y: new W(30),
            a: new W(19),
            t: new W(15e3),
            k: new N(65536),
            g: new N(32768)
        };
    }();
    (function() {
        var N = H.H.m, W = 32768;
        for(var R = 0; R < W; R++){
            var V = R;
            V = (V & 2863311530) >>> 1 | (V & 1431655765) << 1;
            V = (V & 3435973836) >>> 2 | (V & 858993459) << 2;
            V = (V & 4042322160) >>> 4 | (V & 252645135) << 4;
            V = (V & 4278255360) >>> 8 | (V & 16711935) << 8;
            N.r[R] = (V >>> 16 | V << 16) >>> 17;
        }
        function n(A, l, M) {
            while(l-- != 0)A.push(0, M);
        }
        for(var R = 0; R < 32; R++){
            N.q[R] = N.S[R] << 3 | N.T[R];
            N.c[R] = N.p[R] << 4 | N.z[R];
        }
        n(N._, 144, 8);
        n(N._, 112, 9);
        n(N._, 24, 7);
        n(N._, 8, 8);
        H.H.n(N._, 9);
        H.H.A(N._, 9, N.J);
        H.H.l(N._, 9);
        n(N.$, 32, 5);
        H.H.n(N.$, 5);
        H.H.A(N.$, 5, N.h);
        H.H.l(N.$, 5);
        n(N.Q, 19, 0);
        n(N.C, 286, 0);
        n(N.D, 30, 0);
        n(N.v, 320, 0);
    })();
    return H.H.N;
}();
$6ee893d66c44e557$var$UPNG.decode._readInterlace = function(data, out) {
    var w = out.width, h = out.height;
    var bpp = $6ee893d66c44e557$var$UPNG.decode._getBPP(out), cbpp = bpp >> 3, bpl = Math.ceil(w * bpp / 8);
    var img = new Uint8Array(h * bpl);
    var di = 0;
    var starting_row = [
        0,
        0,
        4,
        0,
        2,
        0,
        1
    ];
    var starting_col = [
        0,
        4,
        0,
        2,
        0,
        1,
        0
    ];
    var row_increment = [
        8,
        8,
        8,
        4,
        4,
        2,
        2
    ];
    var col_increment = [
        8,
        8,
        4,
        4,
        2,
        2,
        1
    ];
    var pass = 0;
    while(pass < 7){
        var ri = row_increment[pass], ci = col_increment[pass];
        var sw = 0, sh = 0;
        var cr = starting_row[pass];
        while(cr < h){
            cr += ri;
            sh++;
        }
        var cc = starting_col[pass];
        while(cc < w){
            cc += ci;
            sw++;
        }
        var bpll = Math.ceil(sw * bpp / 8);
        $6ee893d66c44e557$var$UPNG.decode._filterZero(data, out, di, sw, sh);
        var y = 0, row = starting_row[pass];
        while(row < h){
            var col = starting_col[pass];
            var cdi = di + y * bpll << 3;
            while(col < w){
                if (bpp == 1) {
                    var val = data[cdi >> 3];
                    val = val >> 7 - (cdi & 7) & 1;
                    img[row * bpl + (col >> 3)] |= val << 7 - ((col & 7) << 0);
                }
                if (bpp == 2) {
                    var val = data[cdi >> 3];
                    val = val >> 6 - (cdi & 7) & 3;
                    img[row * bpl + (col >> 2)] |= val << 6 - ((col & 3) << 1);
                }
                if (bpp == 4) {
                    var val = data[cdi >> 3];
                    val = val >> 4 - (cdi & 7) & 15;
                    img[row * bpl + (col >> 1)] |= val << 4 - ((col & 1) << 2);
                }
                if (bpp >= 8) {
                    var ii = row * bpl + col * cbpp;
                    for(var j = 0; j < cbpp; j++)img[ii + j] = data[(cdi >> 3) + j];
                }
                cdi += bpp;
                col += ci;
            }
            y++;
            row += ri;
        }
        if (sw * sh != 0) di += sh * (1 + bpll);
        pass = pass + 1;
    }
    return img;
};
$6ee893d66c44e557$var$UPNG.decode._getBPP = function(out) {
    var noc = [
        1,
        null,
        3,
        1,
        2,
        null,
        4
    ][out.ctype];
    return noc * out.depth;
};
$6ee893d66c44e557$var$UPNG.decode._filterZero = function(data, out, off, w, h) {
    var bpp = $6ee893d66c44e557$var$UPNG.decode._getBPP(out), bpl = Math.ceil(w * bpp / 8), paeth = $6ee893d66c44e557$var$UPNG.decode._paeth;
    bpp = Math.ceil(bpp / 8);
    var i = 0, di = 1, type = data[off], x = 0;
    if (type > 1) data[off] = [
        0,
        0,
        1
    ][type - 2];
    if (type == 3) for(x = bpp; x < bpl; x++)data[x + 1] = data[x + 1] + (data[x + 1 - bpp] >>> 1) & 255;
    for(var y = 0; y < h; y++){
        i = off + y * bpl;
        di = i + y + 1;
        type = data[di - 1];
        x = 0;
        if (type == 0) for(; x < bpl; x++)data[i + x] = data[di + x];
        else if (type == 1) {
            for(; x < bpp; x++)data[i + x] = data[di + x];
            for(; x < bpl; x++)data[i + x] = data[di + x] + data[i + x - bpp];
        } else if (type == 2) for(; x < bpl; x++)data[i + x] = data[di + x] + data[i + x - bpl];
        else if (type == 3) {
            for(; x < bpp; x++)data[i + x] = data[di + x] + (data[i + x - bpl] >>> 1);
            for(; x < bpl; x++)data[i + x] = data[di + x] + (data[i + x - bpl] + data[i + x - bpp] >>> 1);
        } else {
            for(; x < bpp; x++)data[i + x] = data[di + x] + paeth(0, data[i + x - bpl], 0);
            for(; x < bpl; x++)data[i + x] = data[di + x] + paeth(data[i + x - bpp], data[i + x - bpl], data[i + x - bpp - bpl]);
        }
    }
    return data;
};
$6ee893d66c44e557$var$UPNG.decode._paeth = function(a, b, c) {
    var p = a + b - c, pa = p - a, pb = p - b, pc = p - c;
    if (pa * pa <= pb * pb && pa * pa <= pc * pc) return a;
    else if (pb * pb <= pc * pc) return b;
    return c;
};
$6ee893d66c44e557$var$UPNG.decode._IHDR = function(data, offset, out) {
    var bin = $6ee893d66c44e557$var$UPNG._bin;
    out.width = bin.readUint(data, offset);
    offset += 4;
    out.height = bin.readUint(data, offset);
    offset += 4;
    out.depth = data[offset];
    offset++;
    out.ctype = data[offset];
    offset++;
    out.compress = data[offset];
    offset++;
    out.filter = data[offset];
    offset++;
    out.interlace = data[offset];
    offset++;
};
$6ee893d66c44e557$var$UPNG._bin = {
    nextZero: function(data, p) {
        while(data[p] != 0)p++;
        return p;
    },
    readUshort: function(buff, p) {
        return buff[p] << 8 | buff[p + 1];
    },
    writeUshort: function(buff, p, n) {
        buff[p] = n >> 8 & 255;
        buff[p + 1] = n & 255;
    },
    readUint: function(buff, p) {
        return buff[p] * 16777216 + (buff[p + 1] << 16 | buff[p + 2] << 8 | buff[p + 3]);
    },
    writeUint: function(buff, p, n) {
        buff[p] = n >> 24 & 255;
        buff[p + 1] = n >> 16 & 255;
        buff[p + 2] = n >> 8 & 255;
        buff[p + 3] = n & 255;
    },
    readASCII: function(buff, p, l) {
        var s = "";
        for(var i = 0; i < l; i++)s += String.fromCharCode(buff[p + i]);
        return s;
    },
    writeASCII: function(data, p, s) {
        for(var i = 0; i < s.length; i++)data[p + i] = s.charCodeAt(i);
    },
    readBytes: function(buff, p, l) {
        var arr = [];
        for(var i = 0; i < l; i++)arr.push(buff[p + i]);
        return arr;
    },
    pad: function(n) {
        return n.length < 2 ? "0" + n : n;
    },
    readUTF8: function(buff, p, l) {
        var s = "", ns;
        for(var i = 0; i < l; i++)s += "%" + $6ee893d66c44e557$var$UPNG._bin.pad(buff[p + i].toString(16));
        try {
            ns = decodeURIComponent(s);
        } catch (e) {
            return $6ee893d66c44e557$var$UPNG._bin.readASCII(buff, p, l);
        }
        return ns;
    }
};
$6ee893d66c44e557$var$UPNG._copyTile = function(sb, sw, sh, tb, tw, th, xoff, yoff, mode) {
    var w = Math.min(sw, tw), h = Math.min(sh, th);
    var si = 0, ti = 0;
    for(var y = 0; y < h; y++)for(var x = 0; x < w; x++){
        if (xoff >= 0 && yoff >= 0) {
            si = y * sw + x << 2;
            ti = (yoff + y) * tw + xoff + x << 2;
        } else {
            si = (-yoff + y) * sw - xoff + x << 2;
            ti = y * tw + x << 2;
        }
        if (mode == 0) {
            tb[ti] = sb[si];
            tb[ti + 1] = sb[si + 1];
            tb[ti + 2] = sb[si + 2];
            tb[ti + 3] = sb[si + 3];
        } else if (mode == 1) {
            var fa = sb[si + 3] * (1 / 255), fr = sb[si] * fa, fg = sb[si + 1] * fa, fb = sb[si + 2] * fa;
            var ba = tb[ti + 3] * (1 / 255), br = tb[ti] * ba, bg = tb[ti + 1] * ba, bb = tb[ti + 2] * ba;
            var ifa = 1 - fa, oa = fa + ba * ifa, ioa = oa == 0 ? 0 : 1 / oa;
            tb[ti + 3] = 255 * oa;
            tb[ti + 0] = (fr + br * ifa) * ioa;
            tb[ti + 1] = (fg + bg * ifa) * ioa;
            tb[ti + 2] = (fb + bb * ifa) * ioa;
        } else if (mode == 2) {
            var fa = sb[si + 3], fr = sb[si], fg = sb[si + 1], fb = sb[si + 2];
            var ba = tb[ti + 3], br = tb[ti], bg = tb[ti + 1], bb = tb[ti + 2];
            if (fa == ba && fr == br && fg == bg && fb == bb) {
                tb[ti] = 0;
                tb[ti + 1] = 0;
                tb[ti + 2] = 0;
                tb[ti + 3] = 0;
            } else {
                tb[ti] = fr;
                tb[ti + 1] = fg;
                tb[ti + 2] = fb;
                tb[ti + 3] = fa;
            }
        } else if (mode == 3) {
            var fa = sb[si + 3], fr = sb[si], fg = sb[si + 1], fb = sb[si + 2];
            var ba = tb[ti + 3], br = tb[ti], bg = tb[ti + 1], bb = tb[ti + 2];
            if (fa == ba && fr == br && fg == bg && fb == bb) continue;
            //if(fa!=255 && ba!=0) return false;
            if (fa < 220 && ba > 20) return false;
        }
    }
    return true;
};
$6ee893d66c44e557$var$UPNG.encode = function(bufs, w, h, ps, dels, tabs, forbidPlte) {
    if (ps == null) ps = 0;
    if (forbidPlte == null) forbidPlte = false;
    var nimg = $6ee893d66c44e557$var$UPNG.encode.compress(bufs, w, h, ps, [
        false,
        false,
        false,
        0,
        forbidPlte
    ]);
    $6ee893d66c44e557$var$UPNG.encode.compressPNG(nimg, -1);
    return $6ee893d66c44e557$var$UPNG.encode._main(nimg, w, h, dels, tabs);
};
$6ee893d66c44e557$var$UPNG.encodeLL = function(bufs, w, h, cc, ac, depth, dels, tabs) {
    var nimg = {
        ctype: 0 + (cc == 1 ? 0 : 2) + (ac == 0 ? 0 : 4),
        depth: depth,
        frames: []
    };
    var time = Date.now();
    var bipp = (cc + ac) * depth, bipl = bipp * w;
    for(var i = 0; i < bufs.length; i++)nimg.frames.push({
        rect: {
            x: 0,
            y: 0,
            width: w,
            height: h
        },
        img: new Uint8Array(bufs[i]),
        blend: 0,
        dispose: 1,
        bpp: Math.ceil(bipp / 8),
        bpl: Math.ceil(bipl / 8)
    });
    $6ee893d66c44e557$var$UPNG.encode.compressPNG(nimg, 0, true);
    var out = $6ee893d66c44e557$var$UPNG.encode._main(nimg, w, h, dels, tabs);
    return out;
};
$6ee893d66c44e557$var$UPNG.encode._main = function(nimg, w, h, dels, tabs) {
    if (tabs == null) tabs = {};
    var crc = $6ee893d66c44e557$var$UPNG.crc.crc, wUi = $6ee893d66c44e557$var$UPNG._bin.writeUint, wUs = $6ee893d66c44e557$var$UPNG._bin.writeUshort, wAs = $6ee893d66c44e557$var$UPNG._bin.writeASCII;
    var offset = 8, anim = nimg.frames.length > 1, pltAlpha = false;
    var leng = 33 + (anim ? 20 : 0);
    if (tabs["sRGB"] != null) leng += 13;
    if (tabs["pHYs"] != null) leng += 21;
    if (nimg.ctype == 3) {
        var dl = nimg.plte.length;
        for(var i = 0; i < dl; i++)if (nimg.plte[i] >>> 24 != 255) pltAlpha = true;
        leng += 8 + dl * 3 + 4 + (pltAlpha ? 8 + dl * 1 + 4 : 0);
    }
    for(var j = 0; j < nimg.frames.length; j++){
        var fr = nimg.frames[j];
        if (anim) leng += 38;
        leng += fr.cimg.length + 12;
        if (j != 0) leng += 4;
    }
    leng += 12;
    var data = new Uint8Array(leng);
    var wr = [
        0x89,
        0x50,
        0x4e,
        0x47,
        0x0d,
        0x0a,
        0x1a,
        0x0a
    ];
    for(var i = 0; i < 8; i++)data[i] = wr[i];
    wUi(data, offset, 13);
    offset += 4;
    wAs(data, offset, "IHDR");
    offset += 4;
    wUi(data, offset, w);
    offset += 4;
    wUi(data, offset, h);
    offset += 4;
    data[offset] = nimg.depth;
    offset++; // depth
    data[offset] = nimg.ctype;
    offset++; // ctype
    data[offset] = 0;
    offset++; // compress
    data[offset] = 0;
    offset++; // filter
    data[offset] = 0;
    offset++; // interlace
    wUi(data, offset, crc(data, offset - 17, 17));
    offset += 4; // crc
    // 13 bytes to say, that it is sRGB
    if (tabs["sRGB"] != null) {
        wUi(data, offset, 1);
        offset += 4;
        wAs(data, offset, "sRGB");
        offset += 4;
        data[offset] = tabs["sRGB"];
        offset++;
        wUi(data, offset, crc(data, offset - 5, 5));
        offset += 4; // crc
    }
    if (tabs["pHYs"] != null) {
        wUi(data, offset, 9);
        offset += 4;
        wAs(data, offset, "pHYs");
        offset += 4;
        wUi(data, offset, tabs["pHYs"][0]);
        offset += 4;
        wUi(data, offset, tabs["pHYs"][1]);
        offset += 4;
        data[offset] = tabs["pHYs"][2];
        offset++;
        wUi(data, offset, crc(data, offset - 13, 13));
        offset += 4; // crc
    }
    if (anim) {
        wUi(data, offset, 8);
        offset += 4;
        wAs(data, offset, "acTL");
        offset += 4;
        wUi(data, offset, nimg.frames.length);
        offset += 4;
        wUi(data, offset, tabs["loop"] != null ? tabs["loop"] : 0);
        offset += 4;
        wUi(data, offset, crc(data, offset - 12, 12));
        offset += 4; // crc
    }
    if (nimg.ctype == 3) {
        var dl = nimg.plte.length;
        wUi(data, offset, dl * 3);
        offset += 4;
        wAs(data, offset, "PLTE");
        offset += 4;
        for(var i = 0; i < dl; i++){
            var ti = i * 3, c = nimg.plte[i], r = c & 255, g = c >>> 8 & 255, b = c >>> 16 & 255;
            data[offset + ti + 0] = r;
            data[offset + ti + 1] = g;
            data[offset + ti + 2] = b;
        }
        offset += dl * 3;
        wUi(data, offset, crc(data, offset - dl * 3 - 4, dl * 3 + 4));
        offset += 4; // crc
        if (pltAlpha) {
            wUi(data, offset, dl);
            offset += 4;
            wAs(data, offset, "tRNS");
            offset += 4;
            for(var i = 0; i < dl; i++)data[offset + i] = nimg.plte[i] >>> 24 & 255;
            offset += dl;
            wUi(data, offset, crc(data, offset - dl - 4, dl + 4));
            offset += 4; // crc
        }
    }
    var fi = 0;
    for(var j = 0; j < nimg.frames.length; j++){
        var fr = nimg.frames[j];
        if (anim) {
            wUi(data, offset, 26);
            offset += 4;
            wAs(data, offset, "fcTL");
            offset += 4;
            wUi(data, offset, fi++);
            offset += 4;
            wUi(data, offset, fr.rect.width);
            offset += 4;
            wUi(data, offset, fr.rect.height);
            offset += 4;
            wUi(data, offset, fr.rect.x);
            offset += 4;
            wUi(data, offset, fr.rect.y);
            offset += 4;
            wUs(data, offset, dels[j]);
            offset += 2;
            wUs(data, offset, 1000);
            offset += 2;
            data[offset] = fr.dispose;
            offset++; // dispose
            data[offset] = fr.blend;
            offset++; // blend
            wUi(data, offset, crc(data, offset - 30, 30));
            offset += 4; // crc
        }
        var imgd = fr.cimg, dl = imgd.length;
        wUi(data, offset, dl + (j == 0 ? 0 : 4));
        offset += 4;
        var ioff = offset;
        wAs(data, offset, j == 0 ? "IDAT" : "fdAT");
        offset += 4;
        if (j != 0) {
            wUi(data, offset, fi++);
            offset += 4;
        }
        data.set(imgd, offset);
        offset += dl;
        wUi(data, offset, crc(data, ioff, offset - ioff));
        offset += 4; // crc
    }
    wUi(data, offset, 0);
    offset += 4;
    wAs(data, offset, "IEND");
    offset += 4;
    wUi(data, offset, crc(data, offset - 4, 4));
    offset += 4; // crc
    return data.buffer;
};
$6ee893d66c44e557$var$UPNG.encode.compressPNG = function(out, filter, levelZero) {
    for(var i = 0; i < out.frames.length; i++){
        var frm = out.frames[i], nw = frm.rect.width, nh = frm.rect.height;
        var fdata = new Uint8Array(nh * frm.bpl + nh);
        frm.cimg = $6ee893d66c44e557$var$UPNG.encode._filterZero(frm.img, nh, frm.bpp, frm.bpl, fdata, filter, levelZero);
    }
};
$6ee893d66c44e557$var$UPNG.encode.compress = function(bufs, w, h, ps, prms) {
    //var time = Date.now();
    var onlyBlend = prms[0], evenCrd = prms[1], forbidPrev = prms[2], minBits = prms[3], forbidPlte = prms[4];
    var ctype = 6, depth = 8, alphaAnd = 255;
    for(var j = 0; j < bufs.length; j++){
        var img = new Uint8Array(bufs[j]), ilen = img.length;
        for(var i = 0; i < ilen; i += 4)alphaAnd &= img[i + 3];
    }
    var gotAlpha = alphaAnd != 255;
    //console.log("alpha check", Date.now()-time);  time = Date.now();
    //var brute = gotAlpha && forGIF;		// brute : frames can only be copied, not "blended"
    var frms = $6ee893d66c44e557$var$UPNG.encode.framize(bufs, w, h, onlyBlend, evenCrd, forbidPrev);
    //console.log("framize", Date.now()-time);  time = Date.now();
    var cmap = {}, plte = [], inds = [];
    if (ps != 0) {
        var nbufs = [];
        for(var i = 0; i < frms.length; i++)nbufs.push(frms[i].img.buffer);
        var abuf = $6ee893d66c44e557$var$UPNG.encode.concatRGBA(nbufs), qres = $6ee893d66c44e557$var$UPNG.quantize(abuf, ps);
        var cof = 0, bb = new Uint8Array(qres.abuf);
        for(var i = 0; i < frms.length; i++){
            var ti = frms[i].img, bln = ti.length;
            inds.push(new Uint8Array(qres.inds.buffer, cof >> 2, bln >> 2));
            for(var j = 0; j < bln; j += 4){
                ti[j] = bb[cof + j];
                ti[j + 1] = bb[cof + j + 1];
                ti[j + 2] = bb[cof + j + 2];
                ti[j + 3] = bb[cof + j + 3];
            }
            cof += bln;
        }
        for(var i = 0; i < qres.plte.length; i++)plte.push(qres.plte[i].est.rgba);
    //console.log("quantize", Date.now()-time);  time = Date.now();
    } else // what if ps==0, but there are <=256 colors?  we still need to detect, if the palette could be used
    for(var j = 0; j < frms.length; j++){
        var frm = frms[j], img32 = new Uint32Array(frm.img.buffer), nw = frm.rect.width, ilen = img32.length;
        var ind = new Uint8Array(ilen);
        inds.push(ind);
        for(var i = 0; i < ilen; i++){
            var c = img32[i];
            if (i != 0 && c == img32[i - 1]) ind[i] = ind[i - 1];
            else if (i > nw && c == img32[i - nw]) ind[i] = ind[i - nw];
            else {
                var cmc = cmap[c];
                if (cmc == null) {
                    cmap[c] = cmc = plte.length;
                    plte.push(c);
                    if (plte.length >= 300) break;
                }
                ind[i] = cmc;
            }
        }
    }
    var cc = plte.length; //console.log("colors:",cc);
    if (cc <= 256 && forbidPlte == false) {
        if (cc <= 2) depth = 1;
        else if (cc <= 4) depth = 2;
        else if (cc <= 16) depth = 4;
        else depth = 8;
        depth = Math.max(depth, minBits);
    }
    for(var j = 0; j < frms.length; j++){
        var frm = frms[j], nx = frm.rect.x, ny = frm.rect.y, nw = frm.rect.width, nh = frm.rect.height;
        var cimg = frm.img, cimg32 = new Uint32Array(cimg.buffer);
        var bpl = 4 * nw, bpp = 4;
        if (cc <= 256 && forbidPlte == false) {
            bpl = Math.ceil(depth * nw / 8);
            var nimg = new Uint8Array(bpl * nh);
            var inj = inds[j];
            for(var y = 0; y < nh; y++){
                var i = y * bpl, ii = y * nw;
                if (depth == 8) for(var x = 0; x < nw; x++)nimg[i + x] = inj[ii + x];
                else if (depth == 4) for(var x = 0; x < nw; x++)nimg[i + (x >> 1)] |= inj[ii + x] << 4 - (x & 1) * 4;
                else if (depth == 2) for(var x = 0; x < nw; x++)nimg[i + (x >> 2)] |= inj[ii + x] << 6 - (x & 3) * 2;
                else if (depth == 1) for(var x = 0; x < nw; x++)nimg[i + (x >> 3)] |= inj[ii + x] << 7 - (x & 7) * 1;
            }
            cimg = nimg;
            ctype = 3;
            bpp = 1;
        } else if (gotAlpha == false && frms.length == 1) {
            var nimg = new Uint8Array(nw * nh * 3), area = nw * nh;
            for(var i = 0; i < area; i++){
                var ti = i * 3, qi = i * 4;
                nimg[ti] = cimg[qi];
                nimg[ti + 1] = cimg[qi + 1];
                nimg[ti + 2] = cimg[qi + 2];
            }
            cimg = nimg;
            ctype = 2;
            bpp = 3;
            bpl = 3 * nw;
        }
        frm.img = cimg;
        frm.bpl = bpl;
        frm.bpp = bpp;
    }
    //console.log("colors => palette indices", Date.now()-time);  time = Date.now();
    return {
        ctype: ctype,
        depth: depth,
        plte: plte,
        frames: frms
    };
};
$6ee893d66c44e557$var$UPNG.encode.framize = function(bufs, w, h, alwaysBlend, evenCrd, forbidPrev) {
    /*  DISPOSE
	    - 0 : no change
		- 1 : clear to transparent
		- 2 : retstore to content before rendering (previous frame disposed)
		BLEND
		- 0 : replace
		- 1 : blend
	*/ var frms = [];
    for(var j = 0; j < bufs.length; j++){
        var cimg = new Uint8Array(bufs[j]), cimg32 = new Uint32Array(cimg.buffer);
        var nimg;
        var nx = 0, ny = 0, nw = w, nh = h, blend = alwaysBlend ? 1 : 0;
        if (j != 0) {
            var tlim = forbidPrev || alwaysBlend || j == 1 || frms[j - 2].dispose != 0 ? 1 : 2, tstp = 0, tarea = 1e9;
            for(var it = 0; it < tlim; it++){
                var pimg = new Uint8Array(bufs[j - 1 - it]), p32 = new Uint32Array(bufs[j - 1 - it]);
                var mix = w, miy = h, max = -1, may = -1;
                for(var y = 0; y < h; y++)for(var x = 0; x < w; x++){
                    var i = y * w + x;
                    if (cimg32[i] != p32[i]) {
                        if (x < mix) mix = x;
                        if (x > max) max = x;
                        if (y < miy) miy = y;
                        if (y > may) may = y;
                    }
                }
                if (max == -1) mix = miy = max = may = 0;
                if (evenCrd) {
                    if ((mix & 1) == 1) mix--;
                    if ((miy & 1) == 1) miy--;
                }
                var sarea = (max - mix + 1) * (may - miy + 1);
                if (sarea < tarea) {
                    tarea = sarea;
                    tstp = it;
                    nx = mix;
                    ny = miy;
                    nw = max - mix + 1;
                    nh = may - miy + 1;
                }
            }
            // alwaysBlend: pokud zjistím, že blendit nelze, nastavím předchozímu snímku dispose=1. Zajistím, aby obsahoval můj obdélník.
            var pimg = new Uint8Array(bufs[j - 1 - tstp]);
            if (tstp == 1) frms[j - 1].dispose = 2;
            nimg = new Uint8Array(nw * nh * 4);
            $6ee893d66c44e557$var$UPNG._copyTile(pimg, w, h, nimg, nw, nh, -nx, -ny, 0);
            blend = $6ee893d66c44e557$var$UPNG._copyTile(cimg, w, h, nimg, nw, nh, -nx, -ny, 3) ? 1 : 0;
            if (blend == 1) $6ee893d66c44e557$var$UPNG.encode._prepareDiff(cimg, w, h, nimg, {
                x: nx,
                y: ny,
                width: nw,
                height: nh
            });
            else $6ee893d66c44e557$var$UPNG._copyTile(cimg, w, h, nimg, nw, nh, -nx, -ny, 0);
        //UPNG._copyTile(cimg,w,h, nimg,nw,nh, -nx,-ny, blend==1?2:0);
        } else nimg = cimg.slice(0); // img may be rewritten further ... don't rewrite input
        frms.push({
            rect: {
                x: nx,
                y: ny,
                width: nw,
                height: nh
            },
            img: nimg,
            blend: blend,
            dispose: 0
        });
    }
    if (alwaysBlend) for(var j = 0; j < frms.length; j++){
        var frm = frms[j];
        if (frm.blend == 1) continue;
        var r0 = frm.rect, r1 = frms[j - 1].rect;
        var miX = Math.min(r0.x, r1.x), miY = Math.min(r0.y, r1.y);
        var maX = Math.max(r0.x + r0.width, r1.x + r1.width), maY = Math.max(r0.y + r0.height, r1.y + r1.height);
        var r = {
            x: miX,
            y: miY,
            width: maX - miX,
            height: maY - miY
        };
        frms[j - 1].dispose = 1;
        if (j - 1 != 0) $6ee893d66c44e557$var$UPNG.encode._updateFrame(bufs, w, h, frms, j - 1, r, evenCrd);
        $6ee893d66c44e557$var$UPNG.encode._updateFrame(bufs, w, h, frms, j, r, evenCrd);
    }
    var area = 0;
    if (bufs.length != 1) for(var i = 0; i < frms.length; i++){
        var frm = frms[i];
        area += frm.rect.width * frm.rect.height;
    //if(i==0 || frm.blend!=1) continue;
    //var ob = new Uint8Array(
    //console.log(frm.blend, frm.dispose, frm.rect);
    }
    //if(area!=0) console.log(area);
    return frms;
};
$6ee893d66c44e557$var$UPNG.encode._updateFrame = function(bufs, w, h, frms, i, r, evenCrd) {
    var U8 = Uint8Array, U32 = Uint32Array;
    var pimg = new U8(bufs[i - 1]), pimg32 = new U32(bufs[i - 1]), nimg = i + 1 < bufs.length ? new U8(bufs[i + 1]) : null;
    var cimg = new U8(bufs[i]), cimg32 = new U32(cimg.buffer);
    var mix = w, miy = h, max = -1, may = -1;
    for(var y = 0; y < r.height; y++)for(var x = 0; x < r.width; x++){
        var cx = r.x + x, cy = r.y + y;
        var j = cy * w + cx, cc = cimg32[j];
        // no need to draw transparency, or to dispose it. Or, if writing the same color and the next one does not need transparency.
        if (cc == 0 || frms[i - 1].dispose == 0 && pimg32[j] == cc && (nimg == null || nimg[j * 4 + 3] != 0)) ;
        else {
            if (cx < mix) mix = cx;
            if (cx > max) max = cx;
            if (cy < miy) miy = cy;
            if (cy > may) may = cy;
        }
    }
    if (max == -1) mix = miy = max = may = 0;
    if (evenCrd) {
        if ((mix & 1) == 1) mix--;
        if ((miy & 1) == 1) miy--;
    }
    r = {
        x: mix,
        y: miy,
        width: max - mix + 1,
        height: may - miy + 1
    };
    var fr = frms[i];
    fr.rect = r;
    fr.blend = 1;
    fr.img = new Uint8Array(r.width * r.height * 4);
    if (frms[i - 1].dispose == 0) {
        $6ee893d66c44e557$var$UPNG._copyTile(pimg, w, h, fr.img, r.width, r.height, -r.x, -r.y, 0);
        $6ee893d66c44e557$var$UPNG.encode._prepareDiff(cimg, w, h, fr.img, r);
    //UPNG._copyTile(cimg,w,h, fr.img,r.width,r.height, -r.x,-r.y, 2);
    } else $6ee893d66c44e557$var$UPNG._copyTile(cimg, w, h, fr.img, r.width, r.height, -r.x, -r.y, 0);
};
$6ee893d66c44e557$var$UPNG.encode._prepareDiff = function(cimg, w, h, nimg, rec) {
    $6ee893d66c44e557$var$UPNG._copyTile(cimg, w, h, nimg, rec.width, rec.height, -rec.x, -rec.y, 2);
/*
	var n32 = new Uint32Array(nimg.buffer);
	var og = new Uint8Array(rec.width*rec.height*4), o32 = new Uint32Array(og.buffer);
	UPNG._copyTile(cimg,w,h, og,rec.width,rec.height, -rec.x,-rec.y, 0);
	for(var i=4; i<nimg.length; i+=4) {
		if(nimg[i-1]!=0 && nimg[i+3]==0 && o32[i>>>2]==o32[(i>>>2)-1]) {
			n32[i>>>2]=o32[i>>>2];
			//var j = i, c=p32[(i>>>2)-1];
			//while(p32[j>>>2]==c) {  n32[j>>>2]=c;  j+=4;  }
		}
	}
	for(var i=nimg.length-8; i>0; i-=4) {
		if(nimg[i+7]!=0 && nimg[i+3]==0 && o32[i>>>2]==o32[(i>>>2)+1]) {
			n32[i>>>2]=o32[i>>>2];
			//var j = i, c=p32[(i>>>2)-1];
			//while(p32[j>>>2]==c) {  n32[j>>>2]=c;  j+=4;  }
		}
	}*/ };
$6ee893d66c44e557$var$UPNG.encode._filterZero = function(img, h, bpp, bpl, data, filter, levelZero) {
    var fls = [], ftry = [
        0,
        1,
        2,
        3,
        4
    ];
    if (filter != -1) ftry = [
        filter
    ];
    else if (h * bpl > 500000 || bpp == 1) ftry = [
        0
    ];
    var opts;
    if (levelZero) opts = {
        level: 0
    };
    var CMPR = levelZero && UZIP != null ? UZIP : (0, (/*@__PURE__*/$parcel$interopDefault($ckCqy)));
    for(var i = 0; i < ftry.length; i++){
        for(var y = 0; y < h; y++)$6ee893d66c44e557$var$UPNG.encode._filterLine(data, img, y, bpl, bpp, ftry[i]);
        //var nimg = new Uint8Array(data.length);
        //var sz = UZIP.F.deflate(data, nimg);  fls.push(nimg.slice(0,sz));
        //var dfl = pako["deflate"](data), dl=dfl.length-4;
        //var crc = (dfl[dl+3]<<24)|(dfl[dl+2]<<16)|(dfl[dl+1]<<8)|(dfl[dl+0]<<0);
        //console.log(crc, UZIP.adler(data,2,data.length-6));
        fls.push(CMPR["deflate"](data, opts));
    }
    var ti, tsize = 1e9;
    for(var i = 0; i < fls.length; i++)if (fls[i].length < tsize) {
        ti = i;
        tsize = fls[i].length;
    }
    return fls[ti];
};
$6ee893d66c44e557$var$UPNG.encode._filterLine = function(data, img, y, bpl, bpp, type) {
    var i = y * bpl, di = i + y, paeth = $6ee893d66c44e557$var$UPNG.decode._paeth;
    data[di] = type;
    di++;
    if (type == 0) {
        if (bpl < 500) for(var x = 0; x < bpl; x++)data[di + x] = img[i + x];
        else data.set(new Uint8Array(img.buffer, i, bpl), di);
    } else if (type == 1) {
        for(var x = 0; x < bpp; x++)data[di + x] = img[i + x];
        for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] - img[i + x - bpp] + 256 & 255;
    } else if (y == 0) {
        for(var x = 0; x < bpp; x++)data[di + x] = img[i + x];
        if (type == 2) for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x];
        if (type == 3) for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] - (img[i + x - bpp] >> 1) + 256 & 255;
        if (type == 4) for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] - paeth(img[i + x - bpp], 0, 0) + 256 & 255;
    } else {
        if (type == 2) for(var x = 0; x < bpl; x++)data[di + x] = img[i + x] + 256 - img[i + x - bpl] & 255;
        if (type == 3) {
            for(var x = 0; x < bpp; x++)data[di + x] = img[i + x] + 256 - (img[i + x - bpl] >> 1) & 255;
            for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] + 256 - (img[i + x - bpl] + img[i + x - bpp] >> 1) & 255;
        }
        if (type == 4) {
            for(var x = 0; x < bpp; x++)data[di + x] = img[i + x] + 256 - paeth(0, img[i + x - bpl], 0) & 255;
            for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] + 256 - paeth(img[i + x - bpp], img[i + x - bpl], img[i + x - bpp - bpl]) & 255;
        }
    }
};
$6ee893d66c44e557$var$UPNG.crc = {
    table: function() {
        var tab = new Uint32Array(256);
        for(var n = 0; n < 256; n++){
            var c = n;
            for(var k = 0; k < 8; k++)if (c & 1) c = 0xedb88320 ^ c >>> 1;
            else c = c >>> 1;
            tab[n] = c;
        }
        return tab;
    }(),
    update: function(c, buf, off, len) {
        for(var i = 0; i < len; i++)c = $6ee893d66c44e557$var$UPNG.crc.table[(c ^ buf[off + i]) & 0xff] ^ c >>> 8;
        return c;
    },
    crc: function(b, o, l) {
        return $6ee893d66c44e557$var$UPNG.crc.update(0xffffffff, b, o, l) ^ 0xffffffff;
    }
};
$6ee893d66c44e557$var$UPNG.quantize = function(abuf, ps) {
    var oimg = new Uint8Array(abuf), nimg = oimg.slice(0), nimg32 = new Uint32Array(nimg.buffer);
    var KD = $6ee893d66c44e557$var$UPNG.quantize.getKDtree(nimg, ps);
    var root = KD[0], leafs = KD[1];
    var planeDst = $6ee893d66c44e557$var$UPNG.quantize.planeDst;
    var sb = oimg, tb = nimg32, len = sb.length;
    var inds = new Uint8Array(oimg.length >> 2);
    for(var i = 0; i < len; i += 4){
        var r = sb[i] * (1 / 255), g = sb[i + 1] * (1 / 255), b = sb[i + 2] * (1 / 255), a = sb[i + 3] * (1 / 255);
        //  exact, but too slow :(
        var nd = $6ee893d66c44e557$var$UPNG.quantize.getNearest(root, r, g, b, a);
        //var nd = root;
        //while(nd.left) nd = (planeDst(nd.est,r,g,b,a)<=0) ? nd.left : nd.right;
        inds[i >> 2] = nd.ind;
        tb[i >> 2] = nd.est.rgba;
    }
    return {
        abuf: nimg.buffer,
        inds: inds,
        plte: leafs
    };
};
$6ee893d66c44e557$var$UPNG.quantize.getKDtree = function(nimg, ps, err) {
    if (err == null) err = 0.0001;
    var nimg32 = new Uint32Array(nimg.buffer);
    var root = {
        i0: 0,
        i1: nimg.length,
        bst: null,
        est: null,
        tdst: 0,
        left: null,
        right: null
    }; // basic statistic, extra statistic
    root.bst = $6ee893d66c44e557$var$UPNG.quantize.stats(nimg, root.i0, root.i1);
    root.est = $6ee893d66c44e557$var$UPNG.quantize.estats(root.bst);
    var leafs = [
        root
    ];
    while(leafs.length < ps){
        var maxL = 0, mi = 0;
        for(var i = 0; i < leafs.length; i++)if (leafs[i].est.L > maxL) {
            maxL = leafs[i].est.L;
            mi = i;
        }
        if (maxL < err) break;
        var node = leafs[mi];
        var s0 = $6ee893d66c44e557$var$UPNG.quantize.splitPixels(nimg, nimg32, node.i0, node.i1, node.est.e, node.est.eMq255);
        var s0wrong = node.i0 >= s0 || node.i1 <= s0;
        //console.log(maxL, leafs.length, mi);
        if (s0wrong) {
            node.est.L = 0;
            continue;
        }
        var ln = {
            i0: node.i0,
            i1: s0,
            bst: null,
            est: null,
            tdst: 0,
            left: null,
            right: null
        };
        ln.bst = $6ee893d66c44e557$var$UPNG.quantize.stats(nimg, ln.i0, ln.i1);
        ln.est = $6ee893d66c44e557$var$UPNG.quantize.estats(ln.bst);
        var rn = {
            i0: s0,
            i1: node.i1,
            bst: null,
            est: null,
            tdst: 0,
            left: null,
            right: null
        };
        rn.bst = {
            R: [],
            m: [],
            N: node.bst.N - ln.bst.N
        };
        for(var i = 0; i < 16; i++)rn.bst.R[i] = node.bst.R[i] - ln.bst.R[i];
        for(var i = 0; i < 4; i++)rn.bst.m[i] = node.bst.m[i] - ln.bst.m[i];
        rn.est = $6ee893d66c44e557$var$UPNG.quantize.estats(rn.bst);
        node.left = ln;
        node.right = rn;
        leafs[mi] = ln;
        leafs.push(rn);
    }
    leafs.sort(function(a, b) {
        return b.bst.N - a.bst.N;
    });
    for(var i = 0; i < leafs.length; i++)leafs[i].ind = i;
    return [
        root,
        leafs
    ];
};
$6ee893d66c44e557$var$UPNG.quantize.getNearest = function(nd, r, g, b, a) {
    if (nd.left == null) {
        nd.tdst = $6ee893d66c44e557$var$UPNG.quantize.dist(nd.est.q, r, g, b, a);
        return nd;
    }
    var planeDst = $6ee893d66c44e557$var$UPNG.quantize.planeDst(nd.est, r, g, b, a);
    var node0 = nd.left, node1 = nd.right;
    if (planeDst > 0) {
        node0 = nd.right;
        node1 = nd.left;
    }
    var ln = $6ee893d66c44e557$var$UPNG.quantize.getNearest(node0, r, g, b, a);
    if (ln.tdst <= planeDst * planeDst) return ln;
    var rn = $6ee893d66c44e557$var$UPNG.quantize.getNearest(node1, r, g, b, a);
    return rn.tdst < ln.tdst ? rn : ln;
};
$6ee893d66c44e557$var$UPNG.quantize.planeDst = function(est, r, g, b, a) {
    var e = est.e;
    return e[0] * r + e[1] * g + e[2] * b + e[3] * a - est.eMq;
};
$6ee893d66c44e557$var$UPNG.quantize.dist = function(q, r, g, b, a) {
    var d0 = r - q[0], d1 = g - q[1], d2 = b - q[2], d3 = a - q[3];
    return d0 * d0 + d1 * d1 + d2 * d2 + d3 * d3;
};
$6ee893d66c44e557$var$UPNG.quantize.splitPixels = function(nimg, nimg32, i0, i1, e, eMq) {
    var vecDot = $6ee893d66c44e557$var$UPNG.quantize.vecDot;
    i1 -= 4;
    var shfs = 0;
    while(i0 < i1){
        while(vecDot(nimg, i0, e) <= eMq)i0 += 4;
        while(vecDot(nimg, i1, e) > eMq)i1 -= 4;
        if (i0 >= i1) break;
        var t = nimg32[i0 >> 2];
        nimg32[i0 >> 2] = nimg32[i1 >> 2];
        nimg32[i1 >> 2] = t;
        i0 += 4;
        i1 -= 4;
    }
    while(vecDot(nimg, i0, e) > eMq)i0 -= 4;
    return i0 + 4;
};
$6ee893d66c44e557$var$UPNG.quantize.vecDot = function(nimg, i, e) {
    return nimg[i] * e[0] + nimg[i + 1] * e[1] + nimg[i + 2] * e[2] + nimg[i + 3] * e[3];
};
$6ee893d66c44e557$var$UPNG.quantize.stats = function(nimg, i0, i1) {
    var R = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    var m = [
        0,
        0,
        0,
        0
    ];
    var N = i1 - i0 >> 2;
    for(var i = i0; i < i1; i += 4){
        var r = nimg[i] * (1 / 255), g = nimg[i + 1] * (1 / 255), b = nimg[i + 2] * (1 / 255), a = nimg[i + 3] * (1 / 255);
        //var r = nimg[i], g = nimg[i+1], b = nimg[i+2], a = nimg[i+3];
        m[0] += r;
        m[1] += g;
        m[2] += b;
        m[3] += a;
        R[0] += r * r;
        R[1] += r * g;
        R[2] += r * b;
        R[3] += r * a;
        R[5] += g * g;
        R[6] += g * b;
        R[7] += g * a;
        R[10] += b * b;
        R[11] += b * a;
        R[15] += a * a;
    }
    R[4] = R[1];
    R[8] = R[2];
    R[9] = R[6];
    R[12] = R[3];
    R[13] = R[7];
    R[14] = R[11];
    return {
        R: R,
        m: m,
        N: N
    };
};
$6ee893d66c44e557$var$UPNG.quantize.estats = function(stats) {
    var R = stats.R, m = stats.m, N = stats.N;
    // when all samples are equal, but N is large (millions), the Rj can be non-zero ( 0.0003.... - precission error)
    var m0 = m[0], m1 = m[1], m2 = m[2], m3 = m[3], iN = N == 0 ? 0 : 1 / N;
    var Rj = [
        R[0] - m0 * m0 * iN,
        R[1] - m0 * m1 * iN,
        R[2] - m0 * m2 * iN,
        R[3] - m0 * m3 * iN,
        R[4] - m1 * m0 * iN,
        R[5] - m1 * m1 * iN,
        R[6] - m1 * m2 * iN,
        R[7] - m1 * m3 * iN,
        R[8] - m2 * m0 * iN,
        R[9] - m2 * m1 * iN,
        R[10] - m2 * m2 * iN,
        R[11] - m2 * m3 * iN,
        R[12] - m3 * m0 * iN,
        R[13] - m3 * m1 * iN,
        R[14] - m3 * m2 * iN,
        R[15] - m3 * m3 * iN
    ];
    var A = Rj, M = $6ee893d66c44e557$var$UPNG.M4;
    var b = [
        0.5,
        0.5,
        0.5,
        0.5
    ], mi = 0, tmi = 0;
    if (N != 0) for(var i = 0; i < 10; i++){
        b = M.multVec(A, b);
        tmi = Math.sqrt(M.dot(b, b));
        b = M.sml(1 / tmi, b);
        if (Math.abs(tmi - mi) < 1e-9) break;
        mi = tmi;
    }
    //b = [0,0,1,0];  mi=N;
    var q = [
        m0 * iN,
        m1 * iN,
        m2 * iN,
        m3 * iN
    ];
    var eMq255 = M.dot(M.sml(255, q), b);
    return {
        Cov: Rj,
        q: q,
        e: b,
        L: mi,
        eMq255: eMq255,
        eMq: M.dot(b, q),
        rgba: (Math.round(255 * q[3]) << 24 | Math.round(255 * q[2]) << 16 | Math.round(255 * q[1]) << 8 | Math.round(255 * q[0]) << 0) >>> 0
    };
};
$6ee893d66c44e557$var$UPNG.M4 = {
    multVec: function(m, v) {
        return [
            m[0] * v[0] + m[1] * v[1] + m[2] * v[2] + m[3] * v[3],
            m[4] * v[0] + m[5] * v[1] + m[6] * v[2] + m[7] * v[3],
            m[8] * v[0] + m[9] * v[1] + m[10] * v[2] + m[11] * v[3],
            m[12] * v[0] + m[13] * v[1] + m[14] * v[2] + m[15] * v[3]
        ];
    },
    dot: function(x, y) {
        return x[0] * y[0] + x[1] * y[1] + x[2] * y[2] + x[3] * y[3];
    },
    sml: function(a, y) {
        return [
            a * y[0],
            a * y[1],
            a * y[2],
            a * y[3]
        ];
    }
};
$6ee893d66c44e557$var$UPNG.encode.concatRGBA = function(bufs) {
    var tlen = 0;
    for(var i = 0; i < bufs.length; i++)tlen += bufs[i].byteLength;
    var nimg = new Uint8Array(tlen), noff = 0;
    for(var i = 0; i < bufs.length; i++){
        var img = new Uint8Array(bufs[i]), il = img.length;
        for(var j = 0; j < il; j += 4){
            var r = img[j], g = img[j + 1], b = img[j + 2], a = img[j + 3];
            if (a == 0) r = g = b = 0;
            nimg[noff + j] = r;
            nimg[noff + j + 1] = g;
            nimg[noff + j + 2] = b;
            nimg[noff + j + 3] = a;
        }
        noff += il;
    }
    return nimg.buffer;
};
var $6ee893d66c44e557$export$2e2bcd8739ae039 = $6ee893d66c44e557$var$UPNG;

});



parcelRegister("h9IbG", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7d58da35b52112a$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $nAWRe = parcelRequire("nAWRe");

var $j04jt = parcelRequire("j04jt");

var $kx2r4 = parcelRequire("kx2r4");

var $4CgUJ = parcelRequire("4CgUJ");

var $dLMRX = parcelRequire("dLMRX");

var $9EODP = parcelRequire("9EODP");

var $8zvel = parcelRequire("8zvel");
parcelRequire("fvYKZ");
var $4ISq8 = parcelRequire("4ISq8");
var $c7d58da35b52112a$var$fullPageBoundingBox = function(page) {
    var mediaBox = page.MediaBox();
    var width = mediaBox.lookup(2, (0, $j04jt.default)).asNumber() - mediaBox.lookup(0, (0, $j04jt.default)).asNumber();
    var height = mediaBox.lookup(3, (0, $j04jt.default)).asNumber() - mediaBox.lookup(1, (0, $j04jt.default)).asNumber();
    return {
        left: 0,
        bottom: 0,
        right: width,
        top: height
    };
};
// Returns the identity matrix, modified to position the content of the given
// bounding box at (0, 0).
var $c7d58da35b52112a$var$boundingBoxAdjustedMatrix = function(bb) {
    return [
        1,
        0,
        0,
        1,
        -bb.left,
        -bb.bottom
    ];
};
var $c7d58da35b52112a$var$PDFPageEmbedder = /** @class */ function() {
    function PDFPageEmbedder(page, boundingBox, transformationMatrix) {
        this.page = page;
        var bb = boundingBox !== null && boundingBox !== void 0 ? boundingBox : $c7d58da35b52112a$var$fullPageBoundingBox(page);
        this.width = bb.right - bb.left;
        this.height = bb.top - bb.bottom;
        this.boundingBox = bb;
        this.transformationMatrix = transformationMatrix !== null && transformationMatrix !== void 0 ? transformationMatrix : $c7d58da35b52112a$var$boundingBoxAdjustedMatrix(bb);
    }
    PDFPageEmbedder.for = function(page, boundingBox, transformationMatrix) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            return (0, $cOQTW.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    new PDFPageEmbedder(page, boundingBox, transformationMatrix)
                ];
            });
        });
    };
    PDFPageEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var _a, Contents, Resources, decodedContents, _b, left, bottom, right, top, xObject;
            return (0, $cOQTW.__generator)(this, function(_c) {
                _a = this.page.normalizedEntries(), Contents = _a.Contents, Resources = _a.Resources;
                if (!Contents) throw new (0, $nAWRe.MissingPageContentsEmbeddingError)();
                decodedContents = this.decodeContents(Contents);
                _b = this.boundingBox, left = _b.left, bottom = _b.bottom, right = _b.right, top = _b.top;
                xObject = context.flateStream(decodedContents, {
                    Type: 'XObject',
                    Subtype: 'Form',
                    FormType: 1,
                    BBox: [
                        left,
                        bottom,
                        right,
                        top
                    ],
                    Matrix: this.transformationMatrix,
                    Resources: Resources
                });
                if (ref) {
                    context.assign(ref, xObject);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(xObject)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    // `contents` is an array of streams which are merged to include them in the XObject.
    // This methods extracts each stream and joins them with a newline character.
    PDFPageEmbedder.prototype.decodeContents = function(contents) {
        var newline = Uint8Array.of((0, $8zvel.default).Newline);
        var decodedContents = [];
        for(var idx = 0, len = contents.size(); idx < len; idx++){
            var stream = contents.lookup(idx, (0, $4CgUJ.default));
            var content = void 0;
            if (stream instanceof (0, $kx2r4.default)) content = (0, $dLMRX.decodePDFRawStream)(stream).decode();
            else if (stream instanceof (0, $9EODP.default)) content = stream.getUnencodedContents();
            else throw new (0, $nAWRe.UnrecognizedStreamTypeError)(stream);
            decodedContents.push(content, newline);
        }
        return (0, $4ISq8.mergeIntoTypedArray).apply(void 0, decodedContents);
    };
    return PDFPageEmbedder;
}();
var $c7d58da35b52112a$export$2e2bcd8739ae039 = $c7d58da35b52112a$var$PDFPageEmbedder;

});
parcelRegister("dLMRX", function(module, exports) {

$parcel$export(module.exports, "decodePDFRawStream", () => $a0659294f562ac04$export$b8317e68ca978594);

var $nAWRe = parcelRequire("nAWRe");

var $8auL6 = parcelRequire("8auL6");

var $brir8 = parcelRequire("brir8");

var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");

var $2wSV8 = parcelRequire("2wSV8");

var $jZikx = parcelRequire("jZikx");

var $1ptqQ = parcelRequire("1ptqQ");

var $hoQ98 = parcelRequire("hoQ98");

var $oQP7X = parcelRequire("oQP7X");

var $940jP = parcelRequire("940jP");
var $a0659294f562ac04$var$decodeStream = function(stream, encoding, params) {
    if (encoding === (0, $dPHSK.default).of('FlateDecode')) return new (0, $1ptqQ.default)(stream);
    if (encoding === (0, $dPHSK.default).of('LZWDecode')) {
        var earlyChange = 1;
        if (params instanceof (0, $brir8.default)) {
            var EarlyChange = params.lookup((0, $dPHSK.default).of('EarlyChange'));
            if (EarlyChange instanceof (0, $j04jt.default)) earlyChange = EarlyChange.asNumber();
        }
        return new (0, $hoQ98.default)(stream, undefined, earlyChange);
    }
    if (encoding === (0, $dPHSK.default).of('ASCII85Decode')) return new (0, $2wSV8.default)(stream);
    if (encoding === (0, $dPHSK.default).of('ASCIIHexDecode')) return new (0, $jZikx.default)(stream);
    if (encoding === (0, $dPHSK.default).of('RunLengthDecode')) return new (0, $oQP7X.default)(stream);
    throw new (0, $nAWRe.UnsupportedEncodingError)(encoding.asString());
};
var $a0659294f562ac04$export$b8317e68ca978594 = function(_a) {
    var dict = _a.dict, contents = _a.contents;
    var stream = new (0, $940jP.default)(contents);
    var Filter = dict.lookup((0, $dPHSK.default).of('Filter'));
    var DecodeParms = dict.lookup((0, $dPHSK.default).of('DecodeParms'));
    if (Filter instanceof (0, $dPHSK.default)) stream = $a0659294f562ac04$var$decodeStream(stream, Filter, DecodeParms);
    else if (Filter instanceof (0, $8auL6.default)) for(var idx = 0, len = Filter.size(); idx < len; idx++)stream = $a0659294f562ac04$var$decodeStream(stream, Filter.lookup(idx, (0, $dPHSK.default)), DecodeParms && DecodeParms.lookupMaybe(idx, (0, $brir8.default)));
    else if (!!Filter) throw new (0, $nAWRe.UnexpectedObjectTypeError)([
        (0, $dPHSK.default),
        (0, $8auL6.default)
    ], Filter);
    return stream;
};

});
parcelRegister("2wSV8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d792bffef4b9a0f$export$2e2bcd8739ae039);
/*
 * Copyright 2012 Mozilla Foundation
 *
 * The Ascii85Stream class contained in this file is a TypeScript port of the
 * JavaScript Ascii85Stream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ 
var $cOQTW = parcelRequire("cOQTW");

var $9BULP = parcelRequire("9BULP");
var $1d792bffef4b9a0f$var$isSpace = function(ch) {
    return ch === 0x20 || ch === 0x09 || ch === 0x0d || ch === 0x0a;
};
var $1d792bffef4b9a0f$var$Ascii85Stream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(Ascii85Stream, _super);
    function Ascii85Stream(stream, maybeLength) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        _this.input = new Uint8Array(5);
        // Most streams increase in size when decoded, but Ascii85 streams
        // typically shrink by ~20%.
        if (maybeLength) maybeLength = 0.8 * maybeLength;
        return _this;
    }
    Ascii85Stream.prototype.readBlock = function() {
        var TILDA_CHAR = 0x7e; // '~'
        var Z_LOWER_CHAR = 0x7a; // 'z'
        var EOF = -1;
        var stream = this.stream;
        var c = stream.getByte();
        while($1d792bffef4b9a0f$var$isSpace(c))c = stream.getByte();
        if (c === EOF || c === TILDA_CHAR) {
            this.eof = true;
            return;
        }
        var bufferLength = this.bufferLength;
        var buffer;
        var i;
        // special code for z
        if (c === Z_LOWER_CHAR) {
            buffer = this.ensureBuffer(bufferLength + 4);
            for(i = 0; i < 4; ++i)buffer[bufferLength + i] = 0;
            this.bufferLength += 4;
        } else {
            var input = this.input;
            input[0] = c;
            for(i = 1; i < 5; ++i){
                c = stream.getByte();
                while($1d792bffef4b9a0f$var$isSpace(c))c = stream.getByte();
                input[i] = c;
                if (c === EOF || c === TILDA_CHAR) break;
            }
            buffer = this.ensureBuffer(bufferLength + i - 1);
            this.bufferLength += i - 1;
            // partial ending;
            if (i < 5) {
                for(; i < 5; ++i)input[i] = 117;
                this.eof = true;
            }
            var t = 0;
            for(i = 0; i < 5; ++i)t = t * 85 + (input[i] - 0x21);
            for(i = 3; i >= 0; --i){
                buffer[bufferLength + i] = t & 0xff;
                t >>= 8;
            }
        }
    };
    return Ascii85Stream;
}((0, $9BULP.default));
var $1d792bffef4b9a0f$export$2e2bcd8739ae039 = $1d792bffef4b9a0f$var$Ascii85Stream;

});
parcelRegister("9BULP", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ff39b2bedd52666$export$2e2bcd8739ae039);

var $nAWRe = parcelRequire("nAWRe");

var $940jP = parcelRequire("940jP");
/*
 * Copyright 2012 Mozilla Foundation
 *
 * The DecodeStream class contained in this file is a TypeScript port of the
 * JavaScript DecodeStream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ // Lots of DecodeStreams are created whose buffers are never used.  For these
// we share a single empty buffer. This is (a) space-efficient and (b) avoids
// having special cases that would be required if we used |null| for an empty
// buffer.
var $6ff39b2bedd52666$var$emptyBuffer = new Uint8Array(0);
/**
 * Super class for the decoding streams
 */ var $6ff39b2bedd52666$var$DecodeStream = /** @class */ function() {
    function DecodeStream(maybeMinBufferLength) {
        this.pos = 0;
        this.bufferLength = 0;
        this.eof = false;
        this.buffer = $6ff39b2bedd52666$var$emptyBuffer;
        this.minBufferLength = 512;
        if (maybeMinBufferLength) // Compute the first power of two that is as big as maybeMinBufferLength.
        while(this.minBufferLength < maybeMinBufferLength)this.minBufferLength *= 2;
    }
    Object.defineProperty(DecodeStream.prototype, "isEmpty", {
        get: function() {
            while(!this.eof && this.bufferLength === 0)this.readBlock();
            return this.bufferLength === 0;
        },
        enumerable: false,
        configurable: true
    });
    DecodeStream.prototype.getByte = function() {
        var pos = this.pos;
        while(this.bufferLength <= pos){
            if (this.eof) return -1;
            this.readBlock();
        }
        return this.buffer[this.pos++];
    };
    DecodeStream.prototype.getUint16 = function() {
        var b0 = this.getByte();
        var b1 = this.getByte();
        if (b0 === -1 || b1 === -1) return -1;
        return (b0 << 8) + b1;
    };
    DecodeStream.prototype.getInt32 = function() {
        var b0 = this.getByte();
        var b1 = this.getByte();
        var b2 = this.getByte();
        var b3 = this.getByte();
        return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
    };
    DecodeStream.prototype.getBytes = function(length, forceClamped) {
        if (forceClamped === void 0) forceClamped = false;
        var end;
        var pos = this.pos;
        if (length) {
            this.ensureBuffer(pos + length);
            end = pos + length;
            while(!this.eof && this.bufferLength < end)this.readBlock();
            var bufEnd = this.bufferLength;
            if (end > bufEnd) end = bufEnd;
        } else {
            while(!this.eof)this.readBlock();
            end = this.bufferLength;
        }
        this.pos = end;
        var subarray = this.buffer.subarray(pos, end);
        // `this.buffer` is either a `Uint8Array` or `Uint8ClampedArray` here.
        return forceClamped && !(subarray instanceof Uint8ClampedArray) ? new Uint8ClampedArray(subarray) : subarray;
    };
    DecodeStream.prototype.peekByte = function() {
        var peekedByte = this.getByte();
        this.pos--;
        return peekedByte;
    };
    DecodeStream.prototype.peekBytes = function(length, forceClamped) {
        if (forceClamped === void 0) forceClamped = false;
        var bytes = this.getBytes(length, forceClamped);
        this.pos -= bytes.length;
        return bytes;
    };
    DecodeStream.prototype.skip = function(n) {
        if (!n) n = 1;
        this.pos += n;
    };
    DecodeStream.prototype.reset = function() {
        this.pos = 0;
    };
    DecodeStream.prototype.makeSubStream = function(start, length /* dict */ ) {
        var end = start + length;
        while(this.bufferLength <= end && !this.eof)this.readBlock();
        return new (0, $940jP.default)(this.buffer, start, length /* dict */ );
    };
    DecodeStream.prototype.decode = function() {
        while(!this.eof)this.readBlock();
        return this.buffer.subarray(0, this.bufferLength);
    };
    DecodeStream.prototype.readBlock = function() {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'readBlock');
    };
    DecodeStream.prototype.ensureBuffer = function(requested) {
        var buffer = this.buffer;
        if (requested <= buffer.byteLength) return buffer;
        var size = this.minBufferLength;
        while(size < requested)size *= 2;
        var buffer2 = new Uint8Array(size);
        buffer2.set(buffer);
        return this.buffer = buffer2;
    };
    return DecodeStream;
}();
var $6ff39b2bedd52666$export$2e2bcd8739ae039 = $6ff39b2bedd52666$var$DecodeStream;

});
parcelRegister("940jP", function(module, exports) {

$parcel$export(module.exports, "default", () => $6994bc106090076a$export$2e2bcd8739ae039);
/*
 * Copyright 2012 Mozilla Foundation
 *
 * The Stream class contained in this file is a TypeScript port of the
 * JavaScript Stream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ var $6994bc106090076a$var$Stream = /** @class */ function() {
    function Stream(buffer, start, length) {
        this.bytes = buffer;
        this.start = start || 0;
        this.pos = this.start;
        this.end = !!start && !!length ? start + length : this.bytes.length;
    }
    Object.defineProperty(Stream.prototype, "length", {
        get: function() {
            return this.end - this.start;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Stream.prototype, "isEmpty", {
        get: function() {
            return this.length === 0;
        },
        enumerable: false,
        configurable: true
    });
    Stream.prototype.getByte = function() {
        if (this.pos >= this.end) return -1;
        return this.bytes[this.pos++];
    };
    Stream.prototype.getUint16 = function() {
        var b0 = this.getByte();
        var b1 = this.getByte();
        if (b0 === -1 || b1 === -1) return -1;
        return (b0 << 8) + b1;
    };
    Stream.prototype.getInt32 = function() {
        var b0 = this.getByte();
        var b1 = this.getByte();
        var b2 = this.getByte();
        var b3 = this.getByte();
        return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
    };
    // Returns subarray of original buffer, should only be read.
    Stream.prototype.getBytes = function(length, forceClamped) {
        if (forceClamped === void 0) forceClamped = false;
        var bytes = this.bytes;
        var pos = this.pos;
        var strEnd = this.end;
        if (!length) {
            var subarray = bytes.subarray(pos, strEnd);
            // `this.bytes` is always a `Uint8Array` here.
            return forceClamped ? new Uint8ClampedArray(subarray) : subarray;
        } else {
            var end = pos + length;
            if (end > strEnd) end = strEnd;
            this.pos = end;
            var subarray = bytes.subarray(pos, end);
            // `this.bytes` is always a `Uint8Array` here.
            return forceClamped ? new Uint8ClampedArray(subarray) : subarray;
        }
    };
    Stream.prototype.peekByte = function() {
        var peekedByte = this.getByte();
        this.pos--;
        return peekedByte;
    };
    Stream.prototype.peekBytes = function(length, forceClamped) {
        if (forceClamped === void 0) forceClamped = false;
        var bytes = this.getBytes(length, forceClamped);
        this.pos -= bytes.length;
        return bytes;
    };
    Stream.prototype.skip = function(n) {
        if (!n) n = 1;
        this.pos += n;
    };
    Stream.prototype.reset = function() {
        this.pos = this.start;
    };
    Stream.prototype.moveStart = function() {
        this.start = this.pos;
    };
    Stream.prototype.makeSubStream = function(start, length) {
        return new Stream(this.bytes, start, length);
    };
    Stream.prototype.decode = function() {
        return this.bytes;
    };
    return Stream;
}();
var $6994bc106090076a$export$2e2bcd8739ae039 = $6994bc106090076a$var$Stream;

});



parcelRegister("jZikx", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8d1eed445279b14$export$2e2bcd8739ae039);
/*
 * Copyright 2012 Mozilla Foundation
 *
 * The AsciiHexStream class contained in this file is a TypeScript port of the
 * JavaScript AsciiHexStream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ 
var $cOQTW = parcelRequire("cOQTW");

var $9BULP = parcelRequire("9BULP");
var $e8d1eed445279b14$var$AsciiHexStream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(AsciiHexStream, _super);
    function AsciiHexStream(stream, maybeLength) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        _this.firstDigit = -1;
        // Most streams increase in size when decoded, but AsciiHex streams shrink
        // by 50%.
        if (maybeLength) maybeLength = 0.5 * maybeLength;
        return _this;
    }
    AsciiHexStream.prototype.readBlock = function() {
        var UPSTREAM_BLOCK_SIZE = 8000;
        var bytes = this.stream.getBytes(UPSTREAM_BLOCK_SIZE);
        if (!bytes.length) {
            this.eof = true;
            return;
        }
        var maxDecodeLength = bytes.length + 1 >> 1;
        var buffer = this.ensureBuffer(this.bufferLength + maxDecodeLength);
        var bufferLength = this.bufferLength;
        var firstDigit = this.firstDigit;
        for(var i = 0, ii = bytes.length; i < ii; i++){
            var ch = bytes[i];
            var digit = void 0;
            if (ch >= 0x30 && ch <= 0x39) // '0'-'9'
            digit = ch & 0x0f;
            else if (ch >= 0x41 && ch <= 0x46 || ch >= 0x61 && ch <= 0x66) // 'A'-'Z', 'a'-'z'
            digit = (ch & 0x0f) + 9;
            else if (ch === 0x3e) {
                // '>'
                this.eof = true;
                break;
            } else continue; // ignoring
            if (firstDigit < 0) firstDigit = digit;
            else {
                buffer[bufferLength++] = firstDigit << 4 | digit;
                firstDigit = -1;
            }
        }
        if (firstDigit >= 0 && this.eof) {
            // incomplete byte
            buffer[bufferLength++] = firstDigit << 4;
            firstDigit = -1;
        }
        this.firstDigit = firstDigit;
        this.bufferLength = bufferLength;
    };
    return AsciiHexStream;
}((0, $9BULP.default));
var $e8d1eed445279b14$export$2e2bcd8739ae039 = $e8d1eed445279b14$var$AsciiHexStream;

});

parcelRegister("1ptqQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $106ef4d7516ef3d6$export$2e2bcd8739ae039);
/*
 * Copyright 1996-2003 Glyph & Cog, LLC
 *
 * The flate stream implementation contained in this file is a JavaScript port
 * of XPDF's implementation, made available under the Apache 2.0 open source
 * license.
 */ 
var $cOQTW = parcelRequire("cOQTW");

var $9BULP = parcelRequire("9BULP");
// prettier-ignore
var $106ef4d7516ef3d6$var$codeLenCodeMap = new Int32Array([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// prettier-ignore
var $106ef4d7516ef3d6$var$lengthDecode = new Int32Array([
    0x00003,
    0x00004,
    0x00005,
    0x00006,
    0x00007,
    0x00008,
    0x00009,
    0x0000a,
    0x1000b,
    0x1000d,
    0x1000f,
    0x10011,
    0x20013,
    0x20017,
    0x2001b,
    0x2001f,
    0x30023,
    0x3002b,
    0x30033,
    0x3003b,
    0x40043,
    0x40053,
    0x40063,
    0x40073,
    0x50083,
    0x500a3,
    0x500c3,
    0x500e3,
    0x00102,
    0x00102,
    0x00102
]);
// prettier-ignore
var $106ef4d7516ef3d6$var$distDecode = new Int32Array([
    0x00001,
    0x00002,
    0x00003,
    0x00004,
    0x10005,
    0x10007,
    0x20009,
    0x2000d,
    0x30011,
    0x30019,
    0x40021,
    0x40031,
    0x50041,
    0x50061,
    0x60081,
    0x600c1,
    0x70101,
    0x70181,
    0x80201,
    0x80301,
    0x90401,
    0x90601,
    0xa0801,
    0xa0c01,
    0xb1001,
    0xb1801,
    0xc2001,
    0xc3001,
    0xd4001,
    0xd6001
]);
// prettier-ignore
var $106ef4d7516ef3d6$var$fixedLitCodeTab = [
    new Int32Array([
        0x70100,
        0x80050,
        0x80010,
        0x80118,
        0x70110,
        0x80070,
        0x80030,
        0x900c0,
        0x70108,
        0x80060,
        0x80020,
        0x900a0,
        0x80000,
        0x80080,
        0x80040,
        0x900e0,
        0x70104,
        0x80058,
        0x80018,
        0x90090,
        0x70114,
        0x80078,
        0x80038,
        0x900d0,
        0x7010c,
        0x80068,
        0x80028,
        0x900b0,
        0x80008,
        0x80088,
        0x80048,
        0x900f0,
        0x70102,
        0x80054,
        0x80014,
        0x8011c,
        0x70112,
        0x80074,
        0x80034,
        0x900c8,
        0x7010a,
        0x80064,
        0x80024,
        0x900a8,
        0x80004,
        0x80084,
        0x80044,
        0x900e8,
        0x70106,
        0x8005c,
        0x8001c,
        0x90098,
        0x70116,
        0x8007c,
        0x8003c,
        0x900d8,
        0x7010e,
        0x8006c,
        0x8002c,
        0x900b8,
        0x8000c,
        0x8008c,
        0x8004c,
        0x900f8,
        0x70101,
        0x80052,
        0x80012,
        0x8011a,
        0x70111,
        0x80072,
        0x80032,
        0x900c4,
        0x70109,
        0x80062,
        0x80022,
        0x900a4,
        0x80002,
        0x80082,
        0x80042,
        0x900e4,
        0x70105,
        0x8005a,
        0x8001a,
        0x90094,
        0x70115,
        0x8007a,
        0x8003a,
        0x900d4,
        0x7010d,
        0x8006a,
        0x8002a,
        0x900b4,
        0x8000a,
        0x8008a,
        0x8004a,
        0x900f4,
        0x70103,
        0x80056,
        0x80016,
        0x8011e,
        0x70113,
        0x80076,
        0x80036,
        0x900cc,
        0x7010b,
        0x80066,
        0x80026,
        0x900ac,
        0x80006,
        0x80086,
        0x80046,
        0x900ec,
        0x70107,
        0x8005e,
        0x8001e,
        0x9009c,
        0x70117,
        0x8007e,
        0x8003e,
        0x900dc,
        0x7010f,
        0x8006e,
        0x8002e,
        0x900bc,
        0x8000e,
        0x8008e,
        0x8004e,
        0x900fc,
        0x70100,
        0x80051,
        0x80011,
        0x80119,
        0x70110,
        0x80071,
        0x80031,
        0x900c2,
        0x70108,
        0x80061,
        0x80021,
        0x900a2,
        0x80001,
        0x80081,
        0x80041,
        0x900e2,
        0x70104,
        0x80059,
        0x80019,
        0x90092,
        0x70114,
        0x80079,
        0x80039,
        0x900d2,
        0x7010c,
        0x80069,
        0x80029,
        0x900b2,
        0x80009,
        0x80089,
        0x80049,
        0x900f2,
        0x70102,
        0x80055,
        0x80015,
        0x8011d,
        0x70112,
        0x80075,
        0x80035,
        0x900ca,
        0x7010a,
        0x80065,
        0x80025,
        0x900aa,
        0x80005,
        0x80085,
        0x80045,
        0x900ea,
        0x70106,
        0x8005d,
        0x8001d,
        0x9009a,
        0x70116,
        0x8007d,
        0x8003d,
        0x900da,
        0x7010e,
        0x8006d,
        0x8002d,
        0x900ba,
        0x8000d,
        0x8008d,
        0x8004d,
        0x900fa,
        0x70101,
        0x80053,
        0x80013,
        0x8011b,
        0x70111,
        0x80073,
        0x80033,
        0x900c6,
        0x70109,
        0x80063,
        0x80023,
        0x900a6,
        0x80003,
        0x80083,
        0x80043,
        0x900e6,
        0x70105,
        0x8005b,
        0x8001b,
        0x90096,
        0x70115,
        0x8007b,
        0x8003b,
        0x900d6,
        0x7010d,
        0x8006b,
        0x8002b,
        0x900b6,
        0x8000b,
        0x8008b,
        0x8004b,
        0x900f6,
        0x70103,
        0x80057,
        0x80017,
        0x8011f,
        0x70113,
        0x80077,
        0x80037,
        0x900ce,
        0x7010b,
        0x80067,
        0x80027,
        0x900ae,
        0x80007,
        0x80087,
        0x80047,
        0x900ee,
        0x70107,
        0x8005f,
        0x8001f,
        0x9009e,
        0x70117,
        0x8007f,
        0x8003f,
        0x900de,
        0x7010f,
        0x8006f,
        0x8002f,
        0x900be,
        0x8000f,
        0x8008f,
        0x8004f,
        0x900fe,
        0x70100,
        0x80050,
        0x80010,
        0x80118,
        0x70110,
        0x80070,
        0x80030,
        0x900c1,
        0x70108,
        0x80060,
        0x80020,
        0x900a1,
        0x80000,
        0x80080,
        0x80040,
        0x900e1,
        0x70104,
        0x80058,
        0x80018,
        0x90091,
        0x70114,
        0x80078,
        0x80038,
        0x900d1,
        0x7010c,
        0x80068,
        0x80028,
        0x900b1,
        0x80008,
        0x80088,
        0x80048,
        0x900f1,
        0x70102,
        0x80054,
        0x80014,
        0x8011c,
        0x70112,
        0x80074,
        0x80034,
        0x900c9,
        0x7010a,
        0x80064,
        0x80024,
        0x900a9,
        0x80004,
        0x80084,
        0x80044,
        0x900e9,
        0x70106,
        0x8005c,
        0x8001c,
        0x90099,
        0x70116,
        0x8007c,
        0x8003c,
        0x900d9,
        0x7010e,
        0x8006c,
        0x8002c,
        0x900b9,
        0x8000c,
        0x8008c,
        0x8004c,
        0x900f9,
        0x70101,
        0x80052,
        0x80012,
        0x8011a,
        0x70111,
        0x80072,
        0x80032,
        0x900c5,
        0x70109,
        0x80062,
        0x80022,
        0x900a5,
        0x80002,
        0x80082,
        0x80042,
        0x900e5,
        0x70105,
        0x8005a,
        0x8001a,
        0x90095,
        0x70115,
        0x8007a,
        0x8003a,
        0x900d5,
        0x7010d,
        0x8006a,
        0x8002a,
        0x900b5,
        0x8000a,
        0x8008a,
        0x8004a,
        0x900f5,
        0x70103,
        0x80056,
        0x80016,
        0x8011e,
        0x70113,
        0x80076,
        0x80036,
        0x900cd,
        0x7010b,
        0x80066,
        0x80026,
        0x900ad,
        0x80006,
        0x80086,
        0x80046,
        0x900ed,
        0x70107,
        0x8005e,
        0x8001e,
        0x9009d,
        0x70117,
        0x8007e,
        0x8003e,
        0x900dd,
        0x7010f,
        0x8006e,
        0x8002e,
        0x900bd,
        0x8000e,
        0x8008e,
        0x8004e,
        0x900fd,
        0x70100,
        0x80051,
        0x80011,
        0x80119,
        0x70110,
        0x80071,
        0x80031,
        0x900c3,
        0x70108,
        0x80061,
        0x80021,
        0x900a3,
        0x80001,
        0x80081,
        0x80041,
        0x900e3,
        0x70104,
        0x80059,
        0x80019,
        0x90093,
        0x70114,
        0x80079,
        0x80039,
        0x900d3,
        0x7010c,
        0x80069,
        0x80029,
        0x900b3,
        0x80009,
        0x80089,
        0x80049,
        0x900f3,
        0x70102,
        0x80055,
        0x80015,
        0x8011d,
        0x70112,
        0x80075,
        0x80035,
        0x900cb,
        0x7010a,
        0x80065,
        0x80025,
        0x900ab,
        0x80005,
        0x80085,
        0x80045,
        0x900eb,
        0x70106,
        0x8005d,
        0x8001d,
        0x9009b,
        0x70116,
        0x8007d,
        0x8003d,
        0x900db,
        0x7010e,
        0x8006d,
        0x8002d,
        0x900bb,
        0x8000d,
        0x8008d,
        0x8004d,
        0x900fb,
        0x70101,
        0x80053,
        0x80013,
        0x8011b,
        0x70111,
        0x80073,
        0x80033,
        0x900c7,
        0x70109,
        0x80063,
        0x80023,
        0x900a7,
        0x80003,
        0x80083,
        0x80043,
        0x900e7,
        0x70105,
        0x8005b,
        0x8001b,
        0x90097,
        0x70115,
        0x8007b,
        0x8003b,
        0x900d7,
        0x7010d,
        0x8006b,
        0x8002b,
        0x900b7,
        0x8000b,
        0x8008b,
        0x8004b,
        0x900f7,
        0x70103,
        0x80057,
        0x80017,
        0x8011f,
        0x70113,
        0x80077,
        0x80037,
        0x900cf,
        0x7010b,
        0x80067,
        0x80027,
        0x900af,
        0x80007,
        0x80087,
        0x80047,
        0x900ef,
        0x70107,
        0x8005f,
        0x8001f,
        0x9009f,
        0x70117,
        0x8007f,
        0x8003f,
        0x900df,
        0x7010f,
        0x8006f,
        0x8002f,
        0x900bf,
        0x8000f,
        0x8008f,
        0x8004f,
        0x900ff
    ]),
    9
];
// prettier-ignore
var $106ef4d7516ef3d6$var$fixedDistCodeTab = [
    new Int32Array([
        0x50000,
        0x50010,
        0x50008,
        0x50018,
        0x50004,
        0x50014,
        0x5000c,
        0x5001c,
        0x50002,
        0x50012,
        0x5000a,
        0x5001a,
        0x50006,
        0x50016,
        0x5000e,
        0x00000,
        0x50001,
        0x50011,
        0x50009,
        0x50019,
        0x50005,
        0x50015,
        0x5000d,
        0x5001d,
        0x50003,
        0x50013,
        0x5000b,
        0x5001b,
        0x50007,
        0x50017,
        0x5000f,
        0x00000
    ]),
    5
];
var $106ef4d7516ef3d6$var$FlateStream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(FlateStream, _super);
    function FlateStream(stream, maybeLength) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        var cmf = stream.getByte();
        var flg = stream.getByte();
        if (cmf === -1 || flg === -1) throw new Error("Invalid header in flate stream: " + cmf + ", " + flg);
        if ((cmf & 0x0f) !== 0x08) throw new Error("Unknown compression method in flate stream: " + cmf + ", " + flg);
        if (((cmf << 8) + flg) % 31 !== 0) throw new Error("Bad FCHECK in flate stream: " + cmf + ", " + flg);
        if (flg & 0x20) throw new Error("FDICT bit set in flate stream: " + cmf + ", " + flg);
        _this.codeSize = 0;
        _this.codeBuf = 0;
        return _this;
    }
    FlateStream.prototype.readBlock = function() {
        var buffer;
        var len;
        var str = this.stream;
        // read block header
        var hdr = this.getBits(3);
        if (hdr & 1) this.eof = true;
        hdr >>= 1;
        if (hdr === 0) {
            // uncompressed block
            var b = void 0;
            if ((b = str.getByte()) === -1) throw new Error('Bad block header in flate stream');
            var blockLen = b;
            if ((b = str.getByte()) === -1) throw new Error('Bad block header in flate stream');
            blockLen |= b << 8;
            if ((b = str.getByte()) === -1) throw new Error('Bad block header in flate stream');
            var check = b;
            if ((b = str.getByte()) === -1) throw new Error('Bad block header in flate stream');
            check |= b << 8;
            if (check !== (~blockLen & 0xffff) && (blockLen !== 0 || check !== 0)) // Ignoring error for bad "empty" block (see issue 1277)
            throw new Error('Bad uncompressed block length in flate stream');
            this.codeBuf = 0;
            this.codeSize = 0;
            var bufferLength = this.bufferLength;
            buffer = this.ensureBuffer(bufferLength + blockLen);
            var end = bufferLength + blockLen;
            this.bufferLength = end;
            if (blockLen === 0) {
                if (str.peekByte() === -1) this.eof = true;
            } else for(var n = bufferLength; n < end; ++n){
                if ((b = str.getByte()) === -1) {
                    this.eof = true;
                    break;
                }
                buffer[n] = b;
            }
            return;
        }
        var litCodeTable;
        var distCodeTable;
        if (hdr === 1) {
            // compressed block, fixed codes
            litCodeTable = $106ef4d7516ef3d6$var$fixedLitCodeTab;
            distCodeTable = $106ef4d7516ef3d6$var$fixedDistCodeTab;
        } else if (hdr === 2) {
            // compressed block, dynamic codes
            var numLitCodes = this.getBits(5) + 257;
            var numDistCodes = this.getBits(5) + 1;
            var numCodeLenCodes = this.getBits(4) + 4;
            // build the code lengths code table
            var codeLenCodeLengths = new Uint8Array($106ef4d7516ef3d6$var$codeLenCodeMap.length);
            var i = void 0;
            for(i = 0; i < numCodeLenCodes; ++i)codeLenCodeLengths[$106ef4d7516ef3d6$var$codeLenCodeMap[i]] = this.getBits(3);
            var codeLenCodeTab = this.generateHuffmanTable(codeLenCodeLengths);
            // build the literal and distance code tables
            len = 0;
            i = 0;
            var codes = numLitCodes + numDistCodes;
            var codeLengths = new Uint8Array(codes);
            var bitsLength = void 0;
            var bitsOffset = void 0;
            var what = void 0;
            while(i < codes){
                var code = this.getCode(codeLenCodeTab);
                if (code === 16) {
                    bitsLength = 2;
                    bitsOffset = 3;
                    what = len;
                } else if (code === 17) {
                    bitsLength = 3;
                    bitsOffset = 3;
                    what = len = 0;
                } else if (code === 18) {
                    bitsLength = 7;
                    bitsOffset = 11;
                    what = len = 0;
                } else {
                    codeLengths[i++] = len = code;
                    continue;
                }
                var repeatLength = this.getBits(bitsLength) + bitsOffset;
                while(repeatLength-- > 0)codeLengths[i++] = what;
            }
            litCodeTable = this.generateHuffmanTable(codeLengths.subarray(0, numLitCodes));
            distCodeTable = this.generateHuffmanTable(codeLengths.subarray(numLitCodes, codes));
        } else throw new Error('Unknown block type in flate stream');
        buffer = this.buffer;
        var limit = buffer ? buffer.length : 0;
        var pos = this.bufferLength;
        while(true){
            var code1 = this.getCode(litCodeTable);
            if (code1 < 256) {
                if (pos + 1 >= limit) {
                    buffer = this.ensureBuffer(pos + 1);
                    limit = buffer.length;
                }
                buffer[pos++] = code1;
                continue;
            }
            if (code1 === 256) {
                this.bufferLength = pos;
                return;
            }
            code1 -= 257;
            code1 = $106ef4d7516ef3d6$var$lengthDecode[code1];
            var code2 = code1 >> 16;
            if (code2 > 0) code2 = this.getBits(code2);
            len = (code1 & 0xffff) + code2;
            code1 = this.getCode(distCodeTable);
            code1 = $106ef4d7516ef3d6$var$distDecode[code1];
            code2 = code1 >> 16;
            if (code2 > 0) code2 = this.getBits(code2);
            var dist = (code1 & 0xffff) + code2;
            if (pos + len >= limit) {
                buffer = this.ensureBuffer(pos + len);
                limit = buffer.length;
            }
            for(var k = 0; k < len; ++k, ++pos)buffer[pos] = buffer[pos - dist];
        }
    };
    FlateStream.prototype.getBits = function(bits) {
        var str = this.stream;
        var codeSize = this.codeSize;
        var codeBuf = this.codeBuf;
        var b;
        while(codeSize < bits){
            if ((b = str.getByte()) === -1) throw new Error('Bad encoding in flate stream');
            codeBuf |= b << codeSize;
            codeSize += 8;
        }
        b = codeBuf & (1 << bits) - 1;
        this.codeBuf = codeBuf >> bits;
        this.codeSize = codeSize -= bits;
        return b;
    };
    FlateStream.prototype.getCode = function(table) {
        var str = this.stream;
        var codes = table[0];
        var maxLen = table[1];
        var codeSize = this.codeSize;
        var codeBuf = this.codeBuf;
        var b;
        while(codeSize < maxLen){
            if ((b = str.getByte()) === -1) break;
            codeBuf |= b << codeSize;
            codeSize += 8;
        }
        var code = codes[codeBuf & (1 << maxLen) - 1];
        if (typeof codes === 'number') console.log('FLATE:', code);
        var codeLen = code >> 16;
        var codeVal = code & 0xffff;
        if (codeLen < 1 || codeSize < codeLen) throw new Error('Bad encoding in flate stream');
        this.codeBuf = codeBuf >> codeLen;
        this.codeSize = codeSize - codeLen;
        return codeVal;
    };
    FlateStream.prototype.generateHuffmanTable = function(lengths) {
        var n = lengths.length;
        // find max code length
        var maxLen = 0;
        var i;
        for(i = 0; i < n; ++i)if (lengths[i] > maxLen) maxLen = lengths[i];
        // build the table
        var size = 1 << maxLen;
        var codes = new Int32Array(size);
        for(var len = 1, code = 0, skip = 2; len <= maxLen; ++len, code <<= 1, skip <<= 1){
            for(var val = 0; val < n; ++val)if (lengths[val] === len) {
                // bit-reverse the code
                var code2 = 0;
                var t = code;
                for(i = 0; i < len; ++i){
                    code2 = code2 << 1 | t & 1;
                    t >>= 1;
                }
                // fill the table entries
                for(i = code2; i < size; i += skip)codes[i] = len << 16 | val;
                ++code;
            }
        }
        return [
            codes,
            maxLen
        ];
    };
    return FlateStream;
}((0, $9BULP.default));
var $106ef4d7516ef3d6$export$2e2bcd8739ae039 = $106ef4d7516ef3d6$var$FlateStream;

});

parcelRegister("hoQ98", function(module, exports) {

$parcel$export(module.exports, "default", () => $caad20b69225c7a9$export$2e2bcd8739ae039);
/*
 * Copyright 2012 Mozilla Foundation
 *
 * The LZWStream class contained in this file is a TypeScript port of the
 * JavaScript LZWStream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ 
var $cOQTW = parcelRequire("cOQTW");

var $9BULP = parcelRequire("9BULP");
var $caad20b69225c7a9$var$LZWStream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(LZWStream, _super);
    function LZWStream(stream, maybeLength, earlyChange) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        _this.cachedData = 0;
        _this.bitsCached = 0;
        var maxLzwDictionarySize = 4096;
        var lzwState = {
            earlyChange: earlyChange,
            codeLength: 9,
            nextCode: 258,
            dictionaryValues: new Uint8Array(maxLzwDictionarySize),
            dictionaryLengths: new Uint16Array(maxLzwDictionarySize),
            dictionaryPrevCodes: new Uint16Array(maxLzwDictionarySize),
            currentSequence: new Uint8Array(maxLzwDictionarySize),
            currentSequenceLength: 0
        };
        for(var i = 0; i < 256; ++i){
            lzwState.dictionaryValues[i] = i;
            lzwState.dictionaryLengths[i] = 1;
        }
        _this.lzwState = lzwState;
        return _this;
    }
    LZWStream.prototype.readBlock = function() {
        var blockSize = 512;
        var estimatedDecodedSize = blockSize * 2;
        var decodedSizeDelta = blockSize;
        var i;
        var j;
        var q;
        var lzwState = this.lzwState;
        if (!lzwState) return; // eof was found
        var earlyChange = lzwState.earlyChange;
        var nextCode = lzwState.nextCode;
        var dictionaryValues = lzwState.dictionaryValues;
        var dictionaryLengths = lzwState.dictionaryLengths;
        var dictionaryPrevCodes = lzwState.dictionaryPrevCodes;
        var codeLength = lzwState.codeLength;
        var prevCode = lzwState.prevCode;
        var currentSequence = lzwState.currentSequence;
        var currentSequenceLength = lzwState.currentSequenceLength;
        var decodedLength = 0;
        var currentBufferLength = this.bufferLength;
        var buffer = this.ensureBuffer(this.bufferLength + estimatedDecodedSize);
        for(i = 0; i < blockSize; i++){
            var code = this.readBits(codeLength);
            var hasPrev = currentSequenceLength > 0;
            if (!code || code < 256) {
                currentSequence[0] = code;
                currentSequenceLength = 1;
            } else if (code >= 258) {
                if (code < nextCode) {
                    currentSequenceLength = dictionaryLengths[code];
                    for(j = currentSequenceLength - 1, q = code; j >= 0; j--){
                        currentSequence[j] = dictionaryValues[q];
                        q = dictionaryPrevCodes[q];
                    }
                } else currentSequence[currentSequenceLength++] = currentSequence[0];
            } else if (code === 256) {
                codeLength = 9;
                nextCode = 258;
                currentSequenceLength = 0;
                continue;
            } else {
                this.eof = true;
                delete this.lzwState;
                break;
            }
            if (hasPrev) {
                dictionaryPrevCodes[nextCode] = prevCode;
                dictionaryLengths[nextCode] = dictionaryLengths[prevCode] + 1;
                dictionaryValues[nextCode] = currentSequence[0];
                nextCode++;
                codeLength = nextCode + earlyChange & nextCode + earlyChange - 1 ? codeLength : Math.min(Math.log(nextCode + earlyChange) / 0.6931471805599453 + 1, 12) | 0;
            }
            prevCode = code;
            decodedLength += currentSequenceLength;
            if (estimatedDecodedSize < decodedLength) {
                do estimatedDecodedSize += decodedSizeDelta;
                while (estimatedDecodedSize < decodedLength);
                buffer = this.ensureBuffer(this.bufferLength + estimatedDecodedSize);
            }
            for(j = 0; j < currentSequenceLength; j++)buffer[currentBufferLength++] = currentSequence[j];
        }
        lzwState.nextCode = nextCode;
        lzwState.codeLength = codeLength;
        lzwState.prevCode = prevCode;
        lzwState.currentSequenceLength = currentSequenceLength;
        this.bufferLength = currentBufferLength;
    };
    LZWStream.prototype.readBits = function(n) {
        var bitsCached = this.bitsCached;
        var cachedData = this.cachedData;
        while(bitsCached < n){
            var c = this.stream.getByte();
            if (c === -1) {
                this.eof = true;
                return null;
            }
            cachedData = cachedData << 8 | c;
            bitsCached += 8;
        }
        this.bitsCached = bitsCached -= n;
        this.cachedData = cachedData;
        return cachedData >>> bitsCached & (1 << n) - 1;
    };
    return LZWStream;
}((0, $9BULP.default));
var $caad20b69225c7a9$export$2e2bcd8739ae039 = $caad20b69225c7a9$var$LZWStream;

});

parcelRegister("oQP7X", function(module, exports) {

$parcel$export(module.exports, "default", () => $04ab37ade25dd344$export$2e2bcd8739ae039);
/*
 * Copyright 2012 Mozilla Foundation
 *
 * The RunLengthStream class contained in this file is a TypeScript port of the
 * JavaScript RunLengthStream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ 
var $cOQTW = parcelRequire("cOQTW");

var $9BULP = parcelRequire("9BULP");
var $04ab37ade25dd344$var$RunLengthStream = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(RunLengthStream, _super);
    function RunLengthStream(stream, maybeLength) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        return _this;
    }
    RunLengthStream.prototype.readBlock = function() {
        // The repeatHeader has following format. The first byte defines type of run
        // and amount of bytes to repeat/copy: n = 0 through 127 - copy next n bytes
        // (in addition to the second byte from the header), n = 129 through 255 -
        // duplicate the second byte from the header (257 - n) times, n = 128 - end.
        var repeatHeader = this.stream.getBytes(2);
        if (!repeatHeader || repeatHeader.length < 2 || repeatHeader[0] === 128) {
            this.eof = true;
            return;
        }
        var buffer;
        var bufferLength = this.bufferLength;
        var n = repeatHeader[0];
        if (n < 128) {
            // copy n bytes
            buffer = this.ensureBuffer(bufferLength + n + 1);
            buffer[bufferLength++] = repeatHeader[1];
            if (n > 0) {
                var source = this.stream.getBytes(n);
                buffer.set(source, bufferLength);
                bufferLength += n;
            }
        } else {
            n = 257 - n;
            var b = repeatHeader[1];
            buffer = this.ensureBuffer(bufferLength + n + 1);
            for(var i = 0; i < n; i++)buffer[bufferLength++] = b;
        }
        this.bufferLength = bufferLength;
    };
    return RunLengthStream;
}((0, $9BULP.default));
var $04ab37ade25dd344$export$2e2bcd8739ae039 = $04ab37ade25dd344$var$RunLengthStream;

});



parcelRegister("cpTWE", function(module, exports) {

$parcel$export(module.exports, "NonFullScreenPageMode", () => NonFullScreenPageMode);
$parcel$export(module.exports, "ReadingDirection", () => ReadingDirection);
$parcel$export(module.exports, "PrintScaling", () => PrintScaling);
$parcel$export(module.exports, "Duplex", () => Duplex);
$parcel$export(module.exports, "default", () => $90a3375623cd9a5a$export$2e2bcd8739ae039);

var $8auL6 = parcelRequire("8auL6");

var $8gQNC = parcelRequire("8gQNC");

var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
var asEnum = function(rawValue, enumType) {
    if (rawValue === undefined) return undefined;
    return enumType[rawValue];
};
var NonFullScreenPageMode;
(function(NonFullScreenPageMode) {
    /**
     * After exiting FullScreen mode, neither the document outline nor thumbnail
     * images should be visible.
     */ NonFullScreenPageMode["UseNone"] = "UseNone";
    /** After exiting FullScreen mode, the document outline should be visible. */ NonFullScreenPageMode["UseOutlines"] = "UseOutlines";
    /** After exiting FullScreen mode, thumbnail images should be visible. */ NonFullScreenPageMode["UseThumbs"] = "UseThumbs";
    /**
     * After exiting FullScreen mode, the optional content group panel should be
     * visible.
     */ NonFullScreenPageMode["UseOC"] = "UseOC";
})(NonFullScreenPageMode || (NonFullScreenPageMode = {}));
var ReadingDirection;
(function(ReadingDirection) {
    /** The predominant reading order is Left to Right. */ ReadingDirection["L2R"] = "L2R";
    /**
     * The predominant reading order is Right to left (including vertical writing
     * systems, such as Chinese, Japanese and Korean).
     */ ReadingDirection["R2L"] = "R2L";
})(ReadingDirection || (ReadingDirection = {}));
var PrintScaling;
(function(PrintScaling) {
    /** No page scaling. */ PrintScaling["None"] = "None";
    /* Use the PDF reader's default print scaling. */ PrintScaling["AppDefault"] = "AppDefault";
})(PrintScaling || (PrintScaling = {}));
var Duplex;
(function(Duplex) {
    /** The PDF reader should print single-sided. */ Duplex["Simplex"] = "Simplex";
    /**
     * The PDF reader should print double sided and flip on the short edge of the
     * sheet.
     */ Duplex["DuplexFlipShortEdge"] = "DuplexFlipShortEdge";
    /**
     * The PDF reader should print double sided and flip on the long edge of the
     * sheet.
     */ Duplex["DuplexFlipLongEdge"] = "DuplexFlipLongEdge";
})(Duplex || (Duplex = {}));
var ViewerPreferences = /** @class */ function() {
    /** @ignore */ function ViewerPreferences(dict) {
        this.dict = dict;
    }
    ViewerPreferences.prototype.lookupBool = function(key) {
        var returnObj = this.dict.lookup((0, $dPHSK.default).of(key));
        if (returnObj instanceof (0, $8gQNC.default)) return returnObj;
        return undefined;
    };
    ViewerPreferences.prototype.lookupName = function(key) {
        var returnObj = this.dict.lookup((0, $dPHSK.default).of(key));
        if (returnObj instanceof (0, $dPHSK.default)) return returnObj;
        return undefined;
    };
    /** @ignore */ ViewerPreferences.prototype.HideToolbar = function() {
        return this.lookupBool('HideToolbar');
    };
    /** @ignore */ ViewerPreferences.prototype.HideMenubar = function() {
        return this.lookupBool('HideMenubar');
    };
    /** @ignore */ ViewerPreferences.prototype.HideWindowUI = function() {
        return this.lookupBool('HideWindowUI');
    };
    /** @ignore */ ViewerPreferences.prototype.FitWindow = function() {
        return this.lookupBool('FitWindow');
    };
    /** @ignore */ ViewerPreferences.prototype.CenterWindow = function() {
        return this.lookupBool('CenterWindow');
    };
    /** @ignore */ ViewerPreferences.prototype.DisplayDocTitle = function() {
        return this.lookupBool('DisplayDocTitle');
    };
    /** @ignore */ ViewerPreferences.prototype.NonFullScreenPageMode = function() {
        return this.lookupName('NonFullScreenPageMode');
    };
    /** @ignore */ ViewerPreferences.prototype.Direction = function() {
        return this.lookupName('Direction');
    };
    /** @ignore */ ViewerPreferences.prototype.PrintScaling = function() {
        return this.lookupName('PrintScaling');
    };
    /** @ignore */ ViewerPreferences.prototype.Duplex = function() {
        return this.lookupName('Duplex');
    };
    /** @ignore */ ViewerPreferences.prototype.PickTrayByPDFSize = function() {
        return this.lookupBool('PickTrayByPDFSize');
    };
    /** @ignore */ ViewerPreferences.prototype.PrintPageRange = function() {
        var PrintPageRange = this.dict.lookup((0, $dPHSK.default).of('PrintPageRange'));
        if (PrintPageRange instanceof (0, $8auL6.default)) return PrintPageRange;
        return undefined;
    };
    /** @ignore */ ViewerPreferences.prototype.NumCopies = function() {
        var NumCopies = this.dict.lookup((0, $dPHSK.default).of('NumCopies'));
        if (NumCopies instanceof (0, $j04jt.default)) return NumCopies;
        return undefined;
    };
    /**
     * Returns `true` if PDF readers should hide the toolbar menus when displaying
     * this document.
     * @returns Whether or not toolbars should be hidden.
     */ ViewerPreferences.prototype.getHideToolbar = function() {
        var _a, _b;
        return (_b = (_a = this.HideToolbar()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if PDF readers should hide the menu bar when displaying this
     * document.
     * @returns Whether or not the menu bar should be hidden.
     */ ViewerPreferences.prototype.getHideMenubar = function() {
        var _a, _b;
        return (_b = (_a = this.HideMenubar()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if PDF readers should hide the user interface elements in
     * the document's window (such as scroll bars and navigation controls),
     * leaving only the document's contents displayed.
     * @returns Whether or not user interface elements should be hidden.
     */ ViewerPreferences.prototype.getHideWindowUI = function() {
        var _a, _b;
        return (_b = (_a = this.HideWindowUI()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if PDF readers should resize the document's window to fit
     * the size of the first displayed page.
     * @returns Whether or not the window should be resized to fit.
     */ ViewerPreferences.prototype.getFitWindow = function() {
        var _a, _b;
        return (_b = (_a = this.FitWindow()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if PDF readers should position the document's window in the
     * center of the screen.
     * @returns Whether or not to center the document window.
     */ ViewerPreferences.prototype.getCenterWindow = function() {
        var _a, _b;
        return (_b = (_a = this.CenterWindow()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if the window's title bar should display the document
     * `Title`, taken from the document metadata (see [[PDFDocument.getTitle]]).
     * Returns `false` if the title bar should instead display the filename of the
     * PDF file.
     * @returns Whether to display the document title.
     */ ViewerPreferences.prototype.getDisplayDocTitle = function() {
        var _a, _b;
        return (_b = (_a = this.DisplayDocTitle()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns the page mode, which tells the PDF reader how to display the
     * document after exiting full-screen mode.
     * @returns The page mode after exiting full-screen mode.
     */ ViewerPreferences.prototype.getNonFullScreenPageMode = function() {
        var _a, _b;
        var mode = (_a = this.NonFullScreenPageMode()) === null || _a === void 0 ? void 0 : _a.decodeText();
        return (_b = asEnum(mode, NonFullScreenPageMode)) !== null && _b !== void 0 ? _b : NonFullScreenPageMode.UseNone;
    };
    /**
     * Returns the predominant reading order for text.
     * @returns The text reading order.
     */ ViewerPreferences.prototype.getReadingDirection = function() {
        var _a, _b;
        var direction = (_a = this.Direction()) === null || _a === void 0 ? void 0 : _a.decodeText();
        return (_b = asEnum(direction, ReadingDirection)) !== null && _b !== void 0 ? _b : ReadingDirection.L2R;
    };
    /**
     * Returns the page scaling option that the PDF reader should select when the
     * print dialog is displayed.
     * @returns The page scaling option.
     */ ViewerPreferences.prototype.getPrintScaling = function() {
        var _a, _b;
        var scaling = (_a = this.PrintScaling()) === null || _a === void 0 ? void 0 : _a.decodeText();
        return (_b = asEnum(scaling, PrintScaling)) !== null && _b !== void 0 ? _b : PrintScaling.AppDefault;
    };
    /**
     * Returns the paper handling option that should be used when printing the
     * file from the print dialog.
     * @returns The paper handling option.
     */ ViewerPreferences.prototype.getDuplex = function() {
        var _a;
        var duplex = (_a = this.Duplex()) === null || _a === void 0 ? void 0 : _a.decodeText();
        return asEnum(duplex, Duplex);
    };
    /**
     * Returns `true` if the PDF page size should be used to select the input
     * paper tray.
     * @returns Whether or not the PDF page size should be used to select the
     *          input paper tray.
     */ ViewerPreferences.prototype.getPickTrayByPDFSize = function() {
        var _a;
        return (_a = this.PickTrayByPDFSize()) === null || _a === void 0 ? void 0 : _a.asBoolean();
    };
    /**
     * Returns an array of page number ranges, which are the values used to
     * initialize the print dialog box when the file is printed. Each range
     * specifies the first (`start`) and last (`end`) pages in a sub-range of
     * pages to be printed. The first page of the PDF file is denoted by 0.
     * For example:
     * ```js
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * const includesPage3 = viewerPrefs
     *   .getPrintRanges()
     *   .some(pr => pr.start =< 2 && pr.end >= 2)
     * if (includesPage3) console.log('printRange includes page 3')
     * ```
     * @returns An array of objects, each with the properties `start` and `end`,
     *          denoting page indices. If not, specified an empty array is
     *          returned.
     */ ViewerPreferences.prototype.getPrintPageRange = function() {
        var rng = this.PrintPageRange();
        if (!rng) return [];
        var pageRanges = [];
        for(var i = 0; i < rng.size(); i += 2){
            // Despite the spec clearly stating that "The first page of the PDF file
            // shall be donoted by 1", several test PDFs (spec 1.7) created in
            // Acrobat XI 11.0 and also read with Reader DC 2020.013 indicate this is
            // actually a 0 based index.
            var start = rng.lookup(i, (0, $j04jt.default)).asNumber();
            var end = rng.lookup(i + 1, (0, $j04jt.default)).asNumber();
            pageRanges.push({
                start: start,
                end: end
            });
        }
        return pageRanges;
    };
    /**
     * Returns the number of copies to be printed when the print dialog is opened
     * for this document.
     * @returns The default number of copies to be printed.
     */ ViewerPreferences.prototype.getNumCopies = function() {
        var _a, _b;
        return (_b = (_a = this.NumCopies()) === null || _a === void 0 ? void 0 : _a.asNumber()) !== null && _b !== void 0 ? _b : 1;
    };
    /**
     * Choose whether the PDF reader's toolbars should be hidden while the
     * document is active.
     * @param hideToolbar `true` if the toolbar should be hidden.
     */ ViewerPreferences.prototype.setHideToolbar = function(hideToolbar) {
        var HideToolbar = this.dict.context.obj(hideToolbar);
        this.dict.set((0, $dPHSK.default).of('HideToolbar'), HideToolbar);
    };
    /**
     * Choose whether the PDF reader's menu bar should be hidden while the
     * document is active.
     * @param hideMenubar `true` if the menu bar should be hidden.
     */ ViewerPreferences.prototype.setHideMenubar = function(hideMenubar) {
        var HideMenubar = this.dict.context.obj(hideMenubar);
        this.dict.set((0, $dPHSK.default).of('HideMenubar'), HideMenubar);
    };
    /**
     * Choose whether the PDF reader should hide user interface elements in the
     * document's window (such as scroll bars and navigation controls), leaving
     * only the document's contents displayed.
     * @param hideWindowUI `true` if the user interface elements should be hidden.
     */ ViewerPreferences.prototype.setHideWindowUI = function(hideWindowUI) {
        var HideWindowUI = this.dict.context.obj(hideWindowUI);
        this.dict.set((0, $dPHSK.default).of('HideWindowUI'), HideWindowUI);
    };
    /**
     * Choose whether the PDF reader should resize the document's window to fit
     * the size of the first displayed page.
     * @param fitWindow `true` if the window should be resized.
     */ ViewerPreferences.prototype.setFitWindow = function(fitWindow) {
        var FitWindow = this.dict.context.obj(fitWindow);
        this.dict.set((0, $dPHSK.default).of('FitWindow'), FitWindow);
    };
    /**
     * Choose whether the PDF reader should position the document's window in the
     * center of the screen.
     * @param centerWindow `true` if the window should be centered.
     */ ViewerPreferences.prototype.setCenterWindow = function(centerWindow) {
        var CenterWindow = this.dict.context.obj(centerWindow);
        this.dict.set((0, $dPHSK.default).of('CenterWindow'), CenterWindow);
    };
    /**
     * Choose whether the window's title bar should display the document `Title`
     * taken from the document metadata (see [[PDFDocument.setTitle]]). If
     * `false`, the title bar should instead display the PDF filename.
     * @param displayTitle `true` if the document title should be displayed.
     */ ViewerPreferences.prototype.setDisplayDocTitle = function(displayTitle) {
        var DisplayDocTitle = this.dict.context.obj(displayTitle);
        this.dict.set((0, $dPHSK.default).of('DisplayDocTitle'), DisplayDocTitle);
    };
    /**
     * Choose how the PDF reader should display the document upon exiting
     * full-screen mode. This entry is meaningful only if the value of the
     * `PageMode` entry in the document's [[PDFCatalog]] is `FullScreen`.
     *
     * For example:
     * ```js
     * import { PDFDocument, NonFullScreenPageMode, PDFName } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     *
     * // Set the PageMode
     * pdfDoc.catalog.set(PDFName.of('PageMode'),PDFName.of('FullScreen'))
     *
     * // Set what happens when full-screen is closed
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * viewerPrefs.setNonFullScreenPageMode(NonFullScreenPageMode.UseOutlines)
     * ```
     *
     * @param nonFullScreenPageMode How the document should be displayed upon
     *                              exiting full screen mode.
     */ ViewerPreferences.prototype.setNonFullScreenPageMode = function(nonFullScreenPageMode) {
        (0, $j0tvB.assertIsOneOf)(nonFullScreenPageMode, 'nonFullScreenPageMode', NonFullScreenPageMode);
        var mode = (0, $dPHSK.default).of(nonFullScreenPageMode);
        this.dict.set((0, $dPHSK.default).of('NonFullScreenPageMode'), mode);
    };
    /**
     * Choose the predominant reading order for text.
     *
     * This entry has no direct effect on the document's contents or page
     * numbering, but may be used to determine the relative positioning of pages
     * when displayed side by side or printed n-up.
     *
     * For example:
     * ```js
     * import { PDFDocument, ReadingDirection } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * viewerPrefs.setReadingDirection(ReadingDirection.R2L)
     * ```
     *
     * @param readingDirection The reading order for text.
     */ ViewerPreferences.prototype.setReadingDirection = function(readingDirection) {
        (0, $j0tvB.assertIsOneOf)(readingDirection, 'readingDirection', ReadingDirection);
        var direction = (0, $dPHSK.default).of(readingDirection);
        this.dict.set((0, $dPHSK.default).of('Direction'), direction);
    };
    /**
     * Choose the page scaling option that should be selected when a print dialog
     * is displayed for this document.
     *
     * For example:
     * ```js
     * import { PDFDocument, PrintScaling } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * viewerPrefs.setPrintScaling(PrintScaling.None)
     * ```
     *
     * @param printScaling The print scaling option.
     */ ViewerPreferences.prototype.setPrintScaling = function(printScaling) {
        (0, $j0tvB.assertIsOneOf)(printScaling, 'printScaling', PrintScaling);
        var scaling = (0, $dPHSK.default).of(printScaling);
        this.dict.set((0, $dPHSK.default).of('PrintScaling'), scaling);
    };
    /**
     * Choose the paper handling option that should be selected by default in the
     * print dialog.
     *
     * For example:
     * ```js
     * import { PDFDocument, Duplex } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * viewerPrefs.setDuplex(Duplex.DuplexFlipShortEdge)
     * ```
     *
     * @param duplex The double or single sided printing option.
     */ ViewerPreferences.prototype.setDuplex = function(duplex) {
        (0, $j0tvB.assertIsOneOf)(duplex, 'duplex', Duplex);
        var dup = (0, $dPHSK.default).of(duplex);
        this.dict.set((0, $dPHSK.default).of('Duplex'), dup);
    };
    /**
     * Choose whether the PDF document's page size should be used to select the
     * input paper tray when printing. This setting influences only the preset
     * values used to populate the print dialog presented by a PDF reader.
     *
     * If PickTrayByPDFSize is true, the check box in the print dialog associated
     * with input paper tray should be checked. This setting has no effect on
     * operating systems that do not provide the ability to pick the input tray
     * by size.
     *
     * @param pickTrayByPDFSize `true` if the document's page size should be used
     *                          to select the input paper tray.
     */ ViewerPreferences.prototype.setPickTrayByPDFSize = function(pickTrayByPDFSize) {
        var PickTrayByPDFSize = this.dict.context.obj(pickTrayByPDFSize);
        this.dict.set((0, $dPHSK.default).of('PickTrayByPDFSize'), PickTrayByPDFSize);
    };
    /**
     * Choose the page numbers used to initialize the print dialog box when the
     * file is printed. The first page of the PDF file is denoted by 0.
     *
     * For example:
     * ```js
     * import { PDFDocument } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     *
     * // We can set the default print range to only the first page
     * viewerPrefs.setPrintPageRange({ start: 0, end: 0 })
     *
     * // Or we can supply noncontiguous ranges (e.g. pages 1, 3, and 5-7)
     * viewerPrefs.setPrintPageRange([
     *   { start: 0, end: 0 },
     *   { start: 2, end: 2 },
     *   { start: 4, end: 6 },
     * ])
     * ```
     *
     * @param printPageRange An object or array of objects, each with the
     *                       properties `start` and `end`, denoting a range of
     *                       page indices.
     */ ViewerPreferences.prototype.setPrintPageRange = function(printPageRange) {
        if (!Array.isArray(printPageRange)) printPageRange = [
            printPageRange
        ];
        var flatRange = [];
        for(var idx = 0, len = printPageRange.length; idx < len; idx++){
            flatRange.push(printPageRange[idx].start);
            flatRange.push(printPageRange[idx].end);
        }
        (0, $j0tvB.assertEachIs)(flatRange, 'printPageRange', [
            'number'
        ]);
        var pageRanges = this.dict.context.obj(flatRange);
        this.dict.set((0, $dPHSK.default).of('PrintPageRange'), pageRanges);
    };
    /**
     * Choose the default number of copies to be printed when the print dialog is
     * opened for this file.
     * @param numCopies The default number of copies.
     */ ViewerPreferences.prototype.setNumCopies = function(numCopies) {
        (0, $j0tvB.assertRange)(numCopies, 'numCopies', 1, Number.MAX_VALUE);
        (0, $j0tvB.assertInteger)(numCopies, 'numCopies');
        var NumCopies = this.dict.context.obj(numCopies);
        this.dict.set((0, $dPHSK.default).of('NumCopies'), NumCopies);
    };
    /** @ignore */ ViewerPreferences.fromDict = function(dict) {
        return new ViewerPreferences(dict);
    };
    /** @ignore */ ViewerPreferences.create = function(context) {
        var dict = context.obj({});
        return new ViewerPreferences(dict);
    };
    return ViewerPreferences;
}();
var $90a3375623cd9a5a$export$2e2bcd8739ae039 = ViewerPreferences;

});

parcelRegister("b3l66", function(module, exports) {

$parcel$export(module.exports, "default", () => $80c05707f2c8c1f7$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $brir8 = parcelRequire("brir8");

var $dPHSK = parcelRequire("dPHSK");
parcelRequire("hO9YF");
var $flrAV = parcelRequire("flrAV");

var $cpTWE = parcelRequire("cpTWE");
var $80c05707f2c8c1f7$var$PDFCatalog = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFCatalog, _super);
    function PDFCatalog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFCatalog.prototype.Pages = function() {
        return this.lookup((0, $dPHSK.default).of('Pages'), (0, $brir8.default));
    };
    PDFCatalog.prototype.AcroForm = function() {
        return this.lookupMaybe((0, $dPHSK.default).of('AcroForm'), (0, $brir8.default));
    };
    PDFCatalog.prototype.getAcroForm = function() {
        var dict = this.AcroForm();
        if (!dict) return undefined;
        return (0, $flrAV.default).fromDict(dict);
    };
    PDFCatalog.prototype.getOrCreateAcroForm = function() {
        var acroForm = this.getAcroForm();
        if (!acroForm) {
            acroForm = (0, $flrAV.default).create(this.context);
            var acroFormRef = this.context.register(acroForm.dict);
            this.set((0, $dPHSK.default).of('AcroForm'), acroFormRef);
        }
        return acroForm;
    };
    PDFCatalog.prototype.ViewerPreferences = function() {
        return this.lookupMaybe((0, $dPHSK.default).of('ViewerPreferences'), (0, $brir8.default));
    };
    PDFCatalog.prototype.getViewerPreferences = function() {
        var dict = this.ViewerPreferences();
        if (!dict) return undefined;
        return (0, $cpTWE.default).fromDict(dict);
    };
    PDFCatalog.prototype.getOrCreateViewerPreferences = function() {
        var viewerPrefs = this.getViewerPreferences();
        if (!viewerPrefs) {
            viewerPrefs = (0, $cpTWE.default).create(this.context);
            var viewerPrefsRef = this.context.register(viewerPrefs.dict);
            this.set((0, $dPHSK.default).of('ViewerPreferences'), viewerPrefsRef);
        }
        return viewerPrefs;
    };
    /**
     * Inserts the given ref as a leaf node of this catalog's page tree at the
     * specified index (zero-based). Also increments the `Count` of each node in
     * the page tree hierarchy to accomodate the new page.
     *
     * Returns the ref of the PDFPageTree node into which `leafRef` was inserted.
     */ PDFCatalog.prototype.insertLeafNode = function(leafRef, index) {
        var pagesRef = this.get((0, $dPHSK.default).of('Pages'));
        var maybeParentRef = this.Pages().insertLeafNode(leafRef, index);
        return maybeParentRef || pagesRef;
    };
    PDFCatalog.prototype.removeLeafNode = function(index) {
        this.Pages().removeLeafNode(index);
    };
    PDFCatalog.withContextAndPages = function(context, pages) {
        var dict = new Map();
        dict.set((0, $dPHSK.default).of('Type'), (0, $dPHSK.default).of('Catalog'));
        dict.set((0, $dPHSK.default).of('Pages'), pages);
        return new PDFCatalog(dict, context);
    };
    PDFCatalog.fromMapWithContext = function(map, context) {
        return new PDFCatalog(map, context);
    };
    return PDFCatalog;
}((0, $brir8.default));
var $80c05707f2c8c1f7$export$2e2bcd8739ae039 = $80c05707f2c8c1f7$var$PDFCatalog;

});
parcelRegister("hO9YF", function(module, exports) {
$parcel$export(module.exports, "AcroButtonFlags", () => (parcelRequire("d5IrD")).AcroButtonFlags);
$parcel$export(module.exports, "AcroChoiceFlags", () => (parcelRequire("d5IrD")).AcroChoiceFlags);
$parcel$export(module.exports, "AcroFieldFlags", () => (parcelRequire("d5IrD")).AcroFieldFlags);
$parcel$export(module.exports, "AcroTextFlags", () => (parcelRequire("d5IrD")).AcroTextFlags);
$parcel$export(module.exports, "createPDFAcroFields", () => (parcelRequire("gkGMc")).createPDFAcroFields);

$parcel$export(module.exports, "PDFAcroCheckBox", () => (parcelRequire("lmORt")).default);
$parcel$export(module.exports, "PDFAcroComboBox", () => (parcelRequire("4vDg3")).default);
$parcel$export(module.exports, "PDFAcroForm", () => (parcelRequire("flrAV")).default);
$parcel$export(module.exports, "PDFAcroListBox", () => (parcelRequire("gEqSi")).default);
$parcel$export(module.exports, "PDFAcroNonTerminal", () => (parcelRequire("dP7Ar")).default);
$parcel$export(module.exports, "PDFAcroPushButton", () => (parcelRequire("1757u")).default);
$parcel$export(module.exports, "PDFAcroRadioButton", () => (parcelRequire("hpItd")).default);
$parcel$export(module.exports, "PDFAcroSignature", () => (parcelRequire("7hDvO")).default);
$parcel$export(module.exports, "PDFAcroTerminal", () => (parcelRequire("64Z70")).default);
$parcel$export(module.exports, "PDFAcroText", () => (parcelRequire("clInn")).default);

var $bYlnh = parcelRequire("bYlnh");

var $lmORt = parcelRequire("lmORt");

var $1pFNX = parcelRequire("1pFNX");

var $4vDg3 = parcelRequire("4vDg3");

var $50MTm = parcelRequire("50MTm");

var $flrAV = parcelRequire("flrAV");

var $gEqSi = parcelRequire("gEqSi");

var $dP7Ar = parcelRequire("dP7Ar");

var $1757u = parcelRequire("1757u");

var $hpItd = parcelRequire("hpItd");

var $7hDvO = parcelRequire("7hDvO");

var $64Z70 = parcelRequire("64Z70");

var $clInn = parcelRequire("clInn");
parcelRequire("d5IrD");
parcelRequire("gkGMc");

});
parcelRegister("bYlnh", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b75e0d2aabd8761$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $8dCYu = parcelRequire("8dCYu");

var $jWFiV = parcelRequire("jWFiV");

var $8auL6 = parcelRequire("8auL6");

var $dPHSK = parcelRequire("dPHSK");

var $64Z70 = parcelRequire("64Z70");

var $nAWRe = parcelRequire("nAWRe");
var $8b75e0d2aabd8761$var$PDFAcroButton = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroButton, _super);
    function PDFAcroButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroButton.prototype.Opt = function() {
        return this.dict.lookupMaybe((0, $dPHSK.default).of('Opt'), (0, $8dCYu.default), (0, $jWFiV.default), (0, $8auL6.default));
    };
    PDFAcroButton.prototype.setOpt = function(opt) {
        this.dict.set((0, $dPHSK.default).of('Opt'), this.dict.context.obj(opt));
    };
    PDFAcroButton.prototype.getExportValues = function() {
        var opt = this.Opt();
        if (!opt) return undefined;
        if (opt instanceof (0, $8dCYu.default) || opt instanceof (0, $jWFiV.default)) return [
            opt
        ];
        var values = [];
        for(var idx = 0, len = opt.size(); idx < len; idx++){
            var value = opt.lookup(idx);
            if (value instanceof (0, $8dCYu.default) || value instanceof (0, $jWFiV.default)) values.push(value);
        }
        return values;
    };
    PDFAcroButton.prototype.removeExportValue = function(idx) {
        var opt = this.Opt();
        if (!opt) return;
        if (opt instanceof (0, $8dCYu.default) || opt instanceof (0, $jWFiV.default)) {
            if (idx !== 0) throw new (0, $nAWRe.IndexOutOfBoundsError)(idx, 0, 0);
            this.setOpt([]);
        } else {
            if (idx < 0 || idx > opt.size()) throw new (0, $nAWRe.IndexOutOfBoundsError)(idx, 0, opt.size());
            opt.remove(idx);
        }
    };
    // Enforce use use of /Opt even if it isn't strictly necessary
    PDFAcroButton.prototype.normalizeExportValues = function() {
        var _a, _b, _c, _d;
        var exportValues = (_a = this.getExportValues()) !== null && _a !== void 0 ? _a : [];
        var Opt = [];
        var widgets = this.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var exportVal = (_b = exportValues[idx]) !== null && _b !== void 0 ? _b : (0, $jWFiV.default).fromText((_d = (_c = widget.getOnValue()) === null || _c === void 0 ? void 0 : _c.decodeText()) !== null && _d !== void 0 ? _d : '');
            Opt.push(exportVal);
        }
        this.setOpt(Opt);
    };
    /**
     * Reuses existing opt if one exists with the same value (assuming
     * `useExistingIdx` is `true`). Returns index of existing (or new) opt.
     */ PDFAcroButton.prototype.addOpt = function(opt, useExistingOptIdx) {
        var _a;
        this.normalizeExportValues();
        var optText = opt.decodeText();
        var existingIdx;
        if (useExistingOptIdx) {
            var exportValues = (_a = this.getExportValues()) !== null && _a !== void 0 ? _a : [];
            for(var idx = 0, len = exportValues.length; idx < len; idx++){
                var exportVal = exportValues[idx];
                if (exportVal.decodeText() === optText) existingIdx = idx;
            }
        }
        var Opt = this.Opt();
        Opt.push(opt);
        return existingIdx !== null && existingIdx !== void 0 ? existingIdx : Opt.size() - 1;
    };
    PDFAcroButton.prototype.addWidgetWithOpt = function(widget, opt, useExistingOptIdx) {
        var optIdx = this.addOpt(opt, useExistingOptIdx);
        var apStateValue = (0, $dPHSK.default).of(String(optIdx));
        this.addWidget(widget);
        return apStateValue;
    };
    return PDFAcroButton;
}((0, $64Z70.default));
var $8b75e0d2aabd8761$export$2e2bcd8739ae039 = $8b75e0d2aabd8761$var$PDFAcroButton;

});
parcelRegister("64Z70", function(module, exports) {

$parcel$export(module.exports, "default", () => $46d285649821c095$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $brir8 = parcelRequire("brir8");

var $dPHSK = parcelRequire("dPHSK");

var $50MTm = parcelRequire("50MTm");

var $7ds0z = parcelRequire("7ds0z");

var $nAWRe = parcelRequire("nAWRe");
var $46d285649821c095$var$PDFAcroTerminal = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroTerminal, _super);
    function PDFAcroTerminal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroTerminal.prototype.FT = function() {
        var nameOrRef = this.getInheritableAttribute((0, $dPHSK.default).of('FT'));
        return this.dict.context.lookup(nameOrRef, (0, $dPHSK.default));
    };
    PDFAcroTerminal.prototype.getWidgets = function() {
        var kidDicts = this.Kids();
        // This field is itself a widget
        if (!kidDicts) return [
            (0, $7ds0z.default).fromDict(this.dict)
        ];
        // This field's kids are its widgets
        var widgets = new Array(kidDicts.size());
        for(var idx = 0, len = kidDicts.size(); idx < len; idx++){
            var dict = kidDicts.lookup(idx, (0, $brir8.default));
            widgets[idx] = (0, $7ds0z.default).fromDict(dict);
        }
        return widgets;
    };
    PDFAcroTerminal.prototype.addWidget = function(ref) {
        var Kids = this.normalizedEntries().Kids;
        Kids.push(ref);
    };
    PDFAcroTerminal.prototype.removeWidget = function(idx) {
        var kidDicts = this.Kids();
        if (!kidDicts) {
            // This field is itself a widget
            if (idx !== 0) throw new (0, $nAWRe.IndexOutOfBoundsError)(idx, 0, 0);
            this.setKids([]);
        } else {
            // This field's kids are its widgets
            if (idx < 0 || idx > kidDicts.size()) throw new (0, $nAWRe.IndexOutOfBoundsError)(idx, 0, kidDicts.size());
            kidDicts.remove(idx);
        }
    };
    PDFAcroTerminal.prototype.normalizedEntries = function() {
        var Kids = this.Kids();
        // If this field is itself a widget (because it was only rendered once in
        // the document, so the field and widget properties were merged) then we
        // add itself to the `Kids` array. The alternative would be to try
        // splitting apart the widget properties and creating a separate object
        // for them.
        if (!Kids) {
            Kids = this.dict.context.obj([
                this.ref
            ]);
            this.dict.set((0, $dPHSK.default).of('Kids'), Kids);
        }
        return {
            Kids: Kids
        };
    };
    PDFAcroTerminal.fromDict = function(dict, ref) {
        return new PDFAcroTerminal(dict, ref);
    };
    return PDFAcroTerminal;
}((0, $50MTm.default));
var $46d285649821c095$export$2e2bcd8739ae039 = $46d285649821c095$var$PDFAcroTerminal;

});
parcelRegister("50MTm", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a62e0bdc23bf2e5$export$2e2bcd8739ae039);

var $brir8 = parcelRequire("brir8");

var $8dCYu = parcelRequire("8dCYu");

var $jWFiV = parcelRequire("jWFiV");

var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");

var $8auL6 = parcelRequire("8auL6");

var $kHzkO = parcelRequire("kHzkO");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");

var $nAWRe = parcelRequire("nAWRe");
// Examples:
//   `/Helv 12 Tf` -> ['Helv', '12']
//   `/HeBo 8.00 Tf` -> ['HeBo', '8.00']
//   `/HeBo Tf` -> ['HeBo', undefined]
var $3a62e0bdc23bf2e5$var$tfRegex = /\/([^\0\t\n\f\r\ ]+)[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]+Tf/;
var $3a62e0bdc23bf2e5$var$PDFAcroField = /** @class */ function() {
    function PDFAcroField(dict, ref) {
        this.dict = dict;
        this.ref = ref;
    }
    PDFAcroField.prototype.T = function() {
        return this.dict.lookupMaybe((0, $dPHSK.default).of('T'), (0, $8dCYu.default), (0, $jWFiV.default));
    };
    PDFAcroField.prototype.Ff = function() {
        var numberOrRef = this.getInheritableAttribute((0, $dPHSK.default).of('Ff'));
        return this.dict.context.lookupMaybe(numberOrRef, (0, $j04jt.default));
    };
    PDFAcroField.prototype.V = function() {
        var valueOrRef = this.getInheritableAttribute((0, $dPHSK.default).of('V'));
        return this.dict.context.lookup(valueOrRef);
    };
    PDFAcroField.prototype.Kids = function() {
        return this.dict.lookupMaybe((0, $dPHSK.default).of('Kids'), (0, $8auL6.default));
    };
    // Parent(): PDFDict | undefined {
    //   return this.dict.lookupMaybe(PDFName.of('Parent'), PDFDict);
    // }
    PDFAcroField.prototype.DA = function() {
        var da = this.dict.lookup((0, $dPHSK.default).of('DA'));
        if (da instanceof (0, $8dCYu.default) || da instanceof (0, $jWFiV.default)) return da;
        return undefined;
    };
    PDFAcroField.prototype.setKids = function(kids) {
        this.dict.set((0, $dPHSK.default).of('Kids'), this.dict.context.obj(kids));
    };
    PDFAcroField.prototype.getParent = function() {
        // const parent = this.Parent();
        // if (!parent) return undefined;
        // return new PDFAcroField(parent);
        var parentRef = this.dict.get((0, $dPHSK.default).of('Parent'));
        if (parentRef instanceof (0, $kHzkO.default)) {
            var parent_1 = this.dict.lookup((0, $dPHSK.default).of('Parent'), (0, $brir8.default));
            return new PDFAcroField(parent_1, parentRef);
        }
        return undefined;
    };
    PDFAcroField.prototype.setParent = function(parent) {
        if (!parent) this.dict.delete((0, $dPHSK.default).of('Parent'));
        else this.dict.set((0, $dPHSK.default).of('Parent'), parent);
    };
    PDFAcroField.prototype.getFullyQualifiedName = function() {
        var parent = this.getParent();
        if (!parent) return this.getPartialName();
        return parent.getFullyQualifiedName() + "." + this.getPartialName();
    };
    PDFAcroField.prototype.getPartialName = function() {
        var _a;
        return (_a = this.T()) === null || _a === void 0 ? void 0 : _a.decodeText();
    };
    PDFAcroField.prototype.setPartialName = function(partialName) {
        if (!partialName) this.dict.delete((0, $dPHSK.default).of('T'));
        else this.dict.set((0, $dPHSK.default).of('T'), (0, $jWFiV.default).fromText(partialName));
    };
    PDFAcroField.prototype.setDefaultAppearance = function(appearance) {
        this.dict.set((0, $dPHSK.default).of('DA'), (0, $8dCYu.default).of(appearance));
    };
    PDFAcroField.prototype.getDefaultAppearance = function() {
        var DA = this.DA();
        if (DA instanceof (0, $jWFiV.default)) return DA.decodeText();
        return DA === null || DA === void 0 ? void 0 : DA.asString();
    };
    PDFAcroField.prototype.setFontSize = function(fontSize) {
        var _a;
        var name = (_a = this.getFullyQualifiedName()) !== null && _a !== void 0 ? _a : '';
        var da = this.getDefaultAppearance();
        if (!da) throw new (0, $nAWRe.MissingDAEntryError)(name);
        var daMatch = (0, $7Kmy8.findLastMatch)(da, $3a62e0bdc23bf2e5$var$tfRegex);
        if (!daMatch.match) throw new (0, $nAWRe.MissingTfOperatorError)(name);
        var daStart = da.slice(0, daMatch.pos - daMatch.match[0].length);
        var daEnd = daMatch.pos <= da.length ? da.slice(daMatch.pos) : '';
        var fontName = daMatch.match[1];
        var modifiedDa = daStart + " /" + fontName + " " + fontSize + " Tf " + daEnd;
        this.setDefaultAppearance(modifiedDa);
    };
    PDFAcroField.prototype.getFlags = function() {
        var _a, _b;
        return (_b = (_a = this.Ff()) === null || _a === void 0 ? void 0 : _a.asNumber()) !== null && _b !== void 0 ? _b : 0;
    };
    PDFAcroField.prototype.setFlags = function(flags) {
        this.dict.set((0, $dPHSK.default).of('Ff'), (0, $j04jt.default).of(flags));
    };
    PDFAcroField.prototype.hasFlag = function(flag) {
        var flags = this.getFlags();
        return (flags & flag) !== 0;
    };
    PDFAcroField.prototype.setFlag = function(flag) {
        var flags = this.getFlags();
        this.setFlags(flags | flag);
    };
    PDFAcroField.prototype.clearFlag = function(flag) {
        var flags = this.getFlags();
        this.setFlags(flags & ~flag);
    };
    PDFAcroField.prototype.setFlagTo = function(flag, enable) {
        if (enable) this.setFlag(flag);
        else this.clearFlag(flag);
    };
    PDFAcroField.prototype.getInheritableAttribute = function(name) {
        var attribute;
        this.ascend(function(node) {
            if (!attribute) attribute = node.dict.get(name);
        });
        return attribute;
    };
    PDFAcroField.prototype.ascend = function(visitor) {
        visitor(this);
        var parent = this.getParent();
        if (parent) parent.ascend(visitor);
    };
    return PDFAcroField;
}();
var $3a62e0bdc23bf2e5$export$2e2bcd8739ae039 = $3a62e0bdc23bf2e5$var$PDFAcroField;

});

parcelRegister("7ds0z", function(module, exports) {

$parcel$export(module.exports, "default", () => $540f7922618e60a2$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $brir8 = parcelRequire("brir8");

var $dPHSK = parcelRequire("dPHSK");

var $kHzkO = parcelRequire("kHzkO");

var $8dCYu = parcelRequire("8dCYu");

var $jWFiV = parcelRequire("jWFiV");

var $2tiKE = parcelRequire("2tiKE");

var $frgJX = parcelRequire("frgJX");

var $6293R = parcelRequire("6293R");
var $540f7922618e60a2$var$PDFWidgetAnnotation = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFWidgetAnnotation, _super);
    function PDFWidgetAnnotation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFWidgetAnnotation.prototype.MK = function() {
        var MK = this.dict.lookup((0, $dPHSK.default).of('MK'));
        if (MK instanceof (0, $brir8.default)) return MK;
        return undefined;
    };
    PDFWidgetAnnotation.prototype.BS = function() {
        var BS = this.dict.lookup((0, $dPHSK.default).of('BS'));
        if (BS instanceof (0, $brir8.default)) return BS;
        return undefined;
    };
    PDFWidgetAnnotation.prototype.DA = function() {
        var da = this.dict.lookup((0, $dPHSK.default).of('DA'));
        if (da instanceof (0, $8dCYu.default) || da instanceof (0, $jWFiV.default)) return da;
        return undefined;
    };
    PDFWidgetAnnotation.prototype.P = function() {
        var P = this.dict.get((0, $dPHSK.default).of('P'));
        if (P instanceof (0, $kHzkO.default)) return P;
        return undefined;
    };
    PDFWidgetAnnotation.prototype.setP = function(page) {
        this.dict.set((0, $dPHSK.default).of('P'), page);
    };
    PDFWidgetAnnotation.prototype.setDefaultAppearance = function(appearance) {
        this.dict.set((0, $dPHSK.default).of('DA'), (0, $8dCYu.default).of(appearance));
    };
    PDFWidgetAnnotation.prototype.getDefaultAppearance = function() {
        var DA = this.DA();
        if (DA instanceof (0, $jWFiV.default)) return DA.decodeText();
        return DA === null || DA === void 0 ? void 0 : DA.asString();
    };
    PDFWidgetAnnotation.prototype.getAppearanceCharacteristics = function() {
        var MK = this.MK();
        if (MK) return (0, $6293R.default).fromDict(MK);
        return undefined;
    };
    PDFWidgetAnnotation.prototype.getOrCreateAppearanceCharacteristics = function() {
        var MK = this.MK();
        if (MK) return (0, $6293R.default).fromDict(MK);
        var ac = (0, $6293R.default).fromDict(this.dict.context.obj({}));
        this.dict.set((0, $dPHSK.default).of('MK'), ac.dict);
        return ac;
    };
    PDFWidgetAnnotation.prototype.getBorderStyle = function() {
        var BS = this.BS();
        if (BS) return (0, $2tiKE.default).fromDict(BS);
        return undefined;
    };
    PDFWidgetAnnotation.prototype.getOrCreateBorderStyle = function() {
        var BS = this.BS();
        if (BS) return (0, $2tiKE.default).fromDict(BS);
        var bs = (0, $2tiKE.default).fromDict(this.dict.context.obj({}));
        this.dict.set((0, $dPHSK.default).of('BS'), bs.dict);
        return bs;
    };
    PDFWidgetAnnotation.prototype.getOnValue = function() {
        var _a;
        var normal = (_a = this.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal;
        if (normal instanceof (0, $brir8.default)) {
            var keys = normal.keys();
            for(var idx = 0, len = keys.length; idx < len; idx++){
                var key = keys[idx];
                if (key !== (0, $dPHSK.default).of('Off')) return key;
            }
        }
        return undefined;
    };
    PDFWidgetAnnotation.fromDict = function(dict) {
        return new PDFWidgetAnnotation(dict);
    };
    PDFWidgetAnnotation.create = function(context, parent) {
        var dict = context.obj({
            Type: 'Annot',
            Subtype: 'Widget',
            Rect: [
                0,
                0,
                0,
                0
            ],
            Parent: parent
        });
        return new PDFWidgetAnnotation(dict);
    };
    return PDFWidgetAnnotation;
}((0, $frgJX.default));
var $540f7922618e60a2$export$2e2bcd8739ae039 = $540f7922618e60a2$var$PDFWidgetAnnotation;

});
parcelRegister("2tiKE", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cccd5df89c90385$export$2e2bcd8739ae039);

var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");
// TODO: Also handle the `/S` and `/D` entries
var $1cccd5df89c90385$var$BorderStyle = /** @class */ function() {
    function BorderStyle(dict) {
        this.dict = dict;
    }
    BorderStyle.prototype.W = function() {
        var W = this.dict.lookup((0, $dPHSK.default).of('W'));
        if (W instanceof (0, $j04jt.default)) return W;
        return undefined;
    };
    BorderStyle.prototype.getWidth = function() {
        var _a, _b;
        return (_b = (_a = this.W()) === null || _a === void 0 ? void 0 : _a.asNumber()) !== null && _b !== void 0 ? _b : 1;
    };
    BorderStyle.prototype.setWidth = function(width) {
        var W = this.dict.context.obj(width);
        this.dict.set((0, $dPHSK.default).of('W'), W);
    };
    BorderStyle.fromDict = function(dict) {
        return new BorderStyle(dict);
    };
    return BorderStyle;
}();
var $1cccd5df89c90385$export$2e2bcd8739ae039 = $1cccd5df89c90385$var$BorderStyle;

});

parcelRegister("frgJX", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3d65ce7bc0fb74b$export$2e2bcd8739ae039);

var $brir8 = parcelRequire("brir8");

var $dPHSK = parcelRequire("dPHSK");

var $4CgUJ = parcelRequire("4CgUJ");

var $8auL6 = parcelRequire("8auL6");

var $kHzkO = parcelRequire("kHzkO");

var $j04jt = parcelRequire("j04jt");
var $b3d65ce7bc0fb74b$var$PDFAnnotation = /** @class */ function() {
    function PDFAnnotation(dict) {
        this.dict = dict;
    }
    // This is technically required by the PDF spec
    PDFAnnotation.prototype.Rect = function() {
        return this.dict.lookup((0, $dPHSK.default).of('Rect'), (0, $8auL6.default));
    };
    PDFAnnotation.prototype.AP = function() {
        return this.dict.lookupMaybe((0, $dPHSK.default).of('AP'), (0, $brir8.default));
    };
    PDFAnnotation.prototype.F = function() {
        var numberOrRef = this.dict.lookup((0, $dPHSK.default).of('F'));
        return this.dict.context.lookupMaybe(numberOrRef, (0, $j04jt.default));
    };
    PDFAnnotation.prototype.getRectangle = function() {
        var _a;
        var Rect = this.Rect();
        return (_a = Rect === null || Rect === void 0 ? void 0 : Rect.asRectangle()) !== null && _a !== void 0 ? _a : {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
    };
    PDFAnnotation.prototype.setRectangle = function(rect) {
        var x = rect.x, y = rect.y, width = rect.width, height = rect.height;
        var Rect = this.dict.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.dict.set((0, $dPHSK.default).of('Rect'), Rect);
    };
    PDFAnnotation.prototype.getAppearanceState = function() {
        var AS = this.dict.lookup((0, $dPHSK.default).of('AS'));
        if (AS instanceof (0, $dPHSK.default)) return AS;
        return undefined;
    };
    PDFAnnotation.prototype.setAppearanceState = function(state) {
        this.dict.set((0, $dPHSK.default).of('AS'), state);
    };
    PDFAnnotation.prototype.setAppearances = function(appearances) {
        this.dict.set((0, $dPHSK.default).of('AP'), appearances);
    };
    PDFAnnotation.prototype.ensureAP = function() {
        var AP = this.AP();
        if (!AP) {
            AP = this.dict.context.obj({});
            this.dict.set((0, $dPHSK.default).of('AP'), AP);
        }
        return AP;
    };
    PDFAnnotation.prototype.getNormalAppearance = function() {
        var AP = this.ensureAP();
        var N = AP.get((0, $dPHSK.default).of('N'));
        if (N instanceof (0, $kHzkO.default) || N instanceof (0, $brir8.default)) return N;
        throw new Error("Unexpected N type: " + (N === null || N === void 0 ? void 0 : N.constructor.name));
    };
    /** @param appearance A PDFDict or PDFStream (direct or ref) */ PDFAnnotation.prototype.setNormalAppearance = function(appearance) {
        var AP = this.ensureAP();
        AP.set((0, $dPHSK.default).of('N'), appearance);
    };
    /** @param appearance A PDFDict or PDFStream (direct or ref) */ PDFAnnotation.prototype.setRolloverAppearance = function(appearance) {
        var AP = this.ensureAP();
        AP.set((0, $dPHSK.default).of('R'), appearance);
    };
    /** @param appearance A PDFDict or PDFStream (direct or ref) */ PDFAnnotation.prototype.setDownAppearance = function(appearance) {
        var AP = this.ensureAP();
        AP.set((0, $dPHSK.default).of('D'), appearance);
    };
    PDFAnnotation.prototype.removeRolloverAppearance = function() {
        var AP = this.AP();
        AP === null || AP === void 0 || AP.delete((0, $dPHSK.default).of('R'));
    };
    PDFAnnotation.prototype.removeDownAppearance = function() {
        var AP = this.AP();
        AP === null || AP === void 0 || AP.delete((0, $dPHSK.default).of('D'));
    };
    PDFAnnotation.prototype.getAppearances = function() {
        var AP = this.AP();
        if (!AP) return undefined;
        var N = AP.lookup((0, $dPHSK.default).of('N'), (0, $brir8.default), (0, $4CgUJ.default));
        var R = AP.lookupMaybe((0, $dPHSK.default).of('R'), (0, $brir8.default), (0, $4CgUJ.default));
        var D = AP.lookupMaybe((0, $dPHSK.default).of('D'), (0, $brir8.default), (0, $4CgUJ.default));
        return {
            normal: N,
            rollover: R,
            down: D
        };
    };
    PDFAnnotation.prototype.getFlags = function() {
        var _a, _b;
        return (_b = (_a = this.F()) === null || _a === void 0 ? void 0 : _a.asNumber()) !== null && _b !== void 0 ? _b : 0;
    };
    PDFAnnotation.prototype.setFlags = function(flags) {
        this.dict.set((0, $dPHSK.default).of('F'), (0, $j04jt.default).of(flags));
    };
    PDFAnnotation.prototype.hasFlag = function(flag) {
        var flags = this.getFlags();
        return (flags & flag) !== 0;
    };
    PDFAnnotation.prototype.setFlag = function(flag) {
        var flags = this.getFlags();
        this.setFlags(flags | flag);
    };
    PDFAnnotation.prototype.clearFlag = function(flag) {
        var flags = this.getFlags();
        this.setFlags(flags & ~flag);
    };
    PDFAnnotation.prototype.setFlagTo = function(flag, enable) {
        if (enable) this.setFlag(flag);
        else this.clearFlag(flag);
    };
    PDFAnnotation.fromDict = function(dict) {
        return new PDFAnnotation(dict);
    };
    return PDFAnnotation;
}();
var $b3d65ce7bc0fb74b$export$2e2bcd8739ae039 = $b3d65ce7bc0fb74b$var$PDFAnnotation;

});

parcelRegister("6293R", function(module, exports) {

$parcel$export(module.exports, "default", () => $4649f56151c7fd29$export$2e2bcd8739ae039);

var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");

var $8auL6 = parcelRequire("8auL6");

var $jWFiV = parcelRequire("jWFiV");

var $8dCYu = parcelRequire("8dCYu");
var $4649f56151c7fd29$var$AppearanceCharacteristics = /** @class */ function() {
    function AppearanceCharacteristics(dict) {
        this.dict = dict;
    }
    AppearanceCharacteristics.prototype.R = function() {
        var R = this.dict.lookup((0, $dPHSK.default).of('R'));
        if (R instanceof (0, $j04jt.default)) return R;
        return undefined;
    };
    AppearanceCharacteristics.prototype.BC = function() {
        var BC = this.dict.lookup((0, $dPHSK.default).of('BC'));
        if (BC instanceof (0, $8auL6.default)) return BC;
        return undefined;
    };
    AppearanceCharacteristics.prototype.BG = function() {
        var BG = this.dict.lookup((0, $dPHSK.default).of('BG'));
        if (BG instanceof (0, $8auL6.default)) return BG;
        return undefined;
    };
    AppearanceCharacteristics.prototype.CA = function() {
        var CA = this.dict.lookup((0, $dPHSK.default).of('CA'));
        if (CA instanceof (0, $jWFiV.default) || CA instanceof (0, $8dCYu.default)) return CA;
        return undefined;
    };
    AppearanceCharacteristics.prototype.RC = function() {
        var RC = this.dict.lookup((0, $dPHSK.default).of('RC'));
        if (RC instanceof (0, $jWFiV.default) || RC instanceof (0, $8dCYu.default)) return RC;
        return undefined;
    };
    AppearanceCharacteristics.prototype.AC = function() {
        var AC = this.dict.lookup((0, $dPHSK.default).of('AC'));
        if (AC instanceof (0, $jWFiV.default) || AC instanceof (0, $8dCYu.default)) return AC;
        return undefined;
    };
    AppearanceCharacteristics.prototype.getRotation = function() {
        var _a;
        return (_a = this.R()) === null || _a === void 0 ? void 0 : _a.asNumber();
    };
    AppearanceCharacteristics.prototype.getBorderColor = function() {
        var BC = this.BC();
        if (!BC) return undefined;
        var components = [];
        for(var idx = 0, len = BC === null || BC === void 0 ? void 0 : BC.size(); idx < len; idx++){
            var component = BC.get(idx);
            if (component instanceof (0, $j04jt.default)) components.push(component.asNumber());
        }
        return components;
    };
    AppearanceCharacteristics.prototype.getBackgroundColor = function() {
        var BG = this.BG();
        if (!BG) return undefined;
        var components = [];
        for(var idx = 0, len = BG === null || BG === void 0 ? void 0 : BG.size(); idx < len; idx++){
            var component = BG.get(idx);
            if (component instanceof (0, $j04jt.default)) components.push(component.asNumber());
        }
        return components;
    };
    AppearanceCharacteristics.prototype.getCaptions = function() {
        var CA = this.CA();
        var RC = this.RC();
        var AC = this.AC();
        return {
            normal: CA === null || CA === void 0 ? void 0 : CA.decodeText(),
            rollover: RC === null || RC === void 0 ? void 0 : RC.decodeText(),
            down: AC === null || AC === void 0 ? void 0 : AC.decodeText()
        };
    };
    AppearanceCharacteristics.prototype.setRotation = function(rotation) {
        var R = this.dict.context.obj(rotation);
        this.dict.set((0, $dPHSK.default).of('R'), R);
    };
    AppearanceCharacteristics.prototype.setBorderColor = function(color) {
        var BC = this.dict.context.obj(color);
        this.dict.set((0, $dPHSK.default).of('BC'), BC);
    };
    AppearanceCharacteristics.prototype.setBackgroundColor = function(color) {
        var BG = this.dict.context.obj(color);
        this.dict.set((0, $dPHSK.default).of('BG'), BG);
    };
    AppearanceCharacteristics.prototype.setCaptions = function(captions) {
        var CA = (0, $jWFiV.default).fromText(captions.normal);
        this.dict.set((0, $dPHSK.default).of('CA'), CA);
        if (captions.rollover) {
            var RC = (0, $jWFiV.default).fromText(captions.rollover);
            this.dict.set((0, $dPHSK.default).of('RC'), RC);
        } else this.dict.delete((0, $dPHSK.default).of('RC'));
        if (captions.down) {
            var AC = (0, $jWFiV.default).fromText(captions.down);
            this.dict.set((0, $dPHSK.default).of('AC'), AC);
        } else this.dict.delete((0, $dPHSK.default).of('AC'));
    };
    AppearanceCharacteristics.fromDict = function(dict) {
        return new AppearanceCharacteristics(dict);
    };
    return AppearanceCharacteristics;
}();
var $4649f56151c7fd29$export$2e2bcd8739ae039 = $4649f56151c7fd29$var$AppearanceCharacteristics;

});




parcelRegister("lmORt", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8e31b0e21e15332$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $dPHSK = parcelRequire("dPHSK");

var $bYlnh = parcelRequire("bYlnh");

var $nAWRe = parcelRequire("nAWRe");
var $f8e31b0e21e15332$var$PDFAcroCheckBox = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroCheckBox, _super);
    function PDFAcroCheckBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroCheckBox.prototype.setValue = function(value) {
        var _a;
        var onValue = (_a = this.getOnValue()) !== null && _a !== void 0 ? _a : (0, $dPHSK.default).of('Yes');
        if (value !== onValue && value !== (0, $dPHSK.default).of('Off')) throw new (0, $nAWRe.InvalidAcroFieldValueError)();
        this.dict.set((0, $dPHSK.default).of('V'), value);
        var widgets = this.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var state = widget.getOnValue() === value ? value : (0, $dPHSK.default).of('Off');
            widget.setAppearanceState(state);
        }
    };
    PDFAcroCheckBox.prototype.getValue = function() {
        var v = this.V();
        if (v instanceof (0, $dPHSK.default)) return v;
        return (0, $dPHSK.default).of('Off');
    };
    PDFAcroCheckBox.prototype.getOnValue = function() {
        var widget = this.getWidgets()[0];
        return widget === null || widget === void 0 ? void 0 : widget.getOnValue();
    };
    PDFAcroCheckBox.fromDict = function(dict, ref) {
        return new PDFAcroCheckBox(dict, ref);
    };
    PDFAcroCheckBox.create = function(context) {
        var dict = context.obj({
            FT: 'Btn',
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroCheckBox(dict, ref);
    };
    return PDFAcroCheckBox;
}((0, $bYlnh.default));
var $f8e31b0e21e15332$export$2e2bcd8739ae039 = $f8e31b0e21e15332$var$PDFAcroCheckBox;

});

parcelRegister("1pFNX", function(module, exports) {

$parcel$export(module.exports, "default", () => $10788dcfb83fdb6c$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $64Z70 = parcelRequire("64Z70");

var $jWFiV = parcelRequire("jWFiV");

var $8dCYu = parcelRequire("8dCYu");

var $8auL6 = parcelRequire("8auL6");

var $dPHSK = parcelRequire("dPHSK");

var $d5IrD = parcelRequire("d5IrD");

var $nAWRe = parcelRequire("nAWRe");
var $10788dcfb83fdb6c$var$PDFAcroChoice = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroChoice, _super);
    function PDFAcroChoice() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroChoice.prototype.setValues = function(values) {
        if (this.hasFlag((0, $d5IrD.AcroChoiceFlags).Combo) && !this.hasFlag((0, $d5IrD.AcroChoiceFlags).Edit) && !this.valuesAreValid(values)) throw new (0, $nAWRe.InvalidAcroFieldValueError)();
        if (values.length === 0) this.dict.delete((0, $dPHSK.default).of('V'));
        if (values.length === 1) this.dict.set((0, $dPHSK.default).of('V'), values[0]);
        if (values.length > 1) {
            if (!this.hasFlag((0, $d5IrD.AcroChoiceFlags).MultiSelect)) throw new (0, $nAWRe.MultiSelectValueError)();
            this.dict.set((0, $dPHSK.default).of('V'), this.dict.context.obj(values));
        }
        this.updateSelectedIndices(values);
    };
    PDFAcroChoice.prototype.valuesAreValid = function(values) {
        var options = this.getOptions();
        var _loop_1 = function(idx, len) {
            var val = values[idx].decodeText();
            if (!options.find(function(o) {
                return val === (o.display || o.value).decodeText();
            })) return {
                value: false
            };
        };
        for(var idx = 0, len = values.length; idx < len; idx++){
            var state_1 = _loop_1(idx, len);
            if (typeof state_1 === "object") return state_1.value;
        }
        return true;
    };
    PDFAcroChoice.prototype.updateSelectedIndices = function(values) {
        if (values.length > 1) {
            var indices = new Array(values.length);
            var options = this.getOptions();
            var _loop_2 = function(idx, len) {
                var val = values[idx].decodeText();
                indices[idx] = options.findIndex(function(o) {
                    return val === (o.display || o.value).decodeText();
                });
            };
            for(var idx = 0, len = values.length; idx < len; idx++)_loop_2(idx, len);
            this.dict.set((0, $dPHSK.default).of('I'), this.dict.context.obj(indices.sort()));
        } else this.dict.delete((0, $dPHSK.default).of('I'));
    };
    PDFAcroChoice.prototype.getValues = function() {
        var v = this.V();
        if (v instanceof (0, $8dCYu.default) || v instanceof (0, $jWFiV.default)) return [
            v
        ];
        if (v instanceof (0, $8auL6.default)) {
            var values = [];
            for(var idx = 0, len = v.size(); idx < len; idx++){
                var value = v.lookup(idx);
                if (value instanceof (0, $8dCYu.default) || value instanceof (0, $jWFiV.default)) values.push(value);
            }
            return values;
        }
        return [];
    };
    PDFAcroChoice.prototype.Opt = function() {
        return this.dict.lookupMaybe((0, $dPHSK.default).of('Opt'), (0, $8dCYu.default), (0, $jWFiV.default), (0, $8auL6.default));
    };
    PDFAcroChoice.prototype.setOptions = function(options) {
        var newOpt = new Array(options.length);
        for(var idx = 0, len = options.length; idx < len; idx++){
            var _a = options[idx], value = _a.value, display = _a.display;
            newOpt[idx] = this.dict.context.obj([
                value,
                display || value
            ]);
        }
        this.dict.set((0, $dPHSK.default).of('Opt'), this.dict.context.obj(newOpt));
    };
    PDFAcroChoice.prototype.getOptions = function() {
        var Opt = this.Opt();
        // Not supposed to happen - Opt _should_ always be `PDFArray | undefined`
        if (Opt instanceof (0, $8dCYu.default) || Opt instanceof (0, $jWFiV.default)) return [
            {
                value: Opt,
                display: Opt
            }
        ];
        if (Opt instanceof (0, $8auL6.default)) {
            var res = [];
            for(var idx = 0, len = Opt.size(); idx < len; idx++){
                var item = Opt.lookup(idx);
                // If `item` is a string, use that as both the export and text value
                if (item instanceof (0, $8dCYu.default) || item instanceof (0, $jWFiV.default)) res.push({
                    value: item,
                    display: item
                });
                // If `item` is an array of one, treat it the same as just a string,
                // if it's an array of two then `item[0]` is the export value and
                // `item[1]` is the text value
                if (item instanceof (0, $8auL6.default)) {
                    if (item.size() > 0) {
                        var first = item.lookup(0, (0, $8dCYu.default), (0, $jWFiV.default));
                        var second = item.lookupMaybe(1, (0, $8dCYu.default), (0, $jWFiV.default));
                        res.push({
                            value: first,
                            display: second || first
                        });
                    }
                }
            }
            return res;
        }
        return [];
    };
    return PDFAcroChoice;
}((0, $64Z70.default));
var $10788dcfb83fdb6c$export$2e2bcd8739ae039 = $10788dcfb83fdb6c$var$PDFAcroChoice;

});
parcelRegister("d5IrD", function(module, exports) {

$parcel$export(module.exports, "AcroFieldFlags", () => $987e37c460e8464e$export$3600c95532547643);
$parcel$export(module.exports, "AcroButtonFlags", () => $987e37c460e8464e$export$59f660e89ffb4f8a);
$parcel$export(module.exports, "AcroTextFlags", () => $987e37c460e8464e$export$389fc7b97397dc8b);
$parcel$export(module.exports, "AcroChoiceFlags", () => $987e37c460e8464e$export$eb88827058402599);
var $987e37c460e8464e$var$flag = function(bitIndex) {
    return 1 << bitIndex;
};
var $987e37c460e8464e$export$3600c95532547643;
(function(AcroFieldFlags) {
    /**
     * If set, the user may not change the value of the field. Any associated
     * widget annotations will not interact with the user; that is, they will not
     * respond to mouse clicks or change their appearance in response to mouse
     * motions. This flag is useful for fields whose values are computed or
     * imported from a database.
     */ AcroFieldFlags[AcroFieldFlags["ReadOnly"] = $987e37c460e8464e$var$flag(0)] = "ReadOnly";
    /**
     * If set, the field shall have a value at the time it is exported by a
     * submit-form action (see 12.7.5.2, "Submit-Form Action").
     */ AcroFieldFlags[AcroFieldFlags["Required"] = $987e37c460e8464e$var$flag(1)] = "Required";
    /**
     * If set, the field shall not be exported by a submit-form action
     * (see 12.7.5.2, "Submit-Form Action").
     */ AcroFieldFlags[AcroFieldFlags["NoExport"] = $987e37c460e8464e$var$flag(2)] = "NoExport";
})($987e37c460e8464e$export$3600c95532547643 || ($987e37c460e8464e$export$3600c95532547643 = {}));
var $987e37c460e8464e$export$59f660e89ffb4f8a;
(function(AcroButtonFlags) {
    /**
     * (Radio buttons only) If set, exactly one radio button shall be selected at
     * all times; selecting the currently selected button has no effect. If clear,
     * clicking the selected button deselects it, leaving no button selected.
     */ AcroButtonFlags[AcroButtonFlags["NoToggleToOff"] = $987e37c460e8464e$var$flag(14)] = "NoToggleToOff";
    /**
     * If set, the field is a set of radio buttons; if clear, the field is a check
     * box. This flag may be set only if the Pushbutton flag is clear.
     */ AcroButtonFlags[AcroButtonFlags["Radio"] = $987e37c460e8464e$var$flag(15)] = "Radio";
    /**
     * If set, the field is a pushbutton that does not retain a permanent value.
     */ AcroButtonFlags[AcroButtonFlags["PushButton"] = $987e37c460e8464e$var$flag(16)] = "PushButton";
    /**
     * If set, a group of radio buttons within a radio button field that use the
     * same value for the on state will turn on and off in unison; that is if one
     * is checked, they are all checked. If clear, the buttons are mutually
     * exclusive (the same behavior as HTML radio buttons).
     */ AcroButtonFlags[AcroButtonFlags["RadiosInUnison"] = $987e37c460e8464e$var$flag(25)] = "RadiosInUnison";
})($987e37c460e8464e$export$59f660e89ffb4f8a || ($987e37c460e8464e$export$59f660e89ffb4f8a = {}));
var $987e37c460e8464e$export$389fc7b97397dc8b;
(function(AcroTextFlags) {
    /**
     * If set, the field may contain multiple lines of text; if clear, the field's
     * text shall be restricted to a single line.
     */ AcroTextFlags[AcroTextFlags["Multiline"] = $987e37c460e8464e$var$flag(12)] = "Multiline";
    /**
     * If set, the field is intended for entering a secure password that should
     * not be echoed visibly to the screen. Characters typed from the keyboard
     * shall instead be echoed in some unreadable form, such as asterisks or
     * bullet characters.
     * > NOTE   To protect password confidentiality, readers should never store
     * >        the value of the text field in the PDF file if this flag is set.
     */ AcroTextFlags[AcroTextFlags["Password"] = $987e37c460e8464e$var$flag(13)] = "Password";
    /**
     * If set, the text entered in the field represents the pathname of a file
     * whose contents shall be submitted as the value of the field.
     */ AcroTextFlags[AcroTextFlags["FileSelect"] = $987e37c460e8464e$var$flag(20)] = "FileSelect";
    /**
     * If set, text entered in the field shall not be spell-checked.
     */ AcroTextFlags[AcroTextFlags["DoNotSpellCheck"] = $987e37c460e8464e$var$flag(22)] = "DoNotSpellCheck";
    /**
     * If set, the field shall not scroll (horizontally for single-line fields,
     * vertically for multiple-line fields) to accommodate more text than fits
     * within its annotation rectangle. Once the field is full, no further text
     * shall be accepted for interactive form filling; for non-interactive form
     * filling, the filler should take care not to add more character than will
     * visibly fit in the defined area.
     */ AcroTextFlags[AcroTextFlags["DoNotScroll"] = $987e37c460e8464e$var$flag(23)] = "DoNotScroll";
    /**
     * May be set only if the MaxLen entry is present in the text field dictionary
     * (see Table 229) and if the Multiline, Password, and FileSelect flags are
     * clear. If set, the field shall be automatically divided into as many
     * equally spaced positions, or combs, as the value of MaxLen, and the text
     * is laid out into those combs.
     */ AcroTextFlags[AcroTextFlags["Comb"] = $987e37c460e8464e$var$flag(24)] = "Comb";
    /**
     * If set, the value of this field shall be a rich text string
     * (see 12.7.3.4, "Rich Text Strings"). If the field has a value, the RV
     * entry of the field dictionary (Table 222) shall specify the rich text
     * string.
     */ AcroTextFlags[AcroTextFlags["RichText"] = $987e37c460e8464e$var$flag(25)] = "RichText";
})($987e37c460e8464e$export$389fc7b97397dc8b || ($987e37c460e8464e$export$389fc7b97397dc8b = {}));
var $987e37c460e8464e$export$eb88827058402599;
(function(AcroChoiceFlags) {
    /**
     * If set, the field is a combo box; if clear, the field is a list box.
     */ AcroChoiceFlags[AcroChoiceFlags["Combo"] = $987e37c460e8464e$var$flag(17)] = "Combo";
    /**
     * If set, the combo box shall include an editable text box as well as a
     * drop-down list; if clear, it shall include only a drop-down list. This
     * flag shall be used only if the Combo flag is set.
     */ AcroChoiceFlags[AcroChoiceFlags["Edit"] = $987e37c460e8464e$var$flag(18)] = "Edit";
    /**
     * If set, the field's option items shall be sorted alphabetically. This flag
     * is intended for use by writers, not by readers. Conforming readers shall
     * display the options in the order in which they occur in the Opt array
     * (see Table 231).
     */ AcroChoiceFlags[AcroChoiceFlags["Sort"] = $987e37c460e8464e$var$flag(19)] = "Sort";
    /**
     * If set, more than one of the field's option items may be selected
     * simultaneously; if clear, at most one item shall be selected.
     */ AcroChoiceFlags[AcroChoiceFlags["MultiSelect"] = $987e37c460e8464e$var$flag(21)] = "MultiSelect";
    /**
     * If set, text entered in the field shall not be spell-checked. This flag
     * shall not be used unless the Combo and Edit flags are both set.
     */ AcroChoiceFlags[AcroChoiceFlags["DoNotSpellCheck"] = $987e37c460e8464e$var$flag(22)] = "DoNotSpellCheck";
    /**
     * If set, the new value shall be committed as soon as a selection is made
     * (commonly with the pointing device). In this case, supplying a value for
     * a field involves three actions: selecting the field for fill-in,
     * selecting a choice for the fill-in value, and leaving that field, which
     * finalizes or "commits" the data choice and triggers any actions associated
     * with the entry or changing of this data. If this flag is on, then
     * processing does not wait for leaving the field action to occur, but
     * immediately proceeds to the third step.
     *
     * This option enables applications to perform an action once a selection is
     * made, without requiring the user to exit the field. If clear, the new
     * value is not committed until the user exits the field.
     */ AcroChoiceFlags[AcroChoiceFlags["CommitOnSelChange"] = $987e37c460e8464e$var$flag(26)] = "CommitOnSelChange";
})($987e37c460e8464e$export$eb88827058402599 || ($987e37c460e8464e$export$eb88827058402599 = {}));

});


parcelRegister("4vDg3", function(module, exports) {

$parcel$export(module.exports, "default", () => $3488827c1474fcce$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $1pFNX = parcelRequire("1pFNX");

var $d5IrD = parcelRequire("d5IrD");
var $3488827c1474fcce$var$PDFAcroComboBox = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroComboBox, _super);
    function PDFAcroComboBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroComboBox.fromDict = function(dict, ref) {
        return new PDFAcroComboBox(dict, ref);
    };
    PDFAcroComboBox.create = function(context) {
        var dict = context.obj({
            FT: 'Ch',
            Ff: (0, $d5IrD.AcroChoiceFlags).Combo,
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroComboBox(dict, ref);
    };
    return PDFAcroComboBox;
}((0, $1pFNX.default));
var $3488827c1474fcce$export$2e2bcd8739ae039 = $3488827c1474fcce$var$PDFAcroComboBox;

});

parcelRegister("flrAV", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2be38e1e2597241$export$2e2bcd8739ae039);

var $brir8 = parcelRequire("brir8");

var $8auL6 = parcelRequire("8auL6");

var $dPHSK = parcelRequire("dPHSK");

var $dP7Ar = parcelRequire("dP7Ar");

var $gkGMc = parcelRequire("gkGMc");
var $b2be38e1e2597241$var$PDFAcroForm = /** @class */ function() {
    function PDFAcroForm(dict) {
        this.dict = dict;
    }
    PDFAcroForm.prototype.Fields = function() {
        var fields = this.dict.lookup((0, $dPHSK.default).of('Fields'));
        if (fields instanceof (0, $8auL6.default)) return fields;
        return undefined;
    };
    PDFAcroForm.prototype.getFields = function() {
        var Fields = this.normalizedEntries().Fields;
        var fields = new Array(Fields.size());
        for(var idx = 0, len = Fields.size(); idx < len; idx++){
            var ref = Fields.get(idx);
            var dict = Fields.lookup(idx, (0, $brir8.default));
            fields[idx] = [
                (0, $gkGMc.createPDFAcroField)(dict, ref),
                ref
            ];
        }
        return fields;
    };
    PDFAcroForm.prototype.getAllFields = function() {
        var allFields = [];
        var pushFields = function(fields) {
            if (!fields) return;
            for(var idx = 0, len = fields.length; idx < len; idx++){
                var field = fields[idx];
                allFields.push(field);
                var fieldModel = field[0];
                if (fieldModel instanceof (0, $dP7Ar.default)) pushFields((0, $gkGMc.createPDFAcroFields)(fieldModel.Kids()));
            }
        };
        pushFields(this.getFields());
        return allFields;
    };
    PDFAcroForm.prototype.addField = function(field) {
        var Fields = this.normalizedEntries().Fields;
        Fields === null || Fields === void 0 || Fields.push(field);
    };
    PDFAcroForm.prototype.removeField = function(field) {
        var parent = field.getParent();
        var fields = parent === undefined ? this.normalizedEntries().Fields : parent.Kids();
        var index = fields === null || fields === void 0 ? void 0 : fields.indexOf(field.ref);
        if (fields === undefined || index === undefined) throw new Error("Tried to remove inexistent field " + field.getFullyQualifiedName());
        fields.remove(index);
        if (parent !== undefined && fields.size() === 0) this.removeField(parent);
    };
    PDFAcroForm.prototype.normalizedEntries = function() {
        var Fields = this.Fields();
        if (!Fields) {
            Fields = this.dict.context.obj([]);
            this.dict.set((0, $dPHSK.default).of('Fields'), Fields);
        }
        return {
            Fields: Fields
        };
    };
    PDFAcroForm.fromDict = function(dict) {
        return new PDFAcroForm(dict);
    };
    PDFAcroForm.create = function(context) {
        var dict = context.obj({
            Fields: []
        });
        return new PDFAcroForm(dict);
    };
    return PDFAcroForm;
}();
var $b2be38e1e2597241$export$2e2bcd8739ae039 = $b2be38e1e2597241$var$PDFAcroForm;

});
parcelRegister("dP7Ar", function(module, exports) {

$parcel$export(module.exports, "default", () => $a105ec5aeb848914$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $dPHSK = parcelRequire("dPHSK");

var $50MTm = parcelRequire("50MTm");
var $a105ec5aeb848914$var$PDFAcroNonTerminal = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroNonTerminal, _super);
    function PDFAcroNonTerminal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroNonTerminal.prototype.addField = function(field) {
        var Kids = this.normalizedEntries().Kids;
        Kids === null || Kids === void 0 || Kids.push(field);
    };
    PDFAcroNonTerminal.prototype.normalizedEntries = function() {
        var Kids = this.Kids();
        if (!Kids) {
            Kids = this.dict.context.obj([]);
            this.dict.set((0, $dPHSK.default).of('Kids'), Kids);
        }
        return {
            Kids: Kids
        };
    };
    PDFAcroNonTerminal.fromDict = function(dict, ref) {
        return new PDFAcroNonTerminal(dict, ref);
    };
    PDFAcroNonTerminal.create = function(context) {
        var dict = context.obj({});
        var ref = context.register(dict);
        return new PDFAcroNonTerminal(dict, ref);
    };
    return PDFAcroNonTerminal;
}((0, $50MTm.default));
var $a105ec5aeb848914$export$2e2bcd8739ae039 = $a105ec5aeb848914$var$PDFAcroNonTerminal;

});

parcelRegister("gkGMc", function(module, exports) {

$parcel$export(module.exports, "createPDFAcroFields", () => $be3fb214968b38d5$export$34b4fb8893136c4c);
$parcel$export(module.exports, "createPDFAcroField", () => $be3fb214968b38d5$export$fe770f59a8fbe6d);

var $j04jt = parcelRequire("j04jt");

var $brir8 = parcelRequire("brir8");

var $dPHSK = parcelRequire("dPHSK");

var $8auL6 = parcelRequire("8auL6");

var $kHzkO = parcelRequire("kHzkO");

var $64Z70 = parcelRequire("64Z70");

var $dP7Ar = parcelRequire("dP7Ar");

var $7hDvO = parcelRequire("7hDvO");

var $clInn = parcelRequire("clInn");

var $1757u = parcelRequire("1757u");

var $hpItd = parcelRequire("hpItd");

var $lmORt = parcelRequire("lmORt");

var $4vDg3 = parcelRequire("4vDg3");

var $gEqSi = parcelRequire("gEqSi");

var $d5IrD = parcelRequire("d5IrD");
var $be3fb214968b38d5$export$34b4fb8893136c4c = function(kidDicts) {
    if (!kidDicts) return [];
    var kids = [];
    for(var idx = 0, len = kidDicts.size(); idx < len; idx++){
        var ref = kidDicts.get(idx);
        var dict = kidDicts.lookup(idx);
        // if (dict instanceof PDFDict) kids.push(PDFAcroField.fromDict(dict));
        if (ref instanceof (0, $kHzkO.default) && dict instanceof (0, $brir8.default)) kids.push([
            $be3fb214968b38d5$export$fe770f59a8fbe6d(dict, ref),
            ref
        ]);
    }
    return kids;
};
var $be3fb214968b38d5$export$fe770f59a8fbe6d = function(dict, ref) {
    var isNonTerminal = $be3fb214968b38d5$var$isNonTerminalAcroField(dict);
    if (isNonTerminal) return (0, $dP7Ar.default).fromDict(dict, ref);
    return $be3fb214968b38d5$var$createPDFAcroTerminal(dict, ref);
};
// TODO: Maybe just check if the dict is *not* a widget? That might be better.
// According to the PDF spec:
//
//   > A field's children in the hierarchy may also include widget annotations
//   > that define its appearance on the page. A field that has children that
//   > are fields is called a non-terminal field. A field that does not have
//   > children that are fields is called a terminal field.
//
// The spec is not entirely clear about how to determine whether a given
// dictionary represents an acrofield or a widget annotation. So we will assume
// that a dictionary is an acrofield if it is a member of the `/Kids` array
// and it contains a `/T` entry (widgets do not have `/T` entries). This isn't
// a bullet proof solution, because the `/T` entry is technically defined as
// optional for acrofields by the PDF spec. But in practice all acrofields seem
// to have a `/T` entry defined.
var $be3fb214968b38d5$var$isNonTerminalAcroField = function(dict) {
    var kids = dict.lookup((0, $dPHSK.default).of('Kids'));
    if (kids instanceof (0, $8auL6.default)) for(var idx = 0, len = kids.size(); idx < len; idx++){
        var kid = kids.lookup(idx);
        var kidIsField = kid instanceof (0, $brir8.default) && kid.has((0, $dPHSK.default).of('T'));
        if (kidIsField) return true;
    }
    return false;
};
var $be3fb214968b38d5$var$createPDFAcroTerminal = function(dict, ref) {
    var ftNameOrRef = $be3fb214968b38d5$var$getInheritableAttribute(dict, (0, $dPHSK.default).of('FT'));
    var type = dict.context.lookup(ftNameOrRef, (0, $dPHSK.default));
    if (type === (0, $dPHSK.default).of('Btn')) return $be3fb214968b38d5$var$createPDFAcroButton(dict, ref);
    if (type === (0, $dPHSK.default).of('Ch')) return $be3fb214968b38d5$var$createPDFAcroChoice(dict, ref);
    if (type === (0, $dPHSK.default).of('Tx')) return (0, $clInn.default).fromDict(dict, ref);
    if (type === (0, $dPHSK.default).of('Sig')) return (0, $7hDvO.default).fromDict(dict, ref);
    // We should never reach this line. But there are a lot of weird PDFs out
    // there. So, just to be safe, we'll try to handle things gracefully instead
    // of throwing an error.
    return (0, $64Z70.default).fromDict(dict, ref);
};
var $be3fb214968b38d5$var$createPDFAcroButton = function(dict, ref) {
    var _a;
    var ffNumberOrRef = $be3fb214968b38d5$var$getInheritableAttribute(dict, (0, $dPHSK.default).of('Ff'));
    var ffNumber = dict.context.lookupMaybe(ffNumberOrRef, (0, $j04jt.default));
    var flags = (_a = ffNumber === null || ffNumber === void 0 ? void 0 : ffNumber.asNumber()) !== null && _a !== void 0 ? _a : 0;
    if ($be3fb214968b38d5$var$flagIsSet(flags, (0, $d5IrD.AcroButtonFlags).PushButton)) return (0, $1757u.default).fromDict(dict, ref);
    else if ($be3fb214968b38d5$var$flagIsSet(flags, (0, $d5IrD.AcroButtonFlags).Radio)) return (0, $hpItd.default).fromDict(dict, ref);
    else return (0, $lmORt.default).fromDict(dict, ref);
};
var $be3fb214968b38d5$var$createPDFAcroChoice = function(dict, ref) {
    var _a;
    var ffNumberOrRef = $be3fb214968b38d5$var$getInheritableAttribute(dict, (0, $dPHSK.default).of('Ff'));
    var ffNumber = dict.context.lookupMaybe(ffNumberOrRef, (0, $j04jt.default));
    var flags = (_a = ffNumber === null || ffNumber === void 0 ? void 0 : ffNumber.asNumber()) !== null && _a !== void 0 ? _a : 0;
    if ($be3fb214968b38d5$var$flagIsSet(flags, (0, $d5IrD.AcroChoiceFlags).Combo)) return (0, $4vDg3.default).fromDict(dict, ref);
    else return (0, $gEqSi.default).fromDict(dict, ref);
};
var $be3fb214968b38d5$var$flagIsSet = function(flags, flag) {
    return (flags & flag) !== 0;
};
var $be3fb214968b38d5$var$getInheritableAttribute = function(startNode, name) {
    var attribute;
    $be3fb214968b38d5$var$ascend(startNode, function(node) {
        if (!attribute) attribute = node.get(name);
    });
    return attribute;
};
var $be3fb214968b38d5$var$ascend = function(startNode, visitor) {
    visitor(startNode);
    var Parent = startNode.lookupMaybe((0, $dPHSK.default).of('Parent'), (0, $brir8.default));
    if (Parent) $be3fb214968b38d5$var$ascend(Parent, visitor);
};

});
parcelRegister("7hDvO", function(module, exports) {

$parcel$export(module.exports, "default", () => $54d8c5346cdc5323$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $64Z70 = parcelRequire("64Z70");
var $54d8c5346cdc5323$var$PDFAcroSignature = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroSignature, _super);
    function PDFAcroSignature() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroSignature.fromDict = function(dict, ref) {
        return new PDFAcroSignature(dict, ref);
    };
    return PDFAcroSignature;
}((0, $64Z70.default));
var $54d8c5346cdc5323$export$2e2bcd8739ae039 = $54d8c5346cdc5323$var$PDFAcroSignature;

});

parcelRegister("clInn", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fd9de5d2343325e$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $j04jt = parcelRequire("j04jt");

var $8dCYu = parcelRequire("8dCYu");

var $jWFiV = parcelRequire("jWFiV");

var $dPHSK = parcelRequire("dPHSK");

var $64Z70 = parcelRequire("64Z70");
var $8fd9de5d2343325e$var$PDFAcroText = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroText, _super);
    function PDFAcroText() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroText.prototype.MaxLen = function() {
        var maxLen = this.dict.lookup((0, $dPHSK.default).of('MaxLen'));
        if (maxLen instanceof (0, $j04jt.default)) return maxLen;
        return undefined;
    };
    PDFAcroText.prototype.Q = function() {
        var q = this.dict.lookup((0, $dPHSK.default).of('Q'));
        if (q instanceof (0, $j04jt.default)) return q;
        return undefined;
    };
    PDFAcroText.prototype.setMaxLength = function(maxLength) {
        this.dict.set((0, $dPHSK.default).of('MaxLen'), (0, $j04jt.default).of(maxLength));
    };
    PDFAcroText.prototype.removeMaxLength = function() {
        this.dict.delete((0, $dPHSK.default).of('MaxLen'));
    };
    PDFAcroText.prototype.getMaxLength = function() {
        var _a;
        return (_a = this.MaxLen()) === null || _a === void 0 ? void 0 : _a.asNumber();
    };
    PDFAcroText.prototype.setQuadding = function(quadding) {
        this.dict.set((0, $dPHSK.default).of('Q'), (0, $j04jt.default).of(quadding));
    };
    PDFAcroText.prototype.getQuadding = function() {
        var _a;
        return (_a = this.Q()) === null || _a === void 0 ? void 0 : _a.asNumber();
    };
    PDFAcroText.prototype.setValue = function(value) {
        this.dict.set((0, $dPHSK.default).of('V'), value);
    // const widgets = this.getWidgets();
    // for (let idx = 0, len = widgets.length; idx < len; idx++) {
    //   const widget = widgets[idx];
    //   const state = widget.getOnValue() === value ? value : PDFName.of('Off');
    //   widget.setAppearanceState(state);
    // }
    };
    PDFAcroText.prototype.removeValue = function() {
        this.dict.delete((0, $dPHSK.default).of('V'));
    };
    PDFAcroText.prototype.getValue = function() {
        var v = this.V();
        if (v instanceof (0, $8dCYu.default) || v instanceof (0, $jWFiV.default)) return v;
        return undefined;
    };
    PDFAcroText.fromDict = function(dict, ref) {
        return new PDFAcroText(dict, ref);
    };
    PDFAcroText.create = function(context) {
        var dict = context.obj({
            FT: 'Tx',
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroText(dict, ref);
    };
    return PDFAcroText;
}((0, $64Z70.default));
var $8fd9de5d2343325e$export$2e2bcd8739ae039 = $8fd9de5d2343325e$var$PDFAcroText;

});

parcelRegister("1757u", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cfa6a9523f95402$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $bYlnh = parcelRequire("bYlnh");

var $d5IrD = parcelRequire("d5IrD");
var $0cfa6a9523f95402$var$PDFAcroPushButton = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroPushButton, _super);
    function PDFAcroPushButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroPushButton.fromDict = function(dict, ref) {
        return new PDFAcroPushButton(dict, ref);
    };
    PDFAcroPushButton.create = function(context) {
        var dict = context.obj({
            FT: 'Btn',
            Ff: (0, $d5IrD.AcroButtonFlags).PushButton,
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroPushButton(dict, ref);
    };
    return PDFAcroPushButton;
}((0, $bYlnh.default));
var $0cfa6a9523f95402$export$2e2bcd8739ae039 = $0cfa6a9523f95402$var$PDFAcroPushButton;

});

parcelRegister("hpItd", function(module, exports) {

$parcel$export(module.exports, "default", () => $cad74455a26124b0$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $dPHSK = parcelRequire("dPHSK");

var $bYlnh = parcelRequire("bYlnh");

var $d5IrD = parcelRequire("d5IrD");

var $nAWRe = parcelRequire("nAWRe");
var $cad74455a26124b0$var$PDFAcroRadioButton = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroRadioButton, _super);
    function PDFAcroRadioButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroRadioButton.prototype.setValue = function(value) {
        var onValues = this.getOnValues();
        if (!onValues.includes(value) && value !== (0, $dPHSK.default).of('Off')) throw new (0, $nAWRe.InvalidAcroFieldValueError)();
        this.dict.set((0, $dPHSK.default).of('V'), value);
        var widgets = this.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var state = widget.getOnValue() === value ? value : (0, $dPHSK.default).of('Off');
            widget.setAppearanceState(state);
        }
    };
    PDFAcroRadioButton.prototype.getValue = function() {
        var v = this.V();
        if (v instanceof (0, $dPHSK.default)) return v;
        return (0, $dPHSK.default).of('Off');
    };
    PDFAcroRadioButton.prototype.getOnValues = function() {
        var widgets = this.getWidgets();
        var onValues = [];
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var onValue = widgets[idx].getOnValue();
            if (onValue) onValues.push(onValue);
        }
        return onValues;
    };
    PDFAcroRadioButton.fromDict = function(dict, ref) {
        return new PDFAcroRadioButton(dict, ref);
    };
    PDFAcroRadioButton.create = function(context) {
        var dict = context.obj({
            FT: 'Btn',
            Ff: (0, $d5IrD.AcroButtonFlags).Radio,
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroRadioButton(dict, ref);
    };
    return PDFAcroRadioButton;
}((0, $bYlnh.default));
var $cad74455a26124b0$export$2e2bcd8739ae039 = $cad74455a26124b0$var$PDFAcroRadioButton;

});

parcelRegister("gEqSi", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1f53a89685317ba$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $1pFNX = parcelRequire("1pFNX");
var $c1f53a89685317ba$var$PDFAcroListBox = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFAcroListBox, _super);
    function PDFAcroListBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroListBox.fromDict = function(dict, ref) {
        return new PDFAcroListBox(dict, ref);
    };
    PDFAcroListBox.create = function(context) {
        var dict = context.obj({
            FT: 'Ch',
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroListBox(dict, ref);
    };
    return PDFAcroListBox;
}((0, $1pFNX.default));
var $c1f53a89685317ba$export$2e2bcd8739ae039 = $c1f53a89685317ba$var$PDFAcroListBox;

});





parcelRegister("4oH3u", function(module, exports) {

$parcel$export(module.exports, "default", () => $333acd2e5fba0d32$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $8auL6 = parcelRequire("8auL6");

var $brir8 = parcelRequire("brir8");

var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");

var $eAof5 = parcelRequire("eAof5");

var $nAWRe = parcelRequire("nAWRe");
var $333acd2e5fba0d32$var$PDFPageTree = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFPageTree, _super);
    function PDFPageTree() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFPageTree.prototype.Parent = function() {
        return this.lookup((0, $dPHSK.default).of('Parent'));
    };
    PDFPageTree.prototype.Kids = function() {
        return this.lookup((0, $dPHSK.default).of('Kids'), (0, $8auL6.default));
    };
    PDFPageTree.prototype.Count = function() {
        return this.lookup((0, $dPHSK.default).of('Count'), (0, $j04jt.default));
    };
    PDFPageTree.prototype.pushTreeNode = function(treeRef) {
        var Kids = this.Kids();
        Kids.push(treeRef);
    };
    PDFPageTree.prototype.pushLeafNode = function(leafRef) {
        var Kids = this.Kids();
        this.insertLeafKid(Kids.size(), leafRef);
    };
    /**
     * Inserts the given ref as a leaf node of this page tree at the specified
     * index (zero-based). Also increments the `Count` of each page tree in the
     * hierarchy to accomodate the new page.
     *
     * Returns the ref of the PDFPageTree node into which `leafRef` was inserted,
     * or `undefined` if it was inserted into the root node (the PDFPageTree upon
     * which the method was first called).
     */ PDFPageTree.prototype.insertLeafNode = function(leafRef, targetIndex) {
        var Kids = this.Kids();
        var Count = this.Count().asNumber();
        if (targetIndex > Count) throw new (0, $nAWRe.InvalidTargetIndexError)(targetIndex, Count);
        var leafsRemainingUntilTarget = targetIndex;
        for(var idx = 0, len = Kids.size(); idx < len; idx++){
            if (leafsRemainingUntilTarget === 0) {
                // Insert page and return
                this.insertLeafKid(idx, leafRef);
                return undefined;
            }
            var kidRef = Kids.get(idx);
            var kid = this.context.lookup(kidRef);
            if (kid instanceof PDFPageTree) {
                if (kid.Count().asNumber() > leafsRemainingUntilTarget) // Dig in
                return kid.insertLeafNode(leafRef, leafsRemainingUntilTarget) || kidRef;
                else // Move on
                leafsRemainingUntilTarget -= kid.Count().asNumber();
            }
            if (kid instanceof (0, $eAof5.default)) // Move on
            leafsRemainingUntilTarget -= 1;
        }
        if (leafsRemainingUntilTarget === 0) {
            // Insert page at the end and return
            this.insertLeafKid(Kids.size(), leafRef);
            return undefined;
        }
        // Should never get here if `targetIndex` is valid
        throw new (0, $nAWRe.CorruptPageTreeError)(targetIndex, 'insertLeafNode');
    };
    /**
     * Removes the leaf node at the specified index (zero-based) from this page
     * tree. Also decrements the `Count` of each page tree in the hierarchy to
     * account for the removed page.
     *
     * If `prune` is true, then intermediate tree nodes will be removed from the
     * tree if they contain 0 children after the leaf node is removed.
     */ PDFPageTree.prototype.removeLeafNode = function(targetIndex, prune) {
        if (prune === void 0) prune = true;
        var Kids = this.Kids();
        var Count = this.Count().asNumber();
        if (targetIndex >= Count) throw new (0, $nAWRe.InvalidTargetIndexError)(targetIndex, Count);
        var leafsRemainingUntilTarget = targetIndex;
        for(var idx = 0, len = Kids.size(); idx < len; idx++){
            var kidRef = Kids.get(idx);
            var kid = this.context.lookup(kidRef);
            if (kid instanceof PDFPageTree) {
                if (kid.Count().asNumber() > leafsRemainingUntilTarget) {
                    // Dig in
                    kid.removeLeafNode(leafsRemainingUntilTarget, prune);
                    if (prune && kid.Kids().size() === 0) Kids.remove(idx);
                    return;
                } else // Move on
                leafsRemainingUntilTarget -= kid.Count().asNumber();
            }
            if (kid instanceof (0, $eAof5.default)) {
                if (leafsRemainingUntilTarget === 0) {
                    // Remove page and return
                    this.removeKid(idx);
                    return;
                } else // Move on
                leafsRemainingUntilTarget -= 1;
            }
        }
        // Should never get here if `targetIndex` is valid
        throw new (0, $nAWRe.CorruptPageTreeError)(targetIndex, 'removeLeafNode');
    };
    PDFPageTree.prototype.ascend = function(visitor) {
        visitor(this);
        var Parent = this.Parent();
        if (Parent) Parent.ascend(visitor);
    };
    /** Performs a Post-Order traversal of this page tree */ PDFPageTree.prototype.traverse = function(visitor) {
        var Kids = this.Kids();
        for(var idx = 0, len = Kids.size(); idx < len; idx++){
            var kidRef = Kids.get(idx);
            var kid = this.context.lookup(kidRef);
            if (kid instanceof PDFPageTree) kid.traverse(visitor);
            visitor(kid, kidRef);
        }
    };
    PDFPageTree.prototype.insertLeafKid = function(kidIdx, leafRef) {
        var Kids = this.Kids();
        this.ascend(function(node) {
            var newCount = node.Count().asNumber() + 1;
            node.set((0, $dPHSK.default).of('Count'), (0, $j04jt.default).of(newCount));
        });
        Kids.insert(kidIdx, leafRef);
    };
    PDFPageTree.prototype.removeKid = function(kidIdx) {
        var Kids = this.Kids();
        var kid = Kids.lookup(kidIdx);
        if (kid instanceof (0, $eAof5.default)) this.ascend(function(node) {
            var newCount = node.Count().asNumber() - 1;
            node.set((0, $dPHSK.default).of('Count'), (0, $j04jt.default).of(newCount));
        });
        Kids.remove(kidIdx);
    };
    PDFPageTree.withContext = function(context, parent) {
        var dict = new Map();
        dict.set((0, $dPHSK.default).of('Type'), (0, $dPHSK.default).of('Pages'));
        dict.set((0, $dPHSK.default).of('Kids'), context.obj([]));
        dict.set((0, $dPHSK.default).of('Count'), context.obj(0));
        if (parent) dict.set((0, $dPHSK.default).of('Parent'), parent);
        return new PDFPageTree(dict, context);
    };
    PDFPageTree.fromMapWithContext = function(map, context) {
        return new PDFPageTree(map, context);
    };
    return PDFPageTree;
}((0, $brir8.default));
var $333acd2e5fba0d32$export$2e2bcd8739ae039 = $333acd2e5fba0d32$var$PDFPageTree;

});

parcelRegister("3QRZR", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ce01d1490df00cf$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $nAWRe = parcelRequire("nAWRe");

var $8auL6 = parcelRequire("8auL6");

var $8gQNC = parcelRequire("8gQNC");

var $brir8 = parcelRequire("brir8");

var $jWFiV = parcelRequire("jWFiV");

var $dPHSK = parcelRequire("dPHSK");

var $eTKUN = parcelRequire("eTKUN");

var $j04jt = parcelRequire("j04jt");

var $kx2r4 = parcelRequire("kx2r4");

var $kHzkO = parcelRequire("kHzkO");

var $8dCYu = parcelRequire("8dCYu");

var $hzVNG = parcelRequire("hzVNG");

var $cDaup = parcelRequire("cDaup");

var $b3l66 = parcelRequire("b3l66");

var $eAof5 = parcelRequire("eAof5");

var $4oH3u = parcelRequire("4oH3u");

var $8zvel = parcelRequire("8zvel");

var $eOx0D = parcelRequire("eOx0D");

var $kThye = parcelRequire("kThye");

var $7qiVc = parcelRequire("7qiVc");

var $14u6w = parcelRequire("14u6w");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
// TODO: Throw error if eof is reached before finishing object parse...
var $2ce01d1490df00cf$var$PDFObjectParser = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFObjectParser, _super);
    function PDFObjectParser(byteStream, context, capNumbers) {
        if (capNumbers === void 0) capNumbers = false;
        var _this = _super.call(this, byteStream, capNumbers) || this;
        _this.context = context;
        return _this;
    }
    // TODO: Is it possible to reduce duplicate parsing for ref lookaheads?
    PDFObjectParser.prototype.parseObject = function() {
        this.skipWhitespaceAndComments();
        if (this.matchKeyword((0, $kThye.Keywords).true)) return (0, $8gQNC.default).True;
        if (this.matchKeyword((0, $kThye.Keywords).false)) return (0, $8gQNC.default).False;
        if (this.matchKeyword((0, $kThye.Keywords).null)) return 0, $eTKUN.default;
        var byte = this.bytes.peek();
        if (byte === (0, $8zvel.default).LessThan && this.bytes.peekAhead(1) === (0, $8zvel.default).LessThan) return this.parseDictOrStream();
        if (byte === (0, $8zvel.default).LessThan) return this.parseHexString();
        if (byte === (0, $8zvel.default).LeftParen) return this.parseString();
        if (byte === (0, $8zvel.default).ForwardSlash) return this.parseName();
        if (byte === (0, $8zvel.default).LeftSquareBracket) return this.parseArray();
        if ((0, $7qiVc.IsNumeric)[byte]) return this.parseNumberOrRef();
        throw new (0, $nAWRe.PDFObjectParsingError)(this.bytes.position(), byte);
    };
    PDFObjectParser.prototype.parseNumberOrRef = function() {
        var firstNum = this.parseRawNumber();
        this.skipWhitespaceAndComments();
        var lookaheadStart = this.bytes.offset();
        if ((0, $7qiVc.IsDigit)[this.bytes.peek()]) {
            var secondNum = this.parseRawNumber();
            this.skipWhitespaceAndComments();
            if (this.bytes.peek() === (0, $8zvel.default).R) {
                this.bytes.assertNext((0, $8zvel.default).R);
                return (0, $kHzkO.default).of(firstNum, secondNum);
            }
        }
        this.bytes.moveTo(lookaheadStart);
        return (0, $j04jt.default).of(firstNum);
    };
    // TODO: Maybe update PDFHexString.of() logic to remove whitespace and validate input?
    PDFObjectParser.prototype.parseHexString = function() {
        var value = '';
        this.bytes.assertNext((0, $8zvel.default).LessThan);
        while(!this.bytes.done() && this.bytes.peek() !== (0, $8zvel.default).GreaterThan)value += (0, $7Kmy8.charFromCode)(this.bytes.next());
        this.bytes.assertNext((0, $8zvel.default).GreaterThan);
        return (0, $jWFiV.default).of(value);
    };
    PDFObjectParser.prototype.parseString = function() {
        var nestingLvl = 0;
        var isEscaped = false;
        var value = '';
        while(!this.bytes.done()){
            var byte = this.bytes.next();
            value += (0, $7Kmy8.charFromCode)(byte);
            // Check for unescaped parenthesis
            if (!isEscaped) {
                if (byte === (0, $8zvel.default).LeftParen) nestingLvl += 1;
                if (byte === (0, $8zvel.default).RightParen) nestingLvl -= 1;
            }
            // Track whether current character is being escaped or not
            if (byte === (0, $8zvel.default).BackSlash) isEscaped = !isEscaped;
            else if (isEscaped) isEscaped = false;
            // Once (if) the unescaped parenthesis balance out, return their contents
            if (nestingLvl === 0) // Remove the outer parens so they aren't part of the contents
            return (0, $8dCYu.default).of(value.substring(1, value.length - 1));
        }
        throw new (0, $nAWRe.UnbalancedParenthesisError)(this.bytes.position());
    };
    // TODO: Compare performance of string concatenation to charFromCode(...bytes)
    // TODO: Maybe preallocate small Uint8Array if can use charFromCode?
    PDFObjectParser.prototype.parseName = function() {
        this.bytes.assertNext((0, $8zvel.default).ForwardSlash);
        var name = '';
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if ((0, $14u6w.IsWhitespace)[byte] || (0, $eOx0D.IsDelimiter)[byte]) break;
            name += (0, $7Kmy8.charFromCode)(byte);
            this.bytes.next();
        }
        return (0, $dPHSK.default).of(name);
    };
    PDFObjectParser.prototype.parseArray = function() {
        this.bytes.assertNext((0, $8zvel.default).LeftSquareBracket);
        this.skipWhitespaceAndComments();
        var pdfArray = (0, $8auL6.default).withContext(this.context);
        while(this.bytes.peek() !== (0, $8zvel.default).RightSquareBracket){
            var element = this.parseObject();
            pdfArray.push(element);
            this.skipWhitespaceAndComments();
        }
        this.bytes.assertNext((0, $8zvel.default).RightSquareBracket);
        return pdfArray;
    };
    PDFObjectParser.prototype.parseDict = function() {
        this.bytes.assertNext((0, $8zvel.default).LessThan);
        this.bytes.assertNext((0, $8zvel.default).LessThan);
        this.skipWhitespaceAndComments();
        var dict = new Map();
        while(!this.bytes.done() && this.bytes.peek() !== (0, $8zvel.default).GreaterThan && this.bytes.peekAhead(1) !== (0, $8zvel.default).GreaterThan){
            var key = this.parseName();
            var value = this.parseObject();
            dict.set(key, value);
            this.skipWhitespaceAndComments();
        }
        this.skipWhitespaceAndComments();
        this.bytes.assertNext((0, $8zvel.default).GreaterThan);
        this.bytes.assertNext((0, $8zvel.default).GreaterThan);
        var Type = dict.get((0, $dPHSK.default).of('Type'));
        if (Type === (0, $dPHSK.default).of('Catalog')) return (0, $b3l66.default).fromMapWithContext(dict, this.context);
        else if (Type === (0, $dPHSK.default).of('Pages')) return (0, $4oH3u.default).fromMapWithContext(dict, this.context);
        else if (Type === (0, $dPHSK.default).of('Page')) return (0, $eAof5.default).fromMapWithContext(dict, this.context);
        else return (0, $brir8.default).fromMapWithContext(dict, this.context);
    };
    PDFObjectParser.prototype.parseDictOrStream = function() {
        var startPos = this.bytes.position();
        var dict = this.parseDict();
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $kThye.Keywords).streamEOF1) && !this.matchKeyword((0, $kThye.Keywords).streamEOF2) && !this.matchKeyword((0, $kThye.Keywords).streamEOF3) && !this.matchKeyword((0, $kThye.Keywords).streamEOF4) && !this.matchKeyword((0, $kThye.Keywords).stream)) return dict;
        var start = this.bytes.offset();
        var end;
        var Length = dict.get((0, $dPHSK.default).of('Length'));
        if (Length instanceof (0, $j04jt.default)) {
            end = start + Length.asNumber();
            this.bytes.moveTo(end);
            this.skipWhitespaceAndComments();
            if (!this.matchKeyword((0, $kThye.Keywords).endstream)) {
                this.bytes.moveTo(start);
                end = this.findEndOfStreamFallback(startPos);
            }
        } else end = this.findEndOfStreamFallback(startPos);
        var contents = this.bytes.slice(start, end);
        return (0, $kx2r4.default).of(dict, contents);
    };
    PDFObjectParser.prototype.findEndOfStreamFallback = function(startPos) {
        // Move to end of stream, while handling nested streams
        var nestingLvl = 1;
        var end = this.bytes.offset();
        while(!this.bytes.done()){
            end = this.bytes.offset();
            if (this.matchKeyword((0, $kThye.Keywords).stream)) nestingLvl += 1;
            else if (this.matchKeyword((0, $kThye.Keywords).EOF1endstream) || this.matchKeyword((0, $kThye.Keywords).EOF2endstream) || this.matchKeyword((0, $kThye.Keywords).EOF3endstream) || this.matchKeyword((0, $kThye.Keywords).endstream)) nestingLvl -= 1;
            else this.bytes.next();
            if (nestingLvl === 0) break;
        }
        if (nestingLvl !== 0) throw new (0, $nAWRe.PDFStreamParsingError)(startPos);
        return end;
    };
    PDFObjectParser.forBytes = function(bytes, context, capNumbers) {
        return new PDFObjectParser((0, $cDaup.default).of(bytes), context, capNumbers);
    };
    PDFObjectParser.forByteStream = function(byteStream, context, capNumbers) {
        if (capNumbers === void 0) capNumbers = false;
        return new PDFObjectParser(byteStream, context, capNumbers);
    };
    return PDFObjectParser;
}((0, $hzVNG.default));
var $2ce01d1490df00cf$export$2e2bcd8739ae039 = $2ce01d1490df00cf$var$PDFObjectParser;

});
parcelRegister("hzVNG", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccc28a798e23d674$export$2e2bcd8739ae039);

var $nAWRe = parcelRequire("nAWRe");

var $8zvel = parcelRequire("8zvel");

var $7qiVc = parcelRequire("7qiVc");

var $14u6w = parcelRequire("14u6w");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $ccc28a798e23d674$var$Newline = (0, $8zvel.default).Newline, $ccc28a798e23d674$var$CarriageReturn = (0, $8zvel.default).CarriageReturn;
// TODO: Throw error if eof is reached before finishing object parse...
var $ccc28a798e23d674$var$BaseParser = /** @class */ function() {
    function BaseParser(bytes, capNumbers) {
        if (capNumbers === void 0) capNumbers = false;
        this.bytes = bytes;
        this.capNumbers = capNumbers;
    }
    BaseParser.prototype.parseRawInt = function() {
        var value = '';
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (!(0, $7qiVc.IsDigit)[byte]) break;
            value += (0, $7Kmy8.charFromCode)(this.bytes.next());
        }
        var numberValue = Number(value);
        if (!value || !isFinite(numberValue)) throw new (0, $nAWRe.NumberParsingError)(this.bytes.position(), value);
        return numberValue;
    };
    // TODO: Maybe handle exponential format?
    // TODO: Compare performance of string concatenation to charFromCode(...bytes)
    BaseParser.prototype.parseRawNumber = function() {
        var value = '';
        // Parse integer-part, the leading (+ | - | . | 0-9)
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (!(0, $7qiVc.IsNumeric)[byte]) break;
            value += (0, $7Kmy8.charFromCode)(this.bytes.next());
            if (byte === (0, $8zvel.default).Period) break;
        }
        // Parse decimal-part, the trailing (0-9)
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (!(0, $7qiVc.IsDigit)[byte]) break;
            value += (0, $7Kmy8.charFromCode)(this.bytes.next());
        }
        var numberValue = Number(value);
        if (!value || !isFinite(numberValue)) throw new (0, $nAWRe.NumberParsingError)(this.bytes.position(), value);
        if (numberValue > Number.MAX_SAFE_INTEGER) {
            if (this.capNumbers) {
                var msg = "Parsed number that is too large for some PDF readers: " + value + ", using Number.MAX_SAFE_INTEGER instead.";
                console.warn(msg);
                return Number.MAX_SAFE_INTEGER;
            } else {
                var msg = "Parsed number that is too large for some PDF readers: " + value + ", not capping.";
                console.warn(msg);
            }
        }
        return numberValue;
    };
    BaseParser.prototype.skipWhitespace = function() {
        while(!this.bytes.done() && (0, $14u6w.IsWhitespace)[this.bytes.peek()])this.bytes.next();
    };
    BaseParser.prototype.skipLine = function() {
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (byte === $ccc28a798e23d674$var$Newline || byte === $ccc28a798e23d674$var$CarriageReturn) return;
            this.bytes.next();
        }
    };
    BaseParser.prototype.skipComment = function() {
        if (this.bytes.peek() !== (0, $8zvel.default).Percent) return false;
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (byte === $ccc28a798e23d674$var$Newline || byte === $ccc28a798e23d674$var$CarriageReturn) return true;
            this.bytes.next();
        }
        return true;
    };
    BaseParser.prototype.skipWhitespaceAndComments = function() {
        this.skipWhitespace();
        while(this.skipComment())this.skipWhitespace();
    };
    BaseParser.prototype.matchKeyword = function(keyword) {
        var initialOffset = this.bytes.offset();
        for(var idx = 0, len = keyword.length; idx < len; idx++)if (this.bytes.done() || this.bytes.next() !== keyword[idx]) {
            this.bytes.moveTo(initialOffset);
            return false;
        }
        return true;
    };
    return BaseParser;
}();
var $ccc28a798e23d674$export$2e2bcd8739ae039 = $ccc28a798e23d674$var$BaseParser;

});
parcelRegister("7qiVc", function(module, exports) {

$parcel$export(module.exports, "IsDigit", () => $5679a387c9e20301$export$9492c31549e88980);
$parcel$export(module.exports, "IsNumeric", () => $5679a387c9e20301$export$4d926b029fa61cfe);

var $8zvel = parcelRequire("8zvel");
var $5679a387c9e20301$export$9492c31549e88980 = new Uint8Array(256);
$5679a387c9e20301$export$9492c31549e88980[(0, $8zvel.default).Zero] = 1;
$5679a387c9e20301$export$9492c31549e88980[(0, $8zvel.default).One] = 1;
$5679a387c9e20301$export$9492c31549e88980[(0, $8zvel.default).Two] = 1;
$5679a387c9e20301$export$9492c31549e88980[(0, $8zvel.default).Three] = 1;
$5679a387c9e20301$export$9492c31549e88980[(0, $8zvel.default).Four] = 1;
$5679a387c9e20301$export$9492c31549e88980[(0, $8zvel.default).Five] = 1;
$5679a387c9e20301$export$9492c31549e88980[(0, $8zvel.default).Six] = 1;
$5679a387c9e20301$export$9492c31549e88980[(0, $8zvel.default).Seven] = 1;
$5679a387c9e20301$export$9492c31549e88980[(0, $8zvel.default).Eight] = 1;
$5679a387c9e20301$export$9492c31549e88980[(0, $8zvel.default).Nine] = 1;
var $5679a387c9e20301$export$d438b84505bee68c = new Uint8Array(256);
$5679a387c9e20301$export$d438b84505bee68c[(0, $8zvel.default).Period] = 1;
$5679a387c9e20301$export$d438b84505bee68c[(0, $8zvel.default).Plus] = 1;
$5679a387c9e20301$export$d438b84505bee68c[(0, $8zvel.default).Minus] = 1;
var $5679a387c9e20301$export$4d926b029fa61cfe = new Uint8Array(256);
for(var $5679a387c9e20301$var$idx = 0, $5679a387c9e20301$var$len = 256; $5679a387c9e20301$var$idx < $5679a387c9e20301$var$len; $5679a387c9e20301$var$idx++)$5679a387c9e20301$export$4d926b029fa61cfe[$5679a387c9e20301$var$idx] = $5679a387c9e20301$export$9492c31549e88980[$5679a387c9e20301$var$idx] || $5679a387c9e20301$export$d438b84505bee68c[$5679a387c9e20301$var$idx] ? 1 : 0;

});


parcelRegister("cDaup", function(module, exports) {

$parcel$export(module.exports, "default", () => $93214384d2c510d6$export$2e2bcd8739ae039);

var $nAWRe = parcelRequire("nAWRe");

var $dLMRX = parcelRequire("dLMRX");

var $8zvel = parcelRequire("8zvel");
// TODO: See how line/col tracking affects performance
var $93214384d2c510d6$var$ByteStream = /** @class */ function() {
    function ByteStream(bytes) {
        this.idx = 0;
        this.line = 0;
        this.column = 0;
        this.bytes = bytes;
        this.length = this.bytes.length;
    }
    ByteStream.prototype.moveTo = function(offset) {
        this.idx = offset;
    };
    ByteStream.prototype.next = function() {
        var byte = this.bytes[this.idx++];
        if (byte === (0, $8zvel.default).Newline) {
            this.line += 1;
            this.column = 0;
        } else this.column += 1;
        return byte;
    };
    ByteStream.prototype.assertNext = function(expected) {
        if (this.peek() !== expected) throw new (0, $nAWRe.NextByteAssertionError)(this.position(), expected, this.peek());
        return this.next();
    };
    ByteStream.prototype.peek = function() {
        return this.bytes[this.idx];
    };
    ByteStream.prototype.peekAhead = function(steps) {
        return this.bytes[this.idx + steps];
    };
    ByteStream.prototype.peekAt = function(offset) {
        return this.bytes[offset];
    };
    ByteStream.prototype.done = function() {
        return this.idx >= this.length;
    };
    ByteStream.prototype.offset = function() {
        return this.idx;
    };
    ByteStream.prototype.slice = function(start, end) {
        return this.bytes.slice(start, end);
    };
    ByteStream.prototype.position = function() {
        return {
            line: this.line,
            column: this.column,
            offset: this.idx
        };
    };
    ByteStream.of = function(bytes) {
        return new ByteStream(bytes);
    };
    ByteStream.fromPDFRawStream = function(rawStream) {
        return ByteStream.of((0, $dLMRX.decodePDFRawStream)(rawStream).decode());
    };
    return ByteStream;
}();
var $93214384d2c510d6$export$2e2bcd8739ae039 = $93214384d2c510d6$var$ByteStream;

});

parcelRegister("kThye", function(module, exports) {

$parcel$export(module.exports, "Keywords", () => $f3568ef95260ec55$export$93ad50ccfacdd77);

var $cOQTW = parcelRequire("cOQTW");

var $8zvel = parcelRequire("8zvel");
var $f3568ef95260ec55$var$Space = (0, $8zvel.default).Space, $f3568ef95260ec55$var$CarriageReturn = (0, $8zvel.default).CarriageReturn, $f3568ef95260ec55$var$Newline = (0, $8zvel.default).Newline;
var $f3568ef95260ec55$var$stream = [
    (0, $8zvel.default).s,
    (0, $8zvel.default).t,
    (0, $8zvel.default).r,
    (0, $8zvel.default).e,
    (0, $8zvel.default).a,
    (0, $8zvel.default).m
];
var $f3568ef95260ec55$var$endstream = [
    (0, $8zvel.default).e,
    (0, $8zvel.default).n,
    (0, $8zvel.default).d,
    (0, $8zvel.default).s,
    (0, $8zvel.default).t,
    (0, $8zvel.default).r,
    (0, $8zvel.default).e,
    (0, $8zvel.default).a,
    (0, $8zvel.default).m
];
var $f3568ef95260ec55$export$93ad50ccfacdd77 = {
    header: [
        (0, $8zvel.default).Percent,
        (0, $8zvel.default).P,
        (0, $8zvel.default).D,
        (0, $8zvel.default).F,
        (0, $8zvel.default).Dash
    ],
    eof: [
        (0, $8zvel.default).Percent,
        (0, $8zvel.default).Percent,
        (0, $8zvel.default).E,
        (0, $8zvel.default).O,
        (0, $8zvel.default).F
    ],
    obj: [
        (0, $8zvel.default).o,
        (0, $8zvel.default).b,
        (0, $8zvel.default).j
    ],
    endobj: [
        (0, $8zvel.default).e,
        (0, $8zvel.default).n,
        (0, $8zvel.default).d,
        (0, $8zvel.default).o,
        (0, $8zvel.default).b,
        (0, $8zvel.default).j
    ],
    xref: [
        (0, $8zvel.default).x,
        (0, $8zvel.default).r,
        (0, $8zvel.default).e,
        (0, $8zvel.default).f
    ],
    trailer: [
        (0, $8zvel.default).t,
        (0, $8zvel.default).r,
        (0, $8zvel.default).a,
        (0, $8zvel.default).i,
        (0, $8zvel.default).l,
        (0, $8zvel.default).e,
        (0, $8zvel.default).r
    ],
    startxref: [
        (0, $8zvel.default).s,
        (0, $8zvel.default).t,
        (0, $8zvel.default).a,
        (0, $8zvel.default).r,
        (0, $8zvel.default).t,
        (0, $8zvel.default).x,
        (0, $8zvel.default).r,
        (0, $8zvel.default).e,
        (0, $8zvel.default).f
    ],
    true: [
        (0, $8zvel.default).t,
        (0, $8zvel.default).r,
        (0, $8zvel.default).u,
        (0, $8zvel.default).e
    ],
    false: [
        (0, $8zvel.default).f,
        (0, $8zvel.default).a,
        (0, $8zvel.default).l,
        (0, $8zvel.default).s,
        (0, $8zvel.default).e
    ],
    null: [
        (0, $8zvel.default).n,
        (0, $8zvel.default).u,
        (0, $8zvel.default).l,
        (0, $8zvel.default).l
    ],
    stream: $f3568ef95260ec55$var$stream,
    streamEOF1: (0, $cOQTW.__spreadArrays)($f3568ef95260ec55$var$stream, [
        $f3568ef95260ec55$var$Space,
        $f3568ef95260ec55$var$CarriageReturn,
        $f3568ef95260ec55$var$Newline
    ]),
    streamEOF2: (0, $cOQTW.__spreadArrays)($f3568ef95260ec55$var$stream, [
        $f3568ef95260ec55$var$CarriageReturn,
        $f3568ef95260ec55$var$Newline
    ]),
    streamEOF3: (0, $cOQTW.__spreadArrays)($f3568ef95260ec55$var$stream, [
        $f3568ef95260ec55$var$CarriageReturn
    ]),
    streamEOF4: (0, $cOQTW.__spreadArrays)($f3568ef95260ec55$var$stream, [
        $f3568ef95260ec55$var$Newline
    ]),
    endstream: $f3568ef95260ec55$var$endstream,
    EOF1endstream: (0, $cOQTW.__spreadArrays)([
        $f3568ef95260ec55$var$CarriageReturn,
        $f3568ef95260ec55$var$Newline
    ], $f3568ef95260ec55$var$endstream),
    EOF2endstream: (0, $cOQTW.__spreadArrays)([
        $f3568ef95260ec55$var$CarriageReturn
    ], $f3568ef95260ec55$var$endstream),
    EOF3endstream: (0, $cOQTW.__spreadArrays)([
        $f3568ef95260ec55$var$Newline
    ], $f3568ef95260ec55$var$endstream)
};

});


parcelRegister("7yUXZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $016bbd830ce30da5$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $nAWRe = parcelRequire("nAWRe");

var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");

var $kHzkO = parcelRequire("kHzkO");

var $cDaup = parcelRequire("cDaup");

var $3QRZR = parcelRequire("3QRZR");
parcelRequire("fvYKZ");
var $ggjMi = parcelRequire("ggjMi");
var $016bbd830ce30da5$var$PDFObjectStreamParser = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFObjectStreamParser, _super);
    function PDFObjectStreamParser(rawStream, shouldWaitForTick) {
        var _this = _super.call(this, (0, $cDaup.default).fromPDFRawStream(rawStream), rawStream.dict.context) || this;
        var dict = rawStream.dict;
        _this.alreadyParsed = false;
        _this.shouldWaitForTick = shouldWaitForTick || function() {
            return false;
        };
        _this.firstOffset = dict.lookup((0, $dPHSK.default).of('First'), (0, $j04jt.default)).asNumber();
        _this.objectCount = dict.lookup((0, $dPHSK.default).of('N'), (0, $j04jt.default)).asNumber();
        return _this;
    }
    PDFObjectStreamParser.prototype.parseIntoContext = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var offsetsAndObjectNumbers, idx, len, _a, objectNumber, offset, object, ref;
            return (0, $cOQTW.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (this.alreadyParsed) throw new (0, $nAWRe.ReparseError)('PDFObjectStreamParser', 'parseIntoContext');
                        this.alreadyParsed = true;
                        offsetsAndObjectNumbers = this.parseOffsetsAndObjectNumbers();
                        idx = 0, len = offsetsAndObjectNumbers.length;
                        _b.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            4
                        ];
                        _a = offsetsAndObjectNumbers[idx], objectNumber = _a.objectNumber, offset = _a.offset;
                        this.bytes.moveTo(this.firstOffset + offset);
                        object = this.parseObject();
                        ref = (0, $kHzkO.default).of(objectNumber, 0);
                        this.context.assign(ref, object);
                        if (!this.shouldWaitForTick()) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $ggjMi.waitForTick)()
                        ];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    PDFObjectStreamParser.prototype.parseOffsetsAndObjectNumbers = function() {
        var offsetsAndObjectNumbers = [];
        for(var idx = 0, len = this.objectCount; idx < len; idx++){
            this.skipWhitespaceAndComments();
            var objectNumber = this.parseRawInt();
            this.skipWhitespaceAndComments();
            var offset = this.parseRawInt();
            offsetsAndObjectNumbers.push({
                objectNumber: objectNumber,
                offset: offset
            });
        }
        return offsetsAndObjectNumbers;
    };
    PDFObjectStreamParser.forStream = function(rawStream, shouldWaitForTick) {
        return new PDFObjectStreamParser(rawStream, shouldWaitForTick);
    };
    return PDFObjectStreamParser;
}((0, $3QRZR.default));
var $016bbd830ce30da5$export$2e2bcd8739ae039 = $016bbd830ce30da5$var$PDFObjectStreamParser;

});

parcelRegister("14nUL", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c78b71d995ee90b$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $Vy0LI = parcelRequire("Vy0LI");

var $eHlB9 = parcelRequire("eHlB9");

var $4S3gv = parcelRequire("4S3gv");

var $nAWRe = parcelRequire("nAWRe");

var $brir8 = parcelRequire("brir8");

var $eTWtL = parcelRequire("eTWtL");

var $dPHSK = parcelRequire("dPHSK");

var $kx2r4 = parcelRequire("kx2r4");

var $kHzkO = parcelRequire("kHzkO");

var $cDaup = parcelRequire("cDaup");

var $3QRZR = parcelRequire("3QRZR");

var $7yUXZ = parcelRequire("7yUXZ");

var $b1gaC = parcelRequire("b1gaC");

var $kl4jO = parcelRequire("kl4jO");

var $8zvel = parcelRequire("8zvel");

var $kThye = parcelRequire("kThye");

var $7qiVc = parcelRequire("7qiVc");
parcelRequire("fvYKZ");
var $ggjMi = parcelRequire("ggjMi");
var $0c78b71d995ee90b$var$PDFParser = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFParser, _super);
    function PDFParser(pdfBytes, objectsPerTick, throwOnInvalidObject, capNumbers) {
        if (objectsPerTick === void 0) objectsPerTick = Infinity;
        if (throwOnInvalidObject === void 0) throwOnInvalidObject = false;
        if (capNumbers === void 0) capNumbers = false;
        var _this = _super.call(this, (0, $cDaup.default).of(pdfBytes), (0, $kl4jO.default).create(), capNumbers) || this;
        _this.alreadyParsed = false;
        _this.parsedObjects = 0;
        _this.shouldWaitForTick = function() {
            _this.parsedObjects += 1;
            return _this.parsedObjects % _this.objectsPerTick === 0;
        };
        _this.objectsPerTick = objectsPerTick;
        _this.throwOnInvalidObject = throwOnInvalidObject;
        return _this;
    }
    PDFParser.prototype.parseDocument = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var prevOffset, offset;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.alreadyParsed) throw new (0, $nAWRe.ReparseError)('PDFParser', 'parseDocument');
                        this.alreadyParsed = true;
                        this.context.header = this.parseHeader();
                        _a.label = 1;
                    case 1:
                        if (!!this.bytes.done()) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.parseDocumentSection()
                        ];
                    case 2:
                        _a.sent();
                        offset = this.bytes.offset();
                        if (offset === prevOffset) throw new (0, $nAWRe.StalledParserError)(this.bytes.position());
                        prevOffset = offset;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 3:
                        this.maybeRecoverRoot();
                        if (this.context.lookup((0, $kHzkO.default).of(0))) {
                            console.warn('Removing parsed object: 0 0 R');
                            this.context.delete((0, $kHzkO.default).of(0));
                        }
                        return [
                            2 /*return*/ ,
                            this.context
                        ];
                }
            });
        });
    };
    PDFParser.prototype.maybeRecoverRoot = function() {
        var isValidCatalog = function(obj) {
            return obj instanceof (0, $brir8.default) && obj.lookup((0, $dPHSK.default).of('Type')) === (0, $dPHSK.default).of('Catalog');
        };
        var catalog = this.context.lookup(this.context.trailerInfo.Root);
        if (!isValidCatalog(catalog)) {
            var indirectObjects = this.context.enumerateIndirectObjects();
            for(var idx = 0, len = indirectObjects.length; idx < len; idx++){
                var _a = indirectObjects[idx], ref = _a[0], object = _a[1];
                if (isValidCatalog(object)) this.context.trailerInfo.Root = ref;
            }
        }
    };
    PDFParser.prototype.parseHeader = function() {
        while(!this.bytes.done()){
            if (this.matchKeyword((0, $kThye.Keywords).header)) {
                var major = this.parseRawInt();
                this.bytes.assertNext((0, $8zvel.default).Period);
                var minor = this.parseRawInt();
                var header = (0, $eHlB9.default).forVersion(major, minor);
                this.skipBinaryHeaderComment();
                return header;
            }
            this.bytes.next();
        }
        throw new (0, $nAWRe.MissingPDFHeaderError)(this.bytes.position());
    };
    PDFParser.prototype.parseIndirectObjectHeader = function() {
        this.skipWhitespaceAndComments();
        var objectNumber = this.parseRawInt();
        this.skipWhitespaceAndComments();
        var generationNumber = this.parseRawInt();
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $kThye.Keywords).obj)) throw new (0, $nAWRe.MissingKeywordError)(this.bytes.position(), (0, $kThye.Keywords).obj);
        return (0, $kHzkO.default).of(objectNumber, generationNumber);
    };
    PDFParser.prototype.matchIndirectObjectHeader = function() {
        var initialOffset = this.bytes.offset();
        try {
            this.parseIndirectObjectHeader();
            return true;
        } catch (e) {
            this.bytes.moveTo(initialOffset);
            return false;
        }
    };
    PDFParser.prototype.parseIndirectObject = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var ref, object;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        ref = this.parseIndirectObjectHeader();
                        this.skipWhitespaceAndComments();
                        object = this.parseObject();
                        this.skipWhitespaceAndComments();
                        // if (!this.matchKeyword(Keywords.endobj)) {
                        // throw new MissingKeywordError(this.bytes.position(), Keywords.endobj);
                        // }
                        // TODO: Log a warning if this fails...
                        this.matchKeyword((0, $kThye.Keywords).endobj);
                        if (!(object instanceof (0, $kx2r4.default) && object.dict.lookup((0, $dPHSK.default).of('Type')) === (0, $dPHSK.default).of('ObjStm'))) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $7yUXZ.default).forStream(object, this.shouldWaitForTick).parseIntoContext()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        if (object instanceof (0, $kx2r4.default) && object.dict.lookup((0, $dPHSK.default).of('Type')) === (0, $dPHSK.default).of('XRef')) (0, $b1gaC.default).forStream(object).parseIntoContext();
                        else this.context.assign(ref, object);
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ ,
                            ref
                        ];
                }
            });
        });
    };
    // TODO: Improve and clean this up
    PDFParser.prototype.tryToParseInvalidIndirectObject = function() {
        var startPos = this.bytes.position();
        var msg = "Trying to parse invalid object: " + JSON.stringify(startPos) + ")";
        if (this.throwOnInvalidObject) throw new Error(msg);
        console.warn(msg);
        var ref = this.parseIndirectObjectHeader();
        console.warn("Invalid object ref: " + ref);
        this.skipWhitespaceAndComments();
        var start = this.bytes.offset();
        var failed = true;
        while(!this.bytes.done()){
            if (this.matchKeyword((0, $kThye.Keywords).endobj)) failed = false;
            if (!failed) break;
            this.bytes.next();
        }
        if (failed) throw new (0, $nAWRe.PDFInvalidObjectParsingError)(startPos);
        var end = this.bytes.offset() - (0, $kThye.Keywords).endobj.length;
        var object = (0, $eTWtL.default).of(this.bytes.slice(start, end));
        this.context.assign(ref, object);
        return ref;
    };
    PDFParser.prototype.parseIndirectObjects = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var initialOffset, e_1;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.skipWhitespaceAndComments();
                        _a.label = 1;
                    case 1:
                        if (!(!this.bytes.done() && (0, $7qiVc.IsDigit)[this.bytes.peek()])) return [
                            3 /*break*/ ,
                            8
                        ];
                        initialOffset = this.bytes.offset();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.parseIndirectObject()
                        ];
                    case 3:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        e_1 = _a.sent();
                        // TODO: Add tracing/logging mechanism to track when this happens!
                        this.bytes.moveTo(initialOffset);
                        this.tryToParseInvalidIndirectObject();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        this.skipWhitespaceAndComments();
                        // TODO: Can this be done only when needed, to avoid harming performance?
                        this.skipJibberish();
                        if (!this.shouldWaitForTick()) return [
                            3 /*break*/ ,
                            7
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $ggjMi.waitForTick)()
                        ];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 8:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    PDFParser.prototype.maybeParseCrossRefSection = function() {
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $kThye.Keywords).xref)) return;
        this.skipWhitespaceAndComments();
        var objectNumber = -1;
        var xref = (0, $Vy0LI.default).createEmpty();
        while(!this.bytes.done() && (0, $7qiVc.IsDigit)[this.bytes.peek()]){
            var firstInt = this.parseRawInt();
            this.skipWhitespaceAndComments();
            var secondInt = this.parseRawInt();
            this.skipWhitespaceAndComments();
            var byte = this.bytes.peek();
            if (byte === (0, $8zvel.default).n || byte === (0, $8zvel.default).f) {
                var ref = (0, $kHzkO.default).of(objectNumber, secondInt);
                if (this.bytes.next() === (0, $8zvel.default).n) xref.addEntry(ref, firstInt);
                else // this.context.delete(ref);
                xref.addDeletedEntry(ref, firstInt);
                objectNumber += 1;
            } else objectNumber = firstInt;
            this.skipWhitespaceAndComments();
        }
        return xref;
    };
    PDFParser.prototype.maybeParseTrailerDict = function() {
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $kThye.Keywords).trailer)) return;
        this.skipWhitespaceAndComments();
        var dict = this.parseDict();
        var context = this.context;
        context.trailerInfo = {
            Root: dict.get((0, $dPHSK.default).of('Root')) || context.trailerInfo.Root,
            Encrypt: dict.get((0, $dPHSK.default).of('Encrypt')) || context.trailerInfo.Encrypt,
            Info: dict.get((0, $dPHSK.default).of('Info')) || context.trailerInfo.Info,
            ID: dict.get((0, $dPHSK.default).of('ID')) || context.trailerInfo.ID
        };
    };
    PDFParser.prototype.maybeParseTrailer = function() {
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $kThye.Keywords).startxref)) return;
        this.skipWhitespaceAndComments();
        var offset = this.parseRawInt();
        this.skipWhitespace();
        this.matchKeyword((0, $kThye.Keywords).eof);
        this.skipWhitespaceAndComments();
        this.matchKeyword((0, $kThye.Keywords).eof);
        this.skipWhitespaceAndComments();
        return (0, $4S3gv.default).forLastCrossRefSectionOffset(offset);
    };
    PDFParser.prototype.parseDocumentSection = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.parseIndirectObjects()
                        ];
                    case 1:
                        _a.sent();
                        this.maybeParseCrossRefSection();
                        this.maybeParseTrailerDict();
                        this.maybeParseTrailer();
                        // TODO: Can this be done only when needed, to avoid harming performance?
                        this.skipJibberish();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * This operation is not necessary for valid PDF files. But some invalid PDFs
     * contain jibberish in between indirect objects. This method is designed to
     * skip past that jibberish, should it exist, until it reaches the next
     * indirect object header, an xref table section, or the file trailer.
     */ PDFParser.prototype.skipJibberish = function() {
        this.skipWhitespaceAndComments();
        while(!this.bytes.done()){
            var initialOffset = this.bytes.offset();
            var byte = this.bytes.peek();
            var isAlphaNumeric = byte >= (0, $8zvel.default).Space && byte <= (0, $8zvel.default).Tilde;
            if (isAlphaNumeric) {
                if (this.matchKeyword((0, $kThye.Keywords).xref) || this.matchKeyword((0, $kThye.Keywords).trailer) || this.matchKeyword((0, $kThye.Keywords).startxref) || this.matchIndirectObjectHeader()) {
                    this.bytes.moveTo(initialOffset);
                    break;
                }
            }
            this.bytes.next();
        }
    };
    /**
     * Skips the binary comment following a PDF header. The specification
     * defines this binary comment (section 7.5.2 File Header) as a sequence of 4
     * or more bytes that are 128 or greater, and which are preceded by a "%".
     *
     * This would imply that to strip out this binary comment, we could check for
     * a sequence of bytes starting with "%", and remove all subsequent bytes that
     * are 128 or greater. This works for many documents that properly comply with
     * the spec. But in the wild, there are PDFs that omit the leading "%", and
     * include bytes that are less than 128 (e.g. 0 or 1). So in order to parse
     * these headers correctly, we just throw out all bytes leading up to the
     * first indirect object header.
     */ PDFParser.prototype.skipBinaryHeaderComment = function() {
        this.skipWhitespaceAndComments();
        try {
            var initialOffset = this.bytes.offset();
            this.parseIndirectObjectHeader();
            this.bytes.moveTo(initialOffset);
        } catch (e) {
            this.bytes.next();
            this.skipWhitespaceAndComments();
        }
    };
    PDFParser.forBytesWithOptions = function(pdfBytes, objectsPerTick, throwOnInvalidObject, capNumbers) {
        return new PDFParser(pdfBytes, objectsPerTick, throwOnInvalidObject, capNumbers);
    };
    return PDFParser;
}((0, $3QRZR.default));
var $0c78b71d995ee90b$export$2e2bcd8739ae039 = $0c78b71d995ee90b$var$PDFParser;

});
parcelRegister("b1gaC", function(module, exports) {

$parcel$export(module.exports, "default", () => $805c54c8bff8c138$export$2e2bcd8739ae039);

var $nAWRe = parcelRequire("nAWRe");

var $8auL6 = parcelRequire("8auL6");

var $dPHSK = parcelRequire("dPHSK");

var $j04jt = parcelRequire("j04jt");

var $kHzkO = parcelRequire("kHzkO");

var $cDaup = parcelRequire("cDaup");
var $805c54c8bff8c138$var$PDFXRefStreamParser = /** @class */ function() {
    function PDFXRefStreamParser(rawStream) {
        this.alreadyParsed = false;
        this.dict = rawStream.dict;
        this.bytes = (0, $cDaup.default).fromPDFRawStream(rawStream);
        this.context = this.dict.context;
        var Size = this.dict.lookup((0, $dPHSK.default).of('Size'), (0, $j04jt.default));
        var Index = this.dict.lookup((0, $dPHSK.default).of('Index'));
        if (Index instanceof (0, $8auL6.default)) {
            this.subsections = [];
            for(var idx = 0, len = Index.size(); idx < len; idx += 2){
                var firstObjectNumber = Index.lookup(idx + 0, (0, $j04jt.default)).asNumber();
                var length_1 = Index.lookup(idx + 1, (0, $j04jt.default)).asNumber();
                this.subsections.push({
                    firstObjectNumber: firstObjectNumber,
                    length: length_1
                });
            }
        } else this.subsections = [
            {
                firstObjectNumber: 0,
                length: Size.asNumber()
            }
        ];
        var W = this.dict.lookup((0, $dPHSK.default).of('W'), (0, $8auL6.default));
        this.byteWidths = [
            -1,
            -1,
            -1
        ];
        for(var idx = 0, len = W.size(); idx < len; idx++)this.byteWidths[idx] = W.lookup(idx, (0, $j04jt.default)).asNumber();
    }
    PDFXRefStreamParser.prototype.parseIntoContext = function() {
        if (this.alreadyParsed) throw new (0, $nAWRe.ReparseError)('PDFXRefStreamParser', 'parseIntoContext');
        this.alreadyParsed = true;
        this.context.trailerInfo = {
            Root: this.dict.get((0, $dPHSK.default).of('Root')),
            Encrypt: this.dict.get((0, $dPHSK.default).of('Encrypt')),
            Info: this.dict.get((0, $dPHSK.default).of('Info')),
            ID: this.dict.get((0, $dPHSK.default).of('ID'))
        };
        var entries = this.parseEntries();
        // for (let idx = 0, len = entries.length; idx < len; idx++) {
        // const entry = entries[idx];
        // if (entry.deleted) this.context.delete(entry.ref);
        // }
        return entries;
    };
    PDFXRefStreamParser.prototype.parseEntries = function() {
        var entries = [];
        var _a = this.byteWidths, typeFieldWidth = _a[0], offsetFieldWidth = _a[1], genFieldWidth = _a[2];
        for(var subsectionIdx = 0, subsectionLen = this.subsections.length; subsectionIdx < subsectionLen; subsectionIdx++){
            var _b = this.subsections[subsectionIdx], firstObjectNumber = _b.firstObjectNumber, length_2 = _b.length;
            for(var objIdx = 0; objIdx < length_2; objIdx++){
                var type = 0;
                for(var idx = 0, len = typeFieldWidth; idx < len; idx++)type = type << 8 | this.bytes.next();
                var offset = 0;
                for(var idx = 0, len = offsetFieldWidth; idx < len; idx++)offset = offset << 8 | this.bytes.next();
                var generationNumber = 0;
                for(var idx = 0, len = genFieldWidth; idx < len; idx++)generationNumber = generationNumber << 8 | this.bytes.next();
                // When the `type` field is absent, it defaults to 1
                if (typeFieldWidth === 0) type = 1;
                var objectNumber = firstObjectNumber + objIdx;
                var entry = {
                    ref: (0, $kHzkO.default).of(objectNumber, generationNumber),
                    offset: offset,
                    deleted: type === 0,
                    inObjectStream: type === 2
                };
                entries.push(entry);
            }
        }
        return entries;
    };
    PDFXRefStreamParser.forStream = function(rawStream) {
        return new PDFXRefStreamParser(rawStream);
    };
    return PDFXRefStreamParser;
}();
var $805c54c8bff8c138$export$2e2bcd8739ae039 = $805c54c8bff8c138$var$PDFXRefStreamParser;

});


parcelRegister("6anj6", function(module, exports) {
$parcel$export(module.exports, "AnnotationFlags", () => (parcelRequire("ckfWn")).AnnotationFlags);

$parcel$export(module.exports, "PDFWidgetAnnotation", () => (parcelRequire("7ds0z")).default);

var $frgJX = parcelRequire("frgJX");

var $7ds0z = parcelRequire("7ds0z");

var $6293R = parcelRequire("6293R");
parcelRequire("ckfWn");

});
parcelRegister("ckfWn", function(module, exports) {

$parcel$export(module.exports, "AnnotationFlags", () => $8f93b7bf8ef0f00e$export$1fa7b68b35026177);
var $8f93b7bf8ef0f00e$var$flag = function(bitIndex) {
    return 1 << bitIndex;
};
var $8f93b7bf8ef0f00e$export$1fa7b68b35026177;
(function(AnnotationFlags) {
    /**
     * If set, do not display the annotation if it does not belong to one of the
     * standard annotation types and no annotation handler is available. If clear,
     * display such an unknown annotation using an appearance stream specified by
     * its appearance dictionary, if any.
     */ AnnotationFlags[AnnotationFlags["Invisible"] = $8f93b7bf8ef0f00e$var$flag(0)] = "Invisible";
    /**
     * If set, do not display or print the annotation or allow it to interact with
     * the user, regardless of its annotation type or whether an annotation
     * handler is available.
     *
     * In cases where screen space is limited, the ability to hide and show
     * annotations selectively can be used in combination with appearance streams
     * to display auxiliary pop-up information similar in function to online help
     * systems.
     */ AnnotationFlags[AnnotationFlags["Hidden"] = $8f93b7bf8ef0f00e$var$flag(1)] = "Hidden";
    /**
     * If set, print the annotation when the page is printed. If clear, never
     * print the annotation, regardless of whether it is displayed on the screen.
     *
     * This can be useful for annotations representing interactive pushbuttons,
     * which would serve no meaningful purpose on the printed page.
     */ AnnotationFlags[AnnotationFlags["Print"] = $8f93b7bf8ef0f00e$var$flag(2)] = "Print";
    /**
     * If set, do not scale the annotation’s appearance to match the magnification
     * of the page. The location of the annotation on the page (defined by the
     * upper-left corner of its annotation rectangle) shall remain fixed,
     * regardless of the page magnification.
     */ AnnotationFlags[AnnotationFlags["NoZoom"] = $8f93b7bf8ef0f00e$var$flag(3)] = "NoZoom";
    /**
     * If set, do not rotate the annotation’s appearance to match the rotation of
     * the page. The upper-left corner of the annotation rectangle shall remain in
     * a fixed location on the page, regardless of the page rotation.
     */ AnnotationFlags[AnnotationFlags["NoRotate"] = $8f93b7bf8ef0f00e$var$flag(4)] = "NoRotate";
    /**
     * If set, do not display the annotation on the screen or allow it to interact
     * with the user. The annotation may be printed (depending on the setting of
     * the Print flag) but should be considered hidden for purposes of on-screen
     * display and user interaction.
     */ AnnotationFlags[AnnotationFlags["NoView"] = $8f93b7bf8ef0f00e$var$flag(5)] = "NoView";
    /**
     * If set, do not allow the annotation to interact with the user. The
     * annotation may be displayed or printed (depending on the settings of the
     * NoView and Print flags) but should not respond to mouse clicks or change
     * its appearance in response to mouse motions.
     *
     * This flag shall be ignored for widget annotations; its function is
     * subsumed by the ReadOnly flag of the associated form field.
     */ AnnotationFlags[AnnotationFlags["ReadOnly"] = $8f93b7bf8ef0f00e$var$flag(6)] = "ReadOnly";
    /**
     * If set, do not allow the annotation to be deleted or its properties
     * (including position and size) to be modified by the user. However, this
     * flag does not restrict changes to the annotation’s contents, such as the
     * value of a form field.
     */ AnnotationFlags[AnnotationFlags["Locked"] = $8f93b7bf8ef0f00e$var$flag(7)] = "Locked";
    /**
     * If set, invert the interpretation of the NoView flag for certain events.
     *
     * A typical use is to have an annotation that appears only when a mouse
     * cursor is held over it.
     */ AnnotationFlags[AnnotationFlags["ToggleNoView"] = $8f93b7bf8ef0f00e$var$flag(8)] = "ToggleNoView";
    /**
     * If set, do not allow the contents of the annotation to be modified by the
     * user. This flag does not restrict deletion of the annotation or changes to
     * other annotation properties, such as position and size.
     */ AnnotationFlags[AnnotationFlags["LockedContents"] = $8f93b7bf8ef0f00e$var$flag(9)] = "LockedContents";
})($8f93b7bf8ef0f00e$export$1fa7b68b35026177 || ($8f93b7bf8ef0f00e$export$1fa7b68b35026177 = {}));

});




parcelRegister("55HYh", function(module, exports) {

$parcel$export(module.exports, "degrees", () => $3b4f8728c2695c8d$export$41fc368e1a942b97);
$parcel$export(module.exports, "degreesToRadians", () => $3b4f8728c2695c8d$export$c9fcf1a7df975d78);
$parcel$export(module.exports, "toRadians", () => $3b4f8728c2695c8d$export$cba01ba138429a1d);
$parcel$export(module.exports, "toDegrees", () => $3b4f8728c2695c8d$export$56cb859c01fa134d);
$parcel$export(module.exports, "reduceRotation", () => $3b4f8728c2695c8d$export$ee0ed07fe78ec05);
$parcel$export(module.exports, "adjustDimsForRotation", () => $3b4f8728c2695c8d$export$312e44550db33c6a);
$parcel$export(module.exports, "rotateRectangle", () => $3b4f8728c2695c8d$export$afddc3b8600307a4);
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
var $hP0hy = parcelRequire("hP0hy");
var $3b4f8728c2695c8d$export$c3cc0f63dbb3500f;
(function(RotationTypes) {
    RotationTypes["Degrees"] = "degrees";
    RotationTypes["Radians"] = "radians";
})($3b4f8728c2695c8d$export$c3cc0f63dbb3500f || ($3b4f8728c2695c8d$export$c3cc0f63dbb3500f = {}));
var $3b4f8728c2695c8d$export$8449e153fbd325fc = function(radianAngle) {
    (0, $j0tvB.assertIs)(radianAngle, 'radianAngle', [
        'number'
    ]);
    return {
        type: $3b4f8728c2695c8d$export$c3cc0f63dbb3500f.Radians,
        angle: radianAngle
    };
};
var $3b4f8728c2695c8d$export$41fc368e1a942b97 = function(degreeAngle) {
    (0, $j0tvB.assertIs)(degreeAngle, 'degreeAngle', [
        'number'
    ]);
    return {
        type: $3b4f8728c2695c8d$export$c3cc0f63dbb3500f.Degrees,
        angle: degreeAngle
    };
};
var $3b4f8728c2695c8d$var$Radians = $3b4f8728c2695c8d$export$c3cc0f63dbb3500f.Radians, $3b4f8728c2695c8d$var$Degrees = $3b4f8728c2695c8d$export$c3cc0f63dbb3500f.Degrees;
var $3b4f8728c2695c8d$export$c9fcf1a7df975d78 = function(degree) {
    return degree * Math.PI / 180;
};
var $3b4f8728c2695c8d$export$c41dd2a8460d3196 = function(radian) {
    return radian * 180 / Math.PI;
};
var $3b4f8728c2695c8d$export$cba01ba138429a1d = function(rotation) {
    return rotation.type === $3b4f8728c2695c8d$var$Radians ? rotation.angle : rotation.type === $3b4f8728c2695c8d$var$Degrees ? $3b4f8728c2695c8d$export$c9fcf1a7df975d78(rotation.angle) : (0, $hP0hy.error)("Invalid rotation: " + JSON.stringify(rotation));
};
var $3b4f8728c2695c8d$export$56cb859c01fa134d = function(rotation) {
    return rotation.type === $3b4f8728c2695c8d$var$Radians ? $3b4f8728c2695c8d$export$c41dd2a8460d3196(rotation.angle) : rotation.type === $3b4f8728c2695c8d$var$Degrees ? rotation.angle : (0, $hP0hy.error)("Invalid rotation: " + JSON.stringify(rotation));
};
var $3b4f8728c2695c8d$export$ee0ed07fe78ec05 = function(degreeAngle) {
    if (degreeAngle === void 0) degreeAngle = 0;
    var quadrants = degreeAngle / 90 % 4;
    if (quadrants === 0) return 0;
    if (quadrants === 1) return 90;
    if (quadrants === 2) return 180;
    if (quadrants === 3) return 270;
    return 0; // `degreeAngle` is not a multiple of 90
};
var $3b4f8728c2695c8d$export$312e44550db33c6a = function(dims, degreeAngle) {
    if (degreeAngle === void 0) degreeAngle = 0;
    var rotation = $3b4f8728c2695c8d$export$ee0ed07fe78ec05(degreeAngle);
    return rotation === 90 || rotation === 270 ? {
        width: dims.height,
        height: dims.width
    } : {
        width: dims.width,
        height: dims.height
    };
};
var $3b4f8728c2695c8d$export$afddc3b8600307a4 = function(rectangle, borderWidth, degreeAngle) {
    if (borderWidth === void 0) borderWidth = 0;
    if (degreeAngle === void 0) degreeAngle = 0;
    var x = rectangle.x, y = rectangle.y, w = rectangle.width, h = rectangle.height;
    var r = $3b4f8728c2695c8d$export$ee0ed07fe78ec05(degreeAngle);
    var b = borderWidth / 2;
    // prettier-ignore
    if (r === 0) return {
        x: x - b,
        y: y - b,
        width: w,
        height: h
    };
    else if (r === 90) return {
        x: x - h + b,
        y: y - b,
        width: h,
        height: w
    };
    else if (r === 180) return {
        x: x - w + b,
        y: y - h + b,
        width: w,
        height: h
    };
    else if (r === 270) return {
        x: x - b,
        y: y - w + b,
        width: h,
        height: w
    };
    else return {
        x: x - b,
        y: y - b,
        width: w,
        height: h
    };
};

});



parcelRegister("ibsNb", function(module, exports) {

$parcel$export(module.exports, "svgPathToOperators", () => $d3cf96a299d38647$export$8de5166f0a5bde2a);
// Originated from pdfkit Copyright (c) 2014 Devon Govett
// https://github.com/foliojs/pdfkit/blob/1e62e6ffe24b378eb890df507a47610f4c4a7b24/lib/path.js
// MIT LICENSE
// Updated for pdf-lib & TypeScript by Jeremy Messenger

var $hPFvC = parcelRequire("hPFvC");
var $d3cf96a299d38647$var$cx = 0;
var $d3cf96a299d38647$var$cy = 0;
var $d3cf96a299d38647$var$px = 0;
var $d3cf96a299d38647$var$py = 0;
var $d3cf96a299d38647$var$sx = 0;
var $d3cf96a299d38647$var$sy = 0;
var $d3cf96a299d38647$var$parameters = new Map([
    [
        'A',
        7
    ],
    [
        'a',
        7
    ],
    [
        'C',
        6
    ],
    [
        'c',
        6
    ],
    [
        'H',
        1
    ],
    [
        'h',
        1
    ],
    [
        'L',
        2
    ],
    [
        'l',
        2
    ],
    [
        'M',
        2
    ],
    [
        'm',
        2
    ],
    [
        'Q',
        4
    ],
    [
        'q',
        4
    ],
    [
        'S',
        4
    ],
    [
        's',
        4
    ],
    [
        'T',
        2
    ],
    [
        't',
        2
    ],
    [
        'V',
        1
    ],
    [
        'v',
        1
    ],
    [
        'Z',
        0
    ],
    [
        'z',
        0
    ]
]);
var $d3cf96a299d38647$var$parse = function(path) {
    var cmd;
    var ret = [];
    var args = [];
    var curArg = '';
    var foundDecimal = false;
    var params = 0;
    for(var _i = 0, path_1 = path; _i < path_1.length; _i++){
        var c = path_1[_i];
        if ($d3cf96a299d38647$var$parameters.has(c)) {
            params = $d3cf96a299d38647$var$parameters.get(c);
            if (cmd) {
                // save existing command
                if (curArg.length > 0) args[args.length] = +curArg;
                ret[ret.length] = {
                    cmd: cmd,
                    args: args
                };
                args = [];
                curArg = '';
                foundDecimal = false;
            }
            cmd = c;
        } else if ([
            ' ',
            ','
        ].includes(c) || c === '-' && curArg.length > 0 && curArg[curArg.length - 1] !== 'e' || c === '.' && foundDecimal) {
            if (curArg.length === 0) continue;
            if (args.length === params) {
                // handle reused commands
                ret[ret.length] = {
                    cmd: cmd,
                    args: args
                };
                args = [
                    +curArg
                ];
                // handle assumed commands
                if (cmd === 'M') cmd = 'L';
                if (cmd === 'm') cmd = 'l';
            } else args[args.length] = +curArg;
            foundDecimal = c === '.';
            // fix for negative numbers or repeated decimals with no delimeter between commands
            curArg = [
                '-',
                '.'
            ].includes(c) ? c : '';
        } else {
            curArg += c;
            if (c === '.') foundDecimal = true;
        }
    }
    // add the last command
    if (curArg.length > 0) {
        if (args.length === params) {
            // handle reused commands
            ret[ret.length] = {
                cmd: cmd,
                args: args
            };
            args = [
                +curArg
            ];
            // handle assumed commands
            if (cmd === 'M') cmd = 'L';
            if (cmd === 'm') cmd = 'l';
        } else args[args.length] = +curArg;
    }
    ret[ret.length] = {
        cmd: cmd,
        args: args
    };
    return ret;
};
var $d3cf96a299d38647$var$apply = function(commands) {
    // current point, control point, and subpath starting point
    $d3cf96a299d38647$var$cx = $d3cf96a299d38647$var$cy = $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$sx = $d3cf96a299d38647$var$sy = 0;
    // run the commands
    var cmds = [];
    for(var i = 0; i < commands.length; i++){
        var c = commands[i];
        if (c.cmd && typeof $d3cf96a299d38647$var$runners[c.cmd] === 'function') {
            var cmd = $d3cf96a299d38647$var$runners[c.cmd](c.args);
            if (Array.isArray(cmd)) cmds = cmds.concat(cmd);
            else cmds.push(cmd);
        }
    }
    return cmds;
};
var $d3cf96a299d38647$var$runners = {
    M: function(a) {
        $d3cf96a299d38647$var$cx = a[0];
        $d3cf96a299d38647$var$cy = a[1];
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$py = null;
        $d3cf96a299d38647$var$sx = $d3cf96a299d38647$var$cx;
        $d3cf96a299d38647$var$sy = $d3cf96a299d38647$var$cy;
        return (0, $hPFvC.moveTo)($d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy);
    },
    m: function(a) {
        $d3cf96a299d38647$var$cx += a[0];
        $d3cf96a299d38647$var$cy += a[1];
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$py = null;
        $d3cf96a299d38647$var$sx = $d3cf96a299d38647$var$cx;
        $d3cf96a299d38647$var$sy = $d3cf96a299d38647$var$cy;
        return (0, $hPFvC.moveTo)($d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy);
    },
    C: function(a) {
        $d3cf96a299d38647$var$cx = a[4];
        $d3cf96a299d38647$var$cy = a[5];
        $d3cf96a299d38647$var$px = a[2];
        $d3cf96a299d38647$var$py = a[3];
        return (0, $hPFvC.appendBezierCurve)(a[0], a[1], a[2], a[3], a[4], a[5]);
    },
    c: function(a) {
        var cmd = (0, $hPFvC.appendBezierCurve)(a[0] + $d3cf96a299d38647$var$cx, a[1] + $d3cf96a299d38647$var$cy, a[2] + $d3cf96a299d38647$var$cx, a[3] + $d3cf96a299d38647$var$cy, a[4] + $d3cf96a299d38647$var$cx, a[5] + $d3cf96a299d38647$var$cy);
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$cx + a[2];
        $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$cy + a[3];
        $d3cf96a299d38647$var$cx += a[4];
        $d3cf96a299d38647$var$cy += a[5];
        return cmd;
    },
    S: function(a) {
        if ($d3cf96a299d38647$var$px === null || $d3cf96a299d38647$var$py === null) {
            $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$cx;
            $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$cy;
        }
        var cmd = (0, $hPFvC.appendBezierCurve)($d3cf96a299d38647$var$cx - ($d3cf96a299d38647$var$px - $d3cf96a299d38647$var$cx), $d3cf96a299d38647$var$cy - ($d3cf96a299d38647$var$py - $d3cf96a299d38647$var$cy), a[0], a[1], a[2], a[3]);
        $d3cf96a299d38647$var$px = a[0];
        $d3cf96a299d38647$var$py = a[1];
        $d3cf96a299d38647$var$cx = a[2];
        $d3cf96a299d38647$var$cy = a[3];
        return cmd;
    },
    s: function(a) {
        if ($d3cf96a299d38647$var$px === null || $d3cf96a299d38647$var$py === null) {
            $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$cx;
            $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$cy;
        }
        var cmd = (0, $hPFvC.appendBezierCurve)($d3cf96a299d38647$var$cx - ($d3cf96a299d38647$var$px - $d3cf96a299d38647$var$cx), $d3cf96a299d38647$var$cy - ($d3cf96a299d38647$var$py - $d3cf96a299d38647$var$cy), $d3cf96a299d38647$var$cx + a[0], $d3cf96a299d38647$var$cy + a[1], $d3cf96a299d38647$var$cx + a[2], $d3cf96a299d38647$var$cy + a[3]);
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$cx + a[0];
        $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$cy + a[1];
        $d3cf96a299d38647$var$cx += a[2];
        $d3cf96a299d38647$var$cy += a[3];
        return cmd;
    },
    Q: function(a) {
        $d3cf96a299d38647$var$px = a[0];
        $d3cf96a299d38647$var$py = a[1];
        $d3cf96a299d38647$var$cx = a[2];
        $d3cf96a299d38647$var$cy = a[3];
        return (0, $hPFvC.appendQuadraticCurve)(a[0], a[1], $d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy);
    },
    q: function(a) {
        var cmd = (0, $hPFvC.appendQuadraticCurve)(a[0] + $d3cf96a299d38647$var$cx, a[1] + $d3cf96a299d38647$var$cy, a[2] + $d3cf96a299d38647$var$cx, a[3] + $d3cf96a299d38647$var$cy);
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$cx + a[0];
        $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$cy + a[1];
        $d3cf96a299d38647$var$cx += a[2];
        $d3cf96a299d38647$var$cy += a[3];
        return cmd;
    },
    T: function(a) {
        if ($d3cf96a299d38647$var$px === null || $d3cf96a299d38647$var$py === null) {
            $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$cx;
            $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$cy;
        } else {
            $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$cx - ($d3cf96a299d38647$var$px - $d3cf96a299d38647$var$cx);
            $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$cy - ($d3cf96a299d38647$var$py - $d3cf96a299d38647$var$cy);
        }
        var cmd = (0, $hPFvC.appendQuadraticCurve)($d3cf96a299d38647$var$px, $d3cf96a299d38647$var$py, a[0], a[1]);
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$cx - ($d3cf96a299d38647$var$px - $d3cf96a299d38647$var$cx);
        $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$cy - ($d3cf96a299d38647$var$py - $d3cf96a299d38647$var$cy);
        $d3cf96a299d38647$var$cx = a[0];
        $d3cf96a299d38647$var$cy = a[1];
        return cmd;
    },
    t: function(a) {
        if ($d3cf96a299d38647$var$px === null || $d3cf96a299d38647$var$py === null) {
            $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$cx;
            $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$cy;
        } else {
            $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$cx - ($d3cf96a299d38647$var$px - $d3cf96a299d38647$var$cx);
            $d3cf96a299d38647$var$py = $d3cf96a299d38647$var$cy - ($d3cf96a299d38647$var$py - $d3cf96a299d38647$var$cy);
        }
        var cmd = (0, $hPFvC.appendQuadraticCurve)($d3cf96a299d38647$var$px, $d3cf96a299d38647$var$py, $d3cf96a299d38647$var$cx + a[0], $d3cf96a299d38647$var$cy + a[1]);
        $d3cf96a299d38647$var$cx += a[0];
        $d3cf96a299d38647$var$cy += a[1];
        return cmd;
    },
    A: function(a) {
        var cmds = $d3cf96a299d38647$var$solveArc($d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy, a);
        $d3cf96a299d38647$var$cx = a[5];
        $d3cf96a299d38647$var$cy = a[6];
        return cmds;
    },
    a: function(a) {
        a[5] += $d3cf96a299d38647$var$cx;
        a[6] += $d3cf96a299d38647$var$cy;
        var cmds = $d3cf96a299d38647$var$solveArc($d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy, a);
        $d3cf96a299d38647$var$cx = a[5];
        $d3cf96a299d38647$var$cy = a[6];
        return cmds;
    },
    L: function(a) {
        $d3cf96a299d38647$var$cx = a[0];
        $d3cf96a299d38647$var$cy = a[1];
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$py = null;
        return (0, $hPFvC.lineTo)($d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy);
    },
    l: function(a) {
        $d3cf96a299d38647$var$cx += a[0];
        $d3cf96a299d38647$var$cy += a[1];
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$py = null;
        return (0, $hPFvC.lineTo)($d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy);
    },
    H: function(a) {
        $d3cf96a299d38647$var$cx = a[0];
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$py = null;
        return (0, $hPFvC.lineTo)($d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy);
    },
    h: function(a) {
        $d3cf96a299d38647$var$cx += a[0];
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$py = null;
        return (0, $hPFvC.lineTo)($d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy);
    },
    V: function(a) {
        $d3cf96a299d38647$var$cy = a[0];
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$py = null;
        return (0, $hPFvC.lineTo)($d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy);
    },
    v: function(a) {
        $d3cf96a299d38647$var$cy += a[0];
        $d3cf96a299d38647$var$px = $d3cf96a299d38647$var$py = null;
        return (0, $hPFvC.lineTo)($d3cf96a299d38647$var$cx, $d3cf96a299d38647$var$cy);
    },
    Z: function() {
        var cmd = (0, $hPFvC.closePath)();
        $d3cf96a299d38647$var$cx = $d3cf96a299d38647$var$sx;
        $d3cf96a299d38647$var$cy = $d3cf96a299d38647$var$sy;
        return cmd;
    },
    z: function() {
        var cmd = (0, $hPFvC.closePath)();
        $d3cf96a299d38647$var$cx = $d3cf96a299d38647$var$sx;
        $d3cf96a299d38647$var$cy = $d3cf96a299d38647$var$sy;
        return cmd;
    }
};
var $d3cf96a299d38647$var$solveArc = function(x, y, coords) {
    var rx = coords[0], ry = coords[1], rot = coords[2], large = coords[3], sweep = coords[4], ex = coords[5], ey = coords[6];
    var segs = $d3cf96a299d38647$var$arcToSegments(ex, ey, rx, ry, large, sweep, rot, x, y);
    var cmds = [];
    for(var _i = 0, segs_1 = segs; _i < segs_1.length; _i++){
        var seg = segs_1[_i];
        var bez = $d3cf96a299d38647$var$segmentToBezier.apply(void 0, seg);
        cmds.push((0, $hPFvC.appendBezierCurve).apply(void 0, bez));
    }
    return cmds;
};
// from Inkscape svgtopdf, thanks!
var $d3cf96a299d38647$var$arcToSegments = function(x, y, rx, ry, large, sweep, rotateX, ox, oy) {
    var th = rotateX * (Math.PI / 180);
    var sinTh = Math.sin(th);
    var cosTh = Math.cos(th);
    rx = Math.abs(rx);
    ry = Math.abs(ry);
    $d3cf96a299d38647$var$px = cosTh * (ox - x) * 0.5 + sinTh * (oy - y) * 0.5;
    $d3cf96a299d38647$var$py = cosTh * (oy - y) * 0.5 - sinTh * (ox - x) * 0.5;
    var pl = $d3cf96a299d38647$var$px * $d3cf96a299d38647$var$px / (rx * rx) + $d3cf96a299d38647$var$py * $d3cf96a299d38647$var$py / (ry * ry);
    if (pl > 1) {
        pl = Math.sqrt(pl);
        rx *= pl;
        ry *= pl;
    }
    var a00 = cosTh / rx;
    var a01 = sinTh / rx;
    var a10 = -sinTh / ry;
    var a11 = cosTh / ry;
    var x0 = a00 * ox + a01 * oy;
    var y0 = a10 * ox + a11 * oy;
    var x1 = a00 * x + a01 * y;
    var y1 = a10 * x + a11 * y;
    var d = (x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0);
    var sfactorSq = 1 / d - 0.25;
    if (sfactorSq < 0) sfactorSq = 0;
    var sfactor = Math.sqrt(sfactorSq);
    if (sweep === large) sfactor = -sfactor;
    var xc = 0.5 * (x0 + x1) - sfactor * (y1 - y0);
    var yc = 0.5 * (y0 + y1) + sfactor * (x1 - x0);
    var th0 = Math.atan2(y0 - yc, x0 - xc);
    var th1 = Math.atan2(y1 - yc, x1 - xc);
    var thArc = th1 - th0;
    if (thArc < 0 && sweep === 1) thArc += 2 * Math.PI;
    else if (thArc > 0 && sweep === 0) thArc -= 2 * Math.PI;
    var segments = Math.ceil(Math.abs(thArc / (Math.PI * 0.5 + 0.001)));
    var result = [];
    for(var i = 0; i < segments; i++){
        var th2 = th0 + i * thArc / segments;
        var th3 = th0 + (i + 1) * thArc / segments;
        result[i] = [
            xc,
            yc,
            th2,
            th3,
            rx,
            ry,
            sinTh,
            cosTh
        ];
    }
    return result;
};
var $d3cf96a299d38647$var$segmentToBezier = function(cx1, cy1, th0, th1, rx, ry, sinTh, cosTh) {
    var a00 = cosTh * rx;
    var a01 = -sinTh * ry;
    var a10 = sinTh * rx;
    var a11 = cosTh * ry;
    var thHalf = 0.5 * (th1 - th0);
    var t = 8 / 3 * Math.sin(thHalf * 0.5) * Math.sin(thHalf * 0.5) / Math.sin(thHalf);
    var x1 = cx1 + Math.cos(th0) - t * Math.sin(th0);
    var y1 = cy1 + Math.sin(th0) + t * Math.cos(th0);
    var x3 = cx1 + Math.cos(th1);
    var y3 = cy1 + Math.sin(th1);
    var x2 = x3 + t * Math.sin(th1);
    var y2 = y3 - t * Math.cos(th1);
    var result = [
        a00 * x1 + a01 * y1,
        a10 * x1 + a11 * y1,
        a00 * x2 + a01 * y2,
        a10 * x2 + a11 * y2,
        a00 * x3 + a01 * y3,
        a10 * x3 + a11 * y3
    ];
    return result;
};
var $d3cf96a299d38647$export$8de5166f0a5bde2a = function(path) {
    return $d3cf96a299d38647$var$apply($d3cf96a299d38647$var$parse(path));
};

});


parcelRegister("d1UXb", function(module, exports) {

$parcel$export(module.exports, "layoutMultilineText", () => $97c78c294af7eaa8$export$f6ba9f13f815cc95);
$parcel$export(module.exports, "layoutCombedText", () => $97c78c294af7eaa8$export$deba41d88dd75dfc);
$parcel$export(module.exports, "layoutSinglelineText", () => $97c78c294af7eaa8$export$c0030606588cf6f2);

var $aYJvX = parcelRequire("aYJvX");

var $5rdXu = parcelRequire("5rdXu");
parcelRequire("fvYKZ");
var $7Kmy8 = parcelRequire("7Kmy8");
var $97c78c294af7eaa8$var$MIN_FONT_SIZE = 4;
var $97c78c294af7eaa8$var$MAX_FONT_SIZE = 500;
var $97c78c294af7eaa8$var$computeFontSize = function(lines, font, bounds, multiline) {
    if (multiline === void 0) multiline = false;
    var fontSize = $97c78c294af7eaa8$var$MIN_FONT_SIZE;
    while(fontSize < $97c78c294af7eaa8$var$MAX_FONT_SIZE){
        var linesUsed = 0;
        for(var lineIdx = 0, lineLen = lines.length; lineIdx < lineLen; lineIdx++){
            linesUsed += 1;
            var line = lines[lineIdx];
            var words = line.split(' ');
            // Layout the words using the current `fontSize`, line wrapping
            // whenever we reach the end of the current line.
            var spaceInLineRemaining = bounds.width;
            for(var idx = 0, len = words.length; idx < len; idx++){
                var isLastWord = idx === len - 1;
                var word = isLastWord ? words[idx] : words[idx] + ' ';
                var widthOfWord = font.widthOfTextAtSize(word, fontSize);
                spaceInLineRemaining -= widthOfWord;
                if (spaceInLineRemaining <= 0) {
                    linesUsed += 1;
                    spaceInLineRemaining = bounds.width - widthOfWord;
                }
            }
        }
        // Return if we exceeded the allowed width
        if (!multiline && linesUsed > lines.length) return fontSize - 1;
        var height = font.heightAtSize(fontSize);
        var lineHeight = height + height * 0.2;
        var totalHeight = lineHeight * linesUsed;
        // Return if we exceeded the allowed height
        if (totalHeight > Math.abs(bounds.height)) return fontSize - 1;
        fontSize += 1;
    }
    return fontSize;
};
var $97c78c294af7eaa8$var$computeCombedFontSize = function(line, font, bounds, cellCount) {
    var cellWidth = bounds.width / cellCount;
    var cellHeight = bounds.height;
    var fontSize = $97c78c294af7eaa8$var$MIN_FONT_SIZE;
    var chars = (0, $7Kmy8.charSplit)(line);
    while(fontSize < $97c78c294af7eaa8$var$MAX_FONT_SIZE){
        for(var idx = 0, len = chars.length; idx < len; idx++){
            var c = chars[idx];
            var tooLong = font.widthOfTextAtSize(c, fontSize) > cellWidth * 0.75;
            if (tooLong) return fontSize - 1;
        }
        var height = font.heightAtSize(fontSize, {
            descender: false
        });
        if (height > cellHeight) return fontSize - 1;
        fontSize += 1;
    }
    return fontSize;
};
var $97c78c294af7eaa8$var$lastIndexOfWhitespace = function(line) {
    for(var idx = line.length; idx > 0; idx--){
        if (/\s/.test(line[idx])) return idx;
    }
    return undefined;
};
var $97c78c294af7eaa8$var$splitOutLines = function(input, maxWidth, font, fontSize) {
    var _a;
    var lastWhitespaceIdx = input.length;
    while(lastWhitespaceIdx > 0){
        var line = input.substring(0, lastWhitespaceIdx);
        var encoded = font.encodeText(line);
        var width = font.widthOfTextAtSize(line, fontSize);
        if (width < maxWidth) {
            var remainder = input.substring(lastWhitespaceIdx) || undefined;
            return {
                line: line,
                encoded: encoded,
                width: width,
                remainder: remainder
            };
        }
        lastWhitespaceIdx = (_a = $97c78c294af7eaa8$var$lastIndexOfWhitespace(line)) !== null && _a !== void 0 ? _a : 0;
    }
    // We were unable to split the input enough to get a chunk that would fit
    // within the specified `maxWidth` so we'll just return everything
    return {
        line: input,
        encoded: font.encodeText(input),
        width: font.widthOfTextAtSize(input, fontSize),
        remainder: undefined
    };
};
var $97c78c294af7eaa8$export$f6ba9f13f815cc95 = function(text, _a) {
    var alignment = _a.alignment, fontSize = _a.fontSize, font = _a.font, bounds = _a.bounds;
    var lines = (0, $7Kmy8.lineSplit)((0, $7Kmy8.cleanText)(text));
    if (fontSize === undefined || fontSize === 0) fontSize = $97c78c294af7eaa8$var$computeFontSize(lines, font, bounds, true);
    var height = font.heightAtSize(fontSize);
    var lineHeight = height + height * 0.2;
    var textLines = [];
    var minX = bounds.x;
    var minY = bounds.y;
    var maxX = bounds.x + bounds.width;
    var maxY = bounds.y + bounds.height;
    var y = bounds.y + bounds.height;
    for(var idx = 0, len = lines.length; idx < len; idx++){
        var prevRemainder = lines[idx];
        while(prevRemainder !== undefined){
            var _b = $97c78c294af7eaa8$var$splitOutLines(prevRemainder, bounds.width, font, fontSize), line = _b.line, encoded = _b.encoded, width = _b.width, remainder = _b.remainder;
            // prettier-ignore
            var x = alignment === (0, $5rdXu.TextAlignment).Left ? bounds.x : alignment === (0, $5rdXu.TextAlignment).Center ? bounds.x + bounds.width / 2 - width / 2 : alignment === (0, $5rdXu.TextAlignment).Right ? bounds.x + bounds.width - width : bounds.x;
            y -= lineHeight;
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x + width > maxX) maxX = x + width;
            if (y + height > maxY) maxY = y + height;
            textLines.push({
                text: line,
                encoded: encoded,
                width: width,
                height: height,
                x: x,
                y: y
            });
            // Only trim lines that we had to split ourselves. So we won't trim lines
            // that the user provided themselves with whitespace.
            prevRemainder = remainder === null || remainder === void 0 ? void 0 : remainder.trim();
        }
    }
    return {
        fontSize: fontSize,
        lineHeight: lineHeight,
        lines: textLines,
        bounds: {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        }
    };
};
var $97c78c294af7eaa8$export$deba41d88dd75dfc = function(text, _a) {
    var fontSize = _a.fontSize, font = _a.font, bounds = _a.bounds, cellCount = _a.cellCount;
    var line = (0, $7Kmy8.mergeLines)((0, $7Kmy8.cleanText)(text));
    if (line.length > cellCount) throw new (0, $aYJvX.CombedTextLayoutError)(line.length, cellCount);
    if (fontSize === undefined || fontSize === 0) fontSize = $97c78c294af7eaa8$var$computeCombedFontSize(line, font, bounds, cellCount);
    var cellWidth = bounds.width / cellCount;
    var height = font.heightAtSize(fontSize, {
        descender: false
    });
    var y = bounds.y + (bounds.height / 2 - height / 2);
    var cells = [];
    var minX = bounds.x;
    var minY = bounds.y;
    var maxX = bounds.x + bounds.width;
    var maxY = bounds.y + bounds.height;
    var cellOffset = 0;
    var charOffset = 0;
    while(cellOffset < cellCount){
        var _b = (0, $7Kmy8.charAtIndex)(line, charOffset), char = _b[0], charLength = _b[1];
        var encoded = font.encodeText(char);
        var width = font.widthOfTextAtSize(char, fontSize);
        var cellCenter = bounds.x + (cellWidth * cellOffset + cellWidth / 2);
        var x = cellCenter - width / 2;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x + width > maxX) maxX = x + width;
        if (y + height > maxY) maxY = y + height;
        cells.push({
            text: line,
            encoded: encoded,
            width: width,
            height: height,
            x: x,
            y: y
        });
        cellOffset += 1;
        charOffset += charLength;
    }
    return {
        fontSize: fontSize,
        cells: cells,
        bounds: {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        }
    };
};
var $97c78c294af7eaa8$export$c0030606588cf6f2 = function(text, _a) {
    var alignment = _a.alignment, fontSize = _a.fontSize, font = _a.font, bounds = _a.bounds;
    var line = (0, $7Kmy8.mergeLines)((0, $7Kmy8.cleanText)(text));
    if (fontSize === undefined || fontSize === 0) fontSize = $97c78c294af7eaa8$var$computeFontSize([
        line
    ], font, bounds);
    var encoded = font.encodeText(line);
    var width = font.widthOfTextAtSize(line, fontSize);
    var height = font.heightAtSize(fontSize, {
        descender: false
    });
    // prettier-ignore
    var x = alignment === (0, $5rdXu.TextAlignment).Left ? bounds.x : alignment === (0, $5rdXu.TextAlignment).Center ? bounds.x + bounds.width / 2 - width / 2 : alignment === (0, $5rdXu.TextAlignment).Right ? bounds.x + bounds.width - width : bounds.x;
    var y = bounds.y + (bounds.height / 2 - height / 2);
    return {
        fontSize: fontSize,
        line: {
            text: line,
            encoded: encoded,
            width: width,
            height: height,
            x: x,
            y: y
        },
        bounds: {
            x: x,
            y: y,
            width: width,
            height: height
        }
    };
};

});
parcelRegister("aYJvX", function(module, exports) {

$parcel$export(module.exports, "EncryptedPDFError", () => $7fe2d034822cb526$export$20fcceeca2b098d2);
$parcel$export(module.exports, "FontkitNotRegisteredError", () => $7fe2d034822cb526$export$529a7c74d0636a48);
$parcel$export(module.exports, "ForeignPageError", () => $7fe2d034822cb526$export$9564a4d28d94eae2);
$parcel$export(module.exports, "RemovePageFromEmptyDocumentError", () => $7fe2d034822cb526$export$cdca06c5927ddc2d);
$parcel$export(module.exports, "NoSuchFieldError", () => $7fe2d034822cb526$export$5bc08baa4a027cbd);
$parcel$export(module.exports, "UnexpectedFieldTypeError", () => $7fe2d034822cb526$export$8909da6c566ff652);
$parcel$export(module.exports, "FieldAlreadyExistsError", () => $7fe2d034822cb526$export$c428cfe4dc6c68df);
$parcel$export(module.exports, "InvalidFieldNamePartError", () => $7fe2d034822cb526$export$83c39fdacfe38500);
$parcel$export(module.exports, "RichTextFieldReadError", () => $7fe2d034822cb526$export$f2fed572e1ed57ab);
$parcel$export(module.exports, "CombedTextLayoutError", () => $7fe2d034822cb526$export$5283dffc620a5c9f);
$parcel$export(module.exports, "ExceededMaxLengthError", () => $7fe2d034822cb526$export$1577e99040d42609);
$parcel$export(module.exports, "InvalidMaxLengthError", () => $7fe2d034822cb526$export$6da6c372180e79b0);
// tslint:disable: max-classes-per-file

var $cOQTW = parcelRequire("cOQTW");
// TODO: Include link to documentation with example
var $7fe2d034822cb526$export$20fcceeca2b098d2 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(EncryptedPDFError, _super);
    function EncryptedPDFError() {
        var _this = this;
        var msg = 'Input document to `PDFDocument.load` is encrypted. You can use `PDFDocument.load(..., { ignoreEncryption: true })` if you wish to load the document anyways.';
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return EncryptedPDFError;
}(Error);
// TODO: Include link to documentation with example
var $7fe2d034822cb526$export$529a7c74d0636a48 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(FontkitNotRegisteredError, _super);
    function FontkitNotRegisteredError() {
        var _this = this;
        var msg = 'Input to `PDFDocument.embedFont` was a custom font, but no `fontkit` instance was found. You must register a `fontkit` instance with `PDFDocument.registerFontkit(...)` before embedding custom fonts.';
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return FontkitNotRegisteredError;
}(Error);
// TODO: Include link to documentation with example
var $7fe2d034822cb526$export$9564a4d28d94eae2 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(ForeignPageError, _super);
    function ForeignPageError() {
        var _this = this;
        var msg = 'A `page` passed to `PDFDocument.addPage` or `PDFDocument.insertPage` was from a different (foreign) PDF document. If you want to copy pages from one PDFDocument to another, you must use `PDFDocument.copyPages(...)` to copy the pages before adding or inserting them.';
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return ForeignPageError;
}(Error);
// TODO: Include link to documentation with example
var $7fe2d034822cb526$export$cdca06c5927ddc2d = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(RemovePageFromEmptyDocumentError, _super);
    function RemovePageFromEmptyDocumentError() {
        var _this = this;
        var msg = 'PDFDocument has no pages so `PDFDocument.removePage` cannot be called';
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return RemovePageFromEmptyDocumentError;
}(Error);
var $7fe2d034822cb526$export$5bc08baa4a027cbd = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(NoSuchFieldError, _super);
    function NoSuchFieldError(name) {
        var _this = this;
        var msg = "PDFDocument has no form field with the name \"" + name + "\"";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return NoSuchFieldError;
}(Error);
var $7fe2d034822cb526$export$8909da6c566ff652 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(UnexpectedFieldTypeError, _super);
    function UnexpectedFieldTypeError(name, expected, actual) {
        var _a, _b;
        var _this = this;
        var expectedType = expected === null || expected === void 0 ? void 0 : expected.name;
        var actualType = (_b = (_a = actual === null || actual === void 0 ? void 0 : actual.constructor) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : actual;
        var msg = "Expected field \"" + name + "\" to be of type " + expectedType + ", " + ("but it is actually of type " + actualType);
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return UnexpectedFieldTypeError;
}(Error);
var $7fe2d034822cb526$export$3437b42908c7d7a3 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(MissingOnValueCheckError, _super);
    function MissingOnValueCheckError(onValue) {
        var _this = this;
        var msg = "Failed to select check box due to missing onValue: \"" + onValue + "\"";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingOnValueCheckError;
}(Error);
var $7fe2d034822cb526$export$c428cfe4dc6c68df = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(FieldAlreadyExistsError, _super);
    function FieldAlreadyExistsError(name) {
        var _this = this;
        var msg = "A field already exists with the specified name: \"" + name + "\"";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return FieldAlreadyExistsError;
}(Error);
var $7fe2d034822cb526$export$83c39fdacfe38500 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(InvalidFieldNamePartError, _super);
    function InvalidFieldNamePartError(namePart) {
        var _this = this;
        var msg = "Field name contains invalid component: \"" + namePart + "\"";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidFieldNamePartError;
}(Error);
var $7fe2d034822cb526$export$6353a2ffd9106bd2 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(FieldExistsAsNonTerminalError, _super);
    function FieldExistsAsNonTerminalError(name) {
        var _this = this;
        var msg = "A non-terminal field already exists with the specified name: \"" + name + "\"";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return FieldExistsAsNonTerminalError;
}(Error);
var $7fe2d034822cb526$export$f2fed572e1ed57ab = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(RichTextFieldReadError, _super);
    function RichTextFieldReadError(fieldName) {
        var _this = this;
        var msg = "Reading rich text fields is not supported: Attempted to read rich text field: " + fieldName;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return RichTextFieldReadError;
}(Error);
var $7fe2d034822cb526$export$5283dffc620a5c9f = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(CombedTextLayoutError, _super);
    function CombedTextLayoutError(lineLength, cellCount) {
        var _this = this;
        var msg = "Failed to layout combed text as lineLength=" + lineLength + " is greater than cellCount=" + cellCount;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return CombedTextLayoutError;
}(Error);
var $7fe2d034822cb526$export$1577e99040d42609 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(ExceededMaxLengthError, _super);
    function ExceededMaxLengthError(textLength, maxLength, name) {
        var _this = this;
        var msg = "Attempted to set text with length=" + textLength + " for TextField with maxLength=" + maxLength + " and name=" + name;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return ExceededMaxLengthError;
}(Error);
var $7fe2d034822cb526$export$6da6c372180e79b0 = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(InvalidMaxLengthError, _super);
    function InvalidMaxLengthError(textLength, maxLength, name) {
        var _this = this;
        var msg = "Attempted to set maxLength=" + maxLength + ", which is less than " + textLength + ", the length of this field's current value (name=" + name + ")";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidMaxLengthError;
}(Error);

});

parcelRegister("5rdXu", function(module, exports) {

$parcel$export(module.exports, "TextAlignment", () => $010595e4078a43c6$export$84b2d1b68830363f);
var $010595e4078a43c6$export$84b2d1b68830363f;
(function(TextAlignment) {
    TextAlignment[TextAlignment["Left"] = 0] = "Left";
    TextAlignment[TextAlignment["Center"] = 1] = "Center";
    TextAlignment[TextAlignment["Right"] = 2] = "Right";
})($010595e4078a43c6$export$84b2d1b68830363f || ($010595e4078a43c6$export$84b2d1b68830363f = {}));

});



parcelRegister("fphXB", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3771f5aa96680ee$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $eq4Zh = parcelRequire("eq4Zh");

var $lzaL9 = parcelRequire("lzaL9");

var $gYSUQ = parcelRequire("gYSUQ");

var $ikSoM = parcelRequire("ikSoM");

var $dgAbg = parcelRequire("dgAbg");

var $gidDr = parcelRequire("gidDr");

var $55HYh = parcelRequire("55HYh");
parcelRequire("iT7lj");
var $1757u = parcelRequire("1757u");
var $4CgUJ = parcelRequire("4CgUJ");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
/**
 * Represents a button field of a [[PDFForm]].
 *
 * [[PDFButton]] fields are interactive controls that users can click with their
 * mouse. This type of [[PDFField]] is not stateful. The purpose of a button
 * is to perform an action when the user clicks on it, such as opening a print
 * modal or resetting the form. Buttons are typically rectangular in shape and
 * have a text label describing the action that they perform when clicked.
 */ var $b3771f5aa96680ee$var$PDFButton = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFButton, _super);
    function PDFButton(acroPushButton, ref, doc) {
        var _this = _super.call(this, acroPushButton, ref, doc) || this;
        (0, $j0tvB.assertIs)(acroPushButton, 'acroButton', [
            [
                (0, $1757u.default),
                'PDFAcroPushButton'
            ]
        ]);
        _this.acroField = acroPushButton;
        return _this;
    }
    /**
     * Display an image inside the bounds of this button's widgets. For example:
     * ```js
     * const pngImage = await pdfDoc.embedPng(...)
     * const button = form.getButton('some.button.field')
     * button.setImage(pngImage, ImageAlignment.Center)
     * ```
     * This will update the appearances streams for each of this button's widgets.
     * @param image The image that should be displayed.
     * @param alignment The alignment of the image.
     */ PDFButton.prototype.setImage = function(image, alignment) {
        if (alignment === void 0) alignment = (0, $gYSUQ.ImageAlignment).Center;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var streamRef = this.createImageAppearanceStream(widget, image, alignment);
            this.updateWidgetAppearances(widget, {
                normal: streamRef
            });
        }
        this.markAsClean();
    };
    /**
     * Set the font size for this field. Larger font sizes will result in larger
     * text being displayed when PDF readers render this button. Font sizes may
     * be integer or floating point numbers. Supplying a negative font size will
     * cause this method to throw an error.
     *
     * For example:
     * ```js
     * const button = form.getButton('some.button.field')
     * button.setFontSize(4)
     * button.setFontSize(15.7)
     * ```
     *
     * > This method depends upon the existence of a default appearance
     * > (`/DA`) string. If this field does not have a default appearance string,
     * > or that string does not contain a font size (via the `Tf` operator),
     * > then this method will throw an error.
     *
     * @param fontSize The font size to be used when rendering text in this field.
     */ PDFButton.prototype.setFontSize = function(fontSize) {
        (0, $j0tvB.assertPositive)(fontSize, 'fontSize');
        this.acroField.setFontSize(fontSize);
        this.markAsDirty();
    };
    /**
     * Show this button on the specified page with the given text. For example:
     * ```js
     * const ubuntuFont = await pdfDoc.embedFont(ubuntuFontBytes)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const button = form.createButton('some.button.field')
     *
     * button.addToPage('Do Stuff', page, {
     *   x: 50,
     *   y: 75,
     *   width: 200,
     *   height: 100,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     *   font: ubuntuFont,
     * })
     * ```
     * This will create a new widget for this button field.
     * @param text The text to be displayed for this button widget.
     * @param page The page to which this button widget should be added.
     * @param options The options to be used when adding this button widget.
     */ PDFButton.prototype.addToPage = function(// TODO: This needs to be optional, e.g. for image buttons
    text, page, options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        (0, $j0tvB.assertOrUndefined)(text, 'text', [
            'string'
        ]);
        (0, $j0tvB.assertOrUndefined)(page, 'page', [
            [
                (0, $eq4Zh.default),
                'PDFPage'
            ]
        ]);
        (0, $dgAbg.assertFieldAppearanceOptions)(options);
        // Create a widget for this button
        var widget = this.createWidget({
            x: ((_a = options === null || options === void 0 ? void 0 : options.x) !== null && _a !== void 0 ? _a : 0) - ((_b = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _b !== void 0 ? _b : 0) / 2,
            y: ((_c = options === null || options === void 0 ? void 0 : options.y) !== null && _c !== void 0 ? _c : 0) - ((_d = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _d !== void 0 ? _d : 0) / 2,
            width: (_e = options === null || options === void 0 ? void 0 : options.width) !== null && _e !== void 0 ? _e : 100,
            height: (_f = options === null || options === void 0 ? void 0 : options.height) !== null && _f !== void 0 ? _f : 50,
            textColor: (_g = options === null || options === void 0 ? void 0 : options.textColor) !== null && _g !== void 0 ? _g : (0, $gidDr.rgb)(0, 0, 0),
            backgroundColor: (_h = options === null || options === void 0 ? void 0 : options.backgroundColor) !== null && _h !== void 0 ? _h : (0, $gidDr.rgb)(0.75, 0.75, 0.75),
            borderColor: options === null || options === void 0 ? void 0 : options.borderColor,
            borderWidth: (_j = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _j !== void 0 ? _j : 0,
            rotate: (_k = options === null || options === void 0 ? void 0 : options.rotate) !== null && _k !== void 0 ? _k : (0, $55HYh.degrees)(0),
            caption: text,
            hidden: options === null || options === void 0 ? void 0 : options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        var font = (_l = options === null || options === void 0 ? void 0 : options.font) !== null && _l !== void 0 ? _l : this.doc.getForm().getDefaultFont();
        this.updateWidgetAppearance(widget, font);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if this button has been marked as dirty, or if any of this
     * button's widgets do not have an appearance stream. For example:
     * ```js
     * const button = form.getButton('some.button.field')
     * if (button.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this button needs an appearance update.
     */ PDFButton.prototype.needsAppearancesUpdate = function() {
        var _a;
        if (this.isDirty()) return true;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var hasAppearances = ((_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal) instanceof (0, $4CgUJ.default);
            if (!hasAppearances) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this button's widgets using
     * the default appearance provider for buttons. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const button = form.getButton('some.button.field')
     * button.defaultUpdateAppearances(helvetica)
     * ```
     * @param font The font to be used for creating the appearance streams.
     */ PDFButton.prototype.defaultUpdateAppearances = function(font) {
        (0, $j0tvB.assertIs)(font, 'font', [
            [
                (0, $lzaL9.default),
                'PDFFont'
            ]
        ]);
        this.updateAppearances(font);
    };
    /**
     * Update the appearance streams for each of this button's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for buttons will be used. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const button = form.getButton('some.button.field')
     * button.updateAppearances(helvetica, (field, widget, font) => {
     *   ...
     *   return {
     *     normal: drawButton(...),
     *     down: drawButton(...),
     *   }
     * })
     * ```
     * @param font The font to be used for creating the appearance streams.
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFButton.prototype.updateAppearances = function(font, provider) {
        (0, $j0tvB.assertIs)(font, 'font', [
            [
                (0, $lzaL9.default),
                'PDFFont'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            this.updateWidgetAppearance(widget, font, provider);
        }
    };
    PDFButton.prototype.updateWidgetAppearance = function(widget, font, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $ikSoM.defaultButtonAppearanceProvider);
        var appearances = (0, $ikSoM.normalizeAppearance)(apProvider(this, widget, font));
        this.updateWidgetAppearanceWithFont(widget, font, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getButton]] method, which will create an
     * > instance of [[PDFButton]] for you.
     *
     * Create an instance of [[PDFButton]] from an existing acroPushButton and ref
     *
     * @param acroPushButton The underlying `PDFAcroPushButton` for this button.
     * @param ref The unique reference for this button.
     * @param doc The document to which this button will belong.
     */ PDFButton.of = function(acroPushButton, ref, doc) {
        return new PDFButton(acroPushButton, ref, doc);
    };
    return PDFButton;
}((0, $dgAbg.default));
var $b3771f5aa96680ee$export$2e2bcd8739ae039 = $b3771f5aa96680ee$var$PDFButton;

});
parcelRegister("eq4Zh", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7f75cccfbb7eb6c$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $gidDr = parcelRequire("gidDr");

var $7mLHs = parcelRequire("7mLHs");

var $hPFvC = parcelRequire("hPFvC");

var $cGbw3 = parcelRequire("cGbw3");

var $kUs6q = parcelRequire("kUs6q");

var $lzaL9 = parcelRequire("lzaL9");

var $7F2yc = parcelRequire("7F2yc");

var $j1dka = parcelRequire("j1dka");

var $55HYh = parcelRequire("55HYh");

var $i4gUC = parcelRequire("i4gUC");
parcelRequire("iT7lj");
var $8auL6 = parcelRequire("8auL6");
var $9EODP = parcelRequire("9EODP");
var $brir8 = parcelRequire("brir8");
var $dPHSK = parcelRequire("dPHSK");
var $5uV6d = parcelRequire("5uV6d");
var $eAof5 = parcelRequire("eAof5");
var $kHzkO = parcelRequire("kHzkO");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
var $7Kmy8 = parcelRequire("7Kmy8");
var $cbIAG = parcelRequire("cbIAG");
/**
 * Represents a single page of a [[PDFDocument]].
 */ var $a7f75cccfbb7eb6c$var$PDFPage = /** @class */ function() {
    function PDFPage(leafNode, ref, doc) {
        this.fontSize = 24;
        this.fontColor = (0, $gidDr.rgb)(0, 0, 0);
        this.lineHeight = 24;
        this.x = 0;
        this.y = 0;
        (0, $j0tvB.assertIs)(leafNode, 'leafNode', [
            [
                (0, $eAof5.default),
                'PDFPageLeaf'
            ]
        ]);
        (0, $j0tvB.assertIs)(ref, 'ref', [
            [
                (0, $kHzkO.default),
                'PDFRef'
            ]
        ]);
        (0, $j0tvB.assertIs)(doc, 'doc', [
            [
                (0, $cGbw3.default),
                'PDFDocument'
            ]
        ]);
        this.node = leafNode;
        this.ref = ref;
        this.doc = doc;
    }
    /**
     * Rotate this page by a multiple of 90 degrees. For example:
     * ```js
     * import { degrees } from 'pdf-lib'
     *
     * page.setRotation(degrees(-90))
     * page.setRotation(degrees(0))
     * page.setRotation(degrees(90))
     * page.setRotation(degrees(180))
     * page.setRotation(degrees(270))
     * ```
     * @param angle The angle to rotate this page.
     */ PDFPage.prototype.setRotation = function(angle) {
        var degreesAngle = (0, $55HYh.toDegrees)(angle);
        (0, $j0tvB.assertMultiple)(degreesAngle, 'degreesAngle', 90);
        this.node.set((0, $dPHSK.default).of('Rotate'), this.doc.context.obj(degreesAngle));
    };
    /**
     * Get this page's rotation angle in degrees. For example:
     * ```js
     * const rotationAngle = page.getRotation().angle;
     * ```
     * @returns The rotation angle of the page in degrees (always a multiple of
     *          90 degrees).
     */ PDFPage.prototype.getRotation = function() {
        var Rotate = this.node.Rotate();
        return (0, $55HYh.degrees)(Rotate ? Rotate.asNumber() : 0);
    };
    /**
     * Resize this page by increasing or decreasing its width and height. For
     * example:
     * ```js
     * page.setSize(250, 500)
     * page.setSize(page.getWidth() + 50, page.getHeight() + 100)
     * page.setSize(page.getWidth() - 50, page.getHeight() - 100)
     * ```
     *
     * Note that the PDF specification does not allow for pages to have explicit
     * widths and heights. Instead it defines the "size" of a page in terms of
     * five rectangles: the MediaBox, CropBox, BleedBox, TrimBox, and ArtBox. As a
     * result, this method cannot directly change the width and height of a page.
     * Instead, it works by adjusting these five boxes.
     *
     * This method performs the following steps:
     *   1. Set width & height of MediaBox.
     *   2. Set width & height of CropBox, if it has same dimensions as MediaBox.
     *   3. Set width & height of BleedBox, if it has same dimensions as MediaBox.
     *   4. Set width & height of TrimBox, if it has same dimensions as MediaBox.
     *   5. Set width & height of ArtBox, if it has same dimensions as MediaBox.
     *
     * This approach works well for most PDF documents as all PDF pages must
     * have a MediaBox, but relatively few have a CropBox, BleedBox, TrimBox, or
     * ArtBox. And when they do have these additional boxes, they often have the
     * same dimensions as the MediaBox. However, if you find this method does not
     * work for your document, consider setting the boxes directly:
     *   * [[PDFPage.setMediaBox]]
     *   * [[PDFPage.setCropBox]]
     *   * [[PDFPage.setBleedBox]]
     *   * [[PDFPage.setTrimBox]]
     *   * [[PDFPage.setArtBox]]
     *
     * @param width The new width of the page.
     * @param height The new height of the page.
     */ PDFPage.prototype.setSize = function(width, height) {
        (0, $j0tvB.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(height, 'height', [
            'number'
        ]);
        var mediaBox = this.getMediaBox();
        this.setMediaBox(mediaBox.x, mediaBox.y, width, height);
        var cropBox = this.getCropBox();
        var bleedBox = this.getBleedBox();
        var trimBox = this.getTrimBox();
        var artBox = this.getArtBox();
        var hasCropBox = this.node.CropBox();
        var hasBleedBox = this.node.BleedBox();
        var hasTrimBox = this.node.TrimBox();
        var hasArtBox = this.node.ArtBox();
        if (hasCropBox && (0, $cbIAG.rectanglesAreEqual)(cropBox, mediaBox)) this.setCropBox(mediaBox.x, mediaBox.y, width, height);
        if (hasBleedBox && (0, $cbIAG.rectanglesAreEqual)(bleedBox, mediaBox)) this.setBleedBox(mediaBox.x, mediaBox.y, width, height);
        if (hasTrimBox && (0, $cbIAG.rectanglesAreEqual)(trimBox, mediaBox)) this.setTrimBox(mediaBox.x, mediaBox.y, width, height);
        if (hasArtBox && (0, $cbIAG.rectanglesAreEqual)(artBox, mediaBox)) this.setArtBox(mediaBox.x, mediaBox.y, width, height);
    };
    /**
     * Resize this page by increasing or decreasing its width. For example:
     * ```js
     * page.setWidth(250)
     * page.setWidth(page.getWidth() + 50)
     * page.setWidth(page.getWidth() - 50)
     * ```
     *
     * This method uses [[PDFPage.setSize]] to set the page's width.
     *
     * @param width The new width of the page.
     */ PDFPage.prototype.setWidth = function(width) {
        (0, $j0tvB.assertIs)(width, 'width', [
            'number'
        ]);
        this.setSize(width, this.getSize().height);
    };
    /**
     * Resize this page by increasing or decreasing its height. For example:
     * ```js
     * page.setHeight(500)
     * page.setHeight(page.getWidth() + 100)
     * page.setHeight(page.getWidth() - 100)
     * ```
     *
     * This method uses [[PDFPage.setSize]] to set the page's height.
     *
     * @param height The new height of the page.
     */ PDFPage.prototype.setHeight = function(height) {
        (0, $j0tvB.assertIs)(height, 'height', [
            'number'
        ]);
        this.setSize(this.getSize().width, height);
    };
    /**
     * Set the MediaBox of this page. For example:
     * ```js
     * const mediaBox = page.getMediaBox()
     *
     * page.setMediaBox(0, 0, 250, 500)
     * page.setMediaBox(mediaBox.x, mediaBox.y, 50, 100)
     * page.setMediaBox(15, 5, mediaBox.width - 50, mediaBox.height - 100)
     * ```
     *
     * See [[PDFPage.getMediaBox]] for details about what the MediaBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new MediaBox.
     * @param y The y coordinate of the lower left corner of the new MediaBox.
     * @param width The width of the new MediaBox.
     * @param height The height of the new MediaBox.
     */ PDFPage.prototype.setMediaBox = function(x, y, width, height) {
        (0, $j0tvB.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(y, 'y', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(height, 'height', [
            'number'
        ]);
        var mediaBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $dPHSK.default).MediaBox, mediaBox);
    };
    /**
     * Set the CropBox of this page. For example:
     * ```js
     * const cropBox = page.getCropBox()
     *
     * page.setCropBox(0, 0, 250, 500)
     * page.setCropBox(cropBox.x, cropBox.y, 50, 100)
     * page.setCropBox(15, 5, cropBox.width - 50, cropBox.height - 100)
     * ```
     *
     * See [[PDFPage.getCropBox]] for details about what the CropBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new CropBox.
     * @param y The y coordinate of the lower left corner of the new CropBox.
     * @param width The width of the new CropBox.
     * @param height The height of the new CropBox.
     */ PDFPage.prototype.setCropBox = function(x, y, width, height) {
        (0, $j0tvB.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(y, 'y', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(height, 'height', [
            'number'
        ]);
        var cropBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $dPHSK.default).CropBox, cropBox);
    };
    /**
     * Set the BleedBox of this page. For example:
     * ```js
     * const bleedBox = page.getBleedBox()
     *
     * page.setBleedBox(0, 0, 250, 500)
     * page.setBleedBox(bleedBox.x, bleedBox.y, 50, 100)
     * page.setBleedBox(15, 5, bleedBox.width - 50, bleedBox.height - 100)
     * ```
     *
     * See [[PDFPage.getBleedBox]] for details about what the BleedBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new BleedBox.
     * @param y The y coordinate of the lower left corner of the new BleedBox.
     * @param width The width of the new BleedBox.
     * @param height The height of the new BleedBox.
     */ PDFPage.prototype.setBleedBox = function(x, y, width, height) {
        (0, $j0tvB.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(y, 'y', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(height, 'height', [
            'number'
        ]);
        var bleedBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $dPHSK.default).BleedBox, bleedBox);
    };
    /**
     * Set the TrimBox of this page. For example:
     * ```js
     * const trimBox = page.getTrimBox()
     *
     * page.setTrimBox(0, 0, 250, 500)
     * page.setTrimBox(trimBox.x, trimBox.y, 50, 100)
     * page.setTrimBox(15, 5, trimBox.width - 50, trimBox.height - 100)
     * ```
     *
     * See [[PDFPage.getTrimBox]] for details about what the TrimBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new TrimBox.
     * @param y The y coordinate of the lower left corner of the new TrimBox.
     * @param width The width of the new TrimBox.
     * @param height The height of the new TrimBox.
     */ PDFPage.prototype.setTrimBox = function(x, y, width, height) {
        (0, $j0tvB.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(y, 'y', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(height, 'height', [
            'number'
        ]);
        var trimBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $dPHSK.default).TrimBox, trimBox);
    };
    /**
     * Set the ArtBox of this page. For example:
     * ```js
     * const artBox = page.getArtBox()
     *
     * page.setArtBox(0, 0, 250, 500)
     * page.setArtBox(artBox.x, artBox.y, 50, 100)
     * page.setArtBox(15, 5, artBox.width - 50, artBox.height - 100)
     * ```
     *
     * See [[PDFPage.getArtBox]] for details about what the ArtBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new ArtBox.
     * @param y The y coordinate of the lower left corner of the new ArtBox.
     * @param width The width of the new ArtBox.
     * @param height The height of the new ArtBox.
     */ PDFPage.prototype.setArtBox = function(x, y, width, height) {
        (0, $j0tvB.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(y, 'y', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(height, 'height', [
            'number'
        ]);
        var artBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $dPHSK.default).ArtBox, artBox);
    };
    /**
     * Get this page's width and height. For example:
     * ```js
     * const { width, height } = page.getSize()
     * ```
     *
     * This method uses [[PDFPage.getMediaBox]] to obtain the page's
     * width and height.
     *
     * @returns The width and height of the page.
     */ PDFPage.prototype.getSize = function() {
        var _a = this.getMediaBox(), width = _a.width, height = _a.height;
        return {
            width: width,
            height: height
        };
    };
    /**
     * Get this page's width. For example:
     * ```js
     * const width = page.getWidth()
     * ```
     *
     * This method uses [[PDFPage.getSize]] to obtain the page's size.
     *
     * @returns The width of the page.
     */ PDFPage.prototype.getWidth = function() {
        return this.getSize().width;
    };
    /**
     * Get this page's height. For example:
     * ```js
     * const height = page.getHeight()
     * ```
     *
     * This method uses [[PDFPage.getSize]] to obtain the page's size.
     *
     * @returns The height of the page.
     */ PDFPage.prototype.getHeight = function() {
        return this.getSize().height;
    };
    /**
     * Get the rectangle defining this page's MediaBox. For example:
     * ```js
     * const { x, y, width, height } = page.getMediaBox()
     * ```
     *
     * The MediaBox of a page defines the boundaries of the physical medium on
     * which the page is to be displayed/printed. It may include extended area
     * surrounding the page content for bleed marks, printing marks, etc...
     * It may also include areas close to the edges of the medium that cannot be
     * marked because of physical limitations of the output device. Content
     * falling outside this boundary may safely be discarded without affecting
     * the meaning of the PDF file.
     *
     * @returns An object defining the lower left corner of the MediaBox and its
     *          width & height.
     */ PDFPage.prototype.getMediaBox = function() {
        var mediaBox = this.node.MediaBox();
        return mediaBox.asRectangle();
    };
    /**
     * Get the rectangle defining this page's CropBox. For example:
     * ```js
     * const { x, y, width, height } = page.getCropBox()
     * ```
     *
     * The CropBox of a page defines the region to which the contents of the page
     * shall be clipped when displayed or printed. Unlike the other boxes, the
     * CropBox does not necessarily represent the physical page geometry. It
     * merely imposes clipping on the page contents.
     *
     * The CropBox's default value is the page's MediaBox.
     *
     * @returns An object defining the lower left corner of the CropBox and its
     *          width & height.
     */ PDFPage.prototype.getCropBox = function() {
        var _a;
        var cropBox = this.node.CropBox();
        return (_a = cropBox === null || cropBox === void 0 ? void 0 : cropBox.asRectangle()) !== null && _a !== void 0 ? _a : this.getMediaBox();
    };
    /**
     * Get the rectangle defining this page's BleedBox. For example:
     * ```js
     * const { x, y, width, height } = page.getBleedBox()
     * ```
     *
     * The BleedBox of a page defines the region to which the contents of the
     * page shall be clipped when output in a production environment. This may
     * include any extra bleed area needed to accommodate the physical
     * limitations of cutting, folding, and trimming equipment. The actual
     * printed page may include printing marks that fall outside the BleedBox.
     *
     * The BleedBox's default value is the page's CropBox.
     *
     * @returns An object defining the lower left corner of the BleedBox and its
     *          width & height.
     */ PDFPage.prototype.getBleedBox = function() {
        var _a;
        var bleedBox = this.node.BleedBox();
        return (_a = bleedBox === null || bleedBox === void 0 ? void 0 : bleedBox.asRectangle()) !== null && _a !== void 0 ? _a : this.getCropBox();
    };
    /**
     * Get the rectangle defining this page's TrimBox. For example:
     * ```js
     * const { x, y, width, height } = page.getTrimBox()
     * ```
     *
     * The TrimBox of a page defines the intended dimensions of the finished
     * page after trimming. It may be smaller than the MediaBox to allow for
     * production-related content, such as printing instructions, cut marks, or
     * color bars.
     *
     * The TrimBox's default value is the page's CropBox.
     *
     * @returns An object defining the lower left corner of the TrimBox and its
     *          width & height.
     */ PDFPage.prototype.getTrimBox = function() {
        var _a;
        var trimBox = this.node.TrimBox();
        return (_a = trimBox === null || trimBox === void 0 ? void 0 : trimBox.asRectangle()) !== null && _a !== void 0 ? _a : this.getCropBox();
    };
    /**
     * Get the rectangle defining this page's ArtBox. For example:
     * ```js
     * const { x, y, width, height } = page.getArtBox()
     * ```
     *
     * The ArtBox of a page defines the extent of the page's meaningful content
     * (including potential white space).
     *
     * The ArtBox's default value is the page's CropBox.
     *
     * @returns An object defining the lower left corner of the ArtBox and its
     *          width & height.
     */ PDFPage.prototype.getArtBox = function() {
        var _a;
        var artBox = this.node.ArtBox();
        return (_a = artBox === null || artBox === void 0 ? void 0 : artBox.asRectangle()) !== null && _a !== void 0 ? _a : this.getCropBox();
    };
    /**
     * Translate this page's content to a new location on the page. This operation
     * is often useful after resizing the page with [[setSize]]. For example:
     * ```js
     * // Add 50 units of whitespace to the top and right of the page
     * page.setSize(page.getWidth() + 50, page.getHeight() + 50)
     *
     * // Move the page's content from the lower-left corner of the page
     * // to the top-right corner.
     * page.translateContent(50, 50)
     *
     * // Now there are 50 units of whitespace to the left and bottom of the page
     * ```
     * See also: [[resetPosition]]
     * @param x The new position on the x-axis for this page's content.
     * @param y The new position on the y-axis for this page's content.
     */ PDFPage.prototype.translateContent = function(x, y) {
        (0, $j0tvB.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(y, 'y', [
            'number'
        ]);
        this.node.normalize();
        this.getContentStream();
        var start = this.createContentStream((0, $hPFvC.pushGraphicsState)(), (0, $hPFvC.translate)(x, y));
        var startRef = this.doc.context.register(start);
        var end = this.createContentStream((0, $hPFvC.popGraphicsState)());
        var endRef = this.doc.context.register(end);
        this.node.wrapContentStreams(startRef, endRef);
    };
    /**
     * Scale the size, content, and annotations of a page.
     *
     * For example:
     * ```js
     * page.scale(0.5, 0.5);
     * ```
     *
     * @param x The factor by which the width for the page should be scaled
     *          (e.g. `0.5` is 50%).
     * @param y The factor by which the height for the page should be scaled
     *          (e.g. `2.0` is 200%).
     */ PDFPage.prototype.scale = function(x, y) {
        (0, $j0tvB.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(y, 'y', [
            'number'
        ]);
        this.setSize(this.getWidth() * x, this.getHeight() * y);
        this.scaleContent(x, y);
        this.scaleAnnotations(x, y);
    };
    /**
     * Scale the content of a page. This is useful after resizing an existing
     * page. This scales only the content, not the annotations.
     *
     * For example:
     * ```js
     * // Bisect the size of the page
     * page.setSize(page.getWidth() / 2, page.getHeight() / 2);
     *
     * // Scale the content of the page down by 50% in x and y
     * page.scaleContent(0.5, 0.5);
     * ```
     * See also: [[scaleAnnotations]]
     * @param x The factor by which the x-axis for the content should be scaled
     *          (e.g. `0.5` is 50%).
     * @param y The factor by which the y-axis for the content should be scaled
     *          (e.g. `2.0` is 200%).
     */ PDFPage.prototype.scaleContent = function(x, y) {
        (0, $j0tvB.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(y, 'y', [
            'number'
        ]);
        this.node.normalize();
        this.getContentStream();
        var start = this.createContentStream((0, $hPFvC.pushGraphicsState)(), (0, $hPFvC.scale)(x, y));
        var startRef = this.doc.context.register(start);
        var end = this.createContentStream((0, $hPFvC.popGraphicsState)());
        var endRef = this.doc.context.register(end);
        this.node.wrapContentStreams(startRef, endRef);
    };
    /**
     * Scale the annotations of a page. This is useful if you want to scale a
     * page with comments or other annotations.
     * ```js
     * // Scale the content of the page down by 50% in x and y
     * page.scaleContent(0.5, 0.5);
     *
     * // Scale the content of the page down by 50% in x and y
     * page.scaleAnnotations(0.5, 0.5);
     * ```
     * See also: [[scaleContent]]
     * @param x The factor by which the x-axis for the annotations should be
     *          scaled (e.g. `0.5` is 50%).
     * @param y The factor by which the y-axis for the annotations should be
     *          scaled (e.g. `2.0` is 200%).
     */ PDFPage.prototype.scaleAnnotations = function(x, y) {
        (0, $j0tvB.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(y, 'y', [
            'number'
        ]);
        var annots = this.node.Annots();
        if (!annots) return;
        for(var idx = 0; idx < annots.size(); idx++){
            var annot = annots.lookup(idx);
            if (annot instanceof (0, $brir8.default)) this.scaleAnnot(annot, x, y);
        }
    };
    /**
     * Reset the x and y coordinates of this page to `(0, 0)`. This operation is
     * often useful after calling [[translateContent]]. For example:
     * ```js
     * // Shift the page's contents up and to the right by 50 units
     * page.translateContent(50, 50)
     *
     * // This text will shifted - it will be drawn at (50, 50)
     * page.drawText('I am shifted')
     *
     * // Move back to (0, 0)
     * page.resetPosition()
     *
     * // This text will not be shifted - it will be drawn at (0, 0)
     * page.drawText('I am not shifted')
     * ```
     */ PDFPage.prototype.resetPosition = function() {
        this.getContentStream(false);
        this.x = 0;
        this.y = 0;
    };
    /**
     * Choose a default font for this page. The default font will be used whenever
     * text is drawn on this page and no font is specified. For example:
     * ```js
     * import { StandardFonts } from 'pdf-lib'
     *
     * const timesRomanFont = await pdfDoc.embedFont(StandardFonts.TimesRoman)
     * const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const courierFont = await pdfDoc.embedFont(StandardFonts.Courier)
     *
     * const page = pdfDoc.addPage()
     *
     * page.setFont(helveticaFont)
     * page.drawText('I will be drawn in Helvetica')
     *
     * page.setFont(timesRomanFont)
     * page.drawText('I will be drawn in Courier', { font: courierFont })
     * ```
     * @param font The default font to be used when drawing text on this page.
     */ PDFPage.prototype.setFont = function(font) {
        // TODO: Reuse image Font name if we've already added this image to Resources.Fonts
        (0, $j0tvB.assertIs)(font, 'font', [
            [
                (0, $lzaL9.default),
                'PDFFont'
            ]
        ]);
        this.font = font;
        this.fontKey = this.node.newFontDictionary(this.font.name, this.font.ref);
    };
    /**
     * Choose a default font size for this page. The default font size will be
     * used whenever text is drawn on this page and no font size is specified.
     * For example:
     * ```js
     * page.setFontSize(12)
     * page.drawText('I will be drawn in size 12')
     *
     * page.setFontSize(36)
     * page.drawText('I will be drawn in size 24', { fontSize: 24 })
     * ```
     * @param fontSize The default font size to be used when drawing text on this
     *                 page.
     */ PDFPage.prototype.setFontSize = function(fontSize) {
        (0, $j0tvB.assertIs)(fontSize, 'fontSize', [
            'number'
        ]);
        this.fontSize = fontSize;
    };
    /**
     * Choose a default font color for this page. The default font color will be
     * used whenever text is drawn on this page and no font color is specified.
     * For example:
     * ```js
     * import { rgb, cmyk, grayscale } from 'pdf-lib'
     *
     * page.setFontColor(rgb(0.97, 0.02, 0.97))
     * page.drawText('I will be drawn in pink')
     *
     * page.setFontColor(cmyk(0.4, 0.7, 0.39, 0.15))
     * page.drawText('I will be drawn in gray', { color: grayscale(0.5) })
     * ```
     * @param fontColor The default font color to be used when drawing text on
     *                  this page.
     */ PDFPage.prototype.setFontColor = function(fontColor) {
        (0, $j0tvB.assertIs)(fontColor, 'fontColor', [
            [
                Object,
                'Color'
            ]
        ]);
        this.fontColor = fontColor;
    };
    /**
     * Choose a default line height for this page. The default line height will be
     * used whenever text is drawn on this page and no line height is specified.
     * For example:
     * ```js
     * page.setLineHeight(12);
     * page.drawText('These lines will be vertically \n separated by 12 units')
     *
     * page.setLineHeight(36);
     * page.drawText('These lines will be vertically \n separated by 24 units', {
     *   lineHeight: 24
     * })
     * ```
     * @param lineHeight The default line height to be used when drawing text on
     *                   this page.
     */ PDFPage.prototype.setLineHeight = function(lineHeight) {
        (0, $j0tvB.assertIs)(lineHeight, 'lineHeight', [
            'number'
        ]);
        this.lineHeight = lineHeight;
    };
    /**
     * Get the default position of this page. For example:
     * ```js
     * const { x, y } = page.getPosition()
     * ```
     * @returns The default position of the page.
     */ PDFPage.prototype.getPosition = function() {
        return {
            x: this.x,
            y: this.y
        };
    };
    /**
     * Get the default x coordinate of this page. For example:
     * ```js
     * const x = page.getX()
     * ```
     * @returns The default x coordinate of the page.
     */ PDFPage.prototype.getX = function() {
        return this.x;
    };
    /**
     * Get the default y coordinate of this page. For example:
     * ```js
     * const y = page.getY()
     * ```
     * @returns The default y coordinate of the page.
     */ PDFPage.prototype.getY = function() {
        return this.y;
    };
    /**
     * Change the default position of this page. For example:
     * ```js
     * page.moveTo(0, 0)
     * page.drawText('I will be drawn at the origin')
     *
     * page.moveTo(0, 25)
     * page.drawText('I will be drawn 25 units up')
     *
     * page.moveTo(25, 25)
     * page.drawText('I will be drawn 25 units up and 25 units to the right')
     * ```
     * @param x The new default position on the x-axis for this page.
     * @param y The new default position on the y-axis for this page.
     */ PDFPage.prototype.moveTo = function(x, y) {
        (0, $j0tvB.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(y, 'y', [
            'number'
        ]);
        this.x = x;
        this.y = y;
    };
    /**
     * Change the default position of this page to be further down the y-axis.
     * For example:
     * ```js
     * page.moveTo(50, 50)
     * page.drawText('I will be drawn at (50, 50)')
     *
     * page.moveDown(10)
     * page.drawText('I will be drawn at (50, 40)')
     * ```
     * @param yDecrease The amount by which the page's default position along the
     *                  y-axis should be decreased.
     */ PDFPage.prototype.moveDown = function(yDecrease) {
        (0, $j0tvB.assertIs)(yDecrease, 'yDecrease', [
            'number'
        ]);
        this.y -= yDecrease;
    };
    /**
     * Change the default position of this page to be further up the y-axis.
     * For example:
     * ```js
     * page.moveTo(50, 50)
     * page.drawText('I will be drawn at (50, 50)')
     *
     * page.moveUp(10)
     * page.drawText('I will be drawn at (50, 60)')
     * ```
     * @param yIncrease The amount by which the page's default position along the
     *                  y-axis should be increased.
     */ PDFPage.prototype.moveUp = function(yIncrease) {
        (0, $j0tvB.assertIs)(yIncrease, 'yIncrease', [
            'number'
        ]);
        this.y += yIncrease;
    };
    /**
     * Change the default position of this page to be further left on the x-axis.
     * For example:
     * ```js
     * page.moveTo(50, 50)
     * page.drawText('I will be drawn at (50, 50)')
     *
     * page.moveLeft(10)
     * page.drawText('I will be drawn at (40, 50)')
     * ```
     * @param xDecrease The amount by which the page's default position along the
     *                  x-axis should be decreased.
     */ PDFPage.prototype.moveLeft = function(xDecrease) {
        (0, $j0tvB.assertIs)(xDecrease, 'xDecrease', [
            'number'
        ]);
        this.x -= xDecrease;
    };
    /**
     * Change the default position of this page to be further right on the y-axis.
     * For example:
     * ```js
     * page.moveTo(50, 50)
     * page.drawText('I will be drawn at (50, 50)')
     *
     * page.moveRight(10)
     * page.drawText('I will be drawn at (60, 50)')
     * ```
     * @param xIncrease The amount by which the page's default position along the
     *                  x-axis should be increased.
     */ PDFPage.prototype.moveRight = function(xIncrease) {
        (0, $j0tvB.assertIs)(xIncrease, 'xIncrease', [
            'number'
        ]);
        this.x += xIncrease;
    };
    /**
     * Push one or more operators to the end of this page's current content
     * stream. For example:
     * ```js
     * import {
     *   pushGraphicsState,
     *   moveTo,
     *   lineTo,
     *   closePath,
     *   setFillingColor,
     *   rgb,
     *   fill,
     *   popGraphicsState,
     * } from 'pdf-lib'
     *
     * // Draw a green triangle in the lower-left corner of the page
     * page.pushOperators(
     *   pushGraphicsState(),
     *   moveTo(0, 0),
     *   lineTo(100, 0),
     *   lineTo(50, 100),
     *   closePath(),
     *   setFillingColor(rgb(0.0, 1.0, 0.0)),
     *   fill(),
     *   popGraphicsState(),
     * )
     * ```
     * @param operator The operators to be pushed.
     */ PDFPage.prototype.pushOperators = function() {
        var operator = [];
        for(var _i = 0; _i < arguments.length; _i++)operator[_i] = arguments[_i];
        (0, $j0tvB.assertEachIs)(operator, 'operator', [
            [
                (0, $5uV6d.default),
                'PDFOperator'
            ]
        ]);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, operator);
    };
    /**
     * Draw one or more lines of text on this page. For example:
     * ```js
     * import { StandardFonts, rgb } from 'pdf-lib'
     *
     * const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const timesRomanFont = await pdfDoc.embedFont(StandardFonts.TimesRoman)
     *
     * const page = pdfDoc.addPage()
     *
     * page.setFont(helveticaFont)
     *
     * page.moveTo(5, 200)
     * page.drawText('The Life of an Egg', { size: 36 })
     *
     * page.moveDown(36)
     * page.drawText('An Epic Tale of Woe', { size: 30 })
     *
     * page.drawText(
     *   `Humpty Dumpty sat on a wall \n` +
     *   `Humpty Dumpty had a great fall; \n` +
     *   `All the king's horses and all the king's men \n` +
     *   `Couldn't put Humpty together again. \n`,
     *   {
     *     x: 25,
     *     y: 100,
     *     font: timesRomanFont,
     *     size: 24,
     *     color: rgb(1, 0, 0),
     *     lineHeight: 24,
     *     opacity: 0.75,
     *   },
     * )
     * ```
     * @param text The text to be drawn.
     * @param options The options to be used when drawing the text.
     */ PDFPage.prototype.drawText = function(text, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (options === void 0) options = {};
        (0, $j0tvB.assertIs)(text, 'text', [
            'string'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.color, 'options.color', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $j0tvB.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $j0tvB.assertOrUndefined)(options.font, 'options.font', [
            [
                (0, $lzaL9.default),
                'PDFFont'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.size, 'options.size', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.xSkew, 'options.xSkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.ySkew, 'options.ySkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.lineHeight, 'options.lineHeight', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.maxWidth, 'options.maxWidth', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.wordBreaks, 'options.wordBreaks', [
            Array
        ]);
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $j1dka.BlendMode));
        var _h = this.setOrEmbedFont(options.font), oldFont = _h.oldFont, newFont = _h.newFont, newFontKey = _h.newFontKey;
        var fontSize = options.size || this.fontSize;
        var wordBreaks = options.wordBreaks || this.doc.defaultWordBreaks;
        var textWidth = function(t) {
            return newFont.widthOfTextAtSize(t, fontSize);
        };
        var lines = options.maxWidth === undefined ? (0, $7Kmy8.lineSplit)((0, $7Kmy8.cleanText)(text)) : (0, $7Kmy8.breakTextIntoLines)(text, wordBreaks, options.maxWidth, textWidth);
        var encodedLines = new Array(lines.length);
        for(var idx = 0, len = lines.length; idx < len; idx++)encodedLines[idx] = newFont.encodeText(lines[idx]);
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            blendMode: options.blendMode
        });
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $7mLHs.drawLinesOfText)(encodedLines, {
            color: (_a = options.color) !== null && _a !== void 0 ? _a : this.fontColor,
            font: newFontKey,
            size: fontSize,
            rotate: (_b = options.rotate) !== null && _b !== void 0 ? _b : (0, $55HYh.degrees)(0),
            xSkew: (_c = options.xSkew) !== null && _c !== void 0 ? _c : (0, $55HYh.degrees)(0),
            ySkew: (_d = options.ySkew) !== null && _d !== void 0 ? _d : (0, $55HYh.degrees)(0),
            x: (_e = options.x) !== null && _e !== void 0 ? _e : this.x,
            y: (_f = options.y) !== null && _f !== void 0 ? _f : this.y,
            lineHeight: (_g = options.lineHeight) !== null && _g !== void 0 ? _g : this.lineHeight,
            graphicsState: graphicsStateKey
        }));
        if (options.font) {
            if (oldFont) this.setFont(oldFont);
            else this.resetFont();
        }
    };
    /**
     * Draw an image on this page. For example:
     * ```js
     * import { degrees } from 'pdf-lib'
     *
     * const jpgUrl = 'https://pdf-lib.js.org/assets/cat_riding_unicorn.jpg'
     * const jpgImageBytes = await fetch(jpgUrl).then((res) => res.arrayBuffer())
     *
     * const jpgImage = await pdfDoc.embedJpg(jpgImageBytes)
     * const jpgDims = jpgImage.scale(0.5)
     *
     * const page = pdfDoc.addPage()
     *
     * page.drawImage(jpgImage, {
     *   x: 25,
     *   y: 25,
     *   width: jpgDims.width,
     *   height: jpgDims.height,
     *   rotate: degrees(30),
     *   opacity: 0.75,
     * })
     * ```
     * @param image The image to be drawn.
     * @param options The options to be used when drawing the image.
     */ PDFPage.prototype.drawImage = function(image, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (options === void 0) options = {};
        // TODO: Reuse image XObject name if we've already added this image to Resources.XObjects
        (0, $j0tvB.assertIs)(image, 'image', [
            [
                (0, $7F2yc.default),
                'PDFImage'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.width, 'options.width', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.height, 'options.height', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.xSkew, 'options.xSkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.ySkew, 'options.ySkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $j1dka.BlendMode));
        var xObjectKey = this.node.newXObject('Image', image.ref);
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            blendMode: options.blendMode
        });
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $7mLHs.drawImage)(xObjectKey, {
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : image.size().width,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : image.size().height,
            rotate: (_e = options.rotate) !== null && _e !== void 0 ? _e : (0, $55HYh.degrees)(0),
            xSkew: (_f = options.xSkew) !== null && _f !== void 0 ? _f : (0, $55HYh.degrees)(0),
            ySkew: (_g = options.ySkew) !== null && _g !== void 0 ? _g : (0, $55HYh.degrees)(0),
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw an embedded PDF page on this page. For example:
     * ```js
     * import { degrees } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const page = pdfDoc.addPage()
     *
     * const sourcePdfUrl = 'https://pdf-lib.js.org/assets/with_large_page_count.pdf'
     * const sourcePdf = await fetch(sourcePdfUrl).then((res) => res.arrayBuffer())
     *
     * // Embed page 74 from the PDF
     * const [embeddedPage] = await pdfDoc.embedPdf(sourcePdf, 73)
     *
     * page.drawPage(embeddedPage, {
     *   x: 250,
     *   y: 200,
     *   xScale: 0.5,
     *   yScale: 0.5,
     *   rotate: degrees(30),
     *   opacity: 0.75,
     * })
     * ```
     *
     * The `options` argument accepts both `width`/`height` and `xScale`/`yScale`
     * as options. Since each of these options defines the size of the drawn page,
     * if both options are given, `width` and `height` take precedence and the
     * corresponding scale variants are ignored.
     *
     * @param embeddedPage The embedded page to be drawn.
     * @param options The options to be used when drawing the embedded page.
     */ PDFPage.prototype.drawPage = function(embeddedPage, options) {
        var _a, _b, _c, _d, _e;
        if (options === void 0) options = {};
        // TODO: Reuse embeddedPage XObject name if we've already added this embeddedPage to Resources.XObjects
        (0, $j0tvB.assertIs)(embeddedPage, 'embeddedPage', [
            [
                (0, $kUs6q.default),
                'PDFEmbeddedPage'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.xScale, 'options.xScale', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.yScale, 'options.yScale', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.width, 'options.width', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.height, 'options.height', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.xSkew, 'options.xSkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.ySkew, 'options.ySkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $j1dka.BlendMode));
        var xObjectKey = this.node.newXObject('EmbeddedPdfPage', embeddedPage.ref);
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            blendMode: options.blendMode
        });
        // prettier-ignore
        var xScale = options.width !== undefined ? options.width / embeddedPage.width : options.xScale !== undefined ? options.xScale : 1;
        // prettier-ignore
        var yScale = options.height !== undefined ? options.height / embeddedPage.height : options.yScale !== undefined ? options.yScale : 1;
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $7mLHs.drawPage)(xObjectKey, {
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            xScale: xScale,
            yScale: yScale,
            rotate: (_c = options.rotate) !== null && _c !== void 0 ? _c : (0, $55HYh.degrees)(0),
            xSkew: (_d = options.xSkew) !== null && _d !== void 0 ? _d : (0, $55HYh.degrees)(0),
            ySkew: (_e = options.ySkew) !== null && _e !== void 0 ? _e : (0, $55HYh.degrees)(0),
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw an SVG path on this page. For example:
     * ```js
     * import { rgb } from 'pdf-lib'
     *
     * const svgPath = 'M 0,20 L 100,160 Q 130,200 150,120 C 190,-40 200,200 300,150 L 400,90'
     *
     * // Draw path as black line
     * page.drawSvgPath(svgPath, { x: 25, y: 75 })
     *
     * // Change border style and opacity
     * page.drawSvgPath(svgPath, {
     *   x: 25,
     *   y: 275,
     *   borderColor: rgb(0.5, 0.5, 0.5),
     *   borderWidth: 2,
     *   borderOpacity: 0.75,
     * })
     *
     * // Set fill color and opacity
     * page.drawSvgPath(svgPath, {
     *   x: 25,
     *   y: 475,
     *   color: rgb(1.0, 0, 0),
     *   opacity: 0.75,
     * })
     *
     * // Draw 50% of original size
     * page.drawSvgPath(svgPath, {
     *   x: 25,
     *   y: 675,
     *   scale: 0.5,
     * })
     * ```
     * @param path The SVG path to be drawn.
     * @param options The options to be used when drawing the SVG path.
     */ PDFPage.prototype.drawSvgPath = function(path, options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (options === void 0) options = {};
        (0, $j0tvB.assertIs)(path, 'path', [
            'string'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.scale, 'options.scale', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.borderWidth, 'options.borderWidth', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.color, 'options.color', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $j0tvB.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $j0tvB.assertOrUndefined)(options.borderColor, 'options.borderColor', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.borderDashArray, 'options.borderDashArray', [
            Array
        ]);
        (0, $j0tvB.assertOrUndefined)(options.borderDashPhase, 'options.borderDashPhase', [
            'number'
        ]);
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.borderLineCap, 'options.borderLineCap', (0, $hPFvC.LineCapStyle));
        (0, $j0tvB.assertRangeOrUndefined)(options.borderOpacity, 'options.borderOpacity', 0, 1);
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $j1dka.BlendMode));
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            borderOpacity: options.borderOpacity,
            blendMode: options.blendMode
        });
        if (!('color' in options) && !('borderColor' in options)) options.borderColor = (0, $gidDr.rgb)(0, 0, 0);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $7mLHs.drawSvgPath)(path, {
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            scale: options.scale,
            rotate: (_c = options.rotate) !== null && _c !== void 0 ? _c : (0, $55HYh.degrees)(0),
            color: (_d = options.color) !== null && _d !== void 0 ? _d : undefined,
            borderColor: (_e = options.borderColor) !== null && _e !== void 0 ? _e : undefined,
            borderWidth: (_f = options.borderWidth) !== null && _f !== void 0 ? _f : 0,
            borderDashArray: (_g = options.borderDashArray) !== null && _g !== void 0 ? _g : undefined,
            borderDashPhase: (_h = options.borderDashPhase) !== null && _h !== void 0 ? _h : undefined,
            borderLineCap: (_j = options.borderLineCap) !== null && _j !== void 0 ? _j : undefined,
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw a line on this page. For example:
     * ```js
     * import { rgb } from 'pdf-lib'
     *
     * page.drawLine({
     *   start: { x: 25, y: 75 },
     *   end: { x: 125, y: 175 },
     *   thickness: 2,
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the line.
     */ PDFPage.prototype.drawLine = function(options) {
        var _a, _b, _c, _d, _e;
        (0, $j0tvB.assertIs)(options.start, 'options.start', [
            [
                Object,
                '{ x: number, y: number }'
            ]
        ]);
        (0, $j0tvB.assertIs)(options.end, 'options.end', [
            [
                Object,
                '{ x: number, y: number }'
            ]
        ]);
        (0, $j0tvB.assertIs)(options.start.x, 'options.start.x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(options.start.y, 'options.start.y', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(options.end.x, 'options.end.x', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(options.end.y, 'options.end.y', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.thickness, 'options.thickness', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.color, 'options.color', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.dashArray, 'options.dashArray', [
            Array
        ]);
        (0, $j0tvB.assertOrUndefined)(options.dashPhase, 'options.dashPhase', [
            'number'
        ]);
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.lineCap, 'options.lineCap', (0, $hPFvC.LineCapStyle));
        (0, $j0tvB.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $j1dka.BlendMode));
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            borderOpacity: options.opacity,
            blendMode: options.blendMode
        });
        if (!('color' in options)) options.color = (0, $gidDr.rgb)(0, 0, 0);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $7mLHs.drawLine)({
            start: options.start,
            end: options.end,
            thickness: (_a = options.thickness) !== null && _a !== void 0 ? _a : 1,
            color: (_b = options.color) !== null && _b !== void 0 ? _b : undefined,
            dashArray: (_c = options.dashArray) !== null && _c !== void 0 ? _c : undefined,
            dashPhase: (_d = options.dashPhase) !== null && _d !== void 0 ? _d : undefined,
            lineCap: (_e = options.lineCap) !== null && _e !== void 0 ? _e : undefined,
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw a rectangle on this page. For example:
     * ```js
     * import { degrees, grayscale, rgb } from 'pdf-lib'
     *
     * page.drawRectangle({
     *   x: 25,
     *   y: 75,
     *   width: 250,
     *   height: 75,
     *   rotate: degrees(-15),
     *   borderWidth: 5,
     *   borderColor: grayscale(0.5),
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.5,
     *   borderOpacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the rectangle.
     */ PDFPage.prototype.drawRectangle = function(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        if (options === void 0) options = {};
        (0, $j0tvB.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.width, 'options.width', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.height, 'options.height', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.xSkew, 'options.xSkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.ySkew, 'options.ySkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.borderWidth, 'options.borderWidth', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.color, 'options.color', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $j0tvB.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $j0tvB.assertOrUndefined)(options.borderColor, 'options.borderColor', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.borderDashArray, 'options.borderDashArray', [
            Array
        ]);
        (0, $j0tvB.assertOrUndefined)(options.borderDashPhase, 'options.borderDashPhase', [
            'number'
        ]);
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.borderLineCap, 'options.borderLineCap', (0, $hPFvC.LineCapStyle));
        (0, $j0tvB.assertRangeOrUndefined)(options.borderOpacity, 'options.borderOpacity', 0, 1);
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $j1dka.BlendMode));
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            borderOpacity: options.borderOpacity,
            blendMode: options.blendMode
        });
        if (!('color' in options) && !('borderColor' in options)) options.color = (0, $gidDr.rgb)(0, 0, 0);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $7mLHs.drawRectangle)({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 150,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 100,
            rotate: (_e = options.rotate) !== null && _e !== void 0 ? _e : (0, $55HYh.degrees)(0),
            xSkew: (_f = options.xSkew) !== null && _f !== void 0 ? _f : (0, $55HYh.degrees)(0),
            ySkew: (_g = options.ySkew) !== null && _g !== void 0 ? _g : (0, $55HYh.degrees)(0),
            borderWidth: (_h = options.borderWidth) !== null && _h !== void 0 ? _h : 0,
            color: (_j = options.color) !== null && _j !== void 0 ? _j : undefined,
            borderColor: (_k = options.borderColor) !== null && _k !== void 0 ? _k : undefined,
            borderDashArray: (_l = options.borderDashArray) !== null && _l !== void 0 ? _l : undefined,
            borderDashPhase: (_m = options.borderDashPhase) !== null && _m !== void 0 ? _m : undefined,
            graphicsState: graphicsStateKey,
            borderLineCap: (_o = options.borderLineCap) !== null && _o !== void 0 ? _o : undefined
        }));
    };
    /**
     * Draw a square on this page. For example:
     * ```js
     * import { degrees, grayscale, rgb } from 'pdf-lib'
     *
     * page.drawSquare({
     *   x: 25,
     *   y: 75,
     *   size: 100,
     *   rotate: degrees(-15),
     *   borderWidth: 5,
     *   borderColor: grayscale(0.5),
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.5,
     *   borderOpacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the square.
     */ PDFPage.prototype.drawSquare = function(options) {
        if (options === void 0) options = {};
        var size = options.size;
        (0, $j0tvB.assertOrUndefined)(size, 'size', [
            'number'
        ]);
        this.drawRectangle((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
            width: size,
            height: size
        }));
    };
    /**
     * Draw an ellipse on this page. For example:
     * ```js
     * import { grayscale, rgb } from 'pdf-lib'
     *
     * page.drawEllipse({
     *   x: 200,
     *   y: 75,
     *   xScale: 100,
     *   yScale: 50,
     *   borderWidth: 5,
     *   borderColor: grayscale(0.5),
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.5,
     *   borderOpacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the ellipse.
     */ PDFPage.prototype.drawEllipse = function(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        if (options === void 0) options = {};
        (0, $j0tvB.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.xScale, 'options.xScale', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.yScale, 'options.yScale', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(options.color, 'options.color', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $j0tvB.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $j0tvB.assertOrUndefined)(options.borderColor, 'options.borderColor', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $j0tvB.assertRangeOrUndefined)(options.borderOpacity, 'options.borderOpacity', 0, 1);
        (0, $j0tvB.assertOrUndefined)(options.borderWidth, 'options.borderWidth', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options.borderDashArray, 'options.borderDashArray', [
            Array
        ]);
        (0, $j0tvB.assertOrUndefined)(options.borderDashPhase, 'options.borderDashPhase', [
            'number'
        ]);
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.borderLineCap, 'options.borderLineCap', (0, $hPFvC.LineCapStyle));
        (0, $j0tvB.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $j1dka.BlendMode));
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            borderOpacity: options.borderOpacity,
            blendMode: options.blendMode
        });
        if (!('color' in options) && !('borderColor' in options)) options.color = (0, $gidDr.rgb)(0, 0, 0);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $7mLHs.drawEllipse)({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            xScale: (_c = options.xScale) !== null && _c !== void 0 ? _c : 100,
            yScale: (_d = options.yScale) !== null && _d !== void 0 ? _d : 100,
            rotate: (_e = options.rotate) !== null && _e !== void 0 ? _e : undefined,
            color: (_f = options.color) !== null && _f !== void 0 ? _f : undefined,
            borderColor: (_g = options.borderColor) !== null && _g !== void 0 ? _g : undefined,
            borderWidth: (_h = options.borderWidth) !== null && _h !== void 0 ? _h : 0,
            borderDashArray: (_j = options.borderDashArray) !== null && _j !== void 0 ? _j : undefined,
            borderDashPhase: (_k = options.borderDashPhase) !== null && _k !== void 0 ? _k : undefined,
            borderLineCap: (_l = options.borderLineCap) !== null && _l !== void 0 ? _l : undefined,
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw a circle on this page. For example:
     * ```js
     * import { grayscale, rgb } from 'pdf-lib'
     *
     * page.drawCircle({
     *   x: 200,
     *   y: 150,
     *   size: 100,
     *   borderWidth: 5,
     *   borderColor: grayscale(0.5),
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.5,
     *   borderOpacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the ellipse.
     */ PDFPage.prototype.drawCircle = function(options) {
        if (options === void 0) options = {};
        var _a = options.size, size = _a === void 0 ? 100 : _a;
        (0, $j0tvB.assertOrUndefined)(size, 'size', [
            'number'
        ]);
        this.drawEllipse((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, options), {
            xScale: size,
            yScale: size
        }));
    };
    PDFPage.prototype.setOrEmbedFont = function(font) {
        var oldFont = this.font;
        var oldFontKey = this.fontKey;
        if (font) this.setFont(font);
        else this.getFont();
        var newFont = this.font;
        var newFontKey = this.fontKey;
        return {
            oldFont: oldFont,
            oldFontKey: oldFontKey,
            newFont: newFont,
            newFontKey: newFontKey
        };
    };
    PDFPage.prototype.getFont = function() {
        if (!this.font || !this.fontKey) {
            var font = this.doc.embedStandardFont((0, $i4gUC.StandardFonts).Helvetica);
            this.setFont(font);
        }
        return [
            this.font,
            this.fontKey
        ];
    };
    PDFPage.prototype.resetFont = function() {
        this.font = undefined;
        this.fontKey = undefined;
    };
    PDFPage.prototype.getContentStream = function(useExisting) {
        if (useExisting === void 0) useExisting = true;
        if (useExisting && this.contentStream) return this.contentStream;
        this.contentStream = this.createContentStream();
        this.contentStreamRef = this.doc.context.register(this.contentStream);
        this.node.addContentStream(this.contentStreamRef);
        return this.contentStream;
    };
    PDFPage.prototype.createContentStream = function() {
        var operators = [];
        for(var _i = 0; _i < arguments.length; _i++)operators[_i] = arguments[_i];
        var dict = this.doc.context.obj({});
        var contentStream = (0, $9EODP.default).of(dict, operators);
        return contentStream;
    };
    PDFPage.prototype.maybeEmbedGraphicsState = function(options) {
        var opacity = options.opacity, borderOpacity = options.borderOpacity, blendMode = options.blendMode;
        if (opacity === undefined && borderOpacity === undefined && blendMode === undefined) return undefined;
        var graphicsState = this.doc.context.obj({
            Type: 'ExtGState',
            ca: opacity,
            CA: borderOpacity,
            BM: blendMode
        });
        var key = this.node.newExtGState('GS', graphicsState);
        return key;
    };
    PDFPage.prototype.scaleAnnot = function(annot, x, y) {
        var selectors = [
            'RD',
            'CL',
            'Vertices',
            'QuadPoints',
            'L',
            'Rect'
        ];
        for(var idx = 0, len = selectors.length; idx < len; idx++){
            var list = annot.lookup((0, $dPHSK.default).of(selectors[idx]));
            if (list instanceof (0, $8auL6.default)) list.scalePDFNumbers(x, y);
        }
        var inkLists = annot.lookup((0, $dPHSK.default).of('InkList'));
        if (inkLists instanceof (0, $8auL6.default)) for(var idx = 0, len = inkLists.size(); idx < len; idx++){
            var arr = inkLists.lookup(idx);
            if (arr instanceof (0, $8auL6.default)) arr.scalePDFNumbers(x, y);
        }
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.addPage]] and [[PDFDocument.insertPage]]
     * > methods, which can create instances of [[PDFPage]] for you.
     *
     * Create an instance of [[PDFPage]] from an existing leaf node.
     *
     * @param leafNode The leaf node to be wrapped.
     * @param ref The unique reference for the page.
     * @param doc The document to which the page will belong.
     */ PDFPage.of = function(leafNode, ref, doc) {
        return new PDFPage(leafNode, ref, doc);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.addPage]] and [[PDFDocument.insertPage]]
     * > methods, which can create instances of [[PDFPage]] for you.
     *
     * Create an instance of [[PDFPage]].
     *
     * @param doc The document to which the page will belong.
     */ PDFPage.create = function(doc) {
        (0, $j0tvB.assertIs)(doc, 'doc', [
            [
                (0, $cGbw3.default),
                'PDFDocument'
            ]
        ]);
        var dummyRef = (0, $kHzkO.default).of(-1);
        var pageLeaf = (0, $eAof5.default).withContextAndParent(doc.context, dummyRef);
        var pageRef = doc.context.register(pageLeaf);
        return new PDFPage(pageLeaf, pageRef, doc);
    };
    return PDFPage;
}();
var $a7f75cccfbb7eb6c$export$2e2bcd8739ae039 = $a7f75cccfbb7eb6c$var$PDFPage;

});
parcelRegister("cGbw3", function(module, exports) {

$parcel$export(module.exports, "default", () => $93b2571d4e1dfe94$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $aYJvX = parcelRequire("aYJvX");

var $kUs6q = parcelRequire("kUs6q");

var $lzaL9 = parcelRequire("lzaL9");

var $7F2yc = parcelRequire("7F2yc");

var $eq4Zh = parcelRequire("eq4Zh");

var $2sybW = parcelRequire("2sybW");

var $gjdfV = parcelRequire("gjdfV");
parcelRequire("iT7lj");
var $gCJZ9 = parcelRequire("gCJZ9");
var $6uXKX = parcelRequire("6uXKX");
var $fmxHr = parcelRequire("fmxHr");
var $nAWRe = parcelRequire("nAWRe");
var $b3l66 = parcelRequire("b3l66");
var $kl4jO = parcelRequire("kl4jO");
var $brir8 = parcelRequire("brir8");
var $jWFiV = parcelRequire("jWFiV");
var $dPHSK = parcelRequire("dPHSK");
var $k5Uzj = parcelRequire("k5Uzj");
var $h9IbG = parcelRequire("h9IbG");
var $eAof5 = parcelRequire("eAof5");
var $4oH3u = parcelRequire("4oH3u");
var $14nUL = parcelRequire("14nUL");
var $7YdvF = parcelRequire("7YdvF");
var $8dCYu = parcelRequire("8dCYu");
var $5HlMk = parcelRequire("5HlMk");
var $atfwl = parcelRequire("atfwl");
var $jwvE5 = parcelRequire("jwvE5");

var $dJaLP = parcelRequire("dJaLP");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
var $clYSv = parcelRequire("clYSv");
var $4ISq8 = parcelRequire("4ISq8");
var $fZ8o5 = parcelRequire("fZ8o5");
var $cbIAG = parcelRequire("cbIAG");

var $k8kub = parcelRequire("k8kub");

var $C6azw = parcelRequire("C6azw");

var $ceWew = parcelRequire("ceWew");

var $8gnuI = parcelRequire("8gnuI");
/**
 * Represents a PDF document.
 */ var $93b2571d4e1dfe94$var$PDFDocument = /** @class */ function() {
    function PDFDocument(context, ignoreEncryption, updateMetadata) {
        var _this = this;
        /** The default word breaks used in PDFPage.drawText */ this.defaultWordBreaks = [
            ' '
        ];
        this.computePages = function() {
            var pages = [];
            _this.catalog.Pages().traverse(function(node, ref) {
                if (node instanceof (0, $eAof5.default)) {
                    var page = _this.pageMap.get(node);
                    if (!page) {
                        page = (0, $eq4Zh.default).of(node, ref, _this);
                        _this.pageMap.set(node, page);
                    }
                    pages.push(page);
                }
            });
            return pages;
        };
        this.getOrCreateForm = function() {
            var acroForm = _this.catalog.getOrCreateAcroForm();
            return (0, $2sybW.default).of(acroForm, _this);
        };
        (0, $j0tvB.assertIs)(context, 'context', [
            [
                (0, $kl4jO.default),
                'PDFContext'
            ]
        ]);
        (0, $j0tvB.assertIs)(ignoreEncryption, 'ignoreEncryption', [
            'boolean'
        ]);
        this.context = context;
        this.catalog = context.lookup(context.trailerInfo.Root);
        this.isEncrypted = !!context.lookup(context.trailerInfo.Encrypt);
        this.pageCache = (0, $clYSv.default).populatedBy(this.computePages);
        this.pageMap = new Map();
        this.formCache = (0, $clYSv.default).populatedBy(this.getOrCreateForm);
        this.fonts = [];
        this.images = [];
        this.embeddedPages = [];
        this.embeddedFiles = [];
        this.javaScripts = [];
        if (!ignoreEncryption && this.isEncrypted) throw new (0, $aYJvX.EncryptedPDFError)();
        if (updateMetadata) this.updateInfoDict();
    }
    /**
     * Load an existing [[PDFDocument]]. The input data can be provided in
     * multiple formats:
     *
     * | Type          | Contents                                               |
     * | ------------- | ------------------------------------------------------ |
     * | `string`      | A base64 encoded string (or data URI) containing a PDF |
     * | `Uint8Array`  | The raw bytes of a PDF                                 |
     * | `ArrayBuffer` | The raw bytes of a PDF                                 |
     *
     * For example:
     * ```js
     * import { PDFDocument } from 'pdf-lib'
     *
     * // pdf=string
     * const base64 =
     *  'JVBERi0xLjcKJYGBgYEKCjUgMCBvYmoKPDwKL0ZpbHRlciAvRmxhdGVEZWNvZGUKL0xlbm' +
     *  'd0aCAxMDQKPj4Kc3RyZWFtCniccwrhMlAAwaJ0Ln2P1Jyy1JLM5ERdc0MjCwUjE4WQNC4Q' +
     *  '6cNlCFZkqGCqYGSqEJLLZWNuYGZiZmbkYuZsZmlmZGRgZmluDCQNzc3NTM2NzdzMXMxMjQ' +
     *  'ztFEKyuEK0uFxDuAAOERdVCmVuZHN0cmVhbQplbmRvYmoKCjYgMCBvYmoKPDwKL0ZpbHRl' +
     *  'ciAvRmxhdGVEZWNvZGUKL1R5cGUgL09ialN0bQovTiA0Ci9GaXJzdCAyMAovTGVuZ3RoID' +
     *  'IxNQo+PgpzdHJlYW0KeJxVj9GqwjAMhu/zFHkBzTo3nCCCiiKIHPEICuJF3cKoSCu2E8/b' +
     *  '20wPIr1p8v9/8kVhgilmGfawX2CGaVrgcAi0/bsy0lrX7IGWpvJ4iJYEN3gEmrrGBlQwGs' +
     *  'HHO9VBX1wNrxAqMX87RBD5xpJuddqwd82tjAHxzV1U5LPgy52DKXWnr1Lheg+j/c/pzGVr' +
     *  'iqV0VlwZPXGPCJjElw/ybkwUmeoWgxesDXGhHJC/D/iikp1Av80ptKU0FdBEe25pPihAM1' +
     *  'u6ytgaaWfs2Hrz35CJT1+EWmAKZW5kc3RyZWFtCmVuZG9iagoKNyAwIG9iago8PAovU2l6' +
     *  'ZSA4Ci9Sb290IDIgMCBSCi9GaWx0ZXIgL0ZsYXRlRGVjb2RlCi9UeXBlIC9YUmVmCi9MZW' +
     *  '5ndGggMzgKL1cgWyAxIDIgMiBdCi9JbmRleCBbIDAgOCBdCj4+CnN0cmVhbQp4nBXEwREA' +
     *  'EBAEsCwz3vrvRmOOyyOoGhZdutHN2MT55fIAVocD+AplbmRzdHJlYW0KZW5kb2JqCgpzdG' +
     *  'FydHhyZWYKNTEwCiUlRU9G'
     *
     * const dataUri = 'data:application/pdf;base64,' + base64
     *
     * const pdfDoc1 = await PDFDocument.load(base64)
     * const pdfDoc2 = await PDFDocument.load(dataUri)
     *
     * // pdf=Uint8Array
     * import fs from 'fs'
     * const uint8Array = fs.readFileSync('with_update_sections.pdf')
     * const pdfDoc3 = await PDFDocument.load(uint8Array)
     *
     * // pdf=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/with_update_sections.pdf'
     * const arrayBuffer = await fetch(url).then(res => res.arrayBuffer())
     * const pdfDoc4 = await PDFDocument.load(arrayBuffer)
     *
     * ```
     *
     * @param pdf The input data containing a PDF document.
     * @param options The options to be used when loading the document.
     * @returns Resolves with a document loaded from the input.
     */ PDFDocument.load = function(pdf, options) {
        if (options === void 0) options = {};
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var _a, ignoreEncryption, _b, parseSpeed, _c, throwOnInvalidObject, _d, updateMetadata, _e, capNumbers, bytes, context;
            return (0, $cOQTW.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        _a = options.ignoreEncryption, ignoreEncryption = _a === void 0 ? false : _a, _b = options.parseSpeed, parseSpeed = _b === void 0 ? (0, $dJaLP.ParseSpeeds).Slow : _b, _c = options.throwOnInvalidObject, throwOnInvalidObject = _c === void 0 ? false : _c, _d = options.updateMetadata, updateMetadata = _d === void 0 ? true : _d, _e = options.capNumbers, capNumbers = _e === void 0 ? false : _e;
                        (0, $j0tvB.assertIs)(pdf, 'pdf', [
                            'string',
                            Uint8Array,
                            ArrayBuffer
                        ]);
                        (0, $j0tvB.assertIs)(ignoreEncryption, 'ignoreEncryption', [
                            'boolean'
                        ]);
                        (0, $j0tvB.assertIs)(parseSpeed, 'parseSpeed', [
                            'number'
                        ]);
                        (0, $j0tvB.assertIs)(throwOnInvalidObject, 'throwOnInvalidObject', [
                            'boolean'
                        ]);
                        bytes = (0, $4ISq8.toUint8Array)(pdf);
                        return [
                            4 /*yield*/ ,
                            (0, $14nUL.default).forBytesWithOptions(bytes, parseSpeed, throwOnInvalidObject, capNumbers).parseDocument()
                        ];
                    case 1:
                        context = _f.sent();
                        return [
                            2 /*return*/ ,
                            new PDFDocument(context, ignoreEncryption, updateMetadata)
                        ];
                }
            });
        });
    };
    /**
     * Create a new [[PDFDocument]].
     * @returns Resolves with the newly created document.
     */ PDFDocument.create = function(options) {
        if (options === void 0) options = {};
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var _a, updateMetadata, context, pageTree, pageTreeRef, catalog;
            return (0, $cOQTW.__generator)(this, function(_b) {
                _a = options.updateMetadata, updateMetadata = _a === void 0 ? true : _a;
                context = (0, $kl4jO.default).create();
                pageTree = (0, $4oH3u.default).withContext(context);
                pageTreeRef = context.register(pageTree);
                catalog = (0, $b3l66.default).withContextAndPages(context, pageTreeRef);
                context.trailerInfo.Root = context.register(catalog);
                return [
                    2 /*return*/ ,
                    new PDFDocument(context, false, updateMetadata)
                ];
            });
        });
    };
    /**
     * Register a fontkit instance. This must be done before custom fonts can
     * be embedded. See [here](https://github.com/Hopding/pdf-lib/tree/master#fontkit-installation)
     * for instructions on how to install and register a fontkit instance.
     *
     * > You do **not** need to call this method to embed standard fonts.
     *
     * For example:
     * ```js
     * import { PDFDocument } from 'pdf-lib'
     * import fontkit from '@pdf-lib/fontkit'
     *
     * const pdfDoc = await PDFDocument.create()
     * pdfDoc.registerFontkit(fontkit)
     * ```
     *
     * @param fontkit The fontkit instance to be registered.
     */ PDFDocument.prototype.registerFontkit = function(fontkit) {
        this.fontkit = fontkit;
    };
    /**
     * Get the [[PDFForm]] containing all interactive fields for this document.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const fields = form.getFields()
     * fields.forEach(field => {
     *   const type = field.constructor.name
     *   const name = field.getName()
     *   console.log(`${type}: ${name}`)
     * })
     * ```
     * @returns The form for this document.
     */ PDFDocument.prototype.getForm = function() {
        var form = this.formCache.access();
        if (form.hasXFA()) {
            console.warn('Removing XFA form data as pdf-lib does not support reading or writing XFA');
            form.deleteXFA();
        }
        return form;
    };
    /**
     * Get this document's title metadata. The title appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const title = pdfDoc.getTitle()
     * ```
     * @returns A string containing the title of this document, if it has one.
     */ PDFDocument.prototype.getTitle = function() {
        var title = this.getInfoDict().lookup((0, $dPHSK.default).Title);
        if (!title) return undefined;
        $93b2571d4e1dfe94$var$assertIsLiteralOrHexString(title);
        return title.decodeText();
    };
    /**
     * Get this document's author metadata. The author appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const author = pdfDoc.getAuthor()
     * ```
     * @returns A string containing the author of this document, if it has one.
     */ PDFDocument.prototype.getAuthor = function() {
        var author = this.getInfoDict().lookup((0, $dPHSK.default).Author);
        if (!author) return undefined;
        $93b2571d4e1dfe94$var$assertIsLiteralOrHexString(author);
        return author.decodeText();
    };
    /**
     * Get this document's subject metadata. The subject appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const subject = pdfDoc.getSubject()
     * ```
     * @returns A string containing the subject of this document, if it has one.
     */ PDFDocument.prototype.getSubject = function() {
        var subject = this.getInfoDict().lookup((0, $dPHSK.default).Subject);
        if (!subject) return undefined;
        $93b2571d4e1dfe94$var$assertIsLiteralOrHexString(subject);
        return subject.decodeText();
    };
    /**
     * Get this document's keywords metadata. The keywords appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const keywords = pdfDoc.getKeywords()
     * ```
     * @returns A string containing the keywords of this document, if it has any.
     */ PDFDocument.prototype.getKeywords = function() {
        var keywords = this.getInfoDict().lookup((0, $dPHSK.default).Keywords);
        if (!keywords) return undefined;
        $93b2571d4e1dfe94$var$assertIsLiteralOrHexString(keywords);
        return keywords.decodeText();
    };
    /**
     * Get this document's creator metadata. The creator appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const creator = pdfDoc.getCreator()
     * ```
     * @returns A string containing the creator of this document, if it has one.
     */ PDFDocument.prototype.getCreator = function() {
        var creator = this.getInfoDict().lookup((0, $dPHSK.default).Creator);
        if (!creator) return undefined;
        $93b2571d4e1dfe94$var$assertIsLiteralOrHexString(creator);
        return creator.decodeText();
    };
    /**
     * Get this document's producer metadata. The producer appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const producer = pdfDoc.getProducer()
     * ```
     * @returns A string containing the producer of this document, if it has one.
     */ PDFDocument.prototype.getProducer = function() {
        var producer = this.getInfoDict().lookup((0, $dPHSK.default).Producer);
        if (!producer) return undefined;
        $93b2571d4e1dfe94$var$assertIsLiteralOrHexString(producer);
        return producer.decodeText();
    };
    /**
     * Get this document's creation date metadata. The creation date appears in
     * the "Document Properties" section of most PDF readers. For example:
     * ```js
     * const creationDate = pdfDoc.getCreationDate()
     * ```
     * @returns A Date containing the creation date of this document,
     *          if it has one.
     */ PDFDocument.prototype.getCreationDate = function() {
        var creationDate = this.getInfoDict().lookup((0, $dPHSK.default).CreationDate);
        if (!creationDate) return undefined;
        $93b2571d4e1dfe94$var$assertIsLiteralOrHexString(creationDate);
        return creationDate.decodeDate();
    };
    /**
     * Get this document's modification date metadata. The modification date
     * appears in the "Document Properties" section of most PDF readers.
     * For example:
     * ```js
     * const modification = pdfDoc.getModificationDate()
     * ```
     * @returns A Date containing the modification date of this document,
     *          if it has one.
     */ PDFDocument.prototype.getModificationDate = function() {
        var modificationDate = this.getInfoDict().lookup((0, $dPHSK.default).ModDate);
        if (!modificationDate) return undefined;
        $93b2571d4e1dfe94$var$assertIsLiteralOrHexString(modificationDate);
        return modificationDate.decodeDate();
    };
    /**
     * Set this document's title metadata. The title will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setTitle('🥚 The Life of an Egg 🍳')
     * ```
     *
     * To display the title in the window's title bar, set the
     * `showInWindowTitleBar` option to `true` (works for _most_ PDF readers).
     * For example:
     * ```js
     * pdfDoc.setTitle('🥚 The Life of an Egg 🍳', { showInWindowTitleBar: true })
     * ```
     *
     * @param title The title of this document.
     * @param options The options to be used when setting the title.
     */ PDFDocument.prototype.setTitle = function(title, options) {
        (0, $j0tvB.assertIs)(title, 'title', [
            'string'
        ]);
        var key = (0, $dPHSK.default).of('Title');
        this.getInfoDict().set(key, (0, $jWFiV.default).fromText(title));
        // Indicate that readers should display the title rather than the filename
        if (options === null || options === void 0 ? void 0 : options.showInWindowTitleBar) {
            var prefs = this.catalog.getOrCreateViewerPreferences();
            prefs.setDisplayDocTitle(true);
        }
    };
    /**
     * Set this document's author metadata. The author will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setAuthor('Humpty Dumpty')
     * ```
     * @param author The author of this document.
     */ PDFDocument.prototype.setAuthor = function(author) {
        (0, $j0tvB.assertIs)(author, 'author', [
            'string'
        ]);
        var key = (0, $dPHSK.default).of('Author');
        this.getInfoDict().set(key, (0, $jWFiV.default).fromText(author));
    };
    /**
     * Set this document's subject metadata. The subject will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setSubject('📘 An Epic Tale of Woe 📖')
     * ```
     * @param subject The subject of this document.
     */ PDFDocument.prototype.setSubject = function(subject) {
        (0, $j0tvB.assertIs)(subject, 'author', [
            'string'
        ]);
        var key = (0, $dPHSK.default).of('Subject');
        this.getInfoDict().set(key, (0, $jWFiV.default).fromText(subject));
    };
    /**
     * Set this document's keyword metadata. These keywords will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setKeywords(['eggs', 'wall', 'fall', 'king', 'horses', 'men'])
     * ```
     * @param keywords An array of keywords associated with this document.
     */ PDFDocument.prototype.setKeywords = function(keywords) {
        (0, $j0tvB.assertIs)(keywords, 'keywords', [
            Array
        ]);
        var key = (0, $dPHSK.default).of('Keywords');
        this.getInfoDict().set(key, (0, $jWFiV.default).fromText(keywords.join(' ')));
    };
    /**
     * Set this document's creator metadata. The creator will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setCreator('PDF App 9000 🤖')
     * ```
     * @param creator The creator of this document.
     */ PDFDocument.prototype.setCreator = function(creator) {
        (0, $j0tvB.assertIs)(creator, 'creator', [
            'string'
        ]);
        var key = (0, $dPHSK.default).of('Creator');
        this.getInfoDict().set(key, (0, $jWFiV.default).fromText(creator));
    };
    /**
     * Set this document's producer metadata. The producer will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setProducer('PDF App 9000 🤖')
     * ```
     * @param producer The producer of this document.
     */ PDFDocument.prototype.setProducer = function(producer) {
        (0, $j0tvB.assertIs)(producer, 'creator', [
            'string'
        ]);
        var key = (0, $dPHSK.default).of('Producer');
        this.getInfoDict().set(key, (0, $jWFiV.default).fromText(producer));
    };
    /**
     * Set this document's language metadata. The language will appear in the
     * "Document Properties" section of some PDF readers. For example:
     * ```js
     * pdfDoc.setLanguage('en-us')
     * ```
     *
     * @param language An RFC 3066 _Language-Tag_ denoting the language of this
     *                 document, or an empty string if the language is unknown.
     */ PDFDocument.prototype.setLanguage = function(language) {
        (0, $j0tvB.assertIs)(language, 'language', [
            'string'
        ]);
        var key = (0, $dPHSK.default).of('Lang');
        this.catalog.set(key, (0, $8dCYu.default).of(language));
    };
    /**
     * Set this document's creation date metadata. The creation date will appear
     * in the "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setCreationDate(new Date())
     * ```
     * @param creationDate The date this document was created.
     */ PDFDocument.prototype.setCreationDate = function(creationDate) {
        (0, $j0tvB.assertIs)(creationDate, 'creationDate', [
            [
                Date,
                'Date'
            ]
        ]);
        var key = (0, $dPHSK.default).of('CreationDate');
        this.getInfoDict().set(key, (0, $8dCYu.default).fromDate(creationDate));
    };
    /**
     * Set this document's modification date metadata. The modification date will
     * appear in the "Document Properties" section of most PDF readers. For
     * example:
     * ```js
     * pdfDoc.setModificationDate(new Date())
     * ```
     * @param modificationDate The date this document was last modified.
     */ PDFDocument.prototype.setModificationDate = function(modificationDate) {
        (0, $j0tvB.assertIs)(modificationDate, 'modificationDate', [
            [
                Date,
                'Date'
            ]
        ]);
        var key = (0, $dPHSK.default).of('ModDate');
        this.getInfoDict().set(key, (0, $8dCYu.default).fromDate(modificationDate));
    };
    /**
     * Get the number of pages contained in this document. For example:
     * ```js
     * const totalPages = pdfDoc.getPageCount()
     * ```
     * @returns The number of pages in this document.
     */ PDFDocument.prototype.getPageCount = function() {
        if (this.pageCount === undefined) this.pageCount = this.getPages().length;
        return this.pageCount;
    };
    /**
     * Get an array of all the pages contained in this document. The pages are
     * stored in the array in the same order that they are rendered in the
     * document. For example:
     * ```js
     * const pages = pdfDoc.getPages()
     * pages[0]   // The first page of the document
     * pages[2]   // The third page of the document
     * pages[197] // The 198th page of the document
     * ```
     * @returns An array of all the pages contained in this document.
     */ PDFDocument.prototype.getPages = function() {
        return this.pageCache.access();
    };
    /**
     * Get the page rendered at a particular `index` of the document. For example:
     * ```js
     * pdfDoc.getPage(0)   // The first page of the document
     * pdfDoc.getPage(2)   // The third page of the document
     * pdfDoc.getPage(197) // The 198th page of the document
     * ```
     * @returns The [[PDFPage]] rendered at the given `index` of the document.
     */ PDFDocument.prototype.getPage = function(index) {
        var pages = this.getPages();
        (0, $j0tvB.assertRange)(index, 'index', 0, pages.length - 1);
        return pages[index];
    };
    /**
     * Get an array of indices for all the pages contained in this document. The
     * array will contain a range of integers from
     * `0..pdfDoc.getPageCount() - 1`. For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     * pdfDoc.addPage()
     * pdfDoc.addPage()
     * pdfDoc.addPage()
     *
     * const indices = pdfDoc.getPageIndices()
     * indices // => [0, 1, 2]
     * ```
     * @returns An array of indices for all pages contained in this document.
     */ PDFDocument.prototype.getPageIndices = function() {
        return (0, $4ISq8.range)(0, this.getPageCount());
    };
    /**
     * Remove the page at a given index from this document. For example:
     * ```js
     * pdfDoc.removePage(0)   // Remove the first page of the document
     * pdfDoc.removePage(2)   // Remove the third page of the document
     * pdfDoc.removePage(197) // Remove the 198th page of the document
     * ```
     * Once a page has been removed, it will no longer be rendered at that index
     * in the document.
     * @param index The index of the page to be removed.
     */ PDFDocument.prototype.removePage = function(index) {
        var pageCount = this.getPageCount();
        if (this.pageCount === 0) throw new (0, $aYJvX.RemovePageFromEmptyDocumentError)();
        (0, $j0tvB.assertRange)(index, 'index', 0, pageCount - 1);
        this.catalog.removeLeafNode(index);
        this.pageCount = pageCount - 1;
    };
    /**
     * Add a page to the end of this document. This method accepts three
     * different value types for the `page` parameter:
     *
     * | Type               | Behavior                                                                            |
     * | ------------------ | ----------------------------------------------------------------------------------- |
     * | `undefined`        | Create a new page and add it to the end of this document                            |
     * | `[number, number]` | Create a new page with the given dimensions and add it to the end of this document  |
     * | `PDFPage`          | Add the existing page to the end of this document                                   |
     *
     * For example:
     * ```js
     * // page=undefined
     * const newPage = pdfDoc.addPage()
     *
     * // page=[number, number]
     * import { PageSizes } from 'pdf-lib'
     * const newPage1 = pdfDoc.addPage(PageSizes.A7)
     * const newPage2 = pdfDoc.addPage(PageSizes.Letter)
     * const newPage3 = pdfDoc.addPage([500, 750])
     *
     * // page=PDFPage
     * const pdfDoc1 = await PDFDocument.create()
     * const pdfDoc2 = await PDFDocument.load(...)
     * const [existingPage] = await pdfDoc1.copyPages(pdfDoc2, [0])
     * pdfDoc1.addPage(existingPage)
     * ```
     *
     * @param page Optionally, the desired dimensions or existing page.
     * @returns The newly created (or existing) page.
     */ PDFDocument.prototype.addPage = function(page) {
        (0, $j0tvB.assertIs)(page, 'page', [
            'undefined',
            [
                (0, $eq4Zh.default),
                'PDFPage'
            ],
            Array
        ]);
        return this.insertPage(this.getPageCount(), page);
    };
    /**
     * Insert a page at a given index within this document. This method accepts
     * three different value types for the `page` parameter:
     *
     * | Type               | Behavior                                                                       |
     * | ------------------ | ------------------------------------------------------------------------------ |
     * | `undefined`        | Create a new page and insert it into this document                             |
     * | `[number, number]` | Create a new page with the given dimensions and insert it into this document   |
     * | `PDFPage`          | Insert the existing page into this document                                    |
     *
     * For example:
     * ```js
     * // page=undefined
     * const newPage = pdfDoc.insertPage(2)
     *
     * // page=[number, number]
     * import { PageSizes } from 'pdf-lib'
     * const newPage1 = pdfDoc.insertPage(2, PageSizes.A7)
     * const newPage2 = pdfDoc.insertPage(0, PageSizes.Letter)
     * const newPage3 = pdfDoc.insertPage(198, [500, 750])
     *
     * // page=PDFPage
     * const pdfDoc1 = await PDFDocument.create()
     * const pdfDoc2 = await PDFDocument.load(...)
     * const [existingPage] = await pdfDoc1.copyPages(pdfDoc2, [0])
     * pdfDoc1.insertPage(0, existingPage)
     * ```
     *
     * @param index The index at which the page should be inserted (zero-based).
     * @param page Optionally, the desired dimensions or existing page.
     * @returns The newly created (or existing) page.
     */ PDFDocument.prototype.insertPage = function(index, page) {
        var pageCount = this.getPageCount();
        (0, $j0tvB.assertRange)(index, 'index', 0, pageCount);
        (0, $j0tvB.assertIs)(page, 'page', [
            'undefined',
            [
                (0, $eq4Zh.default),
                'PDFPage'
            ],
            Array
        ]);
        if (!page || Array.isArray(page)) {
            var dims = Array.isArray(page) ? page : (0, $gjdfV.PageSizes).A4;
            page = (0, $eq4Zh.default).create(this);
            page.setSize.apply(page, dims);
        } else if (page.doc !== this) throw new (0, $aYJvX.ForeignPageError)();
        var parentRef = this.catalog.insertLeafNode(page.ref, index);
        page.node.setParent(parentRef);
        this.pageMap.set(page.node, page);
        this.pageCache.invalidate();
        this.pageCount = pageCount + 1;
        return page;
    };
    /**
     * Copy pages from a source document into this document. Allows pages to be
     * copied between different [[PDFDocument]] instances. For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     * const srcDoc = await PDFDocument.load(...)
     *
     * const copiedPages = await pdfDoc.copyPages(srcDoc, [0, 3, 89])
     * const [firstPage, fourthPage, ninetiethPage] = copiedPages;
     *
     * pdfDoc.addPage(fourthPage)
     * pdfDoc.insertPage(0, ninetiethPage)
     * pdfDoc.addPage(firstPage)
     * ```
     * @param srcDoc The document from which pages should be copied.
     * @param indices The indices of the pages that should be copied.
     * @returns Resolves with an array of pages copied into this document.
     */ PDFDocument.prototype.copyPages = function(srcDoc, indices) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var copier, srcPages, copiedPages, idx, len, srcPage, copiedPage, ref;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        (0, $j0tvB.assertIs)(srcDoc, 'srcDoc', [
                            [
                                PDFDocument,
                                'PDFDocument'
                            ]
                        ]);
                        (0, $j0tvB.assertIs)(indices, 'indices', [
                            Array
                        ]);
                        return [
                            4 /*yield*/ ,
                            srcDoc.flush()
                        ];
                    case 1:
                        _a.sent();
                        copier = (0, $k5Uzj.default).for(srcDoc.context, this.context);
                        srcPages = srcDoc.getPages();
                        copiedPages = new Array(indices.length);
                        for(idx = 0, len = indices.length; idx < len; idx++){
                            srcPage = srcPages[indices[idx]];
                            copiedPage = copier.copy(srcPage.node);
                            ref = this.context.register(copiedPage);
                            copiedPages[idx] = (0, $eq4Zh.default).of(copiedPage, ref, this);
                        }
                        return [
                            2 /*return*/ ,
                            copiedPages
                        ];
                }
            });
        });
    };
    /**
     * Get a copy of this document.
     *
     * For example:
     * ```js
     * const srcDoc = await PDFDocument.load(...)
     * const pdfDoc = await srcDoc.copy()
     * ```
     *
     * > **NOTE:**  This method won't copy all information over to the new
     * > document (acroforms, outlines, etc...).
     *
     * @returns Resolves with a copy this document.
     */ PDFDocument.prototype.copy = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var pdfCopy, contentPages, idx, len;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            PDFDocument.create()
                        ];
                    case 1:
                        pdfCopy = _a.sent();
                        return [
                            4 /*yield*/ ,
                            pdfCopy.copyPages(this, this.getPageIndices())
                        ];
                    case 2:
                        contentPages = _a.sent();
                        for(idx = 0, len = contentPages.length; idx < len; idx++)pdfCopy.addPage(contentPages[idx]);
                        if (this.getAuthor() !== undefined) pdfCopy.setAuthor(this.getAuthor());
                        if (this.getCreationDate() !== undefined) pdfCopy.setCreationDate(this.getCreationDate());
                        if (this.getCreator() !== undefined) pdfCopy.setCreator(this.getCreator());
                        if (this.getModificationDate() !== undefined) pdfCopy.setModificationDate(this.getModificationDate());
                        if (this.getProducer() !== undefined) pdfCopy.setProducer(this.getProducer());
                        if (this.getSubject() !== undefined) pdfCopy.setSubject(this.getSubject());
                        if (this.getTitle() !== undefined) pdfCopy.setTitle(this.getTitle());
                        pdfCopy.defaultWordBreaks = this.defaultWordBreaks;
                        return [
                            2 /*return*/ ,
                            pdfCopy
                        ];
                }
            });
        });
    };
    /**
     * Add JavaScript to this document. The supplied `script` is executed when the
     * document is opened. The `script` can be used to perform some operation
     * when the document is opened (e.g. logging to the console), or it can be
     * used to define a function that can be referenced later in a JavaScript
     * action. For example:
     * ```js
     * // Show "Hello World!" in the console when the PDF is opened
     * pdfDoc.addJavaScript(
     *   'main',
     *   'console.show(); console.println("Hello World!");'
     * );
     *
     * // Define a function named "foo" that can be called in JavaScript Actions
     * pdfDoc.addJavaScript(
     *   'foo',
     *   'function foo() { return "foo"; }'
     * );
     * ```
     * See the [JavaScript for Acrobat API Reference](https://www.adobe.com/content/dam/acom/en/devnet/acrobat/pdfs/js_api_reference.pdf)
     * for details.
     * @param name The name of the script. Must be unique per document.
     * @param script The JavaScript to execute.
     */ PDFDocument.prototype.addJavaScript = function(name, script) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        (0, $j0tvB.assertIs)(script, 'script', [
            'string'
        ]);
        var embedder = (0, $8gnuI.default).for(script, name);
        var ref = this.context.nextRef();
        var javaScript = (0, $ceWew.default).of(ref, this, embedder);
        this.javaScripts.push(javaScript);
    };
    /**
     * Add an attachment to this document. Attachments are visible in the
     * "Attachments" panel of Adobe Acrobat and some other PDF readers. Any
     * type of file can be added as an attachment. This includes, but is not
     * limited to, `.png`, `.jpg`, `.pdf`, `.csv`, `.docx`, and `.xlsx` files.
     *
     * The input data can be provided in multiple formats:
     *
     * | Type          | Contents                                                       |
     * | ------------- | -------------------------------------------------------------- |
     * | `string`      | A base64 encoded string (or data URI) containing an attachment |
     * | `Uint8Array`  | The raw bytes of an attachment                                 |
     * | `ArrayBuffer` | The raw bytes of an attachment                                 |
     *
     * For example:
     * ```js
     * // attachment=string
     * await pdfDoc.attach('/9j/4AAQSkZJRgABAQAAAQABAAD/2wBD...', 'cat_riding_unicorn.jpg', {
     *   mimeType: 'image/jpeg',
     *   description: 'Cool cat riding a unicorn! 🦄🐈🕶️',
     *   creationDate: new Date('2019/12/01'),
     *   modificationDate: new Date('2020/04/19'),
     * })
     * await pdfDoc.attach('data:image/jpeg;base64,/9j/4AAQ...', 'cat_riding_unicorn.jpg', {
     *   mimeType: 'image/jpeg',
     *   description: 'Cool cat riding a unicorn! 🦄🐈🕶️',
     *   creationDate: new Date('2019/12/01'),
     *   modificationDate: new Date('2020/04/19'),
     * })
     *
     * // attachment=Uint8Array
     * import fs from 'fs'
     * const uint8Array = fs.readFileSync('cat_riding_unicorn.jpg')
     * await pdfDoc.attach(uint8Array, 'cat_riding_unicorn.jpg', {
     *   mimeType: 'image/jpeg',
     *   description: 'Cool cat riding a unicorn! 🦄🐈🕶️',
     *   creationDate: new Date('2019/12/01'),
     *   modificationDate: new Date('2020/04/19'),
     * })
     *
     * // attachment=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/cat_riding_unicorn.jpg'
     * const arrayBuffer = await fetch(url).then(res => res.arrayBuffer())
     * await pdfDoc.attach(arrayBuffer, 'cat_riding_unicorn.jpg', {
     *   mimeType: 'image/jpeg',
     *   description: 'Cool cat riding a unicorn! 🦄🐈🕶️',
     *   creationDate: new Date('2019/12/01'),
     *   modificationDate: new Date('2020/04/19'),
     * })
     * ```
     *
     * @param attachment The input data containing the file to be attached.
     * @param name The name of the file to be attached.
     * @returns Resolves when the attachment is complete.
     */ PDFDocument.prototype.attach = function(attachment, name, options) {
        if (options === void 0) options = {};
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var bytes, embedder, ref, embeddedFile;
            return (0, $cOQTW.__generator)(this, function(_a) {
                (0, $j0tvB.assertIs)(attachment, 'attachment', [
                    'string',
                    Uint8Array,
                    ArrayBuffer
                ]);
                (0, $j0tvB.assertIs)(name, 'name', [
                    'string'
                ]);
                (0, $j0tvB.assertOrUndefined)(options.mimeType, 'mimeType', [
                    'string'
                ]);
                (0, $j0tvB.assertOrUndefined)(options.description, 'description', [
                    'string'
                ]);
                (0, $j0tvB.assertOrUndefined)(options.creationDate, 'options.creationDate', [
                    Date
                ]);
                (0, $j0tvB.assertOrUndefined)(options.modificationDate, 'options.modificationDate', [
                    Date
                ]);
                (0, $j0tvB.assertIsOneOfOrUndefined)(options.afRelationship, 'options.afRelationship', (0, $k8kub.AFRelationship));
                bytes = (0, $4ISq8.toUint8Array)(attachment);
                embedder = (0, $k8kub.default).for(bytes, name, options);
                ref = this.context.nextRef();
                embeddedFile = (0, $C6azw.default).of(ref, this, embedder);
                this.embeddedFiles.push(embeddedFile);
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * Embed a font into this document. The input data can be provided in multiple
     * formats:
     *
     * | Type            | Contents                                                |
     * | --------------- | ------------------------------------------------------- |
     * | `StandardFonts` | One of the standard 14 fonts                            |
     * | `string`        | A base64 encoded string (or data URI) containing a font |
     * | `Uint8Array`    | The raw bytes of a font                                 |
     * | `ArrayBuffer`   | The raw bytes of a font                                 |
     *
     * For example:
     * ```js
     * // font=StandardFonts
     * import { StandardFonts } from 'pdf-lib'
     * const font1 = await pdfDoc.embedFont(StandardFonts.Helvetica)
     *
     * // font=string
     * const font2 = await pdfDoc.embedFont('AAEAAAAVAQAABABQRFNJRx/upe...')
     * const font3 = await pdfDoc.embedFont('data:font/opentype;base64,AAEAAA...')
     *
     * // font=Uint8Array
     * import fs from 'fs'
     * const font4 = await pdfDoc.embedFont(fs.readFileSync('Ubuntu-R.ttf'))
     *
     * // font=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/ubuntu/Ubuntu-R.ttf'
     * const ubuntuBytes = await fetch(url).then(res => res.arrayBuffer())
     * const font5 = await pdfDoc.embedFont(ubuntuBytes)
     * ```
     * See also: [[registerFontkit]]
     * @param font The input data for a font.
     * @param options The options to be used when embedding the font.
     * @returns Resolves with the embedded font.
     */ PDFDocument.prototype.embedFont = function(font, options) {
        if (options === void 0) options = {};
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var _a, subset, customName, features, embedder, bytes, fontkit, _b, ref, pdfFont;
            return (0, $cOQTW.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _a = options.subset, subset = _a === void 0 ? false : _a, customName = options.customName, features = options.features;
                        (0, $j0tvB.assertIs)(font, 'font', [
                            'string',
                            Uint8Array,
                            ArrayBuffer
                        ]);
                        (0, $j0tvB.assertIs)(subset, 'subset', [
                            'boolean'
                        ]);
                        if (!(0, $cbIAG.isStandardFont)(font)) return [
                            3 /*break*/ ,
                            1
                        ];
                        embedder = (0, $jwvE5.default).for(font, customName);
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 1:
                        if (!(0, $4ISq8.canBeConvertedToUint8Array)(font)) return [
                            3 /*break*/ ,
                            6
                        ];
                        bytes = (0, $4ISq8.toUint8Array)(font);
                        fontkit = this.assertFontkit();
                        if (!subset) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $6uXKX.default).for(fontkit, bytes, customName, features)
                        ];
                    case 2:
                        _b = _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        return [
                            4 /*yield*/ ,
                            (0, $gCJZ9.default).for(fontkit, bytes, customName, features)
                        ];
                    case 4:
                        _b = _c.sent();
                        _c.label = 5;
                    case 5:
                        embedder = _b;
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        throw new TypeError('`font` must be one of `StandardFonts | string | Uint8Array | ArrayBuffer`');
                    case 7:
                        ref = this.context.nextRef();
                        pdfFont = (0, $lzaL9.default).of(ref, this, embedder);
                        this.fonts.push(pdfFont);
                        return [
                            2 /*return*/ ,
                            pdfFont
                        ];
                }
            });
        });
    };
    /**
     * Embed a standard font into this document.
     * For example:
     * ```js
     * import { StandardFonts } from 'pdf-lib'
     * const helveticaFont = pdfDoc.embedFont(StandardFonts.Helvetica)
     * ```
     * @param font The standard font to be embedded.
     * @param customName The name to be used when embedding the font.
     * @returns The embedded font.
     */ PDFDocument.prototype.embedStandardFont = function(font, customName) {
        (0, $j0tvB.assertIs)(font, 'font', [
            'string'
        ]);
        if (!(0, $cbIAG.isStandardFont)(font)) throw new TypeError('`font` must be one of type `StandardFonts`');
        var embedder = (0, $jwvE5.default).for(font, customName);
        var ref = this.context.nextRef();
        var pdfFont = (0, $lzaL9.default).of(ref, this, embedder);
        this.fonts.push(pdfFont);
        return pdfFont;
    };
    /**
     * Embed a JPEG image into this document. The input data can be provided in
     * multiple formats:
     *
     * | Type          | Contents                                                      |
     * | ------------- | ------------------------------------------------------------- |
     * | `string`      | A base64 encoded string (or data URI) containing a JPEG image |
     * | `Uint8Array`  | The raw bytes of a JPEG image                                 |
     * | `ArrayBuffer` | The raw bytes of a JPEG image                                 |
     *
     * For example:
     * ```js
     * // jpg=string
     * const image1 = await pdfDoc.embedJpg('/9j/4AAQSkZJRgABAQAAAQABAAD/2wBD...')
     * const image2 = await pdfDoc.embedJpg('data:image/jpeg;base64,/9j/4AAQ...')
     *
     * // jpg=Uint8Array
     * import fs from 'fs'
     * const uint8Array = fs.readFileSync('cat_riding_unicorn.jpg')
     * const image3 = await pdfDoc.embedJpg(uint8Array)
     *
     * // jpg=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/cat_riding_unicorn.jpg'
     * const arrayBuffer = await fetch(url).then(res => res.arrayBuffer())
     * const image4 = await pdfDoc.embedJpg(arrayBuffer)
     * ```
     *
     * @param jpg The input data for a JPEG image.
     * @returns Resolves with the embedded image.
     */ PDFDocument.prototype.embedJpg = function(jpg) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var bytes, embedder, ref, pdfImage;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        (0, $j0tvB.assertIs)(jpg, 'jpg', [
                            'string',
                            Uint8Array,
                            ArrayBuffer
                        ]);
                        bytes = (0, $4ISq8.toUint8Array)(jpg);
                        return [
                            4 /*yield*/ ,
                            (0, $fmxHr.default).for(bytes)
                        ];
                    case 1:
                        embedder = _a.sent();
                        ref = this.context.nextRef();
                        pdfImage = (0, $7F2yc.default).of(ref, this, embedder);
                        this.images.push(pdfImage);
                        return [
                            2 /*return*/ ,
                            pdfImage
                        ];
                }
            });
        });
    };
    /**
     * Embed a PNG image into this document. The input data can be provided in
     * multiple formats:
     *
     * | Type          | Contents                                                     |
     * | ------------- | ------------------------------------------------------------ |
     * | `string`      | A base64 encoded string (or data URI) containing a PNG image |
     * | `Uint8Array`  | The raw bytes of a PNG image                                 |
     * | `ArrayBuffer` | The raw bytes of a PNG image                                 |
     *
     * For example:
     * ```js
     * // png=string
     * const image1 = await pdfDoc.embedPng('iVBORw0KGgoAAAANSUhEUgAAAlgAAAF3...')
     * const image2 = await pdfDoc.embedPng('data:image/png;base64,iVBORw0KGg...')
     *
     * // png=Uint8Array
     * import fs from 'fs'
     * const uint8Array = fs.readFileSync('small_mario.png')
     * const image3 = await pdfDoc.embedPng(uint8Array)
     *
     * // png=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/small_mario.png'
     * const arrayBuffer = await fetch(url).then(res => res.arrayBuffer())
     * const image4 = await pdfDoc.embedPng(arrayBuffer)
     * ```
     *
     * @param png The input data for a PNG image.
     * @returns Resolves with the embedded image.
     */ PDFDocument.prototype.embedPng = function(png) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var bytes, embedder, ref, pdfImage;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        (0, $j0tvB.assertIs)(png, 'png', [
                            'string',
                            Uint8Array,
                            ArrayBuffer
                        ]);
                        bytes = (0, $4ISq8.toUint8Array)(png);
                        return [
                            4 /*yield*/ ,
                            (0, $atfwl.default).for(bytes)
                        ];
                    case 1:
                        embedder = _a.sent();
                        ref = this.context.nextRef();
                        pdfImage = (0, $7F2yc.default).of(ref, this, embedder);
                        this.images.push(pdfImage);
                        return [
                            2 /*return*/ ,
                            pdfImage
                        ];
                }
            });
        });
    };
    /**
     * Embed one or more PDF pages into this document.
     *
     * For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     *
     * const sourcePdfUrl = 'https://pdf-lib.js.org/assets/with_large_page_count.pdf'
     * const sourcePdf = await fetch(sourcePdfUrl).then((res) => res.arrayBuffer())
     *
     * // Embed page 74 of `sourcePdf` into `pdfDoc`
     * const [embeddedPage] = await pdfDoc.embedPdf(sourcePdf, [73])
     * ```
     *
     * See [[PDFDocument.load]] for examples of the allowed input data formats.
     *
     * @param pdf The input data containing a PDF document.
     * @param indices The indices of the pages that should be embedded.
     * @returns Resolves with an array of the embedded pages.
     */ PDFDocument.prototype.embedPdf = function(pdf, indices) {
        if (indices === void 0) indices = [
            0
        ];
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var srcDoc, _a, srcPages;
            return (0, $cOQTW.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        (0, $j0tvB.assertIs)(pdf, 'pdf', [
                            'string',
                            Uint8Array,
                            ArrayBuffer,
                            [
                                PDFDocument,
                                'PDFDocument'
                            ]
                        ]);
                        (0, $j0tvB.assertIs)(indices, 'indices', [
                            Array
                        ]);
                        if (!(pdf instanceof PDFDocument)) return [
                            3 /*break*/ ,
                            1
                        ];
                        _a = pdf;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            PDFDocument.load(pdf)
                        ];
                    case 2:
                        _a = _b.sent();
                        _b.label = 3;
                    case 3:
                        srcDoc = _a;
                        srcPages = (0, $4ISq8.pluckIndices)(srcDoc.getPages(), indices);
                        return [
                            2 /*return*/ ,
                            this.embedPages(srcPages)
                        ];
                }
            });
        });
    };
    /**
     * Embed a single PDF page into this document.
     *
     * For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     *
     * const sourcePdfUrl = 'https://pdf-lib.js.org/assets/with_large_page_count.pdf'
     * const sourceBuffer = await fetch(sourcePdfUrl).then((res) => res.arrayBuffer())
     * const sourcePdfDoc = await PDFDocument.load(sourceBuffer)
     * const sourcePdfPage = sourcePdfDoc.getPages()[73]
     *
     * const embeddedPage = await pdfDoc.embedPage(
     *   sourcePdfPage,
     *
     *   // Clip a section of the source page so that we only embed part of it
     *   { left: 100, right: 450, bottom: 330, top: 570 },
     *
     *   // Translate all drawings of the embedded page by (10, 200) units
     *   [1, 0, 0, 1, 10, 200],
     * )
     * ```
     *
     * @param page The page to be embedded.
     * @param boundingBox
     * Optionally, an area of the source page that should be embedded
     * (defaults to entire page).
     * @param transformationMatrix
     * Optionally, a transformation matrix that is always applied to the embedded
     * page anywhere it is drawn.
     * @returns Resolves with the embedded pdf page.
     */ PDFDocument.prototype.embedPage = function(page, boundingBox, transformationMatrix) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var embeddedPage;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        (0, $j0tvB.assertIs)(page, 'page', [
                            [
                                (0, $eq4Zh.default),
                                'PDFPage'
                            ]
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.embedPages([
                                page
                            ], [
                                boundingBox
                            ], [
                                transformationMatrix
                            ])
                        ];
                    case 1:
                        embeddedPage = _a.sent()[0];
                        return [
                            2 /*return*/ ,
                            embeddedPage
                        ];
                }
            });
        });
    };
    /**
     * Embed one or more PDF pages into this document.
     *
     * For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     *
     * const sourcePdfUrl = 'https://pdf-lib.js.org/assets/with_large_page_count.pdf'
     * const sourceBuffer = await fetch(sourcePdfUrl).then((res) => res.arrayBuffer())
     * const sourcePdfDoc = await PDFDocument.load(sourceBuffer)
     *
     * const page1 = sourcePdfDoc.getPages()[0]
     * const page2 = sourcePdfDoc.getPages()[52]
     * const page3 = sourcePdfDoc.getPages()[73]
     *
     * const embeddedPages = await pdfDoc.embedPages([page1, page2, page3])
     * ```
     *
     * @param page
     * The pages to be embedded (they must all share the same context).
     * @param boundingBoxes
     * Optionally, an array of clipping boundaries - one for each page
     * (defaults to entirety of each page).
     * @param transformationMatrices
     * Optionally, an array of transformation matrices - one for each page
     * (each page's transformation will apply anywhere it is drawn).
     * @returns Resolves with an array of the embedded pdf pages.
     */ PDFDocument.prototype.embedPages = function(pages, boundingBoxes, transformationMatrices) {
        if (boundingBoxes === void 0) boundingBoxes = [];
        if (transformationMatrices === void 0) transformationMatrices = [];
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var idx, len, currPage, nextPage, context, maybeCopyPage, embeddedPages, idx, len, page, box, matrix, embedder, ref;
            var _a;
            return (0, $cOQTW.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (pages.length === 0) return [
                            2 /*return*/ ,
                            []
                        ];
                        // Assert all pages have the same context
                        for(idx = 0, len = pages.length - 1; idx < len; idx++){
                            currPage = pages[idx];
                            nextPage = pages[idx + 1];
                            if (currPage.node.context !== nextPage.node.context) throw new (0, $nAWRe.PageEmbeddingMismatchedContextError)();
                        }
                        context = pages[0].node.context;
                        maybeCopyPage = context === this.context ? function(p) {
                            return p;
                        } : (0, $k5Uzj.default).for(context, this.context).copy;
                        embeddedPages = new Array(pages.length);
                        idx = 0, len = pages.length;
                        _b.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            4
                        ];
                        page = maybeCopyPage(pages[idx].node);
                        box = boundingBoxes[idx];
                        matrix = transformationMatrices[idx];
                        return [
                            4 /*yield*/ ,
                            (0, $h9IbG.default).for(page, box, matrix)
                        ];
                    case 2:
                        embedder = _b.sent();
                        ref = this.context.nextRef();
                        embeddedPages[idx] = (0, $kUs6q.default).of(ref, this, embedder);
                        _b.label = 3;
                    case 3:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        (_a = this.embeddedPages).push.apply(_a, embeddedPages);
                        return [
                            2 /*return*/ ,
                            embeddedPages
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You shouldn't need to call this method directly. The [[save]]
     * > and [[saveAsBase64]] methods will automatically ensure that all embedded
     * > assets are flushed before serializing the document.
     *
     * Flush all embedded fonts, PDF pages, and images to this document's
     * [[context]].
     *
     * @returns Resolves when the flush is complete.
     */ PDFDocument.prototype.flush = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.fonts)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.images)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.embeddedPages)
                        ];
                    case 3:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.embeddedFiles)
                        ];
                    case 4:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.javaScripts)
                        ];
                    case 5:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Serialize this document to an array of bytes making up a PDF file.
     * For example:
     * ```js
     * const pdfBytes = await pdfDoc.save()
     * ```
     *
     * There are a number of things you can do with the serialized document,
     * depending on the JavaScript environment you're running in:
     * * Write it to a file in Node or React Native
     * * Download it as a Blob in the browser
     * * Render it in an `iframe`
     *
     * @param options The options to be used when saving the document.
     * @returns Resolves with the bytes of the serialized document.
     */ PDFDocument.prototype.save = function(options) {
        if (options === void 0) options = {};
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var _a, useObjectStreams, _b, addDefaultPage, _c, objectsPerTick, _d, updateFieldAppearances, form, Writer;
            return (0, $cOQTW.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _a = options.useObjectStreams, useObjectStreams = _a === void 0 ? true : _a, _b = options.addDefaultPage, addDefaultPage = _b === void 0 ? true : _b, _c = options.objectsPerTick, objectsPerTick = _c === void 0 ? 50 : _c, _d = options.updateFieldAppearances, updateFieldAppearances = _d === void 0 ? true : _d;
                        (0, $j0tvB.assertIs)(useObjectStreams, 'useObjectStreams', [
                            'boolean'
                        ]);
                        (0, $j0tvB.assertIs)(addDefaultPage, 'addDefaultPage', [
                            'boolean'
                        ]);
                        (0, $j0tvB.assertIs)(objectsPerTick, 'objectsPerTick', [
                            'number'
                        ]);
                        (0, $j0tvB.assertIs)(updateFieldAppearances, 'updateFieldAppearances', [
                            'boolean'
                        ]);
                        if (addDefaultPage && this.getPageCount() === 0) this.addPage();
                        if (updateFieldAppearances) {
                            form = this.formCache.getValue();
                            if (form) form.updateFieldAppearances();
                        }
                        return [
                            4 /*yield*/ ,
                            this.flush()
                        ];
                    case 1:
                        _e.sent();
                        Writer = useObjectStreams ? (0, $7YdvF.default) : (0, $5HlMk.default);
                        return [
                            2 /*return*/ ,
                            Writer.forContext(this.context, objectsPerTick).serializeToBuffer()
                        ];
                }
            });
        });
    };
    /**
     * Serialize this document to a base64 encoded string or data URI making up a
     * PDF file. For example:
     * ```js
     * const base64String = await pdfDoc.saveAsBase64()
     * base64String // => 'JVBERi0xLjcKJYGBgYEKC...'
     *
     * const base64DataUri = await pdfDoc.saveAsBase64({ dataUri: true })
     * base64DataUri // => 'data:application/pdf;base64,JVBERi0xLjcKJYGBgYEKC...'
     * ```
     *
     * @param options The options to be used when saving the document.
     * @returns Resolves with a base64 encoded string or data URI of the
     *          serialized document.
     */ PDFDocument.prototype.saveAsBase64 = function(options) {
        if (options === void 0) options = {};
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var _a, dataUri, otherOptions, bytes, base64;
            return (0, $cOQTW.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = options.dataUri, dataUri = _a === void 0 ? false : _a, otherOptions = (0, $cOQTW.__rest)(options, [
                            "dataUri"
                        ]);
                        (0, $j0tvB.assertIs)(dataUri, 'dataUri', [
                            'boolean'
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.save(otherOptions)
                        ];
                    case 1:
                        bytes = _b.sent();
                        base64 = (0, $fZ8o5.encodeToBase64)(bytes);
                        return [
                            2 /*return*/ ,
                            dataUri ? "data:application/pdf;base64," + base64 : base64
                        ];
                }
            });
        });
    };
    PDFDocument.prototype.findPageForAnnotationRef = function(ref) {
        var pages = this.getPages();
        for(var idx = 0, len = pages.length; idx < len; idx++){
            var page = pages[idx];
            var annotations = page.node.Annots();
            if ((annotations === null || annotations === void 0 ? void 0 : annotations.indexOf(ref)) !== undefined) return page;
        }
        return undefined;
    };
    PDFDocument.prototype.embedAll = function(embeddables) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var idx, len;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        idx = 0, len = embeddables.length;
                        _a.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            embeddables[idx].embed()
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    PDFDocument.prototype.updateInfoDict = function() {
        var pdfLib = "pdf-lib (https://github.com/Hopding/pdf-lib)";
        var now = new Date();
        var info = this.getInfoDict();
        this.setProducer(pdfLib);
        this.setModificationDate(now);
        if (!info.get((0, $dPHSK.default).of('Creator'))) this.setCreator(pdfLib);
        if (!info.get((0, $dPHSK.default).of('CreationDate'))) this.setCreationDate(now);
    };
    PDFDocument.prototype.getInfoDict = function() {
        var existingInfo = this.context.lookup(this.context.trailerInfo.Info);
        if (existingInfo instanceof (0, $brir8.default)) return existingInfo;
        var newInfo = this.context.obj({});
        this.context.trailerInfo.Info = this.context.register(newInfo);
        return newInfo;
    };
    PDFDocument.prototype.assertFontkit = function() {
        if (!this.fontkit) throw new (0, $aYJvX.FontkitNotRegisteredError)();
        return this.fontkit;
    };
    return PDFDocument;
}();
var $93b2571d4e1dfe94$export$2e2bcd8739ae039 = $93b2571d4e1dfe94$var$PDFDocument;
/* tslint:disable-next-line only-arrow-functions */ function $93b2571d4e1dfe94$var$assertIsLiteralOrHexString(pdfObject) {
    if (!(pdfObject instanceof (0, $jWFiV.default)) && !(pdfObject instanceof (0, $8dCYu.default))) throw new (0, $nAWRe.UnexpectedObjectTypeError)([
        (0, $jWFiV.default),
        (0, $8dCYu.default)
    ], pdfObject);
}

});
parcelRegister("kUs6q", function(module, exports) {

$parcel$export(module.exports, "default", () => $f38ed62eeee08801$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $cGbw3 = parcelRequire("cGbw3");
parcelRequire("iT7lj");
var $h9IbG = parcelRequire("h9IbG");
var $kHzkO = parcelRequire("kHzkO");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
/**
 * Represents a PDF page that has been embedded in a [[PDFDocument]].
 */ var $f38ed62eeee08801$var$PDFEmbeddedPage = /** @class */ function() {
    function PDFEmbeddedPage(ref, doc, embedder) {
        this.alreadyEmbedded = false;
        (0, $j0tvB.assertIs)(ref, 'ref', [
            [
                (0, $kHzkO.default),
                'PDFRef'
            ]
        ]);
        (0, $j0tvB.assertIs)(doc, 'doc', [
            [
                (0, $cGbw3.default),
                'PDFDocument'
            ]
        ]);
        (0, $j0tvB.assertIs)(embedder, 'embedder', [
            [
                (0, $h9IbG.default),
                'PDFPageEmbedder'
            ]
        ]);
        this.ref = ref;
        this.doc = doc;
        this.width = embedder.width;
        this.height = embedder.height;
        this.embedder = embedder;
    }
    /**
     * Compute the width and height of this page after being scaled by the
     * given `factor`. For example:
     * ```js
     * embeddedPage.width  // => 500
     * embeddedPage.height // => 250
     *
     * const scaled = embeddedPage.scale(0.5)
     * scaled.width  // => 250
     * scaled.height // => 125
     * ```
     * This operation is often useful before drawing a page with
     * [[PDFPage.drawPage]] to compute the `width` and `height` options.
     * @param factor The factor by which this page should be scaled.
     * @returns The width and height of the page after being scaled.
     */ PDFEmbeddedPage.prototype.scale = function(factor) {
        (0, $j0tvB.assertIs)(factor, 'factor', [
            'number'
        ]);
        return {
            width: this.width * factor,
            height: this.height * factor
        };
    };
    /**
     * Get the width and height of this page. For example:
     * ```js
     * const { width, height } = embeddedPage.size()
     * ```
     * @returns The width and height of the page.
     */ PDFEmbeddedPage.prototype.size = function() {
        return this.scale(1);
    };
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all embeddable pages get embedded.
     *
     * Embed this embeddable page in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFEmbeddedPage.prototype.embed = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.alreadyEmbedded) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.embedder.embedIntoContext(this.doc.context, this.ref)
                        ];
                    case 1:
                        _a.sent();
                        this.alreadyEmbedded = true;
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.embedPdf]] and
     * > [[PDFDocument.embedPage]] methods, which will create instances of
     * > [[PDFEmbeddedPage]] for you.
     *
     * Create an instance of [[PDFEmbeddedPage]] from an existing ref and embedder
     *
     * @param ref The unique reference for this embedded page.
     * @param doc The document to which the embedded page will belong.
     * @param embedder The embedder that will be used to embed the page.
     */ PDFEmbeddedPage.of = function(ref, doc, embedder) {
        return new PDFEmbeddedPage(ref, doc, embedder);
    };
    return PDFEmbeddedPage;
}();
var $f38ed62eeee08801$export$2e2bcd8739ae039 = $f38ed62eeee08801$var$PDFEmbeddedPage;

});

parcelRegister("lzaL9", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb353673e42bee9b$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $cGbw3 = parcelRequire("cGbw3");
parcelRequire("iT7lj");
var $gCJZ9 = parcelRequire("gCJZ9");
var $kHzkO = parcelRequire("kHzkO");
var $jwvE5 = parcelRequire("jwvE5");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
/**
 * Represents a font that has been embedded in a [[PDFDocument]].
 */ var $fb353673e42bee9b$var$PDFFont = /** @class */ function() {
    function PDFFont(ref, doc, embedder) {
        this.modified = true;
        (0, $j0tvB.assertIs)(ref, 'ref', [
            [
                (0, $kHzkO.default),
                'PDFRef'
            ]
        ]);
        (0, $j0tvB.assertIs)(doc, 'doc', [
            [
                (0, $cGbw3.default),
                'PDFDocument'
            ]
        ]);
        (0, $j0tvB.assertIs)(embedder, 'embedder', [
            [
                (0, $gCJZ9.default),
                'CustomFontEmbedder'
            ],
            [
                (0, $jwvE5.default),
                'StandardFontEmbedder'
            ]
        ]);
        this.ref = ref;
        this.doc = doc;
        this.name = embedder.fontName;
        this.embedder = embedder;
    }
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFPage.drawText]] method will automatically encode the text it is
     * > given.
     *
     * Encodes a string of text in this font.
     *
     * @param text The text to be encoded.
     * @returns The encoded text as a hex string.
     */ PDFFont.prototype.encodeText = function(text) {
        (0, $j0tvB.assertIs)(text, 'text', [
            'string'
        ]);
        this.modified = true;
        return this.embedder.encodeText(text);
    };
    /**
     * Measure the width of a string of text drawn in this font at a given size.
     * For example:
     * ```js
     * const width = font.widthOfTextAtSize('Foo Bar Qux Baz', 36)
     * ```
     * @param text The string of text to be measured.
     * @param size The font size to be used for this measurement.
     * @returns The width of the string of text when drawn in this font at the
     *          given size.
     */ PDFFont.prototype.widthOfTextAtSize = function(text, size) {
        (0, $j0tvB.assertIs)(text, 'text', [
            'string'
        ]);
        (0, $j0tvB.assertIs)(size, 'size', [
            'number'
        ]);
        return this.embedder.widthOfTextAtSize(text, size);
    };
    /**
     * Measure the height of this font at a given size. For example:
     * ```js
     * const height = font.heightAtSize(24)
     * ```
     *
     * The `options.descender` value controls whether or not the font's
     * descender is included in the height calculation.
     *
     * @param size The font size to be used for this measurement.
     * @param options The options to be used when computing this measurement.
     * @returns The height of this font at the given size.
     */ PDFFont.prototype.heightAtSize = function(size, options) {
        var _a;
        (0, $j0tvB.assertIs)(size, 'size', [
            'number'
        ]);
        (0, $j0tvB.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.descender, 'options.descender', [
            'boolean'
        ]);
        return this.embedder.heightOfFontAtSize(size, {
            descender: (_a = options === null || options === void 0 ? void 0 : options.descender) !== null && _a !== void 0 ? _a : true
        });
    };
    /**
     * Compute the font size at which this font is a given height. For example:
     * ```js
     * const fontSize = font.sizeAtHeight(12)
     * ```
     * @param height The height to be used for this calculation.
     * @returns The font size at which this font is the given height.
     */ PDFFont.prototype.sizeAtHeight = function(height) {
        (0, $j0tvB.assertIs)(height, 'height', [
            'number'
        ]);
        return this.embedder.sizeOfFontAtHeight(height);
    };
    /**
     * Get the set of unicode code points that can be represented by this font.
     * @returns The set of unicode code points supported by this font.
     */ PDFFont.prototype.getCharacterSet = function() {
        if (this.embedder instanceof (0, $jwvE5.default)) return this.embedder.encoding.supportedCodePoints;
        else return this.embedder.font.characterSet;
    };
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all fonts get embedded.
     *
     * Embed this font in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFFont.prototype.embed = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.modified) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.embedder.embedIntoContext(this.doc.context, this.ref)
                        ];
                    case 1:
                        _a.sent();
                        this.modified = false;
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.embedFont]] and
     * > [[PDFDocument.embedStandardFont]] methods, which will create instances
     * > of [[PDFFont]] for you.
     *
     * Create an instance of [[PDFFont]] from an existing ref and embedder
     *
     * @param ref The unique reference for this font.
     * @param doc The document to which the font will belong.
     * @param embedder The embedder that will be used to embed the font.
     */ PDFFont.of = function(ref, doc, embedder) {
        return new PDFFont(ref, doc, embedder);
    };
    return PDFFont;
}();
var $fb353673e42bee9b$export$2e2bcd8739ae039 = $fb353673e42bee9b$var$PDFFont;

});

parcelRegister("7F2yc", function(module, exports) {

$parcel$export(module.exports, "default", () => $593e57425d0dad5a$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $cGbw3 = parcelRequire("cGbw3");
parcelRequire("iT7lj");
var $fmxHr = parcelRequire("fmxHr");
var $kHzkO = parcelRequire("kHzkO");
var $atfwl = parcelRequire("atfwl");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
/**
 * Represents an image that has been embedded in a [[PDFDocument]].
 */ var $593e57425d0dad5a$var$PDFImage = /** @class */ function() {
    function PDFImage(ref, doc, embedder) {
        (0, $j0tvB.assertIs)(ref, 'ref', [
            [
                (0, $kHzkO.default),
                'PDFRef'
            ]
        ]);
        (0, $j0tvB.assertIs)(doc, 'doc', [
            [
                (0, $cGbw3.default),
                'PDFDocument'
            ]
        ]);
        (0, $j0tvB.assertIs)(embedder, 'embedder', [
            [
                (0, $fmxHr.default),
                'JpegEmbedder'
            ],
            [
                (0, $atfwl.default),
                'PngEmbedder'
            ]
        ]);
        this.ref = ref;
        this.doc = doc;
        this.width = embedder.width;
        this.height = embedder.height;
        this.embedder = embedder;
    }
    /**
     * Compute the width and height of this image after being scaled by the
     * given `factor`. For example:
     * ```js
     * image.width  // => 500
     * image.height // => 250
     *
     * const scaled = image.scale(0.5)
     * scaled.width  // => 250
     * scaled.height // => 125
     * ```
     * This operation is often useful before drawing an image with
     * [[PDFPage.drawImage]] to compute the `width` and `height` options.
     * @param factor The factor by which this image should be scaled.
     * @returns The width and height of the image after being scaled.
     */ PDFImage.prototype.scale = function(factor) {
        (0, $j0tvB.assertIs)(factor, 'factor', [
            'number'
        ]);
        return {
            width: this.width * factor,
            height: this.height * factor
        };
    };
    /**
     * Get the width and height of this image after scaling it as large as
     * possible while maintaining its aspect ratio and not exceeding the
     * specified `width` and `height`. For example:
     * ```
     * image.width  // => 500
     * image.height // => 250
     *
     * const scaled = image.scaleToFit(750, 1000)
     * scaled.width  // => 750
     * scaled.height // => 375
     * ```
     * The `width` and `height` parameters can also be thought of as the width
     * and height of a box that the scaled image must fit within.
     * @param width The bounding box's width.
     * @param height The bounding box's height.
     * @returns The width and height of the image after being scaled.
     */ PDFImage.prototype.scaleToFit = function(width, height) {
        (0, $j0tvB.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $j0tvB.assertIs)(height, 'height', [
            'number'
        ]);
        var imgWidthScale = width / this.width;
        var imgHeightScale = height / this.height;
        var scale = Math.min(imgWidthScale, imgHeightScale);
        return this.scale(scale);
    };
    /**
     * Get the width and height of this image. For example:
     * ```js
     * const { width, height } = image.size()
     * ```
     * @returns The width and height of the image.
     */ PDFImage.prototype.size = function() {
        return this.scale(1);
    };
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all images get embedded.
     *
     * Embed this image in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFImage.prototype.embed = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var _a, doc, ref;
            return (0, $cOQTW.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!this.embedder) return [
                            2 /*return*/ 
                        ];
                        // The image should only be embedded once. If there's a pending embed
                        // operation then wait on it. Otherwise we need to start the embed.
                        if (!this.embedTask) {
                            _a = this, doc = _a.doc, ref = _a.ref;
                            this.embedTask = this.embedder.embedIntoContext(doc.context, ref);
                        }
                        return [
                            4 /*yield*/ ,
                            this.embedTask
                        ];
                    case 1:
                        _b.sent();
                        // We clear `this.embedder` so that the indirectly referenced image data
                        // can be garbage collected, thus avoiding a memory leak.
                        // See https://github.com/Hopding/pdf-lib/pull/1032/files.
                        this.embedder = undefined;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.embedPng]] and [[PDFDocument.embedJpg]]
     * > methods, which will create instances of [[PDFImage]] for you.
     *
     * Create an instance of [[PDFImage]] from an existing ref and embedder
     *
     * @param ref The unique reference for this image.
     * @param doc The document to which the image will belong.
     * @param embedder The embedder that will be used to embed the image.
     */ PDFImage.of = function(ref, doc, embedder) {
        return new PDFImage(ref, doc, embedder);
    };
    return PDFImage;
}();
var $593e57425d0dad5a$export$2e2bcd8739ae039 = $593e57425d0dad5a$var$PDFImage;

});

parcelRegister("2sybW", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ca8b80442f19ab5$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $cGbw3 = parcelRequire("cGbw3");

var $fphXB = parcelRequire("fphXB");

var $67hmm = parcelRequire("67hmm");

var $c2qg8 = parcelRequire("c2qg8");

var $5Apvp = parcelRequire("5Apvp");

var $1DKij = parcelRequire("1DKij");

var $hzhWN = parcelRequire("hzhWN");

var $lqhKQ = parcelRequire("lqhKQ");

var $aYJvX = parcelRequire("aYJvX");

var $lzaL9 = parcelRequire("lzaL9");

var $i4gUC = parcelRequire("i4gUC");

var $7mLHs = parcelRequire("7mLHs");

var $hPFvC = parcelRequire("hPFvC");
parcelRequire("iT7lj");
var $gkGMc = parcelRequire("gkGMc");
var $lmORt = parcelRequire("lmORt");
var $4vDg3 = parcelRequire("4vDg3");
var $flrAV = parcelRequire("flrAV");
var $gEqSi = parcelRequire("gEqSi");
var $dP7Ar = parcelRequire("dP7Ar");
var $1757u = parcelRequire("1757u");
var $hpItd = parcelRequire("hpItd");
var $7hDvO = parcelRequire("7hDvO");
var $clInn = parcelRequire("clInn");
var $brir8 = parcelRequire("brir8");
var $dPHSK = parcelRequire("dPHSK");
var $kHzkO = parcelRequire("kHzkO");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
var $clYSv = parcelRequire("clYSv");
/**
 * Represents the interactive form of a [[PDFDocument]].
 *
 * Interactive forms (sometimes called _AcroForms_) are collections of fields
 * designed to gather information from a user. A PDF document may contains any
 * number of fields that appear on various pages, all of which make up a single,
 * global interactive form spanning the entire document. This means that
 * instances of [[PDFDocument]] shall contain at most one [[PDFForm]].
 *
 * The fields of an interactive form are represented by [[PDFField]] instances.
 */ var $1ca8b80442f19ab5$var$PDFForm = /** @class */ function() {
    function PDFForm(acroForm, doc) {
        var _this = this;
        this.embedDefaultFont = function() {
            return _this.doc.embedStandardFont((0, $i4gUC.StandardFonts).Helvetica);
        };
        (0, $j0tvB.assertIs)(acroForm, 'acroForm', [
            [
                (0, $flrAV.default),
                'PDFAcroForm'
            ]
        ]);
        (0, $j0tvB.assertIs)(doc, 'doc', [
            [
                (0, $cGbw3.default),
                'PDFDocument'
            ]
        ]);
        this.acroForm = acroForm;
        this.doc = doc;
        this.dirtyFields = new Set();
        this.defaultFontCache = (0, $clYSv.default).populatedBy(this.embedDefaultFont);
    }
    /**
     * Returns `true` if this [[PDFForm]] has XFA data. Most PDFs with form
     * fields do not use XFA as it is not widely supported by PDF readers.
     *
     * > `pdf-lib` does not support creation, modification, or reading of XFA
     * > fields.
     *
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * if (form.hasXFA()) console.log('PDF has XFA data')
     * ```
     * @returns Whether or not this form has XFA data.
     */ PDFForm.prototype.hasXFA = function() {
        return this.acroForm.dict.has((0, $dPHSK.default).of('XFA'));
    };
    /**
     * Disconnect the XFA data from this [[PDFForm]] (if any exists). This will
     * force readers to fallback to standard fields if the [[PDFDocument]]
     * contains any. For example:
     *
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * form.deleteXFA()
     * ```
     */ PDFForm.prototype.deleteXFA = function() {
        this.acroForm.dict.delete((0, $dPHSK.default).of('XFA'));
    };
    /**
     * Get all fields contained in this [[PDFForm]]. For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const fields = form.getFields()
     * fields.forEach(field => {
     *   const type = field.constructor.name
     *   const name = field.getName()
     *   console.log(`${type}: ${name}`)
     * })
     * ```
     * @returns An array of all fields in this form.
     */ PDFForm.prototype.getFields = function() {
        var allFields = this.acroForm.getAllFields();
        var fields = [];
        for(var idx = 0, len = allFields.length; idx < len; idx++){
            var _a = allFields[idx], acroField = _a[0], ref = _a[1];
            var field = $1ca8b80442f19ab5$var$convertToPDFField(acroField, ref, this.doc);
            if (field) fields.push(field);
        }
        return fields;
    };
    /**
     * Get the field in this [[PDFForm]] with the given name. For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getFieldMaybe('Page1.Foo.Bar[0]')
     * if (field) console.log('Field exists!')
     * ```
     * @param name A fully qualified field name.
     * @returns The field with the specified name, if one exists.
     */ PDFForm.prototype.getFieldMaybe = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var fields = this.getFields();
        for(var idx = 0, len = fields.length; idx < len; idx++){
            var field = fields[idx];
            if (field.getName() === name) return field;
        }
        return undefined;
    };
    /**
     * Get the field in this [[PDFForm]] with the given name. For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getField('Page1.Foo.Bar[0]')
     * ```
     * If no field exists with the provided name, an error will be thrown.
     * @param name A fully qualified field name.
     * @returns The field with the specified name.
     */ PDFForm.prototype.getField = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getFieldMaybe(name);
        if (field) return field;
        throw new (0, $aYJvX.NoSuchFieldError)(name);
    };
    /**
     * Get the button field in this [[PDFForm]] with the given name. For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const button = form.getButton('Page1.Foo.Button[0]')
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a button.
     * @param name A fully qualified button name.
     * @returns The button with the specified name.
     */ PDFForm.prototype.getButton = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $fphXB.default)) return field;
        throw new (0, $aYJvX.UnexpectedFieldTypeError)(name, (0, $fphXB.default), field);
    };
    /**
     * Get the check box field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const checkBox = form.getCheckBox('Page1.Foo.CheckBox[0]')
     * checkBox.check()
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a check box.
     * @param name A fully qualified check box name.
     * @returns The check box with the specified name.
     */ PDFForm.prototype.getCheckBox = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $67hmm.default)) return field;
        throw new (0, $aYJvX.UnexpectedFieldTypeError)(name, (0, $67hmm.default), field);
    };
    /**
     * Get the dropdown field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const dropdown = form.getDropdown('Page1.Foo.Dropdown[0]')
     * const options = dropdown.getOptions()
     * dropdown.select(options[0])
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a dropdown.
     * @param name A fully qualified dropdown name.
     * @returns The dropdown with the specified name.
     */ PDFForm.prototype.getDropdown = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $c2qg8.default)) return field;
        throw new (0, $aYJvX.UnexpectedFieldTypeError)(name, (0, $c2qg8.default), field);
    };
    /**
     * Get the option list field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const optionList = form.getOptionList('Page1.Foo.OptionList[0]')
     * const options = optionList.getOptions()
     * optionList.select(options[0])
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not an option list.
     * @param name A fully qualified option list name.
     * @returns The option list with the specified name.
     */ PDFForm.prototype.getOptionList = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $5Apvp.default)) return field;
        throw new (0, $aYJvX.UnexpectedFieldTypeError)(name, (0, $5Apvp.default), field);
    };
    /**
     * Get the radio group field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const radioGroup = form.getRadioGroup('Page1.Foo.RadioGroup[0]')
     * const options = radioGroup.getOptions()
     * radioGroup.select(options[0])
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a radio group.
     * @param name A fully qualified radio group name.
     * @returns The radio group with the specified name.
     */ PDFForm.prototype.getRadioGroup = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $1DKij.default)) return field;
        throw new (0, $aYJvX.UnexpectedFieldTypeError)(name, (0, $1DKij.default), field);
    };
    /**
     * Get the signature field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const signature = form.getSignature('Page1.Foo.Signature[0]')
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a signature.
     * @param name A fully qualified signature name.
     * @returns The signature with the specified name.
     */ PDFForm.prototype.getSignature = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $hzhWN.default)) return field;
        throw new (0, $aYJvX.UnexpectedFieldTypeError)(name, (0, $hzhWN.default), field);
    };
    /**
     * Get the text field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const textField = form.getTextField('Page1.Foo.TextField[0]')
     * textField.setText('Are you designed to act or to be acted upon?')
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a text field.
     * @param name A fully qualified text field name.
     * @returns The text field with the specified name.
     */ PDFForm.prototype.getTextField = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $lqhKQ.default)) return field;
        throw new (0, $aYJvX.UnexpectedFieldTypeError)(name, (0, $lqhKQ.default), field);
    };
    /**
     * Create a new button field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const button = form.createButton('cool.new.button')
     *
     * button.addToPage('Do Stuff', font, page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new button.
     * @returns The new button field.
     */ PDFForm.prototype.createButton = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $1ca8b80442f19ab5$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var button = (0, $1757u.default).create(this.doc.context);
        button.setPartialName(nameParts.terminal);
        $1ca8b80442f19ab5$var$addFieldToParent(parent, [
            button,
            button.ref
        ], nameParts.terminal);
        return (0, $fphXB.default).of(button, button.ref, this.doc);
    };
    /**
     * Create a new check box field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const checkBox = form.createCheckBox('cool.new.checkBox')
     *
     * checkBox.addToPage(page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new check box.
     * @returns The new check box field.
     */ PDFForm.prototype.createCheckBox = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $1ca8b80442f19ab5$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var checkBox = (0, $lmORt.default).create(this.doc.context);
        checkBox.setPartialName(nameParts.terminal);
        $1ca8b80442f19ab5$var$addFieldToParent(parent, [
            checkBox,
            checkBox.ref
        ], nameParts.terminal);
        return (0, $67hmm.default).of(checkBox, checkBox.ref, this.doc);
    };
    /**
     * Create a new dropdown field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const dropdown = form.createDropdown('cool.new.dropdown')
     *
     * dropdown.addToPage(font, page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new dropdown.
     * @returns The new dropdown field.
     */ PDFForm.prototype.createDropdown = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $1ca8b80442f19ab5$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var comboBox = (0, $4vDg3.default).create(this.doc.context);
        comboBox.setPartialName(nameParts.terminal);
        $1ca8b80442f19ab5$var$addFieldToParent(parent, [
            comboBox,
            comboBox.ref
        ], nameParts.terminal);
        return (0, $c2qg8.default).of(comboBox, comboBox.ref, this.doc);
    };
    /**
     * Create a new option list field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const optionList = form.createOptionList('cool.new.optionList')
     *
     * optionList.addToPage(font, page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new option list.
     * @returns The new option list field.
     */ PDFForm.prototype.createOptionList = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $1ca8b80442f19ab5$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var listBox = (0, $gEqSi.default).create(this.doc.context);
        listBox.setPartialName(nameParts.terminal);
        $1ca8b80442f19ab5$var$addFieldToParent(parent, [
            listBox,
            listBox.ref
        ], nameParts.terminal);
        return (0, $5Apvp.default).of(listBox, listBox.ref, this.doc);
    };
    /**
     * Create a new radio group field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const radioGroup = form.createRadioGroup('cool.new.radioGroup')
     *
     * radioGroup.addOptionToPage('is-dog', page, { y: 0 })
     * radioGroup.addOptionToPage('is-cat', page, { y: 75 })
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new radio group.
     * @returns The new radio group field.
     */ PDFForm.prototype.createRadioGroup = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $1ca8b80442f19ab5$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var radioButton = (0, $hpItd.default).create(this.doc.context);
        radioButton.setPartialName(nameParts.terminal);
        $1ca8b80442f19ab5$var$addFieldToParent(parent, [
            radioButton,
            radioButton.ref
        ], nameParts.terminal);
        return (0, $1DKij.default).of(radioButton, radioButton.ref, this.doc);
    };
    /**
     * Create a new text field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const textField = form.createTextField('cool.new.textField')
     *
     * textField.addToPage(font, page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new radio group.
     * @returns The new radio group field.
     */ PDFForm.prototype.createTextField = function(name) {
        (0, $j0tvB.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $1ca8b80442f19ab5$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var text = (0, $clInn.default).create(this.doc.context);
        text.setPartialName(nameParts.terminal);
        $1ca8b80442f19ab5$var$addFieldToParent(parent, [
            text,
            text.ref
        ], nameParts.terminal);
        return (0, $lqhKQ.default).of(text, text.ref, this.doc);
    };
    /**
     * Flatten all fields in this [[PDFForm]].
     *
     * Flattening a form field will take the current appearance for each of that
     * field's widgets and make them part of their page's content stream. All form
     * fields and annotations associated are then removed. Note that once a form
     * has been flattened its fields can no longer be accessed or edited.
     *
     * This operation is often used after filling form fields to ensure a
     * consistent appearance across different PDF readers and/or printers.
     * Another common use case is to copy a template document with form fields
     * into another document. In this scenario you would load the template
     * document, fill its fields, flatten it, and then copy its pages into the
     * recipient document - the filled fields will be copied over.
     *
     * For example:
     * ```js
     * const form = pdfDoc.getForm();
     * form.flatten();
     * ```
     */ PDFForm.prototype.flatten = function(options) {
        if (options === void 0) options = {
            updateFieldAppearances: true
        };
        if (options.updateFieldAppearances) this.updateFieldAppearances();
        var fields = this.getFields();
        for(var i = 0, lenFields = fields.length; i < lenFields; i++){
            var field = fields[i];
            var widgets = field.acroField.getWidgets();
            for(var j = 0, lenWidgets = widgets.length; j < lenWidgets; j++){
                var widget = widgets[j];
                var page = this.findWidgetPage(widget);
                var widgetRef = this.findWidgetAppearanceRef(field, widget);
                var xObjectKey = page.node.newXObject('FlatWidget', widgetRef);
                var rectangle = widget.getRectangle();
                var operators = (0, $cOQTW.__spreadArrays)([
                    (0, $hPFvC.pushGraphicsState)(),
                    (0, $hPFvC.translate)(rectangle.x, rectangle.y)
                ], (0, $7mLHs.rotateInPlace)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, rectangle), {
                    rotation: 0
                })), [
                    (0, $hPFvC.drawObject)(xObjectKey),
                    (0, $hPFvC.popGraphicsState)()
                ]).filter(Boolean);
                page.pushOperators.apply(page, operators);
            }
            this.removeField(field);
        }
    };
    /**
     * Remove a field from this [[PDFForm]].
     *
     * For example:
     * ```js
     * const form = pdfDoc.getForm();
     * const ageField = form.getFields().find(x => x.getName() === 'Age');
     * form.removeField(ageField);
     * ```
     */ PDFForm.prototype.removeField = function(field) {
        var widgets = field.acroField.getWidgets();
        var pages = new Set();
        for(var i = 0, len = widgets.length; i < len; i++){
            var widget = widgets[i];
            var widgetRef = this.findWidgetAppearanceRef(field, widget);
            var page = this.findWidgetPage(widget);
            pages.add(page);
            page.node.removeAnnot(widgetRef);
        }
        pages.forEach(function(page) {
            return page.node.removeAnnot(field.ref);
        });
        this.acroForm.removeField(field.acroField);
        var fieldKids = field.acroField.normalizedEntries().Kids;
        var kidsCount = fieldKids.size();
        for(var childIndex = 0; childIndex < kidsCount; childIndex++){
            var child = fieldKids.get(childIndex);
            if (child instanceof (0, $kHzkO.default)) this.doc.context.delete(child);
        }
        this.doc.context.delete(field.ref);
    };
    /**
     * Update the appearance streams for all widgets of all fields in this
     * [[PDFForm]]. Appearance streams will only be created for a widget if it
     * does not have any existing appearance streams, or the field's value has
     * changed (e.g. by calling [[PDFTextField.setText]] or
     * [[PDFDropdown.select]]).
     *
     * For example:
     * ```js
     * const courier = await pdfDoc.embedFont(StandardFonts.Courier)
     * const form = pdfDoc.getForm()
     * form.updateFieldAppearances(courier)
     * ```
     *
     * **IMPORTANT:** The default value for the `font` parameter is
     * [[StandardFonts.Helvetica]]. Note that this is a WinAnsi font. This means
     * that encoding errors will be thrown if any fields contain text with
     * characters outside the WinAnsi character set (the latin alphabet).
     *
     * Embedding a custom font and passing that as the `font`
     * parameter allows you to generate appearance streams with non WinAnsi
     * characters (assuming your custom font supports them).
     *
     * > **NOTE:** The [[PDFDocument.save]] method will call this method to
     * > update appearances automatically if a form was accessed via the
     * > [[PDFDocument.getForm]] method prior to saving.
     *
     * @param font Optionally, the font to use when creating new appearances.
     */ PDFForm.prototype.updateFieldAppearances = function(font) {
        (0, $j0tvB.assertOrUndefined)(font, 'font', [
            [
                (0, $lzaL9.default),
                'PDFFont'
            ]
        ]);
        font = font !== null && font !== void 0 ? font : this.getDefaultFont();
        var fields = this.getFields();
        for(var idx = 0, len = fields.length; idx < len; idx++){
            var field = fields[idx];
            if (field.needsAppearancesUpdate()) field.defaultUpdateAppearances(font);
        }
    };
    /**
     * Mark a field as dirty. This will cause its appearance streams to be
     * updated by [[PDFForm.updateFieldAppearances]].
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getField('foo.bar')
     * form.markFieldAsDirty(field.ref)
     * ```
     * @param fieldRef The reference to the field that should be marked.
     */ PDFForm.prototype.markFieldAsDirty = function(fieldRef) {
        (0, $j0tvB.assertOrUndefined)(fieldRef, 'fieldRef', [
            [
                (0, $kHzkO.default),
                'PDFRef'
            ]
        ]);
        this.dirtyFields.add(fieldRef);
    };
    /**
     * Mark a field as dirty. This will cause its appearance streams to not be
     * updated by [[PDFForm.updateFieldAppearances]].
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getField('foo.bar')
     * form.markFieldAsClean(field.ref)
     * ```
     * @param fieldRef The reference to the field that should be marked.
     */ PDFForm.prototype.markFieldAsClean = function(fieldRef) {
        (0, $j0tvB.assertOrUndefined)(fieldRef, 'fieldRef', [
            [
                (0, $kHzkO.default),
                'PDFRef'
            ]
        ]);
        this.dirtyFields.delete(fieldRef);
    };
    /**
     * Returns `true` is the specified field has been marked as dirty.
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getField('foo.bar')
     * if (form.fieldIsDirty(field.ref)) console.log('Field is dirty')
     * ```
     * @param fieldRef The reference to the field that should be checked.
     * @returns Whether or not the specified field is dirty.
     */ PDFForm.prototype.fieldIsDirty = function(fieldRef) {
        (0, $j0tvB.assertOrUndefined)(fieldRef, 'fieldRef', [
            [
                (0, $kHzkO.default),
                'PDFRef'
            ]
        ]);
        return this.dirtyFields.has(fieldRef);
    };
    PDFForm.prototype.getDefaultFont = function() {
        return this.defaultFontCache.access();
    };
    PDFForm.prototype.findWidgetPage = function(widget) {
        var pageRef = widget.P();
        var page = this.doc.getPages().find(function(x) {
            return x.ref === pageRef;
        });
        if (page === undefined) {
            var widgetRef = this.doc.context.getObjectRef(widget.dict);
            if (widgetRef === undefined) throw new Error('Could not find PDFRef for PDFObject');
            page = this.doc.findPageForAnnotationRef(widgetRef);
            if (page === undefined) throw new Error("Could not find page for PDFRef " + widgetRef);
        }
        return page;
    };
    PDFForm.prototype.findWidgetAppearanceRef = function(field, widget) {
        var _a;
        var refOrDict = widget.getNormalAppearance();
        if (refOrDict instanceof (0, $brir8.default) && (field instanceof (0, $67hmm.default) || field instanceof (0, $1DKij.default))) {
            var value = field.acroField.getValue();
            var ref = (_a = refOrDict.get(value)) !== null && _a !== void 0 ? _a : refOrDict.get((0, $dPHSK.default).of('Off'));
            if (ref instanceof (0, $kHzkO.default)) refOrDict = ref;
        }
        if (!(refOrDict instanceof (0, $kHzkO.default))) {
            var name_1 = field.getName();
            throw new Error("Failed to extract appearance ref for: " + name_1);
        }
        return refOrDict;
    };
    PDFForm.prototype.findOrCreateNonTerminals = function(partialNames) {
        var nonTerminal = [
            this.acroForm
        ];
        for(var idx = 0, len = partialNames.length; idx < len; idx++){
            var namePart = partialNames[idx];
            if (!namePart) throw new (0, $aYJvX.InvalidFieldNamePartError)(namePart);
            var parent_1 = nonTerminal[0], parentRef = nonTerminal[1];
            var res = this.findNonTerminal(namePart, parent_1);
            if (res) nonTerminal = res;
            else {
                var node = (0, $dP7Ar.default).create(this.doc.context);
                node.setPartialName(namePart);
                node.setParent(parentRef);
                var nodeRef = this.doc.context.register(node.dict);
                parent_1.addField(nodeRef);
                nonTerminal = [
                    node,
                    nodeRef
                ];
            }
        }
        return nonTerminal;
    };
    PDFForm.prototype.findNonTerminal = function(partialName, parent) {
        var fields = parent instanceof (0, $flrAV.default) ? this.acroForm.getFields() : (0, $gkGMc.createPDFAcroFields)(parent.Kids());
        for(var idx = 0, len = fields.length; idx < len; idx++){
            var _a = fields[idx], field = _a[0], ref = _a[1];
            if (field.getPartialName() === partialName) {
                if (field instanceof (0, $dP7Ar.default)) return [
                    field,
                    ref
                ];
                throw new (0, $aYJvX.FieldAlreadyExistsError)(partialName);
            }
        }
        return undefined;
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.getForm]] method, which will create an
     * > instance of [[PDFForm]] for you.
     *
     * Create an instance of [[PDFForm]] from an existing acroForm and embedder
     *
     * @param acroForm The underlying `PDFAcroForm` for this form.
     * @param doc The document to which the form will belong.
     */ PDFForm.of = function(acroForm, doc) {
        return new PDFForm(acroForm, doc);
    };
    return PDFForm;
}();
var $1ca8b80442f19ab5$export$2e2bcd8739ae039 = $1ca8b80442f19ab5$var$PDFForm;
var $1ca8b80442f19ab5$var$convertToPDFField = function(field, ref, doc) {
    if (field instanceof (0, $1757u.default)) return (0, $fphXB.default).of(field, ref, doc);
    if (field instanceof (0, $lmORt.default)) return (0, $67hmm.default).of(field, ref, doc);
    if (field instanceof (0, $4vDg3.default)) return (0, $c2qg8.default).of(field, ref, doc);
    if (field instanceof (0, $gEqSi.default)) return (0, $5Apvp.default).of(field, ref, doc);
    if (field instanceof (0, $clInn.default)) return (0, $lqhKQ.default).of(field, ref, doc);
    if (field instanceof (0, $hpItd.default)) return (0, $1DKij.default).of(field, ref, doc);
    if (field instanceof (0, $7hDvO.default)) return (0, $hzhWN.default).of(field, ref, doc);
    return undefined;
};
var $1ca8b80442f19ab5$var$splitFieldName = function(fullyQualifiedName) {
    if (fullyQualifiedName.length === 0) throw new Error('PDF field names must not be empty strings');
    var parts = fullyQualifiedName.split('.');
    for(var idx = 0, len = parts.length; idx < len; idx++){
        if (parts[idx] === '') throw new Error("Periods in PDF field names must be separated by at least one character: \"" + fullyQualifiedName + "\"");
    }
    if (parts.length === 1) return {
        nonTerminal: [],
        terminal: parts[0]
    };
    return {
        nonTerminal: parts.slice(0, parts.length - 1),
        terminal: parts[parts.length - 1]
    };
};
var $1ca8b80442f19ab5$var$addFieldToParent = function(_a, _b, partialName) {
    var parent = _a[0], parentRef = _a[1];
    var field = _b[0], fieldRef = _b[1];
    var entries = parent.normalizedEntries();
    var fields = (0, $gkGMc.createPDFAcroFields)('Kids' in entries ? entries.Kids : entries.Fields);
    for(var idx = 0, len = fields.length; idx < len; idx++){
        if (fields[idx][0].getPartialName() === partialName) throw new (0, $aYJvX.FieldAlreadyExistsError)(partialName);
    }
    parent.addField(fieldRef);
    field.setParent(parentRef);
};

});
parcelRegister("67hmm", function(module, exports) {

$parcel$export(module.exports, "default", () => $4740dcccc2940521$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $eq4Zh = parcelRequire("eq4Zh");

var $ikSoM = parcelRequire("ikSoM");

var $gidDr = parcelRequire("gidDr");

var $55HYh = parcelRequire("55HYh");

var $dgAbg = parcelRequire("dgAbg");
parcelRequire("iT7lj");
var $lmORt = parcelRequire("lmORt");
var $brir8 = parcelRequire("brir8");
var $dPHSK = parcelRequire("dPHSK");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
/**
 * Represents a check box field of a [[PDFForm]].
 *
 * [[PDFCheckBox]] fields are interactive boxes that users can click with their
 * mouse. This type of [[PDFField]] has two states: `on` and `off`. The purpose
 * of a check box is to enable users to select from one or more options, where
 * each option is represented by a single check box. Check boxes are typically
 * square in shape and display a check mark when they are in the `on` state.
 */ var $4740dcccc2940521$var$PDFCheckBox = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFCheckBox, _super);
    function PDFCheckBox(acroCheckBox, ref, doc) {
        var _this = _super.call(this, acroCheckBox, ref, doc) || this;
        (0, $j0tvB.assertIs)(acroCheckBox, 'acroCheckBox', [
            [
                (0, $lmORt.default),
                'PDFAcroCheckBox'
            ]
        ]);
        _this.acroField = acroCheckBox;
        return _this;
    }
    /**
     * Mark this check box. This operation is analogous to a human user clicking
     * a check box to fill it in a PDF reader. This method will update the
     * underlying state of the check box field to indicate it has been selected.
     * PDF libraries and readers will be able to extract this value from the
     * saved document and determine that it was selected.
     *
     * For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * checkBox.check()
     * ```
     *
     * This method will mark this check box as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated appearance
     * streams will display a check mark inside the widgets of this check box
     * field.
     */ PDFCheckBox.prototype.check = function() {
        var _a;
        var onValue = (_a = this.acroField.getOnValue()) !== null && _a !== void 0 ? _a : (0, $dPHSK.default).of('Yes');
        this.markAsDirty();
        this.acroField.setValue(onValue);
    };
    /**
     * Clears this check box. This operation is analogous to a human user clicking
     * a check box to unmark it in a PDF reader. This method will update the
     * underlying state of the check box field to indicate it has been deselected.
     * PDF libraries and readers will be able to extract this value from the
     * saved document and determine that it was not selected.
     *
     * For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * checkBox.uncheck()
     * ```
     *
     * This method will mark this check box as dirty. See [[PDFCheckBox.check]]
     * for more details about what this means.
     */ PDFCheckBox.prototype.uncheck = function() {
        this.markAsDirty();
        this.acroField.setValue((0, $dPHSK.default).of('Off'));
    };
    /**
     * Returns `true` if this check box is selected (either by a human user via
     * a PDF reader, or else programmatically via software). For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * if (checkBox.isChecked()) console.log('check box is selected')
     * ```
     * @returns Whether or not this check box is selected.
     */ PDFCheckBox.prototype.isChecked = function() {
        var onValue = this.acroField.getOnValue();
        return !!onValue && onValue === this.acroField.getValue();
    };
    /**
     * Show this check box on the specified page. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const checkBox = form.createCheckBox('some.checkBox.field')
     *
     * checkBox.addToPage(page, {
     *   x: 50,
     *   y: 75,
     *   width: 25,
     *   height: 25,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     * })
     * ```
     * This will create a new widget for this check box field.
     * @param page The page to which this check box widget should be added.
     * @param options The options to be used when adding this check box widget.
     */ PDFCheckBox.prototype.addToPage = function(page, options) {
        var _a, _b, _c, _d, _e, _f;
        (0, $j0tvB.assertIs)(page, 'page', [
            [
                (0, $eq4Zh.default),
                'PDFPage'
            ]
        ]);
        (0, $dgAbg.assertFieldAppearanceOptions)(options);
        if (!options) options = {};
        if (!('textColor' in options)) options.textColor = (0, $gidDr.rgb)(0, 0, 0);
        if (!('backgroundColor' in options)) options.backgroundColor = (0, $gidDr.rgb)(1, 1, 1);
        if (!('borderColor' in options)) options.borderColor = (0, $gidDr.rgb)(0, 0, 0);
        if (!('borderWidth' in options)) options.borderWidth = 1;
        // Create a widget for this check box
        var widget = this.createWidget({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 50,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 50,
            textColor: options.textColor,
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: (_e = options.borderWidth) !== null && _e !== void 0 ? _e : 0,
            rotate: (_f = options.rotate) !== null && _f !== void 0 ? _f : (0, $55HYh.degrees)(0),
            hidden: options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        widget.setAppearanceState((0, $dPHSK.default).of('Off'));
        this.updateWidgetAppearance(widget, (0, $dPHSK.default).of('Yes'));
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if any of this check box's widgets do not have an
     * appearance stream for its current state. For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * if (checkBox.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this check box needs an appearance update.
     */ PDFCheckBox.prototype.needsAppearancesUpdate = function() {
        var _a;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var state = widget.getAppearanceState();
            var normal = (_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal;
            if (!(normal instanceof (0, $brir8.default))) return true;
            if (state && !normal.has(state)) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this check box's widgets using
     * the default appearance provider for check boxes. For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * checkBox.defaultUpdateAppearances()
     * ```
     */ PDFCheckBox.prototype.defaultUpdateAppearances = function() {
        this.updateAppearances();
    };
    /**
     * Update the appearance streams for each of this check box's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for check boxs will be used. For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * checkBox.updateAppearances((field, widget) => {
     *   ...
     *   return {
     *     normal: { on: drawCheckBox(...), off: drawCheckBox(...) },
     *     down: { on: drawCheckBox(...), off: drawCheckBox(...) },
     *   }
     * })
     * ```
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFCheckBox.prototype.updateAppearances = function(provider) {
        var _a;
        (0, $j0tvB.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var onValue = (_a = widget.getOnValue()) !== null && _a !== void 0 ? _a : (0, $dPHSK.default).of('Yes');
            if (!onValue) continue;
            this.updateWidgetAppearance(widget, onValue, provider);
        }
        this.markAsClean();
    };
    PDFCheckBox.prototype.updateWidgetAppearance = function(widget, onValue, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $ikSoM.defaultCheckBoxAppearanceProvider);
        var appearances = (0, $ikSoM.normalizeAppearance)(apProvider(this, widget));
        this.updateOnOffWidgetAppearance(widget, onValue, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getCheckBox]] method, which will create an
     * > instance of [[PDFCheckBox]] for you.
     *
     * Create an instance of [[PDFCheckBox]] from an existing acroCheckBox and ref
     *
     * @param acroCheckBox The underlying `PDFAcroCheckBox` for this check box.
     * @param ref The unique reference for this check box.
     * @param doc The document to which this check box will belong.
     */ PDFCheckBox.of = function(acroCheckBox, ref, doc) {
        return new PDFCheckBox(acroCheckBox, ref, doc);
    };
    return PDFCheckBox;
}((0, $dgAbg.default));
var $4740dcccc2940521$export$2e2bcd8739ae039 = $4740dcccc2940521$var$PDFCheckBox;

});
parcelRegister("dgAbg", function(module, exports) {

$parcel$export(module.exports, "assertFieldAppearanceOptions", () => $9a88d5b8c9019f73$export$55643210f1835a35);
$parcel$export(module.exports, "default", () => $9a88d5b8c9019f73$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $cGbw3 = parcelRequire("cGbw3");

var $gidDr = parcelRequire("gidDr");

var $55HYh = parcelRequire("55HYh");
parcelRequire("iT7lj");
var $d5IrD = parcelRequire("d5IrD");
var $ckfWn = parcelRequire("ckfWn");
var $nAWRe = parcelRequire("nAWRe");
var $64Z70 = parcelRequire("64Z70");
var $dPHSK = parcelRequire("dPHSK");
var $kHzkO = parcelRequire("kHzkO");
var $7ds0z = parcelRequire("7ds0z");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
parcelRequire("6vWdG");
var $gYSUQ = parcelRequire("gYSUQ");

var $7mLHs = parcelRequire("7mLHs");
var $9a88d5b8c9019f73$export$55643210f1835a35 = function(options) {
    (0, $j0tvB.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.x, 'options.x', [
        'number'
    ]);
    (0, $j0tvB.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.y, 'options.y', [
        'number'
    ]);
    (0, $j0tvB.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.width, 'options.width', [
        'number'
    ]);
    (0, $j0tvB.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.height, 'options.height', [
        'number'
    ]);
    (0, $j0tvB.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.textColor, 'options.textColor', [
        [
            Object,
            'Color'
        ]
    ]);
    (0, $j0tvB.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.backgroundColor, 'options.backgroundColor', [
        [
            Object,
            'Color'
        ]
    ]);
    (0, $j0tvB.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.borderColor, 'options.borderColor', [
        [
            Object,
            'Color'
        ]
    ]);
    (0, $j0tvB.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.borderWidth, 'options.borderWidth', [
        'number'
    ]);
    (0, $j0tvB.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.rotate, 'options.rotate', [
        [
            Object,
            'Rotation'
        ]
    ]);
};
/**
 * Represents a field of a [[PDFForm]].
 *
 * This class is effectively abstract. All fields in a [[PDFForm]] will
 * actually be an instance of a subclass of this class.
 *
 * Note that each field in a PDF is represented by a single field object.
 * However, a given field object may be rendered at multiple locations within
 * the document (across one or more pages). The rendering of a field is
 * controlled by its widgets. Each widget causes its field to be displayed at a
 * particular location in the document.
 *
 * Most of the time each field in a PDF has only a single widget, and thus is
 * only rendered once. However, if a field is rendered multiple times, it will
 * have multiple widgets - one for each location it is rendered.
 *
 * This abstraction of field objects and widgets is defined in the PDF
 * specification and dictates how PDF files store fields and where they are
 * to be rendered.
 */ var $9a88d5b8c9019f73$var$PDFField = /** @class */ function() {
    function PDFField(acroField, ref, doc) {
        (0, $j0tvB.assertIs)(acroField, 'acroField', [
            [
                (0, $64Z70.default),
                'PDFAcroTerminal'
            ]
        ]);
        (0, $j0tvB.assertIs)(ref, 'ref', [
            [
                (0, $kHzkO.default),
                'PDFRef'
            ]
        ]);
        (0, $j0tvB.assertIs)(doc, 'doc', [
            [
                (0, $cGbw3.default),
                'PDFDocument'
            ]
        ]);
        this.acroField = acroField;
        this.ref = ref;
        this.doc = doc;
    }
    /**
     * Get the fully qualified name of this field. For example:
     * ```js
     * const fields = form.getFields()
     * fields.forEach(field => {
     *   const name = field.getName()
     *   console.log('Field name:', name)
     * })
     * ```
     * Note that PDF fields are structured as a tree. Each field is the
     * descendent of a series of ancestor nodes all the way up to the form node,
     * which is always the root of the tree. Each node in the tree (except for
     * the form node) has a partial name. Partial names can be composed of any
     * unicode characters except a period (`.`). The fully qualified name of a
     * field is composed of the partial names of all its ancestors joined
     * with periods. This means that splitting the fully qualified name on
     * periods and taking the last element of the resulting array will give you
     * the partial name of a specific field.
     * @returns The fully qualified name of this field.
     */ PDFField.prototype.getName = function() {
        var _a;
        return (_a = this.acroField.getFullyQualifiedName()) !== null && _a !== void 0 ? _a : '';
    };
    /**
     * Returns `true` if this field is read only. This means that PDF readers
     * will not allow users to interact with the field or change its value. See
     * [[PDFField.enableReadOnly]] and [[PDFField.disableReadOnly]].
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * if (field.isReadOnly()) console.log('Read only is enabled')
     * ```
     * @returns Whether or not this is a read only field.
     */ PDFField.prototype.isReadOnly = function() {
        return this.acroField.hasFlag((0, $d5IrD.AcroFieldFlags).ReadOnly);
    };
    /**
     * Prevent PDF readers from allowing users to interact with this field or
     * change its value. The field will not respond to mouse or keyboard input.
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * field.enableReadOnly()
     * ```
     * Useful for fields whose values are computed, imported from a database, or
     * prefilled by software before being displayed to the user.
     */ PDFField.prototype.enableReadOnly = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroFieldFlags).ReadOnly, true);
    };
    /**
     * Allow users to interact with this field and change its value in PDF
     * readers via mouse and keyboard input. For example:
     * ```js
     * const field = form.getField('some.field')
     * field.disableReadOnly()
     * ```
     */ PDFField.prototype.disableReadOnly = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroFieldFlags).ReadOnly, false);
    };
    /**
     * Returns `true` if this field must have a value when the form is submitted.
     * See [[PDFField.enableRequired]] and [[PDFField.disableRequired]].
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * if (field.isRequired()) console.log('Field is required')
     * ```
     * @returns Whether or not this field is required.
     */ PDFField.prototype.isRequired = function() {
        return this.acroField.hasFlag((0, $d5IrD.AcroFieldFlags).Required);
    };
    /**
     * Require this field to have a value when the form is submitted.
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * field.enableRequired()
     * ```
     */ PDFField.prototype.enableRequired = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroFieldFlags).Required, true);
    };
    /**
     * Do not require this field to have a value when the form is submitted.
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * field.disableRequired()
     * ```
     */ PDFField.prototype.disableRequired = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroFieldFlags).Required, false);
    };
    /**
     * Returns `true` if this field's value should be exported when the form is
     * submitted. See [[PDFField.enableExporting]] and
     * [[PDFField.disableExporting]].
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * if (field.isExported()) console.log('Exporting is enabled')
     * ```
     * @returns Whether or not this field's value should be exported.
     */ PDFField.prototype.isExported = function() {
        return !this.acroField.hasFlag((0, $d5IrD.AcroFieldFlags).NoExport);
    };
    /**
     * Indicate that this field's value should be exported when the form is
     * submitted in a PDF reader. For example:
     * ```js
     * const field = form.getField('some.field')
     * field.enableExporting()
     * ```
     */ PDFField.prototype.enableExporting = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroFieldFlags).NoExport, false);
    };
    /**
     * Indicate that this field's value should **not** be exported when the form
     * is submitted in a PDF reader. For example:
     * ```js
     * const field = form.getField('some.field')
     * field.disableExporting()
     * ```
     */ PDFField.prototype.disableExporting = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroFieldFlags).NoExport, true);
    };
    /** @ignore */ PDFField.prototype.needsAppearancesUpdate = function() {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'needsAppearancesUpdate');
    };
    /** @ignore */ PDFField.prototype.defaultUpdateAppearances = function(_font) {
        throw new (0, $nAWRe.MethodNotImplementedError)(this.constructor.name, 'defaultUpdateAppearances');
    };
    PDFField.prototype.markAsDirty = function() {
        this.doc.getForm().markFieldAsDirty(this.ref);
    };
    PDFField.prototype.markAsClean = function() {
        this.doc.getForm().markFieldAsClean(this.ref);
    };
    PDFField.prototype.isDirty = function() {
        return this.doc.getForm().fieldIsDirty(this.ref);
    };
    PDFField.prototype.createWidget = function(options) {
        var _a;
        var textColor = options.textColor;
        var backgroundColor = options.backgroundColor;
        var borderColor = options.borderColor;
        var borderWidth = options.borderWidth;
        var degreesAngle = (0, $55HYh.toDegrees)(options.rotate);
        var caption = options.caption;
        var x = options.x;
        var y = options.y;
        var width = options.width + borderWidth;
        var height = options.height + borderWidth;
        var hidden = Boolean(options.hidden);
        var pageRef = options.page;
        (0, $j0tvB.assertMultiple)(degreesAngle, 'degreesAngle', 90);
        // Create a widget for this field
        var widget = (0, $7ds0z.default).create(this.doc.context, this.ref);
        // Set widget properties
        var rect = (0, $55HYh.rotateRectangle)({
            x: x,
            y: y,
            width: width,
            height: height
        }, borderWidth, degreesAngle);
        widget.setRectangle(rect);
        if (pageRef) widget.setP(pageRef);
        var ac = widget.getOrCreateAppearanceCharacteristics();
        if (backgroundColor) ac.setBackgroundColor((0, $gidDr.colorToComponents)(backgroundColor));
        ac.setRotation(degreesAngle);
        if (caption) ac.setCaptions({
            normal: caption
        });
        if (borderColor) ac.setBorderColor((0, $gidDr.colorToComponents)(borderColor));
        var bs = widget.getOrCreateBorderStyle();
        if (borderWidth !== undefined) bs.setWidth(borderWidth);
        widget.setFlagTo((0, $ckfWn.AnnotationFlags).Print, true);
        widget.setFlagTo((0, $ckfWn.AnnotationFlags).Hidden, hidden);
        widget.setFlagTo((0, $ckfWn.AnnotationFlags).Invisible, false);
        // Set acrofield properties
        if (textColor) {
            var da = (_a = this.acroField.getDefaultAppearance()) !== null && _a !== void 0 ? _a : '';
            var newDa = da + '\n' + (0, $gidDr.setFillingColor)(textColor).toString();
            this.acroField.setDefaultAppearance(newDa);
        }
        return widget;
    };
    PDFField.prototype.updateWidgetAppearanceWithFont = function(widget, font, _a) {
        var normal = _a.normal, rollover = _a.rollover, down = _a.down;
        this.updateWidgetAppearances(widget, {
            normal: this.createAppearanceStream(widget, normal, font),
            rollover: rollover && this.createAppearanceStream(widget, rollover, font),
            down: down && this.createAppearanceStream(widget, down, font)
        });
    };
    PDFField.prototype.updateOnOffWidgetAppearance = function(widget, onValue, _a) {
        var normal = _a.normal, rollover = _a.rollover, down = _a.down;
        this.updateWidgetAppearances(widget, {
            normal: this.createAppearanceDict(widget, normal, onValue),
            rollover: rollover && this.createAppearanceDict(widget, rollover, onValue),
            down: down && this.createAppearanceDict(widget, down, onValue)
        });
    };
    PDFField.prototype.updateWidgetAppearances = function(widget, _a) {
        var normal = _a.normal, rollover = _a.rollover, down = _a.down;
        widget.setNormalAppearance(normal);
        if (rollover) widget.setRolloverAppearance(rollover);
        else widget.removeRolloverAppearance();
        if (down) widget.setDownAppearance(down);
        else widget.removeDownAppearance();
    };
    // // TODO: Do we need to do this...?
    // private foo(font: PDFFont, dict: PDFDict) {
    //   if (!dict.lookup(PDFName.of('DR'))) {
    //     dict.set(PDFName.of('DR'), dict.context.obj({}));
    //   }
    //   const DR = dict.lookup(PDFName.of('DR'), PDFDict);
    //   if (!DR.lookup(PDFName.of('Font'))) {
    //     DR.set(PDFName.of('Font'), dict.context.obj({}));
    //   }
    //   const Font = DR.lookup(PDFName.of('Font'), PDFDict);
    //   Font.set(PDFName.of(font.name), font.ref);
    // }
    PDFField.prototype.createAppearanceStream = function(widget, appearance, font) {
        var _a;
        var context = this.acroField.dict.context;
        var _b = widget.getRectangle(), width = _b.width, height = _b.height;
        // TODO: Do we need to do this...?
        // if (font) {
        //   this.foo(font, widget.dict);
        //   this.foo(font, this.doc.getForm().acroForm.dict);
        // }
        // END TODO
        var Resources = font && {
            Font: (_a = {}, _a[font.name] = font.ref, _a)
        };
        var stream = context.formXObject(appearance, {
            Resources: Resources,
            BBox: context.obj([
                0,
                0,
                width,
                height
            ]),
            Matrix: context.obj([
                1,
                0,
                0,
                1,
                0,
                0
            ])
        });
        var streamRef = context.register(stream);
        return streamRef;
    };
    /**
     * Create a FormXObject of the supplied image and add it to context.
     * The FormXObject size is calculated based on the widget (including
     * the alignment).
     * @param widget The widget that should display the image.
     * @param alignment The alignment of the image.
     * @param image The image that should be displayed.
     * @returns The ref for the FormXObject that was added to the context.
     */ PDFField.prototype.createImageAppearanceStream = function(widget, image, alignment) {
        // NOTE: This implementation doesn't handle image borders.
        // NOTE: Acrobat seems to resize the image (maybe even skewing its aspect
        //       ratio) to fit perfectly within the widget's rectangle. This method
        //       does not currently do that. Should there be an option for that?
        var _a;
        var _b;
        var context = this.acroField.dict.context;
        var rectangle = widget.getRectangle();
        var ap = widget.getAppearanceCharacteristics();
        var bs = widget.getBorderStyle();
        var borderWidth = (_b = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _b !== void 0 ? _b : 0;
        var rotation = (0, $55HYh.reduceRotation)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
        var rotate = (0, $7mLHs.rotateInPlace)((0, $cOQTW.__assign)((0, $cOQTW.__assign)({}, rectangle), {
            rotation: rotation
        }));
        var adj = (0, $55HYh.adjustDimsForRotation)(rectangle, rotation);
        var imageDims = image.scaleToFit(adj.width - borderWidth * 2, adj.height - borderWidth * 2);
        // Support borders on images and maybe other properties
        var options = {
            x: borderWidth,
            y: borderWidth,
            width: imageDims.width,
            height: imageDims.height,
            //
            rotate: (0, $55HYh.degrees)(0),
            xSkew: (0, $55HYh.degrees)(0),
            ySkew: (0, $55HYh.degrees)(0)
        };
        if (alignment === (0, $gYSUQ.ImageAlignment).Center) {
            options.x += (adj.width - borderWidth * 2) / 2 - imageDims.width / 2;
            options.y += (adj.height - borderWidth * 2) / 2 - imageDims.height / 2;
        } else if (alignment === (0, $gYSUQ.ImageAlignment).Right) {
            options.x = adj.width - borderWidth - imageDims.width;
            options.y = adj.height - borderWidth - imageDims.height;
        }
        var imageName = this.doc.context.addRandomSuffix('Image', 10);
        var appearance = (0, $cOQTW.__spreadArrays)(rotate, (0, $7mLHs.drawImage)(imageName, options));
        ////////////
        var Resources = {
            XObject: (_a = {}, _a[imageName] = image.ref, _a)
        };
        var stream = context.formXObject(appearance, {
            Resources: Resources,
            BBox: context.obj([
                0,
                0,
                rectangle.width,
                rectangle.height
            ]),
            Matrix: context.obj([
                1,
                0,
                0,
                1,
                0,
                0
            ])
        });
        return context.register(stream);
    };
    PDFField.prototype.createAppearanceDict = function(widget, appearance, onValue) {
        var context = this.acroField.dict.context;
        var onStreamRef = this.createAppearanceStream(widget, appearance.on);
        var offStreamRef = this.createAppearanceStream(widget, appearance.off);
        var appearanceDict = context.obj({});
        appearanceDict.set(onValue, onStreamRef);
        appearanceDict.set((0, $dPHSK.default).of('Off'), offStreamRef);
        return appearanceDict;
    };
    return PDFField;
}();
var $9a88d5b8c9019f73$export$2e2bcd8739ae039 = $9a88d5b8c9019f73$var$PDFField;

});
parcelRegister("6vWdG", function(module, exports) {
$parcel$export(module.exports, "ImageAlignment", () => (parcelRequire("gYSUQ")).ImageAlignment);
parcelRequire("gYSUQ");

});
parcelRegister("gYSUQ", function(module, exports) {

$parcel$export(module.exports, "ImageAlignment", () => $c5ccd91931a24d5b$export$8efa99ca8f041e7e);
var $c5ccd91931a24d5b$export$8efa99ca8f041e7e;
(function(ImageAlignment) {
    ImageAlignment[ImageAlignment["Left"] = 0] = "Left";
    ImageAlignment[ImageAlignment["Center"] = 1] = "Center";
    ImageAlignment[ImageAlignment["Right"] = 2] = "Right";
})($c5ccd91931a24d5b$export$8efa99ca8f041e7e || ($c5ccd91931a24d5b$export$8efa99ca8f041e7e = {}));

});




parcelRegister("c2qg8", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c3a0a776d3c65cf$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $eq4Zh = parcelRequire("eq4Zh");

var $lzaL9 = parcelRequire("lzaL9");

var $dgAbg = parcelRequire("dgAbg");

var $ikSoM = parcelRequire("ikSoM");

var $gidDr = parcelRequire("gidDr");

var $55HYh = parcelRequire("55HYh");
parcelRequire("iT7lj");
var $d5IrD = parcelRequire("d5IrD");
var $4vDg3 = parcelRequire("4vDg3");
var $jWFiV = parcelRequire("jWFiV");
var $4CgUJ = parcelRequire("4CgUJ");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
/**
 * Represents a dropdown field of a [[PDFForm]].
 *
 * [[PDFDropdown]] fields are interactive text boxes that display a single
 * element (the currently selected value). The purpose of a dropdown is to
 * enable users to select a single option from a set of possible options. Users
 * can click on a dropdown to view the full list of options it provides.
 * Clicking on an option in the list will cause it to be selected and displayed
 * in the dropdown's text box. Some dropdowns allow users to enter text
 * directly into the box from their keyboard, rather than only being allowed to
 * choose an option from the list (see [[PDFDropdown.isEditable]]).
 */ var $8c3a0a776d3c65cf$var$PDFDropdown = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFDropdown, _super);
    function PDFDropdown(acroComboBox, ref, doc) {
        var _this = _super.call(this, acroComboBox, ref, doc) || this;
        (0, $j0tvB.assertIs)(acroComboBox, 'acroComboBox', [
            [
                (0, $4vDg3.default),
                'PDFAcroComboBox'
            ]
        ]);
        _this.acroField = acroComboBox;
        return _this;
    }
    /**
     * Get the list of available options for this dropdown. These options will be
     * displayed to users who click on this dropdown in a PDF reader.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * const options = dropdown.getOptions()
     * console.log('Dropdown options:', options)
     * ```
     * @returns The options for this dropdown.
     */ PDFDropdown.prototype.getOptions = function() {
        var rawOptions = this.acroField.getOptions();
        var options = new Array(rawOptions.length);
        for(var idx = 0, len = options.length; idx < len; idx++){
            var _a = rawOptions[idx], display = _a.display, value = _a.value;
            options[idx] = (display !== null && display !== void 0 ? display : value).decodeText();
        }
        return options;
    };
    /**
     * Get the selected options for this dropdown. These are the values that were
     * selected by a human user via a PDF reader, or programatically via
     * software.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * const selections = dropdown.getSelected()
     * console.log('Dropdown selections:', selections)
     * ```
     * > **NOTE:** Note that PDF readers only display one selected option when
     * > rendering dropdowns. However, the PDF specification does allow for
     * > multiple values to be selected in a dropdown. As such, the `pdf-lib`
     * > API supports this. However, in most cases the array returned by this
     * > method will contain only a single element (or no elements).
     * @returns The selected options in this dropdown.
     */ PDFDropdown.prototype.getSelected = function() {
        var values = this.acroField.getValues();
        var selected = new Array(values.length);
        for(var idx = 0, len = values.length; idx < len; idx++)selected[idx] = values[idx].decodeText();
        return selected;
    };
    /**
     * Set the list of options that are available for this dropdown. These are
     * the values that will be available for users to select when they view this
     * dropdown in a PDF reader. Note that preexisting options for this dropdown
     * will be removed. Only the values passed as `options` will be available to
     * select.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('planets.dropdown')
     * dropdown.setOptions(['Earth', 'Mars', 'Pluto', 'Venus'])
     * ```
     * @param options The options that should be available in this dropdown.
     */ PDFDropdown.prototype.setOptions = function(options) {
        (0, $j0tvB.assertIs)(options, 'options', [
            Array
        ]);
        var optionObjects = new Array(options.length);
        for(var idx = 0, len = options.length; idx < len; idx++)optionObjects[idx] = {
            value: (0, $jWFiV.default).fromText(options[idx])
        };
        this.acroField.setOptions(optionObjects);
    };
    /**
     * Add to the list of options that are available for this dropdown. Users
     * will be able to select these values in a PDF reader. In addition to the
     * values passed as `options`, any preexisting options for this dropdown will
     * still be available for users to select.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('rockets.dropdown')
     * dropdown.addOptions(['Saturn IV', 'Falcon Heavy'])
     * ```
     * @param options New options that should be available in this dropdown.
     */ PDFDropdown.prototype.addOptions = function(options) {
        (0, $j0tvB.assertIs)(options, 'options', [
            'string',
            Array
        ]);
        var optionsArr = Array.isArray(options) ? options : [
            options
        ];
        var existingOptions = this.acroField.getOptions();
        var newOptions = new Array(optionsArr.length);
        for(var idx = 0, len = optionsArr.length; idx < len; idx++)newOptions[idx] = {
            value: (0, $jWFiV.default).fromText(optionsArr[idx])
        };
        this.acroField.setOptions(existingOptions.concat(newOptions));
    };
    /**
     * Select one or more values for this dropdown. This operation is analogous
     * to a human user opening the dropdown in a PDF reader and clicking on a
     * value to select it. This method will update the underlying state of the
     * dropdown to indicate which values have been selected. PDF libraries and
     * readers will be able to extract these values from the saved document and
     * determine which values were selected.
     *
     * For example:
     * ```js
     * const dropdown = form.getDropdown('best.superhero.dropdown')
     * dropdown.select('One Punch Man')
     * ```
     *
     * This method will mark this dropdown as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated streams will
     * display the selected option inside the widgets of this dropdown.
     *
     * **IMPORTANT:** The default font used to update appearance streams is
     * [[StandardFonts.Helvetica]]. Note that this is a WinAnsi font. This means
     * that encoding errors will be thrown if the selected option for this field
     * contains characters outside the WinAnsi character set (the latin alphabet).
     *
     * Embedding a custom font and passing it to
     * [[PDFForm.updateFieldAppearances]] or [[PDFDropdown.updateAppearances]]
     * allows you to generate appearance streams with characters outside the
     * latin alphabet (assuming the custom font supports them).
     *
     * Selecting an option that does not exist in this dropdown's option list
     * (see [[PDFDropdown.getOptions]]) will enable editing on this dropdown
     * (see [[PDFDropdown.enableEditing]]).
     *
     * > **NOTE:** PDF readers only display one selected option when rendering
     * > dropdowns. However, the PDF specification does allow for multiple values
     * > to be selected in a dropdown. As such, the `pdf-lib` API supports this.
     * > However, it is not recommended to select more than one value with this
     * > method, as only one will be visible. [[PDFOptionList]] fields are better
     * > suited for displaying multiple selected values.
     *
     * @param options The options to be selected.
     * @param merge Whether or not existing selections should be preserved.
     */ PDFDropdown.prototype.select = function(options, merge) {
        if (merge === void 0) merge = false;
        (0, $j0tvB.assertIs)(options, 'options', [
            'string',
            Array
        ]);
        (0, $j0tvB.assertIs)(merge, 'merge', [
            'boolean'
        ]);
        var optionsArr = Array.isArray(options) ? options : [
            options
        ];
        var validOptions = this.getOptions();
        var hasCustomOption = optionsArr.find(function(option) {
            return !validOptions.includes(option);
        });
        if (hasCustomOption) this.enableEditing();
        this.markAsDirty();
        if (optionsArr.length > 1 || optionsArr.length === 1 && merge) this.enableMultiselect();
        var values = new Array(optionsArr.length);
        for(var idx = 0, len = optionsArr.length; idx < len; idx++)values[idx] = (0, $jWFiV.default).fromText(optionsArr[idx]);
        if (merge) {
            var existingValues = this.acroField.getValues();
            this.acroField.setValues(existingValues.concat(values));
        } else this.acroField.setValues(values);
    };
    /**
     * Clear all selected values for this dropdown. This operation is equivalent
     * to selecting an empty list. This method will update the underlying state
     * of the dropdown to indicate that no values have been selected.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.clear()
     * ```
     * This method will mark this text field as dirty. See [[PDFDropdown.select]]
     * for more details about what this means.
     */ PDFDropdown.prototype.clear = function() {
        this.markAsDirty();
        this.acroField.setValues([]);
    };
    /**
     * Set the font size for this field. Larger font sizes will result in larger
     * text being displayed when PDF readers render this dropdown. Font sizes may
     * be integer or floating point numbers. Supplying a negative font size will
     * cause this method to throw an error.
     *
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.setFontSize(4)
     * dropdown.setFontSize(15.7)
     * ```
     *
     * > This method depends upon the existence of a default appearance
     * > (`/DA`) string. If this field does not have a default appearance string,
     * > or that string does not contain a font size (via the `Tf` operator),
     * > then this method will throw an error.
     *
     * @param fontSize The font size to be used when rendering text in this field.
     */ PDFDropdown.prototype.setFontSize = function(fontSize) {
        (0, $j0tvB.assertPositive)(fontSize, 'fontSize');
        this.acroField.setFontSize(fontSize);
        this.markAsDirty();
    };
    /**
     * Returns `true` if users are allowed to edit the selected value of this
     * dropdown directly and are not constrained by the list of available
     * options. See [[PDFDropdown.enableEditing]] and
     * [[PDFDropdown.disableEditing]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isEditable()) console.log('Editing is enabled')
     * ```
     * @returns Whether or not this dropdown is editable.
     */ PDFDropdown.prototype.isEditable = function() {
        return this.acroField.hasFlag((0, $d5IrD.AcroChoiceFlags).Edit);
    };
    /**
     * Allow users to edit the selected value of this dropdown in PDF readers
     * with their keyboard. This means that the selected value of this dropdown
     * will not be constrained by the list of available options. However, if this
     * dropdown has any available options, users will still be allowed to select
     * from that list.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableEditing()
     * ```
     */ PDFDropdown.prototype.enableEditing = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroChoiceFlags).Edit, true);
    };
    /**
     * Do not allow users to edit the selected value of this dropdown in PDF
     * readers with their keyboard. This will constrain the selected value of
     * this dropdown to the list of available options. Users will only be able
     * to select an option from that list.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableEditing()
     * ```
     */ PDFDropdown.prototype.disableEditing = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroChoiceFlags).Edit, false);
    };
    /**
     * Returns `true` if the option list of this dropdown is always displayed
     * in alphabetical order, irrespective of the order in which the options
     * were added to the dropdown. See [[PDFDropdown.enableSorting]] and
     * [[PDFDropdown.disableSorting]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isSorted()) console.log('Sorting is enabled')
     * ```
     * @returns Whether or not this dropdown's options are sorted.
     */ PDFDropdown.prototype.isSorted = function() {
        return this.acroField.hasFlag((0, $d5IrD.AcroChoiceFlags).Sort);
    };
    /**
     * Always display the option list of this dropdown in alphabetical order,
     * irrespective of the order in which the options were added to this dropdown.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableSorting()
     * ```
     */ PDFDropdown.prototype.enableSorting = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroChoiceFlags).Sort, true);
    };
    /**
     * Do not always display the option list of this dropdown in alphabetical
     * order. Instead, display the options in whichever order they were added
     * to the list. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableSorting()
     * ```
     */ PDFDropdown.prototype.disableSorting = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroChoiceFlags).Sort, false);
    };
    /**
     * Returns `true` if multiple options can be selected from this dropdown's
     * option list. See [[PDFDropdown.enableMultiselect]] and
     * [[PDFDropdown.disableMultiselect]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isMultiselect()) console.log('Multiselect is enabled')
     * ```
     * @returns Whether or not multiple options can be selected.
     */ PDFDropdown.prototype.isMultiselect = function() {
        return this.acroField.hasFlag((0, $d5IrD.AcroChoiceFlags).MultiSelect);
    };
    /**
     * Allow users to select more than one option from this dropdown's option
     * list. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableMultiselect()
     * ```
     */ PDFDropdown.prototype.enableMultiselect = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroChoiceFlags).MultiSelect, true);
    };
    /**
     * Do not allow users to select more than one option from this dropdown's
     * option list. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableMultiselect()
     * ```
     */ PDFDropdown.prototype.disableMultiselect = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroChoiceFlags).MultiSelect, false);
    };
    /**
     * Returns `true` if the selected option should be spell checked by PDF
     * readers. Spell checking will only be performed if this dropdown allows
     * editing (see [[PDFDropdown.isEditable]]). See
     * [[PDFDropdown.enableSpellChecking]] and
     * [[PDFDropdown.disableSpellChecking]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isSpellChecked()) console.log('Spell checking is enabled')
     * ```
     * @returns Whether or not this dropdown can be spell checked.
     */ PDFDropdown.prototype.isSpellChecked = function() {
        return !this.acroField.hasFlag((0, $d5IrD.AcroChoiceFlags).DoNotSpellCheck);
    };
    /**
     * Allow PDF readers to spell check the selected option of this dropdown.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableSpellChecking()
     * ```
     */ PDFDropdown.prototype.enableSpellChecking = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroChoiceFlags).DoNotSpellCheck, false);
    };
    /**
     * Do not allow PDF readers to spell check the selected option of this
     * dropdown. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableSpellChecking()
     * ```
     */ PDFDropdown.prototype.disableSpellChecking = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroChoiceFlags).DoNotSpellCheck, true);
    };
    /**
     * Returns `true` if the option selected by a user is stored, or "committed",
     * when the user clicks the option. The alternative is that the user's
     * selection is stored when the user leaves this dropdown field (by clicking
     * outside of it - on another field, for example). See
     * [[PDFDropdown.enableSelectOnClick]] and
     * [[PDFDropdown.disableSelectOnClick]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isSelectOnClick()) console.log('Select on click is enabled')
     * ```
     * @returns Whether or not options are selected immediately after they are
     *          clicked.
     */ PDFDropdown.prototype.isSelectOnClick = function() {
        return this.acroField.hasFlag((0, $d5IrD.AcroChoiceFlags).CommitOnSelChange);
    };
    /**
     * Store the option selected by a user immediately after the user clicks the
     * option. Do not wait for the user to leave this dropdown field (by clicking
     * outside of it - on another field, for example). For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableSelectOnClick()
     * ```
     */ PDFDropdown.prototype.enableSelectOnClick = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroChoiceFlags).CommitOnSelChange, true);
    };
    /**
     * Wait to store the option selected by a user until they leave this dropdown
     * field (by clicking outside of it - on another field, for example).
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableSelectOnClick()
     * ```
     */ PDFDropdown.prototype.disableSelectOnClick = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroChoiceFlags).CommitOnSelChange, false);
    };
    /**
     * Show this dropdown on the specified page. For example:
     * ```js
     * const ubuntuFont = await pdfDoc.embedFont(ubuntuFontBytes)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const dropdown = form.createDropdown('best.gundam')
     * dropdown.setOptions(['Exia', 'Dynames'])
     * dropdown.select('Exia')
     *
     * dropdown.addToPage(page, {
     *   x: 50,
     *   y: 75,
     *   width: 200,
     *   height: 100,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     *   font: ubuntuFont,
     * })
     * ```
     * This will create a new widget for this dropdown field.
     * @param page The page to which this dropdown widget should be added.
     * @param options The options to be used when adding this dropdown widget.
     */ PDFDropdown.prototype.addToPage = function(page, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        (0, $j0tvB.assertIs)(page, 'page', [
            [
                (0, $eq4Zh.default),
                'PDFPage'
            ]
        ]);
        (0, $dgAbg.assertFieldAppearanceOptions)(options);
        if (!options) options = {};
        if (!('textColor' in options)) options.textColor = (0, $gidDr.rgb)(0, 0, 0);
        if (!('backgroundColor' in options)) options.backgroundColor = (0, $gidDr.rgb)(1, 1, 1);
        if (!('borderColor' in options)) options.borderColor = (0, $gidDr.rgb)(0, 0, 0);
        if (!('borderWidth' in options)) options.borderWidth = 1;
        // Create a widget for this dropdown
        var widget = this.createWidget({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 200,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 50,
            textColor: options.textColor,
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: (_e = options.borderWidth) !== null && _e !== void 0 ? _e : 0,
            rotate: (_f = options.rotate) !== null && _f !== void 0 ? _f : (0, $55HYh.degrees)(0),
            hidden: options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        var font = (_g = options.font) !== null && _g !== void 0 ? _g : this.doc.getForm().getDefaultFont();
        this.updateWidgetAppearance(widget, font);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if this dropdown has been marked as dirty, or if any of
     * this dropdown's widgets do not have an appearance stream. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this dropdown needs an appearance update.
     */ PDFDropdown.prototype.needsAppearancesUpdate = function() {
        var _a;
        if (this.isDirty()) return true;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var hasAppearances = ((_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal) instanceof (0, $4CgUJ.default);
            if (!hasAppearances) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this dropdown's widgets using
     * the default appearance provider for dropdowns. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.defaultUpdateAppearances(helvetica)
     * ```
     * @param font The font to be used for creating the appearance streams.
     */ PDFDropdown.prototype.defaultUpdateAppearances = function(font) {
        (0, $j0tvB.assertIs)(font, 'font', [
            [
                (0, $lzaL9.default),
                'PDFFont'
            ]
        ]);
        this.updateAppearances(font);
    };
    /**
     * Update the appearance streams for each of this dropdown's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for dropdowns will be used. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.updateAppearances(helvetica, (field, widget, font) => {
     *   ...
     *   return drawTextField(...)
     * })
     * ```
     * @param font The font to be used for creating the appearance streams.
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFDropdown.prototype.updateAppearances = function(font, provider) {
        (0, $j0tvB.assertIs)(font, 'font', [
            [
                (0, $lzaL9.default),
                'PDFFont'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            this.updateWidgetAppearance(widget, font, provider);
        }
        this.markAsClean();
    };
    // getOption(index: number): string {}
    // getSelectedIndices(): number[] {}
    // removeOptions(option: string | string[]) {}
    // removeIndices(option: number[]) {}
    // deselect(options: string | string[]) {}
    // deselectIndices(optionIndices: number[]) {}
    PDFDropdown.prototype.updateWidgetAppearance = function(widget, font, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $ikSoM.defaultDropdownAppearanceProvider);
        var appearances = (0, $ikSoM.normalizeAppearance)(apProvider(this, widget, font));
        this.updateWidgetAppearanceWithFont(widget, font, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getDropdown]] method, which will create an
     * > instance of [[PDFDropdown]] for you.
     *
     * Create an instance of [[PDFDropdown]] from an existing acroComboBox and ref
     *
     * @param acroComboBox The underlying `PDFAcroComboBox` for this dropdown.
     * @param ref The unique reference for this dropdown.
     * @param doc The document to which this dropdown will belong.
     */ PDFDropdown.of = function(acroComboBox, ref, doc) {
        return new PDFDropdown(acroComboBox, ref, doc);
    };
    return PDFDropdown;
}((0, $dgAbg.default));
var $8c3a0a776d3c65cf$export$2e2bcd8739ae039 = $8c3a0a776d3c65cf$var$PDFDropdown;

});

parcelRegister("5Apvp", function(module, exports) {

$parcel$export(module.exports, "default", () => $41141972e5bafa05$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $eq4Zh = parcelRequire("eq4Zh");

var $lzaL9 = parcelRequire("lzaL9");

var $dgAbg = parcelRequire("dgAbg");

var $ikSoM = parcelRequire("ikSoM");

var $gidDr = parcelRequire("gidDr");

var $55HYh = parcelRequire("55HYh");
parcelRequire("iT7lj");
var $d5IrD = parcelRequire("d5IrD");
var $gEqSi = parcelRequire("gEqSi");
var $jWFiV = parcelRequire("jWFiV");
var $4CgUJ = parcelRequire("4CgUJ");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
/**
 * Represents an option list field of a [[PDFForm]].
 *
 * [[PDFOptionList]] fields are interactive lists of options. The purpose of an
 * option list is to enable users to select one or more options from a set of
 * possible options. Users are able to see the full set of options without
 * first having to click on the field (though scrolling may be necessary).
 * Clicking an option in the list will cause it to be selected and displayed
 * with a highlighted background. Some option lists allow users to select
 * more than one option (see [[PDFOptionList.isMultiselect]]).
 */ var $41141972e5bafa05$var$PDFOptionList = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFOptionList, _super);
    function PDFOptionList(acroListBox, ref, doc) {
        var _this = _super.call(this, acroListBox, ref, doc) || this;
        (0, $j0tvB.assertIs)(acroListBox, 'acroListBox', [
            [
                (0, $gEqSi.default),
                'PDFAcroListBox'
            ]
        ]);
        _this.acroField = acroListBox;
        return _this;
    }
    /**
     * Get the list of available options for this option list. These options will
     * be displayed to users who view this option list in a PDF reader.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * const options = optionList.getOptions()
     * console.log('Option List options:', options)
     * ```
     * @returns The options for this option list.
     */ PDFOptionList.prototype.getOptions = function() {
        var rawOptions = this.acroField.getOptions();
        var options = new Array(rawOptions.length);
        for(var idx = 0, len = options.length; idx < len; idx++){
            var _a = rawOptions[idx], display = _a.display, value = _a.value;
            options[idx] = (display !== null && display !== void 0 ? display : value).decodeText();
        }
        return options;
    };
    /**
     * Get the selected options for this option list. These are the values that
     * were selected by a human user via a PDF reader, or programatically via
     * software.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * const selections = optionList.getSelected()
     * console.log('Option List selections:', selections)
     * ```
     * @returns The selected options for this option list.
     */ PDFOptionList.prototype.getSelected = function() {
        var values = this.acroField.getValues();
        var selected = new Array(values.length);
        for(var idx = 0, len = values.length; idx < len; idx++)selected[idx] = values[idx].decodeText();
        return selected;
    };
    /**
     * Set the list of options that are available for this option list. These are
     * the values that will be available for users to select when they view this
     * option list in a PDF reader. Note that preexisting options for this
     * option list will be removed. Only the values passed as `options` will be
     * available to select.
     *
     * For example:
     * ```js
     * const optionList = form.getOptionList('planets.optionList')
     * optionList.setOptions(['Earth', 'Mars', 'Pluto', 'Venus'])
     * ```
     *
     * This method will mark this option list as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated streams will
     * display the options this field contains inside the widgets of this text
     * field (with selected options highlighted).
     *
     * **IMPORTANT:** The default font used to update appearance streams is
     * [[StandardFonts.Helvetica]]. Note that this is a WinAnsi font. This means
     * that encoding errors will be thrown if this field contains any options
     * with characters outside the WinAnsi character set (the latin alphabet).
     *
     * Embedding a custom font and passing it to
     * [[PDFForm.updateFieldAppearances]] or [[PDFOptionList.updateAppearances]]
     * allows you to generate appearance streams with characters outside the
     * latin alphabet (assuming the custom font supports them).
     *
     * @param options The options that should be available in this option list.
     */ PDFOptionList.prototype.setOptions = function(options) {
        (0, $j0tvB.assertIs)(options, 'options', [
            Array
        ]);
        this.markAsDirty();
        var optionObjects = new Array(options.length);
        for(var idx = 0, len = options.length; idx < len; idx++)optionObjects[idx] = {
            value: (0, $jWFiV.default).fromText(options[idx])
        };
        this.acroField.setOptions(optionObjects);
    };
    /**
     * Add to the list of options that are available for this option list. Users
     * will be able to select these values in a PDF reader. In addition to the
     * values passed as `options`, any preexisting options for this option list
     * will still be available for users to select.
     * For example:
     * ```js
     * const optionList = form.getOptionList('rockets.optionList')
     * optionList.addOptions(['Saturn IV', 'Falcon Heavy'])
     * ```
     * This method will mark this option list as dirty. See
     * [[PDFOptionList.setOptions]] for more details about what this means.
     * @param options New options that should be available in this option list.
     */ PDFOptionList.prototype.addOptions = function(options) {
        (0, $j0tvB.assertIs)(options, 'options', [
            'string',
            Array
        ]);
        this.markAsDirty();
        var optionsArr = Array.isArray(options) ? options : [
            options
        ];
        var existingOptions = this.acroField.getOptions();
        var newOptions = new Array(optionsArr.length);
        for(var idx = 0, len = optionsArr.length; idx < len; idx++)newOptions[idx] = {
            value: (0, $jWFiV.default).fromText(optionsArr[idx])
        };
        this.acroField.setOptions(existingOptions.concat(newOptions));
    };
    /**
     * Select one or more values for this option list. This operation is analogous
     * to a human user opening the option list in a PDF reader and clicking on one
     * or more values to select them. This method will update the underlying state
     * of the option list to indicate which values have been selected. PDF
     * libraries and readers will be able to extract these values from the saved
     * document and determine which values were selected.
     * For example:
     * ```js
     * const optionList = form.getOptionList('best.superheroes.optionList')
     * optionList.select(['One Punch Man', 'Iron Man'])
     * ```
     * This method will mark this option list as dirty. See
     * [[PDFOptionList.setOptions]] for more details about what this means.
     * @param options The options to be selected.
     * @param merge Whether or not existing selections should be preserved.
     */ PDFOptionList.prototype.select = function(options, merge) {
        if (merge === void 0) merge = false;
        (0, $j0tvB.assertIs)(options, 'options', [
            'string',
            Array
        ]);
        (0, $j0tvB.assertIs)(merge, 'merge', [
            'boolean'
        ]);
        var optionsArr = Array.isArray(options) ? options : [
            options
        ];
        var validOptions = this.getOptions();
        (0, $j0tvB.assertIsSubset)(optionsArr, 'option', validOptions);
        this.markAsDirty();
        if (optionsArr.length > 1 || optionsArr.length === 1 && merge) this.enableMultiselect();
        var values = new Array(optionsArr.length);
        for(var idx = 0, len = optionsArr.length; idx < len; idx++)values[idx] = (0, $jWFiV.default).fromText(optionsArr[idx]);
        if (merge) {
            var existingValues = this.acroField.getValues();
            this.acroField.setValues(existingValues.concat(values));
        } else this.acroField.setValues(values);
    };
    /**
     * Clear all selected values for this option list. This operation is
     * equivalent to selecting an empty list. This method will update the
     * underlying state of the option list to indicate that no values have been
     * selected.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.clear()
     * ```
     * This method will mark this option list as dirty. See
     * [[PDFOptionList.setOptions]] for more details about what this means.
     */ PDFOptionList.prototype.clear = function() {
        this.markAsDirty();
        this.acroField.setValues([]);
    };
    /**
     * Set the font size for the text in this field. There needs to be a
     * default appearance string (DA) set with a font value specified
     * for this to work. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.setFontSize(4);
     * ```
     * @param fontSize The font size to set the font to.
     */ /**
     * Set the font size for this field. Larger font sizes will result in larger
     * text being displayed when PDF readers render this option list. Font sizes
     * may be integer or floating point numbers. Supplying a negative font size
     * will cause this method to throw an error.
     *
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.setFontSize(4)
     * optionList.setFontSize(15.7)
     * ```
     *
     * > This method depends upon the existence of a default appearance
     * > (`/DA`) string. If this field does not have a default appearance string,
     * > or that string does not contain a font size (via the `Tf` operator),
     * > then this method will throw an error.
     *
     * @param fontSize The font size to be used when rendering text in this field.
     */ PDFOptionList.prototype.setFontSize = function(fontSize) {
        (0, $j0tvB.assertPositive)(fontSize, 'fontSize');
        this.acroField.setFontSize(fontSize);
        this.markAsDirty();
    };
    /**
     * Returns `true` if the options of this option list are always displayed
     * in alphabetical order, irrespective of the order in which the options
     * were added to the option list. See [[PDFOptionList.enableSorting]] and
     * [[PDFOptionList.disableSorting]]. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * if (optionList.isSorted()) console.log('Sorting is enabled')
     * ```
     * @returns Whether or not this option list is sorted.
     */ PDFOptionList.prototype.isSorted = function() {
        return this.acroField.hasFlag((0, $d5IrD.AcroChoiceFlags).Sort);
    };
    /**
     * Always display the options of this option list in alphabetical order,
     * irrespective of the order in which the options were added to this option
     * list.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.enableSorting()
     * ```
     */ PDFOptionList.prototype.enableSorting = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroChoiceFlags).Sort, true);
    };
    /**
     * Do not always display the options of this option list in alphabetical
     * order. Instead, display the options in whichever order they were added
     * to this option list. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.disableSorting()
     * ```
     */ PDFOptionList.prototype.disableSorting = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroChoiceFlags).Sort, false);
    };
    /**
     * Returns `true` if multiple options can be selected from this option list.
     * See [[PDFOptionList.enableMultiselect]] and
     * [[PDFOptionList.disableMultiselect]]. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * if (optionList.isMultiselect()) console.log('Multiselect is enabled')
     * ```
     * @returns Whether or not multiple options can be selected.
     */ PDFOptionList.prototype.isMultiselect = function() {
        return this.acroField.hasFlag((0, $d5IrD.AcroChoiceFlags).MultiSelect);
    };
    /**
     * Allow users to select more than one option from this option list.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.enableMultiselect()
     * ```
     */ PDFOptionList.prototype.enableMultiselect = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroChoiceFlags).MultiSelect, true);
    };
    /**
     * Do not allow users to select more than one option from this option list.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.disableMultiselect()
     * ```
     */ PDFOptionList.prototype.disableMultiselect = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroChoiceFlags).MultiSelect, false);
    };
    /**
     * Returns `true` if the option selected by a user is stored, or "committed",
     * when the user clicks the option. The alternative is that the user's
     * selection is stored when the user leaves this option list field (by
     * clicking outside of it - on another field, for example). See
     * [[PDFOptionList.enableSelectOnClick]] and
     * [[PDFOptionList.disableSelectOnClick]]. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * if (optionList.isSelectOnClick()) console.log('Select on click is enabled')
     * ```
     * @returns Whether or not options are selected immediately after they are
     *          clicked.
     */ PDFOptionList.prototype.isSelectOnClick = function() {
        return this.acroField.hasFlag((0, $d5IrD.AcroChoiceFlags).CommitOnSelChange);
    };
    /**
     * Store the option selected by a user immediately after the user clicks the
     * option. Do not wait for the user to leave this option list field (by
     * clicking outside of it - on another field, for example). For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.enableSelectOnClick()
     * ```
     */ PDFOptionList.prototype.enableSelectOnClick = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroChoiceFlags).CommitOnSelChange, true);
    };
    /**
     * Wait to store the option selected by a user until they leave this option
     * list field (by clicking outside of it - on another field, for example).
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.disableSelectOnClick()
     * ```
     */ PDFOptionList.prototype.disableSelectOnClick = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroChoiceFlags).CommitOnSelChange, false);
    };
    /**
     * Show this option list on the specified page. For example:
     * ```js
     * const ubuntuFont = await pdfDoc.embedFont(ubuntuFontBytes)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const optionList = form.createOptionList('best.gundams')
     * optionList.setOptions(['Exia', 'Dynames', 'Kyrios', 'Virtue'])
     * optionList.select(['Exia', 'Virtue'])
     *
     * optionList.addToPage(page, {
     *   x: 50,
     *   y: 75,
     *   width: 200,
     *   height: 100,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     *   font: ubuntuFont,
     * })
     * ```
     * This will create a new widget for this option list field.
     * @param page The page to which this option list widget should be added.
     * @param options The options to be used when adding this option list widget.
     */ PDFOptionList.prototype.addToPage = function(page, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        (0, $j0tvB.assertIs)(page, 'page', [
            [
                (0, $eq4Zh.default),
                'PDFPage'
            ]
        ]);
        (0, $dgAbg.assertFieldAppearanceOptions)(options);
        if (!options) options = {};
        if (!('textColor' in options)) options.textColor = (0, $gidDr.rgb)(0, 0, 0);
        if (!('backgroundColor' in options)) options.backgroundColor = (0, $gidDr.rgb)(1, 1, 1);
        if (!('borderColor' in options)) options.borderColor = (0, $gidDr.rgb)(0, 0, 0);
        if (!('borderWidth' in options)) options.borderWidth = 1;
        // Create a widget for this option list
        var widget = this.createWidget({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 200,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 100,
            textColor: options.textColor,
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: (_e = options.borderWidth) !== null && _e !== void 0 ? _e : 0,
            rotate: (_f = options.rotate) !== null && _f !== void 0 ? _f : (0, $55HYh.degrees)(0),
            hidden: options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        var font = (_g = options.font) !== null && _g !== void 0 ? _g : this.doc.getForm().getDefaultFont();
        this.updateWidgetAppearance(widget, font);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if this option list has been marked as dirty, or if any of
     * this option list's widgets do not have an appearance stream. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * if (optionList.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this option list needs an appearance update.
     */ PDFOptionList.prototype.needsAppearancesUpdate = function() {
        var _a;
        if (this.isDirty()) return true;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var hasAppearances = ((_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal) instanceof (0, $4CgUJ.default);
            if (!hasAppearances) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this option list's widgets using
     * the default appearance provider for option lists. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.defaultUpdateAppearances(helvetica)
     * ```
     * @param font The font to be used for creating the appearance streams.
     */ PDFOptionList.prototype.defaultUpdateAppearances = function(font) {
        (0, $j0tvB.assertIs)(font, 'font', [
            [
                (0, $lzaL9.default),
                'PDFFont'
            ]
        ]);
        this.updateAppearances(font);
    };
    /**
     * Update the appearance streams for each of this option list's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for option lists will be used. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.updateAppearances(helvetica, (field, widget, font) => {
     *   ...
     *   return drawOptionList(...)
     * })
     * ```
     * @param font The font to be used for creating the appearance streams.
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFOptionList.prototype.updateAppearances = function(font, provider) {
        (0, $j0tvB.assertIs)(font, 'font', [
            [
                (0, $lzaL9.default),
                'PDFFont'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            this.updateWidgetAppearance(widget, font, provider);
        }
        this.markAsClean();
    };
    // getOption(index: number): string {}
    // getSelectedIndices(): number[] {}
    // removeOptions(option: string | string[]) {}
    // removeIndices(option: number[]) {}
    // deselect(options: string | string[]) {}
    // deselectIndices(optionIndices: number[]) {}
    PDFOptionList.prototype.updateWidgetAppearance = function(widget, font, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $ikSoM.defaultOptionListAppearanceProvider);
        var appearances = (0, $ikSoM.normalizeAppearance)(apProvider(this, widget, font));
        this.updateWidgetAppearanceWithFont(widget, font, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getOptionList]] method, which will create
     * > an instance of [[PDFOptionList]] for you.
     *
     * Create an instance of [[PDFOptionList]] from an existing acroListBox and
     * ref
     *
     * @param acroComboBox The underlying `PDFAcroListBox` for this option list.
     * @param ref The unique reference for this option list.
     * @param doc The document to which this option list will belong.
     */ PDFOptionList.of = function(acroListBox, ref, doc) {
        return new PDFOptionList(acroListBox, ref, doc);
    };
    return PDFOptionList;
}((0, $dgAbg.default));
var $41141972e5bafa05$export$2e2bcd8739ae039 = $41141972e5bafa05$var$PDFOptionList;

});

parcelRegister("1DKij", function(module, exports) {

$parcel$export(module.exports, "default", () => $131d580cd94f5347$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $eq4Zh = parcelRequire("eq4Zh");

var $dgAbg = parcelRequire("dgAbg");

var $ikSoM = parcelRequire("ikSoM");

var $gidDr = parcelRequire("gidDr");

var $55HYh = parcelRequire("55HYh");
parcelRequire("iT7lj");
var $d5IrD = parcelRequire("d5IrD");
var $hpItd = parcelRequire("hpItd");
var $brir8 = parcelRequire("brir8");
var $jWFiV = parcelRequire("jWFiV");
var $dPHSK = parcelRequire("dPHSK");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
/**
 * Represents a radio group field of a [[PDFForm]].
 *
 * [[PDFRadioGroup]] fields are collections of radio buttons. The purpose of a
 * radio group is to enable users to select one option from a set of mutually
 * exclusive choices. Each choice in a radio group is represented by a radio
 * button. Radio buttons each have two states: `on` and `off`. At most one
 * radio button in a group may be in the `on` state at any time. Users can
 * click on a radio button to select it (and thereby automatically deselect any
 * other radio button that might have already been selected). Some radio
 * groups allow users to toggle a selected radio button `off` by clicking on
 * it (see [[PDFRadioGroup.isOffToggleable]]).
 *
 * Note that some radio groups allow multiple radio buttons to be in the `on`
 * state at the same type **if** they represent the same underlying value (see
 * [[PDFRadioGroup.isMutuallyExclusive]]).
 */ var $131d580cd94f5347$var$PDFRadioGroup = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFRadioGroup, _super);
    function PDFRadioGroup(acroRadioButton, ref, doc) {
        var _this = _super.call(this, acroRadioButton, ref, doc) || this;
        (0, $j0tvB.assertIs)(acroRadioButton, 'acroRadioButton', [
            [
                (0, $hpItd.default),
                'PDFAcroRadioButton'
            ]
        ]);
        _this.acroField = acroRadioButton;
        return _this;
    }
    /**
     * Get the list of available options for this radio group. Each option is
     * represented by a radio button. These radio buttons are displayed at
     * various locations in the document, potentially on different pages (though
     * typically they are stacked horizontally or vertically on the same page).
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * const options = radioGroup.getOptions()
     * console.log('Radio Group options:', options)
     * ```
     * @returns The options for this radio group.
     */ PDFRadioGroup.prototype.getOptions = function() {
        var exportValues = this.acroField.getExportValues();
        if (exportValues) {
            var exportOptions = new Array(exportValues.length);
            for(var idx = 0, len = exportValues.length; idx < len; idx++)exportOptions[idx] = exportValues[idx].decodeText();
            return exportOptions;
        }
        var onValues = this.acroField.getOnValues();
        var onOptions = new Array(onValues.length);
        for(var idx = 0, len = onOptions.length; idx < len; idx++)onOptions[idx] = onValues[idx].decodeText();
        return onOptions;
    };
    /**
     * Get the selected option for this radio group. The selected option is
     * represented by the radio button in this group that is turned on. At most
     * one radio button in a group can be selected. If no buttons in this group
     * are selected, `undefined` is returned.
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * const selected = radioGroup.getSelected()
     * console.log('Selected radio button:', selected)
     * ```
     * @returns The selected option for this radio group.
     */ PDFRadioGroup.prototype.getSelected = function() {
        var value = this.acroField.getValue();
        if (value === (0, $dPHSK.default).of('Off')) return undefined;
        var exportValues = this.acroField.getExportValues();
        if (exportValues) {
            var onValues = this.acroField.getOnValues();
            for(var idx = 0, len = onValues.length; idx < len; idx++){
                if (onValues[idx] === value) return exportValues[idx].decodeText();
            }
        }
        return value.decodeText();
    };
    // // TODO: Figure out why this seems to crash Acrobat. Maybe it's because we
    // //       aren't removing the widget reference from the page's Annots?
    // removeOption(option: string) {
    //   assertIs(option, 'option', ['string']);
    //   // TODO: Assert is valid `option`!
    //   const onValues = this.acroField.getOnValues();
    //   const exportValues = this.acroField.getExportValues();
    //   if (exportValues) {
    //     for (let idx = 0, len = exportValues.length; idx < len; idx++) {
    //       if (exportValues[idx].decodeText() === option) {
    //         this.acroField.removeWidget(idx);
    //         this.acroField.removeExportValue(idx);
    //       }
    //     }
    //   } else {
    //     for (let idx = 0, len = onValues.length; idx < len; idx++) {
    //       const value = onValues[idx];
    //       if (value.decodeText() === option) {
    //         this.acroField.removeWidget(idx);
    //         this.acroField.removeExportValue(idx);
    //       }
    //     }
    //   }
    // }
    /**
     * Select an option for this radio group. This operation is analogous to a
     * human user clicking one of the radio buttons in this group via a PDF
     * reader to toggle it on. This method will update the underlying state of
     * the radio group to indicate which option has been selected. PDF libraries
     * and readers will be able to extract this value from the saved document and
     * determine which option was selected.
     *
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('best.superhero.radioGroup')
     * radioGroup.select('One Punch Man')
     * ```
     *
     * This method will mark this radio group as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated appearance
     * streams will display a dot inside the widget of this check box field
     * that represents the selected option.
     *
     * @param option The option to be selected.
     */ PDFRadioGroup.prototype.select = function(option) {
        (0, $j0tvB.assertIs)(option, 'option', [
            'string'
        ]);
        var validOptions = this.getOptions();
        (0, $j0tvB.assertIsOneOf)(option, 'option', validOptions);
        this.markAsDirty();
        var onValues = this.acroField.getOnValues();
        var exportValues = this.acroField.getExportValues();
        if (exportValues) {
            for(var idx = 0, len = exportValues.length; idx < len; idx++)if (exportValues[idx].decodeText() === option) this.acroField.setValue(onValues[idx]);
        } else for(var idx = 0, len = onValues.length; idx < len; idx++){
            var value = onValues[idx];
            if (value.decodeText() === option) this.acroField.setValue(value);
        }
    };
    /**
     * Clear any selected option for this dropdown. This will result in all
     * radio buttons in this group being toggled off. This method will update
     * the underlying state of the dropdown to indicate that no radio buttons
     * have been selected.
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.clear()
     * ```
     * This method will mark this radio group as dirty. See
     * [[PDFRadioGroup.select]] for more details about what this means.
     */ PDFRadioGroup.prototype.clear = function() {
        this.markAsDirty();
        this.acroField.setValue((0, $dPHSK.default).of('Off'));
    };
    /**
     * Returns `true` if users can click on radio buttons in this group to toggle
     * them off. The alternative is that once a user clicks on a radio button
     * to select it, the only way to deselect it is by selecting on another radio
     * button in the group. See [[PDFRadioGroup.enableOffToggling]] and
     * [[PDFRadioGroup.disableOffToggling]]. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * if (radioGroup.isOffToggleable()) console.log('Off toggling is enabled')
     * ```
     */ PDFRadioGroup.prototype.isOffToggleable = function() {
        return !this.acroField.hasFlag((0, $d5IrD.AcroButtonFlags).NoToggleToOff);
    };
    /**
     * Allow users to click on selected radio buttons in this group to toggle
     * them off. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.enableOffToggling()
     * ```
     * > **NOTE:** This feature is documented in the PDF specification
     * > (Table 226). However, most PDF readers do not respect this option and
     * > prevent users from toggling radio buttons off even when it is enabled.
     * > At the time of this writing (9/6/2020) Mac's Preview software did
     * > respect the option. Adobe Acrobat, Foxit Reader, and Google Chrome did
     * > not.
     */ PDFRadioGroup.prototype.enableOffToggling = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroButtonFlags).NoToggleToOff, false);
    };
    /**
     * Prevent users from clicking on selected radio buttons in this group to
     * toggle them off. Clicking on a selected radio button will have no effect.
     * The only way to deselect a selected radio button is to click on a
     * different radio button in the group. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.disableOffToggling()
     * ```
     */ PDFRadioGroup.prototype.disableOffToggling = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroButtonFlags).NoToggleToOff, true);
    };
    /**
     * Returns `true` if the radio buttons in this group are mutually exclusive.
     * This means that when the user selects a radio button, only that specific
     * button will be turned on. Even if other radio buttons in the group
     * represent the same value, they will not be enabled. The alternative to
     * this is that clicking a radio button will select that button along with
     * any other radio buttons in the group that share the same value. See
     * [[PDFRadioGroup.enableMutualExclusion]] and
     * [[PDFRadioGroup.disableMutualExclusion]].
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * if (radioGroup.isMutuallyExclusive()) console.log('Mutual exclusion is enabled')
     * ```
     */ PDFRadioGroup.prototype.isMutuallyExclusive = function() {
        return !this.acroField.hasFlag((0, $d5IrD.AcroButtonFlags).RadiosInUnison);
    };
    /**
     * When the user clicks a radio button in this group it will be selected. In
     * addition, any other radio buttons in this group that share the same
     * underlying value will also be selected. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.enableMutualExclusion()
     * ```
     * Note that this option must be enabled prior to adding options to the
     * radio group. It does not currently apply retroactively to existing
     * radio buttons in the group.
     */ PDFRadioGroup.prototype.enableMutualExclusion = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroButtonFlags).RadiosInUnison, false);
    };
    /**
     * When the user clicks a radio button in this group only it will be selected.
     * No other radio buttons in the group will be selected, even if they share
     * the same underlying value. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.disableMutualExclusion()
     * ```
     * Note that this option must be disabled prior to adding options to the
     * radio group. It does not currently apply retroactively to existing
     * radio buttons in the group.
     */ PDFRadioGroup.prototype.disableMutualExclusion = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroButtonFlags).RadiosInUnison, true);
    };
    /**
     * Add a new radio button to this group on the specified page. For example:
     * ```js
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const radioGroup = form.createRadioGroup('best.gundam')
     *
     * const options = {
     *   x: 50,
     *   width: 25,
     *   height: 25,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     * }
     *
     * radioGroup.addOptionToPage('Exia', page, { ...options, y: 50 })
     * radioGroup.addOptionToPage('Dynames', page, { ...options, y: 110 })
     * ```
     * This will create a new radio button widget for this radio group field.
     * @param option The option that the radio button widget represents.
     * @param page The page to which the radio button widget should be added.
     * @param options The options to be used when adding the radio button widget.
     */ PDFRadioGroup.prototype.addOptionToPage = function(option, page, options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        (0, $j0tvB.assertIs)(option, 'option', [
            'string'
        ]);
        (0, $j0tvB.assertIs)(page, 'page', [
            [
                (0, $eq4Zh.default),
                'PDFPage'
            ]
        ]);
        (0, $dgAbg.assertFieldAppearanceOptions)(options);
        // Create a widget for this radio button
        var widget = this.createWidget({
            x: (_a = options === null || options === void 0 ? void 0 : options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options === null || options === void 0 ? void 0 : options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options === null || options === void 0 ? void 0 : options.width) !== null && _c !== void 0 ? _c : 50,
            height: (_d = options === null || options === void 0 ? void 0 : options.height) !== null && _d !== void 0 ? _d : 50,
            textColor: (_e = options === null || options === void 0 ? void 0 : options.textColor) !== null && _e !== void 0 ? _e : (0, $gidDr.rgb)(0, 0, 0),
            backgroundColor: (_f = options === null || options === void 0 ? void 0 : options.backgroundColor) !== null && _f !== void 0 ? _f : (0, $gidDr.rgb)(1, 1, 1),
            borderColor: (_g = options === null || options === void 0 ? void 0 : options.borderColor) !== null && _g !== void 0 ? _g : (0, $gidDr.rgb)(0, 0, 0),
            borderWidth: (_h = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _h !== void 0 ? _h : 1,
            rotate: (_j = options === null || options === void 0 ? void 0 : options.rotate) !== null && _j !== void 0 ? _j : (0, $55HYh.degrees)(0),
            hidden: options === null || options === void 0 ? void 0 : options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        var apStateValue = this.acroField.addWidgetWithOpt(widgetRef, (0, $jWFiV.default).fromText(option), !this.isMutuallyExclusive());
        // Set appearance streams for widget
        widget.setAppearanceState((0, $dPHSK.default).of('Off'));
        this.updateWidgetAppearance(widget, apStateValue);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if any of this group's radio button widgets do not have an
     * appearance stream for their current state. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * if (radioGroup.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this radio group needs an appearance update.
     */ PDFRadioGroup.prototype.needsAppearancesUpdate = function() {
        var _a;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var state = widget.getAppearanceState();
            var normal = (_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal;
            if (!(normal instanceof (0, $brir8.default))) return true;
            if (state && !normal.has(state)) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this group's radio button widgets
     * using the default appearance provider for radio groups. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.defaultUpdateAppearances()
     * ```
     */ PDFRadioGroup.prototype.defaultUpdateAppearances = function() {
        this.updateAppearances();
    };
    // rg.updateAppearances((field: any, widget: any) => {
    //   assert(field === rg);
    //   assert(widget instanceof PDFWidgetAnnotation);
    //   return { on: [...rectangle, ...circle], off: [...rectangle, ...circle] };
    // });
    /**
     * Update the appearance streams for each of this group's radio button widgets
     * using the given appearance provider. If no `provider` is passed, the
     * default appearance provider for radio groups will be used. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.updateAppearances((field, widget) => {
     *   ...
     *   return {
     *     normal: { on: drawRadioButton(...), off: drawRadioButton(...) },
     *     down: { on: drawRadioButton(...), off: drawRadioButton(...) },
     *   }
     * })
     * ```
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFRadioGroup.prototype.updateAppearances = function(provider) {
        (0, $j0tvB.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var onValue = widget.getOnValue();
            if (!onValue) continue;
            this.updateWidgetAppearance(widget, onValue, provider);
        }
    };
    PDFRadioGroup.prototype.updateWidgetAppearance = function(widget, onValue, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $ikSoM.defaultRadioGroupAppearanceProvider);
        var appearances = (0, $ikSoM.normalizeAppearance)(apProvider(this, widget));
        this.updateOnOffWidgetAppearance(widget, onValue, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getOptionList]] method, which will create an
     * > instance of [[PDFOptionList]] for you.
     *
     * Create an instance of [[PDFOptionList]] from an existing acroRadioButton
     * and ref
     *
     * @param acroRadioButton The underlying `PDFAcroRadioButton` for this
     *                        radio group.
     * @param ref The unique reference for this radio group.
     * @param doc The document to which this radio group will belong.
     */ PDFRadioGroup.of = function(acroRadioButton, ref, doc) {
        return new PDFRadioGroup(acroRadioButton, ref, doc);
    };
    return PDFRadioGroup;
}((0, $dgAbg.default));
var $131d580cd94f5347$export$2e2bcd8739ae039 = $131d580cd94f5347$var$PDFRadioGroup;

});

parcelRegister("hzhWN", function(module, exports) {

$parcel$export(module.exports, "default", () => $cca3a084a6440272$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $dgAbg = parcelRequire("dgAbg");
parcelRequire("iT7lj");
var $7hDvO = parcelRequire("7hDvO");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
/**
 * Represents a signature field of a [[PDFForm]].
 *
 * [[PDFSignature]] fields are digital signatures. `pdf-lib` does not
 * currently provide any specialized APIs for creating digital signatures or
 * reading the contents of existing digital signatures.
 */ var $cca3a084a6440272$var$PDFSignature = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFSignature, _super);
    function PDFSignature(acroSignature, ref, doc) {
        var _this = _super.call(this, acroSignature, ref, doc) || this;
        (0, $j0tvB.assertIs)(acroSignature, 'acroSignature', [
            [
                (0, $7hDvO.default),
                'PDFAcroSignature'
            ]
        ]);
        _this.acroField = acroSignature;
        return _this;
    }
    PDFSignature.prototype.needsAppearancesUpdate = function() {
        return false;
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getSignature]] method, which will create an
     * > instance of [[PDFSignature]] for you.
     *
     * Create an instance of [[PDFSignature]] from an existing acroSignature and
     * ref
     *
     * @param acroSignature The underlying `PDFAcroSignature` for this signature.
     * @param ref The unique reference for this signature.
     * @param doc The document to which this signature will belong.
     */ PDFSignature.of = function(acroSignature, ref, doc) {
        return new PDFSignature(acroSignature, ref, doc);
    };
    return PDFSignature;
}((0, $dgAbg.default));
var $cca3a084a6440272$export$2e2bcd8739ae039 = $cca3a084a6440272$var$PDFSignature;

});

parcelRegister("lqhKQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f989cc5b81a68a40$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $eq4Zh = parcelRequire("eq4Zh");

var $lzaL9 = parcelRequire("lzaL9");

var $dgAbg = parcelRequire("dgAbg");

var $ikSoM = parcelRequire("ikSoM");

var $gidDr = parcelRequire("gidDr");

var $55HYh = parcelRequire("55HYh");

var $aYJvX = parcelRequire("aYJvX");

var $gYSUQ = parcelRequire("gYSUQ");

var $5rdXu = parcelRequire("5rdXu");
parcelRequire("iT7lj");
var $d5IrD = parcelRequire("d5IrD");
var $clInn = parcelRequire("clInn");
var $jWFiV = parcelRequire("jWFiV");
var $4CgUJ = parcelRequire("4CgUJ");
parcelRequire("fvYKZ");
var $j0tvB = parcelRequire("j0tvB");
/**
 * Represents a text field of a [[PDFForm]].
 *
 * [[PDFTextField]] fields are boxes that display text entered by the user. The
 * purpose of a text field is to enable users to enter text or view text values
 * in the document prefilled by software. Users can click on a text field and
 * input text via their keyboard. Some text fields allow multiple lines of text
 * to be entered (see [[PDFTextField.isMultiline]]).
 */ var $f989cc5b81a68a40$var$PDFTextField = /** @class */ function(_super) {
    (0, $cOQTW.__extends)(PDFTextField, _super);
    function PDFTextField(acroText, ref, doc) {
        var _this = _super.call(this, acroText, ref, doc) || this;
        (0, $j0tvB.assertIs)(acroText, 'acroText', [
            [
                (0, $clInn.default),
                'PDFAcroText'
            ]
        ]);
        _this.acroField = acroText;
        return _this;
    }
    /**
     * Get the text that this field contains. This text is visible to users who
     * view this field in a PDF reader.
     *
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * const text = textField.getText()
     * console.log('Text field contents:', text)
     * ```
     *
     * Note that if this text field contains no underlying value, `undefined`
     * will be returned. Text fields may also contain an underlying value that
     * is simply an empty string (`''`). This detail is largely irrelevant for
     * most applications. In general, you'll want to treat both cases the same
     * way and simply consider the text field to be empty. In either case, the
     * text field will appear empty to users when viewed in a PDF reader.
     *
     * An error will be thrown if this is a rich text field. `pdf-lib` does not
     * support reading rich text fields. Nor do most PDF readers and writers.
     * Rich text fields are based on XFA (XML Forms Architecture). Relatively few
     * PDFs use rich text fields or XFA. Unlike PDF itself, XFA is not an ISO
     * standard. XFA has been deprecated in PDF 2.0:
     * * https://en.wikipedia.org/wiki/XFA
     * * http://blog.pdfshareforms.com/pdf-2-0-release-bid-farewell-xfa-forms/
     *
     * @returns The text contained in this text field.
     */ PDFTextField.prototype.getText = function() {
        var value = this.acroField.getValue();
        if (!value && this.isRichFormatted()) throw new (0, $aYJvX.RichTextFieldReadError)(this.getName());
        return value === null || value === void 0 ? void 0 : value.decodeText();
    };
    /**
     * Set the text for this field. This operation is analogous to a human user
     * clicking on the text field in a PDF reader and typing in text via their
     * keyboard. This method will update the underlying state of the text field
     * to indicate what text has been set. PDF libraries and readers will be able
     * to extract these values from the saved document and determine what text
     * was set.
     *
     * For example:
     * ```js
     * const textField = form.getTextField('best.superhero.text.field')
     * textField.setText('One Punch Man')
     * ```
     *
     * This method will mark this text field as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated streams will
     * display the text this field contains inside the widgets of this text
     * field.
     *
     * **IMPORTANT:** The default font used to update appearance streams is
     * [[StandardFonts.Helvetica]]. Note that this is a WinAnsi font. This means
     * that encoding errors will be thrown if this field contains text outside
     * the WinAnsi character set (the latin alphabet).
     *
     * Embedding a custom font and passing it to
     * [[PDFForm.updateFieldAppearances]] or [[PDFTextField.updateAppearances]]
     * allows you to generate appearance streams with characters outside the
     * latin alphabet (assuming the custom font supports them).
     *
     * If this is a rich text field, it will be converted to a standard text
     * field in order to set the text. `pdf-lib` does not support writing rich
     * text strings. Nor do most PDF readers and writers. See
     * [[PDFTextField.getText]] for more information about rich text fields and
     * their deprecation in PDF 2.0.
     *
     * @param text The text this field should contain.
     */ PDFTextField.prototype.setText = function(text) {
        (0, $j0tvB.assertOrUndefined)(text, 'text', [
            'string'
        ]);
        var maxLength = this.getMaxLength();
        if (maxLength !== undefined && text && text.length > maxLength) throw new (0, $aYJvX.ExceededMaxLengthError)(text.length, maxLength, this.getName());
        this.markAsDirty();
        this.disableRichFormatting();
        if (text) this.acroField.setValue((0, $jWFiV.default).fromText(text));
        else this.acroField.removeValue();
    };
    /**
     * Get the alignment for this text field. This value represents the
     * justification of the text when it is displayed to the user in PDF readers.
     * There are three possible alignments: left, center, and right. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * const alignment = textField.getAlignment()
     * if (alignment === TextAlignment.Left) console.log('Text is left justified')
     * if (alignment === TextAlignment.Center) console.log('Text is centered')
     * if (alignment === TextAlignment.Right) console.log('Text is right justified')
     * ```
     * @returns The alignment of this text field.
     */ PDFTextField.prototype.getAlignment = function() {
        var quadding = this.acroField.getQuadding();
        // prettier-ignore
        return quadding === 0 ? (0, $5rdXu.TextAlignment).Left : quadding === 1 ? (0, $5rdXu.TextAlignment).Center : quadding === 2 ? (0, $5rdXu.TextAlignment).Right : (0, $5rdXu.TextAlignment).Left;
    };
    /**
     * Set the alignment for this text field. This will determine the
     * justification of the text when it is displayed to the user in PDF readers.
     * There are three possible alignments: left, center, and right. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     *
     * // Text will be left justified when displayed
     * textField.setAlignment(TextAlignment.Left)
     *
     * // Text will be centered when displayed
     * textField.setAlignment(TextAlignment.Center)
     *
     * // Text will be right justified when displayed
     * textField.setAlignment(TextAlignment.Right)
     * ```
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     * @param alignment The alignment for this text field.
     */ PDFTextField.prototype.setAlignment = function(alignment) {
        (0, $j0tvB.assertIsOneOf)(alignment, 'alignment', (0, $5rdXu.TextAlignment));
        this.markAsDirty();
        this.acroField.setQuadding(alignment);
    };
    /**
     * Get the maximum length of this field. This value represents the maximum
     * number of characters that can be typed into this field by the user. If
     * this field does not have a maximum length, `undefined` is returned.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * const maxLength = textField.getMaxLength()
     * if (maxLength === undefined) console.log('No max length')
     * else console.log(`Max length is ${maxLength}`)
     * ```
     * @returns The maximum number of characters allowed in this field, or
     *          `undefined` if no limit exists.
     */ PDFTextField.prototype.getMaxLength = function() {
        return this.acroField.getMaxLength();
    };
    /**
     * Set the maximum length of this field. This limits the number of characters
     * that can be typed into this field by the user. This also limits the length
     * of the string that can be passed to [[PDFTextField.setText]]. This limit
     * can be removed by passing `undefined` as `maxLength`. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     *
     * // Allow between 0 and 5 characters to be entered
     * textField.setMaxLength(5)
     *
     * // Allow any number of characters to be entered
     * textField.setMaxLength(undefined)
     * ```
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     * @param maxLength The maximum number of characters allowed in this field, or
     *                  `undefined` to remove the limit.
     */ PDFTextField.prototype.setMaxLength = function(maxLength) {
        (0, $j0tvB.assertRangeOrUndefined)(maxLength, 'maxLength', 0, Number.MAX_SAFE_INTEGER);
        this.markAsDirty();
        if (maxLength === undefined) this.acroField.removeMaxLength();
        else {
            var text = this.getText();
            if (text && text.length > maxLength) throw new (0, $aYJvX.InvalidMaxLengthError)(text.length, maxLength, this.getName());
            this.acroField.setMaxLength(maxLength);
        }
    };
    /**
     * Remove the maximum length for this text field. This allows any number of
     * characters to be typed into this field by the user. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.removeMaxLength()
     * ```
     * Calling this method is equivalent to passing `undefined` to
     * [[PDFTextField.setMaxLength]].
     */ PDFTextField.prototype.removeMaxLength = function() {
        this.markAsDirty();
        this.acroField.removeMaxLength();
    };
    /**
     * Display an image inside the bounds of this text field's widgets. For example:
     * ```js
     * const pngImage = await pdfDoc.embedPng(...)
     * const textField = form.getTextField('some.text.field')
     * textField.setImage(pngImage)
     * ```
     * This will update the appearances streams for each of this text field's widgets.
     * @param image The image that should be displayed.
     */ PDFTextField.prototype.setImage = function(image) {
        var fieldAlignment = this.getAlignment();
        // prettier-ignore
        var alignment = fieldAlignment === (0, $5rdXu.TextAlignment).Center ? (0, $gYSUQ.ImageAlignment).Center : fieldAlignment === (0, $5rdXu.TextAlignment).Right ? (0, $gYSUQ.ImageAlignment).Right : (0, $gYSUQ.ImageAlignment).Left;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var streamRef = this.createImageAppearanceStream(widget, image, alignment);
            this.updateWidgetAppearances(widget, {
                normal: streamRef
            });
        }
        this.markAsClean();
    };
    /**
     * Set the font size for this field. Larger font sizes will result in larger
     * text being displayed when PDF readers render this text field. Font sizes
     * may be integer or floating point numbers. Supplying a negative font size
     * will cause this method to throw an error.
     *
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.setFontSize(4)
     * textField.setFontSize(15.7)
     * ```
     *
     * > This method depends upon the existence of a default appearance
     * > (`/DA`) string. If this field does not have a default appearance string,
     * > or that string does not contain a font size (via the `Tf` operator),
     * > then this method will throw an error.
     *
     * @param fontSize The font size to be used when rendering text in this field.
     */ PDFTextField.prototype.setFontSize = function(fontSize) {
        (0, $j0tvB.assertPositive)(fontSize, 'fontSize');
        this.acroField.setFontSize(fontSize);
        this.markAsDirty();
    };
    /**
     * Returns `true` if each line of text is shown on a new line when this
     * field is displayed in a PDF reader. The alternative is that all lines of
     * text are merged onto a single line when displayed. See
     * [[PDFTextField.enableMultiline]] and [[PDFTextField.disableMultiline]].
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isMultiline()) console.log('Multiline is enabled')
     * ```
     * @returns Whether or not this is a multiline text field.
     */ PDFTextField.prototype.isMultiline = function() {
        return this.acroField.hasFlag((0, $d5IrD.AcroTextFlags).Multiline);
    };
    /**
     * Display each line of text on a new line when this field is displayed in a
     * PDF reader. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableMultiline()
     * ```
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     */ PDFTextField.prototype.enableMultiline = function() {
        this.markAsDirty();
        this.acroField.setFlagTo((0, $d5IrD.AcroTextFlags).Multiline, true);
    };
    /**
     * Display each line of text on the same line when this field is displayed
     * in a PDF reader. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableMultiline()
     * ```
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     */ PDFTextField.prototype.disableMultiline = function() {
        this.markAsDirty();
        this.acroField.setFlagTo((0, $d5IrD.AcroTextFlags).Multiline, false);
    };
    /**
     * Returns `true` if this is a password text field. This means that the field
     * is intended for storing a secure password. See
     * [[PDFTextField.enablePassword]] and [[PDFTextField.disablePassword]].
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isPassword()) console.log('Password is enabled')
     * ```
     * @returns Whether or not this is a password text field.
     */ PDFTextField.prototype.isPassword = function() {
        return this.acroField.hasFlag((0, $d5IrD.AcroTextFlags).Password);
    };
    /**
     * Indicate that this text field is intended for storing a secure password.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enablePassword()
     * ```
     * Values entered into password text fields should not be displayed on the
     * screen by PDF readers. Most PDF readers will display the value as
     * asterisks or bullets. PDF readers should never store values entered by the
     * user into password text fields. Similarly, applications should not
     * write data to a password text field.
     *
     * **Please note that this method does not cause entered values to be
     * encrypted or secured in any way! It simply sets a flag that PDF software
     * and readers can access to determine the _purpose_ of this field.**
     */ PDFTextField.prototype.enablePassword = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroTextFlags).Password, true);
    };
    /**
     * Indicate that this text field is **not** intended for storing a secure
     * password. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disablePassword()
     * ```
     */ PDFTextField.prototype.disablePassword = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroTextFlags).Password, false);
    };
    /**
     * Returns `true` if the contents of this text field represent a file path.
     * See [[PDFTextField.enableFileSelection]] and
     * [[PDFTextField.disableFileSelection]]. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isFileSelector()) console.log('Is a file selector')
     * ```
     * @returns Whether or not this field should contain file paths.
     */ PDFTextField.prototype.isFileSelector = function() {
        return this.acroField.hasFlag((0, $d5IrD.AcroTextFlags).FileSelect);
    };
    /**
     * Indicate that this text field is intended to store a file path. The
     * contents of the file stored at that path should be submitted as the value
     * of the field. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableFileSelection()
     * ```
     */ PDFTextField.prototype.enableFileSelection = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroTextFlags).FileSelect, true);
    };
    /**
     * Indicate that this text field is **not** intended to store a file path.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableFileSelection()
     * ```
     */ PDFTextField.prototype.disableFileSelection = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroTextFlags).FileSelect, false);
    };
    /**
     * Returns `true` if the text entered in this field should be spell checked
     * by PDF readers. See [[PDFTextField.enableSpellChecking]] and
     * [[PDFTextField.disableSpellChecking]]. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isSpellChecked()) console.log('Spell checking is enabled')
     * ```
     * @returns Whether or not this field should be spell checked.
     */ PDFTextField.prototype.isSpellChecked = function() {
        return !this.acroField.hasFlag((0, $d5IrD.AcroTextFlags).DoNotSpellCheck);
    };
    /**
     * Allow PDF readers to spell check the text entered in this field.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableSpellChecking()
     * ```
     */ PDFTextField.prototype.enableSpellChecking = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroTextFlags).DoNotSpellCheck, false);
    };
    /**
     * Do not allow PDF readers to spell check the text entered in this field.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableSpellChecking()
     * ```
     */ PDFTextField.prototype.disableSpellChecking = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroTextFlags).DoNotSpellCheck, true);
    };
    /**
     * Returns `true` if PDF readers should allow the user to scroll the text
     * field when its contents do not fit within the field's view bounds. See
     * [[PDFTextField.enableScrolling]] and [[PDFTextField.disableScrolling]].
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isScrollable()) console.log('Scrolling is enabled')
     * ```
     * @returns Whether or not the field is scrollable in PDF readers.
     */ PDFTextField.prototype.isScrollable = function() {
        return !this.acroField.hasFlag((0, $d5IrD.AcroTextFlags).DoNotScroll);
    };
    /**
     * Allow PDF readers to present a scroll bar to the user when the contents
     * of this text field do not fit within its view bounds. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableScrolling()
     * ```
     * A horizontal scroll bar should be shown for singleline fields. A vertical
     * scroll bar should be shown for multiline fields.
     */ PDFTextField.prototype.enableScrolling = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroTextFlags).DoNotScroll, false);
    };
    /**
     * Do not allow PDF readers to present a scroll bar to the user when the
     * contents of this text field do not fit within its view bounds. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableScrolling()
     * ```
     */ PDFTextField.prototype.disableScrolling = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroTextFlags).DoNotScroll, true);
    };
    /**
     * Returns `true` if this is a combed text field. This means that the field
     * is split into `n` equal size cells with one character in each (where `n`
     * is equal to the max length of the text field). The result is that all
     * characters in this field are displayed an equal distance apart from one
     * another. See [[PDFTextField.enableCombing]] and
     * [[PDFTextField.disableCombing]]. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isCombed()) console.log('Combing is enabled')
     * ```
     * Note that in order for a text field to be combed, the following must be
     * true (in addition to enabling combing):
     * * It must not be a multiline field (see [[PDFTextField.isMultiline]])
     * * It must not be a password field (see [[PDFTextField.isPassword]])
     * * It must not be a file selector field (see [[PDFTextField.isFileSelector]])
     * * It must have a max length defined (see [[PDFTextField.setMaxLength]])
     * @returns Whether or not this field is combed.
     */ PDFTextField.prototype.isCombed = function() {
        return this.acroField.hasFlag((0, $d5IrD.AcroTextFlags).Comb) && !this.isMultiline() && !this.isPassword() && !this.isFileSelector() && this.getMaxLength() !== undefined;
    };
    /**
     * Split this field into `n` equal size cells with one character in each
     * (where `n` is equal to the max length of the text field). This will cause
     * all characters in the field to be displayed an equal distance apart from
     * one another. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableCombing()
     * ```
     *
     * In addition to calling this method, text fields must have a max length
     * defined in order to be combed (see [[PDFTextField.setMaxLength]]).
     *
     * This method will also call the following three methods internally:
     * * [[PDFTextField.disableMultiline]]
     * * [[PDFTextField.disablePassword]]
     * * [[PDFTextField.disableFileSelection]]
     *
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     */ PDFTextField.prototype.enableCombing = function() {
        if (this.getMaxLength() === undefined) {
            var msg = "PDFTextFields must have a max length in order to be combed";
            console.warn(msg);
        }
        this.markAsDirty();
        this.disableMultiline();
        this.disablePassword();
        this.disableFileSelection();
        this.acroField.setFlagTo((0, $d5IrD.AcroTextFlags).Comb, true);
    };
    /**
     * Turn off combing for this text field. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableCombing()
     * ```
     * See [[PDFTextField.isCombed]] and [[PDFTextField.enableCombing]] for more
     * information about what combing is.
     *
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     */ PDFTextField.prototype.disableCombing = function() {
        this.markAsDirty();
        this.acroField.setFlagTo((0, $d5IrD.AcroTextFlags).Comb, false);
    };
    /**
     * Returns `true` if this text field contains rich text. See
     * [[PDFTextField.enableRichFormatting]] and
     * [[PDFTextField.disableRichFormatting]]. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isRichFormatted()) console.log('Rich formatting enabled')
     * ```
     * @returns Whether or not this field contains rich text.
     */ PDFTextField.prototype.isRichFormatted = function() {
        return this.acroField.hasFlag((0, $d5IrD.AcroTextFlags).RichText);
    };
    /**
     * Indicate that this field contains XFA data - or rich text. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableRichFormatting()
     * ```
     * Note that `pdf-lib` does not support reading or writing rich text fields.
     * Nor do most PDF readers and writers. Rich text fields are based on XFA
     * (XML Forms Architecture). Relatively few PDFs use rich text fields or XFA.
     * Unlike PDF itself, XFA is not an ISO standard. XFA has been deprecated in
     * PDF 2.0:
     * * https://en.wikipedia.org/wiki/XFA
     * * http://blog.pdfshareforms.com/pdf-2-0-release-bid-farewell-xfa-forms/
     */ PDFTextField.prototype.enableRichFormatting = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroTextFlags).RichText, true);
    };
    /**
     * Indicate that this is a standard text field that does not XFA data (rich
     * text). For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableRichFormatting()
     * ```
     */ PDFTextField.prototype.disableRichFormatting = function() {
        this.acroField.setFlagTo((0, $d5IrD.AcroTextFlags).RichText, false);
    };
    /**
     * Show this text field on the specified page. For example:
     * ```js
     * const ubuntuFont = await pdfDoc.embedFont(ubuntuFontBytes)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const textField = form.createTextField('best.gundam')
     * textField.setText('Exia')
     *
     * textField.addToPage(page, {
     *   x: 50,
     *   y: 75,
     *   width: 200,
     *   height: 100,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     *   font: ubuntuFont,
     * })
     * ```
     * This will create a new widget for this text field.
     * @param page The page to which this text field widget should be added.
     * @param options The options to be used when adding this text field widget.
     */ PDFTextField.prototype.addToPage = function(page, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        (0, $j0tvB.assertIs)(page, 'page', [
            [
                (0, $eq4Zh.default),
                'PDFPage'
            ]
        ]);
        (0, $dgAbg.assertFieldAppearanceOptions)(options);
        if (!options) options = {};
        if (!('textColor' in options)) options.textColor = (0, $gidDr.rgb)(0, 0, 0);
        if (!('backgroundColor' in options)) options.backgroundColor = (0, $gidDr.rgb)(1, 1, 1);
        if (!('borderColor' in options)) options.borderColor = (0, $gidDr.rgb)(0, 0, 0);
        if (!('borderWidth' in options)) options.borderWidth = 1;
        // Create a widget for this text field
        var widget = this.createWidget({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 200,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 50,
            textColor: options.textColor,
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: (_e = options.borderWidth) !== null && _e !== void 0 ? _e : 0,
            rotate: (_f = options.rotate) !== null && _f !== void 0 ? _f : (0, $55HYh.degrees)(0),
            hidden: options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        var font = (_g = options.font) !== null && _g !== void 0 ? _g : this.doc.getForm().getDefaultFont();
        this.updateWidgetAppearance(widget, font);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if this text field has been marked as dirty, or if any of
     * this text field's widgets do not have an appearance stream. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this text field needs an appearance update.
     */ PDFTextField.prototype.needsAppearancesUpdate = function() {
        var _a;
        if (this.isDirty()) return true;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var hasAppearances = ((_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal) instanceof (0, $4CgUJ.default);
            if (!hasAppearances) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this text field's widgets using
     * the default appearance provider for text fields. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const textField = form.getTextField('some.text.field')
     * textField.defaultUpdateAppearances(helvetica)
     * ```
     * @param font The font to be used for creating the appearance streams.
     */ PDFTextField.prototype.defaultUpdateAppearances = function(font) {
        (0, $j0tvB.assertIs)(font, 'font', [
            [
                (0, $lzaL9.default),
                'PDFFont'
            ]
        ]);
        this.updateAppearances(font);
    };
    /**
     * Update the appearance streams for each of this text field's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for text fields will be used. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const textField = form.getTextField('some.text.field')
     * textField.updateAppearances(helvetica, (field, widget, font) => {
     *   ...
     *   return drawTextField(...)
     * })
     * ```
     * @param font The font to be used for creating the appearance streams.
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFTextField.prototype.updateAppearances = function(font, provider) {
        (0, $j0tvB.assertIs)(font, 'font', [
            [
                (0, $lzaL9.default),
                'PDFFont'
            ]
        ]);
        (0, $j0tvB.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            this.updateWidgetAppearance(widget, font, provider);
        }
        this.markAsClean();
    };
    PDFTextField.prototype.updateWidgetAppearance = function(widget, font, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $ikSoM.defaultTextFieldAppearanceProvider);
        var appearances = (0, $ikSoM.normalizeAppearance)(apProvider(this, widget, font));
        this.updateWidgetAppearanceWithFont(widget, font, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getTextField]] method, which will create an
     * > instance of [[PDFTextField]] for you.
     *
     * Create an instance of [[PDFTextField]] from an existing acroText and ref
     *
     * @param acroText The underlying `PDFAcroText` for this text field.
     * @param ref The unique reference for this text field.
     * @param doc The document to which this text field will belong.
     */ PDFTextField.of = function(acroText, ref, doc) {
        return new PDFTextField(acroText, ref, doc);
    };
    return PDFTextField;
}((0, $dgAbg.default));
var $f989cc5b81a68a40$export$2e2bcd8739ae039 = $f989cc5b81a68a40$var$PDFTextField;

});

parcelRegister("i4gUC", function(module, exports) {

$parcel$export(module.exports, "StandardFonts", () => $d275b823cf3c6e5b$export$7dcb046109e65a3d);
var $d275b823cf3c6e5b$export$7dcb046109e65a3d;
(function(StandardFonts) {
    StandardFonts["Courier"] = "Courier";
    StandardFonts["CourierBold"] = "Courier-Bold";
    StandardFonts["CourierOblique"] = "Courier-Oblique";
    StandardFonts["CourierBoldOblique"] = "Courier-BoldOblique";
    StandardFonts["Helvetica"] = "Helvetica";
    StandardFonts["HelveticaBold"] = "Helvetica-Bold";
    StandardFonts["HelveticaOblique"] = "Helvetica-Oblique";
    StandardFonts["HelveticaBoldOblique"] = "Helvetica-BoldOblique";
    StandardFonts["TimesRoman"] = "Times-Roman";
    StandardFonts["TimesRomanBold"] = "Times-Bold";
    StandardFonts["TimesRomanItalic"] = "Times-Italic";
    StandardFonts["TimesRomanBoldItalic"] = "Times-BoldItalic";
    StandardFonts["Symbol"] = "Symbol";
    StandardFonts["ZapfDingbats"] = "ZapfDingbats";
})($d275b823cf3c6e5b$export$7dcb046109e65a3d || ($d275b823cf3c6e5b$export$7dcb046109e65a3d = {}));

});


parcelRegister("gjdfV", function(module, exports) {

$parcel$export(module.exports, "PageSizes", () => $bdf8b405f72f9bf0$export$b4a05ae367f5515c);
var $bdf8b405f72f9bf0$export$b4a05ae367f5515c = {
    '4A0': [
        4767.87,
        6740.79
    ],
    '2A0': [
        3370.39,
        4767.87
    ],
    A0: [
        2383.94,
        3370.39
    ],
    A1: [
        1683.78,
        2383.94
    ],
    A2: [
        1190.55,
        1683.78
    ],
    A3: [
        841.89,
        1190.55
    ],
    A4: [
        595.28,
        841.89
    ],
    A5: [
        419.53,
        595.28
    ],
    A6: [
        297.64,
        419.53
    ],
    A7: [
        209.76,
        297.64
    ],
    A8: [
        147.4,
        209.76
    ],
    A9: [
        104.88,
        147.4
    ],
    A10: [
        73.7,
        104.88
    ],
    B0: [
        2834.65,
        4008.19
    ],
    B1: [
        2004.09,
        2834.65
    ],
    B2: [
        1417.32,
        2004.09
    ],
    B3: [
        1000.63,
        1417.32
    ],
    B4: [
        708.66,
        1000.63
    ],
    B5: [
        498.9,
        708.66
    ],
    B6: [
        354.33,
        498.9
    ],
    B7: [
        249.45,
        354.33
    ],
    B8: [
        175.75,
        249.45
    ],
    B9: [
        124.72,
        175.75
    ],
    B10: [
        87.87,
        124.72
    ],
    C0: [
        2599.37,
        3676.54
    ],
    C1: [
        1836.85,
        2599.37
    ],
    C2: [
        1298.27,
        1836.85
    ],
    C3: [
        918.43,
        1298.27
    ],
    C4: [
        649.13,
        918.43
    ],
    C5: [
        459.21,
        649.13
    ],
    C6: [
        323.15,
        459.21
    ],
    C7: [
        229.61,
        323.15
    ],
    C8: [
        161.57,
        229.61
    ],
    C9: [
        113.39,
        161.57
    ],
    C10: [
        79.37,
        113.39
    ],
    RA0: [
        2437.8,
        3458.27
    ],
    RA1: [
        1729.13,
        2437.8
    ],
    RA2: [
        1218.9,
        1729.13
    ],
    RA3: [
        864.57,
        1218.9
    ],
    RA4: [
        609.45,
        864.57
    ],
    SRA0: [
        2551.18,
        3628.35
    ],
    SRA1: [
        1814.17,
        2551.18
    ],
    SRA2: [
        1275.59,
        1814.17
    ],
    SRA3: [
        907.09,
        1275.59
    ],
    SRA4: [
        637.8,
        907.09
    ],
    Executive: [
        521.86,
        756.0
    ],
    Folio: [
        612.0,
        936.0
    ],
    Legal: [
        612.0,
        1008.0
    ],
    Letter: [
        612.0,
        792.0
    ],
    Tabloid: [
        792.0,
        1224.0
    ]
};

});

parcelRegister("dJaLP", function(module, exports) {

$parcel$export(module.exports, "ParseSpeeds", () => $9fe7d517881d9f8b$export$ba19d141a3749548);
var $9fe7d517881d9f8b$export$ba19d141a3749548;
(function(ParseSpeeds) {
    ParseSpeeds[ParseSpeeds["Fastest"] = Infinity] = "Fastest";
    ParseSpeeds[ParseSpeeds["Fast"] = 1500] = "Fast";
    ParseSpeeds[ParseSpeeds["Medium"] = 500] = "Medium";
    ParseSpeeds[ParseSpeeds["Slow"] = 100] = "Slow";
})($9fe7d517881d9f8b$export$ba19d141a3749548 || ($9fe7d517881d9f8b$export$ba19d141a3749548 = {}));

});

parcelRegister("C6azw", function(module, exports) {

$parcel$export(module.exports, "default", () => $072855dc9321c2b4$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");
parcelRequire("iT7lj");
var $8auL6 = parcelRequire("8auL6");
var $brir8 = parcelRequire("brir8");
var $jWFiV = parcelRequire("jWFiV");
var $dPHSK = parcelRequire("dPHSK");
/**
 * Represents a file that has been embedded in a [[PDFDocument]].
 */ var $072855dc9321c2b4$var$PDFEmbeddedFile = /** @class */ function() {
    function PDFEmbeddedFile(ref, doc, embedder) {
        this.alreadyEmbedded = false;
        this.ref = ref;
        this.doc = doc;
        this.embedder = embedder;
    }
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all embeddable files get embedded.
     *
     * Embed this embeddable file in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFEmbeddedFile.prototype.embed = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var ref, Names, EmbeddedFiles, EFNames, AF;
            return (0, $cOQTW.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.alreadyEmbedded) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.embedder.embedIntoContext(this.doc.context, this.ref)
                        ];
                    case 1:
                        ref = _a.sent();
                        if (!this.doc.catalog.has((0, $dPHSK.default).of('Names'))) this.doc.catalog.set((0, $dPHSK.default).of('Names'), this.doc.context.obj({}));
                        Names = this.doc.catalog.lookup((0, $dPHSK.default).of('Names'), (0, $brir8.default));
                        if (!Names.has((0, $dPHSK.default).of('EmbeddedFiles'))) Names.set((0, $dPHSK.default).of('EmbeddedFiles'), this.doc.context.obj({}));
                        EmbeddedFiles = Names.lookup((0, $dPHSK.default).of('EmbeddedFiles'), (0, $brir8.default));
                        if (!EmbeddedFiles.has((0, $dPHSK.default).of('Names'))) EmbeddedFiles.set((0, $dPHSK.default).of('Names'), this.doc.context.obj([]));
                        EFNames = EmbeddedFiles.lookup((0, $dPHSK.default).of('Names'), (0, $8auL6.default));
                        EFNames.push((0, $jWFiV.default).fromText(this.embedder.fileName));
                        EFNames.push(ref);
                        /**
                         * The AF-Tag is needed to achieve PDF-A3 compliance for embedded files
                         *
                         * The following document outlines the uses cases of the associated files (AF) tag.
                         * See:
                         * https://www.pdfa.org/wp-content/uploads/2018/10/PDF20_AN002-AF.pdf
                         */ if (!this.doc.catalog.has((0, $dPHSK.default).of('AF'))) this.doc.catalog.set((0, $dPHSK.default).of('AF'), this.doc.context.obj([]));
                        AF = this.doc.catalog.lookup((0, $dPHSK.default).of('AF'), (0, $8auL6.default));
                        AF.push(ref);
                        this.alreadyEmbedded = true;
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.attach]] method, which will create
     * instances of [[PDFEmbeddedFile]] for you.
     *
     * Create an instance of [[PDFEmbeddedFile]] from an existing ref and embedder
     *
     * @param ref The unique reference for this file.
     * @param doc The document to which the file will belong.
     * @param embedder The embedder that will be used to embed the file.
     */ PDFEmbeddedFile.of = function(ref, doc, embedder) {
        return new PDFEmbeddedFile(ref, doc, embedder);
    };
    return PDFEmbeddedFile;
}();
var $072855dc9321c2b4$export$2e2bcd8739ae039 = $072855dc9321c2b4$var$PDFEmbeddedFile;

});

parcelRegister("ceWew", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e93f6bd1fec6f6e$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");
parcelRequire("iT7lj");
var $8auL6 = parcelRequire("8auL6");
var $brir8 = parcelRequire("brir8");
var $jWFiV = parcelRequire("jWFiV");
var $dPHSK = parcelRequire("dPHSK");
/**
 * Represents JavaScript that has been embedded in a [[PDFDocument]].
 */ var $8e93f6bd1fec6f6e$var$PDFJavaScript = /** @class */ function() {
    function PDFJavaScript(ref, doc, embedder) {
        this.alreadyEmbedded = false;
        this.ref = ref;
        this.doc = doc;
        this.embedder = embedder;
    }
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all JavaScripts get embedded.
     *
     * Embed this JavaScript in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFJavaScript.prototype.embed = function() {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var _a, catalog, context, ref, Names, Javascript, JSNames;
            return (0, $cOQTW.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!!this.alreadyEmbedded) return [
                            3 /*break*/ ,
                            2
                        ];
                        _a = this.doc, catalog = _a.catalog, context = _a.context;
                        return [
                            4 /*yield*/ ,
                            this.embedder.embedIntoContext(this.doc.context, this.ref)
                        ];
                    case 1:
                        ref = _b.sent();
                        if (!catalog.has((0, $dPHSK.default).of('Names'))) catalog.set((0, $dPHSK.default).of('Names'), context.obj({}));
                        Names = catalog.lookup((0, $dPHSK.default).of('Names'), (0, $brir8.default));
                        if (!Names.has((0, $dPHSK.default).of('JavaScript'))) Names.set((0, $dPHSK.default).of('JavaScript'), context.obj({}));
                        Javascript = Names.lookup((0, $dPHSK.default).of('JavaScript'), (0, $brir8.default));
                        if (!Javascript.has((0, $dPHSK.default).of('Names'))) Javascript.set((0, $dPHSK.default).of('Names'), context.obj([]));
                        JSNames = Javascript.lookup((0, $dPHSK.default).of('Names'), (0, $8auL6.default));
                        JSNames.push((0, $jWFiV.default).fromText(this.embedder.scriptName));
                        JSNames.push(ref);
                        this.alreadyEmbedded = true;
                        _b.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.addJavaScript]] method, which will
     * create instances of [[PDFJavaScript]] for you.
     *
     * Create an instance of [[PDFJavaScript]] from an existing ref and script
     *
     * @param ref The unique reference for this script.
     * @param doc The document to which the script will belong.
     * @param embedder The embedder that will be used to embed the script.
     */ PDFJavaScript.of = function(ref, doc, embedder) {
        return new PDFJavaScript(ref, doc, embedder);
    };
    return PDFJavaScript;
}();
var $8e93f6bd1fec6f6e$export$2e2bcd8739ae039 = $8e93f6bd1fec6f6e$var$PDFJavaScript;

});

parcelRegister("8gnuI", function(module, exports) {

$parcel$export(module.exports, "default", () => $60420ad6933b406d$export$2e2bcd8739ae039);

var $cOQTW = parcelRequire("cOQTW");

var $jWFiV = parcelRequire("jWFiV");
var $60420ad6933b406d$var$JavaScriptEmbedder = /** @class */ function() {
    function JavaScriptEmbedder(script, scriptName) {
        this.script = script;
        this.scriptName = scriptName;
    }
    JavaScriptEmbedder.for = function(script, scriptName) {
        return new JavaScriptEmbedder(script, scriptName);
    };
    JavaScriptEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $cOQTW.__awaiter)(this, void 0, void 0, function() {
            var jsActionDict;
            return (0, $cOQTW.__generator)(this, function(_a) {
                jsActionDict = context.obj({
                    Type: 'Action',
                    S: 'JavaScript',
                    JS: (0, $jWFiV.default).fromText(this.script)
                });
                if (ref) {
                    context.assign(ref, jsActionDict);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(jsActionDict)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return JavaScriptEmbedder;
}();
var $60420ad6933b406d$export$2e2bcd8739ae039 = $60420ad6933b406d$var$JavaScriptEmbedder;

});


parcelRegister("j1dka", function(module, exports) {

$parcel$export(module.exports, "BlendMode", () => $dd8872426cc55b05$export$c9b8fe72ac71821);
var $dd8872426cc55b05$export$c9b8fe72ac71821;
(function(BlendMode) {
    BlendMode["Normal"] = "Normal";
    BlendMode["Multiply"] = "Multiply";
    BlendMode["Screen"] = "Screen";
    BlendMode["Overlay"] = "Overlay";
    BlendMode["Darken"] = "Darken";
    BlendMode["Lighten"] = "Lighten";
    BlendMode["ColorDodge"] = "ColorDodge";
    BlendMode["ColorBurn"] = "ColorBurn";
    BlendMode["HardLight"] = "HardLight";
    BlendMode["SoftLight"] = "SoftLight";
    BlendMode["Difference"] = "Difference";
    BlendMode["Exclusion"] = "Exclusion";
})($dd8872426cc55b05$export$c9b8fe72ac71821 || ($dd8872426cc55b05$export$c9b8fe72ac71821 = {}));

});




parcelRegister("5yZPW", function(module, exports) {
parcelRequire("5rdXu");
parcelRequire("d1UXb");

});


parcelRegister("4J7XC", function(module, exports) {

});


parcelRegister("cWkOq", function(module, exports) {
module.exports = import.meta.resolve("3LdSj");

});


parcelRegister("047iA", function(module, exports) {

$parcel$export(module.exports, "BaseClientesViewColumnsOverrides", () => $93d9c2bb2ad4f404$export$42f8783390937873);

var $ayMG0 = parcelRequire("ayMG0");

var $9mTYo = parcelRequire("9mTYo");

var $3an6L = parcelRequire("3an6L");
function $93d9c2bb2ad4f404$export$42f8783390937873(theme) {
    return {
        6: {
            render: (value)=>{
                const val = value;
                if (val === 'SI') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                    style: {
                        gap: '.5rem'
                    },
                    noWrap: true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3an6L.default), {
                        style: {
                            color: theme.colors.green[8],
                            minWidth: "1.3rem"
                        },
                        size: "1.3rem"
                    })
                });
                return value;
            }
        }
    };
}

});

parcelRegister("1noBe", function(module, exports) {

$parcel$export(module.exports, "BaseReportesViewColumnsOverrides", () => $ba67f7092f344785$export$678c8e4eb7935bcb);

var $ayMG0 = parcelRequire("ayMG0");

var $kPsAn = parcelRequire("kPsAn");
var $9mTYo = parcelRequire("9mTYo");
var $hiGsa = parcelRequire("hiGsa");
var $60Ffz = parcelRequire("60Ffz");

var $3OncY = parcelRequire("3OncY");
function $ba67f7092f344785$export$678c8e4eb7935bcb(column_index) {
    return {
        [column_index]: {
            render: (value)=>{
                const imagenes = value.split(',').map((img)=>img.trim()).filter((img)=>img);
                if (imagenes.length === 0) return '';
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                    align: "flex-start",
                    spacing: "xs",
                    children: imagenes.map((img, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $60Ffz.Tooltip), {
                            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kPsAn.Card), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hiGsa.Image), {
                                    src: `${(0, $3OncY.API_URL)}/${(0, $3OncY.APP_ID)}/serve/${img}`,
                                    alt: `Imagen ${index + 1}`,
                                    maw: "600px",
                                    mt: "auto"
                                }, `img-${index + 1}`)
                            }),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hiGsa.Image), {
                                src: `${(0, $3OncY.API_URL)}/${(0, $3OncY.APP_ID)}/serve/${img}`,
                                alt: `Imagen ${index + 1}`,
                                maw: "30px",
                                mt: "auto"
                            }, `tooltip-${index + 1}`)
                        }))
                });
            }
        }
    };
}

});


parcelRegister("fE7ax", function(module, exports) {
module.exports = import("4BkM4").then(()=>parcelRequire('5szG4'));

});


parcelRegister("cnksb", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b1b646ead0530a7$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $1b1b646ead0530a7$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M12 14m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M12 10.5v1.5",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M12 16v1.5",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M15.031 12.25l-1.299 .75",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M10.268 15l-1.3 .75",
            "key": "svg-4"
        }
    ],
    [
        "path",
        {
            "d": "M15 15.803l-1.285 -.773",
            "key": "svg-5"
        }
    ],
    [
        "path",
        {
            "d": "M10.285 12.97l-1.285 -.773",
            "key": "svg-6"
        }
    ],
    [
        "path",
        {
            "d": "M14 3v4a1 1 0 0 0 1 1h4",
            "key": "svg-7"
        }
    ],
    [
        "path",
        {
            "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z",
            "key": "svg-8"
        }
    ]
];
const $1b1b646ead0530a7$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "file-settings", "FileSettings", $1b1b646ead0530a7$export$3efd853dbb351e94);

});

parcelRegister("8zFeG", function(module, exports) {
module.exports = import("2KKQl").then(()=>parcelRequire('b1EHa'));

});

parcelRegister("eD7iz", function(module, exports) {

$parcel$export(module.exports, "RutasIcon", () => $c70825d246a05f45$export$15e1c8b9404099ab);
$parcel$export(module.exports, "RutasHelpText", () => $c70825d246a05f45$export$e0ccc66d7a9254d7);
$parcel$export(module.exports, "Rutas", () => $c70825d246a05f45$export$f9c5e9924dff554d);

var $49qEn = parcelRequire("49qEn");

var $7LsqC = parcelRequire("7LsqC");

var $cYjyL = parcelRequire("cYjyL");
const $c70825d246a05f45$export$15e1c8b9404099ab = (0, $7LsqC.default);
const $c70825d246a05f45$export$e0ccc66d7a9254d7 = "* Aqu\xed se encuentran las rutas. Los registros de esta tabla muestran el personal encargados de hacer los servicios en las multiples tiendas";

class $c70825d246a05f45$export$f9c5e9924dff554d extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $cYjyL.RutasDef)(), parentKeys);
        super.Form = (parcelRequire("gOebd")).then((module)=>module.RutasForm);
        this.Title = "Rutas";
        this.HelpText = $c70825d246a05f45$export$e0ccc66d7a9254d7;
        this.Icon = $c70825d246a05f45$export$15e1c8b9404099ab;
    }
}

});
parcelRegister("7LsqC", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5273c0c0e6e7dbe$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $c5273c0c0e6e7dbe$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M3 19a2 2 0 1 0 4 0a2 2 0 0 0 -4 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M19 7a2 2 0 1 0 0 -4a2 2 0 0 0 0 4z",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M11 19h5.5a3.5 3.5 0 0 0 0 -7h-8a3.5 3.5 0 0 1 0 -7h4.5",
            "key": "svg-2"
        }
    ]
];
const $c5273c0c0e6e7dbe$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "route", "Route", $c5273c0c0e6e7dbe$export$3efd853dbb351e94);

});

parcelRegister("cYjyL", function(module, exports) {

$parcel$export(module.exports, "RutasDef", () => $685a6b26b1b4a96f$export$e00540607c4756e);

var $49qEn = parcelRequire("49qEn");

var $5kp3N = parcelRequire("5kp3N");

var $7LP39 = parcelRequire("7LP39");
const $685a6b26b1b4a96f$var$columns = ()=>({
        c_ruta_id: new (0, $49qEn.EntityColumn)({
            name: 'c_ruta_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PKAutonum,
            prompt: 'Ruta ID'
        }),
        c_personal_id: new (0, $49qEn.EntityColumn)({
            name: 'c_personal_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Personal'
        }),
        vc_nombre_ruta: new (0, $49qEn.EntityColumn)({
            name: 'vc_nombre_ruta',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Nombre'
        }),
        vc_observaciones_ruta: new (0, $49qEn.EntityColumn)({
            name: 'vc_observaciones_ruta',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Observaciones'
        }),
        c_activo_id: new (0, $49qEn.EntityColumn)({
            name: 'c_activo_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Estado'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $685a6b26b1b4a96f$var$lookups = ()=>({
        'Personal': {
            name: 'Personal',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $7LP39.Personal)(client, parentKeys)
        },
        'Activo': {
            name: 'Activo',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $5kp3N.estActivo)(client, parentKeys)
        }
    });
const $685a6b26b1b4a96f$var$views = ()=>({
        ruta_brwStandard: {
            name: 'ruta_brwStandard',
            keyMappings: {
                c_personal_id: 0
            }
        }
    });
const $685a6b26b1b4a96f$var$procs = ()=>({
        ruta_qryExportar: {
            name: 'ruta_qryExportar'
        },
        ruta_qryClientesExportar: {
            name: 'ruta_qryClientesExportar'
        }
    });
class $685a6b26b1b4a96f$export$e00540607c4756e extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('Rutas'), this.columns = $685a6b26b1b4a96f$var$columns(), this.views = $685a6b26b1b4a96f$var$views(), this.lookups = $685a6b26b1b4a96f$var$lookups(), this.procs = $685a6b26b1b4a96f$var$procs();
    }
}

});

parcelRegister("gOebd", function(module, exports) {
module.exports = import("3fQ8K").then(()=>parcelRequire('kOczV'));

});


parcelRegister("lV2Pc", function(module, exports) {
module.exports = Promise.all([
    import("l0wMD"),
    import("24c8c")
]).then(()=>parcelRequire('1AiPZ'));

});

parcelRegister("2cYS7", function(module, exports) {

$parcel$export(module.exports, "SolicitudesRuteoIcon", () => $b3df1f81b97692cf$export$ee60cb936b408cea);
$parcel$export(module.exports, "SolicitudesRuteoHelpText", () => $b3df1f81b97692cf$export$71bd4fa39e867a2a);
$parcel$export(module.exports, "SolicitudesRuteo", () => $b3df1f81b97692cf$export$10d42064bd6527b9);
$parcel$export(module.exports, "SolicitudesRuteoDetalles", () => $b3df1f81b97692cf$export$ab148913f5435fc);

var $49qEn = parcelRequire("49qEn");

var $bdzm4 = parcelRequire("bdzm4");

var $Vp7Dz = parcelRequire("Vp7Dz");
const $b3df1f81b97692cf$export$ee60cb936b408cea = (0, $bdzm4.default);
const $b3df1f81b97692cf$export$71bd4fa39e867a2a = '* Las solicitudes de ruteo permiten solicitar nuevas rutas o modificar existentes';

class $b3df1f81b97692cf$export$10d42064bd6527b9 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $Vp7Dz.SolicitudesRuteoDef)(), parentKeys);
        this.Form = (parcelRequire("b72F8")).then((module)=>module.SolicitudesRuteoForm);
        this.Title = "Solicitudes de Ruteo";
        this.HelpText = $b3df1f81b97692cf$export$71bd4fa39e867a2a;
        this.Icon = $b3df1f81b97692cf$export$ee60cb936b408cea;
    }
}

class $b3df1f81b97692cf$export$ab148913f5435fc extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $Vp7Dz.SolicitudesRuteoDef)(), parentKeys);
        this.Form = (parcelRequire("fZOv9")).then((module)=>module.SolicitudesRuteoDetallesForm);
        this.Title = "Solicitudes de Ruteo Detalles";
        this.HelpText = $b3df1f81b97692cf$export$71bd4fa39e867a2a;
        this.Icon = $b3df1f81b97692cf$export$ee60cb936b408cea;
    }
}

});
parcelRegister("Vp7Dz", function(module, exports) {

$parcel$export(module.exports, "SolicitudesRuteoDef", () => $0a567e852a84af16$export$e7c6ef4e0ba8c5f8);

var $49qEn = parcelRequire("49qEn");

var $aCFMu = parcelRequire("aCFMu");

var $kna9I = parcelRequire("kna9I");

var $9u8qf = parcelRequire("9u8qf");

var $7LP39 = parcelRequire("7LP39");

var $lV9FS = parcelRequire("lV9FS");

var $2d5Hn = parcelRequire("2d5Hn");

var $bdR8f = parcelRequire("bdR8f");

var $jp87J = parcelRequire("jp87J");

var $2YYBa = parcelRequire("2YYBa");

var $c33b2 = parcelRequire("c33b2");

var $sXLAL = parcelRequire("sXLAL");

var $6rNrX = parcelRequire("6rNrX");

var $2slTQ = parcelRequire("2slTQ");

var $gadmm = parcelRequire("gadmm");

var $oucKI = parcelRequire("oucKI");

var $knTCD = parcelRequire("knTCD");

var $gFeIW = parcelRequire("gFeIW");

var $kAi3x = parcelRequire("kAi3x");

var $gjhGv = parcelRequire("gjhGv");
const $0a567e852a84af16$var$columns = ()=>({
        c_solicitudruteo_id: new (0, $49qEn.EntityColumn)({
            name: 'c_solicitudruteo_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PKAutonum,
            prompt: 'Solicitud Id'
        }),
        c_ruta_id: new (0, $49qEn.EntityColumn)({
            name: 'c_ruta_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Ruta Id'
        }),
        c_tiposolicitudruta_id: new (0, $49qEn.EntityColumn)({
            name: 'c_tiposolicitudruta_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Tipo'
        }),
        vc_codigo_ruta_solicitud: new (0, $49qEn.EntityColumn)({
            name: 'vc_codigo_ruta_solicitud',
            type: 'varchar',
            length: 50,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "C\xf3digo Ruta"
        }),
        d_fechadesde: new (0, $49qEn.EntityColumn)({
            name: 'd_fechadesde',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Fecha desde'
        }),
        c_cliente_id: new (0, $49qEn.EntityColumn)({
            name: 'c_cliente_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Cliente Exclusivo Id'
        }),
        vc_nombre_ruta_solicitud: new (0, $49qEn.EntityColumn)({
            name: 'vc_nombre_ruta_solicitud',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Nombre Ruta'
        }),
        vc_observaciones_solicitud: new (0, $49qEn.EntityColumn)({
            name: 'vc_observaciones_solicitud',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Observaciones'
        }),
        c_personal_id: new (0, $49qEn.EntityColumn)({
            name: 'c_personal_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Personal Id'
        }),
        c_persona_id: new (0, $49qEn.EntityColumn)({
            name: 'c_persona_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Persona Id'
        }),
        vc_numerodni: new (0, $49qEn.EntityColumn)({
            name: 'vc_numerodni',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'DNI'
        }),
        vc_nombre: new (0, $49qEn.EntityColumn)({
            name: 'vc_nombre',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Nombre'
        }),
        vc_apellido: new (0, $49qEn.EntityColumn)({
            name: 'vc_apellido',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Apellido'
        }),
        vc_puestotrabajo: new (0, $49qEn.EntityColumn)({
            name: 'vc_puestotrabajo',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Puesto'
        }),
        dt_nacimiento: new (0, $49qEn.EntityColumn)({
            name: 'dt_nacimiento',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Nacimiento'
        }),
        vc_genero: new (0, $49qEn.EntityColumn)({
            name: 'vc_genero',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "G\xe9nero"
        }),
        vc_fotoguid: new (0, $49qEn.EntityColumn)({
            name: 'vc_fotoguid',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Foto URL'
        }),
        vc_superior: new (0, $49qEn.EntityColumn)({
            name: 'vc_superior',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Superior'
        }),
        vc_telefono: new (0, $49qEn.EntityColumn)({
            name: 'vc_telefono',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Tel\xe9fono"
        }),
        vc_celular: new (0, $49qEn.EntityColumn)({
            name: 'vc_celular',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Celular'
        }),
        vc_celular_trabajo: new (0, $49qEn.EntityColumn)({
            name: 'vc_celular_trabajo',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Celular Trabajo'
        }),
        vc_telefono_alternativo: new (0, $49qEn.EntityColumn)({
            name: 'vc_telefono_alternativo',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Tel\xe9fono Alternativo"
        }),
        vc_email: new (0, $49qEn.EntityColumn)({
            name: 'vc_email',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Email'
        }),
        vc_email_alternativo: new (0, $49qEn.EntityColumn)({
            name: 'vc_email_alternativo',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Email Alternativo'
        }),
        f_latitud: new (0, $49qEn.EntityColumn)({
            name: 'f_latitud',
            type: 'float',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Latitud'
        }),
        f_longitud: new (0, $49qEn.EntityColumn)({
            name: 'f_longitud',
            type: 'float',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Longitud'
        }),
        vc_domicilio_completo: new (0, $49qEn.EntityColumn)({
            name: 'vc_domicilio_completo',
            type: 'varchar',
            length: 2048,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Domicilio Completo'
        }),
        n_total_horas_semanales: new (0, $49qEn.EntityColumn)({
            name: 'n_total_horas_semanales',
            type: 'decimal',
            scale: 2,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Total Horas Semanales'
        }),
        n_horas_semanales_disponibles: new (0, $49qEn.EntityColumn)({
            name: 'n_horas_semanales_disponibles',
            type: 'decimal',
            scale: 2,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Horas Semanales Disponibles'
        }),
        n_horas_semanales_compartidas: new (0, $49qEn.EntityColumn)({
            name: 'n_horas_semanales_compartidas',
            type: 'decimal',
            scale: 2,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Horas Semanales Compartidas'
        }),
        n_horas_semanales_exclusivas: new (0, $49qEn.EntityColumn)({
            name: 'n_horas_semanales_exclusivas',
            type: 'decimal',
            scale: 2,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Horas Semanales Exclusivas'
        }),
        dt_fecha_baja: new (0, $49qEn.EntityColumn)({
            name: 'dt_fecha_baja',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Fecha Baja'
        }),
        dt_fecha_alta: new (0, $49qEn.EntityColumn)({
            name: 'dt_fecha_alta',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Fecha Alta'
        }),
        dt_licencia_desde: new (0, $49qEn.EntityColumn)({
            name: 'dt_licencia_desde',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Licencia Desde'
        }),
        dt_licencia_hasta: new (0, $49qEn.EntityColumn)({
            name: 'dt_licencia_hasta',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Licencia Hasta'
        }),
        c_estado_licencia_id: new (0, $49qEn.EntityColumn)({
            name: 'c_estado_licencia_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Estado Licencia Id'
        }),
        vc_tiendas: new (0, $49qEn.EntityColumn)({
            name: 'vc_tiendas',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Tiendas',
            isArray: true
        }),
        c_autorizacion_id: new (0, $49qEn.EntityColumn)({
            name: 'c_autorizacion_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Autorizacion Id'
        }),
        vc_personal_solicitud: new (0, $49qEn.EntityColumn)({
            name: 'vc_personal_solicitud',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Personal Solicitud'
        }),
        c_personal_ruta_id: new (0, $49qEn.EntityColumn)({
            name: 'c_personal_ruta_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Personal Ruta Id'
        }),
        vc_personal_ruta: new (0, $49qEn.EntityColumn)({
            name: 'vc_personal_ruta',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Personal Ruta'
        }),
        b_nueva: new (0, $49qEn.EntityColumn)({
            name: 'b_nueva',
            type: 'bit',
            flags: (0, $49qEn.EntityColumnFlags).None,
            prompt: 'Solicitud Nueva'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $0a567e852a84af16$var$views = ()=>({
        soru_brwStandard: {
            name: 'soru_brwStandard',
            keyMappings: {
                c_solicitudruteo_id: 0
            }
        },
        soru_brwBorradores: {
            name: 'soru_brwBorradores',
            keyMappings: {
                c_solicitudruteo_id: 0
            }
        },
        soru_brwHistorial: {
            name: 'soru_brwHistorial',
            keyMappings: {
                c_solicitudruteo_id: 0
            }
        },
        soru_brwDisponibleEnRutas: {
            name: 'soru_brwDisponibleEnRutas',
            keyMappings: {
                c_personal_id: 0,
                c_ruta_id: 26
            },
            FiltersEntity: (client, parentKeys)=>new (0, $lV9FS.RutasTiendasFilters)(client, parentKeys),
            gridColumnsOverrides: (0, $gFeIW.DisponibleEnRutasViewColumnsOverrides),
            mapMarkerRenderer: (0, $gjhGv.DisponibleEnRutasViewMarkerRenderer),
            mapInfoWindowRenderer: (0, $kAi3x.DisponibleEnRutasViewInfoWindowRenderer)
        }
    });
const $0a567e852a84af16$var$lookups = ()=>({
        'Personal': {
            name: 'Personal',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $7LP39.Personal)(client, parentKeys)
        },
        'TiposSolicitudRuta': {
            name: 'TiposSolicitudRuta',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $kna9I.catTiposSolicitudRuta)(client, parentKeys)
        },
        'Clientes': {
            name: 'Clientes',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 2
            },
            entityConstructor: (client, parentKeys)=>new (0, $9u8qf.Clientes)(client, parentKeys)
        },
        ...(0, $aCFMu.DomiciliosLookups)()
    });
const $0a567e852a84af16$var$procs = ()=>({
        soru_CrearSolicitudModificacion: {
            name: 'soru_CrearSolicitudModificacion'
        },
        soru_EliminarNoModificada: {
            name: 'soru_EliminarNoModificada'
        },
        soru_Enviar: {
            name: 'soru_Enviar'
        },
        soru_Autorizar: {
            name: 'soru_Autorizar'
        },
        soru_Rechazar: {
            name: 'soru_Rechazar'
        },
        soru_CrearSolicitudesReasignacion: {
            name: 'soru_CrearSolicitudesReasignacion',
            parms: {
                c_personal_origen_id: '',
                c_personal_destino_id: ''
            }
        },
        soru_CrearSolicitudCopiar: {
            name: 'soru_CrearSolicitudCopiar',
            parms: {
                c_personal_origen_id: '',
                c_personal_destino_id: ''
            }
        }
    });
const $0a567e852a84af16$var$clientActions = ()=>({
        ACTAutorizarSolicitudRuta: (0, $2d5Hn.ACTAutorizarSolicitudRuta),
        ACTRechazarSolicitudRuta: (0, $oucKI.ACTRechazarSolicitudRuta),
        ACTEnviarSolicitudRuta: (0, $c33b2.ACTEnviarSolicitudRuta),
        ACTEditarRuta: (0, $jp87J.ACTEditarRuta),
        ACTEliminarRuta: (0, $2YYBa.ACTEliminarRuta),
        ACTReasignarRuta: (0, $gadmm.ACTReasignarRuta),
        ACTCopiarRuta: (0, $bdR8f.ACTCopiarRuta),
        ACTExportarRutas: (0, $6rNrX.ACTExportarRutas),
        ACTImportarRutas: (0, $2slTQ.ACTImportarRutas),
        ACTVerImportaciones: (0, $knTCD.ACTVerImportaciones),
        ACTExportarClientesRutas: (0, $sXLAL.ACTExportarClientesRutas)
    });
class $0a567e852a84af16$export$e7c6ef4e0ba8c5f8 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('SolicitudesRuteo'), this.columns = $0a567e852a84af16$var$columns(), this.views = $0a567e852a84af16$var$views(), this.lookups = $0a567e852a84af16$var$lookups(), this.procs = $0a567e852a84af16$var$procs(), this.clientActions = $0a567e852a84af16$var$clientActions();
    }
}

});
parcelRegister("kna9I", function(module, exports) {

$parcel$export(module.exports, "catTiposSolicitudRuta", () => $550361e332998113$export$447c01d1e2d2fc20);

var $49qEn = parcelRequire("49qEn");
class $550361e332998113$export$447c01d1e2d2fc20 extends (0, $49qEn.CategoriesValues) {
    constructor(client, parentKeys = {}){
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "TiposSolicitudRuta";
        this.def.columns.c_category_id.defaultValue = "TiposSolicitudRuta";
        this.Title = "Tipos de Solicitud";
    }
}

});

parcelRegister("2d5Hn", function(module, exports) {

$parcel$export(module.exports, "ACTAutorizarSolicitudRuta", () => $30df52530da3baa6$export$fe6bbe0e7e0b4af2);

var $ayMG0 = parcelRequire("ayMG0");

var $gU5rH = parcelRequire("gU5rH");
var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");
const $30df52530da3baa6$export$fe6bbe0e7e0b4af2 = {
    name: 'ACTAutorizarSolicitudRuta',
    label: 'Autorizar Solicitud',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Autorizar solicitud de ruta"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    views: [
        'soru_brwStandard'
    ],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        // cast entity
        const solicitud = entity;
        const procParms = {
            c_solicitudruteo_id: selectedKeys?.[0]?.['c_solicitudruteo_id'] ?? ''
        };
        let errores = '';
        if (!procParms.c_solicitudruteo_id) errores = "Los registros seleccionados son inv\xe1lidos";
        if (errores) await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                            size: "1.5rem",
                            stroke: "1.5"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            fw: "700",
                            children: "ERROR"
                        })
                    ]
                })
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        size: "sm",
                        mb: "xs",
                        children: errores
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                        mt: "xs",
                        position: "right",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                            onClick: async ()=>await modal.close(),
                            children: "Cerrar"
                        })
                    })
                ]
            })
        });
        else {
            const abort_controller = new AbortController();
            await modal.open({
                modalProps: {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        fw: "700",
                        children: "Autorizar solicitud de ruteo"
                    })
                },
                focusOnClosed: element,
                content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.ConfirmAndExecutePanel), {
                    content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        size: "sm",
                        mb: "xs",
                        children: "Va a autorizar la solicitud de ruteo. \xbfEst\xe1 seguro?"
                    }),
                    operation: "proc",
                    onCancel: async ()=>{
                        abort_controller.abort();
                        await modal.close();
                        if (onClose) await onClose(false);
                    },
                    onOK: async ()=>{
                        const result = await solicitud.API.executeProcess(solicitud.def.procs.soru_Autorizar, procParms, abort_controller.signal);
                        const success = result.Failed === false;
                        if (success) {
                            await modal.close();
                            if (onClose) await onClose(success);
                        }
                    }
                })
            });
        }
        return false;
    }
};

});

parcelRegister("bdR8f", function(module, exports) {

$parcel$export(module.exports, "ACTCopiarRuta", () => $3de3f2fbcd75d3c8$export$a6213f8110367017);

var $ayMG0 = parcelRequire("ayMG0");

var $gU5rH = parcelRequire("gU5rH");
var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");

var $7LP39 = parcelRequire("7LP39");
const $3de3f2fbcd75d3c8$export$a6213f8110367017 = {
    name: 'ACTCopiarRuta',
    label: 'Copiar Ruta',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Copiar Ruta"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    minSelectedRecords: 1,
    maxSelectedRecords: 1,
    views: [
        'soru_brwDisponibleEnRutas'
    ],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const solicitudesruteo = entity;
        const personal = new (0, $7LP39.Personal)(entity.API.client);
        const procParms = {
            c_personal_origen_id: selectedKeys?.[0]?.['c_personal_id'] ?? '',
            c_personal_destino_id: ''
        };
        let errores = '';
        if (!procParms.c_personal_origen_id) errores = "Los registros seleccionados son inv\xe1lidos";
        await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                    fw: "700",
                    children: "Copiar ruta"
                }),
                size: 'xl'
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.LookupFormAction), {
                lookupEntity: personal,
                viewName: personal.def.views.perl_brwGestionPersonal.name,
                title: "Copiar ruta",
                confirmContent: "\xbfEst\xe1 seguro de que desea copiar la ruta del personal seleccionado?",
                onActionFinished: async ()=>{
                    if (onClose) await onClose();
                },
                onOK: async (keys, abortSignal)=>{
                    const abort_controller = new AbortController();
                    let status = 11;
                    let message = '';
                    if (keys && keys.length > 0) {
                        if (onClose) await onClose();
                        await modal.close();
                    }
                    procParms.c_personal_destino_id = keys[0].c_personal_id;
                    const result = await solicitudesruteo.API.executeProcess(solicitudesruteo.def.procs.soru_CrearSolicitudCopiar, procParms, abort_controller.signal);
                    status = result.Results[0].Status;
                    message = result.Results[0].Message;
                    if (status === 11) await modal.open({
                        modalProps: {
                            title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                                        size: "1.5rem",
                                        stroke: "1.5"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                                        fw: "700",
                                        children: "ERROR"
                                    })
                                ]
                            })
                        },
                        focusOnClosed: element,
                        content: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                                    size: "sm",
                                    mb: "xs",
                                    children: message
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                                    mt: "xs",
                                    position: "right",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                                        onClick: async ()=>await modal.close(),
                                        children: "Cerrar"
                                    })
                                })
                            ]
                        })
                    });
                    return result;
                }
            })
        });
        return false;
    }
};

});

parcelRegister("jp87J", function(module, exports) {

$parcel$export(module.exports, "ACTEditarRuta", () => $ac3177b3131bcbd2$export$2f5684fc7175b92c);

var $ayMG0 = parcelRequire("ayMG0");

var $gU5rH = parcelRequire("gU5rH");
var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");

var $2cYS7 = parcelRequire("2cYS7");
const $ac3177b3131bcbd2$export$2f5684fc7175b92c = {
    name: 'ACTEditarRuta',
    label: 'Editar Ruta',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Editar ruta"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    views: [
        'soru_brwDisponibleEnRutas'
    ],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const abort_controller = new AbortController();
        await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                    fw: "700",
                    children: "Solicitud de modificaci\xf3n de ruta"
                })
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.ConfirmAndExecutePanel), {
                content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                    size: "sm",
                    mb: "xs",
                    children: "Va a generar una solicitud de modificaci\xf3n de ruta. \xbfEst\xe1 seguro?"
                }),
                operation: "proc",
                onCancel: async ()=>{
                    abort_controller.abort();
                    await modal.close();
                    if (onClose) await onClose(false);
                },
                onOK: async ()=>{
                    // cast entity
                    const solicitudesRuteo = new (0, $2cYS7.SolicitudesRuteo)(entity.API.client);
                    solicitudesRuteo.def.columns.c_personal_id.value = selectedKeys[0].c_personal_id || '';
                    const result = await solicitudesRuteo.API.addData();
                    if (result.Failed) {
                        await modal.open({
                            modalProps: {
                                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                                            size: "1.5rem",
                                            stroke: "1.5"
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                                            fw: "700",
                                            children: "ERROR"
                                        })
                                    ]
                                })
                            },
                            focusOnClosed: element,
                            content: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                                        size: "sm",
                                        mb: "xs",
                                        children: result.Results[0].Message
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                                        mt: "xs",
                                        position: "right",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                                            onClick: async ()=>await modal.close(),
                                            children: "Cerrar"
                                        })
                                    })
                                ]
                            })
                        });
                        return;
                    } else {
                        await modal.close();
                        await (0, $49qEn.openEntityForm)({
                            modals: modal,
                            handleModalClosed: async ()=>{
                                if (solicitudesRuteo.def.columns.c_solicitudruteo_id.value) try {
                                    // fire and forget and ignore any error
                                    solicitudesRuteo.API.executeProcess(solicitudesRuteo.def.procs.soru_EliminarNoModificada, {
                                        c_solicitudruteo_id: solicitudesRuteo.def.columns.c_solicitudruteo_id.value
                                    });
                                } catch (error) {
                                    console.error(error);
                                }
                            },
                            formProps: {
                                entity: solicitudesRuteo,
                                initialFormMode: 'edit',
                                getDataOnInit: true
                            },
                            modalFormSize: 'fullscreen',
                            handleModalSaved: async ()=>{
                                await modal.close();
                                if (onClose) await onClose();
                            },
                            handleModalCancel: async ()=>{
                                await modal.close();
                                if (onClose) await onClose();
                            }
                        });
                    }
                }
            })
        });
        return false;
    }
};

});

parcelRegister("2YYBa", function(module, exports) {

$parcel$export(module.exports, "ACTEliminarRuta", () => $ae010279362d44ab$export$e1c0744ad115b5a5);

var $ayMG0 = parcelRequire("ayMG0");

var $gU5rH = parcelRequire("gU5rH");
var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");

var $2cYS7 = parcelRequire("2cYS7");
const $ae010279362d44ab$export$e1c0744ad115b5a5 = {
    name: 'ACTEliminarRuta',
    label: 'Eliminar Ruta',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Eliminar ruta"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    views: [
        'soru_brwDisponibleEnRutas'
    ],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const abort_controller = new AbortController();
        await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                    fw: "700",
                    children: "Solicitud de eliminaci\xf3n de ruta"
                })
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.ConfirmAndExecutePanel), {
                content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                    size: "sm",
                    mb: "xs",
                    children: "Va a generar una solicitud de eliminaci\xf3n de ruta. \xbfEst\xe1 seguro?"
                }),
                operation: "proc",
                onCancel: async ()=>{
                    abort_controller.abort();
                    await modal.close();
                    if (onClose) await onClose(false);
                },
                onOK: async ()=>{
                    // cast entity
                    const solicitudesRuteo = new (0, $2cYS7.SolicitudesRuteo)(entity.API.client);
                    solicitudesRuteo.def.columns.c_personal_id.value = selectedKeys[0].c_personal_id || '';
                    solicitudesRuteo.def.columns.c_tiposolicitudruta_id.value = 'ELIMINAR';
                    const result = await solicitudesRuteo.API.addData();
                    if (result.Failed) await modal.open({
                        modalProps: {
                            title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                                        size: "1.5rem",
                                        stroke: "1.5"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                                        fw: "700",
                                        children: "ERROR"
                                    })
                                ]
                            })
                        },
                        focusOnClosed: element,
                        content: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                                    size: "sm",
                                    mb: "xs",
                                    children: result.Results[0].Message
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                                    mt: "xs",
                                    position: "right",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                                        onClick: async ()=>await modal.close(),
                                        children: "Cerrar"
                                    })
                                })
                            ]
                        })
                    });
                    if (onClose) await onClose();
                    await modal.close();
                }
            })
        });
        return false;
    }
};

});

parcelRegister("c33b2", function(module, exports) {

$parcel$export(module.exports, "ACTEnviarSolicitudRuta", () => $ed9d07a9a032f40c$export$f132747d36d95787);

var $ayMG0 = parcelRequire("ayMG0");

var $gU5rH = parcelRequire("gU5rH");
var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");
const $ed9d07a9a032f40c$export$f132747d36d95787 = {
    name: 'ACTEnviarSolicitudRuta',
    label: 'Enviar Solicitud',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Enviar solicitud de ruta"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    views: [
        'soru_brwBorradores'
    ],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        // cast entity
        const solicitud = entity;
        const procParms = {
            c_solicitudruteo_id: selectedKeys?.[0]?.['c_solicitudruteo_id'] ?? ''
        };
        let errores = '';
        if (!procParms.c_solicitudruteo_id) errores = "Los registros seleccionados son inv\xe1lidos";
        if (errores) await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                            size: "1.5rem",
                            stroke: "1.5"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            fw: "700",
                            children: "ERROR"
                        })
                    ]
                })
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        size: "sm",
                        mb: "xs",
                        children: errores
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                        mt: "xs",
                        position: "right",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                            onClick: async ()=>await modal.close(),
                            children: "Cerrar"
                        })
                    })
                ]
            })
        });
        else {
            const abort_controller = new AbortController();
            await modal.open({
                modalProps: {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        fw: "700",
                        children: "Enviar solicitud de ruteo"
                    })
                },
                focusOnClosed: element,
                content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.ConfirmAndExecutePanel), {
                    content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        size: "sm",
                        mb: "xs",
                        children: "Va a enviar la solicitud de ruteo. \xbfEst\xe1 seguro?"
                    }),
                    operation: "proc",
                    onCancel: async ()=>{
                        abort_controller.abort();
                        await modal.close();
                        if (onClose) await onClose(false);
                    },
                    onOK: async ()=>{
                        const result = await solicitud.API.executeProcess(solicitud.def.procs.soru_Enviar, procParms, abort_controller.signal);
                        const success = result.Failed === false;
                        if (success) {
                            await modal.close();
                            if (onClose) await onClose(success);
                        }
                    }
                })
            });
        }
        return false;
    }
};

});

parcelRegister("sXLAL", function(module, exports) {

$parcel$export(module.exports, "ACTExportarClientesRutas", () => $0e45503c21ee4377$export$40b6c3cdb0372bc7);

var $ayMG0 = parcelRequire("ayMG0");

var $9VIWE = parcelRequire("9VIWE");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $acw62 = parcelRequire("acw62");

var $eD7iz = parcelRequire("eD7iz");
const $0e45503c21ee4377$export$bf442a334d5ff5a7 = ({ rutas: rutas, onClose: onClose })=>{
    const getRutas = (0, $49qEn.useExecuteProc)(rutas, rutas.def.procs.ruta_qryClientesExportar);
    const [datos0, setDatos0] = (0, $acw62.useState)();
    const { exportToExcel: exportToExcel } = (0, $49qEn.useExportToExcel)({
        data: [
            datos0
        ],
        dataResultNames: [
            'Rutas'
        ]
    });
    (0, $acw62.useEffect)(()=>{
        async function fetchData() {
            await getRutas.execute({});
        }
        fetchData();
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!getRutas.status.loading && getRutas.status.data) setDatos0(getRutas.status.data[0]);
    }, [
        getRutas.status
    ]);
    (0, $acw62.useEffect)(()=>{
        if (datos0) {
            exportToExcel();
            onClose();
        }
    }, [
        datos0
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9VIWE.Stack), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                children: "Generando archivo..."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.FakeProgressBar), {})
        ]
    });
};
const $0e45503c21ee4377$export$40b6c3cdb0372bc7 = {
    name: 'ACTExportarClientesRutas',
    label: 'Exportar Rutas por Cliente',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Exportar Rutas por Cliente"
    }),
    refreshOnClose: true,
    dontRequireSelection: true,
    showActionInViewMode: true,
    views: [
        'soru_brwDisponibleEnRutas'
    ],
    onClick: async ({ entity: entity, modal: modal, element: element, onClose: onClose })=>{
        const solicitudesRuteo = entity;
        const rutas = new (0, $eD7iz.Rutas)(solicitudesRuteo.API.client);
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                    fw: "700",
                    children: "Exportar Rutas"
                })
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)($0e45503c21ee4377$export$bf442a334d5ff5a7, {
                rutas: rutas,
                onClose: ()=>modal.close()
            })
        });
        return false;
    }
};

});

parcelRegister("6rNrX", function(module, exports) {

$parcel$export(module.exports, "ACTExportarRutas", () => $2a58046f2f6e7214$export$e2e36dfc229ce44b);

var $ayMG0 = parcelRequire("ayMG0");

var $9VIWE = parcelRequire("9VIWE");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $acw62 = parcelRequire("acw62");

var $eD7iz = parcelRequire("eD7iz");
const $2a58046f2f6e7214$export$8baf78000fde87d3 = ({ rutas: rutas, onClose: onClose })=>{
    const getRutas = (0, $49qEn.useExecuteProc)(rutas, rutas.def.procs.ruta_qryExportar);
    const [datos0, setDatos0] = (0, $acw62.useState)();
    const { exportToExcel: exportToExcel } = (0, $49qEn.useExportToExcel)({
        data: [
            datos0
        ],
        dataResultNames: [
            'Rutas'
        ]
    });
    (0, $acw62.useEffect)(()=>{
        async function fetchData() {
            await getRutas.execute({});
        }
        fetchData();
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!getRutas.status.loading && getRutas.status.data) setDatos0(getRutas.status.data[0]);
    }, [
        getRutas.status
    ]);
    (0, $acw62.useEffect)(()=>{
        if (datos0) {
            exportToExcel();
            onClose();
        }
    }, [
        datos0
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9VIWE.Stack), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                children: "Generando archivo..."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.FakeProgressBar), {})
        ]
    });
};
const $2a58046f2f6e7214$export$e2e36dfc229ce44b = {
    name: 'ACTExportarRutas',
    label: 'Exportar Rutas',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Exportar Rutas"
    }),
    refreshOnClose: true,
    dontRequireSelection: true,
    showActionInViewMode: true,
    views: [
        'soru_brwDisponibleEnRutas'
    ],
    onClick: async ({ entity: entity, modal: modal, element: element, onClose: onClose })=>{
        const solicitudesRuteo = entity;
        const rutas = new (0, $eD7iz.Rutas)(solicitudesRuteo.API.client);
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                    fw: "700",
                    children: "Exportar Rutas"
                })
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)($2a58046f2f6e7214$export$8baf78000fde87d3, {
                rutas: rutas,
                onClose: ()=>modal.close()
            })
        });
        return false;
    }
};

});

parcelRegister("2slTQ", function(module, exports) {

$parcel$export(module.exports, "ACTImportarRutas", () => $e1a90dd651f96813$export$e5da502d277d302f);

var $ayMG0 = parcelRequire("ayMG0");

var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $aXBRj = parcelRequire("aXBRj");

var $6P8un = parcelRequire("6P8un");
const $e1a90dd651f96813$export$e5da502d277d302f = {
    name: 'ACTImportarRutas',
    label: 'Importar Rutas',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Editar ruta"
    }),
    refreshOnClose: true,
    dontRequireSelection: true,
    views: [
        'soru_brwDisponibleEnRutas'
    ],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return false;
        }
        const solicitudesRuteoImportacion = new (0, $aXBRj.SolicitudesRuteoImportacion)(entity.API.client);
        const proceso_id = await new Promise(async (resolve)=>{
            await (0, $49qEn.openEntityForm)({
                modals: modal,
                formProps: {
                    entity: solicitudesRuteoImportacion,
                    initialFormMode: 'add',
                    getDataOnInit: false
                },
                modalFormSize: 'xl',
                handleModalSaved: async (result)=>{
                    const status = result.data?.Results?.[0]?.Status;
                    const message = result.data?.Results?.[0]?.Message;
                    if (status === 0) resolve(message ?? null);
                    else resolve(null);
                },
                handleModalCancel: async ()=>{
                    resolve(null);
                }
            });
        });
        await modal.close();
        if (onClose) await onClose();
        if (proceso_id) {
            const solicitudesRuteoImportacionProceso = new (0, $6P8un.SolicitudesRuteoImportacionProceso)(entity.API.client);
            solicitudesRuteoImportacionProceso.def.columns.c_proceso_id.value = proceso_id;
            await (0, $49qEn.openEntityForm)({
                modals: modal,
                formProps: {
                    entity: solicitudesRuteoImportacionProceso,
                    initialFormMode: 'view',
                    getDataOnInit: true
                },
                modalFormSize: 'xl',
                handleModalSaved: async ()=>{
                    await modal.close();
                    if (onClose) await onClose();
                },
                handleModalCancel: async ()=>{
                    await modal.close();
                    if (onClose) await onClose();
                }
            });
        }
        return false;
    }
};

});
parcelRegister("aXBRj", function(module, exports) {

$parcel$export(module.exports, "SolicitudesRuteoImportacion", () => $0b82ea351d5a94bd$export$6b1fbf680f71ca9d);

var $49qEn = parcelRequire("49qEn");

var $bdzm4 = parcelRequire("bdzm4");

var $g95Mr = parcelRequire("g95Mr");
const $0b82ea351d5a94bd$export$ee60cb936b408cea = (0, $bdzm4.default);
const $0b82ea351d5a94bd$export$71bd4fa39e867a2a = '* Las solicitudes de ruteo permiten solicitar nuevas rutas o modificar existentes';

class $0b82ea351d5a94bd$export$6b1fbf680f71ca9d extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $g95Mr.SolicitudesRuteoImportacionDef)(), parentKeys);
        this.Form = (parcelRequire("ii3Kt")).then((module)=>module.SolicitudesRuteoImportacionForm);
        this.Title = "Solicitudes de Ruteo";
        this.HelpText = $0b82ea351d5a94bd$export$71bd4fa39e867a2a;
        this.Icon = $0b82ea351d5a94bd$export$ee60cb936b408cea;
    }
}

});
parcelRegister("g95Mr", function(module, exports) {

$parcel$export(module.exports, "SolicitudesRuteoImportacionDef", () => $bf2f55b03632254d$export$eb0be4fbefdc06da);

var $49qEn = parcelRequire("49qEn");
const $bf2f55b03632254d$var$columns = ()=>({
        c_solicitudruteo_id: new (0, $49qEn.EntityColumn)({
            name: 'c_solicitudruteo_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PKAutonum,
            prompt: 'Solicitud Id'
        }),
        c_fileprocess_id: new (0, $49qEn.EntityColumn)({
            name: 'c_fileprocess_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Fileprocess Id'
        }),
        c_file_id: new (0, $49qEn.EntityColumn)({
            name: 'c_file_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'File Id'
        }),
        vc_filepath: new (0, $49qEn.EntityColumn)({
            name: 'vc_filepath',
            type: 'varchar',
            length: 2048,
            flags: (0, $49qEn.EntityColumnFlags).None,
            prompt: 'Filepath'
        }),
        c_proceso_id: new (0, $49qEn.EntityColumn)({
            name: 'c_proceso_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Proceso Id'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $bf2f55b03632254d$var$views = ()=>({});
const $bf2f55b03632254d$var$lookups = ()=>({});
const $bf2f55b03632254d$var$procs = ()=>({});
const $bf2f55b03632254d$var$clientActions = ()=>({});
class $bf2f55b03632254d$export$eb0be4fbefdc06da extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('SolicitudesRuteoImportacion'), this.columns = $bf2f55b03632254d$var$columns(), this.views = $bf2f55b03632254d$var$views(), this.lookups = $bf2f55b03632254d$var$lookups(), this.procs = $bf2f55b03632254d$var$procs(), this.clientActions = $bf2f55b03632254d$var$clientActions();
    }
}

});

parcelRegister("ii3Kt", function(module, exports) {
module.exports = import("6gURx").then(()=>parcelRequire('5ZuF6'));

});


parcelRegister("6P8un", function(module, exports) {

$parcel$export(module.exports, "SolicitudesRuteoImportacionProceso", () => $4dc2bdee7ac3a1dd$export$f87b9e734e757623);

var $49qEn = parcelRequire("49qEn");

var $bdzm4 = parcelRequire("bdzm4");

var $7WoaN = parcelRequire("7WoaN");
const $4dc2bdee7ac3a1dd$export$258b9ad82c9ae0b9 = (0, $bdzm4.default);
const $4dc2bdee7ac3a1dd$export$a6c7bec8a2d9405a = "* Importaci\xf3n de Ruteos";

class $4dc2bdee7ac3a1dd$export$f87b9e734e757623 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $7WoaN.SolicitudesRuteoImportacionProcesoDef)(), parentKeys);
        this.Form = (parcelRequire("jpGIJ")).then((module)=>module.SolicitudesRuteoImportacionProcesoForm);
        this.Title = "Importaci\xf3n de Ruteos";
        this.HelpText = $4dc2bdee7ac3a1dd$export$a6c7bec8a2d9405a;
        this.Icon = $4dc2bdee7ac3a1dd$export$258b9ad82c9ae0b9;
    }
}

});
parcelRegister("7WoaN", function(module, exports) {

$parcel$export(module.exports, "SolicitudesRuteoImportacionProcesoDef", () => $6fdd0825683889ef$export$9af6b624b2ba39a4);

var $49qEn = parcelRequire("49qEn");
const $6fdd0825683889ef$var$columns = ()=>({
        c_proceso_id: new (0, $49qEn.EntityColumn)({
            name: 'c_proceso_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PKAutonum,
            prompt: 'Proceso Id'
        }),
        c_fileprocess_id: new (0, $49qEn.EntityColumn)({
            name: 'c_fileprocess_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Fileprocess Id'
        }),
        vc_errores: new (0, $49qEn.EntityColumn)({
            name: 'vc_errores',
            type: 'varchar',
            length: 0,
            flags: (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Errores'
        }),
        vc_fileguid: new (0, $49qEn.EntityColumn)({
            name: 'vc_fileguid',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.EntityColumnFlags).None,
            prompt: 'Fileguid'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $6fdd0825683889ef$var$views = ()=>({
        srip_brwStandard: {
            name: 'srip_brwStandard',
            keyMappings: {
                c_proceso_id: 0
            }
        }
    });
class $6fdd0825683889ef$export$9af6b624b2ba39a4 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('SolicitudesRuteoImportacionProceso'), this.columns = $6fdd0825683889ef$var$columns(), this.views = $6fdd0825683889ef$var$views();
    }
}

});

parcelRegister("jpGIJ", function(module, exports) {
module.exports = import("l7ips").then(()=>parcelRequire('4mbzg'));

});



parcelRegister("gadmm", function(module, exports) {

$parcel$export(module.exports, "ACTReasignarRuta", () => $d498c035bc150f29$export$35831c96fbc222d9);

var $ayMG0 = parcelRequire("ayMG0");

var $gU5rH = parcelRequire("gU5rH");
var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");

var $7LP39 = parcelRequire("7LP39");
const $d498c035bc150f29$export$35831c96fbc222d9 = {
    name: 'ACTReasignarRuta',
    label: 'Reasignar Ruta',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Reasignar Ruta"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    minSelectedRecords: 1,
    maxSelectedRecords: 1,
    views: [
        'soru_brwDisponibleEnRutas'
    ],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const solicitudesruteo = entity;
        const personal = new (0, $7LP39.Personal)(entity.API.client);
        const procParms = {
            c_personal_origen_id: selectedKeys?.[0]?.['c_personal_id'] ?? '',
            c_personal_destino_id: ''
        };
        let errores = '';
        if (!procParms.c_personal_origen_id) errores = "Los registros seleccionados son inv\xe1lidos";
        await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                    fw: "700",
                    children: "Reasignar ruta"
                }),
                size: 'xl'
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.LookupFormAction), {
                lookupEntity: personal,
                viewName: personal.def.views.perl_brwGestionPersonal.name,
                title: "Reasignar ruta",
                confirmContent: "\xbfEst\xe1 seguro de que desea reasignar la ruta del personal seleccionado?",
                onActionFinished: async ()=>{
                    if (onClose) await onClose();
                },
                onOK: async (keys, abortSignal)=>{
                    const abort_controller = new AbortController();
                    let status = 11;
                    let message = '';
                    if (keys && keys.length > 0) {
                        if (onClose) await onClose();
                        await modal.close();
                    }
                    procParms.c_personal_destino_id = keys[0].c_personal_id;
                    const result = await solicitudesruteo.API.executeProcess(solicitudesruteo.def.procs.soru_CrearSolicitudesReasignacion, procParms, abort_controller.signal);
                    status = result.Results[0].Status;
                    message = result.Results[0].Message;
                    if (status === 11) await modal.open({
                        modalProps: {
                            title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                                        size: "1.5rem",
                                        stroke: "1.5"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                                        fw: "700",
                                        children: "ERROR"
                                    })
                                ]
                            })
                        },
                        focusOnClosed: element,
                        content: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                                    size: "sm",
                                    mb: "xs",
                                    children: message
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                                    mt: "xs",
                                    position: "right",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                                        onClick: async ()=>await modal.close(),
                                        children: "Cerrar"
                                    })
                                })
                            ]
                        })
                    });
                    return result;
                }
            })
        });
        return false;
    }
};

});

parcelRegister("oucKI", function(module, exports) {

$parcel$export(module.exports, "ACTRechazarSolicitudRuta", () => $33142b2522b2ab6c$export$b062e42ca42a2205);

var $ayMG0 = parcelRequire("ayMG0");

var $gU5rH = parcelRequire("gU5rH");
var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");
const $33142b2522b2ab6c$export$b062e42ca42a2205 = {
    name: 'ACTRechazarSolicitudRuta',
    label: 'Rechazar Solicitud',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Rechazar solicitud de ruta"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    views: [
        'soru_brwStandard'
    ],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        // cast entity
        const solicitud = entity;
        const procParms = {
            c_solicitudruteo_id: selectedKeys?.[0]?.['c_solicitudruteo_id'] ?? ''
        };
        let errores = '';
        if (!procParms.c_solicitudruteo_id) errores = "Los registros seleccionados son inv\xe1lidos";
        if (errores) await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                            size: "1.5rem",
                            stroke: "1.5"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            fw: "700",
                            children: "ERROR"
                        })
                    ]
                })
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        size: "sm",
                        mb: "xs",
                        children: errores
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                        mt: "xs",
                        position: "right",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                            onClick: async ()=>await modal.close(),
                            children: "Cerrar"
                        })
                    })
                ]
            })
        });
        else {
            const abort_controller = new AbortController();
            await modal.open({
                modalProps: {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        fw: "700",
                        children: "Rechazar solicitud de ruteo"
                    })
                },
                focusOnClosed: element,
                content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.ConfirmAndExecutePanel), {
                    content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        size: "sm",
                        mb: "xs",
                        children: "Va a rechazar la solicitud de ruteo. \xbfEst\xe1 seguro?"
                    }),
                    operation: "proc",
                    onCancel: async ()=>{
                        abort_controller.abort();
                        await modal.close();
                        if (onClose) await onClose(false);
                    },
                    onOK: async ()=>{
                        const result = await solicitud.API.executeProcess(solicitud.def.procs.soru_Rechazar, procParms, abort_controller.signal);
                        const success = result.Failed === false;
                        if (success) {
                            await modal.close();
                            if (onClose) await onClose(success);
                        }
                        return result;
                    }
                })
            });
        }
        return false;
    }
};

});

parcelRegister("knTCD", function(module, exports) {

$parcel$export(module.exports, "ACTVerImportaciones", () => $9d8648910755dc54$export$669f660cc9308213);

var $ayMG0 = parcelRequire("ayMG0");

var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");

var $6P8un = parcelRequire("6P8un");
const $9d8648910755dc54$export$669f660cc9308213 = {
    name: 'ACTVerImportaciones',
    label: 'Ver Importaciones',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Ver Importaciones"
    }),
    refreshOnClose: true,
    dontRequireSelection: true,
    views: [
        'soru_brwDisponibleEnRutas'
    ],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        const solicitudesRuteoImportacionProceso = new (0, $6P8un.SolicitudesRuteoImportacionProceso)(entity.API.client);
        await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                            size: "1.5rem",
                            stroke: "1.5"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            fw: "700",
                            children: "Importaciones de Ruteos"
                        })
                    ]
                }),
                size: "xl"
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: entity.API.client,
                entityConstructor: ()=>solicitudesRuteoImportacionProceso,
                formMode: "edit",
                viewName: "srip_brwStandard",
                refreshOnInit: true,
                enableAdd: false,
                enableDelete: false,
                enableEdit: false,
                enableView: true,
                title: "Ver Importaciones de Ruteos",
                selectionMode: "single"
            }, "importaciones-solicitudes-ruteo")
        });
        return false;
    }
};

});

parcelRegister("gFeIW", function(module, exports) {

$parcel$export(module.exports, "DisponibleEnRutasViewColumnsOverrides", () => $d44d669bc7d7e7ea$export$570aff03b75cdf05);

var $ayMG0 = parcelRequire("ayMG0");

var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $iEQtx = parcelRequire("iEQtx");
var $46Z0k = parcelRequire("46Z0k");
var $6zxJ3 = parcelRequire("6zxJ3");
var $3US3h = parcelRequire("3US3h");
function $d44d669bc7d7e7ea$export$570aff03b75cdf05(theme) {
    return {
        // Horario
        6: {
            render: (value)=>!value ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    style: {
                        gap: '.5rem'
                    },
                    noWrap: true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iEQtx.default), {
                            style: {
                                color: theme.colors.red[8],
                                minWidth: "1.3rem"
                            },
                            size: "1.3rem"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            truncate: true,
                            children: "Sin horario asignado"
                        })
                    ]
                }) : value
        },
        // Horas semanales disponibles
        7: {
            render: (value)=>{
                const num = Number.parseFloat(value);
                const val = value === "" ? null : num;
                if (val === null) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    style: {
                        gap: '.5rem'
                    },
                    noWrap: true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iEQtx.default), {
                            style: {
                                color: theme.colors.red[8],
                                minWidth: "1.3rem"
                            },
                            size: "1.3rem"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            truncate: true,
                            children: "Sin rutas asignadas"
                        })
                    ]
                });
                if (val && val > 0) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    style: {
                        gap: '.5rem'
                    },
                    noWrap: true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $46Z0k.default), {
                            style: {
                                color: theme.colors.pink[6],
                                minWidth: "1.3rem"
                            },
                            size: "1.3rem"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cjohz.Text), {
                            truncate: true,
                            children: [
                                value,
                                " horas disponibles"
                            ]
                        })
                    ]
                });
                if (val && val < 0) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    style: {
                        gap: '.5rem'
                    },
                    noWrap: true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6zxJ3.default), {
                            style: {
                                color: theme.colors.yellow[8],
                                minWidth: "1.3rem"
                            },
                            size: "1.3rem"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cjohz.Text), {
                            children: [
                                value,
                                " horas sobreasignadas"
                            ]
                        })
                    ]
                });
                if (val === 0.00) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    style: {
                        gap: '.5rem'
                    },
                    noWrap: true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.CircleFilledIcon), {
                            mr: "xs",
                            width: "1.3rem",
                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3US3h.default), {
                                size: "0.9rem"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            children: "Horas totales asignadas"
                        })
                    ]
                });
                return value;
            }
        },
        // Baja
        10: {
            render: (value)=>value ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    style: {
                        gap: '.5rem'
                    },
                    noWrap: true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iEQtx.default), {
                            style: {
                                color: theme.colors.red[8],
                                minWidth: "1.3rem"
                            },
                            size: "1.3rem"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            truncate: true,
                            children: value
                        })
                    ]
                }) : value
        },
        // Licencia
        11: {
            render: (value)=>{
                const val = value;
                if (val.startsWith('De licencia')) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    style: {
                        gap: '.5rem'
                    },
                    noWrap: true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iEQtx.default), {
                            style: {
                                color: theme.colors.red[8],
                                minWidth: "1.3rem"
                            },
                            size: "1.3rem"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            truncate: true,
                            children: val
                        })
                    ]
                });
                if (val.startsWith("Pr\xf3xima licencia")) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    style: {
                        gap: '.5rem'
                    },
                    noWrap: true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $46Z0k.default), {
                            style: {
                                color: theme.colors.yellow[8],
                                minWidth: "1.3rem"
                            },
                            size: "1.3rem"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            truncate: true,
                            children: value
                        })
                    ]
                });
                return value;
            }
        }
    };
}

});

parcelRegister("kAi3x", function(module, exports) {

$parcel$export(module.exports, "DisponibleEnRutasViewInfoWindowRenderer", () => $563c10ed10c297a1$export$3f7edcc0eac0f04c);

var $ayMG0 = parcelRequire("ayMG0");

var $436KA = parcelRequire("436KA");
var $gU5rH = parcelRequire("gU5rH");
var $kPsAn = parcelRequire("kPsAn");
var $9mTYo = parcelRequire("9mTYo");
var $9VIWE = parcelRequire("9VIWE");
var $cjohz = parcelRequire("cjohz");
var $ew26C = parcelRequire("ew26C");

var $gFeIW = parcelRequire("gFeIW");
function $563c10ed10c297a1$export$3f7edcc0eac0f04c(record, position, groupManager, infoWindow, UIAPI, theme, entity) {
    const columnsRender = (0, $gFeIW.DisponibleEnRutasViewColumnsOverrides)(theme);
    const personal_id = record[0];
    const apellido = record[3];
    const nombre = record[4];
    const puesto = record[5];
    const horario = record[6];
    const horas_disponibles = record[7];
    const baja = record[10];
    const licencia = record[11];
    const supervisor = record[12];
    const vc_fotoguid = record[25];
    const ruta_id = record[26];
    const SolicitudesRuteo = entity;
    const fotoURL = entity.API.client.getDocumentURL(vc_fotoguid);
    const group = groupManager.getGroupByLocation(position);
    if (group) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kPsAn.Card), {
        withBorder: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9VIWE.Stack), {
            spacing: "xs",
            mb: "xs",
            children: [
                group.records.map(({ recordValue: rec }, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ew26C.Title), {
                                order: 5,
                                children: `ID: ${rec[0]} ${rec[3]}, ${4}${rec[5] ? ' - ' : ''}${rec[5]}`
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                                size: "xs",
                                onClick: async ()=>{
                                    await UIAPI.handleExecuteAction(SolicitudesRuteo.def.clientActions.ACTEditarRuta, [
                                        {
                                            'c_personal_id': rec[0]
                                        }
                                    ]);
                                },
                                children: "Editar"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                                size: "xs",
                                onClick: async ()=>{
                                    await UIAPI.handleExecuteAction(SolicitudesRuteo.def.clientActions.ACTEliminarRuta, [
                                        {
                                            'c_personal_id': rec[0],
                                            'c_tiposolicitudruta_id': 'ELIMINAR'
                                        }
                                    ]);
                                },
                                children: "Eliminar"
                            })
                        ]
                    }, `grp_${rec[0]}`)),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                        size: "xs",
                        variant: "light",
                        onClick: ()=>{
                            infoWindow.close();
                        },
                        children: "Cerrar"
                    })
                })
            ]
        })
    });
    else {
        const horario_asignado = columnsRender[6].render(horario);
        const horas_semanales_disponibles = columnsRender[7].render(horas_disponibles);
        const estado_baja = columnsRender[10].render(baja);
        const estado_licencia = columnsRender[11].render(licencia);
        const client = entity.API.client;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kPsAn.Card), {
            withBorder: true,
            padding: "xs",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9VIWE.Stack), {
                spacing: "0.5rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        spacing: "xs",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $436KA.Avatar), {
                                size: "md",
                                src: fotoURL,
                                radius: "sm"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ew26C.Title), {
                                order: 4,
                                children: `${apellido}, ${nombre}`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        spacing: "xs",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                                weight: 500,
                                size: "sm",
                                children: "Puesto: "
                            }),
                            puesto
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        spacing: "xs",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                                weight: 500,
                                size: "sm",
                                children: "Supervisi\xf3n: "
                            }),
                            supervisor
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        spacing: "0rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                                mr: "xs",
                                weight: 500,
                                size: "sm",
                                children: "Horas pactadas: "
                            }),
                            horario_asignado
                        ]
                    }),
                    horas_semanales_disponibles && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        spacing: "0rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                                mr: "xs",
                                weight: 500,
                                size: "sm",
                                children: "Horas semanales disponibles: "
                            }),
                            horas_semanales_disponibles
                        ]
                    }),
                    estado_licencia && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                        spacing: "0.5rem",
                        children: estado_licencia
                    }),
                    estado_baja && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                        spacing: "0.5rem",
                        children: estado_baja
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        position: "right",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                                size: "xs",
                                variant: "light",
                                onClick: ()=>{
                                    infoWindow.close();
                                },
                                children: "Cerrar"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                                size: "xs",
                                onClick: async ()=>{
                                    await UIAPI.handleExecuteAction(SolicitudesRuteo.def.clientActions.ACTEditarRuta, [
                                        {
                                            'c_personal_id': personal_id
                                        }
                                    ]);
                                },
                                children: "Editar"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                                size: "xs",
                                onClick: async ()=>{
                                    await UIAPI.handleExecuteAction(SolicitudesRuteo.def.clientActions.ACTEliminarRuta, [
                                        {
                                            'c_personal_id': personal_id,
                                            'c_tiposolicitudruta_id': 'ELIMINAR'
                                        }
                                    ]);
                                },
                                children: "Eliminar"
                            })
                        ]
                    })
                ]
            })
        });
    }
}

});

parcelRegister("gjhGv", function(module, exports) {

$parcel$export(module.exports, "DisponibleEnRutasViewMarkerRenderer", () => $3cf18bcbe24b68e7$export$8587da4b152127fe);

var $d2PjO = parcelRequire("d2PjO");
function $3cf18bcbe24b68e7$export$8587da4b152127fe(record, position, theme) {
    const personal_id = record[0];
    const apellido = record[3];
    const nombre = record[4];
    const puesto = record[5];
    const horas_disponibles_str = record[7];
    const horas_disponibles = horas_disponibles_str === "" ? null : Number.parseFloat(horas_disponibles_str);
    let color = theme.colors.green[6];
    let disponibles = '';
    let icon = (0, $d2PjO.moodSmileIcon);
    if (horas_disponibles === null) {
        color = theme.colors.red[8];
        disponibles = '(! Sin rutas asignadas)';
        icon = (0, $d2PjO.moodNeutralIcon);
    } else if (horas_disponibles > 0) {
        color = theme.colors.pink[6];
        disponibles = `(${horas_disponibles} horas disponibles)`;
        icon = (0, $d2PjO.moodSmileIcon);
    } else if (horas_disponibles < 0) {
        color = theme.colors.orange[6];
        disponibles = `(${horas_disponibles} horas sobreasignadas)`;
        icon = (0, $d2PjO.moodSadIcon);
    } else if (horas_disponibles === 0) {
        color = theme.colors.green[6];
        disponibles = `(Todas las horas asignadas)`;
        icon = (0, $d2PjO.moodHappyIcon);
    }
    const markerProps = {
        position: position,
        title: `${apellido}, ${nombre}${puesto && puesto ? ' - ' : ''}${puesto} - ${disponibles}`,
        svgIcon: icon,
        assignColorByValue: undefined,
        fillColor: color
    };
    return markerProps;
}

});


parcelRegister("b72F8", function(module, exports) {
module.exports = Promise.all([
    import("h8pzO"),
    import("4jVIF"),
    import("cVmHe")
]).then(()=>parcelRequire('duHYU'));

});

parcelRegister("fZOv9", function(module, exports) {
module.exports = Promise.all([
    import("4jVIF"),
    import("8xyGX")
]).then(()=>parcelRequire('2kBC0'));

});


parcelRegister("btiOb", function(module, exports) {

$parcel$export(module.exports, "SolicitudesRuteoInfo", () => $ea09b445b74d3ab9$export$25e8f78ad2b9efce);

var $49qEn = parcelRequire("49qEn");

var $bdzm4 = parcelRequire("bdzm4");

var $bx3c7 = parcelRequire("bx3c7");
const $ea09b445b74d3ab9$export$ee60cb936b408cea = (0, $bdzm4.default);
const $ea09b445b74d3ab9$export$71bd4fa39e867a2a = '* Las solicitudes de ruteo permiten solicitar nuevas rutas o modificar existentes';

class $ea09b445b74d3ab9$export$25e8f78ad2b9efce extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $bx3c7.SolicitudesRuteoInfoDef)(), parentKeys);
        this.Form = (parcelRequire("fHSew")).then((module)=>module.SolicitudesRuteoInfoForm);
        this.Title = "Solicitudes de Ruteo";
        this.HelpText = $ea09b445b74d3ab9$export$71bd4fa39e867a2a;
        this.Icon = $ea09b445b74d3ab9$export$ee60cb936b408cea;
    }
}

});
parcelRegister("bx3c7", function(module, exports) {

$parcel$export(module.exports, "SolicitudesRuteoInfoDef", () => $f76b105f0bf81edc$export$7f9fb42dedeeb5a4);

var $49qEn = parcelRequire("49qEn");

var $aCFMu = parcelRequire("aCFMu");

var $kna9I = parcelRequire("kna9I");

var $7LP39 = parcelRequire("7LP39");

var $vpw2n = parcelRequire("vpw2n");

var $kVtYR = parcelRequire("kVtYR");

var $Hg88E = parcelRequire("Hg88E");

var $bnrZu = parcelRequire("bnrZu");

var $goM3B = parcelRequire("goM3B");
const $f76b105f0bf81edc$var$columns = ()=>({
        c_solicitudruteo_id: new (0, $49qEn.EntityColumn)({
            name: 'c_solicitudruteo_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PKAutonum,
            prompt: 'Solicitud Id'
        }),
        c_ruta_id: new (0, $49qEn.EntityColumn)({
            name: 'c_ruta_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Ruta Id'
        }),
        c_tiposolicitudruta_id: new (0, $49qEn.EntityColumn)({
            name: 'c_tiposolicitudruta_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Tipo'
        }),
        vc_codigo_ruta_solicitud: new (0, $49qEn.EntityColumn)({
            name: 'vc_codigo_ruta_solicitud',
            type: 'varchar',
            length: 50,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "C\xf3digo Ruta"
        }),
        d_fechadesde: new (0, $49qEn.EntityColumn)({
            name: 'd_fechadesde',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Fecha desde'
        }),
        vc_nombre_ruta_solicitud: new (0, $49qEn.EntityColumn)({
            name: 'vc_nombre_ruta_solicitud',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Nombre Ruta'
        }),
        vc_observaciones_solicitud: new (0, $49qEn.EntityColumn)({
            name: 'vc_observaciones_solicitud',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Observaciones'
        }),
        c_personal_id: new (0, $49qEn.EntityColumn)({
            name: 'c_personal_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Personal Id'
        }),
        c_persona_id: new (0, $49qEn.EntityColumn)({
            name: 'c_persona_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Persona Id'
        }),
        vc_numerodni: new (0, $49qEn.EntityColumn)({
            name: 'vc_numerodni',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'DNI'
        }),
        vc_nombre: new (0, $49qEn.EntityColumn)({
            name: 'vc_nombre',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Nombre'
        }),
        vc_apellido: new (0, $49qEn.EntityColumn)({
            name: 'vc_apellido',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Apellido'
        }),
        vc_puestotrabajo: new (0, $49qEn.EntityColumn)({
            name: 'vc_puestotrabajo',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Puesto'
        }),
        dt_nacimiento: new (0, $49qEn.EntityColumn)({
            name: 'dt_nacimiento',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Nacimiento'
        }),
        vc_genero: new (0, $49qEn.EntityColumn)({
            name: 'vc_genero',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "G\xe9nero"
        }),
        vc_fotoguid: new (0, $49qEn.EntityColumn)({
            name: 'vc_fotoguid',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Foto URL'
        }),
        vc_superior: new (0, $49qEn.EntityColumn)({
            name: 'vc_superior',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Superior'
        }),
        vc_telefono: new (0, $49qEn.EntityColumn)({
            name: 'vc_telefono',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Tel\xe9fono"
        }),
        vc_celular: new (0, $49qEn.EntityColumn)({
            name: 'vc_celular',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Celular'
        }),
        vc_celular_trabajo: new (0, $49qEn.EntityColumn)({
            name: 'vc_celular_trabajo',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Celular Trabajo'
        }),
        vc_telefono_alternativo: new (0, $49qEn.EntityColumn)({
            name: 'vc_telefono_alternativo',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Tel\xe9fono Alternativo"
        }),
        vc_email: new (0, $49qEn.EntityColumn)({
            name: 'vc_email',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Email'
        }),
        vc_email_alternativo: new (0, $49qEn.EntityColumn)({
            name: 'vc_email_alternativo',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Email Alternativo'
        }),
        f_latitud: new (0, $49qEn.EntityColumn)({
            name: 'f_latitud',
            type: 'float',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Latitud'
        }),
        f_longitud: new (0, $49qEn.EntityColumn)({
            name: 'f_longitud',
            type: 'float',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Longitud'
        }),
        vc_domicilio_completo: new (0, $49qEn.EntityColumn)({
            name: 'vc_domicilio_completo',
            type: 'varchar',
            length: 2048,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Domicilio Completo'
        }),
        n_total_horas_semanales: new (0, $49qEn.EntityColumn)({
            name: 'n_total_horas_semanales',
            type: 'decimal',
            scale: 2,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Total Horas Semanales'
        }),
        n_horas_semanales_disponibles: new (0, $49qEn.EntityColumn)({
            name: 'n_horas_semanales_disponibles',
            type: 'decimal',
            scale: 2,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Horas Semanales Disponibles'
        }),
        n_horas_semanales_compartidas: new (0, $49qEn.EntityColumn)({
            name: 'n_horas_semanales_compartidas',
            type: 'decimal',
            scale: 2,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Horas Semanales Compartidas'
        }),
        n_horas_semanales_exclusivas: new (0, $49qEn.EntityColumn)({
            name: 'n_horas_semanales_exclusivas',
            type: 'decimal',
            scale: 2,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Horas Semanales Exclusivas'
        }),
        dt_fecha_baja: new (0, $49qEn.EntityColumn)({
            name: 'dt_fecha_baja',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Fecha Baja'
        }),
        dt_fecha_alta: new (0, $49qEn.EntityColumn)({
            name: 'dt_fecha_alta',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Fecha Alta'
        }),
        dt_licencia_desde: new (0, $49qEn.EntityColumn)({
            name: 'dt_licencia_desde',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Licencia Desde'
        }),
        dt_licencia_hasta: new (0, $49qEn.EntityColumn)({
            name: 'dt_licencia_hasta',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Licencia Hasta'
        }),
        c_estado_licencia_id: new (0, $49qEn.EntityColumn)({
            name: 'c_estado_licencia_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Estado Licencia Id'
        }),
        vc_tiendas: new (0, $49qEn.EntityColumn)({
            name: 'vc_tiendas',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Tiendas',
            isArray: true
        }),
        c_autorizacion_id: new (0, $49qEn.EntityColumn)({
            name: 'c_autorizacion_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Autorizacion Id'
        }),
        vc_personal_solicitud: new (0, $49qEn.EntityColumn)({
            name: 'vc_personal_solicitud',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Personal Solicitud'
        }),
        c_personal_ruta_id: new (0, $49qEn.EntityColumn)({
            name: 'c_personal_ruta_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Personal Ruta Id'
        }),
        vc_personal_ruta: new (0, $49qEn.EntityColumn)({
            name: 'vc_personal_ruta',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Personal Ruta'
        }),
        c_persona_ruta_id: new (0, $49qEn.EntityColumn)({
            name: 'c_persona_ruta_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Persona Id'
        }),
        vc_numerodni_ruta: new (0, $49qEn.EntityColumn)({
            name: 'vc_numerodni_ruta',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'DNI'
        }),
        vc_nombre_ruta: new (0, $49qEn.EntityColumn)({
            name: 'vc_nombre_ruta',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Nombre'
        }),
        vc_apellido_ruta: new (0, $49qEn.EntityColumn)({
            name: 'vc_apellido_ruta',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Apellido'
        }),
        vc_puestotrabajo_ruta: new (0, $49qEn.EntityColumn)({
            name: 'vc_puestotrabajo_ruta',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Puesto'
        }),
        dt_nacimiento_ruta: new (0, $49qEn.EntityColumn)({
            name: 'dt_nacimiento_ruta',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Nacimiento'
        }),
        vc_genero_ruta: new (0, $49qEn.EntityColumn)({
            name: 'vc_genero_ruta',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "G\xe9nero"
        }),
        vc_fotoguid_ruta: new (0, $49qEn.EntityColumn)({
            name: 'vc_fotoguid_ruta',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Foto URL'
        }),
        vc_superior_ruta: new (0, $49qEn.EntityColumn)({
            name: 'vc_superior_ruta',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Superior'
        }),
        vc_telefono_ruta: new (0, $49qEn.EntityColumn)({
            name: 'vc_telefono_ruta',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Tel\xe9fono"
        }),
        vc_celular_ruta: new (0, $49qEn.EntityColumn)({
            name: 'vc_celular_ruta',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Celular'
        }),
        vc_celular_trabajo_ruta: new (0, $49qEn.EntityColumn)({
            name: 'vc_celular_trabajo_ruta',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Celular Trabajo'
        }),
        vc_telefono_alternativo_ruta: new (0, $49qEn.EntityColumn)({
            name: 'vc_telefono_alternativo_ruta',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Tel\xe9fono Alternativo"
        }),
        vc_email_ruta: new (0, $49qEn.EntityColumn)({
            name: 'vc_email_ruta',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Email'
        }),
        vc_email_alternativo_ruta: new (0, $49qEn.EntityColumn)({
            name: 'vc_email_alternativo_ruta',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Email Alternativo'
        }),
        f_latitud_ruta: new (0, $49qEn.EntityColumn)({
            name: 'f_latitud_ruta',
            type: 'float',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Latitud'
        }),
        f_longitud_ruta: new (0, $49qEn.EntityColumn)({
            name: 'f_longitud_ruta',
            type: 'float',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Longitud'
        }),
        vc_domicilio_completo_ruta: new (0, $49qEn.EntityColumn)({
            name: 'vc_domicilio_completo_ruta',
            type: 'varchar',
            length: 2048,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Domicilio Completo'
        }),
        n_total_horas_semanales_ruta: new (0, $49qEn.EntityColumn)({
            name: 'n_total_horas_semanales_ruta',
            type: 'decimal',
            scale: 2,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Total Horas Semanales'
        }),
        n_horas_semanales_disponibles_ruta: new (0, $49qEn.EntityColumn)({
            name: 'n_horas_semanales_disponibles_ruta',
            type: 'decimal',
            scale: 2,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Horas Semanales Disponibles'
        }),
        n_horas_semanales_compartidas_ruta: new (0, $49qEn.EntityColumn)({
            name: 'n_horas_semanales_compartidas_ruta',
            type: 'decimal',
            scale: 2,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Horas Semanales Compartidas'
        }),
        n_horas_semanales_exclusivas_ruta: new (0, $49qEn.EntityColumn)({
            name: 'n_horas_semanales_exclusivas_ruta',
            type: 'decimal',
            scale: 2,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Horas Semanales Exclusivas'
        }),
        dt_fecha_baja_ruta: new (0, $49qEn.EntityColumn)({
            name: 'dt_fecha_baja_ruta',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Fecha Baja'
        }),
        dt_fecha_alta_ruta: new (0, $49qEn.EntityColumn)({
            name: 'dt_fecha_alta_ruta',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Fecha Alta'
        }),
        dt_licencia_desde_ruta: new (0, $49qEn.EntityColumn)({
            name: 'dt_licencia_desde_ruta',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Licencia Desde'
        }),
        dt_licencia_hasta_ruta: new (0, $49qEn.EntityColumn)({
            name: 'dt_licencia_hasta_ruta',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Licencia Hasta'
        }),
        c_estado_licencia_ruta_id: new (0, $49qEn.EntityColumn)({
            name: 'c_estado_licencia_ruta_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Estado Licencia Id'
        }),
        vc_codigo_ruta: new (0, $49qEn.EntityColumn)({
            name: 'vc_codigo_ruta',
            type: 'varchar',
            length: 50,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "C\xf3digo Ruta"
        }),
        d_fechadesde_ruta: new (0, $49qEn.EntityColumn)({
            name: 'd_fechadesde_ruta',
            type: 'date',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Fecha desde'
        }),
        vc_nombre_ruta_ruta: new (0, $49qEn.EntityColumn)({
            name: 'vc_nombre_ruta_ruta',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Nombre Ruta'
        }),
        vc_observaciones_ruta: new (0, $49qEn.EntityColumn)({
            name: 'vc_observaciones_ruta',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Observaciones'
        }),
        vc_cliente_solicitud: new (0, $49qEn.EntityColumn)({
            name: 'vc_cliente_solicitud',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Cliente Solicitud'
        }),
        vc_cliente_ruta: new (0, $49qEn.EntityColumn)({
            name: 'vc_cliente_ruta',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Cliente Ruta'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $f76b105f0bf81edc$var$views = ()=>({
        sorui_brwStandard: {
            name: 'sorui_brwStandard',
            keyMappings: {
                c_solicitudruteo_id: 0
            },
            FiltersEntity: (client, parentKeys)=>new (0, $vpw2n.SolicitudesRuteoInfoFilters)(client, parentKeys)
        },
        sorui_brwBorradores: {
            name: 'sorui_brwBorradores',
            keyMappings: {
                c_solicitudruteo_id: 0
            },
            FiltersEntity: (client, parentKeys)=>new (0, $vpw2n.SolicitudesRuteoInfoFilters)(client, parentKeys)
        },
        sorui_brwHistorial: {
            name: 'sorui_brwHistorial',
            keyMappings: {
                c_solicitudruteo_id: 0
            }
        },
        sorui_brwDiferenciasRuta: {
            name: 'sorui_brwDiferenciasRuta',
            keyMappings: {
                c_solicitudruteo_id: 0
            },
            gridColumnsOverrides: (0, $goM3B.DiferenciasRutaInfoViewColumnsOverrides)
        }
    });
const $f76b105f0bf81edc$var$lookups = ()=>({
        'Personal': {
            name: 'Personal',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $7LP39.Personal)(client, parentKeys)
        },
        'TiposSolicitudRuta': {
            name: 'TiposSolicitudRuta',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $kna9I.catTiposSolicitudRuta)(client, parentKeys)
        },
        ...(0, $aCFMu.DomiciliosLookups)()
    });
const $f76b105f0bf81edc$var$procs = ()=>({
        sorui_Enviar: {
            name: 'sorui_Enviar'
        },
        sorui_Autorizar: {
            name: 'sorui_Autorizar'
        },
        sorui_Rechazar: {
            name: 'sorui_Rechazar'
        }
    });
const $f76b105f0bf81edc$var$clientActions = ()=>({
        ACTAutorizarSolicitud: (0, $kVtYR.ACTAutorizarSolicitud),
        ACTRechazarSolicitud: (0, $bnrZu.ACTRechazarSolicitud),
        ACTEnviarSolicitud: (0, $Hg88E.ACTEnviarSolicitud)
    });
class $f76b105f0bf81edc$export$7f9fb42dedeeb5a4 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('SolicitudesRuteoInfo'), this.columns = $f76b105f0bf81edc$var$columns(), this.views = $f76b105f0bf81edc$var$views(), this.lookups = $f76b105f0bf81edc$var$lookups(), this.procs = $f76b105f0bf81edc$var$procs(), this.clientActions = $f76b105f0bf81edc$var$clientActions();
    }
}

});
parcelRegister("vpw2n", function(module, exports) {

$parcel$export(module.exports, "SolicitudesRuteoInfoFilters", () => $e47c609cba134288$export$d5b17a8f956d831b);

var $49qEn = parcelRequire("49qEn");

var $bdzm4 = parcelRequire("bdzm4");

var $4CAIC = parcelRequire("4CAIC");
const $e47c609cba134288$export$ee60cb936b408cea = (0, $bdzm4.default);
const $e47c609cba134288$export$71bd4fa39e867a2a = '* Las solicitudes de ruteo permiten solicitar nuevas rutas o modificar existentes';

class $e47c609cba134288$export$d5b17a8f956d831b extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $4CAIC.SolicitudesRuteoInfoFiltersDef)(), parentKeys);
        this.Form = (parcelRequire("7UCQb")).then((module)=>module.SolicitudesRuteoInfoFiltersForm);
        this.Title = "Solicitudes de Ruteo Filtros";
        this.HelpText = $e47c609cba134288$export$71bd4fa39e867a2a;
        this.Icon = $e47c609cba134288$export$ee60cb936b408cea;
    }
}

});
parcelRegister("4CAIC", function(module, exports) {

$parcel$export(module.exports, "SolicitudesRuteoInfoFiltersDef", () => $045b5c5d22881021$export$adbbb925d0bc7a13);

var $49qEn = parcelRequire("49qEn");

var $7LP39 = parcelRequire("7LP39");

var $a4nBq = parcelRequire("a4nBq");
const $045b5c5d22881021$var$columns = ()=>({
        vc_personales: new (0, $49qEn.EntityColumn)({
            name: 'vc_personales',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Personal asignado',
            isArray: true
        }),
        vc_puestos: new (0, $49qEn.EntityColumn)({
            name: 'vc_puestos',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Puestos',
            isArray: true
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $045b5c5d22881021$var$lookups = ()=>({
        'Personal': {
            name: 'Personal',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $7LP39.Personal)(client, parentKeys)
        },
        'Puestos': {
            name: 'Puestos',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $a4nBq.PuestosTrabajo)(client, parentKeys)
        }
    });
class $045b5c5d22881021$export$adbbb925d0bc7a13 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('SolicitudesRuteoInfoFilters'), this.columns = $045b5c5d22881021$var$columns(), this.views = {}, this.lookups = $045b5c5d22881021$var$lookups();
    }
}

});

parcelRegister("7UCQb", function(module, exports) {
module.exports = import("l215r").then(()=>parcelRequire('1D82J'));

});


parcelRegister("kVtYR", function(module, exports) {

$parcel$export(module.exports, "ACTAutorizarSolicitud", () => $946024277ebc42d8$export$e89c9bd51844be8a);

var $ayMG0 = parcelRequire("ayMG0");

var $gU5rH = parcelRequire("gU5rH");
var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");
const $946024277ebc42d8$export$e89c9bd51844be8a = {
    name: 'ACTAutorizarSolicitud',
    label: 'Autorizar Solicitud',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Autorizar solicitud de ruta"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    views: [
        'sorui_brwStandard'
    ],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        // cast entity
        const solicitud = entity;
        const procParms = {
            c_solicitudruteo_id: selectedKeys?.[0]?.['c_solicitudruteo_id'] ?? ''
        };
        let errores = '';
        if (!procParms.c_solicitudruteo_id) errores = "Los registros seleccionados son inv\xe1lidos";
        if (errores) await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                            size: "1.5rem",
                            stroke: "1.5"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            fw: "700",
                            children: "ERROR"
                        })
                    ]
                })
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        size: "sm",
                        mb: "xs",
                        children: errores
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                        mt: "xs",
                        position: "right",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                            onClick: async ()=>await modal.close(),
                            children: "Cerrar"
                        })
                    })
                ]
            })
        });
        else {
            const abort_controller = new AbortController();
            await modal.open({
                modalProps: {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        fw: "700",
                        children: "Autorizar solicitud de ruteo"
                    })
                },
                focusOnClosed: element,
                content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.ConfirmAndExecutePanel), {
                    content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        size: "sm",
                        mb: "xs",
                        children: "Va a autorizar la solicitud de ruteo. \xbfEst\xe1 seguro?"
                    }),
                    operation: "proc",
                    onCancel: async ()=>{
                        await abort_controller.abort();
                        await modal.close();
                    },
                    onOK: async ()=>{
                        const result = await solicitud.API.executeProcess(solicitud.def.procs.sorui_Autorizar, procParms, abort_controller.signal);
                        const success = result.Failed === false;
                        if (onClose) await onClose(success);
                        if (success) await modal.close();
                        return result;
                    }
                })
            });
        }
        return false;
    }
};

});

parcelRegister("Hg88E", function(module, exports) {

$parcel$export(module.exports, "ACTEnviarSolicitud", () => $8bf338e1bba8ed61$export$f3a5d2ebd310e15d);

var $ayMG0 = parcelRequire("ayMG0");

var $gU5rH = parcelRequire("gU5rH");
var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");
const $8bf338e1bba8ed61$export$f3a5d2ebd310e15d = {
    name: 'ACTEnviarSolicitud',
    label: 'Enviar Solicitud',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Enviar solicitud de ruta"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    views: [
        'sorui_brwBorradores'
    ],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        // cast entity
        const solicitud = entity;
        const procParms = {
            c_solicitudruteo_id: selectedKeys?.[0]?.['c_solicitudruteo_id'] ?? ''
        };
        let errores = '';
        if (!procParms.c_solicitudruteo_id) errores = "Los registros seleccionados son inv\xe1lidos";
        if (errores) await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                            size: "1.5rem",
                            stroke: "1.5"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            fw: "700",
                            children: "ERROR"
                        })
                    ]
                })
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        size: "sm",
                        mb: "xs",
                        children: errores
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                        mt: "xs",
                        position: "right",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                            onClick: async ()=>await modal.close(),
                            children: "Cerrar"
                        })
                    })
                ]
            })
        });
        else {
            const abort_controller = new AbortController();
            await modal.open({
                modalProps: {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        fw: "700",
                        children: "Enviar solicitud de ruteo"
                    })
                },
                focusOnClosed: element,
                content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.ConfirmAndExecutePanel), {
                    content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        size: "sm",
                        mb: "xs",
                        children: "Va a enviar la solicitud de ruteo. \xbfEst\xe1 seguro?"
                    }),
                    operation: "proc",
                    onCancel: async ()=>{
                        await abort_controller.abort();
                        await modal.close();
                    },
                    onOK: async ()=>{
                        const result = await solicitud.API.executeProcess(solicitud.def.procs.sorui_Enviar, procParms, abort_controller.signal);
                        const success = result.Failed === false;
                        if (onClose) await onClose(success);
                        if (success) await modal.close();
                        return result;
                    }
                })
            });
        }
        return false;
    }
};

});

parcelRegister("bnrZu", function(module, exports) {

$parcel$export(module.exports, "ACTRechazarSolicitud", () => $b299e3c4d3e099d6$export$e6342a5bbdfb8849);

var $ayMG0 = parcelRequire("ayMG0");

var $gU5rH = parcelRequire("gU5rH");
var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $fIMaa = parcelRequire("fIMaa");
const $b299e3c4d3e099d6$export$e6342a5bbdfb8849 = {
    name: 'ACTRechazarSolicitud',
    label: 'Rechazar Solicitud',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Rechazar solicitud de ruta"
    }),
    refreshOnClose: true,
    dontRequireSelection: false,
    views: [
        'sorui_brwStandard'
    ],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }
        // cast entity
        const solicitud = entity;
        const procParms = {
            c_solicitudruteo_id: selectedKeys?.[0]?.['c_solicitudruteo_id'] ?? ''
        };
        let errores = '';
        if (!procParms.c_solicitudruteo_id) errores = "Los registros seleccionados son inv\xe1lidos";
        if (errores) await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fIMaa.default), {
                            size: "1.5rem",
                            stroke: "1.5"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            fw: "700",
                            children: "ERROR"
                        })
                    ]
                })
            },
            focusOnClosed: element,
            content: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        size: "sm",
                        mb: "xs",
                        children: errores
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                        mt: "xs",
                        position: "right",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                            onClick: async ()=>await modal.close(),
                            children: "Cerrar"
                        })
                    })
                ]
            })
        });
        else {
            const abort_controller = new AbortController();
            await modal.open({
                modalProps: {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        fw: "700",
                        children: "Rechazar solicitud de ruteo"
                    })
                },
                focusOnClosed: element,
                content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.ConfirmAndExecutePanel), {
                    content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                        size: "sm",
                        mb: "xs",
                        children: "Va a rechazar la solicitud de ruteo. \xbfEst\xe1 seguro?"
                    }),
                    operation: "proc",
                    onCancel: async ()=>{
                        await abort_controller.abort();
                        await modal.close();
                    },
                    onOK: async ()=>{
                        const result = await solicitud.API.executeProcess(solicitud.def.procs.sorui_Rechazar, procParms, abort_controller.signal);
                        const success = result.Failed === false;
                        if (onClose) await onClose(success);
                        if (success) await modal.close();
                        return result;
                    }
                })
            });
        }
        return false;
    }
};

});

parcelRegister("goM3B", function(module, exports) {

$parcel$export(module.exports, "DiferenciasRutaInfoViewColumnsOverrides", () => $3ee67b8256f6577a$export$73ce8a4a96bc9157);

var $ayMG0 = parcelRequire("ayMG0");

var $9mTYo = parcelRequire("9mTYo");
var $cjohz = parcelRequire("cjohz");

var $5stbZ = parcelRequire("5stbZ");
var $ln6UH = parcelRequire("ln6UH");
var $3UXuI = parcelRequire("3UXuI");
function $3ee67b8256f6577a$export$73ce8a4a96bc9157(theme) {
    return {
        // Diferencia Tienda
        0: {
            render: (value)=>{
                const val = value;
                if (val.endsWith('*')) {
                    const result = val.replace('*', '').split('por');
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        style: {
                            gap: '.5rem'
                        },
                        noWrap: true,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5stbZ.default), {
                                style: {
                                    color: theme.colors.yellow[8],
                                    minWidth: "1.3rem"
                                },
                                size: "1.3rem"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cjohz.Text), {
                                truncate: true,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("del", {
                                        children: result[0]
                                    }),
                                    " por ",
                                    result[1]
                                ]
                            })
                        ]
                    });
                }
                if (val.endsWith('--')) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    style: {
                        gap: '.5rem'
                    },
                    noWrap: true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ln6UH.default), {
                            style: {
                                color: theme.colors.red[8],
                                minWidth: "1.3rem"
                            },
                            size: "1.3rem"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            truncate: true,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("del", {
                                children: val.replace('--', '')
                            })
                        })
                    ]
                });
                if (val.endsWith('+')) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    style: {
                        gap: '.5rem'
                    },
                    noWrap: true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3UXuI.default), {
                            style: {
                                color: theme.colors.green[8],
                                minWidth: "1.3rem"
                            },
                            size: "1.3rem"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            truncate: true,
                            children: val.replace('+', '')
                        })
                    ]
                });
                return value;
            }
        },
        // Diferencia Lunes
        1: {
            render: (value)=>{
                const val = value;
                if (val.endsWith('*')) {
                    const result = val.replace('*', '').split('por');
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        style: {
                            gap: '.5rem'
                        },
                        noWrap: true,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5stbZ.default), {
                                style: {
                                    color: theme.colors.yellow[8],
                                    minWidth: "1.3rem"
                                },
                                size: "1.3rem"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cjohz.Text), {
                                truncate: true,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("del", {
                                        children: result[0]
                                    }),
                                    " por ",
                                    result[1]
                                ]
                            })
                        ]
                    });
                }
                return value;
            }
        },
        // Diferencia Martes
        2: {
            render: (value)=>{
                const val = value;
                if (val.endsWith('*')) {
                    const result = val.replace('*', '').split('por');
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        style: {
                            gap: '.5rem'
                        },
                        noWrap: true,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5stbZ.default), {
                                style: {
                                    color: theme.colors.yellow[8],
                                    minWidth: "1.3rem"
                                },
                                size: "1.3rem"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cjohz.Text), {
                                truncate: true,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("del", {
                                        children: result[0]
                                    }),
                                    " por ",
                                    result[1]
                                ]
                            })
                        ]
                    });
                }
                return value;
            }
        },
        // Diferencia Miércoles
        3: {
            render: (value)=>{
                const val = value;
                if (val.endsWith('*')) {
                    const result = val.replace('*', '').split('por');
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        style: {
                            gap: '.5rem'
                        },
                        noWrap: true,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5stbZ.default), {
                                style: {
                                    color: theme.colors.yellow[8],
                                    minWidth: "1.3rem"
                                },
                                size: "1.3rem"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cjohz.Text), {
                                truncate: true,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("del", {
                                        children: result[0]
                                    }),
                                    " por ",
                                    result[1]
                                ]
                            })
                        ]
                    });
                }
                return value;
            }
        },
        //// Diferencia Jueves
        4: {
            render: (value)=>{
                const val = value;
                if (val.endsWith('*')) {
                    const result = val.replace('*', '').split('por');
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        style: {
                            gap: '.5rem'
                        },
                        noWrap: true,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5stbZ.default), {
                                style: {
                                    color: theme.colors.yellow[8],
                                    minWidth: "1.3rem"
                                },
                                size: "1.3rem"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cjohz.Text), {
                                truncate: true,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("del", {
                                        children: result[0]
                                    }),
                                    " por ",
                                    result[1]
                                ]
                            })
                        ]
                    });
                }
                return value;
            }
        },
        //// Diferencia Viernes
        5: {
            render: (value)=>{
                const val = value;
                if (val.endsWith('*')) {
                    const result = val.replace('*', '').split('por');
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        style: {
                            gap: '.5rem'
                        },
                        noWrap: true,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5stbZ.default), {
                                style: {
                                    color: theme.colors.yellow[8],
                                    minWidth: "1.3rem"
                                },
                                size: "1.3rem"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cjohz.Text), {
                                truncate: true,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("del", {
                                        children: result[0]
                                    }),
                                    " por ",
                                    result[1]
                                ]
                            })
                        ]
                    });
                }
                return value;
            }
        },
        //// Diferencia Sábado
        6: {
            render: (value)=>{
                const val = value;
                if (val.endsWith('*')) {
                    const result = val.replace('*', '').split('por');
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        style: {
                            gap: '.5rem'
                        },
                        noWrap: true,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5stbZ.default), {
                                style: {
                                    color: theme.colors.yellow[8],
                                    minWidth: "1.3rem"
                                },
                                size: "1.3rem"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cjohz.Text), {
                                truncate: true,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("del", {
                                        children: result[0]
                                    }),
                                    " por ",
                                    result[1]
                                ]
                            })
                        ]
                    });
                }
                return value;
            }
        },
        // Diferencia Domingo
        7: {
            render: (value)=>{
                const val = value;
                if (val.endsWith('*')) {
                    const result = val.replace('*', '').split('por');
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        style: {
                            gap: '.5rem'
                        },
                        noWrap: true,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5stbZ.default), {
                                style: {
                                    color: theme.colors.yellow[8],
                                    minWidth: "1.3rem"
                                },
                                size: "1.3rem"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cjohz.Text), {
                                truncate: true,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("del", {
                                        children: result[0]
                                    }),
                                    " por ",
                                    result[1]
                                ]
                            })
                        ]
                    });
                }
                return value;
            }
        }
    };
}

});
parcelRegister("5stbZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e524a3163a16813$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $6e524a3163a16813$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M4 5m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M16 3l0 4",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M8 3l0 4",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M4 11l16 0",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M8 15h2v2h-2z",
            "key": "svg-4"
        }
    ]
];
const $6e524a3163a16813$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "calendar-event", "CalendarEvent", $6e524a3163a16813$export$3efd853dbb351e94);

});

parcelRegister("ln6UH", function(module, exports) {

$parcel$export(module.exports, "default", () => $acc1d0bb9182d025$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $acc1d0bb9182d025$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M12.5 21h-6.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M16 3v4",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M8 3v4",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M4 11h16",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M16 19h6",
            "key": "svg-4"
        }
    ]
];
const $acc1d0bb9182d025$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "calendar-minus", "CalendarMinus", $acc1d0bb9182d025$export$3efd853dbb351e94);

});

parcelRegister("3UXuI", function(module, exports) {

$parcel$export(module.exports, "default", () => $a271c74dbb22c2ed$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $a271c74dbb22c2ed$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M12.5 21h-6.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v5",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M16 3v4",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M8 3v4",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M4 11h16",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M16 19h6",
            "key": "svg-4"
        }
    ],
    [
        "path",
        {
            "d": "M19 16v6",
            "key": "svg-5"
        }
    ]
];
const $a271c74dbb22c2ed$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "calendar-plus", "CalendarPlus", $a271c74dbb22c2ed$export$3efd853dbb351e94);

});



parcelRegister("fHSew", function(module, exports) {
module.exports = Promise.all([
    import("h8pzO"),
    import("iU5Vi"),
    import("4jVIF"),
    import("9AMke")
]).then(()=>parcelRequire('2vR62'));

});


parcelRegister("8XONQ", function(module, exports) {
module.exports = import("1ucwP").then(()=>parcelRequire('iyioa'));

});

parcelRegister("hP6i7", function(module, exports) {
module.exports = Promise.all([
    import("j0t1y"),
    import("47MzI")
]).then(()=>parcelRequire('4PfxR'));

});


var $ayMG0 = parcelRequire("ayMG0");

var $aRPiL = parcelRequire("aRPiL");
// MMC: para fechas en español

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("7pm8w");

var $crMIh = parcelRequire("crMIh");
var $cm529 = parcelRequire("cm529");
var $gebf7 = parcelRequire("gebf7");
var $9mTYo = parcelRequire("9mTYo");
var $5MBWk = parcelRequire("5MBWk");
var $64A2P = parcelRequire("64A2P");
var $d5Zz2 = parcelRequire("d5Zz2");

var $cnNDs = parcelRequire("cnNDs");

var $agugM = parcelRequire("agugM");
var $jqu36 = parcelRequire("jqu36");
var $7jJlY = parcelRequire("7jJlY");

var $jXwWv = parcelRequire("jXwWv");

var $8TaxK = parcelRequire("8TaxK");
var $64A2P = parcelRequire("64A2P");

var $49qEn = parcelRequire("49qEn");

var $kONlL = parcelRequire("kONlL");
var $5U9YU = parcelRequire("5U9YU");

var $acw62 = parcelRequire("acw62");

var $kF50T = parcelRequire("kF50T");

var $7qrj2 = parcelRequire("7qrj2");

var $7AVya = parcelRequire("7AVya");

var $3OncY = parcelRequire("3OncY");

var $lCDNR = parcelRequire("lCDNR");

var $hLNas = parcelRequire("hLNas");

var $ayMG0 = parcelRequire("ayMG0");

var $1Wgks = parcelRequire("1Wgks");

var $49qEn = parcelRequire("49qEn");
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $7646a0545ed1ac93$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M19.875 6.27c.7 .398 1.13 1.143 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.27 2.27 0 0 1 -2.184 0l-6.75 -4.27a2.23 2.23 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98z",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M15.5 9.422c.312 .18 .503 .515 .5 .876v3.277c0 .364 -.197 .7 -.515 .877l-3 1.922a1 1 0 0 1 -.97 0l-3 -1.922a1 1 0 0 1 -.515 -.876v-3.278c0 -.364 .197 -.7 .514 -.877l3 -1.79c.311 -.174 .69 -.174 1 0l3 1.79h-.014z",
            "key": "svg-1"
        }
    ]
];
const $7646a0545ed1ac93$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "assembly", "Assembly", $7646a0545ed1ac93$export$3efd853dbb351e94);


var $jIc5b = parcelRequire("jIc5b");
var $35ntO = parcelRequire("35ntO");
var $5Ue5f = parcelRequire("5Ue5f");/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $0dcd5353a75e1bef$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M4 6c0 1.657 3.582 3 8 3s8 -1.343 8 -3s-3.582 -3 -8 -3s-8 1.343 -8 3",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M4 6v6c0 1.657 3.582 3 8 3c1.118 0 2.183 -.086 3.15 -.241",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M20 12v-6",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M4 12v6c0 1.657 3.582 3 8 3c.157 0 .312 -.002 .466 -.005",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M16 19h6",
            "key": "svg-4"
        }
    ],
    [
        "path",
        {
            "d": "M19 16l3 3l-3 3",
            "key": "svg-5"
        }
    ]
];
const $0dcd5353a75e1bef$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "database-export", "DatabaseExport", $0dcd5353a75e1bef$export$3efd853dbb351e94);

/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $982d77836dfffb2c$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M5 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-6z",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M8 11v-4a4 4 0 1 1 8 0v4",
            "key": "svg-2"
        }
    ]
];
const $982d77836dfffb2c$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "lock", "Lock", $982d77836dfffb2c$export$3efd853dbb351e94);


var $eae64 = parcelRequire("eae64");/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $13afa6b2127378ea$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M12.005 21.485a1.994 1.994 0 0 1 -1.418 -.585l-4.244 -4.243a8 8 0 1 1 13.634 -5.05",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M19.001 15.5v1.5",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M19.001 21v1.5",
            "key": "svg-4"
        }
    ],
    [
        "path",
        {
            "d": "M22.032 17.25l-1.299 .75",
            "key": "svg-5"
        }
    ],
    [
        "path",
        {
            "d": "M17.27 20l-1.3 .75",
            "key": "svg-6"
        }
    ],
    [
        "path",
        {
            "d": "M15.97 17.25l1.3 .75",
            "key": "svg-7"
        }
    ],
    [
        "path",
        {
            "d": "M20.733 20l1.3 .75",
            "key": "svg-8"
        }
    ]
];
const $13afa6b2127378ea$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "map-pin-cog", "MapPinCog", $13afa6b2127378ea$export$3efd853dbb351e94);


var $TC7kK = parcelRequire("TC7kK");/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $e51f0369048382d5$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M12 13a3 3 0 1 0 0 -6a3 3 0 0 0 0 6z",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M6.201 18.744a4 4 0 0 1 3.799 -2.744h4a4 4 0 0 1 3.798 2.741",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M19.875 6.27c.7 .398 1.13 1.143 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z",
            "key": "svg-2"
        }
    ]
];
const $e51f0369048382d5$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "user-hexagon", "UserHexagon", $e51f0369048382d5$export$3efd853dbb351e94);


var $4d0Rl = parcelRequire("4d0Rl");
var $22CZZ = parcelRequire("22CZZ");
var $54kyq = parcelRequire("54kyq");
var $ktmlo = parcelRequire("ktmlo");

var $49qEn = parcelRequire("49qEn");

var $49qEn = parcelRequire("49qEn");
const $0511ddac583b4106$var$columns = ()=>({
        c_personal_id: new (0, $49qEn.EntityColumn)({
            name: 'c_personal_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Personal Id'
        }),
        c_tienda_id: new (0, $49qEn.EntityColumn)({
            name: 'c_tienda_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Tienda Id'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $0511ddac583b4106$var$procs = ()=>({
        dav2_getUbicacionPersonal: {
            name: 'dav2_getUbicacionPersonal'
        },
        dav2_qryIndicadores: {
            name: 'dav2_qryIndicadores'
        },
        dav2_qryMapa: {
            name: 'dav2_qryMapa'
        },
        dav2_qryDetallePersonal: {
            name: 'dav2_qryDetallePersonal'
        },
        dav2_qryDetalleTienda: {
            name: 'dav2_qryDetalleTienda'
        },
        dav2_qryMarcacionesFueraArea: {
            name: 'dav2_qryMarcacionesFueraArea'
        },
        dav2_qryVisitasSinDatos: {
            name: 'dav2_qryVisitasSinDatos'
        },
        dav2_qryVisitasSinTareas: {
            name: 'dav2_qryVisitasSinTareas'
        },
        dav2_qryRecorridoPersonal: {
            name: 'dav2_qryRecorridoPersonal'
        },
        dav2_qryContactosPersonal: {
            name: 'dav2_qryContactosPersonal'
        },
        dav2_qryResumenVisita: {
            name: 'dav2_qryResumenVisita'
        }
    });
class $0511ddac583b4106$export$5eb2bcd2cf34510a extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('DashboardV2'), this.columns = $0511ddac583b4106$var$columns(), this.procs = $0511ddac583b4106$var$procs();
    }
}



var $5Ue5f = parcelRequire("5Ue5f");

class $0ce329b30bcda5fe$export$292c7aa815a1910a extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $0511ddac583b4106$export$5eb2bcd2cf34510a)(), parentKeys);
        this.Form = (parcelRequire("eVReK")).then((module)=>module.DashboardV2Form);
        this.Title = "DashboardV2";
        this.HelpText = '* DashboardV2.';
        this.Icon = (0, $5Ue5f.default);
    }
}



var $ayMG0 = parcelRequire("ayMG0");

var $9mTYo = parcelRequire("9mTYo");
var $64A2P = parcelRequire("64A2P");

var $49qEn = parcelRequire("49qEn");

var $iEQtx = parcelRequire("iEQtx");
var $6zxJ3 = parcelRequire("6zxJ3");

var $acw62 = parcelRequire("acw62");
function $571ae72822e7da55$export$7ec2ea57aa93f6d9(props) {
    const {} = props;
    const theme = (0, $64A2P.useMantineTheme)();
    const configuracion = (0, $acw62.useMemo)(()=>({
            // Servicios
            3: {
                render: (value)=>!value ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iEQtx.default), {
                                style: {
                                    color: theme.colors.red[8]
                                },
                                size: "1.3rem"
                            }),
                            "Sin servicios"
                        ]
                    }) : value
            },
            // Cantidad de productos
            4: {
                render: (value)=>!value || value === '0' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iEQtx.default), {
                                style: {
                                    color: theme.colors.red[8]
                                },
                                size: "1.3rem"
                            }),
                            "Sin productos"
                        ]
                    }) : value
            },
            // Cantidad de tiendas
            5: {
                render: (value)=>!value || value === '0' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iEQtx.default), {
                                style: {
                                    color: theme.colors.red[8]
                                },
                                size: "1.3rem"
                            }),
                            "Sin tiendas"
                        ]
                    }) : value
            },
            // Cantidad de tiendas sin productos
            6: {
                render: (value)=>value && value !== '0' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6zxJ3.default), {
                                style: {
                                    color: theme.colors.yellow[8]
                                },
                                size: "1.3rem"
                            }),
                            value
                        ]
                    }) : ''
            },
            // Cantidad de tiendas sin servicios
            7: {
                render: (value)=>value && value !== '0' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6zxJ3.default), {
                                style: {
                                    color: theme.colors.yellow[8]
                                },
                                size: "1.3rem"
                            }),
                            value
                        ]
                    }) : ''
            }
        }), []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
        ...props,
        enableAdd: false,
        enableDelete: false,
        columnsOverrides: configuracion
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $9mTYo = parcelRequire("9mTYo");
var $64A2P = parcelRequire("64A2P");

var $49qEn = parcelRequire("49qEn");

var $3US3h = parcelRequire("3US3h");
var $j0J5n = parcelRequire("j0J5n");
var $h8HR1 = parcelRequire("h8HR1");

var $acw62 = parcelRequire("acw62");
function $268b2f3577ca661f$export$1099a918c93775da(props) {
    const {} = props;
    const theme = (0, $64A2P.useMantineTheme)();
    const configuracion = (0, $acw62.useMemo)(()=>({
            // Domicilio geolocalizado
            5: {
                render: (value)=>!value ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j0J5n.default), {
                                style: {
                                    color: theme.colors.red[8]
                                },
                                size: "1.3rem"
                            }),
                            "Sin ubicaci\xf3n"
                        ]
                    }) : value
            },
            // Tienda activa
            8: {
                render: (value)=>value === 'ACTIVO' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        style: {
                            gap: '0rem'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.CircleFilledIcon), {
                                mr: "xs",
                                width: "1.3rem",
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3US3h.default), {
                                    size: "0.9rem"
                                })
                            }),
                            "Activa"
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                        style: {
                            gap: '.5rem'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $h8HR1.default), {
                                style: {
                                    color: theme.colors.red[8]
                                },
                                size: "1.3rem"
                            }),
                            "Baja"
                        ]
                    })
            }
        }), []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
        ...props,
        columnsOverrides: configuracion
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $gU5rH = parcelRequire("gU5rH");
var $ly5N0 = parcelRequire("ly5N0");
var $9VIWE = parcelRequire("9VIWE");

var $49qEn = parcelRequire("49qEn");

var $acw62 = parcelRequire("acw62");

var $5qfPT = parcelRequire("5qfPT");
function $2bc28dceee91f652$export$2e2bcd8739ae039({ client: client }) {
    const [password, setPassword] = (0, $acw62.useState)("");
    const [isAuthorized, setIsAuthorized] = (0, $acw62.useState)(false);
    const [parentKeys, setParentKeys] = (0, $acw62.useState)({});
    const enviarRecibosRef = (0, $acw62.useRef)(new (0, $5qfPT.EnviarRecibos)(client));
    const enviarRecibos = enviarRecibosRef.current;
    const checkPassword = (0, $49qEn.useExecuteProcess)(enviarRecibos, enviarRecibos.def.procs.enre_ComprobarPassword);
    const handleSubmit = (0, $acw62.useCallback)(async (e)=>{
        e.preventDefault();
        await checkPassword.execute({
            vc_password: password
        });
    }, [
        password
    ]);
    (0, $acw62.useEffect)(()=>{
        if (checkPassword.status.error === undefined && checkPassword.status.data && !checkPassword.status.data.Failed === true) {
            setParentKeys({
                vc_password: password
            });
            setIsAuthorized(true);
        }
    }, [
        checkPassword.status.error,
        checkPassword.status.data
    ]);
    const gridHeight = "50vh";
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: !isAuthorized ? /*#__PURE__*/ (0, $ayMG0.jsx)("form", {
            onSubmit: handleSubmit,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9VIWE.Stack), {
                spacing: "md",
                w: 300,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ly5N0.PasswordInput), {
                        label: "Contrase\xf1a de supervisor",
                        placeholder: "Ingrese la contrase\xf1a",
                        required: true,
                        value: password,
                        onChange: (e)=>setPassword(e.currentTarget.value)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gU5rH.Button), {
                        type: "submit",
                        loading: checkPassword.status.loading,
                        children: "Confirmar"
                    }),
                    checkPassword.status.data?.Failed === true && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.AlertError), {
                        title: "Clave incorrecta.",
                        children: "Ingrese la contrase\xf1a correcta."
                    })
                ]
            })
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridForm), {
            gridHeight: gridHeight,
            entity: enviarRecibos,
            parentKeys: parentKeys,
            viewName: "enre_brwStandard",
            selectionMode: "multi",
            enableAdd: false,
            enableEdit: false,
            enableDelete: false,
            enableView: false,
            showActions: true,
            showToolbar: true,
            showActionsToolbar: true,
            doubleClickAction: "none",
            formMode: "edit"
        })
    });
}



var $j02RA = parcelRequire("j02RA");

var $bMvwR = parcelRequire("bMvwR");

var $SKbb0 = parcelRequire("SKbb0");

var $316Pw = parcelRequire("316Pw");

var $6TYT5 = parcelRequire("6TYT5");

var $3TX0s = parcelRequire("3TX0s");

var $99fvj = parcelRequire("99fvj");

var $5wo6I = parcelRequire("5wo6I");

var $k9JMU = parcelRequire("k9JMU");

var $841Z4 = parcelRequire("841Z4");

var $exmmN = parcelRequire("exmmN");

var $hMWb0 = parcelRequire("hMWb0");

var $5GxBW = parcelRequire("5GxBW");

var $iVMwo = parcelRequire("iVMwo");

var $l9enS = parcelRequire("l9enS");

var $e4f1v = parcelRequire("e4f1v");

var $8PdZ4 = parcelRequire("8PdZ4");

var $49qEn = parcelRequire("49qEn");
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $19edee47b31b19ab$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M14 3v4a1 1 0 0 0 1 1h4",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M9 17h6",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M9 13h6",
            "key": "svg-3"
        }
    ]
];
const $19edee47b31b19ab$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "file-description", "FileDescription", $19edee47b31b19ab$export$3efd853dbb351e94);


const $3a99cc844e7128c8$export$a120f7be8c6e0cde = "* Aqu\xed puede ver toda la lista de los tipos de los documentos que puede tener una empresa.";
const $3a99cc844e7128c8$export$c625ac55050129ec = (0, $19edee47b31b19ab$export$2e2bcd8739ae039);
class $3a99cc844e7128c8$export$479c608270a2375a extends (0, $49qEn.CategoriesValues) {
    constructor(client, parentKeys = {}){
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "TiposDocumentoEmpr";
        this.def.columns.c_category_id.defaultValue = "TiposDocumentoEmpr";
        this.Title = "Tipos Documento Empresa";
        this.Icon = $3a99cc844e7128c8$export$c625ac55050129ec;
        this.HelpText = $3a99cc844e7128c8$export$a120f7be8c6e0cde;
    }
}



var $3RgBj = parcelRequire("3RgBj");

var $5A5L0 = parcelRequire("5A5L0");

var $49qEn = parcelRequire("49qEn");
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $985e03bfc1fdac56$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M6 21v-2a4 4 0 0 1 4 -4h3.5",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M20 21l2 -2l-2 -2",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M17 17l-2 2l2 2",
            "key": "svg-3"
        }
    ]
];
const $985e03bfc1fdac56$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "user-code", "UserCode", $985e03bfc1fdac56$export$3efd853dbb351e94);


const $66ea17e39c45d424$export$11f46202674132e7 = (0, $985e03bfc1fdac56$export$2e2bcd8739ae039);
const $66ea17e39c45d424$export$e08a0cfd60bb96a1 = "* Aqu\xed puede ver los diferentes tipos de usuarios.";
class $66ea17e39c45d424$export$bce150febea7974a extends (0, $49qEn.CategoriesValues) {
    constructor(client, parentKeys = {}){
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "UserTypes";
        this.def.columns.c_category_id.defaultValue = "UserTypes";
        this.Title = "Tipos de Usuario";
        this.HelpText = $66ea17e39c45d424$export$e08a0cfd60bb96a1;
        this.Icon = $66ea17e39c45d424$export$11f46202674132e7;
    }
}



var $9u8qf = parcelRequire("9u8qf");

var $49qEn = parcelRequire("49qEn");

var $TC7kK = parcelRequire("TC7kK");

var $49qEn = parcelRequire("49qEn");

var $5A5L0 = parcelRequire("5A5L0");

var $5kp3N = parcelRequire("5kp3N");

var $bYVp3 = parcelRequire("bYVp3");
const $e471f1a762f53ee0$var$columns = ()=>({
        c_cliente_id: new (0, $49qEn.EntityColumn)({
            name: 'c_cliente_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Cliente ID'
        }),
        c_empresa_id: new (0, $49qEn.EntityColumn)({
            name: 'c_empresa_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Empresa'
        }),
        vc_nombre_cliente: new (0, $49qEn.EntityColumn)({
            name: 'vc_nombre_cliente',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Cliente'
        }),
        vc_codigoexterno: new (0, $49qEn.EntityColumn)({
            name: 'vc_codigoexterno',
            type: 'varchar',
            length: 50,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Codigo externo'
        }),
        c_tiposervicio_id: new (0, $49qEn.EntityColumn)({
            name: 'c_tiposervicio_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Tipo de servicio'
        }),
        c_activo_id: new (0, $49qEn.EntityColumn)({
            name: 'c_activo_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Estado'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $e471f1a762f53ee0$var$views = ()=>({
        clcf_brwStandard: {
            name: 'clcf_brwStandard',
            keyMappings: {
                c_cliente_id: 0
            }
        }
    });
const $e471f1a762f53ee0$var$lookups = ()=>({
        'Empresas': {
            name: 'Empresas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $bYVp3.Empresas)(client, parentKeys)
        },
        'TiposServicio': {
            name: 'TiposServicio',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $5A5L0.catTiposServicio)(client, parentKeys)
        },
        'Activo': {
            name: 'Activo',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $5kp3N.estActivo)(client, parentKeys)
        }
    });
class $e471f1a762f53ee0$export$a48ed457a22986bf extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('ClientesConfiguracion'), this.columns = $e471f1a762f53ee0$var$columns(), this.views = $e471f1a762f53ee0$var$views(), this.lookups = $e471f1a762f53ee0$var$lookups();
    }
}


const $3a1ece0bea58f020$export$5473d368c3bb0264 = (0, $TC7kK.default);
const $3a1ece0bea58f020$export$bc79c06fbb221d45 = '* Seleccione el cliente para configurar las tiendas, productos y servicios';

class $3a1ece0bea58f020$export$6c6b43f3d0ccb950 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $e471f1a762f53ee0$export$a48ed457a22986bf)(), parentKeys);
        this.Form = (parcelRequire("fRLGi")).then((module)=>module.ClientesConfiguracionForm);
        this.Title = "Configuraci\xf3n de Clientes, Tiendas, Productos y Servicios";
        this.HelpText = $3a1ece0bea58f020$export$bc79c06fbb221d45;
        this.Icon = $3a1ece0bea58f020$export$5473d368c3bb0264;
    }
}



var $cC5ZS = parcelRequire("cC5ZS");

var $49qEn = parcelRequire("49qEn");

var $4usKR = parcelRequire("4usKR");

var $49qEn = parcelRequire("49qEn");
const $b71d1f7bc3576224$var$columns = ()=>({
        c_importacion_id: new (0, $49qEn.EntityColumn)({
            name: 'c_importacion_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PKAutonum,
            prompt: 'Importacion Id'
        }),
        vc_descripcion: new (0, $49qEn.EntityColumn)({
            name: 'vc_descripcion',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Descripcion'
        }),
        c_fileprocess_id: new (0, $49qEn.EntityColumn)({
            name: 'c_fileprocess_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK,
            prompt: 'Fileprocess Id'
        }),
        c_estado_id: new (0, $49qEn.EntityColumn)({
            name: 'c_estado_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Estado Id'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $b71d1f7bc3576224$var$views = ()=>({
        cpim_brwStandard: {
            name: 'cpim_brwStandard',
            keyMappings: {
                c_importacion_id: 0
            }
        }
    });
const $b71d1f7bc3576224$var$lookups = ()=>({});
class $b71d1f7bc3576224$export$fde513eba8dac98d extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('ClientesProductosImportacion'), this.columns = $b71d1f7bc3576224$var$columns(), this.views = $b71d1f7bc3576224$var$views(), this.lookups = $b71d1f7bc3576224$var$lookups();
    }
}


const $2df6b71b102eaa3b$export$2884f9ad6c375487 = (0, $4usKR.ProductosIcon);
const $2df6b71b102eaa3b$export$dfc6f72527f0d63f = '* <Your help text>.';

class $2df6b71b102eaa3b$export$2b1c67409fa25131 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $b71d1f7bc3576224$export$fde513eba8dac98d)(), parentKeys);
        this.Form = (parcelRequire("9ln4I")).then((module)=>module.ClientesProductosImportacionForm);
        this.Title = "Clientes Productos Importacion";
        this.HelpText = $2df6b71b102eaa3b$export$dfc6f72527f0d63f;
        this.Icon = $2df6b71b102eaa3b$export$2884f9ad6c375487;
    }
}



var $2LSnU = parcelRequire("2LSnU");

var $iHr81 = parcelRequire("iHr81");

var $7UO1x = parcelRequire("7UO1x");

var $elPjY = parcelRequire("elPjY");

var $ieRws = parcelRequire("ieRws");

var $goQRU = parcelRequire("goQRU");

var $giXL1 = parcelRequire("giXL1");

var $bYVp3 = parcelRequire("bYVp3");

var $5qfPT = parcelRequire("5qfPT");

var $49qEn = parcelRequire("49qEn");

var $5stbZ = parcelRequire("5stbZ");
const $8d932423819106b1$var$columns = ()=>({
        c_feriado_id: new (0, $49qEn.EntityColumn)({
            name: 'c_feriado_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PKAutonum,
            prompt: 'Feriado Id',
            description: "C\xf3digo de feriado generado autom\xe1ticamente"
        }),
        vc_nombre_feriado: new (0, $49qEn.EntityColumn)({
            name: 'vc_nombre_feriado',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Nombre',
            description: 'Nombre del feriado'
        }),
        dt_fecha_desde: new (0, $49qEn.EntityColumn)({
            name: 'dt_fecha_desde',
            type: 'datetime',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Fecha Desde',
            description: "Fecha desde la cual el feriado es v\xe1lido"
        }),
        dt_fecha_hasta: new (0, $49qEn.EntityColumn)({
            name: 'dt_fecha_hasta',
            type: 'datetime',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Fecha Hasta',
            description: "Fecha hasta la cual el feriado es v\xe1lido (opcional)"
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $8d932423819106b1$var$views = ()=>({
        feri_brwStandard: {
            name: 'feri_brwStandard',
            keyMappings: {
                c_feriado_id: 0
            }
        }
    });
class $8d932423819106b1$export$9c7d44c69e9acece extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('Feriados'), this.columns = $8d932423819106b1$var$columns(), this.views = $8d932423819106b1$var$views();
    }
}
const $8d932423819106b1$export$2280eab1088f2f46 = (0, $5stbZ.default);
const $8d932423819106b1$export$1ddbb87f13efbdbe = "* Contiene de los d\xedas no laborables y feriados";
class $8d932423819106b1$export$f0c44d98c0461831 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new $8d932423819106b1$export$9c7d44c69e9acece(), parentKeys);
        super.Form = 'AutoForm';
        super.Title = 'Feriados';
        super.Icon = $8d932423819106b1$export$2280eab1088f2f46;
        super.HelpText = $8d932423819106b1$export$1ddbb87f13efbdbe;
    }
}



var $3IWeJ = parcelRequire("3IWeJ");

var $9v5jT = parcelRequire("9v5jT");

var $49qEn = parcelRequire("49qEn");

var $3OncY = parcelRequire("3OncY");
const $a32a53452d089c42$export$e468013a8277919e = "* Configuraci\xf3n para el env\xedo de emails";
class $a32a53452d089c42$export$e299dae4ae81c8fa extends (0, $49qEn.EmailServiceConfiguration) {
    constructor(client, parentKeys = {}){
        super(client, parentKeys);
        this.Title = "Configuraci\xf3n de Email";
        this.HelpText = $a32a53452d089c42$export$e468013a8277919e;
        this.def.columns.i_smtp_port.prompt = "Puerto SMTP";
        this.def.columns.i_smtp_port.description = "Puerto de conexi\xf3n al servidor SMTP";
        this.def.columns.bt_use_ssl.prompt = "Usar SSL";
        this.def.columns.bt_use_ssl.description = "Usar SSL para la conexi\xf3n al servidor SMTP";
        this.def.columns.vc_smtp_host.prompt = "Servidor SMTP";
        this.def.columns.vc_smtp_host.description = "Direcci\xf3n del servidor SMTP";
        this.def.columns.vc_user_name.prompt = "Usuario";
        this.def.columns.vc_user_name.description = "Usuario para autenticarse en el servidor SMTP";
        this.def.columns.vc_password.prompt = "Contrase\xf1a";
        this.def.columns.vc_password.description = "Contrase\xf1a para autenticarse en el servidor SMTP";
        this.def.columns.vc_default_sender_email.prompt = "Email de Remitente";
        this.def.columns.vc_default_sender_email.description = "Email del remitente por defecto";
        this.def.columns.vc_default_sender_name.prompt = "Nombre del Remitente";
        this.def.columns.vc_default_sender_name.description = "Nombre del remitente por defecto";
        this.def.columns.vc_template_subject.prompt = "Asunto";
        this.def.columns.vc_template_subject.description = "Asunto del email que se enviar\xe1";
        this.def.columns.vc_template_subject.defaultValue = "MTS - Recuperaci\xf3n de contrase\xf1a";
        this.def.columns.vc_template_subject.placeholder = "MTS - Recuperaci\xf3n de contrase\xf1a";
        this.def.columns.vc_template_body.prompt = "Mensaje";
        this.def.columns.vc_template_body.description = "Cuerpo del email que se enviar\xe1";
        this.def.columns.vc_template_body.defaultValue = "Ha solicitado un email para recuperar su contrase\xf1a.\n\nPor favor siga este enlace para establecer su nueva contrase\xf1a https://<YOUR_SITE>/recover/?code={RECOVERY_CODE}\n\nMTS support team.";
        this.def.columns.vc_template_body.placeholder = this.def.columns.vc_template_body.defaultValue;
        this.def.columns.c_email_configuration_id.value = (0, $3OncY.APP_ID);
    }
}



var $49qEn = parcelRequire("49qEn");
class $102149287019c41d$export$a926cc14e890be3e extends (0, $49qEn.MicromUsers) {
    constructor(client, parentKeys = {}){
        super(client, parentKeys);
        this.Title = "Usuarios";
        this.def.columns.c_user_id.prompt = "ID";
        this.def.columns.c_user_id.description = "El usuario ID es generado autom\xe1ticamente por el sistema";
        this.def.columns.vc_username.prompt = "Nombre de usuario";
        this.def.columns.vc_username.description = "El nombre de usuario con el que iniciar\xe1 sesi\xf3n. Puede ser un correo electr\xf3nico.";
        this.def.columns.bt_disabled.prompt = "Usuario deshabilitado";
        this.def.columns.bt_disabled.description = "Un usuario deshabilitado no puede inciar sesi\xf3n. Puede tomar 20 minutos para que haga efecto si el usuario se encuentra conectado.";
        this.def.columns.dt_last_login.prompt = "\xdaltimo inicio de sesi\xf3n";
        this.def.columns.dt_last_login.description = "Este valor se actualiza al iniciar sesi\xf3n, no indica si el usuario se encuentra conectado actualmente.";
        this.def.columns.c_usertype_id.prompt = "Tipo de Usuario";
        this.def.columns.c_usertype_id.description = "El Tipo de Usuario indica a qu\xe9 sistemas puede acceder y el grupo al que pertenece el usuario, sobre el cu\xe1l se aplicar\xe1n permisos.";
        this.def.columns.i_badlogonattempts.prompt = "Intentos fallidos";
        this.def.columns.i_badlogonattempts.description = "Indica el n\xfamero de Intentos fallidos para iniciar sesi\xf3n. Superado el m\xe1ximo permitido la cuenta se bloquear\xe1 autom\xe1ticamente por un periodo de tiempo.";
        this.def.columns.vc_email.description = "El campo de Email es opcional. Sin embargo, si este campo no est\xe1 completo esta cuenta de usuario NO PODR\xc1 RECUPERAR SU CLAVE.";
    }
}



var $49qEn = parcelRequire("49qEn");
class $41d9d26609a1fc45$export$491d3c2e4b78ca9a extends (0, $49qEn.MicromUsersGroups) {
    constructor(client, parentKeys = {}){
        super(client, parentKeys);
        this.Title = "Perfiles de Usuario";
        this.HelpText = "* Los perfiles de usuario asignan grupos de permisos";
        this.def.columns.c_user_group_id.prompt = "ID";
        this.def.columns.c_user_group_id.description = "El ID de perfil es generado autom\xe1ticamente por el sistema";
        this.def.columns.vc_user_group_name.prompt = "Nombre del Perfil";
        this.def.columns.vc_user_group_name.description = "El nombre del perfil de usuario que determinar\xe1 el nivel de acceso en el sistema.";
        this.def.columns.vc_group_members.prompt = "Miembros del Perfil";
        this.def.columns.vc_group_members.description = "Usuarios asignados a este perfil.";
        // Cambiamos a nombre y apellido para usar en el form de group members
        this.def.lookups.MicromUsers.viewMapping.descriptionIndex = 2;
    }
}



var $49qEn = parcelRequire("49qEn");

var $49qEn = parcelRequire("49qEn");
const $a7a4c52f0edc8691$var$columns = ()=>({
        c_user_id: new (0, $49qEn.EntityColumn)({
            name: 'c_user_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Cliente'
        }),
        vc_username: new (0, $49qEn.EntityColumn)({
            name: 'vc_username',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Username'
        }),
        vc_password: new (0, $49qEn.EntityColumn)({
            name: 'vc_password',
            type: 'varchar',
            length: 2048,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Password'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $a7a4c52f0edc8691$var$views = ()=>({
        uspw_brwPersonal: {
            name: 'uspw_brwPersonal',
            keyMappings: {
                c_user_id: 0
            }
        },
        uspw_brwClientes: {
            name: 'uspw_brwClientes',
            keyMappings: {
                c_user_id: 0
            }
        }
    });
class $a7a4c52f0edc8691$export$5d7a7dd68f1a42b2 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('UsuariosPassword'), this.columns = $a7a4c52f0edc8691$var$columns(), this.views = $a7a4c52f0edc8691$var$views();
    }
}


const $7de45db546c59736$export$ffed006b39b9a57f = "* Cambiar contrase\xf1a de Usuario.";

class $7de45db546c59736$export$f75d543435791d71 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $a7a4c52f0edc8691$export$5d7a7dd68f1a42b2)(), parentKeys);
        this.Form = (parcelRequire("ivsSe")).then((module)=>module.UsuariosPasswordForm);
        this.Title = "Contrase\xf1a de Usuario";
        this.HelpText = $7de45db546c59736$export$ffed006b39b9a57f;
    }
}



var $kFypM = parcelRequire("kFypM");

var $49qEn = parcelRequire("49qEn");

var $4YQwj = parcelRequire("4YQwj");

class $60092e204c01d751$export$b1ad44e3e57ff523 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $4YQwj.CiudadesDef)(), parentKeys);
        this.Form = (parcelRequire("4TDO3")).then((module)=>module.ProvinciasCiudadesForm);
        this.Title = "Ciudades";
    }
}



var $j8GP5 = parcelRequire("j8GP5");

var $49qEn = parcelRequire("49qEn");

var $2JAvD = parcelRequire("2JAvD");

var $iMxdG = parcelRequire("iMxdG");

class $5b125d3bebeda5ec$export$a68a7f5ee318d650 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $iMxdG.ProvinciasDef)(), parentKeys);
        this.Form = (parcelRequire("j8fD9")).then((module)=>module.PaisesProvinciasForm);
        this.Title = "Provincias";
        this.Icon = (0, $2JAvD.default);
        this.HelpText = "* Seleccione las provincias";
    }
}



var $4Rlmx = parcelRequire("4Rlmx");

var $7LP39 = parcelRequire("7LP39");

var $ayMG0 = parcelRequire("ayMG0");

var $436KA = parcelRequire("436KA");
var $hiiR1 = parcelRequire("hiiR1");
var $9mTYo = parcelRequire("9mTYo");
var $5iXv4 = parcelRequire("5iXv4");
var $9VIWE = parcelRequire("9VIWE");
var $cjohz = parcelRequire("cjohz");
var $64A2P = parcelRequire("64A2P");

var $34B0U = parcelRequire("34B0U");
var $dQNuR = parcelRequire("dQNuR");
var $iayaH = parcelRequire("iayaH");
var $4Rwq2 = parcelRequire("4Rwq2");
var $k0vmM = parcelRequire("k0vmM");
var $bLAHN = parcelRequire("bLAHN");
var $1YbUT = parcelRequire("1YbUT");/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $38825962b21da128$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M18 7v12a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-12l6 -4z",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M10 13l2 -1l2 1",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M10 17l2 -1l2 1",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M10 9l2 -1l2 1",
            "key": "svg-3"
        }
    ]
];
const $38825962b21da128$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "military-rank", "MilitaryRank", $38825962b21da128$export$3efd853dbb351e94);


var $hbKWn = parcelRequire("hbKWn");
var $j0QhJ = parcelRequire("j0QhJ");
function $bf674960115d00da$export$b13db8347905fc02(props) {
    const { entity: entity, record: record } = props;
    const data = record.data;
    const perfiles = data.i_cantidad_grupos === '1' ? 'acceso a ' + data.vc_users_groups : data.vc_users_groups ? "acceso a m\xfaltiples perfiles" : 'Sin permisos';
    const fotoURL = entity.API.client.getThumbnailURL(data.vc_fotoguid);
    const theme = (0, $64A2P.useMantineTheme)();
    const iconColor = theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[5];
    const warningColor = theme.colorScheme === "dark" ? theme.colors.orange[5] : theme.colors.orange[7];
    const errorColor = theme.colorScheme === "dark" ? theme.colors.red[5] : theme.colors.red[7];
    const okColor = theme.colorScheme === "dark" ? theme.colors.green[5] : theme.colors.green[7];
    const activeColor = theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.dark[7];
    const widthCard = "20rem";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hiiR1.Box), {
        mih: "18rem",
        w: widthCard,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cjohz.Text), {
                fz: "lg",
                align: "center",
                fw: 500,
                mb: "xs",
                color: data.dt_fecha_baja ? 'dimmed' : activeColor,
                children: [
                    data.vc_apellido,
                    ", ",
                    data.vc_nombre
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                noWrap: true,
                align: "flex-start",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hiiR1.Box), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $436KA.Avatar), {
                            size: "xl",
                            src: fotoURL,
                            radius: "sm"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9VIWE.Stack), {
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                                noWrap: true,
                                spacing: 10,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dQNuR.default), {
                                        stroke: 1.5,
                                        size: "1rem",
                                        color: data.vc_email ? iconColor : warningColor
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                                        fz: "xs",
                                        c: "dimmed",
                                        children: data.vc_email || "Sin Email"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                                noWrap: true,
                                spacing: 10,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hbKWn.default), {
                                        stroke: 1.5,
                                        size: "1rem",
                                        color: data.vc_celular_trabajo ? iconColor : warningColor
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                                        fz: "xs",
                                        c: "dimmed",
                                        children: data.vc_celular_trabajo || "Sin celular de trabajo"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                                noWrap: true,
                                spacing: 10,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bLAHN.default), {
                                        stroke: 1.5,
                                        size: "1rem",
                                        color: iconColor
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                                        fz: "xs",
                                        c: "dimmed",
                                        children: data.vc_numerodni
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                                noWrap: true,
                                spacing: 10,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $k0vmM.default), {
                                        stroke: 1.5,
                                        size: "1rem",
                                        color: data.vc_genero ? iconColor : warningColor
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                                        fz: "xs",
                                        c: "dimmed",
                                        children: data.vc_genero || "Sin g\xe9nero"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                                noWrap: true,
                                spacing: 10,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iayaH.default), {
                                        stroke: 1.5,
                                        size: "1rem",
                                        color: data.dt_nacimiento ? iconColor : warningColor
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                                        fz: "xs",
                                        c: "dimmed",
                                        children: data.dt_nacimiento || "Sin fecha de nacimiento"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                mt: "xs",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    noWrap: true,
                    spacing: 5,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $38825962b21da128$export$2e2bcd8739ae039), {
                            stroke: 1.5,
                            size: "1rem",
                            color: data.vc_puestotrabajo ? iconColor : warningColor
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                            fz: "0.8rem",
                            c: "dimmed",
                            fw: 700,
                            children: data.vc_puestotrabajo || "Sin Puesto"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                mt: "xs",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                    noWrap: true,
                    spacing: 5,
                    maw: widthCard,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j0QhJ.default), {
                            stroke: 1.5,
                            size: "1rem",
                            style: {
                                minWidth: "1rem"
                            },
                            color: data.vc_users_groups ? okColor : data.vc_username ? warningColor : errorColor
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cjohz.Text), {
                            fz: "0.8rem",
                            c: "dimmed",
                            fw: 700,
                            truncate: true,
                            children: [
                                data.vc_username || "Sin acceso",
                                ", ",
                                perfiles
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5iXv4.Space), {
                mt: "xs"
            }),
            data.dt_fecha_baja && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                noWrap: true,
                spacing: 10,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $34B0U.default), {
                        stroke: 1.5,
                        size: "1rem",
                        color: errorColor
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cjohz.Text), {
                        fz: "xs",
                        c: "dimmed",
                        children: [
                            "BAJA - ",
                            data.dt_fecha_baja.substring(0, 10),
                            " - ",
                            data.c_motivobaja_id
                        ]
                    })
                ]
            }),
            !data.dt_fecha_baja && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                noWrap: true,
                spacing: 10,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Rwq2.default), {
                        stroke: 1.5,
                        size: "1rem",
                        color: okColor
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cjohz.Text), {
                        fz: "xs",
                        c: "dimmed",
                        children: [
                            "ACTIVO - ",
                            data.dt_fecha_alta.substring(0, 10)
                        ]
                    })
                ]
            }),
            data.dt_licencia_desde && data.c_estado_licencia_id === "PROXIMA" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                noWrap: true,
                spacing: 10,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1YbUT.default), {
                        stroke: 1.5,
                        size: "1rem",
                        color: warningColor
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cjohz.Text), {
                        fz: "xs",
                        c: "dimmed",
                        children: [
                            "PR\xd3XIMA LICENCIA - ",
                            data.dt_licencia_desde.substring(0, 10),
                            " - ",
                            data.dt_licencia_hasta.substring(0, 10)
                        ]
                    })
                ]
            }),
            data.dt_licencia_desde && data.c_estado_licencia_id !== "PROXIMA" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                noWrap: true,
                spacing: 10,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $34B0U.default), {
                        stroke: 1.5,
                        size: "1rem",
                        color: warningColor
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cjohz.Text), {
                        fz: "xs",
                        c: "dimmed",
                        children: [
                            "LICENCIA ACTIVA - ",
                            data.dt_licencia_desde.substring(0, 10),
                            " - ",
                            data.dt_licencia_hasta.substring(0, 10)
                        ]
                    })
                ]
            })
        ]
    });
}



var $2cMSZ = parcelRequire("2cMSZ");

var $49qEn = parcelRequire("49qEn");

var $2JAvD = parcelRequire("2JAvD");

var $49qEn = parcelRequire("49qEn");

var $ayMG0 = parcelRequire("ayMG0");

var $9mTYo = parcelRequire("9mTYo");

var $3an6L = parcelRequire("3an6L");
var $h8HR1 = parcelRequire("h8HR1");
function $4187ee6da04273ae$export$8f37326c74d827a2(theme) {
    return {
        2: {
            render: (value)=>{
                const val = value;
                if (val === 'NO') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                    style: {
                        gap: '.5rem'
                    },
                    noWrap: true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $h8HR1.default), {
                        style: {
                            color: theme.colors.red[8],
                            minWidth: "1.3rem"
                        },
                        size: "1.3rem"
                    })
                });
                else if (val === 'SI') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                    style: {
                        gap: '.5rem'
                    },
                    noWrap: true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3an6L.default), {
                        style: {
                            color: theme.colors.green[8],
                            minWidth: "1.3rem"
                        },
                        size: "1.3rem"
                    })
                });
                return value;
            }
        }
    };
}


const $b224b46f19de017d$var$columns = ()=>({
        c_proceso_id: new (0, $49qEn.EntityColumn)({
            name: 'c_proceso_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Proceso ID'
        }),
        c_detalle_id: new (0, $49qEn.EntityColumn)({
            name: 'c_detalle_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Detalle ID'
        }),
        vb_file: new (0, $49qEn.EntityColumn)({
            name: 'vb_file',
            type: 'varbinary',
            length: 0,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'File'
        }),
        bt_firmado: new (0, $49qEn.EntityColumn)({
            name: 'bt_firmado',
            type: 'bit',
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Firmado'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $b224b46f19de017d$var$views = ()=>({
        pere_brwRecibos: {
            name: 'pere_brwRecibos',
            keyMappings: {
                c_proceso_id: 4,
                c_detalle_id: 5
            },
            gridColumnsOverrides: (0, $4187ee6da04273ae$export$8f37326c74d827a2)
        }
    });
const $b224b46f19de017d$var$procs = ()=>({
        pere_FirmarRecibo: {
            name: 'pere_FirmarRecibo'
        }
    });
class $b224b46f19de017d$export$2583299a82bfa8fc extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('PersonalRecibos'), this.columns = $b224b46f19de017d$var$columns(), this.views = $b224b46f19de017d$var$views(), this.procs = $b224b46f19de017d$var$procs();
    }
}


const $c89e01a477d9680d$export$1cb3896cae2a7fec = "* Enviar recibos.";
const $c89e01a477d9680d$export$52e8e7eb8dbb3abe = (0, $2JAvD.default);

class $c89e01a477d9680d$export$2d7154cc11cc4dd0 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $b224b46f19de017d$export$2583299a82bfa8fc)(), parentKeys);
        this.Form = (parcelRequire("loUYT")).then((module)=>module.PersonalRecibosForm);
        this.Title = "Recibos de Sueldo";
        this.HelpText = $c89e01a477d9680d$export$1cb3896cae2a7fec;
        this.Icon = $c89e01a477d9680d$export$52e8e7eb8dbb3abe;
    }
}



var $fHG9v = parcelRequire("fHG9v");

var $gZrbO = parcelRequire("gZrbO");

var $4usKR = parcelRequire("4usKR");

var $a4nBq = parcelRequire("a4nBq");

var $gkMhi = parcelRequire("gkMhi");

var $49qEn = parcelRequire("49qEn");

var $aPuNp = parcelRequire("aPuNp");

var $49qEn = parcelRequire("49qEn");

var $iYjhm = parcelRequire("iYjhm");

var $gkMhi = parcelRequire("gkMhi");

var $7n4Yg = parcelRequire("7n4Yg");

var $ayMG0 = parcelRequire("ayMG0");

var $cjohz = parcelRequire("cjohz");

var $49qEn = parcelRequire("49qEn");

var $6fChe = parcelRequire("6fChe");
const $50dc9a9d2a61ae9a$export$a446eb376eb847fa = {
    name: 'ACTGestionarTiendas',
    label: 'Gestionar Tiendas',
    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
        fw: 700,
        children: "Gestionar Tiendas"
    }),
    refreshOnClose: true,
    minSelectedRecords: 1,
    maxSelectedRecords: 1,
    views: [
        'rasu_brwStandard'
    ],
    onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
        // cast entity
        const parent = entity;
        const tiendas = new (0, $6fChe.RegionesTiendas)(entity.API.client);
        tiendas.def.columns.c_region_id.value = selectedKeys[0].c_region_id || '';
        tiendas.def.columns.c_area_id.value = selectedKeys[0].c_area_id || '';
        tiendas.def.columns.c_subarea_id.value = selectedKeys[0].c_subarea_id || '';
        if (modal) await modal.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                    fw: "700",
                    children: "Gestionar Tiendas"
                }),
                size: 'xl'
            },
            focusOnClosed: element,
            onClosed: async ()=>{
                if (onClose) await onClose();
            },
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: entity.API.client,
                entityConstructor: ()=>tiendas,
                formMode: "edit",
                viewName: "regt_brwTiendasPorRegion",
                parentKeys: tiendas.parentKeys,
                refreshOnInit: true,
                enableAdd: false,
                enableDelete: false,
                enableEdit: false,
                enableView: false,
                showActions: true,
                title: `Gestionar Tiendas`,
                selectionMode: "single"
            }, "region-tiendas")
        });
        else console.log('modal context not found');
        return Promise.resolve(false);
    }
};


const $e90d41b803b5a67f$var$columns = ()=>({
        c_region_id: new (0, $49qEn.EntityColumn)({
            name: 'c_region_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Regi\xf3n"
        }),
        c_area_id: new (0, $49qEn.EntityColumn)({
            name: 'c_area_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Area'
        }),
        c_subarea_id: new (0, $49qEn.EntityColumn)({
            name: 'c_subarea_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Subarea'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $e90d41b803b5a67f$var$views = ()=>({
        rasu_brwStandard: {
            name: 'rasu_brwStandard',
            keyMappings: {
                c_region_id: 4,
                c_area_id: 5,
                c_subarea_id: 6
            }
        }
    });
const $e90d41b803b5a67f$var$lookups = ()=>({
        'Regiones': {
            name: 'Regiones',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $gkMhi.Regiones)(client, parentKeys)
        },
        'Areas': {
            name: 'Areas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $iYjhm.Areas)(client, parentKeys)
        },
        'SubAreas': {
            name: 'SubAreas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $7n4Yg.SubAreas)(client, parentKeys)
        }
    });
const $e90d41b803b5a67f$var$clientActions = ()=>({
        ACTGestionarTiendas: (0, $50dc9a9d2a61ae9a$export$a446eb376eb847fa)
    });
class $e90d41b803b5a67f$export$174a5e783d9b7db2 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('RegionesAreasSubareas'), this.columns = $e90d41b803b5a67f$var$columns(), this.views = $e90d41b803b5a67f$var$views(), this.lookups = $e90d41b803b5a67f$var$lookups(), this.clientActions = $e90d41b803b5a67f$var$clientActions();
    }
}


const $218faffca2028298$export$ac8df1fd47c7482e = (0, $aPuNp.default);
const $218faffca2028298$export$7d3ad38e8222dd20 = '* Administrar regiones, areas y subareas.';
class $218faffca2028298$export$227af23fd42db262 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $e90d41b803b5a67f$export$174a5e783d9b7db2)(), parentKeys);
        this.Form = null;
        this.Title = "Regiones";
        this.HelpText = $218faffca2028298$export$7d3ad38e8222dd20;
        this.Icon = $218faffca2028298$export$ac8df1fd47c7482e;
    }
}



var $1GHab = parcelRequire("1GHab");

var $49qEn = parcelRequire("49qEn");

var $cnksb = parcelRequire("cnksb");

var $49qEn = parcelRequire("49qEn");
const $02f49bf0cfd606ee$var$columns = ()=>({
        c_reportes_configuracion_id: new (0, $49qEn.EntityColumn)({
            name: 'c_reportes_configuracion_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Reportes Configuracion Id'
        }),
        vc_tenant_id: new (0, $49qEn.EntityColumn)({
            name: 'vc_tenant_id',
            type: 'varchar',
            length: 2048,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Tenant Id'
        }),
        vc_client_id: new (0, $49qEn.EntityColumn)({
            name: 'vc_client_id',
            type: 'varchar',
            length: 2048,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Client Id'
        }),
        vc_secret: new (0, $49qEn.EntityColumn)({
            name: 'vc_secret',
            type: 'varchar',
            length: 2048,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Secret'
        }),
        vc_workspace_id: new (0, $49qEn.EntityColumn)({
            name: 'vc_workspace_id',
            type: 'varchar',
            length: 2048,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Workspace Id'
        }),
        vc_report_id: new (0, $49qEn.EntityColumn)({
            name: 'vc_report_id',
            type: 'varchar',
            length: 2048,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Report Id'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $02f49bf0cfd606ee$var$views = ()=>({
        reco_brwStandard: {
            name: 'reco_brwStandard',
            keyMappings: {
                c_reportes_configuracion_id: 0
            }
        }
    });
class $02f49bf0cfd606ee$export$1e0dc38ba426794b extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('ReportesConfiguracion'), this.columns = $02f49bf0cfd606ee$var$columns(), this.views = $02f49bf0cfd606ee$var$views();
    }
}


const $1e26cf2b6cab3a93$export$7f1297617d9459ee = (0, $cnksb.default);
const $1e26cf2b6cab3a93$export$15405db845588694 = "* Configuraci\xf3n de Reportes.";

class $1e26cf2b6cab3a93$export$31755127d334d9b9 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $02f49bf0cfd606ee$export$1e0dc38ba426794b)(), parentKeys);
        this.Form = (parcelRequire("8zFeG")).then((module)=>module.ReportesConfiguracionForm);
        this.Title = "Configuraci\xf3n de Reportes";
        this.HelpText = $1e26cf2b6cab3a93$export$15405db845588694;
        this.Icon = $1e26cf2b6cab3a93$export$7f1297617d9459ee;
    }
}



var $fL73S = parcelRequire("fL73S");

var $b53M2 = parcelRequire("b53M2");

var $eD7iz = parcelRequire("eD7iz");

var $bIKvx = parcelRequire("bIKvx");

var $49qEn = parcelRequire("49qEn");
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $f321d9fdbb4886bb$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M21 12a9 9 0 1 0 -9.002 9",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M19.001 15.5v1.5",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M19.001 21v1.5",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M22.032 17.25l-1.299 .75",
            "key": "svg-4"
        }
    ],
    [
        "path",
        {
            "d": "M17.27 20l-1.3 .75",
            "key": "svg-5"
        }
    ],
    [
        "path",
        {
            "d": "M15.97 17.25l1.3 .75",
            "key": "svg-6"
        }
    ],
    [
        "path",
        {
            "d": "M20.733 20l1.3 .75",
            "key": "svg-7"
        }
    ],
    [
        "path",
        {
            "d": "M12 7v5l2 2",
            "key": "svg-8"
        }
    ]
];
const $f321d9fdbb4886bb$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "clock-cog", "ClockCog", $f321d9fdbb4886bb$export$3efd853dbb351e94);



var $49qEn = parcelRequire("49qEn");

var $SKbb0 = parcelRequire("SKbb0");

var $6TYT5 = parcelRequire("6TYT5");

var $7LP39 = parcelRequire("7LP39");

var $6awxZ = parcelRequire("6awxZ");

var $fciDj = parcelRequire("fciDj");

var $8nhIv = parcelRequire("8nhIv");

var $9RYNw = parcelRequire("9RYNw");

var $lV9FS = parcelRequire("lV9FS");
const $ff9fc655fd70e63b$var$columns = ()=>({
        c_tienda_id: new (0, $49qEn.EntityColumn)({
            name: 'c_tienda_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Tienda Id'
        }),
        c_cadena_id: new (0, $49qEn.EntityColumn)({
            name: 'c_cadena_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).FK | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Cadena'
        }),
        vc_canales: new (0, $49qEn.EntityColumn)({
            name: 'vc_canales',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Canales',
            isArray: true
        }),
        vc_domicilio_completo: new (0, $49qEn.EntityColumn)({
            name: 'vc_domicilio_completo',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Domicilio Completo'
        }),
        i_cantidad_clientes: new (0, $49qEn.EntityColumn)({
            name: 'i_cantidad_clientes',
            type: 'int',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Cantidad Clientes'
        }),
        i_cantidad_productos: new (0, $49qEn.EntityColumn)({
            name: 'i_cantidad_productos',
            type: 'int',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Cantidad Productos'
        }),
        f_latitud: new (0, $49qEn.EntityColumn)({
            name: 'f_latitud',
            type: 'float',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Latitud'
        }),
        f_longitud: new (0, $49qEn.EntityColumn)({
            name: 'f_longitud',
            type: 'float',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Longitud'
        }),
        vc_cobertura_compartida: new (0, $49qEn.EntityColumn)({
            name: 'vc_cobertura_compartida',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Cobertura Compartida'
        }),
        vc_cobertura_exclusiva: new (0, $49qEn.EntityColumn)({
            name: 'vc_cobertura_exclusiva',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Cobertura Exclusiva'
        }),
        vc_personal: new (0, $49qEn.EntityColumn)({
            name: 'vc_personal',
            type: 'varchar',
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: "Supervisi\xf3n",
            isArray: true
        }),
        n_horas_compartidas_configuradas: new (0, $49qEn.EntityColumn)({
            name: 'n_horas_compartidas_configuradas',
            type: 'decimal',
            scale: 2,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Horas Compartidas Configuradas'
        }),
        n_horas_exclusivas_configuradas: new (0, $49qEn.EntityColumn)({
            name: 'n_horas_exclusivas_configuradas',
            type: 'decimal',
            scale: 2,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Horas Exclusivas Configuradas'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $ff9fc655fd70e63b$var$views = ()=>({
        rtct_brwStandard: {
            name: 'rtct_brwStandard',
            keyMappings: {
                c_tienda_id: 0
            },
            FiltersEntity: (client, parentKeys)=>new (0, $lV9FS.RutasTiendasFilters)(client, parentKeys),
            gridColumnsOverrides: (0, $fciDj.CoberturaTiendasViewColumnsOverrides),
            mapMarkerRenderer: (0, $9RYNw.CoberturaTiendasViewMarkerRenderer),
            mapInfoWindowRenderer: (0, $8nhIv.CoberturaTiendasViewInfoWindowRenderer)
        }
    });
const $ff9fc655fd70e63b$var$lookups = ()=>({
        'Personal': {
            name: 'Personal',
            view: 'perl_brwJefes',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $7LP39.Personal)(client, parentKeys)
        },
        'Tiendas': {
            name: 'Tiendas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $6awxZ.Tiendas)(client, parentKeys)
        },
        'Cadenas': {
            name: 'Cadenas',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $SKbb0.Cadenas)(client, parentKeys)
        },
        'Canales': {
            name: 'Canales',
            viewMapping: {
                keyIndex: 0,
                descriptionIndex: 1
            },
            entityConstructor: (client, parentKeys)=>new (0, $6TYT5.catCanales)(client, parentKeys)
        }
    });
class $ff9fc655fd70e63b$export$2e3c887bfb559744 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('RutasTiendasConfiguracionTiempo'), this.columns = $ff9fc655fd70e63b$var$columns(), this.views = $ff9fc655fd70e63b$var$views(), this.lookups = $ff9fc655fd70e63b$var$lookups();
    }
}


const $c2d29d29df2be127$export$79aef4b08442f9ca = (0, $f321d9fdbb4886bb$export$2e2bcd8739ae039);
const $c2d29d29df2be127$export$d8616082e431a00e = "* Configuraci\xf3n del tiempo en tienda. Esta configuraci\xf3n ser\xe1 utilizada para determinar si las rutas asignadas a un Tienda cumplen con la configuraci\xf3n de tiempo pactado con los clientes.";

class $c2d29d29df2be127$export$20dd0d72cc83eb1 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $ff9fc655fd70e63b$export$2e3c887bfb559744)(), parentKeys);
        this.Form = (parcelRequire("lV2Pc")).then((module)=>module.RutasTiendasConfiguracionTiempoForm);
        this.Title = "Configuraci\xf3n de Tiempo en Tienda";
        this.HelpText = $c2d29d29df2be127$export$d8616082e431a00e;
        this.Icon = $c2d29d29df2be127$export$79aef4b08442f9ca;
    }
}



var $1OscC = parcelRequire("1OscC");

var $gKBQM = parcelRequire("gKBQM");

var $2cYS7 = parcelRequire("2cYS7");

var $btiOb = parcelRequire("btiOb");

var $6awxZ = parcelRequire("6awxZ");

var $49qEn = parcelRequire("49qEn");

var $aPuNp = parcelRequire("aPuNp");

var $49qEn = parcelRequire("49qEn");
const $4c60374aac83412f$var$columns = ()=>({
        c_zonahoraria_id: new (0, $49qEn.EntityColumn)({
            name: 'c_zonahoraria_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Zona Horaria Id'
        }),
        vc_zonahoraria_nombre: new (0, $49qEn.EntityColumn)({
            name: 'vc_zonahoraria_nombre',
            type: 'varchar',
            length: 255,
            flags: (0, $49qEn.CommonFlags).Edit,
            prompt: 'Nombre'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $4c60374aac83412f$var$views = ()=>({
        zoho_brwStandard: {
            name: 'zoho_brwStandard',
            keyMappings: {
                c_zonahoraria_id: 0
            }
        }
    });
class $4c60374aac83412f$export$d0395a656d681924 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('ZonasHorarias'), this.columns = $4c60374aac83412f$var$columns(), this.views = $4c60374aac83412f$var$views();
    }
}


const $07da442f2fd65e22$export$af33d22a5e137cca = (0, $aPuNp.default);
const $07da442f2fd65e22$export$f37ac7913e8d1984 = "* Aqui tendra la lista de las zonas horarias.";

class $07da442f2fd65e22$export$395e7159aa830734 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $4c60374aac83412f$export$d0395a656d681924)(), parentKeys);
        super.Form = (parcelRequire("8XONQ")).then((module)=>module.ZonasHorariasForm);
        this.Title = "Zonas Horarias";
        this.Icon = $07da442f2fd65e22$export$af33d22a5e137cca;
        this.HelpText = $07da442f2fd65e22$export$f37ac7913e8d1984;
    }
}



var $49qEn = parcelRequire("49qEn");

var $5Ue5f = parcelRequire("5Ue5f");

var $49qEn = parcelRequire("49qEn");
const $99e2027e32e19cbd$var$columns = ()=>({
        c_personal_id: new (0, $49qEn.EntityColumn)({
            name: 'c_personal_id',
            type: 'char',
            length: 20,
            flags: (0, $49qEn.CommonFlags).PK,
            prompt: 'Personal Id'
        }),
        vc_url_dashboard: new (0, $49qEn.EntityColumn)({
            name: 'vc_url_dashboard',
            type: 'varchar',
            length: 2048,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Url Dashboard'
        }),
        vc_workspace_id: new (0, $49qEn.EntityColumn)({
            name: 'vc_workspace_id',
            type: 'varchar',
            length: 2048,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Workspace Id'
        }),
        vc_report_id: new (0, $49qEn.EntityColumn)({
            name: 'vc_report_id',
            type: 'varchar',
            length: 2048,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Report Id'
        }),
        vc_token: new (0, $49qEn.EntityColumn)({
            name: 'vc_token',
            type: 'varchar',
            length: 2048,
            flags: (0, $49qEn.CommonFlags).Edit | (0, $49qEn.EntityColumnFlags).nullable,
            prompt: 'Token'
        }),
        ...(0, $49qEn.DefaultColumns)()
    });
const $99e2027e32e19cbd$var$views = ()=>({});
class $99e2027e32e19cbd$export$bc598d4d35302ea0 extends (0, $49qEn.EntityDefinition) {
    constructor(){
        super('DashboardSupervisores'), this.columns = $99e2027e32e19cbd$var$columns(), this.views = $99e2027e32e19cbd$var$views();
    }
}


const $3a70019c97cb7af8$export$7e9caa0f0c6553cb = (0, $5Ue5f.default);
const $3a70019c97cb7af8$export$7790039c0ed3ec31 = '* Dashboard';

class $3a70019c97cb7af8$export$5290f7aa5fd87917 extends (0, $49qEn.Entity) {
    constructor(client, parentKeys = {}){
        super(client, new (0, $99e2027e32e19cbd$export$bc598d4d35302ea0)(), parentKeys);
        this.Form = (parcelRequire("hP6i7")).then((module)=>module.DashboardSupervisoresForm);
        this.Title = "PowerBI Supervisores";
        this.HelpText = $3a70019c97cb7af8$export$7790039c0ed3ec31;
        this.Icon = $3a70019c97cb7af8$export$7e9caa0f0c6553cb;
    }
}


const $4554799579f361dc$export$d4cd258d01c03112 = 'BackofficeMenu';
function $4554799579f361dc$export$479f0f2f71193efe({ client: client, setContent: setContent, setIsLoggedIn: setIsLoggedIn }) {
    const iconVariant = "filled";
    const iconSize = "1rem";
    const TiendasSubmenu = [
        {
            ID: "tiposdocumentoempresas",
            label: "Tipos Documento Empresas",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3a99cc844e7128c8$export$c625ac55050129ec), {}),
            description: (0, $3a99cc844e7128c8$export$a120f7be8c6e0cde),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: client,
                allwaysRefreshOnEntityClose: true,
                entityConstructor: ()=>new (0, $3a99cc844e7128c8$export$479c608270a2375a)(client),
                formMode: "add",
                viewName: "cav_brwStandard",
                refreshOnInit: true,
                selectionMode: "multi"
            }, "menuItem-tiposdocumentoempresas")
        },
        {
            ID: "gruposempresas",
            label: "Grupos Empresas",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3IWeJ.GruposEmpresasIcon), {}),
            description: (0, $3IWeJ.GruposEmpresasHelpText),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: client,
                allwaysRefreshOnEntityClose: true,
                modalFormSize: "xl",
                entityConstructor: ()=>new (0, $3IWeJ.GruposEmpresas)(client),
                formMode: "add",
                viewName: "grem_brwStandard",
                refreshOnInit: true,
                selectionMode: "multi"
            }, "menuItem-gruposempresas")
        },
        {
            ID: "empresas",
            label: "Empresas",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bYVp3.EmpresasIcon), {}),
            description: (0, $bYVp3.EmpresasHelpText),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: client,
                allwaysRefreshOnEntityClose: true,
                modalFormSize: "xl",
                entityConstructor: ()=>new (0, $bYVp3.Empresas)(client),
                formMode: "add",
                viewName: "empr_brwStandard",
                refreshOnInit: true,
                selectionMode: "multi"
            }, "menuItem-empresas")
        },
        {
            ID: "regiones",
            label: "Regiones",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gkMhi.RegionesIcon), {}),
            description: (0, $gkMhi.RegionesHelpText),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: client,
                entityConstructor: ()=>new (0, $218faffca2028298$export$227af23fd42db262)(client),
                formMode: "add",
                enableAdd: false,
                enableEdit: false,
                enableDelete: false,
                viewName: "rasu_brwStandard",
                refreshOnInit: true,
                selectionMode: "multi"
            }, "menuItem-regiones")
        },
        {
            ID: "canales",
            label: "Canales",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6TYT5.CanalesIcon), {}),
            description: (0, $6TYT5.CanalesHelpText),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: client,
                entityConstructor: ()=>new (0, $6TYT5.catCanales)(client),
                formMode: "add",
                viewName: "cav_brwStandard",
                refreshOnInit: true,
                selectionMode: "multi"
            }, "menuItem-canales")
        },
        {
            ID: "cadenas",
            label: "Cadenas",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $SKbb0.CadenasIcon), {}),
            description: (0, $SKbb0.CadenasHelpText),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                enableImport: true,
                client: client,
                entityConstructor: ()=>new (0, $SKbb0.Cadenas)(client),
                formMode: "add",
                viewName: "cade_brwStandard",
                refreshOnInit: true,
                selectionMode: "multi"
            }, "menuItem-cadenas")
        },
        {
            ID: "tiendasin",
            label: "Tiendas",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6awxZ.TiendasIcon), {}),
            description: (0, $6awxZ.TiendasHelpText),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $268b2f3577ca661f$export$1099a918c93775da), {
                client: client,
                allwaysRefreshOnEntityClose: true,
                entityConstructor: ()=>new (0, $6awxZ.Tiendas)(client),
                formMode: "add",
                viewName: "tien_brwStandard",
                refreshOnInit: true,
                selectionMode: "multi",
                modalFormSize: "xl"
            }, "menuItem-tiendas")
        }
    ];
    const ClientesSubmenu = [
        {
            ID: "condicionespago",
            label: "Condiciones De Pago",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5A5L0.TiposServicioIcon), {}),
            description: (0, $5A5L0.TiposServicioHelpText),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: client,
                entityConstructor: ()=>new (0, $iHr81.CondicionesPago)(client),
                formMode: "add",
                viewName: "cdpg_brwStandard",
                refreshOnInit: true,
                selectionMode: "multi"
            }, "menuItem-condicionespago")
        },
        {
            ID: "condicionesfacturacion",
            label: "Condiciones de Facturacion",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2LSnU.CondicionesFacturacionIcon), {}),
            description: (0, $gKBQM.ServiciosHelpText),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: client,
                allwaysRefreshOnEntityClose: true,
                modalFormSize: "xl",
                entityConstructor: ()=>new (0, $2LSnU.CondicionesFacturacion)(client),
                formMode: "add",
                viewName: "cdfc_brwStandard",
                refreshOnInit: true,
                selectionMode: "multi"
            }, "menuItem-condicionesfacturacion")
        },
        {
            ID: "productos",
            label: "Productos",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4usKR.ProductosIcon), {}),
            description: (0, $4usKR.ProductosHelpText),
            onClick: ()=>setContent(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                    client: client,
                    allwaysRefreshOnEntityClose: true,
                    entityConstructor: ()=>new (0, $4usKR.Productos)(client),
                    formMode: "add",
                    viewName: "prdc_brwStandard",
                    refreshOnInit: true,
                    selectionMode: "multi",
                    modalFormSize: "xl"
                }, "menuItem-productos"))
        },
        {
            ID: "clientes",
            label: "Clientes",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9u8qf.ClientesIcon), {}),
            description: (0, $9u8qf.ClientesHelpText),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: client,
                allwaysRefreshOnEntityClose: true,
                entityConstructor: ()=>new (0, $9u8qf.Clientes)(client),
                formMode: "add",
                viewName: "clie_brwStandard",
                refreshOnInit: true,
                selectionMode: "multi"
            }, "menuItem-clientes")
        },
        {
            ID: "configuracion",
            label: "Configuraci\xf3n",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3a1ece0bea58f020$export$5473d368c3bb0264), {}),
            description: (0, $3a1ece0bea58f020$export$bc79c06fbb221d45),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $571ae72822e7da55$export$7ec2ea57aa93f6d9), {
                modalFormSize: "xl",
                client: client,
                allwaysRefreshOnEntityClose: true,
                entityConstructor: ()=>new (0, $3a1ece0bea58f020$export$6c6b43f3d0ccb950)(client),
                formMode: "add",
                viewName: "clcf_brwStandard",
                refreshOnInit: true,
                selectionMode: "multi"
            }, "menuItem-configuracion")
        },
        {
            ID: "clientesproductosimportacion",
            label: "Importaci\xf3n de Productos",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4usKR.ProductosIcon), {}),
            description: (0, $4usKR.ProductosHelpText),
            onClick: ()=>setContent(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                    client: client,
                    allwaysRefreshOnEntityClose: true,
                    entityConstructor: ()=>new (0, $2df6b71b102eaa3b$export$2b1c67409fa25131)(client),
                    formMode: "add",
                    viewName: "cpim_brwStandard",
                    refreshOnInit: true,
                    selectionMode: "multi",
                    modalFormSize: "xl"
                }, "menuItem-clientesproductosimportacion"))
        },
        {
            ID: "clientes_tiendas",
            label: "Clientes Tiendas",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6awxZ.TiendasIcon), {}),
            description: "Tiendas activas configuradas para clientes activos",
            onClick: ()=>setContent(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                    client: client,
                    allwaysRefreshOnEntityClose: true,
                    entityConstructor: ()=>new (0, $cC5ZS.ClientesConfiguracionTiendas)(client),
                    formMode: "view",
                    viewName: "clct_brwTodas",
                    refreshOnInit: true,
                    selectionMode: "multi",
                    modalFormSize: "xl",
                    showActions: false,
                    title: "Configuraci\xf3n de Tiendas Activas por Clientes Activos"
                }, "menuItem-clientestiendas"))
        }
    ];
    const WorkForceSubmenu = [
        {
            ID: "feriados",
            label: "Feriados",
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8d932423819106b1$export$2280eab1088f2f46), {}),
            description: (0, $8d932423819106b1$export$1ddbb87f13efbdbe),
            section: 'items',
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: client,
                entityConstructor: ()=>new (0, $8d932423819106b1$export$f0c44d98c0461831)(client),
                formMode: "add",
                viewName: "feri_brwStandard",
                refreshOnInit: true,
                selectionMode: "multi"
            }, "menuItem-feriados")
        },
        {
            ID: "bancos",
            label: "Bancos",
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bMvwR.BancosIcon), {}),
            description: (0, $bMvwR.BancosHelpText),
            section: 'items',
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: client,
                entityConstructor: ()=>new (0, $bMvwR.Bancos)(client),
                formMode: "add",
                viewName: "banc_brwStandard",
                refreshOnInit: true,
                selectionMode: "multi"
            }, "menuItem-bancos")
        },
        {
            ID: "plantillashorarios",
            label: "Plantillas de Horario",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gZrbO.PlantillasHorariosIcon), {}),
            description: (0, $gZrbO.PlantillasHorariosHelpText),
            onClick: ()=>setContent(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                    client: client,
                    entityConstructor: ()=>new (0, $gZrbO.PlantillasHorarios)(client),
                    formMode: "add",
                    viewName: "plah_brwStandard",
                    refreshOnInit: true,
                    selectionMode: "multi"
                }, "menuItem-plantillashorarios"))
        },
        {
            ID: "motivosbaja",
            label: "Motivos de Baja",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $exmmN.MotivosBajaIcon), {}),
            description: (0, $exmmN.MotivosBajaHelpText),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: client,
                entityConstructor: ()=>new (0, $exmmN.catMotivosBaja)(client),
                formMode: "add",
                viewName: "cav_brwStandard",
                refreshOnInit: true,
                selectionMode: "multi"
            }, "menuItem-motivosbaja")
        },
        {
            ID: "motivoslicencias",
            label: "Motivos de Licencia",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hMWb0.MotivosLicenciaIcon), {}),
            description: (0, $hMWb0.MotivosLicenciaHelpText),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: client,
                entityConstructor: ()=>new (0, $hMWb0.catMotivosLicencia)(client),
                formMode: "add",
                viewName: "cav_brwStandard",
                refreshOnInit: true,
                selectionMode: "multi"
            }, "menuItem-motivoslicencia")
        },
        {
            ID: "dispositivos",
            label: "Dispositivos",
            section: 'items',
            description: (0, $giXL1.DispositivosHelpText),
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $giXL1.DispositivosIcon), {}),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: client,
                allwaysRefreshOnEntityClose: true,
                entityConstructor: ()=>new (0, $giXL1.Dispositivos)(client),
                formMode: "add",
                viewName: "disp_brwStandard",
                refreshOnInit: true,
                selectionMode: "multi"
            }, "menuItem-dispositivos")
        },
        {
            ID: "requisitos",
            label: "Requisitos de Ingreso",
            section: 'items',
            description: (0, $fL73S.RequisitosHelpText),
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fL73S.RequisitosIcon), {}),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: client,
                allwaysRefreshOnEntityClose: true,
                entityConstructor: ()=>new (0, $fL73S.Requisitos)(client),
                formMode: "add",
                viewName: "requ_brwStandard",
                refreshOnInit: true,
                selectionMode: "multi"
            }, "menuItem-requisitos")
        },
        {
            ID: "ropa",
            label: "Ropa de Trabajo",
            section: 'items',
            description: (0, $hMWb0.MotivosLicenciaHelpText),
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b53M2.RopaIcon), {}),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: client,
                allwaysRefreshOnEntityClose: true,
                entityConstructor: ()=>new (0, $b53M2.Ropa)(client),
                formMode: "add",
                viewName: "ropa_brwStandard",
                refreshOnInit: true,
                selectionMode: "multi"
            }, "menuItem-ropa")
        },
        {
            ID: "areas",
            label: "\xc1reas",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $316Pw.AreasPersonalIcon), {}),
            description: (0, $316Pw.AreasPersonalHelpText),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: client,
                entityConstructor: ()=>new (0, $316Pw.catAreasPersonal)(client),
                formMode: "add",
                viewName: "cav_brwStandard",
                refreshOnInit: true,
                selectionMode: "multi"
            }, "menuItem-areas")
        },
        {
            ID: "puestos",
            label: "Puestos",
            section: 'items',
            description: (0, $a4nBq.PuestosTrabajoHelpText),
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a4nBq.PuestosTrabajoIcon), {}),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: client,
                allwaysRefreshOnEntityClose: true,
                entityConstructor: ()=>new (0, $a4nBq.PuestosTrabajo)(client),
                formMode: "add",
                viewName: "pues_brwStandard",
                refreshOnInit: true,
                selectionMode: "multi"
            }, "menuItem-puestos")
        },
        {
            ID: "empleados",
            label: "Personal",
            section: 'items',
            description: (0, $7LP39.PersonalHelpText),
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7LP39.PersonalIcon), {}),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataViewPage), {
                allwaysRefreshOnEntityClose: true,
                client: client,
                entityConstructor: ()=>new (0, $7LP39.Personal)(client),
                modalFormSize: "100%",
                viewName: "perl_brwCard",
                refreshOnInit: true,
                selectionMode: "multi",
                Card: (0, $bf674960115d00da$export$b13db8347905fc02)
            }, "menuItem-empleados")
        },
        {
            ID: "asignarpersonal",
            label: "Asignar Personal",
            section: 'items',
            description: "Asignaci\xf3n de Personal",
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7LP39.PersonalIcon), {}),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                enableAdd: false,
                enableEdit: false,
                enableDelete: false,
                enableView: true,
                client: client,
                entityConstructor: ()=>new (0, $7LP39.Personal)(client),
                formMode: "edit",
                viewName: "perl_brwGestionPersonal",
                refreshOnInit: true,
                selectionMode: "single",
                modalFormSize: "xl"
            }, "menuItem-asignarpersonal")
        },
        {
            ID: "licencias",
            label: "Licencias",
            section: 'items',
            description: (0, $2cMSZ.PersonalLicenciasText),
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cMSZ.PersonalLicenciasIcon), {}),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                enableAdd: false,
                client: client,
                entityConstructor: ()=>new (0, $2cMSZ.PersonalLicencias)(client),
                formMode: "edit",
                viewName: "plli_brwHistorial",
                refreshOnInit: true,
                selectionMode: "multi"
            }, "menuItem-licencias")
        },
        //{
        //    ID: "enviarrecibos", label: "Recibos Sueldo", section: 'items', description: 'Envío de recibos de sueldo', icon: <EnviarRecibosIcon />, content: <DataGridPage key="menuItem-enviarrecibos" enableAdd={true} client={client} entityConstructor={() => new EnviarRecibos(client)} formMode="edit" viewName="enre_brwStandard" refreshOnInit selectionMode="multi" />
        //},
        {
            ID: "enviarrecibos",
            label: "Recibos Sueldo",
            section: 'items',
            description: "Env\xedo de recibos de sueldo",
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5qfPT.EnviarRecibosIcon), {}),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2bc28dceee91f652$export$2e2bcd8739ae039), {
                client: client
            })
        }
    ];
    const OperacionesSubmenu = [
        {
            ID: "asignacionpersonal",
            label: "Asignaci\xf3n por Tienda",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fHG9v.PersonalTiendasIcon), {}),
            description: (0, $fHG9v.PersonalTiendasHelpText),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataMapPage), {
                dataGridProps: {
                    filtersFormSize: "lg",
                    viewName: "plti_brwStandard",
                    selectionMode: "multi",
                    refreshOnInit: true,
                    enableAdd: false
                },
                formMode: "add",
                client: client,
                entityConstructor: ()=>new (0, $fHG9v.PersonalTiendas)(client),
                latitudRecordIndex: 9,
                longitudRecordIndex: 10,
                mapHeight: "55vh"
            }, "menuItem-asignacionpersonal")
        },
        {
            ID: "asignaciontiendas",
            label: "Asignaci\xf3n por Personal",
            section: 'items',
            description: (0, $fHG9v.PersonalTiendasHelpText),
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fHG9v.PersonalTiendasIcon), {}),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                enableAdd: false,
                enableEdit: false,
                enableDelete: false,
                enableView: false,
                client: client,
                entityConstructor: ()=>new (0, $fHG9v.PersonalTiendas)(client),
                formMode: "edit",
                viewName: "plti_brwGestionTiendas",
                refreshOnInit: true,
                selectionMode: "multi"
            }, "menuItem-asignaciontiendas")
        },
        {
            ID: "tiempoentienda",
            label: "Tiempo en Tienda",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c2d29d29df2be127$export$79aef4b08442f9ca), {}),
            description: (0, $eD7iz.RutasHelpText),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataMapPage), {
                dataGridProps: {
                    filtersFormSize: "xl",
                    modalFormSize: "100%",
                    viewName: "rtct_brwStandard",
                    selectionMode: "multi",
                    refreshOnInit: true,
                    allwaysRefreshOnEntityClose: true,
                    enableAdd: false,
                    enableDelete: false
                },
                client: client,
                entityConstructor: ()=>new (0, $c2d29d29df2be127$export$20dd0d72cc83eb1)(client),
                formMode: "edit",
                latitudRecordIndex: 14,
                longitudRecordIndex: 15
            }, "menuItem-tiempoEnTienda")
        }
    ];
    const RutasSubmenu = [
        //{
        //    ID: "rutas", label: "Rutas", section: 'items', icon: <RutasIcon />, description: RutasHelpText, content: <RutasTiendasPage key="menuItem-rutas" filtersFormSize="lg" client={client} entityConstructor={() => new RutasTiendasConfiguracion(client)} formMode="add" viewName="rtcf_brwCoberturaTiendas" refreshOnInit selectionMode="multi" />
        //},
        {
            ID: "rutas2",
            label: "Rutas",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eD7iz.RutasIcon), {}),
            description: (0, $eD7iz.RutasHelpText),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.MultiDataMapPage), {
                filtersFormSize: "lg",
                client: client,
                formMode: "edit",
                selectionMode: "multi",
                mapHeight: "66vh",
                dataMapView1: {
                    entityConstructor: ()=>new (0, $bIKvx.RutasTiendasConfiguracion)(client),
                    viewName: "rtcf_brwCoberturaTiendas",
                    //refreshOnInit: true,
                    latitudRecordIndex: 14,
                    longitudRecordIndex: 15,
                    tabLabel: "Tiendas",
                    tabIcon: (0, $jIc5b.default),
                    enableAdd: false,
                    enableDelete: false,
                    enableEdit: false,
                    enableView: true,
                    modalFormSize: "fullscreen"
                },
                dataMapView2: {
                    entityConstructor: ()=>new (0, $2cYS7.SolicitudesRuteo)(client),
                    viewName: "soru_brwDisponibleEnRutas",
                    //refreshOnInit: true,
                    latitudRecordIndex: 23,
                    longitudRecordIndex: 24,
                    tabLabel: "Personal",
                    tabIcon: (0, $4d0Rl.default),
                    enableAdd: false,
                    enableDelete: false,
                    enableEdit: false,
                    enableView: false,
                    modalFormSize: "fullscreen"
                }
            }, "menuItem-rutas2")
        },
        {
            ID: "solicitudesborradorruteo",
            label: "Borradores",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cYS7.SolicitudesRuteoIcon), {}),
            description: (0, $2cYS7.SolicitudesRuteoHelpText),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                title: "Borradores de Solicitudes de Ruteo",
                enableAdd: false,
                enableEdit: false,
                enableDelete: true,
                enableView: true,
                client: client,
                entityConstructor: ()=>new (0, $btiOb.SolicitudesRuteoInfo)(client),
                formMode: "add",
                viewName: "sorui_brwBorradores",
                refreshOnInit: true,
                selectionMode: "multi",
                modalFormSize: "100vw"
            }, "menuItem-solicitudesborradorruteo")
        },
        {
            ID: "solicitudesruteo",
            label: "Autorizaci\xf3n de Ruteo",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cYS7.SolicitudesRuteoIcon), {}),
            description: (0, $2cYS7.SolicitudesRuteoHelpText),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                enableAdd: false,
                enableEdit: false,
                enableDelete: false,
                enableView: true,
                client: client,
                entityConstructor: ()=>new (0, $btiOb.SolicitudesRuteoInfo)(client),
                formMode: "add",
                viewName: "sorui_brwStandard",
                refreshOnInit: true,
                selectionMode: "single",
                modalFormSize: "100vw"
            }, "menuItem-solicitudesruteo")
        },
        {
            ID: "solicitudesruteohistorial",
            label: "Historial",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cYS7.SolicitudesRuteoIcon), {}),
            description: (0, $2cYS7.SolicitudesRuteoHelpText),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                title: "Historial de Solicitud de Ruteo",
                enableAdd: false,
                enableEdit: false,
                enableDelete: false,
                enableView: true,
                client: client,
                entityConstructor: ()=>new (0, $btiOb.SolicitudesRuteoInfo)(client),
                formMode: "add",
                viewName: "sorui_brwHistorial",
                refreshOnInit: true,
                selectionMode: "single",
                modalFormSize: "100vw"
            }, "menuItem-solicitudesruteohistorial")
        },
        {
            ID: "visitasatiendas",
            label: "Visitas",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eD7iz.RutasIcon), {}),
            description: (0, $eD7iz.RutasHelpText),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.MultiDataMapPage), {
                filtersFormSize: "lg",
                client: client,
                formMode: "add",
                selectionMode: "multi",
                mapHeight: "66vh",
                dataMapView1: {
                    entityConstructor: ()=>new (0, $1OscC.VisitasATiendas)(client),
                    viewName: "viti_brwVisitasPorSemana",
                    //refreshOnInit: true,
                    latitudRecordIndex: 13,
                    longitudRecordIndex: 14,
                    tabLabel: "Visitas",
                    tabIcon: (0, $jIc5b.default),
                    enableAdd: false,
                    enableDelete: false,
                    enableEdit: true,
                    enableView: false,
                    modalFormSize: "md"
                },
                dataMapView2: {
                    entityConstructor: ()=>new (0, $1OscC.VisitasATiendas)(client),
                    viewName: "viti_brwVisitasPorSemanaPersonal",
                    //refreshOnInit: true,
                    latitudRecordIndex: 18,
                    longitudRecordIndex: 19,
                    tabLabel: "Personal",
                    tabIcon: (0, $4d0Rl.default),
                    enableAdd: false,
                    enableDelete: false,
                    enableEdit: false,
                    enableView: false,
                    modalFormSize: "md"
                }
            }, "menuItem-visitasatiendas")
        }
    ];
    const AutorizacionesSubmenu = [
        {
            ID: "autorizacionreportes",
            label: "Autorizar Reportes",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $35ntO.default), {}),
            description: (0, $66ea17e39c45d424$export$e08a0cfd60bb96a1),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: client,
                entityConstructor: ()=>new (0, $goQRU.DatosServiciosAutorizacionProductos)(client),
                formMode: "view",
                viewName: "dasp_brwAutorizacionGeneral",
                refreshOnInit: true,
                selectionMode: "multi",
                doubleClickAction: "none",
                enableView: false
            }, "menuItem-autorizacionreportes")
        },
        {
            ID: "gestionreportes",
            label: "Gestionar Reportes",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $35ntO.default), {}),
            description: (0, $66ea17e39c45d424$export$e08a0cfd60bb96a1),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: client,
                enableAdd: false,
                enableEdit: false,
                enableDelete: false,
                entityConstructor: ()=>new (0, $ieRws.DatosServiciosAutorizacion)(client),
                formMode: "view",
                viewName: "dasa_brwGestionReportes",
                title: "Gesti\xf3n de Reportes",
                refreshOnInit: true,
                selectionMode: "single",
                doubleClickAction: "none"
            }, "menuItem-gestionreportes")
        }
    ];
    const UsuariosSubmenu = [
        {
            ID: "abmusuarios",
            label: "Usuarios",
            section: 'items',
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: client,
                entityConstructor: ()=>new (0, $102149287019c41d$export$a926cc14e890be3e)(client),
                formMode: "add",
                viewName: "usr_brwStandard",
                refreshOnInit: true,
                selectionMode: "multi"
            }, "menuItem-abmusuarios")
        }
    ];
    const ConfiguracionSubmenu = [
        {
            ID: "email",
            label: "Env\xedo de Emails",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Wgks.ThemeIcon), {
                variant: iconVariant,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.EmailServiceConfigurationIcon), {
                    size: iconSize
                })
            }),
            description: (0, $a32a53452d089c42$export$e468013a8277919e),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.EntityFormPage), {
                saveAndGetOnSubmit: true,
                client: client,
                entityConstructor: ()=>new (0, $a32a53452d089c42$export$e299dae4ae81c8fa)(client),
                initialFormMode: "edit",
                getDataOnInit: true
            }, "menuItem-email")
        },
        {
            ID: "reportesconfig",
            label: "Dashboard Clientes",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Wgks.ThemeIcon), {
                variant: iconVariant,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e26cf2b6cab3a93$export$7f1297617d9459ee), {
                    size: iconSize
                })
            }),
            description: (0, $1e26cf2b6cab3a93$export$15405db845588694),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.EntityFormPage), {
                saveAndGetOnSubmit: true,
                client: client,
                entityConstructor: ()=>{
                    const ret = new (0, $1e26cf2b6cab3a93$export$31755127d334d9b9)(client);
                    ret.def.columns.c_reportes_configuracion_id.value = 'MTS';
                    return ret;
                },
                initialFormMode: "edit",
                getDataOnInit: true
            }, "menuItem-reportesconfig")
        },
        {
            ID: "dashboardsupcfg",
            label: "Dashboard Supervisores",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Wgks.ThemeIcon), {
                variant: iconVariant,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e26cf2b6cab3a93$export$7f1297617d9459ee), {
                    size: iconSize
                })
            }),
            description: (0, $1e26cf2b6cab3a93$export$15405db845588694),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.EntityFormPage), {
                saveAndGetOnSubmit: true,
                client: client,
                entityConstructor: ()=>{
                    const ret = new (0, $1e26cf2b6cab3a93$export$31755127d334d9b9)(client);
                    ret.def.columns.c_reportes_configuracion_id.value = 'SUPER';
                    return ret;
                },
                initialFormMode: "edit",
                getDataOnInit: true
            }, "menuItem-dashsupconfig")
        },
        {
            ID: "paises",
            label: "Paises",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j8GP5.PaisesIcon), {}),
            description: (0, $j8GP5.PaisesHelpText),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: client,
                entityConstructor: ()=>new (0, $j8GP5.Paises)(client),
                formMode: "add",
                viewName: "pais_brwStandard",
                refreshOnInit: true,
                selectionMode: "multi"
            }, "menuItem-paises")
        },
        {
            ID: "provincias",
            label: "Provincias",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Rlmx.ProvinciasIcon), {}),
            description: (0, $4Rlmx.ProvinciasHelpText),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.EntityFormPage), {
                client: client,
                entityConstructor: ()=>new (0, $5b125d3bebeda5ec$export$a68a7f5ee318d650)(client),
                initialFormMode: "add"
            }, "menuItem-provincias")
        },
        {
            ID: "ciudades",
            label: "Ciudades",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kFypM.CiudadesIcon), {}),
            description: (0, $kFypM.CiudadesHelpText),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.EntityFormPage), {
                client: client,
                entityConstructor: ()=>new (0, $60092e204c01d751$export$b1ad44e3e57ff523)(client),
                initialFormMode: "add"
            }, "menuItem-ciudades")
        },
        {
            ID: "zonashorarias",
            label: "Zonas Horarias",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $07da442f2fd65e22$export$af33d22a5e137cca), {}),
            description: (0, $07da442f2fd65e22$export$f37ac7913e8d1984),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: client,
                entityConstructor: ()=>new (0, $07da442f2fd65e22$export$395e7159aa830734)(client),
                formMode: "add",
                viewName: "zoho_brwStandard",
                refreshOnInit: true,
                selectionMode: "multi"
            }, "menuItem-zonashorarias")
        },
        {
            ID: "genero",
            label: "G\xe9nero",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $841Z4.GeneroIcon), {}),
            description: (0, $841Z4.GeneroHelpText),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: client,
                entityConstructor: ()=>new (0, $841Z4.catGenero)(client),
                formMode: "add",
                viewName: "cav_brwStandard",
                refreshOnInit: true,
                selectionMode: "multi"
            }, "menuItem-genero")
        },
        {
            ID: "tiposdoc",
            label: "Tipos Documento",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8PdZ4.TiposDocumentoIcon), {}),
            description: (0, $8PdZ4.TiposDocumentoHelpText),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: client,
                entityConstructor: ()=>new (0, $8PdZ4.catTiposDocumento)(client),
                formMode: "add",
                viewName: "cav_brwStandard",
                refreshOnInit: true,
                selectionMode: "multi"
            }, "menuItem-tiposdoc")
        },
        {
            ID: "tiposemail",
            label: "Tipos Email",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3RgBj.TiposEmailIcon), {}),
            description: (0, $3RgBj.TiposEmailHelpText),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: client,
                entityConstructor: ()=>new (0, $3RgBj.catTiposEmail)(client),
                formMode: "add",
                viewName: "cav_brwStandard",
                refreshOnInit: true,
                selectionMode: "multi"
            }, "menuItem-tiposemail")
        },
        {
            ID: "tallesletras",
            label: "Talles con Letras",
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5GxBW.TallesLetrasIcon), {}),
            description: (0, $5GxBW.TallesLetrasHelpText),
            section: 'items',
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: client,
                entityConstructor: ()=>new (0, $5GxBW.catTallesConLetras)(client),
                formMode: "add",
                viewName: "cav_brwStandard",
                refreshOnInit: true,
                selectionMode: "multi"
            }, "menuItem-tallesletras")
        },
        {
            ID: "tallespantalones",
            label: "Talles de Pantalones",
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iVMwo.TallesPantalonesIcon), {}),
            description: (0, $iVMwo.TallesPantalonesHelpText),
            section: 'items',
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: client,
                entityConstructor: ()=>new (0, $iVMwo.catTallesPantalones)(client),
                formMode: "add",
                viewName: "cav_brwStandard",
                refreshOnInit: true,
                selectionMode: "multi"
            }, "menuItem-tallespantalones")
        },
        {
            ID: "talleszapatos",
            label: "Talles de Zapatos",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l9enS.TallesZapatosIcon), {}),
            description: (0, $l9enS.TallesZapatosHelpText),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: client,
                entityConstructor: ()=>new (0, $l9enS.catTallesZapatos)(client),
                formMode: "add",
                viewName: "cav_brwStandard",
                refreshOnInit: true,
                selectionMode: "multi"
            }, "menuItem-talleszapatos")
        },
        {
            ID: "diassemana",
            label: "Dias de la Semana",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3TX0s.DiasSemanaIcon), {}),
            description: (0, $3TX0s.DiasSemanaHelpText),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: client,
                entityConstructor: ()=>new (0, $3TX0s.catDiasSemana)(client),
                formMode: "add",
                viewName: "cav_brwStandard",
                refreshOnInit: true,
                selectionMode: "multi"
            }, "menuItem-diassemana")
        },
        {
            ID: "enviomensual",
            label: "Envios Mensuales",
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $99fvj.EnvioMensualIcon), {}),
            description: (0, $99fvj.EnvioMensualHelpText),
            section: 'items',
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: client,
                entityConstructor: ()=>new (0, $99fvj.catEnvioMensual)(client),
                formMode: "add",
                viewName: "cav_brwStandard",
                refreshOnInit: true,
                selectionMode: "multi"
            }, "menuItem-enviomensual")
        },
        {
            ID: "envioquincenal",
            label: "Envios Quincenal",
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5wo6I.EnvioQuincenalIcon), {}),
            description: (0, $5wo6I.EnvioQuincenalHelpText),
            section: 'items',
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: client,
                entityConstructor: ()=>new (0, $5wo6I.catEnvioQuincenal)(client),
                formMode: "add",
                viewName: "cav_brwStandard",
                refreshOnInit: true,
                selectionMode: "multi"
            }, "menuItem-envioquincenal")
        },
        {
            ID: "frecuenciatiempo",
            label: "Frecuencias de Tiempo",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $k9JMU.FrecuenciaTiempoIcon), {}),
            description: (0, $k9JMU.FrecuenciaTiempoHelpText),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: client,
                entityConstructor: ()=>new (0, $k9JMU.catFrecuenciaTiempo)(client),
                formMode: "add",
                viewName: "cav_brwStandard",
                refreshOnInit: true,
                selectionMode: "multi"
            }, "menuItem-frecuenciatiempo")
        }
    ];
    const ServiciosSubmenu = [
        {
            ID: "tiposdatosservicios",
            label: "Tipos De Datos De Servicio",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e4f1v.TiposDatosServiciosIcon), {}),
            description: (0, $e4f1v.TiposDatosServiciosHelpText),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: client,
                entityConstructor: ()=>new (0, $e4f1v.catTiposDatosServicios)(client),
                formMode: "add",
                viewName: "cav_brwStandard",
                refreshOnInit: true,
                selectionMode: "multi"
            }, "menuItem-tiposdatosservicios")
        },
        {
            ID: "tiposservicio",
            label: "Tipos De Servicio",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5A5L0.TiposServicioIcon), {}),
            description: (0, $5A5L0.TiposServicioHelpText),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: client,
                entityConstructor: ()=>new (0, $5A5L0.catTiposServicio)(client),
                formMode: "add",
                viewName: "cav_brwStandard",
                refreshOnInit: true,
                selectionMode: "multi"
            }, "menuItem-tiposservicio")
        },
        {
            ID: "listavalores",
            label: "Lista de Valores",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9v5jT.ListasValoresIcon), {}),
            description: (0, $9v5jT.ListasValoresHelpText),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: client,
                allwaysRefreshOnEntityClose: true,
                modalFormSize: "xl",
                entityConstructor: ()=>new (0, $9v5jT.ListasValores)(client),
                formMode: "add",
                viewName: "liva_brwStandard",
                refreshOnInit: true,
                selectionMode: "multi"
            }, "menuItem-listavalores")
        },
        {
            ID: "serviciosin",
            label: "Servicios",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gKBQM.ServiciosIcon), {}),
            description: (0, $gKBQM.ServiciosHelpText),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: client,
                allwaysRefreshOnEntityClose: true,
                modalFormSize: "xl",
                entityConstructor: ()=>new (0, $gKBQM.Servicios)(client),
                formMode: "add",
                viewName: "serv_brwStandard",
                refreshOnInit: true,
                selectionMode: "multi"
            }, "menuItem-servicios")
        }
    ];
    const SeguridadSubmenu = [
        {
            ID: "perfiles",
            label: "Perfiles de usuario",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $54kyq.default), {
                size: "1rem"
            }),
            description: "* Los perfiles de usuario asignan grupos de permisos",
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                parentKeys: {
                    c_menu_id: 'BackofficeMenu'
                },
                modalFormSize: "xl",
                client: client,
                entityConstructor: ()=>{
                    const ent = new (0, $41d9d26609a1fc45$export$491d3c2e4b78ca9a)(client);
                    return ent;
                },
                formMode: "add",
                viewName: "mug_brwStandard",
                refreshOnInit: true,
                selectionMode: "multi"
            }, "menuItem-perfilesUsuarios")
        },
        {
            ID: "personalpassword",
            label: "Cambiar contrase\xf1a Personal",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $54kyq.default), {}),
            description: "Aqu\xed podr\xe1 cambiar la contrase\xf1a de usuarios del personal.",
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: client,
                allwaysRefreshOnEntityClose: true,
                modalFormSize: "xl",
                entityConstructor: ()=>new (0, $7de45db546c59736$export$f75d543435791d71)(client),
                formMode: "add",
                viewName: "uspw_brwPersonal",
                refreshOnInit: true,
                selectionMode: "single",
                enableAdd: false,
                enableDelete: false,
                enableView: false
            }, "menuItem-personalpassword")
        },
        {
            ID: "clientespassword",
            label: "Cambiar contrase\xf1a Clientes",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $54kyq.default), {}),
            description: "Aqu\xed podr\xe1 cambiar la contrase\xf1a de usuarios de clientes.",
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: client,
                allwaysRefreshOnEntityClose: true,
                modalFormSize: "xl",
                entityConstructor: ()=>new (0, $7de45db546c59736$export$f75d543435791d71)(client),
                formMode: "add",
                viewName: "uspw_brwClientes",
                refreshOnInit: true,
                selectionMode: "single",
                enableAdd: false,
                enableDelete: false,
                enableView: false
            }, "menuItem-clientespassword")
        }
    ];
    const RecibosDeSueldoSubmenu = [
        {
            ID: "misrecibos",
            label: "Mis Recibos de Sueldo",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $54kyq.default), {}),
            description: 'Recibos de Sueldo',
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.DataGridPage), {
                client: client,
                allwaysRefreshOnEntityClose: true,
                modalFormSize: "xl",
                entityConstructor: ()=>new (0, $c89e01a477d9680d$export$2d7154cc11cc4dd0)(client),
                formMode: "add",
                viewName: "pere_brwRecibos",
                refreshOnInit: true,
                selectionMode: "single",
                enableAdd: false,
                enableEdit: false,
                enableDelete: false,
                enableView: true
            }, "menuItem-personalpassword")
        }
    ];
    const AppSupervisorSubMenu = [
        {
            ID: "dashsuper",
            label: "Dashboard Supervisor",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Wgks.ThemeIcon), {
                variant: iconVariant,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ue5f.default), {
                    size: iconSize
                })
            }),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.EntityFormPage), {
                client: client,
                getDataOnInit: true,
                entityConstructor: ()=>new (0, $j02RA.AppSupervisor)(client),
                initialFormMode: "view"
            }, "menuItem-appsupervisor")
        },
        {
            ID: "powerbisuper",
            label: "PowerBI Supervisor",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Wgks.ThemeIcon), {
                variant: iconVariant,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ue5f.default), {
                    size: iconSize
                })
            }),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.EntityFormPage), {
                client: client,
                getDataOnInit: true,
                entityConstructor: ()=>new (0, $3a70019c97cb7af8$export$5290f7aa5fd87917)(client),
                initialFormMode: "view"
            }, "menuItem-appsupervisordashboard")
        }
    ];
    const menu = [
        {
            ID: "dashboard",
            label: "Dashboard",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Wgks.ThemeIcon), {
                variant: iconVariant,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ue5f.default), {
                    size: iconSize
                })
            }),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.EntityFormPage), {
                client: client,
                getDataOnInit: true,
                entityConstructor: ()=>new (0, $7UO1x.Dashboard)(client),
                initialFormMode: "view"
            }, "menuItem-dashboard")
        },
        //{
        //    ID: "dashboardnuevo", label: "Dashboard Nuevo", section: 'items', icon: <ThemeIcon variant={iconVariant}><IconDashboard size={iconSize} /></ThemeIcon>, content: <EntityFormPage key="menuItem-dashboardnuevo" client={client} getDataOnInit={true} entityConstructor={() => new DashboardNuevo(client)} initialFormMode="view" />
        //},
        {
            ID: "dashboardv2",
            label: "Dashboard V2",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Wgks.ThemeIcon), {
                variant: iconVariant,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ue5f.default), {
                    size: iconSize
                })
            }),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.EntityFormPage), {
                client: client,
                getDataOnInit: false,
                entityConstructor: ()=>new (0, $0ce329b30bcda5fe$export$292c7aa815a1910a)(client),
                initialFormMode: "view"
            }, "menuItem-dashboardv2")
        },
        //{
        //    ID: "dashboardseguimiento", label: "Dashboard Seguimiento", section: 'items', icon: <ThemeIcon variant={iconVariant}><IconDashboard size={iconSize} /></ThemeIcon>, content: <EntityFormPage key="menuItem-dashboardseguimiento" client={client} getDataOnInit={true} entityConstructor={() => new DashboardSeguimiento(client)} initialFormMode="view" />
        //},
        {
            ID: "appsupervisor",
            label: "App Supervisor",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Wgks.ThemeIcon), {
                variant: iconVariant,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ue5f.default), {
                    size: iconSize
                })
            }),
            subitems: AppSupervisorSubMenu
        },
        {
            ID: "reportes",
            label: "Exportaci\xf3n de Datos",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Wgks.ThemeIcon), {
                variant: iconVariant,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0dcd5353a75e1bef$export$2e2bcd8739ae039), {
                    size: iconSize
                })
            }),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.EntityFormPage), {
                client: client,
                getDataOnInit: true,
                entityConstructor: ()=>new (0, $1GHab.Reportes)(client),
                initialFormMode: "add"
            }, "menuItem-reportes")
        },
        {
            ID: "tiendas",
            label: "Tiendas",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Wgks.ThemeIcon), {
                variant: iconVariant,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jIc5b.default), {
                    size: iconSize
                })
            }),
            subitems: TiendasSubmenu
        },
        {
            ID: "tclientes",
            label: "Clientes",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Wgks.ThemeIcon), {
                variant: iconVariant,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ktmlo.default), {
                    size: iconSize
                })
            }),
            subitems: ClientesSubmenu
        },
        {
            ID: "servicios",
            label: "Servicios",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Wgks.ThemeIcon), {
                variant: iconVariant,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7646a0545ed1ac93$export$2e2bcd8739ae039), {
                    size: iconSize
                })
            }),
            subitems: ServiciosSubmenu
        },
        {
            ID: "wforce",
            label: "Work Force",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Wgks.ThemeIcon), {
                variant: iconVariant,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e51f0369048382d5$export$2e2bcd8739ae039), {
                    size: iconSize
                })
            }),
            subitems: WorkForceSubmenu
        },
        {
            ID: "asignacion_tiendas",
            label: "Asignaci\xf3n Masiva Tiendas",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Wgks.ThemeIcon), {
                variant: iconVariant,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $13afa6b2127378ea$export$2e2bcd8739ae039), {
                    size: iconSize
                })
            }),
            subitems: OperacionesSubmenu
        },
        {
            ID: "grutas",
            label: "Gesti\xf3n de Rutas",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Wgks.ThemeIcon), {
                variant: iconVariant,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eae64.default), {
                    size: iconSize
                })
            }),
            subitems: RutasSubmenu
        },
        {
            ID: "autorizaciones",
            label: "Autorizaciones",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Wgks.ThemeIcon), {
                variant: iconVariant,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $35ntO.default), {
                    size: iconSize
                })
            }),
            subitems: AutorizacionesSubmenu
        },
        {
            ID: "usuarios",
            label: "Usuarios",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Wgks.ThemeIcon), {
                variant: iconVariant,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $22CZZ.default), {
                    size: iconSize
                })
            }),
            subitems: UsuariosSubmenu
        },
        {
            ID: "config",
            label: "Configuraci\xf3n",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Wgks.ThemeIcon), {
                variant: iconVariant,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $TC7kK.default), {
                    size: iconSize
                })
            }),
            subitems: ConfiguracionSubmenu
        },
        {
            ID: "seguridad",
            label: "Seguridad",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Wgks.ThemeIcon), {
                variant: iconVariant,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $982d77836dfffb2c$export$2e2bcd8739ae039), {
                    size: iconSize
                })
            }),
            subitems: SeguridadSubmenu
        },
        {
            ID: "dashboardClientes",
            label: "Dashboard Clientes",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Wgks.ThemeIcon), {
                variant: iconVariant,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ue5f.default), {
                    size: iconSize
                })
            }),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.EntityFormPage), {
                client: client,
                getDataOnInit: true,
                entityConstructor: ()=>new (0, $elPjY.DashboardClientes)(client),
                initialFormMode: "view"
            }, "menuItem-dashboardClientes")
        },
        {
            ID: "recibosdesueldo",
            label: "Recibos de Sueldo",
            section: 'items',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Wgks.ThemeIcon), {
                variant: iconVariant,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $982d77836dfffb2c$export$2e2bcd8739ae039), {
                    size: iconSize
                })
            }),
            subitems: RecibosDeSueldoSubmenu
        }
    ];
    return menu;
}



var $a99Vi = parcelRequire("a99Vi");
const $d21388e71f137753$var$client = new (0, $49qEn.MicroMClient)({
    app_id: (0, $3OncY.APP_ID),
    api_url: (0, $3OncY.API_URL),
    redirect_on_401: "/"
});
// MMC: descomentar para habilitar grabación de accesos para los menues
//client.startRecordPaths();
(0, $49qEn.DateInputFieldDefaultProps).valueFormat = 'DD/MM/YYYY';
(0, $a99Vi.Translate)();
function $d21388e71f137753$var$App() {
    const theme = (0, $64A2P.useMantineTheme)();
    const [themeColor, setThemeColor] = (0, $acw62.useState)({
        colorKey: theme.primaryColor,
        colorShade: theme.primaryShade
    });
    const preferredColorScheme = (0, $agugM.useColorScheme)();
    (0, $49qEn.GoogleMapsAPILoaderConfig).apiKey = (0, $3OncY.GOOGLE_MAPS_API_KEY);
    (0, $49qEn.GoogleMapsAPILoaderConfig).language = 'es-419';
    // MMC: Esto es para que use el formato de fecha en español
    // TODO: Hacer componente para que se pueda elegir el idioma
    (0, $49qEn.UseLocaleFormatDefaultProps).initialLocale = 'es-AR';
    // MMC: initial menu state
    const getInitialNavbarState = ()=>{
        return window.innerWidth >= 768; // Adjust the breakpoint as needed
    };
    const [opened, setOpened] = (0, $acw62.useState)(getInitialNavbarState());
    const [content, setContent] = (0, $acw62.useState)(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {}));
    const { isLoggedIn: isLoggedIn, setIsLoggedIn: setIsLoggedIn, loggedInInfo: loggedInInfo } = (0, $49qEn.useIsLoggedIn)({
        client: $d21388e71f137753$var$client
    });
    const [sidebarOpened, setSidebarOpened] = (0, $acw62.useState)(getInitialNavbarState());
    // MMC: Aqui se indica el menu ID que luego se usa para deshabilitar/habilitar menues. Ver MenuContent
    const menu = (0, $49qEn.useMenuContent)({
        client: $d21388e71f137753$var$client,
        menuContent: (0, $4554799579f361dc$export$479f0f2f71193efe),
        setContent: setContent,
        setOpened: setOpened,
        isLoggedIn: isLoggedIn,
        setIsLoggedIn: setIsLoggedIn,
        menuId: (0, $4554799579f361dc$export$d4cd258d01c03112)
    });
    const [colorScheme, setColorScheme] = (0, $7jJlY.useLocalStorage)({
        key: 'mantine-color-scheme',
        defaultValue: preferredColorScheme,
        getInitialValueInEffect: true
    });
    const toggleColorScheme = (value)=>{
        setColorScheme(value || (colorScheme === 'dark' ? 'light' : 'dark'));
    };
    (0, $jqu36.useHotkeys)([
        [
            'mod+J',
            ()=>toggleColorScheme()
        ]
    ]);
    const modalOverlayProps = {
        overlayProps: {
            color: colorScheme === 'dark' ? theme.colors.dark[3] : theme.colors.gray[9],
            opacity: 0.55,
            blur: 3
        }
    };
    const [photoURL, setPhotoURL] = (0, $acw62.useState)();
    const [mtsClaims, setMtsClaims] = (0, $acw62.useState)();
    const [enabledMenus, setEnabledMenus] = (0, $acw62.useState)();
    // MMC: para arreglar el problema de que el viewport no se actualiza correctamente en dispositivos móviles IPHONE
    (0, $49qEn.useViewportDynamicVariables)();
    (0, $acw62.useEffect)(()=>{
        let isMounted = true;
        const checkBackoffice = async ()=>{
            try {
                const loggedIn = await $d21388e71f137753$var$client.isLoggedInLocal();
                if (!loggedIn) await $d21388e71f137753$var$client.localLogoff();
                const menus = await $d21388e71f137753$var$client.getMenus();
                if (isMounted) setEnabledMenus(menus);
                const mts_claims = loggedInInfo;
                const photo_url = mts_claims?.vc_fotoguid ? $d21388e71f137753$var$client.getThumbnailURL(mts_claims.vc_fotoguid) : undefined;
                setPhotoURL(photo_url);
                setMtsClaims(mts_claims);
                await (0, $kF50T.getMenusAndRedirectToHome)($d21388e71f137753$var$client);
            } catch (error) {
                console.error("Error getting menus:", error);
            }
        };
        checkBackoffice();
        return ()=>{
            isMounted = false;
        };
    }, [
        loggedInInfo
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.MicroMRouter), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8TaxK.ColorSchemeProvider), {
            colorScheme: colorScheme,
            toggleColorScheme: toggleColorScheme,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $64A2P.MantineProvider), {
                theme: {
                    colors: {
                        brand: [
                            "#FCEFE9",
                            "#F6D1C1",
                            "#F0B499",
                            "#EA9771",
                            "#E47A49",
                            "#DE5C21",
                            "#B24A1A",
                            "#853714",
                            "#59250D",
                            "#2C1207"
                        ]
                    },
                    colorScheme: colorScheme,
                    focusRing: "auto",
                    primaryColor: themeColor.colorKey,
                    primaryShade: themeColor.colorShade
                },
                withCSSVariables: true,
                withGlobalStyles: true,
                withNormalizeCSS: true,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.GridGlobalStyles), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jXwWv.SpotlightProvider), {
                        actions: menu.actions,
                        size: "xl",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cnNDs.DatesProvider), {
                            settings: {
                                locale: 'es',
                                firstDayOfWeek: 1
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $49qEn.ModalsManager), {
                                modalProps: modalOverlayProps,
                                animationDuration: 0,
                                children: [
                                    isLoggedIn === false && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            backgroundImage: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($hLNas)))})`,
                                            backgroundRepeat: 'no-repeat',
                                            backgroundPosition: 'center',
                                            backgroundAttachment: 'fixed',
                                            backgroundSize: 'cover',
                                            height: '100dvh',
                                            padding: '0px'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.LoginModal), {
                                            client: $d21388e71f137753$var$client,
                                            checkOnInit: false,
                                            onClose: ()=>null,
                                            onLoggedIn: async ()=>{
                                                setIsLoggedIn(true);
                                                await (0, $kF50T.getMenusAndRedirectToHome)($d21388e71f137753$var$client);
                                            }
                                        })
                                    }),
                                    isLoggedIn === true && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cm529.AppShell), {
                                        navbarOffsetBreakpoint: "sm",
                                        navbar: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5Zz2.Navbar), {
                                            p: "md",
                                            hiddenBreakpoint: "sm",
                                            hidden: !opened,
                                            width: {
                                                sm: 200,
                                                lg: 300
                                            },
                                            style: !opened ? {
                                                display: 'none',
                                                width: 0
                                            } : undefined,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49qEn.MenuNavBarPanel), {
                                                setOpened: setOpened,
                                                setContent: setContent,
                                                menuItems: menu.items,
                                                activeIDState: menu.activeIDState,
                                                subitemActiveIDState: menu.subitemActiveIDState
                                            })
                                        }),
                                        header: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5MBWk.Header), {
                                            height: {
                                                base: 50,
                                                md: 70
                                            },
                                            zIndex: 101,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                                                sx: {
                                                    height: '100%',
                                                    display: "flex",
                                                    justifyContent: "flex-start"
                                                },
                                                px: 20,
                                                position: "apart",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gebf7.Burger), {
                                                        opened: opened,
                                                        onClick: ()=>setOpened((o)=>!o),
                                                        size: "xs",
                                                        color: theme.colors.gray[6],
                                                        mr: "xs"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9mTYo.Group), {
                                                        w: "3rem",
                                                        h: "auto",
                                                        mr: "xs",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7AVya.Logo), {})
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                                                        sx: {
                                                            flex: 1,
                                                            justifyContent: "flex-end"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7qrj2.LoggedInMenu), {
                                                                loggedInUser: mtsClaims?.username,
                                                                initials: mtsClaims?.userinitials,
                                                                photoURL: photoURL,
                                                                enabledMenus: enabledMenus,
                                                                onLogOut: async ()=>{
                                                                    await $d21388e71f137753$var$client.logoff();
                                                                    setIsLoggedIn(false);
                                                                    window.location.href = "/";
                                                                },
                                                                onEditProfile: async (openform)=>{
                                                                    if (!mtsClaims) return;
                                                                    const perfil = new (0, $lCDNR.PerfilUsuario)($d21388e71f137753$var$client);
                                                                    perfil.def.columns.vc_fotoguid.value = mtsClaims.vc_fotoguid || '';
                                                                    perfil.def.columns.vc_apellido.value = mtsClaims.vc_apellido || '';
                                                                    perfil.def.columns.vc_nombre.value = mtsClaims.vc_nombre || '';
                                                                    perfil.def.columns.vc_username.value = mtsClaims.username || '';
                                                                    await openform({
                                                                        entity: perfil,
                                                                        initialFormMode: 'add',
                                                                        title: 'Editar',
                                                                        onModalSaved: async ()=>{
                                                                            if (!mtsClaims) return;
                                                                            mtsClaims.vc_fotoguid = perfil.def.columns.vc_fotoguid.value;
                                                                            await $d21388e71f137753$var$client.updateClientClaims(mtsClaims);
                                                                            var photo_url = mtsClaims.vc_fotoguid ? $d21388e71f137753$var$client.getThumbnailURL(mtsClaims.vc_fotoguid) : undefined;
                                                                            setPhotoURL(photo_url);
                                                                        }
                                                                    });
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $crMIh.ActionIcon), {
                                                                variant: "default",
                                                                onClick: ()=>toggleColorScheme(),
                                                                size: 30,
                                                                children: colorScheme === 'dark' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5U9YU.default), {
                                                                    size: "1rem"
                                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kONlL.default), {
                                                                    size: "1rem"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        styles: {
                                            main: {
                                                paddingLeft: !opened ? '1rem' : undefined,
                                                paddingRight: !sidebarOpened ? '1rem' : undefined,
                                                minHeight: 'calc(var(--dynVH, 1vh) * 100)',
                                                width: '100%' //'calc(var(--dynVH, 1vh) * 100)'
                                            }
                                        },
                                        children: content
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
}
var $d21388e71f137753$export$2e2bcd8739ae039 = $d21388e71f137753$var$App;


const $0eefd987750b6de6$var$container = document.getElementById("app");
const $0eefd987750b6de6$var$root = (0, $aRPiL.createRoot)($0eefd987750b6de6$var$container);
$0eefd987750b6de6$var$root.render(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $d21388e71f137753$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=html.ac5cdc3e.js.map
